import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.post.detail');
import { HostListener, OnInit, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Router, NavigationEnd } from '@angular/router';

type RegisterStepKey = 'upload' | 'metadata' | 'manual' | 'complete';
type MetadataSectionKey = 'visibility' | 'bibliography' | 'layout';
type ReviewSectionKey = string;
type RecoveryModalState = 'prompt' | 'progress' | 'success' | 'error';
type MetadataReviewFileFilter = 'all' | 'complete' | 'incomplete';
type MetadataAdvanceMode = 'all' | 'selected';
type MetadataReviewWorkflowState = 'draft' | 'ready' | 'advanced';
type SavedReviewSectionKey = (
    'basic'
    | 'classification'
    | 'metadata'
    | 'scope'
    | 'content'
    | 'source'
    | 'toc'
    | 'images'
    | 'entities'
    | 'relations'
    | 'history'
);
type SavedReviewIntent = 'save' | 'complete';
type SavedDtdActionState = 'idle' | 'running' | 'success' | 'error';
type UploadQueuePrimaryAction = (
    'retry-preservation'
    | 'overwrite'
    | 'recheck'
    | 'inspect'
    | 'remove'
    | 'none'
);

class StreamingSha256 {
    private state = new Uint32Array([
        0x6a09e667, 0xbb67ae85, 0x3c6ef372, 0xa54ff53a,
        0x510e527f, 0x9b05688c, 0x1f83d9ab, 0x5be0cd19,
    ]);
    private buffer = new Uint8Array(64);
    private bufferLength = 0;
    private bytesHashed = 0;
    private finished = false;
    private words = new Uint32Array(64);
    private static readonly constants = new Uint32Array([
        0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5,
        0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5,
        0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3,
        0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174,
        0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc,
        0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da,
        0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7,
        0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967,
        0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13,
        0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85,
        0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3,
        0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070,
        0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5,
        0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3,
        0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208,
        0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2,
    ]);

    public update(input: Uint8Array) {
        if (this.finished) throw new Error('SHA-256 계산이 이미 완료되었습니다.');
        this.bytesHashed += input.length;
        let offset = 0;
        if (this.bufferLength > 0) {
            while (this.bufferLength < 64 && offset < input.length) {
                this.buffer[this.bufferLength++] = input[offset++];
            }
            if (this.bufferLength === 64) {
                this.transform(this.buffer);
                this.bufferLength = 0;
            }
        }
        while (offset + 64 <= input.length) {
            this.transform(input.subarray(offset, offset + 64));
            offset += 64;
        }
        while (offset < input.length) {
            this.buffer[this.bufferLength++] = input[offset++];
        }
        return this;
    }

    public digestHex() {
        if (!this.finished) {
            const bytesHashed = this.bytesHashed;
            this.buffer[this.bufferLength++] = 0x80;
            if (this.bufferLength > 56) {
                this.buffer.fill(0, this.bufferLength, 64);
                this.transform(this.buffer);
                this.bufferLength = 0;
            }
            this.buffer.fill(0, this.bufferLength, 56);
            const bitHigh = Math.floor(bytesHashed / 0x20000000);
            const bitLow = (bytesHashed << 3) >>> 0;
            this.buffer[56] = (bitHigh >>> 24) & 0xff;
            this.buffer[57] = (bitHigh >>> 16) & 0xff;
            this.buffer[58] = (bitHigh >>> 8) & 0xff;
            this.buffer[59] = bitHigh & 0xff;
            this.buffer[60] = (bitLow >>> 24) & 0xff;
            this.buffer[61] = (bitLow >>> 16) & 0xff;
            this.buffer[62] = (bitLow >>> 8) & 0xff;
            this.buffer[63] = bitLow & 0xff;
            this.transform(this.buffer);
            this.finished = true;
        }
        return Array.from(this.state)
            .map((value: number) => value.toString(16).padStart(8, '0'))
            .join('');
    }

    private rotateRight(value: number, shift: number) {
        return (value >>> shift) | (value << (32 - shift));
    }

    private transform(chunk: Uint8Array) {
        const words = this.words;
        for (let index = 0; index < 16; index += 1) {
            const offset = index * 4;
            words[index] = (
                (chunk[offset] << 24)
                | (chunk[offset + 1] << 16)
                | (chunk[offset + 2] << 8)
                | chunk[offset + 3]
            ) >>> 0;
        }
        for (let index = 16; index < 64; index += 1) {
            const x = words[index - 15];
            const y = words[index - 2];
            const sigma0 = this.rotateRight(x, 7) ^ this.rotateRight(x, 18) ^ (x >>> 3);
            const sigma1 = this.rotateRight(y, 17) ^ this.rotateRight(y, 19) ^ (y >>> 10);
            words[index] = (
                words[index - 16] + sigma0 + words[index - 7] + sigma1
            ) >>> 0;
        }
        let [a, b, c, d, e, f, g, h] = Array.from(this.state);
        for (let index = 0; index < 64; index += 1) {
            const sum1 = this.rotateRight(e, 6) ^ this.rotateRight(e, 11) ^ this.rotateRight(e, 25);
            const choose = (e & f) ^ (~e & g);
            const temp1 = (
                h + sum1 + choose + StreamingSha256.constants[index] + words[index]
            ) >>> 0;
            const sum0 = this.rotateRight(a, 2) ^ this.rotateRight(a, 13) ^ this.rotateRight(a, 22);
            const majority = (a & b) ^ (a & c) ^ (b & c);
            const temp2 = (sum0 + majority) >>> 0;
            h = g;
            g = f;
            f = e;
            e = (d + temp1) >>> 0;
            d = c;
            c = b;
            b = a;
            a = (temp1 + temp2) >>> 0;
        }
        this.state[0] = (this.state[0] + a) >>> 0;
        this.state[1] = (this.state[1] + b) >>> 0;
        this.state[2] = (this.state[2] + c) >>> 0;
        this.state[3] = (this.state[3] + d) >>> 0;
        this.state[4] = (this.state[4] + e) >>> 0;
        this.state[5] = (this.state[5] + f) >>> 0;
        this.state[6] = (this.state[6] + g) >>> 0;
        this.state[7] = (this.state[7] + h) >>> 0;
    }
}

@Component({
    selector: 'wiz-portal-post-detail',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.post.detail/view.scss */
@charset "UTF-8";
:host {
  display: block;
}

/* ITEM manifestation and cross-language relation review */
.item-registry-shell {
  display: grid;
  min-height: 0;
  flex: 1 1 auto;
  align-content: start;
  gap: 12px;
  padding-bottom: 16px;
  overflow-y: auto;
  color: #344d46;
}

.item-registry-head button,
.item-registry-review-bar button,
.item-registry-alignment-list footer button,
.item-registry-links footer button {
  display: inline-flex;
  min-height: 38px;
  align-items: center;
  justify-content: center;
  gap: 7px;
  border: 1px solid #c8d5d1;
  border-radius: 7px;
  background: #fff;
  color: #245d51;
  padding: 0 13px;
  font-size: 10px;
  font-weight: 900;
  transition: border-color 120ms ease, background 120ms ease, color 120ms ease;
}
.item-registry-head button:hover:not(:disabled), .item-registry-head button:focus-visible,
.item-registry-review-bar button:hover:not(:disabled),
.item-registry-review-bar button:focus-visible,
.item-registry-alignment-list footer button:hover:not(:disabled),
.item-registry-alignment-list footer button:focus-visible,
.item-registry-links footer button:hover:not(:disabled),
.item-registry-links footer button:focus-visible {
  border-color: #8eb3a9;
  background: #f2f8f6;
  color: #174f43;
}
.item-registry-head button:disabled,
.item-registry-review-bar button:disabled,
.item-registry-alignment-list footer button:disabled,
.item-registry-links footer button:disabled {
  cursor: wait;
  opacity: 0.55;
}

.item-registry-policy-card {
  display: grid;
  grid-template-columns: 40px minmax(0, 1fr) auto;
  gap: 13px;
  align-items: center;
  margin: 0 16px;
  padding: 14px 15px;
  border: 1px solid #b9d5cd;
  border-radius: 10px;
  background: linear-gradient(135deg, #f1f8f5 0%, #f8fbfa 100%);
}

.item-registry-policy-icon {
  display: grid;
  width: 40px;
  height: 40px;
  place-items: center;
  border-radius: 10px;
  background: #dcede8;
  color: var(--saved-review-green, #075443);
  font-size: 16px;
}

.item-registry-policy-copy {
  display: grid;
  gap: 3px;
  min-width: 0;
}
.item-registry-policy-copy > span {
  color: #8b6134;
  font-size: 9px;
  font-weight: 900;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}
.item-registry-policy-copy > strong {
  color: #19362f;
  font-size: 12px;
  font-weight: 900;
  line-height: 1.45;
}
.item-registry-policy-copy > p,
.item-registry-policy-copy > small {
  margin: 0;
  color: #5f746e;
  font-size: 10px;
  font-weight: 700;
  line-height: 1.5;
}
.item-registry-policy-copy > small {
  color: #376b5f;
}

.item-registry-revalidate-button {
  display: inline-flex;
  min-width: 190px;
  min-height: 52px;
  align-items: center;
  justify-content: center;
  gap: 10px;
  border: 1px solid var(--saved-review-green, #075443);
  border-radius: 9px;
  background: var(--saved-review-green, #075443);
  color: #fff;
  padding: 8px 15px;
  box-shadow: 0 5px 14px rgba(7, 84, 67, 0.14);
  transition: transform 120ms ease, box-shadow 120ms ease, background 120ms ease;
}
.item-registry-revalidate-button:hover:not(:disabled), .item-registry-revalidate-button:focus-visible {
  background: #0a6652;
  box-shadow: 0 7px 18px rgba(7, 84, 67, 0.2);
  transform: translateY(-1px);
}
.item-registry-revalidate-button:focus-visible {
  outline: 2px solid #77ac9e;
  outline-offset: 2px;
}
.item-registry-revalidate-button:disabled {
  cursor: wait;
  opacity: 0.68;
}
.item-registry-revalidate-button > i {
  font-size: 14px;
}
.item-registry-revalidate-button > span {
  display: grid;
  gap: 2px;
  text-align: left;
}
.item-registry-revalidate-button strong {
  font-size: 11px;
  font-weight: 900;
}
.item-registry-revalidate-button small {
  color: #d9ece6;
  font-size: 8px;
  font-weight: 750;
}

.item-registry-validation {
  display: grid;
  grid-template-columns: auto 1fr auto;
  gap: 12px;
  align-items: center;
  margin: 0 16px;
  padding: 13px 16px;
  border: 1px solid var(--saved-review-line, #d7e1de);
  border-radius: 8px;
  background: #f8faf9;
}
.item-registry-validation > i {
  font-size: 20px;
}
.item-registry-validation strong {
  color: #19362f;
  font-size: 12px;
  font-weight: 900;
}
.item-registry-validation p {
  margin: 3px 0 0;
  color: #6d7d78;
  font-size: 10px;
  font-weight: 650;
  line-height: 1.45;
}
.item-registry-validation small {
  display: block;
  margin-top: 4px;
  color: #a8601c;
  font-size: 9px;
  font-weight: 800;
}
.item-registry-validation dl {
  display: flex;
  gap: 16px;
  margin: 0;
}
.item-registry-validation dl div {
  text-align: center;
}
.item-registry-validation dt {
  color: #74837f;
  font-size: 9px;
  font-weight: 800;
}
.item-registry-validation dd {
  margin: 2px 0 0;
  color: #203a33;
  font-size: 15px;
  font-weight: 900;
}
.item-registry-validation.is-valid {
  border-color: #a9cfc4;
  background: #eff8f4;
}
.item-registry-validation.is-valid > i {
  color: var(--saved-review-green, #075443);
}
.item-registry-validation.is-invalid {
  border-color: #efc58f;
  background: #fff8ed;
}
.item-registry-validation.is-invalid > i {
  color: #b76719;
}

.item-registry-tabs {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 4px;
  margin: 0 16px;
  padding: 4px;
  border: 1px solid #dce5e2;
  border-radius: 8px;
  background: #f0f4f2;
}
.item-registry-tabs button {
  min-height: 48px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #697a75;
  font-size: 14px;
  font-weight: 850;
  transition: background 120ms ease, color 120ms ease, box-shadow 120ms ease;
}
.item-registry-tabs button i {
  margin-right: 9px;
  font-size: 15px;
}
.item-registry-tabs button:hover:not(:disabled) {
  color: #245d51;
}
.item-registry-tabs button:focus-visible {
  outline: 2px solid #78a99c;
  outline-offset: -2px;
}
.item-registry-tabs button.is-active {
  background: #fff;
  color: var(--saved-review-green, #075443);
  box-shadow: 0 1px 4px rgba(26, 55, 47, 0.1);
}
.item-registry-tabs button:disabled {
  opacity: 0.45;
}

.item-registry-tab-notice {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  gap: 13px;
  align-items: start;
  margin: 0 16px;
  padding: 16px 18px;
  border: 1px solid #e2d4bb;
  border-radius: 8px;
  background: #fffaf1;
  color: #7d5a25;
}
.item-registry-tab-notice > i {
  margin-top: 3px;
  color: #b27119;
  font-size: 17px;
}
.item-registry-tab-notice strong {
  color: #704d1d;
  font-size: 14px;
  font-weight: 900;
  line-height: 1.45;
}
.item-registry-tab-notice p,
.item-registry-tab-notice small {
  display: block;
  margin: 6px 0 0;
  color: #866a42;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.6;
}
.item-registry-tab-notice small {
  color: #376b5f;
}

.item-registry-manifestation-screen,
.item-registry-compare-screen,
.item-registry-alignment-screen {
  display: grid;
  gap: 12px;
  margin: 0 16px;
}

.item-registry-manifestation-screen > header,
.item-registry-alignment-screen > header,
.item-registry-links > header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}
.item-registry-manifestation-screen > header h3,
.item-registry-alignment-screen > header h3,
.item-registry-links > header h3 {
  margin: 0;
  color: #19362f;
  font-size: 13px;
  font-weight: 900;
}
.item-registry-manifestation-screen > header p,
.item-registry-alignment-screen > header p,
.item-registry-links > header p {
  margin: 3px 0 0;
  color: #70817c;
  font-size: 10px;
  font-weight: 650;
  line-height: 1.45;
}
.item-registry-manifestation-screen > header > em,
.item-registry-alignment-screen > header > em,
.item-registry-links > header > em {
  flex: 0 0 auto;
  color: #60736d;
  font-size: 10px;
  font-style: normal;
  font-weight: 900;
  white-space: nowrap;
}

.item-registry-manifestation-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 9px;
}
.item-registry-manifestation-grid article {
  min-width: 0;
  padding: 12px;
  border: 1px solid var(--saved-review-line, #d7e1de);
  border-radius: 8px;
  background: #fff;
}
.item-registry-manifestation-grid article.is-original {
  border-color: #9fc8bd;
  background: #f5faf8;
}
.item-registry-manifestation-grid article.is-current {
  box-shadow: inset 3px 0 var(--saved-review-green, #075443);
}
.item-registry-manifestation-grid header {
  display: grid;
  grid-template-columns: auto 1fr auto;
  gap: 10px;
  align-items: center;
}
.item-registry-manifestation-grid header div {
  display: grid;
}
.item-registry-manifestation-grid header .item-registry-card-badges {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 5px;
}
.item-registry-manifestation-grid header strong {
  color: #263f38;
  font-size: 12px;
  font-weight: 900;
}
.item-registry-manifestation-grid header small {
  margin-top: 2px;
  color: #72827d;
  font-size: 9px;
  font-weight: 700;
}
.item-registry-manifestation-grid > article > p {
  min-height: 34px;
  margin: 10px 0;
  color: #425750;
  font-size: 11px;
  font-weight: 750;
  line-height: 1.5;
  word-break: break-all;
}
.item-registry-manifestation-grid footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}
.item-registry-manifestation-grid footer code {
  overflow: hidden;
  color: #788984;
  font-size: 9px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.item-registry-manifestation-grid footer button {
  flex: 0 0 auto;
  border: 0;
  background: transparent;
  color: #216555;
  font-size: 10px;
  font-weight: 900;
}
.item-registry-manifestation-grid footer button:hover, .item-registry-manifestation-grid footer button:focus-visible {
  color: #0f4d3f;
  text-decoration: underline;
}

.item-registry-card-reason {
  display: grid;
  min-height: 34px;
  grid-template-columns: auto minmax(0, 1fr);
  gap: 6px;
  align-items: start;
  margin: 0 0 10px;
  padding: 7px 8px;
  border-radius: 6px;
  background: #f4f7f6;
  color: #63756f;
  font-size: 9px;
  font-weight: 750;
  line-height: 1.45;
}
.item-registry-card-reason > i {
  margin-top: 2px;
  color: #7e918b;
}
.item-registry-card-reason.is-attention {
  background: #fff7ea;
  color: #81591f;
}
.item-registry-card-reason.is-attention > i {
  color: #b76719;
}

.item-registry-role {
  display: grid;
  width: 29px;
  height: 29px;
  place-items: center;
  border-radius: 7px;
  background: var(--saved-review-green, #075443);
  color: #fff;
  font-size: 11px;
  font-weight: 900;
  text-transform: uppercase;
}

.item-registry-relation-list {
  display: grid;
  gap: 8px;
  padding-top: 12px;
  border-top: 1px solid var(--saved-review-line, #d7e1de);
}
.item-registry-relation-list > header {
  display: flex;
  justify-content: space-between;
}
.item-registry-relation-list > header h3 {
  margin: 0;
  color: #203a33;
  font-size: 12px;
  font-weight: 900;
}
.item-registry-relation-list > header span {
  color: #697a75;
  font-size: 10px;
  font-weight: 850;
}
.item-registry-relation-list article {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 11px 12px;
  border: 1px solid #dce4e2;
  border-radius: 7px;
  background: #fff;
  cursor: pointer;
  transition: border-color 120ms ease, background 120ms ease;
}
.item-registry-relation-list article:hover,
.item-registry-relation-list article:focus-visible {
  border-color: #9abeb5;
  background: #f7faf9;
  outline: 0;
}
.item-registry-relation-list article.is-active {
  border-color: #79aa9d;
  background: #edf6f3;
  box-shadow: inset 3px 0 var(--saved-review-green, #075443);
}
.item-registry-relation-list article div {
  display: grid;
  gap: 3px;
}
.item-registry-relation-list article strong {
  color: #29413a;
  font-size: 11px;
  font-weight: 900;
}
.item-registry-relation-list article small {
  color: #71827d;
  font-size: 9px;
  font-weight: 700;
}

.item-registry-shell em.is-approved,
.item-registry-shell em.is-candidate,
.item-registry-shell em.is-warning,
.item-registry-shell em.is-rejected,
.item-registry-shell em.is-excluded,
.item-registry-shell em.is-neutral,
.item-registry-shell em.is-current-tag {
  align-self: center;
  border-radius: 999px;
  padding: 4px 8px;
  font-size: 9px;
  font-style: normal;
  font-weight: 900;
  white-space: nowrap;
}

.item-registry-shell em.is-approved {
  color: #21705e;
  background: #e8f6f1;
}

.item-registry-shell em.is-candidate {
  color: #a8601c;
  background: #fff1df;
}

.item-registry-shell em.is-warning {
  color: #a8601c;
  background: #fff1df;
}

.item-registry-shell em.is-rejected {
  color: #a33a43;
  background: #fdebed;
}

.item-registry-shell em.is-excluded {
  color: #667a74;
  background: #edf2f0;
}

.item-registry-shell em.is-neutral {
  color: #60736d;
  background: #edf2f0;
}

.item-registry-shell em.is-current-tag {
  border: 1px solid #9fc8bd;
  color: #1d6656;
  background: #f1f8f5;
}

.item-registry-relation-picker,
.item-registry-review-bar {
  display: grid;
  align-items: end;
  gap: 10px;
  padding: 11px 12px;
  border: 1px solid #dce4e2;
  border-radius: 8px;
  background: #f8faf9;
}
.item-registry-relation-picker label,
.item-registry-review-bar label {
  display: grid;
  gap: 5px;
}
.item-registry-relation-picker label > span,
.item-registry-review-bar label > span {
  color: #526660;
  font-size: 10px;
  font-weight: 900;
}
.item-registry-relation-picker select, .item-registry-relation-picker input,
.item-registry-review-bar select,
.item-registry-review-bar input {
  min-height: 38px;
  border: 1px solid #ccd7d4;
  border-radius: 7px;
  background: #fff;
  color: #2d463f;
  padding: 0 10px;
  font-size: 11px;
}
.item-registry-relation-picker select:focus, .item-registry-relation-picker input:focus,
.item-registry-review-bar select:focus,
.item-registry-review-bar input:focus {
  border-color: #78a99c;
  outline: 2px solid rgba(120, 169, 156, 0.18);
}

.item-registry-relation-picker {
  grid-template-columns: minmax(320px, 1fr) auto;
}

.item-registry-review-bar .is-reason {
  flex: 1;
}

.item-registry-review-bar {
  position: sticky;
  z-index: 4;
  bottom: 0;
  grid-template-columns: 180px minmax(260px, 1fr) auto;
  box-shadow: 0 -8px 24px rgba(27, 55, 47, 0.08);
}

.item-registry-review-bar > div {
  display: flex;
  gap: 6px;
}

.item-registry-review-bar button.is-primary {
  border-color: var(--saved-review-green, #075443);
  background: var(--saved-review-green, #075443);
  color: #fff;
}

.item-registry-compare-summary {
  display: flex;
  align-items: stretch;
  gap: 6px;
}
.item-registry-compare-summary > span {
  display: grid;
  min-width: 88px;
  align-content: center;
  gap: 3px;
  padding: 7px 10px;
  border: 1px solid #d7e1de;
  border-radius: 7px;
  background: #fff;
}
.item-registry-compare-summary small {
  color: #7a8984;
  font-size: 8px;
  font-weight: 800;
}
.item-registry-compare-summary strong {
  color: #29413a;
  font-size: 10px;
  font-weight: 900;
}

.item-registry-compare-guide {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 10px;
  align-items: start;
  padding: 11px 13px;
  border: 1px solid #cfe0db;
  border-radius: 8px;
  background: #f2f8f6;
}
.item-registry-compare-guide i {
  margin-top: 2px;
  color: #2c7665;
}
.item-registry-compare-guide strong {
  color: #23463d;
  font-size: 11px;
  font-weight: 900;
}
.item-registry-compare-guide p {
  margin: 3px 0 0;
  color: #657973;
  font-size: 9px;
  font-weight: 650;
  line-height: 1.5;
}

.item-registry-loading-line {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 7px;
  background: #edf5f2;
  color: #2e6759;
  font-size: 10px;
  font-weight: 800;
}

.item-registry-compare-navigator {
  overflow: hidden;
  border: 1px solid #d8e2df;
  border-radius: 9px;
  background: #fff;
}
.item-registry-compare-navigator > header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 12px;
  border-bottom: 1px solid #e4ebe9;
  background: #f8faf9;
}
.item-registry-compare-navigator h3 {
  margin: 0;
  color: #203a33;
  font-size: 12px;
  font-weight: 900;
}
.item-registry-compare-navigator p {
  margin: 2px 0 0;
  color: #71827d;
  font-size: 9px;
  line-height: 1.45;
}

.item-registry-compare-candidates {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1px;
  max-height: 252px;
  overflow-y: auto;
  background: #e4ebe9;
}
.item-registry-compare-candidates > button {
  display: grid;
  min-width: 0;
  grid-template-columns: auto minmax(80px, 1fr) auto minmax(80px, 1fr);
  gap: 5px 8px;
  align-items: center;
  border: 0;
  padding: 9px 10px;
  background: #fff;
  color: #345049;
  text-align: left;
  cursor: pointer;
}
.item-registry-compare-candidates > button:hover,
.item-registry-compare-candidates > button:focus-visible {
  z-index: 1;
  background: #f3f8f6;
  outline: 2px solid #83afa3;
  outline-offset: -2px;
}
.item-registry-compare-candidates > button.is-active {
  z-index: 1;
  background: #e9f4f0;
  box-shadow: inset 3px 0 #12634f;
}
.item-registry-compare-candidates > button.is-unresolved {
  background: #fffaf2;
}
.item-registry-compare-candidates span {
  border-radius: 999px;
  padding: 3px 6px;
  background: #edf3f1;
  color: #42665c;
  font-size: 8px;
  font-weight: 900;
  white-space: nowrap;
}
.item-registry-compare-candidates strong, .item-registry-compare-candidates em {
  overflow: hidden;
  font-size: 10px;
  font-style: normal;
  font-weight: 850;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.item-registry-compare-candidates em {
  color: #526b64;
}
.item-registry-compare-candidates i {
  color: #91a19c;
  font-size: 8px;
}
.item-registry-compare-candidates small {
  grid-column: 2/-1;
  overflow: hidden;
  color: #83918d;
  font: 8px/1.35 ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.item-registry-candidate-limit {
  padding: 8px 12px;
  border-top: 1px solid #e4ebe9;
  background: #fbfcfc;
}

.item-registry-compare-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 9px;
}
.item-registry-compare-grid article {
  min-width: 0;
  border: 1px solid var(--saved-review-line, #d7e1de);
  border-radius: 9px;
  overflow: hidden;
  background: #fff;
}
.item-registry-compare-grid article.is-original {
  border-color: #a8cec3;
}
.item-registry-compare-grid article > header {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  align-items: center;
  gap: 9px;
  padding: 10px 12px;
  background: #eff5f2;
}
.item-registry-compare-grid article > header div {
  display: grid;
  min-width: 0;
  gap: 2px;
}
.item-registry-compare-grid article > header strong {
  overflow: hidden;
  color: #29413a;
  font-size: 11px;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.item-registry-compare-grid article > header small {
  color: #6d7d78;
  font-size: 9px;
  font-weight: 750;
}
.item-registry-compare-grid pre {
  height: 440px;
  margin: 0;
  padding: 14px 16px 26px;
  overflow: auto;
  border-top: 1px solid #e4ebe9;
  background: #f9fbfa;
  color: #274139;
  font: 10px/1.72 ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  white-space: pre-wrap;
  word-break: break-word;
}
.item-registry-compare-grid pre mark {
  border-radius: 3px;
  padding: 1px 2px;
  background: #ffe58e;
  color: #453a13;
  box-shadow: 0 0 0 2px rgba(255, 210, 58, 0.16);
}

.item-registry-source-role {
  display: grid;
  min-width: 52px;
  min-height: 28px;
  place-items: center;
  border-radius: 6px;
  background: #dcebe6;
  color: #245b4f;
  font-size: 9px;
  font-weight: 900;
}

.item-registry-source-tools {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto auto;
  gap: 6px;
  padding: 8px 10px;
  border-top: 1px solid #e4ebe9;
}
.item-registry-source-tools input {
  width: 100%;
  min-height: 32px;
  border: 1px solid #cbd8d4;
  border-radius: 6px;
  padding: 0 9px;
  color: #2d463f;
  font-size: 9px;
}
.item-registry-source-tools > button,
.item-registry-source-tools .item-registry-match-nav button {
  min-height: 32px;
  border: 1px solid #c4d4cf;
  border-radius: 6px;
  background: #fff;
  color: #286154;
  font-size: 9px;
  font-weight: 900;
}

.item-registry-match-nav {
  display: flex;
  align-items: center;
  gap: 4px;
}
.item-registry-match-nav button {
  width: 30px;
  padding: 0;
}
.item-registry-match-nav span {
  min-width: 38px;
  color: #657973;
  font-size: 8px;
  text-align: center;
}

.item-registry-window-nav {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  gap: 8px;
  align-items: center;
  padding: 7px 10px;
  border-top: 1px solid #eef2f1;
  background: #fbfcfc;
}
.item-registry-window-nav button {
  display: inline-flex;
  min-height: 28px;
  align-items: center;
  gap: 5px;
  border: 0;
  background: transparent;
  color: #286154;
  font-size: 8px;
  font-weight: 900;
}
.item-registry-window-nav button:disabled {
  color: #a9b4b1;
}
.item-registry-window-nav code {
  overflow: hidden;
  color: #7a8984;
  font-size: 8px;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.item-registry-source-empty {
  display: grid;
  height: 440px;
  place-content: center;
  gap: 4px;
  background: #f9fbfa;
  color: #71827d;
  text-align: center;
}
.item-registry-source-empty strong {
  color: #3c5750;
  font-size: 11px;
}
.item-registry-source-empty p {
  margin: 0;
  font-size: 9px;
}

.item-registry-filter {
  display: flex;
  gap: 5px;
}

.item-registry-filter button {
  min-height: 34px;
  border: 1px solid #ccd7d4;
  border-radius: 7px;
  background: #fff;
  color: #5e716b;
  font-size: 10px;
  font-weight: 850;
}

.item-registry-filter button:hover, .item-registry-filter button:focus-visible {
  border-color: #8eb3a9;
  color: #245d51;
}

.item-registry-filter button.is-active {
  border-color: #7eafa2;
  background: #e8f3f0;
  color: #174f43;
}

.item-registry-alignment-list,
.item-registry-links {
  display: grid;
  gap: 8px;
}
.item-registry-alignment-list article,
.item-registry-links article {
  padding: 12px;
  border: 1px solid #dce4e2;
  border-radius: 8px;
  background: #fff;
}
.item-registry-alignment-list article.is-excluded,
.item-registry-links article.is-excluded {
  opacity: 0.72;
  background: #f4f7f6;
}
.item-registry-alignment-list article > header,
.item-registry-links article > header {
  display: flex;
  gap: 8px;
  align-items: center;
}
.item-registry-alignment-list article > header span,
.item-registry-links article > header span {
  color: #256657;
  font-size: 10px;
  font-weight: 900;
  text-transform: uppercase;
}
.item-registry-alignment-list article > header small,
.item-registry-links article > header small {
  margin-left: auto;
  color: #71827d;
  font-size: 9px;
}
.item-registry-alignment-list footer,
.item-registry-links footer {
  display: flex;
  gap: 6px;
  margin-top: 10px;
}
.item-registry-alignment-list footer input,
.item-registry-links footer input {
  flex: 1;
  min-width: 120px;
  border: 1px solid #ccd7d4;
  border-radius: 7px;
  color: #2d463f;
  padding: 0 10px;
  font-size: 10px;
}
.item-registry-alignment-list footer input:focus,
.item-registry-links footer input:focus {
  border-color: #78a99c;
  outline: 2px solid rgba(120, 169, 156, 0.18);
}

.item-registry-pair {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
  gap: 10px;
  align-items: center;
  margin-top: 10px;
}
.item-registry-pair p {
  display: grid;
  gap: 3px;
  margin: 0;
  padding: 10px;
  border-radius: 7px;
  background: #f6f9f8;
}
.item-registry-pair small {
  color: #71827d;
  font-size: 9px;
}
.item-registry-pair strong {
  color: #29413a;
  font-size: 11px;
  word-break: break-word;
}
.item-registry-pair code {
  color: #788984;
  font-size: 9px;
  word-break: break-all;
}
.item-registry-pair > i {
  color: #8a9c96;
}

.item-registry-links {
  margin-top: 6px;
  padding-top: 14px;
  border-top: 1px solid var(--saved-review-line, #d7e1de);
}

.item-registry-links article {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 10px;
}

.item-registry-links article > div {
  display: grid;
  gap: 4px;
  min-width: 0;
}

.item-registry-links a, .item-registry-links code {
  overflow: hidden;
  color: #216555;
  font-size: 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.item-registry-links small {
  color: #71827d;
  font-size: 9px;
}

.item-registry-links footer {
  grid-column: 1/-1;
}

.item-registry-link-header-actions {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 9px;
}
.item-registry-link-header-actions > span {
  color: #60736d;
  font-size: 10px;
  font-weight: 900;
  white-space: nowrap;
}

.item-registry-bulk-approve-button {
  display: inline-flex;
  min-height: 38px;
  align-items: center;
  justify-content: center;
  gap: 7px;
  border: 1px solid var(--saved-review-green, #075443);
  border-radius: 8px;
  background: var(--saved-review-green, #075443);
  color: #fff;
  padding: 0 14px;
  font-size: 10px;
  font-weight: 900;
  white-space: nowrap;
}
.item-registry-bulk-approve-button:hover:not(:disabled), .item-registry-bulk-approve-button:focus-visible {
  background: #0a6652;
}
.item-registry-bulk-approve-button:focus-visible {
  outline: 2px solid #77ac9e;
  outline-offset: 2px;
}
.item-registry-bulk-approve-button:disabled {
  cursor: default;
  opacity: 0.48;
}
.item-registry-bulk-approve-button[aria-busy=true] {
  cursor: wait;
  opacity: 0.72;
}

.item-registry-link-statuses {
  align-content: start;
  justify-items: end;
}
.item-registry-link-statuses em {
  white-space: nowrap;
}

.item-registry-alert,
.item-registry-empty {
  padding: 18px;
  border: 1px dashed #cfdbd7;
  border-radius: 8px;
  background: #f8faf9;
  color: #71827d;
  font-size: 10px;
  text-align: center;
}

.item-registry-shell > .item-registry-alert,
.item-registry-shell > .item-registry-empty {
  margin: 0 16px;
}

.item-registry-alert.is-error {
  border-style: solid;
  border-color: #e7bfc3;
  background: #fff6f7;
  color: #9f3841;
}

@media (max-width: 960px) {
  .item-registry-policy-card {
    grid-template-columns: 40px minmax(0, 1fr);
  }
  .item-registry-revalidate-button {
    grid-column: 1/-1;
    width: 100%;
  }
  .item-registry-validation {
    grid-template-columns: auto 1fr;
  }
  .item-registry-validation dl {
    grid-column: 1/-1;
    justify-content: space-around;
  }
  .item-registry-compare-grid {
    grid-template-columns: 1fr;
  }
  .item-registry-relation-picker {
    grid-template-columns: 1fr;
  }
  .item-registry-compare-summary {
    flex-wrap: wrap;
  }
  .item-registry-compare-candidates {
    grid-template-columns: 1fr;
  }
  .item-registry-review-bar {
    align-items: stretch;
    flex-direction: column;
  }
  .item-registry-review-bar {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 620px) {
  .item-registry-policy-card {
    grid-template-columns: 34px minmax(0, 1fr);
    margin-right: 12px;
    margin-left: 12px;
    padding: 13px;
  }
  .item-registry-policy-icon {
    width: 34px;
    height: 34px;
  }
  .item-registry-links > header {
    align-items: stretch;
    flex-direction: column;
  }
  .item-registry-link-header-actions {
    justify-content: space-between;
  }
  .item-registry-bulk-approve-button {
    min-height: 42px;
  }
  .item-registry-tabs {
    grid-template-columns: 1fr;
  }
  .item-registry-tabs button {
    min-height: 44px;
    font-size: 13px;
  }
  .item-registry-tab-notice {
    padding: 14px 15px;
  }
  .item-registry-tab-notice strong {
    font-size: 13px;
  }
  .item-registry-tab-notice p,
  .item-registry-tab-notice small {
    font-size: 12px;
  }
  .item-registry-validation,
  .item-registry-tabs,
  .item-registry-tab-notice,
  .item-registry-manifestation-screen,
  .item-registry-compare-screen,
  .item-registry-alignment-screen {
    margin-right: 12px;
    margin-left: 12px;
  }
  .item-registry-pair {
    grid-template-columns: 1fr;
  }
  .item-registry-pair > i {
    transform: rotate(90deg);
    justify-self: center;
  }
  .item-registry-alignment-list footer, .item-registry-links footer {
    flex-wrap: wrap;
  }
  .item-registry-alignment-list footer input, .item-registry-links footer input {
    flex-basis: 100%;
    min-height: 38px;
  }
  .item-registry-compare-navigator > header {
    align-items: stretch;
    flex-direction: column;
  }
  .item-registry-filter {
    overflow-x: auto;
  }
  .item-registry-source-tools {
    grid-template-columns: minmax(0, 1fr) auto;
  }
  .item-registry-match-nav {
    grid-column: 1/-1;
    justify-content: flex-end;
  }
}
/* File visibility command center. The public/private decision is edited in
   one inspector; the first list column is only for multi-item bulk scope. */
.visibility-command-center {
  display: grid;
  grid-template-columns: 240px minmax(0, 1fr) 300px;
  width: 100%;
  min-width: 0;
  overflow: hidden;
  border: 1px solid #d7e1de;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 12px 34px rgba(33, 61, 54, 0.07);
  color: #29413a;
}
.visibility-command-center .aside-kicker {
  font-weight: 600;
}

.visibility-command-rail,
.visibility-command-inspector {
  min-width: 0;
  background: #f8faf9;
}

.visibility-command-rail {
  border-right: 1px solid #dce4e2;
}
.visibility-command-rail > header {
  padding: 24px 20px 18px;
  border-bottom: 1px solid #e0e7e5;
}
.visibility-command-rail h3 {
  margin: 6px 0 7px;
  color: #243c35;
  font-size: 19px;
  font-weight: 700;
  letter-spacing: -0.035em;
}
.visibility-command-rail p {
  margin: 0;
  color: #657873;
  font-size: 13px;
  line-height: 1.6;
}

.visibility-command-search {
  display: grid;
  width: min(100%, 840px);
  gap: 9px;
  padding: 0;
}
.visibility-command-search > span {
  color: #425f57;
  font-size: 13px;
  font-weight: 600;
}
.visibility-command-search > div {
  position: relative;
}
.visibility-command-search i {
  position: absolute;
  top: 50%;
  left: 13px;
  color: #738680;
  font-size: 13px;
  transform: translateY(-50%);
  pointer-events: none;
}
.visibility-command-search input {
  width: 100%;
  min-height: 46px;
  padding: 0 62px 0 38px;
  border: 1px solid #cbd8d4;
  border-radius: 8px;
  outline: none;
  background: #fff;
  color: #263f38;
  font-size: 14px;
}
.visibility-command-search input:focus {
  border-color: #287262;
  box-shadow: 0 0 0 3px rgba(40, 114, 98, 0.13);
}
.visibility-command-search button {
  position: absolute;
  top: 50%;
  right: 8px;
  min-height: 32px;
  padding: 0 9px;
  border: 0;
  border-radius: 7px;
  background: #edf3f1;
  color: #45655c;
  font-size: 12px;
  font-weight: 600;
  transform: translateY(-50%);
}

.visibility-command-filter-list {
  display: grid;
  gap: 5px;
  padding: 14px 12px 18px;
  border-bottom: 1px solid #e0e7e5;
}
.visibility-command-filter-list button {
  display: flex;
  min-height: 46px;
  align-items: center;
  justify-content: space-between;
  padding: 0 13px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: #506860;
  font-size: 14px;
  font-weight: 600;
  text-align: left;
}
.visibility-command-filter-list button:hover {
  background: #edf3f1;
}
.visibility-command-filter-list button.is-active {
  background: #e4efeb;
  color: #125c4d;
}
.visibility-command-filter-list em {
  display: inline-grid;
  min-width: 30px;
  min-height: 26px;
  place-items: center;
  padding: 2px 8px;
  border-radius: 999px;
  background: #e7edeb;
  color: #5c706a;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
}
.visibility-command-filter-list button.is-active em {
  background: #fff;
  color: #155f50;
}

.visibility-readiness-card {
  margin: 16px 14px 10px;
  padding: 15px;
  border: 1px solid #d5dfdc;
  border-radius: 10px;
  background: #fff;
}
.visibility-readiness-card.is-complete {
  border-color: #bddbce;
  background: #f5fbf8;
}
.visibility-readiness-card > div {
  display: grid;
  gap: 4px;
  padding-left: 38px;
}
.visibility-readiness-card small {
  color: #657873;
  font-size: 12px;
  font-weight: 600;
}
.visibility-readiness-card strong {
  color: #245d4f;
  font-size: 20px;
  font-weight: 700;
}
.visibility-readiness-card p {
  color: #6b7d77;
  font-size: 12px;
  line-height: 1.55;
}

.visibility-readiness-icon {
  display: grid;
  width: 30px;
  height: 30px;
  float: left;
  place-items: center;
  border-radius: 8px;
  background: #e2f0eb;
  color: #176452;
  font-size: 13px;
}

.visibility-command-policy {
  margin: 10px 14px 20px;
  padding: 14px 15px;
  border: 1px solid #dbe3e1;
  border-radius: 10px;
  background: #fff;
}
.visibility-command-policy summary {
  color: #405a53;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}
.visibility-command-policy ul {
  display: grid;
  gap: 8px;
  margin: 12px 0 0;
  padding: 0 0 0 18px;
  color: #657873;
  font-size: 12px;
  line-height: 1.55;
}

.visibility-command-main {
  min-width: 0;
  background: #fff;
}

.visibility-command-head {
  display: flex;
  min-height: 114px;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 22px 24px;
  border-bottom: 1px solid #dfe6e4;
}
.visibility-command-head h3 {
  margin: 6px 0;
  color: #243d36;
  font-size: 21px;
  font-weight: 700;
  letter-spacing: -0.04em;
}
.visibility-command-head p {
  max-width: 680px;
  margin: 0;
  color: #62756f;
  font-size: 13px;
  line-height: 1.6;
}

.visibility-command-discovery {
  display: flex;
  justify-content: center;
  padding: 18px 20px 4px;
}

.visibility-command-head-actions,
.visibility-command-selected-actions {
  display: flex;
  align-items: center;
  flex: 0 0 auto;
  gap: 8px;
}
.visibility-command-head-actions button,
.visibility-command-selected-actions button {
  min-height: 44px;
  padding: 0 15px;
  border: 1px solid #c8d5d1;
  border-radius: 8px;
  background: #fff;
  color: #3e6158;
  font-size: 13px;
  font-weight: 600;
}
.visibility-command-head-actions button:hover:not(:disabled),
.visibility-command-selected-actions button:hover:not(:disabled) {
  border-color: #77a397;
  background: #f4faf7;
}
.visibility-command-head-actions button.is-active,
.visibility-command-selected-actions button.is-active {
  border-color: #176554;
  background: #e7f3ef;
  color: #125d4d;
  box-shadow: inset 0 0 0 1px rgba(23, 101, 84, 0.12);
}
.visibility-command-head-actions button:disabled,
.visibility-command-selected-actions button:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.visibility-command-summary {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px;
  padding: 18px 20px;
}
.visibility-command-summary article {
  display: flex;
  min-height: 76px;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 14px 15px;
  border: 1px solid #dce4e2;
  border-radius: 10px;
  background: #fbfcfc;
}
.visibility-command-summary span {
  color: #657873;
  font-size: 13px;
  font-weight: 500;
}
.visibility-command-summary strong {
  color: #2b423c;
  font-size: 24px;
  font-weight: 700;
}
.visibility-command-summary .is-public {
  border-color: #c6dfd1;
  background: #f4faf6;
}
.visibility-command-summary .is-public strong {
  color: #247447;
}
.visibility-command-summary .is-private {
  border-color: #d8dce4;
  background: #f8f9fb;
}
.visibility-command-summary .is-private strong {
  color: #4e5e6a;
}
.visibility-command-summary .is-unset.has-items {
  border-color: #ead19b;
  background: #fffaf0;
}
.visibility-command-summary .is-unset.has-items strong {
  color: #9a661f;
}

.visibility-command-toolbar {
  display: flex;
  min-height: 68px;
  align-items: center;
  gap: 12px;
  padding: 10px 18px;
  border-top: 1px solid #e1e7e5;
  border-bottom: 1px solid #e1e7e5;
  background: #f8fbfa;
}

.visibility-command-selection-status {
  display: grid;
  min-width: 190px;
  gap: 3px;
}
.visibility-command-selection-status strong {
  color: #264f45;
  font-size: 14px;
  font-weight: 700;
}
.visibility-command-selection-status span {
  color: #687a75;
  font-size: 12px;
  line-height: 1.4;
}

.visibility-command-selected-actions {
  margin-left: auto;
}
.visibility-command-selected-actions button:not(.is-clear) {
  border-color: #176554;
  background: #176554;
  color: #fff;
}
.visibility-command-selected-actions button:not(.is-clear):hover:not(:disabled) {
  border-color: #0f5648;
  background: #0f5648;
  color: #fff;
}
.visibility-command-selected-actions button.is-clear {
  background: #fff;
  color: #536a63;
}

.visibility-command-result-count {
  flex: 0 0 auto;
  color: #63766f;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
}

.visibility-command-table-head,
.visibility-command-list > li {
  display: grid;
  grid-template-columns: 34px 42px minmax(220px, 1.45fr) minmax(120px, 0.78fr) minmax(150px, 1fr) minmax(108px, 0.72fr);
  align-items: center;
  gap: 10px;
}

.visibility-command-table-head {
  min-height: 46px;
  padding: 0 16px;
  border-bottom: 1px solid #e1e7e5;
  background: #fafcfb;
  color: #5f736c;
  font-size: 12px;
  font-weight: 600;
}

.visibility-command-select-all,
.visibility-command-row-select {
  display: inline-grid;
  min-width: 34px;
  min-height: 44px;
  place-items: center;
  cursor: pointer;
}
.visibility-command-select-all input,
.visibility-command-row-select input {
  width: 18px;
  height: 18px;
  margin: 0;
  accent-color: #176655;
  cursor: pointer;
}
.visibility-command-select-all input:disabled,
.visibility-command-row-select input:disabled {
  cursor: not-allowed;
  opacity: 0.48;
}

.visibility-command-list {
  margin: 0;
  padding: 0;
  list-style: none;
}
.visibility-command-list > li {
  min-height: 76px;
  padding: 10px 16px;
  border-bottom: 1px solid #e2e8e6;
  background: #fff;
  cursor: pointer;
}
.visibility-command-list > li:hover {
  background: #f7fbf9;
}
.visibility-command-list > li:focus-visible {
  position: relative;
  z-index: 1;
  outline: 3px solid rgba(40, 114, 98, 0.22);
  outline-offset: -3px;
}
.visibility-command-list > li.is-selected {
  background: #f3faf7;
  box-shadow: inset 3px 0 0 #176655;
}
.visibility-command-list > li.is-bulk-selected {
  background: #f1f8f5;
}
.visibility-command-list > li.is-unavailable {
  background: #fafbfb;
  color: #62736e;
}

.visibility-command-index {
  display: grid;
  width: 30px;
  height: 30px;
  place-items: center;
  border-radius: 8px;
  background: #edf3f1;
  color: #4f675f;
  font-size: 13px;
  font-weight: 600;
}

.visibility-command-file {
  display: grid;
  min-width: 0;
  gap: 4px;
}
.visibility-command-file strong {
  overflow: hidden;
  color: #263f38;
  font-size: 16px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.visibility-command-file small {
  overflow: hidden;
  color: #71837d;
  font-size: 12px;
  line-height: 1.45;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.visibility-command-identifier {
  overflow: hidden;
  color: #4d665f;
  font-size: 13px;
  font-weight: 500;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.visibility-command-source-state {
  color: #5e706a;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.45;
}
.visibility-command-source-state.is-applied {
  color: #24704f;
}
.visibility-command-source-state.is-warning {
  color: #9a651f;
}
.visibility-command-source-state.is-manual {
  color: #5e5f75;
}
.visibility-command-source-state.is-disabled, .visibility-command-source-state.is-neutral {
  color: #71817c;
}

.visibility-command-state {
  display: inline-flex;
  width: fit-content;
  max-width: 100%;
  min-height: 32px;
  align-items: center;
  padding: 6px 10px;
  border-radius: 999px;
  background: #edf1f0;
  color: #60716c;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.35;
}
.visibility-command-state.is-public {
  background: #e8f6ed;
  color: #247044;
}
.visibility-command-state.is-private {
  background: #edf0f3;
  color: #4b5d69;
}
.visibility-command-state.is-unset {
  background: #fff0d4;
  color: #94621e;
}
.visibility-command-state.is-disabled {
  background: #f0f2f2;
  color: #667773;
}

.visibility-command-empty,
.visibility-inspector-empty {
  display: grid;
  min-height: 270px;
  place-items: center;
  align-content: center;
  gap: 9px;
  padding: 30px;
  color: #6a7d77;
  text-align: center;
}
.visibility-command-empty i,
.visibility-inspector-empty i {
  color: #7e928b;
  font-size: 24px;
}
.visibility-command-empty strong,
.visibility-inspector-empty strong {
  color: #37564e;
  font-size: 16px;
}
.visibility-command-empty p,
.visibility-inspector-empty p {
  max-width: 360px;
  margin: 0;
  font-size: 13px;
  line-height: 1.6;
}
.visibility-command-empty button,
.visibility-inspector-empty button {
  min-height: 44px;
  margin-top: 6px;
  padding: 0 15px;
  border: 1px solid #c8d6d2;
  border-radius: 8px;
  background: #fff;
  color: #365f55;
  font-size: 13px;
  font-weight: 600;
}

.visibility-command-pagination {
  display: flex;
  min-height: 64px;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 16px;
  border-top: 1px solid #e1e7e5;
}
.visibility-command-pagination > span {
  color: #5f746d;
  font-size: 13px;
  font-weight: 600;
}
.visibility-command-pagination > div {
  display: flex;
  gap: 8px;
}
.visibility-command-pagination button {
  min-height: 44px;
  padding: 0 13px;
  border: 1px solid #cad7d3;
  border-radius: 8px;
  background: #fff;
  color: #3d6057;
  font-size: 13px;
  font-weight: 600;
}
.visibility-command-pagination button:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.visibility-command-inspector {
  border-left: 1px solid #dce4e2;
}
.visibility-command-inspector > header {
  display: flex;
  min-height: 62px;
  align-items: center;
  justify-content: space-between;
  padding: 0 18px;
  border-bottom: 1px solid #dce4e2;
  background: #fff;
}
.visibility-command-inspector h3 {
  margin: 0;
  color: #2b453e;
  font-size: 16px;
  font-weight: 700;
}
.visibility-command-inspector > header button {
  width: 44px;
  height: 44px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: #5a7069;
  font-size: 14px;
}

.visibility-inspector-body {
  display: grid;
  gap: 18px;
  padding: 20px 17px 24px;
}

.visibility-inspector-identity {
  display: grid;
  gap: 7px;
}
.visibility-inspector-identity > strong {
  overflow: hidden;
  color: #243e37;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.4;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.visibility-inspector-identity > small {
  overflow: hidden;
  color: #6c7f79;
  font-size: 13px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.visibility-inspector-overview {
  display: grid;
  gap: 11px;
  margin: 0;
  padding: 15px;
  border: 1px solid #dce4e2;
  border-radius: 10px;
  background: #fff;
}
.visibility-inspector-overview > div {
  display: grid;
  grid-template-columns: 88px minmax(0, 1fr);
  gap: 9px;
}
.visibility-inspector-overview dt,
.visibility-inspector-overview dd {
  margin: 0;
  overflow-wrap: anywhere;
  font-size: 12px;
  line-height: 1.55;
}
.visibility-inspector-overview dt {
  color: #748680;
}
.visibility-inspector-overview dd {
  color: #36534b;
  font-weight: 500;
}
.visibility-inspector-overview dd.is-applied {
  color: #24704f;
}
.visibility-inspector-overview dd.is-warning {
  color: #96621d;
}

.visibility-inspector-source {
  padding: 15px;
  border: 1px solid #c8e0d6;
  border-radius: 10px;
  background: #f1f9f6;
}
.visibility-inspector-source strong {
  color: #285c50;
  font-size: 13px;
  font-weight: 700;
}
.visibility-inspector-source p {
  margin: 6px 0 0;
  color: #3d695e;
  font-size: 13px;
  line-height: 1.6;
}
.visibility-inspector-source.is-warning {
  border-color: #ead1a0;
  background: #fff9ed;
}
.visibility-inspector-source.is-warning strong,
.visibility-inspector-source.is-warning p {
  color: #80571e;
}
.visibility-inspector-source.is-manual, .visibility-inspector-source.is-neutral {
  border-color: #d8dde3;
  background: #f7f8fa;
}
.visibility-inspector-source.is-manual strong,
.visibility-inspector-source.is-manual p, .visibility-inspector-source.is-neutral strong,
.visibility-inspector-source.is-neutral p {
  color: #555f6d;
}

.visibility-inspector-choice {
  display: grid;
  gap: 11px;
}
.visibility-inspector-choice > header {
  display: grid;
  gap: 4px;
}
.visibility-inspector-choice > header strong {
  color: #2e4b43;
  font-size: 15px;
  font-weight: 700;
}
.visibility-inspector-choice > header small {
  color: #6e817b;
  font-size: 12px;
  line-height: 1.5;
}
.visibility-inspector-choice > div {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}
.visibility-inspector-choice button {
  display: flex;
  min-height: 64px;
  align-items: center;
  gap: 9px;
  padding: 10px 12px;
  border: 1px solid #cbd7d3;
  border-radius: 9px;
  background: #fff;
  color: #4d645d;
  text-align: left;
}
.visibility-inspector-choice button i {
  flex: 0 0 auto;
  font-size: 14px;
}
.visibility-inspector-choice button span {
  display: grid;
  gap: 3px;
}
.visibility-inspector-choice button strong {
  font-size: 14px;
  font-weight: 700;
}
.visibility-inspector-choice button small {
  color: #75847f;
  font-size: 12px;
}
.visibility-inspector-choice button.is-active {
  border-color: #176554;
  background: #e9f5f1;
  color: #155f50;
  box-shadow: inset 0 0 0 1px rgba(23, 101, 84, 0.12);
}
.visibility-inspector-choice button:disabled {
  opacity: 0.46;
  cursor: not-allowed;
}
.visibility-inspector-choice > p {
  margin: 0;
  padding: 11px 12px;
  border-radius: 8px;
  background: #f0f3f2;
  color: #60736d;
  font-size: 12px;
  line-height: 1.55;
}

.visibility-inspector-body .registration-safety-warning {
  gap: 9px;
  margin-top: 0;
  padding: 14px;
}
.visibility-inspector-body .registration-safety-warning strong {
  font-size: 13px;
}
.visibility-inspector-body .registration-safety-warning p,
.visibility-inspector-body .registration-safety-warning a,
.visibility-inspector-body .registration-safety-warning label,
.visibility-inspector-body .registration-safety-warning small {
  font-size: 12px;
  line-height: 1.55;
}
.visibility-inspector-body .registration-safety-warning button {
  min-height: 42px;
  font-size: 12px;
}
.visibility-inspector-body .registration-safety-warning input[type=checkbox] {
  width: 17px;
  height: 17px;
}
.visibility-inspector-body .registration-safety-warning textarea {
  min-height: 96px;
  font-size: 13px;
  line-height: 1.55;
}

.visibility-command-center button:focus-visible,
.visibility-command-center input:focus-visible,
.visibility-command-center summary:focus-visible,
.visibility-command-center textarea:focus-visible {
  outline: 3px solid rgba(40, 114, 98, 0.22);
  outline-offset: 2px;
}

@media (max-width: 1320px) {
  .visibility-command-center {
    grid-template-columns: 240px minmax(0, 1fr);
  }
  .visibility-command-inspector {
    grid-column: 1/-1;
    border-top: 1px solid #dce4e2;
    border-left: 0;
  }
  .visibility-inspector-body {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    align-items: start;
  }
  .visibility-inspector-body .registration-safety-warning {
    grid-column: 1/-1;
  }
  .visibility-command-table-head,
  .visibility-command-list > li {
    grid-template-columns: 34px 38px minmax(195px, 1.35fr) minmax(130px, 0.85fr) minmax(120px, 0.85fr) 104px;
  }
}
@media (max-width: 1040px) {
  .visibility-command-table-head,
  .visibility-command-list > li {
    grid-template-columns: 34px 38px minmax(190px, 1.3fr) minmax(135px, 0.9fr) 104px;
  }
  .visibility-command-table-head > span:nth-of-type(4),
  .visibility-command-source-state {
    display: none;
  }
}
@media (max-width: 960px) {
  .visibility-command-center {
    grid-template-columns: 1fr;
  }
  .visibility-command-rail {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    border-right: 0;
    border-bottom: 1px solid #dce4e2;
  }
  .visibility-command-rail > header,
  .visibility-command-policy {
    grid-column: 1/-1;
  }
  .visibility-command-filter-list {
    border-bottom: 0;
  }
  .visibility-command-summary {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 720px) {
  .visibility-command-main {
    order: 1;
  }
  .visibility-command-rail {
    order: 2;
    grid-template-columns: 1fr;
  }
  .visibility-command-inspector {
    order: 3;
  }
  .visibility-command-rail > header,
  .visibility-command-policy {
    grid-column: auto;
  }
  .visibility-command-head {
    align-items: stretch;
    flex-direction: column;
  }
  .visibility-command-head-actions,
  .visibility-command-selected-actions {
    width: 100%;
  }
  .visibility-command-head-actions button,
  .visibility-command-selected-actions button {
    flex: 1;
  }
  .visibility-command-summary {
    padding: 12px;
  }
  .visibility-command-summary article {
    min-height: 68px;
    padding: 11px;
  }
  .visibility-command-summary strong {
    font-size: 21px;
  }
  .visibility-command-toolbar {
    align-items: stretch;
    flex-direction: column;
    padding: 12px;
  }
  .visibility-command-selected-actions {
    margin-left: 0;
  }
  .visibility-command-result-count {
    align-self: flex-end;
  }
  .visibility-command-table-head {
    display: none;
  }
  .visibility-command-list > li {
    grid-template-columns: 34px 34px minmax(0, 1fr);
    gap: 8px 10px;
    padding: 13px 12px;
  }
  .visibility-command-row-select {
    grid-column: 1;
    grid-row: 1/span 4;
  }
  .visibility-command-index {
    grid-column: 2;
    grid-row: 1;
  }
  .visibility-command-file {
    grid-column: 3;
    grid-row: 1;
  }
  .visibility-command-identifier {
    grid-column: 2/-1;
    grid-row: 2;
  }
  .visibility-command-source-state {
    display: block;
    grid-column: 2/-1;
    grid-row: 3;
  }
  .visibility-command-state {
    grid-column: 2/-1;
    grid-row: 4;
  }
  .visibility-inspector-body {
    grid-template-columns: 1fr;
  }
  .visibility-inspector-body .registration-safety-warning {
    grid-column: auto;
  }
}
@media (max-width: 440px) {
  .visibility-command-head-actions,
  .visibility-command-selected-actions,
  .visibility-inspector-choice > div {
    grid-template-columns: 1fr;
    flex-direction: column;
  }
  .visibility-command-head-actions button,
  .visibility-command-selected-actions button {
    width: 100%;
  }
  .visibility-command-summary {
    grid-template-columns: 1fr 1fr;
  }
  .visibility-command-file strong {
    font-size: 15px;
  }
}
@media (prefers-reduced-motion: reduce) {
  .visibility-command-center * {
    scroll-behavior: auto !important;
    transition-duration: 1ms !important;
    animation-duration: 1ms !important;
  }
}
/* XML 이미지 참조를 실제 스토리지 자산과 연결하는 공용 갤러리 */
.xml-image-asset-panel {
  min-width: 0;
  padding: 18px;
  border: 1px solid #d8e5e1;
  border-radius: 16px;
  background: #fff;
}
.xml-image-asset-panel > header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;
}
.xml-image-asset-panel > header h4,
.xml-image-asset-panel > header p {
  margin: 0;
}
.xml-image-asset-panel > header h4,
.xml-image-asset-panel > header strong {
  display: block;
  color: #24483f;
  font-size: 13px;
  font-weight: 700;
}
.xml-image-asset-panel > header p,
.xml-image-asset-panel > header small {
  display: block;
  margin-top: 5px;
  color: #70837d;
  font-size: 10px;
  line-height: 1.55;
}
.xml-image-asset-panel > header > em {
  flex: 0 0 auto;
  border-radius: 999px;
  padding: 6px 10px;
  background: #e9f5f1;
  color: #246b59;
  font-size: 10px;
  font-style: normal;
  font-weight: 700;
}
.xml-image-asset-panel.is-saved {
  border: 0;
  border-radius: 0;
  padding: 18px 20px 20px;
}

.xml-image-asset-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 14px;
}
.xml-image-asset-grid > article {
  min-width: 0;
  overflow: hidden;
  border: 1px solid #dce7e3;
  border-radius: 13px;
  background: #fff;
  box-shadow: 0 8px 24px rgba(36, 72, 63, 0.055);
}
.xml-image-asset-grid > article.is-unavailable {
  background: #f8faf9;
}

.xml-image-asset-preview,
.xml-image-asset-placeholder {
  display: grid;
  width: 100%;
  aspect-ratio: 4/3;
  place-items: center;
  overflow: hidden;
  border-bottom: 1px solid #e0e9e6;
  background: #eef4f2;
}

.xml-image-asset-preview img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: #f3f6f5;
  transition: transform 160ms ease;
}
.xml-image-asset-preview:hover img {
  transform: scale(1.015);
}

.xml-image-asset-placeholder {
  align-content: center;
  gap: 8px;
  padding: 14px;
  box-sizing: border-box;
  color: #758983;
  text-align: center;
}
.xml-image-asset-placeholder > i {
  font-size: 26px;
}
.xml-image-asset-placeholder > strong {
  font-size: 10px;
}
.xml-image-asset-placeholder > button {
  min-height: 30px;
  border: 1px solid #6b9c90;
  border-radius: 8px;
  padding: 0 10px;
  background: #fff;
  color: #286759;
  font-size: 9px;
  font-weight: 700;
  cursor: pointer;
}
.xml-image-asset-placeholder > button:disabled {
  cursor: wait;
  opacity: 0.6;
}

.xml-image-asset-body {
  display: grid;
  gap: 8px;
  padding: 12px;
}
.xml-image-asset-body > strong {
  overflow: hidden;
  color: #294a42;
  font-size: 11px;
  font-weight: 700;
  line-height: 1.45;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.xml-image-asset-body > p {
  display: -webkit-box;
  overflow: hidden;
  margin: 0;
  color: #61756f;
  font-size: 9px;
  line-height: 1.55;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}
.xml-image-asset-body dl {
  display: grid;
  gap: 5px;
  margin: 0;
}
.xml-image-asset-body dl > div {
  display: grid;
  grid-template-columns: 34px minmax(0, 1fr);
  gap: 7px;
}
.xml-image-asset-body dl dt,
.xml-image-asset-body dl dd {
  margin: 0;
  font-size: 8px;
  line-height: 1.45;
}
.xml-image-asset-body dl dt {
  color: #82928d;
  font-weight: 700;
}
.xml-image-asset-body dl dd {
  overflow-wrap: anywhere;
  color: #526963;
}
.xml-image-asset-body > small.is-error {
  color: #b54335;
  font-size: 8px;
  line-height: 1.45;
}

.xml-image-asset-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-top: 16px;
}
.xml-image-asset-pagination span {
  color: #667a74;
  font-size: 9px;
  font-weight: 700;
}
.xml-image-asset-pagination button {
  min-height: 30px;
  border: 1px solid #cfddd8;
  border-radius: 8px;
  padding: 0 11px;
  background: #fff;
  color: #345e53;
  font-size: 9px;
  font-weight: 700;
}
.xml-image-asset-pagination button:disabled {
  color: #a4b0ac;
  background: #f4f7f6;
}

@media (max-width: 720px) {
  .xml-image-asset-panel > header {
    align-items: stretch;
    flex-direction: column;
  }
  .xml-image-asset-grid {
    grid-template-columns: 1fr;
  }
}
/* 2단계 메타데이터 검수 시각 위계 및 버튼 크기 보정 */
.metadata-v21-review {
  margin: 18px 0;
  padding: 18px;
  border: 1px solid #d9e2ee;
  border-radius: 16px;
  background: #f8fafc;
}

.metadata-v21-head,
.metadata-v21-field-head,
.metadata-v21-candidate-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.metadata-v21-head h4,
.metadata-v21-field-head strong {
  margin: 3px 0;
  color: #172033;
}

.metadata-v21-head p,
.metadata-v21-direct-note,
.metadata-v21-empty {
  margin: 4px 0 0;
  color: #64748b;
  font-size: 12px;
}

.metadata-v21-status {
  flex: none;
  padding: 6px 10px;
  border-radius: 999px;
  background: #fff7ed;
  color: #c2410c;
  font-size: 11px;
  font-weight: 700;
}

.metadata-v21-status.is-complete {
  background: #ecfdf5;
  color: #047857;
}

.metadata-v21-legend,
.metadata-v21-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
  margin-top: 14px;
}

.metadata-v21-legend span {
  padding: 4px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
}

.metadata-v21-legend .is-structure {
  background: #e0f2fe;
  color: #0369a1;
}

.metadata-v21-legend .is-v1 {
  background: #f1f5f9;
  color: #475569;
}

.metadata-v21-legend .is-v21 {
  background: #ede9fe;
  color: #6d28d9;
}

.metadata-v21-tabs button {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 8px 10px;
  border: 1px solid #dbe3ec;
  border-radius: 9px;
  background: white;
  color: #475569;
}

.metadata-v21-tabs button.is-active {
  border-color: #334155;
  color: #0f172a;
  box-shadow: 0 0 0 1px #334155;
}

.metadata-v21-tabs button.is-complete em {
  color: #047857;
}

.metadata-v21-tabs em {
  font-size: 10px;
  font-style: normal;
}

.metadata-v21-field {
  margin-top: 12px;
  padding: 14px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: white;
}

.metadata-v21-field-head span {
  margin-left: 8px;
  color: #64748b;
  font-size: 11px;
}

.metadata-v21-field-head span.has-conflict {
  color: #b45309;
}

.metadata-v21-confirm {
  padding: 7px 10px;
  border-radius: 8px;
  background: #172033;
  color: white;
  font-size: 12px;
  font-weight: 700;
}

.metadata-v21-confirm.is-complete {
  background: #047857;
}

.metadata-v21-candidates {
  display: grid;
  gap: 8px;
  margin-top: 12px;
}

.metadata-v21-candidate {
  display: grid;
  gap: 5px;
  width: 100%;
  padding: 11px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #fff;
  text-align: left;
}

.metadata-v21-candidate:hover,
.metadata-v21-candidate.is-selected {
  border-color: #7c3aed;
  background: #faf5ff;
}

.metadata-v21-candidate-top {
  justify-content: flex-start;
}

.metadata-v21-candidate-top em {
  padding: 3px 6px;
  border-radius: 999px;
  background: #eef2ff;
  color: #4338ca;
  font-size: 10px;
  font-style: normal;
  font-weight: 700;
}

.metadata-v21-candidate q {
  overflow: hidden;
  color: #64748b;
  font-size: 11px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@media (max-width: 760px) {
  .metadata-v21-head,
  .metadata-v21-field-head {
    align-items: flex-start;
    flex-direction: column;
  }
}
.source-analysis-workspace {
  display: grid;
  gap: 16px;
  margin-top: 18px;
  border-top: 1px solid #dfe7e5;
  padding-top: 18px;
}

.source-analysis-heading,
.source-analysis-card-head,
.source-analysis-actions,
.source-analysis-partial-choice {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
}

.source-analysis-heading h3,
.source-analysis-heading p,
.source-analysis-card-head strong,
.source-profile-choice p,
.source-analysis-issue p,
.source-analysis-partial-choice p {
  margin: 0;
}

.source-analysis-heading p,
.source-analysis-partial-choice p {
  margin-top: 5px;
  color: #61716e;
  font-size: 12px;
  line-height: 1.55;
}

.source-analysis-summary {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 9px;
}

.source-analysis-summary article {
  display: grid;
  gap: 5px;
  border: 1px solid #dce5e3;
  border-radius: 12px;
  background: #f8fbfa;
  padding: 12px;
}

.source-analysis-summary span {
  color: #64736f;
  font-size: 11px;
  font-weight: 700;
}

.source-analysis-summary strong {
  color: #263d38;
  font-size: 21px;
}

.source-analysis-summary .is-complete {
  border-color: #a7d5c5;
  background: #f0faf6;
}

.source-analysis-summary .is-attention {
  border-color: #e9c77e;
  background: #fff9eb;
}

.source-analysis-summary .is-error {
  border-color: #e6b0aa;
  background: #fff4f2;
}

.source-analysis-summary .is-running {
  border-color: #a9c8df;
  background: #f2f8fc;
}

.source-analysis-list {
  display: grid;
  gap: 12px;
}

.source-analysis-card {
  display: grid;
  gap: 14px;
  border: 1px solid #d8e2df;
  border-radius: 14px;
  background: #ffffff;
  padding: 16px;
  box-shadow: 0 5px 16px rgba(35, 58, 52, 0.05);
}

.source-analysis-card.is-complete {
  border-color: #8fc8b4;
}

.source-analysis-card.is-attention {
  border-color: #dfb962;
}

.source-analysis-card.is-error {
  border-color: #d89289;
}

.source-analysis-card.is-running {
  border-color: #8eb8d5;
}

.source-analysis-identity {
  display: flex;
  align-items: flex-start;
  min-width: 0;
  gap: 10px;
}

.source-analysis-identity > span {
  display: grid;
  place-items: center;
  flex: 0 0 28px;
  height: 28px;
  border-radius: 8px;
  background: #edf3f1;
  color: #36534c;
  font-size: 12px;
  font-weight: 800;
}

.source-analysis-identity div {
  display: grid;
  min-width: 0;
  gap: 3px;
}

.source-analysis-identity strong {
  overflow-wrap: anywhere;
  color: #243b36;
}

.source-analysis-identity small {
  color: #70807c;
}

.source-analysis-state {
  flex: 0 0 auto;
  border-radius: 999px;
  background: #eef3f2;
  padding: 6px 10px;
  color: #50635e;
  font-size: 11px;
  font-style: normal;
  font-weight: 800;
}

.source-analysis-state.is-complete {
  background: #e8f7f1;
  color: #17664d;
}

.source-analysis-state.is-attention {
  background: #fff3d5;
  color: #805b0a;
}

.source-analysis-state.is-error {
  background: #fde9e6;
  color: #963b31;
}

.source-analysis-state.is-running {
  background: #e8f3fa;
  color: #235f86;
}

.source-analysis-overview,
.source-analysis-detail dl {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 9px;
  margin: 0;
}

.source-analysis-overview > div,
.source-analysis-detail dl > div {
  display: grid;
  min-width: 0;
  gap: 4px;
  border-radius: 9px;
  background: #f7f9f9;
  padding: 10px;
}

.source-analysis-overview dt,
.source-analysis-detail dt {
  color: #6d7c78;
  font-size: 10px;
  font-weight: 800;
}

.source-analysis-overview dd,
.source-analysis-detail dd {
  margin: 0;
  overflow-wrap: anywhere;
  color: #2f4741;
  font-size: 12px;
  font-weight: 700;
}

.source-profile-choice {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(190px, 0.45fr);
  gap: 8px 16px;
  border: 1px solid #d7e2df;
  border-radius: 11px;
  background: #f8fbfa;
  padding: 13px;
}

.source-profile-choice > div {
  display: grid;
  gap: 4px;
}

.source-profile-choice p,
.source-profile-choice small {
  color: #5d706b;
  font-size: 11px;
  line-height: 1.5;
}

.source-profile-choice label {
  display: grid;
  gap: 5px;
  color: #435b55;
  font-size: 11px;
  font-weight: 800;
}

.source-profile-choice select {
  width: 100%;
  min-height: 38px;
  border: 1px solid #b8c9c4;
  border-radius: 8px;
  background: #ffffff;
  padding: 0 10px;
}

.source-profile-choice > small {
  grid-column: 1/-1;
}

.source-analysis-issue {
  display: grid;
  gap: 8px;
  border: 1px solid #e5b1aa;
  border-radius: 10px;
  background: #fff5f3;
  padding: 12px;
  color: #7e362f;
}

.source-analysis-issue dl {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 18px;
  margin: 0;
}

.source-analysis-issue dl > div {
  display: flex;
  gap: 6px;
}

.source-analysis-issue dt {
  font-weight: 800;
}

.source-analysis-issue dd {
  margin: 0;
}

.source-analysis-actions {
  justify-content: flex-start;
  flex-wrap: wrap;
}

.source-analysis-actions button {
  border: 1px solid #c7d4d0;
  border-radius: 8px;
  background: #ffffff;
  padding: 8px 11px;
  color: #36534c;
  font-size: 11px;
  font-weight: 800;
}

.source-analysis-detail {
  border-top: 1px dashed #cbd8d5;
  padding-top: 13px;
}

.source-analysis-detail code,
.source-analysis-detail small {
  display: block;
  overflow-wrap: anywhere;
  white-space: normal;
  font-size: 10px;
  font-weight: 500;
}

.source-analysis-detail small {
  margin-top: 4px;
  color: #71817d;
}

.source-analysis-partial-choice {
  align-items: flex-start;
  border: 1px solid #e0b763;
  border-radius: 12px;
  background: #fff9ea;
  padding: 14px;
}

.source-analysis-partial-choice > div:last-child {
  display: flex;
  flex: 0 0 auto;
  flex-wrap: wrap;
  gap: 8px;
}

@media (max-width: 980px) {
  .source-analysis-summary {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .source-analysis-overview,
  .source-analysis-detail dl {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 680px) {
  .source-analysis-heading,
  .source-analysis-card-head,
  .source-analysis-partial-choice {
    align-items: stretch;
    flex-direction: column;
  }
  .source-analysis-summary,
  .source-analysis-overview,
  .source-analysis-detail dl,
  .source-profile-choice {
    grid-template-columns: 1fr;
  }
  .source-profile-choice > small {
    grid-column: auto;
  }
}
.layout-region-detail.is-extracted {
  grid-template-columns: minmax(280px, 0.82fr) minmax(0, 1.55fr);
  align-items: stretch;
}

.layout-actual-preview {
  position: relative;
  min-height: 260px;
  display: grid;
  place-items: center;
  overflow: hidden;
  border: 1px solid #d8e2e0;
  border-radius: 14px;
  background: linear-gradient(45deg, rgba(25, 74, 67, 0.035) 25%, transparent 25%) 0 0/18px 18px, linear-gradient(-45deg, rgba(25, 74, 67, 0.035) 25%, transparent 25%) 0 9px/18px 18px, #f8fbfa;
}
.layout-actual-preview img {
  display: block;
  width: 100%;
  max-height: 520px;
  object-fit: contain;
  background: #fff;
}

.layout-preview-state {
  display: grid;
  justify-items: center;
  gap: 10px;
  padding: 28px;
  color: #526963;
  text-align: center;
}
.layout-preview-state p {
  margin: 0;
  max-width: 320px;
  font-size: 12px;
  line-height: 1.65;
  color: #71847f;
}

.layout-preview-spinner {
  width: 18px;
  height: 18px;
  display: inline-block;
  flex: 0 0 auto;
  border: 2px solid rgba(31, 84, 75, 0.2);
  border-top-color: #1f544b;
  border-radius: 999px;
  animation: layout-preview-spin 0.8s linear infinite;
}

@keyframes layout-preview-spin {
  to {
    transform: rotate(360deg);
  }
}
.layout-image-download {
  position: absolute;
  right: 12px;
  bottom: 12px;
  padding: 8px 12px;
  border-radius: 9px;
  background: rgba(20, 66, 58, 0.92);
  color: #fff !important;
  font-size: 12px;
  font-weight: 800;
  text-decoration: none;
  box-shadow: 0 8px 20px rgba(20, 66, 58, 0.18);
}

.layout-extracted-summary {
  margin: 10px 0 0;
  padding: 12px 14px;
  border-radius: 10px;
  background: #f3f7f6;
  color: #334d47;
  font-size: 13px;
  line-height: 1.65;
  white-space: pre-wrap;
}

.layout-table-extraction {
  margin-top: 12px;
  border: 1px solid #dce5e3;
  border-radius: 12px;
  overflow: hidden;
}
.layout-table-extraction > div:first-child {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 12px;
  background: #f5f8f7;
  font-size: 12px;
  color: #5d716c;
}
.layout-table-extraction > div:first-child strong {
  color: #213e38;
}
.layout-table-extraction > div:first-child button {
  margin-left: auto;
  padding: 4px 8px;
  border: 1px solid #bdd0cb;
  border-radius: 7px;
  background: #fff;
  color: #24574d;
  font-size: 10px;
  font-weight: 800;
}

.layout-table-scroll {
  max-height: 270px;
  overflow: auto;
  background: #fff;
}
.layout-table-scroll table {
  width: max-content;
  min-width: 100%;
  border-collapse: collapse;
}
.layout-table-scroll td {
  min-width: 92px;
  max-width: 240px;
  padding: 8px 10px;
  border-right: 1px solid #e6ecea;
  border-bottom: 1px solid #e6ecea;
  color: #304943;
  font-size: 12px;
  line-height: 1.45;
  vertical-align: top;
}

.layout-annotation-context {
  margin-top: 12px;
  padding: 12px 14px;
  border: 1px solid #ead5ad;
  border-radius: 10px;
  background: #fff9ee;
}
.layout-annotation-context strong {
  display: block;
  color: #76521f;
  font-size: 12px;
}
.layout-annotation-context p {
  margin: 5px 0 0;
  color: #6c604d;
  font-size: 12px;
  line-height: 1.6;
}

.multilingual-launch-panel {
  padding: 22px;
  border: 1px solid #d7e0ee;
  border-radius: 16px;
  background: linear-gradient(135deg, #fbfcff 0%, #f5f8ff 100%);
  box-shadow: 0 10px 26px rgba(35, 57, 92, 0.05);
}

.multilingual-launch-copy {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
}
.multilingual-launch-copy h3 {
  margin: 3px 0 5px;
  color: #17283e;
  font-size: 18px;
}
.multilingual-launch-copy p {
  margin: 0;
  color: #607088;
  font-size: 13px;
  line-height: 1.6;
}

.multilingual-stage {
  flex: 0 0 auto;
  padding: 7px 11px;
  border: 1px solid #d6dfec;
  border-radius: 999px;
  background: #fff;
  color: #607088;
  font-size: 11px;
  font-weight: 800;
}
.multilingual-stage.is-complete {
  border-color: #a9d5c4;
  background: #edf8f4;
  color: #1f6a55;
}
.multilingual-stage.is-partial, .multilingual-stage.is-failed {
  border-color: #e7c98e;
  background: #fff8e8;
  color: #926319;
}

.multilingual-launch-summary {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px;
  margin-top: 18px;
}
.multilingual-launch-summary > div {
  min-width: 0;
  padding: 12px 13px;
  border: 1px solid #e0e6f0;
  border-radius: 11px;
  background: rgba(255, 255, 255, 0.82);
}
.multilingual-launch-summary span {
  display: block;
  color: #7a8799;
  font-size: 10px;
  font-weight: 800;
}
.multilingual-launch-summary strong {
  display: block;
  margin-top: 5px;
  color: #26384f;
  font-size: 14px;
}

.multilingual-launch-actions {
  display: flex;
  justify-content: flex-end;
  gap: 9px;
  margin-top: 15px;
}
.multilingual-launch-actions button {
  min-height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.multilingual-viewer-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1200;
  display: grid;
  place-items: center;
  padding: 26px;
  background: rgba(13, 27, 39, 0.58);
  backdrop-filter: blur(5px);
}

.multilingual-page-viewer {
  width: min(1280px, 96vw);
  height: min(820px, 92vh);
  display: grid;
  grid-template-rows: auto minmax(0, 1fr) auto;
  overflow: hidden;
  border: 1px solid #d9e0e9;
  border-radius: 18px;
  background: #fff;
  box-shadow: 0 28px 80px rgba(11, 25, 42, 0.3);
}
.multilingual-page-viewer > header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  padding: 20px 22px;
  border-bottom: 1px solid #e3e8ef;
  background: #f8faff;
}
.multilingual-page-viewer > header h3 {
  margin: 2px 0 4px;
  color: #17283e;
  font-size: 20px;
}
.multilingual-page-viewer > header p {
  margin: 0;
  color: #69778b;
  font-size: 12px;
}

.viewer-close {
  width: 38px;
  height: 38px;
  border: 1px solid #d6dee9;
  border-radius: 10px;
  background: #fff;
  color: #506078;
  font-size: 23px;
  line-height: 1;
}

.multilingual-viewer-body {
  min-height: 0;
  display: grid;
  grid-template-columns: 170px minmax(0, 1fr);
}

.translation-page-rail {
  min-height: 0;
  overflow-y: auto;
  padding: 12px;
  border-right: 1px solid #e4e9f0;
  background: #f7f9fc;
}
.translation-page-rail button {
  width: 100%;
  display: grid;
  gap: 3px;
  margin-bottom: 6px;
  padding: 10px 11px;
  border: 1px solid transparent;
  border-radius: 9px;
  background: transparent;
  color: #53647a;
  text-align: left;
}
.translation-page-rail button strong {
  font-size: 12px;
}
.translation-page-rail button span {
  font-size: 10px;
  color: #8a96a6;
}
.translation-page-rail button.is-active {
  border-color: #9ab8dc;
  background: #fff;
  color: #1f4f86;
  box-shadow: 0 5px 14px rgba(45, 83, 130, 0.09);
}

.translation-page-content {
  min-width: 0;
  min-height: 0;
  overflow-y: auto;
  padding: 20px;
}

.translation-page-heading {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-bottom: 12px;
}
.translation-page-heading span {
  color: #8b98aa;
  font-size: 10px;
  font-weight: 800;
  text-transform: uppercase;
}
.translation-page-heading h4 {
  margin: 1px 0 0;
  color: #20344e;
  font-size: 18px;
}
.translation-page-heading em {
  color: #748299;
  font-size: 11px;
  font-style: normal;
}

.page-parallel-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
}
.page-parallel-grid > article,
.page-parallel-grid > label {
  min-width: 0;
  padding: 15px;
  border: 1px solid #dfe5ed;
  border-radius: 12px;
  background: #fbfcfe;
}
.page-parallel-grid span {
  display: block;
  margin-bottom: 9px;
  color: #6b7c92;
  font-size: 11px;
  font-weight: 800;
}
.page-parallel-grid p {
  margin: 0;
  color: #2c3e55;
  font-size: 13px;
  line-height: 1.8;
  white-space: pre-wrap;
}
.page-parallel-grid textarea {
  width: 100%;
  min-height: 470px;
  resize: vertical;
  border: 0;
  outline: 0;
  background: transparent;
  color: #2c3e55;
  font: inherit;
  font-size: 13px;
  line-height: 1.8;
}

.viewer-term-strip {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
  padding: 11px 18px;
  border-top: 1px solid #e3e8ef;
  background: #f9fbfd;
}
.viewer-term-strip > strong {
  flex: 0 0 auto;
  color: #2a405c;
  font-size: 11px;
}
.viewer-term-strip > div {
  display: flex;
  gap: 7px;
  min-width: 0;
  overflow-x: auto;
}
.viewer-term-strip span {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 5px 8px;
  border-radius: 7px;
  background: #eef3f8;
  color: #52657d;
  font-size: 10px;
}
.viewer-term-strip span b {
  color: inherit;
  font: inherit;
}
.viewer-term-strip span em,
.viewer-term-strip span small {
  font-size: 8px;
  font-style: normal;
}
.viewer-term-strip span em {
  color: #8a601d;
  font-weight: 800;
}
.viewer-term-strip span small {
  color: #718096;
}
.viewer-term-strip span.needs-review {
  border: 1px solid #e4c37d;
  background: #fff7e7;
  color: #76531a;
}

@media (max-width: 900px) {
  .layout-region-detail.is-extracted,
  .multilingual-viewer-body,
  .page-parallel-grid {
    grid-template-columns: 1fr;
  }
  .multilingual-launch-summary {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .translation-page-rail {
    display: flex;
    overflow-x: auto;
    border-right: 0;
    border-bottom: 1px solid #e4e9f0;
  }
  .translation-page-rail button {
    width: auto;
    min-width: 92px;
    margin: 0 6px 0 0;
  }
  .multilingual-page-viewer {
    height: 95vh;
  }
  .page-parallel-grid textarea {
    min-height: 280px;
  }
}
.register-page {
  min-height: 100vh;
  background: linear-gradient(180deg, #f7f8fa 0%, #eef2f6 100%);
  color: #111827;
  letter-spacing: 0;
}

.register-header {
  position: sticky;
  top: 0;
  z-index: 30;
  border-bottom: 1px solid #dbe2ea;
  background: rgba(255, 255, 255, 0.94);
  backdrop-filter: blur(12px);
  box-shadow: 0 10px 28px rgba(22, 31, 45, 0.06);
}

.register-header-inner,
.register-main {
  width: min(100%, 1120px);
  margin: 0 auto;
  padding: 0 24px;
}

.register-header-inner {
  display: flex;
  height: 74px;
  align-items: center;
  justify-content: space-between;
}

.brand-link {
  display: inline-flex;
  align-items: center;
}

.brand-logo {
  width: auto;
  height: 48px;
  object-fit: contain;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.account-menu {
  position: relative;
}

.account-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 38px;
  max-width: 210px;
  padding: 0 12px;
  border: 1px solid #cbd7e3;
  border-radius: 8px;
  background: #ffffff;
  color: #2f3a48;
  font-size: 13px;
  font-weight: 900;
  text-decoration: none;
  white-space: nowrap;
  box-shadow: 0 8px 18px rgba(22, 31, 45, 0.06);
}

.account-button:hover {
  border-color: #97a8ba;
  background: #f7fafc;
}

.account-avatar {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 999px;
  background: #33302d;
  color: #ffffff;
}

.account-avatar svg {
  width: 15px;
  height: 15px;
}

.account-name {
  overflow: hidden;
  min-width: 0;
  max-width: 126px;
  text-overflow: ellipsis;
}

.account-chevron {
  flex: 0 0 auto;
  width: 16px;
  height: 16px;
  color: #667381;
  transition: transform 200ms ease;
}

.account-chevron.is-open {
  transform: rotate(180deg);
}

.account-dropdown {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  z-index: 50;
  overflow: hidden;
  width: 176px;
  padding: 4px 0;
  border: 1px solid #dbe2ea;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 18px 38px rgba(22, 31, 45, 0.16);
  visibility: hidden;
  opacity: 0;
  pointer-events: none;
  transform: translateY(-8px) scale(0.98);
  transform-origin: top right;
  transition: opacity 200ms ease, transform 200ms cubic-bezier(0.22, 1, 0.36, 1), visibility 0s linear 200ms;
  will-change: opacity, transform;
}

.account-dropdown.is-open {
  visibility: visible;
  opacity: 1;
  pointer-events: auto;
  transform: translateY(0) scale(1);
  transition-delay: 0s;
}

.account-dropdown a {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 40px;
  padding: 0 12px;
  color: #344052;
  font-size: 13px;
  font-weight: 900;
  text-decoration: none;
}

.account-dropdown a:hover {
  background: #f7fafc;
  color: #111827;
}

.account-dropdown a svg {
  width: 17px;
  height: 17px;
  color: #667381;
}

.account-dropdown .logout-link {
  color: #dc2626;
}

.account-dropdown .logout-link:hover {
  background: #fff1f2;
  color: #b91c1c;
}

.account-dropdown .logout-link svg {
  color: currentColor;
}

@media (prefers-reduced-motion: reduce) {
  .account-chevron,
  .account-dropdown {
    transition-duration: 0.01ms;
  }
}
.register-page.is-upload-step .analysis-progress-panel,
.register-page.is-upload-step .source-analysis-workspace {
  display: none !important;
}

.analysis-command-center {
  display: grid;
  grid-template-columns: 260px minmax(0, 1fr) 290px;
  width: 100%;
  min-width: 0;
  overflow: hidden;
  border: 1px solid #d7e1de;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 12px 34px rgba(33, 61, 54, 0.07);
  color: #29413a;
}

.analysis-command-rail,
.analysis-command-inspector {
  min-width: 0;
  background: #f8faf9;
}

.analysis-command-rail {
  border-right: 1px solid #dce4e2;
}
.analysis-command-rail > header {
  padding: 22px 18px 16px;
  border-bottom: 1px solid #e0e7e5;
}
.analysis-command-rail h3 {
  margin: 5px 0 6px;
  color: #243c35;
  font-size: 17px;
  font-weight: 900;
  letter-spacing: -0.035em;
}
.analysis-command-rail p {
  margin: 0;
  color: #6a7a75;
  font-size: 12px;
  line-height: 1.55;
}

.analysis-command-search {
  display: grid;
  gap: 8px;
  padding: 16px 16px 12px;
}
.analysis-command-search > span {
  color: #506861;
  font-size: 12px;
  font-weight: 850;
}
.analysis-command-search > div {
  position: relative;
}
.analysis-command-search i {
  position: absolute;
  top: 50%;
  left: 12px;
  color: #80908b;
  font-size: 12px;
  transform: translateY(-50%);
  pointer-events: none;
}
.analysis-command-search input {
  width: 100%;
  min-height: 42px;
  padding: 0 12px 0 34px;
  border: 1px solid #cdd8d5;
  border-radius: 7px;
  outline: none;
  background: #fff;
  color: #2d453e;
  font-size: 13px;
}
.analysis-command-search input:focus {
  border-color: #287262;
  box-shadow: 0 0 0 3px rgba(40, 114, 98, 0.13);
}

.analysis-command-filter-list {
  display: grid;
  gap: 4px;
  padding: 0 12px 16px;
  border-bottom: 1px solid #e0e7e5;
}
.analysis-command-filter-list button {
  display: flex;
  min-height: 42px;
  align-items: center;
  justify-content: space-between;
  padding: 0 12px;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: #536a63;
  font-size: 13px;
  font-weight: 800;
  text-align: left;
}
.analysis-command-filter-list button:hover {
  background: #edf3f1;
}
.analysis-command-filter-list button.is-active {
  background: #e4efeb;
  color: #125c4d;
}
.analysis-command-filter-list em {
  display: inline-grid;
  min-width: 28px;
  min-height: 24px;
  place-items: center;
  padding: 2px 7px;
  border-radius: 999px;
  background: #e8eeec;
  color: #61736e;
  font-size: 11px;
  font-style: normal;
}
.analysis-command-filter-list button.is-active em {
  background: #fff;
  color: #155f50;
}

.analysis-preservation-card {
  margin: 16px 14px 10px;
  padding: 14px;
  border: 1px solid #d5dfdc;
  border-radius: 9px;
  background: #fff;
}
.analysis-preservation-card.is-complete {
  border-color: #bddbce;
  background: #f5fbf8;
}
.analysis-preservation-card > div:not(.analysis-preservation-meter) {
  display: grid;
  gap: 3px;
  padding-left: 34px;
}
.analysis-preservation-card small {
  color: #6c7d78;
  font-size: 11px;
  font-weight: 750;
}
.analysis-preservation-card strong {
  color: #245d4f;
  font-size: 18px;
  font-weight: 900;
}
.analysis-preservation-card p {
  color: #71807c;
  font-size: 11px;
  line-height: 1.45;
}

.analysis-preservation-icon {
  display: grid;
  width: 27px;
  height: 27px;
  float: left;
  place-items: center;
  border-radius: 7px;
  background: #e2f0eb;
  color: #176452;
  font-size: 12px;
}

.analysis-preservation-meter {
  height: 5px;
  margin-top: 12px;
  overflow: hidden;
  border-radius: 999px;
  background: #e3eae8;
}
.analysis-preservation-meter span {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: #287a65;
}

.analysis-command-policy {
  margin: 10px 14px 18px;
  padding: 13px 14px;
  border: 1px solid #dbe3e1;
  border-radius: 9px;
  background: #fff;
}
.analysis-command-policy summary {
  color: #405a53;
  font-size: 12px;
  font-weight: 850;
  cursor: pointer;
}
.analysis-command-policy ul {
  display: grid;
  gap: 7px;
  margin: 11px 0 0;
  padding: 0 0 0 17px;
  color: #6b7b76;
  font-size: 11px;
  line-height: 1.45;
}

.analysis-command-main {
  min-width: 0;
  background: #fff;
}

.analysis-command-head {
  display: flex;
  min-height: 106px;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 20px 22px;
  border-bottom: 1px solid #dfe6e4;
}
.analysis-command-head h3 {
  margin: 5px 0;
  color: #243d36;
  font-size: 19px;
  font-weight: 900;
  letter-spacing: -0.04em;
}
.analysis-command-head p {
  max-width: 660px;
  margin: 0;
  color: #667873;
  font-size: 12px;
  line-height: 1.55;
}

.analysis-command-head-actions {
  display: flex;
  flex: 0 0 auto;
  gap: 8px;
}
.analysis-command-head-actions button {
  min-height: 42px;
  padding: 0 15px;
  border: 1px solid #c8d5d1;
  border-radius: 7px;
  background: #fff;
  color: #45635b;
  font-size: 12px;
  font-weight: 850;
}
.analysis-command-head-actions .analysis-reconnect-btn {
  border-color: #176554;
  background: #176554;
  color: #fff;
}
.analysis-command-head-actions .analysis-stop-btn {
  border-color: #e4b7aa;
  color: #aa4c3c;
}
.analysis-command-head-actions button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.analysis-grouped-issue {
  display: grid;
  grid-template-columns: 34px minmax(0, 1fr) auto;
  align-items: center;
  gap: 12px;
  margin: 16px 18px 0;
  padding: 14px 16px;
  border: 1px solid #efd39c;
  border-radius: 9px;
  background: #fffaf0;
}
.analysis-grouped-issue.is-error {
  border-color: #efc4ba;
  background: #fff7f5;
}
.analysis-grouped-issue strong {
  color: #4f493b;
  font-size: 13px;
  font-weight: 900;
}
.analysis-grouped-issue p {
  margin: 3px 0 0;
  color: #736b58;
  font-size: 12px;
  line-height: 1.5;
}
.analysis-grouped-issue em {
  padding: 6px 9px;
  border-radius: 999px;
  background: #f4e7ca;
  color: #8a6326;
  font-size: 11px;
  font-style: normal;
  font-weight: 850;
  white-space: nowrap;
}

.analysis-grouped-issue-icon {
  display: grid;
  width: 32px;
  height: 32px;
  place-items: center;
  border-radius: 50%;
  background: #f3e6c6;
  color: #9b6b1f;
  font-size: 13px;
}

.analysis-command-summary {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px;
  padding: 16px 18px;
}
.analysis-command-summary article {
  display: flex;
  min-height: 70px;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 13px 14px;
  border: 1px solid #dce4e2;
  border-radius: 9px;
  background: #fbfcfc;
}
.analysis-command-summary span {
  color: #6a7b76;
  font-size: 12px;
  font-weight: 750;
}
.analysis-command-summary strong {
  color: #2b423c;
  font-size: 22px;
  font-weight: 900;
}
.analysis-command-summary .is-preserved {
  border-color: #c9ded6;
  background: #f5faf8;
}
.analysis-command-summary .is-preserved strong {
  color: #20654f;
}
.analysis-command-summary .is-ready strong {
  color: #287a48;
}
.analysis-command-summary .is-attention.has-items {
  border-color: #ebd29d;
  background: #fffaf0;
}
.analysis-command-summary .is-attention.has-items strong {
  color: #a36b1c;
}

.analysis-command-toolbar {
  display: flex;
  min-height: 58px;
  align-items: stretch;
  justify-content: space-between;
  gap: 12px;
  padding: 0 18px;
  border-top: 1px solid #e1e7e5;
  border-bottom: 1px solid #e1e7e5;
}

.analysis-command-tabs {
  display: flex;
  gap: 10px;
}
.analysis-command-tabs button {
  display: flex;
  min-width: 116px;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 0 10px;
  border: 0;
  border-bottom: 3px solid transparent;
  background: transparent;
  color: #63756f;
  font-size: 13px;
  font-weight: 850;
}
.analysis-command-tabs button.is-active {
  border-bottom-color: #176655;
  color: #176655;
}
.analysis-command-tabs span {
  display: inline-grid;
  min-width: 25px;
  height: 22px;
  place-items: center;
  border-radius: 999px;
  background: #e8eeec;
  color: #60726d;
  font-size: 11px;
}

.analysis-command-result-count {
  align-self: center;
  color: #6a7b76;
  font-size: 12px;
  font-weight: 800;
}

.analysis-command-table-head,
.analysis-command-list > li {
  display: grid;
  grid-template-columns: 46px minmax(170px, 1.35fr) minmax(155px, 1fr) minmax(150px, 1fr) minmax(120px, 0.9fr);
  align-items: center;
  gap: 12px;
}

.analysis-command-table-head {
  min-height: 42px;
  padding: 0 16px;
  border-bottom: 1px solid #e1e7e5;
  background: #fafcfb;
  color: #52645f;
  font-size: 12px;
  font-weight: 850;
}

.analysis-command-progress-panel {
  margin: 16px 18px 0;
  padding: 15px 16px;
  border: 1px solid #c9ddd6;
  border-radius: 10px;
  background: #f5faf8;
  box-shadow: 0 1px 0 rgba(23, 102, 85, 0.04);
}
.analysis-command-progress-panel p {
  margin: 9px 0 0;
  color: #647771;
  font-size: 11px;
  font-weight: 700;
}

.analysis-command-progress-copy {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 11px;
}
.analysis-command-progress-copy > div {
  display: flex;
  align-items: baseline;
  gap: 10px;
}
.analysis-command-progress-copy span {
  color: #526a63;
  font-size: 12px;
  font-weight: 800;
}
.analysis-command-progress-copy strong {
  color: #1f4f42;
  font-size: 18px;
  font-weight: 900;
  letter-spacing: -0.03em;
}
.analysis-command-progress-copy em {
  color: #176655;
  font-size: 16px;
  font-style: normal;
  font-weight: 900;
}

.analysis-command-progress-track {
  height: 12px;
  overflow: hidden;
  border-radius: 999px;
  background: #e1e8e6;
}
.analysis-command-progress-track span {
  display: block;
  width: 100%;
  height: 100%;
  border-radius: inherit;
  background: #176655;
  transform: scaleX(0);
  transform-origin: left center;
  transition: transform 200ms linear;
  will-change: transform;
}

.analysis-command-list {
  margin: 0;
  padding: 0;
  list-style: none;
}
.analysis-command-list > li {
  min-height: 64px;
  padding: 8px 16px;
  border-bottom: 1px solid #e2e8e6;
  background: #fff;
  cursor: pointer;
}
.analysis-command-list > li:hover, .analysis-command-list > li.is-selected {
  background: #f5faf8;
}
.analysis-command-list > li:focus-visible {
  outline: 3px solid rgba(23, 102, 85, 0.28);
  outline-offset: -3px;
}

.analysis-command-index {
  display: grid;
  width: 28px;
  height: 28px;
  place-items: center;
  border-radius: 7px;
  background: #eef3f1;
  color: #526a63;
  font-size: 12px;
  font-weight: 850;
}

.analysis-command-file {
  display: grid;
  min-width: 0;
  gap: 3px;
}
.analysis-command-file strong {
  overflow: hidden;
  color: #29423b;
  font-size: 14px;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.analysis-command-file small {
  color: #7a8985;
  font-size: 11px;
}

.analysis-command-source {
  color: #85632d;
  font-size: 12px;
  font-weight: 800;
  line-height: 1.4;
}
.analysis-command-source i {
  margin-right: 3px;
}
.analysis-command-source.is-complete {
  color: #287550;
}

.analysis-command-state {
  display: inline-flex;
  width: fit-content;
  max-width: 100%;
  align-items: center;
  padding: 6px 9px;
  border-radius: 999px;
  background: #edf1f0;
  color: #60716c;
  font-size: 11px;
  font-weight: 850;
  line-height: 1.35;
}
.analysis-command-state.is-complete {
  background: #e9f6ed;
  color: #277544;
}
.analysis-command-state.is-running {
  background: #eaf3f8;
  color: #2b6785;
}
.analysis-command-state.is-attention {
  background: #fff0d4;
  color: #96631c;
}
.analysis-command-state.is-error {
  background: #fde9e5;
  color: #ad4635;
}

.analysis-command-profile {
  overflow: hidden;
  color: #536963;
  font-size: 12px;
  font-weight: 750;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.analysis-command-empty,
.analysis-inspector-empty {
  display: grid;
  min-height: 250px;
  place-items: center;
  align-content: center;
  gap: 8px;
  padding: 28px;
  color: #72827d;
  text-align: center;
}
.analysis-command-empty i,
.analysis-inspector-empty i {
  color: #81928d;
  font-size: 22px;
}
.analysis-command-empty strong,
.analysis-inspector-empty strong {
  color: #405952;
  font-size: 14px;
}
.analysis-command-empty p,
.analysis-inspector-empty p {
  max-width: 360px;
  margin: 0;
  font-size: 12px;
  line-height: 1.55;
}
.analysis-command-empty button,
.analysis-inspector-empty button {
  min-height: 40px;
  margin-top: 5px;
  padding: 0 14px;
  border: 1px solid #cbd7d3;
  border-radius: 7px;
  background: #fff;
  color: #42645b;
  font-size: 12px;
  font-weight: 850;
}

.analysis-command-pagination {
  display: flex;
  min-height: 60px;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 9px 16px;
  border-top: 1px solid #e1e7e5;
}
.analysis-command-pagination > span {
  color: #647670;
  font-size: 12px;
  font-weight: 800;
}
.analysis-command-pagination > div {
  display: flex;
  gap: 7px;
}
.analysis-command-pagination button {
  min-height: 40px;
  padding: 0 12px;
  border: 1px solid #cdd8d5;
  border-radius: 7px;
  background: #fff;
  color: #436159;
  font-size: 11px;
  font-weight: 850;
}
.analysis-command-pagination button:disabled {
  opacity: 0.45;
}

.analysis-command-partial {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  margin: 16px 18px 20px;
  padding: 15px 16px;
  border: 1px solid #d9e2df;
  border-radius: 9px;
  background: #f7faf9;
}
.analysis-command-partial strong {
  color: #334d46;
  font-size: 13px;
}
.analysis-command-partial p {
  margin: 4px 0 0;
  color: #6c7b77;
  font-size: 12px;
}
.analysis-command-partial > div:last-child {
  display: flex;
  flex: 0 0 auto;
  gap: 8px;
}
.analysis-command-partial button {
  min-height: 42px;
  padding: 0 14px;
  border: 1px solid #c8d5d1;
  border-radius: 7px;
  background: #fff;
  color: #42645b;
  font-size: 12px;
  font-weight: 850;
}
.analysis-command-partial button.is-primary {
  border-color: #176554;
  background: #176554;
  color: #fff;
}

.analysis-command-inspector {
  border-left: 1px solid #dce4e2;
}
.analysis-command-inspector:focus {
  outline: 3px solid rgba(35, 111, 92, 0.2);
  outline-offset: -3px;
}
.analysis-command-inspector > header {
  display: flex;
  min-height: 58px;
  align-items: center;
  justify-content: space-between;
  padding: 0 17px;
  border-bottom: 1px solid #dce4e2;
  background: #fff;
}
.analysis-command-inspector h3 {
  margin: 0;
  color: #2e463f;
  font-size: 14px;
  font-weight: 900;
}
.analysis-command-inspector > header button {
  width: 40px;
  height: 40px;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: #61736e;
}

.analysis-source-replacement-input {
  position: fixed;
  width: 1px;
  height: 1px;
  overflow: hidden;
  opacity: 0;
  pointer-events: none;
}

.analysis-inspector-body {
  display: grid;
  gap: 17px;
  padding: 18px 16px 22px;
}

.analysis-inspector-identity {
  display: grid;
  gap: 9px;
}
.analysis-inspector-identity > strong {
  overflow: hidden;
  color: #263f38;
  font-size: 16px;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.analysis-inspector-overview {
  display: grid;
  gap: 10px;
  margin: 0;
  padding: 14px;
  border: 1px solid #dce4e2;
  border-radius: 9px;
  background: #fff;
}
.analysis-inspector-overview > div {
  display: grid;
  grid-template-columns: 78px minmax(0, 1fr);
  gap: 8px;
}
.analysis-inspector-overview dt,
.analysis-inspector-overview dd {
  margin: 0;
  font-size: 11px;
  line-height: 1.45;
  overflow-wrap: anywhere;
}
.analysis-inspector-overview dt {
  color: #7a8985;
}
.analysis-inspector-overview dd {
  color: #3c5750;
  font-weight: 750;
}
.analysis-inspector-overview dd.is-complete {
  color: #26704e;
}
.analysis-inspector-overview select {
  width: 100%;
  min-height: 34px;
  padding: 5px 28px 5px 9px;
  border: 1px solid #c9d8d3;
  border-radius: 7px;
  background: #fff;
  color: #31584d;
  font: inherit;
  font-weight: 800;
}
.analysis-inspector-overview select:focus-visible {
  outline: 2px solid #2d806a;
  outline-offset: 2px;
}
.analysis-inspector-overview select:disabled {
  opacity: 0.55;
  cursor: wait;
}

.analysis-inspector-advice {
  padding: 14px;
  border: 1px solid #ead4a7;
  border-radius: 9px;
  background: #fffaf0;
}
.analysis-inspector-advice strong {
  color: #554e3e;
  font-size: 12px;
  font-weight: 900;
}
.analysis-inspector-advice p {
  margin: 5px 0 12px;
  color: #716a58;
  font-size: 12px;
  line-height: 1.55;
}
.analysis-inspector-advice p:last-child {
  margin-bottom: 0;
}

.analysis-inspector-actions {
  display: grid;
  gap: 8px;
}
.analysis-inspector-actions button {
  min-height: 43px;
  padding: 0 13px;
  border: 1px solid #176554;
  border-radius: 7px;
  background: #176554;
  color: #fff;
  font-size: 12px;
  font-weight: 850;
}
.analysis-inspector-actions button.is-secondary {
  border-color: #c9d5d1;
  background: #fff;
  color: #436159;
}
.analysis-inspector-actions button:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.analysis-inspector-tech {
  padding-top: 13px;
  border-top: 1px solid #dce4e2;
}
.analysis-inspector-tech summary {
  color: #536b64;
  font-size: 12px;
  font-weight: 850;
  cursor: pointer;
}
.analysis-inspector-tech dl {
  display: grid;
  gap: 9px;
  margin: 13px 0 0;
}
.analysis-inspector-tech dl > div {
  display: grid;
  grid-template-columns: 72px minmax(0, 1fr);
  gap: 8px;
}
.analysis-inspector-tech dt, .analysis-inspector-tech dd {
  margin: 0;
  overflow-wrap: anywhere;
  font-size: 11px;
  line-height: 1.55;
}
.analysis-inspector-tech dt {
  color: #61726d;
}
.analysis-inspector-tech dd {
  color: #40564f;
}

@media (max-width: 1320px) {
  .analysis-command-center {
    grid-template-columns: 235px minmax(0, 1fr);
  }
  .analysis-command-inspector {
    position: fixed;
    top: 86px;
    right: 16px;
    bottom: 92px;
    z-index: 70;
    display: none;
    width: min(390px, 100vw - 32px);
    overflow: auto;
    border: 1px solid #cddbd7;
    border-radius: 12px;
    background: #f8faf9;
    box-shadow: 0 24px 60px rgba(21, 55, 47, 0.24);
  }
  .analysis-command-inspector.is-open {
    display: block;
  }
  .analysis-inspector-body {
    grid-template-columns: 1fr;
  }
  .analysis-inspector-actions,
  .analysis-inspector-tech {
    grid-column: auto;
  }
  .analysis-command-table-head,
  .analysis-command-list > li {
    grid-template-columns: 38px minmax(145px, 1.3fr) minmax(140px, 1fr) minmax(135px, 1fr);
  }
  .analysis-command-table-head span:nth-child(5),
  .analysis-command-profile {
    display: none;
  }
}
@media (max-width: 960px) {
  .analysis-command-center {
    grid-template-columns: 1fr;
  }
  .analysis-command-rail {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    border-right: 0;
    border-bottom: 1px solid #dce4e2;
  }
  .analysis-command-rail > header,
  .analysis-command-policy {
    grid-column: 1/-1;
  }
  .analysis-command-filter-list {
    border-bottom: 0;
  }
  .analysis-command-summary {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .analysis-command-table-head,
  .analysis-command-list > li {
    grid-template-columns: 38px minmax(150px, 1.3fr) minmax(140px, 1fr) minmax(135px, 1fr);
  }
  .analysis-command-table-head span:nth-child(5),
  .analysis-command-profile {
    display: none;
  }
  .analysis-inspector-body {
    grid-template-columns: 1fr;
  }
  .analysis-inspector-actions,
  .analysis-inspector-tech {
    grid-column: auto;
  }
}
@media (max-width: 720px) {
  .analysis-command-main {
    order: 1;
  }
  .analysis-command-rail {
    order: 2;
    grid-template-columns: 1fr;
  }
  .analysis-command-inspector {
    order: 3;
  }
  .analysis-command-rail > header,
  .analysis-command-policy {
    grid-column: auto;
  }
  .analysis-command-head {
    align-items: stretch;
    flex-direction: column;
  }
  .analysis-command-head-actions {
    width: 100%;
  }
  .analysis-command-head-actions button {
    width: 100%;
  }
  .analysis-grouped-issue {
    grid-template-columns: 32px minmax(0, 1fr);
  }
  .analysis-grouped-issue em {
    grid-column: 2;
    justify-self: start;
  }
  .analysis-command-summary {
    padding: 12px;
  }
  .analysis-command-summary article {
    min-height: 62px;
    padding: 10px;
  }
  .analysis-command-summary strong {
    font-size: 19px;
  }
  .analysis-command-toolbar {
    padding: 0 10px;
  }
  .analysis-command-tabs {
    width: 100%;
  }
  .analysis-command-tabs button {
    min-width: 0;
    flex: 1;
  }
  .analysis-command-result-count {
    display: none;
  }
  .analysis-command-table-head {
    display: none;
  }
  .analysis-command-progress-panel {
    margin: 12px 10px 0;
    padding: 13px;
  }
  .analysis-command-progress-copy {
    align-items: flex-start;
  }
  .analysis-command-progress-copy > div {
    align-items: flex-start;
    flex-direction: column;
    gap: 3px;
  }
  .analysis-command-list > li {
    grid-template-columns: 34px minmax(0, 1fr);
    gap: 7px 10px;
    padding: 12px;
  }
  .analysis-command-file {
    grid-column: 2;
  }
  .analysis-command-source {
    grid-column: 2/-1;
  }
  .analysis-command-state {
    grid-column: 2;
  }
  .analysis-command-profile {
    display: none;
  }
  .analysis-command-partial {
    align-items: stretch;
    flex-direction: column;
  }
  .analysis-command-partial > div:last-child {
    display: grid;
  }
  .analysis-inspector-body {
    grid-template-columns: 1fr;
  }
  .analysis-inspector-actions,
  .analysis-inspector-tech {
    grid-column: auto;
  }
}
@media (prefers-reduced-motion: reduce) {
  .analysis-command-center * {
    scroll-behavior: auto !important;
    transition-duration: 1ms !important;
    animation-duration: 1ms !important;
  }
  .analysis-command-progress-track span {
    transition: none !important;
  }
}
/* ReviewOps ylchnmfwnerbwtowijbflwuzvjjpqeca: compact, file-first registration flow */
.register-flow {
  grid-template-columns: minmax(0, 1fr) 300px;
  grid-template-areas: "steps progress" "workbench workbench";
  gap: 14px 18px;
}

.flow-guide {
  display: none;
}

.flow-progress {
  min-height: 96px;
  align-self: stretch;
}

.register-steps {
  grid-template-columns: repeat(4, minmax(0, 1fr));
  align-self: stretch;
}

.register-steps li:not(:last-child)::after {
  right: 0;
  bottom: 14px;
  left: auto;
  width: 1px;
  height: calc(100% - 28px);
}

.register-step {
  min-height: 96px;
  grid-template-columns: 34px minmax(0, 1fr);
  gap: 10px;
  align-items: center;
  padding: 14px;
}

.register-step-number {
  width: 34px;
  height: 34px;
}

.selected-file-list {
  display: grid;
  max-height: 230px;
  gap: 7px;
  margin: 12px 0 0;
  padding: 0;
  overflow-y: auto;
  list-style: none;
}

.selected-file-list.is-url-list {
  max-height: 158px;
  padding-right: 4px;
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior-y: contain;
  scrollbar-color: #9fb7b1 #e8efed;
  scrollbar-width: thin;
}

.selected-file-list.is-url-list:focus-visible {
  outline: 2px solid rgba(47, 98, 90, 0.28);
  outline-offset: 3px;
}

.source-selection-pagination {
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
  padding: 9px 10px;
  border: 1px solid #dce7e3;
  border-radius: 10px;
  background: #f8fbfa;
}

.source-selection-pagination > span {
  color: #536963;
  font-size: 10px;
  font-weight: 850;
}

.source-selection-pagination > div {
  display: inline-flex;
  gap: 6px;
}

.source-selection-pagination button {
  min-height: 30px;
  padding: 0 10px;
  border: 1px solid #cbdcd6;
  border-radius: 8px;
  background: #fff;
  color: #31584f;
  font-size: 9px;
  font-weight: 900;
}

.source-selection-pagination button:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}

.selected-file-list.is-url-list::-webkit-scrollbar {
  width: 6px;
}

.selected-file-list.is-url-list::-webkit-scrollbar-track {
  border-radius: 999px;
  background: #e8efed;
}

.selected-file-list.is-url-list::-webkit-scrollbar-thumb {
  border-radius: 999px;
  background: #9fb7b1;
}

.selected-file-list li {
  display: grid;
  grid-template-columns: 28px minmax(0, 1fr) auto;
  gap: 10px;
  align-items: center;
  min-height: 48px;
  padding: 8px 9px;
  border: 1px solid #dde6e3;
  border-radius: 11px;
  background: rgba(255, 255, 255, 0.9);
}

.selected-file-index {
  display: inline-flex;
  width: 26px;
  height: 26px;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #eaf3f0;
  color: var(--register-green);
  font-size: 10px;
  font-weight: 950;
}

.selected-file-info {
  display: grid;
  min-width: 0;
  gap: 2px;
}

.selected-file-info strong {
  overflow: hidden;
  color: #263733;
  font-size: 11px;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.selected-file-info small {
  color: #87938f;
  font-size: 9px;
  font-weight: 800;
}

.duplicate-preflight-badge {
  display: inline-flex;
  width: fit-content;
  align-items: center;
  min-height: 22px;
  margin-top: 3px;
  padding: 3px 8px;
  border: 1px solid #d4dfdc;
  border-radius: 999px;
  background: #f5f8f7;
  color: #5d6c68;
  font-size: 9px;
  font-weight: 950;
}

.duplicate-preflight-badge.is-checking {
  border-color: #cbdcf0;
  background: #f1f6fc;
  color: #37648f;
}

.duplicate-preflight-badge.is-new {
  border-color: #bcdccd;
  background: #eef8f3;
  color: #287054;
}

.duplicate-preflight-badge.is-registered,
.duplicate-preflight-badge.is-processing,
.duplicate-preflight-badge.is-error {
  border-color: #ebc7b8;
  background: #fff4ef;
  color: #9a492e;
}

.registration-source-stage-badge {
  display: inline-flex;
  width: fit-content;
  align-items: center;
  min-height: 22px;
  margin-top: 3px;
  padding: 3px 8px;
  border: 1px solid #cbdcf0;
  border-radius: 999px;
  background: #f1f6fc;
  color: #37648f;
  font-size: 9px;
  font-weight: 950;
}

.registration-source-stage-badge.is-staged {
  border-color: #bcdccd;
  background: #eef8f3;
  color: #287054;
}

.registration-source-stage-badge.is-error {
  border-color: #ebc7b8;
  background: #fff4ef;
  color: #9a492e;
}

.registration-source-stage-error {
  margin: 3px 0 0;
  color: #9a492e;
  font-size: 9px;
  font-weight: 800;
  line-height: 1.45;
}

.duplicate-preflight-message {
  margin: 2px 0 0;
  color: #687873;
  font-size: 9px;
  font-weight: 750;
  line-height: 1.45;
}

.duplicate-existing-link {
  width: fit-content;
  color: #28685a;
  font-size: 9px;
  font-weight: 900;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.duplicate-preflight-actions {
  display: grid;
  width: 100%;
  gap: 6px;
}

.duplicate-existing-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
}

.duplicate-existing-actions button {
  min-height: 30px;
  padding: 0 10px;
  border: 1px solid #dfc7bd;
  border-radius: 7px;
  background: #fff;
  color: #914b34;
  font-size: 9px;
  font-weight: 900;
}

.duplicate-override-field {
  display: grid;
  width: 100%;
  gap: 4px;
  margin-top: 4px;
  padding: 8px;
  border: 1px solid #e6d5ac;
  border-radius: 8px;
  background: #fffbef;
  color: #73591d;
  font-size: 9px;
  font-weight: 900;
}

.duplicate-version-toggle {
  display: inline-flex;
  width: fit-content;
  gap: 8px;
  align-items: center;
  cursor: pointer;
}

.duplicate-version-toggle input[type=checkbox] {
  width: 18px;
  height: 18px;
  flex: 0 0 18px;
  margin: 0;
  accent-color: #226455;
  cursor: pointer;
}

.duplicate-version-toggle input[type=checkbox]:focus-visible,
.duplicate-existing-actions button:focus-visible,
.duplicate-existing-link:focus-visible {
  outline: 3px solid rgba(43, 102, 89, 0.24);
  outline-offset: 2px;
}

.duplicate-override-field small {
  color: #806c40;
  line-height: 1.4;
}

.duplicate-user-policy {
  margin: 0;
  color: #8f4b34;
  font-size: 9px;
  font-weight: 800;
  line-height: 1.45;
}

.selected-file-actions {
  display: inline-flex;
  gap: 5px;
  align-items: center;
}

.selected-file-list button {
  height: 28px;
  padding: 0 9px;
  border: 1px solid #ead7d0;
  border-radius: 8px;
  background: #fffaf8;
  color: #9a5237;
  font-size: 9px;
  font-weight: 900;
}

.upload-selection-notice {
  margin: 8px 0 0;
  padding: 8px 10px;
  border: 1px solid #d8e5e1;
  border-radius: var(--register-radius-sm, 6px);
  background: #f5f9f7;
  color: #45655d;
  font-size: 9px;
  font-weight: 800;
  line-height: 1.5;
}

.ocr-upload-guidance {
  display: flex;
  gap: 10px;
  align-items: flex-start;
  margin-top: 10px;
  padding: 11px 12px;
  border: 1px solid #cfe0db;
  border-radius: 10px;
  background: #f3f8f6;
  color: #355c52;
}

.ocr-upload-guidance-icon {
  display: inline-flex;
  width: 28px;
  height: 28px;
  flex: 0 0 28px;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  background: #dfeee9;
  color: #286456;
}

.ocr-upload-guidance-icon svg {
  width: 16px;
  height: 16px;
}

.ocr-upload-guidance > div {
  display: grid;
  gap: 3px;
}

.ocr-upload-guidance strong {
  color: #244b42;
  font-size: 10px;
  font-weight: 950;
}

.ocr-upload-guidance p {
  margin: 0;
  color: #617b74;
  font-size: 9px;
  font-weight: 750;
  line-height: 1.55;
}

.registration-recovery-notice {
  margin: 9px 0 0;
  padding: 9px 11px;
  border: 1px solid #bcd9cf;
  border-radius: 9px;
  background: #eef8f4;
  color: #285f51;
  font-size: 9px;
  font-weight: 850;
  line-height: 1.55;
}

.registration-workspace-status {
  display: grid;
  gap: 5px;
  margin-top: 9px;
  padding: 10px 12px;
  border: 1px solid #c9ded7;
  border-radius: 10px;
  background: #f4faf7;
  color: #315f53;
  font-size: 9px;
  line-height: 1.5;
}

.registration-workspace-status > div {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 6px 12px;
}

.registration-workspace-status strong {
  font-size: 10px;
  font-weight: 950;
}

.registration-workspace-status span {
  color: #71857e;
  overflow-wrap: anywhere;
}

.registration-workspace-status p {
  margin: 0;
}

.registration-workspace-status.is-error {
  border-color: #ebc7b8;
  background: #fff4ef;
  color: #9a492e;
}

.analysis-quality-warning {
  color: #9a5a21 !important;
  font-weight: 850 !important;
}

.analysis-progress-panel {
  display: grid;
  gap: 10px;
  margin-top: 14px;
  padding: 14px;
  border: 1px solid #bfd8d1;
  border-radius: 13px;
  background: #f2f8f6;
}

.analysis-progress-head {
  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: space-between;
}

.analysis-progress-head > div {
  display: grid;
  flex: 1;
  min-width: 0;
  gap: 2px;
}

.analysis-progress-head span {
  color: #778681;
  font-size: 9px;
  font-weight: 950;
  letter-spacing: 0.06em;
}

.analysis-progress-head strong {
  overflow: hidden;
  color: #203d37;
  font-size: 12px;
  font-weight: 950;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.analysis-progress-head small {
  overflow: hidden;
  color: #60736d;
  font-size: 9px;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.analysis-progress-head em {
  color: var(--register-green);
  font-size: 19px;
  font-style: normal;
  font-weight: 950;
}

.analysis-progress-head .analysis-cancel-btn {
  flex: 0 0 auto;
  padding: 6px 9px;
  border: 1px solid #d2aaa2;
  border-radius: 8px;
  color: #8b382d;
  background: #fff;
  font-size: 10px;
  font-weight: 900;
  white-space: nowrap;
}

.analysis-progress-head .analysis-cancel-btn:hover {
  background: #fff3f1;
}

.analysis-progress-track {
  height: 8px;
  overflow: hidden;
  border-radius: 999px;
  background: #dce9e5;
}

.analysis-progress-track span {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, #d08b54, var(--register-green));
  transition: width 300ms ease;
}

.analysis-progress-panel > p {
  margin: 0;
  color: #6f7e79;
  font-size: 9px;
  font-weight: 800;
}

.analysis-progress-panel > .analysis-progress-timing {
  color: #2f665b;
  font-variant-numeric: tabular-nums;
  font-weight: 900;
}

.analysis-file-queue {
  display: grid;
  max-height: 168px;
  gap: 5px;
  margin: 0;
  padding: 0;
  overflow-y: auto;
  list-style: none;
}

.analysis-file-queue li {
  display: grid;
  grid-template-columns: 22px minmax(0, 1fr) auto;
  gap: 8px;
  align-items: center;
  padding: 7px 8px;
  border-radius: 9px;
  background: rgba(255, 255, 255, 0.86);
}

.analysis-file-queue li > span {
  display: inline-flex;
  width: 21px;
  height: 21px;
  align-items: center;
  justify-content: center;
  border-radius: 7px;
  background: #eef2f1;
  color: #71807b;
  font-size: 8px;
  font-weight: 950;
}

.analysis-file-queue strong {
  overflow: hidden;
  color: #30423e;
  font-size: 10px;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.analysis-file-queue em {
  color: #7b8985;
  font-size: 9px;
  font-style: normal;
  font-weight: 900;
}

.analysis-file-queue li.is-running > span {
  background: #e6f1ee;
  color: var(--register-green);
  animation: pulse 1.2s ease-in-out infinite;
}

.analysis-file-queue li.is-complete > span,
.analysis-file-queue li.is-saved > span {
  background: #def1e6;
  color: #1f714b;
}

.analysis-file-queue li.is-error > span {
  background: #fff0ed;
  color: #b34b35;
}

.metadata-review-workspace {
  display: grid;
  grid-template-columns: 280px minmax(0, 1fr);
  gap: 18px;
  align-items: start;
}

.metadata-file-rail {
  position: sticky;
  top: 96px;
  display: grid;
  gap: 11px;
  max-height: calc(100vh - 140px);
  padding: 16px;
  overflow: hidden;
  border: 1px solid #dce6e3;
  border-radius: 15px;
  background: #f7faf9;
}

.metadata-file-rail-head {
  display: flex;
  gap: 12px;
  align-items: flex-end;
  justify-content: space-between;
}

.metadata-file-rail-head span {
  color: var(--register-copper);
  font-size: 8px;
  font-weight: 950;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.metadata-file-rail-head h3 {
  margin: 3px 0 0;
  color: #17332d;
  font-size: 15px;
  font-weight: 950;
}

.metadata-file-rail-head > strong {
  color: #6d7d78;
  font-size: 10px;
  font-weight: 950;
}

.metadata-file-rail > p {
  margin: 0;
  color: #7d8985;
  font-size: 9px;
  font-weight: 750;
  line-height: 1.55;
}

.metadata-file-list {
  display: grid;
  gap: 8px;
  overflow-y: auto;
}

.metadata-file-list article {
  display: grid;
  gap: 8px;
  padding: 9px;
  border: 1px solid #e0e7e5;
  border-radius: 11px;
  background: #ffffff;
  transition: border-color 160ms ease, box-shadow 160ms ease;
}

.metadata-file-list article.is-active {
  border-color: var(--register-green);
  box-shadow: 0 0 0 3px rgba(47, 98, 90, 0.09);
}

.metadata-file-list article.is-complete {
  border-color: #9bcab9;
  background: #edf8f3;
}

.metadata-file-list article.is-complete.is-active {
  border-color: #2f735f;
  background: #e4f5ed;
  box-shadow: 0 0 0 3px rgba(47, 115, 95, 0.14);
}

.metadata-file-list article.is-complete .metadata-file-select > span:first-child {
  background: #2f735f;
  color: #ffffff;
}

.metadata-file-list article.is-error {
  border-color: #edc8bf;
  background: #fffaf8;
}

.metadata-file-select {
  display: grid;
  grid-template-columns: 25px minmax(0, 1fr);
  gap: 8px;
  align-items: center;
  width: 100%;
  padding: 0;
  border: 0;
  background: transparent;
  text-align: left;
}

.metadata-file-select > span:first-child {
  display: inline-flex;
  width: 24px;
  height: 24px;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #edf3f1;
  color: var(--register-green);
  font-size: 9px;
  font-weight: 950;
}

.metadata-file-select > span:last-child {
  display: grid;
  min-width: 0;
  gap: 2px;
}

.metadata-file-select strong {
  overflow: hidden;
  color: #263733;
  font-size: 10px;
  font-weight: 950;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.metadata-file-select small {
  color: #80908b;
  font-size: 8px;
  font-weight: 850;
}

.metadata-file-complete-badge {
  display: inline-flex;
  width: fit-content;
  align-items: center;
  gap: 4px;
  margin-top: 3px;
  padding: 3px 6px;
  border-radius: 999px;
  background: #d4ede2;
  color: #24634f;
  font-size: 8px;
  font-style: normal;
  font-weight: 950;
}
.metadata-file-complete-badge svg {
  width: 10px;
  height: 10px;
}

.file-visibility {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 4px;
  padding: 3px;
  border-radius: 9px;
  background: #eef3f1;
}

.file-visibility button {
  height: 27px;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: #74837f;
  font-size: 9px;
  font-weight: 950;
}

.file-visibility button.is-active {
  background: #ffffff;
  color: var(--register-green);
  box-shadow: 0 2px 7px rgba(23, 59, 54, 0.09);
}

.metadata-file-error {
  margin: 0;
  color: #ab4b38;
  font-size: 8px;
  font-weight: 800;
  line-height: 1.45;
}

.metadata-editor {
  display: grid;
  min-width: 0;
  gap: 16px;
}

.metadata-summary-field {
  padding: 18px;
  border: 1px solid #e1e8e6;
  border-radius: 14px;
  background: #fafcfb;
}

.manual-batch {
  grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));
  margin: 0;
  padding: 12px;
  border: 1px solid #e0e7e5;
  border-radius: 13px;
  background: #f8faf9;
}

.final-file-list {
  display: grid;
  gap: 7px;
  margin-top: 14px;
}

.final-file-list > div {
  display: grid;
  grid-template-columns: 24px minmax(0, 1fr) auto;
  gap: 8px;
  align-items: center;
  padding: 8px 9px;
  border: 1px solid #e6ecea;
  border-radius: 10px;
  background: #ffffff;
}

.final-file-list span {
  display: inline-flex;
  width: 23px;
  height: 23px;
  align-items: center;
  justify-content: center;
  border-radius: 7px;
  background: #eaf3f0;
  color: var(--register-green);
  font-size: 8px;
  font-weight: 950;
}

.final-file-list strong {
  overflow: hidden;
  color: #33443f;
  font-size: 10px;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.final-file-list em {
  color: var(--register-green);
  font-size: 9px;
  font-style: normal;
  font-weight: 950;
}

@media (max-width: 1100px) {
  .register-flow {
    grid-template-columns: 1fr;
    grid-template-areas: "progress" "steps" "workbench";
  }
}
@media (max-width: 820px) {
  .register-steps {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .register-steps li:nth-child(2)::after {
    display: none;
  }
  .metadata-review-workspace {
    grid-template-columns: 1fr;
  }
  .metadata-file-rail {
    position: static;
    max-height: none;
  }
  .metadata-file-list {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    max-height: 360px;
  }
}
@media (max-width: 640px) {
  .register-steps,
  .metadata-file-list {
    grid-template-columns: 1fr;
  }
  .register-steps li:nth-child(2)::after {
    display: block;
  }
  .register-steps li:not(:last-child)::after {
    right: 14px;
    bottom: 0;
    left: 62px;
    width: auto;
    height: 1px;
  }
  .selected-file-list li {
    grid-template-columns: 26px minmax(0, 1fr);
  }
  .selected-file-actions {
    grid-column: 2;
    justify-self: start;
  }
}
@media (prefers-reduced-motion: reduce) {
  .analysis-progress-track span,
  .metadata-file-list article {
    transition-duration: 0.01ms;
  }
}
.register-main {
  padding-top: 26px;
  padding-bottom: 56px;
}

.register-topline {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
  margin-bottom: 18px;
  color: #667381;
  font-size: 13px;
  font-weight: 800;
}

.register-hero {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 24px;
  align-items: end;
  padding-bottom: 4px;
}

.register-title-block {
  min-width: 0;
}

.home-link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 34px;
  padding: 0 12px;
  border: 1px solid #d1dbe5;
  border-radius: 8px;
  background: #ffffff;
  color: #526170;
  font-size: 13px;
  font-weight: 900;
  text-decoration: none;
  white-space: nowrap;
}

.home-link:hover {
  border-color: #9fb0c1;
  background: #f7fafc;
  color: #141a21;
}

.home-link svg {
  width: 17px;
  height: 17px;
}

.eyebrow {
  margin: 0;
  color: #5a5148;
  font-size: 13px;
  font-weight: 800;
}

.register-hero h1 {
  margin: 10px 0 0;
  color: #07111f;
  font-size: 32px;
  font-weight: 900;
  line-height: 1.18;
}

.hero-copy {
  max-width: 680px;
  margin: 12px 0 0;
  color: #536170;
  font-size: 15px;
  line-height: 1.7;
}

.detail-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.detail-tab {
  display: inline-flex;
  align-items: center;
  height: 38px;
  padding: 0 14px;
  border: 1px solid #cbd5df;
  border-radius: 8px;
  background: #ffffff;
  color: #5b6775;
  font-size: 13px;
  font-weight: 800;
  text-decoration: none;
}

.detail-tab.is-active {
  border-color: #2f3439;
  background: #2f3439;
  color: #ffffff;
}

.register-flow {
  margin-top: 24px;
}

.flow-progress {
  position: relative;
  height: 3px;
  margin: 0 18px 12px;
  overflow: hidden;
  border-radius: 999px;
  background: #dfe6ed;
}

.flow-progress span {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: #0f7aa5;
  transition: width 180ms ease;
}

.register-steps {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.register-step {
  position: relative;
  display: grid;
  min-height: 118px;
  grid-template-columns: auto minmax(0, 1fr);
  gap: 12px;
  align-items: start;
  width: 100%;
  padding: 17px;
  border: 1px solid #d8e0e8;
  border-radius: 8px;
  background: #ffffff;
  color: #536170;
  text-align: left;
  transition: border-color 160ms ease, box-shadow 160ms ease, background 160ms ease, color 160ms ease;
}

.register-step:hover {
  border-color: #9fb0c1;
  box-shadow: 0 10px 24px rgba(22, 31, 45, 0.08);
}

.register-step.is-active {
  border-color: #2f3439;
  background: #2f3439;
  color: #ffffff;
  box-shadow: 0 18px 36px rgba(22, 31, 45, 0.18);
}

.register-step.is-complete {
  border-color: #bde4ee;
  background: #edf9fb;
  color: #075a6d;
}

.register-step-number {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 999px;
  background: #edf2f7;
  color: #637285;
  font-size: 12px;
  font-weight: 900;
}

.register-step-number.is-active {
  background: #ffffff;
  color: #2f3439;
}

.register-step-number.is-complete {
  background: #0f7aa5;
  color: #ffffff;
}

.register-step-copy {
  display: grid;
  min-width: 0;
  gap: 6px;
}

.register-step-title {
  color: inherit;
  font-size: 15px;
  font-weight: 900;
  line-height: 1.35;
  word-break: keep-all;
}

.register-step-desc {
  color: inherit;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.45;
  opacity: 0.76;
  word-break: keep-all;
}

.register-step-state {
  position: absolute;
  right: 14px;
  bottom: 12px;
  font-size: 11px;
  font-weight: 900;
  opacity: 0.72;
  white-space: nowrap;
}

.register-workbench {
  margin-top: 22px;
  overflow: hidden;
  border: 1px solid #ced8e3;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 18px 50px rgba(22, 31, 45, 0.08);
}

.workbench-head {
  display: flex;
  gap: 18px;
  align-items: start;
  justify-content: space-between;
  padding: 24px 26px;
  border-bottom: 1px solid #e3e9ef;
  background: #fbfcfd;
}

.workbench-head h2 {
  margin: 7px 0 0;
  color: #0b1220;
  font-size: 22px;
  font-weight: 900;
  line-height: 1.25;
}

.workbench-head p:last-child {
  margin: 8px 0 0;
  color: #607080;
  font-size: 13px;
  font-weight: 700;
}

.status-pill {
  display: inline-flex;
  align-items: center;
  height: 30px;
  padding: 0 12px;
  border-radius: 999px;
  background: #eef3f7;
  color: #526170;
  font-size: 12px;
  font-weight: 900;
  white-space: nowrap;
}

.workbench-body {
  padding: 26px;
}

.upload-grid,
.manual-layout,
.complete-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 320px;
  gap: 22px;
}

.metadata-layout,
.manual-form {
  display: grid;
  gap: 20px;
}

.source-panel,
.library-check,
.manual-checks,
.preview-panel,
.final-panel,
.recognition-banner {
  border-radius: 8px;
}

.source-panel {
  padding: 22px;
  border: 1px dashed #b9c7d5;
  background: #f7fafc;
}

.panel-heading {
  display: flex;
  gap: 14px;
  align-items: flex-start;
}

.panel-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 46px;
  height: 46px;
  border: 1px solid #d9e2eb;
  border-radius: 8px;
  background: #ffffff;
  color: #2f5f75;
}

.panel-icon svg {
  width: 22px;
  height: 22px;
}

.panel-heading h3,
.library-check h3,
.manual-checks h3,
.preview-panel h3,
.recognition-banner h3,
.final-panel h3 {
  margin: 0;
  color: #101827;
  font-size: 16px;
  font-weight: 900;
}

.panel-heading p,
.recognition-banner p,
.final-panel p {
  margin: 6px 0 0;
  color: #607080;
  font-size: 13px;
  line-height: 1.6;
}

.source-toggle {
  display: inline-flex;
  gap: 4px;
  margin-top: 20px;
  padding: 4px;
  border: 1px solid #d7e0e8;
  border-radius: 8px;
  background: #ffffff;
}

.source-toggle button {
  height: 34px;
  min-width: 86px;
  padding: 0 14px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #607080;
  font-size: 12px;
  font-weight: 900;
  white-space: nowrap;
  word-break: keep-all;
}

.source-toggle button.is-active {
  background: #2f3439;
  color: #ffffff;
}

.file-box {
  position: relative;
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: space-between;
  min-height: 84px;
  margin-top: 18px;
  padding: 16px;
  border: 1px solid #cbd7e3;
  border-radius: 8px;
  background: #ffffff;
  cursor: pointer;
}

.file-box input {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
}

.file-box-main {
  display: grid;
  min-width: 0;
  gap: 4px;
}

.file-box-main strong {
  overflow: hidden;
  color: #101827;
  font-size: 14px;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: keep-all;
}

.file-box-main small {
  color: #758395;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.45;
  word-break: keep-all;
}

.file-box-action {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  min-width: 78px;
  height: 34px;
  padding: 0 12px;
  border-radius: 6px;
  background: #eef3f7;
  color: #374151;
  font-size: 12px;
  font-weight: 900;
  white-space: nowrap;
  word-break: keep-all;
}

.url-entry {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 10px;
  margin-top: 18px;
}

.button-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 14px;
}

.primary-btn,
.secondary-btn,
.dark-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 78px;
  height: 40px;
  padding: 0 15px;
  border-radius: 7px;
  font-size: 13px;
  font-weight: 900;
  white-space: nowrap;
}

.primary-btn {
  border: 1px solid #2f3439;
  background: #2f3439;
  color: #ffffff;
}

.primary-btn:hover,
.dark-btn:hover {
  background: #171c21;
}

.secondary-btn {
  border: 1px solid #c9d4df;
  background: #ffffff;
  color: #415062;
}

.secondary-btn:hover {
  background: #f4f7fa;
}

button:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}

.selected-source {
  display: flex;
  min-width: 0;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  margin-top: 18px;
  padding: 13px 14px;
  border-radius: 8px;
  background: #ffffff;
  color: #607080;
  font-size: 13px;
}

.selected-source span {
  color: #26313f;
  font-weight: 900;
}

.selected-source strong {
  min-width: 0;
  color: #0b1220;
  font-weight: 800;
  overflow-wrap: anywhere;
}

.selected-source em {
  color: #8a98a8;
  font-style: normal;
}

.analysis-status {
  display: flex;
  gap: 10px;
  align-items: flex-start;
  margin-top: 12px;
  padding: 13px 14px;
  border: 1px solid;
  border-radius: 8px;
  font-size: 12px;
}

.analysis-status-dot {
  flex: 0 0 auto;
  width: 9px;
  height: 9px;
  margin-top: 5px;
  border-radius: 999px;
  background: currentColor;
}

.analysis-status div {
  display: grid;
  gap: 3px;
}

.analysis-status strong {
  font-size: 13px;
  font-weight: 900;
}

.analysis-status p {
  margin: 0;
  line-height: 1.55;
}

.analysis-status.is-running {
  border-color: #b9ddea;
  background: #edf8fb;
  color: #0f6f91;
}

.analysis-status.is-running .analysis-status-dot {
  animation: pulse 1.2s ease-in-out infinite;
}

.analysis-status.is-complete {
  border-color: #b9e2ce;
  background: #effaf4;
  color: #14724a;
}

.analysis-status.is-error {
  border-color: #fecaca;
  background: #fff1f2;
  color: #b91c1c;
}

.batch-list {
  display: grid;
  gap: 8px;
  margin-top: 14px;
}

.batch-list button {
  display: grid;
  grid-template-columns: 28px minmax(0, 1fr) auto;
  gap: 10px;
  align-items: center;
  width: 100%;
  min-height: 44px;
  padding: 7px 10px;
  border: 1px solid #d7e0e8;
  border-radius: 8px;
  background: #fff;
  color: #465566;
  text-align: left;
}

.batch-list button.is-active {
  border-color: #19799c;
  box-shadow: 0 0 0 2px rgba(25, 121, 156, 0.12);
}

.batch-list button > span {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 999px;
  background: #eef3f7;
  font-size: 11px;
  font-weight: 900;
}

.batch-list button strong {
  min-width: 0;
  overflow: hidden;
  color: #172230;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.batch-list button em {
  color: #607080;
  font-size: 11px;
  font-style: normal;
  font-weight: 900;
}

.metadata-batch {
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  margin: 0 0 18px;
}

.library-check,
.manual-checks,
.preview-panel {
  padding: 20px;
  border: 1px solid #e0e7ee;
  background: #fbfcfd;
}

.library-check dl,
.preview-list {
  display: grid;
  gap: 10px;
  margin: 16px 0 0;
}

.library-check dl div,
.preview-list div {
  display: grid;
  gap: 5px;
  padding: 12px;
  border-radius: 8px;
  background: #ffffff;
}

.library-check dt,
.preview-list dt {
  color: #748295;
  font-size: 12px;
  font-weight: 800;
}

.library-check dd,
.preview-list dd {
  margin: 0;
  color: #111827;
  font-size: 13px;
  font-weight: 900;
  line-height: 1.55;
}

.recognition-banner {
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: space-between;
  padding: 18px 20px;
  border: 1px solid #cfe3e9;
  background: #f0f8fa;
}

.dark-btn {
  border: 1px solid #2f3439;
  background: #2f3439;
  color: #ffffff;
}

.dark-btn svg,
.final-panel button svg {
  width: 16px;
  height: 16px;
  margin-right: 8px;
  animation: spin 0.9s linear infinite;
}

.dark-btn circle,
.final-panel button circle {
  opacity: 0.25;
  fill: none;
}

.dark-btn path,
.final-panel button path {
  opacity: 0.75;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px;
}

.field {
  display: grid;
  gap: 7px;
}

.field label {
  color: #354253;
  font-size: 13px;
  font-weight: 900;
}

.field input,
.field select,
.field textarea,
.url-entry textarea,
.url-entry input {
  width: 100%;
  border: 1px solid #c7d3df;
  border-radius: 7px;
  background: #ffffff;
  color: #111827;
  font-size: 14px;
  line-height: 1.4;
  outline: none;
  transition: border-color 150ms ease, box-shadow 150ms ease;
}

.field input,
.field select {
  height: 42px;
  padding: 0 12px;
}

.url-entry input {
  height: 48px;
  padding: 0 14px;
}

.url-entry-help {
  margin: 7px 0 0;
  color: #74827e;
  font-size: 10px;
  font-weight: 750;
  line-height: 1.5;
}

.field textarea {
  min-height: 176px;
  resize: vertical;
  padding: 12px;
}

.field-heading {
  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: space-between;
}

.field-heading > span {
  color: #9a5c0d;
  font-size: 12px;
  font-weight: 900;
}

.ocr-editor,
.entity-editor,
.admin-settings {
  margin-top: 22px;
  padding-top: 22px;
  border-top: 1px solid #dde5ec;
}

.low-confidence-words {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding: 12px;
  border-radius: 8px;
  background: #fff8eb;
}

.low-confidence-words span {
  padding: 4px 7px;
  border: 1px solid #f4d49d;
  border-radius: 6px;
  background: #fff;
  color: #965b08;
  font-size: 11px;
  font-weight: 900;
}

.entity-editor {
  display: grid;
  gap: 10px;
}

.entity-editor label {
  color: #354253;
  font-size: 13px;
  font-weight: 900;
}

.entity-row {
  display: grid;
  grid-template-columns: minmax(100px, 1fr) 120px minmax(100px, 1fr) minmax(150px, 1.2fr) 56px 52px;
  gap: 7px;
  align-items: center;
}

.entity-row input,
.entity-row select {
  width: 100%;
  height: 38px;
  padding: 0 9px;
  border: 1px solid #c7d3df;
  border-radius: 7px;
  background: #fff;
  font-size: 12px;
}

.entity-confidence {
  color: #27704f;
  font-size: 11px;
  font-weight: 900;
  text-align: center;
}

.entity-confidence.is-low {
  color: #b45309;
}

.entity-remove {
  height: 34px;
  border: 1px solid #f2b8b8;
  border-radius: 6px;
  background: #fff;
  color: #b42323;
  font-size: 11px;
  font-weight: 900;
}

.empty-editor {
  padding: 18px;
  border-radius: 8px;
  background: #f7f9fb;
  color: #8492a1;
  font-size: 12px;
  text-align: center;
}

.admin-settings {
  color: #26313f;
}

.admin-settings summary {
  cursor: pointer;
  color: #26313f;
  font-size: 14px;
  font-weight: 900;
}

.admin-settings-body {
  display: grid;
  gap: 16px;
  margin-top: 16px;
  padding: 18px;
  border: 1px solid #dbe4ec;
  border-radius: 8px;
  background: #f7f9fb;
}

.admin-options {
  display: flex;
  flex-wrap: wrap;
  gap: 18px;
}

.admin-options label {
  display: inline-flex;
  gap: 8px;
  align-items: center;
  font-size: 12px;
  font-weight: 800;
}

.field input:focus,
.field select:focus,
.field textarea:focus,
.url-entry textarea:focus,
.url-entry input:focus {
  border-color: #0f7aa5;
  box-shadow: 0 0 0 3px rgba(15, 122, 165, 0.14);
}

.manual-checks {
  align-self: start;
}

.check-list {
  display: grid;
  gap: 9px;
  margin-top: 16px;
}

.check-item {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  gap: 10px;
  align-items: center;
  padding: 11px 12px;
  border-radius: 8px;
  background: #ffffff;
  color: #4b5968;
  font-size: 13px;
  font-weight: 800;
}

.check-index {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 999px;
  background: #eef3f7;
  color: #536170;
  font-size: 11px;
  font-weight: 900;
}

.check-item strong {
  color: #a15c06;
  font-size: 11px;
  font-weight: 900;
}

.pre-line {
  white-space: pre-wrap;
}

.final-panel {
  padding: 24px;
  background: #2f3439;
  color: #ffffff;
}

.final-label {
  color: #b9c7d5;
  font-size: 12px;
  font-weight: 900;
}

.final-panel h3 {
  margin-top: 8px;
  color: #ffffff;
}

.final-panel p {
  color: #d6dde5;
}

.final-panel button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 42px;
  margin-top: 22px;
  border: 0;
  border-radius: 7px;
  background: #ffffff;
  color: #111827;
  font-size: 13px;
  font-weight: 900;
}

.final-panel button:hover {
  background: #edf2f7;
}

.workbench-footer {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  padding: 18px 26px;
  border-top: 1px solid #e3e9ef;
  background: #f7f9fb;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
@keyframes pulse {
  0%, 100% {
    opacity: 0.35;
    transform: scale(0.8);
  }
  50% {
    opacity: 1;
    transform: scale(1.15);
  }
}
@media (max-width: 960px) {
  .register-hero,
  .upload-grid,
  .manual-layout,
  .complete-layout {
    grid-template-columns: 1fr;
  }
  .register-steps {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .entity-row {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 640px) {
  .register-header-inner,
  .register-main {
    padding-right: 16px;
    padding-left: 16px;
  }
  .register-main {
    padding-top: 24px;
  }
  .register-hero h1 {
    font-size: 26px;
  }
  .register-steps,
  .form-grid,
  .url-entry {
    grid-template-columns: 1fr;
  }
  .register-step {
    min-height: 104px;
  }
  .workbench-head,
  .recognition-banner {
    flex-direction: column;
    align-items: stretch;
  }
  .workbench-body,
  .workbench-head,
  .workbench-footer {
    padding-right: 18px;
    padding-left: 18px;
  }
  .file-box {
    align-items: flex-start;
    flex-direction: column;
  }
  .workbench-footer {
    justify-content: stretch;
  }
  .workbench-footer .primary-btn,
  .workbench-footer .secondary-btn {
    flex: 1 1 0;
  }
}
/* Premium accession workspace */
:host {
  height: 100%;
}

.register-page {
  --register-ink: #173b36;
  --register-green: #2f625a;
  --register-copper: #9a5b2b;
  --register-paper: #f5f7f5;
  background: radial-gradient(circle at 8% 4%, rgba(47, 98, 90, 0.07), transparent 27rem), linear-gradient(180deg, #f9faf8 0, var(--register-paper) 35rem, #f1f4f2 100%);
  font-family: Pretendard, "Noto Sans KR", "Apple SD Gothic Neo", system-ui, sans-serif;
}

.register-header {
  border-color: rgba(203, 213, 225, 0.75);
  background: rgba(255, 255, 255, 0.95);
  box-shadow: 0 6px 24px rgba(15, 23, 42, 0.045);
}

.register-header-inner,
.register-main {
  width: min(100%, 1560px);
}

.register-header-inner {
  height: 78px;
}

.brand-link {
  border-radius: 10px;
  text-decoration: none;
}

.brand-link:focus-visible {
  outline: 2px solid var(--register-green);
  outline-offset: 5px;
}

.brand-logo {
  height: 45px;
}

.brand-divider {
  width: 1px;
  height: 28px;
  margin: 0 15px;
  background: #dde4e2;
}

.brand-context {
  display: grid;
  gap: 3px;
}

.brand-context small {
  color: var(--register-copper);
  font-size: 9px;
  font-weight: 900;
  letter-spacing: 0.17em;
  line-height: 1;
  text-transform: uppercase;
}

.brand-context strong {
  color: #52605d;
  font-size: 12px;
  font-weight: 900;
}

.account-button {
  height: 40px;
  border-color: #d7dfdd;
  border-radius: 10px;
  color: #44534f;
  box-shadow: 0 3px 10px rgba(15, 23, 42, 0.045);
}

.account-button:hover,
.account-button[aria-expanded=true] {
  border-color: #aebdb9;
  background: #fafcfb;
}

.account-avatar {
  width: 27px;
  height: 27px;
  background: var(--register-green);
}

.account-dropdown {
  width: 190px;
  padding: 6px;
  border-radius: 12px;
}

.account-dropdown a {
  border-radius: 8px;
}

.register-main {
  padding-top: 22px;
  padding-bottom: 72px;
}

.register-topline {
  margin-bottom: 20px;
  color: #84918e;
  font-size: 12px;
}

.home-link {
  min-height: 32px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #586762;
  font-size: 12px;
}

.home-link:hover {
  border: 0;
  background: transparent;
  color: var(--register-ink);
}

.breadcrumb-divider {
  color: #c5cecb;
}

.register-hero {
  grid-template-columns: minmax(0, 1fr) 350px;
  gap: 28px;
  align-items: center;
  padding: 4px 0 8px;
}

.eyebrow,
.aside-kicker {
  color: var(--register-copper);
  font-size: 10px;
  font-weight: 900;
  letter-spacing: 0.13em;
  text-transform: uppercase;
}

.register-hero h1 {
  margin-top: 8px;
  color: #0b1715;
  font-size: 36px;
  letter-spacing: -0.035em;
}

.hero-copy {
  max-width: 720px;
  margin-top: 10px;
  color: #5b6966;
  font-size: 14px;
}

.hero-assurance {
  display: flex;
  gap: 14px;
  align-items: center;
  padding: 16px 18px;
  border: 1px solid #dbe5e2;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.78);
  box-shadow: 0 10px 28px rgba(23, 59, 54, 0.055);
}

.assurance-icon {
  display: inline-flex;
  flex: 0 0 auto;
  width: 42px;
  height: 42px;
  align-items: center;
  justify-content: center;
  border-radius: 13px;
  background: #eaf3f0;
  color: var(--register-green);
}

.assurance-icon svg {
  width: 21px;
  height: 21px;
}

.hero-assurance strong {
  color: #253632;
  font-size: 13px;
  font-weight: 900;
}

.hero-assurance p {
  margin: 4px 0 0;
  color: #71807c;
  font-size: 11px;
  font-weight: 700;
  line-height: 1.55;
}

.register-flow {
  display: grid;
  grid-template-columns: 282px minmax(0, 1fr);
  grid-template-areas: "progress workbench" "steps workbench" "guide workbench";
  gap: 12px 22px;
  align-items: start;
  margin-top: 28px;
}

.flow-progress {
  grid-area: progress;
  height: auto;
  margin: 0;
  overflow: visible;
  border: 1px solid #dbe4e1;
  border-radius: 16px;
  background: #ffffff;
  padding: 16px;
  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.04);
}

.flow-progress-copy {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}

.flow-progress-copy p {
  margin: 0;
  color: #88938f;
  font-size: 10px;
  font-weight: 900;
  letter-spacing: 0.08em;
}

.flow-progress-copy strong {
  display: block;
  margin-top: 3px;
  color: var(--register-ink);
  font-size: 23px;
  font-weight: 950;
  letter-spacing: -0.04em;
}

.flow-progress-copy > span {
  color: #9aa5a1;
  font-size: 11px;
  font-weight: 900;
}

.flow-progress-copy span {
  height: auto;
  border-radius: 0;
  background: transparent;
}

.flow-progress-track {
  height: 6px;
  margin-top: 13px;
  overflow: hidden;
  border-radius: 999px;
  background: #e8eeec;
}

.flow-progress-track span {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, #3a776d, var(--register-ink));
  transition: width 260ms cubic-bezier(0.22, 1, 0.36, 1);
}

.register-steps {
  grid-area: steps;
  grid-template-columns: 1fr;
  gap: 0;
  overflow: hidden;
  border: 1px solid #dbe4e1;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.045);
}

.register-steps li {
  position: relative;
}

.register-steps li:not(:last-child)::after {
  position: absolute;
  bottom: 0;
  left: 66px;
  right: 14px;
  height: 1px;
  background: #edf1f0;
  content: "";
}

.register-step {
  min-height: 92px;
  grid-template-columns: 38px minmax(0, 1fr);
  gap: 12px;
  align-items: center;
  padding: 15px 16px;
  border: 0;
  border-radius: 0;
  background: #ffffff;
  color: #61706c;
  box-shadow: none;
}

.register-step:hover {
  border: 0;
  background: #f7faf9;
  box-shadow: none;
}

.register-step.is-active {
  border: 0;
  background: linear-gradient(135deg, #2f625a, var(--register-ink));
  color: #ffffff;
  box-shadow: 0 12px 28px rgba(23, 59, 54, 0.16);
}

.register-step.is-complete {
  border: 0;
  background: #f0f7f4;
  color: #245149;
}

.register-step-number {
  width: 38px;
  height: 38px;
  background: #f0f3f2;
  color: #768480;
  font-size: 11px;
}

.register-step-number.is-active {
  background: rgba(255, 255, 255, 0.96);
  color: var(--register-ink);
}

.register-step-number.is-complete {
  background: var(--register-green);
  color: #ffffff;
}

.register-step-title {
  font-size: 14px;
}

.register-step-desc {
  font-size: 11px;
}

.register-step-state {
  right: 15px;
  bottom: 10px;
  font-size: 9px;
  letter-spacing: 0.04em;
}

.flow-guide {
  grid-area: guide;
  display: flex;
  gap: 11px;
  padding: 14px;
  border: 1px solid #e2e7e5;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.65);
}

.flow-guide-icon {
  display: inline-flex;
  flex: 0 0 auto;
  width: 30px;
  height: 30px;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  background: #eef3f2;
  color: #657470;
}

.flow-guide-icon svg {
  width: 16px;
  height: 16px;
}

.flow-guide strong {
  color: #40504c;
  font-size: 11px;
  font-weight: 900;
}

.flow-guide p {
  margin: 4px 0 0;
  color: #7a8783;
  font-size: 10px;
  font-weight: 700;
  line-height: 1.55;
}

.register-workbench {
  grid-area: workbench;
  margin-top: 0;
  scroll-margin-top: 96px;
  overflow: visible;
  border-color: #d7e1de;
  border-radius: 20px;
  box-shadow: 0 22px 54px rgba(23, 59, 54, 0.075);
}

.workbench-head {
  align-items: center;
  padding: 22px 24px;
  border-radius: 20px 20px 0 0;
  border-color: #e5ebe9;
  background: linear-gradient(110deg, rgba(249, 251, 250, 0.98), rgba(242, 247, 245, 0.94));
}

.workbench-title {
  display: flex;
  gap: 14px;
  align-items: center;
}

.workbench-step-number {
  display: inline-flex;
  flex: 0 0 auto;
  width: 48px;
  height: 48px;
  align-items: center;
  justify-content: center;
  border-radius: 15px;
  background: var(--register-ink);
  color: #ffffff;
  font-size: 13px;
  font-weight: 950;
  box-shadow: 0 8px 18px rgba(23, 59, 54, 0.2);
}

.workbench-head h2 {
  margin-top: 4px;
  color: #0d1d1a;
  font-size: 21px;
  letter-spacing: -0.025em;
}

.workbench-head p:last-child {
  margin-top: 4px;
  color: #71807c;
  font-size: 11px;
}

.status-pill {
  height: 29px;
  border: 1px solid #dae3e0;
  background: #ffffff;
  color: #5d6c68;
  font-size: 10px;
}

.workbench-body {
  padding: 24px;
}

.workbench-body > div {
  animation: register-step-enter 260ms cubic-bezier(0.22, 1, 0.36, 1) backwards;
}

.upload-grid,
.manual-layout,
.complete-layout {
  grid-template-columns: minmax(0, 1fr) 280px;
  gap: 18px;
}

.source-panel,
.library-check,
.manual-checks,
.preview-panel,
.final-panel,
.recognition-banner {
  border-radius: 16px;
}

.source-panel {
  padding: 22px;
  border: 1px solid #cbdcd7;
  background: linear-gradient(145deg, rgba(247, 251, 249, 0.98), rgba(241, 247, 245, 0.94));
}

.panel-icon {
  width: 44px;
  height: 44px;
  border-color: #cfddd9;
  border-radius: 13px;
  color: var(--register-green);
}

.panel-heading h3,
.library-check h3,
.manual-checks h3,
.preview-panel h3,
.recognition-banner h3,
.final-panel h3,
.section-heading h3 {
  color: #14231f;
  font-size: 16px;
}

.source-toggle {
  width: 100%;
  margin-top: 18px;
  border-color: #d7e2df;
  border-radius: 11px;
}

.source-toggle button {
  flex: 1 1 0;
  border-radius: 8px;
}

.source-toggle button.is-active {
  background: var(--register-ink);
}

.file-box {
  display: grid;
  min-height: 150px;
  grid-template-columns: 48px minmax(0, 1fr) auto;
  margin-top: 16px;
  padding: 20px;
  border: 1px dashed #9fb9b2;
  border-radius: 15px;
  background: rgba(255, 255, 255, 0.9);
  transition: border-color 180ms ease, background-color 180ms ease, box-shadow 180ms ease, transform 180ms ease;
}

.file-box:hover,
.file-box:focus-within {
  border-color: var(--register-green);
  background: #ffffff;
  box-shadow: 0 12px 28px rgba(23, 59, 54, 0.085);
  transform: translateY(-1px);
}

.file-box-visual {
  display: inline-flex;
  width: 48px;
  height: 48px;
  align-items: center;
  justify-content: center;
  border-radius: 14px;
  background: #eaf3f0;
  color: var(--register-green);
}

.file-box-visual svg {
  width: 23px;
  height: 23px;
}

.file-box-main strong {
  font-size: 14px;
}

.file-box-main small {
  max-width: 480px;
  color: #7c8985;
  font-size: 11px;
}

.file-box-action {
  min-width: 82px;
  height: 36px;
  border: 1px solid #d8e2df;
  border-radius: 9px;
  background: #ffffff;
  color: #3d514c;
}

.url-entry textarea,
.url-entry input,
.field input,
.field select,
.field textarea {
  border-color: #d3ddda;
  border-radius: 10px;
}

.url-entry textarea:focus,
.url-entry input:focus,
.field input:focus,
.field select:focus,
.field textarea:focus {
  border-color: var(--register-green);
  box-shadow: 0 0 0 3px rgba(47, 98, 90, 0.1);
}

.selected-source {
  display: grid;
  grid-template-columns: 34px minmax(0, 1fr) auto;
  gap: 10px;
  margin-top: 14px;
  padding: 12px;
  border: 1px solid #dde6e3;
  border-radius: 12px;
  background: #ffffff;
}

.source-status-icon {
  display: inline-flex;
  width: 32px;
  height: 32px;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  background: #f0f3f2;
  color: #8a9692;
}

.source-status-icon.is-ready {
  background: #e7f4ed;
  color: #277255;
}

.source-status-icon svg {
  width: 16px;
  height: 16px;
}

.selected-source-copy {
  display: grid;
  min-width: 0;
  gap: 2px;
}

.selected-source-copy span {
  color: #8a9692;
  font-size: 9px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.selected-source-copy strong {
  overflow: hidden;
  color: #263733;
  font-size: 11px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.selected-source > em {
  color: #778580;
  font-size: 10px;
  font-weight: 800;
}

.source-features {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px;
  margin-top: 12px;
}

.source-features > span {
  display: flex;
  gap: 8px;
  align-items: center;
  min-width: 0;
  padding: 9px 10px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.78);
}

.source-features strong {
  color: var(--register-copper);
  font-size: 9px;
  font-weight: 950;
}

.source-features em {
  overflow: hidden;
  color: #64736f;
  font-size: 10px;
  font-style: normal;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.primary-btn,
.dark-btn {
  border-color: var(--register-ink);
  border-radius: 10px;
  background: linear-gradient(135deg, #2f625a, var(--register-ink));
  box-shadow: 0 7px 17px rgba(23, 59, 54, 0.14);
}

.primary-btn:hover,
.dark-btn:hover {
  background: linear-gradient(135deg, #28574f, #102f2a);
  box-shadow: 0 9px 22px rgba(23, 59, 54, 0.2);
}

.secondary-btn {
  border-color: #d3ddda;
  border-radius: 10px;
  color: #52625d;
}

.primary-btn svg,
.secondary-btn svg {
  width: 15px;
  height: 15px;
}

.library-check,
.manual-checks,
.preview-panel {
  padding: 20px;
  border-color: #dfe7e5;
  background: #fafcfb;
}

.check-intro {
  margin: 7px 0 0;
  color: #7a8783;
  font-size: 10px;
  font-weight: 700;
  line-height: 1.6;
}

.library-check dl div,
.preview-list div {
  border: 1px solid #edf1f0;
  border-radius: 10px;
}

.library-check dt,
.preview-list dt {
  color: #87938f;
  font-size: 10px;
}

.library-check dd,
.preview-list dd {
  color: #263632;
  font-size: 12px;
}

.recognition-banner {
  padding: 18px 20px;
  border-color: #c9ddd7;
  background: linear-gradient(135deg, #eef7f4, #f7faf9);
}

.recognition-banner .aside-kicker {
  display: block;
  margin-bottom: 5px;
}

.metadata-stats {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px;
}

.metadata-stats > div {
  display: grid;
  gap: 5px;
  padding: 14px;
  border: 1px solid #e1e8e6;
  border-radius: 12px;
  background: #ffffff;
}

.metadata-stats span {
  color: #8a9692;
  font-size: 9px;
  font-weight: 900;
  letter-spacing: 0.05em;
}

.metadata-stats strong {
  color: #263733;
  font-size: 14px;
  font-weight: 950;
}

.section-heading {
  display: flex;
  gap: 20px;
  align-items: end;
  justify-content: space-between;
  padding-bottom: 12px;
  border-bottom: 1px solid #e6ecea;
}

.section-heading h3 {
  margin: 4px 0 0;
}

.section-heading p {
  margin: 0;
  color: #7a8783;
  font-size: 10px;
  font-weight: 700;
}

.metadata-form {
  padding: 18px;
  border: 1px solid #e1e8e6;
  border-radius: 14px;
  background: #fafcfb;
}

.metadata-layout > .field {
  padding: 18px;
  border: 1px solid #e1e8e6;
  border-radius: 14px;
  background: #fafcfb;
}

.field label {
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: space-between;
  color: #41514c;
  font-size: 11px;
}

.field label strong {
  display: inline-flex;
  min-width: 43px;
  height: 22px;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  background: #eaf3f0;
  color: var(--register-green);
  font-size: 9px;
  font-weight: 950;
}

.manual-checks {
  position: sticky;
  top: 98px;
}

.check-item {
  border: 1px solid #edf1f0;
  border-radius: 10px;
}

.check-index {
  background: #eaf3f0;
  color: var(--register-green);
}

.complete-layout {
  align-items: start;
}

.final-panel {
  padding: 22px;
  background: radial-gradient(circle at 100% 0, rgba(199, 131, 77, 0.24), transparent 13rem), linear-gradient(145deg, #244f48, var(--register-ink));
  box-shadow: 0 18px 38px rgba(23, 59, 54, 0.18);
}

.final-label {
  color: #d9ae8a;
  font-size: 9px;
  letter-spacing: 0.13em;
  text-transform: uppercase;
}

.final-panel p {
  color: #d6e2df;
  font-size: 11px;
}

.readiness-score {
  display: flex;
  gap: 13px;
  align-items: center;
  margin-top: 20px;
  padding: 13px;
  border: 1px solid rgba(255, 255, 255, 0.13);
  border-radius: 13px;
  background: rgba(255, 255, 255, 0.07);
}

.readiness-ring {
  display: flex;
  flex: 0 0 auto;
  width: 52px;
  height: 52px;
  align-items: baseline;
  justify-content: center;
  border-radius: 999px;
  background: radial-gradient(circle closest-side, #21453f 77%, transparent 79% 99%), conic-gradient(#d89b68 var(--readiness), rgba(255, 255, 255, 0.13) 0);
  padding-top: 16px;
}

.readiness-ring strong {
  color: #ffffff;
  font-size: 15px;
  font-weight: 950;
}

.readiness-ring span {
  color: #b9cbc6;
  font-size: 9px;
}

.readiness-score > div:last-child > strong {
  color: #ffffff;
  font-size: 11px;
  font-weight: 900;
}

.readiness-score > div:last-child > p {
  margin-top: 3px;
  font-size: 9px;
}

.final-checks {
  display: grid;
  gap: 7px;
  margin: 15px 0 0;
  padding: 0;
  list-style: none;
}

.final-checks li {
  display: flex;
  gap: 8px;
  align-items: center;
  color: #b8cac5;
  font-size: 10px;
  font-weight: 800;
}

.final-checks li::before {
  display: inline-flex;
  width: 16px;
  height: 16px;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 999px;
  color: transparent;
  font-size: 9px;
  content: "✓";
}

.final-checks li.is-ready {
  color: #ffffff;
}

.final-checks li.is-ready::before {
  border-color: #d89b68;
  background: #d89b68;
  color: #173b36;
}

.workbench-footer {
  position: sticky;
  bottom: 0;
  z-index: 8;
  align-items: center;
  justify-content: space-between;
  padding: 16px 22px;
  border-radius: 0 0 20px 20px;
  border-color: #e1e8e6;
  background: rgba(250, 252, 251, 0.96);
  backdrop-filter: blur(12px);
}

.footer-guidance {
  display: grid;
  gap: 3px;
  min-width: 0;
}

.footer-guidance span {
  color: var(--register-copper);
  font-size: 9px;
  font-weight: 950;
  letter-spacing: 0.09em;
}

.footer-guidance strong {
  overflow: hidden;
  color: #65736f;
  font-size: 10px;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.footer-actions {
  display: flex;
  flex: 0 0 auto;
  gap: 8px;
}

.footer-actions .primary-btn {
  min-width: 154px;
}

.footer-actions .secondary-btn {
  gap: 5px;
}

.final-save-btn {
  background: linear-gradient(135deg, #b8723d, #925127);
  border-color: #925127;
}

.final-save-btn:hover {
  background: linear-gradient(135deg, #a96532, #7e431f);
}

.spinner {
  margin-right: 7px;
  animation: spin 0.9s linear infinite;
}

button:not(:disabled) {
  cursor: pointer;
}

button:focus-visible,
a:focus-visible,
summary:focus-visible {
  outline: 2px solid var(--register-green);
  outline-offset: 3px;
}

@keyframes register-step-enter {
  from {
    opacity: 0;
    transform: translateY(7px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@media (max-width: 1100px) {
  .register-hero {
    grid-template-columns: minmax(0, 1fr) 310px;
  }
  .register-flow {
    grid-template-columns: 1fr;
    grid-template-areas: "progress" "steps" "guide" "workbench";
  }
  .register-steps {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .register-steps li:not(:last-child)::after {
    right: 0;
    bottom: 14px;
    left: auto;
    width: 1px;
    height: calc(100% - 28px);
  }
  .register-step {
    min-height: 105px;
    align-items: start;
  }
  .flow-guide {
    display: none;
  }
}
@media (max-width: 820px) {
  .brand-context,
  .brand-divider {
    display: none;
  }
  .register-hero {
    grid-template-columns: 1fr;
  }
  .hero-assurance {
    display: none;
  }
  .register-steps {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .register-steps li:nth-child(2)::after {
    display: none;
  }
  .upload-grid,
  .manual-layout,
  .complete-layout {
    grid-template-columns: 1fr;
  }
  .manual-checks {
    position: static;
  }
  .metadata-stats {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .workbench-footer {
    align-items: stretch;
    flex-direction: column;
  }
  .footer-guidance strong {
    white-space: normal;
  }
  .footer-actions {
    justify-content: flex-end;
  }
}
@media (max-width: 640px) {
  .register-header-inner {
    height: 68px;
  }
  .brand-logo {
    height: 40px;
  }
  .account-name,
  .account-chevron {
    display: none;
  }
  .account-button {
    width: 40px;
    padding: 0;
  }
  .register-main {
    padding-top: 18px;
    padding-bottom: 42px;
  }
  .register-topline {
    margin-bottom: 14px;
  }
  .register-hero h1 {
    font-size: 29px;
  }
  .hero-copy {
    font-size: 12px;
  }
  .register-flow {
    margin-top: 20px;
  }
  .register-steps {
    grid-template-columns: 1fr;
  }
  .register-steps li:nth-child(2)::after {
    display: block;
  }
  .register-steps li:not(:last-child)::after {
    right: 14px;
    bottom: 0;
    left: 66px;
    width: auto;
    height: 1px;
  }
  .register-step {
    min-height: 82px;
    align-items: center;
  }
  .workbench-head,
  .workbench-body,
  .workbench-footer {
    padding-right: 16px;
    padding-left: 16px;
  }
  .workbench-step-number {
    width: 42px;
    height: 42px;
    border-radius: 13px;
  }
  .workbench-head h2 {
    font-size: 18px;
  }
  .status-pill {
    display: none;
  }
  .file-box {
    min-height: 178px;
    grid-template-columns: 1fr;
    justify-items: start;
  }
  .file-box-action {
    width: 100%;
  }
  .source-features {
    grid-template-columns: 1fr;
  }
  .selected-source {
    grid-template-columns: 32px minmax(0, 1fr);
  }
  .selected-source > em {
    grid-column: 2;
  }
  .metadata-stats,
  .form-grid {
    grid-template-columns: 1fr;
  }
  .section-heading {
    align-items: flex-start;
    flex-direction: column;
  }
  .footer-actions {
    width: 100%;
  }
  .footer-actions .primary-btn,
  .footer-actions .secondary-btn {
    flex: 1 1 0;
    min-width: 0;
  }
}
@media (prefers-reduced-motion: reduce) {
  .workbench-body > div {
    animation-duration: 0.01ms;
  }
  .flow-progress-track span,
  .file-box {
    transition-duration: 0.01ms;
  }
}
/* Review follow-up: clearly separated progress and step cards. */
.register-flow {
  grid-template-columns: 1fr;
  grid-template-areas: "progress" "steps" "workbench";
  gap: 12px;
}

.flow-guide {
  display: none;
}

.flow-progress {
  display: block;
  min-height: 0;
  padding: 14px 18px;
  border-radius: 14px;
  box-shadow: 0 7px 20px rgba(23, 59, 54, 0.045);
}

.flow-progress-copy {
  align-items: center;
}

.flow-progress-copy strong {
  display: inline;
  margin: 0 0 0 8px;
  font-size: 18px;
}

.flow-progress-track {
  height: 5px;
  margin-top: 10px;
}

.register-steps {
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px;
  overflow: visible;
  border: 0;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
}

.register-steps li::after {
  display: none !important;
}

.register-step {
  min-height: 88px;
  grid-template-columns: 36px minmax(0, 1fr);
  gap: 4px 11px;
  align-items: center;
  padding: 13px 14px;
  border: 1px solid #dbe4e1;
  border-radius: 14px;
  background: #ffffff;
  box-shadow: 0 7px 18px rgba(23, 59, 54, 0.04);
}

.register-step:hover {
  border: 1px solid #b9cdc7;
  border-radius: 14px;
  background: #f8fbfa;
  box-shadow: 0 10px 24px rgba(23, 59, 54, 0.075);
}

.register-step.is-active {
  border: 1px solid var(--register-ink);
  border-radius: 14px;
  box-shadow: 0 12px 28px rgba(23, 59, 54, 0.16);
}

.register-step.is-complete {
  border: 1px solid #cce0da;
  border-radius: 14px;
}

.register-step-number {
  width: 36px;
  height: 36px;
}

.register-step-copy {
  gap: 2px;
}

.register-step-state {
  position: static;
  grid-column: 2;
  justify-self: start;
  padding: 3px 7px;
  border-radius: 999px;
  background: #eef3f1;
  color: #70807b;
  font-size: 8px;
  line-height: 1.2;
  opacity: 1;
}

.register-step.is-active .register-step-state {
  background: rgba(255, 255, 255, 0.16);
  color: #ffffff;
}

.register-step.is-complete .register-step-state {
  background: #dcece7;
  color: #286055;
}

.ocr-empty-alert {
  padding: 12px 14px;
  border: 1px solid #efd3b8;
  border-radius: 11px;
  background: #fff9f3;
}

.ocr-empty-alert strong {
  color: #8c4e1e;
  font-size: 11px;
  font-weight: 950;
}

.ocr-empty-alert p {
  margin: 4px 0 0;
  color: #966844;
  font-size: 9px;
  font-weight: 750;
  line-height: 1.5;
}

@media (max-width: 820px) {
  .register-steps {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 640px) {
  .register-steps {
    grid-template-columns: 1fr;
  }
  .register-step {
    min-height: 82px;
  }
}
.metadata-confidence-summary {
  display: flex;
  gap: 14px;
  align-items: center;
  justify-content: space-between;
  padding: 12px 14px;
  border: 1px solid #cfe3da;
  border-radius: 12px;
  background: #f2f8f5;
}

.metadata-confidence-summary.has-review {
  border-color: #ebc99e;
  background: #fff9ef;
}

.metadata-confidence-summary > div {
  display: flex;
  gap: 7px;
  align-items: center;
  white-space: nowrap;
}

.metadata-confidence-summary span {
  color: #74837e;
  font-size: 9px;
  font-weight: 900;
}

.metadata-confidence-summary strong {
  color: var(--register-green);
  font-size: 13px;
  font-weight: 950;
}

.metadata-confidence-summary.has-review strong {
  color: #a05e19;
}

.metadata-confidence-summary p {
  margin: 0;
  color: #5f706a;
  font-size: 10px;
  font-weight: 850;
  text-align: right;
}

.confidence-indicator {
  display: inline-flex;
  flex: 0 0 auto;
  gap: 6px;
  align-items: center;
}

.confidence-indicator strong {
  min-width: 48px;
  padding: 0 8px;
  white-space: nowrap;
}

.confidence-indicator small {
  color: #9b5b18;
  font-size: 8px;
  font-weight: 950;
  white-space: nowrap;
}

.confidence-indicator.is-good strong {
  background: #e6f4ed;
  color: #24704f;
}

.confidence-indicator.is-low strong {
  background: #fff0dc;
  color: #a15712;
}

.confidence-indicator.is-unscored strong {
  background: #fff3e7;
  color: #9a5522;
}

.confidence-indicator.is-empty strong {
  background: #eef2f1;
  color: #7c8985;
}

.admin-key-status {
  padding: 13px 14px;
  border: 1px solid #cfe2da;
  border-radius: 11px;
  background: #f0f7f4;
}

.admin-key-status span {
  display: block;
  color: #72817c;
  font-size: 9px;
  font-weight: 900;
}

.admin-key-status strong {
  display: block;
  margin-top: 3px;
  color: #26584e;
  font-size: 12px;
  font-weight: 950;
}

.admin-key-status p {
  margin: 4px 0 0;
  color: #71807b;
  font-size: 9px;
  font-weight: 750;
  line-height: 1.5;
}

@media (max-width: 640px) {
  .metadata-confidence-summary {
    align-items: flex-start;
    flex-direction: column;
  }
  .metadata-confidence-summary p {
    text-align: left;
  }
  .confidence-indicator {
    align-items: flex-end;
    flex-direction: column;
    gap: 3px;
  }
}
/* Drag-and-drop and malware scan states */
.file-box.is-dragging {
  border-color: var(--register-copper);
  border-style: solid;
  background: linear-gradient(135deg, #edf8f4, #fff8ef);
  box-shadow: 0 0 0 4px rgba(198, 121, 58, 0.12), 0 16px 34px rgba(23, 59, 54, 0.12);
  transform: translateY(-2px) scale(1.005);
}

.file-box.is-dragging .file-box-visual {
  background: var(--register-green);
  color: #ffffff;
  transform: scale(1.06);
}

.file-box.is-dragging .file-box-action {
  border-color: var(--register-copper);
  background: var(--register-copper);
  color: #ffffff;
}

.analysis-file-queue li.is-scanning > span {
  background: #fff0dc;
  color: #9a5517;
  animation: pulse 1.2s ease-in-out infinite;
}

@media (prefers-reduced-motion: reduce) {
  .file-box.is-dragging,
  .file-box.is-dragging .file-box-visual,
  .analysis-file-queue li.is-scanning > span {
    animation: none;
    transform: none;
  }
}
/* Incremental collection -------------------------------------------------- */
.incremental-workspace {
  display: grid;
  gap: 16px;
  margin-top: 18px;
}

.sync-method-card,
.sync-config-card,
.sync-source-section,
.sync-history-section {
  border: 1px solid #d5e2de;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.94);
}

.sync-method-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  padding: 16px 18px;
  background: linear-gradient(135deg, #173b36, #24554d);
  color: #ffffff;
}

.sync-method-card h4,
.sync-config-card h4,
.sync-source-section h4,
.sync-history-section h4 {
  margin: 3px 0 0;
  color: inherit;
  font-size: 15px;
  font-weight: 760;
  letter-spacing: -0.02em;
}

.sync-method-card p {
  margin: 5px 0 0;
  color: rgba(255, 255, 255, 0.72);
  font-size: 11px;
  line-height: 1.55;
}

.sync-method-card .aside-kicker {
  color: #9bd2c5;
}

.sync-method-badge {
  flex: 0 0 auto;
  padding: 7px 10px;
  border: 1px solid rgba(255, 255, 255, 0.24);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.08);
  color: #d7f0ea;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.1em;
}

.sync-config-card {
  padding: 18px;
}

.sync-card-head,
.sync-section-head,
.sync-source-top,
.sync-source-actions,
.sync-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.sync-card-head {
  padding-bottom: 14px;
  border-bottom: 1px solid #edf2f0;
}

.sync-card-head h4,
.sync-section-head h4 {
  color: #172722;
}

.sync-text-btn {
  border: 0;
  background: transparent;
  color: #37665d;
  font-size: 11px;
  font-weight: 700;
  text-decoration: underline;
  text-underline-offset: 3px;
}

.sync-text-btn:hover {
  color: #173b36;
}

.sync-form-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
  margin-top: 16px;
}

.sync-field {
  display: grid;
  align-content: start;
  gap: 7px;
}

.sync-field.is-wide {
  grid-column: 1/-1;
}

.sync-field > span {
  color: #40534e;
  font-size: 10px;
  font-weight: 760;
}

.sync-field input,
.sync-field select {
  width: 100%;
  min-width: 0;
  height: 40px;
  border: 1px solid #cddbd7;
  border-radius: 9px;
  background: #ffffff;
  padding: 0 11px;
  color: #182722;
  font-size: 11px;
  outline: 0;
}

.sync-field input:focus,
.sync-field select:focus {
  border-color: #397a6c;
  box-shadow: 0 0 0 3px rgba(57, 122, 108, 0.11);
}

.sync-field small {
  color: #81908c;
  font-size: 9px;
  line-height: 1.5;
}

.sync-enabled {
  display: inline-flex;
  grid-column: 1/-1;
  align-items: center;
  gap: 8px;
  color: #40534e;
  font-size: 11px;
  font-weight: 700;
}

.sync-enabled input {
  width: 15px;
  height: 15px;
  accent-color: #24554d;
}

.sync-policy-note {
  margin-top: 15px;
  padding: 13px 14px;
  border: 1px solid #d9e5e1;
  border-radius: 10px;
  background: #f5f9f7;
}

.sync-policy-note strong {
  display: block;
  color: #23463f;
  font-size: 11px;
}

.sync-policy-note p {
  margin: 5px 0 0;
  color: #62736e;
  font-size: 10px;
  line-height: 1.65;
}

.sync-actions {
  justify-content: flex-end;
  margin-top: 15px;
}

.sync-actions .primary-btn,
.sync-actions .secondary-btn {
  min-height: 40px;
  padding: 0 16px;
}

.sync-summary-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px;
}

.sync-summary-grid article {
  min-width: 0;
  padding: 13px 14px;
  border: 1px solid #d8e3e0;
  border-radius: 11px;
  background: #ffffff;
}

.sync-summary-grid article.has-attention {
  border-color: #e7c4b7;
  background: #fff8f5;
}

.sync-summary-grid span {
  display: block;
  color: #788783;
  font-size: 9px;
  font-weight: 700;
}

.sync-summary-grid strong {
  display: block;
  overflow: hidden;
  margin-top: 5px;
  color: #1a2c27;
  font-size: 14px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sync-source-section,
.sync-history-section {
  overflow: hidden;
}

.sync-section-head {
  padding: 15px 17px;
  border-bottom: 1px solid #e8efed;
}

.sync-source-list {
  display: grid;
  gap: 10px;
  padding: 14px;
}

.sync-source-list > article {
  padding: 14px;
  border: 1px solid #dce6e3;
  border-radius: 11px;
  background: #fbfdfc;
}

.sync-source-list > article.is-disabled {
  opacity: 0.66;
}

.sync-source-top {
  justify-content: flex-start;
}

.sync-state-dot {
  width: 8px;
  height: 8px;
  flex: 0 0 auto;
  border-radius: 999px;
  background: #aab5b2;
}

.sync-state-dot.is-enabled {
  background: #29916f;
  box-shadow: 0 0 0 4px rgba(41, 145, 111, 0.11);
}

.sync-source-top > div {
  min-width: 0;
  flex: 1 1 auto;
}

.sync-source-top strong,
.sync-source-top small {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sync-source-top strong {
  color: #1e2e2a;
  font-size: 11px;
}

.sync-source-top small {
  margin-top: 4px;
  color: #7b8985;
  font-size: 9px;
}

.sync-change-pill {
  display: inline-flex;
  align-items: center;
  min-height: 23px;
  padding: 0 8px;
  border: 1px solid #d8e0de;
  border-radius: 999px;
  background: #f6f8f7;
  color: #66736f;
  font-size: 9px;
  font-weight: 760;
  white-space: nowrap;
}

.sync-change-pill.is-changed {
  border-color: #b7dccc;
  background: #edf8f3;
  color: #1d7659;
}

.sync-change-pill.is-attention {
  border-color: #edc9bb;
  background: #fff3ee;
  color: #a3482c;
}

.sync-change-pill.is-stable {
  border-color: #cddbd7;
  background: #f2f7f5;
  color: #4a625c;
}

.sync-source-list dl {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 7px;
  margin: 12px 0 0;
}

.sync-source-list dl div {
  min-width: 0;
  padding: 8px 9px;
  border-radius: 8px;
  background: #f0f5f3;
}

.sync-source-list dt {
  color: #87938f;
  font-size: 8px;
  font-weight: 700;
}

.sync-source-list dd {
  overflow: hidden;
  margin: 4px 0 0;
  color: #40534e;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 9px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sync-source-error {
  margin: 10px 0 0;
  padding: 8px 10px;
  border-radius: 7px;
  background: #fff0eb;
  color: #a54429;
  font-size: 9px;
  line-height: 1.5;
}

.sync-source-actions {
  justify-content: flex-end;
  margin-top: 11px;
}

.sync-run-btn {
  min-height: 32px;
  padding: 0 11px;
  border: 0;
  border-radius: 8px;
  background: #1d453e;
  color: #ffffff;
  font-size: 10px;
  font-weight: 760;
}

.sync-run-btn:disabled {
  cursor: wait;
  opacity: 0.55;
}

.sync-history-tabs {
  display: inline-flex;
  padding: 3px;
  border-radius: 8px;
  background: #eef3f1;
}

.sync-history-tabs button {
  border: 0;
  border-radius: 6px;
  background: transparent;
  padding: 6px 9px;
  color: #65736f;
  font-size: 9px;
  font-weight: 700;
}

.sync-history-tabs button.is-active {
  background: #ffffff;
  color: #1f4a42;
  box-shadow: 0 1px 4px rgba(26, 57, 51, 0.1);
}

.sync-empty {
  padding: 28px 18px;
  color: #8b9793;
  font-size: 10px;
  text-align: center;
}

.sync-history-table-wrap {
  overflow-x: auto;
}

.sync-history-table {
  width: 100%;
  min-width: 720px;
  border-collapse: collapse;
  table-layout: fixed;
}

.sync-history-table th,
.sync-history-table td {
  padding: 10px 11px;
  border-bottom: 1px solid #edf1f0;
  color: #50605b;
  font-size: 9px;
  text-align: left;
  vertical-align: middle;
}

.sync-history-table th {
  background: #f7faf9;
  color: #7c8985;
  font-weight: 760;
}

.sync-history-table tr:last-child td {
  border-bottom: 0;
}

.sync-url-cell {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sync-hash-cell {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
}

.sync-check {
  align-self: start;
  position: sticky;
  top: 104px;
}

@media (max-width: 1100px) {
  .sync-form-grid,
  .sync-source-list dl {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .sync-summary-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 760px) {
  .sync-method-card,
  .sync-card-head,
  .sync-section-head {
    align-items: flex-start;
    flex-direction: column;
  }
  .sync-form-grid,
  .sync-source-list dl,
  .sync-summary-grid {
    grid-template-columns: 1fr;
  }
  .sync-source-top {
    align-items: flex-start;
    flex-wrap: wrap;
  }
  .sync-source-top > div {
    width: calc(100% - 24px);
    flex-basis: calc(100% - 24px);
  }
  .sync-actions,
  .sync-source-actions {
    align-items: stretch;
    flex-direction: column;
  }
  .sync-actions button,
  .sync-source-actions button {
    width: 100%;
  }
}
.layout-analysis-panel {
  display: grid;
  gap: 18px;
  padding: 22px;
  border: 1px solid #dce5ee;
  border-radius: 14px;
  background: #ffffff;
  box-shadow: 0 14px 32px rgba(31, 45, 61, 0.05);
}

.layout-analysis-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
}

.layout-analysis-head h3 {
  margin: 4px 0 6px;
  color: #17212f;
  font-size: 17px;
  font-weight: 900;
}

.layout-analysis-head p {
  margin: 0;
  color: #68778a;
  font-size: 12px;
  line-height: 1.65;
}

.layout-head-actions {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 8px;
}

.layout-refresh-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  min-height: 31px;
  padding: 6px 10px;
  border: 1px solid #1f5b50;
  border-radius: 7px;
  background: #215f54;
  color: #ffffff;
  font-size: 10px;
  font-weight: 850;
}

.layout-refresh-button:disabled {
  cursor: wait;
  opacity: 0.65;
}

.layout-refresh-button .layout-preview-spinner {
  width: 12px;
  height: 12px;
  border-width: 2px;
}

.layout-coordinate-system {
  flex: 0 0 auto;
  padding: 6px 9px;
  border: 1px solid #cfdbe8;
  border-radius: 6px;
  background: #f7fafc;
  color: #536579;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 10px;
  font-weight: 800;
}

.layout-summary-grid {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 10px;
}

.layout-summary-grid > div {
  display: grid;
  gap: 5px;
  min-width: 0;
  padding: 12px 14px;
  border: 1px solid #e4eaf1;
  border-radius: 9px;
  background: #f8fafc;
}

.layout-summary-grid span {
  color: #7a8797;
  font-size: 10px;
  font-weight: 800;
}

.layout-summary-grid strong {
  overflow: hidden;
  color: #253346;
  font-size: 14px;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.layout-warning-list,
.layout-empty-state {
  padding: 13px 15px;
  border: 1px solid #eadfbd;
  border-radius: 9px;
  background: #fffbeb;
}

.layout-warning-list p,
.layout-empty-state p {
  margin: 0;
  color: #786535;
  font-size: 11px;
  line-height: 1.6;
}

.layout-warning-list p + p {
  margin-top: 4px;
}

.layout-empty-state strong {
  display: block;
  margin-bottom: 3px;
  color: #5d5131;
  font-size: 12px;
}

.layout-region-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.layout-region-grid article {
  display: grid;
  grid-template-columns: 96px minmax(0, 1fr);
  gap: 14px;
  min-width: 0;
  padding: 13px;
  border: 1px solid #e1e7ee;
  border-radius: 10px;
  background: #fbfcfd;
}

.layout-region-grid article.is-table {
  border-color: #b9d1ee;
}

.layout-region-grid article.is-figure {
  border-color: #d5c7ee;
}

.layout-region-grid article.is-annotation {
  border-color: #ead1a9;
}

.layout-page-map {
  position: relative;
  width: 82px;
  aspect-ratio: 0.72;
  overflow: hidden;
  border: 1px solid #cfd8e3;
  border-radius: 4px;
  background: linear-gradient(#e7edf4 1px, transparent 1px) 0 12px/100% 12px, #ffffff;
  box-shadow: 0 5px 12px rgba(31, 45, 61, 0.08);
}

.layout-region-box {
  position: absolute;
  display: block;
  min-width: 5px;
  min-height: 5px;
  border: 2px solid #64748b;
  background: rgba(100, 116, 139, 0.14);
}

.layout-region-box.is-table {
  border-color: #2563eb;
  background: rgba(37, 99, 235, 0.15);
}

.layout-region-box.is-figure {
  border-color: #7c3aed;
  background: rgba(124, 58, 237, 0.15);
}

.layout-region-box.is-annotation {
  border-color: #d97706;
  background: rgba(217, 119, 6, 0.16);
}

.layout-region-body {
  min-width: 0;
}

.layout-region-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.layout-region-title span {
  padding: 3px 7px;
  border-radius: 999px;
  background: #e9eef4;
  color: #526173;
  font-size: 10px;
  font-weight: 900;
}

.layout-region-title span.is-table {
  background: #dbeafe;
  color: #1d4ed8;
}

.layout-region-title span.is-figure {
  background: #ede9fe;
  color: #6d28d9;
}

.layout-region-title span.is-annotation {
  background: #fef3c7;
  color: #a16207;
}

.layout-region-title strong {
  color: #536173;
  font-size: 10px;
  font-weight: 800;
}

.layout-region-body code {
  display: block;
  overflow: hidden;
  margin-top: 8px;
  color: #46566b;
  font-size: 9px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.layout-region-body p {
  display: -webkit-box;
  overflow: hidden;
  margin: 7px 0 0;
  color: #6f7c8c;
  font-size: 10px;
  line-height: 1.55;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.layout-region-body .layout-image-marker {
  color: #6d28d9;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  word-break: break-all;
}

.layout-region-body small {
  display: block;
  overflow: hidden;
  margin-top: 7px;
  color: #7c3aed;
  font-size: 9px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.layout-more-regions {
  margin: -4px 0 0;
  color: #6c7888;
  font-size: 10px;
  text-align: right;
}

.layout-storage-flow {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
}

.layout-storage-flow article {
  display: flex;
  gap: 10px;
  min-width: 0;
  padding: 12px;
  border: 1px solid #e1e8ef;
  border-radius: 10px;
  background: #fbfcfd;
}

.layout-storage-flow article > span {
  display: inline-flex;
  width: 26px;
  height: 26px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #e8f0ee;
  color: #2f625a;
  font-size: 9px;
  font-weight: 950;
}

.layout-storage-flow article > div {
  min-width: 0;
}

.layout-storage-flow strong {
  display: block;
  color: #253346;
  font-size: 11px;
  font-weight: 900;
}

.layout-storage-flow p {
  overflow: hidden;
  margin: 4px 0 0;
  color: #738194;
  font-size: 9px;
  font-weight: 700;
  line-height: 1.5;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.layout-limit-notice,
.layout-complete-notice {
  padding: 12px 14px;
  border: 1px solid #cfe0ef;
  border-radius: 10px;
  background: #f1f7fb;
}

.layout-complete-notice {
  border-color: #c8ddd6;
  background: #f1f8f5;
}

.layout-limit-notice strong,
.layout-complete-notice strong {
  color: #285678;
  font-size: 11px;
  font-weight: 900;
}

.layout-limit-notice p,
.layout-complete-notice p {
  margin: 4px 0 0;
  color: #60798d;
  font-size: 10px;
  font-weight: 700;
  line-height: 1.55;
}

.layout-complete-notice strong {
  color: #2c6658;
}

.layout-complete-notice p {
  color: #5f7d74;
}

.layout-inspector-bar {
  display: flex;
  gap: 18px;
  align-items: center;
  justify-content: space-between;
  padding: 14px 15px;
  border: 1px solid #dde5ed;
  border-radius: 11px;
  background: #f8fafc;
}

.layout-inspector-bar > div {
  min-width: 0;
}

.layout-inspector-bar strong {
  color: #26374b;
  font-size: 12px;
  font-weight: 900;
}

.layout-inspector-bar p {
  margin: 3px 0 0;
  color: #738194;
  font-size: 10px;
  font-weight: 700;
  line-height: 1.5;
}

.layout-detail-toggle {
  display: inline-flex;
  min-height: 36px;
  flex: 0 0 auto;
  gap: 8px;
  align-items: center;
  padding: 0 12px;
  border: 1px solid #cbd8e3;
  border-radius: 9px;
  background: #ffffff;
  color: #3e5269;
  font-size: 10px;
  font-weight: 900;
}

.layout-detail-toggle em {
  padding: 3px 6px;
  border-radius: 999px;
  background: #e8f0ee;
  color: #2f625a;
  font-size: 8px;
  font-style: normal;
}

.layout-detail-toggle:hover {
  border-color: #91a8bb;
  background: #f9fbfc;
}

.layout-inspector {
  display: grid;
  gap: 12px;
  padding: 14px;
  border: 1px solid #dbe4ec;
  border-radius: 12px;
  background: #fbfcfd;
}

.layout-inspector-toolbar {
  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: space-between;
}

.layout-type-filters,
.layout-region-pagination {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
}

.layout-type-filters button,
.layout-region-pagination button {
  min-height: 30px;
  padding: 0 10px;
  border: 1px solid #d8e1e9;
  border-radius: 8px;
  background: #ffffff;
  color: #647489;
  font-size: 9px;
  font-weight: 900;
}

.layout-type-filters button.is-active {
  border-color: #2f625a;
  background: #2f625a;
  color: #ffffff;
}

.layout-region-pagination button:disabled {
  cursor: not-allowed;
  opacity: 0.4;
}

.layout-region-pagination span {
  min-width: 44px;
  color: #586a7e;
  font-size: 9px;
  font-weight: 900;
  text-align: center;
}

.layout-region-table-wrap {
  overflow-x: auto;
  border: 1px solid #e0e7ee;
  border-radius: 10px;
  background: #ffffff;
}

.layout-region-table {
  min-width: 720px;
}

.layout-region-table-head,
.layout-region-row {
  display: grid;
  grid-template-columns: 62px 74px minmax(210px, 1.3fr) minmax(180px, 1fr) 72px;
  gap: 10px;
  align-items: center;
}

.layout-region-table-head {
  min-height: 34px;
  padding: 0 12px;
  border-bottom: 1px solid #e6ebf0;
  background: #f5f8fa;
  color: #7b8998;
  font-size: 8px;
  font-weight: 900;
}

.layout-region-row {
  width: 100%;
  min-height: 44px;
  padding: 6px 12px;
  border: 0;
  border-bottom: 1px solid #edf1f4;
  background: #ffffff;
  color: #506176;
  font-size: 9px;
  text-align: left;
}

.layout-region-row:last-child {
  border-bottom: 0;
}

.layout-region-row:hover,
.layout-region-row.is-active {
  background: #f0f6f4;
}

.layout-region-row.is-active {
  box-shadow: inset 0 0 0 1px #86aaa1;
}

.layout-region-row code,
.layout-region-storage {
  overflow: hidden;
  font-size: 9px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.layout-region-row strong {
  color: #405267;
  font-size: 9px;
  text-align: right;
}

.layout-region-type {
  display: inline-flex;
  width: fit-content;
  align-items: center;
  justify-content: center;
  padding: 3px 7px;
  border-radius: 999px;
  background: #e9eef4;
  color: #526173;
  font-size: 9px;
  font-weight: 900;
}

.layout-region-type.is-table {
  background: #dbeafe;
  color: #1d4ed8;
}

.layout-region-type.is-figure {
  background: #ede9fe;
  color: #6d28d9;
}

.layout-region-type.is-annotation {
  background: #fef3c7;
  color: #a16207;
}

.layout-region-detail {
  display: grid;
  grid-template-columns: 96px minmax(0, 1fr);
  gap: 14px;
  padding: 14px;
  border: 1px solid #dfe7ee;
  border-radius: 10px;
  background: #ffffff;
}

.layout-region-detail .layout-page-map {
  width: 82px;
}

.layout-region-detail-body {
  min-width: 0;
}

.layout-region-detail-head {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  justify-content: space-between;
}

.layout-region-detail-head > div {
  display: flex;
  gap: 8px;
  align-items: center;
}

.layout-region-detail-head strong,
.layout-region-detail-head em {
  color: #52657a;
  font-size: 9px;
  font-style: normal;
  font-weight: 900;
}

.layout-region-detail dl {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 7px 16px;
  margin: 11px 0 0;
}

.layout-region-detail dl div {
  display: grid;
  min-width: 0;
  grid-template-columns: 76px minmax(0, 1fr);
  gap: 8px;
}

.layout-region-detail dt {
  color: #8793a1;
  font-size: 8px;
  font-weight: 900;
}

.layout-region-detail dd {
  overflow: hidden;
  margin: 0;
  color: #495d73;
  font-size: 9px;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.layout-marker-code {
  display: block;
  overflow-wrap: anywhere;
  margin-top: 10px;
  padding: 8px 10px;
  border-radius: 7px;
  background: #f5f2ff;
  color: #6d28d9;
  font-size: 9px;
}

.layout-region-text {
  display: -webkit-box;
  overflow: hidden;
  margin: 8px 0 0;
  color: #66768a;
  font-size: 9px;
  line-height: 1.55;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

@media (max-width: 900px) {
  .layout-summary-grid,
  .layout-region-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .layout-storage-flow {
    grid-template-columns: 1fr;
  }
  .layout-inspector-toolbar {
    align-items: flex-start;
    flex-direction: column;
  }
}
@media (max-width: 620px) {
  .layout-analysis-head {
    flex-direction: column;
  }
  .layout-head-actions {
    width: 100%;
    align-items: stretch;
    flex-direction: column;
  }
  .layout-refresh-button {
    width: 100%;
  }
  .layout-summary-grid,
  .layout-region-grid {
    grid-template-columns: 1fr;
  }
  .layout-region-grid article {
    grid-template-columns: 74px minmax(0, 1fr);
  }
  .layout-page-map {
    width: 64px;
  }
  .layout-inspector-bar,
  .layout-region-detail {
    align-items: stretch;
    grid-template-columns: 1fr;
  }
  .layout-inspector-bar {
    flex-direction: column;
  }
  .layout-detail-toggle {
    width: 100%;
    justify-content: center;
  }
  .layout-region-detail dl {
    grid-template-columns: 1fr;
  }
}
.register-page {
  --register-radius-sm: 6px;
  --register-radius-md: 9px;
  --register-radius-lg: 12px;
}

.register-workbench,
.hero-assurance,
.flow-progress,
.flow-guide,
.source-panel,
.library-check,
.recognition-banner,
.metadata-stats,
.layout-analysis-panel,
.metadata-review-workspace,
.manual-form,
.preview-panel,
.final-check-panel,
.multilingual-launch-panel,
.ocr-quality-bridge {
  border-radius: var(--register-radius-lg) !important;
}

.register-step,
.file-box,
.url-entry,
.analysis-progress-panel,
.analysis-status,
.field input,
.field select,
.field textarea,
.secondary-btn,
.primary-btn,
.dark-btn,
.status-pill,
.metadata-file-select,
.layout-detail-toggle {
  border-radius: var(--register-radius-sm) !important;
}

.status-pill.is-pending {
  border-color: #d5c28e;
  background: #fff9e9;
  color: #7d6425;
}

.registration-substeps {
  position: relative;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  padding: 6px;
  border: 1px solid #dbe4e1;
  border-radius: var(--register-radius-md);
  background: #f2f6f5;
}
.registration-substeps > button {
  min-width: 0;
  min-height: 72px;
  display: grid;
  grid-template-columns: 34px minmax(0, 1fr) auto;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border: 1px solid transparent;
  border-radius: var(--register-radius-sm);
  background: transparent;
  color: #63736f;
  text-align: left;
  transition: border-color 180ms ease, background 180ms ease, color 180ms ease, transform 180ms ease;
}
.registration-substeps > button > span:first-child {
  width: 30px;
  height: 30px;
  display: grid;
  place-items: center;
  border: 1px solid #cad6d3;
  border-radius: 50%;
  background: #fff;
  font-size: 10px;
  font-weight: 900;
}
.registration-substeps > button > span:nth-child(2) {
  min-width: 0;
}
.registration-substeps > button strong {
  display: block;
  overflow: hidden;
  font-size: 11px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.registration-substeps > button small {
  display: block;
  margin-top: 3px;
  overflow: hidden;
  color: #899793;
  font-size: 8px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.registration-substeps > button em {
  color: #98a5a1;
  font-size: 8px;
  font-style: normal;
  font-weight: 800;
}
.registration-substeps > button:hover {
  border-color: #b8ccc7;
  background: rgba(255, 255, 255, 0.72);
}
.registration-substeps > button.is-active {
  border-color: #245c51;
  background: #fff;
  color: #173f37;
  box-shadow: 0 5px 14px rgba(29, 72, 63, 0.08);
  transform: translateY(-1px);
}
.registration-substeps > button.is-active > span:first-child {
  border-color: #245c51;
  background: #245c51;
  color: #fff;
}
.registration-substeps > button.is-active em {
  color: #a6632f;
}
.registration-substeps > button.is-complete > span:first-child {
  border-color: #8eb9ad;
  background: #eaf5f1;
  color: #236052;
}
.registration-substeps > button.is-processing {
  border-color: #d7aa67;
  background: #fff9ed;
  color: #815a21;
}
.registration-substeps > button.is-processing > span:first-child {
  border-color: #d7aa67;
  background: #fff1d4;
  color: #8b5b19;
  animation: pulse 1.2s ease-in-out infinite;
}
.registration-substeps > button.is-failed {
  border-color: #dfb4aa;
  background: #fff6f3;
  color: #984b3b;
}

.metadata-stage-panel,
.review-stage-panel {
  padding: 20px;
  border: 1px solid #d9e3e0;
  border-radius: var(--register-radius-lg);
  background: #fff;
  box-shadow: 0 10px 28px rgba(26, 61, 54, 0.045);
}

.stage-panel-enter {
  animation: register-stage-in 260ms cubic-bezier(0.22, 0.75, 0.25, 1) backwards;
}

@keyframes register-stage-in {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.stage-panel-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e4ebe9;
}
.stage-panel-head h3 {
  margin: 3px 0 5px;
  color: #173b34;
  font-size: 17px;
}
.stage-panel-head p {
  margin: 0;
  max-width: 680px;
  color: #6d7d79;
  font-size: 10px;
  line-height: 1.65;
}
.stage-panel-head > strong {
  flex: 0 0 auto;
  padding: 7px 10px;
  border: 1px solid #c9d8d4;
  border-radius: var(--register-radius-sm);
  background: #f5f9f8;
  color: #356257;
  font-size: 10px;
}

.visibility-file-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  margin-top: 16px;
}
.visibility-file-grid > article {
  min-width: 0;
  padding: 13px;
  border: 1px solid #dce5e3;
  border-radius: var(--register-radius-md);
  background: #fbfcfc;
  transition: border-color 180ms ease, box-shadow 180ms ease, transform 180ms ease;
}
.visibility-file-grid > article.is-active {
  border-color: #88aea5;
}
.visibility-file-grid > article.is-selected {
  border-color: #79a69b;
  background: #f2f8f6;
}
.visibility-file-grid > article > p {
  margin: 9px 0 0;
  color: #9a672a;
  font-size: 9px;
}
.visibility-file-grid > article > p.is-complete {
  color: #2c6658;
}

.visibility-file-main {
  width: 100%;
  display: grid;
  grid-template-columns: 28px minmax(0, 1fr);
  align-items: center;
  gap: 9px;
  padding: 0 0 11px;
  border: 0;
  background: transparent;
  color: #2f4842;
  text-align: left;
}
.visibility-file-main > span {
  width: 27px;
  height: 27px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  background: #eaf2f0;
  font-size: 9px;
  font-weight: 900;
}
.visibility-file-main div {
  min-width: 0;
}
.visibility-file-main strong {
  display: block;
  overflow: hidden;
  font-size: 11px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.visibility-file-main small {
  display: block;
  margin-top: 3px;
  color: #83918d;
  font-size: 8px;
}

.visibility-choice {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 7px;
}
.visibility-choice button {
  display: grid;
  gap: 2px;
  padding: 9px 10px;
  border: 1px solid #d8e1df;
  border-radius: var(--register-radius-sm);
  background: #fff;
  color: #5b6d68;
  text-align: left;
  transition: border-color 160ms ease, background 160ms ease;
}
.visibility-choice button strong {
  font-size: 10px;
}
.visibility-choice button small {
  color: #8b9995;
  font-size: 8px;
}
.visibility-choice button.is-active {
  border-color: #2b6659;
  background: #edf7f3;
  color: #20574b;
}

.registration-safety-warning {
  display: grid;
  gap: 6px;
  margin-top: 10px;
  padding: 10px 11px;
  border: 1px solid #e7cfaa;
  border-radius: 10px;
  background: #fff9ef;
  color: #72501f;
}
.registration-safety-warning strong {
  font-size: 10px;
  font-weight: 950;
}
.registration-safety-warning p {
  margin: 0;
  color: #876b43;
  font-size: 9px;
  line-height: 1.55;
}
.registration-safety-warning a {
  width: fit-content;
  color: #275f86;
  font-size: 9px;
  font-weight: 900;
  text-decoration: underline;
}

.registration-safety-warning.is-security label {
  display: flex;
  gap: 7px;
  align-items: flex-start;
  color: #63471f;
  font-size: 9px;
  font-weight: 850;
  line-height: 1.45;
  cursor: pointer;
}
.registration-safety-warning.is-security input[type=checkbox] {
  width: 14px;
  height: 14px;
  flex: 0 0 14px;
  margin-top: 1px;
  accent-color: #2b6659;
}

.registration-safety-warning.is-duplicate {
  border-color: #e4c4b6;
  background: #fff6f2;
  color: #873f28;
}

.duplicate-admin-controls {
  display: grid;
  gap: 9px;
  padding-top: 3px;
}

.duplicate-admin-controls .duplicate-version-toggle {
  color: #6f321f;
  font-size: 10px;
  font-weight: 900;
  line-height: 1.45;
}

.registration-safety-warning.is-security {
  border-color: #e7d5a9;
  background: #fffbef;
}

.review-stage-layout,
.metadata-layout {
  display: grid;
  gap: 14px;
}

.review-file-switcher {
  display: flex;
  align-items: center;
  gap: 7px;
  min-width: 0;
  padding: 8px 10px;
  overflow-x: auto;
  border: 1px solid #dfe7e5;
  border-radius: var(--register-radius-md);
  background: #f8faf9;
}
.review-file-switcher > span {
  flex: 0 0 auto;
  margin-right: 3px;
  color: #778681;
  font-size: 9px;
  font-weight: 800;
}
.review-file-switcher button {
  flex: 0 0 auto;
  min-width: 150px;
  padding: 7px 9px;
  border: 1px solid #dbe4e2;
  border-radius: var(--register-radius-sm);
  background: #fff;
  color: #5c6f69;
  text-align: left;
  transition: border-color 160ms ease, background 160ms ease;
}
.review-file-switcher button strong {
  display: block;
  max-width: 190px;
  overflow: hidden;
  font-size: 9px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.review-file-switcher button small {
  display: block;
  margin-top: 2px;
  color: #8a9894;
  font-size: 8px;
}
.review-file-switcher button.is-active {
  border-color: #2b6559;
  background: #edf6f3;
  color: #245a4e;
}

.review-status-badge {
  flex: 0 0 auto;
  padding: 7px 10px;
  border: 1px solid #d3deda;
  border-radius: var(--register-radius-sm);
  background: #f8faf9;
  color: #61716d;
  font-size: 9px;
  font-weight: 800;
}
.review-status-badge.is-complete {
  border-color: #9fc5b9;
  background: #edf7f3;
  color: #236052;
}
.review-status-badge.is-partial, .review-status-badge.is-failed {
  border-color: #dfbd7b;
  background: #fff8e9;
  color: #805b1e;
}

.review-overview-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px;
  margin-top: 16px;
}
.review-overview-grid article {
  min-width: 0;
  padding: 12px;
  border: 1px solid #e0e7e5;
  border-radius: var(--register-radius-sm);
  background: #f9fbfa;
}
.review-overview-grid span,
.review-overview-grid small {
  display: block;
  color: #84918d;
  font-size: 8px;
}
.review-overview-grid strong {
  display: block;
  margin-top: 4px;
  overflow: hidden;
  color: #2f5048;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.review-overview-grid small {
  margin-top: 3px;
}

.review-stage-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 14px;
}

.pipeline-progress-card {
  display: grid;
  gap: 9px;
  margin-top: 14px;
  padding: 14px;
  border: 1px solid #bcd6cf;
  border-radius: var(--register-radius-md);
  background: #f1f8f5;
}

.pipeline-progress-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.pipeline-progress-head > div {
  min-width: 0;
}
.pipeline-progress-head span {
  display: block;
  color: #73857f;
  font-size: 8px;
  font-weight: 900;
  letter-spacing: 0.06em;
}
.pipeline-progress-head strong {
  display: block;
  margin-top: 3px;
  overflow: hidden;
  color: #234f45;
  font-size: 11px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.pipeline-progress-head em {
  color: #28675a;
  font-size: 17px;
  font-style: normal;
  font-weight: 950;
}

.pipeline-progress-track {
  height: 7px;
  overflow: hidden;
  border-radius: 999px;
  background: #dbe9e5;
}
.pipeline-progress-track span {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, #c77d43, #2f6b5e);
  transition: width 220ms ease;
}

.pipeline-progress-detail {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.pipeline-progress-detail span {
  flex: 0 0 auto;
  color: #315d53;
  font-size: 9px;
  font-weight: 900;
}
.pipeline-progress-detail p {
  margin: 0;
  color: #6d7e79;
  font-size: 9px;
  font-weight: 750;
  text-align: right;
}

.ocr-review-callout {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  margin-top: 14px;
  padding: 15px;
  border: 1px solid #c9ddd7;
  border-radius: var(--register-radius-md);
  background: #f3f8f6;
}
.ocr-review-callout strong {
  color: #29584d;
  font-size: 11px;
}
.ocr-review-callout p {
  margin: 4px 0 0;
  color: #71807c;
  font-size: 9px;
  line-height: 1.55;
}

.entity-card-list {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  margin-top: 16px;
}
.entity-card-list > article {
  min-width: 0;
  padding: 13px;
  border: 1px solid #dfe6e4;
  border-radius: var(--register-radius-md);
  background: #fbfcfc;
}
.entity-card-list > article.needs-review {
  border-color: #ddbd80;
  background: #fffaf1;
}
.entity-card-list > article > header {
  display: flex;
  align-items: center;
  gap: 7px;
  margin-bottom: 11px;
}
.entity-card-list > article > header span {
  padding: 4px 7px;
  border-radius: 4px;
  background: #eaf2f0;
  color: #326157;
  font-size: 8px;
  font-weight: 900;
}
.entity-card-list > article > header em {
  color: #5f726c;
  font-size: 9px;
  font-style: normal;
  font-weight: 800;
}
.entity-card-list > article > header strong {
  color: #986620;
  font-size: 8px;
}
.entity-card-list > article > header button {
  margin-left: auto;
  border: 0;
  background: transparent;
  color: #9a6f6f;
  font-size: 16px;
}

.entity-card-fields {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 9px;
}
.entity-card-fields label {
  min-width: 0;
}
.entity-card-fields span {
  display: block;
  margin-bottom: 4px;
  color: #788783;
  font-size: 8px;
  font-weight: 800;
}
.entity-card-fields input,
.entity-card-fields select {
  width: 100%;
  min-width: 0;
  padding: 8px 9px;
  border: 1px solid #d5dfdc;
  border-radius: var(--register-radius-sm);
  background: #fff;
  color: #314943;
  font-size: 10px;
}

.entity-empty-state {
  margin-top: 16px;
  padding: 34px;
  border: 1px dashed #cfdad7;
  background: #f9fbfa;
  color: #687a75;
  text-align: center;
}
.entity-empty-state strong {
  font-size: 11px;
}
.entity-empty-state p {
  margin: 5px 0 0;
  font-size: 9px;
}

.translation-workspace-backdrop,
.ocr-workspace-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1600;
  display: grid;
  place-items: center;
  width: 100vw;
  height: 100vh;
  height: 100dvh;
  box-sizing: border-box;
  padding: 24px;
  overflow: auto;
  overscroll-behavior: contain;
  background: rgba(12, 26, 23, 0.66);
  backdrop-filter: blur(4px);
  animation: workspace-backdrop-in 180ms ease both;
  isolation: isolate;
}

@keyframes workspace-backdrop-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.translation-workspace,
.ocr-page-workspace {
  position: relative;
  z-index: 1;
  width: calc(100vw - 48px);
  max-width: 1360px;
  height: calc(100vh - 48px);
  height: calc(100dvh - 48px);
  max-height: 850px;
  min-width: 0;
  box-sizing: border-box;
  display: grid;
  grid-template-rows: auto minmax(0, 1fr);
  overflow: hidden;
  border: 1px solid #bdccc8;
  border-radius: var(--register-radius-lg);
  background: #fff;
  box-shadow: 0 28px 90px rgba(5, 20, 16, 0.34);
  animation: workspace-panel-in 240ms cubic-bezier(0.22, 0.78, 0.25, 1) both;
}
.translation-workspace > header,
.ocr-page-workspace > header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
  padding: 18px 20px;
  border-bottom: 1px solid #dfe7e5;
  background: #f7faf9;
}
.translation-workspace > header h3,
.ocr-page-workspace > header h3 {
  margin: 2px 0 4px;
  color: #173d35;
  font-size: 18px;
}
.translation-workspace > header p,
.ocr-page-workspace > header p {
  margin: 0;
  color: #71817c;
  font-size: 9px;
}

@keyframes workspace-panel-in {
  from {
    opacity: 0;
    transform: translateY(12px) scale(0.985);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
.workspace-head-meta {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 10px;
}
.workspace-head-meta span {
  padding: 6px 9px;
  border: 1px solid #d5dfdc;
  border-radius: 5px;
  background: #fff;
  color: #5c716a;
  font-size: 9px;
  font-weight: 800;
}
.workspace-head-meta button {
  width: 34px;
  height: 34px;
  border: 1px solid #d0dbd8;
  border-radius: 6px;
  background: #fff;
  color: #526862;
  font-size: 19px;
}

.translation-workspace {
  width: calc(100vw - 80px);
  max-width: 1320px;
  height: 90vh;
  height: 90dvh;
  max-height: 820px;
  display: flex;
  flex-direction: column;
}

.translation-workspace-backdrop {
  padding: 5vh 40px;
  overflow: hidden;
}

.register-page.has-workspace-dialog .workbench-body > div {
  animation: none !important;
  transform: none !important;
}

.translation-workspace-body {
  flex: 1 1 auto;
  min-height: 0;
  display: grid;
  grid-template-columns: 150px minmax(0, 1fr);
  overflow: hidden;
  transition: grid-template-columns 160ms ease;
}
.translation-workspace-body > aside {
  min-height: 0;
  overflow-y: auto;
  padding: 11px;
  border-right: 1px solid #e0e7e5;
  background: #f5f8f7;
}
.translation-workspace-body > aside > button {
  width: 100%;
  display: grid;
  grid-template-columns: 28px minmax(0, 1fr);
  align-items: center;
  gap: 8px;
  margin-bottom: 5px;
  padding: 8px;
  border: 1px solid transparent;
  border-radius: 6px;
  background: transparent;
  color: #62736e;
  text-align: left;
}
.translation-workspace-body > aside > button > span {
  width: 26px;
  height: 26px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  background: #e7eeec;
  font-size: 9px;
  font-weight: 900;
}
.translation-workspace-body > aside > button strong {
  display: block;
  font-size: 9px;
}
.translation-workspace-body > aside > button small {
  display: block;
  margin-top: 2px;
  color: #8a9894;
  font-size: 8px;
}
.translation-workspace-body > aside > button.is-active {
  border-color: #2a6659;
  background: #fff;
  color: #235b4f;
}
.translation-workspace-body > aside > button.is-active > span {
  background: #2a6659;
  color: #fff;
}
.translation-workspace-body > aside > button.is-not-required small {
  color: #56716a;
}
.translation-workspace-body > aside > button.is-review-required small {
  color: #9a641b;
}
.translation-workspace-body > main {
  width: 100%;
  min-width: 0;
  min-height: 0;
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  grid-template-rows: auto auto auto minmax(0, 1fr);
  overflow: hidden;
  padding: 12px 14px;
}
.translation-workspace-body > main.has-terms {
  grid-template-rows: auto auto auto minmax(0, 1fr) 42px;
}
.translation-workspace-body > main > * {
  min-width: 0;
  max-width: 100%;
}

.translation-workspace-body.is-rail-collapsed {
  grid-template-columns: 58px minmax(0, 1fr);
}
.translation-workspace-body.is-rail-collapsed > aside {
  padding: 8px 6px;
}
.translation-workspace-body.is-rail-collapsed .workspace-rail-title {
  display: none;
}
.translation-workspace-body.is-rail-collapsed > aside > button {
  display: grid;
  grid-template-columns: 1fr;
  justify-items: center;
  padding: 7px 4px;
}
.translation-workspace-body.is-rail-collapsed > aside > button > div,
.translation-workspace-body.is-rail-collapsed > aside > button > strong {
  display: none;
}

.workspace-rail-title {
  display: flex;
  justify-content: space-between;
  padding: 3px 3px 10px;
  color: #63736f;
  font-size: 9px;
}

.translation-workspace-body > aside > .workspace-rail-toggle {
  display: flex;
  grid-template-columns: none;
  justify-content: center;
  gap: 5px;
  margin-bottom: 9px;
  border-color: #d9e2df;
  background: #fff;
}
.translation-workspace-body > aside > .workspace-rail-toggle > span {
  width: auto;
  height: auto;
  background: transparent;
  color: #48665f;
  font-size: 14px;
}

.workspace-page-head {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-bottom: 9px;
}
.workspace-page-head span {
  color: #8a9793;
  font-size: 8px;
  font-weight: 900;
  text-transform: uppercase;
}
.workspace-page-head h4 {
  margin: 2px 0 0;
  color: #294d45;
  font-size: 15px;
}
.workspace-page-head em {
  color: #788783;
  font-size: 9px;
  font-style: normal;
}

.translation-page-meta {
  display: flex;
  align-items: center;
  gap: 8px;
}
.translation-page-meta strong {
  padding: 4px 7px;
  border-radius: 999px;
  background: #e9f4f0;
  color: #286153;
  font-size: 8px;
}
.translation-page-meta strong.is-not-required {
  background: #edf2f1;
  color: #5d716b;
}
.translation-page-meta strong.is-review-required {
  background: #fff2dd;
  color: #93601d;
}

.translation-workspace-guide {
  display: flex;
  gap: 7px;
  align-items: baseline;
  margin-bottom: 8px;
  padding: 7px 9px;
  border: 1px solid #cfe0db;
  border-radius: 7px;
  background: #f0f7f4;
}
.translation-workspace-guide strong {
  flex: 0 0 auto;
  color: #2e6256;
  font-size: 8px;
  font-weight: 950;
}
.translation-workspace-guide span {
  color: #697c76;
  font-size: 8px;
  line-height: 1.45;
}

.translation-compare-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-template-rows: minmax(0, 1fr);
  gap: 0;
  width: 100%;
  max-width: 100%;
  min-height: 0;
  box-sizing: border-box;
  overflow: hidden;
}
.translation-compare-grid > article,
.translation-compare-grid > section {
  width: auto;
  max-width: 100%;
  min-width: 0;
  min-height: 0;
  box-sizing: border-box;
  display: grid;
  grid-template-rows: auto minmax(0, 1fr);
  overflow: hidden;
  border: 1px solid #dfe6e4;
  background: #fbfcfc;
}
.translation-compare-grid > article {
  grid-column: 1;
  border-right: 0;
}
.translation-compare-grid > section {
  grid-column: 2;
}
.translation-compare-grid header {
  display: flex;
  justify-content: space-between;
  padding: 10px 12px;
  border-bottom: 1px solid #e3e9e7;
  background: #f5f8f7;
}
.translation-compare-grid header strong {
  color: #3d5a53;
  font-size: 10px;
}
.translation-compare-grid header span {
  color: #899691;
  font-size: 8px;
}
.translation-compare-grid textarea {
  width: 100%;
  height: 100%;
  min-height: 0;
  resize: none;
  border: 0;
  outline: 0;
  padding: 14px;
  background: #fff;
  color: #334b45;
  font: inherit;
  font-size: 11px;
  line-height: 1.8;
}

.translation-pdf-panel,
.translation-result-panel {
  min-height: 0;
}

.translation-pdf-canvas {
  min-height: 0;
  display: grid;
  place-items: center;
  overflow: hidden;
  padding: 10px;
  background: #e8eeec;
}
.translation-pdf-canvas img {
  display: block;
  width: 100%;
  height: 100%;
  min-width: 0;
  min-height: 0;
  object-fit: contain;
  background: #fff;
  box-shadow: 0 7px 22px rgba(24, 45, 39, 0.13);
}
.translation-pdf-canvas.is-text-source {
  place-items: stretch;
  padding: 0;
  background: #fff;
}

.translation-text-source {
  width: 100%;
  height: 100%;
  min-width: 0;
  min-height: 0;
  box-sizing: border-box;
  margin: 0;
  padding: 14px;
  overflow: auto;
  overscroll-behavior: contain;
  scrollbar-gutter: stable;
  background: #fff;
  color: #334b45;
  font-family: inherit;
  font-size: 11px;
  line-height: 1.8;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.translation-pdf-empty {
  width: min(340px, 100%);
  padding: 28px 20px;
  border: 1px dashed #bdcac7;
  background: rgba(255, 255, 255, 0.76);
  color: #64756f;
  text-align: center;
}
.translation-pdf-empty strong {
  display: block;
  color: #35564e;
  font-size: 11px;
}
.translation-pdf-empty p {
  margin: 6px 0 0;
  font-size: 9px;
  line-height: 1.6;
}
.translation-pdf-empty button {
  margin-top: 12px;
  padding: 7px 10px;
  border: 1px solid #b9cec8;
  border-radius: 5px;
  background: #fff;
  color: #2d6257;
  font-size: 9px;
  font-weight: 800;
}

.translation-result-panel {
  display: flex !important;
  flex-direction: column;
  background: #fff !important;
}
.translation-result-panel > header {
  flex: 0 0 auto;
}
.translation-result-panel > textarea {
  width: 100%;
  min-width: 0;
  flex: 1 1 auto;
  box-sizing: border-box;
  overflow: auto;
  overscroll-behavior: contain;
  scrollbar-gutter: stable;
}

.translation-page-note {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 7px 12px;
  border-bottom: 1px solid #e1e8e6;
  background: #f1f6f4;
  color: #64756f;
  font-size: 8px;
}
.translation-page-note strong {
  color: #365c53;
}
.translation-page-note.is-warning {
  border-color: #edd6a8;
  background: #fff8e9;
  color: #826b45;
}
.translation-page-note.is-warning strong {
  color: #8c5c17;
}

.translation-term-dock {
  width: 100%;
  max-width: 100%;
  min-height: 42px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 8px;
  padding: 9px 10px;
  border: 1px solid #e0e7e5;
  background: #f8faf9;
}
.translation-term-dock > strong {
  flex: 0 0 auto;
  color: #466159;
  font-size: 9px;
}
.translation-term-dock > div {
  display: flex;
  flex: 1 1 auto;
  gap: 6px;
  width: 0;
  min-width: 0;
  overflow-x: auto;
}
.translation-term-dock span {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 4px 7px;
  border-radius: 4px;
  background: #eaf2f0;
  color: #4e675f;
  font-size: 8px;
}
.translation-term-dock span b {
  color: inherit;
  font: inherit;
}
.translation-term-dock span em,
.translation-term-dock span small {
  font-size: 7px;
  font-style: normal;
}
.translation-term-dock span em {
  color: #8a601d;
  font-weight: 850;
}
.translation-term-dock span small {
  color: #718078;
}
.translation-term-dock span.needs-review {
  border: 1px solid #e4c37d;
  background: #fff7e7;
  color: #76531a;
}

.ocr-page-workspace {
  width: calc(100vw - 64px);
  max-width: 1360px;
  height: 90vh;
  height: 90dvh;
  max-height: 1040px;
  display: flex;
  flex-direction: column;
}

.ocr-workspace-backdrop {
  padding: 5vh 32px;
  overflow: hidden;
}

.ocr-workspace-toolbar {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  padding: 8px 14px;
  border-bottom: 1px solid #e1e8e6;
  background: #fff;
}
.ocr-workspace-toolbar > div {
  display: flex;
  align-items: center;
  gap: 7px;
}
.ocr-workspace-toolbar button:not(.primary-btn) {
  padding: 6px 9px;
  border: 1px solid #d6dfdd;
  border-radius: 5px;
  background: #fff;
  color: #5c706a;
  font-size: 9px;
  font-weight: 800;
}
.ocr-workspace-toolbar strong {
  color: #34574f;
  font-size: 10px;
}
.ocr-workspace-toolbar span {
  color: #71817c;
  font-size: 9px;
}
.ocr-workspace-toolbar span.is-saved {
  color: #256252;
  font-weight: 800;
}

.ocr-page-pagination {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 48px;
  padding: 8px 14px calc(8px + env(safe-area-inset-bottom));
  border-top: 1px solid #dce5e2;
  background: #fff;
}
.ocr-page-pagination button {
  padding: 6px 10px;
  border: 1px solid #d6dfdd;
  border-radius: 5px;
  background: #fff;
  color: #4f6861;
  font-size: 9px;
  font-weight: 800;
}
.ocr-page-pagination button:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}
.ocr-page-pagination strong {
  min-width: 72px;
  color: #34574f;
  font-size: 10px;
  text-align: center;
}

.ocr-page-error {
  padding: 8px 14px;
  border-bottom: 1px solid #eccfa6;
  background: #fff7e8;
  color: #895e22;
  font-size: 9px;
}

.ocr-page-compare {
  flex: 1 1 auto;
  min-height: 0;
  display: grid;
  grid-template-columns: minmax(380px, 0.95fr) minmax(480px, 1.05fr);
  gap: 0;
  overflow: hidden;
}

.ocr-source-page,
.ocr-page-editor {
  min-width: 0;
  min-height: 0;
  display: grid;
  grid-template-rows: auto minmax(0, 1fr);
}
.ocr-source-page > header,
.ocr-page-editor > header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 9px 12px;
  border-bottom: 1px solid #e1e8e6;
  background: #f6f9f8;
}
.ocr-source-page > header strong,
.ocr-page-editor > header strong {
  color: #3a574f;
  font-size: 10px;
}
.ocr-source-page > header span,
.ocr-page-editor > header span {
  color: #84918d;
  font-size: 8px;
}

.ocr-source-page {
  border-right: 1px solid #dce5e2;
  background: #e9eeec;
  overflow: hidden;
}

.ocr-source-canvas {
  min-height: 0;
  display: grid;
  place-items: center;
  overflow: auto;
  padding: 12px;
}

.ocr-source-canvas img {
  display: block;
  width: 100%;
  height: 100%;
  min-width: 0;
  min-height: 0;
  object-fit: contain;
  background: #fff;
  box-shadow: 0 7px 22px rgba(24, 45, 39, 0.13);
}

.ocr-source-empty {
  width: min(320px, 100%);
  padding: 28px 20px;
  border: 1px dashed #bdcac7;
  background: rgba(255, 255, 255, 0.72);
  color: #64756f;
  text-align: center;
}
.ocr-source-empty strong {
  display: block;
  color: #35564e;
  font-size: 11px;
}
.ocr-source-empty p {
  margin: 6px 0 0;
  font-size: 9px;
  line-height: 1.6;
}

.ocr-page-editor {
  display: flex;
  flex-direction: column;
  background: #fff;
  overflow: hidden;
}
.ocr-page-editor > textarea {
  flex: 1 1 auto;
  width: 100%;
  height: 100%;
  min-height: 0;
  box-sizing: border-box;
  overflow: auto;
  resize: none;
  border: 0;
  outline: 0;
  padding: 14px;
  color: #2f4741;
  font: inherit;
  font-size: 11px;
  line-height: 1.75;
}

.ocr-mobile-panes {
  display: none;
}

.ocr-mini-tabs {
  display: flex;
  gap: 4px;
}

.ocr-mini-tabs button {
  padding: 4px 7px;
  border: 1px solid #d5dfdc;
  border-radius: 4px;
  background: #fff;
  color: #73827e;
  font-size: 8px;
  font-weight: 800;
}

.ocr-mini-tabs button.is-active {
  border-color: #2a6659;
  background: #2a6659;
  color: #fff;
}

.ocr-page-score-strip {
  display: flex;
  gap: 5px;
  min-height: 38px;
  padding: 7px 10px;
  overflow-x: auto;
  border-bottom: 1px solid #e3e9e7;
  background: #fafcfc;
}
.ocr-page-score-strip button {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 5px 7px;
  border: 1px solid #dbe3e1;
  border-radius: 4px;
  background: #fff;
  color: #61736d;
}
.ocr-page-score-strip strong {
  max-width: 100px;
  overflow: hidden;
  font-size: 8px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ocr-page-score-strip em {
  font-size: 8px;
  font-style: normal;
}
.ocr-page-score-strip button.is-low {
  border-color: #dfbf80;
  background: #fff8ea;
  color: #865e20;
}
.ocr-page-score-strip button.is-active {
  border-color: #2a6659;
  background: #eaf5f1;
  color: #225b4f;
}

.layout-preview-state button {
  padding: 7px 10px;
  border: 1px solid #b9cec8;
  border-radius: 5px;
  background: #fff;
  color: #2d6257;
  font-size: 9px;
  font-weight: 800;
}

@media (max-width: 980px) {
  .registration-substeps {
    grid-template-columns: 1fr;
  }
  .registration-substeps > button {
    min-height: 60px;
  }
  .visibility-file-grid,
  .entity-card-list {
    grid-template-columns: 1fr;
  }
  .review-overview-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .translation-workspace-body,
  .translation-workspace-body.is-rail-collapsed {
    grid-template-columns: 112px minmax(0, 1fr);
  }
  .translation-workspace-body.is-rail-collapsed > aside > button {
    grid-template-columns: 28px minmax(0, 1fr);
    justify-items: stretch;
  }
  .translation-workspace-body.is-rail-collapsed > aside > button > div,
  .translation-workspace-body.is-rail-collapsed > aside > button > strong {
    display: block;
  }
  .translation-workspace-body.is-rail-collapsed .workspace-rail-title {
    display: flex;
  }
  .translation-workspace-body > aside > .workspace-rail-toggle {
    display: none;
  }
  .ocr-workspace-backdrop {
    padding: 0;
  }
  .ocr-page-workspace {
    width: 100vw;
    height: 100vh;
    height: 100dvh;
    max-height: none;
    border: 0;
    border-radius: 0;
  }
  .ocr-mobile-panes {
    flex: 0 0 auto;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 6px;
    padding: 7px 10px;
    border-bottom: 1px solid #dce5e2;
    background: #f4f8f7;
  }
  .ocr-mobile-panes button {
    padding: 7px 10px;
    border: 1px solid #cbd8d5;
    border-radius: 5px;
    background: #fff;
    color: #60736d;
    font-size: 9px;
    font-weight: 800;
  }
  .ocr-mobile-panes button.is-active {
    border-color: #2a6659;
    background: #2a6659;
    color: #fff;
  }
  .ocr-page-compare {
    display: block;
    overflow: hidden;
  }
  .ocr-source-page,
  .ocr-page-editor {
    display: none;
    width: 100%;
    height: 100%;
    min-height: 0;
    border: 0;
  }
  .ocr-source-page.is-mobile-active {
    display: grid;
  }
  .ocr-page-editor.is-mobile-active {
    display: flex;
  }
}
@media (max-width: 640px) {
  .visibility-file-grid,
  .review-overview-grid,
  .entity-card-fields {
    grid-template-columns: 1fr;
  }
  .stage-panel-head,
  .ocr-review-callout,
  .ocr-workspace-toolbar {
    align-items: flex-start;
    flex-direction: column;
  }
  .translation-workspace-backdrop {
    padding: 6px;
  }
  .translation-workspace {
    width: calc(100vw - 12px);
    height: calc(100vh - 12px);
    height: calc(100dvh - 12px);
    max-height: none;
    border-radius: 7px;
  }
  .translation-workspace-body,
  .translation-workspace-body.is-rail-collapsed {
    grid-template-columns: 1fr;
  }
  .translation-workspace-body {
    grid-template-rows: auto minmax(0, 1fr);
  }
  .translation-workspace-body > aside {
    display: flex;
    gap: 5px;
    min-height: 74px;
    overflow-x: auto;
    overflow-y: hidden;
    border-right: 0;
    border-bottom: 1px solid #e0e7e5;
  }
  .translation-workspace-body > aside > button {
    width: auto;
    min-width: 105px;
  }
  .workspace-rail-title {
    display: none;
  }
  .translation-workspace-body > main {
    padding: 12px;
  }
  .translation-compare-grid {
    grid-template-columns: minmax(0, 1fr);
    grid-template-rows: repeat(2, minmax(260px, 1fr));
    overflow-y: auto;
  }
  .translation-compare-grid > article,
  .translation-compare-grid > section {
    grid-column: 1;
    min-height: 0;
  }
  .translation-workspace > header,
  .ocr-page-workspace > header {
    padding: 13px 14px;
  }
  .translation-workspace > header p,
  .ocr-page-workspace > header p {
    display: none;
  }
  .pipeline-progress-detail {
    align-items: flex-start;
    flex-direction: column;
    gap: 4px;
  }
  .pipeline-progress-detail p {
    text-align: left;
  }
}
@media (prefers-reduced-motion: reduce) {
  .stage-panel-enter,
  .translation-workspace,
  .ocr-page-workspace,
  .translation-workspace-backdrop,
  .ocr-workspace-backdrop {
    animation: none !important;
  }
  .registration-substeps > button,
  .visibility-file-grid > article {
    transition: none !important;
  }
  .registration-substeps > button.is-processing > span:first-child {
    animation: none !important;
  }
}
.register-step.is-active:hover,
.register-step.is-active:focus-visible {
  border-color: var(--register-ink);
  background: linear-gradient(135deg, #2f625a, var(--register-ink));
  color: #ffffff;
  box-shadow: 0 12px 28px rgba(23, 59, 54, 0.2);
}

.register-step.is-active:hover .register-step-title,
.register-step.is-active:hover .register-step-desc,
.register-step.is-active:hover .register-step-state,
.register-step.is-active:focus-visible .register-step-title,
.register-step.is-active:focus-visible .register-step-desc,
.register-step.is-active:focus-visible .register-step-state {
  color: #ffffff;
}

.multilingual-panel,
.saved-multilingual-view {
  display: grid;
  gap: 16px;
  padding: 20px;
  border: 1px solid #d8dbea;
  border-radius: 14px;
  background: linear-gradient(145deg, #fbfbff 0%, #f7f9fc 100%);
}

.saved-multilingual-view {
  margin-top: 24px;
}

.multilingual-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
}

.multilingual-head h3 {
  margin: 5px 0 4px;
  color: #263346;
  font-size: 15px;
  font-weight: 950;
}

.multilingual-head p {
  margin: 0;
  color: #6f7b8c;
  font-size: 11px;
  line-height: 1.65;
}

.multilingual-status {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 6px;
  padding: 8px 10px;
  border: 1px solid #d8deec;
  border-radius: 999px;
  background: #ffffff;
  white-space: nowrap;
}

.multilingual-status span,
.multilingual-status strong,
.multilingual-status em {
  font-size: 10px;
  font-style: normal;
  font-weight: 900;
}

.multilingual-status span {
  color: #555f74;
}

.multilingual-status strong {
  color: #4f46a5;
}

.multilingual-status em {
  padding-left: 6px;
  border-left: 1px solid #e2e6ef;
  color: #7b8496;
}

.saved-translation-run {
  min-height: 30px;
  margin-left: 4px;
  padding: 0 12px;
  border: 0;
  border-radius: 999px;
  background: #275f55;
  color: #ffffff;
  font-size: 10px;
  font-weight: 900;
  cursor: pointer;
}

.saved-translation-run:disabled {
  cursor: wait;
  opacity: 0.55;
}

.saved-translation-empty {
  padding: 28px;
  border: 1px dashed #cbd9d5;
  border-radius: 12px;
  background: #f7faf9;
  text-align: center;
}

.saved-translation-empty strong {
  display: block;
  color: #284b45;
  font-size: 13px;
  font-weight: 950;
}

.saved-translation-empty p {
  margin: 7px 0 0;
  color: #71817d;
  font-size: 11px;
  line-height: 1.65;
}

.saved-translation-progress {
  margin: 0;
}

.multilingual-warning,
.multilingual-empty {
  padding: 12px 14px;
  border: 1px solid #eadfbd;
  border-radius: 10px;
  background: #fffbeb;
}

.multilingual-warning strong,
.multilingual-empty strong {
  display: block;
  margin-bottom: 3px;
  color: #68572c;
  font-size: 11px;
  font-weight: 900;
}

.multilingual-warning p,
.multilingual-empty p {
  margin: 0;
  color: #806d3e;
  font-size: 10px;
  line-height: 1.55;
}

.multilingual-empty {
  border-color: #e1e6ed;
  background: #ffffff;
}

.multilingual-empty strong,
.multilingual-empty p {
  color: #687588;
}

.multilingual-summary {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px;
}

.multilingual-summary > div {
  display: grid;
  gap: 4px;
  padding: 11px 12px;
  border: 1px solid #e0e4ed;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.86);
}

.multilingual-summary span {
  color: #808a9a;
  font-size: 9px;
  font-weight: 850;
}

.multilingual-summary strong {
  color: #313d51;
  font-size: 13px;
  font-weight: 950;
}

.normalized-term-list {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 9px;
}

.normalized-term-list article {
  min-width: 0;
  padding: 11px 12px;
  border: 1px solid #e0e4ec;
  border-radius: 10px;
  background: #ffffff;
}

.normalized-term-list article.is-hanja {
  border-color: #e4c59d;
  background: #fffdf8;
}

.normalized-term-list article.is-dictionary {
  border-color: #b9d0ec;
  background: #fafdff;
}

.term-flags {
  display: flex;
  gap: 5px;
  align-items: center;
}

.term-flags span,
.term-flags em {
  padding: 2px 6px;
  border-radius: 999px;
  background: #eef1f6;
  color: #596579;
  font-size: 8px;
  font-style: normal;
  font-weight: 950;
}

.is-hanja .term-flags span {
  background: #fef3c7;
  color: #92400e;
}

.term-flags em {
  background: #dbeafe;
  color: #1d4ed8;
}

.term-main {
  display: flex;
  align-items: center;
  gap: 7px;
  min-width: 0;
  margin-top: 8px;
}

.term-main strong,
.term-main b {
  overflow: hidden;
  color: #27364a;
  font-size: 12px;
  font-weight: 950;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.term-main span {
  color: #9aa4b3;
  font-size: 10px;
}

.term-main b {
  color: #4f46a5;
}

.normalized-term-list small {
  display: block;
  margin-top: 6px;
  color: #818b9a;
  font-size: 9px;
}

.normalized-term-list p {
  margin: 6px 0 0;
  color: #687588;
  font-size: 9px;
  line-height: 1.5;
}

.parallel-translation {
  overflow: hidden;
  border: 1px solid #dde2eb;
  border-radius: 12px;
  background: #ffffff;
}

.parallel-translation-head,
.parallel-translation article {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.parallel-translation-head {
  border-bottom: 1px solid #dfe4ec;
  background: #f3f5f9;
}

.parallel-translation-head span {
  padding: 10px 13px;
  color: #586579;
  font-size: 10px;
  font-weight: 950;
}

.parallel-translation-head span + span,
.parallel-cell + .parallel-cell {
  border-left: 1px solid #e1e5ed;
}

.parallel-translation article + article {
  border-top: 1px solid #e5e8ef;
}

.parallel-cell {
  display: block;
  min-width: 0;
  padding: 13px;
  background: #ffffff;
}

.parallel-cell.is-translation {
  background: #fcfcff;
}

.parallel-cell > span {
  display: block;
  margin-bottom: 7px;
  color: #9099a7;
  font-size: 8px;
  font-weight: 950;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.parallel-cell p {
  margin: 0;
  color: #3c485b;
  font-size: 11px;
  line-height: 1.75;
  white-space: pre-wrap;
}

.parallel-cell textarea {
  display: block;
  width: 100%;
  min-height: 110px;
  resize: vertical;
  border: 1px solid #dce1ea;
  border-radius: 8px;
  background: #ffffff;
  color: #303d51;
  font: inherit;
  font-size: 11px;
  line-height: 1.7;
}

.parallel-cell textarea:focus {
  border-color: #6366b5;
  outline: 2px solid rgba(99, 102, 181, 0.12);
}

.parallel-translation.is-readonly .parallel-cell {
  min-height: 100%;
}

.multilingual-limit-note {
  margin: -4px 0 0;
  color: #7a8494;
  font-size: 9px;
  line-height: 1.55;
  text-align: right;
}

@media (max-width: 960px) {
  .normalized-term-list {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 700px) {
  .multilingual-head {
    flex-direction: column;
  }
  .multilingual-status {
    white-space: normal;
  }
  .multilingual-summary,
  .normalized-term-list,
  .parallel-translation-head,
  .parallel-translation article {
    grid-template-columns: 1fr;
  }
  .parallel-translation-head span + span,
  .parallel-cell + .parallel-cell {
    border-left: 0;
    border-top: 1px solid #e1e5ed;
  }
}
.entity-detail-shell {
  display: grid;
  gap: 16px;
}

.entity-detail-header,
.entity-inspector-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
}

.entity-detail-header {
  padding: 24px;
  border: 1px solid #dce5e2;
  border-radius: 12px;
  background: linear-gradient(120deg, rgba(31, 92, 78, 0.08), transparent 52%), #ffffff;
}

.entity-detail-back-link {
  display: inline-flex;
  min-height: 34px;
  align-items: center;
  gap: 7px;
  margin-bottom: 14px;
  border: 1px solid #c9d9d4;
  border-radius: 8px;
  padding: 0 11px;
  background: #fff;
  color: #285f52;
  font-size: 11px;
  font-weight: 900;
  text-decoration: none;
}
.entity-detail-back-link:hover, .entity-detail-back-link:focus-visible {
  border-color: #6f9f92;
  background: #eef6f3;
  color: #174f43;
}

.entity-detail-kicker {
  display: block;
  margin-bottom: 6px;
  color: #2d6d5e;
  font-size: 10px;
  font-weight: 900;
  letter-spacing: 0.14em;
  text-transform: uppercase;
}

.entity-detail-header h2,
.entity-inspector-header h3 {
  margin: 0;
  color: #182823;
  font-size: 20px;
  font-weight: 900;
}

.entity-detail-header p,
.entity-inspector-header p {
  margin: 8px 0 0;
  color: #62716c;
  font-size: 13px;
  line-height: 1.6;
}

.entity-detail-summary {
  display: grid;
  grid-template-columns: repeat(4, minmax(74px, 92px));
  overflow: hidden;
  border: 1px solid #d7e2de;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.82);
}

.entity-detail-summary > span {
  display: grid;
  place-items: center;
  min-height: 68px;
  border-left: 1px solid #e4ece9;
}

.entity-detail-summary > span:first-child {
  border-left: 0;
}

.entity-detail-summary strong {
  color: #1f5c4e;
  font-size: 19px;
  line-height: 1;
}

.entity-detail-summary small {
  color: #71807b;
  font-size: 10px;
  font-weight: 800;
}

.entity-filter-panel {
  display: grid;
  grid-template-columns: minmax(280px, 1fr) repeat(3, minmax(132px, 180px));
  gap: 10px;
  padding: 14px;
  border: 1px solid #dce5e2;
  border-radius: 10px;
  background: #ffffff;
}

.entity-filter-panel label {
  display: grid;
  gap: 6px;
}

.entity-filter-panel label > span,
.entity-review-form label > span,
.entity-review-form legend {
  color: #52635d;
  font-size: 11px;
  font-weight: 900;
}

.entity-filter-panel input,
.entity-filter-panel select,
.entity-review-form input,
.entity-review-form select,
.entity-review-form textarea {
  width: 100%;
  min-height: 38px;
  border: 1px solid #ccd9d5;
  border-radius: 7px;
  background: #ffffff;
  color: #263b34;
  font: inherit;
  font-size: 12px;
  outline: none;
}

.entity-filter-panel input,
.entity-review-form input,
.entity-review-form select,
.entity-review-form textarea {
  padding: 9px 11px;
}

.entity-filter-panel select {
  padding: 0 10px;
}

.entity-filter-panel input:focus,
.entity-filter-panel select:focus,
.entity-review-form input:focus,
.entity-review-form select:focus,
.entity-review-form textarea:focus {
  border-color: #347b69;
  box-shadow: 0 0 0 3px rgba(52, 123, 105, 0.12);
}

.entity-table-card,
.entity-inspector {
  overflow: hidden;
  border: 1px solid #dce5e2;
  border-radius: 12px;
  background: #ffffff;
}

.entity-table-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 12px 16px;
  border-bottom: 1px solid #e4ebe9;
  background: #f8faf9;
}

.entity-table-meta p,
.entity-table-meta span {
  margin: 0;
  font-size: 11px;
}

.entity-table-meta p {
  color: #293d37;
  font-weight: 900;
}

.entity-table-meta span {
  color: #71807b;
}

.entity-table-scroll {
  width: 100%;
  overflow-x: auto;
}

.entity-record-table {
  width: 100%;
  min-width: 1260px;
  border-collapse: collapse;
  table-layout: fixed;
}

.entity-record-table th {
  padding: 10px 12px;
  border-bottom: 1px solid #dce5e2;
  background: #f1f6f4;
  color: #53635e;
  font-size: 10px;
  font-weight: 900;
  text-align: left;
  white-space: nowrap;
}

.entity-record-table td {
  padding: 11px 12px;
  border-bottom: 1px solid #edf1f0;
  color: #374a44;
  font-size: 11px;
  line-height: 1.45;
  vertical-align: top;
  word-break: keep-all;
}

.entity-record-table tbody tr {
  transition: background 140ms ease;
}

.entity-record-table tbody tr.entity-record-row {
  cursor: pointer;
}

.entity-record-table tbody tr.entity-record-row:focus-visible {
  outline: 2px solid #2c765e;
  outline-offset: -2px;
}

.entity-record-table tbody tr:hover,
.entity-record-table tbody tr.is-selected {
  background: #f1f8f5;
}

.entity-record-table tbody tr.is-selected {
  box-shadow: inset 3px 0 #2c765e;
}

.entity-record-table tbody tr.is-excluded {
  background: #fff8ee;
}

.entity-record-table td strong,
.entity-record-table td small {
  display: block;
}

.entity-record-table td small {
  max-width: 190px;
  margin-top: 3px;
  overflow: hidden;
  color: #7a8883;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.entity-name-button {
  max-width: 150px;
  padding: 0;
  overflow: hidden;
  border: 0;
  background: transparent;
  color: #235f51;
  font: inherit;
  font-weight: 900;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
}

.entity-name-button:hover {
  text-decoration: underline;
}

.entity-type-badge,
.entity-review-status {
  display: inline-flex;
  align-items: center;
  width: max-content;
  min-height: 24px;
  padding: 0 8px;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 900;
  white-space: nowrap;
}

.entity-type-badge {
  background: #eef3f2;
  color: #52655f;
}

.entity-type-badge.is-person {
  background: #eef1fb;
  color: #4a5f9a;
}

.entity-type-badge.is-place {
  background: #edf7f1;
  color: #337251;
}

.entity-type-badge.is-organization {
  background: #f7f2e8;
  color: #816126;
}

.entity-type-badge.is-event {
  background: #f9eeee;
  color: #8b4d4d;
}

.entity-review-status.is-approved {
  background: #e8f5ef;
  color: #2d7058;
}

.entity-review-status.is-needs-review {
  background: #fff3d9;
  color: #8b6415;
}

.entity-review-status.is-corrected {
  background: #fce8e5;
  color: #a04437;
}

.entity-review-status.is-excluded {
  background: #ecefed;
  color: #606c68;
}

.entity-review-status.is-duplicate {
  background: #f0ebfa;
  color: #67508f;
}

.entity-table-empty,
.entity-detail-empty {
  color: #7a8984;
  font-size: 12px;
  text-align: center;
}

.entity-table-empty {
  padding: 40px !important;
}

.entity-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  padding: 13px;
  border-top: 1px solid #e4ebe9;
  background: #fbfcfc;
}

.entity-pagination button,
.entity-inspector-actions button,
.entity-review-actions button,
.entity-link-status-actions button {
  min-height: 32px;
  padding: 0 11px;
  border: 1px solid #ccd9d5;
  border-radius: 6px;
  background: #ffffff;
  color: #42554f;
  font: inherit;
  font-size: 11px;
  font-weight: 900;
  cursor: pointer;
}

.entity-pagination button.is-active,
.entity-link-status-actions button.is-active {
  border-color: #2c765e;
  background: #2c765e;
  color: #ffffff;
}

.entity-pagination button:disabled,
.entity-review-actions button:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}

.entity-inspector {
  padding: 22px;
}

.entity-inspector-header {
  padding-bottom: 18px;
  border-bottom: 1px solid #e4ebe9;
}

.entity-inspector-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.entity-inspector-actions button {
  border-color: #2c765e;
  color: #235f51;
}

.entity-inspector-actions .entity-deletion-target-button {
  border-color: #c67b2d;
  background: #fff8ee;
  color: #9a5715;
}

.entity-inspector-actions .entity-deletion-target-button.is-cancel {
  border-color: #8aa59c;
  background: #f3f7f5;
  color: #375f53;
}

.entity-inspector-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 14px;
  margin-top: 16px;
}

.entity-evidence-card,
.entity-history-card,
.entity-candidate-card,
.entity-review-editor {
  padding: 16px;
  border: 1px solid #dfe8e5;
  border-radius: 9px;
  background: #fbfcfc;
}

.entity-candidate-card,
.entity-review-editor,
.entity-permission-note {
  margin-top: 14px;
}

.entity-section-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 12px;
}

.entity-section-heading > div {
  display: grid;
  gap: 3px;
}

.entity-section-heading span,
.entity-section-heading small {
  color: #71807b;
  font-size: 10px;
  font-weight: 800;
}

.entity-section-heading strong {
  color: #283e37;
  font-size: 13px;
}

.entity-evidence-card blockquote {
  min-height: 74px;
  margin: 0;
  padding: 14px;
  border-left: 3px solid #4c8b79;
  border-radius: 0 7px 7px 0;
  background: #ffffff;
  color: #334841;
  font-size: 13px;
  line-height: 1.7;
}

.entity-evidence-card dl,
.entity-candidate-item dl {
  display: grid;
  gap: 7px;
  margin: 12px 0 0;
}

.entity-evidence-card dl > div,
.entity-candidate-item dl > div {
  display: grid;
  grid-template-columns: 88px minmax(0, 1fr);
  gap: 10px;
}

.entity-evidence-card dt,
.entity-candidate-item dt {
  color: #7a8984;
  font-size: 10px;
  font-weight: 800;
}

.entity-evidence-card dd,
.entity-candidate-item dd {
  margin: 0;
  color: #344840;
  font-size: 11px;
}

.entity-history-list {
  display: grid;
  gap: 9px;
  max-height: 270px;
  margin: 0;
  padding: 0;
  overflow-y: auto;
  list-style: none;
}

.entity-history-list li {
  padding: 11px;
  border: 1px solid #e1e9e7;
  border-radius: 7px;
  background: #ffffff;
}

.entity-history-list li > div {
  display: flex;
  justify-content: space-between;
  gap: 10px;
}

.entity-history-list strong {
  color: #2e493f;
  font-size: 11px;
}

.entity-history-list time,
.entity-history-list small {
  color: #81908b;
  font-size: 9px;
}

.entity-history-list p {
  margin: 7px 0 4px;
  color: #40534d;
  font-size: 11px;
}

.entity-history-list em {
  display: block;
  margin-top: 6px;
  color: #65756f;
  font-size: 9px;
  font-style: normal;
  line-height: 1.5;
}

.entity-candidate-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.entity-candidate-item {
  padding: 13px;
  border: 1px solid #dfe7e4;
  border-radius: 8px;
  background: #ffffff;
}

.entity-candidate-item.is-selected {
  border-color: #5d9787;
  box-shadow: inset 0 0 0 1px #5d9787;
}

.entity-candidate-item.is-draft-selected {
  border-color: #2c765e;
  background: #f1f8f5;
  box-shadow: 0 0 0 2px rgba(44, 118, 94, 0.13);
}

.entity-candidate-radio {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 10px;
  color: #2b6656;
  font-size: 10px;
  font-weight: 900;
}

.entity-candidate-radio input {
  accent-color: #2c765e;
}

.entity-candidate-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.entity-candidate-title strong {
  color: #243c34;
  font-size: 13px;
}

.entity-candidate-title span {
  color: #70807a;
  font-family: monospace;
  font-size: 10px;
}

.entity-candidate-item > p {
  min-height: 34px;
  margin: 8px 0 0;
  color: #65746f;
  font-size: 10px;
  line-height: 1.6;
}

.entity-candidate-links,
.entity-candidate-identifiers {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-top: 10px;
}

.entity-candidate-links a,
.entity-candidate-identifiers span {
  padding: 4px 7px;
  border-radius: 5px;
  background: #eef4f2;
  color: #346a5c;
  font-size: 9px;
  font-weight: 800;
  text-decoration: none;
}

.entity-review-editor {
  border-color: #bdd5ce;
  background: #f6faf8;
}

.entity-review-form {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 12px;
}

.entity-review-form label,
.entity-review-form fieldset {
  display: grid;
  gap: 7px;
  min-width: 0;
  margin: 0;
  padding: 0;
  border: 0;
}

.entity-review-reason {
  grid-column: 1/-1;
}

.entity-review-disposition,
.entity-review-duplicate-target,
.entity-review-auto-reason {
  grid-column: 1/-1;
}

.entity-review-form textarea {
  min-height: 76px;
  resize: vertical;
}

.entity-link-status-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
}

.entity-link-status-actions span {
  color: #2d6d5e;
  font-size: 10px;
  font-weight: 900;
}

.entity-review-actions {
  display: flex;
  justify-content: flex-end;
  gap: 7px;
  margin-top: 13px;
}

.entity-review-actions button.is-primary {
  border-color: #265f51;
  background: #265f51;
  color: #ffffff;
}

.entity-permission-note {
  padding: 13px 15px;
  border: 1px solid #dde5e2;
  border-radius: 8px;
  background: #f7f9f8;
}

.entity-permission-note strong {
  color: #4a5c56;
  font-size: 11px;
}

.entity-permission-note p {
  margin: 4px 0 0;
  color: #75837e;
  font-size: 10px;
}

@media (max-width: 980px) {
  .entity-detail-header,
  .entity-inspector-header {
    align-items: stretch;
    flex-direction: column;
  }
  .entity-detail-summary {
    width: 100%;
    grid-template-columns: repeat(4, 1fr);
  }
  .entity-filter-panel {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .entity-search-field {
    grid-column: 1/-1;
  }
  .entity-inspector-grid,
  .entity-candidate-grid {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 640px) {
  .entity-detail-header,
  .entity-inspector {
    padding: 16px;
  }
  .entity-filter-panel,
  .entity-review-form {
    grid-template-columns: 1fr;
  }
  .entity-search-field,
  .entity-review-reason,
  .entity-review-disposition,
  .entity-review-duplicate-target,
  .entity-review-auto-reason {
    grid-column: auto;
  }
  .entity-table-meta,
  .entity-section-heading,
  .entity-inspector-actions {
    align-items: flex-start;
    flex-direction: column;
  }
  .entity-detail-summary {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .entity-detail-summary > span {
    min-height: 58px;
  }
}
.register-page .entity-review-head-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
}
.register-page .entity-review-workspace {
  display: grid;
  gap: 16px;
  margin-top: 20px;
}
.register-page .entity-review-card {
  overflow: hidden;
  border: 1px solid #d7e1e5;
  border-radius: 15px;
  background: #fff;
  box-shadow: 0 10px 28px rgba(29, 55, 66, 0.06);
}
.register-page .entity-review-card.needs-review {
  border-color: #d8b86d;
}
.register-page .entity-review-card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 15px;
  border-bottom: 1px solid #e5ecef;
  background: #f7fafb;
}
.register-page .entity-review-card-head > div {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 7px;
}
.register-page .entity-review-card-head span,
.register-page .entity-review-card-head em {
  padding: 4px 8px;
  border-radius: 999px;
  background: #e6f0ed;
  color: #315f55;
  font-size: 11px;
  font-style: normal;
  font-weight: 800;
}
.register-page .entity-review-card-head em {
  background: #eef2f4;
  color: #58707a;
}
.register-page .entity-review-card-head .entity-link-state {
  background: #eef2f4;
  color: #60747d;
}
.register-page .entity-review-card-head .entity-link-state.is-selected {
  background: #e5f3ec;
  color: #236045;
}
.register-page .entity-review-card-head .entity-link-state.is-deferred {
  background: #fff3d9;
  color: #825d15;
}
.register-page .entity-source-identity {
  display: grid;
  gap: 5px;
  padding: 16px;
  border-bottom: 1px solid #e8eef1;
  background: #fbfcfd;
}
.register-page .entity-source-identity > span {
  color: #758792;
  font-size: 11px;
  font-weight: 800;
}
.register-page .entity-source-identity strong {
  color: #183d4d;
  font-size: 18px;
}
.register-page .entity-source-identity q {
  color: #3f5f6d;
  font-size: 13px;
  line-height: 1.6;
}
.register-page .entity-source-identity small,
.register-page .entity-source-identity p {
  margin: 0;
  color: #72848e;
  font-size: 11px;
  line-height: 1.55;
}
.register-page .entity-source-identity p {
  margin-top: 4px;
  color: #8a691f;
}
.register-page .entity-edit-grid {
  display: grid;
  grid-template-columns: minmax(0, 1.4fr) minmax(160px, 0.6fr);
  gap: 12px;
  padding: 16px 16px 0;
}
.register-page .entity-edit-grid label {
  display: grid;
  gap: 6px;
  min-width: 0;
}
.register-page .entity-edit-grid label.is-wide {
  grid-column: 1/-1;
}
.register-page .entity-edit-grid span,
.register-page .entity-edit-grid .entity-decision-reason > span {
  color: #425f6c;
  font-size: 12px;
  font-weight: 800;
}
.register-page .entity-edit-grid input,
.register-page .entity-edit-grid select {
  width: 100%;
  min-height: 42px;
  padding: 0 12px;
  border: 1px solid #ccd9df;
  border-radius: 10px;
  background: #fff;
  color: #213f4c;
  font-size: 13px;
}
.register-page .entity-edit-grid input[readonly] {
  background: #f3f6f7;
  color: #627781;
}
.register-page .entity-decision-reason {
  display: grid;
  gap: 6px;
  padding: 14px 16px 0;
}
.register-page .entity-decision-reason > span {
  color: #425f6c;
  font-size: 12px;
  font-weight: 800;
}
.register-page .entity-decision-reason textarea {
  width: 100%;
  min-height: 70px;
  padding: 10px 12px;
  border: 1px solid #ccd9df;
  border-radius: 10px;
  color: #213f4c;
  font-size: 13px;
  line-height: 1.55;
  resize: vertical;
}
.register-page .entity-decision-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 10px 16px 16px;
}
.register-page .entity-decision-actions button:disabled,
.register-page .entity-decision-actions + .kg-candidate-section button:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}
.register-page .kg-candidate-section {
  padding: 16px;
  border-top: 1px solid #e5ecef;
  background: #f6f9fa;
}
.register-page .kg-candidate-section > header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
  margin-bottom: 12px;
}
.register-page .kg-candidate-section > header strong {
  color: #1e4454;
  font-size: 14px;
}
.register-page .kg-candidate-section > header p {
  margin: 4px 0 0;
  color: #71838c;
  font-size: 11px;
  line-height: 1.5;
}
.register-page .kg-candidate-section > header > span {
  flex: 0 0 auto;
  padding: 4px 8px;
  border-radius: 999px;
  background: #e4ecef;
  color: #516b76;
  font-size: 11px;
  font-weight: 800;
}
.register-page .kg-candidate-list {
  display: grid;
  gap: 10px;
}
.register-page .kg-candidate-list > article {
  padding: 14px;
  border: 1px solid #d6e1e5;
  border-radius: 12px;
  background: #fff;
}
.register-page .kg-candidate-list > article.is-selected {
  border-color: #43816d;
  box-shadow: 0 0 0 2px rgba(67, 129, 109, 0.12);
}
.register-page .kg-candidate-list > article > header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}
.register-page .kg-candidate-list > article > header strong {
  display: block;
  color: #183d4d;
  font-size: 15px;
}
.register-page .kg-candidate-list > article > header span {
  display: block;
  margin-top: 3px;
  color: #72848d;
  font-size: 11px;
}
.register-page .kg-candidate-list > article > header em {
  flex: 0 1 auto;
  padding: 4px 7px;
  border-radius: 7px;
  background: #edf3f5;
  color: #526c76;
  font-size: 10px;
  font-style: normal;
  font-weight: 800;
  text-align: right;
}
.register-page .kg-candidate-list > article dl {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  margin: 12px 0 0;
}
.register-page .kg-candidate-list > article dl div {
  min-width: 0;
  padding: 9px 10px;
  border-radius: 9px;
  background: #f6f9fa;
}
.register-page .kg-candidate-list > article dl dt {
  color: #7a8b93;
  font-size: 10px;
  font-weight: 800;
}
.register-page .kg-candidate-list > article dl dd {
  margin: 4px 0 0;
  color: #304e5b;
  font-size: 12px;
  line-height: 1.45;
  overflow-wrap: anywhere;
}
.register-page .kg-candidate-description {
  margin: 8px 0 0;
  color: #526a75;
  font-size: 12px;
  line-height: 1.55;
}
.register-page .kg-candidate-identifiers {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 10px;
}
.register-page .kg-candidate-identifiers span {
  padding: 4px 7px;
  border: 1px solid #dbe4e8;
  border-radius: 999px;
  color: #5c727c;
  font-size: 10px;
}
.register-page .kg-candidate-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 12px;
}
.register-page .kg-candidate-footer > div {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.register-page .kg-candidate-footer a,
.register-page .kg-candidate-footer > div > span {
  color: #286351;
  font-size: 11px;
  font-weight: 800;
}
.register-page .kg-candidate-empty {
  padding: 24px;
  border: 1px dashed #ccd9df;
  border-radius: 11px;
  color: #657983;
  text-align: center;
}
.register-page .kg-candidate-empty strong {
  font-size: 13px;
}
.register-page .kg-candidate-empty p {
  margin: 5px 0 0;
  font-size: 11px;
}
.register-page .entity-history {
  padding: 13px 16px;
  border-top: 1px solid #e5ecef;
}
.register-page .entity-history summary {
  color: #375866;
  cursor: pointer;
  font-size: 12px;
  font-weight: 800;
}
.register-page .entity-history ol {
  display: grid;
  gap: 8px;
  margin: 10px 0 0;
  padding: 0;
  list-style: none;
}
.register-page .entity-history li {
  padding: 10px;
  border-radius: 9px;
  background: #f6f9fa;
}
.register-page .entity-history li > div {
  display: flex;
  justify-content: space-between;
  gap: 10px;
}
.register-page .entity-history li strong,
.register-page .entity-history li time,
.register-page .entity-history li p,
.register-page .entity-history li small {
  font-size: 11px;
}
.register-page .entity-history li time,
.register-page .entity-history li small {
  color: #748690;
}
.register-page .entity-history li p {
  margin: 5px 0;
  color: #405d69;
}

@media (max-width: 760px) {
  .register-page .entity-review-head-actions,
  .register-page .kg-candidate-footer {
    align-items: stretch;
    flex-direction: column;
  }
  .register-page .entity-edit-grid,
  .register-page .kg-candidate-list > article dl {
    grid-template-columns: 1fr;
  }
  .register-page .entity-edit-grid label.is-wide {
    grid-column: auto;
  }
  .register-page .kg-candidate-list > article > header {
    flex-direction: column;
  }
  .register-page .kg-candidate-footer button {
    width: 100%;
  }
}
.register-page .xml-review-unavailable,
.register-page .xml-field-review {
  margin: 18px 0;
  border: 1px solid #dbe4ec;
  border-radius: 18px;
  background: #fff;
}
.register-page .xml-review-unavailable {
  padding: 18px 20px;
  border-color: #f0c9a7;
  background: #fff9f3;
}
.register-page .xml-review-unavailable strong {
  color: #9a4b17;
}
.register-page .xml-review-unavailable p,
.register-page .xml-review-unavailable small {
  display: block;
  margin: 6px 0 0;
  color: #6f5a49;
}
.register-page .xml-field-review {
  overflow: hidden;
  box-shadow: 0 14px 34px rgba(34, 55, 75, 0.07);
}
.register-page .xml-review-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
  padding: 22px 24px 16px;
}
.register-page .xml-review-head h4 {
  margin: 5px 0 7px;
  color: #17293a;
  font-size: 19px;
}
.register-page .xml-review-head p {
  margin: 0;
  color: #637486;
  line-height: 1.55;
}
.register-page .xml-review-progress {
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  align-items: flex-end;
  padding: 10px 14px;
  border-radius: 12px;
  background: #edf7f3;
  color: #205f4e;
}
.register-page .xml-review-progress strong {
  font-size: 18px;
}
.register-page .xml-review-progress span {
  margin-top: 2px;
  font-size: 11px;
}
.register-page .xml-review-workflow {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 0;
  margin: 0;
  padding: 0 24px 20px;
  list-style: none;
}
.register-page .xml-review-workflow li {
  position: relative;
  display: flex;
  align-items: center;
  gap: 7px;
  min-width: 0;
  color: #8794a0;
  font-size: 11px;
}
.register-page .xml-review-workflow li::after {
  position: absolute;
  top: 7px;
  right: 8px;
  left: 24px;
  height: 1px;
  background: #dce4ea;
  content: "";
}
.register-page .xml-review-workflow li:last-child::after {
  display: none;
}
.register-page .xml-review-workflow li > span {
  position: relative;
  z-index: 1;
  width: 15px;
  height: 15px;
  flex: 0 0 15px;
  border: 2px solid #cbd6de;
  border-radius: 50%;
  background: #fff;
}
.register-page .xml-review-workflow li strong {
  overflow: hidden;
  padding-right: 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.register-page .xml-review-workflow li.is-complete, .register-page .xml-review-workflow li.is-ready {
  color: #236a57;
}
.register-page .xml-review-workflow li.is-complete > span, .register-page .xml-review-workflow li.is-ready > span {
  border-color: #2d8a70;
  background: #2d8a70;
  box-shadow: inset 0 0 0 3px #fff;
}
.register-page .xml-review-workflow li.is-active {
  color: #174f78;
}
.register-page .xml-review-workflow li.is-active > span {
  border-color: #2377ad;
  box-shadow: inset 0 0 0 3px #fff;
  background: #2377ad;
}
.register-page .xml-source-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 12px 24px;
  border-block: 1px solid #e8eef2;
  background: #f8fafc;
}
.register-page .xml-source-toolbar > div {
  display: flex;
  align-items: baseline;
  gap: 10px;
}
.register-page .xml-source-toolbar strong {
  color: #2a3c4d;
}
.register-page .xml-source-toolbar span {
  color: #7c8a97;
  font-size: 11px;
}
.register-page .xml-source-toolbar code {
  max-width: 540px;
  overflow: hidden;
  color: #325b72;
  font-size: 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.register-page .xml-source-toolbar button {
  border: 1px solid #cbd8e2;
  border-radius: 8px;
  padding: 7px 11px;
  background: #fff;
  color: #31556f;
  cursor: pointer;
}
.register-page .xml-source-preview {
  max-height: 360px;
  margin: 0;
  overflow: auto;
  padding: 18px 24px;
  border-bottom: 1px solid #e6edf2;
  background: #111d27;
  color: #cfe4d8;
  font: 12px/1.65 ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  white-space: pre-wrap;
  word-break: break-word;
}
.register-page .xml-source-preview mark {
  border-radius: 3px;
  padding: 1px 2px;
  background: #ffe47a;
  color: #17212a;
  box-shadow: 0 0 0 2px rgba(255, 228, 122, 0.2);
}
.register-page .xml-review-summary {
  display: flex;
  gap: 8px;
  padding: 16px 24px 4px;
}
.register-page .xml-review-summary > span {
  display: flex;
  align-items: baseline;
  gap: 5px;
  padding: 7px 10px;
  border-radius: 999px;
  background: #f2f5f7;
}
.register-page .xml-review-summary strong {
  color: #263c4e;
}
.register-page .xml-review-summary em {
  color: #71808d;
  font-size: 11px;
  font-style: normal;
}
.register-page .xml-field-list {
  display: grid;
  gap: 14px;
  padding: 16px 24px 24px;
}
.register-page .xml-field-card {
  border: 1px solid #dde5eb;
  border-left: 4px solid #aab8c3;
  border-radius: 14px;
  background: #fff;
}
.register-page .xml-field-card.is-confirmed {
  border-left-color: #2b8a68;
}
.register-page .xml-field-card.is-modified {
  border-left-color: #8b65c3;
}
.register-page .xml-field-card.is-conflict {
  border-left-color: #d36b3c;
}
.register-page .xml-field-card.is-no_evidence, .register-page .xml-field-card.is-unreviewed {
  border-left-color: #d2a338;
}
.register-page .xml-field-card.is-active {
  border-color: #3980a6;
  border-left-color: #247399;
  box-shadow: 0 0 0 2px rgba(36, 115, 153, 0.12);
}
.register-page .xml-field-card > header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 14px 16px;
  border-bottom: 1px solid #e9eef2;
  background: #fbfcfd;
  cursor: pointer;
}
.register-page .xml-field-card > header > div:first-child {
  display: flex;
  align-items: center;
  gap: 9px;
}
.register-page .xml-field-card > header code {
  border-radius: 5px;
  padding: 3px 6px;
  background: #edf2f5;
  color: #647684;
  font-size: 10px;
}
.register-page .xml-field-statuses {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 6px;
}
.register-page .xml-field-statuses span {
  border-radius: 999px;
  padding: 5px 8px;
  font-size: 10px;
}
.register-page .xml-conflict-state {
  background: #eef2f4;
  color: #667783;
}
.register-page .xml-conflict-state.has-conflict {
  background: #fff0e8;
  color: #a14d24;
}
.register-page .xml-field-state {
  background: #edf6f2;
  color: #28644f;
}
.register-page .xml-field-comparison {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  border-bottom: 1px solid #e9eef2;
}
.register-page .xml-field-comparison section {
  min-width: 0;
  padding: 16px;
}
.register-page .xml-field-comparison section + section {
  border-left: 1px solid #e9eef2;
  background: #fbfcfd;
}
.register-page .xml-field-comparison section > span,
.register-page .xml-field-comparison section > small {
  display: block;
  color: #7a8995;
  font-size: 10px;
}
.register-page .xml-field-comparison section > strong {
  display: block;
  margin: 7px 0;
  color: #223747;
  line-height: 1.5;
  word-break: break-word;
}
.register-page .xml-field-comparison section ul {
  display: grid;
  gap: 6px;
  margin: 10px 0 0;
  padding: 0;
  list-style: none;
}
.register-page .xml-field-comparison section li {
  display: grid;
  grid-template-columns: minmax(120px, 0.75fr) minmax(0, 1fr);
  gap: 4px 10px;
  padding: 8px;
  border-radius: 8px;
  background: #f0f4f6;
}
.register-page .xml-field-comparison section li code {
  overflow: hidden;
  color: #526b7c;
  font-size: 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.register-page .xml-field-comparison section li em {
  color: #263b49;
  font-size: 11px;
  font-style: normal;
  word-break: break-word;
}
.register-page .xml-field-comparison section li small {
  grid-column: 1/-1;
  color: #87949e;
  font-size: 9px;
}
.register-page .xml-field-comparison section p {
  margin: 9px 0 0;
  color: #a05a32;
  font-size: 11px;
}
.register-page .xml-value-choice {
  margin-top: 10px;
  border: 1px solid #b9cbd7;
  border-radius: 8px;
  padding: 6px 9px;
  background: #fff;
  color: #315c75;
  font-size: 10px;
  font-weight: 700;
  cursor: pointer;
}
.register-page .xml-value-choice.is-source {
  border-color: #b9d5ca;
  color: #27684f;
}
.register-page .xml-field-editor,
.register-page .xml-standard-link,
.register-page .xml-change-reason,
.register-page .xml-field-actions,
.register-page .xml-change-history {
  margin: 14px 16px 0;
}
.register-page .xml-field-editor-head,
.register-page .xml-field-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.register-page .xml-field-editor-head {
  margin-bottom: 8px;
}
.register-page .xml-field-editor-head label {
  color: #344b5c;
  font-weight: 700;
}
.register-page .xml-field-editor-head button {
  border: 1px solid #bcd3df;
  border-radius: 7px;
  padding: 6px 9px;
  background: #f4f9fb;
  color: #27647f;
  font-size: 10px;
  cursor: pointer;
}
.register-page .xml-repeat-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 8px;
  margin-top: 7px;
}
.register-page .xml-repeat-row input {
  width: 100%;
  border: 1px solid #cad7e0;
  border-radius: 9px;
  padding: 10px 11px;
  color: #223747;
}
.register-page .xml-repeat-row button {
  border: 0;
  background: transparent;
  color: #a04a42;
  font-size: 11px;
  cursor: pointer;
}
.register-page .xml-standard-link {
  display: grid;
  grid-template-columns: minmax(0, 0.65fr) minmax(0, 1fr);
  gap: 10px;
  padding: 12px;
  border-radius: 11px;
  background: #f5f8fa;
}
.register-page .xml-standard-link label,
.register-page .xml-standard-link span {
  display: block;
}
.register-page .xml-standard-link span {
  margin-bottom: 6px;
  color: #637583;
  font-size: 10px;
}
.register-page .xml-standard-link input {
  width: 100%;
  border: 1px solid #cad7e0;
  border-radius: 8px;
  padding: 9px 10px;
  background: #fff;
}
.register-page .xml-change-reason {
  display: block;
}
.register-page .xml-change-reason span {
  display: block;
  margin-bottom: 6px;
  color: #637583;
  font-size: 10px;
}
.register-page .xml-change-reason textarea {
  width: 100%;
  resize: vertical;
  border: 1px solid #cad7e0;
  border-radius: 9px;
  padding: 10px 11px;
}
.register-page .xml-change-reason.is-required textarea {
  border-color: #d28b5f;
  background: #fffaf6;
}
.register-page .xml-field-actions {
  padding-bottom: 14px;
}
.register-page .xml-field-actions small {
  color: #7b8994;
  line-height: 1.4;
}
.register-page .xml-field-actions button {
  flex: 0 0 auto;
  border: 0;
  border-radius: 9px;
  padding: 9px 13px;
  background: #1f5d7c;
  color: #fff;
  cursor: pointer;
}
.register-page .xml-field-actions button.is-complete {
  background: #28745c;
}
.register-page .xml-change-history {
  margin-bottom: 14px;
  border-top: 1px dashed #d7e0e6;
  padding-top: 12px;
}
.register-page .xml-change-history summary {
  color: #455e70;
  font-size: 11px;
  cursor: pointer;
}
.register-page .xml-change-history ol {
  display: grid;
  gap: 8px;
  margin: 10px 0 0;
  padding: 0;
  list-style: none;
}
.register-page .xml-change-history li {
  padding: 10px 11px;
  border-radius: 9px;
  background: #f6f8fa;
}
.register-page .xml-change-history li > div {
  display: flex;
  justify-content: space-between;
  gap: 12px;
}
.register-page .xml-change-history li time,
.register-page .xml-change-history li small {
  color: #7a8994;
  font-size: 10px;
}
.register-page .xml-change-history li p {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
  margin: 7px 0;
  color: #657682;
  font-size: 11px;
}
.register-page .xml-change-history li del {
  color: #a65a54;
}
.register-page .xml-change-history li ins {
  color: #28705b;
  text-decoration: none;
}

.xml-saved-review {
  margin-top: 24px;
  overflow: hidden;
  border: 1px solid #d9e4e9;
  border-radius: 16px;
  background: #f8fbfc;
}
.xml-saved-review > header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  padding: 20px 22px;
  border-bottom: 1px solid #e0e9ed;
  background: #fff;
}
.xml-saved-review > header h3 {
  margin: 4px 0 6px;
  color: #193446;
  font-size: 18px;
}
.xml-saved-review > header p {
  margin: 0;
  color: #687c88;
  font-size: 12px;
}
.xml-saved-review .xml-saved-summary {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 7px;
}
.xml-saved-review .xml-saved-summary span {
  display: grid;
  justify-items: end;
  border-radius: 9px;
  padding: 7px 10px;
  background: #edf5f3;
  color: #285f52;
}
.xml-saved-review .xml-saved-summary small {
  font-size: 9px;
}
.xml-saved-review .xml-saved-summary code {
  align-self: center;
  border-radius: 6px;
  padding: 5px 7px;
  background: #eef2f5;
  color: #5c6f7b;
  font-size: 9px;
}
.xml-saved-review .xml-saved-source .xml-source-toolbar {
  display: flex;
  padding: 10px 18px;
  border-bottom: 1px solid #dce7eb;
  background: #f3f7f9;
}
.xml-saved-review .xml-saved-source .xml-source-toolbar > div {
  display: flex;
  align-items: baseline;
  gap: 9px;
}
.xml-saved-review .xml-saved-source .xml-source-toolbar strong {
  color: #2d4656;
}
.xml-saved-review .xml-saved-source .xml-source-toolbar span {
  color: #70838f;
  font-size: 10px;
}
.xml-saved-review .xml-saved-source .xml-source-preview {
  max-height: 280px;
  margin: 0;
  overflow: auto;
  padding: 16px 18px;
  background: #111d27;
  color: #cfe4d8;
  font: 11px/1.65 ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  white-space: pre-wrap;
  word-break: break-word;
}
.xml-saved-review .xml-saved-source .xml-source-preview mark {
  border-radius: 3px;
  padding: 1px 2px;
  background: #ffe47a;
  color: #17212a;
}
.xml-saved-review .xml-saved-field-list {
  display: grid;
  gap: 10px;
  padding: 18px;
}
.xml-saved-review .xml-saved-field-list > article {
  overflow: hidden;
  border: 1px solid #dbe5e9;
  border-radius: 11px;
  background: #fff;
}
.xml-saved-review .xml-saved-field-list > article.is-active {
  border-color: #3d7f9f;
  box-shadow: 0 0 0 2px rgba(61, 127, 159, 0.1);
}
.xml-saved-review .xml-saved-field-list dl {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px 18px;
  margin: 0;
  padding: 14px 16px;
}
.xml-saved-review .xml-saved-field-list dt {
  color: #7b8b95;
  font-size: 10px;
}
.xml-saved-review .xml-saved-field-list dd {
  margin: 4px 0 0;
  color: #263e4d;
  font-size: 12px;
  word-break: break-word;
}
.xml-saved-review .xml-saved-field-list dd code {
  display: block;
  margin-top: 3px;
  color: #426a7d;
  font-size: 10px;
}
.xml-saved-review .xml-saved-field-head {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border: 0;
  border-bottom: 1px solid #e6edef;
  padding: 12px 15px;
  background: #fbfcfd;
  text-align: left;
  cursor: pointer;
}
.xml-saved-review .xml-saved-field-head span {
  display: flex;
  align-items: center;
  gap: 8px;
}
.xml-saved-review .xml-saved-field-head code {
  color: #768894;
  font-size: 9px;
}
.xml-saved-review .xml-saved-field-head em {
  border-radius: 999px;
  padding: 4px 7px;
  background: #edf6f2;
  color: #2e6754;
  font-size: 9px;
  font-style: normal;
}
.xml-saved-review .xml-saved-history {
  display: grid;
  gap: 7px;
  margin: 0;
  padding: 0 16px 15px;
  list-style: none;
}
.xml-saved-review .xml-saved-history li {
  border-radius: 8px;
  padding: 9px 10px;
  background: #f4f7f8;
}
.xml-saved-review .xml-saved-history div,
.xml-saved-review .xml-saved-history p {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
}
.xml-saved-review .xml-saved-history time,
.xml-saved-review .xml-saved-history code,
.xml-saved-review .xml-saved-history small {
  color: #71828c;
  font-size: 9px;
}
.xml-saved-review .xml-saved-history p {
  margin: 5px 0;
  color: #647681;
  font-size: 11px;
}
.xml-saved-review .xml-saved-history del {
  color: #a65953;
}
.xml-saved-review .xml-saved-history ins {
  color: #28705b;
  text-decoration: none;
}

@media (max-width: 760px) {
  .xml-saved-review > header {
    flex-direction: column;
  }
  .xml-saved-review .xml-saved-summary {
    justify-content: flex-start;
  }
  .xml-saved-review .xml-saved-field-list dl {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 900px) {
  .register-page .xml-review-head {
    flex-direction: column;
  }
  .register-page .xml-review-progress {
    align-items: flex-start;
  }
  .register-page .xml-review-workflow {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 10px 0;
  }
  .register-page .xml-field-comparison {
    grid-template-columns: 1fr;
  }
  .register-page .xml-field-comparison section + section {
    border-top: 1px solid #e9eef2;
    border-left: 0;
  }
}
@media (max-width: 620px) {
  .register-page .xml-review-head,
  .register-page .xml-field-list {
    padding-inline: 14px;
  }
  .register-page .xml-review-workflow {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    padding-inline: 14px;
  }
  .register-page .xml-source-toolbar {
    align-items: flex-start;
    flex-direction: column;
    padding-inline: 14px;
  }
  .register-page .xml-standard-link {
    grid-template-columns: 1fr;
  }
  .register-page .xml-field-actions,
  .register-page .xml-field-card > header {
    align-items: stretch;
    flex-direction: column;
  }
  .register-page .xml-field-statuses {
    justify-content: flex-start;
  }
}
.register-page .document-profile-selector {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(260px, 340px);
  gap: 20px;
  align-items: end;
  margin: 0 0 20px;
  padding: 18px 20px;
  border: 1px solid #d9e2ec;
  border-radius: 16px;
  background: linear-gradient(135deg, #f8fbfd 0%, #f2f7f9 100%);
}
.register-page .document-profile-selector strong {
  display: block;
  margin-top: 4px;
  color: #162f3d;
  font-size: 17px;
}
.register-page .document-profile-selector p,
.register-page .document-profile-selector small {
  display: block;
  margin: 5px 0 0;
  color: #617581;
  font-size: 12px;
  line-height: 1.55;
}
.register-page .document-profile-selector label > span {
  display: block;
  margin-bottom: 7px;
  color: #334d5b;
  font-size: 12px;
  font-weight: 800;
}
.register-page .document-profile-selector select {
  width: 100%;
  min-height: 42px;
  padding: 0 38px 0 12px;
  border: 1px solid #b9c9d2;
  border-radius: 10px;
  background: #fff;
  color: #193846;
  font-weight: 800;
}
.register-page .document-profile-results {
  padding: 22px;
  border: 1px solid #dce5ea;
  border-radius: 18px;
  background: #fff;
}
.register-page .document-profile-result-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin-top: 18px;
}
.register-page .document-profile-result-grid article {
  min-width: 0;
  padding: 16px;
  border: 1px solid #dbe4e9;
  border-radius: 13px;
  background: #fbfcfd;
}
.register-page .document-profile-result-grid article.is-empty {
  border-style: dashed;
  background: #fafafa;
}
.register-page .document-profile-result-grid header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}
.register-page .document-profile-result-grid header strong {
  color: #173746;
  font-size: 14px;
}
.register-page .document-profile-result-grid header span {
  color: #6c7f89;
  font-size: 11px;
  font-weight: 800;
}
.register-page .document-profile-result-grid p {
  margin: 7px 0 10px;
  color: #6a7c86;
  font-size: 12px;
}
.register-page .document-profile-result-grid pre {
  max-height: 150px;
  margin: 0;
  overflow: auto;
  color: #304b59;
  font: inherit;
  font-size: 12px;
  line-height: 1.6;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}
.register-page .document-profile-review-panel {
  min-height: 430px;
}
.register-page .document-profile-field-editor {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 20px;
}
.register-page .document-profile-field-editor > span {
  color: #294754;
  font-size: 13px;
  font-weight: 800;
}
.register-page .document-profile-field-editor input,
.register-page .document-profile-field-editor textarea {
  width: 100%;
  border: 1px solid #cbd8df;
  border-radius: 12px;
  background: #fff;
  color: #203d4a;
  font-size: 14px;
  line-height: 1.65;
}
.register-page .document-profile-field-editor input {
  min-height: 44px;
  padding: 0 13px;
}
.register-page .document-profile-field-editor textarea {
  min-height: 260px;
  padding: 13px;
  resize: vertical;
}
.register-page .document-profile-field-editor small {
  color: #71828c;
  font-size: 11px;
}
.register-page .document-profile-source-preview {
  display: grid;
  place-items: center;
  min-height: 310px;
  margin-top: 20px;
  padding: 16px;
  border: 1px solid #d9e3e8;
  border-radius: 14px;
  background: #f6f9fa;
}
.register-page .document-profile-source-preview img {
  max-width: 100%;
  max-height: 520px;
  object-fit: contain;
}
.register-page .document-profile-source-preview a {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: min(100%, 520px);
  padding: 22px;
  border: 1px solid #c9d8df;
  border-radius: 13px;
  background: #fff;
  color: #1b4658;
  text-decoration: none;
  overflow-wrap: anywhere;
}
.register-page .document-profile-source-preview a span {
  color: #5f7783;
  font-size: 12px;
}
.register-page .document-profile-empty-notice {
  margin-top: 14px;
  padding: 13px 15px;
  border: 1px dashed #d5c89f;
  border-radius: 11px;
  background: #fffaf0;
}
.register-page .document-profile-empty-notice strong {
  color: #765c18;
  font-size: 13px;
}
.register-page .document-profile-empty-notice p {
  margin: 4px 0 0;
  color: #816f43;
  font-size: 12px;
}

@media (max-width: 760px) {
  .register-page .document-profile-selector,
  .register-page .document-profile-result-grid {
    grid-template-columns: 1fr;
  }
  .register-page .document-profile-source-preview {
    min-height: 220px;
  }
}
.manual-edit-badge {
  margin-left: auto;
  padding: 4px 7px;
  border-radius: 999px;
  background: #edf7f3;
  color: #276354;
  font-size: 9px;
  font-style: normal;
  font-weight: 800;
}

.summary-policy {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 9px;
  padding: 10px 12px;
  border: 1px solid #cfe1db;
  border-radius: 10px;
  background: #f4faf8;
}
.summary-policy > div {
  display: flex;
  align-items: baseline;
  gap: 5px;
}
.summary-policy strong {
  color: #285b4f;
  font-size: 11px;
}
.summary-policy span {
  color: #71827e;
  font-size: 9px;
}
.summary-policy button {
  margin-left: auto;
  padding: 6px 9px;
  border: 1px solid #d4ad68;
  border-radius: 7px;
  background: #fff8e8;
  color: #875e20;
  font-size: 9px;
  font-weight: 800;
}
.summary-policy.has-error {
  border-color: #e1c17f;
  background: #fffaf0;
}

.summary-entity-list {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 8px;
}
.summary-entity-list span {
  padding: 5px 8px;
  border-radius: 7px;
  background: #eef6f3;
  color: #315e54;
  font-size: 9px;
  font-weight: 700;
}
.summary-entity-list span.is-missing {
  background: #fff0e3;
  color: #9a5425;
  text-decoration: underline;
  text-decoration-style: dotted;
}

.ocr-quality-bridge {
  display: grid;
  grid-template-columns: minmax(220px, 1fr) minmax(360px, 1.6fr) auto;
  align-items: center;
  gap: 18px;
  padding: 17px 18px;
  border: 1px solid #d6e2e0;
  border-radius: 14px;
  background: #f8fbfa;
}
.ocr-quality-bridge h4 {
  margin: 3px 0 4px;
  color: #213e38;
  font-size: 14px;
}
.ocr-quality-bridge p {
  margin: 0;
  color: #70807c;
  font-size: 10px;
  line-height: 1.55;
}

.ocr-quality-metrics {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
}
.ocr-quality-metrics > div {
  min-width: 0;
  padding: 9px 10px;
  border: 1px solid #e0e8e6;
  border-radius: 9px;
  background: #fff;
}
.ocr-quality-metrics span,
.ocr-quality-metrics small {
  display: block;
  color: #80908c;
  font-size: 8px;
}
.ocr-quality-metrics strong {
  display: block;
  margin: 3px 0;
  color: #2a4d45;
  font-size: 11px;
}

.ocr-review-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin: 10px 0;
}
.ocr-review-toolbar > div {
  display: flex;
  gap: 5px;
}
.ocr-review-toolbar button {
  padding: 7px 10px;
  border: 1px solid #d7e0de;
  border-radius: 8px;
  background: #fff;
  color: #63746f;
  font-size: 9px;
  font-weight: 800;
}
.ocr-review-toolbar button.is-active {
  border-color: #2a665a;
  background: #285e53;
  color: #fff;
}

.ocr-correction-workspace {
  display: grid;
  grid-template-columns: minmax(220px, 0.62fr) minmax(0, 1.7fr);
  min-height: 470px;
  overflow: hidden;
  border: 1px solid #d9e2e0;
  border-radius: 12px;
  background: #fff;
}

.ocr-confidence-list {
  max-height: 600px;
  overflow-y: auto;
  padding: 10px;
  border-right: 1px solid #dfe7e5;
  background: #f6f9f8;
}
.ocr-confidence-list > button {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 5px;
  padding: 8px 9px;
  border: 1px solid transparent;
  border-radius: 8px;
  background: transparent;
  color: #455c56;
  text-align: left;
}
.ocr-confidence-list > button span {
  min-width: 0;
}
.ocr-confidence-list > button strong {
  display: block;
  overflow: hidden;
  font-size: 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ocr-confidence-list > button small {
  display: block;
  margin-top: 2px;
  color: #8a9995;
  font-size: 8px;
}
.ocr-confidence-list > button em {
  flex: 0 0 auto;
  color: #60736e;
  font-size: 9px;
  font-style: normal;
  font-weight: 800;
}
.ocr-confidence-list > button.is-low {
  background: #fff8ed;
  color: #7a5620;
}
.ocr-confidence-list > button.is-active {
  border-color: #3a7569;
  background: #eaf5f1;
  color: #1f594d;
}
.ocr-confidence-list > button.is-corrected {
  border-color: #9ac9b9;
}

.ocr-confidence-list-head {
  display: flex;
  justify-content: space-between;
  padding: 4px 3px 10px;
  color: #536a64;
  font-size: 9px;
}
.ocr-confidence-list-head span {
  color: #8b9995;
}

.ocr-score-empty {
  padding: 28px 12px;
  color: #73837f;
  text-align: center;
}
.ocr-score-empty strong {
  font-size: 10px;
}
.ocr-score-empty p {
  margin: 5px 0 0;
  font-size: 9px;
  line-height: 1.5;
}

.ocr-text-editor-panel {
  min-width: 0;
  padding: 12px;
}
.ocr-text-editor-panel textarea {
  width: 100%;
  min-height: 470px;
  resize: vertical;
  border: 1px solid #d9e2e0;
  border-radius: 10px;
  background: #fff;
  color: #293d38;
  font: inherit;
  font-size: 11px;
  line-height: 1.75;
}

.ocr-inline-correction {
  display: grid;
  grid-template-columns: minmax(140px, auto) minmax(150px, 1fr) auto;
  align-items: center;
  gap: 8px;
  margin-bottom: 9px;
  padding: 9px;
  border-radius: 9px;
  background: #edf6f3;
}
.ocr-inline-correction span {
  display: block;
  color: #7a8b86;
  font-size: 8px;
}
.ocr-inline-correction strong {
  display: block;
  margin-top: 2px;
  color: #2f594f;
  font-size: 10px;
}
.ocr-inline-correction input {
  min-width: 0;
  padding: 7px 8px;
  border: 1px solid #c9d9d5;
  border-radius: 7px;
  font-size: 10px;
}
.ocr-inline-correction button {
  padding: 7px 10px;
  border: 0;
  border-radius: 7px;
  background: #285e53;
  color: #fff;
  font-size: 9px;
  font-weight: 800;
}

.ocr-editor-note {
  margin: 7px 0 0;
  color: #7c8c88;
  font-size: 9px;
  line-height: 1.5;
}

@media (max-width: 980px) {
  .ocr-quality-bridge {
    grid-template-columns: 1fr;
  }
  .ocr-correction-workspace {
    grid-template-columns: 1fr;
  }
  .ocr-confidence-list {
    max-height: 260px;
    border-right: 0;
    border-bottom: 1px solid #dfe7e5;
  }
}
@media (max-width: 620px) {
  .ocr-quality-metrics {
    grid-template-columns: 1fr;
  }
  .ocr-review-toolbar {
    align-items: flex-start;
    flex-direction: column;
  }
  .ocr-inline-correction {
    grid-template-columns: 1fr;
  }
  .summary-policy {
    align-items: flex-start;
    flex-direction: column;
  }
  .summary-policy button {
    margin-left: 0;
  }
}
.complete-layout {
  display: block;
}

.final-review-shell {
  display: grid;
  gap: 14px;
}

.final-review-heading {
  display: grid;
  grid-template-columns: 42px minmax(0, 1fr) auto;
  align-items: center;
  gap: 13px;
  padding: 17px 18px;
  border: 1px solid #d6e2df;
  border-radius: var(--register-radius-lg);
  background: linear-gradient(135deg, #f7faf9, #f0f6f4);
}
.final-review-heading h3 {
  margin: 3px 0 3px;
  color: #163a33;
  font-size: 17px;
}
.final-review-heading p {
  margin: 0;
  color: #6e7e79;
  font-size: 10px;
  line-height: 1.55;
}

.final-review-icon {
  width: 42px;
  height: 42px;
  display: grid;
  place-items: center;
  border: 1px solid #bfd4ce;
  border-radius: var(--register-radius-md);
  background: #fff;
  color: #2c6659;
}
.final-review-icon svg {
  width: 21px;
  height: 21px;
}

.final-ready-badge {
  padding: 7px 10px;
  border: 1px solid #e2c593;
  border-radius: var(--register-radius-sm);
  background: #fff9eb;
  color: #835c1f;
  font-size: 9px;
  font-weight: 900;
  white-space: nowrap;
}
.final-ready-badge.is-ready {
  border-color: #a9cdbf;
  background: #ebf6f2;
  color: #245d50;
}

.final-review-summary {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 10px;
}
.final-review-summary article {
  min-width: 0;
  min-height: 116px;
  overflow: hidden;
  padding: 15px;
  border: 1px solid #dfe7e5;
  border-radius: var(--register-radius-md);
  background: #fff;
  box-shadow: 0 7px 18px rgba(38, 71, 63, 0.045);
}
.final-review-summary article > header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}
.final-review-summary article > header span {
  min-width: 0;
  overflow: hidden;
  color: #71847e;
  font-size: 9px;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.final-review-summary article > header i {
  width: 24px;
  height: 24px;
  display: grid;
  flex: 0 0 auto;
  place-items: center;
  border-radius: 8px;
  background: #edf3f1;
  color: #5c7770;
  font-size: 8px;
  font-style: normal;
  font-weight: 950;
}
.final-review-summary article.is-success > header i {
  background: #e2f2ed;
  color: #246853;
}
.final-review-summary article.is-scope > header i {
  background: #e8f1f4;
  color: #426f7e;
}
.final-review-summary article.has-warning > header i {
  background: #fff0cf;
  color: #956216;
}
.final-review-summary article.is-error > header i {
  background: #fce7e1;
  color: #9b4a36;
}
.final-review-summary article.is-draft > header i {
  background: #f5ecdf;
  color: #7d5a2e;
}
.final-review-summary strong {
  display: block;
  margin-top: 12px;
  overflow: hidden;
  color: #294a42;
  font-size: 16px;
  line-height: 1.2;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.final-review-summary small {
  display: block;
  margin-top: 7px;
  overflow: hidden;
  color: #7f908b;
  font-size: 8px;
  line-height: 1.4;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.final-review-columns {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 300px;
  gap: 12px;
  align-items: start;
}

.final-preview-card,
.final-check-card {
  min-width: 0;
  padding: 18px;
  border: 1px solid #dbe4e2;
  border-radius: var(--register-radius-lg);
  background: #fff;
}

.final-preview-card > header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
  padding-bottom: 13px;
  border-bottom: 1px solid #e6ecea;
}
.final-preview-card > header h4 {
  margin: 3px 0 0;
  color: #213f38;
  font-size: 14px;
}
.final-preview-card > header p {
  margin: 5px 0 0;
  color: #74837f;
  font-size: 9px;
  line-height: 1.5;
}
.final-preview-card > header > strong {
  flex: 0 0 auto;
  color: #315f54;
  font-size: 10px;
  white-space: nowrap;
}

.final-registration-data-list {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  margin-top: 14px;
  scroll-margin-top: 116px;
}

.final-registration-data-item {
  min-width: 0;
  overflow: hidden;
  border: 1px solid #dce7e4;
  border-radius: var(--register-radius-md);
  background: #fff;
}
.final-registration-data-item > header {
  display: grid;
  grid-template-columns: 28px minmax(0, 1fr) auto;
  gap: 9px;
  align-items: center;
  padding: 11px;
  border-bottom: 1px solid #e4ebe9;
  background: #f5f9f7;
}
.final-registration-data-item > header > div {
  min-width: 0;
}
.final-registration-data-item > header strong,
.final-registration-data-item > header small {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.final-registration-data-item > header strong {
  color: #294b43;
  font-size: 10px;
}
.final-registration-data-item > header small {
  margin-top: 3px;
  color: #758780;
  font-size: 8px;
}
.final-registration-data-item > .final-meta-grid {
  margin: 10px;
}
.final-registration-data-item > .final-description-block {
  margin: 0 10px 10px;
}
.final-registration-data-item.is-excluded {
  border-color: #e4c6bd;
  background: #fffafa;
}
.final-registration-data-item.is-excluded > header {
  background: #fff4f1;
}

.final-registration-data-item:focus {
  outline: 3px solid rgba(55, 126, 108, 0.2);
  outline-offset: 3px;
}

.final-registration-data-index {
  width: 28px;
  height: 28px;
  display: grid;
  place-items: center;
  border-radius: 8px;
  background: #dfeee9;
  color: #286253;
  font-size: 9px;
  font-weight: 900;
}

.final-registration-data-actions {
  display: flex;
  align-items: center;
  gap: 6px;
}

.final-registration-edit-btn {
  padding: 6px 9px;
  border: 1px solid #b8cec8;
  border-radius: var(--register-radius-sm);
  background: #fff;
  color: #2c6659;
  font-size: 9px;
  font-weight: 900;
  white-space: nowrap;
}
.final-registration-edit-btn:hover:not(:disabled) {
  border-color: #2f7565;
  background: #edf7f3;
}
.final-registration-edit-btn:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}

.final-registration-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 12px;
  padding: 10px 12px;
  border: 1px solid #dce7e4;
  border-radius: var(--register-radius-md);
  background: #f8fbfa;
}
.final-registration-pagination > span {
  color: #617a73;
  font-size: 9px;
  font-weight: 850;
}
.final-registration-pagination > div {
  display: flex;
  align-items: center;
  gap: 5px;
}
.final-registration-pagination button {
  min-width: 30px;
  height: 30px;
  padding: 0 9px;
  border: 1px solid #cbdad6;
  border-radius: 8px;
  background: #fff;
  color: #45645c;
  font-size: 9px;
  font-weight: 900;
}
.final-registration-pagination button.is-active {
  border-color: #2e7463;
  background: #2e7463;
  color: #fff;
  box-shadow: 0 5px 12px rgba(46, 116, 99, 0.16);
}
.final-registration-pagination button:disabled {
  cursor: not-allowed;
  opacity: 0.4;
}

.final-correction-return {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 13px 15px;
  border: 1px solid #9fc9bc;
  border-radius: var(--register-radius-md);
  background: #edf7f3;
  box-shadow: 0 8px 22px rgba(36, 93, 80, 0.08);
}
.final-correction-return > div {
  min-width: 0;
}
.final-correction-return strong {
  display: block;
  margin-top: 3px;
  color: #1f584b;
  font-size: 12px;
}
.final-correction-return p {
  margin: 3px 0 0;
  color: #668078;
  font-size: 9px;
  line-height: 1.5;
}
.final-correction-return button {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 6px;
  padding: 9px 12px;
  border: 0;
  border-radius: var(--register-radius-sm);
  background: #266a59;
  color: #fff;
  font-size: 10px;
  font-weight: 900;
  box-shadow: 0 7px 16px rgba(38, 106, 89, 0.18);
}
.final-correction-return button svg {
  width: 15px;
  height: 15px;
}
.final-correction-return button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.workbench-body > .final-correction-return {
  margin-bottom: 14px;
}

.final-correction-return.is-warning-review {
  border-color: #ddc58d;
  background: #fff9eb;
  box-shadow: 0 8px 22px rgba(117, 83, 31, 0.08);
}
.final-correction-return.is-warning-review strong {
  color: #664a1f;
}
.final-correction-return.is-warning-review p {
  color: #7f6c4e;
}
.final-correction-return.is-warning-review button {
  background: #8a6428;
  box-shadow: 0 7px 16px rgba(116, 80, 27, 0.18);
}

.final-correction-status {
  display: inline-flex;
  margin-top: 7px;
  padding: 5px 8px;
  border-radius: 999px;
  background: #f4e4bd;
  color: #78531d;
  font-size: 9px;
  font-weight: 900;
}

.final-registration-data-empty {
  margin: 14px 0 0;
  padding: 16px;
  border: 1px dashed #ccd9d5;
  border-radius: var(--register-radius-md);
  color: #71847d;
  text-align: center;
  font-size: 10px;
}

.final-visibility-badge {
  flex: 0 0 auto;
  padding: 6px 9px;
  border: 1px solid #d7dfdd;
  border-radius: var(--register-radius-sm);
  background: #f6f8f7;
  color: #61706c;
  font-size: 9px;
  font-weight: 900;
}
.final-visibility-badge.is-public {
  border-color: #a8cabc;
  background: #ecf6f2;
  color: #245e51;
}
.final-visibility-badge.is-private {
  border-color: #dfc99f;
  background: #fff9ed;
  color: #805c24;
}

.final-meta-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  margin: 14px 0 0;
}
.final-meta-grid > div {
  min-width: 0;
  padding: 10px 11px;
  border: 1px solid #e6ecea;
  border-radius: var(--register-radius-sm);
  background: #fafcfb;
}
.final-meta-grid > div.is-wide {
  grid-column: 1/-1;
}
.final-meta-grid dt {
  color: #84928e;
  font-size: 8px;
  font-weight: 900;
}
.final-meta-grid dd {
  margin: 4px 0 0;
  overflow-wrap: anywhere;
  color: #263d37;
  font-size: 10px;
  font-weight: 850;
  line-height: 1.55;
}

.final-description-block {
  margin-top: 8px;
  padding: 11px;
  border: 1px solid #e6ecea;
  border-radius: var(--register-radius-sm);
  background: #fafcfb;
}
.final-description-block > span {
  color: #84928e;
  font-size: 8px;
  font-weight: 900;
}
.final-description-block p {
  max-height: 132px;
  margin: 5px 0 0;
  overflow-y: auto;
  color: #334942;
  font-size: 10px;
  line-height: 1.65;
}

.final-file-block {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #e6ecea;
}
.final-file-block > header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.final-file-block > header strong {
  color: #344d46;
  font-size: 10px;
}
.final-file-block > header span {
  color: #7d8d88;
  font-size: 8px;
  font-weight: 900;
}
.final-file-block .final-file-list {
  max-height: 156px;
  overflow-y: auto;
}

.final-check-card {
  position: sticky;
  top: 96px;
  background: #f8faf9;
}
.final-check-card > header h4 {
  margin: 3px 0 4px;
  color: #213f38;
  font-size: 14px;
}
.final-check-card > header p {
  margin: 0;
  color: #74837f;
  font-size: 9px;
  line-height: 1.55;
}

.final-readiness {
  margin-top: 14px;
  padding: 12px;
  border: 1px solid #dbe5e2;
  border-radius: var(--register-radius-md);
  background: #fff;
}
.final-readiness > div:first-child {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.final-readiness > div:first-child span {
  color: #6f807b;
  font-size: 9px;
  font-weight: 850;
}
.final-readiness > div:first-child strong {
  color: #285f53;
  font-size: 12px;
}
.final-readiness > p {
  margin: 7px 0 0;
  color: #788782;
  font-size: 8px;
  line-height: 1.5;
}

.final-readiness-track {
  height: 6px;
  margin-top: 8px;
  overflow: hidden;
  border-radius: 999px;
  background: #e3ebe8;
}
.final-readiness-track span {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: #2f6a5d;
  transition: width 220ms ease;
}

.final-check-card .final-checks {
  display: grid;
  gap: 6px;
  margin: 10px 0 0;
  padding: 0;
}

.final-check-card .final-checks li {
  display: grid;
  grid-template-columns: 17px minmax(0, 1fr) auto;
  gap: 8px;
  align-items: center;
  padding: 8px 9px;
  border: 1px solid #e1e8e6;
  border-radius: var(--register-radius-sm);
  background: #fff;
  color: #61716c;
  font-size: 9px;
}

.final-check-card .final-checks li::before {
  width: 17px;
  height: 17px;
  display: grid;
  place-items: center;
  border: 1px solid #ccd8d4;
  border-radius: 50%;
  background: #f6f8f7;
  color: transparent;
  font-size: 9px;
  content: "✓";
}

.final-check-card .final-checks li > span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.final-check-card .final-checks li > strong {
  color: #9a692d;
  font-size: 8px;
  white-space: nowrap;
}

.final-check-card .final-checks li.is-ready {
  border-color: #d7e6e1;
  color: #31594f;
}

.final-check-card .final-checks li.is-ready::before {
  border-color: #80ad9f;
  background: #e7f3ef;
  color: #236052;
}

.final-check-card .final-checks li.is-ready > strong {
  color: #276154;
}

.final-ready-badge.is-ready,
.final-ready-badge.is-complete {
  border-color: #a9cdbf;
  background: #ebf6f2;
  color: #245d50;
}

.final-ready-badge.is-attention,
.final-ready-badge.is-checking {
  border-color: #e2c593;
  background: #fff9eb;
  color: #835c1f;
}

.final-ready-badge.is-blocked,
.final-ready-badge.is-failed {
  border-color: #e1b1a4;
  background: #fff3ef;
  color: #934834;
}

.final-ready-badge.is-processing,
.final-ready-badge.is-partial {
  border-color: #b9cfdc;
  background: #f0f7fb;
  color: #35677e;
}

.final-registration-progress,
.final-registration-results,
.final-issue-summary {
  padding: 16px;
  border: 1px solid #d8e5e1;
  border-radius: var(--register-radius-lg);
  background: #fff;
}

.final-registration-progress {
  background: #f6faf8;
}
.final-registration-progress > div:first-child {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #265e52;
  font-size: 11px;
}
.final-registration-progress p {
  margin: 8px 0 0;
  color: #70827c;
  font-size: 9px;
}

.final-registration-progress-track {
  height: 8px;
  margin-top: 10px;
  overflow: hidden;
  border-radius: 999px;
  background: #dfebe7;
}
.final-registration-progress-track span {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: #2e7564;
  transition: width 220ms ease;
}

.final-registration-results > header,
.final-issue-summary > header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}
.final-registration-results > header h4,
.final-issue-summary > header h4 {
  margin: 3px 0 2px;
  color: #213f38;
  font-size: 14px;
}
.final-registration-results > header p,
.final-issue-summary > header p {
  margin: 0;
  color: #758680;
  font-size: 9px;
  line-height: 1.55;
}

.final-registration-result-list {
  display: grid;
  gap: 8px;
  margin-top: 13px;
}

.final-registration-result-list article {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto auto;
  align-items: center;
  gap: 12px;
  padding: 11px;
  border: 1px solid #dbe6e2;
  border-radius: 9px;
  background: #f9fbfa;
}
.final-registration-result-list article strong,
.final-registration-result-list article small,
.final-registration-result-list article code {
  display: block;
}
.final-registration-result-list article strong {
  color: #284a42;
  font-size: 10px;
}
.final-registration-result-list article small {
  margin-top: 3px;
  color: #72837d;
  font-size: 9px;
}
.final-registration-result-list article code {
  margin-top: 3px;
  color: #8a665a;
  font-size: 8px;
}
.final-registration-result-list article > span {
  color: #286452;
  font-size: 9px;
  font-weight: 900;
}
.final-registration-result-list article > a {
  color: #245f52;
  font-size: 9px;
  font-weight: 900;
}
.final-registration-result-list article.is-failed {
  border-color: #e2b9ae;
  background: #fff7f4;
}
.final-registration-result-list article.is-excluded {
  border-color: #e4d8c1;
  background: #fffbf3;
}

.final-result-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 12px;
}
.final-result-actions a {
  text-decoration: none;
}

.final-issue-summary article > button {
  padding: 6px 8px;
  border: 1px solid #bdd3cc;
  border-radius: 7px;
  background: #fff;
  color: #285f53;
  font-size: 8px;
  font-weight: 900;
}

.final-registration-agreement {
  display: flex;
  gap: 11px;
  align-items: center;
  min-height: 58px;
  margin-top: 12px;
  padding: 12px 14px;
  border: 1px solid #a8cabc;
  border-radius: 9px;
  background: #edf7f3;
  cursor: pointer;
  user-select: none;
  transition: border-color 150ms ease, background 150ms ease, box-shadow 150ms ease;
}
.final-registration-agreement input {
  flex: 0 0 auto;
  width: 22px;
  height: 22px;
  margin: 0;
  accent-color: #25715e;
  cursor: pointer;
}
.final-registration-agreement strong, .final-registration-agreement small {
  display: block;
}
.final-registration-agreement strong {
  color: #245d50;
  font-size: 10px;
}
.final-registration-agreement small {
  margin-top: 4px;
  color: #617b73;
  font-size: 8px;
  line-height: 1.45;
}
.final-registration-agreement:hover:not(.is-disabled), .final-registration-agreement:focus-within {
  border-color: #4c927f;
  box-shadow: 0 0 0 3px rgba(37, 113, 94, 0.12);
}
.final-registration-agreement.is-checked {
  border-color: #2f7d69;
  background: #e2f3ed;
}
.final-registration-agreement.is-disabled {
  border-color: #e0c1b8;
  background: #fff7f4;
  cursor: not-allowed;
  opacity: 0.72;
}
.final-registration-agreement.is-disabled input {
  cursor: not-allowed;
}

.final-save-disabled-reason {
  margin: 8px 0 0;
  color: #92513e;
  font-size: 8px;
  line-height: 1.5;
}

.final-issue-summary {
  scroll-margin-top: 90px;
}
.final-issue-summary:focus {
  outline: 3px solid rgba(44, 112, 96, 0.22);
}
.final-issue-summary.has-blocking {
  border-color: #dfb6aa;
  background: #fffafa;
}
.final-issue-summary dl {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 5px;
  margin: 9px 0 0;
}
.final-issue-summary dl > div {
  display: flex;
  gap: 6px;
  min-width: 0;
}
.final-issue-summary dt {
  color: #8a7a70;
  font-size: 8px;
  font-weight: 900;
}
.final-issue-summary dd {
  margin: 0;
  overflow-wrap: anywhere;
  color: #5f5149;
  font-size: 8px;
}

.final-blocking-list {
  margin-top: 12px;
}
.final-blocking-list > header,
.final-blocking-list > article {
  display: grid;
}
.final-blocking-list > header {
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 12px;
  align-items: center;
  margin-bottom: 7px;
}
.final-blocking-list > header strong {
  color: #7b493d;
  font-size: 10px;
}
.final-blocking-list > header span {
  color: #916e65;
  font-size: 8px;
}
.final-blocking-list > article {
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 14px;
  margin-top: 9px;
  padding: 11px;
  border: 1px solid #e2b8ad;
  border-radius: 9px;
  background: #fff6f3;
}
.final-blocking-list > article strong {
  color: #694a39;
  font-size: 10px;
}
.final-blocking-list > article p {
  margin: 4px 0 0;
  color: #806b60;
  font-size: 9px;
}
.final-blocking-list > article > button {
  align-self: center;
}

.final-issue-header-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 7px;
  align-items: center;
}
.final-issue-header-actions button {
  min-height: 30px;
  padding: 6px 9px;
  font-size: 8px;
}

.final-issue-counts {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}
.final-issue-counts span {
  padding: 5px 8px;
  border-radius: 999px;
  font-size: 8px;
  font-weight: 900;
}
.final-issue-counts .is-blocking {
  background: #f7dfd8;
  color: #854535;
}
.final-issue-counts .is-warning {
  background: #f9ebca;
  color: #805519;
}

.final-preflight-technical {
  position: relative;
}
.final-preflight-technical summary {
  min-height: 30px;
  padding: 7px 9px;
  border: 1px solid #cbdcd6;
  border-radius: 7px;
  background: #fff;
  color: #42675e;
  font-size: 8px;
  font-weight: 900;
  cursor: pointer;
  list-style: none;
}
.final-preflight-technical summary::-webkit-details-marker {
  display: none;
}
.final-preflight-technical code {
  position: absolute;
  z-index: 3;
  top: calc(100% + 5px);
  right: 0;
  width: max-content;
  max-width: min(430px, 78vw);
  padding: 8px 10px;
  border: 1px solid #cfddd8;
  border-radius: 7px;
  background: #fff;
  box-shadow: 0 8px 20px rgba(28, 62, 54, 0.12);
  overflow-wrap: anywhere;
  color: #667a74;
  font-size: 8px;
}

.final-warning-groups {
  margin-top: 13px;
}
.final-warning-groups > header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 8px;
}
.final-warning-groups > header strong {
  color: #554a32;
  font-size: 10px;
}
.final-warning-groups > header p {
  margin: 3px 0 0;
  color: #81745c;
  font-size: 8px;
}
.final-warning-groups > header > span {
  padding: 4px 7px;
  border-radius: 999px;
  background: #f8ebca;
  color: #805519;
  font-size: 8px;
  font-weight: 900;
  white-space: nowrap;
}

.final-warning-group {
  margin-top: 7px;
  overflow: hidden;
  border: 1px solid #e3d6ba;
  border-radius: 9px;
  background: #fffcf6;
}
.final-warning-group > summary {
  display: grid;
  grid-template-columns: 28px minmax(0, 1fr) auto auto;
  gap: 9px;
  align-items: center;
  padding: 9px 11px;
  cursor: pointer;
  list-style: none;
}
.final-warning-group > summary::-webkit-details-marker {
  display: none;
}
.final-warning-group > summary::after {
  content: "열기";
  color: #8d6b2e;
  font-size: 8px;
  font-weight: 900;
}
.final-warning-group[open] > summary::after {
  content: "닫기";
}
.final-warning-group > summary em {
  padding: 4px 7px;
  border-radius: 999px;
  background: #f8ebca;
  color: #805519;
  font-size: 8px;
  font-style: normal;
  font-weight: 900;
  white-space: nowrap;
}

.final-warning-file-index {
  display: grid;
  place-items: center;
  width: 28px;
  height: 28px;
  border-radius: 8px;
  background: #f5ead0;
  color: #7c571e;
  font-size: 9px;
  font-weight: 900;
}

.final-warning-file-copy {
  min-width: 0;
}
.final-warning-file-copy strong,
.final-warning-file-copy small {
  display: block;
}
.final-warning-file-copy strong {
  overflow: hidden;
  color: #4d493d;
  font-size: 9px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.final-warning-file-copy small {
  margin-top: 2px;
  color: #857a67;
  font-size: 8px;
}

.final-warning-detail {
  display: grid;
  gap: 7px;
  padding: 0 10px 10px;
}
.final-warning-detail article {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 12px;
  padding: 10px;
  border: 1px solid #eadfc8;
  border-radius: 8px;
  background: #fff;
}
.final-warning-detail article strong {
  color: #594b35;
  font-size: 9px;
}
.final-warning-detail article p {
  margin: 3px 0 0;
  color: #81735d;
  font-size: 8px;
  line-height: 1.45;
}
.final-warning-detail article > button {
  align-self: center;
}

@media (max-width: 940px) {
  .final-review-summary {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .final-review-columns {
    grid-template-columns: 1fr;
  }
  .final-check-card {
    position: static;
  }
}
@media (max-width: 620px) {
  .final-review-heading {
    grid-template-columns: 36px minmax(0, 1fr);
  }
  .final-review-icon {
    width: 36px;
    height: 36px;
  }
  .final-ready-badge {
    grid-column: 1/-1;
    justify-self: stretch;
    text-align: center;
  }
  .final-review-summary,
  .final-registration-data-list,
  .final-meta-grid {
    grid-template-columns: 1fr;
  }
  .final-meta-grid > div.is-wide {
    grid-column: auto;
  }
  .final-registration-result-list article,
  .final-blocking-list > article,
  .final-warning-detail article,
  .final-issue-summary dl {
    grid-template-columns: 1fr;
  }
  .final-registration-results > header,
  .final-issue-summary > header {
    flex-direction: column;
  }
  .final-issue-header-actions {
    justify-content: flex-start;
  }
}
.register-page .flow-progress-copy p,
.register-page .flow-progress-copy > span {
  font-size: 12px;
}
.register-page .register-step-title {
  font-size: 14px;
  line-height: 1.35;
}
.register-page .register-step-desc {
  font-size: 11px;
  line-height: 1.45;
}
.register-page .register-step-state {
  font-size: 10px;
}
.register-page .workbench-head h2 {
  font-size: 21px;
}
.register-page .workbench-head p:last-child {
  font-size: 12px;
  line-height: 1.55;
}
.register-page .panel-heading h3 {
  font-size: 16px;
}
.register-page .panel-heading p {
  font-size: 12px;
  line-height: 1.55;
}
.register-page .source-toggle button,
.register-page .primary-btn,
.register-page .secondary-btn,
.register-page .dark-btn {
  font-size: 12px;
}
.register-page .file-box-main strong {
  font-size: 14px;
}
.register-page .file-box-main small,
.register-page .url-helper,
.register-page .source-features em,
.register-page .selected-file-info small,
.register-page .upload-selection-notice,
.register-page .registration-recovery-notice {
  font-size: 11px;
  line-height: 1.55;
}
.register-page .source-features strong,
.register-page .selected-file-info strong,
.register-page .analysis-file-queue strong {
  font-size: 12px;
}
.register-page .url-entry textarea,
.register-page .url-entry input {
  font-size: 13px;
  line-height: 1.55;
}
.register-page .analysis-progress-head span,
.register-page .analysis-progress-head small,
.register-page .analysis-progress-panel > p,
.register-page .analysis-file-queue em {
  font-size: 11px;
}
.register-page .analysis-progress-head strong {
  font-size: 14px;
}
.register-page .metadata-file-rail-head span,
.register-page .metadata-file-rail > p,
.register-page .metadata-file-select small,
.register-page .metadata-file-error {
  font-size: 10px;
  line-height: 1.5;
}
.register-page .metadata-file-rail-head > strong,
.register-page .metadata-file-select strong {
  font-size: 12px;
}
.register-page .field label {
  font-size: 12px;
}
.register-page .field input,
.register-page .field select,
.register-page .field textarea {
  font-size: 13px;
  line-height: 1.55;
}
.register-page .field > small,
.register-page .confidence-indicator small {
  font-size: 10px;
  line-height: 1.5;
}
.register-page .registration-substeps > button {
  min-height: 80px;
}
.register-page .registration-substeps > button > span:first-child {
  font-size: 11px;
}
.register-page .registration-substeps > button strong {
  font-size: 13px;
}
.register-page .registration-substeps > button small,
.register-page .registration-substeps > button em {
  font-size: 10px;
  line-height: 1.4;
}
.register-page .stage-panel-head h3 {
  font-size: 19px;
}
.register-page .stage-panel-head p {
  font-size: 12px;
  line-height: 1.6;
}
.register-page .review-status-badge {
  font-size: 11px;
}
.register-page .review-file-switcher > span {
  font-size: 11px;
}
.register-page .review-file-switcher button strong {
  font-size: 11px;
}
.register-page .review-file-switcher button small {
  font-size: 10px;
}
.register-page .review-overview-grid span,
.register-page .review-overview-grid small {
  font-size: 10px;
  line-height: 1.4;
}
.register-page .review-overview-grid strong {
  font-size: 14px;
}
.register-page .pipeline-progress-head span {
  font-size: 10px;
}
.register-page .pipeline-progress-head strong {
  font-size: 13px;
}
.register-page .pipeline-progress-detail span,
.register-page .pipeline-progress-detail p {
  font-size: 11px;
  line-height: 1.45;
}
.register-page .multilingual-warning strong,
.register-page .multilingual-empty strong {
  font-size: 12px;
}
.register-page .multilingual-warning p,
.register-page .multilingual-empty p,
.register-page .translation-compare-grid article > div,
.register-page .translation-compare-grid textarea {
  font-size: 12px;
  line-height: 1.7;
}
.register-page .ocr-confidence-list > button strong,
.register-page .ocr-score-empty strong,
.register-page .ocr-inline-correction strong {
  font-size: 12px;
}
.register-page .ocr-confidence-list > button small,
.register-page .ocr-confidence-list > button em,
.register-page .ocr-confidence-list-head,
.register-page .ocr-score-empty p,
.register-page .ocr-inline-correction span,
.register-page .ocr-editor-note {
  font-size: 10px;
  line-height: 1.5;
}
.register-page .ocr-text-editor-panel textarea,
.register-page .ocr-inline-correction input {
  font-size: 13px;
}
.register-page .final-review-heading p,
.register-page .final-check-card > header p {
  font-size: 11px;
}
.register-page .final-ready-badge,
.register-page .final-visibility-badge,
.register-page .final-review-summary span,
.register-page .final-review-summary small,
.register-page .final-meta-grid dt,
.register-page .final-file-block > header span,
.register-page .final-readiness > p {
  font-size: 10px;
}
.register-page .final-review-summary strong {
  font-size: 16px;
}
.register-page .final-meta-grid dd,
.register-page .final-description-block p,
.register-page .final-check-card .final-checks li {
  font-size: 12px;
  line-height: 1.55;
}
.register-page .final-check-card .final-checks li > strong {
  font-size: 10px;
}

@media (max-width: 700px) {
  .register-page .register-step-title {
    font-size: 13px;
  }
  .register-page .register-step-desc {
    font-size: 10px;
  }
  .register-page .registration-substeps > button strong {
    font-size: 12px;
  }
}
.register-page.is-recovery-modal-open > .register-header,
.register-page.is-recovery-modal-open > .register-main,
.register-page.is-exit-dialog-open > .register-header,
.register-page.is-exit-dialog-open > .register-main,
.register-page.is-final-confirm-open > .register-header,
.register-page.is-final-confirm-open > .register-main,
.register-page.is-registration-processing-open > .register-header,
.register-page.is-registration-processing-open > .register-main,
.register-page.is-overwrite-confirm-open > .register-header,
.register-page.is-overwrite-confirm-open > .register-main {
  pointer-events: none;
  user-select: none;
}

.registration-processing-backdrop {
  position: fixed;
  inset: 0;
  z-index: 2340;
  display: grid;
  place-items: center;
  width: 100vw;
  height: 100vh;
  height: 100dvh;
  box-sizing: border-box;
  padding: 24px;
  background: rgba(10, 29, 24, 0.72);
  backdrop-filter: blur(7px);
  animation: final-confirm-backdrop-in 160ms ease both;
}

.registration-processing-dialog {
  width: min(100%, 560px);
  overflow: hidden;
  border: 1px solid #c8d8d2;
  border-radius: 22px;
  background: #fff;
  box-shadow: 0 34px 100px rgba(3, 19, 14, 0.42);
  animation: final-confirm-dialog-in 210ms cubic-bezier(0.22, 0.78, 0.25, 1) both;
}

.registration-processing-header {
  display: grid;
  grid-template-columns: 54px minmax(0, 1fr);
  gap: 16px;
  align-items: center;
  padding: 28px;
  border-bottom: 1px solid #e1e9e6;
  background: linear-gradient(135deg, #f1f8f5, #fff);
}
.registration-processing-header h2 {
  margin: 0;
  color: #163c32;
  font-size: 22px;
  line-height: 1.35;
  letter-spacing: -0.03em;
}
.registration-processing-header div > p:last-child {
  margin: 7px 0 0;
  color: #687c75;
  font-size: 11px;
  line-height: 1.6;
}

.registration-processing-eyebrow {
  margin: 0 0 5px;
  color: #8f5a22;
  font-size: 9px;
  font-weight: 900;
  letter-spacing: 0.14em;
  text-transform: uppercase;
}

.registration-processing-icon {
  display: grid;
  place-items: center;
  width: 54px;
  height: 54px;
  border-radius: 16px;
  background: #e3f3ed;
  color: #28735d;
}
.registration-processing-icon svg {
  width: 30px;
  height: 30px;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-width: 2.2;
  animation: registration-processing-spin 900ms linear infinite;
}
.registration-processing-icon circle {
  opacity: 0.2;
}

.registration-processing-body {
  padding: 26px 28px 28px;
}

.registration-processing-state {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 5px 14px;
  align-items: end;
}
.registration-processing-state span {
  grid-column: 1/-1;
  color: #778983;
  font-size: 9px;
  font-weight: 850;
}
.registration-processing-state strong {
  min-width: 0;
  color: #245447;
  font-size: 14px;
  line-height: 1.4;
  overflow-wrap: anywhere;
}
.registration-processing-state em {
  color: #21614f;
  font-size: 20px;
  font-style: normal;
  font-weight: 950;
}

.registration-processing-track {
  height: 12px;
  margin-top: 16px;
  overflow: hidden;
  border-radius: 999px;
  background: #dfece7;
}
.registration-processing-track span {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, #2e7564, #3d927b);
  transition: width 220ms linear;
}

.registration-processing-meta {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  margin-top: 11px;
  color: #71837d;
  font-size: 9px;
}
.registration-processing-meta strong {
  color: #42685d;
}

.registration-processing-body > p {
  margin: 20px 0 0;
  padding: 13px 15px;
  border-radius: 11px;
  background: #f3f7f5;
  color: #687b75;
  font-size: 10px;
  line-height: 1.55;
  text-align: center;
}

@keyframes registration-processing-spin {
  to {
    transform: rotate(360deg);
  }
}
@media (max-width: 620px) {
  .registration-processing-backdrop {
    padding: 12px;
  }
  .registration-processing-dialog {
    border-radius: 17px;
  }
  .registration-processing-header {
    grid-template-columns: 46px minmax(0, 1fr);
    gap: 12px;
    padding: 22px 18px;
  }
  .registration-processing-icon {
    width: 46px;
    height: 46px;
  }
  .registration-processing-header h2 {
    font-size: 18px;
  }
  .registration-processing-body {
    padding: 22px 18px;
  }
}
@media (prefers-reduced-motion: reduce) {
  .registration-processing-backdrop,
  .registration-processing-dialog,
  .registration-processing-icon svg {
    animation-duration: 1ms !important;
  }
}
.overwrite-confirm-backdrop {
  position: fixed;
  inset: 0;
  z-index: 2300;
  display: grid;
  place-items: center;
  width: 100vw;
  height: 100vh;
  height: 100dvh;
  box-sizing: border-box;
  padding: 24px;
  overflow: auto;
  overscroll-behavior: contain;
  background: rgba(9, 27, 22, 0.68);
  backdrop-filter: blur(8px);
  animation: overwrite-confirm-backdrop-in 160ms ease both;
}

.overwrite-confirm-dialog {
  width: min(100%, 560px);
  max-height: calc(100vh - 48px);
  max-height: calc(100dvh - 48px);
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: auto;
  border: 1px solid #cbdad5;
  border-radius: 22px;
  background: #fff;
  box-shadow: 0 34px 100px rgba(3, 18, 14, 0.4), 0 2px 0 rgba(255, 255, 255, 0.75) inset;
  color: #183b33;
  animation: overwrite-confirm-dialog-in 210ms cubic-bezier(0.22, 0.78, 0.25, 1) both;
}

.overwrite-confirm-header {
  display: grid;
  grid-template-columns: 50px minmax(0, 1fr) 36px;
  gap: 0 14px;
  align-items: start;
  padding: 24px 24px 21px;
  border-bottom: 1px solid #e2ebe8;
  background: radial-gradient(circle at 8% 0%, rgba(255, 226, 163, 0.38), transparent 34%), linear-gradient(135deg, #fffcf6 0%, #fff 62%);
}

.overwrite-confirm-icon {
  display: grid;
  place-items: center;
  width: 50px;
  height: 50px;
  border-radius: 15px;
  background: linear-gradient(145deg, #fff0c7, #fff8e7);
  color: #b77408;
  box-shadow: 0 9px 22px rgba(170, 105, 7, 0.11), inset 0 0 0 1px rgba(183, 116, 8, 0.08);
}
.overwrite-confirm-icon svg {
  width: 26px;
  height: 26px;
}

.overwrite-confirm-eyebrow {
  margin: 1px 0 5px;
  color: #9d6310;
  font-size: 9px;
  font-weight: 900;
  letter-spacing: 0.15em;
  text-transform: uppercase;
}

.overwrite-confirm-header h2 {
  margin: 0;
  color: #173b32;
  font-size: 21px;
  font-weight: 950;
  line-height: 1.35;
  letter-spacing: -0.03em;
}

.overwrite-confirm-header div > p:last-child {
  margin: 7px 0 0;
  color: #687b75;
  font-size: 12px;
  font-weight: 650;
  line-height: 1.6;
  overflow-wrap: anywhere;
}

.overwrite-confirm-close {
  display: grid;
  place-items: center;
  width: 36px;
  height: 36px;
  padding: 0;
  border: 1px solid #d9e3e0;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.82);
  color: #667a74;
  cursor: pointer;
  transition: border-color 150ms ease, background 150ms ease, color 150ms ease;
}
.overwrite-confirm-close svg {
  width: 18px;
  height: 18px;
}
.overwrite-confirm-close:hover {
  border-color: #adbfba;
  background: #fff;
  color: #294f45;
}

.overwrite-confirm-file {
  display: grid;
  grid-template-columns: 42px minmax(0, 1fr) auto;
  gap: 12px;
  align-items: center;
  margin: 18px 24px 0;
  padding: 13px 14px;
  border: 1px solid #dce6e3;
  border-radius: 14px;
  background: #f7faf9;
}

.overwrite-confirm-file-icon {
  display: grid;
  place-items: center;
  width: 42px;
  height: 42px;
  border-radius: 12px;
  background: #e8f3ef;
  color: #2b6c59;
}
.overwrite-confirm-file-icon svg {
  width: 22px;
  height: 22px;
}

.overwrite-confirm-file > div {
  min-width: 0;
}
.overwrite-confirm-file > div span,
.overwrite-confirm-file > div small {
  display: block;
  color: #7a8c86;
  font-size: 9px;
  font-weight: 750;
  line-height: 1.45;
}
.overwrite-confirm-file > div strong {
  display: block;
  margin: 3px 0;
  color: #234c41;
  font-size: 13px;
  font-weight: 900;
  line-height: 1.45;
  overflow-wrap: anywhere;
}

.overwrite-confirm-file > em {
  align-self: center;
  border: 1px solid #cbded7;
  border-radius: 999px;
  padding: 5px 8px;
  background: #edf6f3;
  color: #2f6a59;
  font-size: 9px;
  font-style: normal;
  font-weight: 900;
  white-space: nowrap;
}

.overwrite-confirm-impact {
  display: flex;
  align-items: flex-start;
  gap: 11px;
  margin: 12px 24px 0;
  padding: 14px 15px;
  border: 1px solid #edcf97;
  border-radius: 14px;
  background: linear-gradient(135deg, #fff8e9, #fffcf6);
}
.overwrite-confirm-impact > span {
  display: grid;
  flex: 0 0 auto;
  place-items: center;
  width: 30px;
  height: 30px;
  border-radius: 9px;
  background: #ffedc4;
  color: #ab6a09;
}
.overwrite-confirm-impact > span svg {
  width: 17px;
  height: 17px;
}
.overwrite-confirm-impact strong {
  display: block;
  color: #7d4d0c;
  font-size: 11px;
  font-weight: 900;
  line-height: 1.5;
}
.overwrite-confirm-impact ul {
  display: grid;
  gap: 3px;
  margin: 5px 0 0;
  padding-left: 16px;
  color: #7b6650;
  font-size: 10px;
  font-weight: 650;
  line-height: 1.55;
}

.overwrite-confirm-scope {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin: 10px 24px 0;
  padding: 10px 12px;
  border-radius: 11px;
  background: #eef6f3;
  color: #42685d;
}
.overwrite-confirm-scope svg {
  flex: 0 0 auto;
  width: 16px;
  height: 16px;
  margin-top: 1px;
}
.overwrite-confirm-scope p {
  margin: 0;
  font-size: 9px;
  font-weight: 750;
  line-height: 1.6;
}

.overwrite-confirm-actions {
  display: flex;
  justify-content: flex-end;
  gap: 9px;
  padding: 18px 24px 24px;
}
.overwrite-confirm-actions button {
  min-height: 44px;
  border-radius: 10px;
  padding: 0 17px;
  font-size: 11px;
  font-weight: 900;
  cursor: pointer;
  transition: border-color 150ms ease, background 150ms ease, color 150ms ease, box-shadow 150ms ease, transform 150ms ease;
}
.overwrite-confirm-actions button:active {
  transform: translateY(1px);
}

.overwrite-confirm-secondary {
  min-width: 76px;
  border: 1px solid #ccd9d5;
  background: #fff;
  color: #506a62;
}
.overwrite-confirm-secondary:hover {
  border-color: #9fb5ae;
  background: #f7faf9;
  color: #294f44;
}

.overwrite-confirm-primary {
  display: inline-flex;
  min-width: 178px;
  align-items: center;
  justify-content: center;
  gap: 7px;
  border: 1px solid #a76506;
  background: linear-gradient(135deg, #c7810b, #a96706);
  color: #fff;
  box-shadow: 0 10px 24px rgba(169, 103, 6, 0.22);
}
.overwrite-confirm-primary svg {
  width: 17px;
  height: 17px;
}
.overwrite-confirm-primary:hover {
  border-color: #8c5403;
  background: linear-gradient(135deg, #b87308, #8f5604);
  box-shadow: 0 12px 28px rgba(150, 89, 4, 0.28);
}

.overwrite-confirm-close:focus-visible,
.overwrite-confirm-secondary:focus-visible,
.overwrite-confirm-primary:focus-visible {
  outline: 3px solid rgba(180, 113, 10, 0.2);
  outline-offset: 2px;
}

@keyframes overwrite-confirm-backdrop-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes overwrite-confirm-dialog-in {
  from {
    opacity: 0;
    transform: translateY(10px) scale(0.985);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@media (max-width: 600px) {
  .overwrite-confirm-backdrop {
    align-items: end;
    padding: 10px;
  }
  .overwrite-confirm-dialog {
    max-height: calc(100vh - 20px);
    max-height: calc(100dvh - 20px);
    border-radius: 20px;
  }
  .overwrite-confirm-header {
    grid-template-columns: 44px minmax(0, 1fr) 34px;
    gap: 0 11px;
    padding: 20px 17px 18px;
  }
  .overwrite-confirm-icon {
    width: 44px;
    height: 44px;
    border-radius: 13px;
  }
  .overwrite-confirm-icon svg {
    width: 23px;
    height: 23px;
  }
  .overwrite-confirm-header h2 {
    font-size: 18px;
  }
  .overwrite-confirm-close {
    width: 34px;
    height: 34px;
  }
  .overwrite-confirm-file,
  .overwrite-confirm-impact,
  .overwrite-confirm-scope {
    margin-right: 17px;
    margin-left: 17px;
  }
  .overwrite-confirm-file {
    grid-template-columns: 38px minmax(0, 1fr);
  }
  .overwrite-confirm-file > em {
    grid-column: 2;
    justify-self: start;
  }
  .overwrite-confirm-actions {
    flex-direction: column-reverse;
    padding: 17px;
  }
  .overwrite-confirm-actions button {
    width: 100%;
  }
}
@media (prefers-reduced-motion: reduce) {
  .overwrite-confirm-backdrop,
  .overwrite-confirm-dialog {
    animation: none;
  }
}
.final-confirm-backdrop {
  position: fixed;
  inset: 0;
  z-index: 2280;
  display: grid;
  place-items: center;
  width: 100vw;
  height: 100vh;
  height: 100dvh;
  box-sizing: border-box;
  padding: 24px;
  overflow: auto;
  overscroll-behavior: contain;
  background: rgba(10, 29, 24, 0.72);
  backdrop-filter: blur(7px);
  animation: final-confirm-backdrop-in 160ms ease both;
}

.final-confirm-dialog {
  width: min(100%, 680px);
  max-height: calc(100vh - 48px);
  max-height: calc(100dvh - 48px);
  box-sizing: border-box;
  padding: 0;
  overflow-x: hidden;
  overflow-y: auto;
  border: 1px solid #c8d8d2;
  border-radius: 22px;
  background: #fff;
  box-shadow: 0 34px 100px rgba(3, 19, 14, 0.42), 0 2px 0 rgba(255, 255, 255, 0.72) inset;
  animation: final-confirm-dialog-in 210ms cubic-bezier(0.22, 0.78, 0.25, 1) both;
}

.final-confirm-header {
  position: relative;
  display: grid;
  grid-template-columns: 54px minmax(0, 1fr) 38px;
  gap: 0 16px;
  align-items: start;
  padding: 28px 28px 24px;
  border-bottom: 1px solid #e1e9e6;
  background: radial-gradient(circle at 10% 0%, rgba(206, 237, 226, 0.62), transparent 34%), linear-gradient(135deg, #f9fcfb, #fff);
}

.final-confirm-icon {
  display: grid;
  place-items: center;
  width: 54px;
  height: 54px;
  border-radius: 16px;
  background: linear-gradient(145deg, #dff2ea, #edf8f4);
  color: #28735d;
  box-shadow: 0 9px 22px rgba(40, 115, 93, 0.12), inset 0 0 0 1px rgba(40, 115, 93, 0.08);
}
.final-confirm-icon svg {
  width: 28px;
  height: 28px;
}

.final-confirm-eyebrow {
  margin: 1px 0 6px;
  color: #8f5a22;
  font-size: 10px;
  font-weight: 900;
  letter-spacing: 0.14em;
  text-transform: uppercase;
}

.final-confirm-header h2 {
  margin: 0;
  color: #163c32;
  font-size: 23px;
  line-height: 1.3;
  letter-spacing: -0.03em;
}

.final-confirm-header div > p:last-child {
  margin: 8px 0 0;
  color: #687c75;
  font-size: 12px;
  line-height: 1.6;
  overflow-wrap: anywhere;
}

.final-confirm-close {
  display: grid;
  place-items: center;
  width: 38px;
  height: 38px;
  padding: 0;
  border: 1px solid #d7e1de;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.78);
  color: #60766f;
  cursor: pointer;
  transition: border-color 150ms ease, background 150ms ease, color 150ms ease;
}
.final-confirm-close svg {
  width: 18px;
  height: 18px;
}
.final-confirm-close:hover {
  border-color: #aebfba;
  background: #fff;
  color: #284f45;
}
.final-confirm-close:focus-visible {
  outline: 3px solid rgba(47, 123, 101, 0.18);
  outline-offset: 2px;
}

.final-confirm-summary {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
  margin: 0;
  padding: 22px 28px 0;
}
.final-confirm-summary > div {
  position: relative;
  min-width: 0;
  padding: 15px 16px 14px;
  overflow: hidden;
  border: 1px solid #dbe5e2;
  border-radius: 13px;
  background: #f7faf9;
}
.final-confirm-summary > div::after {
  position: absolute;
  top: 0;
  right: 0;
  width: 34px;
  height: 34px;
  border-radius: 0 0 0 34px;
  background: rgba(44, 119, 96, 0.07);
  content: "";
}
.final-confirm-summary > div.has-warning {
  border-color: #e9cd9c;
  background: #fffaf0;
}
.final-confirm-summary > div.has-warning::after {
  background: rgba(184, 119, 21, 0.1);
}
.final-confirm-summary > div.has-warning dd {
  color: #905b13;
}
.final-confirm-summary dt {
  color: #74867f;
  font-size: 9px;
  font-weight: 850;
}
.final-confirm-summary dd {
  margin: 6px 0 3px;
  color: #245447;
  font-size: 16px;
  font-weight: 950;
  line-height: 1.3;
  letter-spacing: -0.02em;
  overflow-wrap: anywhere;
}
.final-confirm-summary small {
  display: block;
  color: #81908b;
  font-size: 8px;
  line-height: 1.45;
}

.final-confirm-note {
  display: flex;
  align-items: flex-start;
  gap: 11px;
  margin: 14px 28px 0;
  padding: 14px 16px;
  border: 1px solid #cfe0da;
  border-radius: 13px;
  background: #f1f8f5;
  color: #2d6555;
}
.final-confirm-note > svg {
  flex: 0 0 auto;
  width: 19px;
  height: 19px;
  margin-top: 1px;
}
.final-confirm-note strong {
  display: block;
  color: #265748;
  font-size: 11px;
  line-height: 1.5;
}
.final-confirm-note p {
  margin: 3px 0 0;
  color: #687d75;
  font-size: 10px;
  line-height: 1.6;
  overflow-wrap: anywhere;
}

.final-confirm-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 22px 28px 28px;
}

.final-confirm-secondary,
.final-confirm-primary {
  min-height: 44px;
  padding: 10px 18px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 900;
  cursor: pointer;
  transition: border-color 150ms ease, background 150ms ease, color 150ms ease, box-shadow 150ms ease, transform 150ms ease;
}
.final-confirm-secondary:active,
.final-confirm-primary:active {
  transform: translateY(1px);
}
.final-confirm-secondary:focus-visible,
.final-confirm-primary:focus-visible {
  outline: 3px solid rgba(47, 123, 101, 0.18);
  outline-offset: 2px;
}

.final-confirm-secondary {
  border: 1px solid #cbd8d4;
  background: #fff;
  color: #506a62;
}
.final-confirm-secondary:hover {
  border-color: #9eb4ad;
  background: #f7faf9;
  color: #294f44;
}

.final-confirm-primary {
  display: inline-flex;
  min-width: 154px;
  align-items: center;
  justify-content: center;
  gap: 7px;
  border: 1px solid #23624f;
  background: linear-gradient(135deg, #2c7660, #205846);
  color: #fff;
  box-shadow: 0 10px 24px rgba(35, 98, 79, 0.22);
}
.final-confirm-primary svg {
  width: 17px;
  height: 17px;
}
.final-confirm-primary:hover {
  border-color: #194b3b;
  background: linear-gradient(135deg, #256851, #194b3b);
  box-shadow: 0 12px 28px rgba(35, 98, 79, 0.28);
}

@keyframes final-confirm-backdrop-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes final-confirm-dialog-in {
  from {
    opacity: 0;
    transform: translateY(12px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@media (max-width: 620px) {
  .final-confirm-backdrop {
    padding: 12px;
  }
  .final-confirm-dialog {
    max-height: calc(100vh - 24px);
    max-height: calc(100dvh - 24px);
    border-radius: 17px;
  }
  .final-confirm-header {
    grid-template-columns: 46px minmax(0, 1fr) 34px;
    gap: 0 12px;
    padding: 22px 18px 20px;
  }
  .final-confirm-icon {
    width: 46px;
    height: 46px;
    border-radius: 13px;
  }
  .final-confirm-icon svg {
    width: 24px;
    height: 24px;
  }
  .final-confirm-header h2 {
    font-size: 19px;
  }
  .final-confirm-close {
    width: 34px;
    height: 34px;
  }
  .final-confirm-summary {
    grid-template-columns: 1fr;
    padding: 18px 18px 0;
  }
  .final-confirm-note {
    margin: 12px 18px 0;
  }
  .final-confirm-actions {
    flex-direction: column-reverse;
    padding: 18px;
  }
  .final-confirm-secondary,
  .final-confirm-primary {
    width: 100%;
  }
}
@media (prefers-reduced-motion: reduce) {
  .final-confirm-backdrop,
  .final-confirm-dialog {
    animation-duration: 1ms !important;
  }
}
.registration-exit-backdrop {
  position: fixed;
  inset: 0;
  z-index: 2250;
  display: grid;
  place-items: center;
  width: 100vw;
  height: 100vh;
  height: 100dvh;
  box-sizing: border-box;
  padding: 24px;
  overflow: auto;
  overscroll-behavior: contain;
  background: rgba(12, 28, 24, 0.68);
  backdrop-filter: blur(6px);
  animation: registration-exit-backdrop-in 160ms ease both;
}

.registration-exit-dialog {
  width: min(100%, 620px);
  max-height: calc(100vh - 48px);
  max-height: calc(100dvh - 48px);
  box-sizing: border-box;
  padding: 30px;
  overflow-x: hidden;
  overflow-y: auto;
  border: 1px solid #cad8d3;
  border-radius: 20px;
  background: #fff;
  box-shadow: 0 32px 90px rgba(4, 20, 15, 0.38);
  animation: registration-exit-dialog-in 210ms cubic-bezier(0.22, 0.78, 0.25, 1) both;
}

.registration-exit-header {
  display: grid;
  grid-template-columns: 52px minmax(0, 1fr);
  gap: 0 18px;
  align-items: start;
}

.registration-exit-icon {
  display: grid;
  place-items: center;
  width: 52px;
  height: 52px;
  border-radius: 15px;
  background: #fff3d8;
  color: #a86a08;
}
.registration-exit-icon svg {
  width: 27px;
  height: 27px;
}

.registration-exit-eyebrow {
  margin: 1px 0 6px;
  color: #9b6418;
  font-size: 10px;
  font-weight: 900;
  letter-spacing: 0.14em;
}

.registration-exit-header h2 {
  margin: 0;
  color: #173c33;
  font-size: 22px;
  line-height: 1.35;
  letter-spacing: -0.025em;
}

.registration-exit-header div:last-child > p:last-child {
  margin: 9px 0 0;
  color: #657a72;
  font-size: 13px;
  line-height: 1.65;
  overflow-wrap: anywhere;
}

.registration-exit-processing {
  display: flex;
  align-items: flex-start;
  gap: 11px;
  margin-top: 22px;
  padding: 14px 16px;
  border: 1px solid #c8ddd5;
  border-radius: 12px;
  background: #f1f8f5;
}
.registration-exit-processing > span {
  flex: 0 0 auto;
  width: 8px;
  height: 8px;
  margin-top: 6px;
  border-radius: 50%;
  background: #2d7b61;
  box-shadow: 0 0 0 4px rgba(45, 123, 97, 0.12);
}
.registration-exit-processing strong {
  display: block;
  color: #245445;
  font-size: 12px;
  line-height: 1.5;
}
.registration-exit-processing p {
  margin: 3px 0 0;
  color: #667b73;
  font-size: 11px;
  line-height: 1.55;
}

.registration-exit-summary {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  margin: 22px 0 0;
}
.registration-exit-summary > div {
  min-width: 0;
  padding: 15px 16px;
  border: 1px solid #dde6e3;
  border-radius: 12px;
  background: #f8faf9;
}
.registration-exit-summary dt {
  color: #768981;
  font-size: 10px;
  font-weight: 800;
}
.registration-exit-summary dd {
  margin: 5px 0 0;
  color: #264c41;
  font-size: 13px;
  font-weight: 900;
  line-height: 1.45;
  overflow-wrap: anywhere;
}

.registration-exit-warning {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-top: 12px;
  padding: 14px 16px;
  border: 1px solid #edd3a8;
  border-radius: 12px;
  background: #fff9ed;
  color: #89591a;
}
.registration-exit-warning svg {
  flex: 0 0 auto;
  width: 18px;
  height: 18px;
  margin-top: 1px;
}
.registration-exit-warning p {
  margin: 0;
  font-size: 11px;
  line-height: 1.6;
}
.registration-exit-warning strong {
  color: #74460d;
}

.registration-exit-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 24px;
}

.registration-exit-discard,
.registration-exit-continue {
  min-height: 44px;
  padding: 10px 18px;
  border-radius: 9px;
  font-size: 12px;
  font-weight: 900;
  cursor: pointer;
  transition: border-color 150ms ease, background 150ms ease, color 150ms ease, transform 150ms ease;
}
.registration-exit-discard:active,
.registration-exit-continue:active {
  transform: translateY(1px);
}

.registration-exit-discard {
  border: 1px solid #d9b985;
  background: #fff;
  color: #946116;
}
.registration-exit-discard:hover {
  border-color: #c68d35;
  background: #fff8eb;
}

.registration-exit-continue {
  min-width: 142px;
  border: 1px solid #245f4c;
  background: #245f4c;
  color: #fff;
  box-shadow: 0 8px 20px rgba(36, 95, 76, 0.18);
}
.registration-exit-continue:hover {
  border-color: #194d3c;
  background: #194d3c;
}
.registration-exit-continue:focus-visible {
  outline: 3px solid rgba(58, 132, 105, 0.24);
  outline-offset: 2px;
}

@keyframes registration-exit-backdrop-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes registration-exit-dialog-in {
  from {
    opacity: 0;
    transform: translateY(10px) scale(0.985);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@media (max-width: 560px) {
  .registration-exit-backdrop {
    padding: 12px;
  }
  .registration-exit-dialog {
    max-height: calc(100vh - 24px);
    max-height: calc(100dvh - 24px);
    padding: 22px 18px 18px;
    border-radius: 15px;
  }
  .registration-exit-header {
    grid-template-columns: 44px minmax(0, 1fr);
    gap: 0 12px;
  }
  .registration-exit-icon {
    width: 44px;
    height: 44px;
    border-radius: 12px;
  }
  .registration-exit-icon svg {
    width: 23px;
    height: 23px;
  }
  .registration-exit-header h2 {
    font-size: 18px;
  }
  .registration-exit-summary {
    grid-template-columns: 1fr;
  }
  .registration-exit-actions {
    flex-direction: column-reverse;
  }
  .registration-exit-discard,
  .registration-exit-continue {
    width: 100%;
  }
}
@media (prefers-reduced-motion: reduce) {
  .registration-exit-backdrop,
  .registration-exit-dialog {
    animation-duration: 1ms !important;
  }
}
.recovery-modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 2200;
  display: grid;
  place-items: center;
  width: 100vw;
  height: 100vh;
  height: 100dvh;
  box-sizing: border-box;
  padding: 24px;
  overflow: auto;
  overscroll-behavior: contain;
  background: rgba(10, 25, 21, 0.7);
  backdrop-filter: blur(5px);
  animation: recovery-backdrop-in 160ms ease both;
}

.recovery-modal {
  position: relative;
  width: min(100%, 560px);
  max-height: calc(100vh - 48px);
  max-height: calc(100dvh - 48px);
  box-sizing: border-box;
  display: grid;
  grid-template-columns: 54px minmax(0, 1fr);
  gap: 0 18px;
  padding: 30px;
  overflow-x: hidden;
  overflow-y: auto;
  border: 1px solid #c7d6d1;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 30px 90px rgba(4, 20, 15, 0.38);
  animation: recovery-modal-in 200ms cubic-bezier(0.22, 0.78, 0.25, 1) both;
}

.recovery-modal-icon {
  grid-column: 1;
  display: grid;
  place-items: center;
  width: 54px;
  height: 54px;
  border-radius: 14px;
  background: #eaf4f0;
  color: #23634f;
}
.recovery-modal-icon svg {
  width: 27px;
  height: 27px;
}
.recovery-modal-icon.is-success {
  background: #e5f4ed;
  color: #1d7758;
}
.recovery-modal-icon.is-error {
  background: #fff0eb;
  color: #a74732;
}

.recovery-modal-spinner {
  animation: recovery-spinner 900ms linear infinite;
}

.recovery-modal-copy {
  grid-column: 2;
  min-width: 0;
}
.recovery-modal-copy h2 {
  margin: 3px 0 8px;
  color: #173c33;
  font-size: 22px;
  line-height: 1.3;
  overflow-wrap: anywhere;
}
.recovery-modal-copy > p:last-child {
  margin: 0;
  color: #647871;
  font-size: 13px;
  line-height: 1.65;
  overflow-wrap: anywhere;
}

.recovery-modal-eyebrow {
  margin: 0;
  color: #6d817a;
  font-size: 10px;
  font-weight: 900;
  letter-spacing: 0.14em;
}

.recovery-progress-panel,
.recovery-error-panel,
.recovery-workspace-summary,
.recovery-modal-actions {
  grid-column: 1/-1;
}

.recovery-workspace-summary {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  margin: 18px 0 0;
}

.recovery-workspace-summary div {
  min-width: 0;
  padding: 10px 12px;
  border: 1px solid #dbe6e2;
  border-radius: 10px;
  background: #f7faf9;
}

.recovery-workspace-summary dt {
  color: #74867f;
  font-size: 9px;
  font-weight: 850;
}

.recovery-workspace-summary dd {
  margin: 4px 0 0;
  color: #224b40;
  font-size: 11px;
  font-weight: 900;
  overflow-wrap: anywhere;
}

.recovery-progress-panel {
  margin-top: 24px;
  padding: 18px;
  border: 1px solid #dbe6e2;
  border-radius: 12px;
  background: #f7faf9;
}

.recovery-progress-heading {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
}
.recovery-progress-heading div {
  min-width: 0;
}
.recovery-progress-heading span {
  display: block;
  margin-bottom: 4px;
  color: #74867f;
  font-size: 10px;
  font-weight: 800;
}
.recovery-progress-heading strong {
  display: block;
  color: #224b40;
  font-size: 15px;
  line-height: 1.45;
  overflow-wrap: anywhere;
}
.recovery-progress-heading em {
  flex: 0 0 auto;
  color: #276951;
  font-size: 12px;
  font-style: normal;
  font-weight: 900;
  white-space: nowrap;
}

.recovery-progress-track {
  position: relative;
  height: 9px;
  margin-top: 14px;
  overflow: hidden;
  border-radius: 999px;
  background: #dce8e4;
}
.recovery-progress-track > span {
  position: absolute;
  inset: 0 auto 0 0;
  border-radius: inherit;
  background: linear-gradient(90deg, #397d67, #6fab91);
  transition: width 220ms ease;
}
.recovery-progress-track.is-indeterminate .recovery-progress-indeterminate {
  width: 38%;
  background: linear-gradient(90deg, transparent, #4f927a 38%, #85b69f 62%, transparent);
  animation: recovery-progress-indeterminate 1.25s ease-in-out infinite;
}

.recovery-current-stage {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin: 12px 0 0;
  color: #536a62;
  font-size: 12px;
  line-height: 1.55;
  overflow-wrap: anywhere;
}
.recovery-current-stage span {
  flex: 0 0 auto;
  width: 7px;
  height: 7px;
  margin-top: 6px;
  border-radius: 50%;
  background: #4d8a74;
  box-shadow: 0 0 0 4px rgba(77, 138, 116, 0.12);
}

.recovery-error-panel {
  margin-top: 24px;
  padding: 16px 18px;
  border: 1px solid #efc9bd;
  border-radius: 12px;
  background: #fff6f2;
}
.recovery-error-panel strong {
  display: block;
  color: #963f2c;
  font-size: 13px;
  line-height: 1.55;
  overflow-wrap: anywhere;
}
.recovery-error-panel p {
  margin: 6px 0 0;
  color: #825e54;
  font-size: 11px;
  line-height: 1.55;
}

.recovery-modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 26px;
}

.recovery-primary-btn,
.recovery-secondary-btn {
  min-height: 42px;
  min-width: 122px;
  padding: 10px 17px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 900;
  cursor: pointer;
}
.recovery-primary-btn:disabled,
.recovery-secondary-btn:disabled {
  cursor: not-allowed;
  opacity: 0.58;
}

.recovery-primary-btn {
  border: 1px solid #28664f;
  background: #28664f;
  color: #fff;
}
.recovery-primary-btn:hover:not(:disabled) {
  border-color: #1f5641;
  background: #1f5641;
}

.recovery-secondary-btn {
  border: 1px solid #cbd8d4;
  background: #fff;
  color: #4d655d;
}
.recovery-secondary-btn:hover:not(:disabled) {
  background: #f3f7f5;
}

@keyframes recovery-backdrop-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes recovery-modal-in {
  from {
    opacity: 0;
    transform: translateY(10px) scale(0.985);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@keyframes recovery-spinner {
  to {
    transform: rotate(360deg);
  }
}
@keyframes recovery-progress-indeterminate {
  from {
    transform: translateX(-115%);
  }
  to {
    transform: translateX(360%);
  }
}
@media (max-width: 560px) {
  .recovery-modal-backdrop {
    place-items: center;
    padding: 12px;
  }
  .recovery-modal {
    max-height: calc(100vh - 24px);
    max-height: calc(100dvh - 24px);
    grid-template-columns: 44px minmax(0, 1fr);
    gap: 0 12px;
    padding: 22px 18px;
    border-radius: 12px;
  }
  .recovery-modal-icon {
    width: 44px;
    height: 44px;
    border-radius: 11px;
  }
  .recovery-modal-icon svg {
    width: 23px;
    height: 23px;
  }
  .recovery-modal-copy h2 {
    margin-top: 1px;
    font-size: 18px;
  }
  .recovery-modal-copy > p:last-child {
    grid-column: 1/-1;
    font-size: 12px;
  }
  .recovery-progress-panel,
  .recovery-error-panel {
    margin-top: 20px;
    padding: 15px;
  }
  .recovery-workspace-summary {
    grid-template-columns: 1fr;
  }
  .recovery-progress-heading {
    align-items: flex-start;
  }
  .recovery-progress-heading strong {
    font-size: 14px;
  }
  .recovery-modal-actions {
    flex-direction: column-reverse;
    margin-top: 20px;
  }
  .recovery-primary-btn,
  .recovery-secondary-btn {
    width: 100%;
    min-width: 0;
  }
}
@media (max-height: 540px) {
  .recovery-modal-backdrop {
    place-items: start center;
  }
}
@media (prefers-reduced-motion: reduce) {
  .recovery-modal-backdrop,
  .recovery-modal,
  .recovery-modal-spinner,
  .recovery-progress-track > span {
    animation-duration: 1ms !important;
    transition-duration: 1ms !important;
  }
}
.register-page {
  --registration-footer-reserve: 112px;
}
.register-page .workbench-head-badges {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 7px;
}
.register-page .work-scope-pill {
  display: inline-flex;
  max-width: min(420px, 42vw);
  align-items: center;
  padding: 7px 10px;
  overflow: hidden;
  border: 1px solid #c9dbd6;
  border-radius: var(--register-radius-sm);
  background: #eef7f4;
  color: #275e52;
  font-size: 11px;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.register-page .batch-recovery-banner {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 14px;
  margin: 18px 22px 14px;
  padding: 13px 14px;
  border: 1px solid #e4b8a7;
  border-radius: var(--register-radius-md);
  background: #fff7f3;
}
.register-page .batch-recovery-banner strong {
  color: #854632;
  font-size: 13px;
}
.register-page .batch-recovery-banner p {
  margin: 3px 0 0;
  color: #8b695e;
  font-size: 11px;
  line-height: 1.5;
}
.register-page .batch-recovery-counts {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}
.register-page .batch-recovery-counts span {
  padding: 5px 8px;
  border-radius: 999px;
  background: #f8e3dc;
  color: #8d4a35;
  font-size: 10px;
  font-weight: 900;
  white-space: nowrap;
}
.register-page .analysis-file-queue li {
  grid-template-columns: 22px minmax(0, 1fr) auto auto;
}
.register-page .analysis-file-queue li > button {
  padding: 4px 7px;
  border: 1px solid #e0b6ab;
  border-radius: 6px;
  background: #fff;
  color: #9c4d3a;
  font-size: 10px;
  font-weight: 900;
}
.register-page .error-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 8px;
}
.register-page .error-actions button {
  padding: 6px 9px;
  border: 1px solid #dcae9f;
  border-radius: 7px;
  background: #fff;
  color: #914734;
  font-size: 10px;
  font-weight: 900;
}
.register-page .technical-error-details {
  grid-column: 2/-1;
  width: 100%;
  max-height: 180px;
  margin: 9px 0 0;
  padding: 10px;
  overflow: auto;
  border: 1px solid #d8c8c4;
  border-radius: 8px;
  background: #2d2928;
  color: #f5e9e6;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 10px;
  line-height: 1.55;
  white-space: pre-wrap;
}
.register-page .registration-substeps > button.is-attention {
  border-color: #dfbd7b;
  background: #fffaf0;
  color: #7c5b23;
}
.register-page .registration-substeps > button.is-attention > span:first-child {
  border-color: #d6ae65;
  background: #fff0cf;
  color: #83591c;
}
.register-page .review-control-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 12px 13px;
  border: 1px solid #d5e2de;
  border-radius: var(--register-radius-md);
  background: #f6faf8;
}
.register-page .review-control-summary {
  display: grid;
  grid-template-columns: auto auto;
  align-items: baseline;
  gap: 3px 7px;
  min-width: 190px;
}
.register-page .review-control-summary span {
  color: #788a84;
  font-size: 10px;
  font-weight: 850;
}
.register-page .review-control-summary strong {
  color: #255d51;
  font-size: 14px;
}
.register-page .review-control-summary em {
  grid-column: 1/-1;
  color: #71817c;
  font-size: 10px;
  font-style: normal;
  font-weight: 800;
}
.register-page .review-control-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 6px;
}
.register-page .review-control-actions button {
  padding: 7px 9px;
  border: 1px solid #cfdbd8;
  border-radius: 7px;
  background: #fff;
  color: #60716c;
  font-size: 10px;
  font-weight: 900;
}
.register-page .review-control-actions button.is-active {
  border-color: #2c685b;
  background: #e9f4f0;
  color: #245e51;
}
.register-page .review-control-actions .review-confirm-btn.is-confirmed {
  border-color: #78aa9b;
  background: #dff1eb;
  color: #1f6655;
}
.register-page .review-control-actions .review-next-btn {
  border-color: #c69466;
  background: #fff8ef;
  color: #845126;
}
.register-page .file-review-task-board {
  display: grid;
  gap: 12px;
  padding: 16px;
  border: 1px solid #d8e0e8;
  border-radius: var(--register-radius-md);
  background: #fff;
}
.register-page .file-review-task-head,
.register-page .file-review-task-card > header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
}
.register-page .file-review-task-head h3 {
  margin: 3px 0 0;
  color: #203a51;
  font-size: 16px;
}
.register-page .file-review-task-head p,
.register-page .file-review-task-card > header p,
.register-page .file-review-task-reason {
  margin: 4px 0 0;
  color: #68798a;
  font-size: 11px;
  line-height: 1.55;
}
.register-page .file-review-task-head > strong {
  flex: 0 0 auto;
  color: #325c7e;
  font-size: 12px;
}
.register-page .file-review-task-list {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 9px;
}
.register-page .file-review-task-card {
  min-width: 0;
  padding: 13px;
  border: 1px solid #dfe5eb;
  border-radius: 9px;
  background: #fbfcfd;
}
.register-page .file-review-task-card.is-review_required {
  background: #fffaf3;
}
.register-page .file-review-task-card.is-complete {
  background: #f5fbf8;
}
.register-page .file-review-task-card.is-failed {
  background: #fff7f6;
}
.register-page .file-review-task-card.is-not_applicable {
  background: #f7f8fa;
}
.register-page .file-review-task-card > header strong {
  color: #263c50;
  font-size: 12px;
}
.register-page .file-review-task-status {
  flex: 0 0 auto;
  padding: 4px 7px;
  border-radius: 999px;
  background: #e7edf2;
  color: #5d6c79;
  font-size: 9px;
  font-weight: 900;
}
.register-page .file-review-task-status.is-review_required {
  background: #f9e8ca;
  color: #86571d;
}
.register-page .file-review-task-status.is-complete {
  background: #dcefe8;
  color: #246653;
}
.register-page .file-review-task-status.is-failed {
  background: #f7dedb;
  color: #96483f;
}
.register-page .file-review-task-facts,
.register-page .file-review-language-list {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-top: 9px;
}
.register-page .file-review-task-facts span,
.register-page .file-review-language-list span {
  padding: 4px 6px;
  border-radius: 5px;
  background: #edf2f6;
  color: #536b7d;
  font-size: 9px;
  font-weight: 850;
}
.register-page .file-review-compare-list {
  display: grid;
  gap: 7px;
  max-height: 340px;
  margin-top: 10px;
  overflow: auto;
}
.register-page .file-review-compare-row {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 7px;
}
.register-page .file-review-compare-row > div {
  min-width: 0;
  padding: 8px;
  border: 1px solid #e3e8ed;
  border-radius: 7px;
  background: #fff;
}
.register-page .file-review-compare-row span {
  color: #71808c;
  font-size: 9px;
  font-weight: 900;
}
.register-page .file-review-compare-row p {
  max-height: 100px;
  margin: 4px 0 0;
  overflow: auto;
  color: #33495c;
  font-size: 10px;
  line-height: 1.55;
  white-space: pre-wrap;
}
.register-page .file-review-task-history {
  margin-top: 9px;
  color: #586b7a;
  font-size: 10px;
}
.register-page .file-review-task-history ol {
  display: grid;
  gap: 5px;
  margin: 7px 0 0;
  padding-left: 18px;
}
.register-page .file-review-task-history li {
  display: grid;
  grid-template-columns: auto 1fr auto;
  gap: 6px;
}
.register-page .file-review-task-empty {
  padding: 14px;
  border: 1px dashed #cdd6dd;
  border-radius: var(--register-radius-md);
  background: #f8fafb;
}
.register-page .file-review-task-empty strong {
  color: #475d6d;
  font-size: 12px;
}
.register-page .file-review-task-empty p {
  margin: 4px 0 0;
  color: #71808c;
  font-size: 10px;
}
.register-page .review-file-switcher button.needs-attention {
  border-color: #ddbd83;
  background: #fffaf1;
}
.register-page .review-filter-empty {
  margin: 0;
  padding: 5px 8px;
  color: #72827d;
  font-size: 10px;
}
.register-page .direct-text-review {
  display: grid;
  gap: 11px;
  margin-top: 14px;
  padding: 15px;
  border: 1px solid #bfd9d1;
  border-radius: var(--register-radius-md);
  background: #f3f9f7;
}
.register-page .direct-text-review > header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
}
.register-page .direct-text-review > header strong {
  color: #234f45;
  font-size: 13px;
}
.register-page .direct-text-review > header p,
.register-page .direct-text-review > p {
  margin: 4px 0 0;
  color: #647a74;
  font-size: 11px;
  line-height: 1.55;
}
.register-page .direct-text-review > header > span {
  flex: 0 0 auto;
  padding: 5px 8px;
  border-radius: 999px;
  background: #dcefe9;
  color: #236052;
  font-size: 10px;
  font-weight: 900;
}
.register-page .direct-text-review textarea {
  width: 100%;
  min-height: 320px;
  padding: 12px;
  resize: vertical;
  border: 1px solid #c9d9d5;
  border-radius: 8px;
  background: #fff;
  color: #2c403b;
  font: inherit;
  font-size: 13px;
  line-height: 1.75;
}
.register-page .final-review-summary {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}
.register-page .final-review-summary article.has-warning {
  border-color: #e7ce9a;
  background: #fffbf2;
}
.register-page .final-review-summary article.is-error {
  border-color: #dfb5aa;
  background: #fff7f4;
}
.register-page .final-review-summary article.is-saving,
.register-page .final-review-summary article.is-pending {
  border-color: #dec68c;
  background: #fffbef;
}
.register-page .final-file-list > div {
  grid-template-columns: 24px minmax(0, 1fr) auto;
  align-items: center;
}
.register-page .final-file-list > div > div {
  min-width: 0;
}
.register-page .final-file-list > div > div strong,
.register-page .final-file-list > div > div small {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.register-page .final-file-list > div > div small {
  margin-top: 3px;
  color: #7d8d88;
  font-size: 9px;
}
.register-page .final-file-list > div.is-error {
  border-color: #e4c0b6;
  background: #fff7f4;
}
.register-page .final-file-list > div.is-error em {
  color: #9c4937;
}
.register-page .partial-registration-warning {
  display: grid;
  gap: 7px;
  margin-bottom: 14px;
  padding: 11px;
  border: 1px solid #dfad98;
  border-radius: var(--register-radius-md);
  background: #fff5f1;
}
.register-page .partial-registration-warning strong {
  color: #884430;
  font-size: 11px;
}
.register-page .partial-registration-warning p {
  margin: 0;
  color: #8c695e;
  font-size: 10px;
  line-height: 1.5;
}
.register-page .partial-registration-warning label {
  display: flex;
  gap: 7px;
  align-items: flex-start;
  color: #744233;
  font-size: 10px;
  font-weight: 850;
  line-height: 1.45;
  cursor: pointer;
}
.register-page .partial-registration-warning input {
  width: 15px;
  height: 15px;
  flex: 0 0 15px;
  margin-top: 1px;
  accent-color: #9a533a;
}
.register-page .workbench-body {
  padding-bottom: var(--registration-footer-reserve);
}
.register-page .field,
.register-page .review-stage-panel,
.register-page .metadata-stage-panel,
.register-page .direct-text-review {
  scroll-margin-bottom: calc(var(--registration-footer-reserve) + 20px);
}
.register-page .workbench-footer {
  bottom: max(0px, env(safe-area-inset-bottom));
  box-shadow: 0 -10px 28px rgba(26, 61, 54, 0.08);
}
.register-page .footer-information {
  display: grid;
  gap: 7px;
  min-width: 0;
}
.register-page .footer-status-row {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.register-page .footer-scope,
.register-page .autosave-status {
  display: inline-flex;
  align-items: center;
  padding: 4px 7px;
  border-radius: 999px;
  background: #edf3f1;
  color: #5f746e;
  font-size: 9px;
  font-weight: 850;
}
.register-page .autosave-status::before {
  width: 6px;
  height: 6px;
  margin-right: 5px;
  border-radius: 50%;
  background: #82928d;
  content: "";
}
.register-page .autosave-status.is-saving::before,
.register-page .autosave-status.is-pending::before {
  background: #c47b3f;
  animation: pulse 1.2s ease-in-out infinite;
}
.register-page .autosave-status.is-saved::before {
  background: #2c765e;
}
.register-page .autosave-status.is-error {
  background: #fff0eb;
  color: #9a4734;
}
.register-page .autosave-status.is-error::before {
  background: #b94f38;
}

@media (max-width: 1280px) {
  .register-page .final-review-summary {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 980px) {
  .register-page .batch-recovery-banner {
    grid-template-columns: 1fr auto;
  }
  .register-page .batch-recovery-counts {
    grid-column: 1;
  }
  .register-page .review-control-bar {
    align-items: stretch;
    flex-direction: column;
  }
  .register-page .review-control-actions {
    justify-content: flex-start;
  }
  .register-page .final-review-summary {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 700px) {
  .register-page {
    --registration-footer-reserve: 24px;
  }
  .register-page .workbench-head-badges,
  .register-page .review-control-actions,
  .register-page .footer-status-row {
    justify-content: flex-start;
  }
  .register-page .work-scope-pill {
    max-width: 100%;
  }
  .register-page .batch-recovery-banner {
    grid-template-columns: 1fr;
    margin-inline: 14px;
  }
  .register-page .batch-recovery-counts {
    grid-column: auto;
  }
  .register-page .analysis-file-queue li {
    grid-template-columns: 22px minmax(0, 1fr) auto;
  }
  .register-page .analysis-file-queue li > em {
    grid-column: 2;
  }
  .register-page .analysis-file-queue li > button {
    grid-column: 3;
    grid-row: 1/span 2;
  }
  .register-page .review-control-actions button {
    flex: 1 1 calc(50% - 6px);
  }
  .register-page .file-review-task-list,
  .register-page .file-review-compare-row {
    grid-template-columns: 1fr;
  }
  .register-page .file-review-task-head,
  .register-page .file-review-task-card > header {
    flex-direction: column;
  }
  .register-page .file-review-task-history li {
    grid-template-columns: 1fr;
  }
  .register-page .direct-text-review > header {
    flex-direction: column;
  }
  .register-page .final-review-summary {
    grid-template-columns: 1fr;
  }
  .register-page .workbench-footer {
    position: static;
    padding-bottom: calc(16px + env(safe-area-inset-bottom));
    box-shadow: none;
  }
}
/* Structured per-file registration error guidance */
.analysis-file-queue {
  max-height: 320px;
}

.batch-item-error {
  display: grid;
  grid-column: 1/-1;
  gap: 6px;
  padding: 9px;
  border: 1px solid #efc9c0;
  border-radius: 9px;
  background: #fff8f6;
  color: #783f33;
}

.batch-item-error small {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  color: #9c4b3b;
  font-size: 9px;
}

.batch-item-error p,
.batch-item-error code {
  margin: 0;
  overflow-wrap: anywhere;
  font-size: 9px;
  line-height: 1.5;
}

.batch-item-error code {
  color: #6f5c57;
}

.batch-item-error-action {
  color: #63534f;
}

.batch-item-error-actions,
.metadata-file-error > div {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.batch-item-error-actions button,
.metadata-file-error button {
  min-height: 28px;
  padding: 5px 8px;
  border: 1px solid #dba99d;
  border-radius: 7px;
  background: #ffffff;
  color: #883f30;
  font-size: 9px;
  font-weight: 900;
  cursor: pointer;
}

.batch-item-error-actions button:disabled,
.metadata-file-error button:disabled {
  cursor: not-allowed;
  opacity: 0.48;
}

.metadata-file-error {
  display: grid;
  gap: 5px;
  padding: 8px;
  border: 1px solid #efc9c0;
  border-radius: 8px;
  background: #fff8f6;
}

.metadata-file-error p,
.metadata-file-error code,
.metadata-file-error small {
  margin: 0;
  overflow-wrap: anywhere;
  color: #783f33;
  font-size: 8px;
  line-height: 1.45;
}

/* source-response-probe-v1 */
.source-response-probe,
.xml-profile-match-results {
  margin-top: 14px;
  border: 1px solid #dbe4e2;
  border-radius: 14px;
  background: #f8fbfa;
  padding: 16px;
}

.source-response-probe > header,
.xml-profile-match-results > header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 12px;
}

.source-response-probe dl {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.source-response-probe dl > div,
.xml-profile-match-results article {
  min-width: 0;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #fff;
  padding: 11px 12px;
}

.source-response-probe dt,
.xml-profile-match-results dt,
.source-probe-error dt {
  color: #64748b;
  font-size: 11px;
  font-weight: 800;
}

.source-response-probe dd,
.xml-profile-match-results dd,
.source-probe-error dd {
  margin-top: 4px;
  overflow-wrap: anywhere;
  color: #1e293b;
  font-size: 12px;
  font-weight: 700;
}

.xml-profile-field-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.xml-profile-diagnostics {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px;
  margin: 0 0 12px;
}

.xml-profile-diagnostics > div {
  min-width: 0;
  border: 1px solid #d8e6e2;
  border-radius: 9px;
  background: #ffffff;
  padding: 9px 10px;
}

.xml-profile-notice {
  display: grid;
  gap: 5px;
  border: 1px solid #efc38f;
  border-radius: 10px;
  background: #fff8ed;
  padding: 13px 14px;
  color: #7c4b12;
}

.xml-profile-notice p,
.xml-profile-notice small,
.xml-profile-parse-info {
  margin: 0;
  overflow-wrap: anywhere;
  font-size: 11px;
  line-height: 1.5;
}

.xml-profile-parse-info {
  margin-bottom: 10px;
  color: #526b66;
  font-weight: 700;
}

.xml-profile-match-results article > header {
  display: flex;
  justify-content: space-between;
  gap: 10px;
}

.xml-profile-match-results article code {
  display: block;
  margin: 8px 0;
  overflow-wrap: anywhere;
  color: #47635e;
  font-size: 10px;
}

.xml-profile-match-results article dl > div + div {
  margin-top: 8px;
}

.source-probe-error {
  margin: 8px 0;
  border-top: 1px solid rgba(255, 255, 255, 0.24);
  padding-top: 8px;
}

.source-probe-error > div + div {
  margin-top: 5px;
}

@media (max-width: 760px) {
  .source-response-probe dl,
  .xml-profile-field-grid,
  .xml-profile-diagnostics {
    grid-template-columns: 1fr;
  }
}
.source-analysis-summary {
  grid-template-columns: repeat(6, minmax(0, 1fr));
}

.source-analysis-summary article {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 48px;
  padding: 9px 11px;
}

.source-analysis-summary strong {
  font-size: 18px;
}

.source-analysis-list-guide {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  color: #60716d;
  font-size: 11px;
}

.source-analysis-list-guide > div {
  display: flex;
  align-items: baseline;
  min-width: 0;
  gap: 8px;
}

.source-analysis-list-guide strong {
  flex: 0 0 auto;
  color: #2c4740;
  font-size: 12px;
}

.source-analysis-list-guide button {
  flex: 0 0 auto;
  border: 0;
  background: transparent;
  padding: 4px;
  color: #35665a;
  font-size: 11px;
  font-weight: 800;
}

.source-analysis-list {
  max-height: min(64vh, 660px);
  overflow-y: auto;
  overscroll-behavior: contain;
  scrollbar-gutter: stable;
  padding: 2px 8px 8px 2px;
}

.source-analysis-card {
  gap: 0;
  padding: 12px 14px;
  box-shadow: 0 3px 10px rgba(35, 58, 52, 0.04);
}

.source-analysis-card.is-expanded {
  box-shadow: 0 8px 22px rgba(35, 58, 52, 0.09);
}

.source-analysis-card-head {
  display: grid;
  grid-template-columns: minmax(260px, 1.55fr) minmax(280px, 0.9fr) auto auto;
  align-items: center;
  gap: 12px;
}

.source-analysis-identity {
  align-items: center;
}

.source-analysis-identity strong {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.source-analysis-compact {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  min-width: 0;
  gap: 6px;
}

.source-analysis-compact > span {
  display: grid;
  min-width: 0;
  gap: 1px;
}

.source-analysis-compact small {
  color: #7a8985;
  font-size: 9px;
  font-weight: 800;
}

.source-analysis-compact strong {
  overflow: hidden;
  color: #314943;
  font-size: 11px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.source-analysis-toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  min-height: 32px;
  border: 1px solid #c7d4d0;
  border-radius: 8px;
  background: #ffffff;
  padding: 6px 9px;
  color: #36534c;
  font-size: 10px;
  font-weight: 800;
  white-space: nowrap;
}

.source-analysis-toggle svg {
  width: 14px;
  height: 14px;
  transition: transform 160ms ease;
}

.source-analysis-toggle svg.is-open {
  transform: rotate(180deg);
}

.source-analysis-expanded {
  display: grid;
  gap: 14px;
  margin-top: 12px;
  border-top: 1px solid #e2e9e7;
  padding-top: 14px;
}

@media (max-width: 1180px) {
  .source-analysis-summary {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .source-analysis-card-head {
    grid-template-columns: minmax(0, 1fr) auto auto;
  }
  .source-analysis-compact {
    grid-column: 1/-1;
    grid-row: 2;
  }
}
@media (max-width: 680px) {
  .source-analysis-summary {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .source-analysis-summary article {
    min-height: 44px;
  }
  .source-analysis-list-guide {
    align-items: flex-start;
  }
  .source-analysis-list-guide > div {
    align-items: flex-start;
    flex-direction: column;
    gap: 2px;
  }
  .source-analysis-list {
    max-height: 70vh;
    padding-right: 4px;
  }
  .source-analysis-card-head {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
  }
  .source-analysis-compact {
    grid-column: 1/-1;
    grid-row: auto;
  }
  .source-analysis-state {
    grid-column: 1;
    justify-self: start;
  }
  .source-analysis-toggle {
    grid-column: 2;
  }
}
/* 2단계 통합 메타데이터 검수 */
.register-page.is-metadata-step .register-main {
  width: min(100%, 1880px);
}

.metadata-stage-breadcrumb {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: -2px 0 16px;
  color: #6e7f7a;
  font-size: 13px;
}
.metadata-stage-breadcrumb i {
  color: #b5c2be;
  font-style: normal;
}
.metadata-stage-breadcrumb strong {
  color: #173c36;
}

.visibility-bulk-toolbar,
.metadata-review-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  border: 1px solid #dbe7e3;
  background: #f7faf9;
}

.visibility-bulk-toolbar {
  margin-bottom: 18px;
  padding: 14px 16px;
  border-radius: 14px;
}

.visibility-discovery-toolbar {
  display: grid;
  grid-template-columns: minmax(260px, 1fr) minmax(170px, 220px) auto;
  align-items: end;
  gap: 12px;
  margin-top: 18px;
  margin-bottom: 10px;
  padding: 14px 16px;
  border: 1px solid #dbe7e3;
  border-radius: 14px;
  background: #fff;
}

.visibility-search-control,
.visibility-filter-control {
  display: grid;
  gap: 7px;
}
.visibility-search-control > span,
.visibility-filter-control > span {
  color: #48635c;
  font-size: 12px;
  font-weight: 800;
}
.visibility-search-control input,
.visibility-search-control select,
.visibility-filter-control input,
.visibility-filter-control select {
  width: 100%;
  min-height: 42px;
  border: 1px solid #cbdad5;
  border-radius: 10px;
  background: #fff;
  color: #183c36;
  font-size: 13px;
  outline: none;
}
.visibility-search-control input:focus,
.visibility-search-control select:focus,
.visibility-filter-control input:focus,
.visibility-filter-control select:focus {
  border-color: #3d816f;
  box-shadow: 0 0 0 3px rgba(61, 129, 111, 0.12);
}

.visibility-search-control > div {
  position: relative;
}
.visibility-search-control input {
  padding: 0 68px 0 12px;
}
.visibility-search-control button {
  position: absolute;
  top: 50%;
  right: 8px;
  min-height: 28px;
  padding: 0 8px;
  border: 0;
  border-radius: 7px;
  background: #eef4f2;
  color: #4b6b63;
  font-size: 11px;
  font-weight: 800;
  transform: translateY(-50%);
}

.visibility-filter-control select {
  padding: 0 34px 0 12px;
}

.visibility-result-summary {
  display: flex;
  align-items: baseline;
  justify-content: flex-end;
  gap: 5px;
  min-height: 42px;
  padding: 11px 0;
  color: #72847f;
  font-size: 12px;
  white-space: nowrap;
}
.visibility-result-summary strong {
  color: #205f50;
  font-size: 15px;
}

.visibility-selection-toolbar {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 14px;
  padding: 12px 14px;
  border: 1px solid #cfe0da;
  border-radius: 12px;
  background: #edf7f3;
}
.visibility-selection-toolbar > p {
  margin: 0;
  color: #526d65;
  font-size: 12px;
}
.visibility-selection-toolbar > p strong {
  color: #205f50;
}

.visibility-select-all,
.visibility-file-select-row label {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  color: #254e45;
  font-size: 12px;
  font-weight: 800;
  cursor: pointer;
}
.visibility-select-all input,
.visibility-file-select-row label input {
  width: 16px;
  height: 16px;
  margin: 0;
  accent-color: #2f7765;
}

.visibility-selected-actions {
  display: flex;
  align-items: center;
  gap: 7px;
  margin-left: auto;
}
.visibility-selected-actions button {
  min-height: 36px;
  padding: 0 12px;
  border: 1px solid #2f7765;
  border-radius: 9px;
  background: #2f7765;
  color: #fff;
  font-size: 12px;
  font-weight: 800;
}
.visibility-selected-actions button.is-clear {
  border-color: #c3d4cf;
  background: #fff;
  color: #4b655e;
}
.visibility-selected-actions button:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.visibility-file-grid > article.is-bulk-selected {
  border-color: #2f7765;
  box-shadow: 0 0 0 2px rgba(47, 119, 101, 0.14);
}

.visibility-file-select-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 10px;
  padding-bottom: 9px;
  border-bottom: 1px solid #e3ebe8;
}
.visibility-file-select-row label {
  font-size: 11px;
}
.visibility-file-select-row em {
  padding: 4px 7px;
  border-radius: 999px;
  background: #eef3f2;
  color: #587069;
  font-size: 10px;
  font-style: normal;
  font-weight: 800;
}

.visibility-file-main small.visibility-item-identifier {
  color: #396c60;
  font-weight: 750;
}

.visibility-file-grid > article > p.visibility-source-note {
  padding: 8px 9px;
  border-radius: 8px;
  background: #eef7f4;
  color: #2b6658;
  line-height: 1.5;
}
.visibility-file-grid > article > p.visibility-source-note.is-warning {
  background: #fff5e5;
  color: #8a5a1e;
}
.visibility-file-grid > article > p.visibility-source-note.is-manual {
  background: #f2f3f7;
  color: #5b6170;
}

.visibility-empty-result {
  grid-column: 1/-1;
  padding: 34px 20px;
  border: 1px dashed #c9d9d4;
  border-radius: 14px;
  background: #fafcfb;
  color: #355c53;
  text-align: center;
}
.visibility-empty-result strong {
  font-size: 14px;
}
.visibility-empty-result p {
  margin: 7px 0 0;
  color: #778a84;
  font-size: 12px;
}

.visibility-counts,
.visibility-bulk-actions,
.metadata-review-filters,
.metadata-bulk-preview,
.metadata-field-decisions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.visibility-counts span {
  padding-right: 10px;
  color: #657873;
  font-size: 13px;
}
.visibility-counts span strong {
  margin-left: 3px;
  color: #183c36;
}

.visibility-bulk-actions button,
.metadata-review-toolbar button,
.metadata-field-decisions button {
  min-height: 38px;
  padding: 0 14px;
  border: 1px solid #cbdad5;
  border-radius: 10px;
  background: #fff;
  color: #244943;
  font-weight: 700;
}

.visibility-bulk-actions button {
  transition: border-color 0.16s ease, background 0.16s ease, color 0.16s ease, box-shadow 0.16s ease;
}
.visibility-bulk-actions button.is-active {
  border-color: #2f7765;
  background: #e9f5f1;
  color: #205f50;
  box-shadow: inset 0 0 0 1px rgba(47, 119, 101, 0.14);
}

.autosave-status {
  display: inline-flex;
  align-items: center;
  min-height: 30px;
  padding: 0 10px;
  border-radius: 999px;
  background: #edf4f1;
  color: #526e67;
  font-size: 12px;
  font-weight: 700;
}
.autosave-status.is-saving, .autosave-status.is-pending {
  background: #fff4dd;
  color: #8a6325;
}
.autosave-status.is-error {
  background: #fff0ee;
  color: #b04d43;
}
.autosave-status.is-saved {
  background: #e8f6f0;
  color: #28705c;
}

.unified-metadata-review {
  align-items: start;
}

.metadata-review-main {
  min-width: 0;
}

.metadata-review-page-head,
.metadata-field-detail-head,
.dtd-coverage-panel > header,
.profile-handoff-panel > header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
}
.metadata-review-page-head h3,
.metadata-review-page-head h4,
.metadata-review-page-head p,
.metadata-field-detail-head h3,
.metadata-field-detail-head h4,
.metadata-field-detail-head p,
.dtd-coverage-panel > header h3,
.dtd-coverage-panel > header h4,
.dtd-coverage-panel > header p,
.profile-handoff-panel > header h3,
.profile-handoff-panel > header h4,
.profile-handoff-panel > header p {
  margin: 0;
}
.metadata-review-page-head p,
.metadata-field-detail-head p,
.dtd-coverage-panel > header p,
.profile-handoff-panel > header p {
  margin-top: 7px;
  color: #657873;
  line-height: 1.55;
}
.metadata-review-page-head > div:last-child,
.metadata-field-detail-head > div:last-child,
.dtd-coverage-panel > header > div:last-child,
.profile-handoff-panel > header > div:last-child {
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  gap: 8px;
}

.source-response-compact {
  display: grid;
  grid-template-columns: auto auto minmax(0, 1fr);
  align-items: center;
  gap: 12px;
  margin-top: 16px;
  padding: 11px 14px;
  border-radius: 12px;
  background: #f3f7f6;
  color: #5c706b;
  font-size: 12px;
}
.source-response-compact code {
  overflow: hidden;
  color: #47635c;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.metadata-review-toolbar {
  margin-top: 18px;
  padding: 12px;
  border-radius: 14px;
}

.metadata-review-filters button.is-active {
  border-color: #377666;
  background: #eaf5f1;
  color: #1f5d4f;
}

.metadata-bulk-preview {
  color: #536e67;
  font-size: 13px;
}
.metadata-bulk-preview small {
  color: #86958f;
}
.metadata-bulk-preview button {
  display: inline-flex;
  max-width: min(100%, 520px);
  align-items: center;
  gap: 6px;
  border-color: #2f6e5e;
  background: #2f6e5e;
  color: #fff;
}
.metadata-bulk-preview button:disabled {
  cursor: not-allowed;
  opacity: 0.48;
}

.metadata-bulk-file-name {
  display: inline-block;
  min-width: 0;
  max-width: 230px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.metadata-master-detail {
  display: grid;
  grid-template-columns: minmax(230px, 285px) minmax(0, 1fr);
  gap: 16px;
  margin-top: 16px;
  align-items: start;
}

.metadata-field-master {
  display: flex;
  max-height: 920px;
  flex-direction: column;
  gap: 8px;
  overflow: auto;
  padding: 4px 6px 4px 2px;
  scrollbar-gutter: stable;
}
.metadata-field-master > button {
  display: flex;
  min-width: 0;
  padding: 13px;
  border: 1px solid #dce6e3;
  border-radius: 13px;
  background: #fff;
  color: #284a44;
  text-align: left;
  flex-direction: column;
  gap: 6px;
}
.metadata-field-master > button.is-active {
  border-color: #4d927e;
  box-shadow: 0 0 0 2px rgba(77, 146, 126, 0.12);
}
.metadata-field-master > button.is-complete {
  background: #f2faf6;
}
.metadata-field-master > button > small {
  overflow: hidden;
  color: #546b65;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.metadata-field-master-top,
.metadata-field-master-status {
  display: flex;
  align-items: center;
  gap: 7px;
}

.metadata-field-master-top {
  justify-content: space-between;
}
.metadata-field-master-top strong {
  margin-right: auto;
}
.metadata-field-master-top em {
  padding: 2px 6px;
  border-radius: 999px;
  background: #f1eee8;
  color: #765c37;
  font-size: 10px;
  font-style: normal;
}
.metadata-field-master-top em.is-modified {
  background: #fff0dd;
  color: #9a5d12;
}

.metadata-field-master-status {
  color: #658078;
  font-size: 11px;
}
.metadata-field-master-status i {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #c2ceca;
}
.metadata-field-master-status b {
  flex: 0 0 auto;
}
.metadata-field-master-status small {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.metadata-field-detail {
  min-width: 0;
  padding: 20px;
  border: 1px solid #d8e4e0;
  border-radius: 18px;
  background: #fff;
  box-shadow: 0 10px 30px rgba(30, 66, 57, 0.06);
}

.required-chip {
  padding: 5px 9px;
  border-radius: 999px;
  background: #fff0df;
  color: #945d1e;
  font-size: 11px;
  font-weight: 800;
}

.metadata-value-comparison {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin-top: 18px;
}
.metadata-value-comparison article {
  display: flex;
  min-width: 0;
  padding: 15px;
  border: 1px solid #e1e9e6;
  border-radius: 13px;
  background: #f8faf9;
  flex-direction: column;
  gap: 7px;
}
.metadata-value-comparison article.is-source {
  background: #f4f8fb;
}
.metadata-value-comparison article > span,
.metadata-value-comparison article > small {
  color: #6f807b;
  font-size: 11px;
}
.metadata-value-comparison article strong,
.metadata-value-comparison article code {
  overflow-wrap: anywhere;
}
.metadata-value-comparison article button {
  align-self: flex-start;
  margin-top: auto;
  padding: 6px 9px;
  border: 1px solid #cddbd6;
  border-radius: 8px;
  background: #fff;
  color: #315f54;
  font-weight: 700;
}

.metadata-value-heading {
  display: flex;
  min-height: 30px;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}
.metadata-value-heading > span {
  color: #6f807b;
  font-size: 11px;
}

.metadata-value-comparison article .metadata-value-expand {
  display: inline-flex;
  width: 30px;
  height: 30px;
  flex: 0 0 30px;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 0;
  border-color: #c6d7d2;
}
.metadata-value-comparison article .metadata-value-expand svg {
  width: 15px;
  height: 15px;
}

.metadata-value-preview {
  line-height: 1.6;
  white-space: pre-wrap;
}
.metadata-value-preview.is-truncated {
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
}

.metadata-value-modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1700;
  display: grid;
  place-items: center;
  padding: 24px;
  overflow: auto;
  overscroll-behavior: contain;
  background: rgba(12, 27, 23, 0.62);
  backdrop-filter: blur(4px);
}

.metadata-value-modal {
  width: min(100%, 920px);
  max-height: min(82vh, 760px);
  overflow: hidden;
  border: 1px solid #bdcec8;
  border-radius: 18px;
  background: #fff;
  box-shadow: 0 28px 90px rgba(5, 20, 16, 0.3);
}
.metadata-value-modal > header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  padding: 20px 22px;
  border-bottom: 1px solid #dfe8e5;
  background: #f6faf8;
}
.metadata-value-modal > header span {
  color: var(--register-copper);
  font-size: 10px;
  font-weight: 900;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}
.metadata-value-modal > header h2 {
  margin: 5px 0 0;
  color: #173c35;
  font-size: 20px;
}
.metadata-value-modal > header p {
  margin: 7px 0 0;
  color: #687b75;
  font-size: 12px;
  overflow-wrap: anywhere;
}
.metadata-value-modal > pre {
  max-height: calc(min(82vh, 760px) - 112px);
  margin: 0;
  padding: 22px;
  overflow: auto;
  color: #263f38;
  font-family: inherit;
  font-size: 14px;
  line-height: 1.8;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.metadata-value-modal-close {
  display: inline-flex;
  width: 38px;
  height: 38px;
  flex: 0 0 38px;
  align-items: center;
  justify-content: center;
  border: 1px solid #cad9d4;
  border-radius: 10px;
  background: #fff;
  color: #315b51;
}
.metadata-value-modal-close svg {
  width: 19px;
  height: 19px;
}

.metadata-evidence-panel,
.metadata-assist-candidates,
.metadata-field-editor {
  margin-top: 16px;
  padding: 15px;
  border: 1px solid #e1e9e6;
  border-radius: 13px;
  background: #fbfcfc;
}

.metadata-evidence-panel > header,
.metadata-field-editor-head,
.metadata-assist-candidates > header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.metadata-evidence-panel > header button,
.metadata-field-editor-head button,
.metadata-assist-candidates > header button {
  padding: 6px 9px;
  border: 1px solid #cbdad5;
  border-radius: 8px;
  background: #fff;
  color: #2f6759;
  font-weight: 700;
}

.metadata-evidence-list {
  display: grid;
  max-height: 220px;
  gap: 8px;
  margin-top: 12px;
  overflow: auto;
}
.metadata-evidence-list article {
  display: grid;
  gap: 5px;
  padding: 10px;
  border-radius: 9px;
  background: #f0f5f3;
}
.metadata-evidence-list q {
  color: #334f48;
  line-height: 1.5;
}

.metadata-evidence-empty {
  margin: 12px 0 0;
  color: #8a7164;
}

.metadata-source-preview {
  max-height: 280px;
  margin: 12px 0 0;
  overflow: auto;
  padding: 14px;
  border-radius: 10px;
  background: #17241f;
  color: #dbe9e4;
  white-space: pre-wrap;
  word-break: break-word;
}
.metadata-source-preview mark {
  background: #ffe18b;
  color: #17241f;
}

.metadata-assist-candidates > div {
  display: flex;
  gap: 8px;
  margin-top: 10px;
  overflow-x: auto;
}
.metadata-assist-candidates > div button {
  display: flex;
  min-width: 180px;
  padding: 10px;
  border: 1px solid #d5e2de;
  border-radius: 10px;
  background: #fff;
  text-align: left;
  flex-direction: column;
  gap: 5px;
}

.metadata-field-editor .xml-repeat-row {
  margin-top: 10px;
}
.metadata-field-editor .xml-repeat-row input,
.metadata-field-editor .xml-repeat-row select,
.metadata-field-editor .xml-repeat-row textarea {
  width: 100%;
}
.metadata-field-editor .xml-repeat-row select {
  min-height: 40px;
  border: 1px solid #cbdad5;
  border-radius: 8px;
  padding: 0 11px;
  background: #fff;
  color: #2d463f;
}

.era-final-control {
  display: grid;
  width: 100%;
  min-width: 0;
  gap: 7px;
}
.era-final-control .era-select-shell {
  position: relative;
  width: 100%;
  min-width: 0;
  min-height: 42px;
  overflow: hidden;
  border: 1px solid #acc9c0;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 1px 2px rgba(21, 67, 55, 0.07);
  transition: border-color 160ms ease, box-shadow 160ms ease, background-color 160ms ease;
}
.era-final-control .era-select-shell:hover {
  border-color: #72a596;
  background: #fbfefd;
}
.era-final-control .era-select-shell:focus-within {
  border-color: #2d7663;
  box-shadow: 0 0 0 3px rgba(45, 118, 99, 0.14);
}
.era-final-control .era-select-shell.has-value {
  border-color: #8fb9ad;
}
.era-final-control .era-select-shell select {
  width: 100%;
  min-height: 42px;
  appearance: none;
  border: 0;
  border-radius: 0;
  outline: 0;
  padding: 0 54px 0 14px;
  background: transparent;
  color: #1f493e;
  cursor: pointer;
  font-size: 11px;
  font-weight: 850;
}
.era-final-control .era-select-icon {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  display: grid;
  width: 44px;
  place-items: center;
  border-left: 1px solid #d8e7e2;
  background: #f1f7f5;
  color: #2d7663;
  pointer-events: none;
  font-size: 11px;
}

.metadata-standard-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin-top: 16px;
}
.metadata-standard-grid label {
  display: grid;
  gap: 7px;
  color: #5d716c;
  font-size: 12px;
}

.metadata-field-decisions {
  justify-content: flex-end;
  margin-top: 14px;
}
.metadata-field-decisions .is-primary {
  border-color: #285f51;
  background: #285f51;
  color: #fff;
}

/* 2-2 공통 메타데이터 검수 작업대 */
.unified-metadata-review {
  --review-ink: #173d34;
  --review-muted: #687d76;
  --review-line: #d7e5e0;
  --review-green: #2d7663;
  grid-template-columns: 252px minmax(0, 1fr);
  gap: 24px;
}
.unified-metadata-review .metadata-file-rail {
  gap: 14px;
  padding: 18px;
  border-color: #d3e2dc;
  border-radius: 20px;
  background: linear-gradient(180deg, #f9fbfa 0%, #f1f7f4 100%);
  box-shadow: 0 12px 32px rgba(28, 69, 58, 0.07);
}
.unified-metadata-review .metadata-file-rail header h3 {
  color: var(--review-ink);
  font-size: 17px;
  letter-spacing: -0.03em;
}
.unified-metadata-review .metadata-file-rail header > span {
  color: #2a6858;
  font-weight: 800;
}
.unified-metadata-review .metadata-file-list {
  gap: 9px;
  padding-right: 3px;
  scrollbar-gutter: stable;
}
.unified-metadata-review .metadata-file-list article {
  padding: 10px;
  border-color: #dce7e3;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.84);
  box-shadow: 0 2px 8px rgba(30, 68, 58, 0.025);
  transition: 160ms ease;
}
.unified-metadata-review .metadata-file-list article:hover {
  border-color: #a7c9be;
  box-shadow: 0 8px 18px rgba(30, 68, 58, 0.07);
  transform: translateY(-1px);
}
.unified-metadata-review .metadata-file-list article.is-active {
  border-color: #448c77;
  background: #fff;
  box-shadow: 0 0 0 2px rgba(68, 140, 119, 0.1), 0 10px 22px rgba(30, 68, 58, 0.08);
}
.unified-metadata-review .metadata-file-list article.is-complete:not(.is-active) {
  border-color: #c8ded5;
  background: #eef8f4;
}
.unified-metadata-review .metadata-file-select {
  gap: 9px;
}
.unified-metadata-review .metadata-file-select > span:first-child {
  width: 30px;
  height: 30px;
  border-radius: 10px;
  color: #2a6a59;
  background: #e7f2ee;
}
.unified-metadata-review .metadata-file-select strong {
  color: #1e463c;
  font-size: 12px;
  line-height: 1.35;
}
.unified-metadata-review .metadata-file-select small {
  margin-top: 3px;
  color: #758a83;
  font-size: 10px;
  line-height: 1.45;
}
.unified-metadata-review .metadata-review-page-head {
  align-items: center;
  padding: 2px 2px 18px;
  border-bottom: 1px solid var(--review-line);
}
.unified-metadata-review .metadata-review-page-head h3 {
  margin-top: 5px;
  color: var(--review-ink);
  font-size: 24px;
  letter-spacing: -0.045em;
}
.unified-metadata-review .metadata-review-page-head p {
  max-width: 720px;
  margin-top: 8px;
  color: var(--review-muted);
  font-size: 13px;
  line-height: 1.65;
}
.unified-metadata-review .source-response-compact {
  min-height: 42px;
  margin-top: 14px;
  padding: 11px 15px;
  border: 1px solid #dbe8e3;
  border-radius: 13px;
  background: #f6faf8;
}
.unified-metadata-review .source-response-compact code {
  min-width: 0;
  color: #587069;
}
.unified-metadata-review .metadata-review-toolbar {
  align-items: center;
  margin-top: 14px;
  padding: 10px 12px;
  border-color: #d9e5e0;
  border-radius: 15px;
  background: #fff;
  box-shadow: 0 8px 22px rgba(30, 68, 58, 0.045);
}
.unified-metadata-review .metadata-review-filters {
  align-items: center;
  gap: 7px;
}
.unified-metadata-review .metadata-review-filters button {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  min-height: 38px;
  padding: 0 13px;
  border-color: #d8e4df;
  border-radius: 11px;
  color: #5f746d;
  background: #fff;
}
.unified-metadata-review .metadata-review-filters button strong {
  color: inherit;
  font-size: 13px;
}
.unified-metadata-review .metadata-review-filters button span {
  min-width: 23px;
  padding: 3px 6px;
  border-radius: 999px;
  color: #2f6859;
  background: #edf5f2;
  font-size: 10px;
}
.unified-metadata-review .metadata-review-filters button.is-active {
  border-color: #63a28f;
  color: #1f5e4f;
  background: #eaf5f1;
}
.unified-metadata-review .metadata-bulk-preview {
  gap: 12px;
}
.unified-metadata-review .metadata-bulk-preview > span {
  display: grid;
  gap: 2px;
  color: #6c817a;
  font-size: 10px;
  text-align: right;
}
.unified-metadata-review .metadata-bulk-preview > span strong {
  color: #2d6556;
  font-size: 12px;
}
.unified-metadata-review .metadata-bulk-preview button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  min-width: 208px;
  min-height: 40px;
  padding: 0 15px;
  border-radius: 12px;
  box-shadow: 0 8px 16px rgba(34, 102, 84, 0.16);
  white-space: nowrap;
}
.unified-metadata-review .metadata-bulk-preview button svg {
  width: 16px;
  height: 16px;
  flex: 0 0 16px;
}
.unified-metadata-review .metadata-master-detail {
  grid-template-columns: minmax(275px, 310px) minmax(0, 1fr);
  gap: 20px;
  margin-top: 16px;
}
.unified-metadata-review .metadata-field-master {
  gap: 9px;
  max-height: min(920px, 100vh - 190px);
  padding: 2px 8px 2px 2px;
  scrollbar-gutter: stable;
}
.unified-metadata-review .metadata-field-master > button {
  display: grid;
  grid-template-columns: 34px minmax(0, 1fr) 18px;
  align-items: center;
  gap: 10px;
  min-height: 82px;
  padding: 11px 10px;
  border-color: #dbe6e2;
  border-radius: 15px;
  background: #fff;
  box-shadow: 0 3px 10px rgba(30, 68, 58, 0.035);
  transition: 160ms ease;
}
.unified-metadata-review .metadata-field-master > button:hover {
  border-color: #9fc8bb;
  box-shadow: 0 9px 20px rgba(30, 68, 58, 0.07);
  transform: translateY(-1px);
}
.unified-metadata-review .metadata-field-master > button.is-active {
  border-color: #3d8c76;
  background: #f4fbf8;
  box-shadow: 0 0 0 2px rgba(61, 140, 118, 0.1), 0 10px 22px rgba(30, 68, 58, 0.08);
}
.unified-metadata-review .metadata-field-master > button.is-complete:not(.is-active) {
  border-color: #cae0d8;
  background: #f1f9f6;
}
.unified-metadata-review .metadata-field-detail {
  padding: 24px;
  border-color: #d6e4df;
  border-radius: 22px;
  background: #fff;
  box-shadow: 0 16px 38px rgba(27, 68, 57, 0.075);
}
.unified-metadata-review .metadata-field-detail-head {
  align-items: flex-start;
}
.unified-metadata-review .metadata-field-detail-head h4 {
  margin-top: 5px;
  color: var(--review-ink);
  font-size: 24px;
  letter-spacing: -0.04em;
}
.unified-metadata-review .metadata-field-detail-head > div > p:last-child {
  margin-top: 7px;
  color: var(--review-muted);
  font-size: 13px;
}
.unified-metadata-review .metadata-value-comparison {
  gap: 14px;
  margin-top: 14px;
}
.unified-metadata-review .metadata-value-comparison article {
  min-height: 210px;
  padding: 18px;
  border-color: #dce7e3;
  border-radius: 16px;
  background: #fbfcfc;
}
.unified-metadata-review .metadata-value-comparison article.is-source {
  border-color: #d6e4e8;
  background: linear-gradient(145deg, #f5f9fb 0%, #f1f6f8 100%);
}
.unified-metadata-review .metadata-value-comparison article .metadata-value-heading > span {
  display: flex;
  align-items: center;
  gap: 8px;
}
.unified-metadata-review .metadata-value-comparison article .metadata-value-heading > span > b {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 25px;
  height: 25px;
  border-radius: 8px;
  color: #276b59;
  background: #e2f1ec;
  font-size: 10px;
}
.unified-metadata-review .metadata-value-comparison article .metadata-value-heading > span > em {
  color: #6c817a;
  font-size: 11px;
  font-style: normal;
}
.unified-metadata-review .metadata-value-comparison article.is-source .metadata-value-heading > span > b {
  color: #386a78;
  background: #e2eef2;
}
.unified-metadata-review .metadata-value-comparison code {
  margin-top: auto;
  padding-top: 10px;
  color: #71847e;
  font-size: 10px;
}
.unified-metadata-review .metadata-value-preview {
  margin-top: 15px;
  color: #193f35;
  font-size: 16px;
  line-height: 1.65;
}
.unified-metadata-review .metadata-evidence-panel,
.unified-metadata-review .metadata-field-editor {
  margin-top: 14px;
  padding: 18px;
  border-radius: 16px;
}
.unified-metadata-review .metadata-evidence-panel {
  border-color: #dbe7e3;
  background: #fbfcfc;
}
.unified-metadata-review .metadata-evidence-panel header > div {
  display: grid;
  gap: 3px;
}
.unified-metadata-review .metadata-evidence-panel header h5 {
  color: #234a40;
  font-size: 14px;
}
.unified-metadata-review .metadata-evidence-panel header small {
  color: #788b85;
  font-size: 10px;
}
.unified-metadata-review .metadata-field-editor {
  border-color: #bdd8cf;
  background: linear-gradient(145deg, #f8fcfa 0%, #f2f8f5 100%);
}
.unified-metadata-review .metadata-field-editor .metadata-field-editor-head > div {
  display: grid;
  gap: 3px;
}
.unified-metadata-review .metadata-field-editor .metadata-field-editor-head label {
  color: #214a3f;
  font-size: 15px;
}
.unified-metadata-review .metadata-field-editor .metadata-field-editor-head small {
  color: #6d827b;
  font-size: 10px;
}
.unified-metadata-review .metadata-field-editor input,
.unified-metadata-review .metadata-field-editor textarea {
  border-color: #cdded8;
  border-radius: 11px;
  background: rgba(255, 255, 255, 0.95);
}
.unified-metadata-review .metadata-field-editor input:focus,
.unified-metadata-review .metadata-field-editor textarea:focus {
  border-color: #4c957f;
  box-shadow: 0 0 0 3px rgba(76, 149, 127, 0.12);
}
.unified-metadata-review .xml-change-reason {
  display: grid;
  gap: 7px;
  margin-top: 14px;
  padding: 14px;
  border: 1px solid #d9e5e1;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.76);
}
.unified-metadata-review .xml-change-reason label {
  color: #385f54;
  font-size: 11px;
  font-weight: 800;
}
.unified-metadata-review .xml-change-reason small {
  color: #7d8e88;
  font-size: 10px;
}
.unified-metadata-review .xml-change-reason textarea {
  min-height: 86px;
  margin-top: 2px;
}
.unified-metadata-review .metadata-field-decisions {
  align-items: center;
  justify-content: space-between;
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #d7e4df;
}
.unified-metadata-review .metadata-field-decisions > div {
  display: flex;
  gap: 8px;
}
.unified-metadata-review .metadata-field-decisions button {
  min-height: 42px;
  padding: 0 14px;
  border-radius: 11px;
}
.unified-metadata-review .metadata-field-decisions > button:last-child {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-width: 220px;
  box-shadow: 0 9px 18px rgba(28, 92, 75, 0.18);
}

.metadata-file-progress,
.metadata-review-progress {
  display: grid;
  gap: 9px;
}

.metadata-file-progress > div,
.metadata-review-progress > span:first-child {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  color: #6c817a;
  font-size: 11px;
  font-weight: 700;
}

.metadata-file-progress strong,
.metadata-review-progress strong {
  color: #173d34;
  font-size: 12px;
}

.metadata-progress-track {
  display: block;
  width: 100%;
  height: 6px;
  overflow: hidden;
  border-radius: 999px;
  background: #dfeae6;
}
.metadata-progress-track i {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, #4b9a80 0%, #286d5b 100%);
  transition: width 220ms ease;
}

.metadata-review-progress {
  min-width: 220px;
  padding: 13px 14px;
  border: 1px solid #d8e5e0;
  border-radius: 15px;
  background: #fff;
  box-shadow: 0 8px 22px rgba(30, 68, 58, 0.06);
}
.metadata-review-progress > span:first-child > strong {
  font-size: 16px;
}
.metadata-review-progress > em {
  justify-self: start;
  padding: 4px 9px;
  border-radius: 999px;
  color: #88601e;
  background: #fff2d7;
  font-size: 10px;
  font-style: normal;
  font-weight: 800;
}
.metadata-review-progress > em.is-complete {
  color: #1f6e5a;
  background: #e1f3ec;
}
.metadata-review-progress > small {
  display: flex;
  align-items: center;
  gap: 5px;
  color: #74867f;
  font-size: 10px;
}
.metadata-review-progress > small::before {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #2e8069;
  content: "";
}

.source-response-status {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  color: #2f6e5d;
  font-weight: 800;
}
.source-response-status::before {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #42a07f;
  box-shadow: 0 0 0 4px rgba(66, 160, 127, 0.11);
  content: "";
}

.metadata-toolbar-label {
  color: #71857e;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.metadata-field-index {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 11px;
  color: #416d61;
  background: #edf4f1;
  font-size: 11px;
  font-weight: 900;
}

.is-active .metadata-field-index {
  color: #fff;
  background: #2e7964;
  box-shadow: 0 5px 12px rgba(46, 121, 100, 0.22);
}

.metadata-field-master-copy {
  display: grid;
  min-width: 0;
  gap: 5px;
}
.metadata-field-master-copy > span:first-child {
  display: flex;
  align-items: center;
  gap: 6px;
}
.metadata-field-master-copy strong {
  overflow: hidden;
  color: #244b41;
  font-size: 14px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.metadata-field-master-copy > small {
  overflow: hidden;
  color: #5f756e;
  font-size: 11px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.metadata-field-master-copy .metadata-field-master-status {
  margin-top: 0;
}

.metadata-field-chevron {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #9aaba5;
}

.is-active .metadata-field-chevron {
  color: #2e7964;
}

.metadata-review-guidance {
  display: grid;
  grid-template-columns: 36px minmax(0, 1fr);
  align-items: center;
  gap: 11px;
  margin-top: 18px;
  padding: 12px 14px;
  border: 1px solid #d9e8e2;
  border-radius: 14px;
  color: #577068;
  background: linear-gradient(90deg, #f0f8f5 0%, #f8fbfa 100%);
}
.metadata-review-guidance > span {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 12px;
  color: #2f7864;
  background: #fff;
  box-shadow: 0 4px 10px rgba(30, 68, 58, 0.06);
}
.metadata-review-guidance > div {
  display: grid;
  gap: 2px;
}
.metadata-review-guidance strong {
  color: #285d50;
  font-size: 12px;
}
.metadata-review-guidance small {
  font-size: 11px;
  line-height: 1.5;
}

.metadata-strategy-summary {
  display: grid;
  gap: 14px;
  margin-top: 16px;
  padding: 16px;
  border: 1px solid #d5e5df;
  border-radius: 16px;
  background: linear-gradient(135deg, #f5faf8 0%, #fbfcfb 100%);
}
.metadata-strategy-summary > header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
}
.metadata-strategy-summary > header > div {
  display: grid;
  min-width: 0;
  gap: 4px;
}
.metadata-strategy-summary > header strong {
  color: #234f44;
  font-size: 15px;
}
.metadata-strategy-summary > header p {
  margin: 0;
  color: #62766f;
  font-size: 12px;
  line-height: 1.55;
}

.metadata-strategy-actions {
  display: flex;
  flex: 0 0 auto;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: flex-end;
  gap: 7px;
  max-width: min(620px, 56%);
}
.metadata-strategy-actions label {
  display: grid;
  min-width: 280px;
  gap: 4px;
}
.metadata-strategy-actions label > span {
  color: #657b73;
  font-size: 10px;
  font-weight: 800;
}
.metadata-strategy-actions select,
.metadata-strategy-actions button {
  min-height: 36px;
  border: 1px solid #bdd3cb;
  border-radius: 9px;
  color: #28594d;
  background: #fff;
  font-size: 11px;
  font-weight: 700;
}
.metadata-strategy-actions select {
  width: 100%;
  padding: 0 34px 0 11px;
  appearance: none;
  cursor: pointer;
}
.metadata-strategy-actions select:hover:not(:disabled) {
  border-color: #3b806d;
  background: #f8fcfa;
}
.metadata-strategy-actions select:focus-visible {
  border-color: #2f806b;
  outline: 3px solid rgba(47, 128, 107, 0.16);
  outline-offset: 1px;
}
.metadata-strategy-actions button {
  padding: 0 11px;
  cursor: pointer;
}
.metadata-strategy-actions button:hover:not(:disabled) {
  border-color: #3b806d;
}
.metadata-strategy-actions select:disabled,
.metadata-strategy-actions button:disabled {
  cursor: wait;
  opacity: 0.55;
}
.metadata-strategy-actions > em {
  align-self: center;
  padding: 6px 10px;
  border-radius: 999px;
  color: #286451;
  background: #e3f2ec;
  font-size: 11px;
  font-style: normal;
  font-weight: 800;
}
.metadata-strategy-actions > small {
  align-self: center;
  color: #71857e;
  font-size: 10px;
  white-space: nowrap;
}

.metadata-strategy-select-control {
  position: relative;
  display: block;
}
.metadata-strategy-select-control > svg {
  position: absolute;
  top: 50%;
  right: 11px;
  width: 17px;
  height: 17px;
  color: #2f705f;
  pointer-events: none;
  transform: translateY(-50%);
  transition: transform 0.16s ease, color 0.16s ease;
}
.metadata-strategy-select-control:hover > svg {
  color: #1f5d4d;
  transform: translateY(-42%);
}

.metadata-strategy-change-hint {
  display: inline-flex !important;
  align-items: center;
  gap: 5px;
  margin: 1px 0 0 !important;
  color: #4f7167 !important;
  font-size: 10px !important;
  font-weight: 750;
}
.metadata-strategy-change-hint > svg {
  width: 12px;
  height: 12px;
  flex: 0 0 auto;
}

.metadata-strategy-facts {
  display: grid;
  grid-template-columns: repeat(3, minmax(100px, 0.45fr)) minmax(220px, 1.65fr);
  gap: 8px;
}
.metadata-strategy-facts > span {
  display: grid;
  min-width: 0;
  gap: 2px;
  padding: 10px 12px;
  border: 1px solid #dfebe7;
  border-radius: 11px;
  background: rgba(255, 255, 255, 0.82);
}
.metadata-strategy-facts > span strong {
  overflow: hidden;
  color: #285b4f;
  font-size: 13px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.metadata-strategy-facts > span small {
  color: #7a8d86;
  font-size: 10px;
}

.metadata-hierarchy-auto-status {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  gap: 11px;
  padding: 11px 13px;
  border: 1px solid #cfe3dc;
  border-radius: 11px;
  background: #f2f8f6;
}
.metadata-hierarchy-auto-status > svg {
  width: 19px;
  height: 19px;
  padding: 4px;
  border-radius: 50%;
  background: #2f806b;
  color: #fff;
}
.metadata-hierarchy-auto-status > div {
  display: grid;
  min-width: 0;
  gap: 2px;
}
.metadata-hierarchy-auto-status strong {
  color: #285b4f;
  font-size: 12px;
}
.metadata-hierarchy-auto-status small {
  color: #6b7e78;
  font-size: 10px;
  line-height: 1.5;
}
.metadata-hierarchy-auto-status > em {
  color: #2f705f;
  font-size: 10px;
  font-style: normal;
  font-weight: 850;
  white-space: nowrap;
}

.metadata-hierarchy-role-review {
  display: grid;
  gap: 12px;
  padding: 14px;
  border: 1px solid #e2bd78;
  border-radius: 13px;
  background: #fff9ed;
}
.metadata-hierarchy-role-review.is-confirmed {
  border-color: #b9d9cd;
  background: #f3faf7;
}
.metadata-hierarchy-role-review > header,
.metadata-hierarchy-role-review > footer {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
}
.metadata-hierarchy-role-review > header > div {
  display: grid;
  min-width: 0;
  gap: 3px;
}
.metadata-hierarchy-role-review > header strong {
  color: #234f44;
  font-size: 14px;
}
.metadata-hierarchy-role-review > header p {
  margin: 0;
  color: #6a7974;
  font-size: 11px;
  line-height: 1.55;
}
.metadata-hierarchy-role-review > header > em {
  flex: 0 0 auto;
  padding: 6px 9px;
  border-radius: 999px;
  color: #276451;
  background: #dfefe9;
  font-size: 10px;
  font-style: normal;
  font-weight: 850;
}
.metadata-hierarchy-role-review > header > em.is-attention {
  color: #875919;
  background: #f9e7c4;
}
.metadata-hierarchy-role-review > footer {
  align-items: center;
  justify-content: flex-end;
}
.metadata-hierarchy-role-review > footer button {
  min-height: 36px;
  padding: 0 13px;
  border: 1px solid #bfd3cc;
  border-radius: 9px;
  color: #2a5d50;
  background: #fff;
  font-size: 11px;
  font-weight: 800;
}
.metadata-hierarchy-role-review > footer button.is-primary {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  border-color: #2f7965;
  color: #fff;
  background: #2f7965;
}
.metadata-hierarchy-role-review > footer button svg {
  width: 15px;
  height: 15px;
}
.metadata-hierarchy-role-review > footer button:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.metadata-hierarchy-role-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
}
.metadata-hierarchy-role-grid label {
  display: grid;
  min-width: 0;
  gap: 7px;
  padding: 10px;
  border: 1px solid rgba(178, 204, 195, 0.72);
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.82);
}
.metadata-hierarchy-role-grid label > span {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 7px;
}
.metadata-hierarchy-role-grid b {
  color: #255b4e;
  font-size: 11px;
}
.metadata-hierarchy-role-grid small {
  color: #7b8c86;
  font-size: 9px;
}
.metadata-hierarchy-role-grid select {
  width: 100%;
  min-height: 36px;
  padding: 0 30px 0 10px;
  border: 1px solid #c6d8d2;
  border-radius: 8px;
  color: #294f45;
  background: #fff;
  font-size: 11px;
  font-weight: 700;
}

.metadata-unit-overview {
  overflow: hidden;
  border: 1px solid #d7e5e0;
  border-radius: 13px;
  background: #fff;
}
.metadata-unit-overview > summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 13px 15px;
  cursor: pointer;
  list-style: none;
}
.metadata-unit-overview > summary::-webkit-details-marker {
  display: none;
}
.metadata-unit-overview > summary > span {
  display: grid;
  min-width: 0;
  gap: 2px;
}
.metadata-unit-overview > summary strong {
  color: #244f44;
  font-size: 13px;
}
.metadata-unit-overview > summary small {
  color: #71837d;
  font-size: 10px;
}
.metadata-unit-overview > summary em {
  flex: 0 0 auto;
  color: #2a6a58;
  font-size: 10px;
  font-style: normal;
  font-weight: 850;
}
.metadata-unit-overview[open] > summary {
  border-bottom: 1px solid #dfe9e5;
}

.metadata-unit-overview-body {
  display: grid;
  gap: 10px;
  padding: 12px;
}

.metadata-unit-overview-toolbar {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 10px;
}
.metadata-unit-overview-toolbar label {
  display: grid;
  flex: 1 1 auto;
  max-width: 620px;
  gap: 4px;
}
.metadata-unit-overview-toolbar label span {
  color: #60766e;
  font-size: 10px;
  font-weight: 800;
}
.metadata-unit-overview-toolbar input,
.metadata-unit-overview-toolbar button {
  min-height: 38px;
  border: 1px solid #c7d9d3;
  border-radius: 9px;
  background: #fff;
  font-size: 11px;
}
.metadata-unit-overview-toolbar input {
  width: 100%;
  padding: 0 12px;
  color: #294d44;
}
.metadata-unit-overview-toolbar button {
  flex: 0 0 auto;
  padding: 0 12px;
  color: #27604f;
  font-weight: 800;
}

.metadata-unit-overview-list {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 9px;
  max-height: 640px;
  margin: 0;
  padding: 0;
  overflow: auto;
  list-style: none;
}
.metadata-unit-overview-list > li {
  display: grid;
  align-content: start;
  gap: 7px;
  min-width: 0;
  padding: 12px;
  border: 1px solid #dce8e4;
  border-radius: 11px;
  background: #fbfcfc;
}
.metadata-unit-overview-list > li.is-reviewed {
  border-color: #99c8b8;
  background: #f0f8f5;
}
.metadata-unit-overview-list > li.is-conflict {
  border-color: #e4b16f;
  background: #fffaf1;
}
.metadata-unit-overview-list > li > strong {
  overflow: hidden;
  color: #244c42;
  font-size: 13px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.metadata-unit-overview-list > li > small {
  overflow: hidden;
  color: #71847d;
  font-size: 9px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.metadata-unit-overview-list li > header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 9px;
}
.metadata-unit-overview-list li > header > span {
  display: inline-flex;
  align-items: center;
  gap: 5px;
}
.metadata-unit-overview-list li > header b {
  color: #2a6757;
  font-size: 10px;
}
.metadata-unit-overview-list li > header em {
  color: #71837d;
  font-size: 9px;
  font-style: normal;
}
.metadata-unit-overview-list li > header button {
  min-height: 30px;
  padding: 0 9px;
  border: 1px solid #bfd5cd;
  border-radius: 8px;
  color: #29604f;
  background: #fff;
  font-size: 9px;
  font-weight: 800;
}

.metadata-unit-common-values {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}
.metadata-unit-common-values span {
  display: inline-flex;
  min-width: 0;
  max-width: 100%;
  gap: 4px;
  padding: 5px 7px;
  border-radius: 7px;
  color: #506d64;
  background: #eef4f2;
}
.metadata-unit-common-values b {
  flex: 0 0 auto;
  font-size: 9px;
}
.metadata-unit-common-values small {
  overflow: hidden;
  font-size: 9px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.metadata-unit-entities {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.metadata-unit-entities span {
  padding: 4px 7px;
  border-radius: 999px;
  font-size: 9px;
  font-weight: 700;
}
.metadata-unit-entities span.is-person {
  color: #375e86;
  background: #eaf2fb;
}
.metadata-unit-entities span.is-place {
  color: #7b5c27;
  background: #fbf0d8;
}

.metadata-unit-conflict {
  margin: 0;
  color: #8b5d1c;
  font-size: 10px;
  font-weight: 700;
}

.metadata-unit-overview-empty {
  grid-column: 1/-1;
  color: #71847d;
  text-align: center;
}

.metadata-unit-overview-pagination {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
}
.metadata-unit-overview-pagination span {
  margin-right: auto;
  color: #72857e;
  font-size: 10px;
}
.metadata-unit-overview-pagination b {
  color: #345e53;
  font-size: 10px;
}
.metadata-unit-overview-pagination button {
  min-height: 32px;
  padding: 0 10px;
  border: 1px solid #c8d9d3;
  border-radius: 8px;
  color: #2a5f51;
  background: #fff;
  font-size: 10px;
  font-weight: 800;
}
.metadata-unit-overview-pagination button:disabled {
  opacity: 0.45;
}

.metadata-field-master-top em.is-primary {
  color: #315f89;
  background: #eaf3fb;
}

.metadata-field-scope-summary {
  color: #456e63 !important;
  font-weight: 700;
}

.metadata-review-scope-switch {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  margin-top: 16px;
  padding: 5px;
  border: 1px solid #d8e5e0;
  border-radius: 13px;
  background: #f2f7f5;
}
.metadata-review-scope-switch button {
  display: grid;
  min-width: 0;
  gap: 2px;
  padding: 10px 12px;
  border: 1px solid transparent;
  border-radius: 9px;
  color: #587169;
  background: transparent;
  text-align: left;
}
.metadata-review-scope-switch button span {
  font-size: 12px;
  font-weight: 850;
}
.metadata-review-scope-switch button small {
  overflow: hidden;
  color: #7a8b86;
  font-size: 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.metadata-review-scope-switch button.is-active {
  border-color: #9fc5b9;
  color: #225f50;
  background: #fff;
  box-shadow: 0 4px 12px rgba(37, 91, 77, 0.08);
}
.metadata-review-scope-switch button:focus-visible {
  outline: 3px solid rgba(46, 121, 100, 0.24);
  outline-offset: 2px;
}

.metadata-hierarchy-workbench {
  display: grid;
  gap: 14px;
  margin-top: 16px;
  overflow: hidden;
  border: 1px solid #d8e5e0;
  border-radius: 15px;
  background: #fbfcfc;
}

.metadata-hierarchy-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
  padding: 16px 18px 0;
}
.metadata-hierarchy-head > div {
  display: grid;
  min-width: 0;
  gap: 4px;
}
.metadata-hierarchy-head strong {
  color: #244f44;
  font-size: 14px;
}
.metadata-hierarchy-head p {
  margin: 0;
  color: #687c75;
  font-size: 11px;
  line-height: 1.55;
}

.metadata-hierarchy-status {
  flex: 0 0 auto;
  padding: 6px 9px;
  border-radius: 999px;
  color: #276451;
  background: #e5f3ed;
  font-size: 10px;
  font-style: normal;
  font-weight: 850;
}
.metadata-hierarchy-status.is-attention {
  color: #8b531d;
  background: #fff0dc;
}

.metadata-hierarchy-notices {
  display: grid;
  gap: 8px;
  padding: 0 18px;
}
.metadata-hierarchy-notices aside {
  padding: 10px 12px;
  border: 1px solid #d7e6e1;
  border-radius: 10px;
  background: #f4f9f7;
}
.metadata-hierarchy-notices aside strong {
  color: #315f53;
  font-size: 11px;
}
.metadata-hierarchy-notices aside p {
  margin: 3px 0 0;
  color: #6a7e77;
  font-size: 10px;
  line-height: 1.5;
}
.metadata-hierarchy-notices aside.is-warning {
  border-color: #ecd6b8;
  background: #fff8ec;
}
.metadata-hierarchy-notices aside.is-warning strong {
  color: #87551e;
}
.metadata-hierarchy-notices aside.is-warning p {
  color: #806b51;
}

.metadata-hierarchy-toolbar {
  display: flex;
  align-items: end;
  justify-content: space-between;
  gap: 14px;
  padding: 0 18px;
}
.metadata-hierarchy-toolbar label {
  display: grid;
  width: min(100%, 520px);
  gap: 6px;
  color: #516b64;
  font-size: 11px;
  font-weight: 800;
}
.metadata-hierarchy-toolbar input {
  width: 100%;
  padding: 9px 11px;
  border: 1px solid #cadbd5;
  border-radius: 9px;
  color: #26483f;
  background: #fff;
}
.metadata-hierarchy-toolbar > small {
  color: #72857f;
  font-size: 10px;
}

.metadata-hierarchy-layout {
  display: grid;
  min-height: 430px;
  grid-template-columns: minmax(250px, 0.72fr) minmax(0, 1.28fr);
  border-top: 1px solid #dfe9e5;
}

.metadata-hierarchy-unit-list {
  max-height: 650px;
  margin: 0;
  padding: 8px;
  overflow: auto;
  border-right: 1px solid #dfe9e5;
  background: #f5f9f7;
  list-style: none;
}
.metadata-hierarchy-unit-list li + li {
  margin-top: 5px;
}
.metadata-hierarchy-unit-list button {
  display: grid;
  width: 100%;
  min-width: 0;
  gap: 4px;
  padding-top: 10px;
  padding-right: 10px;
  padding-bottom: 10px;
  border: 1px solid transparent;
  border-radius: 10px;
  color: #35564d;
  background: transparent;
  text-align: left;
}
.metadata-hierarchy-unit-list button > strong,
.metadata-hierarchy-unit-list button > small,
.metadata-hierarchy-unit-list button > .metadata-hierarchy-unit-value {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.metadata-hierarchy-unit-list button > strong {
  font-size: 12px;
}
.metadata-hierarchy-unit-list button > small {
  color: #7a8b86;
  font-size: 10px;
}
.metadata-hierarchy-unit-list button.is-active {
  border-color: #8db8ab;
  background: #e9f5f0;
  box-shadow: inset 3px 0 #2f7864;
}
.metadata-hierarchy-unit-list button.is-conflict:not(.is-active) {
  border-color: #ebd2ae;
  background: #fff9ef;
}
.metadata-hierarchy-unit-list button:focus-visible {
  outline: 3px solid rgba(46, 121, 100, 0.24);
  outline-offset: 1px;
}

.metadata-hierarchy-unit-top {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 6px;
}
.metadata-hierarchy-unit-top b {
  flex: 0 0 auto;
  color: #2e745f;
  font-family: monospace;
  font-size: 10px;
}
.metadata-hierarchy-unit-top em {
  overflow: hidden;
  color: #61776f;
  font-size: 10px;
  font-style: normal;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.metadata-hierarchy-unit-top small {
  flex: 0 0 auto;
  margin-left: auto;
  color: #2f725e;
  font-size: 9px;
  font-weight: 800;
}

.metadata-hierarchy-unit-value {
  color: #3b655a;
  font-size: 11px;
  font-weight: 750;
}

.metadata-hierarchy-detail {
  min-width: 0;
  padding: 18px;
}
.metadata-hierarchy-detail > header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
}
.metadata-hierarchy-detail > header > div {
  display: grid;
  min-width: 0;
  gap: 4px;
}
.metadata-hierarchy-detail > header span {
  color: #397361;
  font-size: 10px;
  font-weight: 850;
}
.metadata-hierarchy-detail > header strong {
  color: #244c42;
  font-size: 15px;
}
.metadata-hierarchy-detail > header p {
  margin: 0;
  color: #788a84;
  font-size: 10px;
  overflow-wrap: anywhere;
}
.metadata-hierarchy-detail > header > em {
  flex: 0 0 auto;
  color: #557068;
  font-size: 10px;
  font-style: normal;
}

.metadata-hierarchy-representative {
  display: grid;
  gap: 5px;
  margin-top: 14px;
  padding: 12px;
  border: 1px solid #cfe1da;
  border-radius: 11px;
  background: #f1f8f5;
}
.metadata-hierarchy-representative span {
  color: #557169;
  font-size: 10px;
  font-weight: 800;
}
.metadata-hierarchy-representative strong {
  color: #245a4c;
  line-height: 1.55;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}
.metadata-hierarchy-representative small {
  color: #778a83;
  font-size: 10px;
}

.metadata-hierarchy-unit-conflict {
  margin-top: 10px;
  padding: 10px 12px;
  border: 1px solid #ecd2ad;
  border-radius: 10px;
  background: #fff8ec;
}
.metadata-hierarchy-unit-conflict strong {
  color: #87551e;
  font-size: 11px;
}
.metadata-hierarchy-unit-conflict p {
  margin: 3px 0 0;
  color: #806b51;
  font-size: 10px;
  line-height: 1.5;
}

.metadata-hierarchy-candidate-list {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  margin-top: 12px;
}
.metadata-hierarchy-candidate-list > article {
  display: flex;
  min-width: 0;
  min-height: 155px;
  padding: 12px;
  border: 1px solid #dbe6e2;
  border-radius: 11px;
  background: #fff;
  flex-direction: column;
  gap: 7px;
}
.metadata-hierarchy-candidate-list > article.is-selected {
  border-color: #4d927e;
  box-shadow: 0 0 0 2px rgba(77, 146, 126, 0.12);
}
.metadata-hierarchy-candidate-list > article header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}
.metadata-hierarchy-candidate-list > article header span,
.metadata-hierarchy-candidate-list > article header em {
  font-size: 9px;
}
.metadata-hierarchy-candidate-list > article header em {
  color: #2e745f;
  font-style: normal;
  font-weight: 850;
}
.metadata-hierarchy-candidate-list > article > strong {
  color: #2d5047;
  line-height: 1.55;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}
.metadata-hierarchy-candidate-list > article > code {
  color: #758780;
  font-size: 9px;
  overflow-wrap: anywhere;
}
.metadata-hierarchy-candidate-list > article > button {
  min-height: 36px;
  margin-top: auto;
  padding: 7px 9px;
  border: 1px solid #b9d2ca;
  border-radius: 8px;
  color: #2b6757;
  background: #f7fbf9;
  font-size: 10px;
  font-weight: 850;
}
.metadata-hierarchy-candidate-list > article > button[aria-pressed=true] {
  border-color: #286b59;
  color: #fff;
  background: #286b59;
}
.metadata-hierarchy-candidate-list > article > button:focus-visible {
  outline: 3px solid rgba(46, 121, 100, 0.24);
  outline-offset: 2px;
}

.metadata-hierarchy-evidence {
  margin-top: 14px;
  padding-top: 14px;
  border-top: 1px solid #dfe8e5;
}
.metadata-hierarchy-evidence > header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.metadata-hierarchy-evidence > header strong {
  color: #345d52;
  font-size: 11px;
}
.metadata-hierarchy-evidence > header button {
  padding: 6px 8px;
  border: 1px solid #c8d9d3;
  border-radius: 7px;
  color: #2e6858;
  background: #fff;
  font-size: 10px;
  font-weight: 800;
}

.metadata-hierarchy-empty {
  padding: 18px;
  color: #7d8d88;
  font-size: 11px;
  text-align: center;
}

.xml-change-history .metadata-review-history-action {
  display: inline-flex;
  margin-left: 7px;
  padding: 2px 6px;
  border-radius: 999px;
  color: #2f6859;
  background: #e6f2ed;
  font-size: 9px;
  font-style: normal;
  font-weight: 800;
}

.xml-change-history p.metadata-review-history-scope {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto auto minmax(0, 1fr);
  align-items: center;
  gap: 6px;
  padding: 8px;
  border-radius: 8px;
  background: #edf4f1;
}
.xml-change-history p.metadata-review-history-scope span {
  color: #547069;
  font-size: 9px;
  font-weight: 800;
}
.xml-change-history p.metadata-review-history-scope i {
  color: #8a9a95;
  font-style: normal;
}
.xml-change-history p.metadata-review-history-scope code {
  color: #355e53;
  font-size: 9px;
  overflow-wrap: anywhere;
}

.metadata-value-apply {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  width: 100%;
  min-height: 40px;
  margin-top: 14px;
  border: 1px solid #bdd5cd;
  border-radius: 11px;
  color: #2d6959;
  background: #fff;
  font-weight: 800;
}
.metadata-value-apply svg {
  opacity: 0;
}
.metadata-value-apply:hover {
  border-color: #67a28f;
  background: #eef8f4;
}
.metadata-value-apply.is-selected {
  border-color: #246b58;
  color: #fff;
  background: #246b58;
  box-shadow: 0 7px 16px rgba(36, 107, 88, 0.2);
}
.metadata-value-apply.is-selected svg {
  opacity: 1;
}

.metadata-standard-details {
  margin-top: 14px;
  overflow: hidden;
  border: 1px solid #d7e4df;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.72);
}
.metadata-standard-details summary {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  color: #2d6254;
  cursor: pointer;
  font-size: 12px;
  font-weight: 800;
  list-style: none;
}
.metadata-standard-details summary::-webkit-details-marker {
  display: none;
}
.metadata-standard-details summary::after {
  width: 7px;
  height: 7px;
  margin-left: auto;
  border-right: 1.5px solid currentColor;
  border-bottom: 1.5px solid currentColor;
  content: "";
  transform: rotate(45deg);
}
.metadata-standard-details summary small {
  color: #83938e;
  font-size: 10px;
  font-weight: 600;
}
.metadata-standard-details[open] summary {
  border-bottom: 1px solid #e0eae6;
}
.metadata-standard-details[open] summary::after {
  transform: rotate(225deg);
}
.metadata-standard-details .metadata-standard-grid {
  margin: 0;
  padding: 14px;
}

@media (max-width: 1180px) {
  .unified-metadata-review {
    grid-template-columns: 225px minmax(0, 1fr);
    gap: 18px;
  }
  .unified-metadata-review .metadata-master-detail {
    grid-template-columns: 255px minmax(0, 1fr);
    gap: 14px;
  }
}
@media (max-width: 860px) {
  .unified-metadata-review {
    grid-template-columns: minmax(0, 1fr);
  }
  .unified-metadata-review .metadata-file-rail {
    position: static;
  }
  .unified-metadata-review .metadata-file-list {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    max-height: 230px;
  }
  .unified-metadata-review .metadata-review-page-head {
    align-items: stretch;
  }
  .unified-metadata-review .metadata-master-detail {
    grid-template-columns: minmax(0, 1fr);
  }
  .unified-metadata-review .metadata-field-master {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    max-height: 350px;
  }
  .metadata-review-progress {
    min-width: 0;
  }
  .metadata-strategy-facts {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .metadata-strategy-summary > header,
  .metadata-hierarchy-role-review > header,
  .metadata-hierarchy-head,
  .metadata-hierarchy-toolbar {
    align-items: stretch;
    flex-direction: column;
  }
  .metadata-strategy-actions {
    justify-content: flex-start;
    max-width: none;
  }
  .metadata-strategy-actions label {
    min-width: min(100%, 320px);
  }
  .metadata-hierarchy-toolbar label {
    width: 100%;
  }
  .metadata-hierarchy-layout {
    grid-template-columns: minmax(0, 1fr);
  }
  .metadata-hierarchy-role-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .metadata-unit-overview-list {
    grid-template-columns: minmax(0, 1fr);
  }
  .metadata-hierarchy-unit-list {
    max-height: 280px;
    border-right: 0;
    border-bottom: 1px solid #dfe9e5;
  }
}
@media (max-width: 560px) {
  .unified-metadata-review .metadata-file-list,
  .unified-metadata-review .metadata-field-master {
    grid-template-columns: minmax(0, 1fr);
  }
  .unified-metadata-review .metadata-field-detail {
    padding: 17px;
  }
  .unified-metadata-review .metadata-value-comparison {
    grid-template-columns: minmax(0, 1fr);
  }
  .unified-metadata-review .metadata-strategy-facts,
  .unified-metadata-review .metadata-hierarchy-role-grid,
  .unified-metadata-review .metadata-review-scope-switch,
  .unified-metadata-review .metadata-hierarchy-candidate-list {
    grid-template-columns: minmax(0, 1fr);
  }
  .unified-metadata-review .metadata-hierarchy-role-review > footer,
  .unified-metadata-review .metadata-unit-overview-toolbar {
    align-items: stretch;
    flex-direction: column;
  }
  .unified-metadata-review .metadata-hierarchy-role-review > footer button,
  .unified-metadata-review .metadata-unit-overview-toolbar button {
    width: 100%;
  }
  .unified-metadata-review .xml-change-history p.metadata-review-history-scope {
    grid-template-columns: minmax(0, 1fr);
  }
  .unified-metadata-review .xml-change-history p.metadata-review-history-scope i {
    display: none;
  }
  .unified-metadata-review .metadata-field-decisions {
    align-items: stretch;
    flex-direction: column;
  }
  .unified-metadata-review .metadata-field-decisions > div {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .unified-metadata-review .metadata-field-decisions > button:last-child {
    width: 100%;
  }
}
.metadata-scope-stage {
  display: grid;
  width: 100%;
  min-width: 0;
  max-width: 100%;
  gap: 18px;
}

.final-warning-target-list {
  display: grid;
  gap: 8px;
  padding: 13px;
  border: 1px solid #d9a64b;
  border-radius: 11px;
  background: #fff8e8;
}
.final-warning-target-list > header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.final-warning-target-list > header strong {
  display: block;
  margin-top: 3px;
  color: #6f4818;
  font-size: 11px;
}
.final-warning-target-list > header em {
  padding: 5px 8px;
  border-radius: 999px;
  background: #bd771c;
  color: #fff;
  font-size: 8px;
  font-style: normal;
  font-weight: 900;
}
.final-warning-target-list > article {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  gap: 4px 9px;
  padding: 10px;
  border: 1px solid #e4bf78;
  border-radius: 9px;
  background: #fff;
}
.final-warning-target-list > article > span {
  grid-row: 1/3;
  align-self: start;
  padding: 4px 7px;
  border-radius: 999px;
  background: #bd771c;
  color: #fff;
  font-size: 8px;
  font-weight: 900;
}
.final-warning-target-list > article p {
  margin: 0;
  color: #65491f;
  font-size: 9px;
  font-weight: 800;
}
.final-warning-target-list > article small {
  color: #846c48;
  font-size: 8px;
}

.scope-tier-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.scope-tier-card {
  display: grid;
  grid-template-columns: 34px minmax(0, 1fr);
  gap: 10px;
  padding: 16px;
  border: 1px solid #dce7e3;
  border-radius: 14px;
  background: #fff;
}
.scope-tier-card > span {
  display: grid;
  width: 30px;
  height: 30px;
  border-radius: 9px;
  background: #e9f4f0;
  color: #276554;
  font-weight: 900;
  place-items: center;
}
.scope-tier-card p {
  margin: 5px 0 0;
  color: #697b76;
  line-height: 1.4;
}
.scope-tier-card em {
  grid-column: 2;
  color: #417066;
  font-size: 12px;
  font-style: normal;
  font-weight: 800;
}
.scope-tier-card.is-disabled {
  opacity: 0.68;
}

.layout-applicability-notice {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  padding: 13px 15px;
  border: 1px solid #d7e5e1;
  border-radius: 13px;
  background: #f5f9f8;
}
.layout-applicability-notice > span {
  flex: 0 0 auto;
  padding: 5px 8px;
  border-radius: 999px;
  background: #e7efed;
  color: #5e746e;
  font-size: 9px;
  font-weight: 850;
}
.layout-applicability-notice > div {
  display: grid;
  gap: 3px;
}
.layout-applicability-notice strong {
  color: #315c52;
  font-size: 12px;
}
.layout-applicability-notice p {
  margin: 0;
  color: #6b7e78;
  font-size: 10px;
  line-height: 1.55;
}

.dtd-coverage-panel,
.profile-handoff-panel {
  width: 100%;
  min-width: 0;
  max-width: 100%;
  box-sizing: border-box;
  padding: 18px;
  border: 1px solid #dbe6e2;
  border-radius: 16px;
  background: #fff;
}

.dtd-coverage-panel {
  overflow: hidden;
}

.dtd-file-switcher {
  width: 100%;
  min-width: 0;
  max-width: 100%;
  box-sizing: border-box;
  margin: -4px -4px 16px;
  overflow-x: auto;
  overscroll-behavior-inline: contain;
  border-color: #d7e5e0;
  background: #f3f8f6;
}
.dtd-file-switcher button {
  min-width: 210px;
  max-width: 260px;
}
.dtd-file-switcher button small {
  max-width: 240px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dtd-coverage-header {
  padding-bottom: 16px;
  border-bottom: 1px solid #e4ece9;
}

.dtd-coverage-health {
  display: flex !important;
  align-items: center !important;
  flex-direction: row !important;
  gap: 10px !important;
  padding: 9px 12px;
  border: 1px solid #cfe3dc;
  border-radius: 12px;
  background: #f0f8f5;
}
.dtd-coverage-health > span {
  width: 10px;
  height: 10px;
  flex: 0 0 auto;
  border-radius: 50%;
  background: #2f806b;
  box-shadow: 0 0 0 4px rgba(47, 128, 107, 0.12);
}
.dtd-coverage-health > div {
  display: grid;
  gap: 1px;
  text-align: left;
}
.dtd-coverage-health strong {
  color: #244e43;
  font-size: 13px;
}
.dtd-coverage-health small {
  color: #6a7e78;
  font-size: 11px;
}
.dtd-coverage-health.has-issues {
  border-color: #efd8a8;
  background: #fff8e9;
}
.dtd-coverage-health.has-issues > span {
  background: #bd7c21;
  box-shadow: 0 0 0 4px rgba(189, 124, 33, 0.13);
}

.dtd-coverage-overview {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
  margin-top: 16px;
}
.dtd-coverage-overview article {
  display: grid;
  min-width: 0;
  gap: 5px;
  padding: 14px 16px;
  border: 1px solid #dce8e4;
  border-radius: 13px;
  background: #f7faf9;
}
.dtd-coverage-overview article.is-schema {
  background: #f4f8f7;
}
.dtd-coverage-overview article.is-source {
  border-color: #cfe3dc;
  background: #eff8f4;
}
.dtd-coverage-overview article.is-quality {
  background: #f8faf9;
}
.dtd-coverage-overview article.is-quality.has-issues {
  border-color: #efd6a3;
  background: #fff8e9;
}
.dtd-coverage-overview span {
  color: #72827e;
  font-size: 11px;
  font-weight: 700;
}
.dtd-coverage-overview strong {
  color: #203f38;
  font-size: 20px;
  letter-spacing: -0.02em;
}
.dtd-coverage-overview p {
  margin: 0;
  color: #657a74;
  font-size: 12px;
}

.dtd-coverage-workspace {
  display: grid;
  width: 100%;
  min-width: 0;
  max-width: 100%;
  grid-template-columns: minmax(320px, 0.72fr) minmax(0, 1.28fr);
  gap: 12px;
  margin-top: 12px;
}

.dtd-group-navigation,
.dtd-group-inspector {
  min-width: 0;
  overflow: hidden;
  border: 1px solid #dce7e3;
  border-radius: 14px;
  background: #fbfcfc;
}

.dtd-group-navigation {
  padding: 13px;
}
.dtd-group-navigation > header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 2px 2px 12px;
}
.dtd-group-navigation > header > div {
  display: grid;
  gap: 2px;
}
.dtd-group-navigation > header strong {
  color: #294e45;
  font-size: 13px;
}
.dtd-group-navigation > header small {
  color: #758681;
  font-size: 11px;
}
.dtd-group-navigation > header em {
  display: grid;
  width: 28px;
  height: 28px;
  place-items: center;
  border-radius: 9px;
  background: #e8f3ef;
  color: #2e6c5c;
  font-size: 12px;
  font-style: normal;
  font-weight: 800;
}

.dtd-group-index {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 7px;
  max-height: 390px;
  overflow: auto;
  padding-right: 3px;
}
.dtd-group-index button {
  display: grid;
  min-width: 0;
  grid-template-columns: 8px minmax(0, 1fr) auto;
  align-items: center;
  gap: 8px;
  padding: 10px;
  border: 1px solid #e0e9e6;
  border-radius: 10px;
  background: #fff;
  color: #315149;
  text-align: left;
  transition: border-color 0.16s ease, background 0.16s ease, box-shadow 0.16s ease;
}
.dtd-group-index button > span:nth-child(2) {
  display: grid;
  min-width: 0;
  gap: 2px;
}
.dtd-group-index button strong,
.dtd-group-index button small {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dtd-group-index button strong {
  font-size: 12px;
}
.dtd-group-index button small {
  color: #788984;
  font-size: 10px;
}
.dtd-group-index button em {
  color: #34705f;
  font-size: 10px;
  font-style: normal;
  font-weight: 800;
}
.dtd-group-index button:hover {
  border-color: #9abdb2;
  background: #f7fbf9;
}
.dtd-group-index button.is-active {
  border-color: #397f6d;
  background: #eef8f4;
  box-shadow: 0 0 0 2px rgba(57, 127, 109, 0.1);
}
.dtd-group-index button.is-attention em {
  color: #9a671e;
}
.dtd-group-index button.is-attention .dtd-group-state-dot {
  background: #d89a3d;
}
.dtd-group-index button.is-error em {
  color: #ae4d43;
}
.dtd-group-index button.is-error .dtd-group-state-dot {
  background: #c85b51;
}

.dtd-group-state-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #3b8a74;
}

.dtd-group-inspector > header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 15px 16px;
  border-bottom: 1px solid #e1eae7;
  background: #f3f8f6;
}
.dtd-group-inspector > header h5,
.dtd-group-inspector > header p {
  margin: 0;
}
.dtd-group-inspector > header h5 {
  margin-top: 4px;
  color: #264d43;
  font-size: 17px;
}
.dtd-group-inspector > header p {
  margin-top: 4px;
  color: #697d77;
  font-size: 12px;
}
.dtd-group-inspector > header > em {
  padding: 6px 9px;
  border-radius: 999px;
  background: #dff1ea;
  color: #2d725f;
  font-size: 11px;
  font-style: normal;
  font-weight: 800;
}
.dtd-group-inspector > header > em.is-attention {
  background: #fff0d3;
  color: #936119;
}
.dtd-group-inspector > header > em.is-error {
  background: #ffebe8;
  color: #ad4a41;
}

.dtd-group-detail {
  display: grid;
  max-height: 390px;
  overflow: auto;
  padding: 8px;
}
.dtd-group-detail > div {
  display: grid;
  grid-template-columns: minmax(130px, 0.75fr) 62px minmax(170px, 1.25fr);
  align-items: center;
  gap: 10px;
  padding: 10px;
  border-bottom: 1px solid #e7eeeb;
  font-size: 12px;
}
.dtd-group-detail > div.is-absent {
  color: #81908c;
  background: #fafbfb;
}
.dtd-group-detail > div.is-absent code {
  color: #899692;
}
.dtd-group-detail .dtd-group-detail-head {
  position: sticky;
  z-index: 1;
  top: -8px;
  padding-block: 8px;
  background: #fff;
  color: #71827d;
  font-size: 10px;
  font-weight: 800;
  text-transform: uppercase;
}
.dtd-group-detail code {
  overflow: hidden;
  color: #46645c;
  font-family: inherit;
  font-size: 11px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dtd-group-detail .dtd-item-name {
  display: grid;
  min-width: 0;
  gap: 2px;
}
.dtd-group-detail .dtd-item-name strong {
  overflow: hidden;
  color: #294e45;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dtd-group-detail .dtd-item-name small {
  color: #778984;
  font-size: 10px;
}
.dtd-group-detail .dtd-item-count {
  color: #43665d;
  font-weight: 800;
}
.dtd-group-detail .dtd-item-mapping {
  grid-column: 3;
  color: #34715f;
  font-size: 10px;
}

.dtd-field-workflow {
  display: grid;
  gap: 12px;
  margin-top: 18px;
  padding-top: 18px;
  border-top: 1px solid #dce7e3;
}

.dtd-field-workflow-head,
.dtd-field-workflow-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}
.dtd-field-workflow-head h5,
.dtd-field-workflow-head p,
.dtd-field-workflow-toolbar h5,
.dtd-field-workflow-toolbar p {
  margin: 0;
}
.dtd-field-workflow-head h5,
.dtd-field-workflow-toolbar h5 {
  margin-top: 3px;
  color: #244d42;
  font-size: 17px;
}
.dtd-field-workflow-head p,
.dtd-field-workflow-toolbar p {
  margin-top: 4px;
  color: #687d77;
  font-size: 12px;
}

.dtd-field-workflow-summary {
  display: grid;
  justify-items: end;
  gap: 3px;
}
.dtd-field-workflow-summary strong {
  color: #285e50;
  font-size: 13px;
}
.dtd-field-workflow-summary small {
  color: #71847e;
  font-size: 11px;
}
.dtd-field-workflow-summary button {
  padding: 7px 10px;
  border: 1px solid #3f826f;
  border-radius: 9px;
  background: #397a68;
  color: #fff;
  font-size: 11px;
  font-weight: 800;
  cursor: pointer;
}
.dtd-field-workflow-summary button:hover {
  background: #2f6d5c;
}
.dtd-field-workflow-summary button.is-all {
  border-color: #8a6a2b;
  background: #74571f;
}
.dtd-field-workflow-summary button.is-all:hover {
  background: #654a18;
}
.dtd-field-workflow-summary button:disabled {
  border-color: #d5e1dd;
  background: #edf2f0;
  color: #8aa099;
  cursor: not-allowed;
}

.dtd-field-bulk-actions {
  display: flex;
  justify-content: flex-end;
  gap: 6px;
  margin-top: 5px;
}

.dtd-review-guide {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border: 1px solid #e3d3a8;
  border-radius: 12px;
  background: #fffaf0;
}
.dtd-review-guide > div {
  display: grid;
  gap: 3px;
}
.dtd-review-guide strong {
  color: #684f1d;
  font-size: 13px;
}
.dtd-review-guide p {
  margin: 0;
  color: #786b4e;
  font-size: 11px;
  line-height: 1.55;
}
.dtd-review-guide > button {
  padding: 9px 12px;
  border: 1px solid #8a6a2b;
  border-radius: 9px;
  background: #74571f;
  color: #fff;
  font-size: 11px;
  font-weight: 800;
  white-space: nowrap;
  cursor: pointer;
}
.dtd-review-guide.is-complete {
  grid-template-columns: auto minmax(0, 1fr);
  border-color: #bcd9cf;
  background: #f0f8f5;
}
.dtd-review-guide.is-complete strong {
  color: #285e50;
}
.dtd-review-guide.is-complete p {
  color: #60776f;
}

.dtd-review-guide-step {
  display: grid;
  width: 28px;
  height: 28px;
  place-items: center;
  border-radius: 999px;
  background: #74571f;
  color: #fff;
  font-size: 12px;
  font-weight: 900;
}
.is-complete .dtd-review-guide-step {
  background: #347660;
}

.dtd-field-workflow-toolbar {
  padding: 10px 12px;
  border: 1px solid #e0e9e6;
  border-radius: 11px;
  background: #f8faf9;
}
.dtd-field-workflow-toolbar > strong {
  color: #315f53;
  font-size: 12px;
  font-weight: 800;
}
.dtd-field-workflow-toolbar > div {
  display: flex;
  gap: 5px;
}
.dtd-field-workflow-toolbar > div button {
  padding: 7px 10px;
  border: 1px solid #d5e2de;
  border-radius: 8px;
  background: #fff;
  color: #547068;
  font-size: 11px;
  font-weight: 700;
}
.dtd-field-workflow-toolbar > div button.is-active {
  border-color: #4b8877;
  background: #eaf5f1;
  color: #286452;
}
.dtd-field-workflow-toolbar label {
  display: flex;
  align-items: center;
  gap: 8px;
}
.dtd-field-workflow-toolbar label span {
  color: #60766f;
  font-size: 11px;
  font-weight: 700;
}
.dtd-field-workflow-toolbar label input {
  width: min(34vw, 360px);
  padding: 8px 10px;
  border: 1px solid #d6e2de;
  border-radius: 8px;
  background: #fff;
  font-size: 12px;
}

.dtd-field-workbench {
  display: grid;
  grid-template-columns: minmax(250px, 0.65fr) minmax(0, 1.35fr);
  min-height: 500px;
  overflow: hidden;
  border: 1px solid #d9e5e1;
  border-radius: 14px;
  background: #fff;
}

.dtd-field-master {
  max-height: 650px;
  overflow: auto;
  padding: 8px;
  border-right: 1px solid #dfe8e5;
  background: #f7faf9;
}
.dtd-field-master > button {
  display: grid;
  width: 100%;
  grid-template-columns: 24px minmax(0, 1fr) auto;
  align-items: center;
  gap: 8px;
  padding: 9px;
  border: 1px solid transparent;
  border-radius: 9px;
  background: transparent;
  color: #35574e;
  text-align: left;
}
.dtd-field-master > button > span {
  color: #3f7a69;
  font-family: monospace;
  font-size: 11px;
  font-weight: 800;
}
.dtd-field-master > button > div {
  display: grid;
  min-width: 0;
  gap: 2px;
}
.dtd-field-master > button strong,
.dtd-field-master > button small {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dtd-field-master > button strong {
  font-size: 12px;
}
.dtd-field-master > button small,
.dtd-field-master > button em {
  color: #778984;
  font-size: 10px;
}
.dtd-field-master > button em {
  font-style: normal;
  font-weight: 800;
}
.dtd-field-master > button.is-active {
  border-color: #8eb6aa;
  background: #eaf5f1;
}
.dtd-field-master > button.is-complete em {
  color: #2e806a;
}
.dtd-field-master > button.is-absent {
  opacity: 0.58;
}

.dtd-field-empty {
  display: grid;
  justify-items: center;
  gap: 7px;
  margin: 24px 8px;
  color: #778984;
  font-size: 12px;
  text-align: center;
}
.dtd-field-empty strong {
  color: #47665d;
  font-size: 12px;
}
.dtd-field-empty p {
  max-width: 220px;
  margin: 0;
  font-size: 10px;
  line-height: 1.5;
}
.dtd-field-empty button {
  padding: 7px 9px;
  border: 1px solid #8eb6aa;
  border-radius: 8px;
  background: #fff;
  color: #286452;
  font-size: 10px;
  font-weight: 800;
  cursor: pointer;
}

.dtd-field-inspector {
  display: grid;
  align-content: start;
  gap: 13px;
  min-width: 0;
  max-height: 650px;
  overflow: auto;
  padding: 16px;
}
.dtd-field-inspector > header {
  display: flex;
  justify-content: space-between;
  gap: 14px;
}
.dtd-field-inspector > header h5,
.dtd-field-inspector > header p {
  margin: 0;
}
.dtd-field-inspector > header h5 {
  margin-top: 3px;
  color: #244d42;
  font-size: 17px;
}
.dtd-field-inspector > header p {
  max-width: 680px;
  margin-top: 4px;
  overflow: hidden;
  color: #71827d;
  font-family: monospace;
  font-size: 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dtd-field-inspector > header > em {
  align-self: start;
  padding: 5px 8px;
  border-radius: 999px;
  background: #eef3f1;
  color: #587068;
  font-size: 10px;
  font-style: normal;
  font-weight: 800;
}

.dtd-field-value-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 9px;
}
.dtd-field-value-grid article {
  display: grid;
  min-width: 0;
  gap: 5px;
  padding: 11px;
  border: 1px solid #dce7e3;
  border-radius: 10px;
  background: #f8faf9;
}
.dtd-field-value-grid span,
.dtd-field-value-grid small {
  color: #71837d;
  font-size: 10px;
}
.dtd-field-value-grid strong {
  overflow-wrap: anywhere;
  color: #34564d;
  font-size: 12px;
  line-height: 1.55;
}

.dtd-field-decision-guide {
  display: grid;
  gap: 3px;
  padding: 11px 12px;
  border: 1px solid #d6dfb8;
  border-radius: 10px;
  background: #fbfced;
}
.dtd-field-decision-guide strong {
  color: #50601d;
  font-size: 12px;
}
.dtd-field-decision-guide p {
  margin: 0;
  color: #6f7651;
  font-size: 10px;
  line-height: 1.5;
}
.dtd-field-decision-guide.is-changed {
  border-color: #e3d3a8;
  background: #fffaf0;
}
.dtd-field-decision-guide.is-changed strong {
  color: #684f1d;
}
.dtd-field-decision-guide.is-complete {
  border-color: #c9ddd6;
  background: #f3f9f7;
}
.dtd-field-decision-guide.is-complete strong {
  color: #286452;
}

.dtd-field-editor,
.dtd-field-reason {
  display: grid;
  gap: 7px;
}
.dtd-field-editor > label,
.dtd-field-editor > span,
.dtd-field-reason > label,
.dtd-field-reason > span {
  color: #4d6b62;
  font-size: 11px;
  font-weight: 800;
}
.dtd-field-editor small,
.dtd-field-reason small {
  color: #7a8b85;
  font-size: 10px;
  font-weight: 500;
}

.dtd-field-value-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 6px;
}
.dtd-field-value-row input,
.dtd-field-value-row button,
.dtd-field-value-row textarea {
  border: 1px solid #d5e2de;
  border-radius: 8px;
  background: #fff;
  font-size: 12px;
}
.dtd-field-value-row input {
  min-width: 0;
  padding: 9px 10px;
}
.dtd-field-value-row button {
  padding: 7px 9px;
  color: #8a5149;
}

.dtd-field-add-value {
  justify-self: start;
  padding: 6px 9px;
  border: 1px dashed #9ebdb4;
  border-radius: 8px;
  background: #f5faf8;
  color: #3d7565;
  font-size: 11px;
  font-weight: 700;
}

.dtd-search-index-toggle {
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 10px 12px;
  border: 1px solid #cfe1db;
  border-radius: 10px;
  background: #f0f8f5;
}
.dtd-search-index-toggle > span {
  display: grid;
  gap: 2px;
}
.dtd-search-index-toggle strong {
  color: #315f52;
  font-size: 12px;
}
.dtd-search-index-toggle small {
  color: #70827d;
  font-size: 10px;
}

.dtd-field-reason textarea {
  resize: vertical;
  padding: 9px 10px;
  border: 1px solid #d5e2de;
  border-radius: 8px;
  font-family: inherit;
  font-size: 12px;
}

.dtd-source-compare,
.dtd-field-evidence-list,
.dtd-field-history {
  border: 1px solid #dce7e3;
  border-radius: 10px;
  background: #fafcfb;
}
.dtd-source-compare summary,
.dtd-field-evidence-list summary,
.dtd-field-history summary {
  padding: 9px 11px;
  color: #41675d;
  font-size: 11px;
  font-weight: 800;
  cursor: pointer;
}

.dtd-source-compare pre {
  max-height: 260px;
  overflow: auto;
  margin: 0;
  padding: 11px;
  border-top: 1px solid #e2eae7;
  background: #202b28;
  color: #d7e3df;
  font-size: 10px;
  line-height: 1.55;
  white-space: pre-wrap;
}
.dtd-source-compare pre mark {
  background: #ffe39b;
  color: #302b1f;
}

.dtd-field-evidence-list {
  display: grid;
  gap: 5px;
  max-height: 160px;
  overflow: auto;
  padding: 10px;
}
.dtd-field-evidence-list strong {
  color: #41675d;
  font-size: 11px;
}
.dtd-field-evidence-list code {
  overflow-wrap: anywhere;
  color: #657a74;
  font-size: 10px;
}

.dtd-field-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.dtd-field-actions span {
  color: #81672e;
  font-size: 10px;
}
.dtd-field-actions button {
  margin-left: auto;
  padding: 9px 12px;
  border: 1px solid #347660;
  border-radius: 9px;
  background: #347660;
  color: #fff;
  font-size: 11px;
  font-weight: 800;
}
.dtd-field-actions button:disabled {
  border-color: #cddbd6;
  background: #eaf1ef;
  color: #668078;
  cursor: default;
}

.dtd-field-inspector-empty {
  place-content: center;
  justify-items: center;
  min-height: 360px;
  text-align: center;
}
.dtd-field-inspector-empty strong {
  color: #35574e;
  font-size: 14px;
}
.dtd-field-inspector-empty p {
  max-width: 380px;
  margin: 0;
  color: #71827d;
  font-size: 11px;
  line-height: 1.6;
}

.dtd-field-history article {
  display: grid;
  gap: 3px;
  padding: 9px 11px;
  border-top: 1px solid #e2eae7;
}
.dtd-field-history strong,
.dtd-field-history p,
.dtd-field-history small {
  margin: 0;
  font-size: 10px;
}
.dtd-field-history p {
  color: #526d65;
}
.dtd-field-history small {
  color: #778984;
}

.profile-handoff-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 9px;
  margin-top: 14px;
}
.profile-handoff-grid article {
  padding: 12px;
  border-radius: 10px;
  background: #f4f8f6;
}
.profile-handoff-grid article > div {
  display: flex;
  justify-content: space-between;
  gap: 8px;
}
.profile-handoff-grid article p {
  margin: 6px 0;
  color: #667a74;
  font-size: 12px;
}
.profile-handoff-grid article small {
  color: #337060;
  font-weight: 700;
}
.profile-handoff-grid article.is-empty {
  opacity: 0.65;
}

@media (max-width: 1100px) {
  .metadata-master-detail {
    grid-template-columns: 220px minmax(0, 1fr);
  }
  .dtd-coverage-workspace {
    grid-template-columns: minmax(280px, 0.8fr) minmax(0, 1.2fr);
  }
  .dtd-field-workbench {
    grid-template-columns: minmax(220px, 0.6fr) minmax(0, 1.4fr);
  }
}
@media (max-width: 860px) {
  .visibility-bulk-toolbar,
  .visibility-selection-toolbar,
  .metadata-review-toolbar,
  .metadata-review-page-head {
    align-items: stretch;
    flex-direction: column;
  }
  .visibility-discovery-toolbar {
    grid-template-columns: 1fr;
  }
  .visibility-result-summary {
    justify-content: flex-start;
    min-height: 0;
    padding: 2px 0;
  }
  .visibility-selected-actions {
    width: 100%;
    margin-left: 0;
  }
  .visibility-selected-actions button {
    flex: 1 1 auto;
  }
  .metadata-master-detail {
    grid-template-columns: 1fr;
  }
  .metadata-field-master {
    display: grid;
    max-height: 290px;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .metadata-value-comparison,
  .metadata-standard-grid,
  .scope-tier-grid,
  .profile-handoff-grid,
  .dtd-coverage-overview,
  .dtd-coverage-workspace,
  .dtd-field-workbench,
  .dtd-field-value-grid {
    grid-template-columns: 1fr;
  }
  .dtd-field-master {
    max-height: 260px;
    border-right: 0;
    border-bottom: 1px solid #dfe8e5;
  }
  .dtd-field-workflow-head,
  .dtd-field-workflow-toolbar {
    align-items: stretch;
    flex-direction: column;
  }
  .dtd-field-workflow-summary {
    justify-items: start;
  }
  .dtd-field-bulk-actions {
    width: 100%;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  .dtd-review-guide {
    grid-template-columns: auto minmax(0, 1fr);
  }
  .dtd-review-guide > button {
    grid-column: 1/-1;
    width: 100%;
  }
  .dtd-field-workflow-toolbar label input {
    width: 100%;
  }
  .dtd-group-index {
    max-height: 270px;
  }
  .source-response-compact {
    grid-template-columns: 1fr;
  }
  .metadata-value-modal-backdrop {
    padding: 12px;
  }
  .metadata-value-modal {
    max-height: 90vh;
  }
  .metadata-value-modal > header {
    padding: 16px;
  }
  .metadata-value-modal > pre {
    max-height: calc(90vh - 104px);
    padding: 16px;
  }
}
@media (max-width: 560px) {
  .dtd-coverage-header {
    align-items: stretch;
    flex-direction: column;
  }
  .dtd-coverage-health {
    align-self: stretch;
    justify-content: flex-start;
  }
  .dtd-group-index {
    grid-template-columns: 1fr;
  }
  .dtd-group-detail .dtd-group-detail-head {
    display: none;
  }
  .dtd-group-detail > div {
    grid-template-columns: minmax(0, 1fr) auto;
  }
  .dtd-group-detail code,
  .dtd-group-detail .dtd-item-mapping {
    grid-column: 1/-1;
  }
}
/* 3단계 Profile별 콘텐츠 검수 작업대 */
.register-page.is-review-step .register-main {
  width: min(100%, 1680px);
}
.register-page.is-review-step .workbench-body {
  padding: 18px;
}

.profile-review-workbench {
  display: grid;
  gap: 14px;
  min-width: 0;
}

.profile-review-header {
  display: grid;
  grid-template-columns: minmax(260px, 1fr) auto minmax(250px, 0.7fr);
  gap: 18px;
  align-items: center;
  padding: 16px 18px;
  border: 1px solid #d7e4e0;
  border-radius: 14px;
  background: linear-gradient(120deg, #f9fbfa, #f0f7f4);
}

.profile-review-file {
  min-width: 0;
}
.profile-review-file h2 {
  margin: 4px 0 0;
  overflow: hidden;
  color: #183d36;
  font-size: 18px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.profile-review-file p {
  margin: 5px 0 0;
  color: #6e817b;
  font-size: 10px;
  line-height: 1.5;
}

.profile-review-stats {
  display: flex;
  gap: 7px;
}
.profile-review-stats > span,
.profile-review-stats .profile-review-stat-button,
.profile-review-stats .profile-review-bulk-approve {
  display: grid;
  min-width: 70px;
  gap: 2px;
  padding: 8px 10px;
  border: 1px solid #d9e5e1;
  border-radius: 9px;
  background: #fff;
}
.profile-review-stats small {
  color: #7b8b86;
  font-size: 8px;
  font-weight: 850;
}
.profile-review-stats strong {
  color: #245d50;
  font-size: 13px;
}
.profile-review-stats .is-attention {
  border-color: #ead3a8;
  background: #fffaf1;
}
.profile-review-stats .is-attention strong {
  color: #925f24;
}
.profile-review-stats .is-error {
  border-color: #e7c2b9;
  background: #fff7f5;
}
.profile-review-stats .is-error strong {
  color: #a24f3c;
}

.profile-review-bulk-approve {
  appearance: none;
  border-color: #2f7664 !important;
  background: #2f7664 !important;
  color: #fff;
  font: inherit;
  text-align: left;
  cursor: pointer;
  transition: background 160ms ease, box-shadow 160ms ease, transform 160ms ease;
}
.profile-review-bulk-approve small,
.profile-review-bulk-approve strong,
.profile-review-bulk-approve em {
  color: #fff !important;
}
.profile-review-bulk-approve em {
  font-size: 8px;
  font-style: normal;
  font-weight: 850;
}
.profile-review-bulk-approve:hover:not(:disabled), .profile-review-bulk-approve:focus-visible {
  background: #245f51 !important;
  box-shadow: 0 0 0 3px rgba(47, 118, 100, 0.16);
  transform: translateY(-1px);
  outline: none;
}
.profile-review-bulk-approve:disabled {
  border-color: #d9e5e1 !important;
  background: #edf3f1 !important;
  cursor: default;
  opacity: 0.72;
}
.profile-review-bulk-approve:disabled small,
.profile-review-bulk-approve:disabled strong,
.profile-review-bulk-approve:disabled em {
  color: #7b8b86 !important;
}

.review-attention-menu-wrap {
  position: relative;
  z-index: 70;
}

.profile-review-stat-button {
  width: 100%;
  appearance: none;
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;
  transition: border-color 0.16s ease, box-shadow 0.16s ease, transform 0.16s ease;
}
.profile-review-stat-button > span {
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: space-between;
}
.profile-review-stat-button em {
  color: #9a733f;
  font-size: 8px;
  font-style: normal;
  font-weight: 850;
}
.profile-review-stat-button:hover:not(:disabled), .profile-review-stat-button:focus-visible, .profile-review-stat-button.is-open {
  border-color: #c68a35;
  box-shadow: 0 0 0 3px rgba(198, 138, 53, 0.14);
  transform: translateY(-1px);
  outline: none;
}
.profile-review-stat-button:disabled {
  border-color: #d9e5e1;
  background: #f8faf9;
  cursor: default;
  opacity: 0.7;
}
.profile-review-stat-button:disabled strong,
.profile-review-stat-button:disabled em {
  color: #7b8b86;
}

.review-attention-menu-backdrop {
  position: fixed;
  z-index: 71;
  inset: 0;
  padding: 0;
  border: 0;
  background: rgba(20, 48, 42, 0.12);
  cursor: default;
}

.review-attention-menu {
  position: absolute;
  z-index: 72;
  top: calc(100% + 10px);
  right: 0;
  display: grid;
  width: min(440px, 100vw - 36px);
  overflow: hidden;
  border: 1px solid #d3e1dd;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 18px 44px rgba(23, 60, 52, 0.2);
}
.review-attention-menu > header {
  display: flex;
  gap: 18px;
  align-items: flex-start;
  justify-content: space-between;
  padding: 15px 16px 12px;
  border-bottom: 1px solid #e3ebe8;
  background: #f6faf8;
}
.review-attention-menu > header strong {
  color: #1b5045;
  font-size: 14px;
}
.review-attention-menu > header p {
  margin: 3px 0 0;
  color: #748680;
  font-size: 9px;
  line-height: 1.45;
}
.review-attention-menu > header button {
  width: 28px;
  height: 28px;
  padding: 0;
  border: 1px solid #d2e0dc;
  border-radius: 7px;
  background: #fff;
  color: #526c65;
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
}

.review-attention-menu-summary {
  display: flex;
  gap: 7px;
  align-items: baseline;
  padding: 10px 16px;
  border-bottom: 1px solid #edf2f0;
}
.review-attention-menu-summary span,
.review-attention-menu-summary em {
  color: #778984;
  font-size: 9px;
  font-style: normal;
}
.review-attention-menu-summary strong {
  color: #925f24;
  font-size: 13px;
}
.review-attention-menu-summary em {
  margin-left: auto;
}

.review-attention-item-list {
  display: grid;
  max-height: min(430px, 58vh);
  overflow-y: auto;
  overscroll-behavior: contain;
}
.review-attention-item-list > button {
  display: grid;
  grid-template-columns: 32px minmax(0, 1fr) auto;
  gap: 10px;
  align-items: center;
  padding: 11px 14px;
  border: 0;
  border-bottom: 1px solid #edf2f0;
  background: #fff;
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;
}
.review-attention-item-list > button:last-child {
  border-bottom: 0;
}
.review-attention-item-list > button:hover, .review-attention-item-list > button:focus-visible, .review-attention-item-list > button.is-current {
  background: #fff8eb;
  outline: none;
}
.review-attention-item-list > button.is-current {
  box-shadow: inset 3px 0 #bd7b22;
}

.review-attention-file-index {
  display: grid;
  width: 32px;
  height: 32px;
  place-items: center;
  border-radius: 9px;
  background: #e9f3f0;
  color: #2b675a;
  font-size: 10px;
  font-weight: 900;
}

.review-attention-item-copy {
  display: grid;
  min-width: 0;
  gap: 2px;
}
.review-attention-item-copy small,
.review-attention-item-copy strong,
.review-attention-item-copy em {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.review-attention-item-copy small {
  color: #71837d;
  font-size: 9px;
}
.review-attention-item-copy strong {
  color: #254e45;
  font-size: 11px;
}
.review-attention-item-copy em {
  color: #9a6524;
  font-size: 8px;
  font-style: normal;
  font-weight: 800;
}

.review-attention-item-arrow {
  color: #9a6524;
  font-size: 20px;
  font-weight: 700;
}

.profile-review-file-nav {
  display: grid;
  grid-template-columns: 82px minmax(230px, 1fr) 82px;
  gap: 8px;
  min-width: 0;
}

.profile-review-file-step {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-width: 0;
  min-height: 58px;
  padding: 0 10px;
  border: 1px solid #c9dad5;
  border-radius: 10px;
  background: #fff;
  color: #285d52;
  font: inherit;
  box-shadow: 0 3px 10px rgba(25, 72, 61, 0.04);
  cursor: pointer;
  transition: border-color 160ms ease, background 160ms ease, color 160ms ease, transform 160ms ease, box-shadow 160ms ease;
}
.profile-review-file-step span {
  flex: 0 0 auto;
  font-size: 20px;
  line-height: 1;
}
.profile-review-file-step strong {
  font-size: 9px;
  font-weight: 900;
  line-height: 1.2;
  white-space: nowrap;
}
.profile-review-file-step:hover:not(:disabled) {
  border-color: #6da696;
  background: #f4faf7;
  box-shadow: 0 6px 16px rgba(25, 72, 61, 0.09);
  transform: translateY(-1px);
}
.profile-review-file-step:focus-visible {
  outline: 3px solid rgba(48, 125, 106, 0.18);
  outline-offset: 2px;
}
.profile-review-file-step:disabled {
  border-color: #dbe5e2;
  background: #f5f8f7;
  color: #9aaba6;
  box-shadow: none;
  cursor: not-allowed;
  opacity: 0.72;
}

.profile-review-file-picker {
  position: relative;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 3px 10px;
  min-width: 0;
  min-height: 58px;
  padding: 9px 86px 8px 13px;
  overflow: hidden;
  border: 1px solid #aacbc2;
  border-radius: 10px;
  background: linear-gradient(90deg, rgba(232, 246, 240, 0.76), rgba(255, 255, 255, 0.96) 48%), #fff;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.65), 0 4px 12px rgba(24, 75, 63, 0.05);
  color: #214f45;
  cursor: pointer;
  transition: border-color 160ms ease, box-shadow 160ms ease, transform 160ms ease;
}
.profile-review-file-picker:hover {
  border-color: #5e9c8b;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.75), 0 7px 18px rgba(24, 75, 63, 0.1);
  transform: translateY(-1px);
}
.profile-review-file-picker:focus-within {
  border-color: #347b69;
  box-shadow: 0 0 0 3px rgba(52, 123, 105, 0.14);
}
.profile-review-file-picker select {
  position: absolute;
  inset: 0;
  z-index: 3;
  width: 100%;
  height: 100%;
  margin: 0;
  cursor: pointer;
  opacity: 0;
}

.profile-review-file-picker-topline {
  display: flex;
  grid-column: 1/-1;
  align-items: center;
  justify-content: space-between;
  min-width: 0;
}
.profile-review-file-picker-topline > small {
  color: #657c75;
  font-size: 8px;
  font-weight: 850;
  letter-spacing: 0.02em;
}
.profile-review-file-picker-topline > em {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: #98601b;
  font-size: 8px;
  font-style: normal;
  font-weight: 900;
}
.profile-review-file-picker-topline > em.is-complete {
  color: #27725f;
}
.profile-review-file-picker-topline .status-dot {
  width: 6px;
  height: 6px;
  border-radius: 999px;
  background: currentColor;
  box-shadow: 0 0 0 3px rgba(152, 96, 27, 0.09);
}

.profile-review-file-picker-name {
  min-width: 0;
  overflow: hidden;
  font-size: 11px;
  font-weight: 950;
  line-height: 1.25;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.profile-review-file-picker-source {
  grid-column: 1/-1;
  min-width: 0;
  overflow: hidden;
  color: #71827d;
  font-size: 7px;
  line-height: 1.25;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.profile-review-file-picker-hint {
  position: absolute;
  top: 50%;
  right: 31px;
  color: #55746c;
  font-size: 8px;
  font-weight: 900;
  pointer-events: none;
  transform: translateY(-50%);
}

.profile-review-file-picker-chevron {
  position: absolute;
  top: 50%;
  right: 11px;
  width: 14px;
  height: 14px;
  pointer-events: none;
  transform: translateY(-50%);
}

.profile-review-body {
  display: grid;
  grid-template-columns: 238px minmax(520px, 1fr) 294px;
  gap: 12px;
  min-height: 720px;
  align-items: start;
}

.profile-review-area-nav,
.profile-review-detail,
.profile-review-inspector {
  min-width: 0;
  border: 1px solid #dbe5e2;
  border-radius: 13px;
  background: #fff;
}

.profile-review-area-nav {
  position: sticky;
  top: 82px;
  display: grid;
  gap: 7px;
  max-height: calc(100vh - 112px);
  padding: 11px;
  overflow-y: auto;
}
.profile-review-area-nav > header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 3px 3px 7px;
  color: #6c7d78;
  font-size: 9px;
}
.profile-review-area-nav > header strong {
  color: #285c51;
  font-size: 10px;
}
.profile-review-area-nav > button {
  position: relative;
  display: grid;
  grid-template-columns: 26px minmax(0, 1fr);
  gap: 8px;
  min-width: 0;
  padding: 10px;
  border: 1px solid #dde6e3;
  border-radius: 9px;
  background: #fbfcfc;
  color: #405b54;
  text-align: left;
  cursor: pointer;
}
.profile-review-area-nav > button:hover, .profile-review-area-nav > button.is-active {
  border-color: #4b897b;
  background: #eef7f4;
}
.profile-review-area-nav > button.is-complete {
  border-color: #8dbdab;
  background: linear-gradient(135deg, #e7f5ef, #f4fbf8);
}
.profile-review-area-nav > button.is-complete .area-order {
  background: #cce7dc;
  color: #1e6755;
}
.profile-review-area-nav > button.is-complete .area-copy strong {
  color: #1d5e4f;
}
.profile-review-area-nav > button.is-complete .area-copy small {
  color: #52796f;
}
.profile-review-area-nav > button.is-complete em.is-complete {
  background: #2f7c67;
  color: #fff;
}
.profile-review-area-nav > button.is-complete:hover, .profile-review-area-nav > button.is-complete.is-active {
  border-color: #347d6a;
  background: linear-gradient(135deg, #dcefe7, #edf8f4);
  box-shadow: 0 4px 12px rgba(36, 107, 89, 0.14);
}
.profile-review-area-nav > button.is-error, .profile-review-area-nav > button.is-missing {
  background: #fff8f5;
}
.profile-review-area-nav > button.is-not_applicable, .profile-review-area-nav > button.is-source_absent {
  background: #f7f9f8;
}
.profile-review-area-nav .area-order {
  display: inline-flex;
  width: 26px;
  height: 26px;
  align-items: center;
  justify-content: center;
  border-radius: 7px;
  background: #eaf2ef;
  color: #2e675a;
  font-size: 9px;
  font-weight: 900;
}
.profile-review-area-nav .area-copy {
  min-width: 0;
}
.profile-review-area-nav .area-copy strong,
.profile-review-area-nav .area-copy small {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.profile-review-area-nav .area-copy strong {
  color: #294a42;
  font-size: 11px;
}
.profile-review-area-nav .area-copy small {
  margin-top: 3px;
  color: #7c8c87;
  font-size: 8px;
}
.profile-review-area-nav em {
  grid-column: 2;
  justify-self: start;
  padding: 3px 6px;
  border-radius: 999px;
  background: #edf2f0;
  color: #6c7b76;
  font-size: 8px;
  font-style: normal;
  font-weight: 850;
}
.profile-review-area-nav em.is-complete {
  background: #dbefe8;
  color: #246453;
}
.profile-review-area-nav em.is-review_required, .profile-review-area-nav em.is-modified {
  background: #f8e8ca;
  color: #875a21;
}
.profile-review-area-nav em.is-error, .profile-review-area-nav em.is-missing {
  background: #f6dfda;
  color: #984b3c;
}

.profile-review-detail {
  display: grid;
  gap: 14px;
  padding: 18px;
}

.profile-review-detail-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
}
.profile-review-detail-head h3 {
  margin: 4px 0 0;
  color: #173d35;
  font-size: 19px;
}
.profile-review-detail-head p {
  margin: 5px 0 0;
  color: #6d7f79;
  font-size: 11px;
  line-height: 1.55;
}

.review-area-status {
  flex: 0 0 auto;
  padding: 6px 9px;
  border-radius: 999px;
  background: #edf2f0;
  color: #60716b;
  font-size: 9px;
  font-weight: 900;
}
.review-area-status.is-complete {
  background: #dcefe9;
  color: #246453;
}
.review-area-status.is-review_required, .review-area-status.is-modified {
  background: #f8e8ca;
  color: #875a21;
}
.review-area-status.is-error, .review-area-status.is-missing {
  background: #f6dfda;
  color: #984b3c;
}

.review-state-callout {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  gap: 10px;
  align-items: center;
  padding: 10px 12px;
  border: 1px solid #dbe6e2;
  border-radius: 9px;
  background: #f7faf9;
}
.review-state-callout strong {
  color: #335d53;
  font-size: 10px;
}
.review-state-callout p {
  margin: 0;
  color: #71827c;
  font-size: 9px;
  line-height: 1.5;
}
.review-state-callout.is-error, .review-state-callout.is-missing {
  border-color: #e6c4bb;
  background: #fff7f5;
}
.review-state-callout.is-error strong, .review-state-callout.is-missing strong {
  color: #9a4b39;
}
.review-state-callout.is-not_applicable, .review-state-callout.is-source_absent {
  background: #f5f7f7;
}

.review-metric-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px;
}
.review-metric-grid article {
  display: grid;
  gap: 4px;
  padding: 11px;
  border: 1px solid #dfe8e5;
  border-radius: 9px;
  background: #f9fbfa;
}
.review-metric-grid article.has-warning {
  border-color: #e4c992;
  background: #fffaf0;
}
.review-metric-grid span {
  color: #788983;
  font-size: 9px;
  font-weight: 800;
}
.review-metric-grid strong {
  color: #285b50;
  font-size: 14px;
}
.review-metric-grid .metric-basis {
  grid-column: 1/-1;
  margin: 0;
  padding: 7px 9px;
  border-radius: 7px;
  background: #eef4f2;
  color: #647a73;
  font-size: 9px;
  line-height: 1.5;
}

.segmented-text-workspace,
.parallel-review-workspace,
.paragraph-review-workspace,
.linked-record-workspace,
.registration-entity-workspace,
.media-review-workspace,
.media-order-workspace,
.ocr-summary-workspace,
.attachment-review-workspace,
.key-value-review-workspace {
  display: grid;
  gap: 12px;
  min-width: 0;
}

.review-list-toolbar,
.entity-master-toolbar,
.paragraph-review-summary,
.parallel-review-summary {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  padding: 9px;
  border: 1px solid #dfe8e5;
  border-radius: 9px;
  background: #f8faf9;
}
.review-list-toolbar input,
.review-list-toolbar select,
.entity-master-toolbar input,
.entity-master-toolbar select,
.paragraph-review-summary input,
.paragraph-review-summary select,
.parallel-review-summary input,
.parallel-review-summary select {
  min-width: 0;
  height: 34px;
  padding: 0 10px;
  border: 1px solid #d1ded9;
  border-radius: 7px;
  background: #fff;
  color: #35564e;
  font: inherit;
  font-size: 10px;
}
.review-list-toolbar input[type=search],
.entity-master-toolbar input[type=search],
.paragraph-review-summary input[type=search],
.parallel-review-summary input[type=search] {
  flex: 1 1 220px;
}
.review-list-toolbar > span,
.review-list-toolbar small,
.entity-master-toolbar > span,
.entity-master-toolbar small,
.paragraph-review-summary > span,
.paragraph-review-summary small,
.parallel-review-summary > span,
.parallel-review-summary small {
  color: #74857f;
  font-size: 9px;
  font-weight: 800;
}

.review-attention-filter {
  display: grid;
  grid-template-columns: 26px minmax(0, 1fr) auto;
  gap: 8px;
  min-width: 220px;
  min-height: 44px;
  align-items: center;
  padding: 6px 9px;
  border: 1px solid #d5dfdc;
  border-radius: 9px;
  background: #fff;
  color: #506861;
  text-align: left;
  cursor: pointer;
  transition: border-color 150ms ease, background 150ms ease, box-shadow 150ms ease;
}
.review-attention-filter:hover {
  border-color: #c39a56;
  background: #fffaf1;
}
.review-attention-filter.has-issues {
  border-color: #dfbd7b;
  background: #fff9ed;
  box-shadow: 0 5px 14px rgba(142, 94, 30, 0.08);
}
.review-attention-filter.is-active {
  border-color: #a66d22;
  background: #a66d22;
  color: #fff;
  box-shadow: 0 7px 16px rgba(123, 78, 20, 0.2);
}
.review-attention-filter .review-attention-filter-icon {
  display: inline-flex;
  width: 26px;
  height: 26px;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #f5dfb8;
  color: #8b581a;
  font-size: 12px;
  font-weight: 950;
}
.review-attention-filter > span:nth-child(2) {
  min-width: 0;
}
.review-attention-filter > span:nth-child(2) strong,
.review-attention-filter > span:nth-child(2) small {
  display: block;
}
.review-attention-filter > span:nth-child(2) strong {
  color: inherit;
  font-size: 10px;
}
.review-attention-filter > span:nth-child(2) small {
  margin-top: 2px;
  color: #8a7658;
  font-size: 8px;
}
.review-attention-filter em {
  padding: 4px 7px;
  border-radius: 999px;
  background: #f4dfb9;
  color: #8b581a;
  font-size: 9px;
  font-style: normal;
  font-weight: 950;
}
.review-attention-filter.is-active .review-attention-filter-icon,
.review-attention-filter.is-active em {
  background: rgba(255, 255, 255, 0.2);
  color: #fff;
}
.review-attention-filter.is-active small {
  color: rgba(255, 255, 255, 0.78);
}

.segmented-text-list {
  display: grid;
  gap: 8px;
}
.segmented-text-list article {
  min-width: 0;
  padding: 12px 13px;
  border: 1px solid #dee7e4;
  border-radius: 9px;
  background: #fff;
}
.segmented-text-list article.needs-attention {
  border-color: #e3c58c;
  background: #fffaf1;
}
.segmented-text-list header {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #758680;
  font-size: 9px;
}
.segmented-text-list header strong {
  color: #2d5d52;
}
.segmented-text-list header em {
  margin-left: auto;
  color: #925f24;
  font-style: normal;
  font-weight: 900;
}
.segmented-text-list p {
  max-height: 210px;
  margin: 8px 0 0;
  overflow: auto;
  color: #334f48;
  font-size: 12px;
  line-height: 1.75;
  white-space: pre-wrap;
}

.review-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}
.review-pagination button {
  padding: 6px 10px;
  border: 1px solid #cfddd8;
  border-radius: 7px;
  background: #fff;
  color: #315f55;
  font-size: 9px;
  font-weight: 850;
}
.review-pagination button:disabled {
  opacity: 0.4;
}
.review-pagination span {
  color: #70827c;
  font-size: 9px;
  font-weight: 850;
}

.parallel-review-summary strong {
  color: #285c51;
  font-size: 11px;
}
.parallel-review-summary button {
  margin-left: auto;
}

.translation-pending-card {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 12px;
  align-items: center;
  padding: 14px;
  border: 1px solid #e6c98f;
  border-radius: 10px;
  background: #fff9ed;
}
.translation-pending-card > header {
  display: flex;
  min-width: 0;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}
.translation-pending-card > header > div {
  display: grid;
  gap: 4px;
  min-width: 0;
}
.translation-pending-card > header strong {
  color: #704b18;
  font-size: 12px;
}
.translation-pending-card > header p {
  margin: 0;
  color: #80663c;
  font-size: 9px;
  line-height: 1.55;
}
.translation-pending-card > header em {
  flex: 0 0 auto;
  padding: 4px 7px;
  border-radius: 999px;
  background: #f4dfb8;
  color: #775019;
  font-size: 8px;
  font-style: normal;
  font-weight: 900;
}
.translation-pending-card.is-error {
  border-color: #e0b8ad;
  background: #fff7f5;
}

.translation-pending-kicker {
  color: #a56c21;
  font-size: 8px;
  font-weight: 900;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.translation-start-btn {
  min-height: 36px;
  padding: 8px 13px;
  border: 1px solid #226250;
  border-radius: 8px;
  background: #226250;
  color: #fff;
  font-size: 9px;
  font-weight: 900;
  cursor: pointer;
}
.translation-start-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.translation-live-progress {
  display: grid;
  grid-column: 1/-1;
  gap: 8px;
  padding: 11px;
  border: 1px solid #c9ddd6;
  border-radius: 9px;
  background: #fff;
}
.translation-live-progress > header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}
.translation-live-progress > header > div {
  display: grid;
  gap: 3px;
}
.translation-live-progress > header span {
  color: #6a7f78;
  font-size: 8px;
  font-weight: 900;
}
.translation-live-progress > header strong {
  color: #285b50;
  font-size: 10px;
}
.translation-live-progress > header em {
  color: #236654;
  font-size: 12px;
  font-style: normal;
  font-weight: 950;
}
.translation-live-progress > footer {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  gap: 8px;
  align-items: baseline;
}
.translation-live-progress > footer strong {
  color: #315f55;
  font-size: 8px;
}
.translation-live-progress > footer p {
  margin: 0;
  color: #6c7f79;
  font-size: 8px;
  line-height: 1.45;
}
.translation-live-progress > footer time {
  color: #899792;
  font-size: 7px;
  white-space: nowrap;
}

.translation-live-progress-track {
  height: 8px;
  overflow: hidden;
  border-radius: 999px;
  background: #e6efec;
}
.translation-live-progress-track > span {
  display: block;
  width: 0;
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, #2f7f6a, #55a58f);
  transition: width 180ms ease;
}

.translation-rerun-progress {
  border-color: #a9d0c5;
  background: #f4faf7;
  box-shadow: 0 6px 16px rgba(41, 101, 85, 0.07);
}

.translation-candidate-stage {
  display: grid;
  gap: 8px;
}

.translation-candidate-guide {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  gap: 5px 9px;
  align-items: baseline;
  padding: 10px 12px;
  border: 1px solid #c9ddd7;
  border-radius: 9px;
  background: #eef7f3;
}
.translation-candidate-guide strong {
  color: #245e50;
  font-size: 9px;
  font-weight: 950;
}
.translation-candidate-guide p {
  margin: 0;
  color: #60756e;
  font-size: 8px;
  line-height: 1.5;
}

.translation-candidate-list {
  display: grid;
  gap: 8px;
}
.translation-candidate-list > article {
  overflow: hidden;
  border: 1px solid #dce6e3;
  border-radius: 9px;
  background: #fff;
}
.translation-candidate-list > article > header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  padding: 8px 10px;
  background: #f4f8f6;
}
.translation-candidate-list > article > header > div {
  display: grid;
  min-width: 0;
  gap: 2px;
}
.translation-candidate-list > article > header > div strong {
  color: #315e54;
  font-size: 9px;
}
.translation-candidate-list > article > header > div span {
  color: #8a6128;
  font-size: 8px;
  font-weight: 900;
}
.translation-candidate-list > article > header .translation-candidate-header-actions {
  display: flex;
  flex: 0 0 auto;
  gap: 6px;
  align-items: center;
}
.translation-candidate-list > article > header .translation-candidate-header-actions > em {
  padding: 4px 7px;
  border-radius: 999px;
  background: #fff0cf;
  color: #8a5a17;
  font-size: 7px;
  font-style: normal;
  font-weight: 950;
  white-space: nowrap;
}
.translation-candidate-list > article > header button {
  flex: 0 0 auto;
  min-height: 26px;
  padding: 4px 8px;
  border: 1px solid #c8dcd5;
  border-radius: 7px;
  background: #fff;
  color: #286352;
  font-size: 8px;
  font-weight: 900;
  cursor: pointer;
}
.translation-candidate-list > article > header button:hover {
  border-color: #6da795;
  background: #eef7f3;
}
.translation-candidate-list > article.is-expanded .translation-candidate-source p {
  display: block;
  max-height: 260px;
  overflow: auto;
  overscroll-behavior: contain;
  scrollbar-gutter: stable;
  -webkit-line-clamp: unset;
}

.translation-candidate-compare {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.translation-candidate-compare > section {
  display: grid;
  min-width: 0;
  align-content: start;
  gap: 7px;
  padding: 11px;
}
.translation-candidate-compare > section + section {
  border-left: 1px solid #e1e8e6;
}
.translation-candidate-compare small {
  color: #6d817a;
  font-size: 8px;
  font-weight: 950;
}

.translation-candidate-source {
  background: #fff;
}
.translation-candidate-source p {
  display: -webkit-box;
  margin: 0;
  overflow: hidden;
  color: #344f48;
  font-size: 10px;
  line-height: 1.65;
  white-space: pre-wrap;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}

.translation-candidate-placeholder {
  background: #f8faf9;
}
.translation-candidate-placeholder > div {
  display: grid;
  min-height: 52px;
  place-content: center;
  gap: 3px;
  padding: 10px;
  border: 1px dashed #cedbd7;
  border-radius: 8px;
  text-align: center;
}
.translation-candidate-placeholder > div strong {
  color: #657770;
  font-size: 9px;
}
.translation-candidate-placeholder > div span {
  color: #8a9793;
  font-size: 8px;
  line-height: 1.45;
}

.translation-candidate-targets {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  gap: 7px 9px;
  align-items: start;
  padding: 8px 10px;
  border-top: 1px solid #e4ebe9;
  background: #fbfcfc;
}
.translation-candidate-targets > strong {
  padding-top: 4px;
  color: #526b64;
  font-size: 8px;
  font-weight: 950;
  white-space: nowrap;
}
.translation-candidate-targets > div {
  display: flex;
  min-width: 0;
  flex-wrap: wrap;
  gap: 4px;
}
.translation-candidate-targets > div > span {
  display: inline-flex;
  gap: 4px;
  align-items: center;
  max-width: 100%;
  padding: 3px 6px;
  overflow: hidden;
  border: 1px solid #d6e3df;
  border-radius: 999px;
  background: #eef6f3;
  color: #335a51;
  font-size: 8px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.translation-candidate-targets > div > span em {
  color: #9a6420;
  font-size: 7px;
  font-style: normal;
  font-weight: 950;
}
.translation-candidate-targets > p {
  margin: 0;
  padding-top: 3px;
  color: #778983;
  font-size: 8px;
}

.parallel-review-list {
  display: grid;
  gap: 9px;
}
.parallel-review-list > article {
  overflow: hidden;
  border: 1px solid #dce6e3;
  border-radius: 9px;
}
.parallel-review-list > article > header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 10px;
  background: #f4f8f6;
  color: #577068;
  font-size: 9px;
}
.parallel-review-list > article > header span.is-empty {
  color: #a05942;
}
.parallel-review-list > article > header span.is-partial {
  color: #986616;
}
.parallel-review-list > article > div {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.parallel-review-list > article section {
  min-width: 0;
  padding: 12px;
}
.parallel-review-list > article section + section {
  border-left: 1px solid #e1e8e6;
}
.parallel-review-list > article .parallel-review-source {
  background: #ffffff;
}
.parallel-review-list > article .parallel-review-translation {
  background: #f1f8f5;
}
.parallel-review-list > article .parallel-review-translation.is-empty {
  background: #fff8ed;
}
.parallel-review-list > article small {
  color: #315f55;
  font-size: 9px;
  font-weight: 950;
}
.parallel-review-list > article p {
  min-height: 72px;
  max-height: 240px;
  margin: 6px 0 0;
  overflow: auto;
  overscroll-behavior: contain;
  scrollbar-gutter: stable;
  color: #344f48;
  font-size: 11px;
  line-height: 1.65;
  white-space: pre-wrap;
}

.parallel-review-list .translation-segment-failure-reason {
  min-height: 0;
  max-height: none;
  margin: 0;
  padding: 8px 10px;
  overflow: visible;
  border-top: 1px solid #ecd7ac;
  background: #fff9ed;
  color: #7d5a1f;
  font-size: 9px;
  font-weight: 800;
  line-height: 1.55;
}

.parallel-review-row-actions {
  display: flex;
  align-items: center;
  gap: 7px;
}

.translation-segment-retry-btn {
  display: inline-flex;
  min-height: 28px;
  align-items: center;
  gap: 5px;
  padding: 5px 9px;
  border: 1px solid #d19c4a;
  border-radius: 7px;
  background: #fff;
  color: #805619;
  font-size: 8px;
  font-weight: 950;
  cursor: pointer;
}
.translation-segment-retry-btn .layout-preview-spinner {
  width: 11px;
  height: 11px;
}
.translation-segment-retry-btn:hover:not(:disabled) {
  border-color: #b77927;
  background: #fff8ea;
}
.translation-segment-retry-btn:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.parallel-review-warning {
  display: grid;
  gap: 3px;
  padding: 10px 12px;
  border: 1px solid #e9c887;
  border-radius: 9px;
  background: #fff8ea;
}
.parallel-review-warning strong {
  color: #875d1e;
  font-size: 9px;
  font-weight: 950;
}
.parallel-review-warning p {
  margin: 0;
  color: #7e7058;
  font-size: 8px;
  line-height: 1.5;
}

.parallel-review-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
}

.translation-rerun-btn,
.translation-reopen-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  min-height: 30px;
  padding: 6px 10px;
  border-radius: 8px;
  font-size: 8px;
  font-weight: 950;
  cursor: pointer;
}
.translation-rerun-btn:disabled,
.translation-reopen-btn:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}

.translation-rerun-btn {
  border: 1px solid #d19c4a;
  background: #fff8e9;
  color: #805619;
}
.translation-rerun-btn:hover {
  background: #ffefcf;
}

.translation-reopen-btn {
  border: 1px solid #245f52;
  background: #286b5c;
  color: #fff;
}
.translation-reopen-btn:hover {
  background: #1f584c;
}

.paragraph-review-summary {
  justify-content: space-between;
}
.paragraph-review-summary > div {
  display: flex;
  gap: 9px;
  align-items: baseline;
}
.paragraph-review-summary strong {
  color: #285c51;
  font-size: 12px;
}
.paragraph-review-summary span {
  color: #8a6b38;
  font-size: 9px;
  font-weight: 850;
}

.paragraph-review-grid {
  display: grid;
  grid-template-columns: 225px minmax(0, 1fr);
  gap: 10px;
  min-height: 480px;
}

.paragraph-master {
  display: grid;
  align-content: start;
  gap: 6px;
  max-height: 520px;
  padding-right: 4px;
  overflow-y: auto;
}
.paragraph-master button {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 4px 8px;
  padding: 9px;
  border: 1px solid #dce6e3;
  border-radius: 8px;
  background: #fff;
  color: #49635c;
  text-align: left;
}
.paragraph-master button.is-active {
  border-color: #3c8070;
  background: #edf7f3;
}
.paragraph-master button.needs-attention {
  background: #fffaf1;
}
.paragraph-master button strong {
  color: #2c5a50;
  font-size: 9px;
}
.paragraph-master button span {
  grid-column: 1/-1;
  overflow: hidden;
  font-size: 9px;
  line-height: 1.5;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.paragraph-master button em {
  font-size: 8px;
  font-style: normal;
}

.paragraph-editor {
  display: grid;
  align-content: start;
  gap: 10px;
  padding: 13px;
  border: 1px solid #dce6e3;
  border-radius: 9px;
  background: #f9fbfa;
}
.paragraph-editor header {
  display: flex;
  justify-content: space-between;
  color: #6b7e77;
  font-size: 9px;
}
.paragraph-editor header strong {
  color: #2c5a50;
  font-size: 11px;
}
.paragraph-editor textarea {
  width: 100%;
  min-height: 330px;
  padding: 11px;
  resize: vertical;
  border: 1px solid #cfddd8;
  border-radius: 8px;
  background: #fff;
  color: #314d46;
  font: inherit;
  font-size: 11px;
  line-height: 1.7;
}

.paragraph-editor-actions,
.entity-decision-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 6px;
}
.paragraph-editor-actions button,
.entity-decision-actions button {
  padding: 7px 9px;
  border: 1px solid #cbdad5;
  border-radius: 7px;
  background: #fff;
  color: #315f55;
  font-size: 9px;
  font-weight: 850;
}
.paragraph-editor-actions button.is-primary,
.entity-decision-actions button.is-primary {
  border-color: #246556;
  background: #246556;
  color: #fff;
}

.linked-record-list {
  display: grid;
  gap: 7px;
  max-height: 430px;
  overflow-y: auto;
}
.linked-record-list article {
  display: grid;
  grid-template-columns: 32px minmax(0, 1fr) auto;
  gap: 9px;
  align-items: center;
  padding: 10px;
  border: 1px solid #dfe8e5;
  border-radius: 8px;
  background: #fff;
}
.linked-record-list article > span {
  display: inline-flex;
  width: 28px;
  height: 28px;
  align-items: center;
  justify-content: center;
  border-radius: 7px;
  background: #edf4f1;
  color: #2f675a;
  font-size: 9px;
  font-weight: 900;
}
.linked-record-list article strong,
.linked-record-list article small {
  display: block;
}
.linked-record-list article strong {
  color: #34534b;
  font-size: 10px;
}
.linked-record-list article small {
  margin-top: 3px;
  color: #7c8c87;
  font-size: 8px;
}

.linked-record-editor,
.key-value-review-workspace label {
  display: grid;
  gap: 7px;
  color: #526b64;
  font-size: 9px;
  font-weight: 850;
}
.linked-record-editor textarea,
.key-value-review-workspace label textarea {
  width: 100%;
  padding: 10px;
  resize: vertical;
  border: 1px solid #cfddd8;
  border-radius: 8px;
  color: #314d46;
  font: inherit;
  font-size: 10px;
  line-height: 1.65;
}

.registration-entity-grid {
  display: grid;
  grid-template-columns: 225px minmax(0, 1fr);
  gap: 10px;
}

.entity-master-list {
  display: grid;
  align-content: start;
  gap: 6px;
  max-height: 650px;
  overflow-y: auto;
}
.entity-master-list > header {
  display: flex;
  justify-content: space-between;
  padding: 4px 2px 7px;
  color: #71837d;
  font-size: 8px;
}
.entity-master-list > header strong {
  color: #2e6055;
  font-size: 10px;
}
.entity-master-list > button {
  position: relative;
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  gap: 4px 7px;
  padding: 9px;
  border: 1px solid #dce6e3;
  border-radius: 8px;
  background: #fff;
  color: #3f5d55;
  text-align: left;
}
.entity-master-list > button.is-active {
  border-color: #3e8071;
  background: #eef7f4;
}
.entity-master-list > button.needs-attention {
  background: #fffaf1;
}
.entity-master-list > button.is-final-warning-target {
  padding-right: 70px;
  border-color: #d9a64b;
  background: #fff4d9;
  box-shadow: 0 0 0 2px rgba(217, 166, 75, 0.13);
}
.entity-master-list > button > span {
  font-size: 8px;
}
.entity-master-list > button > strong {
  overflow: hidden;
  font-size: 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.entity-master-list > button > small {
  grid-column: 1/-1;
  overflow: hidden;
  color: #788983;
  font-size: 8px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.final-warning-target-badge {
  position: absolute;
  top: 8px;
  right: 8px;
  padding: 4px 7px;
  border-radius: 999px;
  background: #bd771c;
  color: #fff;
  font-size: 7px;
  font-style: normal;
  font-weight: 900;
}

.final-warning-target-guidance {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 11px 13px;
  border: 1px solid #d9a64b;
  border-radius: 9px;
  background: #fff4d9;
}
.final-warning-target-guidance strong {
  color: #6f4818;
  font-size: 10px;
}
.final-warning-target-guidance p {
  margin: 3px 0 0;
  color: #82663d;
  font-size: 8px;
  line-height: 1.5;
}
.final-warning-target-guidance > span {
  flex: 0 0 auto;
  padding: 5px 8px;
  border-radius: 999px;
  background: #bd771c;
  color: #fff;
  font-size: 8px;
  font-weight: 900;
}

.entity-decision-gate {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 13px;
  border: 1px solid #dda84e;
  border-radius: 9px;
  background: #fff7e7;
  box-shadow: 0 5px 14px rgba(142, 94, 30, 0.08);
}
.entity-decision-gate strong {
  color: #6f4818;
  font-size: 10px;
}
.entity-decision-gate p {
  margin: 3px 0 0;
  color: #82663d;
  font-size: 8px;
  line-height: 1.55;
}
.entity-decision-gate > button {
  flex: 0 0 auto;
  min-height: 34px;
  padding: 0 11px;
  border: 1px solid #b97a25;
  border-radius: 7px;
  background: #b97a25;
  color: #fff;
  font: inherit;
  font-size: 8px;
  font-weight: 900;
  cursor: pointer;
}

.entity-detail-panel {
  display: grid;
  gap: 11px;
  min-width: 0;
  padding: 13px;
  border: 1px solid #dce6e3;
  border-radius: 9px;
  background: #fbfcfc;
}
.entity-detail-panel > header {
  display: flex;
  justify-content: space-between;
  gap: 10px;
}
.entity-detail-panel > header h4 {
  margin: 4px 0 0;
  color: #244d44;
  font-size: 16px;
}
.entity-detail-panel > header p {
  margin: 4px 0 0;
  color: #74857f;
  font-size: 8px;
}
.entity-detail-panel > header em {
  color: #7a8b85;
  font-size: 9px;
  font-style: normal;
  font-weight: 850;
}
.entity-detail-panel.is-final-warning-target {
  border-color: #d9a64b;
  background: #fffbf1;
  box-shadow: 0 0 0 2px rgba(217, 166, 75, 0.11);
}

.final-warning-target-note {
  padding: 9px 10px;
  border: 1px solid #e0ba71;
  border-radius: 8px;
  background: #fff1cf;
}
.final-warning-target-note strong {
  color: #6d4616;
  font-size: 9px;
}
.final-warning-target-note p {
  margin: 3px 0 0;
  color: #82643a;
  font-size: 8px;
  line-height: 1.5;
}

.entity-source-card {
  display: grid;
  gap: 6px;
  padding: 10px;
  border: 1px solid #dbe6e2;
  border-radius: 8px;
  background: #f3f8f6;
}
.entity-source-card small {
  color: #6f837c;
  font-size: 8px;
}
.entity-source-card strong {
  color: #28584d;
  font-size: 12px;
}
.entity-source-card q {
  color: #4a625b;
  font-size: 9px;
  line-height: 1.55;
}

.entity-name-reading-review {
  display: grid;
  gap: 10px;
  padding: 11px;
  border: 1px solid #dfbd76;
  border-radius: 8px;
  background: #fff8e9;
}
.entity-name-reading-review > header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}
.entity-name-reading-review > header strong {
  color: #704a19;
  font-size: 10px;
}
.entity-name-reading-review > header p {
  margin: 3px 0 0;
  color: #816944;
  font-size: 8px;
  line-height: 1.5;
}
.entity-name-reading-review > header em {
  flex: 0 0 auto;
  padding: 4px 7px;
  border-radius: 999px;
  background: #f2ddb2;
  color: #6d4817;
  font-size: 8px;
  font-style: normal;
  font-weight: 900;
}
.entity-name-reading-review > div {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
}
.entity-name-reading-review button {
  display: grid;
  gap: 2px;
  min-width: 96px;
  padding: 7px 9px;
  border: 1px solid #b7883c;
  border-radius: 7px;
  background: #fff;
  color: #68491d;
  text-align: left;
}
.entity-name-reading-review button strong {
  font-size: 10px;
}
.entity-name-reading-review button small {
  color: #8a714c;
  font-size: 7px;
}
.entity-name-reading-review > p {
  margin: 0;
  color: #816944;
  font-size: 8px;
}

.compact-candidate-list {
  display: grid;
  gap: 7px;
}
.compact-candidate-list > header {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  color: #70817b;
  font-size: 8px;
}
.compact-candidate-list > header strong {
  color: #2d5c51;
  font-size: 10px;
}
.compact-candidate-list article {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 8px;
  padding: 9px;
  border: 1px solid #dfe7e5;
  border-radius: 8px;
  background: #fff;
}
.compact-candidate-list article.is-selected {
  border-color: #4b8c7c;
  background: #eef7f4;
}
.compact-candidate-list article strong,
.compact-candidate-list article span,
.compact-candidate-list article p {
  display: block;
}
.compact-candidate-list article strong {
  color: #294e46;
  font-size: 10px;
}
.compact-candidate-list article span {
  margin-top: 2px;
  color: #70817b;
  font-size: 8px;
}
.compact-candidate-list article p {
  margin: 4px 0 0;
  color: #62756e;
  font-size: 8px;
  line-height: 1.45;
}
.compact-candidate-list article button {
  align-self: center;
  padding: 6px 8px;
  border: 1px solid #2f7061;
  border-radius: 6px;
  background: #fff;
  color: #2f7061;
  font-size: 8px;
  font-weight: 900;
}

.entity-candidate-empty {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px;
  border: 1px solid #d9b66f;
  border-radius: 8px;
  background: #fff8e9;
}
.entity-candidate-empty strong {
  color: #704a19;
  font-size: 10px;
}
.entity-candidate-empty p {
  margin: 3px 0 0;
  color: #816944;
  font-size: 8px;
  line-height: 1.55;
}
.entity-candidate-empty > button {
  flex: 0 0 auto;
  min-height: 34px;
  padding: 0 11px;
  border: 1px solid #a86e20;
  border-radius: 7px;
  background: #a86e20;
  color: #fff;
  font: inherit;
  font-size: 8px;
  font-weight: 900;
  cursor: pointer;
}

.media-review-workspace {
  grid-template-columns: minmax(280px, 1fr) minmax(220px, 0.7fr);
}

.media-preview {
  display: grid;
  min-height: 420px;
  place-items: center;
  overflow: hidden;
  border: 1px solid #dbe5e2;
  border-radius: 10px;
  background: #f2f5f4;
}
.media-preview img {
  display: block;
  max-width: 100%;
  max-height: 620px;
  object-fit: contain;
}

.media-facts {
  display: grid;
  align-content: start;
  gap: 8px;
}
.media-facts article {
  display: grid;
  gap: 5px;
  padding: 12px;
  border: 1px solid #dfe8e5;
  border-radius: 9px;
  background: #f9fbfa;
}
.media-facts span {
  color: #788983;
  font-size: 8px;
  font-weight: 850;
}
.media-facts strong {
  overflow-wrap: anywhere;
  color: #2d5b51;
  font-size: 11px;
}

.media-order-workspace > article,
.attachment-review-workspace > article {
  display: grid;
  grid-template-columns: 36px 84px minmax(0, 1fr);
  gap: 10px;
  align-items: center;
  padding: 11px;
  border: 1px solid #dce6e3;
  border-radius: 9px;
  background: #fff;
}
.media-order-workspace > article > span,
.attachment-review-workspace > article > span {
  display: inline-flex;
  width: 32px;
  height: 32px;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #e9f3ef;
  color: #2f675a;
  font-size: 10px;
  font-weight: 900;
}
.media-order-workspace > article img,
.attachment-review-workspace > article img {
  width: 84px;
  height: 64px;
  border-radius: 7px;
  object-fit: cover;
}
.media-order-workspace > article strong,
.attachment-review-workspace > article strong {
  color: #2d554c;
  font-size: 10px;
}
.media-order-workspace > article p,
.attachment-review-workspace > article p {
  margin: 4px 0 0;
  color: #73847e;
  font-size: 9px;
}

.ocr-review-callout {
  display: flex;
  align-items: center;
  gap: 8px;
}
.ocr-review-callout > div {
  margin-right: auto;
}

.attachment-review-workspace > article {
  grid-template-columns: 42px minmax(0, 1fr) auto;
}
.attachment-review-workspace > article > a {
  padding: 7px 9px;
  border: 1px solid #2e6c5e;
  border-radius: 7px;
  color: #2e6c5e;
  font-size: 9px;
  font-weight: 850;
  text-decoration: none;
}

.attachment-review-workspace dl,
.profile-review-inspector dl {
  display: grid;
  gap: 0;
  margin: 0;
}
.attachment-review-workspace dl > div,
.profile-review-inspector dl > div {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  padding: 8px 0;
  border-bottom: 1px solid #e7ecea;
}
.attachment-review-workspace dl dt,
.profile-review-inspector dl dt {
  color: #778781;
  font-size: 8px;
}
.attachment-review-workspace dl dd,
.profile-review-inspector dl dd {
  margin: 0;
  color: #31564d;
  font-size: 9px;
  font-weight: 850;
  text-align: right;
}

.key-value-review-workspace > article {
  padding: 9px 10px;
  border: 1px solid #dfe8e5;
  border-radius: 8px;
  color: #36574f;
  font-size: 10px;
}

.profile-review-empty {
  display: grid;
  gap: 5px;
  padding: 18px;
  border: 1px dashed #cfdad7;
  border-radius: 9px;
  background: #f8faf9;
}
.profile-review-empty strong {
  color: #4a635c;
  font-size: 11px;
}
.profile-review-empty p {
  margin: 0;
  color: #788983;
  font-size: 9px;
  line-height: 1.55;
}
.profile-review-empty.is-error {
  border-color: #dfbcb2;
  background: #fff7f5;
}

.profile-review-inspector {
  position: sticky;
  top: 82px;
  display: grid;
  gap: 12px;
  max-height: calc(100vh - 112px);
  padding: 14px;
  border-color: #bfd7d0;
  background: #fbfdfc;
  box-shadow: 0 12px 30px rgba(22, 71, 60, 0.09);
  overflow-y: auto;
}
.profile-review-inspector > section {
  display: grid;
  gap: 7px;
}
.profile-review-inspector > section h3 {
  margin: 0;
  color: #28564c;
  font-size: 13px;
}
.profile-review-inspector > section p {
  margin: 0;
  color: #72837d;
  font-size: 9px;
  line-height: 1.55;
}

.profile-review-scope-card {
  padding: 13px;
  border: 1px solid #b7d6cc;
  border-radius: 10px;
  background: linear-gradient(145deg, #e8f5f0, #f5fbf8);
}
.profile-review-scope-card p {
  color: #56756c !important;
  font-size: 9px !important;
}

.profile-review-scope-heading,
.profile-review-status-heading,
.profile-review-action-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.profile-review-scope-heading {
  color: #255e51;
  font-size: 9px;
  font-weight: 900;
}
.profile-review-scope-heading em {
  padding: 4px 7px;
  border-radius: 999px;
  background: #2b7563;
  color: #fff;
  font-size: 8px;
  font-style: normal;
  white-space: nowrap;
}

.profile-review-scope-file {
  display: block;
  overflow: hidden;
  color: #173f36;
  font-size: 12px;
  line-height: 1.4;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.profile-review-status-card {
  padding: 2px 2px 0;
}

.profile-review-status-heading .review-area-status {
  flex: 0 0 auto;
}

.profile-review-history {
  padding-top: 3px;
  border-top: 1px solid #e4ebe9;
  color: #587069;
  font-size: 9px;
}
.profile-review-history ol {
  display: grid;
  gap: 7px;
  margin: 8px 0 0;
  padding-left: 16px;
}
.profile-review-history p {
  margin: 2px 0;
}
.profile-review-history time {
  color: #82918c;
  font-size: 8px;
}

.profile-review-sticky-actions {
  position: sticky;
  bottom: 0;
  display: grid;
  gap: 8px;
  padding: 12px 0 0;
  border-top: 1px solid #dfe7e5;
  background: #fbfdfc;
}
.profile-review-sticky-actions button {
  min-height: 38px;
  padding: 9px 10px;
  border: 1px solid #cbdad5;
  border-radius: 7px;
  background: #fff;
  color: #315f55;
  font-size: 9px;
  font-weight: 900;
  cursor: pointer;
}
.profile-review-sticky-actions button.is-primary {
  border-color: #286b5c;
  background: #286b5c;
  color: #fff;
  box-shadow: 0 6px 14px rgba(40, 107, 92, 0.16);
}
.profile-review-sticky-actions button.is-primary.is-complete {
  border-color: #80b4a5;
  background: #e2f1ec;
  color: #246253;
  box-shadow: none;
}
.profile-review-sticky-actions button.is-file-complete {
  width: 100%;
  min-height: 44px;
  border-color: #173f36;
  background: #173f36;
  color: #fff;
  font-size: 10px;
  box-shadow: 0 8px 18px rgba(23, 63, 54, 0.2);
}
.profile-review-sticky-actions button:disabled {
  opacity: 0.45;
  cursor: not-allowed;
  box-shadow: none;
}

.profile-review-action-heading {
  min-width: 0;
}
.profile-review-action-heading strong {
  color: #244e45;
  font-size: 9px;
}
.profile-review-action-heading span {
  overflow: hidden;
  color: #768781;
  font-size: 8px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.profile-review-area-actions {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 6px;
}

.profile-review-file-action {
  display: grid;
  gap: 7px;
  margin-top: 3px;
  padding: 11px;
  border: 1px solid #c8dcd6;
  border-radius: 10px;
  background: #f2f8f5;
}
.profile-review-file-action p {
  margin: 0;
  color: #667c75;
  font-size: 8px;
  line-height: 1.5;
}
.profile-review-file-action p.is-attention {
  padding: 7px 8px;
  border-radius: 7px;
  background: #fff0cf;
  color: #825417;
  font-weight: 850;
}

@media (max-width: 1280px) {
  .profile-review-header {
    grid-template-columns: minmax(260px, 1fr) auto;
  }
  .profile-review-file-nav {
    grid-column: 1/-1;
  }
  .profile-review-body {
    grid-template-columns: 210px minmax(0, 1fr);
  }
  .profile-review-inspector {
    position: static;
    grid-column: 1/-1;
    grid-template-columns: minmax(0, 1fr) minmax(220px, 0.5fr);
    max-height: none;
  }
  .profile-review-sticky-actions {
    grid-column: 1/-1;
    grid-template-columns: minmax(180px, 0.55fr) minmax(260px, 1fr) minmax(280px, 1fr);
    align-items: end;
  }
  .profile-review-sticky-actions > .profile-review-action-heading {
    grid-column: 1/-1;
  }
  .profile-review-file-action {
    align-self: stretch;
  }
}
@media (max-width: 900px) {
  .profile-review-header,
  .profile-review-body {
    grid-template-columns: 1fr;
  }
  .profile-review-stats {
    overflow-x: auto;
  }
  .profile-review-area-nav,
  .profile-review-inspector {
    position: static;
    max-height: none;
  }
  .profile-review-area-nav {
    display: flex;
    overflow-x: auto;
  }
  .profile-review-area-nav > header {
    display: none;
  }
  .profile-review-area-nav > button {
    flex: 0 0 190px;
  }
  .profile-review-inspector {
    grid-template-columns: 1fr;
  }
  .profile-review-sticky-actions {
    grid-template-columns: 1fr;
  }
  .profile-review-sticky-actions > .profile-review-action-heading {
    grid-column: auto;
  }
  .paragraph-review-grid,
  .registration-entity-grid,
  .media-review-workspace {
    grid-template-columns: 1fr;
  }
  .paragraph-master,
  .entity-master-list {
    max-height: 280px;
  }
}
@media (max-width: 620px) {
  .register-page.is-review-step .workbench-body {
    padding: 10px;
  }
  .profile-review-file-nav {
    grid-template-columns: 62px minmax(0, 1fr) 62px;
  }
  .profile-review-file-step {
    padding: 0 7px;
  }
  .profile-review-file-step strong {
    font-size: 8px;
  }
  .profile-review-file-picker {
    padding-right: 36px;
  }
  .profile-review-file-picker-hint,
  .profile-review-file-picker-source {
    display: none;
  }
  .profile-review-file-picker-chevron {
    right: 12px;
  }
  .profile-review-file-picker-name {
    grid-column: 1/-1;
  }
  .profile-review-header,
  .profile-review-detail {
    padding: 12px;
  }
  .profile-review-stats > span,
  .profile-review-stat-button,
  .profile-review-bulk-approve {
    min-width: 64px;
  }
  .review-attention-menu {
    position: fixed;
    top: 88px;
    right: 12px;
    left: 12px;
    width: auto;
  }
  .review-metric-grid,
  .profile-review-area-actions {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .parallel-review-list > article > div {
    grid-template-columns: 1fr;
  }
  .parallel-review-list > article section + section,
  .translation-candidate-compare > section + section {
    border-top: 1px solid #e1e8e6;
    border-left: 0;
  }
  .translation-candidate-guide,
  .translation-candidate-targets,
  .translation-candidate-compare {
    grid-template-columns: 1fr;
  }
  .ocr-review-callout {
    align-items: stretch;
    flex-direction: column;
  }
}
/* 등록 자료 상세: 요약 우선 정보 구조와 선택형 XML 검수 탐색 */
.register-page.is-detail-view {
  --detail-ink: #173b36;
  --detail-green: #27695d;
  --detail-green-dark: #184a41;
  --detail-muted: #6c7c78;
  --detail-line: #dce6e3;
  --detail-soft: #f3f7f5;
  --detail-paper: #ffffff;
}
.register-page.is-detail-view .register-header-inner,
.register-page.is-detail-view .register-main {
  width: min(100%, 1480px);
}
.register-page.is-detail-view .register-main {
  padding-top: 18px;
}
.register-page.is-detail-view .register-hero {
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 32px;
  align-items: end;
  padding: 12px 0 20px;
}
.register-page.is-detail-view .register-hero h1 {
  max-width: 1050px;
  font-size: clamp(30px, 3vw, 46px);
  line-height: 1.16;
}
.register-page.is-detail-view .hero-copy {
  margin-top: 12px;
  font-size: 14px;
}
.register-page.is-detail-view .detail-tabs {
  gap: 6px;
  padding: 5px;
  border: 1px solid #d9e3e0;
  border-radius: 13px;
  background: rgba(255, 255, 255, 0.82);
  box-shadow: 0 10px 28px rgba(24, 74, 65, 0.05);
}
.register-page.is-detail-view .detail-tab {
  min-height: 40px;
  border: 0;
  border-radius: 9px;
  padding: 0 15px;
  background: transparent;
  color: #657671;
  font-size: 12px;
  transition: background 160ms ease, color 160ms ease, box-shadow 160ms ease;
}
.register-page.is-detail-view .detail-tab:hover {
  background: #f0f5f3;
  color: var(--detail-ink);
}
.register-page.is-detail-view .detail-tab.is-active {
  background: var(--detail-green-dark);
  color: #fff;
  box-shadow: 0 6px 16px rgba(24, 74, 65, 0.18);
}

.saved-detail-page {
  display: grid;
  gap: 20px;
}

.saved-detail-section-nav {
  position: sticky;
  top: 12px;
  z-index: 12;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  border: 1px solid #d7e4e0;
  border-radius: 16px;
  padding: 12px 14px 12px 18px;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 12px 30px rgba(30, 69, 61, 0.09);
  backdrop-filter: blur(14px);
}

.saved-detail-section-nav-copy {
  min-width: 0;
}
.saved-detail-section-nav-copy strong,
.saved-detail-section-nav-copy span {
  display: block;
}
.saved-detail-section-nav-copy strong {
  color: var(--detail-ink);
  font-size: 12px;
  font-weight: 900;
}
.saved-detail-section-nav-copy span {
  margin-top: 3px;
  color: #7b8c87;
  font-size: 9px;
  font-weight: 700;
}

.saved-detail-section-tabs {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 7px;
}
.saved-detail-section-tabs button {
  display: flex;
  min-height: 46px;
  align-items: center;
  gap: 9px;
  border: 1px solid #d8e3e0;
  border-radius: 11px;
  padding: 0 13px;
  background: #f8faf9;
  color: #516962;
  text-align: left;
  transition: border-color 150ms ease, background 150ms ease, color 150ms ease, box-shadow 150ms ease;
}
.saved-detail-section-tabs button span,
.saved-detail-section-tabs button em {
  display: block;
  white-space: nowrap;
}
.saved-detail-section-tabs button span {
  font-size: 11px;
  font-weight: 900;
}
.saved-detail-section-tabs button em {
  border-radius: 999px;
  padding: 4px 7px;
  background: #e8efed;
  color: #6d817b;
  font-size: 8px;
  font-style: normal;
  font-weight: 900;
}
.saved-detail-section-tabs button:hover {
  border-color: #91b3aa;
  background: #f2f8f5;
}
.saved-detail-section-tabs button.is-active {
  border-color: var(--detail-green);
  background: var(--detail-green);
  color: #fff;
  box-shadow: 0 8px 18px rgba(35, 98, 84, 0.2);
}
.saved-detail-section-tabs button.is-active em {
  background: rgba(255, 255, 255, 0.16);
  color: #fff;
}

.saved-detail-overview,
.xml-saved-review,
.saved-multilingual-view {
  border: 1px solid var(--detail-line);
  border-radius: 20px;
  background: var(--detail-paper);
  box-shadow: 0 16px 42px rgba(29, 63, 57, 0.055);
}

.saved-detail-overview {
  overflow: hidden;
}

.saved-detail-overview-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  padding: 24px 28px;
  border-bottom: 1px solid var(--detail-line);
  background: radial-gradient(circle at 92% 0, rgba(66, 133, 118, 0.11), transparent 280px), linear-gradient(135deg, #ffffff 0%, #f7faf8 100%);
}
.saved-detail-overview-head > div {
  min-width: 0;
}
.saved-detail-overview-head h2 {
  margin: 10px 0 0;
  color: var(--detail-ink);
  font-size: 24px;
  font-weight: 900;
  letter-spacing: -0.025em;
}
.saved-detail-overview-head p {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 9px;
  margin: 8px 0 0;
  color: var(--detail-muted);
  font-size: 12px;
  font-weight: 700;
}
.saved-detail-overview-head p i {
  width: 3px;
  height: 3px;
  border-radius: 50%;
  background: #aebbb7;
}

.saved-detail-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
}
.saved-detail-badges span {
  display: inline-flex;
  min-height: 27px;
  align-items: center;
  border: 1px solid transparent;
  border-radius: 999px;
  padding: 0 10px;
  font-size: 10px;
  font-weight: 900;
}
.saved-detail-badges .is-category {
  border-color: #d8e1df;
  background: #fff;
  color: #536963;
}
.saved-detail-badges .is-profile {
  border-color: #d6e4e0;
  background: #edf6f3;
  color: #286457;
}

.saved-detail-overview-grid {
  display: grid;
  grid-template-columns: minmax(0, 1.55fr) minmax(320px, 0.75fr);
  gap: 0;
}

.saved-detail-description,
.saved-detail-facts {
  min-width: 0;
  padding: 28px;
}

.saved-detail-facts {
  border-left: 1px solid var(--detail-line);
  background: #fbfcfb;
}

.saved-detail-section-title {
  display: flex;
  align-items: center;
  gap: 11px;
}
.saved-detail-section-title > span {
  width: 34px;
  height: 34px;
  display: grid;
  flex: 0 0 auto;
  place-items: center;
  border-radius: 10px;
  background: #e8f2ef;
  color: var(--detail-green);
}
.saved-detail-section-title svg {
  width: 18px;
  height: 18px;
}
.saved-detail-section-title strong,
.saved-detail-section-title small {
  display: block;
}
.saved-detail-section-title strong {
  color: var(--detail-ink);
  font-size: 14px;
  font-weight: 900;
}
.saved-detail-section-title small {
  margin-top: 3px;
  color: #82908c;
  font-size: 10px;
  line-height: 1.45;
}

.saved-detail-description-copy {
  position: relative;
  overflow: hidden;
  margin-top: 20px;
  color: #3d514c;
  font-size: 14px;
  line-height: 1.95;
  white-space: pre-wrap;
}
.saved-detail-description-copy.is-collapsed {
  max-height: 10.8em;
}
.saved-detail-description-copy.is-collapsed::after {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  height: 4.5em;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0), #fff 88%);
  content: "";
  pointer-events: none;
}

.saved-detail-expand {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 12px;
  border: 0;
  padding: 4px 0;
  background: transparent;
  color: var(--detail-green);
  font-size: 11px;
  font-weight: 900;
}
.saved-detail-expand svg {
  width: 14px;
  height: 14px;
  transition: transform 160ms ease;
}
.saved-detail-expand svg.is-open {
  transform: rotate(180deg);
}

.saved-detail-keywords {
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid #e5ecea;
}
.saved-detail-keywords > strong {
  color: #536963;
  font-size: 10px;
  font-weight: 900;
}
.saved-detail-keywords > div {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
  margin-top: 9px;
}
.saved-detail-keywords span {
  display: inline-flex;
  min-height: 28px;
  align-items: center;
  border-radius: 999px;
  padding: 0 10px;
  background: #f0f5f3;
  color: #426259;
  font-size: 10px;
  font-weight: 800;
}

.saved-detail-facts dl {
  display: grid;
  gap: 0;
  margin: 18px 0 0;
}
.saved-detail-facts dl > div {
  display: grid;
  grid-template-columns: 108px minmax(0, 1fr);
  gap: 14px;
  align-items: start;
  padding: 12px 0;
  border-bottom: 1px solid #e5ecea;
}
.saved-detail-facts dl > div:last-child {
  border-bottom: 0;
}
.saved-detail-facts dl dt {
  color: #7a8985;
  font-size: 10px;
  font-weight: 800;
}
.saved-detail-facts dl dd {
  margin: 0;
  color: #2e4942;
  font-size: 12px;
  font-weight: 800;
  line-height: 1.55;
  text-align: right;
  word-break: keep-all;
}

.saved-detail-inline-status {
  display: inline-flex;
  min-height: 25px;
  align-items: center;
  border-radius: 999px;
  padding: 0 9px;
  font-size: 10px;
}

.register-page.is-detail-view .xml-saved-review {
  margin-top: 0;
  overflow: hidden;
  border-radius: 20px;
  background: #fff;
}
.register-page.is-detail-view .xml-saved-review > header {
  align-items: center;
  padding: 23px 26px;
  border-bottom: 1px solid var(--detail-line);
  background: #fff;
}
.register-page.is-detail-view .xml-saved-review > header h3 {
  margin: 6px 0 5px;
  color: var(--detail-ink);
  font-size: 20px;
  font-weight: 900;
}
.register-page.is-detail-view .xml-saved-review > header p {
  color: #74837f;
  font-size: 11px;
  line-height: 1.6;
}
.register-page.is-detail-view .xml-saved-review .xml-saved-summary {
  align-items: center;
  flex-wrap: nowrap;
}
.register-page.is-detail-view .xml-saved-review .xml-saved-summary span {
  min-width: 76px;
  justify-items: start;
  border: 1px solid #dce8e4;
  border-radius: 10px;
  padding: 9px 11px;
  background: #f2f7f5;
}
.register-page.is-detail-view .xml-saved-review .xml-saved-summary strong {
  font-size: 16px;
  line-height: 1;
}
.register-page.is-detail-view .xml-saved-review .xml-saved-summary small {
  margin-top: 4px;
  color: #6c817b;
  font-size: 9px;
}
.register-page.is-detail-view .xml-saved-review .xml-saved-summary code {
  max-width: 190px;
  overflow: hidden;
  border-radius: 8px;
  padding: 8px 9px;
  color: #71817d;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.register-page.is-detail-view .xml-saved-review .xml-saved-source {
  border-bottom: 1px solid var(--detail-line);
}
.register-page.is-detail-view .xml-saved-review .xml-saved-source .xml-source-toolbar {
  align-items: center;
  justify-content: space-between;
  padding: 11px 20px;
  background: #f3f7f5;
}
.register-page.is-detail-view .xml-saved-review .xml-saved-source .xml-source-toolbar small {
  color: #71837e;
  font-size: 9px;
}
.register-page.is-detail-view .xml-saved-review .xml-saved-source .xml-source-preview {
  max-height: 360px;
  padding: 18px 22px;
  background: #14221f;
  color: #d5e7df;
  font-size: 11px;
  line-height: 1.75;
}

.xml-saved-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 14px 20px;
  border-bottom: 1px solid var(--detail-line);
  background: #f8faf9;
}
.xml-saved-toolbar > div {
  min-width: 0;
}
.xml-saved-toolbar strong,
.xml-saved-toolbar span {
  display: block;
}
.xml-saved-toolbar strong {
  color: #315149;
  font-size: 12px;
  font-weight: 900;
}
.xml-saved-toolbar > div span {
  margin-top: 3px;
  color: #80908b;
  font-size: 10px;
}
.xml-saved-toolbar button {
  display: inline-flex;
  min-height: 38px;
  flex: 0 0 auto;
  align-items: center;
  gap: 7px;
  border: 1px solid #c6d8d3;
  border-radius: 9px;
  padding: 0 12px;
  background: #fff;
  color: #2c5d52;
  font-size: 10px;
  font-weight: 900;
}
.xml-saved-toolbar button svg {
  width: 15px;
  height: 15px;
}
.xml-saved-toolbar button.is-open {
  border-color: var(--detail-green);
  background: var(--detail-green);
  color: #fff;
}

.xml-saved-workspace {
  display: grid;
  height: min(720px, 100vh - 230px);
  min-height: 440px;
  grid-template-columns: 260px minmax(0, 1fr);
  overflow: hidden;
}

.xml-saved-field-rail {
  max-height: none;
  overflow-y: auto;
  padding: 12px;
  border-right: 1px solid var(--detail-line);
  background: #f5f8f7;
  scrollbar-width: thin;
}
.xml-saved-field-rail button {
  width: 100%;
  display: grid;
  grid-template-columns: 28px minmax(0, 1fr) auto;
  gap: 9px;
  align-items: center;
  margin-bottom: 6px;
  border: 1px solid transparent;
  border-radius: 10px;
  padding: 10px;
  background: transparent;
  color: #526963;
  text-align: left;
  transition: border-color 150ms ease, background 150ms ease, box-shadow 150ms ease;
}
.xml-saved-field-rail button > span:nth-child(2) {
  min-width: 0;
}
.xml-saved-field-rail button strong,
.xml-saved-field-rail button code {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.xml-saved-field-rail button strong {
  font-size: 11px;
  font-weight: 900;
}
.xml-saved-field-rail button code {
  margin-top: 3px;
  color: #85938f;
  font-size: 8px;
}
.xml-saved-field-rail button em {
  border-radius: 999px;
  padding: 4px 6px;
  background: #e8f2ef;
  color: #2f675a;
  font-size: 8px;
  font-style: normal;
  font-weight: 900;
  white-space: nowrap;
}
.xml-saved-field-rail button:hover {
  border-color: #d2dfdb;
  background: rgba(255, 255, 255, 0.75);
}
.xml-saved-field-rail button.is-active {
  border-color: #77a79b;
  background: #fff;
  color: var(--detail-ink);
  box-shadow: 0 7px 18px rgba(26, 79, 69, 0.08);
}

.xml-saved-field-index {
  width: 28px;
  height: 28px;
  display: grid;
  place-items: center;
  border-radius: 8px;
  background: #e4eeeb;
  color: #3a685e;
  font-size: 9px;
  font-weight: 900;
}

.xml-saved-field-rail button.is-active .xml-saved-field-index {
  background: var(--detail-green);
  color: #fff;
}

.xml-saved-field-detail {
  min-width: 0;
  overflow-y: auto;
  padding: 24px 26px;
}
.xml-saved-field-detail > header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
  padding-bottom: 18px;
  border-bottom: 1px solid #e2eae7;
}
.xml-saved-field-detail > header span {
  display: block;
  color: #81908c;
  font-size: 9px;
  font-weight: 900;
}
.xml-saved-field-detail > header h4 {
  margin: 5px 0 3px;
  color: var(--detail-ink);
  font-size: 22px;
  font-weight: 900;
}
.xml-saved-field-detail > header code {
  color: #738681;
  font-size: 10px;
}
.xml-saved-field-detail > header > em {
  border-radius: 999px;
  padding: 6px 9px;
  background: #e9f4f0;
  color: #286450;
  font-size: 9px;
  font-style: normal;
  font-weight: 900;
}

.xml-saved-value-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  margin: 18px 0 0;
}
.xml-saved-value-grid > div {
  min-width: 0;
  min-height: 112px;
  border: 1px solid #e0e8e5;
  border-radius: 12px;
  padding: 14px 15px;
  background: #fafcfb;
}
.xml-saved-value-grid > div.is-final {
  border-color: #a9ccc2;
  background: #edf7f3;
}
.xml-saved-value-grid > div.is-path {
  min-height: auto;
  grid-column: 1/-1;
}
.xml-saved-value-grid dt {
  color: #7e8e89;
  font-size: 9px;
  font-weight: 900;
}
.xml-saved-value-grid dd {
  margin: 10px 0 0;
  color: #294a42;
  font-size: 12px;
  font-weight: 800;
  line-height: 1.65;
  word-break: break-word;
}
.xml-saved-value-grid dd code,
.xml-saved-value-grid dd span {
  display: block;
  margin-top: 4px;
  color: #4f746a;
  font-size: 9px;
  font-weight: 700;
  overflow-wrap: anywhere;
}

.xml-saved-history-panel {
  margin-top: 18px;
  border: 1px solid #e1e8e6;
  border-radius: 12px;
  background: #fbfcfc;
  overflow: hidden;
}
.xml-saved-history-panel > header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 11px 14px;
  border-bottom: 1px solid #e5ebe9;
  background: #f4f7f6;
}
.xml-saved-history-panel > header strong {
  color: #3d5a53;
  font-size: 11px;
  font-weight: 900;
}
.xml-saved-history-panel > header span {
  color: #7c8c87;
  font-size: 9px;
  font-weight: 900;
}
.xml-saved-history-panel .xml-saved-history {
  padding: 12px 14px 14px;
}

.xml-saved-history-empty,
.xml-saved-empty {
  margin: 0;
  padding: 24px;
  color: #83918d;
  font-size: 11px;
  text-align: center;
}

.xml-saved-empty {
  display: grid;
  place-content: center;
  gap: 5px;
}
.xml-saved-empty strong {
  color: #506660;
  font-size: 13px;
}
.xml-saved-empty p {
  margin: 0;
}

@media (max-width: 980px) {
  .register-page.is-detail-view .register-hero {
    grid-template-columns: 1fr;
  }
  .register-page.is-detail-view .detail-tabs {
    width: fit-content;
  }
  .saved-detail-overview-grid {
    grid-template-columns: 1fr;
  }
  .saved-detail-facts {
    border-top: 1px solid var(--detail-line);
    border-left: 0;
  }
  .xml-saved-workspace {
    grid-template-columns: 220px minmax(0, 1fr);
  }
  .saved-detail-section-nav {
    align-items: stretch;
    flex-direction: column;
  }
  .saved-detail-section-tabs {
    width: 100%;
  }
  .saved-detail-section-tabs button {
    flex: 1 1 0;
    justify-content: center;
  }
}
@media (max-width: 720px) {
  .register-page.is-detail-view .register-main {
    padding-inline: 14px;
  }
  .register-page.is-detail-view .register-hero h1 {
    font-size: 28px;
  }
  .register-page.is-detail-view .detail-tabs {
    width: 100%;
    overflow-x: auto;
    flex-wrap: nowrap;
  }
  .register-page.is-detail-view .detail-tab {
    flex: 0 0 auto;
  }
  .saved-detail-overview-head,
  .register-page.is-detail-view .xml-saved-review > header,
  .xml-saved-toolbar {
    align-items: stretch;
    flex-direction: column;
  }
  .saved-detail-section-nav {
    position: static;
    padding: 12px;
  }
  .saved-detail-section-nav-copy {
    display: none;
  }
  .saved-detail-section-tabs {
    overflow-x: auto;
    justify-content: flex-start;
  }
  .saved-detail-section-tabs button {
    min-width: 148px;
    flex: 0 0 auto;
  }
  .saved-detail-description,
  .saved-detail-facts,
  .xml-saved-field-detail {
    padding: 20px;
  }
  .register-page.is-detail-view .xml-saved-review .xml-saved-summary {
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  .xml-saved-toolbar button {
    width: 100%;
    justify-content: center;
  }
  .xml-saved-workspace {
    height: auto;
    min-height: 0;
    grid-template-columns: 1fr;
    overflow: visible;
  }
  .xml-saved-field-rail {
    display: flex;
    max-height: none;
    overflow-x: auto;
    border-right: 0;
    border-bottom: 1px solid var(--detail-line);
  }
  .xml-saved-field-rail button {
    min-width: 190px;
    margin: 0 6px 0 0;
  }
  .xml-saved-field-detail {
    max-height: none;
    overflow: visible;
  }
  .xml-saved-value-grid {
    grid-template-columns: 1fr;
  }
  .xml-saved-value-grid > div.is-path {
    grid-column: auto;
  }
  .saved-detail-facts dl > div {
    grid-template-columns: 96px minmax(0, 1fr);
  }
}
.registration-save-error-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1400;
  display: grid;
  place-items: center;
  padding: 24px;
  background: rgba(17, 34, 31, 0.58);
  backdrop-filter: blur(7px);
  animation: registration-save-error-backdrop-in 160ms ease both;
}

.registration-save-error-dialog {
  width: min(680px, 100%);
  max-height: calc(100vh - 48px);
  overflow-y: auto;
  border: 1px solid #dce6e2;
  border-radius: 22px;
  padding: 28px;
  background: #fff;
  box-shadow: 0 28px 80px rgba(12, 38, 31, 0.24);
  color: #183b33;
  animation: registration-save-error-dialog-in 190ms ease both;
}

.registration-save-error-header {
  position: relative;
  display: grid;
  grid-template-columns: 52px minmax(0, 1fr) 38px;
  align-items: start;
  gap: 16px;
}
.registration-save-error-header h2 {
  margin: 4px 0 7px;
  color: #153c33;
  font-size: 24px;
  font-weight: 900;
  letter-spacing: -0.035em;
  line-height: 1.3;
}
.registration-save-error-header > div > p:last-child {
  margin: 0;
  color: #6b7e79;
  font-size: 13px;
  font-weight: 650;
  line-height: 1.65;
}

.registration-save-error-eyebrow {
  margin: 1px 0 0;
  color: #a45d27;
  font-size: 10px;
  font-weight: 900;
  letter-spacing: 0.15em;
}

.registration-save-error-icon {
  display: grid;
  width: 52px;
  height: 52px;
  place-items: center;
  border-radius: 16px;
  background: #fff1e8;
  color: #c05e29;
}
.registration-save-error-icon svg {
  width: 27px;
  height: 27px;
}

.registration-save-error-close {
  display: grid;
  width: 38px;
  height: 38px;
  place-items: center;
  border: 1px solid #dbe5e2;
  border-radius: 11px;
  background: #fff;
  color: #647a74;
}
.registration-save-error-close svg {
  width: 19px;
  height: 19px;
}
.registration-save-error-close:hover {
  border-color: #acc5be;
  background: #f4f8f6;
  color: #244e43;
}

.registration-save-error-summary {
  margin-top: 24px;
  border: 1px solid #f0c9b2;
  border-radius: 16px;
  padding: 18px 20px;
  background: linear-gradient(135deg, #fff9f4 0%, #fffdf9 100%);
}
.registration-save-error-summary > p {
  margin: 7px 0 0;
  color: #755f53;
  font-size: 12px;
  font-weight: 650;
  line-height: 1.65;
}

.registration-save-error-status {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 13px;
}
.registration-save-error-status span {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #d06c35;
  box-shadow: 0 0 0 4px rgba(208, 108, 53, 0.12);
}
.registration-save-error-status strong {
  color: #9b4c25;
  font-size: 11px;
  font-weight: 900;
}
.registration-save-error-status em {
  margin-left: auto;
  border-radius: 999px;
  padding: 5px 9px;
  background: #e8f4f0;
  color: #296653;
  font-size: 10px;
  font-style: normal;
  font-weight: 900;
}

.registration-save-error-message {
  display: block;
  color: #553126;
  font-size: 16px;
  font-weight: 900;
  line-height: 1.5;
}

.registration-save-error-meta {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 9px;
  margin: 12px 0 0;
}
.registration-save-error-meta > div {
  min-width: 0;
  border: 1px solid #e3ebe8;
  border-radius: 13px;
  padding: 12px 14px;
  background: #f8faf9;
}
.registration-save-error-meta > div.is-wide {
  grid-column: 1/-1;
}
.registration-save-error-meta dt {
  color: #84938f;
  font-size: 9px;
  font-weight: 900;
}
.registration-save-error-meta dd {
  margin: 6px 0 0;
  color: #284f45;
  font-size: 12px;
  font-weight: 850;
  overflow-wrap: anywhere;
}
.registration-save-error-meta code {
  color: #55756c;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 10px;
}

.registration-save-error-note {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-top: 12px;
  border-radius: 13px;
  padding: 13px 15px;
  background: #eef6f3;
  color: #42665c;
}
.registration-save-error-note svg {
  flex: 0 0 auto;
  width: 18px;
  height: 18px;
  margin-top: 1px;
}
.registration-save-error-note p {
  margin: 0;
  font-size: 11px;
  font-weight: 700;
  line-height: 1.6;
}

.registration-save-error-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 22px;
}
.registration-save-error-actions button {
  min-height: 46px;
  border-radius: 12px;
  padding: 0 18px;
  font-size: 13px;
  font-weight: 900;
}

.registration-save-error-secondary {
  border: 1px solid #d6e1dd;
  background: #fff;
  color: #3f5f57;
}

.registration-save-error-primary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: 1px solid #205e4e;
  background: #205e4e;
  color: #fff;
  box-shadow: 0 10px 24px rgba(32, 94, 78, 0.18);
}
.registration-save-error-primary svg {
  width: 18px;
  height: 18px;
}
.registration-save-error-primary:hover {
  border-color: #164c3f;
  background: #164c3f;
}

@keyframes registration-save-error-backdrop-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes registration-save-error-dialog-in {
  from {
    opacity: 0;
    transform: translateY(10px) scale(0.985);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@media (max-width: 620px) {
  .registration-save-error-backdrop {
    align-items: end;
    padding: 12px;
  }
  .registration-save-error-dialog {
    max-height: calc(100vh - 24px);
    border-radius: 20px;
    padding: 22px 18px;
  }
  .registration-save-error-header {
    grid-template-columns: 46px minmax(0, 1fr) 34px;
    gap: 11px;
  }
  .registration-save-error-header h2 {
    font-size: 20px;
  }
  .registration-save-error-icon {
    width: 46px;
    height: 46px;
    border-radius: 14px;
  }
  .registration-save-error-meta {
    grid-template-columns: 1fr;
  }
  .registration-save-error-actions {
    flex-direction: column-reverse;
  }
  .registration-save-error-actions button {
    width: 100%;
  }
}
@media (prefers-reduced-motion: reduce) {
  .registration-save-error-backdrop,
  .registration-save-error-dialog {
    animation: none;
  }
}
.unified-metadata-review {
  grid-template-columns: 288px minmax(0, 1fr);
}
.unified-metadata-review .metadata-file-rail {
  max-height: min(860px, 100vh - 150px);
  padding: 20px;
  border: 1px solid #d7e3df;
  border-radius: 18px;
  background: #f7faf9;
  box-shadow: 0 10px 28px rgba(28, 64, 55, 0.055);
}
.unified-metadata-review .metadata-file-rail-head {
  align-items: flex-end;
}
.unified-metadata-review .metadata-file-rail-head span {
  margin-bottom: 5px;
  color: #9b602c;
  font-size: 10px;
  letter-spacing: 0.12em;
}
.unified-metadata-review .metadata-file-rail-head h3 {
  color: #1d4038;
  font-size: 19px;
  letter-spacing: -0.035em;
}
.unified-metadata-review .metadata-file-rail-head > strong {
  display: inline-flex;
  min-width: 38px;
  height: 28px;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  background: #e7f1ed;
  color: #2f6759;
  font-size: 11px;
}
.unified-metadata-review .metadata-file-rail > p {
  margin: 0;
  color: #6b7e78;
  font-size: 11px;
  line-height: 1.6;
}
.unified-metadata-review .metadata-file-list {
  gap: 10px;
}
.unified-metadata-review .metadata-file-list article {
  gap: 10px;
  padding: 11px;
  border-radius: 14px;
}
.unified-metadata-review .metadata-file-list article.is-error {
  border-color: #e8c4ba;
  background: #fff;
}
.unified-metadata-review .metadata-file-select {
  grid-template-columns: 32px minmax(0, 1fr);
  gap: 10px;
  min-height: 42px;
}
.unified-metadata-review .metadata-file-select > span:first-child {
  width: 32px;
  height: 32px;
  border-radius: 10px;
  font-size: 10px;
}
.unified-metadata-review .metadata-file-select strong {
  font-size: 12px;
}
.unified-metadata-review .metadata-file-select small {
  overflow: hidden;
  font-size: 10px;
  line-height: 1.45;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.unified-metadata-review .metadata-master-detail {
  grid-template-columns: minmax(280px, 306px) minmax(0, 1fr);
}
.unified-metadata-review .metadata-value-comparison article {
  min-height: 188px;
}
.unified-metadata-review .metadata-value-apply {
  align-self: stretch;
  width: 100%;
  min-height: 40px;
  margin-top: auto;
  padding: 0 14px;
  border-radius: 10px;
  font-size: 12px;
  line-height: 1;
}
.unified-metadata-review .metadata-value-apply svg {
  display: block;
  width: 16px;
  height: 16px;
  flex: 0 0 16px;
}
.unified-metadata-review .metadata-value-apply.is-selected {
  border-color: #347862;
  background: #e7f4ef;
  color: #225e4d;
  box-shadow: none;
}
.unified-metadata-review .metadata-field-decisions {
  gap: 12px;
}
.unified-metadata-review .metadata-field-decisions > div {
  display: flex;
  gap: 8px;
}
.unified-metadata-review .metadata-field-decisions button {
  min-height: 42px;
  border-radius: 10px;
  font-size: 12px;
}
.unified-metadata-review .metadata-field-decisions .is-secondary {
  color: #516a63;
  background: #fff;
}
.unified-metadata-review .metadata-field-decisions > button.is-primary {
  min-width: 190px;
  padding: 0 18px;
  box-shadow: 0 7px 16px rgba(34, 92, 76, 0.14);
}
.unified-metadata-review .metadata-field-decisions > button.is-primary svg {
  display: block;
  width: 17px;
  height: 17px;
  flex: 0 0 17px;
}
.unified-metadata-review .metadata-field-decisions > button.is-primary.is-complete {
  border-color: #a7c9bd;
  background: #eef7f4;
  color: #2b6858;
  box-shadow: none;
}
.unified-metadata-review button:focus-visible {
  outline: 3px solid rgba(64, 139, 117, 0.22);
  outline-offset: 2px;
}

.metadata-file-error {
  gap: 9px;
  padding: 10px;
  border: 1px solid #efc8bf;
  border-radius: 11px;
  background: #fff8f6;
}

.metadata-file-error-copy {
  display: grid;
  grid-template-columns: 24px minmax(0, 1fr);
  gap: 8px;
  align-items: start;
}
.metadata-file-error-copy > div {
  display: grid;
  min-width: 0;
  gap: 3px;
}
.metadata-file-error-copy strong {
  color: #8c3f31;
  font-size: 10px;
}
.metadata-file-error-copy p {
  display: -webkit-box;
  overflow: hidden;
  color: #86574d;
  font-size: 9px;
  line-height: 1.5;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.metadata-file-error-icon {
  display: inline-flex;
  width: 24px;
  height: 24px;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #f9ded8;
  color: #9d4635;
  font-size: 12px;
  font-weight: 950;
}

.metadata-file-error .metadata-file-retry {
  display: inline-flex;
  width: 100%;
  min-height: 34px;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 0 11px;
  border-color: #dfb4a9;
  border-radius: 9px;
  background: #fff;
  color: #8b4032;
  font-size: 10px;
}
.metadata-file-error .metadata-file-retry svg {
  display: block;
  width: 14px;
  height: 14px;
  flex: 0 0 14px;
}

@media (max-width: 1180px) {
  .unified-metadata-review {
    grid-template-columns: 240px minmax(0, 1fr);
  }
  .unified-metadata-review .metadata-master-detail {
    grid-template-columns: 250px minmax(0, 1fr);
  }
}
@media (max-width: 860px) {
  .unified-metadata-review {
    grid-template-columns: minmax(0, 1fr);
  }
  .unified-metadata-review .metadata-file-rail {
    max-height: none;
  }
  .unified-metadata-review .metadata-master-detail {
    grid-template-columns: minmax(0, 1fr);
  }
}
@media (max-width: 560px) {
  .unified-metadata-review .metadata-field-decisions > div {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    width: 100%;
  }
  .unified-metadata-review .metadata-field-decisions > button.is-primary {
    width: 100%;
  }
}
/* 파일별 메타 검수 저장·필터·부분 진행 */
.metadata-file-filters {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 5px;
}
.metadata-file-filters button {
  min-height: 31px;
  padding: 5px 6px;
  border: 1px solid #d4e1dd;
  border-radius: 8px;
  background: #fff;
  color: #61756f;
  font-size: 10px;
  font-weight: 800;
}
.metadata-file-filters button.is-active {
  border-color: #367765;
  background: #e9f5f1;
  color: #205f50;
}

.metadata-advance-panel {
  display: grid;
  gap: 9px;
  padding: 11px;
  border: 1px solid #d8e5e0;
  border-radius: 11px;
  background: #fff;
}
.metadata-advance-panel.is-selected-mode {
  border-color: #d8b66e;
  background: #fffaf0;
}
.metadata-advance-panel header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
}
.metadata-advance-panel header div {
  display: grid;
  gap: 2px;
}
.metadata-advance-panel header strong {
  color: #214a41;
  font-size: 11px;
}
.metadata-advance-panel header small {
  color: #788b85;
  font-size: 9px;
  line-height: 1.4;
}
.metadata-advance-panel header em {
  flex: 0 0 auto;
  padding: 3px 7px;
  border-radius: 999px;
  background: #e8f4ef;
  color: #276653;
  font-size: 9px;
  font-style: normal;
  font-weight: 900;
}
.metadata-advance-panel > p {
  margin: 0;
  color: #855c1d;
  font-size: 9px;
  font-weight: 700;
  line-height: 1.5;
}

.metadata-advance-actions {
  display: flex;
  gap: 5px;
}
.metadata-advance-actions button {
  flex: 1 1 0;
  min-height: 29px;
  padding: 4px 7px;
  border: 1px solid #cfddd8;
  border-radius: 7px;
  background: #f8fbfa;
  color: #45665e;
  font-size: 9px;
  font-weight: 800;
}

.metadata-advance-submit {
  min-height: 35px;
  padding: 7px 9px;
  border: 1px solid #296b58;
  border-radius: 8px;
  background: #296b58;
  color: #fff;
  font-size: 10px;
  font-weight: 900;
}

.metadata-advance-panel button:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.metadata-file-list article.is-paused {
  border-style: dashed;
  background: #fffaf0;
}

.metadata-file-resume {
  justify-self: end;
  min-height: 26px;
  padding: 3px 8px;
  border: 1px solid #cba45c;
  border-radius: 7px;
  background: #fff7e8;
  color: #805515;
  font-size: 9px;
  font-weight: 850;
}

.metadata-file-workflow-state {
  color: #487268 !important;
  font-weight: 800 !important;
}

.metadata-file-empty {
  margin: 0;
  padding: 18px 10px;
  border: 1px dashed #cfdcd8;
  border-radius: 10px;
  color: #6e817b;
  font-size: 10px;
  text-align: center;
}

.metadata-review-draft-actions {
  display: flex;
  align-items: center;
  gap: 7px;
}
.metadata-review-draft-actions button {
  min-height: 34px;
  padding: 7px 11px;
  border: 1px solid #c9d9d4;
  border-radius: 9px;
  background: #fff;
  color: #315f54;
  font-size: 11px;
  font-weight: 850;
}
.metadata-review-draft-actions button:last-child {
  border-color: #9bbbad;
  background: #edf6f2;
}

.metadata-draft-notice {
  margin: 10px 0 0;
  padding: 9px 12px;
  border-radius: 9px;
  background: #edf6f2;
  color: #326557;
  font-size: 11px;
  font-weight: 750;
}

.metadata-selection-final-warning {
  margin-top: 16px;
  padding: 14px 16px;
  border: 1px solid #e5c789;
  border-radius: 12px;
  background: #fff9ed;
  color: #805716;
}
.metadata-selection-final-warning strong {
  font-size: 13px;
}
.metadata-selection-final-warning p {
  margin: 5px 0 0;
  font-size: 11px;
  line-height: 1.55;
}

.registration-exit-save {
  min-height: 44px;
  padding: 10px 18px;
  border: 1px solid #9bbbad;
  border-radius: 9px;
  background: #edf6f2;
  color: #245f4c;
  font-size: 12px;
  font-weight: 900;
}

.registration-exit-actions button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

@media (max-width: 900px) {
  .metadata-review-page-head {
    flex-wrap: wrap;
  }
  .metadata-review-draft-actions {
    width: 100%;
  }
  .metadata-review-draft-actions button {
    flex: 1 1 0;
  }
}
@media (max-width: 560px) {
  .metadata-file-filters {
    grid-template-columns: 1fr;
  }
  .metadata-review-draft-actions {
    flex-direction: column;
  }
  .metadata-review-draft-actions button,
  .registration-exit-save {
    width: 100%;
  }
}
/* 1단계 원본 등록 커맨드 센터 — 2026-08-11 선택 시안 3 */
.register-page.is-upload-step {
  --upload-workspace-max-width: 1680px;
  --upload-command-rail-width: 288px;
  --upload-command-inspector-width: 320px;
  min-height: 100vh;
  background: #f4f6f5;
}
.register-page.is-upload-step .register-header {
  border-bottom: 1px solid #d7dfdc;
  background: rgba(255, 255, 255, 0.97);
  box-shadow: none;
}
.register-page.is-upload-step .register-header-inner,
.register-page.is-upload-step .register-main {
  width: 100%;
  max-width: var(--upload-workspace-max-width);
  margin-inline: auto;
  box-sizing: border-box;
}
.register-page.is-upload-step .register-header-inner {
  display: flex;
  height: 58px;
  min-height: 58px;
  align-items: center;
  gap: 14px;
  padding: 0 22px;
}
.register-page.is-upload-step .brand-link {
  flex: 0 0 auto;
}
.register-page.is-upload-step .header-actions {
  margin-left: auto;
}
.register-page.is-upload-step .register-header-page-divider {
  width: 1px;
  height: 22px;
  margin-left: 2px;
  background: #d7dfdc;
}
.register-page.is-upload-step .register-header-page-title {
  color: #1d302b;
  font-size: 17px;
  font-weight: 900;
  letter-spacing: -0.035em;
}
.register-page.is-upload-step .brand-logo {
  width: auto;
  max-height: 28px;
}
.register-page.is-upload-step .brand-context small {
  display: none;
}
.register-page.is-upload-step .brand-context strong {
  font-size: 17px;
  letter-spacing: -0.035em;
}
.register-page.is-upload-step .register-main {
  padding: 0 16px 28px;
}
.register-page.is-upload-step .register-topline {
  display: none;
}
.register-page.is-upload-step .register-hero {
  display: none;
}
.register-page.is-upload-step .register-title-block {
  display: flex;
  align-items: center;
  gap: 12px;
}
.register-page.is-upload-step .register-title-block .eyebrow,
.register-page.is-upload-step .register-title-block .hero-copy,
.register-page.is-upload-step .hero-assurance {
  display: none;
}
.register-page.is-upload-step .register-hero h1 {
  margin: 0;
  color: #172e29;
  font-size: 20px;
  font-weight: 900;
  letter-spacing: -0.04em;
}
.register-page.is-upload-step .register-flow {
  display: grid;
  gap: 8px;
  margin: 0;
  padding: 0;
}
.register-page.is-upload-step .flow-progress,
.register-page.is-upload-step .flow-guide,
.register-page.is-upload-step .workbench-head {
  display: none;
}
.register-page.is-upload-step .register-steps {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  margin: 0;
  padding: 8px 22px 10px;
  border: 0;
  border-bottom: 1px solid #d9e1de;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
}
.register-page.is-upload-step .register-steps li {
  position: relative;
  min-width: 0;
  padding-right: 42px;
}
.register-page.is-upload-step .register-steps li:last-child {
  padding-right: 0;
}
.register-page.is-upload-step .register-steps li:not(:last-child)::after {
  top: 20px;
  right: 14px;
  left: 156px;
  display: block !important;
  width: auto;
  min-width: 0;
  height: 1px;
  background: #d6dfdc;
  content: "";
}
.register-page.is-upload-step .register-step {
  min-height: 42px;
  padding: 0;
  border: 0;
  background: transparent;
  box-shadow: none;
}
.register-page.is-upload-step .register-step-number {
  width: 36px;
  height: 36px;
  border: 0;
  border-radius: 50%;
  background: #e7ecea;
  color: #465b55;
  font-size: 13px;
}
.register-page.is-upload-step .register-step[aria-current=step] .register-step-number {
  background: #075443;
  color: #fff;
}
.register-page.is-upload-step .register-step-copy {
  gap: 2px;
  min-width: 0;
}
.register-page.is-upload-step .register-step-title {
  overflow: hidden;
  color: #314a44;
  font-size: 14px;
  font-weight: 850;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.register-page.is-upload-step .register-step-desc {
  overflow: hidden;
  color: #7a8985;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.register-page.is-upload-step .register-step-state {
  align-self: end;
  color: #75847f;
  font-size: 12px;
}
.register-page.is-upload-step .register-step[aria-current=step] .register-step-title,
.register-page.is-upload-step .register-step[aria-current=step] .register-step-state {
  color: #075443;
}
.register-page.is-upload-step .register-workbench {
  overflow: visible;
  margin: 0;
  border: 0;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
}
.register-page.is-upload-step .workbench-body {
  padding: 0;
}
.register-page.is-upload-step .workbench-body > .upload-command-center {
  width: 100%;
}
.register-page.is-upload-step .workbench-footer {
  position: sticky;
  z-index: 20;
  bottom: 0;
  min-height: 88px;
  margin-top: 16px;
  padding: 14px 20px;
  border: 1px solid #d6dfdc;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.97);
  box-shadow: 0 -8px 24px rgba(29, 55, 48, 0.06);
  backdrop-filter: blur(12px);
}
.register-page.is-upload-step .workbench-footer .primary-btn {
  min-width: 240px;
  min-height: 48px;
  border-radius: 5px;
  background: #075443;
  box-shadow: none;
}
.register-page.is-upload-step .workbench-footer .secondary-btn {
  min-height: 44px;
}
.register-page.is-upload-step .workbench-footer .primary-btn,
.register-page.is-upload-step .workbench-footer .secondary-btn {
  font-size: 13px;
}
.register-page.is-upload-step .footer-guidance span,
.register-page.is-upload-step .footer-scope,
.register-page.is-upload-step .autosave-status {
  font-size: 11px;
}
.register-page.is-upload-step .footer-guidance strong {
  font-size: 12px;
}
.register-page.is-upload-step .footer-scope,
.register-page.is-upload-step .autosave-status {
  padding: 6px 9px;
}

.upload-command-center {
  display: grid;
  grid-template-columns: var(--upload-command-rail-width) minmax(560px, 1fr) var(--upload-command-inspector-width);
  min-height: 650px;
  min-height: clamp(650px, 100dvh - 260px, 1040px);
  overflow: hidden;
  border: 1px solid #d6dfdc;
  border-radius: 7px;
  background: #fff;
  color: #263d37;
  box-shadow: 0 2px 8px rgba(31, 61, 53, 0.035);
}
.upload-command-center button,
.upload-command-center input,
.upload-command-center textarea,
.upload-command-center select {
  font: inherit;
}
.upload-command-center button {
  cursor: pointer;
}
.upload-command-center button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}
.upload-command-center button:focus-visible,
.upload-command-center input:focus-visible,
.upload-command-center textarea:focus-visible,
.upload-command-center select:focus-visible,
.upload-command-center summary:focus-visible {
  outline: 3px solid rgba(20, 112, 91, 0.22);
  outline-offset: 2px;
}

.simple-file-upload {
  display: grid;
  width: min(760px, 100% - 48px);
  min-height: clamp(500px, 100dvh - 390px, 720px);
  place-content: center;
  justify-self: center;
  gap: 24px;
  margin: 28px auto;
  padding: 48px;
  border: 1px solid #d6e0dd;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 14px 40px rgba(31, 61, 53, 0.07);
  color: #263d37;
  text-align: center;
}

.simple-file-upload-copy {
  display: grid;
  justify-items: center;
  gap: 8px;
}
.simple-file-upload-copy h3 {
  margin: 0;
  color: #203a33;
  font-size: 28px;
  font-weight: 800;
  letter-spacing: -0.045em;
}
.simple-file-upload-copy p {
  margin: 0;
  color: #6c7d78;
  font-size: 14px;
  line-height: 1.6;
}

.simple-file-upload-kicker {
  color: #a56736;
  font-size: 11px;
  font-weight: 900;
  letter-spacing: 0.14em;
  text-transform: uppercase;
}

.simple-file-upload-dropzone {
  display: grid;
  width: min(600px, 100%);
  min-height: 270px;
  place-items: center;
  align-content: center;
  gap: 12px;
  padding: 36px 24px;
  border: 2px dashed #a9c2bb;
  border-radius: 14px;
  background: #f7fbf9;
  cursor: pointer;
  transition: border-color 160ms ease, background 160ms ease, transform 160ms ease;
}
.simple-file-upload-dropzone input {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
}
.simple-file-upload-dropzone strong {
  color: #284a41;
  font-size: 18px;
  font-weight: 800;
  letter-spacing: -0.025em;
}
.simple-file-upload-dropzone:hover, .simple-file-upload-dropzone:focus-within, .simple-file-upload-dropzone.is-dragging {
  border-color: #176253;
  background: #edf7f3;
  transform: translateY(-2px);
}
.simple-file-upload-dropzone:focus-within {
  outline: 3px solid rgba(23, 98, 83, 0.15);
}

.simple-file-upload-icon {
  display: grid;
  width: 64px;
  height: 64px;
  place-items: center;
  border-radius: 18px;
  background: #e1f0eb;
  color: #176253;
  font-size: 25px;
}

.simple-file-upload-formats {
  color: #7b8b86;
  font-size: 13px;
}

.simple-file-upload-button {
  display: inline-grid;
  min-width: 150px;
  min-height: 46px;
  margin-top: 6px;
  place-items: center;
  border-radius: 8px;
  background: #176253;
  color: #fff;
  font-size: 14px;
  font-weight: 900;
  box-shadow: 0 8px 18px rgba(23, 98, 83, 0.18);
}

.simple-file-upload-limit {
  margin: -10px 0 0;
  color: #7b8985;
  font-size: 12px;
}

.upload-command-center.is-simplified {
  grid-template-columns: minmax(0, 1fr);
  width: min(1180px, 100% - 32px);
  min-height: 0;
  margin: 24px auto;
  overflow: visible;
  border-radius: 12px;
  box-shadow: 0 12px 34px rgba(31, 61, 53, 0.065);
}
.upload-command-center.is-simplified > .upload-command-rail,
.upload-command-center.is-simplified > .upload-command-inspector {
  display: none;
}
.upload-command-center.is-simplified > .upload-command-main {
  grid-column: 1;
  overflow: hidden;
  border-radius: inherit;
}
.upload-command-center.is-simplified .upload-command-overview {
  min-height: 96px;
  padding: 12px 16px;
  background: #f8fbfa;
}
.upload-command-center.is-simplified .upload-command-overview article {
  padding: 0 16px;
}
.upload-command-center.is-simplified .upload-command-overview strong {
  font-size: 18px;
}
.upload-command-center.is-simplified .upload-command-list-head {
  min-height: 76px;
  justify-content: flex-start;
  gap: 10px;
  padding: 12px 18px;
  background: #fff;
}
.upload-command-center.is-simplified .upload-command-tabs,
.upload-command-center.is-simplified .upload-command-page-size {
  display: none;
}
.upload-command-center.is-simplified .upload-command-list-head > em {
  margin-left: 2px;
  white-space: nowrap;
}
.upload-command-center.is-simplified .upload-command-table-head,
.upload-command-center.is-simplified .upload-command-row {
  grid-template-columns: 46px minmax(220px, 1.6fr) 82px minmax(150px, 1fr) minmax(145px, 0.9fr) 88px;
}
.upload-command-center.is-simplified ul[class~=upload-command-file-list] {
  max-height: min(580px, 100dvh - 500px);
  overflow-y: auto;
  scrollbar-gutter: stable;
}
.upload-command-center.is-simplified .upload-command-row-detail {
  grid-template-columns: minmax(0, 1.4fr) minmax(240px, 1fr) auto;
  margin: 12px 18px 18px;
  border-radius: 8px;
}
.upload-command-center.is-simplified .upload-command-notices {
  padding: 12px 18px 16px;
}

.simple-upload-queue-heading {
  display: grid;
  min-width: 190px;
  margin-right: auto;
  gap: 3px;
}
.simple-upload-queue-heading strong {
  color: #263f38;
  font-size: 16px;
  font-weight: 900;
}
.simple-upload-queue-heading span {
  color: #72817d;
  font-size: 11px;
  font-weight: 700;
}

.simple-upload-queue-add {
  display: inline-flex;
  min-height: 40px;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 0 14px;
  border: 1px solid #176253;
  border-radius: 6px;
  background: #fff;
  color: #176253;
  font-size: 12px;
  font-weight: 900;
  cursor: pointer;
}
.simple-upload-queue-add input {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
}
.simple-upload-queue-add:hover, .simple-upload-queue-add:focus-within {
  background: #edf7f3;
}
.simple-upload-queue-add:focus-within {
  outline: 3px solid rgba(23, 98, 83, 0.15);
  outline-offset: 2px;
}
.simple-upload-queue-add.is-disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.simple-upload-bulk-version {
  display: inline-flex;
  min-height: 40px;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 0 14px;
  border: 1px solid #b97835;
  border-radius: 6px;
  background: #fffaf2;
  color: #8b561e;
  font-size: 12px;
  font-weight: 900;
  white-space: nowrap;
}
.simple-upload-bulk-version:hover:not(:disabled), .simple-upload-bulk-version:focus-visible {
  background: #f9ecd9;
}
.simple-upload-bulk-version.is-active {
  border-color: #176253;
  background: #e8f3ef;
  color: #176253;
}
.simple-upload-bulk-version:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.upload-command-center.is-simplified .upload-command-row-actions {
  display: grid;
  grid-template-columns: repeat(2, 132px);
  align-self: start;
  justify-content: end;
  gap: 8px;
}
.upload-command-center.is-simplified .upload-command-row-actions a,
.upload-command-center.is-simplified .upload-command-row-actions button {
  display: inline-flex;
  width: 132px;
  min-height: 44px;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  padding: 0 12px;
  line-height: 1.2;
  text-align: center;
}

@media (max-width: 720px) {
  .simple-file-upload {
    width: calc(100% - 24px);
    min-height: 460px;
    margin: 12px auto;
    padding: 28px 16px;
    border-radius: 12px;
  }
  .simple-file-upload-copy h3 {
    font-size: 23px;
  }
  .simple-file-upload-dropzone {
    min-height: 250px;
    padding: 28px 16px;
  }
  .simple-file-upload-dropzone strong {
    font-size: 16px;
  }
  .upload-command-center.is-simplified {
    width: calc(100% - 16px);
    margin: 8px auto;
  }
  .upload-command-center.is-simplified .upload-command-overview {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .upload-command-center.is-simplified .upload-command-list-head {
    align-items: stretch;
    flex-direction: column;
  }
  .upload-command-center.is-simplified .simple-upload-queue-add {
    width: 100%;
  }
  .upload-command-center.is-simplified .simple-upload-bulk-version {
    width: 100%;
  }
  .upload-command-center.is-simplified ul[class~=upload-command-file-list] {
    max-height: none;
    overflow: visible;
  }
  .upload-command-center.is-simplified .upload-command-row-detail {
    grid-template-columns: 1fr;
    margin: 8px 10px 14px;
  }
}
.upload-command-rail,
.upload-command-inspector {
  min-width: 0;
  background: #fbfcfb;
}

.upload-command-rail {
  border-right: 1px solid #dce3e1;
}

.upload-command-section {
  padding: 18px;
  border-bottom: 1px solid #e0e6e4;
}
.upload-command-section h3 {
  margin: 0 0 12px;
  color: #263b36;
  font-size: 14px;
  font-weight: 900;
  letter-spacing: -0.02em;
}

.upload-command-section-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}
.upload-command-section-head button {
  padding: 0;
  border: 0;
  background: transparent;
  color: #4e7a70;
  font-size: 12px;
  font-weight: 800;
}

.upload-command-toggle {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0;
  padding: 3px;
  border: 1px solid #d3dcda;
  border-radius: 5px;
  background: #fff;
}
.upload-command-toggle button {
  min-height: 40px;
  border: 0;
  border-radius: 4px;
  background: transparent;
  color: #71807c;
  font-size: 13px;
  font-weight: 850;
}
.upload-command-toggle button.is-active {
  background: #176253;
  color: #fff;
}

.upload-command-dropzone {
  display: grid;
  min-height: 188px;
  padding: 22px 14px;
  place-items: center;
  align-content: center;
  gap: 6px;
  border: 1px dashed #b8c8c3;
  border-radius: 6px;
  background: #fff;
  text-align: center;
  cursor: pointer;
}
.upload-command-dropzone input {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
}
.upload-command-dropzone strong {
  color: #344a44;
  font-size: 13px;
  line-height: 1.45;
}
.upload-command-dropzone small {
  color: #8a9793;
  font-size: 11px;
}
.upload-command-dropzone.is-dragging {
  border-color: #217562;
  background: #f0f8f5;
}

.upload-command-dropzone-icon {
  display: grid;
  width: 40px;
  height: 40px;
  place-items: center;
  border: 1px solid #b8cbc5;
  border-radius: 50%;
  color: #155f50;
  font-size: 17px;
  font-weight: 700;
}

.upload-command-file-action {
  margin-top: 4px;
  color: #276c5e;
  font-size: 12px;
  font-weight: 900;
}

.upload-command-url {
  display: grid;
  gap: 6px;
}
.upload-command-url span {
  color: #536a64;
  font-size: 12px;
  font-weight: 800;
}
.upload-command-url input {
  width: 100%;
  min-height: 42px;
  padding: 0 10px;
  border: 1px solid #cdd8d5;
  border-radius: 5px;
  background: #fff;
  color: #29423c;
  font-size: 13px;
}

.upload-command-add-url,
.upload-command-sample-url {
  width: 100%;
  min-height: 42px;
  margin-top: 8px;
  border: 1px solid #aac2bb;
  border-radius: 5px;
  background: #fff;
  color: #276758;
  font-size: 12px;
  font-weight: 900;
}

.upload-command-add-url {
  border-color: #176253;
  background: #176253;
  color: #fff;
}

.upload-command-search {
  display: grid;
  gap: 6px;
  margin: 2px 0 12px;
}
.upload-command-search span {
  color: #657873;
  font-size: 12px;
  font-weight: 800;
}
.upload-command-search input {
  width: 100%;
  min-height: 42px;
  padding: 0 10px;
  border: 1px solid #ced8d5;
  border-radius: 5px;
  background: #fff;
  color: #29413b;
  font-size: 12px;
}

.upload-command-filter-list {
  display: grid;
  gap: 2px;
}
.upload-command-filter-list button {
  display: flex;
  min-height: 40px;
  align-items: center;
  justify-content: space-between;
  padding: 0 9px;
  border: 0;
  border-radius: 4px;
  background: transparent;
  color: #526762;
  font-size: 12px;
  font-weight: 800;
}
.upload-command-filter-list button.is-active {
  background: #e6f0ec;
  color: #155b4d;
}
.upload-command-filter-list em {
  min-width: 24px;
  padding: 2px 6px;
  border-radius: 999px;
  background: #edf1f0;
  color: #687a75;
  font-size: 11px;
  font-style: normal;
  text-align: center;
}
.upload-command-filter-list button.is-active em {
  background: #fff;
  color: #155b4d;
}

.upload-command-policy {
  margin: 12px 16px 16px;
  padding: 14px;
  border: 1px solid #d8e0de;
  border-radius: 6px;
  background: #fff;
}
.upload-command-policy summary {
  color: #354e47;
  font-size: 12px;
  font-weight: 900;
  cursor: pointer;
}
.upload-command-policy ul {
  display: grid;
  gap: 6px;
  margin: 10px 0 0;
  padding: 0;
  list-style: none;
}
.upload-command-policy li {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #667973;
  font-size: 11px;
}
.upload-command-policy li i {
  color: #28745f;
  font-size: 10px;
}

.upload-command-main {
  min-width: 0;
  background: #fff;
}

.upload-command-overview {
  display: grid;
  grid-template-columns: 1fr 1.2fr 1fr 1fr 1fr;
  min-height: 120px;
  align-items: stretch;
  padding: 18px 14px;
  border-bottom: 1px solid #dfe5e3;
}
.upload-command-overview article {
  display: grid;
  align-content: center;
  gap: 5px;
  min-width: 0;
  padding: 0 18px;
  border-right: 1px solid #e0e6e4;
}
.upload-command-overview article:last-child {
  border-right: 0;
}
.upload-command-overview span {
  overflow: hidden;
  color: #73827e;
  font-size: 11px;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.upload-command-overview strong {
  overflow: hidden;
  color: #293e38;
  font-size: 20px;
  font-weight: 900;
  letter-spacing: -0.035em;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.upload-command-overview article.is-complete strong {
  color: #248040;
}
.upload-command-overview.has-active-phase article.is-complete:not(.is-active) strong {
  color: #293e38;
}
.upload-command-overview.has-active-phase article:not(.is-active) .upload-command-meter span {
  background: #aebbb7;
}
.upload-command-overview article.is-active {
  border-bottom: 0;
  border-radius: 8px;
  background: #edf7f3;
  box-shadow: none;
}
.upload-command-overview article.is-active > span,
.upload-command-overview article.is-active > strong {
  color: #176253;
}

.upload-command-meter {
  height: 4px;
  margin-top: 4px;
  overflow: hidden;
  border-radius: 999px;
  background: #e2e9e7;
}
.upload-command-meter span {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: #176253;
}

.upload-command-list-head {
  display: flex;
  min-height: 68px;
  align-items: center;
  justify-content: flex-end;
  gap: 14px;
  padding: 0 18px;
  border-bottom: 1px solid #e0e6e4;
}
.upload-command-list-head > em {
  color: #657671;
  font-size: 11px;
  font-style: normal;
  font-weight: 800;
}

.upload-command-tabs {
  display: flex;
  align-self: stretch;
  margin-right: auto;
  gap: 8px;
}
.upload-command-tabs button {
  display: flex;
  min-width: 120px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 12px;
  border: 0;
  border-bottom: 2px solid transparent;
  background: transparent;
  color: #6d7e79;
  font-size: 13px;
  font-weight: 850;
}
.upload-command-tabs button.is-active {
  border-bottom-color: #176253;
  color: #176253;
}
.upload-command-tabs span {
  display: inline-grid;
  min-width: 23px;
  height: 20px;
  place-items: center;
  border-radius: 999px;
  background: #e8eceb;
  color: #64746f;
  font-size: 11px;
}
.upload-command-tabs button.is-active span {
  background: #f0e4d5;
  color: #a15f22;
}

.upload-command-page-size {
  display: flex;
  align-items: center;
}
.upload-command-page-size > span {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
}
.upload-command-page-size select {
  min-height: 40px;
  padding: 0 26px 0 10px;
  border: 1px solid #d3dcda;
  border-radius: 5px;
  background: #fff;
  color: #536762;
  font-size: 12px;
}

.upload-command-bulk-overwrite {
  display: inline-flex;
  min-height: 40px;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 0 12px;
  border: 1px solid #176253;
  border-radius: 5px;
  background: #176253;
  color: #fff;
  font-size: 12px;
  font-weight: 900;
  white-space: nowrap;
}
.upload-command-bulk-overwrite:hover:not(:disabled) {
  background: #114f43;
}
.upload-command-bulk-overwrite:disabled {
  border-color: #b8c7c3;
  background: #dce5e2;
  color: #73847f;
  cursor: not-allowed;
}

.upload-command-operation-progress {
  display: grid;
  gap: 8px;
  padding: 12px 14px;
  border: 1px solid #cbded8;
  border-radius: 6px;
  background: #f4faf7;
}
.upload-command-operation-progress.is-bulk {
  margin: 12px 16px;
  border-color: #b9d5cd;
  background: #eff8f4;
}
.upload-command-operation-progress.is-row {
  margin: 0 16px 10px;
}
.upload-command-operation-progress.is-inspector {
  border-color: #b9d5cd;
  background: #f0f8f5;
}
.upload-command-operation-progress > p {
  margin: 0;
  color: #5d726b;
  font-size: 11px;
  line-height: 1.5;
}

.upload-command-operation-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.upload-command-operation-head strong {
  color: #24584a;
  font-size: 12px;
  font-weight: 900;
}
.upload-command-operation-head span {
  flex: 0 0 auto;
  color: #26705d;
  font-size: 11px;
  font-weight: 900;
  font-variant-numeric: tabular-nums;
}

.upload-command-operation-track {
  position: relative;
  height: 8px;
  overflow: hidden;
  border-radius: 999px;
  background: #dce9e5;
}
.upload-command-operation-track > span {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, #26755f, #5a9b84);
  transition: width 160ms ease;
}

.upload-command-operation-progress.is-indeterminate .upload-command-operation-track > span {
  width: 38%;
  background: linear-gradient(90deg, transparent, #3d846e 38%, #78ad99 62%, transparent);
  animation: recovery-progress-indeterminate 1.25s ease-in-out infinite;
}

.upload-command-table-head,
.upload-command-row {
  display: grid;
  grid-template-columns: 48px minmax(155px, 1.35fr) 70px minmax(120px, 1fr) minmax(120px, 1fr) 82px;
  align-items: center;
  gap: 10px;
}

.upload-command-table-head {
  min-height: 48px;
  padding: 0 16px;
  border-bottom: 1px solid #e0e6e4;
  background: #fbfcfc;
  color: #657671;
  font-size: 11px;
  font-weight: 850;
}
.upload-command-table-head span:nth-child(5),
.upload-command-table-head span:nth-child(6) {
  text-align: center;
}

.upload-command-file-list {
  display: block;
  max-height: none;
  margin: 0;
  overflow: visible;
  padding: 0;
  list-style: none;
}
.upload-command-file-list > li {
  display: block;
  min-height: 60px;
  padding: 0;
  border: 0;
  border-bottom: 1px solid #e3e8e6;
  border-radius: 0;
  background: #fff;
  cursor: pointer;
}
.upload-command-file-list > li:hover,
.upload-command-file-list > li.is-selected {
  background: #f6faf8;
}
.upload-command-file-list > li.is-attention.is-selected {
  box-shadow: inset 2px 0 0 #dd7b5e;
}
.upload-command-file-list .selected-file-index {
  display: grid;
  width: 22px;
  height: 22px;
  place-items: center;
  border: 1px solid #cbd6d3;
  border-radius: 3px;
  background: #fff;
  color: #5f716c;
  font-size: 10px;
  font-weight: 850;
}
.upload-command-file-list .selected-file-info {
  display: grid;
  min-width: 0;
  gap: 2px;
}
.upload-command-file-list .selected-file-info strong {
  overflow: hidden;
  color: #304740;
  font-size: 13px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.upload-command-file-list .selected-file-info small {
  overflow: hidden;
  color: #84918d;
  font-size: 11px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.upload-command-file-list .registration-source-stage-badge {
  justify-self: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.upload-command-file-list .selected-file-actions {
  display: flex;
  width: 100%;
  justify-self: center;
  justify-content: center;
}
.upload-command-file-list .selected-file-actions button {
  width: 74px;
  min-height: 40px;
  padding: 0 10px;
  border: 1px solid #ccd7d4;
  border-radius: 4px;
  background: #fff;
  color: #49645d;
  font-size: 12px;
  font-weight: 850;
  line-height: 1;
  white-space: nowrap;
}
.upload-command-file-list .selected-file-actions button.is-overwrite {
  border-color: #8fb9ae;
  background: #f2f8f6;
  color: #176253;
}
.upload-command-file-list .selected-file-actions button.is-retry {
  border-color: #e2b8aa;
  background: #fff8f5;
  color: #a04432;
}
.upload-command-file-list .selected-file-actions button.is-remove {
  border-color: #ccd7d4;
  background: #fff;
  color: #49645d;
}

.upload-command-row {
  min-height: 60px;
  padding: 8px 16px;
}

.upload-command-file-size {
  color: #657671;
  font-size: 11px;
}

.upload-command-issue {
  display: inline-flex;
  width: fit-content;
  max-width: 100%;
  align-items: center;
  gap: 5px;
  overflow: hidden;
  color: #a04432;
  font-size: 11px;
  font-weight: 850;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.upload-command-issue::before {
  width: 6px;
  height: 6px;
  flex: 0 0 6px;
  border-radius: 50%;
  background: currentColor;
  content: "";
}
.upload-command-issue.is-ready {
  color: #21814a;
}
.upload-command-issue.is-pending {
  color: #a97624;
}
.upload-command-issue.is-attention {
  color: #c54934;
}

.upload-command-row-detail {
  display: grid;
  grid-template-columns: minmax(0, 1.3fr) minmax(200px, 1fr) auto;
  gap: 18px;
  margin: 0 16px 12px;
  padding: 16px;
  border: 1px solid #ecd1c7;
  border-radius: 5px;
  background: #fffaf8;
}
.upload-command-row-detail strong {
  color: #364d46;
  font-size: 12px;
  font-weight: 900;
}
.upload-command-row-detail p {
  margin: 5px 0 10px;
  color: #65736f;
  font-size: 12px;
  line-height: 1.55;
}

.upload-command-advice {
  padding: 11px 12px;
  border: 1px solid #d8e2df;
  border-radius: 5px;
  background: #f8fbfa;
}

.upload-command-row-actions {
  display: flex;
  align-items: center;
  gap: 6px;
}
.upload-command-row-actions a,
.upload-command-row-actions button {
  min-height: 40px;
  padding: 0 10px;
  border: 1px solid #d1dad7;
  border-radius: 4px;
  background: #fff;
  color: #3f635a;
  font-size: 12px;
  font-weight: 850;
  text-decoration: none;
  white-space: nowrap;
}

.upload-command-version {
  grid-column: 1/-1;
  padding-top: 12px;
  border-top: 1px solid #ead8d1;
}

.upload-command-empty {
  display: grid;
  min-height: 360px;
  min-height: clamp(360px, 100dvh - 470px, 820px);
  place-items: center;
  align-content: center;
  gap: 8px;
  padding: 40px;
  color: #71817d;
  text-align: center;
}
.upload-command-empty strong {
  color: #405852;
  font-size: 16px;
}
.upload-command-empty p {
  max-width: 480px;
  margin: 0;
  font-size: 12px;
  line-height: 1.6;
}

.upload-command-empty-icon {
  display: grid;
  width: 44px;
  height: 44px;
  margin-bottom: 4px;
  place-items: center;
  border: 1px solid #cbdad6;
  border-radius: 50%;
  background: #f3f8f6;
  color: #176253;
  font-size: 18px;
}

.upload-command-url-workspace .upload-command-list-head > div {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-right: auto;
}
.upload-command-url-workspace .upload-command-list-head strong {
  color: #314a43;
  font-size: 12px;
}
.upload-command-url-workspace .upload-command-list-head span,
.upload-command-url-workspace .upload-command-list-head em {
  color: #76847f;
  font-size: 11px;
  font-style: normal;
}
.upload-command-url-workspace .selected-file-list {
  margin: 0;
  padding: 0;
  border: 0;
  border-radius: 0;
}
.upload-command-url-workspace .selected-file-list li {
  border-bottom: 1px solid #e2e8e6;
  border-radius: 0;
}

.upload-command-pagination {
  margin: 0;
  padding: 12px 16px;
  border: 0;
  border-top: 1px solid #e0e6e4;
  border-radius: 0;
}

.upload-command-notices {
  display: grid;
  gap: 6px;
  padding: 10px 16px 16px;
}
.upload-command-notices p {
  margin: 0;
}

.registration-workspace-inline {
  display: flex;
  flex-wrap: wrap;
  gap: 6px 12px;
  color: #71807c;
  font-size: 11px;
}
.registration-workspace-inline strong {
  color: #46635b;
}

.upload-command-inspector {
  border-left: 1px solid #dce3e1;
}
.upload-command-inspector > header {
  display: flex;
  min-height: 56px;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  border-bottom: 1px solid #dce3e1;
  background: #fff;
}
.upload-command-inspector > header h3 {
  margin: 0;
  color: #2d433d;
  font-size: 14px;
  font-weight: 900;
}
.upload-command-inspector > header button {
  width: 40px;
  height: 40px;
  border: 0;
  background: transparent;
  color: #667873;
  font-size: 14px;
}
.upload-command-inspector.is-collapsed {
  align-self: start;
}

.upload-inspector-body {
  display: grid;
  gap: 20px;
  padding: 20px;
}

.upload-inspector-identity {
  display: grid;
  gap: 7px;
}
.upload-inspector-identity > strong {
  overflow: hidden;
  color: #2d433d;
  font-size: 15px;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.upload-inspector-identity > small {
  color: #73827e;
  font-size: 11px;
}

.upload-inspector-copy {
  display: grid;
  gap: 6px;
}
.upload-inspector-copy strong {
  color: #334b44;
  font-size: 13px;
  font-weight: 900;
}
.upload-inspector-copy p {
  margin: 0;
  color: #61736d;
  font-size: 12px;
  line-height: 1.65;
}

.upload-inspector-advice {
  padding: 12px;
  border: 1px solid #ead9b6;
  border-radius: 5px;
  background: #fffaf0;
}
.upload-inspector-advice strong {
  color: #5b634b;
  font-size: 12px;
  font-weight: 900;
}
.upload-inspector-advice p {
  margin: 5px 0 0;
  color: #726b54;
  font-size: 12px;
  line-height: 1.6;
}

.upload-inspector-actions {
  display: grid;
  gap: 7px;
}
.upload-inspector-actions button,
.upload-inspector-actions a {
  display: grid;
  min-height: 44px;
  place-items: center;
  border: 1px solid #1a6757;
  border-radius: 4px;
  background: #176253;
  color: #fff;
  font-size: 13px;
  font-weight: 900;
  text-decoration: none;
}
.upload-inspector-actions button.is-danger {
  border-color: #df7465;
  background: #fff;
  color: #c44d3d;
}

.upload-inspector-tech {
  padding-top: 12px;
  border-top: 1px solid #dce3e1;
}
.upload-inspector-tech summary {
  color: #526a63;
  font-size: 12px;
  font-weight: 900;
  cursor: pointer;
}
.upload-inspector-tech dl {
  display: grid;
  gap: 8px;
  margin: 12px 0 0;
}
.upload-inspector-tech dl div {
  display: grid;
  grid-template-columns: 66px minmax(0, 1fr);
  gap: 8px;
}
.upload-inspector-tech dt,
.upload-inspector-tech dd {
  margin: 0;
  overflow-wrap: anywhere;
  font-size: 11px;
  line-height: 1.5;
}
.upload-inspector-tech dt {
  color: #81908c;
}
.upload-inspector-tech dd {
  color: #4f635d;
}

.upload-inspector-empty {
  display: grid;
  min-height: 420px;
  min-height: clamp(420px, 100dvh - 340px, 880px);
  place-items: center;
  align-content: center;
  gap: 7px;
  padding: 24px;
  text-align: center;
}
.upload-inspector-empty strong {
  color: #405852;
  font-size: 15px;
}
.upload-inspector-empty p {
  margin: 0;
  color: #788682;
  font-size: 12px;
  line-height: 1.6;
}

@media (max-width: 1220px) {
  .upload-command-center {
    grid-template-columns: 230px minmax(0, 1fr);
  }
  .upload-command-inspector {
    grid-column: 1/-1;
    border-top: 1px solid #dce3e1;
    border-left: 0;
  }
  .upload-inspector-body {
    grid-template-columns: minmax(180px, 1fr) minmax(180px, 1fr) minmax(200px, 1fr);
    align-items: start;
  }
  .upload-inspector-actions,
  .upload-inspector-tech {
    grid-column: 3;
  }
}
@media (max-width: 960px) {
  .register-page.is-upload-step .register-main {
    padding-inline: 10px;
  }
  .register-page.is-upload-step .register-steps {
    padding-inline: 10px;
  }
  .register-page.is-upload-step .register-steps li {
    padding-right: 18px;
  }
  .register-page.is-upload-step .register-steps li:not(:last-child)::after {
    display: none !important;
  }
  .register-page.is-upload-step .register-step-state,
  .register-page.is-upload-step .register-step-desc {
    display: none;
  }
  .upload-command-center {
    grid-template-columns: 1fr;
  }
  .upload-command-rail {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    border-right: 0;
    border-bottom: 1px solid #dce3e1;
  }
  .upload-command-section.is-filter,
  .upload-command-policy {
    grid-column: 1/-1;
  }
  .upload-command-policy {
    margin: 12px 16px;
  }
  .upload-command-overview {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .upload-command-overview article:nth-child(3) {
    border-right: 0;
  }
  .upload-command-overview article:nth-child(n+4) {
    margin-top: 14px;
  }
  .upload-command-table-head,
  .upload-command-row {
    grid-template-columns: 38px minmax(150px, 1.4fr) 66px minmax(110px, 1fr) 118px 76px;
  }
}
@media (max-width: 720px) {
  .register-page.is-upload-step .register-header-inner {
    padding-inline: 12px;
  }
  .register-page.is-upload-step .brand-context {
    display: none;
  }
  .register-page.is-upload-step .register-hero {
    padding-inline: 2px;
  }
  .register-page.is-upload-step .register-steps {
    gap: 8px;
    overflow-x: auto;
  }
  .register-page.is-upload-step .register-steps li {
    min-width: 90px;
    padding: 0;
  }
  .register-page.is-upload-step .register-step-copy {
    display: none;
  }
  .register-page.is-upload-step .register-step {
    justify-content: center;
  }
  .register-page.is-upload-step .workbench-footer {
    position: static;
    align-items: stretch;
    flex-direction: column;
  }
  .register-page.is-upload-step .workbench-footer .primary-btn {
    width: 100%;
  }
  .upload-command-rail {
    grid-template-columns: 1fr;
  }
  .upload-command-section.is-filter,
  .upload-command-policy {
    grid-column: auto;
  }
  .upload-command-overview {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    padding: 10px;
  }
  .upload-command-overview article {
    min-height: 70px;
    padding: 10px;
    border-bottom: 1px solid #e0e6e4;
  }
  .upload-command-overview article:nth-child(2n) {
    border-right: 0;
  }
  .upload-command-list-head {
    min-height: 54px;
    flex-wrap: wrap;
    padding: 8px 10px;
  }
  .upload-command-tabs {
    width: 100%;
  }
  .upload-command-tabs button {
    min-width: 0;
    flex: 1;
  }
  .upload-command-bulk-overwrite {
    flex: 1 1 180px;
    order: 2;
  }
  .upload-command-table-head {
    display: none;
  }
  .upload-command-row {
    grid-template-columns: 28px minmax(0, 1fr) auto;
    gap: 7px;
    padding: 10px;
  }
  .upload-command-file-size {
    grid-column: 2;
  }
  .upload-command-issue {
    grid-column: 2;
    white-space: normal;
  }
  .upload-command-file-list .registration-source-stage-badge {
    grid-column: 2;
    justify-self: start;
  }
  .upload-command-file-list .selected-file-actions {
    grid-column: 3;
    grid-row: 1/span 4;
    justify-self: end;
    justify-content: flex-end;
  }
  .upload-command-row-detail {
    grid-template-columns: 1fr;
  }
  .upload-inspector-body {
    grid-template-columns: 1fr;
  }
  .upload-inspector-actions,
  .upload-inspector-tech {
    grid-column: auto;
  }
}
@media (prefers-reduced-motion: reduce) {
  .upload-command-center *,
  .register-page.is-upload-step .workbench-footer {
    scroll-behavior: auto !important;
    transition-duration: 1ms !important;
    animation-duration: 1ms !important;
  }
  .upload-command-operation-progress.is-indeterminate .upload-command-operation-track > span {
    width: 100%;
    animation: none !important;
  }
}
/* 1단계 원본 분석 커맨드 센터 — 와이드 데스크톱 비율 보정 */
@media (min-width: 961px) {
  .register-page.is-upload-step .workbench-body > .analysis-command-center {
    width: 100%;
  }
  .register-page.is-upload-step .analysis-command-center {
    height: clamp(720px, 100vh - 260px, 1040px);
    height: clamp(720px, 100dvh - 260px, 1040px);
    min-height: 720px;
    border-radius: 7px;
    box-shadow: 0 2px 8px rgba(31, 61, 53, 0.035);
  }
  .analysis-command-rail,
  .analysis-command-inspector {
    min-height: 0;
    overflow-y: auto;
    scrollbar-gutter: stable;
  }
  .analysis-command-main {
    display: flex;
    min-height: 0;
    overflow: hidden;
    flex-direction: column;
  }
  .analysis-command-list {
    min-height: 0;
    overflow-y: auto;
    flex: 1 1 auto;
    scrollbar-gutter: stable;
  }
  .analysis-command-empty {
    min-height: 0;
    flex: 1 1 auto;
  }
  .analysis-command-rail > header {
    padding: 24px 20px 18px;
  }
  .analysis-command-rail h3 {
    font-size: 18px;
  }
  .analysis-command-rail p {
    font-size: 13px;
  }
  .analysis-command-search {
    padding: 18px 18px 14px;
  }
  .analysis-command-search > span {
    font-size: 13px;
  }
  .analysis-command-search input {
    min-height: 44px;
  }
  .analysis-command-filter-list {
    padding: 0 14px 18px;
  }
  .analysis-command-filter-list button {
    min-height: 44px;
    font-size: 13px;
  }
  .analysis-command-filter-list em {
    font-size: 12px;
  }
  .analysis-preservation-card {
    margin: 18px 16px 10px;
    padding: 16px;
  }
  .analysis-preservation-card small {
    font-size: 12px;
  }
  .analysis-preservation-card strong {
    font-size: 20px;
  }
  .analysis-preservation-card p {
    font-size: 12px;
  }
  .analysis-command-policy {
    margin: 10px 16px 20px;
    padding: 15px 16px;
  }
  .analysis-command-policy summary {
    font-size: 13px;
  }
  .analysis-command-policy ul {
    font-size: 12px;
  }
  .analysis-command-head {
    min-height: 116px;
    padding: 22px 24px;
  }
  .analysis-command-head h3 {
    font-size: 20px;
  }
  .analysis-command-head p {
    font-size: 13px;
  }
  .analysis-command-head-actions button {
    min-height: 44px;
    font-size: 13px;
  }
  .analysis-command-summary {
    gap: 12px;
    padding: 18px 20px;
  }
  .analysis-command-summary article {
    min-height: 78px;
    padding: 14px 16px;
  }
  .analysis-command-summary span {
    font-size: 13px;
  }
  .analysis-command-summary strong {
    font-size: 24px;
  }
  .analysis-command-toolbar {
    min-height: 62px;
    padding: 0 20px;
  }
  .analysis-command-tabs button,
  .analysis-command-result-count {
    font-size: 13px;
  }
  .analysis-command-table-head {
    min-height: 48px;
    padding: 0 18px;
    font-size: 13px;
  }
  .analysis-command-list > li {
    min-height: 72px;
    padding: 10px 18px;
  }
  .analysis-command-file strong {
    font-size: 15px;
  }
  .analysis-command-file small {
    font-size: 12px;
  }
  .analysis-command-source,
  .analysis-command-profile {
    font-size: 13px;
  }
  .analysis-command-state {
    font-size: 12px;
  }
  .analysis-command-pagination {
    flex: 0 0 auto;
  }
  .analysis-command-pagination > span {
    font-size: 13px;
  }
  .analysis-command-pagination button {
    min-height: 42px;
    font-size: 12px;
  }
  .analysis-command-inspector > header {
    min-height: 64px;
  }
  .analysis-command-inspector h3 {
    font-size: 16px;
  }
  .analysis-inspector-body {
    gap: 20px;
    padding: 20px 18px 24px;
  }
  .analysis-inspector-identity > strong {
    font-size: 17px;
  }
  .analysis-inspector-overview {
    padding: 16px;
  }
  .analysis-inspector-overview dt,
  .analysis-inspector-overview dd {
    font-size: 12px;
  }
  .analysis-inspector-advice {
    padding: 16px;
  }
  .analysis-inspector-advice strong,
  .analysis-inspector-advice p {
    font-size: 13px;
  }
  .analysis-inspector-actions button {
    min-height: 44px;
    font-size: 13px;
  }
  .analysis-inspector-tech summary {
    font-size: 13px;
  }
  .analysis-inspector-tech dt,
  .analysis-inspector-tech dd {
    font-size: 12px;
  }
}
/* Saved material review command center — option 1 */
.register-page.is-detail-view:has(.saved-review-page) {
  --saved-review-ink: #173b36;
  --saved-review-green: #075443;
  --saved-review-green-mid: #2f625a;
  --saved-review-green-soft: #e8f3f0;
  --saved-review-line: #d7e1de;
  --saved-review-paper: #ffffff;
  --saved-review-canvas: #f4f6f5;
  --saved-review-muted: #6d7d78;
  --saved-review-rail: 288px;
  --saved-review-gap: 16px;
  min-height: 100vh;
  background: var(--saved-review-canvas);
  font-family: SUIT, Pretendard, "Noto Sans KR", "Apple SD Gothic Neo", system-ui, sans-serif;
}
.register-page.is-detail-view:has(.saved-review-page) .register-header {
  border-bottom-color: #dbe3e0;
  background: rgba(255, 255, 255, 0.97);
  box-shadow: none;
}
.register-page.is-detail-view:has(.saved-review-page) .register-header-inner,
.register-page.is-detail-view:has(.saved-review-page) .register-main {
  width: min(100%, 1680px);
  padding-inline: 18px;
}
.register-page.is-detail-view:has(.saved-review-page) .register-header-inner {
  height: 56px;
}
.register-page.is-detail-view:has(.saved-review-page) .brand-logo {
  width: auto;
  height: 30px;
  max-height: 30px;
}
.register-page.is-detail-view:has(.saved-review-page) .brand-divider {
  height: 24px;
  margin-inline: 14px;
}
.register-page.is-detail-view:has(.saved-review-page) .brand-context {
  gap: 0;
}
.register-page.is-detail-view:has(.saved-review-page) .brand-context small {
  display: none;
}
.register-page.is-detail-view:has(.saved-review-page) .brand-context strong {
  color: #2f403c;
  font-size: 17px;
  font-weight: 900;
  letter-spacing: -0.035em;
}
.register-page.is-detail-view:has(.saved-review-page) .account-button {
  height: 38px;
  border: 0;
  box-shadow: none;
}
.register-page.is-detail-view:has(.saved-review-page) .account-avatar {
  width: 28px;
  height: 28px;
  background: var(--saved-review-green);
}
.register-page.is-detail-view:has(.saved-review-page) .register-main {
  padding-top: 0;
  padding-bottom: 30px;
}

.saved-review-page,
.saved-review-page * {
  box-sizing: border-box;
}

.saved-review-page {
  width: 100%;
  min-width: 0;
  color: #243832;
  font-family: inherit;
}
.saved-review-page button,
.saved-review-page input,
.saved-review-page textarea,
.saved-review-page output {
  font: inherit;
}
.saved-review-page button:focus-visible,
.saved-review-page a:focus-visible,
.saved-review-page input:focus-visible,
.saved-review-page textarea:focus-visible,
.saved-review-page tr:focus-visible {
  outline: 3px solid rgba(7, 84, 67, 0.2);
  outline-offset: 2px;
}
.saved-review-page [hidden] {
  display: none !important;
}

.saved-review-navigation {
  display: flex;
  min-height: 36px;
  align-items: center;
  gap: 12px;
}

.saved-review-back-button {
  display: inline-flex;
  min-height: 32px;
  flex: 0 0 auto;
  align-items: center;
  gap: 7px;
  padding: 0 11px;
  border: 1px solid #d4dfdc;
  border-radius: 7px;
  background: #fff;
  color: #536762;
  cursor: pointer;
  font-size: 12px;
  font-weight: 800;
  transition: border-color 0.18s ease, background 0.18s ease, color 0.18s ease;
}
.saved-review-back-button:hover {
  border-color: #9fb8b1;
  background: #f4f8f6;
  color: var(--saved-review-green);
}
.saved-review-back-button i {
  font-size: 11px;
}

.saved-review-breadcrumb {
  display: flex;
  min-width: 0;
  flex: 1 1 auto;
  align-items: center;
  gap: 12px;
  overflow: hidden;
  color: #778783;
  font-size: 12px;
  font-weight: 700;
}
.saved-review-breadcrumb a {
  color: #536762;
  text-decoration: none;
}
.saved-review-breadcrumb i {
  color: #a8b4b0;
  font-size: 8px;
}
.saved-review-breadcrumb span,
.saved-review-breadcrumb strong {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.saved-review-breadcrumb strong {
  color: #314b44;
  font-weight: 900;
}

.saved-review-file-navigation {
  display: grid;
  min-width: 0;
  flex: 0 1 430px;
  grid-template-columns: 34px minmax(180px, 360px) 34px;
  gap: 7px;
  align-items: center;
}
.saved-review-file-navigation > button,
.saved-review-file-navigation .saved-review-file-select {
  height: 32px;
  border: 1px solid #d4dfdc;
  border-radius: 7px;
  background: #fff;
  color: #425b54;
  font-size: 12px;
  font-weight: 750;
}
.saved-review-file-navigation > button {
  display: grid;
  width: 34px;
  padding: 0;
  place-items: center;
  cursor: pointer;
  transition: border-color 0.18s ease, background 0.18s ease, color 0.18s ease;
}
.saved-review-file-navigation > button:hover:not(:disabled) {
  border-color: #9fb8b1;
  background: #f4f8f6;
  color: var(--saved-review-green);
}
.saved-review-file-navigation > button:disabled {
  border-color: #e4eae8;
  background: #f7f9f8;
  color: #b6c1be;
  cursor: not-allowed;
}

.saved-review-file-select-wrap {
  position: relative;
  min-width: 0;
}

.saved-review-file-select {
  display: grid;
  width: 100%;
  min-width: 0;
  grid-template-columns: minmax(0, 1fr) 12px;
  gap: 9px;
  align-items: center;
  padding: 0 11px;
  text-align: left;
  cursor: pointer;
}
.saved-review-file-select > i {
  color: #7f918c;
  font-size: 9px;
  transition: transform 0.18s ease;
}
.saved-review-file-select.is-open {
  border-color: #74a497;
  box-shadow: 0 0 0 3px rgba(17, 105, 84, 0.1);
}
.saved-review-file-select.is-open > i {
  transform: rotate(180deg);
}
.saved-review-file-select:disabled {
  background: #f7f9f8;
  color: #879692;
  cursor: not-allowed;
}

.saved-review-file-select-copy {
  display: grid;
  min-width: 0;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 8px;
  align-items: center;
}
.saved-review-file-select-copy strong {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 800;
}
.saved-review-file-select-copy small {
  color: #83928e;
  font-size: 9px;
  font-weight: 750;
  white-space: nowrap;
}

.saved-review-file-menu {
  position: absolute;
  z-index: 120;
  top: calc(100% + 7px);
  right: 0;
  display: grid;
  width: min(430px, 100vw - 28px);
  max-height: 390px;
  grid-template-rows: auto minmax(0, 1fr);
  overflow: hidden;
  border: 1px solid #cad8d4;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 18px 48px rgba(30, 54, 47, 0.2);
}

.saved-review-file-search {
  position: relative;
  display: block;
  padding: 10px;
  border-bottom: 1px solid #e2e9e7;
  background: #f8faf9;
}
.saved-review-file-search i {
  position: absolute;
  top: 50%;
  left: 22px;
  color: #879792;
  font-size: 11px;
  transform: translateY(-50%);
}
.saved-review-file-search input {
  width: 100%;
  height: 34px;
  min-width: 0;
  padding: 0 11px 0 32px;
  border: 1px solid #d5dfdc;
  border-radius: 7px;
  background: #fff;
  color: #314b44;
  font-size: 11px;
  outline: none;
}
.saved-review-file-search input:focus {
  border-color: #79a99c;
  box-shadow: 0 0 0 3px rgba(17, 105, 84, 0.09);
}

.saved-review-file-options {
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
  padding: 6px;
}

.saved-review-file-option {
  display: grid;
  width: 100%;
  min-height: 36px;
  grid-template-columns: 30px minmax(0, 1fr) 14px;
  gap: 8px;
  align-items: center;
  padding: 7px 9px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #435a53;
  text-align: left;
  cursor: pointer;
}
.saved-review-file-option:hover, .saved-review-file-option.is-selected {
  background: #edf5f2;
  color: #155f4d;
}
.saved-review-file-option strong {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 11px;
  font-weight: 750;
}
.saved-review-file-option > i {
  color: #176b57;
  font-size: 10px;
}

.saved-review-file-option-index {
  color: #8a9995;
  font-size: 9px;
  font-weight: 700;
  text-align: right;
}

.saved-review-file-empty {
  margin: 0;
  padding: 28px 12px;
  color: #84938f;
  font-size: 11px;
  text-align: center;
}

.saved-review-summary {
  display: grid;
  min-height: 76px;
  grid-template-columns: minmax(380px, 1.35fr) minmax(260px, 0.72fr) minmax(180px, 0.45fr) auto;
  gap: 24px;
  align-items: center;
  padding: 4px 0 8px;
}

.saved-review-identity {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 15px;
}

.saved-review-file-icon {
  display: grid;
  width: 64px;
  height: 64px;
  flex: 0 0 auto;
  place-items: center;
  border: 1px solid #d4dfdc;
  border-radius: 7px;
  background: #fff;
  color: var(--saved-review-green);
}
.saved-review-file-icon i {
  font-size: 31px;
}

.saved-review-identity-copy {
  min-width: 0;
}

.saved-review-title-row {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 10px;
}
.saved-review-title-row h1 {
  min-width: 0;
  overflow: hidden;
  margin: 0;
  color: #102923;
  font-size: 26px;
  font-weight: 900;
  letter-spacing: -0.045em;
  line-height: 1.2;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.saved-review-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
  margin-top: 8px;
}
.saved-review-badges span {
  display: inline-flex;
  min-height: 25px;
  align-items: center;
  border-radius: 999px;
  padding: 0 10px;
  background: #eef2f1;
  color: #546762;
  font-size: 11px;
  font-weight: 800;
}
.saved-review-badges .is-visibility,
.saved-review-badges .published,
.saved-review-badges .is-published {
  background: #e8f6f1;
  color: #22705f;
}
.saved-review-badges .draft,
.saved-review-badges .is-draft {
  background: #fff1df;
  color: #a8601c;
}
.saved-review-badges .is-profile {
  background: #e9f3f1;
  color: #24665a;
}

.saved-review-progress,
.saved-review-autosave {
  min-width: 0;
}
.saved-review-progress > small,
.saved-review-autosave > small {
  display: block;
  margin-bottom: 8px;
  color: #758580;
  font-size: 11px;
  font-weight: 800;
}

.saved-review-progress-copy {
  display: grid;
  grid-template-columns: auto minmax(80px, 1fr) auto;
  gap: 12px;
  align-items: center;
}
.saved-review-progress-copy strong {
  color: #263f38;
  font-size: 16px;
  font-weight: 900;
  white-space: nowrap;
}
.saved-review-progress-copy em {
  color: #697a75;
  font-size: 11px;
  font-style: normal;
  font-weight: 800;
}

.saved-review-progress-track {
  display: block;
  height: 7px;
  overflow: hidden;
  border-radius: 999px;
  background: #dfe7e4;
}
.saved-review-progress-track i {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, #2f7768, var(--saved-review-green));
  transition: width 180ms ease;
}

.saved-review-autosave strong {
  display: block;
  overflow: hidden;
  color: #5b6d68;
  font-size: 12px;
  font-weight: 750;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.saved-review-autosave p {
  max-width: 250px;
  margin: 5px 0 0;
  color: #6f807b;
  font-size: 9px;
  line-height: 1.4;
}
.saved-review-autosave button {
  display: inline-flex;
  min-height: 27px;
  align-items: center;
  gap: 6px;
  margin-top: 7px;
  border: 1px solid #bdcec9;
  border-radius: 999px;
  padding: 0 10px;
  background: #fff;
  color: #246657;
  font-size: 9px;
  font-weight: 900;
}

.saved-review-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
}
.saved-review-actions button {
  display: inline-flex;
  min-height: 42px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: 1px solid #bfcac7;
  border-radius: 7px;
  padding: 0 20px;
  background: #fff;
  color: #315149;
  font-size: 12px;
  font-weight: 900;
  white-space: nowrap;
}
.saved-review-actions button.is-primary {
  min-width: 145px;
  border-color: var(--saved-review-green);
  background: linear-gradient(135deg, #126251, var(--saved-review-green));
  color: #fff;
  box-shadow: 0 5px 12px rgba(7, 84, 67, 0.15);
}
.saved-review-actions button.is-icon {
  width: 42px;
  padding: 0;
  color: #5f706b;
}
.saved-review-actions button:disabled {
  cursor: wait;
  opacity: 0.55;
}

.saved-review-action-menu-wrap {
  position: relative;
  flex: 0 0 auto;
}

.saved-review-action-menu {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  z-index: 30;
  display: grid;
  width: 210px;
  overflow: hidden;
  border: 1px solid #cbd8d4;
  border-radius: 9px;
  padding: 5px;
  background: #fff;
  box-shadow: 0 14px 34px rgba(26, 55, 47, 0.18);
}
.saved-review-action-menu button {
  width: 100%;
  min-height: 38px;
  justify-content: flex-start;
  gap: 10px;
  border: 0;
  border-radius: 6px;
  padding: 0 11px;
  background: transparent;
  color: #314f47;
  font-size: 10px;
  text-align: left;
}
.saved-review-action-menu button:hover, .saved-review-action-menu button:focus-visible {
  background: #edf5f2;
  color: #145847;
}
.saved-review-action-menu button i {
  width: 15px;
  color: #52756c;
  text-align: center;
}

.saved-review-workspace {
  display: grid;
  min-height: calc(100dvh - 204px);
  grid-template-columns: var(--saved-review-rail) minmax(0, 1fr);
  gap: var(--saved-review-gap);
  align-items: stretch;
}

.saved-review-stage-rail,
.saved-review-center,
.saved-review-evidence {
  min-width: 0;
  overflow: hidden;
  border: 1px solid var(--saved-review-line);
  border-radius: 10px;
  background: var(--saved-review-paper);
}

.saved-review-stage-rail {
  position: sticky;
  top: 70px;
  align-self: start;
  max-height: calc(100dvh - 88px);
  overflow-y: auto;
}
.saved-review-stage-rail > header {
  display: flex;
  min-height: 48px;
  align-items: center;
  padding: 0 16px;
  border-bottom: 1px solid var(--saved-review-line);
}
.saved-review-stage-rail > header h2 {
  margin: 0;
  color: #203a33;
  font-size: 14px;
  font-weight: 900;
}
.saved-review-stage-rail > nav {
  padding: 10px 8px 14px;
}

.saved-review-stage {
  position: relative;
  display: grid;
  width: 100%;
  min-height: 58px;
  grid-template-columns: 30px minmax(0, 1fr) auto 14px;
  gap: 10px;
  align-items: center;
  border: 0;
  border-bottom: 1px solid #e3e9e7;
  border-radius: 6px;
  padding: 0 9px;
  background: transparent;
  color: #344d46;
  text-align: left;
}
.saved-review-stage:hover {
  background: #f4f8f6;
}
.saved-review-stage.is-active {
  border-bottom-color: transparent;
  background: var(--saved-review-green-soft);
  color: #174f43;
}
.saved-review-stage.is-history {
  margin-top: 8px;
  border-top: 1px solid #e3e9e7;
  border-bottom: 0;
}
.saved-review-stage > strong {
  min-width: 0;
  overflow: hidden;
  font-size: 13px;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.saved-review-stage > em {
  display: inline-flex;
  min-height: 24px;
  align-items: center;
  border-radius: 999px;
  padding: 0 8px;
  background: #edf2f0;
  color: #586b66;
  font-size: 10px;
  font-style: normal;
  font-weight: 900;
  white-space: nowrap;
}
.saved-review-stage.is-complete > em {
  background: #e8f5f0;
  color: #23715f;
}

.saved-review-stage-index {
  display: grid;
  width: 26px;
  height: 26px;
  place-items: center;
  border-radius: 50%;
  background: #eef2f1;
  color: #566a64;
  font-size: 11px;
  font-weight: 900;
}

.saved-review-stage.is-active .saved-review-stage-index,
.saved-review-stage.is-complete .saved-review-stage-index {
  background: var(--saved-review-green);
  color: #fff;
}

.saved-review-stage-chevron {
  color: #899893;
  font-size: 10px;
}

.saved-review-stage-group {
  border-bottom: 1px solid #e3e9e7;
}
.saved-review-stage-group > .saved-review-stage {
  border-bottom: 0;
}

.saved-review-stage-children {
  position: relative;
  display: grid;
  padding: 0 7px 7px 26px;
}
.saved-review-stage-children::before {
  position: absolute;
  top: 0;
  bottom: 19px;
  left: 25px;
  width: 1px;
  background: #d8e1de;
  content: "";
}
.saved-review-stage-children button {
  position: relative;
  display: grid;
  min-height: 42px;
  grid-template-columns: 10px minmax(0, 1fr) auto;
  gap: 9px;
  align-items: center;
  border: 0;
  border-radius: 6px;
  padding: 0 8px 0 15px;
  background: transparent;
  color: #52655f;
  text-align: left;
}
.saved-review-stage-children button > span {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #8ea09a;
}
.saved-review-stage-children button > strong {
  font-size: 11px;
  font-weight: 850;
}
.saved-review-stage-children button > em {
  color: #667a74;
  font-size: 9px;
  font-style: normal;
  font-weight: 850;
}
.saved-review-stage-children button:hover, .saved-review-stage-children button.is-active {
  background: #f0f6f3;
  color: #1f5b4e;
}
.saved-review-stage-children button.is-complete > em {
  color: #23715f;
}
.saved-review-stage-children button.is-editing > em, .saved-review-stage-children button.is-modified > em {
  color: #2563a9;
}
.saved-review-stage-children button.is-attention > em {
  color: #b76719;
}

.saved-review-center {
  display: flex;
  min-height: 720px;
  flex-direction: column;
}

.saved-review-panel-head,
.saved-review-section-head {
  display: flex;
  min-height: 68px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 13px 17px;
  border-bottom: 1px solid var(--saved-review-line);
}
.saved-review-panel-head h2,
.saved-review-section-head h2 {
  margin: 0;
  color: #19362f;
  font-size: 17px;
  font-weight: 900;
  letter-spacing: -0.025em;
}
.saved-review-panel-head p,
.saved-review-section-head p {
  margin: 4px 0 0;
  color: #70817c;
  font-size: 10px;
  font-weight: 650;
  line-height: 1.45;
}
.saved-review-panel-head > button,
.saved-review-section-head > button {
  display: inline-flex;
  min-height: 38px;
  flex: 0 0 auto;
  align-items: center;
  gap: 8px;
  border: 1px solid #c8d5d1;
  border-radius: 7px;
  padding: 0 13px;
  background: #fff;
  color: #245d51;
  font-size: 11px;
  font-weight: 900;
}

.saved-review-field-table-wrap {
  flex: 0 0 auto;
  max-height: 378px;
  overflow: auto;
  border-bottom: 1px solid var(--saved-review-line);
}
.saved-review-field-table-wrap.is-all-items {
  max-height: none;
  flex: 1 1 auto;
}

.saved-review-field-table {
  width: 100%;
  min-width: 760px;
  border-collapse: collapse;
  table-layout: fixed;
}
.saved-review-field-table col.is-index {
  width: 44px;
}
.saved-review-field-table col.is-label {
  width: 116px;
}
.saved-review-field-table col.is-value {
  width: 22%;
}
.saved-review-field-table col.is-status {
  width: 96px;
}
.saved-review-field-table thead {
  position: sticky;
  top: 0;
  z-index: 2;
  background: #f8faf9;
}
.saved-review-field-table th,
.saved-review-field-table td {
  height: 38px;
  overflow: hidden;
  border-bottom: 1px solid #e1e8e6;
  padding: 0 10px;
  color: #425750;
  font-size: 10px;
  font-weight: 700;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.saved-review-field-table thead th {
  height: 40px;
  color: #74837f;
  font-size: 9px;
  font-weight: 900;
}
.saved-review-field-table tbody tr {
  cursor: pointer;
  transition: background 120ms ease, box-shadow 120ms ease;
}
.saved-review-field-table tbody tr:hover {
  background: #f7faf9;
}
.saved-review-field-table tbody tr.is-active {
  background: #ecf5f2;
  box-shadow: inset 0 0 0 1px #7aa99e;
}
.saved-review-field-table tbody tr.is-active th, .saved-review-field-table tbody tr.is-active td {
  color: #193f35;
}
.saved-review-field-table tbody th {
  color: #2b403a;
  font-size: 11px;
  font-weight: 900;
}

.saved-review-row-index {
  display: grid;
  width: 22px;
  height: 22px;
  place-items: center;
  border: 1px solid #d4ddda;
  border-radius: 50%;
  background: #fff;
  color: #687a75;
  font-size: 9px;
  font-weight: 900;
}

.saved-review-status {
  display: inline-flex;
  min-height: 22px;
  align-items: center;
  border-radius: 999px;
  padding: 0 8px;
  background: #eef2f1;
  color: #5e716b;
  font-size: 9px;
  font-style: normal;
  font-weight: 900;
  white-space: nowrap;
}
.saved-review-status.is-complete, .saved-review-status.is-confirmed, .saved-review-status.is-auto-match {
  background: #e8f6f1;
  color: #21705e;
}
.saved-review-status.is-editing, .saved-review-status.is-modified, .saved-review-status.is-changed {
  background: #e8f1fd;
  color: #2563a9;
}
.saved-review-status.is-attention, .saved-review-status.is-conflict, .saved-review-status.is-pending {
  background: #fff1df;
  color: #b76719;
}

.saved-review-field-editor {
  display: flex;
  min-height: 340px;
  flex: 1 1 auto;
  flex-direction: column;
  overflow-y: auto;
  padding: 14px 17px 17px;
}
.saved-review-field-editor > header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e3e9e7;
}
.saved-review-field-editor > header span {
  color: #768681;
  font-size: 10px;
  font-weight: 850;
}
.saved-review-field-editor > header h3 {
  display: inline;
  margin: 0 0 0 11px;
  color: #1e3831;
  font-size: 13px;
  font-weight: 900;
}
.saved-review-field-editor > footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
  padding-top: 0;
}
.saved-review-field-editor > footer button {
  display: inline-flex;
  min-height: 40px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: 1px solid var(--saved-review-green);
  border-radius: 7px;
  padding: 0 17px;
  background: var(--saved-review-green);
  color: #fff;
  font-size: 11px;
  font-weight: 900;
}

.saved-review-source-toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 0 8px;
}
.saved-review-source-toggle > span {
  margin-right: 10px;
  color: #526660;
  font-size: 10px;
  font-weight: 900;
}
.saved-review-source-toggle button {
  min-height: 32px;
  border: 1px solid #ccd7d4;
  border-radius: 6px;
  padding: 0 13px;
  background: #fff;
  color: #536761;
  font-size: 10px;
  font-weight: 850;
}
.saved-review-source-toggle button.is-active {
  border-color: #4d8e80;
  background: #edf6f3;
  color: #1d6556;
}

.saved-review-editor-grid {
  display: grid;
  gap: 8px;
}

.saved-review-editor-row,
.saved-review-final-value,
.saved-review-note {
  display: grid;
  min-width: 0;
  grid-template-columns: 100px minmax(0, 1fr) 92px;
  gap: 10px;
  align-items: center;
}
.saved-review-editor-row > label,
.saved-review-editor-row > span,
.saved-review-final-value > label,
.saved-review-final-value > span,
.saved-review-note > label,
.saved-review-note > span {
  color: #526660;
  font-size: 10px;
  font-weight: 900;
}
.saved-review-editor-row output,
.saved-review-editor-row input,
.saved-review-editor-row select,
.saved-review-editor-row textarea,
.saved-review-final-value output,
.saved-review-final-value input,
.saved-review-final-value select,
.saved-review-final-value textarea,
.saved-review-note output,
.saved-review-note input,
.saved-review-note select,
.saved-review-note textarea {
  width: 100%;
  min-width: 0;
  border: 1px solid #d8e0de;
  border-radius: 6px;
  background: #f8faf9;
  color: #314a43;
  font-size: 11px;
  line-height: 1.55;
}
.saved-review-editor-row output,
.saved-review-final-value output,
.saved-review-note output {
  display: flex;
  min-height: 34px;
  align-items: center;
  overflow: hidden;
  padding: 0 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.saved-review-editor-row input,
.saved-review-editor-row select,
.saved-review-final-value input,
.saved-review-final-value select,
.saved-review-note input,
.saved-review-note select {
  min-height: 36px;
  padding: 0 12px;
  background: #fff;
}
.saved-review-editor-row select,
.saved-review-final-value select,
.saved-review-note select {
  cursor: pointer;
}
.saved-review-editor-row textarea,
.saved-review-final-value textarea,
.saved-review-note textarea {
  min-height: 66px;
  padding: 9px 12px;
  resize: vertical;
  background: #fff;
}
.saved-review-editor-row > small,
.saved-review-final-value > small,
.saved-review-note > small {
  color: #788984;
  font-size: 9px;
  font-weight: 750;
  text-align: right;
}

.saved-review-repeat-values {
  display: grid;
  gap: 7px;
}
.saved-review-repeat-values > div {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 7px;
}
.saved-review-repeat-values button {
  min-height: 36px;
  padding: 0 10px;
  border: 1px solid #ccd7d4;
  border-radius: 6px;
  background: #fff;
  color: #526660;
  font-size: 10px;
  font-weight: 850;
}
.saved-review-repeat-values button.is-add {
  justify-self: start;
  border-color: #8fb9ad;
  color: #246b59;
}

.saved-review-final-value > span,
.saved-review-note > span {
  align-self: start;
  padding-top: 10px;
}

.saved-review-hierarchy-values {
  margin-top: 14px;
  overflow: hidden;
  border: 1px solid #cbdcd7;
  border-radius: 9px;
  background: #fff;
}
.saved-review-hierarchy-values > header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
  padding: 14px 16px;
  border-bottom: 1px solid #dce7e3;
  background: #edf6f3;
}
.saved-review-hierarchy-values > header strong {
  display: block;
  color: #174f42;
  font-size: 13px;
  font-weight: 900;
}
.saved-review-hierarchy-values > header p {
  margin: 5px 0 0;
  color: #4e6961;
  font-size: 10px;
  font-weight: 700;
  line-height: 1.65;
}
.saved-review-hierarchy-values > header em {
  flex: 0 0 auto;
  border-radius: 999px;
  padding: 5px 9px;
  background: #dceee8;
  color: #1b6957;
  font-size: 10px;
  font-style: normal;
  font-weight: 900;
  white-space: nowrap;
}

.saved-review-hierarchy-toolbar {
  display: grid;
  grid-template-columns: minmax(220px, 1fr) 190px auto;
  gap: 8px;
  padding: 12px 14px;
  border-bottom: 1px solid #e2eae7;
}
.saved-review-hierarchy-toolbar label {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  align-items: center;
  gap: 8px;
}
.saved-review-hierarchy-toolbar label span {
  color: #536a63;
  font-size: 10px;
  font-weight: 900;
  white-space: nowrap;
}
.saved-review-hierarchy-toolbar input,
.saved-review-hierarchy-toolbar select,
.saved-review-hierarchy-toolbar button {
  min-height: 34px;
  border: 1px solid #cbd8d4;
  border-radius: 6px;
  padding: 0 10px;
  background: #fff;
  color: #29463e;
  font-size: 10px;
  font-weight: 750;
}
.saved-review-hierarchy-toolbar button {
  border-color: #2d7563;
  background: #2d7563;
  color: #fff;
  font-weight: 900;
}

.saved-review-hierarchy-state {
  margin: 0;
  padding: 20px;
  color: #5f746e;
  font-size: 11px;
  font-weight: 800;
  text-align: center;
}
.saved-review-hierarchy-state.is-error {
  color: #b34d43;
}

.saved-review-hierarchy-table-wrap {
  max-height: 480px;
  overflow: auto;
}

.saved-review-hierarchy-table {
  width: 100%;
  min-width: 900px;
  border-collapse: collapse;
  table-layout: fixed;
}
.saved-review-hierarchy-table th,
.saved-review-hierarchy-table td {
  border-bottom: 1px solid #e5ece9;
  padding: 9px 11px;
  color: #334e46;
  font-size: 10px;
  line-height: 1.55;
  text-align: left;
  vertical-align: top;
}
.saved-review-hierarchy-table th {
  position: sticky;
  top: 0;
  z-index: 1;
  background: #f5f8f7;
  color: #526861;
  font-size: 9px;
  font-weight: 900;
}
.saved-review-hierarchy-table th:nth-child(1) {
  width: 105px;
}
.saved-review-hierarchy-table th:nth-child(2) {
  width: 34%;
}
.saved-review-hierarchy-table th:nth-child(3) {
  width: 28%;
}
.saved-review-hierarchy-table td strong,
.saved-review-hierarchy-table td small,
.saved-review-hierarchy-table td code,
.saved-review-hierarchy-table td span {
  display: block;
}
.saved-review-hierarchy-table td strong {
  font-weight: 900;
}
.saved-review-hierarchy-table td small {
  margin-top: 2px;
  color: #70837d;
  font-size: 9px;
}
.saved-review-hierarchy-table td code {
  margin-top: 4px;
  overflow-wrap: anywhere;
  color: #52736a;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 8px;
  white-space: normal;
}

.saved-review-hierarchy-pagination {
  display: flex;
  justify-content: center;
  gap: 5px;
  padding: 11px 14px;
  border-top: 1px solid #e2eae7;
}
.saved-review-hierarchy-pagination button {
  min-width: 32px;
  min-height: 32px;
  border: 1px solid #cbd8d4;
  border-radius: 6px;
  background: #fff;
  color: #4c655e;
  font-size: 10px;
  font-weight: 850;
}
.saved-review-hierarchy-pagination button.is-active {
  border-color: #2d7563;
  background: #2d7563;
  color: #fff;
}
.saved-review-hierarchy-pagination button:disabled {
  opacity: 0.45;
}

.saved-review-evidence {
  position: sticky;
  top: 70px;
  align-self: start;
  max-height: calc(100dvh - 88px);
  overflow-y: auto;
}
.saved-review-evidence > header {
  display: flex;
  min-height: 48px;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  border-bottom: 1px solid var(--saved-review-line);
}
.saved-review-evidence > header h2 {
  margin: 0;
  color: #203a33;
  font-size: 14px;
  font-weight: 900;
}
.saved-review-evidence > header button,
.saved-review-evidence > header > i {
  display: grid;
  width: 30px;
  height: 30px;
  place-items: center;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #697b75;
}

.saved-review-evidence-summary,
.saved-review-xml-fragment,
.saved-review-revision,
.saved-review-timeline,
.saved-review-section-context > section {
  padding: 15px 18px;
  border-bottom: 1px solid #e2e8e6;
}
.saved-review-evidence-summary > small,
.saved-review-xml-fragment > small,
.saved-review-revision > small,
.saved-review-timeline > small,
.saved-review-section-context > section > small {
  display: block;
  margin-bottom: 8px;
  color: #788883;
  font-size: 10px;
  font-weight: 800;
}

.saved-review-evidence-summary h3 {
  margin: 0 0 18px;
  color: #263f38;
  font-size: 15px;
  font-weight: 900;
}
.saved-review-evidence-summary code {
  display: block;
  overflow: hidden;
  border-radius: 7px;
  padding: 11px;
  background: #f2f4f4;
  color: #60716c;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 9px;
  line-height: 1.55;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.saved-review-xml-fragment pre {
  max-height: 180px;
  overflow: auto;
  margin: 0;
  border-radius: 7px;
  padding: 13px;
  background: #f5f7f7;
  color: #45645c;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 10px;
  line-height: 1.7;
  white-space: pre-wrap;
  word-break: break-word;
}
.saved-review-xml-fragment pre mark,
.saved-review-xml-fragment pre .xml-review-highlight {
  border-radius: 2px;
  background: #ffe27a;
  color: #3d3a21;
}

.saved-review-evidence-facts {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  margin: 0;
  padding: 14px 18px;
  border-bottom: 1px solid #e2e8e6;
}
.saved-review-evidence-facts div {
  min-width: 0;
  padding-right: 14px;
}
.saved-review-evidence-facts div + div {
  padding-left: 14px;
  border-left: 1px solid #dce4e1;
}
.saved-review-evidence-facts dt {
  color: #7b8b86;
  font-size: 9px;
  font-weight: 800;
}
.saved-review-evidence-facts dd {
  margin: 7px 0 0;
  overflow: hidden;
  color: #24685a;
  font-size: 13px;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.saved-review-revision code {
  display: block;
  overflow: hidden;
  border-radius: 7px;
  padding: 10px;
  background: #f2f4f4;
  color: #667873;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 9px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.saved-review-timeline > header strong {
  color: #2e4640;
  font-size: 11px;
  font-weight: 900;
}
.saved-review-timeline ol {
  display: grid;
  gap: 18px;
  margin: 16px 0 0;
  padding: 0 0 0 23px;
  list-style: none;
}
.saved-review-timeline li {
  position: relative;
}
.saved-review-timeline li::before {
  position: absolute;
  top: 4px;
  left: -19px;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #8b9995;
  content: "";
}
.saved-review-timeline li::after {
  position: absolute;
  top: 14px;
  bottom: -20px;
  left: -16px;
  width: 1px;
  background: #dce4e1;
  content: "";
}
.saved-review-timeline li:last-child::after {
  display: none;
}
.saved-review-timeline li.is-current::before {
  background: #2d7b69;
}
.saved-review-timeline li time {
  color: #5d6f6a;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 9px;
  font-weight: 800;
}
.saved-review-timeline li > em {
  margin-left: 7px;
  color: #2563a9;
  font-size: 8px;
  font-style: normal;
  font-weight: 900;
}
.saved-review-timeline li p {
  margin: 6px 0 3px;
  color: #344e47;
  font-size: 10px;
  font-weight: 750;
  line-height: 1.5;
}
.saved-review-timeline li small {
  color: #7a8a85;
  font-size: 9px;
}

.saved-review-timeline-empty,
.saved-review-empty {
  margin: 12px 0 0;
  padding: 20px;
  border: 1px dashed #cfdbd7;
  border-radius: 8px;
  background: #f8faf9;
  color: #71827d;
  font-size: 11px;
  text-align: center;
}

.saved-review-history-all,
.saved-review-context-back {
  display: flex;
  min-height: 38px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin: 14px 18px 18px;
  border: 1px solid #cad5d2;
  border-radius: 7px;
  padding: 0 13px;
  background: #fff;
  color: #315a50;
  font-size: 10px;
  font-weight: 900;
}

.saved-review-section-shell {
  display: flex;
  min-height: 0;
  flex: 1 1 auto;
  flex-direction: column;
  overflow-y: auto;
}

.saved-review-section-head > div > span {
  display: block;
  margin-bottom: 4px;
  color: #8a5b32;
  font-size: 9px;
  font-weight: 900;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}
.saved-review-section-head > em {
  display: inline-flex;
  min-height: 25px;
  align-items: center;
  border-radius: 999px;
  padding: 0 9px;
  background: #edf2f0;
  color: #60736d;
  font-size: 9px;
  font-style: normal;
  font-weight: 900;
}
.saved-review-section-head > em.is-complete {
  background: #e8f6f1;
  color: #21705e;
}
.saved-review-section-head > em.is-editing {
  background: #e8f1fd;
  color: #2563a9;
}
.saved-review-section-head > em.is-attention {
  background: #fff1df;
  color: #b76719;
}

.saved-review-form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  padding: 20px;
}
.saved-review-form-grid label {
  display: grid;
  gap: 7px;
}
.saved-review-form-grid label.is-wide {
  grid-column: 1/-1;
}
.saved-review-form-grid label > span {
  color: #4c615b;
  font-size: 11px;
  font-weight: 900;
}

.saved-review-date-field {
  display: grid;
  align-content: start;
  gap: 7px;
}
.saved-review-date-field > span {
  color: #4c615b;
  font-size: 11px;
  font-weight: 900;
}

.saved-review-date-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 7px;
}
.saved-review-date-row button,
.saved-review-date-row + .saved-review-date-add {
  min-height: 40px;
  padding: 0 10px;
  border: 1px solid #ccd7d4;
  border-radius: 7px;
  background: #fff;
  color: #526660;
  font-size: 10px;
  font-weight: 850;
}

.saved-review-date-add {
  justify-self: start;
  min-height: 34px;
  padding: 0 11px;
  border: 1px solid #8fb9ad;
  border-radius: 7px;
  background: #f2f8f6;
  color: #246b59;
  font-size: 10px;
  font-weight: 900;
}

.saved-review-form-grid input,
.saved-review-form-grid select,
.saved-review-form-grid textarea,
.saved-review-material-type select {
  width: 100%;
  border: 1px solid #ccd7d4;
  border-radius: 7px;
  background: #fff;
  color: #2d463f;
  font-size: 12px;
}

.saved-review-form-grid input,
.saved-review-form-grid select,
.saved-review-material-type select {
  min-height: 40px;
  padding: 0 12px;
}

.saved-review-material-type select {
  cursor: pointer;
}

.saved-review-form-grid textarea {
  padding: 11px 12px;
  line-height: 1.65;
  resize: vertical;
}

.saved-review-section-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: auto;
  padding: 14px 20px;
  border-top: 1px solid #e0e7e5;
  background: #fafcfb;
}
.saved-review-section-actions button {
  display: inline-flex;
  min-height: 40px;
  align-items: center;
  gap: 8px;
  border: 1px solid var(--saved-review-green);
  border-radius: 7px;
  padding: 0 16px;
  background: var(--saved-review-green);
  color: #fff;
  font-size: 11px;
  font-weight: 900;
}

.saved-review-classification-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  padding: 20px;
}
.saved-review-classification-grid > section {
  min-width: 0;
  border: 1px solid #d9e2df;
  border-radius: 9px;
  padding: 16px;
  background: #fbfcfc;
}
.saved-review-classification-grid > section > header {
  display: flex;
  gap: 11px;
  align-items: flex-start;
  margin-bottom: 16px;
}
.saved-review-classification-grid > section > header > i {
  display: grid;
  width: 34px;
  height: 34px;
  flex: 0 0 auto;
  place-items: center;
  border-radius: 8px;
  background: #e8f3f0;
  color: #256657;
}
.saved-review-classification-grid > section > header strong {
  color: #29423b;
  font-size: 12px;
  font-weight: 900;
}
.saved-review-classification-grid > section > header p {
  margin: 3px 0 0;
  color: #788883;
  font-size: 9px;
}

.saved-review-choice-cards {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 7px;
}
.saved-review-choice-cards label {
  display: flex;
  min-height: 78px;
  align-items: center;
  gap: 9px;
  border: 1px solid #d7e0dd;
  border-radius: 8px;
  padding: 10px;
  background: #fff;
  cursor: pointer;
}
.saved-review-choice-cards label.is-active {
  border-color: #5c978a;
  background: #edf6f3;
  box-shadow: inset 0 0 0 1px rgba(7, 84, 67, 0.08);
}
.saved-review-choice-cards label input {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  opacity: 0;
}
.saved-review-choice-cards label > i {
  color: #52726a;
  font-size: 15px;
}
.saved-review-choice-cards label strong,
.saved-review-choice-cards label small {
  display: block;
}
.saved-review-choice-cards label strong {
  color: #304a43;
  font-size: 10px;
  font-weight: 900;
}
.saved-review-choice-cards label small {
  margin-top: 3px;
  color: #7b8b86;
  font-size: 8px;
}

.saved-review-material-type {
  display: grid;
  gap: 7px;
}
.saved-review-material-type > span {
  color: #4d625c;
  font-size: 10px;
  font-weight: 900;
}

.saved-review-classification-facts,
.saved-review-section-context dl {
  display: grid;
  gap: 0;
  margin: 14px 0 0;
}
.saved-review-classification-facts div,
.saved-review-section-context dl div {
  display: flex;
  min-height: 34px;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  border-bottom: 1px solid #e2e8e6;
}
.saved-review-classification-facts dt,
.saved-review-section-context dl dt {
  color: #768681;
  font-size: 9px;
  font-weight: 800;
}
.saved-review-classification-facts dd,
.saved-review-section-context dl dd {
  margin: 0;
  color: #315149;
  font-size: 10px;
  font-weight: 900;
  text-align: right;
}

.saved-review-scope-metrics {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
  padding: 18px 20px 0;
}
.saved-review-scope-metrics article {
  display: grid;
  min-height: 92px;
  grid-template-columns: 34px minmax(0, 1fr);
  gap: 3px 10px;
  align-content: center;
  border: 1px solid #d9e2df;
  border-radius: 9px;
  padding: 13px;
  background: #fafcfb;
}
.saved-review-scope-metrics article > i {
  grid-row: 1/3;
  align-self: center;
  color: #397164;
  font-size: 18px;
}
.saved-review-scope-metrics article span {
  color: #758580;
  font-size: 9px;
  font-weight: 800;
}
.saved-review-scope-metrics article strong {
  color: #29443c;
  font-size: 17px;
  font-weight: 900;
}
.saved-review-scope-metrics article.has-warning {
  border-color: #eccb9f;
  background: #fffaf2;
}

.saved-review-dtd-review {
  margin: 0 20px 20px;
  overflow: hidden;
  border: 1px solid #d5e0dd;
  border-radius: 10px;
  background: #fff;
}
.saved-review-dtd-review > header {
  display: flex;
  min-height: 54px;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 14px;
  border-bottom: 1px solid #dfe7e4;
  background: #f6f9f8;
}
.saved-review-dtd-review > header strong,
.saved-review-dtd-review > header small {
  display: block;
}
.saved-review-dtd-review > header strong {
  color: #2f4a43;
  font-size: 11px;
  font-weight: 900;
}
.saved-review-dtd-review > header small {
  margin-top: 4px;
  color: #758680;
  font-size: 9px;
}
.saved-review-dtd-review > header button {
  display: inline-flex;
  min-height: 32px;
  align-items: center;
  gap: 7px;
  border: 1px solid #b9cec8;
  border-radius: 7px;
  padding: 0 11px;
  background: #fff;
  color: #266557;
  font-size: 9px;
  font-weight: 900;
}
.saved-review-dtd-review > header button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.saved-review-dtd-group-filter {
  padding: 14px;
  border-bottom: 1px solid #dfe7e4;
  background: #fff;
}
.saved-review-dtd-group-filter > header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
}
.saved-review-dtd-group-filter > header > div {
  min-width: 0;
}
.saved-review-dtd-group-filter > header strong,
.saved-review-dtd-group-filter > header small {
  display: block;
}
.saved-review-dtd-group-filter > header strong {
  color: #2f4a43;
  font-size: 11px;
  font-weight: 900;
}
.saved-review-dtd-group-filter > header small {
  max-width: 720px;
  margin-top: 4px;
  color: #71817c;
  font-size: 9px;
  line-height: 1.5;
}
.saved-review-dtd-group-filter > header > button {
  flex: none;
  min-height: 30px;
  border: 1px solid #c6d5d1;
  border-radius: 7px;
  padding: 0 10px;
  background: #f8fbfa;
  color: #3c665c;
  font-size: 9px;
  font-weight: 900;
  white-space: nowrap;
}

.saved-review-dtd-group-chips {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(190px, 1fr));
  gap: 8px;
  margin-top: 12px;
}

.saved-review-dtd-group-chip {
  display: grid;
  width: 100%;
  min-height: 58px;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 10px;
  align-items: center;
  border: 1px solid #d7e1de;
  border-radius: 8px;
  padding: 9px 10px;
  background: #fbfcfc;
  color: #405952;
  text-align: left;
}
.saved-review-dtd-group-chip:hover {
  border-color: #a9c5bd;
  background: #f4f9f7;
}
.saved-review-dtd-group-chip.is-active {
  border-color: #4b8b7b;
  background: #edf7f4;
}
.saved-review-dtd-group-chip span,
.saved-review-dtd-group-chip strong,
.saved-review-dtd-group-chip small {
  display: block;
  min-width: 0;
}
.saved-review-dtd-group-chip strong {
  overflow: hidden;
  font-size: 10px;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.saved-review-dtd-group-chip small {
  margin-top: 4px;
  color: #7a8a85;
  font-size: 8px;
}
.saved-review-dtd-group-chip em {
  border-radius: 999px;
  padding: 4px 7px;
  background: #e8f3ef;
  color: #397164;
  font-size: 8px;
  font-style: normal;
  font-weight: 900;
  white-space: nowrap;
}
.saved-review-dtd-group-chip.is-attention em {
  background: #fff1df;
  color: #a8601c;
}
.saved-review-dtd-group-chip.is-error em {
  background: #ffebe8;
  color: #b5473e;
}
.saved-review-dtd-group-chip.is-empty {
  background: #f7f8f8;
  color: #7c8985;
}
.saved-review-dtd-group-chip.is-empty em {
  background: #ecefef;
  color: #7c8985;
}

.saved-review-dtd-action-progress {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(140px, 0.7fr) auto;
  gap: 12px;
  align-items: center;
  padding: 10px 14px;
  border-bottom: 1px solid #dfe7e4;
  background: #f8fbfa;
}
.saved-review-dtd-action-progress strong,
.saved-review-dtd-action-progress small {
  display: block;
}
.saved-review-dtd-action-progress strong {
  color: #315149;
  font-size: 10px;
  font-weight: 900;
}
.saved-review-dtd-action-progress small {
  margin-top: 3px;
  color: #71817c;
  font-size: 8px;
}
.saved-review-dtd-action-progress > em {
  color: #2f7768;
  font-size: 9px;
  font-style: normal;
  font-weight: 900;
  white-space: nowrap;
}
.saved-review-dtd-action-progress.is-error {
  background: #fff8f7;
}
.saved-review-dtd-action-progress.is-error > em {
  color: #b5473e;
}

.saved-review-dtd-action-track {
  position: relative;
  display: block;
  height: 5px;
  overflow: hidden;
  border-radius: 999px;
  background: #dfe9e6;
}
.saved-review-dtd-action-track i {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: #2f7768;
  transition: width 0.2s ease;
}
.saved-review-dtd-action-track.is-indeterminate i {
  width: 36% !important;
  animation: recovery-progress-indeterminate 1.25s ease-in-out infinite;
}

.saved-review-dtd-workspace {
  display: grid;
  min-height: 340px;
  grid-template-columns: minmax(190px, 0.72fr) minmax(0, 1.7fr);
}
.saved-review-dtd-workspace > nav {
  max-height: 430px;
  overflow-y: auto;
  border-right: 1px solid #dfe7e4;
  background: #fafcfb;
}
.saved-review-dtd-workspace > nav button {
  display: grid;
  width: 100%;
  min-height: 56px;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 10px;
  align-items: center;
  border: 0;
  border-bottom: 1px solid #e4eae8;
  padding: 9px 12px;
  background: transparent;
  color: #405952;
  text-align: left;
}
.saved-review-dtd-workspace > nav button:hover, .saved-review-dtd-workspace > nav button.is-active {
  background: #edf6f3;
}
.saved-review-dtd-workspace > nav button.is-active {
  box-shadow: inset 3px 0 0 #2f7768;
}
.saved-review-dtd-workspace > nav button span,
.saved-review-dtd-workspace > nav button strong,
.saved-review-dtd-workspace > nav button small {
  display: block;
  min-width: 0;
}
.saved-review-dtd-workspace > nav button strong {
  overflow: hidden;
  font-size: 10px;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.saved-review-dtd-workspace > nav button small {
  margin-top: 4px;
  color: #82908c;
  font-size: 8px;
}
.saved-review-dtd-workspace > nav button em {
  border-radius: 999px;
  padding: 4px 7px;
  background: #fff1df;
  color: #a8601c;
  font-size: 8px;
  font-style: normal;
  font-weight: 900;
  white-space: nowrap;
}
.saved-review-dtd-workspace > article {
  display: grid;
  align-content: start;
  gap: 12px;
  padding: 16px;
}
.saved-review-dtd-workspace > article > header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}
.saved-review-dtd-workspace > article > header small {
  color: #82908c;
  font-size: 8px;
  font-weight: 800;
}
.saved-review-dtd-workspace > article > header h3 {
  margin: 4px 0 0;
  color: #29453d;
  font-size: 15px;
  font-weight: 900;
}
.saved-review-dtd-workspace > article > header code {
  max-width: 48%;
  overflow: hidden;
  border-radius: 5px;
  padding: 5px 7px;
  background: #f0f4f3;
  color: #60736d;
  font-size: 8px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.saved-review-dtd-workspace > article label {
  display: grid;
  gap: 6px;
}
.saved-review-dtd-workspace > article label span {
  color: #4b625b;
  font-size: 9px;
  font-weight: 900;
}
.saved-review-dtd-workspace > article input,
.saved-review-dtd-workspace > article textarea {
  width: 100%;
  border: 1px solid #cbd7d3;
  border-radius: 7px;
  background: #fff;
  color: #2d463f;
  font-size: 11px;
}
.saved-review-dtd-workspace > article input {
  min-height: 38px;
  padding: 0 11px;
}
.saved-review-dtd-workspace > article textarea {
  padding: 10px 11px;
  line-height: 1.6;
  resize: vertical;
}
.saved-review-dtd-workspace > article > button,
.saved-review-dtd-workspace > article footer button {
  display: inline-flex;
  min-height: 36px;
  align-items: center;
  justify-content: center;
  gap: 7px;
  border: 1px solid #c5d4d0;
  border-radius: 7px;
  padding: 0 12px;
  background: #fff;
  color: #2c6256;
  font-size: 9px;
  font-weight: 900;
}
.saved-review-dtd-workspace > article footer {
  display: flex;
  justify-content: flex-end;
}
.saved-review-dtd-workspace > article footer button {
  border-color: var(--saved-review-green);
  background: var(--saved-review-green);
  color: #fff;
}

.saved-review-dtd-filter-empty {
  grid-column: 1/-1;
  margin: 0;
  padding: 24px 14px;
  color: #7d8b87;
  font-size: 9px;
  text-align: center;
}

.saved-review-dtd-occurrences {
  display: grid;
  gap: 9px;
  border: 1px solid #dce7e3;
  border-radius: 8px;
  padding: 11px;
  background: #f8fbfa;
}
.saved-review-dtd-occurrences > header,
.saved-review-dtd-occurrences > nav,
.saved-review-dtd-occurrences .saved-review-dtd-occurrence-search {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}
.saved-review-dtd-occurrences > header strong,
.saved-review-dtd-occurrences > header small {
  display: block;
}
.saved-review-dtd-occurrences > header strong {
  color: #29453d;
  font-size: 10px;
}
.saved-review-dtd-occurrences > header small {
  margin-top: 3px;
  color: #71847e;
  font-size: 8px;
}
.saved-review-dtd-occurrences > header em {
  color: #2f7768;
  font-size: 9px;
  font-style: normal;
  font-weight: 900;
}
.saved-review-dtd-occurrences .saved-review-dtd-occurrence-search input {
  min-width: 0;
  flex: 1;
}
.saved-review-dtd-occurrences button {
  min-height: 34px;
  border: 1px solid #b9cec8;
  border-radius: 7px;
  padding: 0 10px;
  background: #fff;
  color: #2f6257;
  font-size: 9px;
  font-weight: 900;
}
.saved-review-dtd-occurrences > nav {
  justify-content: center;
}
.saved-review-dtd-occurrences > nav span {
  color: #596f68;
  font-size: 9px;
  font-weight: 900;
}

.saved-review-dtd-occurrence-list {
  display: grid;
  max-height: 250px;
  gap: 6px;
  overflow-y: auto;
  margin: 0;
  padding: 0;
  list-style: none;
}
.saved-review-dtd-occurrence-list li {
  display: grid;
  grid-template-columns: 28px minmax(0, 1fr);
  gap: 8px;
  border-radius: 6px;
  padding: 8px;
  background: #fff;
}
.saved-review-dtd-occurrence-list li > span {
  color: #789089;
  font-size: 8px;
  font-weight: 900;
}
.saved-review-dtd-occurrence-list li strong, .saved-review-dtd-occurrence-list li code {
  display: block;
  overflow-wrap: anywhere;
}
.saved-review-dtd-occurrence-list li strong {
  color: #314d45;
  font-size: 9px;
  line-height: 1.45;
}
.saved-review-dtd-occurrence-list li code {
  margin-top: 4px;
  color: #7a8b86;
  font-size: 8px;
}

.saved-review-dtd-occurrence-state {
  margin: 0;
  padding: 10px;
  color: #71847e;
  font-size: 9px;
  text-align: center;
}
.saved-review-dtd-occurrence-state.is-error {
  color: #b34f4f;
}

.saved-review-dtd-help {
  margin: 0;
  color: #70827c;
  font-size: 9px;
  line-height: 1.55;
}

.saved-review-content-overview {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  padding: 20px;
}
.saved-review-content-overview button {
  display: grid;
  min-height: 104px;
  grid-template-columns: 42px minmax(0, 1fr) auto;
  gap: 12px;
  align-items: center;
  border: 1px solid #d8e2df;
  border-radius: 9px;
  padding: 14px;
  background: #fff;
  color: #435a53;
  text-align: left;
}
.saved-review-content-overview button:hover {
  border-color: #8fb3aa;
  background: #f5f9f7;
}
.saved-review-content-overview button > i:first-child {
  display: grid;
  width: 42px;
  height: 42px;
  place-items: center;
  border-radius: 9px;
  background: #e9f3f0;
  color: #286759;
  font-size: 17px;
}
.saved-review-content-overview button strong,
.saved-review-content-overview button small {
  display: block;
}
.saved-review-content-overview button strong {
  color: #2d4740;
  font-size: 12px;
  font-weight: 900;
}
.saved-review-content-overview button small {
  margin-top: 5px;
  color: #748680;
  font-size: 9px;
  font-weight: 800;
}

.saved-review-source-panel,
.saved-review-translation-panel,
.saved-review-entity-panel {
  padding: 18px 20px 20px;
}
.saved-review-source-panel > header,
.saved-review-translation-panel > header,
.saved-review-entity-panel > header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  margin-bottom: 12px;
}
.saved-review-source-panel > header strong,
.saved-review-source-panel > header small,
.saved-review-translation-panel > header strong,
.saved-review-translation-panel > header small,
.saved-review-entity-panel > header strong,
.saved-review-entity-panel > header small {
  display: block;
}
.saved-review-source-panel > header strong,
.saved-review-translation-panel > header strong,
.saved-review-entity-panel > header strong {
  color: #2d4740;
  font-size: 12px;
  font-weight: 900;
}
.saved-review-source-panel > header small,
.saved-review-translation-panel > header small,
.saved-review-entity-panel > header small {
  margin-top: 3px;
  color: #7a8a85;
  font-size: 9px;
}
.saved-review-source-panel > header > em,
.saved-review-source-panel > header > a,
.saved-review-translation-panel > header > em,
.saved-review-translation-panel > header > a,
.saved-review-entity-panel > header > em,
.saved-review-entity-panel > header > a {
  border-radius: 999px;
  padding: 5px 8px;
  background: #edf3f1;
  color: #506861;
  font-size: 9px;
  font-style: normal;
  font-weight: 900;
  text-decoration: none;
}

.saved-review-content-check {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 7px;
}
.saved-review-content-check > em,
.saved-review-content-check > a,
.saved-review-content-check > button {
  display: inline-flex;
  min-height: 28px;
  align-items: center;
  border-radius: 999px;
  padding: 0 9px;
  font-size: 9px;
  font-style: normal;
  font-weight: 900;
  text-decoration: none;
}
.saved-review-content-check > em {
  background: #edf3f1;
  color: #506861;
}
.saved-review-content-check > em.is-complete {
  background: #e8f6f1;
  color: #21705e;
}
.saved-review-content-check > em.is-attention {
  background: #fff1df;
  color: #b76719;
}
.saved-review-content-check > a,
.saved-review-content-check > button {
  border: 1px solid #c6d5d1;
  background: #fff;
  color: #2b6256;
}
.saved-review-content-check > button.saved-review-translation-action {
  min-height: 38px;
  gap: 7px;
  border-color: var(--saved-review-green);
  border-radius: 8px;
  padding: 0 15px;
  background: var(--saved-review-green);
  color: #fff;
  font-size: 11px;
}
.saved-review-content-check > button.saved-review-translation-action:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.saved-review-source-panel > pre,
.saved-review-translation-source > pre {
  max-height: 560px;
  overflow: auto;
  margin: 0;
  border: 1px solid #dce4e1;
  border-radius: 8px;
  padding: 16px;
  background: #f8faf9;
  color: #3d554e;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", monospace;
  font-size: 11px;
  line-height: 1.8;
  tab-size: 4;
  white-space: pre;
}

.saved-review-inline-state {
  margin: 12px 0;
  border-radius: 7px;
  padding: 12px 14px;
  background: #eef5f3;
  color: #38685d;
  font-size: 10px;
  font-weight: 800;
}
.saved-review-inline-state.is-processing {
  display: flex;
  align-items: center;
  gap: 8px;
}
.saved-review-inline-state.is-error {
  background: #fff0ef;
  color: #a63d34;
}

.saved-review-translation-source {
  margin-bottom: 14px;
  border: 1px solid #dce4e1;
  border-radius: 8px;
  padding: 13px;
  background: #fbfcfc;
}
.saved-review-translation-source > header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 9px;
}
.saved-review-translation-source > header strong {
  color: #2d4740;
  font-size: 11px;
  font-weight: 900;
}
.saved-review-translation-source > header small {
  color: #7a8a85;
  font-size: 9px;
}
.saved-review-translation-source > pre {
  max-height: 360px;
  padding: 13px;
  background: #fff;
}

.saved-review-translation-progress,
.saved-review-entity-progress {
  margin: 0 0 14px;
}

.saved-review-translation-list {
  display: grid;
  gap: 10px;
}
.saved-review-translation-list article {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  overflow: hidden;
  border: 1px solid #dce4e1;
  border-radius: 8px;
}
.saved-review-translation-list article > div {
  min-width: 0;
  padding: 13px;
}
.saved-review-translation-list article > div + div {
  border-left: 1px solid #dce4e1;
  background: #f8faf9;
}
.saved-review-translation-list article small {
  color: #788883;
  font-size: 9px;
  font-weight: 850;
}
.saved-review-translation-list article p {
  max-height: 120px;
  overflow-y: auto;
  margin: 7px 0 0;
  color: #425a53;
  font-size: 10px;
  line-height: 1.65;
  white-space: pre-wrap;
}

.saved-review-entity-list {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}
.saved-review-entity-list article {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 4px 8px;
  border: 1px solid #dce4e1;
  border-radius: 8px;
  padding: 11px 12px;
  transition: border-color 140ms ease, background 140ms ease;
}
.saved-review-entity-list article.is-deletion-target {
  border-color: #e2bd8e;
  background: #fff9f0;
}
.saved-review-entity-list article strong {
  color: #314a43;
  font-size: 11px;
  font-weight: 900;
}
.saved-review-entity-list article span {
  grid-column: 1;
  color: #7b8b86;
  font-size: 9px;
}
.saved-review-entity-list article em {
  grid-row: 1;
  grid-column: 2;
  align-self: center;
  color: #317061;
  font-size: 9px;
  font-style: normal;
  font-weight: 850;
}
.saved-review-entity-list article em.is-deletion-target {
  color: #a55c18;
}
.saved-review-entity-list article .saved-entity-deletion-button {
  grid-row: 2;
  grid-column: 2;
  min-height: 27px;
  align-self: center;
  border: 1px solid #d2914d;
  border-radius: 6px;
  padding: 0 9px;
  background: #fff;
  color: #9a5715;
  font: inherit;
  font-size: 9px;
  font-weight: 900;
  cursor: pointer;
}
.saved-review-entity-list article .saved-entity-deletion-button.is-cancel {
  border-color: #8aa59c;
  color: #375f53;
}

.saved-review-entity-more {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 10px;
  border: 1px solid #cfe0da;
  border-radius: 8px;
  padding: 10px 12px;
  background: #f4f9f7;
  color: #536b63;
  font-size: 10px;
}
.saved-review-entity-more a {
  flex: 0 0 auto;
  border-radius: 6px;
  padding: 7px 10px;
  background: #2c765e;
  color: #fff;
  font-weight: 900;
  text-decoration: none;
}

.entity-review-auto-reason {
  margin: 0;
  border-radius: 7px;
  padding: 11px 12px;
  background: #eef6f3;
  color: #35675a;
  font-size: 11px;
  font-weight: 800;
}

.saved-review-history-list {
  position: relative;
  display: grid;
  gap: 10px;
  padding: 20px;
}
.saved-review-history-list article {
  position: relative;
  display: grid;
  grid-template-columns: 18px minmax(0, 1fr);
  gap: 10px;
}
.saved-review-history-list article > div {
  border: 1px solid #dce4e1;
  border-radius: 8px;
  padding: 12px;
  background: #fbfcfc;
}
.saved-review-history-list article header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
}
.saved-review-history-list article strong {
  color: #304a43;
  font-size: 11px;
  font-weight: 900;
}
.saved-review-history-list article time,
.saved-review-history-list article small {
  color: #7c8c87;
  font-size: 9px;
}
.saved-review-history-list article p {
  margin: 7px 0 4px;
  color: #435a53;
  font-size: 10px;
}

.saved-review-history-dot {
  width: 9px;
  height: 9px;
  margin-top: 15px;
  border-radius: 50%;
  background: #2f7768;
  box-shadow: 0 0 0 4px #e7f2ee;
}

.saved-review-section-context > section h3 {
  margin: 0;
  color: #2a443d;
  font-size: 16px;
  font-weight: 900;
}
.saved-review-section-context > section > p {
  margin: 14px 0 0;
  color: #72837e;
  font-size: 10px;
  line-height: 1.6;
}
.saved-review-section-context > section dd.is-complete {
  color: #21705e;
}
.saved-review-section-context > section dd.is-editing,
.saved-review-section-context > section dd.is-modified {
  color: #2563a9;
}
.saved-review-section-context > section dd.is-attention {
  color: #b76719;
}

@media (max-width: 1360px) {
  .register-page.is-detail-view:has(.saved-review-page) {
    --saved-review-rail: 250px;
    --saved-review-gap: 12px;
  }
  .saved-review-summary {
    grid-template-columns: minmax(330px, 1.2fr) minmax(230px, 0.7fr) 170px auto;
    gap: 16px;
  }
  .saved-review-actions {
    gap: 7px;
  }
  .saved-review-actions button {
    padding-inline: 14px;
  }
  .saved-review-stage {
    grid-template-columns: 28px minmax(0, 1fr) auto 11px;
    gap: 7px;
  }
  .saved-review-choice-cards {
    grid-template-columns: 1fr;
  }
  .saved-review-choice-cards label {
    min-height: 56px;
  }
}
@media (max-width: 1180px) {
  .saved-review-navigation {
    flex-wrap: wrap;
  }
  .saved-review-file-navigation {
    margin-left: auto;
  }
  .saved-review-summary {
    grid-template-columns: minmax(340px, 1fr) minmax(260px, 0.7fr) 190px;
  }
  .saved-review-summary .saved-review-actions {
    grid-column: 1/-1;
    justify-content: flex-end;
  }
  .saved-review-workspace {
    grid-template-columns: 250px minmax(0, 1fr);
  }
}
@media (max-width: 900px) {
  .register-page.is-detail-view:has(.saved-review-page) .register-header-inner,
  .register-page.is-detail-view:has(.saved-review-page) .register-main {
    padding-inline: 14px;
  }
  .register-page.is-detail-view:has(.saved-review-page) .brand-context {
    display: none;
  }
  .saved-review-summary {
    grid-template-columns: minmax(0, 1fr) minmax(240px, 0.7fr);
  }
  .saved-review-summary .saved-review-autosave {
    grid-column: 1;
  }
  .saved-review-summary .saved-review-actions {
    grid-column: 2;
    grid-row: 2;
  }
  .saved-review-file-navigation {
    width: 100%;
    flex-basis: 100%;
    grid-template-columns: 36px minmax(0, 1fr) 36px;
    margin-left: 0;
  }
  .saved-review-file-navigation > button {
    width: 36px;
  }
  .saved-review-workspace {
    grid-template-columns: minmax(0, 1fr);
  }
  .saved-review-stage-rail {
    position: static;
    max-height: none;
    grid-column: 1;
  }
  .saved-review-stage-rail > nav {
    display: flex;
    gap: 7px;
    overflow-x: auto;
    padding: 8px;
  }
  .saved-review-stage,
  .saved-review-stage-group {
    min-width: 190px;
    border: 1px solid #dce4e1;
  }
  .saved-review-stage {
    border-bottom: 0;
  }
  .saved-review-stage-group > .saved-review-stage {
    min-width: 100%;
    border: 0;
  }
  .saved-review-stage-children {
    display: none;
  }
  .saved-review-classification-grid,
  .saved-review-dtd-workspace {
    grid-template-columns: 1fr;
  }
  .saved-review-dtd-workspace > nav {
    display: grid;
    max-height: 220px;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    border-right: 0;
    border-bottom: 1px solid #dfe7e4;
  }
}
@media (max-width: 680px) {
  .saved-review-navigation {
    gap: 8px;
  }
  .saved-review-back-button {
    width: 32px;
    justify-content: center;
    padding: 0;
  }
  .saved-review-back-button span {
    position: absolute;
    width: 1px;
    height: 1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
  }
  .saved-review-breadcrumb {
    gap: 8px;
  }
  .saved-review-summary {
    grid-template-columns: minmax(0, 1fr);
    gap: 12px;
  }
  .saved-review-identity,
  .saved-review-progress,
  .saved-review-autosave,
  .saved-review-actions {
    grid-column: 1 !important;
    grid-row: auto !important;
  }
  .saved-review-title-row h1 {
    font-size: 21px;
  }
  .saved-review-file-icon {
    width: 54px;
    height: 54px;
  }
  .saved-review-file-icon i {
    font-size: 25px;
  }
  .saved-review-actions {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1.2fr) 42px;
  }
  .saved-review-actions button {
    width: 100%;
    padding-inline: 8px;
  }
  .saved-review-actions .saved-review-action-menu-wrap {
    width: 42px;
  }
  .saved-review-actions .saved-review-action-menu {
    width: min(240px, 100vw - 28px);
  }
  .saved-review-actions .saved-review-action-menu button {
    padding-inline: 11px;
  }
  .saved-review-panel-head,
  .saved-review-section-head {
    align-items: stretch;
    flex-direction: column;
  }
  .saved-review-panel-head > button,
  .saved-review-section-head > button {
    width: 100%;
    justify-content: center;
  }
  .saved-review-field-table-wrap {
    max-height: 330px;
  }
  .saved-review-field-editor {
    padding-inline: 13px;
  }
  .saved-review-source-toggle {
    align-items: stretch;
    flex-wrap: wrap;
  }
  .saved-review-source-toggle > span {
    width: 100%;
  }
  .saved-review-source-toggle button {
    flex: 1 1 0;
  }
  .saved-review-editor-row,
  .saved-review-final-value,
  .saved-review-note {
    grid-template-columns: minmax(0, 1fr);
  }
  .saved-review-editor-row > span,
  .saved-review-final-value > span,
  .saved-review-note > span {
    padding-top: 0;
  }
  .saved-review-editor-row > small,
  .saved-review-final-value > small,
  .saved-review-note > small {
    text-align: left;
  }
  .saved-review-form-grid,
  .saved-review-classification-grid,
  .saved-review-scope-metrics,
  .saved-review-content-overview,
  .saved-review-entity-list {
    grid-template-columns: minmax(0, 1fr);
  }
  .saved-review-dtd-review {
    margin-inline: 12px;
  }
  .saved-review-dtd-review > header {
    align-items: stretch;
    flex-direction: column;
  }
  .saved-review-dtd-action-progress {
    grid-template-columns: minmax(0, 1fr);
  }
  .saved-review-dtd-workspace > nav {
    grid-template-columns: minmax(0, 1fr);
  }
  .saved-review-form-grid label.is-wide {
    grid-column: 1;
  }
  .saved-review-translation-list article {
    grid-template-columns: minmax(0, 1fr);
  }
  .saved-review-translation-list article > div + div {
    border-top: 1px solid #dce4e1;
    border-left: 0;
  }
  .saved-review-evidence-facts {
    grid-template-columns: 1fr;
  }
  .saved-review-evidence-facts div + div {
    margin-top: 10px;
    padding-top: 10px;
    padding-left: 0;
    border-top: 1px solid #dce4e1;
    border-left: 0;
  }
}
@media (prefers-reduced-motion: reduce) {
  .saved-review-progress-track i,
  .saved-review-field-table tbody tr {
    transition-duration: 0.01ms;
  }
}
@media (min-width: 1321px) {
  .register-page.is-upload-step .analysis-command-center {
    grid-template-columns: var(--upload-command-rail-width) minmax(680px, 1fr) var(--upload-command-inspector-width);
  }
}
/* 2-2 공통 메타데이터 검수 — 선택 시안 3: 근거 우선 2열 작업대 */
.register-page.is-metadata-step {
  --metadata-review-rail-width: 312px;
  --metadata-review-gap: 20px;
}
.register-page.is-metadata-step .unified-metadata-review {
  grid-template-columns: var(--metadata-review-rail-width) minmax(0, 1fr);
  gap: var(--metadata-review-gap);
  align-items: start;
}
.register-page.is-metadata-step .metadata-file-rail {
  position: sticky;
  top: 82px;
  display: flex;
  max-height: calc(100dvh - 108px);
  gap: 14px;
  padding: 18px;
  overflow-x: hidden;
  overflow-y: auto;
  border: 1px solid #d8e2df;
  border-radius: 12px;
  background: #fbfcfc;
  box-shadow: none;
  flex-direction: column;
  scrollbar-gutter: stable;
}
.register-page.is-metadata-step .metadata-file-rail-head {
  align-items: center;
}
.register-page.is-metadata-step .metadata-file-rail-head span {
  margin: 0 0 4px;
  color: #a7652d;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.1em;
}
.register-page.is-metadata-step .metadata-file-rail-head h3 {
  color: #183e35;
  font-size: 20px;
  font-weight: 700;
}
.register-page.is-metadata-step .metadata-file-rail-head > strong {
  min-width: 38px;
  height: 32px;
  color: #305f53;
  background: #eaf2ef;
  font-size: 12px;
  font-weight: 600;
}
.register-page.is-metadata-step .metadata-file-rail > p {
  color: #647a73;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.55;
}
.register-page.is-metadata-step .metadata-queue-search {
  display: grid;
  gap: 6px;
}
.register-page.is-metadata-step .metadata-queue-search > span {
  color: #45645c;
  font-size: 12px;
  font-weight: 600;
}
.register-page.is-metadata-step .metadata-queue-search input {
  width: 100%;
  min-height: 44px;
  padding: 0 13px;
  border: 1px solid #cad8d3;
  border-radius: 8px;
  background: #fff;
  color: #173d34;
  font-size: 13px;
  font-weight: 400;
  outline: none;
}
.register-page.is-metadata-step .metadata-queue-search input:focus {
  border-color: #4b8877;
  box-shadow: 0 0 0 3px rgba(75, 136, 119, 0.12);
}
.register-page.is-metadata-step .metadata-file-filters {
  gap: 4px;
}
.register-page.is-metadata-step .metadata-file-filters button {
  min-height: 38px;
  padding: 5px;
  border-radius: 7px;
  font-size: 11px;
  font-weight: 600;
}
.register-page.is-metadata-step .metadata-queue-section-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding-top: 11px;
  border-top: 1px solid #dfe7e4;
}
.register-page.is-metadata-step .metadata-queue-section-head strong {
  color: #244b41;
  font-size: 13px;
  font-weight: 700;
}
.register-page.is-metadata-step .metadata-queue-section-head small {
  color: #788a84;
  font-size: 11px;
  font-weight: 400;
}
.register-page.is-metadata-step .metadata-file-list,
.register-page.is-metadata-step .metadata-field-master {
  max-height: none;
  gap: 5px;
  padding: 0;
  overflow: visible;
}
.register-page.is-metadata-step .metadata-file-list article {
  gap: 8px;
  padding: 10px;
  border-radius: 9px;
  background: #fff;
  box-shadow: none;
  transform: none;
}
.register-page.is-metadata-step .metadata-file-list article:hover {
  border-color: #9fc3b8;
  box-shadow: none;
  transform: none;
}
.register-page.is-metadata-step .metadata-file-list article.is-active {
  border-color: #2e7663;
  background: #edf7f3;
}
.register-page.is-metadata-step .metadata-file-resume {
  font-weight: 600;
}
.register-page.is-metadata-step .metadata-file-select {
  grid-template-columns: 34px minmax(0, 1fr);
  gap: 10px;
  min-height: 44px;
}
.register-page.is-metadata-step .metadata-file-select > span:first-child {
  width: 34px;
  height: 34px;
  border-radius: 8px;
  font-size: 11px;
}
.register-page.is-metadata-step .metadata-file-select strong {
  color: #1d4339;
  font-size: 13px;
  font-weight: 600;
}
.register-page.is-metadata-step .metadata-file-select small {
  margin-top: 2px;
  font-size: 10px;
  font-weight: 400;
}
.register-page.is-metadata-step .metadata-file-workflow-state,
.register-page.is-metadata-step .metadata-file-complete-badge {
  font-weight: 600 !important;
}
.register-page.is-metadata-step .metadata-file-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 0 1px;
}
.register-page.is-metadata-step .metadata-file-pagination > span {
  color: #60756e;
  font-size: 10px;
}
.register-page.is-metadata-step .metadata-file-pagination > div {
  display: flex;
  align-items: center;
  gap: 5px;
}
.register-page.is-metadata-step .metadata-file-pagination button {
  min-width: 46px;
  min-height: 30px;
  padding: 0 8px;
  border: 1px solid #cad8d3;
  border-radius: 7px;
  background: #fff;
  color: #315f54;
  font-size: 10px;
  font-weight: 600;
}
.register-page.is-metadata-step .metadata-file-pagination button:disabled {
  opacity: 0.42;
  cursor: not-allowed;
}
.register-page.is-metadata-step .metadata-file-pagination strong {
  min-width: 42px;
  color: #49645c;
  font-size: 10px;
  font-weight: 600;
  text-align: center;
}
.register-page.is-metadata-step .metadata-field-master > button {
  grid-template-columns: 36px minmax(0, 1fr) 16px;
  gap: 10px;
  min-height: 74px;
  padding: 10px 12px;
  border-radius: 9px;
  box-shadow: none;
  transform: none;
}
.register-page.is-metadata-step .metadata-field-master > button:hover {
  border-color: #9fc3b8;
  box-shadow: none;
  transform: none;
}
.register-page.is-metadata-step .metadata-field-master > button.is-active {
  border-color: #2e7663;
  background: #edf7f3;
}
.register-page.is-metadata-step .metadata-field-index {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  font-size: 11px;
  font-weight: 600;
}
.register-page.is-metadata-step .metadata-field-master-copy {
  gap: 4px;
}
.register-page.is-metadata-step .metadata-field-master-copy strong {
  font-size: 14px;
  font-weight: 600;
}
.register-page.is-metadata-step .metadata-field-master-copy > small {
  font-size: 11px;
  font-weight: 400;
}
.register-page.is-metadata-step .metadata-field-master-status b {
  font-size: 10px;
  font-weight: 600;
}
.register-page.is-metadata-step .metadata-field-master-top em {
  font-weight: 600;
}
.register-page.is-metadata-step .metadata-advance-panel {
  margin-top: 2px;
  border-radius: 9px;
  box-shadow: none;
}
.register-page.is-metadata-step .metadata-advance-panel header strong,
.register-page.is-metadata-step .metadata-advance-panel header em,
.register-page.is-metadata-step .metadata-advance-panel button {
  font-weight: 600;
}
.register-page.is-metadata-step .metadata-review-main {
  min-width: 0;
}
.register-page.is-metadata-step .metadata-review-page-head {
  display: grid;
  grid-template-columns: minmax(340px, 1fr) minmax(230px, 280px) auto;
  align-items: center;
  gap: 18px;
  padding: 0 0 16px;
}
.register-page.is-metadata-step .metadata-review-page-head h3 {
  font-size: 24px;
  font-weight: 700;
}
.register-page.is-metadata-step .metadata-review-page-head p {
  margin-top: 6px;
  font-size: 13px;
  font-weight: 400;
}
.register-page.is-metadata-step .metadata-review-progress {
  min-width: 0;
  padding: 12px 14px;
  border-radius: 10px;
  box-shadow: none;
}
.register-page.is-metadata-step .metadata-review-draft-actions {
  align-items: stretch;
  flex-direction: column;
}
.register-page.is-metadata-step .metadata-review-draft-actions button {
  min-height: 36px;
  border-radius: 8px;
  font-weight: 600;
}
.register-page.is-metadata-step .metadata-strategy-summary {
  gap: 12px;
  margin-top: 14px;
  padding: 16px 18px;
  border-radius: 12px;
  background: #f7faf9;
}
.register-page.is-metadata-step .metadata-strategy-summary .metadata-strategy-actions > em {
  font-weight: 600;
}
.register-page.is-metadata-step .metadata-current-fields {
  display: grid;
  gap: 12px;
  margin-top: 14px;
  padding: 16px 18px 18px;
  border: 1px solid #dbe7e3;
  border-radius: 12px;
  background: #fbfcfc;
}
.register-page.is-metadata-step .metadata-current-fields > .metadata-queue-section-head {
  padding-top: 0;
  border-top: 0;
}
.register-page.is-metadata-step .metadata-current-fields > .metadata-queue-section-head strong {
  font-size: 15px;
}
.register-page.is-metadata-step .metadata-current-fields > .metadata-queue-section-head small {
  font-size: 12px;
}
.register-page.is-metadata-step .metadata-current-fields .metadata-field-master {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
}
.register-page.is-metadata-step .metadata-current-fields .metadata-review-toolbar {
  margin-top: 0;
}
.register-page.is-metadata-step .metadata-review-toolbar {
  margin-top: 14px;
  padding: 11px 12px;
  border-radius: 10px;
  box-shadow: none;
}
.register-page.is-metadata-step .metadata-review-filters button {
  min-height: 36px;
  border-radius: 8px;
  font-weight: 600;
}
.register-page.is-metadata-step .metadata-bulk-preview {
  gap: 7px;
}
.register-page.is-metadata-step .metadata-bulk-preview button {
  min-width: 0;
  min-height: 38px;
  border-radius: 8px;
  font-size: 11px;
  font-weight: 600;
  box-shadow: none;
}
.register-page.is-metadata-step .metadata-master-detail {
  display: block;
  margin-top: 12px;
}
.register-page.is-metadata-step .metadata-field-detail {
  min-width: 0;
  padding: 18px;
  border-radius: 12px;
  box-shadow: none;
}
.register-page.is-metadata-step .metadata-field-detail-head h4 {
  font-size: 22px;
  font-weight: 700;
}
.register-page.is-metadata-step .metadata-review-guidance {
  margin-top: 12px;
  border-radius: 9px;
  background: #f3f8f6;
}
.register-page.is-metadata-step .metadata-review-guidance strong {
  font-weight: 600;
}
.register-page.is-metadata-step .metadata-review-scope-switch {
  margin-top: 12px;
  border-radius: 9px;
}
.register-page.is-metadata-step .metadata-review-scope-switch button span {
  font-weight: 600;
}
.register-page.is-metadata-step .metadata-value-comparison {
  grid-template-columns: minmax(0, 3fr) minmax(0, 2fr);
  gap: 12px;
}
.register-page.is-metadata-step .metadata-value-comparison article {
  min-height: 186px;
  padding: 15px;
  border-radius: 10px;
}
.register-page.is-metadata-step .metadata-value-comparison article .metadata-value-heading > span > em {
  font-size: 11px;
  font-weight: 500;
}
.register-page.is-metadata-step .metadata-value-preview {
  font-size: 15px;
  font-weight: 500;
}
.register-page.is-metadata-step .metadata-evidence-panel,
.register-page.is-metadata-step .metadata-field-editor,
.register-page.is-metadata-step .xml-change-reason,
.register-page.is-metadata-step .metadata-standard-details {
  border-radius: 10px;
  box-shadow: none;
}
.register-page.is-metadata-step .metadata-evidence-list article {
  min-width: 0;
}
.register-page.is-metadata-step .metadata-evidence-list article code,
.register-page.is-metadata-step .metadata-evidence-list article q {
  overflow-wrap: anywhere;
  word-break: break-word;
  white-space: pre-wrap;
}
.register-page.is-metadata-step .metadata-field-decisions button,
.register-page.is-metadata-step .metadata-field-editor input,
.register-page.is-metadata-step .metadata-field-editor textarea,
.register-page.is-metadata-step .xml-change-reason textarea {
  font-weight: 500;
}
.register-page.is-metadata-step .metadata-hierarchy-workbench {
  border-radius: 10px;
  box-shadow: none;
}
.register-page.is-metadata-step .metadata-hierarchy-layout {
  grid-template-columns: minmax(280px, 0.78fr) minmax(420px, 1.22fr);
}
.register-page.is-metadata-step .metadata-hierarchy-candidate-list > article {
  box-shadow: none;
}
.register-page.is-metadata-step button:focus-visible,
.register-page.is-metadata-step input:focus-visible,
.register-page.is-metadata-step textarea:focus-visible {
  outline: 3px solid rgba(46, 118, 99, 0.2);
  outline-offset: 2px;
}

@media (max-width: 1280px) {
  .register-page.is-metadata-step {
    --metadata-review-rail-width: 280px;
  }
  .register-page.is-metadata-step .metadata-review-page-head {
    grid-template-columns: minmax(260px, 1fr) minmax(190px, 230px);
  }
  .register-page.is-metadata-step .metadata-review-draft-actions {
    grid-column: 1/-1;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .register-page.is-metadata-step .metadata-review-toolbar {
    align-items: stretch;
    flex-direction: column;
  }
  .register-page.is-metadata-step .metadata-bulk-preview {
    justify-content: space-between;
  }
  .register-page.is-metadata-step .metadata-hierarchy-layout,
  .register-page.is-metadata-step .metadata-value-comparison {
    grid-template-columns: minmax(0, 1fr);
  }
}
@media (max-width: 960px) {
  .register-page.is-metadata-step .unified-metadata-review {
    grid-template-columns: minmax(0, 1fr);
  }
  .register-page.is-metadata-step .metadata-file-rail {
    position: static;
    max-height: none;
  }
  .register-page.is-metadata-step .metadata-file-list,
  .register-page.is-metadata-step .metadata-field-master {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .register-page.is-metadata-step .metadata-advance-panel,
  .register-page.is-metadata-step .metadata-file-pagination,
  .register-page.is-metadata-step .metadata-queue-section-head,
  .register-page.is-metadata-step .metadata-queue-search,
  .register-page.is-metadata-step .metadata-file-progress,
  .register-page.is-metadata-step .metadata-file-filters {
    grid-column: 1/-1;
  }
}
@media (max-width: 620px) {
  .register-page.is-metadata-step .metadata-file-list,
  .register-page.is-metadata-step .metadata-field-master,
  .register-page.is-metadata-step .metadata-review-page-head,
  .register-page.is-metadata-step .metadata-review-draft-actions,
  .register-page.is-metadata-step .metadata-strategy-facts,
  .register-page.is-metadata-step .metadata-review-scope-switch,
  .register-page.is-metadata-step .metadata-hierarchy-candidate-list {
    grid-template-columns: minmax(0, 1fr);
  }
  .register-page.is-metadata-step .metadata-field-detail {
    padding: 14px;
  }
  .register-page.is-metadata-step .metadata-file-pagination {
    align-items: stretch;
    flex-direction: column;
  }
  .register-page.is-metadata-step .metadata-bulk-preview,
  .register-page.is-metadata-step .metadata-field-decisions {
    align-items: stretch;
    flex-direction: column;
  }
  .register-page.is-metadata-step .metadata-bulk-preview button,
  .register-page.is-metadata-step .metadata-field-decisions button,
  .register-page.is-metadata-step .metadata-field-decisions > button:last-child {
    width: 100%;
  }
}
/* 자료 등록 1~3단계 공통 상단 진행 표시.
   단계별 작업대 폭은 유지하고, 헤더와 stepper만 같은 캔버스·간격·상태 규칙을 사용한다. */
.register-page.is-registration-mode {
  --registration-stepper-max-width: 1680px;
  min-height: 100vh;
  background: #f4f6f5;
}
.register-page.is-registration-mode .register-header {
  border-bottom: 1px solid #d7dfdc;
  background: rgba(255, 255, 255, 0.97);
  box-shadow: none;
}
.register-page.is-registration-mode .register-header-inner {
  display: flex;
  width: 100%;
  max-width: var(--registration-stepper-max-width);
  height: 58px;
  min-height: 58px;
  align-items: center;
  gap: 14px;
  margin-inline: auto;
  padding: 0 22px;
  box-sizing: border-box;
}
.register-page.is-registration-mode .brand-link {
  flex: 0 0 auto;
}
.register-page.is-registration-mode .header-actions {
  margin-left: auto;
}
.register-page.is-registration-mode .register-header-page-divider {
  width: 1px;
  height: 22px;
  margin-left: 2px;
  background: #d7dfdc;
}
.register-page.is-registration-mode .register-header-page-title {
  color: #1d302b;
  font-size: 17px;
  font-weight: 900;
  letter-spacing: -0.035em;
}
.register-page.is-registration-mode .brand-logo {
  width: auto;
  height: 28px;
  max-height: 28px;
}
.register-page.is-registration-mode .brand-context small {
  display: none;
}
.register-page.is-registration-mode .brand-context strong {
  font-size: 17px;
  letter-spacing: -0.035em;
}
.register-page.is-registration-mode .register-main {
  padding-top: 16px;
  padding-inline: 16px;
}
.register-page.is-registration-mode .register-topline,
.register-page.is-registration-mode .register-hero {
  display: none;
}
.register-page.is-registration-mode .register-flow {
  display: grid;
  gap: 8px;
  margin: 0;
  padding: 0;
}
.register-page.is-registration-mode .flow-progress,
.register-page.is-registration-mode .flow-guide,
.register-page.is-registration-mode .workbench-head {
  display: none;
}
.register-page.is-registration-mode .register-steps {
  display: grid;
  width: min(100vw - 32px, var(--registration-stepper-max-width));
  grid-template-columns: repeat(3, minmax(0, 1fr));
  justify-self: center;
  margin: 0;
  padding: 8px 22px 10px;
  border: 0;
  border-bottom: 1px solid #d9e1de;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
  box-sizing: border-box;
}
.register-page.is-registration-mode .register-steps li {
  position: relative;
  min-width: 0;
  padding-right: 42px;
}
.register-page.is-registration-mode .register-steps li:last-child {
  padding-right: 0;
}
.register-page.is-registration-mode .register-steps li:not(:last-child)::after {
  top: 20px;
  right: 14px;
  left: 156px;
  display: block !important;
  width: auto;
  min-width: 0;
  height: 1px;
  background: #d6dfdc;
  content: "";
}
.register-page.is-registration-mode .register-step {
  min-height: 42px;
  padding: 0;
  border: 0;
  border-radius: 0;
  background: transparent;
  color: #465b55;
  box-shadow: none;
}
.register-page.is-registration-mode .register-step:hover,
.register-page.is-registration-mode .register-step:focus-visible {
  border: 0;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
}
.register-page.is-registration-mode .register-step:focus-visible {
  outline: 2px solid rgba(7, 84, 67, 0.28);
  outline-offset: 4px;
}
.register-page.is-registration-mode .register-step-number {
  width: 36px;
  height: 36px;
  border: 0;
  border-radius: 50%;
  background: #e7ecea;
  color: #465b55;
  font-size: 13px;
}
.register-page.is-registration-mode .register-step-copy {
  min-width: 0;
  gap: 2px;
}
.register-page.is-registration-mode .register-step-title {
  overflow: hidden;
  color: #314a44;
  font-size: 14px;
  font-weight: 850;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.register-page.is-registration-mode .register-step-desc {
  overflow: hidden;
  color: #6f807b;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.register-page.is-registration-mode .register-step-state {
  align-self: end;
  padding: 3px 7px;
  border-radius: 999px;
  background: #eef3f1;
  color: #75847f;
  font-size: 12px;
  letter-spacing: 0;
}
.register-page.is-registration-mode .register-step[aria-current=step] .register-step-number {
  background: #075443;
  color: #fff;
}
.register-page.is-registration-mode .register-step[aria-current=step] .register-step-title,
.register-page.is-registration-mode .register-step[aria-current=step] .register-step-state {
  color: #075443;
}
.register-page.is-registration-mode .register-step[aria-current=step] .register-step-state {
  background: #e7f2ee;
}
.register-page.is-registration-mode .register-step.is-complete .register-step-number {
  background: #dcece7;
  color: #245f51;
}
.register-page.is-registration-mode .register-step.is-complete .register-step-title,
.register-page.is-registration-mode .register-step.is-complete .register-step-state {
  color: #245f51;
}
.register-page.is-registration-mode .register-step.is-complete .register-step-state {
  background: #e5f1ed;
}

@media (max-width: 960px) {
  .register-page.is-registration-mode .register-main {
    padding-inline: 10px;
  }
  .register-page.is-registration-mode .register-steps {
    width: calc(100vw - 20px);
    padding-inline: 10px;
  }
  .register-page.is-registration-mode .register-steps li {
    padding-right: 18px;
  }
  .register-page.is-registration-mode .register-steps li:not(:last-child)::after {
    display: none !important;
  }
  .register-page.is-registration-mode .register-step-state,
  .register-page.is-registration-mode .register-step-desc {
    display: none;
  }
}
@media (max-width: 720px) {
  .register-page.is-registration-mode .register-header-inner {
    padding-inline: 12px;
  }
  .register-page.is-registration-mode .register-main {
    padding-top: 12px;
  }
  .register-page.is-registration-mode .brand-context {
    display: none;
  }
  .register-page.is-registration-mode .register-steps {
    grid-template-columns: repeat(3, minmax(72px, 1fr));
    gap: 8px;
    overflow-x: auto;
  }
  .register-page.is-registration-mode .register-steps li {
    min-width: 72px;
    padding: 0;
  }
  .register-page.is-registration-mode .register-step-copy {
    display: none;
  }
  .register-page.is-registration-mode .register-step {
    grid-template-columns: 36px;
    justify-content: center;
  }
}
/* 자료 등록 1~3단계는 브라우저 80% 확대/축소와 같은 데스크톱 밀도로 표시한다.
   축소한 만큼 캔버스를 125%로 보정하고 초과 폭의 절반을 양쪽으로 나눠
   작업대 중심이 원래 viewport 중심에서 밀리지 않게 한다. */
@media (min-width: 961px) {
  /* 125% 보정 캔버스가 host 바깥의 문서 폭으로 합산되지 않게 한다.
     섹션 내부에서 의도한 overflow-x: auto는 각각의 스크롤 영역에서 유지된다. */
  :host:has(> .register-page.is-registration-mode) {
    width: 100%;
    max-width: 100%;
    overflow-x: hidden;
    overflow-x: clip;
  }
  /* fixed 모달의 viewport 단위는 부모의 0.8 배율로 함께 줄어든다.
     오버레이 자체를 125vw/125dvh로 잡아 렌더링 결과가 실제 화면 100%가 되게 한다. */
  .register-page.is-registration-mode > .overwrite-confirm-backdrop,
  .register-page.is-registration-mode > .metadata-value-modal-backdrop,
  .register-page.is-registration-mode > .registration-save-error-backdrop,
  .register-page.is-registration-mode > .registration-processing-backdrop,
  .register-page.is-registration-mode > .final-confirm-backdrop,
  .register-page.is-registration-mode > .registration-exit-backdrop,
  .register-page.is-registration-mode > .recovery-modal-backdrop,
  .register-page.is-registration-mode .translation-workspace-backdrop,
  .register-page.is-registration-mode .ocr-workspace-backdrop {
    width: 125vw;
    max-width: none;
    height: 125vh;
    height: 125dvh;
  }
  /* 오버레이 범위는 위에서 직접 보정하고 작업창 본체만 역배율을 적용해
     패널 크기·타이포·내부 여백의 기존 설계를 함께 복원한다. */
  .register-page.is-registration-mode .translation-workspace,
  .register-page.is-registration-mode .ocr-page-workspace {
    zoom: 1.25;
  }
  .register-page.is-registration-mode {
    width: 125%;
    max-width: none;
    margin-inline: -12.5%;
    min-height: 125vh;
    min-height: 125dvh;
    box-sizing: border-box;
    zoom: 0.8;
  }
}
/* 등록 단계는 화면 중앙의 동일한 3개 카드로 표시한다. */
.register-page.is-registration-mode .register-steps {
  width: min(1320px, 100% - 64px);
  grid-template-columns: repeat(3, minmax(0, 1fr));
  justify-self: center;
  gap: 14px;
  margin: 8px auto 16px;
  padding: 14px;
  border: 1px solid #d8e3df;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 10px 28px rgba(31, 61, 53, 0.055);
  box-sizing: border-box;
}
.register-page.is-registration-mode .register-steps li {
  padding: 0;
}
.register-page.is-registration-mode .register-steps li:not(:last-child)::after {
  display: none !important;
}
.register-page.is-registration-mode .register-step {
  display: grid;
  min-height: 82px;
  grid-template-columns: 42px minmax(0, 1fr) auto;
  align-items: center;
  gap: 12px;
  padding: 13px 15px;
  border: 1px solid #dce5e2;
  border-radius: 12px;
  background: #f9fbfa;
  color: #526660;
  box-shadow: none;
  text-align: left;
}
.register-page.is-registration-mode .register-step:hover,
.register-page.is-registration-mode .register-step:focus-visible {
  border: 1px solid #a9c5bd;
  border-radius: 12px;
  background: #f3f8f6;
  box-shadow: 0 8px 20px rgba(31, 61, 53, 0.07);
}
.register-page.is-registration-mode .register-step-number {
  width: 42px;
  height: 42px;
  border: 1px solid #d6e0dd;
  background: #eef3f1;
  color: #60736d;
  font-size: 13px;
}
.register-page.is-registration-mode .register-step-copy {
  gap: 4px;
}
.register-page.is-registration-mode .register-step-title {
  color: #29423b;
  font-size: 15px;
  font-weight: 900;
  white-space: normal;
}
.register-page.is-registration-mode .register-step-desc {
  color: #71817c;
  font-size: 11px;
  line-height: 1.45;
  white-space: normal;
}
.register-page.is-registration-mode .register-step-state {
  position: static;
  align-self: center;
  justify-self: end;
  padding: 5px 9px;
  border-radius: 999px;
  background: #edf2f0;
  color: #6c7c77;
  font-size: 11px;
}
.register-page.is-registration-mode .register-step[aria-current=step] {
  border-color: #2f7867;
  background: #eef7f4;
  box-shadow: inset 0 0 0 1px rgba(47, 120, 103, 0.08);
}
.register-page.is-registration-mode .register-step[aria-current=step] .register-step-number {
  border-color: #075443;
  background: #075443;
  color: #fff;
}
.register-page.is-registration-mode .register-step[aria-current=step] .register-step-state {
  background: #dcefe9;
  color: #075443;
}
.register-page.is-registration-mode .register-step.is-complete {
  border-color: #c9ded8;
  background: #f5faf8;
}

@media (max-width: 960px) {
  .register-page.is-registration-mode .register-steps {
    width: calc(100% - 20px);
    gap: 8px;
    padding: 10px;
  }
  .register-page.is-registration-mode .register-step {
    min-height: 64px;
    grid-template-columns: 38px minmax(0, 1fr);
    padding: 10px;
  }
  .register-page.is-registration-mode .register-step-number {
    width: 38px;
    height: 38px;
  }
  .register-page.is-registration-mode .register-step-state {
    display: none;
  }
}
@media (max-width: 720px) {
  .register-page.is-registration-mode .register-steps {
    width: calc(100% - 12px);
    grid-template-columns: repeat(3, minmax(72px, 1fr));
    margin-top: 4px;
    padding: 8px;
  }
  .register-page.is-registration-mode .register-step {
    grid-template-columns: 38px;
    justify-content: center;
  }
  .register-page.is-registration-mode .register-step-copy {
    display: none;
  }
}
/* 메타정보 내부 2단계는 상단 진행 표시와 같은 중앙 카드로 정리한다. */
.register-page.is-metadata-step .metadata-registration-substeps {
  width: min(980px, 100% - 48px);
  grid-template-columns: repeat(2, minmax(0, 1fr));
  justify-self: center;
  gap: 12px;
  margin: 10px auto 12px;
  padding: 10px;
  border: 1px solid #d8e3df;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.92);
  box-shadow: 0 10px 28px rgba(31, 61, 53, 0.055);
  box-sizing: border-box;
}
.register-page.is-metadata-step .metadata-registration-substeps > button {
  min-height: 82px;
  grid-template-columns: 42px minmax(0, 1fr) auto;
  gap: 12px;
  padding: 13px 15px;
  border: 1px solid #dce5e2;
  border-radius: 12px;
  background: #f9fbfa;
  box-shadow: none;
  text-align: left;
}
.register-page.is-metadata-step .metadata-registration-substeps > button:hover, .register-page.is-metadata-step .metadata-registration-substeps > button:focus-visible {
  border-color: #a9c5bd;
  background: #f3f8f6;
  box-shadow: 0 8px 20px rgba(31, 61, 53, 0.07);
  transform: none;
}
.register-page.is-metadata-step .metadata-registration-substeps > button > span:first-child {
  width: 42px;
  height: 42px;
  border: 1px solid #d6e0dd;
  background: #eef3f1;
  color: #60736d;
  font-size: 13px;
}
.register-page.is-metadata-step .metadata-registration-substeps > button > span:nth-child(2) {
  gap: 4px;
}
.register-page.is-metadata-step .metadata-registration-substeps > button strong {
  color: #29423b;
  font-size: 15px;
  font-weight: 900;
  white-space: normal;
}
.register-page.is-metadata-step .metadata-registration-substeps > button small {
  color: #71817c;
  font-size: 11px;
  line-height: 1.45;
  white-space: normal;
}
.register-page.is-metadata-step .metadata-registration-substeps > button em {
  justify-self: end;
  padding: 5px 9px;
  border-radius: 999px;
  background: #edf2f0;
  color: #6c7c77;
  font-size: 11px;
}
.register-page.is-metadata-step .metadata-registration-substeps > button.is-active {
  border-color: #2f7867;
  background: #eef7f4;
  box-shadow: inset 0 0 0 1px rgba(47, 120, 103, 0.08);
}
.register-page.is-metadata-step .metadata-registration-substeps > button.is-active > span:first-child {
  border-color: #075443;
  background: #075443;
  color: #fff;
}
.register-page.is-metadata-step .metadata-registration-substeps > button.is-active em {
  background: #dcefe9;
  color: #075443;
}
.register-page.is-metadata-step .metadata-registration-substeps > button.is-complete {
  border-color: #c9ded8;
  background: #f5faf8;
}
.register-page.is-metadata-step .metadata-stage-breadcrumb {
  width: min(980px, 100% - 48px);
  margin: 0 auto 16px;
  box-sizing: border-box;
}

@media (max-width: 720px) {
  .register-page.is-metadata-step .metadata-registration-substeps {
    width: calc(100% - 16px);
    gap: 7px;
    padding: 7px;
  }
  .register-page.is-metadata-step .metadata-registration-substeps > button {
    min-height: 68px;
    grid-template-columns: 36px minmax(0, 1fr);
    gap: 9px;
    padding: 10px;
  }
  .register-page.is-metadata-step .metadata-registration-substeps > button > span:first-child {
    width: 36px;
    height: 36px;
  }
  .register-page.is-metadata-step .metadata-registration-substeps > button small,
  .register-page.is-metadata-step .metadata-registration-substeps > button em {
    display: none;
  }
  .register-page.is-metadata-step .metadata-registration-substeps > button strong {
    font-size: 13px;
    line-height: 1.35;
  }
  .register-page.is-metadata-step .metadata-stage-breadcrumb {
    width: calc(100% - 16px);
  }
}
/* 저장 자료 공통 메타데이터: 선택한 행 바로 아래에서 검수한다. */
.saved-review-field-table-wrap.has-inline-detail {
  max-height: none;
  overflow-x: auto;
  overflow-y: visible;
}

.saved-review-field-table tbody tr.saved-review-inline-detail-row {
  cursor: default;
  background: #f7faf9;
  box-shadow: inset 0 -1px 0 #cfdcd8;
}
.saved-review-field-table tbody tr.saved-review-inline-detail-row:hover {
  background: #f7faf9;
}
.saved-review-field-table tbody tr.saved-review-inline-detail-row > td {
  height: auto;
  overflow: visible;
  border-bottom: 1px solid #cbd9d5;
  padding: 0;
  text-overflow: clip;
  white-space: normal;
}
.saved-review-field-table tbody tr.is-active:has(+ .saved-review-inline-detail-row) {
  border-bottom-color: transparent;
  box-shadow: inset 0 0 0 1px #6b9c90;
}

.saved-review-inline-editor {
  min-height: 0;
  overflow: visible;
  padding: 16px 18px 18px;
  border-left: 3px solid #2f7966;
  background: #f7faf9;
  animation: saved-review-inline-open 160ms ease-out both;
}

@keyframes saved-review-inline-open {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@media (max-width: 720px) {
  .saved-review-field-table-wrap.has-inline-detail {
    max-height: none;
  }
  .saved-review-inline-editor {
    padding: 14px 13px 16px;
  }
  .saved-review-hierarchy-values > header {
    flex-direction: column;
  }
  .saved-review-hierarchy-toolbar {
    grid-template-columns: 1fr;
  }
}`],
})
export class PortalPostDetailComponent implements OnInit, OnDestroy {
    public id: string = '';
    public tab: string = 'view';
    public data: any = null;
    public saving: boolean = false;

    public tabs: any[] = [
        { key: 'view', label: '자료 상세' },
        { key: 'entities', label: '개체명·연계정보' },
        { key: 'settings', label: '설정' },
    ];
    public entitySearch: string = '';
    public entityTypeFilter: string = 'all';
    public entityStatusFilter: string = 'all';
    public entityLinkFilter: string = 'all';
    public entityPage: number = 1;
    public readonly entityPageSize: number = 15;
    public selectedEntityRecord: any = null;
    public entityReviewEditing: boolean = false;
    public entityReviewSaving: boolean = false;
    public entityReviewDraft: any = {
        type: 'OTHER',
        normalized: '',
        kg_id: '',
        link_status: 'unlinked',
        review_disposition: 'needs_review',
        duplicate_of_entity_id: '',
        reason: '',
    };
    public entityOccurrenceCounts: any = {};
    private savedEntityDeletionSnapshots: any = {};

    public registerSteps: any[] = [
        { key: 'upload', order: '01', label: '파일 선택 및 원본 분석', description: '실제 원본·형식·Profile 확정' },
        { key: 'metadata', order: '02', label: '메타정보 등록 및 검수', description: '공개 설정·공통 메타데이터 확정' },
        { key: 'complete', order: '03', label: '최종 확인 및 자료함 등록', description: '확정 결과·오류·경고 확인 후 등록' },
    ];
    public registerStep: RegisterStepKey = 'upload';
    public metadataSection: MetadataSectionKey = 'visibility';
    public readonly deferredRegistrationReviewStagesVisible: boolean = false;
    public visibilitySearch: string = '';
    public visibilityStatusFilter: 'all' | 'published' | 'draft' | 'unset' = 'all';
    public selectedVisibilityKeys: string[] = [];
    private selectedVisibilityKeySet: Set<string> = new Set<string>();
    private selectedVisibilityKeySetSource: string[] = this.selectedVisibilityKeys;
    private visibilitySelectionRenderQueued: boolean = false;
    public visibilityPage: number = 1;
    public readonly visibilityPageSize: number = 10;
    public visibilityInspectorOpen: boolean = true;
    public selectedVisibilityInspectorIndex: number | null = null;
    public metadataV21FieldName: string = 'title';
    public xmlReviewSourceOpen: boolean = false;
    public xmlReviewActiveFieldId: string = '';
    public savedXmlSourceOpen: boolean = false;
    public detailDescriptionExpanded: boolean = false;
    public savedDetailSection: 'overview' | 'audit' | 'translation' = 'overview';
    public savedReviewSection: SavedReviewSectionKey = 'metadata';
    public readonly hiddenSavedReviewStageKeys: SavedReviewSectionKey[] = [
        'scope', 'content', 'relations',
    ];
    public savedReviewSaving: boolean = false;
    public savedReviewDirty: boolean = false;
    public savedReviewSavedAt: string = '';
    public savedReviewNotice: string = '';
    public savedReviewActionsOpen: boolean = false;
    public savedReviewFiles: any[] = [];
    public savedReviewFilesLoading: boolean = false;
    public savedReviewFilesError: string = '';
    public savedReviewFileNavigating: boolean = false;
    public savedReviewFileMenuOpen: boolean = false;
    public savedReviewFileSearch: string = '';
    public savedReviewMetadataAllItems: boolean = false;
    public savedReviewSourceFullText: string = '';
    public savedReviewSourceLoaded: boolean = false;
    public savedReviewSourceLoading: boolean = false;
    public savedReviewSourceError: string = '';
    public savedImageAssets: any = {
        total: 0, ready: 0, missing: 0, failed: 0,
        page: 1, page_size: 24, pages: 1, items: [],
    };
    public savedImageAssetsLoading: boolean = false;
    public savedImageAssetsError: string = '';
    public savedImageAssetMaterializing: any = {};
    private savedImageAssetAutoRequestedPages: any = {};
    public savedImageAssetAutoActiveCount: number = 0;
    private readonly savedImageAssetAutoBatchSize: number = 1;
    public pendingImageAssetMaterializing: any = {};
    public pendingImageAssetsError: string = '';
    public itemRegistry: any = null;
    public itemRegistryLoading: boolean = false;
    public itemRegistryError: string = '';
    public itemRegistryView: 'manifestations' | 'compare' | 'alignments' = 'manifestations';
    public itemRegistrySelectedRelationId: string = '';
    public itemRegistryAlignmentType: 'all' | 'entity' | 'term' | 'link' = 'all';
    public itemRegistrySavingId: string = '';
    public itemRegistryBulkApproving: boolean = false;
    public itemRegistrySourceWindows: any = {};
    public itemRegistrySourceQueries: any = {};
    public itemRegistrySelectedAlignmentId: string = '';
    public itemRegistrySourceLoading: boolean = false;
    public itemRegistrySourceError: string = '';
    public savedEntityExtracting: boolean = false;
    public savedEntityProgress: any = null;
    public savedContentReviewChecks: any = {};
    public savedContentReviewReasons: any = {};
    public savedContentReviewRequiredKeys: string[] = [];
    public readonly savedContentReviewSectionKeys: string[] = [
        'source', 'toc', 'images', 'entities',
    ];
    public readonly eraOptions: string[] = [
        '선사', '고대', '고려', '조선', '근대', '현대', '통사', '기타',
    ];
    public savedDtdActionState: SavedDtdActionState = 'idle';
    public savedDtdActionLabel: string = '';
    public savedDtdActionMessage: string = '';
    public savedDtdActionTotal: number = 0;
    public savedDtdActionCompleted: number = 0;
    public savedDtdOccurrenceFieldId: string = '';
    public savedDtdOccurrenceItems: any[] = [];
    public savedDtdOccurrencePage: number = 1;
    public savedDtdOccurrencePages: number = 1;
    public savedDtdOccurrenceTotal: number = 0;
    public savedDtdOccurrenceQuery: string = '';
    public savedDtdOccurrenceLoading: boolean = false;
    public savedDtdOccurrenceError: string = '';
    private savedDtdOccurrenceRequestToken: number = 0;
    public savedHierarchyUnits: any[] = [];
    public savedHierarchyTotal: number = 0;
    public savedHierarchyPage: number = 1;
    public readonly savedHierarchyPageSize: number = 50;
    public savedHierarchyQuery: string = '';
    public savedHierarchyLevel: string = 'all';
    public savedHierarchyLoading: boolean = false;
    public savedHierarchyError: string = '';
    private savedHierarchyLoadedKey: string = '';
    private savedHierarchyRequestToken: number = 0;
    private savedReviewHydrated: boolean = false;
    private savedReviewAutosaveTimer: any = null;
    private savedReviewMutationVersion: number = 0;
    private readonly savedReviewAutosaveDelayMs: number = 1200;
    public metadataValueModalOpen: boolean = false;
    public metadataValueModalFieldLabel: string = '';
    public metadataValueModalValueLabel: string = '';
    public metadataValueModalValue: string = '';
    public metadataValueModalContext: string = '';
    public metadataReviewFilter: 'all' | 'primary' | 'attention' = 'attention';
    public metadataReviewFileFilter: MetadataReviewFileFilter = 'all';
    public metadataReviewQueueSearch: string = '';
    public metadataReviewFilePage: number = 1;
    public readonly metadataReviewFilePageSize: number = 10;
    public metadataAdvanceMode: MetadataAdvanceMode = 'all';
    public metadataAdvanceSelectionKeys: string[] = [];
    public metadataDraftNotice: string = '';
    public metadataStrategyChanging: boolean = false;
    public metadataHierarchyReviewChanging: boolean = false;
    public metadataReviewScopeMode: 'representative' | 'hierarchy' = 'representative';
    public metadataHierarchySearch: string = '';
    public metadataHierarchyOverviewSearch: string = '';
    public metadataHierarchyOverviewPage: number = 1;
    public readonly metadataHierarchyOverviewPageSize: number = 20;
    public metadataHierarchyActiveUnitIds: any = {};
    public dtdCoverageActiveGroup: string = '';
    public dtdReviewActiveFieldId: string = '';
    public dtdReviewFilter: 'all' | 'attention' = 'attention';
    public dtdReviewSearch: string = '';
    public savedDtdGroupFilter: string = 'all';
    public savedDtdShowAllGroups: boolean = false;
    public reviewSection: ReviewSectionKey = '';
    public reviewTextPage: number = 1;
    public readonly reviewTextPageSize: number = 8;
    public reviewTextSearch: string = '';
    public reviewTextAttentionOnly: boolean = false;
    public reviewTranslationPage: number = 1;
    public readonly reviewTranslationPageSize: number = 6;
    public reviewTranslationCandidateExpandedIndex: number = -1;
    public multilingualSegmentProcessingIndex: number | null = null;
    public reviewAttentionMenuOpen: boolean = false;
    public reviewParagraphIndex: number = 0;
    public reviewParagraphDraft: string = '';
    public registrationEntitySearch: string = '';
    public registrationEntityStatus: string = 'all';
    public registrationEntityPage: number = 1;
    public readonly registrationEntityPageSize: number = 12;
    public registrationEntityIndex: number = 0;
    public metadataSections: any[] = [
        { key: 'visibility', order: '01', label: '공개 및 운영 설정', description: '파일별 공개 여부와 접근 조건' },
        { key: 'bibliography', order: '02', label: '공통 메타데이터 검수', description: '10개 공통 필드의 값·근거 확정' },
    ];
    public reviewSections: any[] = [];
    public documentProfileChanging: boolean = false;
    public uploadFileName: string = '';
    public uploadSourceType: 'file' | 'url' | 'incremental' = 'file';
    public xmlUrl: string = '';
    public xmlUrls: string[] = [];
    public metaRecognizing: boolean = false;
    public analysisId: string = '';
    public analysisInfo: any = null;
    public analysisError: string = '';
    public recoveryNotice: string = '';
    public recoveryRestoring: boolean = false;
    public recoveryModalOpen: boolean = false;
    public recoveryModalState: RecoveryModalState = 'prompt';
    public recoveryModalPercent: number | null = null;
    public recoveryStageLabel: string = '작업 정보 확인 중';
    public recoveryStageDetail: string = '복구할 작업과 마지막 저장 시점을 확인합니다.';
    public recoveryCurrentStage: string = '';
    public recoveryErrorMessage: string = '';
    public registrationWorkspaceId: string = '';
    public registrationWorkspaceSourceCount: number = 0;
    public registrationWorkspaceSavedAt: string = '';
    public registrationWorkspaceSavedBy: string = '';
    public registrationWorkspaceRevision: string = '';
    public registrationWorkspaceStatus: 'idle' | 'saving' | 'saved' | 'error' = 'idle';
    public registrationWorkspaceMessage: string = '';
    public registrationWorkspaceLegacy: boolean = false;
    public registrationOriginalArchiveId: string = '';
    public registrationOriginalArchiveSourceCount: number = 0;
    public registrationOriginalArchiveAt: string = '';
    public registrationOriginalArchiveBy: string = '';
    public registrationOriginalArchiveStatus: 'idle' | 'saving' | 'verified' | 'partial' | 'error' = 'idle';
    public registrationOriginalArchiveMessage: string = '';
    public manualChecks: string[] = ['저신뢰 OCR', '서지정보', '표·그림·주석 영역', '다국어 용어·번역', '자동 요약', '개체명', '공개 상태'];
    public uploadFiles: File[] = [];
    public filePreflights: any[] = [];
    public filePreflightRunning: boolean = false;
    public uploadSelectionNotice: string = '';
    public sourceSelectionPage: number = 1;
    public readonly sourceSelectionPageSize: number = 10;
    public uploadQueueSearch: string = '';
    public uploadQueueFilter: 'all' | 'attention' | 'ready' | 'preserved' = 'all';
    public selectedUploadInspectorIndex: number | null = null;
    public uploadInspectorOpen: boolean = true;
    public analysisQueueSearch: string = '';
    public analysisQueueFilter: 'all' | 'attention' | 'active' | 'ready' = 'all';
    public analysisQueuePage: number = 1;
    public readonly analysisQueuePageSize: number = 50;
    public selectedAnalysisInspectorIndex: number | null = null;
    public analysisInspectorOpen: boolean = typeof window === 'undefined'
        ? true : window.innerWidth > 1320;
    public batchSourceReplacementRunning: boolean = false;
    public batchSourceReplacementTargetIndex: number = -1;
    public batchSourceReplacementLocks: { [key: number]: boolean } = {};
    public readonly maxActiveBatchFiles: number = 100;
    public completedRegistrationCount: number = 0;
    public selectedRegistrationSourceCount: number = 0;
    public processedRegistrationSourceCount: number = 0;
    public registrationAnalysisSources: any[] = [];
    public batchItems: any[] = [];
    public retryProgress: any = {
        status: 'idle',
        total: 0,
        completed: 0,
        succeeded: 0,
        failed: 0,
        currentBatchIndex: -1,
        currentOrder: 0,
        currentName: '',
        stage: '',
        detail: '',
        indeterminate: false,
    };
    public analysisDetailOpen: { [key: number]: boolean } = {};
    public activeBatchIndex: number = -1;
    public aiSettings: any = null;
    public aiSettingsAdmin: boolean = false;
    public settingsSaving: boolean = false;
    public entityDictionaryText: string = '';
    public historicalTermDictionaryText: string = '';
    public materialTypeOptions: string[] = ['도서', '문서', '지도', '사진·영상', '유물·유적', '연구성과', '법령', '기타'];
    public provenanceTypeOptions: any[] = [
        { value: 'direct_upload', label: '직접 업로드' },
        { value: 'external_crawl', label: '외부 사이트 수집' },
        { value: 'donation', label: '기증' },
        { value: 'migration', label: '기존 데이터 이관' },
        { value: 'other', label: '기타' },
    ];
    public accountMenuOpen: boolean = false;
    public uploadDragging: boolean = false;
    public syncLoading: boolean = false;
    public syncSaving: boolean = false;
    public syncRunningId: string = '';
    public syncSources: any[] = [];
    public syncHistory: any[] = [];
    public deletionHistory: any[] = [];
    public syncSummary: any = { total: 0, enabled: 0, attention: 0, last_run: '' };
    public syncMethod: any = null;
    public syncHistoryTab: 'collection' | 'deletion' = 'collection';
    public syncForm: any = this.emptySyncForm();
    public layoutDetailsOpen: boolean = false;
    public layoutRegionFilter: 'all' | 'table' | 'figure' | 'annotation' = 'all';
    public layoutRegionPage: number = 1;
    public selectedLayoutRegionId: string = '';
    public layoutPreviewLoadingId: string = '';
    public layoutPreviewError: string = '';
    public layoutRefreshing: boolean = false;
    public multilingualProcessing: boolean = false;
    public multilingualProgress: any = {
        status: 'idle', stage: '', label: '', detail: '',
        completed_steps: 0, total_steps: 1, percent: 0,
    };
    public multilingualViewerOpen: boolean = false;
    public selectedTranslationPage: number = 0;
    public translationRailCollapsed: boolean = false;
    public translationMobilePane: 'source' | 'translation' = 'source';
    public translationPdfState: 'idle' | 'loading' | 'ready' | 'missing' | 'error' = 'idle';
    public translationPdfError: string = '';
    public translationPdfPreview: string = '';
    public translationPdfPageCache: any = {};
    public translationPdfRequestId: number = 0;
    public ocrReviewUnit: 'word' | 'character' = 'word';
    public ocrReviewFilter: 'low' | 'all' = 'low';
    public ocrMobilePane: 'source' | 'ocr' = 'source';
    public selectedOcrCandidate: any = null;
    public ocrCorrectionValue: string = '';
    public ocrModalOpen: boolean = false;
    public ocrPageNumber: number = 1;
    public ocrPageLoading: boolean = false;
    public ocrPageError: string = '';
    public ocrPagePreview: string = '';
    public ocrPageOriginalText: string = '';
    public ocrPageDraftText: string = '';
    public ocrPageConfidence: number | null = null;
    public ocrPageCache: any = {};
    public ocrSavedPages: any = {};
    public reviewFileFilter: 'all' | 'attention' = 'all';
    public autoSaveState: 'idle' | 'pending' | 'saving' | 'saved' | 'error' = 'idle';
    public autoSaveSavedAt: string = '';
    public autoSaveMessage: string = '변경 내용은 자동 저장됩니다.';
    public technicalErrorDetails: string = '';
    public technicalErrorOpen: boolean = false;
    public partialRegistrationConfirmed: boolean = false;
    public finalRegistrationAgreement: boolean = false;
    public registrationCompletionFinalized: boolean = false;
    public registrationPreflightLoading: boolean = false;
    public registrationSubmitting: boolean = false;
    private registrationCommitPreflightPrepared: boolean = false;
    private registrationDraftSyncFailures: any[] = [];
    private registrationDraftSyncError: any = null;
    public registrationProcessingOpen: boolean = false;
    public registrationPreflightRequestId: string = '';
    public registrationResults: any[] = [];
    public finalRegistrationPage: number = 1;
    public readonly finalRegistrationPageSize: number = 4;
    public finalRegistrationConfirmOpen: boolean = false;
    public overwriteConfirmOpen: boolean = false;
    public overwriteConfirmFileName: string = '';
    public overwriteConfirmFileMeta: string = '';
    public overwriteConfirmMode: 'single' | 'bulk' = 'single';
    public overwriteConfirmCount: number = 1;
    public bulkOverwriteRunning: boolean = false;
    public bulkOverwriteTotal: number = 0;
    public bulkOverwriteCompleted: number = 0;
    public bulkOverwriteSucceeded: number = 0;
    public bulkOverwriteFailed: number = 0;
    public filePreflightReleaseRunning: boolean = false;
    public registrationSaveErrorOpen: boolean = false;
    public registrationSaveRetrying: boolean = false;
    public registrationSaveError: any = {
        title: '자료함 저장을 완료하지 못했습니다',
        message: '',
        cause: '',
        prevention: '',
        errorCode: '',
        stage: '',
        userAction: '',
        fileName: '',
        requestId: '',
        retryable: true,
        targetIndex: -1,
        failedCount: 1,
    };
    public registrationProgress: any = {
        status: 'idle',
        stage: '',
        label: '',
        completed: 0,
        total: 0,
        percent: 0,
    };
    private finalReviewReturnState: any = null;
    private finalRegistrationConfirmResolver: ((confirmed: boolean) => void) | null = null;
    private overwriteConfirmResolver: ((confirmed: boolean) => void) | null = null;
    private overwriteConfirmReturnFocus: HTMLElement | null = null;
    public weekdays: any[] = [
        { value: 0, label: '월요일' },
        { value: 1, label: '화요일' },
        { value: 2, label: '수요일' },
        { value: 3, label: '목요일' },
        { value: 4, label: '금요일' },
        { value: 5, label: '토요일' },
        { value: 6, label: '일요일' },
    ];

    private basePath: string = '/posts';
    private libraryPath: string = '/home';
    private routerSub: any;
    private uploadFile: File | null = null;
    private navigationBypass: boolean = false;
    private exitConfirmationPromise: Promise<boolean> | null = null;
    private exitConfirmationResolver: ((confirmed: boolean) => void) | null = null;
    public exitDialogOpen: boolean = false;
    public exitDialogFileCount: number = 0;
    public exitDialogProcessing: boolean = false;
    public exitDialogSaving: boolean = false;
    public exitDialogDiscarding: boolean = false;
    private exitNavigationTarget: string = '';
    private exitNavigationScheduled: boolean = false;
    private syncFormBaseline: string = '';
    private layoutRegionsPerPage: number = 8;
    private layoutRefreshAttemptedId: string = '';
    private pendingWorkGuard = (targetUrl: string = '') => (
        this.canLeavePendingWork(targetUrl)
    );
    public readonly maxBatchFiles: number = 1000;
    private readonly analysisWorkerConcurrency: number = 2;
    private readonly duplicatePreflightConcurrency: number = 4;
    private readonly registrationPreflightConcurrency: number = 4;
    private readonly registrationSaveConcurrency: number = 4;
    private readonly duplicateVersionCheckboxReason: string = (
        '관리자 체크박스 선택으로 새 버전 등록'
    );
    private readonly registrationRecoveryBatchSize: number = 1;
    private readonly registrationRecoveryDetailConcurrency: number = 4;
    private readonly maxBackpressureRetries: number = 360;
    private recoveryTimer: any = null;
    private recoverySaveTimer: any = null;
    private analysisProgressRenderTimer: any = null;
    private recoverySaving: boolean = false;
    private recoverySavePending: boolean = false;
    private recoverySaveCompletion: Promise<void> = Promise.resolve();
    private resolveRecoverySaveCompletion: (() => void) | null = null;
    private registrationWorkspaceSaving: boolean = false;
    private registrationWorkspaceSaveQueue: Promise<void> = Promise.resolve();
    private registrationWorkspaceSaveQueueDepth: number = 0;
    private registrationAnalysisSourcesWorkspaceId: string = '';
    private routedRegistrationWorkspaceId: string = '';
    private registrationRouteRedirecting: boolean = false;
    private registrationRouteLoading: boolean = false;
    private registrationPreflightDraftWorkTotal: number = 0;
    private registrationPreflightCandidateWorkTotal: number = 0;
    private recoveryDraftHashes: any = {};
    private recoverySnapshot: any = null;
    private recoveryAttemptPromise: Promise<void> | null = null;
    private recoveryMonitorPromise: Promise<void> | null = null;
    private recoveryHydrationPromise: Promise<void> | null = null;
    private recoveryDestroyed: boolean = false;
    private analysisCancellationRequested: boolean = false;
    private analysisBatchStartedAt: number = 0;
    private analysisBatchFinishedAt: number = 0;
    private readonly recoveryPollIntervalMs: number = 1500;
    private readonly recoveryTimeoutMs: number = 2 * 60 * 1000;
    private readonly analysisProgressRenderIntervalMs: number = 100;
    private filePreflightTaskCount: number = 0;
    private filePreflightRowTasks = new WeakMap<object, Promise<void>>();

    constructor(@Inject( Service)         public service: Service,@Inject( Router)         private router: Router,    ) {
        this.id = this.routeId();
        this.tab = this.routeTab(this.id);
        this.routedRegistrationWorkspaceId = this.routeWorkspaceId();
        this.syncFormBaseline = this.syncFormSnapshot(this.syncForm);
    }

    private async runBounded<T>(
        rows: T[], concurrency: number,
        task: (row: T, index: number) => Promise<void>,
    ) {
        let cursor = 0;
        const workerCount = Math.min(
            Math.max(1, Math.floor(concurrency || 1)),
            rows.length,
        );
        const workers = Array.from({ length: workerCount }, async () => {
            while (cursor < rows.length) {
                const index = cursor;
                cursor += 1;
                await task(rows[index], index);
            }
        });
        await Promise.all(workers);
    }

    private beginFilePreflightTask() {
        this.filePreflightTaskCount += 1;
        this.filePreflightRunning = true;
    }

    private endFilePreflightTask() {
        this.filePreflightTaskCount = Math.max(
            0,
            this.filePreflightTaskCount - 1,
        );
        this.filePreflightRunning = this.filePreflightTaskCount > 0;
    }

    public async ngOnInit() {
        await this.service.init();
        const authenticated = await this.service.auth.check();
        if (!authenticated) {
            location.href = '/login';
            return;
        }

        this.routerSub = this.router.events.subscribe(async (event) => {
            if (event instanceof NavigationEnd) {
                const newId = this.routeId();
                if (
                    newId !== 'new'
                    && `${WizRoute.segment.tab || ''}` === 'edit'
                ) {
                    this.service.href(`${this.basePath}/${newId}/view`);
                    return;
                }
                const newTab = this.routeTab(newId);
                const newWorkspaceIdRaw = this.routeWorkspaceIdRaw();
                const newWorkspaceId = this.routeWorkspaceId();

                if (this.registrationRouteRedirecting) return;

                if (newId && newId !== this.id) {
                    this.id = newId;
                    this.tab = newTab;
                    this.routedRegistrationWorkspaceId = newWorkspaceId;
                    if (this.isRegistrationMode()) {
                        if (newWorkspaceIdRaw) {
                            await this.initialiseRegistrationWorkspaceRoute(newWorkspaceIdRaw);
                        } else {
                            await this.bootstrapRegistrationWorkspaceRoute();
                        }
                    } else {
                        await this.load();
                    }
                } else if (newWorkspaceId !== this.routedRegistrationWorkspaceId) {
                    this.suspendRegistrationRecoveryWrites();
                    this.persistRegistrationRecovery();
                    await this.registrationWorkspaceSaveQueue;
                    this.routedRegistrationWorkspaceId = newWorkspaceId;
                    this.tab = newTab;
                    if (this.isRegistrationMode()) {
                        if (newWorkspaceIdRaw) {
                            await this.initialiseRegistrationWorkspaceRoute(newWorkspaceIdRaw);
                        } else {
                            await this.bootstrapRegistrationWorkspaceRoute();
                        }
                    }
                } else if (newTab !== this.tab) {
                    this.tab = newTab;
                    await this.service.render();
                }
            }
        });

        if (
            !this.isNewPost()
            && `${WizRoute.segment.tab || ''}` === 'edit'
        ) {
            this.service.href(`${this.basePath}/${this.id}/view`);
            return;
        }

        if (!this.isNewPost() && !WizRoute.segment.tab) {
            this.service.href(`${this.basePath}/${this.id}/view`);
            return;
        }

        if (this.isRegistrationMode()) {
            const workspaceIdRaw = this.routeWorkspaceIdRaw();
            if (!workspaceIdRaw) {
                await this.bootstrapRegistrationWorkspaceRoute();
                return;
            }
            await this.initialiseRegistrationWorkspaceRoute(workspaceIdRaw);
            return;
        }
        await this.load();
    }

    public ngOnDestroy() {
        this.recoveryDestroyed = true;
        if (this.overwriteConfirmResolver) {
            this.overwriteConfirmResolver(false);
            this.overwriteConfirmResolver = null;
        }
        this.overwriteConfirmReturnFocus = null;
        if (this.exitConfirmationResolver) {
            this.exitConfirmationResolver(false);
            this.exitConfirmationResolver = null;
        }
        if (this.routerSub) this.routerSub.unsubscribe();
        if (this.recoveryTimer) clearInterval(this.recoveryTimer);
        if (this.recoverySaveTimer) clearTimeout(this.recoverySaveTimer);
        if (this.savedReviewAutosaveTimer) {
            clearTimeout(this.savedReviewAutosaveTimer);
            this.savedReviewAutosaveTimer = null;
        }
        if (this.analysisProgressRenderTimer) {
            clearTimeout(this.analysisProgressRenderTimer);
            this.analysisProgressRenderTimer = null;
        }
        this.persistRegistrationRecovery();
        this.uninstallPendingWorkGuard();
    }

    public isNewPost() {
        return this.id === 'new';
    }

    public isRegistrationMode() {
        return this.isNewPost() && this.tab === 'edit';
    }

    private installPendingWorkGuard() {
        if (
            !this.isRegistrationMode()
            && (this.isNewPost() || this.tab !== 'view')
        ) return;
        (window as any).__wizPendingWorkGuard = this.pendingWorkGuard;
    }

    private uninstallPendingWorkGuard() {
        const host = window as any;
        if (host.__wizPendingWorkGuard === this.pendingWorkGuard) delete host.__wizPendingWorkGuard;
    }

    private registrationRecoveryOwnerKey() {
        const session = this.service.auth.session || {};
        return String(session.id || session.email || 'anonymous')
            .replace(/[^A-Za-z0-9_-]/g, '_');
    }

    private legacyRegistrationRecoveryKey() {
        return 'post-registration-recovery-v2:' + this.registrationRecoveryOwnerKey();
    }

    private legacyActiveRegistrationRecoveryKey() {
        return 'post-registration-recovery-active-v1:' + this.registrationRecoveryOwnerKey();
    }

    private registrationRecoveryKey(workspaceId: string = this.registrationWorkspaceId) {
        const normalised = this.normaliseRegistrationWorkspaceId(workspaceId);
        if (!normalised) return this.legacyRegistrationRecoveryKey();
        return `post-registration-recovery-v3:${this.registrationRecoveryOwnerKey()}:${normalised}`;
    }

    private activeRegistrationRecoveryKey(workspaceId: string = this.registrationWorkspaceId) {
        const normalised = this.normaliseRegistrationWorkspaceId(workspaceId);
        if (!normalised) return this.legacyActiveRegistrationRecoveryKey();
        return `post-registration-recovery-active-v2:${this.registrationRecoveryOwnerKey()}:${normalised}`;
    }

    private migrateLegacyRegistrationRecoverySnapshot(workspaceId: string) {
        const normalised = this.normaliseRegistrationWorkspaceId(workspaceId);
        if (!normalised) return null;
        try {
            const legacyKey = this.legacyRegistrationRecoveryKey();
            const legacySnapshot = JSON.parse(localStorage.getItem(legacyKey) || 'null');
            if (
                !legacySnapshot
                || this.normaliseRegistrationWorkspaceId(legacySnapshot.workspace_id) !== normalised
            ) return null;
            localStorage.setItem(
                this.registrationRecoveryKey(normalised),
                JSON.stringify(legacySnapshot),
            );
            const legacyActiveKey = this.legacyActiveRegistrationRecoveryKey();
            const legacyActive = JSON.parse(localStorage.getItem(legacyActiveKey) || 'null');
            if (
                legacyActive
                && legacyActive.signature === this.registrationRecoverySignature(legacySnapshot)
            ) {
                localStorage.setItem(
                    this.activeRegistrationRecoveryKey(normalised),
                    JSON.stringify(legacyActive),
                );
                localStorage.removeItem(legacyActiveKey);
            }
            localStorage.removeItem(legacyKey);
            return legacySnapshot;
        } catch (_) {
            return null;
        }
    }

    private registrationRecoverySignature(snapshot: any) {
        const items = Array.isArray(snapshot && snapshot.items) ? snapshot.items : [];
        return [
            Number(snapshot && snapshot.saved_at || 0),
            ...items.map((item: any) => `${item.analysis_id || ''}:${item.progress_id || ''}`),
            ...(Array.isArray(snapshot && snapshot.xml_urls) ? snapshot.xml_urls : []),
        ].join('|');
    }

    private readActiveRegistrationRecovery(snapshot: any) {
        try {
            const active = JSON.parse(localStorage.getItem(this.activeRegistrationRecoveryKey()) || 'null');
            if (!active || active.signature !== this.registrationRecoverySignature(snapshot)) return null;
            const startedAt = Number(active.started_at || 0);
            if (!startedAt) return null;
            return { startedAt };
        } catch (_) {
            return null;
        }
    }

    private markActiveRegistrationRecovery(snapshot: any, startedAt: number = Date.now()) {
        try {
            localStorage.setItem(this.activeRegistrationRecoveryKey(), JSON.stringify({
                signature: this.registrationRecoverySignature(snapshot),
                started_at: startedAt,
            }));
        } catch (_) { }
        return startedAt;
    }

    private clearActiveRegistrationRecovery() {
        try {
            localStorage.removeItem(this.activeRegistrationRecoveryKey());
        } catch (_) { }
    }

    private startRegistrationRecovery() {
        if (this.recoveryTimer) clearInterval(this.recoveryTimer);
        this.recoveryTimer = setInterval(() => {
            if (
                this.registrationSubmitting
                || this.registrationPreflightLoading
                || this.saving
            ) return;
            this.persistRegistrationRecovery();
            void this.flushRegistrationRecoveryDrafts();
            void this.saveRegistrationWorkspace();
        }, 10000);
    }

    private queueRegistrationRecoverySave() {
        if (!this.isRegistrationMode()) {
            if (!this.isNewPost() && this.savedReviewHydrated) {
                this.markSavedReviewDirty();
            }
            return;
        }
        if (this.recoveryRestoring) return;
        if (this.activeBatchIndex >= 0 && this.batchItems[this.activeBatchIndex] && this.data) {
            const activeItem = this.batchItems[this.activeBatchIndex];
            activeItem.form = this.cloneForm(this.data);
            this.captureRegistrationLocalDraft(activeItem, activeItem.form);
        }
        this.autoSaveState = 'pending';
        this.autoSaveMessage = '변경 내용 저장 대기 중';
        this.persistRegistrationRecovery();
        if (this.recoverySaveTimer) clearTimeout(this.recoverySaveTimer);
        this.recoverySaveTimer = setTimeout(() => {
            this.recoverySaveTimer = null;
            if (
                this.registrationSubmitting
                || this.registrationPreflightLoading
                || this.saving
            ) return;
            void this.flushRegistrationRecoveryDrafts();
            void this.saveRegistrationWorkspace();
        }, 1200);
    }

    private ensureRegistrationWorkspaceId() {
        if (!this.registrationWorkspaceId) {
            this.registrationWorkspaceId = this.createProgressId();
        }
        return this.registrationWorkspaceId;
    }

    private registrationWorkspaceBootstrapSnapshot() {
        return {
            version: 10,
            workspace_id: '',
            workspace_revision: '',
            saved_at: Date.now(),
            analysis_batch_started_at: 0,
            analysis_batch_finished_at: 0,
            completed_registration_count: 0,
            selected_source_count: 0,
            processed_source_count: 0,
            register_step: 'upload',
            metadata_section: 'visibility',
            review_section: '',
            active_index: -1,
            metadata_advance_mode: 'all',
            metadata_advance_selection_keys: [],
            upload_source_type: 'file',
            xml_urls: [],
            queued_sources: [],
            items: [],
        };
    }

    private registrationWorkspaceRouteUrl(workspaceId: string) {
        return `${this.basePath}/new/${workspaceId}/edit`;
    }

    private async createRegistrationWorkspace() {
        try {
            const snapshot = this.registrationWorkspaceBootstrapSnapshot();
            const result = await wiz.call('analyze', {
                mode: 'registration_workspace_save',
                workspace_id: '',
                snapshot: JSON.stringify(snapshot),
            });
            const workspace = result?.data?.workspace;
            const workspaceId = this.normaliseRegistrationWorkspaceId(
                workspace?.workspace_id,
            );
            if (!result || result.code !== 200 || !workspace || !workspaceId) {
                throw new Error(
                    result?.data?.message || '새 등록 작업공간을 만들지 못했습니다.'
                );
            }
            return workspace;
        } catch (error) {
            const captured = this.captureError(
                error,
                '새 등록 작업공간을 만들지 못했습니다.',
            );
            this.registrationWorkspaceStatus = 'error';
            this.registrationWorkspaceMessage = captured.message;
            return null;
        }
    }

    private async replaceRegistrationWorkspaceRoute(workspaceId: string) {
        const normalised = this.normaliseRegistrationWorkspaceId(workspaceId);
        if (!normalised) return false;
        const previousWorkspaceId = this.normaliseRegistrationWorkspaceId(
            this.routedRegistrationWorkspaceId || this.routeWorkspaceId(),
        );
        const initialiseInPlace = !!(
            previousWorkspaceId
            && previousWorkspaceId !== normalised
        );
        this.registrationRouteRedirecting = true;
        this.navigationBypass = true;
        this.uninstallPendingWorkGuard();
        let navigated = false;
        try {
            navigated = await this.router.navigateByUrl(
                this.registrationWorkspaceRouteUrl(normalised),
                { replaceUrl: true },
            );
            // Angular reuses the canonical page component when only
            // :workspaceId changes. Its NavigationEnd handler is deliberately
            // suppressed during this guarded replacement, so initialise the
            // new workspace explicitly instead of leaving the old component
            // bound to the new URL.
            if (navigated && initialiseInPlace && !this.recoveryDestroyed) {
                this.registrationRouteRedirecting = false;
                this.navigationBypass = false;
                return await this.initialiseRegistrationWorkspaceRoute(
                    normalised,
                );
            }
            return navigated;
        } catch (_) {
            return false;
        } finally {
            if (!navigated) {
                this.registrationRouteRedirecting = false;
                this.navigationBypass = false;
                this.installPendingWorkGuard();
            }
        }
    }

    private async bootstrapRegistrationWorkspaceRoute() {
        if (this.registrationRouteRedirecting) return true;
        let workspace = await this.latestRegistrationWorkspace('');
        if (!workspace) workspace = await this.createRegistrationWorkspace();
        const workspaceId = this.normaliseRegistrationWorkspaceId(
            workspace?.workspace_id,
        );
        if (!workspace || !workspaceId) {
            await this.service.modal.error(
                this.registrationWorkspaceMessage
                || '등록 작업공간을 준비하지 못했습니다. 잠시 후 다시 시도해주세요.'
            );
            return false;
        }
        this.applyRegistrationWorkspaceSummary(workspace);
        const navigated = await this.replaceRegistrationWorkspaceRoute(workspaceId);
        if (!navigated) {
            await this.service.modal.error(
                '등록 작업 주소로 이동하지 못했습니다. 잠시 후 다시 시도해주세요.'
            );
        }
        return navigated;
    }

    private async initialiseRegistrationWorkspaceRoute(workspaceId: string) {
        const normalised = this.normaliseRegistrationWorkspaceId(workspaceId);
        if (!normalised) {
            await this.service.modal.error('등록 작업 주소가 올바르지 않습니다.');
            this.navigationBypass = true;
            this.service.href(this.libraryPath);
            return false;
        }
        if (`${workspaceId || ''}`.trim() !== normalised) {
            return await this.replaceRegistrationWorkspaceRoute(normalised);
        }
        if (this.registrationRouteLoading) return false;
        this.registrationRouteLoading = true;
        this.suspendRegistrationRecoveryWrites();
        this.routedRegistrationWorkspaceId = normalised;
        this.registrationWorkspaceId = normalised;
        this.recoverySnapshot = null;
        this.recoveryModalOpen = false;
        this.recoveryRestoring = false;
        this.recoveryErrorMessage = '';
        try {
            await this.load();
            const workspace = await this.latestRegistrationWorkspace(normalised);
            if (
                !workspace
                || this.normaliseRegistrationWorkspaceId(workspace.workspace_id) !== normalised
            ) {
                throw new Error(
                    '요청한 등록 작업공간을 찾을 수 없거나 접근 권한이 없습니다.'
                );
            }
            if (!['active', 'paused'].includes(`${workspace.state || ''}`)) {
                throw new Error(
                    '이미 완료했거나 종료한 등록 작업입니다. 자료함에서 새 등록을 시작해주세요.'
                );
            }
            this.applyRegistrationWorkspaceSummary(workspace);
            await Promise.all([
                this.loadAISettings(),
                this.loadClassificationOptions(),
            ]);
            this.installPendingWorkGuard();
            await this.offerRegistrationRecovery(workspace);
            this.startRegistrationRecovery();
            return true;
        } catch (error) {
            const captured = this.captureError(
                error,
                '등록 작업공간을 불러오지 못했습니다.',
            );
            this.registrationWorkspaceStatus = 'error';
            this.registrationWorkspaceMessage = captured.message;
            this.uninstallPendingWorkGuard();
            await this.service.modal.error(captured.message);
            this.navigationBypass = true;
            this.service.href(this.libraryPath);
            return false;
        } finally {
            this.registrationRouteLoading = false;
        }
    }

    private isNativeUploadFile(value: any): value is File {
        return !!(
            value
            && typeof value.slice === 'function'
            && typeof value.arrayBuffer === 'function'
            && !value.__registrationPlaceholder
        );
    }

    private registrationSourceIndex(source: any, row: any, fallback: number) {
        const values = [
            row?.sourceIndex,
            source?.__registrationSourceIndex,
            source?.sourceIndex,
            fallback,
        ];
        for (const value of values) {
            const parsed = Number(value);
            if (Number.isInteger(parsed) && parsed >= 0) return parsed;
        }
        return Math.max(0, Number(fallback) || 0);
    }

    private nextRegistrationSourceIndex() {
        const assigned = this.filePreflights
            .map((row: any) => Number(row?.sourceIndex))
            .filter((value: number) => Number.isInteger(value) && value >= 0);
        return Math.max(
            this.processedRegistrationSourceCount - 1,
            ...(assigned.length ? assigned : [-1]),
        ) + 1;
    }

    private registrationQueuedSources() {
        if (this.uploadSourceType === 'url') {
            return this.xmlUrls.map((url: string, index: number) => ({
                source_index: this.processedRegistrationSourceCount + index,
                index: this.processedRegistrationSourceCount + index,
                source_id: '',
                name: url,
                size: 0,
                mime_type: 'application/xml',
                original_hash: '',
                source_url: url,
                staged: true,
                status: 'queued',
            }));
        }
        return this.uploadFiles.map((source: any, index: number) => {
            const row = this.filePreflights[index] || {};
            const sourceIndex = this.registrationSourceIndex(source, row, index);
            const sourceId = `${row.stagedSourceId || source?.stagedSourceId || ''}`;
            const staged = !!(row.staged && sourceId);
            return {
                source_index: sourceIndex,
                index: sourceIndex,
                source_id: staged ? sourceId : '',
                staged_source_id: staged ? sourceId : '',
                requested_source_id: sourceId,
                name: `${source?.name || row.name || ''}`,
                size: Number(source?.size || row.size || 0),
                mime_type: `${source?.type || row.mimeType || 'application/octet-stream'}`,
                last_modified: Number(source?.lastModified || row.lastModified || 0),
                original_hash: `${row.originalHash || source?.originalHash || ''}`,
                staged,
                staged_at: `${row.stagedAt || ''}`,
                staged_by: `${row.stagedBy || ''}`,
                stage_status: `${row.stageStatus || (row.staged ? 'staged' : 'pending')}`,
                stage_error: `${row.stageError || ''}`,
                preflight_status: `${row.status || 'checking'}`,
                duplicate_override_selected: !!row.overrideSelected,
                duplicate_override_confirmed: !!row.overrideConfirmed,
                duplicate_override_reason: `${row.overrideReason || ''}`,
                can_override: !!row.canOverride,
                owned_by_me: row.ownedByMe !== false,
                policy: `${row.policy || ''}`,
                existing: row.existing || null,
                status: 'queued',
            };
        });
    }

    private registrationAnalysisSourceIndex(source: any, fallback: number = -1) {
        const candidates = [
            source?.sourceIndex,
            source?.source_index,
            source?.__registrationSourceIndex,
            source?.index,
            fallback,
        ];
        for (const candidate of candidates) {
            const parsed = Number(candidate);
            if (Number.isInteger(parsed) && parsed >= 0) return parsed;
        }
        return -1;
    }

    private registrationAnalysisSourceKey(source: any, fallback: number = -1) {
        const explicitKey = `${source?.key || ''}`.trim();
        if (explicitKey) return explicitKey;
        const sourceId = `${
            source?.stagedSourceId
            || source?.staged_source_id
            || source?.source_id
            || source?.requested_source_id
            || ''
        }`.trim();
        if (sourceId) return `source-id:${sourceId}`;
        const sourceUrl = `${source?.sourceUrl || source?.source_url || ''}`.trim();
        if (sourceUrl) return `source-url:${sourceUrl}`;
        const sourceIndex = this.registrationAnalysisSourceIndex(source, fallback);
        if (sourceIndex >= 0) return `source-index:${sourceIndex}`;
        return `source-name:${`${source?.name || ''}`.trim()}:${Math.max(0, fallback)}`;
    }

    private registrationAnalysisSourceDescriptor(source: any, fallback: number = -1) {
        const sourceIndex = this.registrationAnalysisSourceIndex(source, fallback);
        const explicitStagedFlag = typeof source?.staged === 'boolean'
            ? source.staged : null;
        const stagedSourceId = `${
            source?.stagedSourceId
            || source?.staged_source_id
            || source?.source_id
            || ''
        }`.trim();
        return {
            key: this.registrationAnalysisSourceKey(source, fallback),
            sourceIndex,
            name: `${source?.name || source?.file_name || `업로드 원본 ${sourceIndex + 1}`}`,
            stagedSourceId,
            requestedSourceId: `${source?.requestedSourceId || source?.requested_source_id || ''}`,
            sourceUrl: `${source?.sourceUrl || source?.source_url || ''}`,
            preflightHash: `${
                source?.preflightHash
                || source?.preflight_hash
                || source?.originalHash
                || source?.original_hash
                || source?.checksum_sha256
                || ''
            }`,
            mimeType: `${source?.mimeType || source?.mime_type || ''}`,
            staged: !!stagedSourceId && explicitStagedFlag !== false,
            stageStatus: `${source?.stageStatus || source?.stage_status || ''}`,
            stageError: `${source?.stageError || source?.stage_error || ''}`,
            preflightStatus: `${source?.preflightStatus || source?.preflight_status || ''}`,
            existing: source?.existing || null,
            sourceFile: source?.sourceFile || null,
            item: source?.item || null,
        };
    }

    private mergeRegistrationAnalysisSources(rows: any[]) {
        const merged = new Map<string, any>();
        this.registrationAnalysisSources.forEach((source: any, index: number) => {
            const descriptor = this.registrationAnalysisSourceDescriptor(source, index);
            merged.set(descriptor.key, { ...descriptor, ...source });
        });
        (Array.isArray(rows) ? rows : []).forEach((source: any, index: number) => {
            if (!source || typeof source !== 'object') return;
            const descriptor = this.registrationAnalysisSourceDescriptor(source, index);
            const existing = merged.get(descriptor.key) || {};
            const next: any = { ...existing };
            Object.entries(descriptor).forEach(([key, value]: [string, any]) => {
                if (key === 'item' && !value) return;
                if (value === '' || value === null || typeof value === 'undefined') return;
                next[key] = value;
            });
            next.key = descriptor.key;
            next.staged = existing.staged === true || descriptor.staged === true;
            merged.set(descriptor.key, next);
        });
        this.registrationAnalysisSources = Array.from(merged.values()).sort(
            (left: any, right: any) => {
                const leftIndex = Number(left?.sourceIndex);
                const rightIndex = Number(right?.sourceIndex);
                const safeLeft = Number.isInteger(leftIndex) && leftIndex >= 0
                    ? leftIndex : Number.MAX_SAFE_INTEGER;
                const safeRight = Number.isInteger(rightIndex) && rightIndex >= 0
                    ? rightIndex : Number.MAX_SAFE_INTEGER;
                return safeLeft - safeRight
                    || `${left?.name || ''}`.localeCompare(`${right?.name || ''}`);
            }
        );
    }

    private registrationAnalysisItemSnapshot(item: any) {
        const source = item?.analysis?.source || {};
        const profile = item?.analysis?.document_profile || {};
        const readiness = item?.analysis?.analysis_readiness || {};
        return {
            name: `${item?.name || ''}`,
            status: `${item?.status || 'queued'}`,
            progress: Number(item?.progress || 0),
            stageLabel: `${item?.stageLabel || ''}`,
            stageDetail: `${item?.stageDetail || ''}`,
            error: `${item?.error || ''}`,
            errorInfo: item?.errorInfo ? { ...item.errorInfo } : null,
            failureStage: `${item?.failureStage || ''}`,
            sourceIndex: this.registrationAnalysisSourceIndex(item),
            stagedSourceId: `${item?.stagedSourceId || ''}`,
            sourceUrl: `${item?.sourceUrl || source?.url || ''}`,
            preflightHash: `${item?.preflightHash || ''}`,
            analysis: item?.analysis ? {
                id: `${item.analysis.id || ''}`,
                source: {
                    actual_format: `${source.actual_format || ''}`,
                    mime_type: `${source.mime_type || ''}`,
                    name: `${source.name || item?.name || ''}`,
                    url: `${source.url || item?.sourceUrl || ''}`,
                },
                document_profile: {
                    key: `${profile.key || ''}`,
                    label: `${profile.label || ''}`,
                },
                analysis_readiness: {
                    can_proceed: readiness.can_proceed,
                    source_acquired: readiness.source_acquired,
                    format_detected: readiness.format_detected,
                    extraction_completed: readiness.extraction_completed,
                    extraction_runnable: readiness.extraction_runnable,
                },
            } : null,
            form: null,
            sourceFile: null,
            displayOnly: true,
        };
    }

    private rememberRegistrationAnalysisItems(items: any[]) {
        const snapshots = (Array.isArray(items) ? items : []).map(
            (item: any) => this.registrationAnalysisItemSnapshot(item)
        );
        this.mergeRegistrationAnalysisSources(snapshots);
        const itemsByKey = new Map<string, any>();
        snapshots.forEach((item: any, index: number) => {
            if (!item || typeof item !== 'object') return;
            itemsByKey.set(this.registrationAnalysisSourceKey(item, index), item);
        });
        this.registrationAnalysisSources = this.registrationAnalysisSources.map(
            (source: any) => ({
                ...source,
                item: itemsByKey.get(`${source?.key || ''}`) || source?.item || null,
            })
        );
    }

    private registrationLocalDraft(form: any, serialized: boolean = false) {
        if (!form || typeof form !== 'object') return serialized ? '' : null;
        const encoded = JSON.stringify({
            source_name: form.source_name || '',
            title: form.title || '',
            content: form.content || '',
            category: form.category || '',
            status: form.status || 'draft',
            authors: form.authors || '',
            publisher: form.publisher || '',
            created_dates: this.normaliseDateValues(form.created_dates),
            issued_dates: this.normaliseDateValues(form.issued_dates),
            document_date: form.document_date || '',
            language: form.language || '',
            era: form.era || '',
            keywords: form.keywords || '',
            ocr_text: form.ocr_text || '',
            ocr_page_corrections: form.ocr_page_corrections || [],
            entities: form.entities || [],
            multilingual: form.multilingual || {},
            document_profile: form.document_profile || '',
            profile_fields: form.profile_fields || {},
            provenance_type: form.provenance_type || 'direct_upload',
            source_scheme: form.source_scheme || '',
            source_category: form.source_category || '',
            duplicate_confirmed: !!form.duplicate_confirmed,
            duplicate_override_reason: form.duplicate_override_reason || '',
            security_acknowledged: !!form.security_acknowledged,
            common_metadata_review: form.common_metadata_review || {},
            metadata_v2_1_review: form.metadata_v2_1_review || {},
            xml_field_review: form.xml_field_review || {},
        });
        return serialized ? encoded : JSON.parse(encoded);
    }

    private registrationRecoveryDraftPayload(item: any) {
        if (!item?.analysis?.id || !item.form) return null;
        return {
            data: this.savePayload(item.form, item.analysis.id, item, 'draft'),
            visibility_confirmed: !!item.visibilityConfirmed,
            review_checks: this.normaliseReviewChecks(item.reviewChecks),
            workflow_state: this.registrationDraftWorkflowState(item),
            prevalidate: this.registrationDraftPreflightReady(item),
        };
    }

    private registrationDraftPreflightReady(item: any) {
        if (!item?.form || item.status !== 'complete') return false;
        return this.metadataReviewFileComplete(item);
    }

    private captureRegistrationLocalDraft(item: any, form: any = null) {
        if (!item || !(form || item.form)) return;
        const serialized = this.registrationLocalDraft(
            form || item.form, true
        );
        if (!serialized) return;
        item.localRecoveryDraft = JSON.parse(serialized);
        item.localRecoveryDraftHash = serialized;
    }

    private registrationRecoverySnapshot(includeLocalDraft: boolean = false) {
        const items = this.batchItems.map((item: any, itemIndex: number) => ({
            name: item.name || '',
            analysis_id: item.analysis && item.analysis.id
                ? item.analysis.id : `${item.analysisId || ''}`,
            progress_id: item.progressId || '',
            source_index: this.registrationSourceIndex(
                item.sourceFile,
                item,
                itemIndex,
            ),
            staged_source_id: `${item.stagedSourceId || ''}`,
            source_id: `${item.stagedSourceId || ''}`,
            status: item.status || 'queued',
            visibility_confirmed: !!item.visibilityConfirmed,
            visibility_status: ['draft', 'published'].includes(item.form?.status)
                ? item.form.status : '',
            security_acknowledged: !!item.securityAcknowledged,
            duplicate_confirmed: !!item.duplicateConfirmed,
            duplicate_override_selected: !!item.duplicateOverrideSelected,
            duplicate_override_confirmed: !!item.duplicateOverrideConfirmed,
            duplicate_override_reason: `${item.duplicateOverrideReason || item.form?.duplicate_override_reason || ''}`,
            duplicate_override_document_id: `${
                item.duplicateOverrideDocumentId
                || item.analysis?.duplicate?.post_id
                || item.analysis?.duplicate_override?.document_id
                || ''
            }`,
            preflight_hash: `${item.preflightHash || ''}`,
            requested_profile: `${item.requestedProfile || ''}`,
            review_checks: this.normaliseReviewChecks(item.reviewChecks),
            workflow_state: this.registrationDraftWorkflowState(item),
            metadata_review_paused: !!item.metadataReviewPaused,
            failure_stage: item.failureStage || '',
            error: item.error || '',
            error_info: item.errorInfo || null,
            processing_started_at: Number(item.processingStartedAt || 0),
            processing_completed_at: Number(item.processingCompletedAt || 0),
            source_url: item.sourceUrl || (item.analysis && item.analysis.source ? item.analysis.source.url || '' : ''),
            local_draft: includeLocalDraft
                ? item.localRecoveryDraft || null : null,
            draft_revision: `${item.draftRevision || ''}`,
            registration_preflight: item.registrationPreflight || null,
            registration_preflight_revision: `${
                item.registrationPreflightDraftRevision || ''
            }`,
            registration_preflight_source_checksum: `${
                item.registrationPreflightSourceChecksum || ''
            }`,
            registration_counted: !!item.registrationCounted,
            registration_result: item.registrationResult || null,
        }));
        const selectedXmlUrls = this.uploadSourceType === 'url' ? [...this.xmlUrls] : [];
        const queuedSources = this.registrationQueuedSources();
        if (
            !items.some((item: any) => item.analysis_id || item.progress_id)
            && !selectedXmlUrls.length
            && !queuedSources.length
        ) return null;
        return {
            version: 10,
            workspace_id: this.registrationWorkspaceId || '',
            workspace_revision: this.registrationWorkspaceRevision || '',
            saved_at: Date.now(),
            analysis_batch_started_at: Number(this.analysisBatchStartedAt || 0),
            analysis_batch_finished_at: Number(this.analysisBatchFinishedAt || 0),
            completed_registration_count: this.completedRegistrationCount,
            selected_source_count: this.analysisOverallTotalCount(),
            processed_source_count: this.processedRegistrationSourceCount,
            register_step: this.registerStep,
            metadata_section: this.metadataSection,
            review_section: this.reviewSection,
            active_index: this.activeBatchIndex,
            metadata_advance_mode: this.metadataAdvanceMode,
            metadata_advance_selection_keys: [...this.metadataAdvanceSelectionKeys],
            upload_source_type: this.uploadSourceType,
            xml_urls: selectedXmlUrls,
            queued_sources: queuedSources,
            items,
        };
    }

    private persistRegistrationRecovery() {
        if (!this.isRegistrationMode() || this.navigationBypass) return;
        const snapshot = this.registrationRecoverySnapshot(true);
        if (!snapshot) return;
        try {
            localStorage.setItem(this.registrationRecoveryKey(), JSON.stringify(snapshot));
        } catch (_) {
            this.recoveryNotice = '브라우저 복구 정보를 저장하지 못했습니다. 현재 화면을 닫지 마세요.';
        }
    }

    private registrationRecoveryLocalDraftIsCurrent(saved: any, row: any) {
        if (!saved?.local_draft || typeof saved.local_draft !== 'object') return false;
        const serverRevision = `${row?.draft?.revision || ''}`.trim();
        if (!serverRevision) return true;
        const localBaseRevision = `${saved?.draft_revision || ''}`.trim();
        return !!localBaseRevision && localBaseRevision === serverRevision;
    }

    private applyRegistrationWorkspaceSummary(workspace: any, acceptRevision: boolean = true) {
        if (!workspace || typeof workspace !== 'object') return;
        const nextWorkspaceId = this.normaliseRegistrationWorkspaceId(
            workspace.workspace_id
            || workspace.snapshot?.workspace_id
            || this.registrationWorkspaceId
            || ''
        );
        const routeWorkspaceId = this.routeWorkspaceId();
        if (
            routeWorkspaceId
            && nextWorkspaceId
            && routeWorkspaceId !== nextWorkspaceId
        ) {
            this.registrationWorkspaceStatus = 'error';
            this.registrationWorkspaceMessage = '현재 주소와 다른 등록 작업 응답을 무시했습니다.';
            return;
        }
        const trackedWorkspaceId = this.registrationAnalysisSourcesWorkspaceId
            || this.registrationWorkspaceId;
        if (
            trackedWorkspaceId
            && nextWorkspaceId
            && trackedWorkspaceId !== nextWorkspaceId
        ) {
            this.registrationAnalysisSources = [];
        }
        this.registrationWorkspaceId = nextWorkspaceId;
        this.registrationAnalysisSourcesWorkspaceId = nextWorkspaceId;
        const queuedAnalysisSources = Array.isArray(workspace.snapshot?.queued_sources)
            ? workspace.snapshot.queued_sources : [];
        const queuedAnalysisKeys = new Set(
            queuedAnalysisSources.map((source: any, index: number) => (
                this.registrationAnalysisSourceKey(source, index)
            ))
        );
        const persistedAnalysisItems = (Array.isArray(workspace.snapshot?.items)
            ? workspace.snapshot.items : []).filter((item: any, index: number) => (
            ['saved', 'registration_complete'].includes(`${item?.status || ''}`)
            || queuedAnalysisKeys.has(this.registrationAnalysisSourceKey(item, index))
        ));
        this.mergeRegistrationAnalysisSources([
            ...queuedAnalysisSources,
            ...persistedAnalysisItems,
        ]);
        this.rememberRegistrationAnalysisItems(
            persistedAnalysisItems.map((item: any) => ({
                ...item,
                sourceIndex: this.registrationAnalysisSourceIndex(item),
                stagedSourceId: `${item?.staged_source_id || item?.source_id || ''}`,
                sourceUrl: `${item?.source_url || ''}`,
                status: ['saved', 'registration_complete'].includes(`${item?.status || ''}`)
                    ? 'registration_complete' : `${item?.status || 'queued'}`,
            }))
        );
        const explicitSourceCount = Number(workspace.source_count);
        this.registrationWorkspaceSourceCount = Math.max(0, Number.isFinite(explicitSourceCount)
            ? explicitSourceCount
            : Number(workspace.snapshot?.queued_sources?.filter(
                (row: any) => row?.staged === true
                    && !!`${row?.source_id || row?.staged_source_id || ''}`
            ).length || 0));
        const snapshotSelectedCount = Number(workspace.snapshot?.selected_source_count || 0);
        const snapshotProcessedCount = Number(workspace.snapshot?.processed_source_count || 0);
        if (Number.isFinite(snapshotProcessedCount)) {
            this.processedRegistrationSourceCount = Math.max(
                this.processedRegistrationSourceCount,
                snapshotProcessedCount,
            );
        }
        const inferredSelectedCount = this.processedRegistrationSourceCount
            + Number(workspace.snapshot?.queued_sources?.length || 0);
        const persistedSelectedCount = Number.isFinite(snapshotSelectedCount)
            ? snapshotSelectedCount : 0;
        this.selectedRegistrationSourceCount = persistedSelectedCount > 0
            ? Math.max(
                this.selectedRegistrationSourceCount,
                persistedSelectedCount,
                inferredSelectedCount,
            )
            : Math.max(
                this.selectedRegistrationSourceCount,
                inferredSelectedCount,
                this.registrationWorkspaceSourceCount,
            );
        this.registrationWorkspaceSavedAt = `${workspace.server_saved_at || ''}`;
        this.registrationWorkspaceSavedBy = `${workspace.server_saved_by || ''}`;
        if (acceptRevision) {
            this.registrationWorkspaceRevision = `${workspace.revision || this.registrationWorkspaceRevision || ''}`;
        }
        this.registrationWorkspaceLegacy = !!workspace.legacy;
        const originalArchive = workspace.original_archive;
        if (originalArchive && typeof originalArchive === 'object') {
            this.registrationOriginalArchiveId = `${originalArchive.archive_id || ''}`;
            this.registrationOriginalArchiveSourceCount = Math.max(
                0,
                Number(originalArchive.active_source_count ?? originalArchive.source_count ?? 0) || 0,
            );
            this.registrationOriginalArchiveAt = `${originalArchive.verified_at || originalArchive.created_at || ''}`;
            this.registrationOriginalArchiveBy = `${originalArchive.verified_by || originalArchive.created_by || ''}`;
            this.registrationOriginalArchiveStatus = originalArchive.state === 'verified'
                && originalArchive.complete !== false
                ? 'verified'
                : originalArchive.state === 'integrity_error'
                    ? 'error' : 'partial';
            this.registrationOriginalArchiveMessage = this.registrationOriginalArchiveStatus === 'verified'
                ? '메타정보 확정 전 원본이 SHA-256 검증과 함께 우선 등록되었습니다.'
                : this.registrationOriginalArchiveStatus === 'error'
                    ? '원본 보존기록 무결성을 확인하지 못했습니다. 원본 우선 등록을 다시 실행해주세요.'
                    : '새로 추가한 원본이 있습니다. 원본 우선 등록을 다시 실행해주세요.';
        } else {
            this.registrationOriginalArchiveId = '';
            this.registrationOriginalArchiveSourceCount = 0;
            this.registrationOriginalArchiveAt = '';
            this.registrationOriginalArchiveBy = '';
            this.registrationOriginalArchiveStatus = 'idle';
            this.registrationOriginalArchiveMessage = '';
        }
    }

    public registrationOriginalArchiveReady() {
        return !!(
            this.uploadSourceType === 'file'
            && this.registrationWorkspaceId
            && this.uploadFiles.length > 0
            && !this.filePreflightRunning
            && !this.sourceSelectionLocked()
            && this.filePreflights.length === this.uploadFiles.length
            && this.filePreflights.every((row: any) => (
                row?.staged === true && !!`${row?.stagedSourceId || ''}`
            ))
        );
    }

    public registrationOriginalArchiveButtonLabel() {
        if (this.registrationOriginalArchiveStatus === 'saving') {
            return '원본 XML 우선 등록 중...';
        }
        if (this.registrationOriginalArchiveStatus === 'verified') {
            return '원본 XML 우선 등록 확인';
        }
        return '원본 XML 우선 등록';
    }

    public async archiveRegistrationOriginals() {
        if (this.registrationOriginalArchiveStatus === 'saving') return;
        if (!this.registrationOriginalArchiveReady()) {
            await this.service.modal.error(
                '선택한 모든 원본의 서버 보존이 끝난 뒤 원본 XML 우선 등록을 실행해주세요.'
            );
            return;
        }
        this.registrationOriginalArchiveStatus = 'saving';
        this.registrationOriginalArchiveMessage = '원본 바이트와 SHA-256을 대조해 독립 보존기록을 만들고 있습니다.';
        await this.service.render();
        try {
            const workspaceSaved = await this.saveRegistrationWorkspace(true);
            if (!workspaceSaved) {
                throw new Error(
                    this.registrationWorkspaceMessage || '현재 원본 목록을 서버에 저장하지 못했습니다.'
                );
            }
            const result = await wiz.call('analyze', {
                mode: 'registration_workspace_archive',
                workspace_id: this.registrationWorkspaceId,
                expected_revision: this.registrationWorkspaceRevision,
            });
            if (!result || result.code !== 200 || !result.data?.workspace) {
                throw new Error(
                    result?.data?.message || '원본 XML 우선 등록을 완료하지 못했습니다.'
                );
            }
            this.applyRegistrationWorkspaceSummary(result.data.workspace);
            const archive = result.data.original_archive || result.data.workspace.original_archive || {};
            this.registrationOriginalArchiveId = `${archive.archive_id || this.registrationOriginalArchiveId || ''}`;
            this.registrationOriginalArchiveSourceCount = Math.max(
                0,
                Number(archive.active_source_count ?? archive.source_count ?? this.registrationOriginalArchiveSourceCount) || 0,
            );
            this.registrationOriginalArchiveAt = `${archive.verified_at || archive.created_at || this.registrationOriginalArchiveAt || ''}`;
            this.registrationOriginalArchiveBy = `${archive.verified_by || archive.created_by || this.registrationOriginalArchiveBy || ''}`;
            this.registrationOriginalArchiveStatus = 'verified';
            this.registrationOriginalArchiveMessage = result.data.idempotent
                ? '기존 원본 우선 등록본의 SHA-256 무결성을 다시 확인했습니다.'
                : `${this.registrationOriginalArchiveSourceCount}개 원본 XML을 메타정보 확정 전 상태로 우선 등록했습니다.`;
            this.persistRegistrationRecovery();
        } catch (error) {
            const captured = this.captureError(
                error,
                '원본 XML 우선 등록을 완료하지 못했습니다.',
            );
            this.registrationOriginalArchiveStatus = 'error';
            this.registrationOriginalArchiveMessage = captured.message;
        } finally {
            await this.service.render();
        }
    }

    private async saveRegistrationWorkspace(force: boolean = false) {
        if (!this.isRegistrationMode()) return true;
        if (this.filePreflightRunning && !force) return true;
        this.registrationWorkspaceSaveQueueDepth += 1;
        this.registrationWorkspaceSaving = true;
        const operation = this.registrationWorkspaceSaveQueue.then(async () => {
            const snapshot = this.registrationRecoverySnapshot();
            if (!snapshot) return true;
            this.ensureRegistrationWorkspaceId();
            snapshot.workspace_id = this.registrationWorkspaceId;
            this.registrationWorkspaceStatus = 'saving';
            this.registrationWorkspaceMessage = '전체 원본 목록과 작업 위치를 서버에 저장하고 있습니다.';
            const request: any = {
                mode: 'registration_workspace_save',
                workspace_id: this.registrationWorkspaceId,
                snapshot: JSON.stringify(snapshot),
            };
            if (this.registrationWorkspaceRevision) {
                request.expected_revision = this.registrationWorkspaceRevision;
            }
            const result = await wiz.call('analyze', request);
            if (!result || result.code !== 200 || !result.data?.workspace) {
                throw new Error(
                    result?.data?.message
                    || '전체 등록 작업을 서버에 저장하지 못했습니다.'
                );
            }
            this.applyRegistrationWorkspaceSummary(result.data.workspace);
            this.registrationWorkspaceStatus = 'saved';
            this.registrationWorkspaceMessage = '전체 원본과 검수 작업 위치를 서버에 저장했습니다.';
            return true;
        });
        this.registrationWorkspaceSaveQueue = operation.then(
            () => undefined,
            () => undefined,
        );
        try {
            return await operation;
        } catch (error) {
            const captured = this.captureError(
                error,
                '전체 등록 작업을 서버에 저장하지 못했습니다.',
            );
            this.registrationWorkspaceStatus = 'error';
            this.registrationWorkspaceMessage = captured.message;
            return false;
        } finally {
            this.registrationWorkspaceSaveQueueDepth = Math.max(
                0,
                this.registrationWorkspaceSaveQueueDepth - 1,
            );
            this.registrationWorkspaceSaving = this.registrationWorkspaceSaveQueueDepth > 0;
            await this.service.render();
        }
    }

    private async setRegistrationWorkspaceState(
        state: 'active' | 'paused' | 'discarded' | 'completed',
        includeSnapshot: boolean = true,
    ) {
        if (!this.registrationWorkspaceId) return true;
        const snapshot = includeSnapshot ? this.registrationRecoverySnapshot() : null;
        try {
            const request: any = {
                mode: 'registration_workspace_state',
                workspace_id: this.registrationWorkspaceId,
                state,
                workspace_state: state,
                expected_revision: this.registrationWorkspaceRevision,
            };
            if (snapshot) request.snapshot = JSON.stringify(snapshot);
            const result = await wiz.call('analyze', request);
            if (!result || result.code !== 200 || !result.data?.workspace) {
                throw new Error(
                    result?.data?.message || '등록 작업 상태를 서버에 반영하지 못했습니다.'
                );
            }
            this.applyRegistrationWorkspaceSummary(result.data.workspace);
            return true;
        } catch (error) {
            const captured = this.captureError(
                error,
                '등록 작업 상태를 서버에 반영하지 못했습니다.',
            );
            this.registrationWorkspaceStatus = 'error';
            this.registrationWorkspaceMessage = captured.message;
            return false;
        }
    }

    private clearRegistrationRecovery() {
        try {
            localStorage.removeItem(this.registrationRecoveryKey());
            const legacySnapshot = JSON.parse(
                localStorage.getItem(this.legacyRegistrationRecoveryKey()) || 'null'
            );
            if (
                legacySnapshot
                && this.normaliseRegistrationWorkspaceId(legacySnapshot.workspace_id)
                    === this.normaliseRegistrationWorkspaceId(this.registrationWorkspaceId)
            ) {
                localStorage.removeItem(this.legacyRegistrationRecoveryKey());
                localStorage.removeItem(this.legacyActiveRegistrationRecoveryKey());
            }
        } catch (_) { }
        this.clearActiveRegistrationRecovery();
        this.recoveryDraftHashes = {};
    }

    private setRegistrationPreflightProgress(
        stage: 'draft' | 'preflight',
        label: string,
        completed: number,
        complete: boolean = false,
    ) {
        const total = Math.max(
            0,
            this.registrationPreflightDraftWorkTotal
            + this.registrationPreflightCandidateWorkTotal,
        );
        const boundedCompleted = Math.max(
            0,
            Math.min(total, Math.floor(Number(completed) || 0)),
        );
        const previousPercent = (
            this.registrationProgress?.status === 'processing'
            && Number.isFinite(Number(this.registrationProgress?.percent))
        ) ? Number(this.registrationProgress.percent) : 0;
        const calculatedPercent = total > 0
            ? Math.round(boundedCompleted / total * 100)
            : (complete || stage === 'preflight' ? 100 : 0);
        const registrationCommitFlow = !!(
            this.registrationSubmitting && this.registrationProcessingOpen
        );
        const displayPercent = registrationCommitFlow
            ? Math.round(calculatedPercent * 0.3)
            : calculatedPercent;
        this.registrationProgress = {
            status: complete && !registrationCommitFlow ? 'complete' : 'processing',
            stage,
            label,
            completed: boundedCompleted,
            total,
            percent: complete
                ? (registrationCommitFlow ? 30 : 100)
                : Math.max(previousPercent, displayPercent),
        };
    }

    private async flushRegistrationRecoveryDrafts() {
        if (!this.isRegistrationMode()) {
            this.registrationDraftSyncFailures = [];
            return;
        }
        if (this.recoverySaving) {
            this.recoverySavePending = true;
            return;
        }
        this.recoverySavePending = false;
        if (this.activeBatchIndex >= 0 && this.batchItems[this.activeBatchIndex] && this.data) {
            this.batchItems[this.activeBatchIndex].form = this.cloneForm(this.data);
        }
        const candidates = this.batchItems.filter(
            (item: any) => (
                item.status === 'complete'
                || (item.status === 'error' && item.failureStage === 'save')
            ) && item.analysis && item.analysis.id && item.form
        );
        const preparedCandidates = candidates.map((item: any) => {
            const draft = this.registrationRecoveryDraftPayload(item);
            return {
                item,
                draft,
                serialized: draft ? JSON.stringify(draft) : '',
            };
        }).filter((row: any) => !!row.draft);
        preparedCandidates.forEach(({ item, serialized }: any) => {
            if (this.recoveryDraftHashes[item.analysis.id] !== serialized) return;
            delete item.localRecoveryDraft;
            delete item.localRecoveryDraftHash;
        });
        const saveCandidates = preparedCandidates.filter(({ item, serialized }: any) => (
            this.recoveryDraftHashes[item.analysis.id] !== serialized
        ));
        if (this.registrationPreflightLoading) {
            this.registrationPreflightDraftWorkTotal = saveCandidates.length;
            this.setRegistrationPreflightProgress(
                'draft',
                saveCandidates.length ? '검수 초안 저장 중' : '검수 초안 저장 확인 완료',
                0,
            );
        }
        if (!saveCandidates.length) {
            this.registrationDraftSyncFailures = [];
            this.autoSaveState = 'saved';
            this.autoSaveSavedAt = this.formatAutoSaveTime();
            this.autoSaveMessage = '브라우저 임시 저장 완료';
            await this.service.render();
            return;
        }

        this.recoverySaving = true;
        this.recoverySaveCompletion = new Promise<void>((resolve) => {
            this.resolveRecoverySaveCompletion = resolve;
        });
        this.autoSaveState = 'saving';
        this.autoSaveMessage = '서버에 검수 내용 저장 중';
        let savedDraftCount = 0;
        const failures: any[] = [];
        this.registrationDraftSyncFailures = [];
        try {
            await this.service.render();
            await this.runBounded(
                saveCandidates,
                this.registrationPreflightConcurrency,
                async ({ item, draft, serialized }: any) => {
                try {
                    if (this.recoveryDraftHashes[item.analysis.id] === serialized) return;
                    const submittedLocalDraftHash = this.registrationLocalDraft(
                        item.form, true
                    );
                    const requestDraft = {
                        ...draft,
                        expected_revision: item.draftRevision || '',
                    };
                    const submittedXmlReview = JSON.stringify(
                        item.form.xml_field_review || {}
                    );
                    const submittedEntities = JSON.stringify(
                        item.form.entities || []
                    );
                    const result = await wiz.call('analyze', {
                        mode: 'registration_draft',
                        analysis_id: item.analysis.id,
                        draft: JSON.stringify(requestDraft),
                    });
                if (!result || result.code !== 200) {
                    throw (result && result.data)
                        || new Error('서버 초안 저장 요청에 실패했습니다.');
                }
                item.draftRevision = result.data && result.data.draft
                    ? result.data.draft.revision || item.draftRevision || ''
                    : item.draftRevision || '';
                const savedPreflight = result.data && result.data.draft
                    ? result.data.draft.preflight : null;
                if (savedPreflight && typeof savedPreflight === 'object') {
                    item.registrationPreflight = { ...savedPreflight };
                    item.registrationPreflightDraftRevision = `${
                        savedPreflight.draft_revision || item.draftRevision || ''
                    }`;
                    item.registrationPreflightSourceChecksum = `${
                        savedPreflight.source_checksum
                        || savedPreflight.source?.checksum
                        || item.analysis?.source?.checksum_sha256
                        || ''
                    }`;
                }
                const authoritativeWorkflowState = result.data && result.data.draft
                    ? result.data.draft.workflow_state?.metadata_review : '';
                if (authoritativeWorkflowState) {
                    item.registrationWorkflowState = {
                        ...(result.data.draft.workflow_state || {}),
                    };
                    item.metadataReviewState = this.normaliseMetadataReviewWorkflowState(
                        authoritativeWorkflowState,
                    );
                }
                const authoritativeXmlReview = result.data && result.data.draft
                    ? result.data.draft.xml_field_review : null;
                if (
                    authoritativeXmlReview
                    && Array.isArray(authoritativeXmlReview.fields)
                    && authoritativeXmlReview.fields.length
                ) {
                    const formXmlReviewIsCurrent = JSON.stringify(
                        item.form.xml_field_review || {}
                    ) === submittedXmlReview;
                    const activeXmlReviewIsCurrent = (
                        this.batchItems[this.activeBatchIndex] === item
                        && this.data
                        && JSON.stringify(this.data.xml_field_review || {}) === submittedXmlReview
                    );
                    if (formXmlReviewIsCurrent) {
                        item.form.xml_field_review = JSON.parse(
                            JSON.stringify(authoritativeXmlReview)
                        );
                    }
                    if (activeXmlReviewIsCurrent) {
                        this.data.xml_field_review = JSON.parse(
                            JSON.stringify(authoritativeXmlReview)
                        );
                    }
                }
                const authoritativeEntities = result.data && result.data.draft
                    ? result.data.draft.entities : null;
                if (Array.isArray(authoritativeEntities)) {
                    const formEntitiesAreCurrent = JSON.stringify(
                        item.form.entities || []
                    ) === submittedEntities;
                    const activeEntitiesAreCurrent = (
                        this.batchItems[this.activeBatchIndex] === item
                        && this.data
                        && JSON.stringify(this.data.entities || []) === submittedEntities
                    );
                    if (formEntitiesAreCurrent) {
                        item.form.entities = authoritativeEntities.map(
                            (row: any, index: number) => this.prepareEntityForReview(row, index)
                        );
                        if (item.form.profile_fields && item.form.document_profile === 'full_text') {
                            item.form.profile_fields.entities = item.form.entities.map(
                                (row: any) => ({ ...row })
                            );
                        }
                    }
                    if (activeEntitiesAreCurrent) {
                        this.data.entities = authoritativeEntities.map(
                            (row: any, index: number) => this.prepareEntityForReview(row, index)
                        );
                        if (this.data.profile_fields && this.data.document_profile === 'full_text') {
                            this.data.profile_fields.entities = this.data.entities.map(
                                (row: any) => ({ ...row })
                            );
                        }
                    }
                }
                    const authoritativeDraft = this.registrationRecoveryDraftPayload(item);
                    const submittedDraftIsCurrent = (
                        !item.localRecoveryDraftHash
                        || item.localRecoveryDraftHash === submittedLocalDraftHash
                    );
                    this.recoveryDraftHashes[item.analysis.id] = submittedDraftIsCurrent
                        ? JSON.stringify(authoritativeDraft || draft)
                        : serialized;
                    if (submittedDraftIsCurrent) {
                        delete item.localRecoveryDraft;
                        delete item.localRecoveryDraftHash;
                    }
                } catch (error) {
                    const captured = this.captureError(
                        error,
                        `${item.name || '자료'} 검수 초안을 저장하지 못했습니다.`,
                    );
                    failures.push({ item, captured });
                    if (captured.details) this.technicalErrorDetails = captured.details;
                } finally {
                    savedDraftCount += 1;
                    if (this.registrationPreflightLoading) {
                        this.setRegistrationPreflightProgress(
                            'draft',
                            '검수 초안 저장 중',
                            savedDraftCount,
                        );
                        await this.service.render();
                    }
                }
            });
            if (failures.length) {
                this.registrationDraftSyncFailures = failures.slice();
                this.autoSaveState = 'error';
                this.autoSaveMessage = `${failures.length}개 자료의 초안 저장에 실패했습니다. 나머지 자료는 저장했습니다.`;
            } else {
                this.registrationDraftSyncFailures = [];
                this.autoSaveState = 'saved';
                this.autoSaveSavedAt = this.formatAutoSaveTime();
                this.autoSaveMessage = '모든 검수 내용 자동 저장 완료';
            }
        } catch (error) {
            const captured = this.captureError(error, '자동 저장에 실패했습니다. 잠시 후 다시 시도합니다.');
            this.registrationDraftSyncFailures = saveCandidates.map(({ item }: any) => ({
                item,
                captured,
            }));
            this.autoSaveState = 'error';
            this.autoSaveMessage = captured.message;
            if (captured.details) this.technicalErrorDetails = captured.details;
        } finally {
            const resolveSaveCompletion = this.resolveRecoverySaveCompletion;
            this.resolveRecoverySaveCompletion = null;
            this.recoverySaving = false;
            if (resolveSaveCompletion) resolveSaveCompletion();
            this.persistRegistrationRecovery();
            await this.service.render();
            if (this.recoverySavePending) {
                this.recoverySavePending = false;
                void this.flushRegistrationRecoveryDrafts();
            }
        }
    }

    private async waitForRegistrationRecoverySave() {
        while (this.recoverySaving || this.recoverySavePending) {
            if (this.recoveryDestroyed) return false;
            if (this.recoverySaving) {
                await this.recoverySaveCompletion;
            } else {
                await this.service.sleep(25);
            }
        }
        return true;
    }

    private async flushRegistrationRecoveryDraftsNow() {
        if (this.recoverySaveTimer) {
            clearTimeout(this.recoverySaveTimer);
            this.recoverySaveTimer = null;
        }
        if (!await this.waitForRegistrationRecoverySave()) return false;
        await this.flushRegistrationRecoveryDrafts();
        if (!await this.waitForRegistrationRecoverySave()) return false;
        this.persistRegistrationRecovery();
        return this.autoSaveState === 'saved';
    }

    private recoveredForm(analysis: any, draft: any, localVisibility: any = null) {
        const form = this.analysisForm(analysis);
        const data = draft && draft.data && typeof draft.data === 'object' ? draft.data : {};
        const corrections = data.ai_corrections && typeof data.ai_corrections === 'object'
            ? data.ai_corrections
            : {};
        form.title = corrections.title || data.title || form.title;
        form.category = corrections.category || data.category || form.category;
        form.content = corrections.summary || data.content || form.content;
        const draftVisibilityConfirmed = !!(draft && draft.visibility_confirmed);
        const localVisibilityConfirmed = !!(
            localVisibility && localVisibility.confirmed
        );
        const recoveredVisibilityStatus = draftVisibilityConfirmed
            ? data.status
            : localVisibilityConfirmed
                ? localVisibility.status
                : '';
        form.status = ['draft', 'published'].includes(recoveredVisibilityStatus)
            ? recoveredVisibilityStatus : form.status;
        form.authors = Array.isArray(corrections.authors) ? corrections.authors.join(', ') : form.authors;
        form.publisher = corrections.publisher || form.publisher || '';
        form.created_dates = this.normaliseDateValues(corrections.created_dates);
        form.issued_dates = this.normaliseDateValues(corrections.issued_dates);
        if (!form.created_dates.length && !form.issued_dates.length && corrections.date) {
            form.issued_dates = [`${corrections.date}`];
        }
        form.document_date = form.issued_dates[0]
            || form.created_dates[0] || corrections.date || form.document_date;
        form.language = corrections.language || form.language || '';
        form.era = corrections.era || form.era;
        form.keywords = Array.isArray(corrections.keywords) ? corrections.keywords.join(', ') : form.keywords;
        form.ocr_text = corrections.ocr_text || form.ocr_text;
        form.ocr_page_corrections = Array.isArray(corrections.ocr_pages) ? corrections.ocr_pages : [];
        form.entities = (
            Array.isArray(corrections.entities) && corrections.entities.length
                ? corrections.entities
                : form.entities
        ).map((row: any, index: number) => this.prepareEntityForReview(row, index));
        form.multilingual = this.normaliseMultilingual(corrections.multilingual || form.multilingual);
        form.document_profile = corrections.document_profile || form.document_profile || '';
        form.profile_fields = corrections.profile_fields
            ? JSON.parse(JSON.stringify(corrections.profile_fields))
            : (form.profile_fields || {});
        if (form.document_profile === 'full_text' && form.profile_fields) {
            form.profile_fields.entities = form.entities.map((row: any) => ({ ...row }));
        }
        form.provenance_type = corrections.provenance_type || form.provenance_type;
        form.source_scheme = corrections.source_scheme || form.source_scheme;
        form.source_category = corrections.source_category || form.source_category;
        form.duplicate_confirmed = !!corrections.duplicate_confirmed;
        form.duplicate_override_reason = corrections.duplicate_override_reason || '';
        form.security_acknowledged = !!corrections.security_acknowledged;
        form.common_metadata_review = corrections.common_metadata_review
            ? JSON.parse(JSON.stringify(corrections.common_metadata_review))
            : form.common_metadata_review;
        form.metadata_v2_1_review = corrections.metadata_v2_1_review
            ? JSON.parse(JSON.stringify(corrections.metadata_v2_1_review))
            : form.metadata_v2_1_review;
        form.xml_field_review = corrections.xml_field_review
            ? JSON.parse(JSON.stringify(corrections.xml_field_review))
            : form.xml_field_review;
        return form;
    }

    private async requestRegistrationRecovery(snapshot: any) {
        const requestedItems = (Array.isArray(snapshot?.items) ? snapshot.items : [])
            .filter((item: any) => item?.analysis_id || item?.progress_id);
        const chunks: any[][] = [];
        for (
            let offset = 0;
            offset < requestedItems.length;
            offset += this.registrationRecoveryBatchSize
        ) {
            chunks.push(requestedItems.slice(
                offset,
                offset + this.registrationRecoveryBatchSize,
            ));
        }
        const recoveredByChunk: any[][] = Array.from(
            { length: chunks.length }, () => [],
        );
        let failedResponse: any = null;
        await this.runBounded(
            chunks,
            this.registrationRecoveryDetailConcurrency,
            async (chunk: any[], chunkIndex: number) => {
            const response = await wiz.call('analyze', {
                mode: 'registration_recovery',
                compressed: typeof (window as any).DecompressionStream === 'function'
                    ? 'true' : 'false',
                analysis_ids: JSON.stringify(
                    chunk
                        .filter((item: any) => !item.progress_id)
                        .map((item: any) => item.analysis_id)
                        .filter(Boolean)
                ),
                progress_ids: JSON.stringify(
                    chunk.map((item: any) => item.progress_id).filter(Boolean)
                ),
            });
            if (!response || response.code !== 200 || !response.data?.recovery) {
                failedResponse = response;
                return;
            }
            const recovery = await this.decodeRegistrationRecovery(
                response.data.recovery,
            );
            recoveredByChunk[chunkIndex] = recovery.items || [];
        });
        if (failedResponse) return failedResponse;
        return {
            code: 200,
            data: { recovery: { items: recoveredByChunk.flat() } },
        };
    }

    private async decodeRegistrationRecovery(value: any) {
        if (!value || value.encoding !== 'gzip-base64') return value || {};
        const encoded = `${value.payload || ''}`;
        const DecompressionStreamConstructor = (window as any).DecompressionStream;
        if (!encoded || typeof DecompressionStreamConstructor !== 'function') {
            throw new Error('압축된 복구 데이터를 이 브라우저에서 열 수 없습니다.');
        }
        const binary = window.atob(encoded);
        const bytes = new Uint8Array(binary.length);
        for (let index = 0; index < binary.length; index += 1) {
            bytes[index] = binary.charCodeAt(index);
        }
        const stream = new Blob([bytes]).stream().pipeThrough(
            new DecompressionStreamConstructor('gzip'),
        );
        return JSON.parse(await new Response(stream).text());
    }

    private recoveryAnalysisWithDraft(row: any) {
        const analysis = row?.analysis && typeof row.analysis === 'object'
            ? row.analysis : {};
        const corrections = row?.draft?.data?.ai_corrections
            && typeof row.draft.data.ai_corrections === 'object'
            ? row.draft.data.ai_corrections : {};
        const restoredFields = Array.isArray(
            analysis.recovery_draft_analysis_fields,
        ) ? analysis.recovery_draft_analysis_fields : [];
        const restored = { ...analysis };
        for (const key of ['xml_field_review', 'profile_fields', 'entities', 'multilingual']) {
            if (restoredFields.includes(key) && typeof corrections[key] !== 'undefined') {
                restored[key] = corrections[key];
            }
        }
        if (restoredFields.includes('ocr_text')) {
            restored.ocr = {
                ...(restored.ocr || {}),
                text: `${corrections.ocr_text || ''}`,
            };
        }
        delete restored.recovery_draft_analysis_fields;
        return restored;
    }

    private async requestRegistrationRecoveryProgress(progressId: string) {
        const query = new URLSearchParams({ mode: 'progress', progress_id: progressId });
        const response = await fetch(`/wiz/api/portal.post.detail/analyze?${query.toString()}`, {
            method: 'GET',
            credentials: 'same-origin',
        });
        if (!response.ok) {
            throw new Error(`분석 진행 상태를 불러오지 못했습니다. (HTTP ${response.status})`);
        }
        const payload = await response.json();
        const progress = payload && payload.code === 200 && payload.data
            ? payload.data.progress
            : null;
        if (!progress) throw new Error('분석 진행 상태 응답이 올바르지 않습니다.');
        return progress;
    }

    private isActiveRecoveryStatus(status: any) {
        return ['running', 'queued', 'reserved', 'processing'].includes(`${status || ''}`.toLowerCase());
    }

    private recoveryFailureMessage(rows: any[]) {
        const failed = rows.find((row: any) => ['failed', 'missing'].includes(`${row.status || ''}`.toLowerCase()));
        if (!failed) return '';
        return failed.error
            || (failed.progress && failed.progress.detail)
            || '분석 작업을 복구할 수 없습니다. 원문을 확인한 뒤 다시 시도해주세요.';
    }

    private async refreshActiveRecoveryProgress(rows: any[]) {
        const activeRows = rows.filter((row: any) => (
            this.isActiveRecoveryStatus(row.status) && row.progress_id
        ));
        await this.runBounded(
            activeRows,
            this.registrationPreflightConcurrency,
            async (row: any) => {
                const progress = await this.requestRegistrationRecoveryProgress(row.progress_id);
                row.progress = progress;
                row.status = progress.status || row.status;
            },
        );
        return rows;
    }

    private updateRecoveryProgress(rows: any[], snapshot: any) {
        const activeRows = rows.filter((row: any) => this.isActiveRecoveryStatus(row.status));
        const active = activeRows[0] || null;
        const progress = active && active.progress ? active.progress : {};
        const status = `${progress.status || active?.status || ''}`.toLowerCase();
        const rawPercent = Number(progress.percent);
        const hasActualPercent = Number.isFinite(rawPercent)
            && !['queued', 'reserved'].includes(status)
            && Number(progress.total_steps || 0) > 0;
        const savedItems = Array.isArray(snapshot.items) ? snapshot.items : [];
        const saved = active
            ? savedItems.find((item: any) => (
                (active.progress_id && item.progress_id === active.progress_id)
                || (active.analysis_id && item.analysis_id === active.analysis_id)
            ))
            : null;
        const completedCount = rows.filter((row: any) => row.status === 'complete' && row.analysis).length;
        const itemCount = Math.max(1, savedItems.length);
        const position = active
            ? `${Math.min(itemCount, completedCount + 1)} / ${itemCount}`
            : `${completedCount} / ${itemCount}`;
        const name = saved && saved.name ? ` · ${saved.name}` : '';

        this.recoveryModalState = 'progress';
        this.recoveryStageLabel = '분석 상태 복원 중';
        this.recoveryCurrentStage = progress.label || (
            status === 'queued' || status === 'reserved'
                ? '서버 처리 순서 확인 중'
                : '기존 분석 작업을 확인하고 있습니다.'
        );
        this.recoveryStageDetail = `복구 작업 ${position}${name}${progress.detail ? ` · ${progress.detail}` : ''}`;
        this.recoveryModalPercent = hasActualPercent
            ? Math.max(0, Math.min(100, Math.round(rawPercent)))
            : null;
    }

    private applyRecoveredAnalysisResult(item: any, row: any) {
        const analysis = this.normaliseAnalysis(
            this.recoveryAnalysisWithDraft(row),
        );
        const form = this.recoveredForm(analysis, row.draft);
        const progress = row && row.progress && typeof row.progress === 'object'
            ? row.progress : {};
        const localVisibilityStatus = `${
            item.visibilityStatus || item.form?.status || ''
        }`;
        if (
            !row?.draft?.visibility_confirmed
            && item.visibilityConfirmed
            && ['draft', 'published'].includes(localVisibilityStatus)
        ) {
            form.status = localVisibilityStatus;
        }
        const savedReasonCandidate = `${
            item.duplicateOverrideReason
            || form.duplicate_override_reason
            || (item.duplicateOverrideSelected
                ? this.duplicateVersionCheckboxReason : '')
        }`.trim();
        const savedReason = item.duplicateOverrideSelected
            && savedReasonCandidate.length < 5
            ? this.duplicateVersionCheckboxReason
            : savedReasonCandidate;
        const savedTarget = `${item.duplicateOverrideDocumentId || ''}`;
        const analysisTarget = `${
            analysis?.duplicate?.post_id
            || analysis?.duplicate_override?.document_id
            || ''
        }`;
        const savedOverrideReady = !!(
            analysis?.duplicate?.found
            && item.duplicateOverrideSelected
            && savedReason.length >= 5
            && savedTarget
            && savedTarget === analysisTarget
        );
        const localDraftRevision = `${item.draftRevision || ''}`;
        const serverDraftRevision = `${row?.draft?.revision || ''}`;
        if (
            item.localRecoveryDraft
            && (!serverDraftRevision || localDraftRevision === serverDraftRevision)
        ) {
            Object.assign(
                form,
                JSON.parse(JSON.stringify(item.localRecoveryDraft)),
            );
        }
        item.analysis = analysis;
        item.analysisId = `${analysis.id || item.analysisId || ''}`;
        item.form = form;
        item.visibilityConfirmed = !!(
            row?.draft?.visibility_confirmed
            || item.visibilityConfirmed
            || this.sourceVisibilityStatus(analysis)
        );
        item.visibilityStatus = item.visibilityConfirmed ? form.status : '';
        item.securityScan = analysis.security_scan || item.securityScan || null;
        item.securityAcknowledged = !!(
            item.securityScan
            && item.securityScan.protection_level === 'full'
        );
        form.security_acknowledged = item.securityAcknowledged;
        item.duplicateOverrideReason = savedReason;
        item.duplicateConfirmed = !analysis?.duplicate?.found || savedOverrideReady;
        item.duplicateOverrideSelected = savedOverrideReady;
        item.duplicateOverrideConfirmed = savedOverrideReady;
        form.duplicate_override_reason = savedReason;
        form.duplicate_confirmed = item.duplicateConfirmed;
        item.reviewChecks = this.normaliseReviewChecks(
            row?.draft?.review_checks || item.reviewChecks,
            this.defaultReviewChecks(analysis, form),
        );
        item.status = 'complete';
        item.progress = 100;
        item.processingStartedAt = Number(
            item.processingStartedAt || progress.started_epoch_ms || Date.now()
        );
        item.processingCompletedAt = Number(
            item.processingCompletedAt || Date.now()
        );
        item.completedSteps = 11;
        item.totalSteps = 11;
        item.stageLabel = 'Profile 판별 완료';
        item.stageDetail = '서버 분석이 완료되어 결과와 입력 초안을 준비했습니다.';
        item.failureStage = '';
        item.error = '';
        item.errorDetails = '';
        item.errorInfo = null;
        item.draftRevision = row.draft?.revision || item.draftRevision || '';
        item.metadataReviewState = this.normaliseMetadataReviewWorkflowState(
            row.draft?.workflow_state?.metadata_review || item.metadataReviewState,
        );
        item.registrationWorkflowState = row.draft?.workflow_state
            && typeof row.draft.workflow_state === 'object'
            ? { ...row.draft.workflow_state } : (item.registrationWorkflowState || {});
        item.metadataReviewPaused = false;
        item.recoveryDetailPending = false;
    }

    private recoveryProgressNeedsResume(row: any, item: any) {
        const progress = row && row.progress && typeof row.progress === 'object'
            ? row.progress : {};
        const status = `${progress.status || row?.status || ''}`.toLowerCase();
        return (
            ['queued', 'reserved'].includes(status)
            && !`${progress.updated || ''}`.trim()
            && !!`${item?.stagedSourceId || ''}`.trim()
        );
    }

    private async resumeRecoveredQueuedAnalysis(
        item: any,
        scanUnstartedRemoteSource: boolean = false,
    ) {
        if (!item.processingStartedAt) item.processingStartedAt = Date.now();
        const reconnecting = !!`${item.progressId || ''}`.trim();
        item.status = 'running';
        item.stageLabel = item.stagedSourceId
            ? reconnecting
                ? '서버 보존 원본 분석 다시 연결 중'
                : '서버 보존 원본 분석 시작 중'
            : reconnecting
                ? '기존 URL 분석 요청 다시 연결 중'
                : '대기 URL 분석 시작 중';
        item.stageDetail = item.stagedSourceId
            ? reconnecting
                ? '서버 작업공간의 원본으로 중단된 분석을 이어서 시작합니다.'
                : '서버 작업공간에 보존된 원본으로 분석을 시작합니다.'
            : reconnecting
                ? '같은 진행 ID로 실제 서버 분석을 이어서 시작합니다.'
                : '대기 중이던 URL 원본의 분석을 시작합니다.';
        await this.service.render();
        try {
            if (this.analysisCancellationRequested) {
                throw new Error('사용자가 이 등록 작업을 취소했습니다.');
            }
            if (item.stagedSourceId || scanUnstartedRemoteSource) {
                item.securityScan = await this.requestSecurityScan(
                    null,
                    item,
                    item.sourceUrl,
                );
                item.securityAcknowledged = item.securityScan.protection_level === 'full';
            }
            if (this.analysisCancellationRequested) {
                throw new Error('사용자가 이 등록 작업을 취소했습니다.');
            }
            const analysis = await this.requestAnalysis(
                null,
                item,
                item.sourceUrl,
                true,
            );
            this.applyRecoveredAnalysisResult(item, {
                analysis,
                draft: null,
            });
        } catch (error) {
            const cancelled = this.analysisCancellationRequested;
            const captured = cancelled
                ? {
                    message: '사용자가 이 등록 작업을 취소했습니다.',
                    details: '',
                }
                : this.captureError(
                    error,
                    '대기 중인 원본 분석을 시작하지 못했습니다.',
                );
            item.status = 'error';
            item.failureStage = 'analysis';
            item.error = captured.message;
            item.errorDetails = captured.details;
            item.errorInfo = cancelled ? {
                stage: 'cancelled',
                errorCode: 'ANALYSIS_CANCELLED',
                message: captured.message,
                userAction: '필요한 파일만 다시 시도해주세요.',
                retryable: true,
                requestId: '',
            } : captured;
            item.stageLabel = cancelled ? '처리 취소' : '처리 실패';
            item.stageDetail = captured.message;
        }
        item.processingCompletedAt = Date.now();
        this.persistRegistrationRecovery();
        await this.service.render();
    }

    private resumableWaitingAnalysisSources() {
        if (this.uploadSourceType !== 'file') return [];
        const activeKeys = new Set<string>();
        this.batchItems.forEach((item: any, index: number) => {
            activeKeys.add(this.registrationAnalysisSourceKey(item, index));
        });
        return this.registrationQueuedSources()
            .map((source: any, queueIndex: number) => {
                const fallback = this.processedRegistrationSourceCount + queueIndex;
                const descriptor = this.registrationAnalysisSourceDescriptor(
                    source,
                    fallback,
                );
                const preflight = this.filePreflights[queueIndex] || null;
                return {
                    key: descriptor.key,
                    source,
                    descriptor,
                    queueIndex,
                    preflight,
                };
            })
            .filter((candidate: any) => {
                if (activeKeys.has(`${candidate.key || ''}`)) return false;
                return !!candidate.descriptor.stagedSourceId
                    && this.filePreflightReady(candidate.preflight);
            });
    }

    public resumableWaitingAnalysisCount() {
        return this.resumableWaitingAnalysisSources().length;
    }

    public waitingAnalysisResumeLabel(
        waiting: number = this.resumableWaitingAnalysisCount(),
    ) {
        const next = Math.min(waiting, this.maxActiveBatchFiles);
        return waiting > this.maxActiveBatchFiles
            ? `다음 ${next}개 분석 재개`
            : `분석 대기 재개 · ${next}개`;
    }

    private waitingAnalysisRequestedProfile() {
        const profiles = Array.from(new Set(
            this.batchItems
                .map((item: any) => `${item?.requestedProfile || ''}`.trim())
                .filter(Boolean)
        ));
        return profiles.length === 1 ? profiles[0] : '';
    }

    private waitingAnalysisItem(candidate: any, requestedProfile: string = '') {
        const descriptor = candidate.descriptor || {};
        const preflight = candidate.preflight || {};
        const sourceCandidate = this.uploadFiles[candidate.queueIndex] || null;
        const sourceFile = this.isNativeUploadFile(sourceCandidate)
            ? sourceCandidate as File : null;
        const duplicateOverrideSelected = !!preflight.overrideSelected;
        const duplicateOverrideReason = duplicateOverrideSelected
            ? (`${preflight.overrideReason || ''}`.trim().length >= 5
                ? `${preflight.overrideReason}`
                : this.duplicateVersionCheckboxReason)
            : '';
        return {
            name: `${descriptor.name || `업로드 원본 ${descriptor.sourceIndex + 1}`}`,
            status: 'queued',
            progress: 0,
            stageLabel: '분석 재개 대기',
            stageDetail: '앞선 대기 원본이 끝나면 분석을 시작합니다.',
            completedSteps: 0,
            totalSteps: 11,
            securityScan: null,
            analysis: null,
            error: '',
            form: null,
            visibilityConfirmed: false,
            visibilityStatus: '',
            securityAcknowledged: false,
            duplicateConfirmed: false,
            duplicateOverrideSelected,
            duplicateOverrideConfirmed: duplicateOverrideSelected,
            progressId: '',
            securityProgressId: '',
            draftRevision: '',
            metadataReviewState: 'draft',
            metadataReviewPaused: false,
            registrationWorkflowState: {},
            sourceUrl: `${descriptor.sourceUrl || ''}`,
            sourceFile,
            sourceIndex: Number(descriptor.sourceIndex),
            stagedSourceId: `${descriptor.stagedSourceId || ''}`,
            failureStage: '',
            errorDetails: '',
            errorInfo: null,
            preflightHash: `${preflight.originalHash || descriptor.preflightHash || ''}`,
            preflightClaimToken: `${preflight.claimToken || ''}`,
            duplicateOverrideReason,
            duplicateOverrideDocumentId: `${preflight.existing?.document_id || ''}`,
            requestedProfile,
            processingStartedAt: 0,
            processingCompletedAt: 0,
            reviewChecks: this.normaliseReviewChecks(null),
            displayOnly: false,
        };
    }

    public async resumeWaitingAnalyses() {
        if (
            this.registerStep !== 'upload'
            || this.metaRecognizing
            || this.saving
            || this.recoveryRestoring
            || this.analysisCancellationRequested
        ) return;
        const candidates = this.resumableWaitingAnalysisSources()
            .slice(0, this.maxActiveBatchFiles);
        if (!candidates.length) return;

        const requestedProfile = this.waitingAnalysisRequestedProfile();
        const items = candidates.map(
            (candidate: any) => this.waitingAnalysisItem(
                candidate,
                requestedProfile,
            )
        );
        const firstBatchIndex = this.batchItems.length;
        const appendedKeys = new Set<string>(
            candidates.map((candidate: any) => `${candidate.key || ''}`)
        );
        this.metaRecognizing = true;
        this.analysisCancellationRequested = false;
        this.analysisBatchStartedAt = Date.now();
        this.analysisBatchFinishedAt = 0;
        this.batchItems.push(...items);
        this.analysisQueueFilter = 'all';
        const firstQueueIndex = this.analysisQueueIndexForBatchIndex(
            firstBatchIndex,
        ) ?? 0;
        this.analysisQueuePage = Math.floor(
            firstQueueIndex / this.analysisQueuePageSize
        ) + 1;
        this.selectedAnalysisInspectorIndex = firstQueueIndex;
        this.persistRegistrationRecovery();
        await this.service.render();

        const workspaceSaved = await this.saveRegistrationWorkspace(true);
        if (!workspaceSaved) {
            this.batchItems = this.batchItems.filter((item: any, index: number) => (
                !appendedKeys.has(this.registrationAnalysisSourceKey(item, index))
            ));
            this.metaRecognizing = false;
            this.analysisBatchFinishedAt = Date.now();
            this.persistRegistrationRecovery();
            await this.service.render();
            await this.service.modal.error(
                '분석 대기 항목을 서버 작업공간에 저장하지 못해 분석을 시작하지 않았습니다.'
            );
            return;
        }

        try {
            await this.runBounded(
                items,
                this.analysisWorkerConcurrency,
                async (item: any) => {
                    if (this.recoveryDestroyed) return;
                    if (this.analysisCancellationRequested) {
                        item.status = 'error';
                        item.failureStage = 'analysis';
                        item.error = '사용자가 이 등록 작업을 취소했습니다.';
                        item.errorInfo = {
                            stage: 'cancelled',
                            errorCode: 'ANALYSIS_CANCELLED',
                            message: item.error,
                            userAction: '필요한 파일만 다시 시도해주세요.',
                            retryable: true,
                            requestId: '',
                        };
                        item.stageLabel = '처리 취소';
                        item.stageDetail = '아직 시작하지 않은 대기 분석을 취소했습니다.';
                        item.processingCompletedAt = Date.now();
                        return;
                    }
                    await this.resumeRecoveredQueuedAnalysis(item, true);
                },
            );
        } finally {
            this.metaRecognizing = this.batchItems.some((item: any) => (
                ['scanning', 'running'].includes(`${item.status || ''}`)
            ));
            this.analysisCancellationRequested = false;
            this.analysisBatchFinishedAt = Date.now();
            this.rememberRegistrationAnalysisItems(this.batchItems);
            this.persistRegistrationRecovery();
            const finalWorkspaceSaved = await this.saveRegistrationWorkspace(true);
            if (!finalWorkspaceSaved) {
                this.recoveryNotice = '추가 분석 결과를 서버 작업공간에 저장하지 못했습니다. 현재 화면을 닫지 말고 다시 시도해주세요.';
            }
            await this.service.render();
        }
    }

    private async resumeRecoveredStagedAnalyses() {
        const queued = this.batchItems.filter((item: any) => (
            item?.status === 'queued'
            && !!`${item.stagedSourceId || ''}`.trim()
            && !item.analysis
        ));
        if (!queued.length) return;
        this.metaRecognizing = true;
        await this.service.render();
        try {
            await this.runBounded(
                queued,
                this.analysisWorkerConcurrency,
                async (item: any) => {
                    if (this.recoveryDestroyed) return;
                    await this.resumeRecoveredQueuedAnalysis(item);
                },
            );
        } finally {
            this.metaRecognizing = this.batchItems.some((item: any) => (
                ['scanning', 'running'].includes(item.status)
            ));
            const firstComplete = this.batchItems.findIndex((item: any) => (
                item.status === 'complete' && item.analysis && item.form
            ));
            if (firstComplete >= 0 && this.activeBatchIndex < 0) {
                await this.selectBatchItem(firstComplete);
            }
            this.persistRegistrationRecovery();
            await this.saveRegistrationWorkspace(true);
            await this.service.render();
        }
    }

    private async monitorRecoveredAnalyses() {
        if (this.recoveryMonitorPromise) return await this.recoveryMonitorPromise;
        const monitor = (async () => {
            try {
                while (!this.recoveryDestroyed) {
                    const activeItems = this.batchItems.filter((item: any) => (
                        item
                        && item.status === 'running'
                        && !item.recoveryDetailPending
                        && item.progressId
                        && !item.analysis
                    ));
                    if (!activeItems.length) break;
                    const response = await this.requestRegistrationRecovery({
                        items: activeItems.map((item: any) => ({
                            name: item.name || '',
                            analysis_id: '',
                            progress_id: item.progressId,
                        })),
                    });
                    const rows = response && response.code === 200
                        && response.data && response.data.recovery
                        ? response.data.recovery.items || []
                        : [];
                    const resumableItems: any[] = [];
                    for (const item of activeItems) {
                        const row = rows.find((candidate: any) => (
                            candidate.progress_id === item.progressId
                        )) || {};
                        if (row.analysis) {
                            this.applyRecoveredAnalysisResult(item, row);
                            continue;
                        }
                        if (this.recoveryProgressNeedsResume(row, item)) {
                            resumableItems.push(item);
                            continue;
                        }
                        if (
                            row.status
                            && !this.isActiveRecoveryStatus(row.status)
                        ) {
                            const captured = this.recoveredRegistrationError(
                                {
                                    name: item.name,
                                    progress_id: item.progressId,
                                    failure_stage: 'analysis',
                                },
                                row,
                                item.name || '복구 자료',
                            );
                            item.status = 'error';
                            item.failureStage = 'analysis';
                            item.error = captured.message;
                            item.errorDetails = captured.details;
                            item.errorInfo = captured;
                            item.stageLabel = '처리 실패';
                            item.stageDetail = captured.message;
                            continue;
                        }
                        const progress = row.progress || {};
                        if (this.applyServerAnalysisProgress(item, progress)) {
                            item.stageLabel = progress.label
                                || '기존 분석 계속 진행 중';
                            item.stageDetail = progress.detail
                                || '복구 화면을 닫아도 서버 분석은 계속됩니다.';
                        }
                    }
                    if (resumableItems.length) {
                        await this.runBounded(
                            resumableItems,
                            this.analysisWorkerConcurrency,
                            async (item: any) => {
                                if (this.recoveryDestroyed) return;
                                await this.resumeRecoveredQueuedAnalysis(item);
                            },
                        );
                    }
                    this.persistRegistrationRecovery();
                    await this.service.render();
                    if (this.batchItems.some((item: any) => (
                        item.status === 'running'
                        && !item.recoveryDetailPending
                        && item.progressId
                        && !item.analysis
                    ))) {
                        await this.service.sleep(this.recoveryPollIntervalMs);
                    }
                }
            } catch (error) {
                const captured = this.captureError(
                    error,
                    '기존 분석 진행 상태를 잠시 확인하지 못했습니다.',
                );
                this.recoveryNotice = `${captured.message} 기존 분석은 계속 유지됩니다.`;
            } finally {
                this.metaRecognizing = this.batchItems.some((item: any) => (
                    ['scanning', 'running'].includes(item.status)
                ));
                const firstComplete = this.batchItems.findIndex(
                    (item: any) => item.status === 'complete'
                        && item.analysis
                        && item.form
                );
                if (firstComplete >= 0 && this.activeBatchIndex < 0) {
                    await this.selectBatchItem(firstComplete);
                }
                this.persistRegistrationRecovery();
                await this.service.render();
            }
        })();
        this.recoveryMonitorPromise = monitor;
        try {
            await monitor;
        } finally {
            this.recoveryMonitorPromise = null;
        }
    }

    private recoveredRegistrationError(saved: any, row: any, name: string) {
        if (saved && saved.error_info && !row?.error_code) {
            return this.captureError(
                saved.error_info,
                saved.error || '이 파일의 이전 처리에 실패했습니다.'
            );
        }
        const progress = row && row.progress ? row.progress : {};
        const recoveredSaveState = ['save_failed', 'save_pending'].includes(
            `${row?.status || ''}`
        );
        return this.captureError({
            stage: recoveredSaveState
                ? 'save'
                : progress.stage || saved?.failure_stage || 'analysis',
            file_name: name,
            field: saved?.source_url ? 'source_url' : 'file',
            error_code: row?.error_code || 'ANALYSIS_FAILED',
            message: row?.error || progress.detail || saved?.error
                || '이 파일의 이전 처리에 실패했습니다.',
            user_action: row?.user_action || (
                saved?.source_url
                    ? '실패한 URL만 다시 시도해주세요.'
                    : '원문 파일을 다시 선택한 뒤 해당 파일만 처리해주세요.'
            ),
            retryable: typeof row?.retryable === 'boolean'
                ? row.retryable : !!saved?.source_url,
            request_id: '',
        }, '이 파일의 이전 처리에 실패했습니다.');
    }

    private async applyRegistrationRecovery(
        snapshot: any,
        recoveredRows: any[],
        deferMissingDetails: boolean = false,
    ) {
        const snapshotVersion = Math.max(0, Number(snapshot?.version || 0) || 0);
        const legacySavedRowsWereCredited = !!(
            snapshotVersion < 10
            && `${snapshot?.register_step || ''}` === 'metadata'
            && Number(snapshot?.completed_registration_count || 0) > 0
        );
        const queuedSources = Array.isArray(snapshot.queued_sources)
            ? snapshot.queued_sources
                .filter((source: any) => source && typeof source === 'object')
                .slice(0, this.maxBatchFiles)
            : [];
        this.registrationAnalysisSources = [];
        this.registrationAnalysisSourcesWorkspaceId = `${
            snapshot.workspace_id || this.registrationWorkspaceId || ''
        }`;
        this.mergeRegistrationAnalysisSources([
            ...queuedSources,
            ...(Array.isArray(snapshot.items) ? snapshot.items : []),
        ]);
        const recoveredProcessedCount = Math.max(
            0,
            Number(snapshot.processed_source_count ?? snapshot.completed_registration_count ?? 0) || 0,
        );
        const recoveredSourceIndexes = [
            ...queuedSources,
            ...(Array.isArray(snapshot.items) ? snapshot.items : []),
        ].map((row: any) => Number(row?.source_index ?? row?.index ?? -1))
            .filter((value: number) => Number.isInteger(value) && value >= 0);
        const recoveredIndexedTotal = recoveredSourceIndexes.length
            ? Math.max(...recoveredSourceIndexes) + 1 : 0;
        this.processedRegistrationSourceCount = recoveredProcessedCount;
        const recoveredSelectedCount = Math.max(
            0,
            Number(snapshot.selected_source_count || 0) || 0,
        );
        this.selectedRegistrationSourceCount = recoveredSelectedCount > 0
            ? Math.max(
                recoveredSelectedCount,
                recoveredProcessedCount + queuedSources.length,
            )
            : Math.max(
                recoveredProcessedCount + queuedSources.length,
                recoveredIndexedTotal,
                this.registrationWorkspaceSourceCount,
            );
        const selectedXmlUrls = Array.isArray(snapshot.xml_urls)
            ? snapshot.xml_urls.filter((url: any) => typeof url === 'string' && /^https?:\/\//i.test(url)).slice(0, this.maxBatchFiles)
            : [];
        const hasServerWork = (snapshot.items || []).some(
            (item: any) => item.analysis_id || item.progress_id
        );
        const hasRecoverableItemState = (snapshot.items || []).some(
            (item: any) => (
                item.error_info
                || item.error
                || item.duplicate_override_selected
                || item.duplicate_override_confirmed
                || item.duplicate_override_reason
            )
        );
        if (
            !hasServerWork
            && !hasRecoverableItemState
            && snapshot.upload_source_type === 'url'
            && (selectedXmlUrls.length || queuedSources.length)
        ) {
            this.uploadSourceType = 'url';
            this.xmlUrls = Array.from(new Set(
                selectedXmlUrls.length
                    ? selectedXmlUrls
                    : queuedSources.map((source: any) => `${source.source_url || ''}`).filter(Boolean)
            ));
            this.xmlUrl = '';
            this.uploadFileName = this.xmlUrlSelectionLabel();
            this.registerStep = 'upload';
            this.recoveryNotice = this.xmlUrls.length + '개 XML URL 입력 목록을 복구했습니다. 분석을 다시 시작해주세요.';
            await this.service.render();
            return;
        }

        const restored: any[] = [];
        let recoveredSavedOutsideQueue = 0;
        for (const saved of snapshot.items || []) {
            const row = recoveredRows.find((candidate: any) => (
                (saved.analysis_id && candidate.analysis_id === saved.analysis_id)
                || (saved.progress_id && candidate.progress_id === saved.progress_id)
            )) || {};
            const name = saved.name || row?.analysis?.source?.name || '복구 자료';
            const savedSourceIndex = Number(saved.source_index);
            const sourceIndex = Number.isInteger(savedSourceIndex) && savedSourceIndex >= 0
                ? savedSourceIndex : restored.length;
            const queuedSource = queuedSources.find((source: any, queueIndex: number) => (
                Number(source.source_index ?? source.index ?? queueIndex) === sourceIndex
                || (
                    (saved.staged_source_id || saved.source_id)
                    && `${source.source_id || ''}` === `${saved.staged_source_id || saved.source_id}`
                )
            )) || {};
            const sourceStillQueued = !!Object.keys(queuedSource).length;
            const recoveredRegistrationSaved = !!(
                row?.status === 'saved'
                && row?.registration?.post_id
            );
            if (
                (saved.status === 'saved' || recoveredRegistrationSaved)
                && queuedSources.length
                && !sourceStillQueued
            ) {
                recoveredSavedOutsideQueue += 1;
                continue;
            }
            const hasAnalysis = !!(row && row.analysis);
            const analysis = hasAnalysis ? this.normaliseAnalysis(
                this.recoveryAnalysisWithDraft(row),
            ) : null;
            const form = analysis ? this.recoveredForm(analysis, row.draft, {
                confirmed: !!saved.visibility_confirmed,
                status: saved.visibility_status || '',
            }) : null;
            const localDraftIsCurrent = this.registrationRecoveryLocalDraftIsCurrent(
                saved,
                row,
            );
            if (form && localDraftIsCurrent) {
                Object.assign(
                    form,
                    JSON.parse(JSON.stringify(saved.local_draft)),
                );
            }
            const deferredDetailRecovery = !!(
                deferMissingDetails
                && !analysis
                && !row?.status
                && (saved.analysis_id || saved.progress_id)
            );
            const activeRecovery = !analysis && (
                deferredDetailRecovery
                || this.isActiveRecoveryStatus(
                    row.status || row?.progress?.status
                )
            );
            const stagedQueuedRecovery = !!(
                !analysis
                && !activeRecovery
                && `${
                    saved.staged_source_id
                    || saved.source_id
                    || queuedSource.source_id
                    || ''
                }`
                && ['queued', 'scanning'].includes(`${saved.status || ''}`)
            );
            const recoveredSaveState = ['save_failed', 'save_pending'].includes(
                `${row?.status || ''}`
            );
            const restoreSaveFailure = !recoveredRegistrationSaved && (
                recoveredSaveState
                || (
                    saved.status === 'error'
                    && saved.failure_stage === 'save'
                    && !!analysis
                    && !!form
                )
            );
            const errorInfo = !recoveredRegistrationSaved && (
                restoreSaveFailure
                || (!analysis && !activeRecovery && !stagedQueuedRecovery)
            )
                ? this.recoveredRegistrationError(saved, row, name)
                : null;
            const restoredStatus = activeRecovery
                ? 'running'
                : stagedQueuedRecovery
                ? 'queued'
                : errorInfo
                ? 'error'
                : saved.status === 'saved' ? 'saved' : 'complete';
            const durableRestoredStatus = recoveredRegistrationSaved
                ? 'saved' : restoredStatus;
            const restoredOverrideSelected = !!(
                saved.duplicate_override_selected
                || (form && form.duplicate_confirmed)
            );
            const restoredOverrideReasonCandidate = `${
                saved.duplicate_override_reason
                || (form ? form.duplicate_override_reason || '' : '')
            }`.trim();
            const restoredOverrideReason = restoredOverrideSelected
                && restoredOverrideReasonCandidate.length < 5
                ? this.duplicateVersionCheckboxReason
                : restoredOverrideReasonCandidate;
            const restoredItem: any = {
                name,
                status: restoredStatus,
                progress: analysis
                    ? 100
                    : this.safeNumber(row?.progress?.percent, 0),
                stageLabel: deferredDetailRecovery
                    ? '상세 정보 불러오는 중'
                    : activeRecovery
                    ? row?.progress?.label || '기존 분석 계속 진행 중'
                    : stagedQueuedRecovery
                    ? '서버 보존 원본 분석 재개 대기'
                    : errorInfo
                    ? this.registrationErrorStageLabel(errorInfo.stage)
                    : durableRestoredStatus === 'saved' ? '이미 자료함 등록 완료' : '이전 분석 결과 복구 완료',
                stageDetail: deferredDetailRecovery
                    ? '작업 화면을 먼저 열고 서버에 저장된 상세 검수 내용을 병렬로 불러옵니다.'
                    : activeRecovery
                    ? row?.progress?.detail || '복구 화면을 닫아도 서버 분석은 계속됩니다.'
                    : stagedQueuedRecovery
                    ? '서버에 보존된 원본으로 중단된 분석을 이어서 시작합니다.'
                    : errorInfo
                    ? errorInfo.message
                    : durableRestoredStatus === 'saved'
                        ? '완료된 자료는 다시 생성하지 않고 기존 등록 상태를 유지합니다.'
                        : '서버에 보관된 분석 결과와 입력 초안을 복구했습니다.',
                completedSteps: analysis ? 11 : this.safeNumber(row?.progress?.completed_steps, 0),
                totalSteps: analysis ? 11 : this.safeNumber(row?.progress?.total_steps, 11),
                securityScan: analysis ? analysis.security_scan || null : null,
                analysis,
                error: errorInfo ? errorInfo.message : '',
                form,
                visibilityConfirmed: !!(
                    row?.draft?.visibility_confirmed
                    || saved.visibility_confirmed
                    || this.sourceVisibilityStatus(analysis)
                ),
                visibilityStatus: `${
                    row?.draft?.visibility_confirmed
                        ? row?.draft?.data?.status || ''
                        : saved.visibility_confirmed
                            ? saved.visibility_status || ''
                            : this.sourceVisibilityStatus(analysis)
                }`,
                securityAcknowledged: !!(form && form.security_acknowledged),
                duplicateConfirmed: !!(
                    (form && form.duplicate_confirmed)
                    || (
                        analysis?.duplicate?.found
                        && restoredOverrideSelected
                        && restoredOverrideReason.length >= 5
                    )
                ),
                duplicateOverrideSelected: restoredOverrideSelected,
                duplicateOverrideConfirmed: restoredOverrideSelected,
                duplicateOverrideReason: restoredOverrideReason,
                duplicateOverrideDocumentId: `${
                    saved.duplicate_override_document_id || ''
                }`,
                reviewChecks: analysis && form
                    ? this.normaliseReviewChecks(
                        row?.draft?.review_checks || saved.review_checks,
                        this.defaultReviewChecks(analysis, form)
                    )
                    : this.normaliseReviewChecks(saved.review_checks),
                metadataReviewState: this.normaliseMetadataReviewWorkflowState(
                    row?.draft?.workflow_state?.metadata_review
                    || saved?.workflow_state?.metadata_review
                    || saved?.metadata_review_state,
                ),
                metadataReviewPaused: !!saved.metadata_review_paused,
                registrationWorkflowState: row?.draft?.workflow_state
                    && typeof row.draft.workflow_state === 'object'
                    ? { ...row.draft.workflow_state }
                    : saved?.workflow_state && typeof saved.workflow_state === 'object'
                        ? { ...saved.workflow_state } : {},
                registrationPreflight: row?.draft
                    ? (
                        row.draft?.preflight_cache?.preflight
                        && typeof row.draft.preflight_cache.preflight === 'object'
                    )
                        ? { ...row.draft.preflight_cache.preflight }
                        : null
                    : saved?.registration_preflight
                        && typeof saved.registration_preflight === 'object'
                            ? { ...saved.registration_preflight } : null,
                registrationPreflightDraftRevision: `${
                    row?.draft
                        ? row.draft?.preflight_cache?.draft_revision || ''
                        : saved?.registration_preflight_revision || ''
                }`,
                registrationPreflightSourceChecksum: `${
                    row?.draft
                        ? row.draft?.preflight_cache?.source_checksum || ''
                        : saved?.registration_preflight_source_checksum || ''
                }`,
                registrationResult: recoveredRegistrationSaved
                    ? { ...row.registration }
                    : saved?.registration_result
                        && typeof saved.registration_result === 'object'
                            ? { ...saved.registration_result } : null,
                registrationCounted: saved?.registration_counted === true || (
                    legacySavedRowsWereCredited
                    && (saved.status === 'saved' || recoveredRegistrationSaved)
                ),
                failureStage: errorInfo
                    ? (restoreSaveFailure ? 'save' : saved.failure_stage || 'analysis')
                    : '',
                errorDetails: errorInfo?.details || '',
                errorInfo,
                processingStartedAt: Number(
                    saved.processing_started_at
                    || row?.progress?.started_epoch_ms
                    || 0
                ),
                processingCompletedAt: Number(
                    saved.processing_completed_at
                    || (
                        analysis
                        && row?.progress?.started_epoch_ms
                        && row?.progress?.total_duration_ms
                            ? Number(row.progress.started_epoch_ms)
                                + Number(row.progress.total_duration_ms)
                            : 0
                    )
                ),
                sourceFile: null,
                sourceIndex,
                analysisId: saved.analysis_id || row?.analysis_id || '',
                stagedSourceId: `${
                    saved.staged_source_id || saved.source_id || queuedSource.source_id || ''
                }`,
                progressId: saved.progress_id || row?.progress_id || '',
                sourceUrl: saved.source_url || (analysis && analysis.source ? analysis.source.url || '' : ''),
                preflightHash: `${saved.preflight_hash || ''}`,
                preflightClaimToken: `${saved.preflight_claim_token || ''}`,
                requestedProfile: `${saved.requested_profile || ''}`,
                draftRevision: row.draft?.revision || '',
                localRecoveryDraft: localDraftIsCurrent
                    ? JSON.parse(JSON.stringify(saved.local_draft)) : null,
                localRecoveryDraftHash: localDraftIsCurrent
                    ? JSON.stringify(saved.local_draft) : '',
                recoveryDetailPending: deferredDetailRecovery,
            };
            restoredItem.status = durableRestoredStatus;
            restored.push(restoredItem);
        }
        if (!restored.length && !queuedSources.length) {
            throw new Error('복구할 등록 작업 정보가 없습니다.');
        }

        this.uploadSourceType = snapshot.upload_source_type === 'url' ? 'url' : 'file';
        if (this.uploadSourceType === 'file') {
            this.uploadFiles = queuedSources.map((source: any, index: number) => ({
                name: `${source.name || `복구 원본 ${index + 1}`}`,
                size: Number(source.size || 0),
                type: `${source.mime_type || 'application/octet-stream'}`,
                lastModified: Number(source.last_modified || 0),
                __registrationPlaceholder: true,
                __registrationSourceIndex: Number(
                    source.source_index ?? source.index ?? index
                ),
                stagedSourceId: `${
                    source.staged === true
                        ? source.source_id || source.staged_source_id || ''
                        : ''
                }`,
                originalHash: `${source.original_hash || source.checksum_sha256 || ''}`,
            }));
            this.filePreflights = queuedSources.map((source: any, index: number) => ({
                name: `${source.name || `복구 원본 ${index + 1}`}`,
                status: `${source.preflight_status || 'new'}`,
                label: '서버 보존 원본',
                message: '서버에 보존된 원본으로 남은 검수와 분석을 이어갑니다.',
                progress: 100,
                originalHash: `${source.original_hash || source.checksum_sha256 || ''}`,
                claimToken: '',
                blocking: false,
                restricted: false,
                canOverride: typeof source.can_override === 'boolean'
                    ? source.can_override
                    : !!(
                        `${source.preflight_status || ''}` === 'registered'
                        && this.aiSettingsAdmin
                    ),
                ownedByMe: source.owned_by_me !== false,
                canOverwrite: false,
                overwriteToken: '',
                overwritePending: false,
                releasePending: false,
                overrideSelected: !!source.duplicate_override_selected,
                overrideConfirmed: !!source.duplicate_override_selected,
                overrideReason: source.duplicate_override_selected
                    ? (`${source.duplicate_override_reason || ''}`.trim().length >= 5
                        ? `${source.duplicate_override_reason}`
                        : this.duplicateVersionCheckboxReason)
                    : '',
                existing: source.existing || null,
                policy: `${source.policy || ''}`,
                sourceIndex: Number(source.source_index ?? source.index ?? index),
                stagedSourceId: `${
                    source.staged === true
                        ? source.source_id || source.staged_source_id || ''
                        : ''
                }`,
                staged: !!(
                    source.staged === true
                    && (source.source_id || source.staged_source_id)
                ),
                stageStatus: source.staged === true
                    && (source.source_id || source.staged_source_id)
                    ? 'staged' : `${source.stage_status || 'error'}`,
                stageError: `${source.stage_error || (
                    source.staged === true ? '' : '원본이 서버에 전송되기 전에 작업이 중단되었습니다. 원본을 다시 선택해주세요.'
                )}`,
                stageProgress: source.staged === true
                    && (source.source_id || source.staged_source_id) ? 100 : 0,
                stagedAt: `${source.staged_at || ''}`,
                stagedBy: `${source.staged_by || ''}`,
                size: Number(source.size || 0),
                mimeType: `${source.mime_type || 'application/octet-stream'}`,
                lastModified: Number(source.last_modified || 0),
            }));
            restored.forEach((item: any) => {
                const sourceQueueIndex = this.filePreflights.findIndex(
                    (row: any) => Number(row.sourceIndex) === Number(item.sourceIndex)
                );
                if (sourceQueueIndex >= 0) {
                    item.sourceFile = this.uploadFiles[sourceQueueIndex];
                    item.stagedSourceId = item.stagedSourceId
                        || this.filePreflights[sourceQueueIndex].stagedSourceId;
                }
            });
            this.uploadFile = this.uploadFiles[0] || null;
        } else {
            this.uploadFiles = [];
            this.filePreflights = [];
            this.uploadFile = null;
        }
        this.batchItems = restored;
        this.rememberRegistrationAnalysisItems(restored);
        const recoveredStartTimes = restored
            .map((item: any) => Number(item.processingStartedAt || 0))
            .filter((value: number) => Number.isFinite(value) && value > 0);
        const recoveredFinishTimes = restored
            .map((item: any) => Number(item.processingCompletedAt || 0))
            .filter((value: number) => Number.isFinite(value) && value > 0);
        const recoveredWorkInProgress = restored.some((item: any) => (
            ['queued', 'scanning', 'running'].includes(`${item.status || ''}`)
        ));
        this.analysisBatchStartedAt = Number(
            snapshot.analysis_batch_started_at
            || (recoveredStartTimes.length ? Math.min(...recoveredStartTimes) : 0)
            || (recoveredWorkInProgress ? Date.now() : 0)
        );
        this.analysisBatchFinishedAt = Number(
            snapshot.analysis_batch_finished_at
            || (!recoveredWorkInProgress && recoveredFinishTimes.length
                ? Math.max(...recoveredFinishTimes) : 0)
        );
        this.selectedVisibilityKeys = [];
        this.metadataReviewFileFilter = 'all';
        this.metadataAdvanceMode = snapshot.metadata_advance_mode === 'selected'
            ? 'selected' : 'all';
        const savedAdvanceKeys = Array.isArray(snapshot.metadata_advance_selection_keys)
            ? snapshot.metadata_advance_selection_keys
                .map((key: any) => `${key || ''}`)
                .filter(Boolean)
            : [];
        const restoredAdvanceKeys = restored
            .map((item: any, index: number) => ({ item, index }))
            .filter((row: any) => row.item.metadataReviewState === 'advanced')
            .map((row: any) => this.metadataReviewItemKey(row.item, row.index));
        this.metadataAdvanceSelectionKeys = Array.from(new Set([
            ...savedAdvanceKeys,
            ...restoredAdvanceKeys,
        ]));
        if (
            this.metadataAdvanceMode === 'selected'
            && this.metadataAdvanceSelectionKeys.length === 0
        ) {
            this.metadataAdvanceMode = 'all';
        }
        this.xmlUrls = this.uploadSourceType === 'url'
            ? Array.from(new Set(
                selectedXmlUrls.length
                    ? selectedXmlUrls
                    : restored.map((item: any) => item.sourceUrl).filter(Boolean)
            ))
            : [];
        this.xmlUrl = '';
        const recoveredStagedSourceCount = queuedSources.filter((source: any) => (
            source?.staged === true
            && !!`${source?.source_id || source?.staged_source_id || ''}`
        )).length;
        this.uploadFileName = this.uploadSourceType === 'file' && this.uploadFiles.length
            ? this.uploadFiles.length === 1
                ? this.uploadFiles[0].name
                : `${this.uploadFiles.length}개 원본 목록 복구 · 서버 보존 ${recoveredStagedSourceCount}개`
            : restored.length === 1
                ? restored[0].name
                : restored.length + '개 등록 작업 복구됨';
        this.completedRegistrationCount = Math.max(
            recoveredSavedOutsideQueue,
            Number(snapshot.completed_registration_count || 0),
        );
        this.registrationWorkspaceId = `${snapshot.workspace_id || this.registrationWorkspaceId || ''}`;
        this.registrationWorkspaceSourceCount = Math.max(
            this.registrationWorkspaceSourceCount,
            recoveredStagedSourceCount,
        );
        this.selectedRegistrationSourceCount = Math.max(
            this.selectedRegistrationSourceCount,
            this.processedRegistrationSourceCount + this.queuedRegistrationSourceCount(),
            this.registrationWorkspaceSourceCount,
        );

        const legacyStep = ['metadata', 'manual', 'complete'].includes(snapshot.register_step)
            ? snapshot.register_step : 'metadata';
        const restoredStep = legacyStep === 'manual' ? 'complete' : legacyStep;
        const restrictToAdvanceScope = restoredStep === 'complete';
        const recoveryItemSelectable = (item: any, index: number) => (
            !!item?.analysis
            && !!item?.form
            && item.status !== 'saved'
            && (
                !restrictToAdvanceScope
                || this.metadataAdvanceItemIncluded(item, index)
            )
        );
        const requestedIndex = Math.max(
            0,
            Math.min(restored.length - 1, Number(snapshot.active_index) || 0)
        );
        const requestedItem = restored[requestedIndex];
        const selectableIndex = recoveryItemSelectable(requestedItem, requestedIndex)
            ? requestedIndex
            : restored.findIndex((item: any, index: number) => (
                recoveryItemSelectable(item, index)
            ));
        if (selectableIndex >= 0) {
            this.registerStep = restoredStep;
            this.metadataSection = ['visibility', 'bibliography'].includes(snapshot.metadata_section)
                ? snapshot.metadata_section : 'bibliography';
            this.reviewSection = typeof snapshot.review_section === 'string'
                ? snapshot.review_section : '';
            await this.selectBatchItem(selectableIndex);
        } else {
            this.registerStep = 'upload';
            this.metadataSection = 'visibility';
            this.reviewSection = '';
            this.activeBatchIndex = -1;
        }

        const failed = restored.filter((item: any) => item.status === 'error').length;
        const complete = restored.length - failed;
        this.analysisQueueSearch = '';
        this.analysisQueueFilter = 'all';
        this.analysisQueuePage = 1;
        this.selectedAnalysisInspectorIndex = null;
        this.analysisInspectorOpen = this.defaultAnalysisInspectorOpen();
        this.analysisError = failed
            ? `${failed}개 파일의 실패 단계와 조치 방법을 복구했습니다.`
            : '';
        this.recoveryNotice = failed
            ? `${complete}개 정상 결과와 ${failed}개 실패 행을 함께 복구했습니다.`
            : `${complete}개 파일의 분석 결과와 입력 초안을 복구했습니다.`;
        const detailPending = restored.filter(
            (item: any) => item.recoveryDetailPending,
        ).length;
        const active = restored.filter((item: any) => (
            item.status === 'running' && !item.recoveryDetailPending
        )).length;
        const stagedQueued = restored.filter((item: any) => (
            item.status === 'queued'
            && !!`${item.stagedSourceId || ''}`.trim()
        )).length;
        if (active) {
            this.metaRecognizing = true;
            this.recoveryNotice = `${active}개 분석은 기존 작업을 그대로 이어서 확인하고 있습니다. 화면 복구를 기다릴 필요가 없습니다.`;
        } else if (detailPending) {
            this.recoveryNotice = `${detailPending}개 파일의 상세 검수 내용을 백그라운드에서 불러오고 있습니다.`;
        } else if (stagedQueued) {
            this.metaRecognizing = true;
            this.recoveryNotice = `${stagedQueued}개 서버 보존 원본의 중단된 분석을 순서대로 이어서 시작합니다.`;
        }
        this.persistRegistrationRecovery();
        await this.service.render();
    }

    private continueRecoveredRegistrationWork() {
        const active = this.batchItems.some((item: any) => (
            item?.status === 'running'
            && !item.recoveryDetailPending
            && !!item.progressId
            && !item.analysis
        ));
        const stagedQueued = this.batchItems.some((item: any) => (
            item?.status === 'queued'
            && !!`${item.stagedSourceId || ''}`.trim()
            && !item.analysis
        ));
        if (this.registerStep === 'complete' && !active) {
            void this.refreshRegistrationPreflight();
        }
        if (active || stagedQueued) {
            void (async () => {
                if (active) await this.monitorRecoveredAnalyses();
                if (stagedQueued) await this.resumeRecoveredStagedAnalyses();
            })();
        }
    }

    private async restoreRegistrationRecovery(snapshot: any, startedAt: number) {
        const selectedXmlUrls = Array.isArray(snapshot.xml_urls)
            ? snapshot.xml_urls.filter((url: any) => typeof url === 'string' && /^https?:\/\//i.test(url)).slice(0, this.maxBatchFiles)
            : [];
        const hasServerWork = (snapshot.items || []).some(
            (item: any) => item.analysis_id || item.progress_id
        );
        if (!hasServerWork && snapshot.upload_source_type === 'url' && selectedXmlUrls.length) {
            this.recoveryStageLabel = '결과 불러오는 중';
            this.recoveryStageDetail = '저장된 XML URL 입력 목록을 복원합니다.';
            this.recoveryCurrentStage = '마지막 입력 상태를 적용하고 있습니다.';
            this.recoveryModalPercent = null;
            await this.service.render();
            await this.applyRegistrationRecovery(snapshot, []);
            return;
        }

        const savedItems = Array.isArray(snapshot.items) ? snapshot.items : [];
        const requestedIndex = Math.max(
            0,
            Math.min(savedItems.length - 1, Number(snapshot.active_index) || 0),
        );
        const requestedItem = savedItems[requestedIndex];
        const foregroundItem = (
            requestedItem?.analysis_id || requestedItem?.progress_id
        ) ? requestedItem
            : savedItems.find((item: any) => item?.analysis_id || item?.progress_id);
        const response = await this.requestRegistrationRecovery({
            items: foregroundItem ? [foregroundItem] : [],
        });
        if (!response || response.code !== 200 || !response.data || !response.data.recovery) {
            throw new Error('이전 등록 작업 정보를 불러오지 못했습니다.');
        }
        const recoveredRows = response.data.recovery.items || [];
        const activeRows = recoveredRows.filter((row: any) => (
            this.isActiveRecoveryStatus(row.status)
        ));
        if (activeRows.length) {
            await this.refreshActiveRecoveryProgress(recoveredRows);
            this.updateRecoveryProgress(recoveredRows, snapshot);
            await this.service.render();
        }

        if (this.recoveryDestroyed) return;
        this.recoveryModalState = 'progress';
        this.recoveryStageLabel = '결과 불러오는 중';
        this.recoveryStageDetail = '분석 결과와 마지막 입력 초안을 기존 작업 화면에 적용합니다.';
        this.recoveryCurrentStage = '복구할 화면과 단계를 구성하고 있습니다.';
        this.recoveryModalPercent = null;
        await this.service.render();
        await this.applyRegistrationRecovery(snapshot, recoveredRows, true);
    }

    private async hydrateDeferredRegistrationRecoveryDetails() {
        if (this.recoveryHydrationPromise) return await this.recoveryHydrationPromise;
        const pending = this.batchItems.filter(
            (item: any) => item?.recoveryDetailPending,
        );
        if (!pending.length) return;
        const hydrate = (async () => {
            let completed = 0;
            await this.runBounded(
                pending,
                this.registrationRecoveryDetailConcurrency,
                async (item: any) => {
                    try {
                        const response = await this.requestRegistrationRecovery({
                            items: [{
                                analysis_id: item.analysisId || '',
                                progress_id: item.progressId || '',
                            }],
                        });
                        const row = response?.code === 200
                            ? response.data?.recovery?.items?.[0] : null;
                        if (row?.analysis) {
                            this.applyRecoveredAnalysisResult(item, row);
                        } else if (row && this.isActiveRecoveryStatus(row.status)) {
                            item.recoveryDetailPending = false;
                            item.status = 'running';
                            item.stageLabel = row?.progress?.label || '기존 분석 계속 진행 중';
                            item.stageDetail = row?.progress?.detail || '서버 분석이 끝나면 상세 내용을 자동으로 불러옵니다.';
                        } else {
                            const captured = this.recoveredRegistrationError(
                                item,
                                row || {},
                                item.name || '복구 자료',
                            );
                            item.recoveryDetailPending = false;
                            item.status = 'error';
                            item.failureStage = 'analysis';
                            item.error = captured.message;
                            item.errorDetails = captured.details;
                            item.errorInfo = captured;
                            item.stageLabel = '상세 복구 실패';
                            item.stageDetail = captured.message;
                        }
                    } catch (error) {
                        const captured = this.captureError(
                            error,
                            `${item.name || '파일'}의 상세 정보를 불러오지 못했습니다.`,
                        );
                        item.recoveryDetailPending = false;
                        item.status = 'error';
                        item.failureStage = 'analysis';
                        item.error = captured.message;
                        item.errorDetails = captured.details;
                        item.errorInfo = captured;
                        item.stageLabel = '상세 복구 실패';
                        item.stageDetail = captured.message;
                    } finally {
                        completed += 1;
                        this.recoveryNotice = completed < pending.length
                            ? `상세 검수 정보 ${completed} / ${pending.length}개를 불러왔습니다.`
                            : `${pending.length}개 파일의 상세 검수 정보를 모두 불러왔습니다.`;
                        this.scheduleAnalysisProgressRender();
                    }
                },
            );
            this.rememberRegistrationAnalysisItems(this.batchItems);
            this.persistRegistrationRecovery();
            await this.service.render();
            this.continueRecoveredRegistrationWork();
        })();
        this.recoveryHydrationPromise = hydrate;
        try {
            await hydrate;
        } finally {
            this.recoveryHydrationPromise = null;
        }
    }

    public async beginRegistrationRecovery(resumeStartedAt?: number) {
        if (this.recoveryRestoring || this.recoveryAttemptPromise || !this.recoverySnapshot) return;
        this.recoveryRestoring = true;
        this.recoveryModalOpen = true;
        this.recoveryModalState = 'progress';
        this.recoveryModalPercent = null;
        this.recoveryStageLabel = '작업 정보 확인 중';
        this.recoveryStageDetail = '복구할 작업과 마지막 저장 시점을 확인합니다.';
        this.recoveryCurrentStage = '';
        this.recoveryErrorMessage = '';
        const startedAt = this.markActiveRegistrationRecovery(
            this.recoverySnapshot,
            Number(resumeStartedAt || 0) || Date.now(),
        );
        await this.service.render();

        const attempt = (async () => {
            try {
                await this.restoreRegistrationRecovery(this.recoverySnapshot, startedAt);
                if (this.recoveryDestroyed) return;
                const activated = await this.setRegistrationWorkspaceState('active', false);
                if (!activated) {
                    throw new Error(
                        '복구한 작업을 진행 상태로 전환하지 못했습니다. 기존 서버 데이터는 유지됩니다.'
                    );
                }
                this.continueRecoveredRegistrationWork();
                void this.hydrateDeferredRegistrationRecoveryDetails();
                this.clearActiveRegistrationRecovery();
                this.recoveryModalState = 'success';
                this.recoveryModalPercent = 100;
                this.recoveryStageLabel = '복구 완료';
                this.recoveryStageDetail = '마지막으로 작업하던 단계와 파일로 돌아갑니다.';
                this.recoveryCurrentStage = '기존 작업 화면을 표시합니다.';
                await this.service.render();
                await this.service.sleep(250);
                if (this.recoveryDestroyed) return;
                this.recoveryModalOpen = false;
                this.recoveryRestoring = false;
                this.recoverySnapshot = null;
                await this.service.render();
            } catch (error) {
                if (this.recoveryDestroyed) return;
                this.clearActiveRegistrationRecovery();
                const captured = this.captureError(error, '등록 작업 복구에 실패했습니다.');
                this.technicalErrorDetails = captured.details;
                this.recoveryRestoring = false;
                this.recoveryModalState = 'error';
                this.recoveryModalPercent = null;
                this.recoveryStageLabel = '작업을 복구하지 못했습니다';
                this.recoveryStageDetail = '기존 분석 작업은 삭제하거나 새로 만들지 않았습니다.';
                this.recoveryCurrentStage = '';
                this.recoveryErrorMessage = captured.message;
                await this.service.render();
            }
        })();
        this.recoveryAttemptPromise = attempt;
        try {
            await attempt;
        } finally {
            this.recoveryAttemptPromise = null;
        }
    }

    public async retryRegistrationRecovery() {
        if (this.recoveryRestoring) return;
        await this.beginRegistrationRecovery();
    }

    public async deferRegistrationRecovery() {
        if (this.recoveryRestoring) return;
        this.clearActiveRegistrationRecovery();
        this.recoveryModalOpen = false;
        this.recoverySnapshot = null;
        this.recoveryErrorMessage = '';
        await this.service.render();
    }

    public async startFreshRegistration() {
        if (this.recoveryRestoring) return;
        const discarded = await this.setRegistrationWorkspaceState('discarded');
        if (!discarded) {
            await this.service.modal.error(
                '기존 작업의 중단 상태를 서버에 기록하지 못했습니다. 잠시 후 다시 시도해주세요.'
            );
            return;
        }
        this.clearRegistrationRecovery();
        this.registrationWorkspaceId = '';
        this.registrationWorkspaceRevision = '';
        this.registrationWorkspaceSourceCount = 0;
        this.selectedRegistrationSourceCount = 0;
        this.processedRegistrationSourceCount = 0;
        this.registrationWorkspaceSavedAt = '';
        this.registrationWorkspaceSavedBy = '';
        this.registrationWorkspaceStatus = 'idle';
        this.registrationWorkspaceMessage = '';
        this.registrationWorkspaceLegacy = false;
        this.registrationOriginalArchiveId = '';
        this.registrationOriginalArchiveSourceCount = 0;
        this.registrationOriginalArchiveAt = '';
        this.registrationOriginalArchiveBy = '';
        this.registrationOriginalArchiveStatus = 'idle';
        this.registrationOriginalArchiveMessage = '';
        this.recoveryModalOpen = false;
        this.recoverySnapshot = null;
        this.recoveryErrorMessage = '';
        const workspace = await this.createRegistrationWorkspace();
        const workspaceId = this.normaliseRegistrationWorkspaceId(
            workspace?.workspace_id,
        );
        if (!workspace || !workspaceId) {
            await this.service.modal.error(
                this.registrationWorkspaceMessage
                || '새 등록 작업공간을 준비하지 못했습니다.'
            );
            this.navigationBypass = true;
            this.service.href(this.libraryPath);
            return;
        }
        if (!await this.replaceRegistrationWorkspaceRoute(workspaceId)) {
            await this.service.modal.error(
                '새 등록 작업 주소로 이동하지 못했습니다. 자료함에서 다시 시작해주세요.'
            );
            this.navigationBypass = true;
            this.service.href(this.libraryPath);
        }
    }

    private registrationSnapshotTimestamp(snapshot: any, serverSavedAt: any = '') {
        const local = Number(snapshot?.saved_at || 0);
        if (Number.isFinite(local) && local > 0) return local;
        const server = Date.parse(`${serverSavedAt || ''}`);
        return Number.isFinite(server) ? server : 0;
    }

    private mergeRegistrationLocalDrafts(serverSnapshot: any, localSnapshot: any) {
        const merged = JSON.parse(JSON.stringify(serverSnapshot || {}));
        const mergedItems = Array.isArray(merged.items) ? merged.items : [];
        const localItems = Array.isArray(localSnapshot?.items)
            ? localSnapshot.items : [];
        localItems.filter((item: any) => (
            item?.local_draft && typeof item.local_draft === 'object'
        )).forEach((localItem: any) => {
            const localSourceIndex = Number(localItem.source_index);
            const index = mergedItems.findIndex((serverItem: any) => (
                (localItem.analysis_id && serverItem.analysis_id === localItem.analysis_id)
                || (localItem.progress_id && serverItem.progress_id === localItem.progress_id)
                || (
                    Number.isInteger(localSourceIndex)
                    && localSourceIndex >= 0
                    && Number(serverItem.source_index) === localSourceIndex
                )
            ));
            if (index >= 0) {
                mergedItems[index].local_draft = JSON.parse(
                    JSON.stringify(localItem.local_draft)
                );
            } else {
                mergedItems.push(JSON.parse(JSON.stringify(localItem)));
            }
        });
        merged.items = mergedItems;
        merged.saved_at = Math.max(
            this.registrationSnapshotTimestamp(serverSnapshot),
            this.registrationSnapshotTimestamp(localSnapshot),
        );
        return merged;
    }

    private async latestRegistrationWorkspace(workspaceId: string | null = null) {
        try {
            const requestedWorkspaceId = workspaceId === null
                ? this.normaliseRegistrationWorkspaceId(
                    this.routeWorkspaceId() || this.registrationWorkspaceId,
                )
                : this.normaliseRegistrationWorkspaceId(workspaceId);
            const request: any = {
                mode: 'registration_workspace_latest',
            };
            if (requestedWorkspaceId) request.workspace_id = requestedWorkspaceId;
            const result = await wiz.call('analyze', request);
            if (!result || result.code !== 200) return null;
            const workspace = result.data?.workspace || null;
            if (
                requestedWorkspaceId
                && this.normaliseRegistrationWorkspaceId(workspace?.workspace_id)
                    !== requestedWorkspaceId
            ) return null;
            return workspace;
        } catch (_) {
            return null;
        }
    }

    private async offerRegistrationRecovery(prefetchedWorkspace: any = null) {
        const targetWorkspaceId = this.normaliseRegistrationWorkspaceId(
            this.routeWorkspaceId() || this.registrationWorkspaceId,
        );
        let localSnapshot: any = null;
        try {
            localSnapshot = JSON.parse(localStorage.getItem(this.registrationRecoveryKey()) || 'null');
        } catch (_) {
            try {
                localStorage.removeItem(this.registrationRecoveryKey());
            } catch (_) { }
        }
        if (!localSnapshot && targetWorkspaceId) {
            localSnapshot = this.migrateLegacyRegistrationRecoverySnapshot(
                targetWorkspaceId,
            );
        }
        if (
            localSnapshot
            && targetWorkspaceId
            && this.normaliseRegistrationWorkspaceId(localSnapshot.workspace_id)
                !== targetWorkspaceId
        ) {
            localSnapshot = null;
            try {
                localStorage.removeItem(this.registrationRecoveryKey(targetWorkspaceId));
            } catch (_) { }
        }
        const serverWorkspace = prefetchedWorkspace
            || await this.latestRegistrationWorkspace(targetWorkspaceId || null);
        const serverWorkspaceId = this.normaliseRegistrationWorkspaceId(
            serverWorkspace?.workspace_id,
        );
        if (
            targetWorkspaceId
            && serverWorkspaceId
            && serverWorkspaceId !== targetWorkspaceId
        ) return;
        let serverSnapshot: any = null;
        if (serverWorkspace?.snapshot && typeof serverWorkspace.snapshot === 'object') {
            serverSnapshot = serverWorkspace.snapshot;
        } else if (typeof serverWorkspace?.snapshot === 'string') {
            try {
                serverSnapshot = JSON.parse(serverWorkspace.snapshot);
            } catch (_) { }
        }
        const localTimestamp = this.registrationSnapshotTimestamp(localSnapshot);
        const serverTimestamp = this.registrationSnapshotTimestamp(
            serverSnapshot,
            serverWorkspace?.server_saved_at,
        );
        const useServerSnapshot = !!serverSnapshot && serverTimestamp >= localTimestamp;
        const localWorkspaceId = this.normaliseRegistrationWorkspaceId(
            localSnapshot?.workspace_id,
        );
        const snapshot = useServerSnapshot
            && localWorkspaceId
            && localWorkspaceId === serverWorkspaceId
            ? this.mergeRegistrationLocalDrafts(serverSnapshot, localSnapshot)
            : useServerSnapshot ? serverSnapshot : localSnapshot;
        if (!snapshot) return;
        const snapshotWorkspaceId = this.normaliseRegistrationWorkspaceId(
            snapshot.workspace_id,
        );
        const sameServerWorkspace = !!serverWorkspace && (
            useServerSnapshot
            || (!!snapshotWorkspaceId && snapshotWorkspaceId === serverWorkspaceId)
        );
        if (sameServerWorkspace) {
            this.applyRegistrationWorkspaceSummary(serverWorkspace);
        } else {
            this.registrationWorkspaceId = targetWorkspaceId || snapshotWorkspaceId;
            this.registrationWorkspaceRevision = `${
                snapshot.workspace_revision || snapshot.revision || ''
            }`;
            this.registrationWorkspaceSourceCount = Array.isArray(snapshot.queued_sources)
                ? snapshot.queued_sources.length : 0;
            this.registrationWorkspaceSavedAt = '';
            this.registrationWorkspaceSavedBy = '';
            this.registrationWorkspaceLegacy = !snapshotWorkspaceId;
        }
        this.registrationWorkspaceId = `${
            targetWorkspaceId
            || snapshotWorkspaceId
            || (useServerSnapshot ? serverWorkspaceId : '')
            || this.registrationWorkspaceId
            || ''
        }`;
        if (!this.registrationWorkspaceId) {
            this.registrationWorkspaceLegacy = true;
            this.ensureRegistrationWorkspaceId();
        }
        const hasRecoverableWork = (snapshot.items || []).some(
            (item: any) => item.analysis_id || item.progress_id
        ) || (
            snapshot.upload_source_type === 'url'
            && Array.isArray(snapshot.xml_urls)
            && snapshot.xml_urls.length > 0
        ) || (Array.isArray(snapshot.queued_sources) && snapshot.queued_sources.length > 0);
        if (!hasRecoverableWork) return;
        this.recoverySnapshot = snapshot;
        this.recoveryModalOpen = true;
        this.recoveryModalState = 'prompt';
        this.recoveryModalPercent = null;
        this.recoveryStageLabel = '작업 정보 확인 중';
        this.recoveryStageDetail = '서버에 보관된 분석 결과와 마지막 입력 초안을 불러올 수 있습니다.';
        this.recoveryCurrentStage = '';
        this.recoveryErrorMessage = '';
        const active = this.readActiveRegistrationRecovery(snapshot);
        await this.service.render();
        if (active) await this.beginRegistrationRecovery(active.startedAt);
    }

    private hasUnsavedRegistrationWork() {
        if (!this.isRegistrationMode()) return false;
        if (this.saving || this.metaRecognizing || this.multilingualProcessing || this.syncSaving || !!this.syncRunningId) return true;
        if (this.registerStep !== 'upload' || !!this.analysisId || this.batchItems.length > 0) return true;
        if (this.uploadFiles.length > 0 || this.xmlUrls.length > 0 || !!this.uploadFileName || !!`${this.xmlUrl || ''}`.trim()) return true;
        if (this.syncFormSnapshot(this.syncForm) !== this.syncFormBaseline) return true;

        const form = this.data || {};
        const values = [
            form.title, form.content, form.category, form.authors,
            this.dateValuesText(form.created_dates),
            this.dateValuesText(form.issued_dates), form.document_date,
            form.era, form.keywords, form.ocr_text, form.source_scheme, form.source_category,
        ];
        if (values.some((value: any) => `${value || ''}`.trim())) return true;
        if (Array.isArray(form.entities) && form.entities.length > 0) return true;
        const multilingual = form.multilingual || {};
        return (Array.isArray(multilingual.segments) && multilingual.segments.length > 0)
            || (Array.isArray(multilingual.terms) && multilingual.terms.length > 0);
    }

    private hasProcessedSourceWork() {
        return this.processedRegistrationSourceCount > 0
            || !!this.analysisId
            || this.registerStep !== 'upload'
            || this.batchItems.some((item: any) => !!item.analysis || !!item.form || item.status === 'complete');
    }

    private async confirmRegistrationReset(title: string, message: string, action: string) {
        const confirmed = await this.service.modal.show({
            title,
            message,
            action,
            actionBtn: 'warning',
            cancel: '계속 작성',
            status: 'warning'
        });
        return !!confirmed;
    }

    private resetRegistrationAnalysisAndForm() {
        this.clearRegistrationRecovery();
        this.registerStep = 'upload';
        this.metadataSection = 'visibility';
        this.visibilitySearch = '';
        this.visibilityStatusFilter = 'all';
        this.selectedVisibilityKeys = [];
        this.visibilityPage = 1;
        this.visibilityInspectorOpen = true;
        this.selectedVisibilityInspectorIndex = null;
        this.metadataReviewFileFilter = 'all';
        this.metadataAdvanceMode = 'all';
        this.metadataAdvanceSelectionKeys = [];
        this.metadataDraftNotice = '';
        this.reviewSection = '';
        this.reviewSections = [];
        this.reviewFileFilter = 'all';
        this.partialRegistrationConfirmed = false;
        this.registrationCompletionFinalized = false;
        this.technicalErrorDetails = '';
        this.technicalErrorOpen = false;
        this.autoSaveState = 'idle';
        this.autoSaveSavedAt = '';
        this.autoSaveMessage = '변경 내용은 자동 저장됩니다.';
        this.registrationAnalysisSources = this.processedRegistrationSourceCount > 0
            ? this.registrationAnalysisSources.filter((source: any) => (
                ['saved', 'registration_complete'].includes(
                    `${source?.item?.status || ''}`
                )
            ))
            : [];
        this.batchItems = [];
        this.analysisDetailOpen = {};
        this.activeBatchIndex = -1;
        this.resetAnalysis();
        this.data = this.emptyRegistrationData();
    }

    private emptyRegistrationData() {
        return {
            title: '',
            content: '',
            category: '',
            status: 'draft',
            provenance_type: 'direct_upload',
            source_scheme: '',
            source_category: '',
            ocr_page_corrections: [],
            multilingual: this.emptyMultilingual(),
            document_profile: '',
            profile_fields: {},
            metadata_v2_1_review: { review_status: 'NOT_APPLICABLE', fields: {} },
        };
    }

    public accountDisplayName() {
        const session = this.service.auth.session || {};
        return session.name || session.id || session.email || 'User';
    }

    public async toggleAccountMenu() {
        this.savedReviewFileMenuOpen = false;
        this.savedReviewFileSearch = '';
        this.accountMenuOpen = !this.accountMenuOpen;
        await this.service.render();
    }

    public async closeAccountMenu() {
        this.accountMenuOpen = false;
        await this.service.render();
    }

    @HostListener('document:click')
    public async closeAccountMenuOnOutsideClick() {
        if (
            !this.accountMenuOpen
            && !this.savedReviewActionsOpen
            && !this.savedReviewFileMenuOpen
        ) return;
        this.accountMenuOpen = false;
        this.savedReviewActionsOpen = false;
        this.savedReviewFileMenuOpen = false;
        this.savedReviewFileSearch = '';
        await this.service.render();
    }

    @HostListener('window:beforeunload', ['$event'])
    public protectUnsavedWorkOnBrowserExit(event: BeforeUnloadEvent) {
        if (this.activeBatchIndex >= 0 && this.batchItems[this.activeBatchIndex] && this.data) {
            this.batchItems[this.activeBatchIndex].form = this.cloneForm(this.data);
        }
        this.persistRegistrationRecovery();
        if (
            this.navigationBypass
            || (
                !this.hasUnsavedRegistrationWork()
                && !this.hasUnsavedSavedReviewWork()
            )
        ) return;
        event.preventDefault();
        event.returnValue = '';
    }

    @HostListener('document:input', ['$event'])
    @HostListener('document:change', ['$event'])
    public markRegistrationInputChanged(event: Event | null = null) {
        const target = event?.target as HTMLElement | null;
        if (target?.closest?.('.final-registration-agreement')) return;
        this.markRegistrationChanged();
    }

    public markRegistrationChanged() {
        if (
            !this.isRegistrationMode()
            || this.recoveryRestoring
            || this.metaRecognizing
            || this.saving
            || this.registrationSubmitting
            || this.registrationPreflightLoading
        ) return;
        if (this.activeBatchIndex >= 0 && this.batchItems[this.activeBatchIndex] && this.data) {
            this.batchItems[this.activeBatchIndex].form = this.cloneForm(this.data);
        }
        this.queueRegistrationRecoverySave();
    }

    @HostListener('document:keydown.escape', ['$event'])
    public async closeActiveWorkspaceOnEscape(event: KeyboardEvent) {
        if (this.registrationProcessingOpen) {
            event.preventDefault();
            event.stopPropagation();
            return;
        }
        if (this.overwriteConfirmOpen) {
            event.preventDefault();
            event.stopPropagation();
            await this.resolveProcessingOverwriteConfirmation(false);
            return;
        }
        if (this.exitDialogOpen) {
            event.preventDefault();
            event.stopPropagation();
            await this.continueRegistration();
            return;
        }
        if (this.recoveryModalOpen) {
            event.preventDefault();
            event.stopPropagation();
            return;
        }
        if (this.metadataValueModalOpen) {
            event.preventDefault();
            event.stopPropagation();
            await this.closeMetadataValueModal();
            return;
        }
        if (this.ocrModalOpen) {
            await this.closeOcrCorrection();
            return;
        }
        if (this.savedReviewActionsOpen) {
            event.preventDefault();
            this.savedReviewActionsOpen = false;
            await this.service.render();
            return;
        }
        if (this.savedReviewFileMenuOpen) {
            event.preventDefault();
            this.savedReviewFileMenuOpen = false;
            this.savedReviewFileSearch = '';
            await this.service.render();
            return;
        }
        if (this.multilingualViewerOpen) await this.closeMultilingualViewer();
    }

    @HostListener('document:keydown.tab', ['$event'])
    public trapProcessingOverwriteDialogFocus(event: KeyboardEvent) {
        if (!this.overwriteConfirmOpen) return;
        const dialog = document.querySelector(
            '.overwrite-confirm-dialog'
        ) as HTMLElement | null;
        if (!dialog) return;
        const focusable = Array.from(dialog.querySelectorAll<HTMLElement>(
            'button:not([disabled]), a[href], input:not([disabled]), '
            + 'select:not([disabled]), textarea:not([disabled]), '
            + '[tabindex]:not([tabindex="-1"])'
        )).filter((target: HTMLElement) => (
            target.offsetParent !== null && target.getAttribute('aria-hidden') !== 'true'
        ));
        if (!focusable.length) {
            event.preventDefault();
            dialog.focus();
            return;
        }
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        const active = document.activeElement;
        if (event.shiftKey && (active === first || !dialog.contains(active))) {
            event.preventDefault();
            last.focus();
        } else if (!event.shiftKey && (active === last || !dialog.contains(active))) {
            event.preventDefault();
            first.focus();
        }
    }

    private normaliseRegistrationExitTarget(targetUrl: string = '') {
        const fallback = this.libraryPath;
        try {
            const target = new URL(
                `${targetUrl || this.exitNavigationTarget || fallback}`,
                location.origin,
            );
            if (target.origin !== location.origin) return fallback;
            return `${target.pathname}${target.search}${target.hash}` || fallback;
        } catch (_) {
            return fallback;
        }
    }

    private suspendRegistrationRecoveryWrites() {
        if (this.recoveryTimer) {
            clearInterval(this.recoveryTimer);
            this.recoveryTimer = null;
        }
        if (this.recoverySaveTimer) {
            clearTimeout(this.recoverySaveTimer);
            this.recoverySaveTimer = null;
        }
    }

    private async finishRegistrationExit(
        resolve: ((confirmed: boolean) => void) | null,
    ) {
        const target = this.normaliseRegistrationExitTarget();
        this.navigationBypass = true;
        this.exitNavigationScheduled = true;
        this.uninstallPendingWorkGuard();
        this.exitDialogOpen = false;
        this.exitDialogSaving = false;
        this.exitDialogDiscarding = false;
        await this.service.render();

        // Cancel the original guarded SPA transition and perform one explicit
        // same-origin navigation. The original transition may already have
        // been skipped while the confirmation dialog was open.
        if (resolve) resolve(false);
        window.setTimeout(() => {
            if (!this.exitNavigationScheduled) return;
            if (target.startsWith('/auth/logout')) {
                localStorage.removeItem('document-authenticated');
                localStorage.removeItem('document-session');
            }
            location.assign(target);
        }, 0);
    }

    private requestDiscardedRegistrationClaimCleanup() {
        if (!this.registrationWorkspaceId) return;
        const query = new URLSearchParams({
            mode: 'registration_workspace_state',
            workspace_id: this.registrationWorkspaceId,
            state: 'discarded',
        });
        const url = `/wiz/api/portal.post.detail/analyze?${query.toString()}`;
        try {
            if (typeof navigator.sendBeacon === 'function') {
                navigator.sendBeacon(url, new Blob([], { type: 'text/plain' }));
                return;
            }
        } catch (_) { }
        void fetch(url, {
            method: 'POST',
            credentials: 'same-origin',
            keepalive: true,
        }).catch(() => undefined);
    }

    public async canLeaveRegistration(targetUrl: string = '') {
        if (this.navigationBypass || !this.hasUnsavedRegistrationWork()) return true;
        this.exitNavigationTarget = this.normaliseRegistrationExitTarget(targetUrl);
        if (this.exitConfirmationPromise) return await this.exitConfirmationPromise;

        this.exitDialogFileCount = Math.max(this.uploadFiles.length, this.batchItems.length);
        this.exitDialogProcessing = this.metaRecognizing
            || this.filePreflightRunning
            || this.filePreflightReleasePending()
            || this.processingOverwriteRunning()
            || this.multilingualProcessing
            || this.saving
            || this.syncSaving
            || !!this.syncRunningId;
        this.exitDialogSaving = false;
        this.exitDialogDiscarding = false;
        this.exitDialogOpen = true;
        this.exitConfirmationPromise = new Promise<boolean>((resolve) => {
            this.exitConfirmationResolver = resolve;
        });
        await this.service.render();
        const continueButton = document.querySelector(
            '.registration-exit-continue'
        ) as HTMLButtonElement | null;
        if (continueButton) continueButton.focus({ preventScroll: true });

        try {
            return await this.exitConfirmationPromise;
        } finally {
            this.exitConfirmationPromise = null;
            this.exitConfirmationResolver = null;
        }
    }

    private hasUnsavedSavedReviewWork() {
        return !this.isNewPost()
            && this.tab === 'view'
            && this.savedReviewHydrated
            && (
                this.savedReviewDirty
                || this.savedReviewSaving
                || !!this.savedReviewAutosaveTimer
            );
    }

    private async canLeaveSavedReview() {
        if (this.navigationBypass || !this.hasUnsavedSavedReviewWork()) return true;
        if (this.savedReviewSaving) {
            await this.service.modal.error(
                '검수 내용을 저장하고 있습니다. 저장이 끝난 뒤 다시 이동해주세요.'
            );
            return false;
        }
        const confirmed = await this.service.modal.show({
            title: '검수 변경사항을 저장할까요?',
            message: '아직 저장되지 않은 검수 내용이 있습니다. 저장이 완료된 뒤 안전하게 이동합니다.',
            action: '저장 후 이동',
            actionBtn: 'success',
            cancel: '계속 검수',
            status: 'warning',
        });
        if (!confirmed) return false;
        const saved = await this.persistSavedReview('save');
        if (!saved) {
            this.savedReviewNotice = '저장에 실패했습니다. 변경 내용은 현재 화면에 남아 있습니다.';
            await this.service.render();
        }
        return saved;
    }

    public async canLeavePendingWork(targetUrl: string = '') {
        if (this.hasUnsavedSavedReviewWork()) {
            return await this.canLeaveSavedReview();
        }
        return await this.canLeaveRegistration(targetUrl);
    }

    public async continueRegistration() {
        if (
            !this.exitDialogOpen
            || this.exitDialogSaving
            || this.exitDialogDiscarding
        ) return;
        const resolve = this.exitConfirmationResolver;
        this.exitDialogOpen = false;
        this.exitNavigationTarget = '';
        await this.service.render();
        if (resolve) resolve(false);
    }

    public async discardRegistrationAndLeave() {
        if (
            !this.exitDialogOpen
            || this.exitDialogSaving
            || this.exitDialogDiscarding
        ) return;
        this.exitDialogDiscarding = true;
        this.analysisCancellationRequested = true;
        this.suspendRegistrationRecoveryWrites();
        await this.service.render();

        // Serialize against an autosave already in flight. Claim cleanup is
        // now queued atomically by the server's discarded transition and must
        // never block this terminal action in the browser.
        await this.registrationWorkspaceSaveQueue;
        const resolve = this.exitConfirmationResolver;
        const discarded = await this.setRegistrationWorkspaceState('discarded');
        if (!discarded) {
            this.exitDialogDiscarding = false;
            this.startRegistrationRecovery();
            await this.service.render();
            await this.service.modal.error(
                '작업 삭제 상태를 서버에 기록하지 못했습니다. 잠시 후 다시 시도해주세요.'
            );
            return;
        }
        this.requestDiscardedRegistrationClaimCleanup();
        this.clearRegistrationRecovery();
        await this.finishRegistrationExit(resolve);
    }

    private async flushRegistrationRecoveryDraftsForExit() {
        await this.registrationWorkspaceSaveQueue;
        const draftsSaved = await this.flushRegistrationRecoveryDraftsNow();
        if (!draftsSaved) return false;
        const workspaceSaved = await this.saveRegistrationWorkspace(true);
        return workspaceSaved;
    }

    public async pauseRegistrationAndLeave() {
        if (
            !this.exitDialogOpen
            || this.exitDialogSaving
            || this.exitDialogDiscarding
        ) return;
        if (
            this.filePreflightRunning
            || this.filePreflightReleasePending()
            || this.processingOverwriteRunning()
        ) {
            await this.service.modal.error(
                this.processingOverwriteRunning()
                    ? '동일 파일 덮어쓰기를 저장하고 있습니다. 현재 작업이 끝난 뒤 저장 후 나가기를 다시 눌러주세요.'
                    : this.filePreflightReleasePending()
                    ? '동일 파일 처리 권한을 정리하고 있습니다. 현재 작업이 끝난 뒤 저장 후 나가기를 다시 눌러주세요.'
                    : '선택한 원본을 서버에 보존하고 있습니다. 원본 보존이 끝난 뒤 저장 후 나가기를 다시 눌러주세요.'
            );
            return;
        }
        this.exitDialogSaving = true;
        const item = this.activeBatchItem();
        if (item && this.registerStep === 'metadata' && this.metadataSection === 'bibliography') {
            item.metadataReviewPaused = true;
        }
        this.syncActiveBatch();
        await this.service.render();
        const saved = await this.flushRegistrationRecoveryDraftsForExit();
        if (!saved) {
            this.exitDialogSaving = false;
            await this.service.render();
            await this.service.modal.error(
                '검수 초안을 서버에 저장하지 못했습니다. 저장 상태를 확인한 뒤 다시 시도해주세요.'
            );
            return;
        }
        const paused = await this.setRegistrationWorkspaceState('paused');
        if (!paused) {
            this.exitDialogSaving = false;
            await this.service.render();
            await this.service.modal.error(
                '작업 중단 상태를 서버에 기록하지 못했습니다. 잠시 후 다시 시도해주세요.'
            );
            return;
        }
        const resolve = this.exitConfirmationResolver;
        await this.finishRegistrationExit(resolve);
    }

    public async persistCurrentMetadataReviewDraft() {
        const item = this.activeBatchItem();
        if (!item || !item.analysis || !item.form || this.recoverySaving) return;
        item.metadataReviewPaused = false;
        this.metadataDraftNotice = '현재 자료의 검수 초안을 저장하고 있습니다.';
        this.syncActiveBatch();
        await this.service.render();
        const saved = await this.flushRegistrationRecoveryDraftsForExit();
        this.metadataDraftNotice = saved
            ? `현재 자료 임시저장 완료 · ${this.autoSaveSavedAt || this.formatAutoSaveTime()}`
            : '현재 자료 임시저장에 실패했습니다. 화면을 닫지 말고 다시 시도해주세요.';
        await this.service.render();
    }

    public async pauseMetadataReviewForLater() {
        const allowed = await this.canLeaveRegistration(this.libraryPath);
        if (!allowed) return;
        this.navigationBypass = true;
        this.service.href(this.libraryPath);
    }

    public async logoutWithRegistrationCheck(event: Event) {
        event.preventDefault();
        event.stopPropagation();
        this.accountMenuOpen = false;
        const allowed = await this.canLeavePendingWork(
            '/auth/logout?returnTo=/login'
        );
        if (!allowed) {
            await this.service.render();
            return;
        }
        this.navigationBypass = true;
        localStorage.removeItem('document-authenticated');
        localStorage.removeItem('document-session');
        location.href = '/auth/logout?returnTo=/login';
    }

    public async load() {
        if (this.isNewPost()) {
            this.savedReviewHydrated = false;
            this.savedReviewDirty = false;
            if (this.savedReviewAutosaveTimer) {
                clearTimeout(this.savedReviewAutosaveTimer);
                this.savedReviewAutosaveTimer = null;
            }
            this.navigationBypass = false;
            this.exitNavigationTarget = '';
            this.exitNavigationScheduled = false;
            this.exitConfirmationPromise = null;
            this.exitConfirmationResolver = null;
            this.exitDialogOpen = false;
            this.exitDialogDiscarding = false;
            this.data = this.emptyRegistrationData();
            this.tab = 'edit';
            this.registerStep = 'upload';
            this.uploadFileName = '';
            this.uploadSourceType = 'file';
            this.xmlUrl = '';
            this.xmlUrls = [];
            this.uploadDragging = false;
            this.uploadFile = null;
            this.uploadFiles = [];
            this.filePreflights = [];
            this.filePreflightTaskCount = 0;
            this.filePreflightRunning = false;
            this.bulkOverwriteRunning = false;
            this.bulkOverwriteTotal = 0;
            this.bulkOverwriteCompleted = 0;
            this.bulkOverwriteSucceeded = 0;
            this.bulkOverwriteFailed = 0;
            this.filePreflightReleaseRunning = false;
            this.batchSourceReplacementRunning = false;
            this.batchSourceReplacementTargetIndex = -1;
            this.batchSourceReplacementLocks = {};
            this.uploadSelectionNotice = '';
            this.sourceSelectionPage = 1;
            this.completedRegistrationCount = 0;
            this.selectedRegistrationSourceCount = 0;
            this.processedRegistrationSourceCount = 0;
            this.batchItems = [];
            this.registrationCompletionFinalized = false;
            this.registrationWorkspaceId = this.routeWorkspaceId();
            this.routedRegistrationWorkspaceId = this.registrationWorkspaceId;
            this.registrationWorkspaceSourceCount = 0;
            this.registrationWorkspaceSavedAt = '';
            this.registrationWorkspaceSavedBy = '';
            this.registrationWorkspaceRevision = '';
            this.registrationWorkspaceStatus = 'idle';
            this.registrationWorkspaceMessage = '';
            this.registrationWorkspaceLegacy = false;
            this.registrationOriginalArchiveId = '';
            this.registrationOriginalArchiveSourceCount = 0;
            this.registrationOriginalArchiveAt = '';
            this.registrationOriginalArchiveBy = '';
            this.registrationOriginalArchiveStatus = 'idle';
            this.registrationOriginalArchiveMessage = '';
            this.metadataReviewFileFilter = 'all';
            this.metadataAdvanceMode = 'all';
            this.metadataAdvanceSelectionKeys = [];
            this.metadataDraftNotice = '';
            this.activeBatchIndex = -1;
            this.metaRecognizing = false;
            this.syncForm = this.emptySyncForm();
            this.syncFormBaseline = this.syncFormSnapshot(this.syncForm);
            this.resetAnalysis();
            this.installPendingWorkGuard();
            await this.service.render();
            return;
        }

        this.uninstallPendingWorkGuard();
        this.savedReviewHydrated = false;
        if (this.savedReviewAutosaveTimer) {
            clearTimeout(this.savedReviewAutosaveTimer);
            this.savedReviewAutosaveTimer = null;
        }
        this.data = null;
        await this.service.render();

        const { code, data } = await wiz.call("get", { id: this.id });
        if (code !== 200) {
            this.service.href(this.libraryPath);
            return;
        }
        this.data = data;
        const metadata = data.ai_metadata || {};
        const classification = metadata.corrections || {};
        this.data.authors = Array.isArray(metadata.authors) ? metadata.authors.join(', ') : '';
        this.data.publisher = classification.publisher || '';
        this.data.created_dates = this.normaliseDateValues(
            metadata.created_dates || classification.created_dates
        );
        this.data.issued_dates = this.normaliseDateValues(
            metadata.issued_dates || classification.issued_dates
        );
        if (!this.data.created_dates.length && !this.data.issued_dates.length && metadata.document_date) {
            this.data.issued_dates = [`${metadata.document_date}`];
        }
        this.data.document_date = this.data.issued_dates[0]
            || this.data.created_dates[0] || metadata.document_date || '';
        this.data.era = `${metadata.era || ''}`.slice(0, 100);
        this.data.keywords = Array.isArray(metadata.keywords) ? metadata.keywords.join(', ') : '';
        this.data.ocr_text = metadata.ocr_text || '';
        this.data.entities = metadata.entities || [];
        this.data.provenance_type = classification.provenance_type || (metadata.source_type === 'url' ? 'external_crawl' : 'direct_upload');
        this.data.source_scheme = classification.source_scheme || this.sourceScheme(metadata.source_url || '');
        this.data.source_category = classification.source_category || '';
        this.data.multilingual = this.normaliseMultilingual(
            metadata.multilingual || (metadata.corrections ? metadata.corrections.multilingual : null)
        );
        this.data.document_profile = metadata.document_profile || classification.document_profile || '';
        this.data.document_profile_detail = (
            metadata.document_profile_detail
            || data.document_profile_detail
            || {}
        );
        this.data.profile_fields = metadata.profile_fields || classification.profile_fields || {};
        this.data.image_assets = (
            metadata.image_assets
            || data.image_assets
            || {
                total: 0, ready: 0, missing: 0, failed: 0,
                page: 1, page_size: 24, pages: 1, items: [],
            }
        );
        this.data.source_checksum = (
            metadata.source_checksum || data.source_checksum || ''
        );
        this.data.common_metadata_review = (
            metadata.common_metadata_review
            || classification.common_metadata_review
            || data.common_metadata_review
            || { schema_version: 'common-metadata-review-v1', fields: [] }
        );
        this.data.metadata_v2_1_review = (
            metadata.metadata_v2_1_review
            || classification.metadata_v2_1_review
            || data.metadata_v2_1_review
            || { review_status: 'NOT_APPLICABLE', fields: {} }
        );
        this.data.xml_field_review = (
            metadata.xml_field_review
            || classification.xml_field_review
            || data.xml_field_review
            || {}
        );
        this.initialiseMetadataReviewFocus();
        this.metadataReviewScopeMode = 'representative';
        this.metadataHierarchySearch = '';
        this.metadataHierarchyOverviewSearch = '';
        this.metadataHierarchyOverviewPage = 1;
        this.metadataHierarchyActiveUnitIds = {};
        this.initialiseDtdReviewFocus();
        this.savedXmlSourceOpen = false;
        this.detailDescriptionExpanded = false;
        this.savedDetailSection = 'overview';
        this.initialiseSavedReviewState(metadata, classification);
        this.syncCurrentSavedReviewFileOption();
        this.installPendingWorkGuard();
        this.resetEntityDetailState();
        this.savedReviewFileNavigating = false;
        this.savedReviewFileMenuOpen = false;
        this.savedReviewFileSearch = '';
        this.itemRegistry = null;
        this.itemRegistryError = '';
        this.itemRegistrySelectedRelationId = '';
        this.itemRegistrySourceWindows = {};
        this.itemRegistrySourceQueries = {};
        this.itemRegistrySelectedAlignmentId = '';
        void this.loadSavedReviewFiles();
        void this.loadItemManifestationRegistry();
        await this.service.render();
        if (this.metadataHierarchyApplicable()) {
            void this.loadSavedHierarchyUnits(1);
        }
    }

    public detailKeywordItems() {
        const keywords = this.data && this.data.keywords;
        const values = Array.isArray(keywords)
            ? keywords
            : `${keywords || ''}`.split(/[,·|]/);
        return values
            .map((value: any) => `${value || ''}`.trim())
            .filter(Boolean)
            .slice(0, 12);
    }

    public detailDescriptionIsLong() {
        return `${this.data?.content || ''}`.trim().length > 520;
    }

    public async toggleDetailDescription() {
        this.detailDescriptionExpanded = !this.detailDescriptionExpanded;
        await this.service.render();
    }

    public async toggleSavedXmlSource() {
        this.savedXmlSourceOpen = !this.savedXmlSourceOpen;
        await this.service.render();
    }

    public async setSavedDetailSection(section: 'overview' | 'audit' | 'translation') {
        if (section === 'audit' && !this.xmlFieldReviewEnabled()) return;
        if (section === 'translation' && !this.savedDetailTranslationAvailable()) return;
        this.savedDetailSection = section;
        await this.service.render();
    }

    private savedContentReviewKey(key: string) {
        const aliases: any = {
            source: 'original_text',
            translation: 'translated_text',
            toc: 'table_of_contents',
            images: 'image_assets',
            entities: 'entities',
        };
        return aliases[key] || `${key || ''}`;
    }

    private savedContentReviewGroupKeys(key: string) {
        const groups: any = {
            source: [
                'original_text', 'paragraphs', 'annotations',
                'image', 'image_order', 'captions', 'image_ocr',
                'artifact_metadata', 'attachment', 'pdf_pages',
                'attachment_links',
            ],
            translation: ['translated_text'],
            toc: ['table_of_contents'],
            images: ['image_assets'],
            entities: ['entities'],
        };
        const canonical = this.savedContentReviewKey(key);
        const candidates = groups[key] || [canonical];
        const available = new Set([
            ...this.savedContentReviewRequiredKeys,
            ...Object.keys(this.savedContentReviewChecks || {}),
            ...this.documentProfileReviewItems()
                .map((item: any) => `${item?.key || ''}`)
                .filter(Boolean),
        ]);
        const matched = candidates.filter((row: string) => available.has(row));
        return matched.length ? matched : (canonical ? [canonical] : []);
    }

    private savedContentReviewHasValue(key: string) {
        const canonical = this.savedContentReviewKey(key);
        if (canonical === 'original_text') {
            const sourceFields = this.savedContentReviewGroupKeys('source');
            return !!`${
                this.profileFieldValue('original_text')
                || this.data?.ocr_text
                || ''
            }`.trim() || sourceFields.some(
                (fieldKey: string) => this.profileFieldHasValue(fieldKey)
            );
        }
        if (canonical === 'translated_text') {
            return this.savedDetailTranslationRows().some(
                (row: any) => !!`${row?.translation || ''}`.trim()
            ) || !!`${this.profileFieldValue('translated_text') || ''}`.trim();
        }
        if (canonical === 'image_assets') return this.savedDetailHasImages();
        if (canonical === 'entities') return this.entityRows().length > 0;
        return this.profileFieldHasValue(canonical);
    }

    private savedDetailTocValueText(value: any, depth: number = 0): string {
        if (value === null || typeof value === 'undefined') return '';
        if (typeof value === 'string' || typeof value === 'number') {
            return `${value}`.trim();
        }
        if (Array.isArray(value)) {
            return value
                .map((row: any) => this.savedDetailTocValueText(row, depth + 1))
                .filter(Boolean)
                .join('\n');
        }
        if (typeof value !== 'object' || depth > 4) return '';
        const label = `${
            value.title || value.text || value.label || value.name || ''
        }`.trim();
        const page = `${value.page || value.page_number || ''}`.trim();
        const own = [label, page ? `${page}쪽` : ''].filter(Boolean).join(' · ');
        const children = this.savedDetailTocValueText(
            value.children || value.items || value.entries || [],
            depth + 1,
        );
        if (own && children) {
            return `${own}\n${children.split('\n').map(
                (row: string) => `  ${row}`
            ).join('\n')}`;
        }
        if (own || children) return own || children;
        const serialised = JSON.stringify(value, null, 2);
        return serialised === '{}' ? '' : serialised;
    }

    public savedDetailTocText() {
        const fields = this.data?.profile_fields || {};
        for (const value of [fields.toc, fields.table_of_contents]) {
            const text = this.savedDetailTocValueText(value);
            if (text) return text;
        }
        return '';
    }

    public savedDetailHasToc() {
        return !!this.savedDetailTocText();
    }

    public savedDetailHasImages() {
        return this.safeNumber(this.savedImageAssets?.total, 0) > 0;
    }

    public savedImageAssetRows() {
        return Array.isArray(this.savedImageAssets?.items)
            ? this.savedImageAssets.items : [];
    }

    public savedImageAssetUrl(asset: any, variant: 'preview' | 'original' = 'preview') {
        if (!this.id || !asset?.id) return '';
        const query = new URLSearchParams({
            mode: 'registered_image_asset',
            id: this.id,
            asset_id: `${asset.id}`,
            variant,
            v: `${asset.checksum_sha256 || this.data?.source_checksum || ''}`,
        });
        return `/wiz/api/portal.post.detail/analyze?${query.toString()}`;
    }

    public imageAssetDisplayTitle(asset: any) {
        return `${
            asset?.caption || asset?.title || asset?.level_title
            || asset?.filename || asset?.reference || '이미지'
        }`.trim();
    }

    public imageAssetLevelLabel(asset: any) {
        const level = this.safeNumber(asset?.level, 0);
        const title = `${asset?.level_title || asset?.level_name || ''}`.trim();
        return [level > 0 ? `LEVEL ${level}` : '', title].filter(Boolean).join(' · ')
            || 'ITEM 연결';
    }

    private replaceSavedImageAsset(updated: any) {
        const rows = this.savedImageAssetRows();
        const index = rows.findIndex((row: any) => row?.id === updated?.id);
        if (index < 0) return;
        const previousStatus = `${rows[index]?.status || ''}`;
        const nextStatus = `${updated?.status || previousStatus}`;
        rows[index] = { ...rows[index], ...updated };
        if (previousStatus !== nextStatus) {
            for (const status of ['ready', 'missing', 'failed']) {
                const delta = (nextStatus === status ? 1 : 0)
                    - (previousStatus === status ? 1 : 0);
                this.savedImageAssets[status] = Math.max(
                    0,
                    this.safeNumber(this.savedImageAssets[status], 0) + delta,
                );
            }
        }
    }

    public savedImageAssetIsMaterializing(asset: any) {
        return !!this.savedImageAssetMaterializing[
            `${this.id || ''}:${asset?.id || ''}`
        ];
    }

    private async autoMaterializeSavedImageAssetPage(
        pageKey: string, targets: any[], postId: string,
    ) {
        let completed = true;
        if (postId === this.id) {
            this.savedImageAssetAutoActiveCount += 1;
            await this.service.render();
        }
        try {
            for (
                let index = 0;
                index < targets.length;
                index += this.savedImageAssetAutoBatchSize
            ) {
                const batch = targets.slice(
                    index, index + this.savedImageAssetAutoBatchSize
                );
                const results = await Promise.all(batch.map(
                    (asset: any) => this.materializeSavedImageAsset(
                        asset, false, postId
                    )
                ));
                if (results.some((row: any) => row?.status !== 'ready')) {
                    completed = false;
                }
                if (postId === this.id) await this.service.render();
            }
        } catch (error) {
            completed = false;
            throw error;
        } finally {
            if (completed) {
                this.savedImageAssetAutoRequestedPages[pageKey] = 'complete';
            } else {
                delete this.savedImageAssetAutoRequestedPages[pageKey];
            }
            if (postId === this.id) {
                this.savedImageAssetAutoActiveCount = Math.max(
                    0, this.savedImageAssetAutoActiveCount - 1
                );
                await this.service.render();
            }
        }
    }

    public async loadSavedImageAssets(page: number = 1, autoMaterialize: boolean = true) {
        if (!this.id || this.savedImageAssetsLoading) return;
        const postId = this.id;
        const requestedPage = Math.max(1, page);
        let autoPageKey = '';
        let autoTargets: any[] = [];
        this.savedImageAssetsLoading = true;
        this.savedImageAssetsError = '';
        try {
            const result = await wiz.call('analyze', {
                mode: 'registered_image_assets',
                id: postId,
                page: requestedPage,
                page_size: 24,
            });
            const imagePage = result?.data;
            if (
                !imagePage
                || typeof imagePage !== 'object'
                || !Array.isArray(imagePage.items)
            ) {
                throw new Error(
                    '이미지 참조 집계와 상세 목록 응답이 일치하지 않습니다.'
                );
            }
            this.savedImageAssets = imagePage;
            const pageKey = `${this.safeNumber(imagePage.page, page)}`;
            if (
                autoMaterialize
                && !this.savedImageAssetAutoRequestedPages[pageKey]
            ) {
                this.savedImageAssetAutoRequestedPages[pageKey] = 'running';
                autoPageKey = pageKey;
                autoTargets = this.savedImageAssetRows().filter(
                    (asset: any) => asset?.materializable && asset?.status !== 'ready'
                );
                if (!autoTargets.length) {
                    this.savedImageAssetAutoRequestedPages[pageKey] = 'complete';
                }
            }
        } catch (error) {
            this.savedImageAssetsError = this.captureError(
                error, '저장된 이미지 자산을 불러오지 못했습니다.'
            ).message;
        } finally {
            this.savedImageAssetsLoading = false;
            await this.service.render();
        }
        if (autoPageKey && autoTargets.length) {
            void this.autoMaterializeSavedImageAssetPage(
                autoPageKey, autoTargets, postId
            ).catch(async (error: any) => {
                if (postId !== this.id) return;
                this.savedImageAssetsError = this.captureError(
                    error, '이미지 자동 저장 작업을 완료하지 못했습니다.'
                ).message;
                await this.service.render();
            });
        }
    }

    public async materializeSavedImageAsset(
        asset: any, render: boolean = true, postId: string = this.id,
    ) {
        const materializingKey = `${postId || ''}:${asset?.id || ''}`;
        if (!postId || !asset?.id || this.savedImageAssetMaterializing[materializingKey]) return null;
        this.savedImageAssetMaterializing[materializingKey] = true;
        if (render && postId === this.id) await this.service.render();
        try {
            const result = await wiz.call('analyze', {
                mode: 'materialize_registered_image_asset',
                id: postId,
                asset_id: asset.id,
            });
            if (!result?.data?.id) {
                throw new Error('저장된 이미지 자산 응답이 올바르지 않습니다.');
            }
            if (postId === this.id) this.replaceSavedImageAsset(result.data);
            return result.data;
        } catch (error) {
            if (postId === this.id) {
                this.savedImageAssetsError = this.captureError(
                    error, '이미지를 스토리지에 저장하지 못했습니다.'
                ).message;
            }
            return null;
        } finally {
            delete this.savedImageAssetMaterializing[materializingKey];
            if (render && postId === this.id) await this.service.render();
        }
    }

    public async moveSavedImageAssetPage(offset: number) {
        const next = Math.max(
            1,
            Math.min(
                this.safeNumber(this.savedImageAssets?.pages, 1),
                this.safeNumber(this.savedImageAssets?.page, 1) + offset,
            ),
        );
        if (next === this.safeNumber(this.savedImageAssets?.page, 1)) return;
        await this.loadSavedImageAssets(next, true);
    }

    public savedContentReviewVisibleSectionKeys() {
        return this.savedContentReviewSectionKeys.filter(
            (key: string) => key !== 'toc' || this.savedDetailHasToc()
        );
    }

    private savedContentReviewApplicableRequiredKeys() {
        return this.savedContentReviewRequiredKeys.filter(
            (key: string) => (
                !['translation', 'translated_text'].includes(key)
                && (
                    !['toc', 'table_of_contents'].includes(key)
                    || this.savedDetailHasToc()
                )
            ) && (
                !['images', 'image_assets'].includes(key)
                || this.savedDetailHasImages()
            )
        );
    }

    private initialiseSavedReviewState(metadata: any, classification: any) {
        const registeredReview = (
            this.data?.registered_review
            || metadata?.registered_review
            || classification?.registered_review
            || {}
        );
        const registrationSnapshot = (
            classification?.registration_snapshot
            && typeof classification.registration_snapshot === 'object'
        ) ? classification.registration_snapshot : {};
        const contentReview = (
            registeredReview?.content_review
            || this.data?.content_review
            || metadata?.content_review
            || classification?.content_review
            || registrationSnapshot
            || {}
        );
        const strategyKeys = Array.isArray(
            this.xmlMetadataStrategy()?.content_review_keys
        ) ? this.xmlMetadataStrategy().content_review_keys : [];
        const contentRequiredKeys = Array.isArray(contentReview?.required_review_keys)
            ? contentReview.required_review_keys : [];
        const snapshotRequiredKeys = Array.isArray(registrationSnapshot?.required_review_keys)
            ? registrationSnapshot.required_review_keys : [];
        const requiredKeys = (
            contentRequiredKeys.length
                ? contentRequiredKeys
                : snapshotRequiredKeys.length ? snapshotRequiredKeys : strategyKeys
        ).map((key: any) => `${key || ''}`).filter(Boolean);
        const checks = (
            contentReview?.review_checks
            && typeof contentReview.review_checks === 'object'
        ) ? contentReview.review_checks : {};
        const checkKeys = Object.keys(checks);
        const profileReviewKeys = this.documentProfileReviewItems()
            .map((item: any) => `${item?.key || ''}`)
            .filter(Boolean);
        const preferredReviewKeys = [
            'original_text', 'table_of_contents', 'entities',
        ].filter((key: string) => (
            !profileReviewKeys.length || profileReviewKeys.includes(key)
        ));
        const fallbackReviewKeys = `${this.documentProfile()?.key || ''}` === 'full_text'
            ? preferredReviewKeys
            : profileReviewKeys;
        this.savedContentReviewRequiredKeys = Array.from(new Set(
            requiredKeys.length
                ? requiredKeys
                : checkKeys.length
                    ? checkKeys
                    : fallbackReviewKeys.length
                        ? fallbackReviewKeys
                        : preferredReviewKeys
        ));
        this.savedContentReviewChecks = this.normaliseReviewChecks(
            checks,
            null,
            this.savedContentReviewRequiredKeys,
        );
        this.savedContentReviewReasons = (
            contentReview?.reasons
            && typeof contentReview.reasons === 'object'
        ) ? { ...contentReview.reasons } : {};
        this.savedReviewSection = 'metadata';
        this.savedReviewSaving = false;
        this.savedReviewDirty = false;
        this.savedReviewNotice = '';
        this.savedReviewActionsOpen = false;
        this.savedReviewMetadataAllItems = false;
        this.savedReviewSourceFullText = '';
        this.savedReviewSourceLoaded = false;
        this.savedReviewSourceLoading = false;
        this.savedReviewSourceError = '';
        const initialImageAssets = this.data?.image_assets;
        this.savedImageAssets = (
            initialImageAssets && typeof initialImageAssets === 'object'
        ) ? { ...initialImageAssets } : {
            total: 0, ready: 0, missing: 0, failed: 0,
            page: 1, page_size: 24, pages: 1, items: [],
        };
        this.savedImageAssetsLoading = false;
        this.savedImageAssetsError = '';
        this.savedImageAssetMaterializing = {};
        this.savedImageAssetAutoRequestedPages = {};
        this.savedImageAssetAutoActiveCount = 0;
        this.savedEntityExtracting = false;
        this.savedEntityProgress = null;
        this.savedDtdActionState = 'idle';
        this.savedDtdActionLabel = '';
        this.savedDtdActionMessage = '';
        this.savedDtdActionTotal = 0;
        this.savedDtdActionCompleted = 0;
        this.savedHierarchyUnits = [];
        this.savedHierarchyTotal = 0;
        this.savedHierarchyPage = 1;
        this.savedHierarchyQuery = '';
        this.savedHierarchyLevel = 'all';
        this.savedHierarchyLoading = false;
        this.savedHierarchyError = '';
        this.savedHierarchyLoadedKey = '';
        this.savedHierarchyRequestToken += 1;
        this.savedReviewSavedAt = `${
            contentReview?.saved_at
            || registeredReview?.updated
            || this.data?.updated
            || ''
        }`;
        this.savedReviewMutationVersion = 0;
        this.savedReviewHydrated = true;
    }

    public canManageSavedReview() {
        return !!(
            this.data
            && (
                this.data.can_manage_review
                || this.data.can_manage_post
                || this.data.can_manage_entities
                || this.data.can_manage_translation
            )
        );
    }

    public async toggleSavedReviewActions(event: Event | null = null) {
        event?.preventDefault();
        event?.stopPropagation();
        this.accountMenuOpen = false;
        this.savedReviewFileMenuOpen = false;
        this.savedReviewFileSearch = '';
        this.savedReviewActionsOpen = !this.savedReviewActionsOpen;
        await this.service.render();
    }

    public async navigateToLibrary(event: Event | null = null) {
        event?.preventDefault();
        event?.stopPropagation();
        const allowed = await this.canLeavePendingWork(this.libraryPath);
        if (!allowed) {
            await this.service.render();
            return;
        }
        this.navigationBypass = true;
        this.service.href(this.libraryPath);
    }

    public async goBackFromSavedReview() {
        const allowed = await this.canLeavePendingWork();
        if (!allowed) {
            await this.service.render();
            return;
        }
        this.navigationBypass = true;
        if (window.history.length > 1) {
            window.history.back();
            return;
        }
        this.service.href(this.libraryPath);
    }

    private syncCurrentSavedReviewFileOption() {
        if (!this.id || !this.data) return;
        const current = {
            id: `${this.id}`,
            title: `${this.data.title || '제목 없는 자료'}`,
            status: `${this.data.status || 'draft'}`,
        };
        const index = this.savedReviewFiles.findIndex(
            (file: any) => `${file?.id || ''}` === current.id
        );
        if (index < 0) {
            this.savedReviewFiles = [current, ...this.savedReviewFiles];
            return;
        }
        this.savedReviewFiles[index] = {
            ...this.savedReviewFiles[index],
            ...current,
        };
    }

    private async loadSavedReviewFiles() {
        if (this.savedReviewFilesLoading || this.savedReviewFiles.length > 1) return;
        this.savedReviewFilesLoading = true;
        this.savedReviewFilesError = '';
        try {
            const result = await wiz.call('get', {
                mode: 'review_navigation',
                id: this.id,
            });
            if (result.code !== 200) {
                throw new Error(
                    result.data?.message || '검수할 파일 목록을 불러오지 못했습니다.'
                );
            }
            if (!Array.isArray(result.data?.files)) {
                throw new Error(
                    '상세 파일 이동 목록이 최신 형식으로 연결되지 않았습니다.'
                );
            }
            const files = result.data.files;
            if (!files.some(
                (file: any) => `${file?.id || ''}` === `${this.id || ''}`
            )) {
                throw new Error(
                    '현재 자료가 상세 파일 이동 목록에서 누락되었습니다.'
                );
            }
            this.savedReviewFiles = files
                .map((file: any) => ({
                    id: `${file?.id || ''}`,
                    title: `${file?.title || '제목 없는 자료'}`,
                    status: `${file?.status || 'draft'}`,
                    source_name: `${file?.source_name || ''}`,
                    item_code: `${file?.item_code || ''}`,
                    manifestation_role: `${file?.manifestation_role || ''}`,
                    manifestation_role_label: `${file?.manifestation_role_label || ''}`,
                    manifestation_sequence: `${file?.manifestation_sequence || ''}`,
                }))
                .filter((file: any) => !!file.id);
            this.syncCurrentSavedReviewFileOption();
        } catch (error) {
            const captured = this.captureError(
                error,
                '검수할 파일 목록을 불러오지 못했습니다.'
            );
            this.savedReviewFilesError = captured.message;
            this.syncCurrentSavedReviewFileOption();
        } finally {
            this.savedReviewFilesLoading = false;
            await this.service.render();
        }
    }

    public savedReviewFileIndex() {
        return this.savedReviewFiles.findIndex(
            (file: any) => `${file?.id || ''}` === `${this.id || ''}`
        );
    }

    public savedReviewPreviousFile() {
        const index = this.savedReviewFileIndex();
        return index > 0 ? this.savedReviewFiles[index - 1] : null;
    }

    public savedReviewNextFile() {
        const index = this.savedReviewFileIndex();
        return index >= 0 && index < this.savedReviewFiles.length - 1
            ? this.savedReviewFiles[index + 1] : null;
    }

    public savedReviewCurrentFile() {
        const index = this.savedReviewFileIndex();
        return index >= 0 ? this.savedReviewFiles[index] : null;
    }

    public savedReviewFilePositionLabel() {
        if (this.savedReviewFilesError) return '파일 목록 연결 오류';
        const index = this.savedReviewFileIndex();
        if (index < 0) return `전체 ${this.savedReviewFiles.length}개`;
        return `${index + 1} / ${this.savedReviewFiles.length}`;
    }

    public savedReviewFilteredFiles() {
        const query = `${this.savedReviewFileSearch || ''}`
            .trim().toLocaleLowerCase();
        if (!query) return this.savedReviewFiles;
        return this.savedReviewFiles.filter((file: any) => (
            `${file?.title || ''}`.toLocaleLowerCase().includes(query)
            || `${file?.source_name || ''}`.toLocaleLowerCase().includes(query)
            || `${file?.id || ''}`.toLocaleLowerCase().includes(query)
        ));
    }

    public async toggleSavedReviewFileMenu(event: Event) {
        event.preventDefault();
        event.stopPropagation();
        if (
            this.savedReviewFilesLoading
            || this.savedReviewFileNavigating
            || this.savedReviewFiles.length < 2
        ) return;
        this.accountMenuOpen = false;
        this.savedReviewActionsOpen = false;
        this.savedReviewFileMenuOpen = !this.savedReviewFileMenuOpen;
        if (!this.savedReviewFileMenuOpen) this.savedReviewFileSearch = '';
        await this.service.render();
        if (this.savedReviewFileMenuOpen) {
            const input = document.querySelector(
                '.saved-review-file-search input'
            ) as HTMLInputElement | null;
            input?.focus({ preventScroll: true });
        }
    }

    private async navigateToSavedReviewFile(targetId: string) {
        const nextId = `${targetId || ''}`.trim();
        if (!nextId || nextId === `${this.id || ''}` || this.savedReviewFileNavigating) {
            return;
        }
        const targetUrl = `${this.basePath}/${encodeURIComponent(nextId)}/view`;
        const allowed = await this.canLeavePendingWork(targetUrl);
        if (!allowed) {
            await this.service.render();
            return;
        }
        this.savedReviewFileNavigating = true;
        await this.service.render();
        this.service.href(targetUrl);
    }

    public async moveSavedReviewFile(direction: -1 | 1) {
        const target = direction < 0
            ? this.savedReviewPreviousFile()
            : this.savedReviewNextFile();
        if (!target) return;
        await this.navigateToSavedReviewFile(target.id);
    }

    public async chooseSavedReviewFile(file: any, event: Event) {
        event.preventDefault();
        event.stopPropagation();
        this.savedReviewFileMenuOpen = false;
        this.savedReviewFileSearch = '';
        await this.navigateToSavedReviewFile(`${file?.id || ''}`);
    }

    public async runSavedReviewAction(action: 'source' | 'history' | 'library') {
        this.savedReviewActionsOpen = false;
        if (action === 'source') {
            await this.selectSavedReviewSection('source');
            return;
        }
        if (action === 'history') {
            await this.selectSavedReviewSection('history');
            return;
        }
        await this.navigateToLibrary();
    }

    public async toggleSavedReviewMetadataAllItems() {
        this.savedReviewMetadataAllItems = !this.savedReviewMetadataAllItems;
        await this.service.render();
    }

    public async selectSavedReviewMetadataField(field: any) {
        this.savedReviewMetadataAllItems = false;
        await this.selectXmlReviewField(field);
        if (this.savedReviewFieldUsesHierarchy(field)) {
            void this.loadSavedHierarchyUnits(this.savedHierarchyPage || 1);
        }
    }

    public savedReviewFieldUsesHierarchy(field: any) {
        return !!field
            && ['title', 'created_dates', 'issued_dates'].includes(
                `${field.id || ''}`
            )
            && this.xmlReviewScopeApplicable(field);
    }

    public savedReviewFieldLabel(field: any) {
        if (
            `${field?.id || ''}` === 'title'
            && this.savedReviewFieldUsesHierarchy(field)
        ) {
            return '상위 자료명';
        }
        return `${field?.label || ''}`;
    }

    public savedReviewFinalValueLabel(field: any) {
        if (
            `${field?.id || ''}` === 'title'
            && this.savedReviewFieldUsesHierarchy(field)
        ) {
            return '상위 자료 대표값';
        }
        if (this.savedReviewFieldUsesHierarchy(field)) return '자료함 대표값';
        return '최종 등록값';
    }

    public savedReviewOriginalValueText(field: any) {
        if (!this.savedReviewFieldUsesHierarchy(field)) {
            return this.xmlReviewValueText(
                field?.original_display_value || field?.original_value
            );
        }
        const childCount = Math.max(0, this.metadataHierarchyUnitCount() - 1);
        if (`${field?.id || ''}` === 'title') {
            return `상위 자료명 ${this.xmlReviewValueText(field.current_value)} · 하위 자료 ${childCount.toLocaleString()}개 별도 보존`;
        }
        return `상위 대표값과 하위 자료별 연대를 분리 보존 · 전체 ${this.metadataHierarchyUnitCount().toLocaleString()}개 자료 단위`;
    }

    private savedHierarchyRequestKey(page: number) {
        return [
            page,
            `${this.savedHierarchyQuery || ''}`.trim(),
            `${this.savedHierarchyLevel || 'all'}`,
        ].join('|');
    }

    public async loadSavedHierarchyUnits(
        page: number = 1,
        force: boolean = false,
    ) {
        if (
            !this.id
            || this.isNewPost()
            || !this.metadataHierarchyApplicable()
        ) return;
        const targetPage = Math.max(1, this.safeNumber(page, 1));
        const requestKey = this.savedHierarchyRequestKey(targetPage);
        if (!force && requestKey === this.savedHierarchyLoadedKey) return;
        const requestToken = ++this.savedHierarchyRequestToken;
        this.savedHierarchyLoading = true;
        this.savedHierarchyError = '';
        await this.service.render();
        try {
            const result = await wiz.call('get', {
                mode: 'hierarchy_units',
                id: this.id,
                query: `${this.savedHierarchyQuery || ''}`.trim(),
                level: this.savedHierarchyLevel === 'all'
                    ? '' : this.savedHierarchyLevel,
                status: 'all',
                page: targetPage,
                dump: this.savedHierarchyPageSize,
            });
            if (requestToken !== this.savedHierarchyRequestToken) return;
            if (result.code !== 200) {
                throw new Error(
                    result.data?.message
                    || '하위 자료 등록값을 불러오지 못했습니다.'
                );
            }
            this.savedHierarchyUnits = Array.isArray(result.data?.units)
                ? result.data.units : [];
            this.savedHierarchyTotal = this.safeNumber(result.data?.total, 0);
            this.savedHierarchyPage = Math.min(
                targetPage, this.savedHierarchyPageCount()
            );
            this.savedHierarchyLoadedKey = requestKey;
        } catch (error) {
            if (requestToken !== this.savedHierarchyRequestToken) return;
            const captured = this.captureError(
                error, '하위 자료 등록값을 불러오지 못했습니다.'
            );
            this.savedHierarchyUnits = [];
            this.savedHierarchyTotal = 0;
            this.savedHierarchyError = captured.message;
        } finally {
            if (requestToken === this.savedHierarchyRequestToken) {
                this.savedHierarchyLoading = false;
                await this.service.render();
            }
        }
    }

    public async searchSavedHierarchyUnits() {
        this.savedHierarchyLoadedKey = '';
        await this.loadSavedHierarchyUnits(1, true);
    }

    public savedHierarchyPageCount() {
        return Math.max(
            1,
            Math.ceil(this.savedHierarchyTotal / this.savedHierarchyPageSize)
        );
    }

    public savedHierarchyPaginationPages() {
        const count = this.savedHierarchyPageCount();
        const start = Math.max(
            1, Math.min(this.savedHierarchyPage - 2, count - 4)
        );
        const end = Math.min(count, start + 4);
        return Array.from(
            { length: Math.max(0, end - start + 1) },
            (_row: any, index: number) => start + index,
        );
    }

    public savedHierarchyCountLabel() {
        const filtered = Math.max(0, this.savedHierarchyTotal);
        const full = Math.max(0, this.metadataHierarchyUnitCount());
        const narrowed = !!`${this.savedHierarchyQuery || ''}`.trim()
            || this.savedHierarchyLevel !== 'all';
        if (narrowed) {
            return `검색 결과 ${filtered.toLocaleString()}개 · 전체 ${full.toLocaleString()}개 자료 단위`;
        }
        return `전체 ${(filtered || full).toLocaleString()}개 자료 단위`;
    }

    public async moveSavedHierarchyPage(page: number) {
        const target = Math.max(
            1, Math.min(this.savedHierarchyPageCount(), page)
        );
        if (
            target === this.savedHierarchyPage
            && this.savedHierarchyLoadedKey
        ) return;
        await this.loadSavedHierarchyUnits(target, true);
    }

    public savedHierarchyUnitTypeLabel(unit: any) {
        if (`${unit?.level || ''}` === 'ITEM') return '상위 자료';
        if (unit?.service_unit) return '사료 발췌';
        return '하위 자료';
    }

    private savedHierarchyUnitMetadata(unit: any) {
        const metadata = unit?.metadata;
        if (metadata && typeof metadata === 'object') return metadata;
        if (typeof metadata !== 'string' || !metadata.trim()) return {};
        try {
            const parsed = JSON.parse(metadata);
            return parsed && typeof parsed === 'object' ? parsed : {};
        } catch (_) {
            return {};
        }
    }

    public savedHierarchyUnitDateText(unit: any) {
        const metadata = this.savedHierarchyUnitMetadata(unit);
        const entries = Array.isArray(metadata?.semantic?.date_entries)
            ? metadata.semantic.date_entries : [];
        const labels: any = {
            dateissued: '발행',
            issued: '발행',
            publicationdate: '발행',
            datecreated: '작성',
            pdate: '작성',
            dateoccurred: '발생',
        };
        const values: string[] = [];
        entries.forEach((entry: any) => {
            const value = `${entry?.value || ''}`.trim();
            if (!value) return;
            const label = labels[
                `${entry?.element || ''}`.toLowerCase()
            ] || '연대';
            const display = `${label} ${value}`;
            if (!values.includes(display)) values.push(display);
        });
        if (!values.length && `${unit?.issued || ''}`.trim()) {
            values.push(`발행 ${`${unit.issued}`.trim()}`);
        }
        return values.join(' · ') || '연대 없음';
    }

    public savedHierarchyUnitDateSourcePath(unit: any) {
        const metadata = this.savedHierarchyUnitMetadata(unit);
        const semanticEntries = Array.isArray(
            metadata?.semantic?.date_entries
        ) ? metadata.semantic.date_entries : [];
        const issuedEntries = Array.isArray(
            metadata?.source_context?.issued_entries
        ) ? metadata.source_context.issued_entries : [];
        const entries = [...semanticEntries, ...issuedEntries];
        const paths = entries.map(
            (entry: any) => `${entry?.source_path || ''}`.trim()
        ).filter(Boolean);
        return Array.from(new Set(paths)).join(' · ');
    }

    public savedHierarchyUnitTitleSourcePath(unit: any) {
        const metadata = this.savedHierarchyUnitMetadata(unit);
        const occurrences = Array.isArray(metadata?.occurrences)
            ? metadata.occurrences : [];
        const title = occurrences.find((row: any) => (
            `${row?.element || row?.name || ''}`.toLowerCase() === 'maintitle'
            && `${row?.source_path || ''}`.includes('/title[')
        ));
        return `${title?.source_path || unit?.unit_path || ''}`;
    }

    public savedReviewSourceIsXml() {
        const metadata = this.data?.ai_metadata || {};
        const candidates = [
            metadata.source_format,
            metadata.file_type,
            metadata.mime_type,
            metadata.source_name,
            this.data?.file_type,
            this.data?.source_name,
        ].map((value: any) => `${value || ''}`.toLocaleLowerCase());
        if (candidates.some((value: string) => (
            value === 'xml'
            || value.includes('application/xml')
            || value.includes('text/xml')
            || value.endsWith('.xml')
        ))) return true;
        return !!(
            this.data?.xml_field_review
            || metadata.xml_field_review
            || this.data?.document_profile
            || metadata.document_profile
        );
    }

    public savedReviewSourceText() {
        return this.savedReviewSourceFullText || `${
            this.profileFieldValue('original_text')
            || this.data?.ocr_text
            || ''
        }`;
    }

    public savedReviewSourceCharacterCount() {
        return this.savedReviewSourceText().length;
    }

    private decodeXmlSource(buffer: ArrayBuffer, contentType: string = '') {
        const bytes = new Uint8Array(buffer);
        if (!bytes.length) return '';

        const candidates: string[] = [];
        let signatureEncoding = '';
        const aliases: any = {
            'utf8': 'utf-8',
            'utf-8': 'utf-8',
            'utf-8-sig': 'utf-8',
            'utf16': 'utf-16',
            'utf-16': 'utf-16',
            'utf16le': 'utf-16le',
            'utf-16le': 'utf-16le',
            'utf-16-le': 'utf-16le',
            'utf16be': 'utf-16be',
            'utf-16be': 'utf-16be',
            'utf-16-be': 'utf-16be',
            'cp949': 'euc-kr',
            'euc-kr': 'euc-kr',
            'windows-949': 'euc-kr',
            'ms949': 'euc-kr',
            'euckr': 'euc-kr',
            'ks-c-5601-1987': 'euc-kr',
        };
        const inferredUtf16Encoding = () => {
            let evenNulls = 0;
            let oddNulls = 0;
            const sampleLength = Math.min(bytes.length - (bytes.length % 2), 256);
            for (let index = 0; index < sampleLength; index += 2) {
                if (bytes[index] === 0) evenNulls += 1;
                if (bytes[index + 1] === 0) oddNulls += 1;
            }
            if (evenNulls > oddNulls * 2) return 'utf-16be';
            return 'utf-16le';
        };
        const addCandidate = (value: string) => {
            let encoding = `${value || ''}`.trim().toLowerCase()
                .replace(/_/g, '-');
            encoding = aliases[encoding] || '';
            if (encoding === 'utf-16') {
                encoding = signatureEncoding.startsWith('utf-16')
                    ? signatureEncoding : '';
            }
            if (
                ['utf-16le', 'utf-16be'].includes(encoding)
                && signatureEncoding !== encoding
            ) {
                encoding = '';
            }
            if (encoding && !candidates.includes(encoding)) {
                candidates.push(encoding);
            }
        };

        if (
            bytes.length >= 3
            && bytes[0] === 0xef
            && bytes[1] === 0xbb
            && bytes[2] === 0xbf
        ) {
            signatureEncoding = 'utf-8';
        } else if (
            bytes.length >= 2
            && bytes[0] === 0xff
            && bytes[1] === 0xfe
        ) {
            signatureEncoding = 'utf-16le';
        } else if (
            bytes.length >= 2
            && bytes[0] === 0xfe
            && bytes[1] === 0xff
        ) {
            signatureEncoding = 'utf-16be';
        } else if (
            bytes.length >= 4
            && bytes[0] === 0x00
            && bytes[1] === 0x3c
            && bytes[2] === 0x00
            && bytes[3] === 0x3f
        ) {
            signatureEncoding = 'utf-16be';
        } else if (
            bytes.length >= 4
            && bytes[0] === 0x3c
            && bytes[1] === 0x00
            && bytes[2] === 0x3f
            && bytes[3] === 0x00
        ) {
            signatureEncoding = 'utf-16le';
        } else {
            const inferredEncoding = inferredUtf16Encoding();
            const sample = bytes.subarray(0, Math.min(bytes.length, 256));
            const nullCount = sample.reduce(
                (count: number, value: number) => count + (value === 0 ? 1 : 0),
                0,
            );
            if (sample.length >= 8 && nullCount >= Math.floor(sample.length / 4)) {
                signatureEncoding = inferredEncoding;
            }
        }
        addCandidate(signatureEncoding);

        // Keep the server-side XML contract: valid UTF-8 wins over a stale
        // legacy declaration, while BOM/signature-detected UTF-16 wins first.
        addCandidate('utf-8');
        const prefix = bytes.subarray(0, Math.min(bytes.length, 1024));
        let declarationProbe = '';
        if (signatureEncoding.startsWith('utf-16')) {
            declarationProbe = new TextDecoder(signatureEncoding).decode(prefix);
        } else {
            declarationProbe = Array.from(prefix)
                .map((value: number) => String.fromCharCode(value))
                .join('');
        }
        const declaration = declarationProbe.replace(/\u0000/g, '').match(
            /<\?xml\b[^>]{0,512}?\bencoding\s*=\s*["']([A-Za-z0-9._:-]{1,64})["']/i,
        );
        if (declaration) addCandidate(declaration[1]);
        const charset = `${contentType || ''}`.match(
            /charset\s*=\s*["']?([^;\s"']+)/i,
        );
        if (charset) addCandidate(charset[1]);
        addCandidate('euc-kr');

        for (const encoding of candidates) {
            try {
                const decoded = new TextDecoder(
                    encoding,
                    { fatal: true },
                ).decode(bytes).replace(/^\uFEFF/, '');
                if (
                    !decoded.includes('\u0000')
                    && decoded.trimStart().startsWith('<')
                ) return decoded;
            } catch (_) { }
        }
        throw new Error('XML 문자 인코딩을 해석할 수 없습니다.');
    }

    public async ensureSavedReviewSource() {
        if (
            this.savedReviewSourceLoaded
            || this.savedReviewSourceLoading
            || !this.savedReviewSourceIsXml()
            || !this.canManageSavedReview()
        ) return;
        this.savedReviewSourceLoading = true;
        this.savedReviewSourceError = '';
        await this.service.render();
        try {
            const query = new URLSearchParams({
                mode: 'registered_source',
                id: `${this.id}`,
            });
            const response = await fetch(
                `/wiz/api/portal.post.detail/analyze?${query.toString()}`,
                { method: 'POST', credentials: 'same-origin' },
            );
            if (!response.ok) {
                let message = '등록 XML 원문 전체를 불러오지 못했습니다.';
                try {
                    const payload = await response.json();
                    message = payload?.data?.message || payload?.message || message;
                } catch (_) { }
                throw new Error(message);
            }
            const sourceBuffer = await response.arrayBuffer();
            const sourceText = this.decodeXmlSource(
                sourceBuffer,
                response.headers.get('Content-Type') || '',
            );
            if (!sourceText) {
                throw new Error('보존된 XML 원문이 비어 있습니다.');
            }
            this.savedReviewSourceFullText = sourceText;
            this.savedReviewSourceLoaded = true;
        } catch (error) {
            const captured = this.captureError(
                error, '등록 XML 원문 전체를 불러오지 못했습니다.'
            );
            this.savedReviewSourceError = captured.message;
        } finally {
            this.savedReviewSourceLoading = false;
            await this.service.render();
        }
    }

    public async selectSavedReviewSection(section: string) {
        const sections: SavedReviewSectionKey[] = [
            'basic', 'classification', 'metadata', 'scope', 'content',
            'source', 'toc', 'images', 'entities', 'relations', 'history',
        ];
        if (!sections.includes(section as SavedReviewSectionKey)) return;
        if (section === 'toc' && !this.savedDetailHasToc()) return;
        this.savedReviewActionsOpen = false;
        this.savedReviewSection = section as SavedReviewSectionKey;
        if (this.savedReviewSection !== 'metadata') {
            this.savedReviewMetadataAllItems = false;
        }
        if (this.savedReviewSection === 'metadata' && !this.xmlReviewActiveField()) {
            this.initialiseMetadataReviewFocus();
        }
        if (this.savedReviewSection === 'scope') {
            this.savedDtdGroupFilter = 'all';
            this.savedDtdShowAllGroups = false;
            this.initialiseDtdReviewFocus();
        }
        await this.service.render();
        if (this.savedReviewSection === 'scope') {
            void this.loadSavedDtdOccurrences(1);
        }
        if (this.savedReviewSection === 'source') {
            await this.ensureSavedReviewSource();
        }
        if (this.savedReviewSection === 'images') {
            await this.loadSavedImageAssets(
                this.safeNumber(this.savedImageAssets?.page, 1), true
            );
        }
        if (this.savedReviewSection === 'relations') {
            await this.loadItemManifestationRegistry();
        }
    }

    public savedReviewStageVisible(section: SavedReviewSectionKey) {
        return !this.hiddenSavedReviewStageKeys.includes(section);
    }

    public async loadItemManifestationRegistry(
        force: boolean = false, relationId: string = ''
    ) {
        if (!this.id || this.isNewPost() || this.itemRegistryLoading) return;
        if (this.itemRegistry && !force) return;
        this.itemRegistryLoading = true;
        this.itemRegistryError = '';
        await this.service.render();
        try {
            const result = await wiz.call('get', {
                mode: 'item_manifestations', id: this.id,
                relation_id: relationId,
            });
            if (result.code !== 200) {
                throw new Error(
                    result.data?.message || 'ITEM 관계 정보를 불러오지 못했습니다.'
                );
            }
            this.itemRegistry = result.data?.registry || null;
            const relations = Array.isArray(this.itemRegistry?.relations)
                ? this.itemRegistry.relations : [];
            if (!relations.some(
                (row: any) => `${row?.id || ''}` === this.itemRegistrySelectedRelationId
            )) {
                this.itemRegistrySelectedRelationId = `${relations[0]?.id || ''}`;
            }
        } catch (error) {
            this.itemRegistryError = this.captureError(
                error, 'ITEM 관계 정보를 불러오지 못했습니다.'
            ).message;
        } finally {
            this.itemRegistryLoading = false;
            await this.service.render();
        }
    }

    public itemRegistryManifestations() {
        return Array.isArray(this.itemRegistry?.manifestations)
            ? this.itemRegistry.manifestations : [];
    }

    public itemRegistryRelations() {
        return Array.isArray(this.itemRegistry?.relations)
            ? this.itemRegistry.relations : [];
    }

    public itemRegistryAllAlignments() {
        return Array.isArray(this.itemRegistry?.alignments)
            ? this.itemRegistry.alignments : [];
    }

    public itemRegistryAllLinks() {
        return Array.isArray(this.itemRegistry?.links)
            ? this.itemRegistry.links : [];
    }

    public itemRegistryCurrentManifestation() {
        return this.itemRegistryManifestations().find(
            (row: any) => `${row?.post_id || ''}` === `${this.id || ''}`
        ) || null;
    }

    public itemRegistryManifestationRelations(manifestation: any) {
        const manifestationId = `${manifestation?.id || ''}`;
        if (!manifestationId) return [];
        return this.itemRegistryRelations().filter((row: any) => (
            `${row?.source_manifestation_id || ''}` === manifestationId
            || `${row?.target_manifestation_id || ''}` === manifestationId
        ));
    }

    public itemRegistryManifestationAlignments(manifestation: any) {
        const relationIds = new Set(
            this.itemRegistryManifestationRelations(manifestation).map(
                (row: any) => `${row?.id || ''}`
            )
        );
        return this.itemRegistryAllAlignments().filter(
            (row: any) => relationIds.has(`${row?.relation_id || ''}`)
        );
    }

    public itemRegistryManifestationLinks(manifestation: any) {
        const manifestationId = `${manifestation?.id || ''}`;
        if (!manifestationId) return [];
        return this.itemRegistryAllLinks().filter(
            (row: any) => `${row?.manifestation_id || ''}` === manifestationId
        );
    }

    public itemRegistryCurrentLinks() {
        return this.itemRegistryManifestationLinks(
            this.itemRegistryCurrentManifestation()
        );
    }

    public itemRegistryManifestationPendingCounts(manifestation: any) {
        const relations = this.itemRegistryManifestationRelations(manifestation).filter(
            (row: any) => `${row?.status || ''}` === 'candidate'
        ).length;
        const alignments = this.itemRegistryManifestationAlignments(manifestation).filter(
            (row: any) => ['candidate', 'unresolved'].includes(`${row?.status || ''}`)
        ).length;
        const linkRows = this.itemRegistryManifestationLinks(manifestation);
        const linkValidation = linkRows.filter(
            (row: any) => `${row?.resolution_status || ''}` === 'unresolved'
        ).length;
        const linkApproval = linkRows.filter(
            (row: any) => `${row?.review_status || ''}` === 'candidate'
        ).length;
        const links = linkRows.filter(
            (row: any) => (
                `${row?.review_status || ''}` === 'candidate'
                || `${row?.resolution_status || ''}` === 'unresolved'
            )
        ).length;
        return { relations, alignments, links, linkValidation, linkApproval };
    }

    public itemRegistryManifestationPendingCount(manifestation: any) {
        const counts = this.itemRegistryManifestationPendingCounts(manifestation);
        return counts.relations + counts.alignments + counts.links;
    }

    public itemRegistryPendingReviewCount() {
        const relations = this.itemRegistryRelations().filter(
            (row: any) => `${row?.status || ''}` === 'candidate'
        ).length;
        const alignments = this.itemRegistryAllAlignments().filter(
            (row: any) => ['candidate', 'unresolved'].includes(`${row?.status || ''}`)
        ).length;
        const links = this.itemRegistryAllLinks().filter(
            (row: any) => (
                `${row?.review_status || ''}` === 'candidate'
                || `${row?.resolution_status || ''}` === 'unresolved'
            )
        ).length;
        return relations + alignments + links;
    }

    public itemRegistryReviewComplete() {
        return Boolean(
            this.itemRegistry?.validation?.valid
            && this.itemRegistryPendingReviewCount() === 0
        );
    }

    public itemRegistryRelationUnavailableReason() {
        const manifestations = this.itemRegistryManifestations();
        const originals = manifestations.filter(
            (row: any) => `${row?.role || ''}` === 'd'
        );
        const targets = manifestations.filter(
            (row: any) => !['', 'd'].includes(`${row?.role || ''}`)
        );
        const sequences = originals.map(
            (row: any) => `${row?.sequence || '-'}`
        ).filter(Boolean).join('·');
        if (originals.length && !targets.length) {
            return `현재 ITEM에는 d 원문 ${originals.length}개${sequences ? ` (순번 ${sequences})` : ''}만 있고, 같은 순번의 번역문·판본 파일이 없어 원문 · 번역문 통합 검수와 개체·용어 대응 검수를 시작할 수 없습니다.`;
        }
        if (!originals.length) {
            return '관계의 기준이 되는 d 원문이 없어 원문 · 번역문 통합 검수와 대응 검수를 시작할 수 없습니다.';
        }
        return '같은 ITEM·순번으로 연결할 원문과 번역문·판본 조합을 찾지 못했습니다.';
    }

    public itemRegistryManifestationStatusLabel(manifestation: any) {
        const pending = this.itemRegistryManifestationPendingCount(manifestation);
        if (pending) return `검수 필요 ${pending}건`;
        if (
            `${manifestation?.role || ''}` === 'd'
            && this.itemRegistryManifestationRelations(manifestation).length === 0
        ) return '관계 대상 없음';
        return this.itemRegistryStatusLabel(manifestation?.relation_status);
    }

    public itemRegistryManifestationStatusClass(manifestation: any) {
        if (this.itemRegistryManifestationPendingCount(manifestation)) {
            return 'is-candidate';
        }
        if (
            `${manifestation?.role || ''}` === 'd'
            && this.itemRegistryManifestationRelations(manifestation).length === 0
        ) return 'is-neutral';
        return this.itemRegistryStatusClass(manifestation?.relation_status);
    }

    public itemRegistryManifestationStatusReason(manifestation: any) {
        const counts = this.itemRegistryManifestationPendingCounts(manifestation);
        const parts = [];
        if (counts.relations) parts.push(`관계 후보 ${counts.relations}건`);
        if (counts.alignments) parts.push(`대응 후보 ${counts.alignments}건`);
        if (counts.links) {
            const linkReasons = [];
            if (counts.linkValidation) {
                linkReasons.push(`유효성 미확인 ${counts.linkValidation}건`);
            }
            if (counts.linkApproval) {
                linkReasons.push(`승인 전 ${counts.linkApproval}건`);
            }
            parts.push(`외부 링크 ${counts.links}건(${linkReasons.join(' · ')})`);
        }
        if (parts.length) {
            const relationNote = (
                `${manifestation?.role || ''}` === 'd'
                && this.itemRegistryManifestationRelations(manifestation).length === 0
            ) ? ' 같은 순번의 번역문·판본은 없어 언어·판본 관계 검수 대상은 아닙니다.' : '';
            return `확인할 항목은 ${parts.join(', ')}입니다.${relationNote}`;
        }
        if (
            `${manifestation?.role || ''}` === 'd'
            && this.itemRegistryManifestationRelations(manifestation).length === 0
        ) {
            return '같은 순번의 번역문·판본이 없어 현재 검수할 언어·판본 관계가 없습니다.';
        }
        return `${this.itemRegistryStatusLabel(manifestation?.relation_status)} 상태입니다.`;
    }

    public itemRegistrySelectedRelation() {
        return this.itemRegistryRelations().find(
            (row: any) => `${row?.id || ''}` === this.itemRegistrySelectedRelationId
        ) || null;
    }

    public itemRegistryManifestation(id: any) {
        return this.itemRegistryManifestations().find(
            (row: any) => `${row?.id || ''}` === `${id || ''}`
        ) || null;
    }

    public itemRegistryRelationSource(relation: any = null) {
        const row = relation || this.itemRegistrySelectedRelation();
        return this.itemRegistryManifestation(row?.source_manifestation_id);
    }

    public itemRegistryRelationTarget(relation: any = null) {
        const row = relation || this.itemRegistrySelectedRelation();
        return this.itemRegistryManifestation(row?.target_manifestation_id);
    }

    public itemRegistryStatusLabel(status: any) {
        const labels: any = {
            candidate: '검수 필요', approved: '승인', rejected: '거절',
            independent: '독립 자료', missing_original: '원문 누락',
            linked: '관계 확정', unresolved: '후보 없음', excluded: '제외',
            available: '접근 가능', missing: '없음', forbidden: '접근 제한',
            invalid: '잘못된 링크', blocked: '안전상 차단',
        };
        return labels[`${status || ''}`] || `${status || '-'}`;
    }

    public itemRegistryStatusClass(status: any) {
        const value = `${status || ''}`;
        if (['approved', 'linked', 'available'].includes(value)) return 'is-approved';
        if (['rejected', 'missing', 'invalid'].includes(value)) return 'is-rejected';
        if (['missing_original', 'forbidden', 'blocked', 'unresolved'].includes(value)) return 'is-warning';
        if (value === 'excluded') return 'is-excluded';
        return 'is-candidate';
    }

    public async selectItemRegistryView(
        view: 'manifestations' | 'compare' | 'alignments'
    ) {
        this.itemRegistryView = view;
        await this.service.render();
        if (['compare', 'alignments'].includes(view) && this.itemRegistrySelectedRelationId) {
            await this.loadItemManifestationRegistry(
                true, this.itemRegistrySelectedRelationId
            );
        }
        if (view === 'compare') await this.loadItemRegistryComparisonSources();
    }

    public async selectItemRegistryRelation(relation: any) {
        this.itemRegistrySelectedRelationId = `${relation?.id || ''}`;
        this.itemRegistrySourceError = '';
        this.itemRegistrySelectedAlignmentId = '';
        await this.service.render();
        if (
            ['compare', 'alignments'].includes(this.itemRegistryView)
            && this.itemRegistrySelectedRelationId
        ) {
            await this.loadItemManifestationRegistry(
                true, this.itemRegistrySelectedRelationId
            );
        }
        if (this.itemRegistryView === 'compare') {
            await this.loadItemRegistryComparisonSources();
        }
    }

    public itemRegistryComparisonAlignments() {
        const rows = Array.isArray(this.itemRegistry?.alignments)
            ? this.itemRegistry.alignments : [];
        return rows.filter((row: any) => (
            `${row?.relation_id || ''}` === this.itemRegistrySelectedRelationId
        ));
    }

    public itemRegistryComparisonVisibleAlignments() {
        return this.itemRegistryComparisonAlignments().filter((row: any) => (
            this.itemRegistryAlignmentType === 'all'
            || `${row?.alignment_type || ''}` === this.itemRegistryAlignmentType
        )).slice(0, 120);
    }

    public itemRegistrySelectedComparisonAlignment() {
        return this.itemRegistryComparisonAlignments().find(
            (row: any) => `${row?.id || ''}` === this.itemRegistrySelectedAlignmentId
        ) || null;
    }

    public itemRegistryAlignmentTypeLabel(value: any) {
        const labels: any = { entity: '개체명', term: 'DTD 용어', link: '링크' };
        return labels[`${value || ''}`] || '대응 후보';
    }

    public itemRegistrySourceWindow(manifestation: any) {
        return this.itemRegistrySourceWindows[`${manifestation?.post_id || ''}`] || null;
    }

    public itemRegistrySourceQuery(manifestation: any) {
        return `${this.itemRegistrySourceQueries[`${manifestation?.post_id || ''}`] || ''}`;
    }

    public itemRegistryWindowRange(manifestation: any) {
        const row = this.itemRegistrySourceWindow(manifestation);
        if (!row) return '원문 구간 준비 중';
        return `${Number(row.start_line || 1).toLocaleString('ko-KR')}–${Number(row.end_line || 1).toLocaleString('ko-KR')}행 · ${Number(row.byte_size || 0).toLocaleString('ko-KR')} bytes`;
    }

    public itemRegistryWindowBefore(manifestation: any) {
        const row = this.itemRegistrySourceWindow(manifestation);
        if (!row) return '';
        const start = Number(row.match_start);
        return start >= 0 ? `${row.text || ''}`.slice(0, start) : `${row.text || ''}`;
    }

    public itemRegistryWindowMatch(manifestation: any) {
        const row = this.itemRegistrySourceWindow(manifestation);
        if (!row || Number(row.match_start) < 0) return '';
        return `${row.text || ''}`.slice(Number(row.match_start), Number(row.match_end));
    }

    public itemRegistryWindowAfter(manifestation: any) {
        const row = this.itemRegistrySourceWindow(manifestation);
        if (!row || Number(row.match_start) < 0) return '';
        return `${row.text || ''}`.slice(Number(row.match_end));
    }

    private async loadItemRegistrySourceWindow(
        manifestation: any, offset: number = 0, query: string = '', matchIndex: number = 0
    ) {
        const postId = `${manifestation?.post_id || ''}`;
        if (!postId) return;
        const result = await wiz.call('get', {
            mode: 'registered_source_window', id: postId,
            offset, limit: 32000, query, match_index: matchIndex,
        });
        if (result.code !== 200) {
            throw new Error(
                result.data?.message || '비교할 XML 원문 구간을 불러오지 못했습니다.'
            );
        }
        this.itemRegistrySourceWindows[postId] = result.data?.source_window || null;
        this.itemRegistrySourceQueries[postId] = query;
    }

    public async loadItemRegistryComparisonSources() {
        const relation = this.itemRegistrySelectedRelation();
        const source = this.itemRegistryRelationSource(relation);
        const target = this.itemRegistryRelationTarget(relation);
        if (!source?.post_id || !target?.post_id || this.itemRegistrySourceLoading) return;
        this.itemRegistrySourceLoading = true;
        this.itemRegistrySourceError = '';
        await this.service.render();
        try {
            const alignments = this.itemRegistryComparisonAlignments();
            let alignment = this.itemRegistrySelectedComparisonAlignment();
            if (!alignment && alignments.length) {
                alignment = alignments.find((row: any) => (
                    row?.target_key && row?.status !== 'excluded'
                )) || alignments[0];
                this.itemRegistrySelectedAlignmentId = `${alignment?.id || ''}`;
            }
            const sourceQuery = `${alignment?.source_value || ''}`.trim().slice(0, 300);
            const targetQuery = `${alignment?.target_value || ''}`.trim().slice(0, 300);
            await Promise.all([
                this.loadItemRegistrySourceWindow(source, 0, sourceQuery, 0),
                this.loadItemRegistrySourceWindow(target, 0, targetQuery, 0),
            ]);
        } catch (error) {
            this.itemRegistrySourceError = this.captureError(
                error, '원문 · 번역문 통합 검수 자료를 불러오지 못했습니다.'
            ).message;
        } finally {
            this.itemRegistrySourceLoading = false;
            await this.service.render();
        }
    }

    public async selectItemRegistryComparisonAlignment(alignment: any) {
        this.itemRegistrySelectedAlignmentId = `${alignment?.id || ''}`;
        await this.loadItemRegistryComparisonSources();
    }

    public async shiftItemRegistrySourceWindow(manifestation: any, direction: 'previous' | 'next') {
        const row = this.itemRegistrySourceWindow(manifestation);
        if (!row || this.itemRegistrySourceLoading) return;
        this.itemRegistrySourceLoading = true;
        this.itemRegistrySourceError = '';
        await this.service.render();
        try {
            await this.loadItemRegistrySourceWindow(
                manifestation,
                Number(direction === 'previous' ? row.previous_offset : row.next_offset) || 0,
                '', 0,
            );
        } catch (error) {
            this.itemRegistrySourceError = this.captureError(
                error, 'XML 원문의 다음 구간을 불러오지 못했습니다.'
            ).message;
        } finally {
            this.itemRegistrySourceLoading = false;
            await this.service.render();
        }
    }

    public async searchItemRegistrySourceWindow(manifestation: any, matchIndex: number = 0) {
        if (!manifestation?.post_id || this.itemRegistrySourceLoading) return;
        this.itemRegistrySourceLoading = true;
        this.itemRegistrySourceError = '';
        await this.service.render();
        try {
            await this.loadItemRegistrySourceWindow(
                manifestation, 0,
                this.itemRegistrySourceQuery(manifestation), matchIndex,
            );
        } catch (error) {
            this.itemRegistrySourceError = this.captureError(
                error, 'XML 원문에서 대응 값을 찾지 못했습니다.'
            ).message;
        } finally {
            this.itemRegistrySourceLoading = false;
            await this.service.render();
        }
    }

    public async nextItemRegistrySourceMatch(manifestation: any, delta: number) {
        const row = this.itemRegistrySourceWindow(manifestation);
        if (!row || !row.match_count) return;
        const nextIndex = Math.max(
            0, Math.min(Number(row.match_count) - 1, Number(row.match_index) + delta)
        );
        await this.searchItemRegistrySourceWindow(manifestation, nextIndex);
    }

    public itemRegistryFilteredAlignments() {
        const rows = Array.isArray(this.itemRegistry?.alignments)
            ? this.itemRegistry.alignments : [];
        return rows.filter((row: any) => (
            `${row?.relation_id || ''}` === this.itemRegistrySelectedRelationId
            && (
                this.itemRegistryAlignmentType === 'all'
                || `${row?.alignment_type || ''}` === this.itemRegistryAlignmentType
            )
        ));
    }

    public itemRegistryLinks() {
        const relation = this.itemRegistrySelectedRelation();
        const ids = new Set([
            this.itemRegistryRelationSource(relation)?.id,
            this.itemRegistryRelationTarget(relation)?.id,
        ].filter(Boolean));
        if (!ids.size) {
            const currentId = this.itemRegistryCurrentManifestation()?.id;
            if (currentId) ids.add(currentId);
        }
        return this.itemRegistryAllLinks()
            .filter((row: any) => ids.has(row?.manifestation_id));
    }

    public itemRegistryPendingApprovalLinks() {
        return this.itemRegistryLinks().filter((row: any) => (
            `${row?.review_status || 'candidate'}` === 'candidate'
        ));
    }

    public async bulkApproveItemRegistryLinks() {
        const links = this.itemRegistryPendingApprovalLinks();
        if (!links.length || this.itemRegistrySavingId) return;
        this.itemRegistryBulkApproving = true;
        this.itemRegistrySavingId = 'bulk-links';
        await this.service.render();
        try {
            const result = await wiz.call('save', {
                mode: 'item_link_bulk_approve', id: this.id,
                target_kind: 'link',
                targets: JSON.stringify(links.map((row: any) => ({
                    id: row.id, version: row.version,
                }))),
            });
            if (result.code !== 200) throw new Error(
                result.data?.message || '링크 일괄 승인 결과를 저장하지 못했습니다.'
            );
            this.itemRegistry = result.data?.registry || this.itemRegistry;
            const summary = result.data?.bulk || {};
            const approved = Number(summary.approved_count) || 0;
            const failed = Number(summary.failed_count) || 0;
            const skipped = Number(summary.skipped_count) || 0;
            if (!approved && failed) {
                await this.service.modal.error(
                    `승인된 링크가 없습니다. ${failed}건은 유효성 확인을 통과하지 못했습니다.`
                );
            } else {
                const details = [
                    `${approved}건 승인 완료`,
                    failed ? `${failed}건 유효성 확인 필요` : '',
                    skipped ? `${skipped}건 기존 검수 상태 유지` : '',
                ].filter(Boolean).join(' · ');
                await this.service.modal.success(details);
            }
        } catch (error) {
            await this.service.modal.error(this.captureError(
                error, '링크 일괄 승인 중 오류가 발생했습니다.'
            ).message);
        } finally {
            this.itemRegistryBulkApproving = false;
            this.itemRegistrySavingId = '';
            await this.service.render();
        }
    }

    private async submitItemRegistryReview(
        targetKind: 'relation' | 'alignment' | 'link', row: any,
        status: string,
    ) {
        if (!row?.id || this.itemRegistrySavingId) return;
        const reason = `${row.review_reason || ''}`.trim();
        if (['rejected', 'independent', 'excluded'].includes(status) && !reason) {
            await this.service.modal.error('거절·독립·제외 처리에는 판단 사유를 입력해주세요.');
            return;
        }
        this.itemRegistrySavingId = `${row.id}`;
        await this.service.render();
        try {
            const result = await wiz.call('save', {
                mode: 'item_manifestation_review', id: this.id,
                target_kind: targetKind, target_id: row.id,
                status, expected_version: row.version,
                relation_type: row.relation_type || 'unknown', reason,
            });
            if (result.code !== 200) throw new Error(
                result.data?.message || 'ITEM 관계 검수 결과를 저장하지 못했습니다.'
            );
            this.itemRegistry = result.data?.registry || this.itemRegistry;
        } catch (error) {
            await this.service.modal.error(this.captureError(
                error, 'ITEM 관계 검수 중 오류가 발생했습니다.'
            ).message);
        } finally {
            this.itemRegistrySavingId = '';
            await this.service.render();
        }
    }

    public async reviewItemRegistryRelation(row: any, status: string) {
        await this.submitItemRegistryReview('relation', row, status);
    }

    public async reviewItemRegistryAlignment(row: any, status: string) {
        await this.submitItemRegistryReview('alignment', row, status);
    }

    public async reviewItemRegistryLink(row: any, status: string) {
        await this.submitItemRegistryReview('link', row, status);
    }

    public async validateItemRegistryLink(row: any) {
        if (!row?.id || this.itemRegistrySavingId) return;
        this.itemRegistrySavingId = `${row.id}`;
        await this.service.render();
        try {
            const result = await wiz.call('save', {
                mode: 'item_link_validate', id: this.id,
                target_kind: 'link', target_id: row.id,
            });
            if (result.code !== 200) throw new Error(
                result.data?.message || '링크 유효성을 확인하지 못했습니다.'
            );
            this.itemRegistry = result.data?.registry || this.itemRegistry;
        } catch (error) {
            await this.service.modal.error(this.captureError(
                error, '링크 확인 중 오류가 발생했습니다.'
            ).message);
        } finally {
            this.itemRegistrySavingId = '';
            await this.service.render();
        }
    }

    public async selectSavedDtdReviewField(field: any) {
        if (!field) return;
        this.dtdCoverageActiveGroup = `${field.group_id || ''}`;
        this.dtdReviewActiveFieldId = `${field.id || ''}`;
        await this.service.render();
        await this.loadSavedDtdOccurrences(1, true);
    }

    public async loadSavedDtdOccurrences(page: number = 1, reset: boolean = false) {
        const field = this.savedReviewDtdActiveField();
        const fieldId = `${field?.id || ''}`;
        if (!this.id || !fieldId) return;
        const requestToken = ++this.savedDtdOccurrenceRequestToken;
        const fieldChanged = this.savedDtdOccurrenceFieldId !== fieldId;
        if (reset || fieldChanged) {
            this.savedDtdOccurrenceFieldId = fieldId;
            this.savedDtdOccurrenceItems = [];
            this.savedDtdOccurrencePage = 1;
            this.savedDtdOccurrencePages = 1;
            this.savedDtdOccurrenceTotal = 0;
            this.savedDtdOccurrenceError = '';
            if (fieldChanged) this.savedDtdOccurrenceQuery = '';
        }
        this.savedDtdOccurrenceLoading = true;
        this.savedDtdOccurrenceError = '';
        await this.service.render();
        try {
            const result = await wiz.call('get', {
                mode: 'dtd_occurrences',
                id: this.id,
                field_id: fieldId,
                page: Math.max(1, Number(page || 1)),
                dump: 20,
                query: `${this.savedDtdOccurrenceQuery || ''}`.trim(),
            });
            if (result.code !== 200) {
                throw new Error(
                    result.data?.message || 'DTD 전체 반복값을 불러오지 못했습니다.'
                );
            }
            const data = result.data?.occurrences || {};
            if (
                requestToken !== this.savedDtdOccurrenceRequestToken
                || `${data.field_id || ''}` !== fieldId
                || `${this.savedReviewDtdActiveField()?.id || ''}` !== fieldId
            ) return;
            this.savedDtdOccurrenceItems = Array.isArray(data.items)
                ? data.items : [];
            this.savedDtdOccurrencePage = Math.max(1, Number(data.page || 1));
            this.savedDtdOccurrencePages = Math.max(1, Number(data.pages || 1));
            this.savedDtdOccurrenceTotal = Math.max(0, Number(data.total || 0));
        } catch (error) {
            if (requestToken !== this.savedDtdOccurrenceRequestToken) return;
            const captured = this.captureError(
                error, 'DTD 전체 반복값을 불러오지 못했습니다.'
            );
            this.savedDtdOccurrenceError = captured.message;
        } finally {
            if (requestToken === this.savedDtdOccurrenceRequestToken) {
                this.savedDtdOccurrenceLoading = false;
                await this.service.render();
            }
        }
    }

    public async searchSavedDtdOccurrences() {
        await this.loadSavedDtdOccurrences(1, true);
    }

    public async moveSavedDtdOccurrencePage(direction: -1 | 1) {
        const target = Math.min(
            this.savedDtdOccurrencePages,
            Math.max(1, this.savedDtdOccurrencePage + direction),
        );
        if (target === this.savedDtdOccurrencePage) return;
        await this.loadSavedDtdOccurrences(target);
    }

    private savedReviewCommonFieldValues(fieldId: string, rawValue: any) {
        if (['created_dates', 'issued_dates'].includes(fieldId)) {
            return this.normaliseDateValues(rawValue);
        }
        const text = `${rawValue || ''}`;
        if (['authors', 'keywords'].includes(fieldId)) {
            return text
                .split(/[,\n·|]/)
                .map((value: string) => value.trim())
                .filter(Boolean)
                .slice(0, 20);
        }
        return [text.trim()];
    }

    public savedReviewDateValues(fieldId: string) {
        if (!['created_dates', 'issued_dates'].includes(fieldId)) return [''];
        const rows = Array.isArray(this.data?.[fieldId])
            ? this.data[fieldId].map((row: any) => `${row || ''}`)
            : [];
        return rows.length ? rows : [''];
    }

    private setSavedReviewDateValues(fieldId: string, values: any[]) {
        if (!this.data || !['created_dates', 'issued_dates'].includes(fieldId)) return;
        const draftValues = (Array.isArray(values) ? values : [])
            .map((row: any) => `${row || ''}`).slice(0, 20);
        this.data[fieldId] = draftValues;
        const canonical = this.normaliseDateValues(draftValues);
        this.data.document_date = this.normaliseDateValues(
            this.data.issued_dates
        )[0] || this.normaliseDateValues(this.data.created_dates)[0] || '';
        [this.data.xml_field_review, this.data.common_metadata_review]
            .filter((review: any) => review && typeof review === 'object')
            .forEach((review: any) => {
                const field = (Array.isArray(review.fields) ? review.fields : [])
                    .find((row: any) => `${row?.id || ''}` === fieldId);
                if (!field) return;
                field.current_value = [...canonical];
                field.status = this.xmlReviewChanged(field)
                    ? 'modified' : 'unreviewed';
                field.reviewed = false;
            });
        this.markSavedReviewDirty();
    }

    public updateSavedReviewDateValue(
        fieldId: string, index: number, rawValue: any
    ) {
        const values = [...this.savedReviewDateValues(fieldId)];
        while (values.length <= index) values.push('');
        values[index] = `${rawValue || ''}`;
        this.setSavedReviewDateValues(fieldId, values);
    }

    public async addSavedReviewDateValue(fieldId: string) {
        const values = [...this.savedReviewDateValues(fieldId), ''];
        this.setSavedReviewDateValues(fieldId, values);
        await this.renderPreservingViewport();
    }

    public async removeSavedReviewDateValue(fieldId: string, index: number) {
        const values = [...this.savedReviewDateValues(fieldId)];
        values.splice(index, 1);
        this.setSavedReviewDateValues(fieldId, values);
        await this.renderPreservingViewport();
    }

    public updateSavedReviewCommonField(fieldId: string, rawValue: any) {
        if (!this.data || !this.savedReviewHydrated) return;
        if (fieldId === 'era') {
            this.updateSavedReviewEraSelection(rawValue);
            return;
        }
        const formKeys: any = {
            title: 'title',
            authors: 'authors',
            publisher: 'publisher',
            era: 'era',
            category: 'category',
            keywords: 'keywords',
            language: 'language',
            summary: 'content',
        };
        const formKey = formKeys[fieldId];
        if (!formKey) return;
        const controlledValue = `${rawValue || ''}`;
        this.data[formKey] = controlledValue;
        const values = this.savedReviewCommonFieldValues(
            fieldId, controlledValue
        );
        [this.data.xml_field_review, this.data.common_metadata_review]
            .filter((review: any) => review && typeof review === 'object')
            .forEach((review: any) => {
                const fields = Array.isArray(review.fields) ? review.fields : [];
                const field = fields.find(
                    (row: any) => `${row?.id || ''}` === fieldId
                );
                if (!field) return;
                field.current_value = field.repeatable ? [...values] : values.slice(0, 1);
                field.status = this.xmlReviewChanged(field) ? 'modified' : 'unreviewed';
                field.reviewed = false;
            });
        this.markSavedReviewDirty();
    }

    public savedReviewEraField() {
        const reviews = [
            this.data?.xml_field_review,
            this.data?.common_metadata_review,
        ];
        for (const review of reviews) {
            const field = (Array.isArray(review?.fields) ? review.fields : [])
                .find((row: any) => `${row?.id || ''}` === 'era');
            if (field) return field;
        }
        return null;
    }

    private setSavedReviewEraControl(rawCode: any, rawOther: any) {
        if (!this.data || !this.savedReviewHydrated) return;
        const code = this.eraOptions.includes(`${rawCode || ''}`)
            ? `${rawCode || ''}` : '';
        const other = code === '기타'
            ? `${rawOther || ''}`.slice(0, 100) : '';
        const currentValue = code === '기타' ? other : code;
        this.data.era = currentValue;
        [this.data.xml_field_review, this.data.common_metadata_review]
            .filter((review: any) => review && typeof review === 'object')
            .forEach((review: any) => {
                const field = (Array.isArray(review.fields) ? review.fields : [])
                    .find((row: any) => `${row?.id || ''}` === 'era');
                if (!field) return;
                field.era_code = code;
                field.era_other_value = other;
                field.current_value = currentValue ? [currentValue] : [];
                field.status = this.xmlReviewChanged(field)
                    ? 'modified' : 'unreviewed';
                field.reviewed = false;
            });
        this.markSavedReviewDirty();
    }

    public updateSavedReviewEraSelection(rawCode: any) {
        const field = this.savedReviewEraField();
        const other = `${rawCode || ''}` === '기타'
            ? this.eraOtherInputValue(field, this.data?.era) : '';
        this.setSavedReviewEraControl(rawCode, other);
    }

    public updateSavedReviewEraOtherValue(rawValue: any) {
        this.setSavedReviewEraControl('기타', rawValue);
    }

    public markSavedReviewDirty() {
        if (this.isNewPost() || !this.data || !this.savedReviewHydrated) return;
        this.savedReviewDirty = true;
        this.savedReviewMutationVersion += 1;
        this.savedReviewNotice = '변경 내용을 자동 저장할 예정입니다.';
        if (!this.canManageSavedReview()) return;
        if (this.savedReviewAutosaveTimer) clearTimeout(this.savedReviewAutosaveTimer);
        this.savedReviewAutosaveTimer = setTimeout(() => {
            this.savedReviewAutosaveTimer = null;
            void this.persistSavedReview('save', true);
        }, this.savedReviewAutosaveDelayMs);
    }

    private savedReviewSubmittedFields(fields: any) {
        const rows = Array.isArray(fields) ? fields : [];
        const allowed = [
            'id', 'current_value', 'status', 'reviewed', 'reason',
            'standard_reference', 'scope_review', 'search_index',
            'era_code', 'era_other_value',
        ];
        return rows.map((field: any) => {
            const result = allowed.reduce((submitted: any, key: string) => {
                if (typeof field?.[key] !== 'undefined') {
                    submitted[key] = JSON.parse(JSON.stringify(field[key]));
                }
                return submitted;
            }, {});
            if (result.id === 'era') {
                const raw = Array.isArray(result.current_value)
                    ? result.current_value[0] : result.current_value;
                const code = this.eraSelectionValue(field, raw);
                const other = code === '기타'
                    ? this.eraOtherInputValue(field, raw) : '';
                result.era_code = code;
                result.era_other_value = other;
                const era = code === '기타'
                    ? (other || (`${raw || ''}`.trim() === '기타' ? '기타' : ''))
                    : code;
                result.current_value = era ? [era] : [];
            }
            return result;
        });
    }

    private savedReviewFallbackCommonFields() {
        const values: any = {
            title: `${this.data?.title || ''}`,
            authors: this.savedReviewCommonFieldValues(
                'authors', this.data?.authors
            ),
            publisher: `${this.data?.publisher || ''}`,
            created_dates: this.normaliseDateValues(this.data?.created_dates),
            issued_dates: this.normaliseDateValues(this.data?.issued_dates),
            era: `${this.data?.era || ''}`,
            category: `${this.data?.category || ''}`,
            keywords: this.savedReviewCommonFieldValues(
                'keywords', this.data?.keywords
            ),
            language: `${this.data?.language || ''}`,
            summary: `${this.data?.content || ''}`,
        };
        return [
            ['title', false], ['authors', true], ['publisher', false],
            ['created_dates', true], ['issued_dates', true],
            ['era', false], ['category', false],
            ['keywords', true], ['language', false], ['summary', false],
        ].map(([id, repeatable]: any[]) => ({
            id,
            current_value: repeatable
                ? [...(values[id] || [])]
                : [`${values[id] || ''}`],
            status: 'modified',
            reviewed: false,
            reason: '등록 자료 기본 정보 재검수',
        }));
    }

    private savedReviewSubmittedBlock(value: any, commonFallback: boolean = false) {
        const source = value && typeof value === 'object' ? value : {};
        const submittedFields = this.savedReviewSubmittedFields(source.fields);
        return {
            schema_version: source.schema_version || '',
            revision: source.revision || '',
            metadata_strategy: source.metadata_strategy
                ? JSON.parse(JSON.stringify(source.metadata_strategy)) : {},
            fields: submittedFields.length || !commonFallback
                ? submittedFields
                : this.savedReviewFallbackCommonFields(),
            dtd_fields: this.savedReviewSubmittedFields(source.dtd_fields),
        };
    }

    private savedReviewSubmittedEntities() {
        return this.entityRows().map(
            (entity: any) => JSON.parse(JSON.stringify(entity))
        );
    }

    private savedReviewSubmission(intent: SavedReviewIntent) {
        return {
            intent,
            post: {
                title: `${this.data?.title || ''}`,
                content: `${this.data?.content || ''}`,
                category: `${this.data?.category || ''}`,
                status: this.data?.status === 'published' ? 'published' : 'draft',
            },
            common_metadata_review: this.savedReviewSubmittedBlock(
                this.data?.common_metadata_review,
                true,
            ),
            xml_field_review: this.savedReviewSubmittedBlock(
                this.data?.xml_field_review
            ),
            content_review: {
                required_review_keys: [...this.savedContentReviewRequiredKeys],
                review_checks: { ...this.savedContentReviewChecks },
                reasons: { ...this.savedContentReviewReasons },
            },
            entities: this.savedReviewSubmittedEntities(),
        };
    }

    private applySavedReviewResponse(response: any, preserveLocal: boolean) {
        const payload = response && typeof response === 'object' ? response : {};
        this.data.revision = payload.revision || payload.updated || this.data.revision;
        this.data.updated = payload.updated || this.data.updated;
        this.savedReviewSavedAt = `${
            payload.saved_at || payload.updated || new Date().toISOString()
        }`;
        if (preserveLocal) return;

        const post = payload.post && typeof payload.post === 'object'
            ? payload.post : {};
        if (typeof post.title !== 'undefined') this.data.title = post.title;
        if (typeof post.category !== 'undefined') this.data.category = post.category;
        if (typeof post.status !== 'undefined') this.data.status = post.status;

        const metadata = payload.metadata && typeof payload.metadata === 'object'
            ? payload.metadata : {};
        if (typeof metadata.authors !== 'undefined') {
            this.data.authors = Array.isArray(metadata.authors)
                ? metadata.authors.join(', ') : `${metadata.authors || ''}`;
        }
        if (typeof metadata.publisher !== 'undefined') this.data.publisher = metadata.publisher || '';
        if (typeof metadata.created_dates !== 'undefined') {
            this.data.created_dates = this.normaliseDateValues(metadata.created_dates);
        }
        if (typeof metadata.issued_dates !== 'undefined') {
            this.data.issued_dates = this.normaliseDateValues(metadata.issued_dates);
        }
        if (typeof metadata.document_date !== 'undefined') {
            this.data.document_date = this.normaliseDateValues(
                this.data.issued_dates
            )[0] || this.normaliseDateValues(this.data.created_dates)[0]
                || metadata.document_date || '';
        }
        if (typeof metadata.era !== 'undefined') {
            this.data.era = `${metadata.era || ''}`.slice(0, 100);
        }
        if (typeof metadata.language !== 'undefined') this.data.language = metadata.language || '';
        if (typeof metadata.keywords !== 'undefined') {
            this.data.keywords = Array.isArray(metadata.keywords)
                ? metadata.keywords.join(', ') : `${metadata.keywords || ''}`;
        }
        if (typeof metadata.summary !== 'undefined') this.data.content = metadata.summary || '';
        if (payload.common_metadata_review) {
            this.data.common_metadata_review = payload.common_metadata_review;
        }
        if (payload.xml_field_review) this.data.xml_field_review = payload.xml_field_review;
        if (Array.isArray(payload.entities)) {
            this.data.entities = payload.entities;
            this.data.profile_fields = {
                ...(this.data.profile_fields || {}),
                entities: payload.entities.map((row: any) => ({ ...row })),
            };
            this.data.ai_metadata = {
                ...(this.data.ai_metadata || {}),
                entities: payload.entities,
                profile_fields: this.data.profile_fields,
            };
            this.savedEntityDeletionSnapshots = {};
            this.rebuildEntityOccurrenceCounts();
        }
        const contentReview = payload.content_review;
        if (contentReview && typeof contentReview === 'object') {
            if (Array.isArray(contentReview.required_review_keys)) {
                this.savedContentReviewRequiredKeys = contentReview.required_review_keys
                    .map((key: any) => `${key || ''}`).filter(Boolean);
            }
            this.savedContentReviewChecks = this.normaliseReviewChecks(
                contentReview.review_checks,
                null,
                this.savedContentReviewRequiredKeys,
            );
            this.savedContentReviewReasons = (
                contentReview.reasons && typeof contentReview.reasons === 'object'
            ) ? { ...contentReview.reasons } : this.savedContentReviewReasons;
        }
        if (!this.xmlReviewActiveField()) this.initialiseMetadataReviewFocus();
        this.initialiseDtdReviewFocus();
    }

    private async persistSavedReview(
        intent: SavedReviewIntent,
        silent: boolean = false,
    ) {
        if (this.isNewPost() || !this.data || this.savedReviewSaving) return false;
        if (!this.canManageSavedReview()) {
            if (!silent) await this.service.modal.error('이 자료를 검수·수정할 권한이 없습니다.');
            return false;
        }
        if (this.savedReviewAutosaveTimer) {
            clearTimeout(this.savedReviewAutosaveTimer);
            this.savedReviewAutosaveTimer = null;
        }
        const submittedVersion = this.savedReviewMutationVersion;
        let scheduleFollowupSave = false;
        this.savedReviewSaving = true;
        this.savedReviewNotice = intent === 'complete'
            ? '검수 완료 상태를 저장하고 있습니다.'
            : '검수 초안을 저장하고 있습니다.';
        await this.service.render();
        try {
            const result = await wiz.call('save', {
                mode: 'registered_review',
                id: this.id,
                expected_revision: this.data.revision || this.data.updated || '',
                review: JSON.stringify(this.savedReviewSubmission(intent)),
            });
            if (result.code !== 200) {
                const conflict = result.code === 409
                    && result.data?.conflict === 'revision_conflict';
                this.savedReviewNotice = conflict
                    ? '다른 사용자가 먼저 수정했습니다. 최신 내용을 다시 불러와주세요.'
                    : (result.data?.message || '검수 내용을 저장하지 못했습니다.');
                this.savedReviewDirty = true;
                if (!silent) await this.service.modal.error(this.savedReviewNotice);
                return false;
            }
            const changedDuringSave = submittedVersion !== this.savedReviewMutationVersion;
            scheduleFollowupSave = changedDuringSave;
            this.applySavedReviewResponse(result.data || {}, changedDuringSave);
            this.savedReviewDirty = changedDuringSave;
            this.savedReviewNotice = intent === 'complete'
                ? '전체 검수를 완료하고 저장했습니다.'
                : changedDuringSave
                    ? '이전 변경을 저장했습니다. 새 변경 내용을 이어서 저장합니다.'
                    : '검수 초안을 저장했습니다.';
            if (!silent) await this.service.modal.success(this.savedReviewNotice);
            return true;
        } catch (error) {
            const captured = this.captureError(error, '검수 내용 저장 중 오류가 발생했습니다.');
            this.savedReviewNotice = captured.message;
            this.savedReviewDirty = true;
            if (!silent) await this.service.modal.error(captured.message);
            return false;
        } finally {
            this.savedReviewSaving = false;
            if (
                scheduleFollowupSave
                && this.savedReviewDirty
                && this.canManageSavedReview()
            ) {
                if (this.savedReviewAutosaveTimer) clearTimeout(this.savedReviewAutosaveTimer);
                this.savedReviewAutosaveTimer = setTimeout(() => {
                    this.savedReviewAutosaveTimer = null;
                    void this.persistSavedReview('save', true);
                }, this.savedReviewAutosaveDelayMs);
            }
            await this.service.render();
        }
    }

    public async saveSavedReviewDraft(): Promise<void> {
        await this.persistSavedReview('save');
    }

    public async retrySavedReviewSave(): Promise<void> {
        await this.persistSavedReview('save');
    }

    public async completeSavedReview(): Promise<void> {
        if (!`${this.data?.title || ''}`.trim()) {
            this.savedReviewSection = 'basic';
            await this.service.modal.error('자료명을 입력해주세요.');
            return;
        }
        if (!`${this.data?.category || ''}`.trim()) {
            this.savedReviewSection = 'classification';
            await this.service.modal.error('자료 유형을 선택해주세요.');
            return;
        }
        const metadataPending = this.xmlReviewPendingCount();
        if (metadataPending > 0) {
            this.savedReviewSection = 'metadata';
            await this.service.modal.error(`메타데이터 ${metadataPending}개를 먼저 검수해주세요.`);
            return;
        }
        const dtdPending = this.dtdReviewPendingCount();
        if (dtdPending > 0) {
            this.savedReviewSection = 'scope';
            await this.service.modal.error(`추출 범위 예외 ${dtdPending}개를 먼저 검수해주세요.`);
            return;
        }
        const contentPending = this.savedContentReviewApplicableRequiredKeys().filter(
            (key: string) => !this.savedContentReviewChecks[key]
        );
        if (contentPending.length > 0) {
            this.savedReviewSection = 'content';
            await this.service.modal.error(`파일별 콘텐츠 ${contentPending.length}개를 먼저 검수해주세요.`);
            return;
        }
        await this.persistSavedReview('complete');
    }

    public savedReviewProgressPercent() {
        let total = 3;
        let completed = 0;
        if (`${this.data?.title || ''}`.trim()) completed += 1;
        if (`${this.data?.category || ''}`.trim()) completed += 1;
        if (`${this.data?.status || ''}`.trim()) completed += 1;
        const metadataFields = this.xmlReviewFields();
        total += metadataFields.length;
        completed += metadataFields.filter(
            (field: any) => this.metadataReviewFieldComplete(field)
        ).length;
        const dtdFields = this.dtdReviewFields().filter(
            (field: any) => !this.dtdReviewFieldStructureOnly(field)
        );
        total += dtdFields.length;
        completed += dtdFields.filter(
            (field: any) => this.dtdReviewFieldComplete(field)
        ).length;
        const contentSections = this.savedContentReviewVisibleSectionKeys();
        total += contentSections.length;
        completed += contentSections.filter(
            (key: string) => this.savedContentReviewStatusLabel(key) !== '확인 필요'
        ).length;
        return total > 0 ? Math.round((completed / total) * 100) : 0;
    }

    public savedReviewSavedAtLabel() {
        if (this.savedReviewSaving) return '저장 중';
        if (this.savedReviewDirty) return '저장 대기 중';
        if (!this.savedReviewSavedAt) return '저장 이력 없음';
        const parsed = this.parseSavedReviewTimestamp(this.savedReviewSavedAt);
        if (!Number.isNaN(parsed.getTime())) {
            return `마지막 저장 ${this.formatAutoSaveTime(parsed)}`;
        }
        return `마지막 저장 ${this.savedReviewSavedAt}`;
    }

    public savedMetadataComplete() {
        const fields = this.xmlReviewFields();
        return fields.length > 0 && fields.every(
            (field: any) => this.metadataReviewFieldComplete(field)
        );
    }

    public updateSavedReviewMaterialStrategy(strategyId: string) {
        if (!this.data || !this.savedReviewHydrated || this.savedReviewSaving) return;
        const requestedId = `${strategyId || ''}`.trim();
        if (!requestedId || requestedId === `${this.xmlMetadataStrategy().id || ''}`) {
            return;
        }
        if (!this.updateLocalMetadataStrategy(requestedId, true)) return;
        this.markSavedReviewDirty();
    }

    public savedMetadataProgressLabel() {
        const total = this.xmlReviewFields().length;
        if (!total) return '검수 항목 없음';
        if (this.savedMetadataComplete()) return '완료';
        return `${this.metadataReviewCompletedCount()} / ${total}`;
    }

    public savedDtdComplete() {
        const fields = this.dtdReviewFields().filter(
            (field: any) => !this.dtdReviewFieldStructureOnly(field)
        );
        return fields.length > 0 && fields.every(
            (field: any) => this.dtdReviewFieldComplete(field)
        );
    }

    public savedDtdProgressLabel() {
        const fields = this.dtdReviewFields().filter(
            (field: any) => !this.dtdReviewFieldStructureOnly(field)
        );
        if (!fields.length) return 'DTD 적용 대상 아님';
        const completed = fields.filter(
            (field: any) => this.dtdReviewFieldComplete(field)
        ).length;
        if (completed === fields.length) return '완료';
        return `${completed.toLocaleString()} / ${fields.length.toLocaleString()} 완료`;
    }

    public savedContentComplete() {
        const sections = this.savedContentReviewVisibleSectionKeys();
        return sections.length > 0 && sections.every(
            (key: string) => this.savedContentReviewStatusLabel(key) !== '확인 필요'
        );
    }

    public savedContentProgressLabel() {
        const sections = this.savedContentReviewVisibleSectionKeys();
        const total = sections.length;
        const completed = sections.filter(
            (key: string) => this.savedContentReviewStatusLabel(key) !== '확인 필요'
        ).length;
        if (!total) return '검수 항목 없음';
        if (completed === total) return '완료';
        return `${completed} / ${total} 완료`;
    }

    public savedContentReviewStatusLabel(key: string) {
        if (key === 'images' && !this.savedDetailHasImages()) {
            return '해당 없음';
        }
        const groupKeys = this.savedContentReviewGroupKeys(key);
        const required = groupKeys.filter(
            (row: string) => this.savedContentReviewRequiredKeys.includes(row)
        );
        const applicable = required.length ? required : groupKeys;
        if (
            applicable.length
            && applicable.every((row: string) => !!this.savedContentReviewChecks[row])
        ) return '검수 완료';
        if (
            !required.length
            && !this.savedContentReviewHasValue(key)
        ) return '해당 없음';
        return '확인 필요';
    }

    public savedContentReviewStatusClass(key: string) {
        const label = this.savedContentReviewStatusLabel(key);
        if (label === '검수 완료') return 'is-complete';
        if (label === '해당 없음') return 'is-not-applicable';
        return 'is-attention';
    }

    public async toggleSavedContentReviewCheck(key: string) {
        const groupKeys = this.savedContentReviewGroupKeys(key);
        if (!groupKeys.length || !this.canManageSavedReview()) return;
        const nextReviewed = !groupKeys.every(
            (row: string) => !!this.savedContentReviewChecks[row]
        );
        groupKeys.forEach((reviewKey: string) => {
            this.savedContentReviewChecks[reviewKey] = nextReviewed;
            this.appendProfileReviewHistory(
                reviewKey,
                nextReviewed ? 'area_completed' : 'area_reopened',
                this.savedContentReviewReasons[reviewKey] || '',
            );
        });
        this.markSavedReviewDirty();
        await this.service.render();
    }

    public savedReviewActiveFieldNumber(field: any) {
        const index = this.xmlReviewFields().indexOf(field);
        return index >= 0 ? index + 1 : 0;
    }

    public savedReviewFieldStatusLabel(field: any) {
        return this.xmlReviewStatusLabel(field);
    }

    public savedReviewFieldStatusClass(field: any) {
        return this.xmlReviewStatusClass(field);
    }

    public savedReviewEvidenceFragment(field: any) {
        const evidence = this.xmlReviewEvidence(field)[0] || {};
        const value = `${
            evidence.excerpt
            || evidence.quote
            || evidence.value
            || this.xmlReviewValueText(field?.original_display_value || field?.original_value)
            || ''
        }`.replace(/\s+/g, ' ').trim();
        if (!value || value === '값 없음') return '저장된 원문 근거가 없습니다.';
        const fragment = value.length > 180 ? `${value.slice(0, 180)}…` : value;
        return fragment
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
    }

    public savedReviewLatestHistory(field: any) {
        return this.xmlReviewHistory(field).slice(0, 3);
    }

    public async onUploadSelected(event: any) {
        const input = event && event.target ? event.target : null;
        const files: File[] = input && input.files ? Array.from(input.files as FileList) : [];
        if (!files.length) return;
        await this.applyUploadFiles(files, input);
    }

    public async onUploadDragOver(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();
        if (this.sourceSelectionLocked()) return;
        if (event.dataTransfer) event.dataTransfer.dropEffect = 'copy';
        if (this.uploadDragging) return;
        this.uploadDragging = true;
        await this.service.render();
    }

    public async onUploadDragLeave(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();
        const dropZone = event.currentTarget as HTMLElement;
        const nextTarget = event.relatedTarget as Node;
        if (dropZone && nextTarget && dropZone.contains(nextTarget)) return;
        if (!this.uploadDragging) return;
        this.uploadDragging = false;
        await this.service.render();
    }

    public async onUploadDropped(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();
        this.uploadDragging = false;
        if (this.sourceSelectionLocked()) return;
        const files: File[] = event.dataTransfer && event.dataTransfer.files
            ? Array.from(event.dataTransfer.files as FileList)
            : [];
        if (!files.length) {
            await this.service.modal.error("드롭한 항목에서 파일을 찾을 수 없습니다.");
            await this.service.render();
            return;
        }
        await this.applyUploadFiles(files);
    }

    private async hashFileStreaming(file: File, row: any) {
        const hasher = new StreamingSha256();
        const chunkSize = 4 * 1024 * 1024;
        let offset = 0;
        while (offset < file.size) {
            if (row?.releasePending) return '';
            const end = Math.min(file.size, offset + chunkSize);
            const chunk = new Uint8Array(
                await file.slice(offset, end).arrayBuffer()
            );
            if (row?.releasePending) return '';
            hasher.update(chunk);
            offset = end;
            row.progress = file.size > 0
                ? Math.round((offset / file.size) * 100)
                : 100;
            row.message = `SHA-256 계산 ${row.progress}%`;
            await this.service.render();
        }
        if (file.size === 0) row.progress = 100;
        return `sha256:${hasher.digestHex()}`;
    }

    private uploadQueueRowIndex(row: any, file: any = null) {
        const index = this.filePreflights.indexOf(row);
        if (index < 0) return -1;
        if (file && this.uploadFiles[index] !== file) return -1;
        return index;
    }

    private async checkSelectedFile(
        index: number, file: File, reuseClaim: boolean = false,
        showRegisteredNotice: boolean = true, expectedRow: any = null,
    ) {
        const row = expectedRow || this.filePreflights[index];
        if (!row || this.uploadQueueRowIndex(row, file) < 0) return;
        let resolvePreflightCompletion: (() => void) = () => {};
        const preflightCompletion = new Promise<void>((resolve) => {
            resolvePreflightCompletion = resolve;
        });
        row.preflightCompletion = preflightCompletion;
        const reusableHash = reuseClaim ? `${row.originalHash || ''}` : '';
        row.status = 'checking';
        row.label = '중복 확인 중';
        row.message = reusableHash
            ? '실제 처리 직전에 동일 파일 claim을 다시 확인하고 있습니다.'
            : '원문을 메모리에 전체 적재하지 않고 SHA-256을 계산하고 있습니다.';
        row.progress = reusableHash ? 100 : 0;
        row.blocking = true;
        row.ownedByMe = false;
        row.canOverwrite = false;
        row.overwriteToken = '';
        row.claimToken = reuseClaim && row.claimToken
            ? row.claimToken : this.createProgressId();
        row.existing = null;
        let registeredNotice = '';
        await this.service.render();
        try {
            row.originalHash = reusableHash || await this.hashFileStreaming(file, row);
            if (row.releasePending) return;
            if (this.uploadQueueRowIndex(row, file) < 0) return;
            row.message = '기존 자료와 동일 원문 등록 권한을 조회하고 있습니다.';
            await this.service.render();
            const query = new URLSearchParams({
                mode: 'duplicate_preflight',
                original_hash: row.originalHash,
                claim_token: row.claimToken,
                ...(row.staged === true && row.stageStatus === 'staged'
                    && `${row.stagedSourceId || ''}`
                    && `${this.registrationWorkspaceId || ''}`
                    ? {
                        workspace_id: `${this.registrationWorkspaceId}`,
                        staged_source_id: `${row.stagedSourceId}`,
                    }
                    : {}),
            });
            const preflightController = new AbortController();
            row.preflightAbortController = preflightController;
            const preflightTimeout = window.setTimeout(
                () => preflightController.abort(),
                20000,
            );
            let response: Response;
            try {
                response = await fetch(
                    `/wiz/api/portal.post.detail/analyze?${query.toString()}`,
                    {
                        method: 'POST',
                        credentials: 'same-origin',
                        signal: preflightController.signal,
                    }
                );
            } finally {
                window.clearTimeout(preflightTimeout);
                if (row.preflightAbortController === preflightController) {
                    delete row.preflightAbortController;
                }
            }
            const payload = await response.json();
            const preflight = payload && payload.code === 200 && payload.data
                ? payload.data.preflight : null;
            if (!preflight || !preflight.status) {
                throw new Error(
                    (payload && payload.data && payload.data.message)
                    || '동일 파일 등록 여부를 확인하지 못했습니다.'
                );
            }
            if (row.releasePending) {
                this.applyUploadPreflightResult(
                    row,
                    preflight,
                    `${row.claimToken || ''}`,
                );
                return;
            }
            if (this.uploadQueueRowIndex(row, file) < 0) {
                // The user can remove a row while its duplicate request is in
                // flight. Apply the detached response only long enough to
                // release a newly-created claim; never revive the removed row.
                this.applyUploadPreflightResult(
                    row,
                    preflight,
                    `${row.claimToken || ''}`,
                );
                await this.releaseFilePreflight(row);
                return;
            }
            row.status = preflight.status;
            row.label = row.status === 'processing'
                ? this.filePreflightLabel(row)
                : preflight.label || this.filePreflightLabel(row);
            row.message = preflight.message || '';
            row.blocking = !!preflight.blocking;
            row.restricted = !!preflight.restricted;
            row.canOverride = !!preflight.can_override;
            row.existing = preflight.existing || null;
            row.policy = preflight.policy || '';
            row.claimToken = preflight.claim_token || row.claimToken;
            row.ownedByMe = preflight.owned_by_me === true;
            row.overwriteToken = `${
                preflight.overwrite_token || preflight.restart_token || ''
            }`;
            row.canOverwrite = !!(
                row.status === 'processing'
                && row.ownedByMe
                && (
                    preflight.can_overwrite === true
                    || preflight.can_restart === true
                )
                && row.overwriteToken
            );
            if (!row.canOverwrite) row.overwriteToken = '';
            row.progress = 100;
            if (row.status !== 'registered' || !row.canOverride) {
                row.overrideSelected = false;
                row.overrideConfirmed = false;
                row.overrideReason = '';
            }
            if (row.status === 'registered') {
                registeredNotice = row.canOverride
                    ? '동일한 원문 파일이 이미 등록되어 있습니다. 기존 자료를 확인하거나 새 버전으로 등록하려면 체크박스를 선택해주세요.'
                    : '동일한 원문 파일이 이미 등록되어 있어 다시 등록할 수 없습니다. 기존 자료를 확인하거나 이번 등록에서 제외해주세요.';
            }
        } catch (error) {
            row.status = 'error';
            row.label = '확인 실패';
            row.message = error instanceof Error
                ? error.message : '동일 파일 등록 여부를 확인하지 못했습니다.';
            row.blocking = true;
            if (!row.releasePending) row.claimToken = '';
            row.ownedByMe = false;
            row.canOverwrite = false;
            row.overwriteToken = '';
        } finally {
            resolvePreflightCompletion();
            if (row.preflightCompletion === preflightCompletion) {
                delete row.preflightCompletion;
            }
        }
        await this.service.render();
        if (registeredNotice && showRegisteredNotice) {
            await this.service.modal.error(registeredNotice);
        }
    }

    private applyUploadPreflightResult(
        row: any, preflight: any, fallbackClaimToken: string = '',
    ) {
        row.status = `${preflight?.status || 'error'}`;
        row.label = row.status === 'processing'
            ? this.filePreflightLabel(row)
            : preflight?.label || this.filePreflightLabel(row);
        row.message = `${preflight?.message || ''}`;
        row.blocking = !!preflight?.blocking;
        row.restricted = !!preflight?.restricted;
        row.canOverride = !!preflight?.can_override;
        row.existing = preflight?.existing || null;
        row.policy = `${preflight?.policy || ''}`;
        row.claimToken = `${
            preflight?.claim_token || fallbackClaimToken || row.claimToken || ''
        }`;
        row.ownedByMe = preflight?.owned_by_me === true;
        row.overwriteToken = `${
            preflight?.overwrite_token || preflight?.restart_token || ''
        }`;
        row.canOverwrite = !!(
            row.status === 'processing'
            && row.ownedByMe
            && (
                preflight?.can_overwrite === true
                || preflight?.can_restart === true
            )
            && row.overwriteToken
        );
        if (!row.canOverwrite) row.overwriteToken = '';
        row.progress = 100;
        if (row.status !== 'registered' || !row.canOverride) {
            row.overrideSelected = false;
            row.overrideConfirmed = false;
            row.overrideReason = '';
        }
        if (`${preflight?.workspace_revision || ''}`) {
            this.registrationWorkspaceRevision = `${
                preflight.workspace_revision
            }`;
        }
    }

    private async requestStagedSourceClaimReconciliation(
        stagedSourceId: string, originalHash: string = '',
    ) {
        const workspaceId = `${this.registrationWorkspaceId || ''}`.trim();
        stagedSourceId = `${stagedSourceId || ''}`.trim();
        if (!workspaceId || !stagedSourceId) {
            throw new Error(
                '업로드된 서버 원본을 찾을 수 없습니다. 원본을 다시 지정해주세요.'
            );
        }
        const request = async (query: URLSearchParams) => {
            const controller = new AbortController();
            const timeout = window.setTimeout(() => controller.abort(), 20000);
            let payload: any = null;
            try {
                const response = await fetch(
                    `/wiz/api/portal.post.detail/analyze?${query.toString()}`,
                    {
                        method: 'POST',
                        credentials: 'same-origin',
                        signal: controller.signal,
                    },
                );
                payload = await response.json();
            } catch (error) {
                if (`${(error as any)?.name || ''}` === 'AbortError') {
                    const timeoutError: any = new Error(
                        '서버 응답이 20초 동안 없어 작업을 중단했습니다. 원본은 그대로 보존되어 있으니 다시 시도해주세요.'
                    );
                    timeoutError.errorCode = 'REQUEST_TIMEOUT';
                    timeoutError.userAction = '잠시 후 일괄 덮어쓰기를 다시 실행해주세요.';
                    throw timeoutError;
                }
                throw error;
            } finally {
                window.clearTimeout(timeout);
            }
            if (!payload || payload.code !== 200) {
                const detail = payload?.data || {};
                const requestId = `${detail.request_id || ''}`.trim();
                const message = `${
                    detail.message
                    || '업로드된 원본의 분석 권한을 확인하지 못했습니다.'
                }${requestId ? ` (요청 ID: ${requestId})` : ''}`;
                const error: any = new Error(message);
                error.errorCode = `${detail.error_code || ''}`;
                error.userAction = `${detail.user_action || ''}`;
                error.requestId = requestId;
                throw error;
            }
            const preflight = payload.data?.preflight || null;
            if (!preflight || !preflight.status) {
                throw new Error(
                    '업로드된 원본의 분석 권한 응답을 확인하지 못했습니다.'
                );
            }
            return preflight;
        };
        const query = new URLSearchParams({
            mode: 'registration_workspace_reconcile_claim',
            workspace_id: workspaceId,
            staged_source_id: stagedSourceId,
        });
        try {
            return await request(query);
        } catch (error) {
            if (`${(error as any)?.errorCode || ''}` !== 'ANALYSIS_MODE_MISMATCH') {
                throw error;
            }
            originalHash = `${originalHash || ''}`.trim().toLowerCase();
            if (!/^sha256:[0-9a-f]{64}$/.test(originalHash)) {
                const hashError: any = new Error(
                    '보존 원본의 SHA-256 정보를 확인할 수 없어 안전한 덮어쓰기를 중단했습니다.'
                );
                hashError.errorCode = 'STAGED_SOURCE_HASH_MISSING';
                throw hashError;
            }
            // Long-lived WIZ workers may cache the API mode allow-list.  The
            // existing overwrite transport is stable, while the fresh model
            // decodes this explicit command and still validates owner, bytes,
            // active leases, repository CAS and the workspace receipt.
            const compatibilityQuery = new URLSearchParams({
                mode: 'duplicate_overwrite',
                original_hash: originalHash,
                claim_token: `registration-workspace-reconcile-v1:${workspaceId}:${stagedSourceId}`,
                previous_claim_token: '',
                workspace_id: workspaceId,
                staged_source_id: stagedSourceId,
            });
            return await request(compatibilityQuery);
        }
    }

    public async retryFilePreflight(index: number, event?: Event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (this.uploadQueueRowActionDisabled(index) || !this.uploadFiles[index]) return;
        const row = this.filePreflights[index];
        const reusePreservedHash = !!(
            row
            && row.staged === true
            && row.stageStatus === 'staged'
            && `${row.stagedSourceId || ''}`
            && `${row.originalHash || ''}`
        );
        this.beginFilePreflightTask();
        try {
            if (
                reusePreservedHash
                && `${this.registrationWorkspaceId || ''}`
            ) {
                const file = this.uploadFiles[index];
                row.status = 'checking';
                row.label = '서버 원본 확인 중';
                row.message = '보존된 원본을 기준으로 중복 처리 권한을 안전하게 다시 확인하고 있습니다.';
                row.blocking = true;
                await this.service.render();
                try {
                    const preflight = await this
                        .requestStagedSourceClaimReconciliation(
                            `${row.stagedSourceId}`,
                            `${row.originalHash || ''}`,
                        );
                    if (this.uploadQueueRowIndex(row, file) < 0) return;
                    if (
                        preflight.status === 'new'
                        && (
                            preflight.workspace_claim_bound !== true
                            || !`${preflight.claim_token || ''}`
                        )
                    ) {
                        throw new Error(
                            '업로드된 서버 원본과 처리 권한의 연결을 확인하지 못했습니다.'
                        );
                    }
                    this.applyUploadPreflightResult(row, preflight);
                    if (row.status === 'new') {
                        row.message = '보존된 서버 원본과 중복 처리 권한을 다시 연결했습니다.';
                    }
                } catch (error) {
                    if (this.uploadQueueRowIndex(row, file) < 0) return;
                    const errorCode = `${(error as any)?.errorCode || ''}`;
                    row.status = errorCode === 'OPERATION_IN_PROGRESS'
                        ? 'processing' : 'error';
                    row.label = errorCode === 'ANALYSIS_MODE_MISMATCH'
                        ? '서버 기능 업데이트 필요'
                        : errorCode === 'OPERATION_IN_PROGRESS'
                            ? '실제 서버 분석 상태 확인 필요'
                            : '재확인 실패';
                    row.message = error instanceof Error
                        ? error.message
                        : '업로드된 서버 원본의 중복 처리 권한을 확인하지 못했습니다.';
                    row.blocking = true;
                    row.ownedByMe = false;
                    row.canOverwrite = false;
                    row.overwriteToken = '';
                }
            } else {
                await this.checkSelectedFile(
                    index,
                    this.uploadFiles[index],
                    reusePreservedHash,
                );
            }
        } finally {
            this.endFilePreflightTask();
            const attentionIndex = this.uploadFiles.findIndex(
                (_file: File, index: number) => !this.uploadQueueRowReady(index)
            );
            if (attentionIndex >= 0) {
                this.selectedUploadInspectorIndex = attentionIndex;
            }
            await this.service.render();
        }
    }

    private async confirmProcessingOverwrite(
        file: File | null, index: number, count: number = 1,
    ) {
        if (this.overwriteConfirmResolver) return false;
        this.overwriteConfirmReturnFocus = document.activeElement instanceof HTMLElement
            ? document.activeElement : null;
        this.overwriteConfirmMode = count > 1 ? 'bulk' : 'single';
        this.overwriteConfirmCount = Math.max(1, Number(count) || 1);
        this.overwriteConfirmFileName = this.overwriteConfirmMode === 'bulk'
            ? `처리 필요 파일 ${this.overwriteConfirmCount.toLocaleString('ko-KR')}개`
            : `${file && file.name || '선택한 파일'}`;
        this.overwriteConfirmFileMeta = this.overwriteConfirmMode === 'bulk'
            ? '전체 선택 목록 · 서버 원본 보존 완료 항목만'
            : `${this.fileSizeLabel(file)} · ${index + 1}번째 파일`;
        this.overwriteConfirmOpen = true;
        const confirmation = new Promise<boolean>((resolve) => {
            this.overwriteConfirmResolver = resolve;
        });
        await this.service.render();
        const cancelButton = document.querySelector(
            '.overwrite-confirm-secondary'
        ) as HTMLElement | null;
        if (cancelButton) cancelButton.focus();
        return await confirmation;
    }

    public async resolveProcessingOverwriteConfirmation(confirmed: boolean) {
        const resolver = this.overwriteConfirmResolver;
        const returnFocus = this.overwriteConfirmReturnFocus;
        const confirmMode = this.overwriteConfirmMode;
        this.overwriteConfirmResolver = null;
        this.overwriteConfirmReturnFocus = null;
        this.overwriteConfirmOpen = false;
        this.overwriteConfirmFileName = '';
        this.overwriteConfirmFileMeta = '';
        this.overwriteConfirmMode = 'single';
        this.overwriteConfirmCount = 1;
        await this.service.render();
        if (
            !confirmed
            && confirmMode === 'single'
            && returnFocus
            && returnFocus.isConnected
        ) {
            returnFocus.focus();
        }
        if (resolver) resolver(!!confirmed);
    }

    private processingOverwriteSnapshot(index: number) {
        const row = this.filePreflights[index];
        const file = this.uploadFiles[index];
        if (!row || !file) return null;
        return {
            index,
            row,
            file,
            status: `${row.status || ''}`,
            originalHash: `${row.originalHash || ''}`,
            previousClaimToken: `${row.overwriteToken || ''}`,
            stagedSourceId: `${row.stagedSourceId || ''}`,
        };
    }

    private processingOverwriteSnapshotValid(candidate: any) {
        if (
            !candidate
            || this.metaRecognizing
            || this.filePreflightReleaseRunning
        ) return false;
        const row = candidate.row;
        const file = candidate.file;
        const index = this.uploadQueueRowIndex(row, file);
        const ownedProcessing = !!(
            row.status === 'processing'
            && row.ownedByMe
            && row.canOverwrite
            && `${row.overwriteToken || ''}` === `${
                candidate.previousClaimToken || ''
            }`
            && !!`${row.overwriteToken || ''}`
        );
        return !!(
            index >= 0
            && `${row.status || ''}` === `${candidate.status || ''}`
            && ownedProcessing
            && row.staged === true
            && row.stageStatus === 'staged'
            && `${row.stagedSourceId || ''}` === `${candidate.stagedSourceId || ''}`
            && !!`${row.stagedSourceId || ''}`
            && `${row.originalHash || ''}` === `${candidate.originalHash || ''}`
            && !!`${row.originalHash || ''}`
            && !row.releasePending
        );
    }

    private async executeProcessingOverwrite(candidate: any) {
        if (!this.processingOverwriteSnapshotValid(candidate)) {
            return { outcome: 'skipped', registeredNotice: '' };
        }
        const row = candidate.row;
        const file = candidate.file;
        const stagedSourceId = `${row.stagedSourceId || ''}`;
        row.overwritePending = true;
        row.label = '동일 파일 덮어쓰기 중';
        row.message = '보존된 서버 원본을 기준으로 기존 처리 권한을 안전하게 교체하고 있습니다.';
        row.blocking = true;

        let registeredNotice = '';
        try {
            await this.service.render();
            const preflight = await this
                .requestStagedSourceClaimReconciliation(
                    stagedSourceId,
                    `${candidate.originalHash || ''}`,
                );
            if (
                preflight.status === 'new'
                && (
                    preflight.workspace_claim_bound !== true
                    || !`${preflight.claim_token || ''}`
                )
            ) {
                throw new Error(
                    '덮어쓰기 권한이 업로드된 서버 원본에 연결됐는지 확인하지 못했습니다. 분석을 시작하지 않았습니다.'
                );
            }
            if (this.uploadQueueRowIndex(row, file) < 0) {
                return { outcome: 'skipped', registeredNotice: '' };
            }

            this.applyUploadPreflightResult(row, preflight);
            if (row.status === 'new') {
                row.message = '보존된 서버 원본과 새 처리 권한의 연결을 확인했습니다.';
                this.uploadSelectionNotice = `${file.name}의 기존 처리 작업을 현재 업로드로 덮어썼습니다.`;
            } else if (row.status === 'registered') {
                registeredNotice = row.canOverride
                    ? '덮어쓰기 확인 중 동일 파일 등록이 완료되었습니다. 기존 자료를 확인하거나 새 버전 등록 여부를 선택해주세요.'
                    : '덮어쓰기 확인 중 동일 파일 등록이 완료되어 덮어쓸 수 없습니다. 기존 자료를 확인하거나 이번 등록에서 제외해주세요.';
            }
            return {
                outcome: row.status === 'new'
                    ? 'success'
                    : row.status === 'registered' ? 'registered' : 'changed',
                registeredNotice,
            };
        } catch (error) {
            if (this.uploadQueueRowIndex(row, file) < 0) {
                return { outcome: 'skipped', registeredNotice: '' };
            }
            const errorCode = `${(error as any)?.errorCode || ''}`;
            row.status = 'error';
            row.label = errorCode === 'ANALYSIS_MODE_MISMATCH'
                ? '서버 연결 갱신 필요'
                : errorCode === 'REQUEST_TIMEOUT'
                    ? '서버 응답 지연'
                    : '덮어쓰기 실패';
            row.message = error instanceof Error
                ? error.message : '동일 파일 작업을 덮어쓰지 못했습니다.';
            row.blocking = true;
            row.canOverwrite = false;
            return { outcome: 'failed', registeredNotice: '' };
        } finally {
            if (this.filePreflights.includes(row)) row.overwritePending = false;
        }
    }

    public async overwriteProcessingFile(index: number, event?: Event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (!this.uploadQueueCanOverwrite(index)) return;
        const candidate = this.processingOverwriteSnapshot(index);
        if (!candidate) return;
        const expectedOriginalHash = `${candidate.originalHash}`;
        const expectedOverwriteToken = `${candidate.previousClaimToken}`;
        const confirmed = await this.confirmProcessingOverwrite(
            candidate.file,
            index,
        );
        if (!confirmed) return;
        if (
            !this.processingOverwriteSnapshotValid(candidate)
            || `${candidate.row.originalHash}` !== expectedOriginalHash
            || `${candidate.row.overwriteToken}` !== expectedOverwriteToken
        ) {
            this.uploadSelectionNotice = '확인하는 동안 동일 파일 상태가 변경되어 덮어쓰기를 실행하지 않았습니다. 현재 상태에서 다시 시도해주세요.';
            await this.service.render();
            return;
        }

        const result = await this.executeProcessingOverwrite(candidate);
        this.persistRegistrationRecovery();
        await this.saveRegistrationWorkspace(true);
        await this.service.render();
        if (result.registeredNotice) {
            await this.service.modal.error(result.registeredNotice);
        }
    }

    public async overwriteAllProcessingFiles(event?: Event) {
        const returnFocus = event?.currentTarget instanceof HTMLElement
            ? event.currentTarget
            : document.activeElement instanceof HTMLElement
                ? document.activeElement
                : null;
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (this.bulkOverwriteRunning || this.metaRecognizing) return;
        const candidates = this.uploadQueueBulkOverwriteCandidates();
        if (!candidates.length) return;
        this.bulkOverwriteRunning = true;
        this.bulkOverwriteTotal = candidates.length;
        this.bulkOverwriteCompleted = 0;
        this.bulkOverwriteSucceeded = 0;
        this.bulkOverwriteFailed = 0;
        const confirmed = await this.confirmProcessingOverwrite(
            null,
            -1,
            candidates.length,
        );
        if (!confirmed) {
            this.bulkOverwriteRunning = false;
            await this.service.render();
            if (returnFocus && returnFocus.isConnected) returnFocus.focus();
            return;
        }

        const executable = candidates.filter(
            (candidate: any) => this.processingOverwriteSnapshotValid(candidate)
        );
        if (!executable.length) {
            this.bulkOverwriteRunning = false;
            this.uploadSelectionNotice = '일괄 덮어쓰기 대상의 상태가 변경되었습니다. 목록을 다시 확인해주세요.';
            await this.service.render();
            return;
        }

        this.bulkOverwriteTotal = executable.length;
        let completed = 0;
        let succeeded = 0;
        let failed = 0;
        await this.service.render();
        const progressRegion = document.querySelector(
            '.upload-command-operation-progress.is-bulk'
        ) as HTMLElement | null;
        if (progressRegion) progressRegion.focus({ preventScroll: true });
        try {
            await this.runBounded(
                executable,
                this.duplicatePreflightConcurrency,
                async (candidate: any) => {
                    let outcome = 'failed';
                    try {
                        const result = await this.executeProcessingOverwrite(candidate);
                        outcome = `${result.outcome || 'failed'}`;
                    } catch (_) {
                        outcome = 'failed';
                    }
                    if (outcome === 'success') succeeded += 1;
                    if (outcome === 'failed') failed += 1;
                    completed += 1;
                    this.bulkOverwriteSucceeded = succeeded;
                    this.bulkOverwriteFailed = failed;
                    this.bulkOverwriteCompleted = completed;
                    await this.service.render();
                },
            );
            this.persistRegistrationRecovery();
            await this.saveRegistrationWorkspace(true);
            const changed = Math.max(
                0,
                this.bulkOverwriteCompleted
                    - this.bulkOverwriteSucceeded
                    - this.bulkOverwriteFailed,
            );
            this.uploadSelectionNotice = [
                `일괄 덮어쓰기 ${this.bulkOverwriteSucceeded.toLocaleString('ko-KR')}개 완료`,
                changed ? `상태 변경 ${changed.toLocaleString('ko-KR')}개` : '',
                this.bulkOverwriteFailed
                    ? `실패 ${this.bulkOverwriteFailed.toLocaleString('ko-KR')}개는 다시 확인 필요`
                    : '',
            ].filter(Boolean).join(' · ');
        } finally {
            this.bulkOverwriteRunning = false;
            await this.service.render();
            const resultNotice = document.querySelector(
                '.upload-command-notices .upload-selection-notice'
            ) as HTMLElement | null;
            if (resultNotice) {
                resultNotice.focus({ preventScroll: true });
            } else if (returnFocus && returnFocus.isConnected) {
                returnFocus.focus({ preventScroll: true });
            }
        }
    }

    private async releaseFilePreflight(row: any) {
        if (!row) return true;
        const cancellableStatus = row.status === 'new' || !!(
            row.releasePending
            && ['checking', 'error'].includes(`${row.status || ''}`)
        );
        if (!cancellableStatus) return true;
        const originalHash = `${row.originalHash || ''}`;
        let claimToken = `${row.claimToken || ''}`;
        const stagedSourceId = `${row.stagedSourceId || ''}`;
        const workspaceId = `${this.registrationWorkspaceId || ''}`;
        const useStagedClaim = !!(
            row.staged === true
            && row.stageStatus === 'staged'
            && workspaceId
            && stagedSourceId
        );
        if (!originalHash) return true;
        if (
            row.releasePending
            && row.status === 'error'
            && useStagedClaim
            && !claimToken
        ) {
            try {
                const preflight = await this
                    .requestStagedSourceClaimReconciliation(
                        stagedSourceId,
                        originalHash,
                    );
                this.applyUploadPreflightResult(row, preflight);
                if (row.status !== 'new') return true;
                claimToken = `${row.claimToken || preflight.claim_token || ''}`;
                if (!claimToken) return false;
            } catch (_) {
                return false;
            }
        }
        if (!claimToken && !useStagedClaim) {
            return row.status === 'error';
        }
        if (
            row.releasePending
            && row.status === 'error'
            && !useStagedClaim
        ) {
            const reconcileController = new AbortController();
            const reconcileTimeout = window.setTimeout(
                () => reconcileController.abort(),
                15000,
            );
            try {
                const reconcileQuery = new URLSearchParams({
                    mode: 'duplicate_preflight',
                    original_hash: originalHash,
                    claim_token: claimToken,
                    ...(useStagedClaim
                        ? {
                            workspace_id: workspaceId,
                            staged_source_id: stagedSourceId,
                        }
                        : {}),
                });
                const reconcileResponse = await fetch(
                    `/wiz/api/portal.post.detail/analyze?${reconcileQuery.toString()}`,
                    {
                        method: 'POST',
                        credentials: 'same-origin',
                        signal: reconcileController.signal,
                    },
                );
                const reconcilePayload = await reconcileResponse.json();
                const preflight = reconcilePayload?.code === 200
                    ? reconcilePayload?.data?.preflight : null;
                if (!preflight?.status) return false;
                this.applyUploadPreflightResult(row, preflight, claimToken);
                if (row.status !== 'new') return true;
                return await this.releaseFilePreflight(row);
            } catch (_) {
                return false;
            } finally {
                window.clearTimeout(reconcileTimeout);
            }
        }
        const controller = new AbortController();
        const timeout = window.setTimeout(() => controller.abort(), 15000);
        try {
            const query = new URLSearchParams({
                mode: 'duplicate_cancel',
                original_hash: originalHash,
                claim_token: claimToken,
                ...(useStagedClaim
                    ? {
                        workspace_id: workspaceId,
                        staged_source_id: stagedSourceId,
                    }
                    : {}),
            });
            const response = await fetch(
                `/wiz/api/portal.post.detail/analyze?${query.toString()}`,
                {
                    method: 'POST',
                    credentials: 'same-origin',
                    keepalive: true,
                    signal: controller.signal,
                }
            );
            const payload = await response.json();
            return !!(
                payload
                && payload.code === 200
                && payload.data
                && payload.data.preflight
                && payload.data.preflight.status === 'cancelled'
            );
        } catch (_) {
            return false;
        } finally {
            window.clearTimeout(timeout);
        }
    }

    private async releaseSelectedFilePreflights(rows: any[]) {
        if (this.filePreflightReleaseRunning) return false;
        this.filePreflightReleaseRunning = true;
        let released = true;
        try {
            await this.runBounded(
                [...(rows || [])],
                this.duplicatePreflightConcurrency,
                async (row: any) => {
                    if (!await this.releaseFilePreflight(row)) released = false;
                },
            );
            return released;
        } finally {
            this.filePreflightReleaseRunning = false;
            await this.service.render();
        }
    }

    public filePreflightLabel(row: any) {
        if (row?.overwritePending) return '현재 업로드 덮어쓰기 중';
        if (row && row.status === 'error' && `${row.label || ''}`.trim()) {
            return `${row.label}`.trim();
        }
        const labels: any = {
            checking: '중복 확인 중',
            new: '신규 자료',
            registered: '동일 파일 등록됨',
            processing: '동일 파일 처리 필요',
            error: '확인 실패',
        };
        return labels[`${row && row.status ? row.status : 'checking'}`]
            || '중복 확인 중';
    }

    public uploadQueueRowOperationProgress(index: number) {
        const row = this.filePreflights[index];
        if (!row) return null;
        const percent = (value: any) => Math.max(
            0,
            Math.min(100, Math.round(Number(value) || 0)),
        );
        if (row.overwritePending) {
            return {
                label: '현재 업로드로 덮어쓰기 중',
                detail: `${row.message || (
                    '원본 업로드는 완료되었습니다. 이전 미완료 처리 권한을 현재 파일로 안전하게 교체하고 있습니다.'
                )}`,
                percent: null,
                indeterminate: true,
            };
        }
        if (row.status === 'checking') {
            const hashPercent = percent(row.progress);
            const waitingForServer = hashPercent >= 100;
            return {
                label: waitingForServer
                    ? '중복 검사 응답 대기 중' : 'SHA-256 검사 중',
                detail: waitingForServer
                    ? '해시 계산을 완료하고 서버의 중복 확인 응답을 기다리고 있습니다.'
                    : `파일 해시 계산 ${hashPercent}%`,
                percent: waitingForServer ? null : hashPercent,
                indeterminate: waitingForServer,
            };
        }
        if (row.stageStatus === 'uploading') {
            const uploadPercent = percent(row.stageProgress);
            const waitingForServer = uploadPercent >= 100;
            return {
                label: waitingForServer
                    ? '서버 원본 저장 확인 중' : '서버 원본 업로드 중',
                detail: waitingForServer
                    ? '파일 전송을 완료하고 서버의 원본 보존 응답을 기다리고 있습니다.'
                    : `실제 전송 바이트 ${uploadPercent}%`,
                percent: waitingForServer ? null : uploadPercent,
                indeterminate: waitingForServer,
            };
        }
        if (row.stageStatus === 'pending') {
            return {
                label: '서버 원본 보존 대기 중',
                detail: '중복 확인이 끝난 원본을 서버 작업공간에 안전하게 보존할 준비를 하고 있습니다.',
                percent: null,
                indeterminate: true,
            };
        }
        return null;
    }

    public filePreflightClass(row: any) {
        return `is-${row && row.status ? row.status : 'checking'}`;
    }

    private uploadQueueSelectionClaimOwnerIndex(index: number) {
        const row = this.filePreflights[index];
        const originalHash = `${row?.originalHash || ''}`.trim().toLowerCase();
        if (!originalHash) return -1;
        return this.filePreflights.findIndex((candidate: any, candidateIndex: number) => (
            candidateIndex !== index
            && `${candidate?.status || ''}` === 'new'
            && `${candidate?.originalHash || ''}`.trim().toLowerCase() === originalHash
        ));
    }

    public uploadQueueCanOverwrite(index: number) {
        const row = this.filePreflights[index];
        const file = this.uploadFiles[index];
        return !!(
            !this.metaRecognizing
            && !this.bulkOverwriteRunning
            && !this.filePreflightReleaseRunning
            && row
            && file
            && row.staged === true
            && !!`${row.stagedSourceId || ''}`
            && row.stageStatus === 'staged'
            && row.status === 'processing'
            && row.ownedByMe
            && row.canOverwrite
            && !!`${row.originalHash || ''}`
            && !!`${row.overwriteToken || ''}`
            && !row.overwritePending
            && !row.releasePending
            && this.uploadQueueSelectionClaimOwnerIndex(index) < 0
        );
    }

    public uploadQueueBulkOverwriteCandidates() {
        if (
            this.metaRecognizing
            || this.bulkOverwriteRunning
            || this.filePreflightReleasePending()
        ) return [];
        const seenHashes = new Set<string>();
        const selectedNewHashes = new Set<string>();
        this.filePreflights.forEach((candidate: any) => {
            const originalHash = `${candidate?.originalHash || ''}`
                .trim().toLowerCase();
            if (candidate?.status === 'new' && originalHash) {
                selectedNewHashes.add(originalHash);
            }
        });
        return this.filePreflights.reduce((candidates: any[], row: any, index: number) => {
            const originalHash = `${row?.originalHash || ''}`.trim().toLowerCase();
            const claimedBySelectedNewRow = !!(
                originalHash
                && selectedNewHashes.has(originalHash)
            );
            const ownedProcessing = !!(
                row?.status === 'processing'
                && row?.ownedByMe
                && row?.canOverwrite
                && !!row?.overwriteToken
            );
            const eligible = !!(
                !this.metaRecognizing
                && !this.bulkOverwriteRunning
                && row
                && this.uploadFiles[index]
                && row.staged === true
                && !!`${row.stagedSourceId || ''}`
                && row.stageStatus === 'staged'
                && ownedProcessing
                && !!row.originalHash
                && !row.overwritePending
                && !claimedBySelectedNewRow
                && !seenHashes.has(originalHash)
            );
            if (!eligible) return candidates;
            seenHashes.add(originalHash);
            const snapshot = this.processingOverwriteSnapshot(index);
            if (snapshot) candidates.push(snapshot);
            return candidates;
        }, []);
    }

    public uploadQueueBulkOverwriteEligibleCount() {
        return this.uploadQueueBulkOverwriteCandidates().length;
    }

    public bulkOverwriteProgressPercent() {
        if (!this.bulkOverwriteTotal) return 0;
        return Math.round(
            (this.bulkOverwriteCompleted / this.bulkOverwriteTotal) * 100
        );
    }

    public uploadQueueRowActionDisabled(index: number) {
        const row = this.filePreflights[index];
        const file = this.uploadFiles[index];
        return !!(
            this.metaRecognizing
            || this.bulkOverwriteRunning
            || this.filePreflightReleaseRunning
            || !row
            || !file
            || row.overwritePending
            || row.releasePending
            || row.status === 'checking'
            || ['pending', 'uploading'].includes(`${row.stageStatus || ''}`)
        );
    }

    public uploadQueueRowRemovalDisabled(index: number) {
        const row = this.filePreflights[index];
        const file = this.uploadFiles[index];
        return !!(
            this.metaRecognizing
            || this.bulkOverwriteRunning
            || this.filePreflightReleaseRunning
            || !row
            || !file
            || row.overwritePending
            || row.releasePending
            || row.stageStatus === 'uploading'
        );
    }

    public uploadQueuePrimaryAction(index: number): UploadQueuePrimaryAction {
        const row = this.filePreflights[index];
        const file = this.uploadFiles[index];
        if (!row || !file) return 'none';
        if (row.overwritePending) return 'none';
        if (row.stageStatus === 'error') return 'retry-preservation';
        if (
            row.status === 'checking'
            || ['pending', 'uploading'].includes(`${row.stageStatus || ''}`)
        ) return 'none';
        if (row.status === 'registered') return 'inspect';
        if (row.status === 'processing') {
            if (this.uploadQueueSelectionClaimOwnerIndex(index) >= 0) {
                return 'remove';
            }
            return this.uploadQueueCanOverwrite(index) ? 'overwrite' : 'recheck';
        }
        if (row.status === 'error') return 'recheck';
        if (this.uploadQueueRowReady(index)) return 'remove';
        return 'none';
    }

    public uploadQueuePrimaryActionLabel(index: number) {
        const labels: Record<UploadQueuePrimaryAction, string> = {
            'retry-preservation': '재시도',
            overwrite: '덮어쓰기',
            recheck: '다시 확인',
            inspect: '조치 보기',
            remove: '제거',
            none: '',
        };
        return labels[this.uploadQueuePrimaryAction(index)];
    }

    public uploadQueuePrimaryActionAriaLabel(index: number) {
        const fileName = `${this.uploadFiles[index]?.name || '선택 파일'}`;
        const action = this.uploadQueuePrimaryAction(index);
        const labels: Record<UploadQueuePrimaryAction, string> = {
            'retry-preservation': '원본 보존 재시도',
            overwrite: '현재 업로드로 덮어쓰기',
            recheck: '동일 파일 상태 다시 확인',
            inspect: '동일 파일 조치 보기',
            remove: '선택 파일 제거',
            none: '',
        };
        return labels[action] ? `${fileName} ${labels[action]}` : '';
    }

    public async runUploadQueuePrimaryAction(index: number, event?: Event) {
        const action = this.uploadQueuePrimaryAction(index);
        if (action === 'retry-preservation') {
            await this.retryRegistrationSourceStage(index, event);
            return;
        }
        if (action === 'overwrite') {
            await this.overwriteProcessingFile(index, event);
            return;
        }
        if (action === 'recheck') {
            await this.retryFilePreflight(index, event);
            return;
        }
        if (action === 'inspect') {
            await this.selectUploadInspectorFile(index, event);
            return;
        }
        if (action === 'remove') {
            await this.removeSelectedFile(index, event);
        }
    }

    public preflightExistingUrl(row: any) {
        const documentId = row && row.existing
            ? `${row.existing.document_id || ''}` : '';
        return /^[A-Za-z0-9_-]{1,32}$/.test(documentId)
            ? `${this.basePath}/${encodeURIComponent(documentId)}/view`
            : '';
    }

    public preflightOverrideReasonValid(row: any) {
        return !!(
            row
            && row.status === 'registered'
            && row.canOverride
            && row.overrideSelected
            && `${row.overrideReason || ''}`.trim().length >= 5
        );
    }

    public preflightOverrideValid(row: any) {
        return this.preflightOverrideReasonValid(row) && !!row.overrideConfirmed;
    }

    public async setPreflightOverrideSelected(index: number, checked: boolean) {
        const row = this.filePreflights[index];
        if (!row || row.status !== 'registered' || !row.canOverride) return;
        row.overrideSelected = !!checked;
        row.overrideConfirmed = row.overrideSelected;
        row.overrideReason = row.overrideSelected
            ? this.duplicateVersionCheckboxReason : '';
        this.uploadSelectionNotice = row.overrideSelected
            ? '새 버전 등록을 선택했습니다. 감사용 등록 사유는 자동으로 기록됩니다.'
            : '기존 자료를 확인하거나 이 파일 등록을 취소할 수 있습니다.';
        this.queueRegistrationRecoverySave();
        await this.service.render();
    }

    public bulkVersionRegistrationEligibleCount() {
        return this.filePreflights.filter((row: any) => (
            row?.status === 'registered' && row?.canOverride
        )).length;
    }

    public bulkVersionRegistrationSelectedCount() {
        return this.filePreflights.filter((row: any) => (
            row?.status === 'registered'
            && row?.canOverride
            && this.preflightOverrideValid(row)
        )).length;
    }

    public allVersionRegistrationsSelected() {
        const eligible = this.bulkVersionRegistrationEligibleCount();
        return eligible > 0
            && this.bulkVersionRegistrationSelectedCount() === eligible;
    }

    public async toggleAllVersionRegistrations() {
        const eligible = this.bulkVersionRegistrationEligibleCount();
        if (!eligible) return;
        const checked = !this.allVersionRegistrationsSelected();
        this.filePreflights.forEach((row: any) => {
            if (row?.status !== 'registered' || !row?.canOverride) return;
            row.overrideSelected = checked;
            row.overrideConfirmed = checked;
            row.overrideReason = checked
                ? this.duplicateVersionCheckboxReason : '';
        });
        this.uploadSelectionNotice = checked
            ? `기존 자료 ${eligible}개를 새 버전 등록 대상으로 일괄 선택했습니다.`
            : `기존 자료 ${eligible}개의 새 버전 등록 선택을 해제했습니다.`;
        this.queueRegistrationRecoverySave();
        await this.service.render();
    }

    public async cancelPreflightRegistration(index: number, event?: Event) {
        await this.removeSelectedFile(index, event);
    }

    private filePreflightBlockingMessage(row: any, index: number = -1) {
        if (row?.overwritePending) {
            return '현재 업로드를 사용하도록 이전 미완료 처리 권한을 안전하게 교체하고 있습니다.';
        }
        if (row?.status === 'checking') {
            return '파일 중복 확인이 끝날 때까지 기다려주세요.';
        }
        if (row?.status === 'error') {
            return `${row.message || ''}`.trim()
                || '중복 확인에 실패한 파일을 다시 확인해주세요.';
        }
        if (row?.status === 'processing') {
            const resolvedIndex = index >= 0
                ? index : this.filePreflights.indexOf(row);
            if (this.uploadQueueSelectionClaimOwnerIndex(resolvedIndex) >= 0) {
                return '현재 선택 목록에 같은 원문이 이미 포함되어 있습니다. 한 파일만 유지하고 이번 파일은 제외해주세요.';
            }
            return row.canOverwrite && row.ownedByMe
                ? '내 계정에 동일 파일의 이전 처리 권한이 남아 있습니다. 현재 업로드로 덮어쓰거나 이번 파일을 제외해주세요.'
                : '동일 파일과 연결된 기존 등록 작업이 있습니다. 상태를 다시 확인하거나 이번 파일을 제외해주세요.';
        }
        if (row?.status === 'registered') {
            const prefix = '동일한 원문 파일이 이미 등록되어 있습니다. ';
            if (!row.canOverride) {
                return prefix + '기존 자료를 확인하거나 이번 등록에서 제외해주세요.';
            }
            if (!row.overrideSelected) {
                return prefix + '새 버전으로 등록하려면 해당 선택 항목을 먼저 체크해주세요.';
            }
            if (!this.preflightOverrideValid(row)) {
                return prefix + '새 버전 등록 체크박스를 다시 선택해주세요.';
            }
        }
        if (row?.stageStatus === 'uploading' || row?.stageStatus === 'pending') {
            return '원본 파일의 서버 보존이 끝날 때까지 기다려주세요.';
        }
        if (row?.stageStatus === 'error' || !row?.stagedSourceId) {
            return row?.stageError || '원본 파일을 서버에 보존한 뒤 다시 시도해주세요.';
        }
        return '이미 등록된 동일 파일은 업로드·OCR·AI 처리를 실행할 수 없습니다.';
    }

    private filePreflightReady(row: any) {
        return !!(
            row
            && row.staged === true
            && !!`${row.stagedSourceId || ''}`
            && (
                row.status === 'new'
                || this.preflightOverrideValid(row)
            )
        );
    }

    private filePreflightClaimReady(row: any) {
        return !!(
            row
            && row.status === 'new'
            && row.blocking !== true
            && /^sha256:[0-9a-f]{64}$/i.test(`${row.originalHash || ''}`)
            && /^[0-9a-f]{32}$/i.test(`${row.claimToken || ''}`)
        );
    }

    public registrationSourceStageLabel(row: any) {
        const status = `${row?.stageStatus || ''}`;
        const labels: any = {
            pending: '서버 원본 보존 대기',
            uploading: '서버 원본 보존 중',
            staged: '서버 원본 보존 완료',
            error: '서버 원본 보존 실패',
        };
        return labels[status] || (row?.staged ? '서버 원본 보존 완료' : '서버 원본 보존 대기');
    }

    public registrationSourceStageClass(row: any) {
        return `is-${row?.stageStatus || (row?.staged ? 'staged' : 'pending')}`;
    }

    private async stageRegistrationSource(
        index: number, file: File, expectedRow: any = null,
    ) {
        const row = expectedRow || this.filePreflights[index];
        if (
            !row
            || this.uploadQueueRowIndex(row, file) < 0
            || !this.isNativeUploadFile(file)
            || row.releasePending
        ) return false;
        this.ensureRegistrationWorkspaceId();
        row.sourceIndex = this.registrationSourceIndex(file, row, index);
        row.stagedSourceId = `${row.stagedSourceId || this.createProgressId()}`;
        row.stageStatus = 'uploading';
        row.stageError = '';
        row.staged = false;
        row.stageProgress = 0;
        await this.service.render();
        try {
            const sourceMetadata = {
                index: row.sourceIndex,
                checksum_sha256: `${row.originalHash || ''}`.replace(/^sha256:/i, ''),
                original_hash: `${row.originalHash || ''}`,
                claim_token: `${row.claimToken || ''}`,
                name: `${file.name || row.name || ''}`,
                size: Number(file.size || 0),
                mime_type: `${file.type || 'application/octet-stream'}`,
                source_type: 'file',
                source_url: '',
                replace_existing: row.replaceExisting === true,
                expected_previous_original_hash: `${row.expectedPreviousOriginalHash || ''}`,
            };
            const query = new URLSearchParams({
                mode: 'registration_workspace_stage',
                workspace_id: this.registrationWorkspaceId,
                source_id: row.stagedSourceId,
            });
            const form = new FormData();
            form.append('file', file, file.name);
            form.append('source_metadata', JSON.stringify(sourceMetadata));
            const payload = await this.requestJsonWithUploadProgress(
                `/wiz/api/portal.post.detail/analyze?${query.toString()}`,
                form,
                (ratio: number) => {
                    row.stageProgress = Math.max(0, Math.min(100, Math.round(ratio * 100)));
                    this.service.render();
                },
            );
            const source = payload && payload.code === 200 && payload.data
                ? payload.data.source : null;
            if (!source || !source.source_id) {
                throw new Error(
                    payload?.data?.message || '원본 파일을 서버에 보존하지 못했습니다.'
                );
            }
            row.stagedSourceId = `${source.source_id}`;
            row.sourceIndex = this.registrationSourceIndex(source, source, row.sourceIndex);
            row.staged = true;
            row.stageStatus = 'staged';
            row.stageProgress = 100;
            row.stagedAt = `${source.staged_at || ''}`;
            row.stagedBy = `${source.staged_by || ''}`;
            row.sourceGeneration = `${source.source_generation || ''}`;
            row.originalHash = `${source.original_hash || source.checksum_sha256 || row.originalHash || ''}`;
            row.replaceExisting = false;
            row.expectedPreviousOriginalHash = '';
            if (payload.data.workspace) {
                this.applyRegistrationWorkspaceSummary(
                    payload.data.workspace,
                    !this.registrationWorkspaceRevision,
                );
            }
            this.persistRegistrationRecovery();
            return true;
        } catch (error) {
            const captured = this.captureError(
                error,
                `${file.name || '선택 파일'} 원본을 서버에 보존하지 못했습니다.`,
            );
            row.staged = false;
            row.stageStatus = 'error';
            row.stageError = captured.message;
            row.stageProgress = 0;
            this.registrationWorkspaceStatus = 'error';
            this.registrationWorkspaceMessage = captured.message;
            this.persistRegistrationRecovery();
            return false;
        } finally {
            await this.service.render();
        }
    }

    public async retryRegistrationSourceStage(index: number, event?: Event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        const file = this.uploadFiles[index];
        if (
            this.uploadQueueRowActionDisabled(index)
            || !this.isNativeUploadFile(file)
        ) return;
        this.beginFilePreflightTask();
        try {
            this.persistRegistrationRecovery();
            if (!await this.saveRegistrationWorkspace(true)) return;
            await this.stageRegistrationSource(index, file);
            const latestWorkspace = await this.latestRegistrationWorkspace();
            if (
                latestWorkspace
                && `${latestWorkspace.workspace_id || ''}` === this.registrationWorkspaceId
            ) {
                this.applyRegistrationWorkspaceSummary(latestWorkspace);
            }
            await this.saveRegistrationWorkspace(true);
        } finally {
            this.endFilePreflightTask();
            await this.service.render();
        }
    }

    private filePreflightsReady() {
        const activeCount = Math.min(
            this.uploadFiles.length,
            this.maxActiveBatchFiles,
        );
        return activeCount > 0
            && this.filePreflights.length === this.uploadFiles.length
            && this.filePreflights
                .slice(0, activeCount)
                .every((row: any) => this.filePreflightReady(row));
    }

    private async refreshFilePreflightLease(source: any, item: any) {
        if (!source?.file && !item?.stagedSourceId) return;
        const index = Number(source.selectionIndex);
        const row = this.filePreflights[index];
        if (!Number.isInteger(index) || !row || this.uploadFiles[index] !== source.file) {
            throw new Error('처리할 파일의 중복 확인 정보를 찾을 수 없습니다. 파일을 다시 선택해주세요.');
        }
        if (this.isNativeUploadFile(source.file)) {
            await this.checkSelectedFile(index, source.file, true, false);
        } else if (!row.staged || !row.stagedSourceId) {
            throw new Error('서버에 보존된 원본을 찾을 수 없습니다. 원본을 다시 선택해주세요.');
        }
        const refreshed = this.filePreflights[index];
        if (!this.filePreflightReady(refreshed)) {
            throw new Error(this.filePreflightBlockingMessage(refreshed));
        }
        item.preflightHash = `${refreshed.originalHash || ''}`;
        item.preflightClaimToken = `${refreshed.claimToken || ''}`;
        item.duplicateOverrideSelected = !!refreshed.overrideSelected;
        item.duplicateOverrideConfirmed = !!refreshed.overrideConfirmed;
        item.duplicateOverrideReason = `${refreshed.overrideReason || ''}`;
        item.duplicateOverrideDocumentId = `${refreshed.existing?.document_id || ''}`;
        item.sourceIndex = this.registrationSourceIndex(source.file, refreshed, index);
        item.stagedSourceId = `${refreshed.stagedSourceId || item.stagedSourceId || ''}`;
    }

    private async reconcileUploadedSourceClaim(item: any, row: any = null) {
        const stagedSourceId = `${
            item?.stagedSourceId || row?.stagedSourceId || ''
        }`.trim();
        const preflight = await this
            .requestStagedSourceClaimReconciliation(
                stagedSourceId,
                `${item?.preflightHash || row?.originalHash || ''}`,
            );
        if (
            preflight.status !== 'new'
            || preflight.workspace_claim_bound !== true
            || !`${preflight.claim_token || ''}`
        ) {
            const error: any = new Error(
                preflight?.message
                || '업로드된 원본의 분석 권한 교체를 완료하지 못했습니다.'
            );
            error.errorCode = 'STAGED_CLAIM_RECONCILIATION_FAILED';
            error.userAction = '다른 창에서 같은 파일을 처리 중인지 확인한 뒤 다시 시도해주세요.';
            throw error;
        }
        item.preflightClaimToken = `${preflight.claim_token}`;
        if (row) {
            this.applyUploadPreflightResult(row, preflight);
            row.message = '업로드된 서버 원본과 분석 권한 연결을 확인했습니다.';
        }
        this.persistRegistrationRecovery();
        await this.service.render();
        return preflight;
    }

    private async applyUploadFiles(files: File[], input?: any) {
        if (this.sourceSelectionLocked()) {
            if (input) input.value = '';
            await this.service.modal.error(
                '선택한 파일의 중복 확인이 끝난 뒤 파일을 추가해주세요.'
            );
            return;
        }
        const fileKey = (file: File) => [
            `${file.name || ''}`.toLocaleLowerCase(),
            Number(file.size || 0),
            Number(file.lastModified || 0),
            `${file.type || ''}`.toLocaleLowerCase(),
        ].join('::');
        const existingKeys = new Set(this.uploadFiles.map((file: File) => fileKey(file)));
        const incomingKeys = new Set<string>();
        const additions = files.filter((file: File) => {
            const key = fileKey(file);
            if (existingKeys.has(key) || incomingKeys.has(key)) return false;
            incomingKeys.add(key);
            return true;
        });
        const duplicateCount = files.length - additions.length;

        if (this.uploadFiles.length + additions.length > this.maxBatchFiles) {
            if (input) input.value = '';
            this.uploadSelectionNotice = `현재 ${this.uploadFiles.length}개가 선택되어 있습니다.`;
            await this.service.modal.error(
                `한 작업에서는 최대 ${this.maxBatchFiles.toLocaleString('ko-KR')}개까지 선택할 수 있습니다. 선택한 원본은 최대 ${this.maxActiveBatchFiles}개씩 나누어 순차 처리하며, 전체 등록 건수에는 제한이 없습니다.`
            );
            await this.service.render();
            return;
        }
        const oversized = files.find((file: File) => file.size > 100 * 1024 * 1024);
        if (oversized) {
            if (input) input.value = '';
            this.uploadSelectionNotice = '용량을 초과한 파일만 추가되지 않았습니다. 기존 선택은 유지됩니다.';
            await this.service.modal.error(`${oversized.name}: 원문 파일은 100MB 이하만 처리할 수 있습니다. 기존 선택은 유지됩니다.`);
            await this.service.render();
            return;
        }

        if (!additions.length) {
            if (input) input.value = '';
            this.uploadSelectionNotice = duplicateCount > 0
                ? `이미 선택된 파일 ${duplicateCount}개는 중복 추가하지 않았습니다.`
                : '추가할 새 파일이 없습니다.';
            await this.service.render();
            return;
        }

        if (this.hasProcessedSourceWork()) {
            const add = await this.confirmRegistrationReset(
                '원문 파일을 추가할까요?',
                `현재 선택한 ${this.uploadFiles.length}개 파일은 유지됩니다. 파일 구성이 바뀌므로 기존 분석 결과와 직접 수정한 메타정보만 초기화됩니다.`,
                '파일 추가'
            );
            if (!add) {
                if (input) input.value = '';
                return;
            }
            this.resetRegistrationAnalysisAndForm();
        }

        this.uploadSourceType = 'file';
        this.ensureRegistrationWorkspaceId();
        if (this.data) this.data.provenance_type = 'direct_upload';
        this.uploadDragging = false;
        this.uploadFiles = [...this.uploadFiles, ...additions];
        this.selectedRegistrationSourceCount = (
            this.processedRegistrationSourceCount + this.uploadFiles.length
        );
        const firstAddedIndex = this.filePreflights.length;
        const firstAddedSourceIndex = this.nextRegistrationSourceIndex();
        this.sourceSelectionPage = firstAddedIndex > 0
            ? Math.floor(firstAddedIndex / this.sourceSelectionPageSize) + 1
            : 1;
        const addedRows = additions.map((file: File, index: number) => ({
                name: file.name,
                status: 'checking',
                label: '중복 확인 중',
                message: '원문을 메모리에 전체 적재하지 않고 SHA-256을 계산하고 있습니다.',
                progress: 0,
                originalHash: '',
                claimToken: '',
                blocking: true,
                restricted: false,
                canOverride: false,
                ownedByMe: false,
                canOverwrite: false,
                overwriteToken: '',
                overwritePending: false,
                releasePending: false,
                overrideSelected: false,
                overrideConfirmed: false,
                overrideReason: '',
                existing: null,
                policy: '',
                sourceIndex: firstAddedSourceIndex + index,
                stagedSourceId: this.createProgressId(),
                staged: false,
                stageStatus: 'pending',
                stageError: '',
                stageProgress: 0,
                stagedAt: '',
                stagedBy: '',
                size: Number(file.size || 0),
                mimeType: `${file.type || 'application/octet-stream'}`,
                lastModified: Number(file.lastModified || 0),
            }));
        this.filePreflights = [...this.filePreflights, ...addedRows];
        this.selectedUploadInspectorIndex = firstAddedIndex;
        this.uploadInspectorOpen = true;
        this.uploadFile = this.uploadFiles.length ? this.uploadFiles[0] : null;
        this.uploadFileName = this.uploadFiles.length === 1
            ? this.uploadFiles[0].name
            : `${this.uploadFiles.length}개 파일 선택됨`;
        this.uploadSelectionNotice = `${additions.length}개 파일을 추가했습니다.${duplicateCount > 0 ? ` 중복 ${duplicateCount}개는 제외했습니다.` : ''}`;
        this.batchItems = [];
        this.activeBatchIndex = -1;
        this.resetAnalysis();
        if (input) input.value = '';
        this.beginFilePreflightTask();
        await this.service.render();
        try {
            this.persistRegistrationRecovery();
            const workspaceCreated = await this.saveRegistrationWorkspace(true);
            if (!workspaceCreated) {
                additions.forEach((_file: File, offset: number) => {
                    const row = this.filePreflights[firstAddedIndex + offset];
                    if (!row) return;
                    row.stageStatus = 'error';
                    row.stageError = this.registrationWorkspaceMessage
                        || '서버 작업공간을 준비하지 못했습니다.';
                    row.staged = false;
                });
                this.uploadSelectionNotice = '서버 작업공간 준비에 실패했습니다. 원본 보존을 다시 시도해주세요.';
                return;
            }
            await this.runBounded(
                additions,
                this.duplicatePreflightConcurrency,
                async (file: File, offset: number) => {
                    const row = addedRows[offset];
                    const currentIndex = this.uploadQueueRowIndex(row, file);
                    if (currentIndex < 0) return;
                    const rowTask = (async () => {
                        await this.checkSelectedFile(
                            currentIndex,
                            file,
                            false,
                            additions.length === 1,
                            row,
                        );
                        if (row.releasePending) return;
                        const stageIndex = this.uploadQueueRowIndex(row, file);
                        if (stageIndex < 0) return;
                        await this.stageRegistrationSource(stageIndex, file, row);
                    })();
                    this.filePreflightRowTasks.set(row, rowTask);
                    try {
                        await rowTask;
                    } finally {
                        if (this.filePreflightRowTasks.get(row) === rowTask) {
                            this.filePreflightRowTasks.delete(row);
                        }
                    }
                },
            );
            const latestWorkspace = await this.latestRegistrationWorkspace();
            if (
                latestWorkspace
                && `${latestWorkspace.workspace_id || ''}` === this.registrationWorkspaceId
            ) {
                this.applyRegistrationWorkspaceSummary(latestWorkspace);
            }
            await this.saveRegistrationWorkspace(true);
            if (additions.length > 1) {
                const checkedRows = addedRows.filter(
                    (row: any) => this.filePreflights.includes(row)
                );
                const attentionCount = checkedRows.filter(
                    (row: any) => !this.filePreflightReady(row)
                ).length;
                this.uploadSelectionNotice = attentionCount > 0
                    ? `${checkedRows.length}개 중복 확인 완료 · ${attentionCount}개는 목록에서 조치가 필요합니다.`
                    : `${checkedRows.length}개 파일의 중복 확인을 완료했습니다. 최대 ${this.maxActiveBatchFiles}개씩 순차 처리합니다.`;
            }
        } finally {
            this.endFilePreflightTask();
            const attentionIndex = this.uploadFiles.findIndex(
                (_file: File, index: number) => !this.uploadQueueRowReady(index)
            );
            if (attentionIndex >= 0) {
                this.selectedUploadInspectorIndex = attentionIndex;
            }
            await this.service.render();
        }
    }

    public async removeSelectedFile(index: number, event?: Event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (
            index < 0
            || index >= this.uploadFiles.length
            || this.uploadQueueRowRemovalDisabled(index)
        ) return;
        const row = this.filePreflights[index];
        const file = this.uploadFiles[index];
        if (!row || !file) return;
        const rowTask = this.filePreflightRowTasks.get(row)
            || row.preflightCompletion;
        row.releasePending = true;
        if (row.preflightAbortController) {
            row.preflightAbortController.abort();
        }
        await this.service.render();
        try {
            if (rowTask) await rowTask;
            if (this.uploadQueueRowIndex(row, file) < 0) return;
            const resetProcessedWork = this.hasProcessedSourceWork();
            if (resetProcessedWork) {
                const remove = await this.confirmRegistrationReset(
                    '선택한 파일을 제거할까요?',
                    '분석 후 파일 구성을 바꾸면 현재 분석 결과와 직접 수정한 메타정보가 초기화됩니다.',
                    '파일 제거'
                );
                if (!remove) return;
            }
            if (!await this.releaseFilePreflight(row)) {
                await this.service.modal.error(
                    '동일 파일 처리 권한을 안전하게 해제하지 못했습니다. 파일을 유지했으니 잠시 후 다시 시도해주세요.'
                );
                return;
            }
            const liveIndex = this.uploadQueueRowIndex(row, file);
            if (liveIndex < 0) return;
            if (resetProcessedWork) this.resetRegistrationAnalysisAndForm();
            const removedName = file.name;
            this.uploadFiles.splice(liveIndex, 1);
            this.uploadFiles = [...this.uploadFiles];
            this.selectedRegistrationSourceCount = (
                this.processedRegistrationSourceCount + this.uploadFiles.length
            );
            this.filePreflights.splice(liveIndex, 1);
            this.filePreflights = [...this.filePreflights];
            if (this.selectedUploadInspectorIndex === liveIndex) {
                this.selectedUploadInspectorIndex = null;
            } else if (
                this.selectedUploadInspectorIndex !== null
                && this.selectedUploadInspectorIndex > liveIndex
            ) {
                this.selectedUploadInspectorIndex -= 1;
            }
            this.uploadFile = this.uploadFiles.length ? this.uploadFiles[0] : null;
            this.uploadFileName = this.uploadFiles.length === 1
                ? this.uploadFiles[0].name
                : (this.uploadFiles.length ? `${this.uploadFiles.length}개 파일 선택됨` : '');
            this.uploadSelectionNotice = `${removedName} 파일을 목록에서 제거했습니다.`;
            this.batchItems = [];
            this.activeBatchIndex = -1;
            this.resetAnalysis();
            this.persistRegistrationRecovery();
            await this.saveRegistrationWorkspace(true);
        } finally {
            if (this.filePreflights.includes(row)) row.releasePending = false;
            await this.service.render();
        }
    }


    public async selectUploadSource(type: 'file' | 'url' | 'incremental') {
        if (this.sourceSelectionLocked()) return false;
        if (this.uploadSourceType === type) return true;
        const hasSourceWork = this.uploadFiles.length > 0
            || !!this.uploadFileName
            || this.xmlUrls.length > 0
            || !!`${this.xmlUrl || ''}`.trim()
            || this.hasProcessedSourceWork()
            || this.syncFormSnapshot(this.syncForm) !== this.syncFormBaseline;
        if (hasSourceWork) {
            const change = await this.confirmRegistrationReset(
                '등록 방식을 변경할까요?',
                '등록 방식을 바꾸면 선택한 원문과 아직 저장하지 않은 분석·입력 내용이 초기화됩니다.',
                '등록 방식 변경'
            );
            if (!change) return false;
        }
        if (!await this.releaseSelectedFilePreflights(this.filePreflights)) {
            await this.service.modal.error(
                '동일 파일 처리 권한을 안전하게 해제하지 못해 등록 방식을 변경하지 않았습니다. 잠시 후 다시 시도해주세요.'
            );
            return false;
        }
        if (hasSourceWork) this.restoreSyncFormBaseline();
        this.resetRegistrationAnalysisAndForm();
        this.uploadSourceType = type;
        if (this.data) this.data.provenance_type = type === 'url' ? 'external_crawl' : 'direct_upload';
        this.uploadDragging = false;
        this.uploadFile = null;
        this.uploadFiles = [];
        this.filePreflights = [];
        this.uploadSelectionNotice = '';
        this.sourceSelectionPage = 1;
        this.uploadQueueSearch = '';
        this.uploadQueueFilter = 'all';
        this.selectedUploadInspectorIndex = null;
        this.uploadInspectorOpen = true;
        this.analysisQueueSearch = '';
        this.analysisQueueFilter = 'all';
        this.analysisQueuePage = 1;
        this.selectedAnalysisInspectorIndex = null;
        this.analysisInspectorOpen = this.defaultAnalysisInspectorOpen();
        this.completedRegistrationCount = 0;
        this.selectedRegistrationSourceCount = 0;
        this.processedRegistrationSourceCount = 0;
        this.batchItems = [];
        this.activeBatchIndex = -1;
        this.uploadFileName = '';
        this.xmlUrl = '';
        this.xmlUrls = [];
        if (type === 'incremental' && !this.syncSources.length && !this.syncLoading) {
            await this.loadSyncDashboard();
        }
        await this.service.render();
        return true;
    }

    private parseXmlUrlInput(value: string = this.xmlUrl) {
        const urls: string[] = [];
        const invalid: string[] = [];
        const seen = new Set<string>();
        let duplicateCount = 0;
        const rows = `${value || ''}`.split(/\r?\n/);
        rows.forEach((raw: string, index: number) => {
            const candidate = raw.trim();
            if (!candidate) return;
            try {
                const parsed = new URL(candidate);
                if (!['http:', 'https:'].includes(parsed.protocol) || !parsed.hostname) {
                    throw new Error('protocol');
                }
                if (parsed.username || parsed.password) {
                    invalid.push(`${index + 1}번째 URL에는 사용자 정보를 포함할 수 없습니다.`);
                    return;
                }
                const normalised = parsed.toString();
                if (seen.has(normalised)) {
                    duplicateCount += 1;
                    return;
                }
                seen.add(normalised);
                urls.push(normalised);
            } catch (_) {
                invalid.push(`${index + 1}번째 URL은 http 또는 https 형식이 아닙니다.`);
            }
        });
        return { urls, invalid, duplicateCount };
    }

    private xmlUrlSelectionLabel(urls: string[] = this.xmlUrls) {
        if (!urls.length) return '';
        return urls.length === 1 ? urls[0] : `${urls.length}개 XML URL 선택됨`;
    }

    public uploadQueueRowReady(index: number) {
        return this.filePreflightReady(this.filePreflights[index]);
    }

    public uploadQueueReadyCount() {
        return this.uploadFiles.reduce(
            (count: number, _file: File, index: number) => (
                count + (this.uploadQueueRowReady(index) ? 1 : 0)
            ),
            0,
        );
    }

    public uploadQueueAttentionCount() {
        return Math.max(0, this.uploadFiles.length - this.uploadQueueReadyCount());
    }

    public uploadQueuePreservedCount() {
        return this.uploadFiles.reduce(
            (count: number, _file: File, index: number) => (
                count + (this.filePreflights[index]?.staged === true ? 1 : 0)
            ),
            0,
        );
    }

    public uploadQueuePreservedPercent() {
        if (!this.uploadFiles.length) return 0;
        return Math.round(
            (this.uploadQueuePreservedCount() / this.uploadFiles.length) * 100
        );
    }

    public uploadQueuePreservationComplete() {
        return this.uploadSourceType === 'file'
            && this.uploadFiles.length > 0
            && this.filePreflights.length === this.uploadFiles.length
            && this.filePreflights.every((row: any) => (
                row?.staged === true
                && `${row?.stageStatus || ''}` === 'staged'
                && !!`${row?.stagedSourceId || ''}`
            ));
    }

    public uploadOverviewActiveMetric(): 'preservation' | 'analysis-ready' | '' {
        if (this.uploadSourceType !== 'file' || !this.uploadFiles.length) return '';
        const allPreserved = this.uploadQueuePreservationComplete();
        const preservationRunning = this.filePreflightRunning
            && !allPreserved
            && this.filePreflights.some((row: any) => (
                ['pending', 'uploading'].includes(`${row?.stageStatus || ''}`)
            ));
        if (preservationRunning) return 'preservation';
        const overwriteRunning = !this.overwriteConfirmOpen
            && this.processingOverwriteRunning();
        if (allPreserved && overwriteRunning) return 'analysis-ready';
        return '';
    }

    public uploadQueueDuplicateCheckComplete() {
        return this.uploadFiles.length > 0
            && this.filePreflights.length === this.uploadFiles.length
            && this.filePreflights.every((row: any) => (
                !!row && !['checking', 'error'].includes(`${row.status || ''}`)
            ));
    }

    public uploadQueueIssueLabel(index: number) {
        const row = this.filePreflights[index];
        if (!row) return '검사 대기';
        if (row.overwritePending) return '덮어쓰기 진행 중';
        if (row.stageStatus === 'error') return '원본 보존 실패';
        if (row.status === 'registered') return '동일 파일 등록됨';
        if (row.status === 'processing') {
            return this.uploadQueueSelectionClaimOwnerIndex(index) >= 0
                ? '현재 선택 내 동일 원문'
                : '동일 파일 처리 필요';
        }
        if (row.status === 'error') return row.label || '중복 검사 실패';
        if (row.status === 'checking') return 'SHA-256 검사 중';
        if (this.uploadQueueRowReady(index)) return '분석 준비 완료';
        if (row.stageStatus === 'uploading' || row.stageStatus === 'pending') {
            return '원본 보존 중';
        }
        return this.filePreflightLabel(row);
    }

    public uploadQueueIssueMessage(index: number) {
        const file = this.uploadFiles[index];
        const row = this.filePreflights[index];
        if (!file) return '선택한 파일 정보를 찾을 수 없습니다.';
        if (!row) return '파일 검사 준비가 끝날 때까지 잠시 기다려주세요.';
        if (row.overwritePending) {
            return `${row.message || '이전 미완료 처리 권한을 현재 업로드로 교체하고 있습니다.'}`;
        }
        if (this.uploadQueueRowReady(index)) {
            return 'SHA-256 중복 검사와 서버 원본 보존이 완료되어 자동 분석을 시작할 수 있습니다.';
        }
        return this.filePreflightBlockingMessage(row, index);
    }

    public uploadQueueNextAction(index: number) {
        const row = this.filePreflights[index];
        if (!row) return '검사 준비가 끝날 때까지 잠시 기다려주세요.';
        if (row.overwritePending) {
            return '서버 권한 교체가 끝나면 이 파일의 상태와 다음 동작이 자동으로 갱신됩니다.';
        }
        if (row.stageStatus === 'error') {
            return '원본 보존을 다시 시도하거나 필요 없는 파일은 제거해주세요.';
        }
        if (row.status === 'registered') {
            return row.canOverride
                ? '기존 자료를 확인하거나 체크박스로 새 버전 등록을 선택해주세요.'
                : '기존 자료를 확인한 뒤 이번 등록에서 제외해주세요.';
        }
        if (row.status === 'processing') {
            if (this.uploadQueueSelectionClaimOwnerIndex(index) >= 0) {
                return '같은 원문은 한 파일만 유지할 수 있습니다. 이번 파일을 제외해주세요.';
            }
            return row.ownedByMe && row.canOverwrite
                ? '현재 업로드로 덮어쓰거나 이번 파일을 제외해주세요.'
                : '연결된 등록 작업의 상태를 다시 확인하거나 이번 파일을 제외해주세요.';
        }
        if (row.status === 'error') return '중복 검사를 다시 실행하거나 필요 없는 파일은 제거해주세요.';
        if (row.status === 'checking' || ['pending', 'uploading'].includes(`${row.stageStatus || ''}`)) {
            return '검사와 서버 원본 보존이 완료되면 상태가 자동으로 갱신됩니다.';
        }
        return '목록의 확인 필요 항목을 모두 해결한 뒤 원본 자동 분석을 시작해주세요.';
    }

    public uploadQueueRecommendedAction(index: number) {
        const row = this.filePreflights[index];
        if (!row) return '파일을 다시 선택하면 검사가 자동으로 시작됩니다.';
        if (row.overwritePending) {
            return '원본은 이미 서버에 보존되어 있습니다. 현재 진행 표시가 끝날 때까지 기다려주세요.';
        }
        if (this.uploadQueueRowReady(index)) return '현재 파일은 별도 조치 없이 분석할 수 있습니다.';
        if (row.stageStatus === 'error') return '“원본 보존 재시도”를 실행하거나 필요 없는 파일은 제거하세요.';
        if (row.status === 'registered') return '중복 등록을 피하려면 기존 자료를 먼저 확인하세요.';
        if (row.status === 'processing') {
            return this.uploadQueueSelectionClaimOwnerIndex(index) >= 0
                ? '현재 선택 목록에서 유지할 파일 한 개를 남기고 이 파일을 제외하세요.'
                : '이전 처리 권한의 소유자와 상태를 확인하고 가능한 경우 덮어쓰기 또는 제외를 선택하세요.';
        }
        if (row.status === 'error') return '“중복 검사 재시도”를 실행하거나 필요 없는 파일은 제거하세요.';
        return '검사가 끝날 때까지 기다리거나 필요 없는 파일은 파일 제거를 눌러주세요.';
    }

    public uploadQueueRowClass(index: number) {
        const row = this.filePreflights[index];
        if (row?.overwritePending) return 'is-pending';
        if (this.uploadQueueRowReady(index)) return 'is-ready';
        if (!row || row.status === 'checking' || ['pending', 'uploading'].includes(`${row.stageStatus || ''}`)) {
            return 'is-pending';
        }
        return 'is-attention';
    }

    private uploadQueueFilterMatches(index: number) {
        if (this.uploadQueueFilter === 'attention') return !this.uploadQueueRowReady(index);
        if (this.uploadQueueFilter === 'ready') return this.uploadQueueRowReady(index);
        if (this.uploadQueueFilter === 'preserved') {
            return this.filePreflights[index]?.staged === true;
        }
        return true;
    }

    public uploadQueueFilteredRows() {
        const search = `${this.uploadQueueSearch || ''}`.trim().toLocaleLowerCase();
        return this.uploadFiles
            .map((item: File, index: number) => ({ item, index }))
            .filter((row: any) => (
                this.uploadQueueFilterMatches(row.index)
                && (!search || `${row.item?.name || ''}`.toLocaleLowerCase().includes(search))
            ));
    }

    public uploadQueueFilteredCount() {
        return this.uploadQueueFilteredRows().length;
    }

    public async setUploadQueueSearch(value: string) {
        this.uploadQueueSearch = `${value || ''}`.slice(0, 200);
        this.sourceSelectionPage = 1;
        await this.service.render();
    }

    public async setUploadQueueFilter(filter: 'all' | 'attention' | 'ready' | 'preserved') {
        this.uploadQueueFilter = filter;
        this.sourceSelectionPage = 1;
        this.selectedUploadInspectorIndex = null;
        await this.service.render();
    }

    public async resetUploadQueueFilter() {
        this.uploadQueueSearch = '';
        this.uploadQueueFilter = 'all';
        this.sourceSelectionPage = 1;
        this.selectedUploadInspectorIndex = null;
        await this.service.render();
    }

    public async selectUploadInspectorFile(index: number, event?: Event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (index < 0 || index >= this.uploadFiles.length) return;
        this.selectedUploadInspectorIndex = index;
        this.uploadInspectorOpen = true;
        await this.service.render();
    }

    public async toggleUploadInspector() {
        this.uploadInspectorOpen = !this.uploadInspectorOpen;
        await this.service.render();
    }

    public resolvedUploadInspectorIndex() {
        if (!this.uploadFiles.length) return -1;
        const visibleRows = this.uploadQueueFilteredRows();
        if (
            this.selectedUploadInspectorIndex !== null
            && visibleRows.some((row: any) => row.index === this.selectedUploadInspectorIndex)
        ) {
            return this.selectedUploadInspectorIndex;
        }
        const attention = visibleRows.find((row: any) => !this.uploadQueueRowReady(row.index));
        if (attention) return attention.index;
        if (visibleRows.length) return visibleRows[0].index;
        return -1;
    }

    public uploadInspectorFile() {
        return this.uploadFiles[this.resolvedUploadInspectorIndex()] || null;
    }

    public uploadInspectorPreflight() {
        return this.filePreflights[this.resolvedUploadInspectorIndex()] || null;
    }

    private sourceSelectionValues() {
        return this.uploadSourceType === 'url' ? this.xmlUrls : this.uploadFiles;
    }

    public sourceSelectionPageCount() {
        const total = this.uploadSourceType === 'url'
            ? this.xmlUrls.length
            : this.uploadQueueFilteredRows().length;
        return Math.max(
            1,
            Math.ceil(total / this.sourceSelectionPageSize),
        );
    }

    public sourceSelectionCurrentPage() {
        return Math.min(
            Math.max(1, this.sourceSelectionPage),
            this.sourceSelectionPageCount(),
        );
    }

    private sourceSelectionRows(values: any[]) {
        const start = (
            this.sourceSelectionCurrentPage() - 1
        ) * this.sourceSelectionPageSize;
        return values
            .map((item: any, index: number) => ({ item, index }))
            .slice(start, start + this.sourceSelectionPageSize);
    }

    public selectedFilePageRows() {
        const start = (
            this.sourceSelectionCurrentPage() - 1
        ) * this.sourceSelectionPageSize;
        return this.uploadQueueFilteredRows().slice(
            start,
            start + this.sourceSelectionPageSize,
        );
    }

    public selectedXmlUrlPageRows() {
        return this.sourceSelectionRows(this.xmlUrls);
    }

    public sourceSelectionPageRangeLabel() {
        const total = this.uploadSourceType === 'url'
            ? this.xmlUrls.length
            : this.uploadQueueFilteredRows().length;
        if (!total) return '0개';
        const start = (
            this.sourceSelectionCurrentPage() - 1
        ) * this.sourceSelectionPageSize + 1;
        const end = Math.min(total, start + this.sourceSelectionPageSize - 1);
        return `${start.toLocaleString('ko-KR')}–${end.toLocaleString('ko-KR')} / ${total.toLocaleString('ko-KR')}개`;
    }

    public trackByIndexedRow(_index: number, row: any) {
        return row?.key ?? row?.index;
    }

    public async setSourceSelectionPage(page: number) {
        this.sourceSelectionPage = Math.min(
            Math.max(1, Number(page) || 1),
            this.sourceSelectionPageCount(),
        );
        await this.service.render();
    }

    public sourceSelectionLocked() {
        return this.metaRecognizing
            || this.filePreflightRunning
            || this.filePreflightReleasePending()
            || this.processingOverwriteRunning();
    }

    public filePreflightReleasePending() {
        return this.filePreflightReleaseRunning || this.filePreflights.some(
            (row: any) => !!row?.releasePending
        );
    }

    public processingOverwriteRunning() {
        return this.bulkOverwriteRunning || this.filePreflights.some(
            (row: any) => !!row?.overwritePending
        );
    }

    private focusXmlUrlInput() {
        setTimeout(() => {
            const input = document.getElementById('registration-source-url') as HTMLInputElement | null;
            if (input && !input.disabled) input.focus();
        }, 0);
    }

    public async useSampleXmlUrl() {
        if (this.sourceSelectionLocked()) return;
        const selected = await this.selectUploadSource('url');
        if (!selected) return;
        const sampleUrl = new URL(
            'https://contents.nahf.or.kr/viewer/xmlViewer.do?itemId=gd&levelId='
        ).toString();
        if (this.xmlUrls.includes(sampleUrl)) {
            this.uploadSelectionNotice = '샘플 URL이 이미 목록에 있습니다.';
            await this.service.render();
            this.focusXmlUrlInput();
            return;
        }
        if (this.xmlUrls.length >= this.maxBatchFiles) {
            await this.service.modal.error(`한 작업에서는 URL을 최대 ${this.maxBatchFiles.toLocaleString('ko-KR')}개까지 선택할 수 있습니다. 최대 ${this.maxActiveBatchFiles}개씩 나누어 처리합니다.`);
            this.focusXmlUrlInput();
            return;
        }
        this.xmlUrl = sampleUrl;
        await this.addXmlUrl();
    }

    public async addXmlUrl(event?: KeyboardEvent) {
        if (event) event.preventDefault();
        if (this.sourceSelectionLocked()) return false;

        const parsed = this.parseXmlUrlInput();
        if (!parsed.urls.length) {
            await this.service.modal.error('추가할 원본 또는 XML Viewer URL을 입력해주세요.');
            this.focusXmlUrlInput();
            return false;
        }
        if (parsed.invalid.length) {
            await this.service.modal.error(parsed.invalid[0]);
            this.focusXmlUrlInput();
            return false;
        }
        if (parsed.urls.length > 1) {
            await this.service.modal.error('URL은 한 번에 1개씩 추가해주세요.');
            this.focusXmlUrlInput();
            return false;
        }

        const nextUrl = parsed.urls[0];
        if (this.xmlUrls.includes(nextUrl)) {
            this.xmlUrl = '';
            this.uploadSelectionNotice = '이미 추가된 URL입니다.';
            await this.service.render();
            this.focusXmlUrlInput();
            return false;
        }
        if (this.xmlUrls.length >= this.maxBatchFiles) {
            await this.service.modal.error(
                `한 작업에서는 URL을 최대 ${this.maxBatchFiles.toLocaleString('ko-KR')}개까지 선택할 수 있습니다. 최대 ${this.maxActiveBatchFiles}개씩 나누어 처리합니다.`
            );
            this.focusXmlUrlInput();
            return false;
        }

        const resetProcessedWork = this.hasProcessedSourceWork();
        if (resetProcessedWork) {
            const add = await this.confirmRegistrationReset(
                'XML URL을 추가할까요?',
                `현재 추가한 ${this.xmlUrls.length}개 URL은 유지됩니다. URL 구성이 바뀌므로 기존 분석 결과와 직접 수정한 메타정보만 초기화됩니다.`,
                'URL 추가'
            );
            if (!add) {
                this.focusXmlUrlInput();
                return false;
            }
        }

        if (!await this.releaseSelectedFilePreflights(this.filePreflights)) {
            await this.service.modal.error(
                '동일 파일 처리 권한을 안전하게 해제하지 못해 URL을 추가하지 않았습니다. 잠시 후 다시 시도해주세요.'
            );
            this.focusXmlUrlInput();
            return false;
        }
        if (resetProcessedWork) this.resetRegistrationAnalysisAndForm();

        const nextUrls = [...this.xmlUrls, nextUrl];
        this.uploadSourceType = 'url';
        this.ensureRegistrationWorkspaceId();
        if (this.data) {
            this.data.provenance_type = 'external_crawl';
            this.data.source_scheme = this.sourceScheme(nextUrls[0]);
        }
        this.uploadFile = null;
        this.uploadFiles = [];
        this.filePreflights = [];
        this.xmlUrls = nextUrls;
        this.selectedRegistrationSourceCount = (
            this.processedRegistrationSourceCount + this.xmlUrls.length
        );
        this.sourceSelectionPage = Math.floor(
            (this.xmlUrls.length - 1) / this.sourceSelectionPageSize
        ) + 1;
        this.xmlUrl = '';
        this.uploadFileName = this.xmlUrlSelectionLabel();
        this.uploadSelectionNotice = `URL을 추가했습니다. 현재 ${this.xmlUrls.length}개입니다.`;
        this.batchItems = [];
        this.activeBatchIndex = -1;
        this.resetAnalysis();
        this.persistRegistrationRecovery();
        await this.saveRegistrationWorkspace(true);
        await this.service.render();
        this.focusXmlUrlInput();
        return true;
    }

    public async applyXmlUrl() {
        if (`${this.xmlUrl || ''}`.trim()) return await this.addXmlUrl();
        if (this.xmlUrls.length > 0) return true;
        await this.service.modal.error('메타정보를 등록할 원본 또는 XML Viewer URL을 추가해주세요.');
        this.focusXmlUrlInput();
        return false;
    }

    public async removeSelectedXmlUrl(index: number, event?: Event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (this.sourceSelectionLocked() || index < 0 || index >= this.xmlUrls.length) return;
        if (this.hasProcessedSourceWork()) {
            const remove = await this.confirmRegistrationReset(
                '선택한 XML URL을 제거할까요?',
                '분석 후 URL 구성을 바꾸면 현재 분석 결과와 직접 수정한 메타정보가 초기화됩니다.',
                'URL 제거'
            );
            if (!remove) return;
            this.resetRegistrationAnalysisAndForm();
        }
        const removed = this.xmlUrls[index];
        this.xmlUrls = this.xmlUrls.filter((_: string, rowIndex: number) => rowIndex !== index);
        this.selectedRegistrationSourceCount = (
            this.processedRegistrationSourceCount + this.xmlUrls.length
        );
        this.xmlUrl = '';
        this.uploadFileName = this.xmlUrlSelectionLabel();
        this.uploadSelectionNotice = `${removed} URL을 목록에서 제거했습니다.`;
        this.batchItems = [];
        this.activeBatchIndex = -1;
        this.resetAnalysis();
        this.persistRegistrationRecovery();
        await this.saveRegistrationWorkspace(true);
        await this.service.render();
        this.focusXmlUrlInput();
    }

    public async runAutoMeta() {
        if (!this.data || this.sourceSelectionLocked() || this.uploadSourceType === 'incremental') return;

        if (this.uploadSourceType === 'file' && this.uploadFiles.length === 0) {
            await this.service.modal.error("메타정보를 등록할 원문 파일을 선택해주세요.");
            return;
        }
        if (this.uploadSourceType === 'file' && !this.filePreflightsReady()) {
            const blocked = this.filePreflights.find(
                (row: any, index: number) => (
                    index < this.maxActiveBatchFiles
                    && !this.filePreflightReady(row)
                )
            );
            await this.service.modal.error(
                this.filePreflightBlockingMessage(blocked)
            );
            return;
        }
        if (this.uploadSourceType === 'url') {
            const valid = await this.applyXmlUrl();
            if (!valid) return;
        }

        if (this.hasProcessedSourceWork()) {
            const retry = await this.confirmRegistrationReset(
                '메타정보를 다시 추출할까요?',
                '다시 추출하면 현재 직접 수정한 메타정보와 파일별 검수 내용이 새 분석 결과로 바뀝니다.',
                '다시 추출'
            );
            if (!retry) return;
        }

        this.metaRecognizing = true;
        this.analysisCancellationRequested = false;
        this.analysisBatchStartedAt = Date.now();
        this.analysisBatchFinishedAt = 0;
        this.analysisError = '';
        this.technicalErrorDetails = '';
        this.technicalErrorOpen = false;
        this.partialRegistrationConfirmed = false;
        this.registrationCompletionFinalized = false;
        this.activeBatchIndex = -1;
        this.selectedRegistrationSourceCount = Math.max(
            this.selectedRegistrationSourceCount,
            this.processedRegistrationSourceCount + this.queuedRegistrationSourceCount(),
        );
        if (this.processedRegistrationSourceCount === 0) {
            this.registrationAnalysisSources = [];
        }
        this.registrationAnalysisSourcesWorkspaceId = this.registrationWorkspaceId;
        this.mergeRegistrationAnalysisSources(this.registrationQueuedSources());
        const requestedProfile = `${this.data?.document_profile || ''}`;

        try {
            const sources: any[] = this.uploadSourceType === 'url'
                ? this.xmlUrls
                    .slice(0, this.maxActiveBatchFiles)
                    .map((url: string, index: number) => ({
                        file: null, name: url, url, selectionIndex: index,
                        sourceIndex: this.processedRegistrationSourceCount + index,
                        stagedSourceId: '',
                    }))
                : this.uploadFiles
                    .slice(0, this.maxActiveBatchFiles)
                    .map((file: File, index: number) => ({
                    file,
                    name: file.name,
                    url: '',
                    selectionIndex: index,
                    preflight: this.filePreflights[index] || null,
                    sourceIndex: this.registrationSourceIndex(
                        file,
                        this.filePreflights[index],
                        index,
                    ),
                    stagedSourceId: `${this.filePreflights[index]?.stagedSourceId || ''}`,
                }));
            const queuedSourceCount = this.uploadSourceType === 'url'
                ? this.xmlUrls.length : this.uploadFiles.length;
            if (queuedSourceCount > sources.length) {
                this.uploadSelectionNotice = `업로드한 ${queuedSourceCount.toLocaleString('ko-KR')}개 전체를 분석 목록에 표시했습니다. 서버 처리 순서에 따라 분석 상태가 계속 갱신됩니다.`;
            }
            this.visibilitySearch = '';
            this.visibilityStatusFilter = 'all';
            this.selectedVisibilityKeys = [];
            this.visibilityPage = 1;
            this.visibilityInspectorOpen = true;
            this.selectedVisibilityInspectorIndex = null;
            this.metadataReviewFileFilter = 'all';
            this.metadataAdvanceMode = 'all';
            this.metadataAdvanceSelectionKeys = [];
            this.metadataDraftNotice = '';
            this.batchItems = sources.map((source: any) => ({
                name: source.name,
                status: 'queued',
                progress: 0,
                stageLabel: '처리 대기 중',
                stageDetail: '앞선 파일이 끝나면 시작합니다.',
                completedSteps: 0,
                totalSteps: 11,
                securityScan: null,
                analysis: null,
                error: '',
                form: null,
                visibilityConfirmed: false,
                visibilityStatus: '',
                securityAcknowledged: false,
                duplicateConfirmed: false,
                duplicateOverrideSelected: !!source.preflight?.overrideSelected,
                duplicateOverrideConfirmed: !!source.preflight?.overrideSelected,
                progressId: '',
                securityProgressId: '',
                draftRevision: '',
                metadataReviewState: 'draft',
                metadataReviewPaused: false,
                registrationWorkflowState: {},
                sourceUrl: source.url || '',
                sourceFile: source.file || null,
                sourceIndex: source.sourceIndex,
                stagedSourceId: source.stagedSourceId || '',
                failureStage: '',
                errorDetails: '',
                errorInfo: null,
                preflightHash: source.preflight?.originalHash || '',
                preflightClaimToken: source.preflight?.claimToken || '',
                duplicateOverrideReason: source.preflight?.overrideSelected
                    ? (`${source.preflight?.overrideReason || ''}`.trim().length >= 5
                        ? `${source.preflight?.overrideReason}`
                        : this.duplicateVersionCheckboxReason)
                    : '',
                duplicateOverrideDocumentId: `${
                    source.preflight?.existing?.document_id || ''
                }`,
                requestedProfile,
                processingStartedAt: 0,
                processingCompletedAt: 0,
                reviewChecks: this.normaliseReviewChecks(null),
            }));
            this.rememberRegistrationAnalysisItems(this.batchItems);
            this.analysisQueueSearch = '';
            this.analysisQueueFilter = 'all';
            this.analysisQueuePage = 1;
            this.selectedAnalysisInspectorIndex = this.analysisQueueAllRows()[0]?.index ?? null;
            this.analysisInspectorOpen = this.defaultAnalysisInspectorOpen();
            this.persistRegistrationRecovery();
            await this.service.render();

            await this.runBounded(
                sources,
                this.analysisWorkerConcurrency,
                async (source: any, index: number) => {
                const item = this.batchItems[index];
                if (this.analysisCancellationRequested) {
                    item.status = 'error';
                    item.failureStage = 'analysis';
                    item.error = '사용자가 이 등록 작업을 취소했습니다.';
                    item.errorInfo = {
                        stage: 'cancelled',
                        fileName: item.name,
                        field: '',
                        errorCode: 'ANALYSIS_CANCELLED',
                        message: item.error,
                        userAction: '필요한 파일만 다시 시도해주세요.',
                        retryable: true,
                        requestId: '',
                    };
                    item.stageLabel = '처리 취소';
                    item.stageDetail = '다른 사용자의 작업에는 영향을 주지 않습니다.';
                    item.processingCompletedAt = Date.now();
                    return;
                }
                item.processingStartedAt = Date.now();
                item.status = 'scanning';
                item.progress = 0;
                item.stageLabel = source.file ? '보안 검사용 원문 전송 중' : '원격 원문 보안 검사 준비 중';
                item.stageDetail = '전송된 실제 바이트와 완료된 서버 단계를 기준으로 표시합니다.';
                await this.service.render();
                try {
                    await this.refreshFilePreflightLease(source, item);
                    if (this.analysisCancellationRequested) {
                        throw new Error('사용자가 이 등록 작업을 취소했습니다.');
                    }
                    item.securityScan = await this.requestSecurityScan(source.file, item, source.url || '');
                    item.securityAcknowledged = item.securityScan.protection_level === 'full';
                    if (this.analysisCancellationRequested) {
                        throw new Error('사용자가 이 등록 작업을 취소했습니다.');
                    }
                    item.status = 'running';
                    item.stageLabel = source.file ? '분석용 원문 전송 중' : '원격 원문 내려받는 중';
                    item.stageDetail = '서버 분석 요청을 준비합니다.';
                    await this.service.render();
                    item.analysis = await this.requestAnalysis(source.file, item, source.url || '');
                    item.securityScan = item.analysis.security_scan || item.securityScan;
                    item.securityAcknowledged = item.securityScan.protection_level === 'full';
                    item.form = this.analysisForm(item.analysis);
                    item.visibilityConfirmed = !!this.sourceVisibilityStatus(item.analysis);
                    item.visibilityStatus = item.visibilityConfirmed ? item.form.status : '';
                    item.form.duplicate_override_reason = item.duplicateOverrideReason || '';
                    item.duplicateConfirmed = (
                        !(item.analysis.duplicate && item.analysis.duplicate.found)
                        || (
                            this.aiSettingsAdmin
                            && item.duplicateOverrideSelected
                            && item.duplicateOverrideConfirmed
                            && `${item.duplicateOverrideReason || ''}`.trim().length >= 5
                            && !!`${item.duplicateOverrideDocumentId || ''}`
                            && `${item.duplicateOverrideDocumentId || ''}`
                                === `${item.analysis?.duplicate?.post_id || ''}`
                        )
                    );
                    item.form.duplicate_confirmed = item.duplicateConfirmed;
                    item.form.security_acknowledged = item.securityAcknowledged;
                    item.reviewChecks = this.defaultReviewChecks(item.analysis, item.form);
                    item.failureStage = '';
                    item.error = '';
                    item.errorDetails = '';
                    item.errorInfo = null;
                    item.status = 'complete';
                    item.progress = 100;
                    item.stageLabel = 'Profile 판별 완료';
                    item.stageDetail = '원본 확보·형식 판별·Profile 추천·추출 준비를 완료했습니다.';
                } catch (error) {
                    const captured = this.analysisCancellationRequested
                        ? {
                            message: '사용자가 이 등록 작업을 취소했습니다.',
                            details: '',
                        }
                        : this.captureError(error, '문서 처리에 실패했습니다.');
                    item.status = 'error';
                    item.failureStage = 'analysis';
                    item.error = captured.message;
                    item.errorDetails = captured.details;
                    item.errorInfo = captured;
                    if (captured.duplicate) {
                        this.applyDuplicateConflict(item, captured.duplicate);
                        this.analysisDetailOpen = { [index]: true };
                    }
                    item.stageLabel = this.analysisCancellationRequested
                        ? '처리 취소' : '처리 실패';
                    item.stageDetail = item.error;
                    if (captured.details) this.technicalErrorDetails = captured.details;
                }
                item.processingCompletedAt = Date.now();
                this.queueRegistrationRecoverySave();
                await this.service.render();
                },
            );
            this.analysisBatchFinishedAt = Date.now();
            this.persistRegistrationRecovery();
            const firstComplete = this.batchItems.findIndex((item: any) => item.status === 'complete');
            if (firstComplete < 0) throw new Error(this.batchItems[0]?.error || '처리된 자료가 없습니다.');
            await this.selectBatchItem(firstComplete);
            const duplicateFailureIndex = this.batchItems.findIndex(
                (item: any) => item.status === 'error' && this.duplicateReviewRequired(item)
            );
            if (duplicateFailureIndex >= 0) {
                this.analysisDetailOpen = { [duplicateFailureIndex]: true };
                await this.service.render();
                await this.service.modal.error(
                    `${this.batchItems[duplicateFailureIndex].name || '선택 파일'}: 동일한 원문 자료가 이미 등록되어 있습니다. 배치 목록에서 기존 자료를 확인하거나 이번 등록에서 제외해주세요.`
                );
            }
            this.registerStep = 'upload';
            this.syncReviewSections();
            const failed = this.batchItems.filter((item: any) => item.status === 'error').length;
            if (failed > 0) this.analysisError = `${failed}개 파일 처리에 실패했습니다. 배치 목록에서 확인해주세요.`;
        } catch (error) {
            const captured = this.captureError(error, '메타정보 등록 중 오류가 발생했습니다.');
            this.analysisError = captured.message;
            this.technicalErrorDetails = captured.details;
            this.technicalErrorOpen = false;
            await this.service.modal.error(captured.message);
        } finally {
            this.metaRecognizing = false;
            this.analysisCancellationRequested = false;
            if (this.analysisBatchStartedAt && !this.analysisBatchFinishedAt) {
                this.analysisBatchFinishedAt = Date.now();
            }
            this.analysisQueueFilter = 'all';
            this.analysisQueuePage = 1;
            if (this.analysisActionRequiredCount() > 0) {
                const firstAttention = this.batchItems.findIndex(
                    (item: any) => this.analysisItemNeedsAction(item)
                );
                if (firstAttention >= 0) {
                    const inspectorIndex = this.analysisQueueIndexForBatchIndex(firstAttention);
                    if (inspectorIndex !== null) {
                        this.selectedAnalysisInspectorIndex = inspectorIndex;
                        this.analysisQueuePage = Math.floor(
                            inspectorIndex / this.analysisQueuePageSize
                        ) + 1;
                    }
                }
            }
            this.persistRegistrationRecovery();
            await this.service.render();
            if (this.batchItems.length > 0) this.scrollToCurrentStep();
        }
    }

    public async cancelActiveAnalysis() {
        if (!this.metaRecognizing || this.analysisCancellationRequested) return;
        this.analysisCancellationRequested = true;
        const active = this.batchItems.filter(
            (item: any) => ['scanning', 'running', 'queued'].includes(item.status)
                && !!(item.progressId || item.securityProgressId || item.processingStartedAt)
        );
        const progressIds = Array.from(new Set(active.reduce(
            (values: string[], item: any) => values.concat([
                `${item.progressId || ''}`,
                `${item.securityProgressId || ''}`,
            ]),
            [],
        ).filter((value: string) => !!value)));
        let cancellationError = '';
        await this.runBounded(
            progressIds,
            this.analysisWorkerConcurrency,
            async (progressId: string) => {
                const result = await wiz.call('analyze', {
                    mode: 'cancel',
                    progress_id: progressId,
                });
                if (result && result.code !== 200 && !cancellationError) {
                    cancellationError = result.data && result.data.message
                        ? result.data.message : '분석 취소 요청을 확인하지 못했습니다.';
                }
            },
        );
        if (cancellationError) this.analysisError = cancellationError;
        active.forEach((item: any) => {
            item.stageLabel = '처리 취소 요청';
            item.stageDetail = '현재 사용자의 실행 중인 분석을 모두 중단하고 있습니다.';
        });
        await this.service.render();
    }

    public failedItemCount() {
        return this.batchItems.filter((item: any) => item.status === 'error').length;
    }

    public retryableFailedItemCount() {
        return this.batchItems.filter(
            (item: any, index: number) => this.failedItemCanRetry(item, index)
        ).length;
    }

    public failedAnalysisCount() {
        return this.batchItems.filter(
            (item: any) => item.status === 'error' && item.failureStage !== 'save'
        ).length;
    }

    public failedSaveCount() {
        return this.batchItems.filter(
            (item: any) => item.status === 'error' && item.failureStage === 'save'
        ).length;
    }

    public retryFailedButtonLabel() {
        if (this.retryProgress.status === 'running') return '조치 필요 항목 처리 중';
        const analysis = this.failedAnalysisCount();
        const save = this.failedSaveCount();
        if (analysis && save) return `분석 ${analysis}개·저장 ${save}개 조치`;
        if (save) return `저장 확인 ${save}개`;
        return `분석 조치 ${analysis}개`;
    }

    public analysisBulkRetryActionLabel() {
        const retryable = this.batchItems.filter(
            (item: any, index: number) => this.failedItemCanRetry(item, index)
        );
        if (
            retryable.length > 0
            && retryable.every((item: any) => (
                this.batchItemOperationInProgress(item)
                && !this.batchItemOperationReconnectable(item)
                && !!`${item.stagedSourceId || ''}`
            ))
        ) {
            return '업로드된 원본으로 다시 분석';
        }
        return '조치 필요 항목 다시 분석';
    }

    public retryProgressPercent() {
        const total = Math.max(0, this.safeNumber(this.retryProgress.total, 0));
        if (!total) return 0;
        if (['complete', 'partial'].includes(this.retryProgress.status)) return 100;
        if (this.retryProgress.status === 'error') {
            return Math.max(
                0,
                Math.min(
                    100,
                    Math.round(this.safeNumber(this.retryProgress.completed, 0) / total * 100)
                )
            );
        }
        let activeRatio = 0;
        if (!this.retryProgress.indeterminate) {
            const active = this.batchItems[this.retryProgress.currentBatchIndex];
            activeRatio = Math.max(
                0,
                Math.min(0.99, this.safeNumber(active?.progress, 0) / 100)
            );
        }
        return Math.max(
            0,
            Math.min(
                99,
                Math.round(
                    (
                        this.safeNumber(this.retryProgress.completed, 0)
                        + activeRatio
                    ) / total * 100
                )
            )
        );
    }

    public retryProgressStatusLabel() {
        if (this.retryProgress.status === 'running') return '재시도 진행 중';
        if (this.retryProgress.status === 'complete') return '재시도 완료';
        if (this.retryProgress.status === 'partial') return '일부 항목 재실패';
        if (this.retryProgress.status === 'error') return '재시도 중단';
        return '';
    }

    public dismissRetryProgress() {
        if (this.retryProgress.status === 'running') return;
        this.resetRetryProgressState();
        this.service.render();
    }

    private resetRetryProgressState() {
        this.retryProgress = {
            status: 'idle',
            total: 0,
            completed: 0,
            succeeded: 0,
            failed: 0,
            currentBatchIndex: -1,
            currentOrder: 0,
            currentName: '',
            stage: '',
            detail: '',
            indeterminate: false,
        };
    }

    public registrationErrorStageLabel(stage: any) {
        const labels: any = {
            input: '입력 확인',
            source: '원본 확보',
            redirect: 'Redirect 확인',
            viewer_xml: 'XML Viewer 원본 탐색',
            file: '파일 처리',
            duplicate: '중복 확인',
            security: '보안 검사',
            ocr: 'OCR',
            llm: 'LLM 메타정보',
            layout: '페이지 구조',
            storage: '저장소',
            mysql: 'MySQL',
            milvus: 'Milvus',
            queue: '처리 대기',
            draft: '검수 초안 저장',
            save: '자료 저장',
            analysis: '문서 분석',
            metadata: '2단계 메타정보 검수',
            manual: '3단계 파일별 검수',
            cancelled: '사용자 취소',
        };
        const key = `${stage || ''}`.toLowerCase();
        return labels[key] || '처리 단계';
    }

    public failedItemCanRetry(item: any, index: number) {
        if (!item || item.status !== 'error') return false;
        if (
            item.errorInfo?.errorCode === 'DUPLICATE_MATERIAL'
            && this.aiSettingsAdmin
            && this.duplicateOverrideValid(item)
        ) {
            return true;
        }
        if (item.errorInfo?.retryable === false) return false;
        if (item.failureStage === 'save') return !!(item.analysis && item.form);
        return !!(
            item.stagedSourceId
            || item.sourceFile
            || this.uploadFiles[index]
            || item.sourceUrl
            || (this.uploadSourceType === 'url' && this.xmlUrls[index])
        );
    }

    public async goToFailedField(index: number) {
        const item = this.batchItems[index];
        if (!item || item.status !== 'error') return;
        const field = `${item.errorInfo?.field || ''}`;
        const uploadField = ['file', 'source_url', 'analysis_id'].includes(field)
            || !(item.analysis && item.form);
        if (uploadField) {
            this.registerStep = 'upload';
            this.uploadSourceType = item.sourceUrl ? 'url' : 'file';
        } else {
            await this.selectBatchItem(index);
            this.registerStep = 'metadata';
            this.metadataSection = 'bibliography';
            const reviewField = this.xmlReviewFields().find(
                (row: any) => `${row.id || ''}` === field
            );
            if (reviewField) this.xmlReviewActiveFieldId = reviewField.id;
        }
        await this.service.render();
        const targetIds: any = {
            file: 'registration-source-file',
            source_url: 'registration-source-url',
            title: 'registration-field-title',
            category: 'registration-field-category',
            authors: 'registration-field-authors',
            date: 'registration-field-date',
            era: 'registration-field-era',
            keywords: 'registration-field-keywords',
            summary: 'registration-field-summary',
        };
        const targetId = targetIds[field] || (
            uploadField ? (item.sourceUrl ? 'registration-source-url' : 'registration-source-file')
                : 'register-workbench'
        );
        setTimeout(() => {
            const target = document.getElementById(targetId) as HTMLElement;
            if (!target) return;
            target.scrollIntoView({ behavior: 'smooth', block: 'center' });
            if (typeof (target as any).focus === 'function') (target as any).focus();
        }, 0);
    }

    private async reconnectOperationInProgressItem(item: any) {
        const progressId = this.operationReconnectProgressId(item);
        if (!progressId) return { handled: false, completed: false, monitoring: false };

        const response = await this.requestRegistrationRecovery({
            items: [{
                name: `${item?.name || ''}`,
                analysis_id: '',
                progress_id: progressId,
            }],
        });
        const rows = response && response.code === 200
            && response.data && response.data.recovery
            ? response.data.recovery.items || [] : [];
        const row = rows.find((candidate: any) => (
            `${candidate?.progress_id || ''}` === progressId
        ));
        if (!row) {
            throw new Error('기존 분석 상태 응답을 확인할 수 없습니다. 새 분석은 시작하지 않았습니다.');
        }
        if (row.analysis) {
            this.applyRecoveredAnalysisResult(item, row);
            item.stageDetail = '서버에 완료되어 있던 분석 결과를 새 작업 없이 불러왔습니다.';
            return { handled: true, completed: true, monitoring: false };
        }

        const progress = row.progress && typeof row.progress === 'object'
            ? row.progress : {};
        const status = `${progress.status || row.status || ''}`.toLowerCase();
        if (this.isActiveRecoveryStatus(status)) {
            item.progressId = progressId;
            item.status = 'running';
            item.failureStage = '';
            item.error = '';
            item.errorDetails = '';
            item.errorInfo = null;
            this.applyServerAnalysisProgress(item, progress);
            item.stageLabel = '서버 분석 진행 중 · 자동 확인';
            item.stageDetail = progress.detail
                || '서버에서 실제 분석 중입니다. 완료 여부를 이 화면에서 자동으로 확인합니다.';
            this.persistRegistrationRecovery();
            if (!await this.saveRegistrationWorkspace(true)) {
                throw new Error(
                    '확인한 서버 분석 ID를 작업공간에 저장하지 못했습니다. 새 분석은 시작하지 않았습니다.'
                );
            }
            return { handled: true, completed: false, monitoring: true };
        }

        // A terminal or missing progress record no longer represents a live
        // operation. Clear only the stale link; the preserved source remains
        // available for the normal, idempotent retry path below.
        item.progressId = '';
        this.persistRegistrationRecovery();
        if (!await this.saveRegistrationWorkspace(true)) {
            throw new Error(
                '종료된 분석 연결 상태를 작업공간에 반영하지 못했습니다. 새 분석은 시작하지 않았습니다.'
            );
        }
        return { handled: false, completed: false, monitoring: false };
    }

    public async retryFailedItems(targetIndex?: number) {
        if (this.metaRecognizing || this.saving) return;
        const failedRows = this.batchItems
            .map((item: any, index: number) => ({ item, index }))
            .filter((row: any) => (
                row.item.status === 'error'
                && this.failedItemCanRetry(row.item, row.index)
                && (typeof targetIndex !== 'number' || row.index === targetIndex)
            ));
        if (!failedRows.length) return;

        const orphanedClaimRows = failedRows.filter((row: any) => (
            this.batchItemOperationInProgress(row.item)
            && !this.batchItemOperationReconnectable(row.item)
            && !!`${row.item?.stagedSourceId || ''}`
        ));
        if (orphanedClaimRows.length > 0) {
            const confirmed = await this.service.modal.show({
                title: '업로드된 원본으로 다시 분석할까요?',
                message: `${orphanedClaimRows.length}개 파일은 원본이 정상 보존됐지만 덮어쓰기 권한 연결만 완료되지 않았습니다. 실제 실행 중인 서버 작업이 없는지 확인한 뒤, 이번 작업에 업로드한 원본의 권한을 다시 연결하고 분석합니다.`,
                action: '업로드 원본 분석 시작',
                actionBtn: 'warning',
                cancel: '목록 확인',
                status: 'warning',
            });
            if (!confirmed) return;
        }

        this.metaRecognizing = true;
        this.retryProgress = {
            status: 'running',
            total: failedRows.length,
            completed: 0,
            succeeded: 0,
            failed: 0,
            currentBatchIndex: -1,
            currentOrder: 0,
            currentName: '',
            stage: '재시도 준비 중',
            detail: '실패한 항목의 기존 분석·검수 내용을 확인하고 있습니다.',
            indeterminate: true,
        };
        this.partialRegistrationConfirmed = false;
        this.analysisError = '';
        this.technicalErrorDetails = '';
        let recoveredAnalysis = 0;
        let recoveredSave = 0;
        let reconnectedAnalysis = 0;
        let retryLoopError: any = null;

        try {
            for (let retryIndex = 0; retryIndex < failedRows.length; retryIndex += 1) {
                const row = failedRows[retryIndex];
                const item = row.item;
                this.retryProgress.currentBatchIndex = row.index;
                this.retryProgress.currentOrder = retryIndex + 1;
                this.retryProgress.currentName = item.name || `항목 ${row.index + 1}`;
                this.retryProgress.stage = item.failureStage === 'save'
                    ? '자료함 저장 다시 실행'
                    : '원본 분석 다시 실행';
                this.retryProgress.detail = `${retryIndex + 1} / ${failedRows.length}번째 실패 항목을 처리하고 있습니다.`;
                this.retryProgress.indeterminate = item.failureStage === 'save';
                await this.service.render();
                if (item.failureStage === 'save' && item.analysis && item.form) {
                    try {
                        if (this.isNewPost() && !this.registrationPreflightReusable(item)) {
                            item.status = 'complete';
                            item.stageLabel = '검수 초안 다시 확인 중';
                            item.stageDetail = '서버에 저장된 정확한 초안 버전과 원본 체크섬을 다시 확인합니다.';
                            this.retryProgress.detail = item.stageDetail;
                            await this.service.render();
                            await this.refreshRegistrationPreflight();
                            if (!this.registrationPreflightReusable(item)) {
                                throw this.registrationDraftSyncError
                                    || this.registrationDraftReferenceError(item);
                            }
                        }
                        item.status = 'running';
                        item.progress = 0;
                        item.stageLabel = '등록 저장 다시 시도 중';
                        item.stageDetail = '기존 분석과 검수 내용은 유지하고 작은 초안 참조의 저장 응답을 기다립니다.';
                        this.retryProgress.detail = item.stageDetail;
                        await this.service.render();
                        const result = await this.callRegistrationSave(
                            this.registrationCommitRequest(item, item.form)
                        );
                        if (!result || result.code !== 200) {
                            throw (result && result.data)
                                || new Error('자료 저장에 실패했습니다.');
                        }
                        item.status = 'saved';
                        item.failureStage = '';
                        item.error = '';
                        item.errorDetails = '';
                        item.errorInfo = null;
                        item.progress = 100;
                        item.stageLabel = '등록 완료';
                        item.stageDetail = '기존 분석·검수 내용을 그대로 저장했습니다.';
                        item.registrationResult = {
                            name: item.name,
                            title: item.form?.title || item.name,
                            status: 'saved',
                            message: result.data?.ingestion?.warning || '자료함 등록 완료',
                            id: result.data?.id || '',
                            visibility: item.form?.status || 'draft',
                            updated: result.data?.updated || '',
                            postprocess: result.data?.ingestion?.status || 'complete',
                        };
                        this.creditSavedRegistrationItems();
                        recoveredSave += 1;
                        this.retryProgress.succeeded += 1;
                    } catch (error) {
                        const captured = this.captureError(error, '자료 저장에 실패했습니다.');
                        item.status = 'error';
                        item.failureStage = 'save';
                        item.error = captured.message;
                        item.errorDetails = captured.details;
                        item.errorInfo = captured;
                        item.stageLabel = '저장 실패';
                        item.stageDetail = item.error;
                        this.retryProgress.failed += 1;
                    }
                    this.retryProgress.completed += 1;
                    this.persistRegistrationRecovery();
                    await this.service.render();
                    continue;
                }

                if (
                    this.batchItemOperationInProgress(item)
                    && this.batchItemOperationReconnectable(item)
                ) {
                    this.retryProgress.stage = '서버 분석 상태 확인';
                    this.retryProgress.detail = '새 요청을 만들기 전에 기존 서버 분석의 실제 상태를 확인하고 있습니다.';
                    this.retryProgress.indeterminate = true;
                    await this.service.render();
                    try {
                        const reconnect = await this.reconnectOperationInProgressItem(item);
                        if (reconnect.completed) {
                            recoveredAnalysis += 1;
                            this.retryProgress.succeeded += 1;
                        } else if (reconnect.monitoring) {
                            reconnectedAnalysis += 1;
                            this.retryProgress.succeeded += 1;
                        }
                        if (reconnect.handled) {
                            this.retryProgress.completed += 1;
                            this.queueRegistrationRecoverySave();
                            await this.service.render();
                            continue;
                        }
                    } catch (error) {
                        const captured = this.captureError(
                            error,
                            '기존 서버 분석 상태를 확인하지 못했습니다.',
                        );
                        item.status = 'error';
                        item.failureStage = 'analysis';
                        item.error = captured.message;
                        item.errorDetails = captured.details;
                        item.errorInfo = captured;
                        item.stageLabel = '서버 분석 상태 확인 실패';
                        item.stageDetail = `${captured.message} 새 분석은 시작하지 않았습니다.`;
                        this.retryProgress.failed += 1;
                        this.retryProgress.completed += 1;
                        this.queueRegistrationRecoverySave();
                        await this.service.render();
                        continue;
                    }
                }

                if (
                    this.batchItemOperationInProgress(item)
                    && !this.batchItemOperationReconnectable(item)
                    && item.stagedSourceId
                ) {
                    this.retryProgress.stage = '업로드된 원본 분석 준비';
                    this.retryProgress.detail = '실제 실행 중인 서버 작업을 확인하고, 이번 작업에 업로드한 원본의 처리 권한을 다시 연결합니다.';
                    this.retryProgress.indeterminate = true;
                    await this.service.render();
                    try {
                        const stagedRow = this.filePreflights.find(
                            (candidate: any) => Number(candidate?.sourceIndex)
                                === Number(item.sourceIndex)
                        ) || null;
                        await this.reconcileUploadedSourceClaim(item, stagedRow);
                    } catch (error) {
                        const captured = this.captureError(
                            error,
                            '업로드된 원본의 분석 준비를 완료하지 못했습니다.',
                        );
                        item.status = 'error';
                        item.failureStage = 'analysis';
                        item.error = captured.message;
                        item.errorDetails = captured.details;
                        item.errorInfo = captured;
                        item.stageLabel = '업로드 원본 분석 준비 필요';
                        item.stageDetail = captured.message;
                        this.retryProgress.failed += 1;
                        this.retryProgress.completed += 1;
                        this.queueRegistrationRecoverySave();
                        await this.service.render();
                        continue;
                    }
                }

                const sourceQueueIndex = this.filePreflights.findIndex(
                    (candidate: any) => Number(candidate?.sourceIndex) === Number(item.sourceIndex)
                );
                const resolvedSourceQueueIndex = sourceQueueIndex >= 0
                    ? sourceQueueIndex : row.index;
                const sourceCandidate = item.sourceFile
                    || this.uploadFiles[resolvedSourceQueueIndex]
                    || null;
                const sourceFile = this.isNativeUploadFile(sourceCandidate)
                    ? sourceCandidate as File : null;
                const stagedSourceId = `${
                    item.stagedSourceId
                    || this.filePreflights[resolvedSourceQueueIndex]?.stagedSourceId
                    || ''
                }`;
                const sourceUrl = item.sourceUrl || (
                    this.uploadSourceType === 'url' ? this.xmlUrls[row.index] || '' : ''
                );
                if (!sourceFile && !sourceUrl && !stagedSourceId) {
                    item.error = '원본 파일 데이터가 없어 이 항목만 다시 처리할 수 없습니다. 원문을 다시 선택해주세요.';
                    item.errorDetails = '';
                    item.errorInfo = {
                        stage: 'file',
                        fileName: item.name,
                        field: 'file',
                        errorCode: 'SOURCE_RESELECT_REQUIRED',
                        message: item.error,
                        userAction: '원문 파일을 다시 선택해주세요.',
                        retryable: false,
                        requestId: '',
                    };
                    item.failureStage = 'analysis';
                    item.stageLabel = '원본 다시 선택 필요';
                    item.stageDetail = item.error;
                    this.retryProgress.failed += 1;
                    this.retryProgress.completed += 1;
                    await this.service.render();
                    continue;
                }
                if (sourceFile) {
                    await this.checkSelectedFile(resolvedSourceQueueIndex, sourceFile, true);
                    const preflight = this.filePreflights[resolvedSourceQueueIndex];
                    if (!this.filePreflightReady(preflight)) {
                        item.error = preflight?.message
                            || '동일 파일 등록 여부를 다시 확인하지 못했습니다.';
                        item.errorDetails = '';
                        item.errorInfo = {
                            stage: 'duplicate',
                            fileName: item.name,
                            field: 'file',
                            errorCode: 'DUPLICATE_PREFLIGHT_FAILED',
                            message: item.error,
                            userAction: '중복 상태를 다시 확인한 뒤 해당 파일만 재시도해주세요.',
                            retryable: true,
                            requestId: '',
                        };
                        item.failureStage = 'analysis';
                        item.stageLabel = this.filePreflightLabel(preflight);
                        item.stageDetail = item.error;
                        this.retryProgress.failed += 1;
                        this.retryProgress.completed += 1;
                        await this.service.render();
                        continue;
                    }
                    item.preflightHash = preflight.originalHash || '';
                    item.preflightClaimToken = preflight.claimToken || '';
                    item.duplicateOverrideReason = preflight.overrideReason || '';
                }
                if (stagedSourceId) item.stagedSourceId = stagedSourceId;

                item.status = 'scanning';
                item.progress = 0;
                item.error = '';
                item.errorDetails = '';
                    item.errorInfo = null;
                item.stageLabel = sourceFile
                    ? '보안 검사용 원문 다시 전송 중'
                    : stagedSourceId
                        ? '업로드된 원본 다시 검사 중'
                        : '원격 원문 보안 검사 다시 준비 중';
                item.stageDetail = '성공한 파일과 검수 내용은 유지하고 이 항목만 처리합니다.';
                this.retryProgress.indeterminate = false;
                this.retryProgress.detail = item.stageDetail;
                await this.service.render();
                try {
                    item.securityScan = await this.requestSecurityScan(sourceFile, item, sourceUrl);
                    item.securityAcknowledged = item.securityScan.protection_level === 'full';
                    item.status = 'running';
                    item.stageLabel = '실패 항목 문서 분석 중';
                    item.analysis = await this.requestAnalysis(sourceFile, item, sourceUrl);
                    item.securityScan = item.analysis.security_scan || item.securityScan;
                    item.securityAcknowledged = item.securityScan.protection_level === 'full';
                    item.form = this.analysisForm(item.analysis);
                    item.visibilityConfirmed = !!this.sourceVisibilityStatus(item.analysis);
                    item.visibilityStatus = item.visibilityConfirmed ? item.form.status : '';
                    item.form.duplicate_override_reason = item.duplicateOverrideReason || '';
                    item.duplicateConfirmed = (
                        !(item.analysis.duplicate && item.analysis.duplicate.found)
                        || (
                            this.aiSettingsAdmin
                            && item.duplicateOverrideSelected
                            && item.duplicateOverrideConfirmed
                            && `${item.duplicateOverrideReason || ''}`.trim().length >= 5
                            && !!`${item.duplicateOverrideDocumentId || ''}`
                            && `${item.duplicateOverrideDocumentId || ''}`
                                === `${item.analysis?.duplicate?.post_id || ''}`
                        )
                    );
                    item.form.duplicate_confirmed = item.duplicateConfirmed;
                    item.form.security_acknowledged = item.securityAcknowledged;
                    item.reviewChecks = this.defaultReviewChecks(item.analysis, item.form);
                    item.status = 'complete';
                    item.progress = 100;
                    item.failureStage = '';
                    item.error = '';
                    item.errorDetails = '';
                    item.errorInfo = null;
                    item.stageLabel = 'Profile 판별 완료';
                    item.stageDetail = '재시도한 파일의 원본 분석을 완료했습니다.';
                    recoveredAnalysis += 1;
                    this.retryProgress.succeeded += 1;
                } catch (error) {
                    const captured = this.captureError(error, '문서 재처리에 실패했습니다.');
                    item.status = 'error';
                    item.failureStage = 'analysis';
                    item.error = captured.message;
                    item.errorDetails = captured.details;
                    item.errorInfo = captured;
                    if (captured.duplicate) {
                        this.applyDuplicateConflict(item, captured.duplicate);
                        this.analysisDetailOpen = { [row.index]: true };
                    }
                    item.stageLabel = '재처리 실패';
                    item.stageDetail = item.error;
                    if (captured.details) this.technicalErrorDetails = captured.details;
                    this.retryProgress.failed += 1;
                }
                this.retryProgress.completed += 1;
                this.queueRegistrationRecoverySave();
                await this.service.render();
            }
        } catch (error) {
            retryLoopError = this.captureError(error, '실패 항목 재시도를 계속할 수 없습니다.');
            this.analysisError = retryLoopError.message;
            if (retryLoopError.details) this.technicalErrorDetails = retryLoopError.details;
        } finally {
            this.metaRecognizing = this.batchItems.some((item: any) => (
                item && ['scanning', 'running'].includes(item.status)
            ));
            this.retryProgress.currentBatchIndex = -1;
            this.retryProgress.indeterminate = false;
            this.retryProgress.status = retryLoopError
                ? 'error'
                : (this.retryProgress.failed > 0 ? 'partial' : 'complete');
            this.retryProgress.stage = retryLoopError
                ? '재시도 중단'
                : (this.retryProgress.failed > 0 ? '일부 항목을 처리하지 못했습니다.' : '실패 항목 재시도를 마쳤습니다.');
            this.retryProgress.detail = retryLoopError
                ? retryLoopError.message
                : `${this.retryProgress.succeeded}개 성공 · ${this.retryProgress.failed}개 재실패`;
            this.analysisQueueFilter = 'all';
            this.analysisQueuePage = 1;
            await this.service.render();
        }

        const remaining = this.failedItemCount();
        if (reconnectedAnalysis > 0) {
            void this.monitorRecoveredAnalyses();
        }
        if (recoveredAnalysis > 0) {
            const firstRecovered = failedRows.find(
                (row: any) => row.item.status === 'complete'
            );
            if (firstRecovered) await this.selectBatchItem(firstRecovered.index);
            this.registerStep = 'upload';
        }
        if (remaining > 0) {
            this.analysisError = `${remaining}개 항목이 아직 실패 상태입니다. 오류 안내를 확인해주세요.`;
            const saveFailures = this.batchItems
                .map((item: any, index: number) => ({ item, index }))
                .filter((row: any) => (
                    row.item.status === 'error' && row.item.failureStage === 'save'
                ));
            if (saveFailures.length > 0) {
                const first = saveFailures[0];
                await this.openRegistrationSaveError(
                    first.item.errorInfo || {
                        message: first.item.error,
                        fileName: first.item.name,
                        retryable: true,
                    },
                    saveFailures.length === 1 ? first.index : -1,
                    saveFailures.length,
                );
            } else {
                const firstRemaining = this.batchItems.findIndex(
                    (item: any) => item.status === 'error'
                );
                if (firstRemaining >= 0) {
                    const inspectorIndex = this.analysisQueueIndexForBatchIndex(firstRemaining);
                    if (inspectorIndex !== null) {
                        await this.selectAnalysisInspector(inspectorIndex);
                    }
                }
            }
        } else if (this.batchItems.every((item: any) => item.status === 'saved')) {
            this.clearRegistrationRecovery();
            await this.service.modal.success('실패했던 자료를 모두 저장했습니다.');
            this.navigationBypass = true;
            this.service.href(this.libraryPath);
            return;
        } else {
            await this.service.modal.success(
                reconnectedAnalysis > 0
                    ? `${reconnectedAnalysis}개 서버 분석을 확인했으며 완료 여부를 자동으로 갱신합니다.`
                    : `${recoveredAnalysis}개 분석·${recoveredSave}개 저장을 복구했습니다.`
            );
        }
        this.persistRegistrationRecovery();
        await this.service.render();
    }

    private createProgressId() {
        const cryptoApi: any = window.crypto;
        if (cryptoApi && typeof cryptoApi.randomUUID === 'function') {
            return `${cryptoApi.randomUUID()}`.replace(/-/g, '').toLowerCase();
        }
        if (cryptoApi && typeof cryptoApi.getRandomValues === 'function') {
            const values = new Uint8Array(16);
            cryptoApi.getRandomValues(values);
            return Array.from(values).map((value: number) => value.toString(16).padStart(2, '0')).join('');
        }
        return Array.from({ length: 32 }, () => Math.floor(Math.random() * 16).toString(16)).join('');
    }

    private async reserveAnalysisSlot(item: any, progressId: string) {
        const query = new URLSearchParams({ mode: 'reserve', progress_id: progressId });
        for (let attempt = 0; attempt <= this.maxBackpressureRetries; attempt += 1) {
            const response = await fetch(`/wiz/api/portal.post.detail/analyze?${query.toString()}`, {
                method: 'POST', credentials: 'same-origin'
            });
            const payload = await response.json();
            if (payload && payload.code === 200) return;
            if (!payload || payload.code !== 429 || attempt >= this.maxBackpressureRetries) {
                throw (payload && payload.data)
                    || new Error('서버 분석 순서를 확보하지 못했습니다.');
            }
            await this.waitForAnalysisSlot(payload, item, attempt);
        }
    }

    private async waitForAnalysisSlot(payload: any, item: any, attempt: number) {
        const seconds = Math.max(1, Math.min(30, Number(payload && payload.data && payload.data.retry_after) || 5));
        item.status = 'queued';
        item.stageLabel = '서버 처리 순서 대기 중';
        item.stageDetail = `대용량 분석 동시 실행 수를 제한하고 있습니다. ${seconds}초 후 재시도 · ${attempt + 1}회`;
        await this.service.render();
        await this.service.sleep(seconds * 1000);
    }

    private requestJsonWithUploadProgress(
        url: string,
        form: FormData,
        onUploadProgress?: (ratio: number) => void,
    ): Promise<any> {
        return new Promise((resolve, reject) => {
            const request = new XMLHttpRequest();
            request.open('POST', url, true);
            request.withCredentials = true;
            request.upload.onprogress = (event: ProgressEvent) => {
                if (!onUploadProgress || !event.lengthComputable || event.total <= 0) return;
                onUploadProgress(Math.max(0, Math.min(1, event.loaded / event.total)));
            };
            request.onerror = () => reject(new Error('서버와 통신하지 못했습니다.'));
            request.onabort = () => reject(new Error('요청이 중단되었습니다.'));
            request.onload = () => {
                try {
                    resolve(JSON.parse(request.responseText || '{}'));
                } catch (_) {
                    reject(new Error('서버 응답 형식을 확인할 수 없습니다.'));
                }
            };
            request.send(form);
        });
    }

    private scheduleAnalysisProgressRender() {
        if (this.analysisProgressRenderTimer || this.recoveryDestroyed) return;
        this.analysisProgressRenderTimer = setTimeout(() => {
            this.analysisProgressRenderTimer = null;
            if (this.recoveryDestroyed) return;
            this.service.render();
        }, this.analysisProgressRenderIntervalMs);
    }

    private applyServerAnalysisProgress(item: any, progress: any) {
        if (!item || !progress || `${progress.status || ''}` === 'queued') return false;
        const rawPercent = Number(progress.percent);
        if (!Number.isFinite(rawPercent)) return false;
        const serverPercent = Math.max(
            0,
            Math.min(100, rawPercent),
        );
        item.progress = Math.max(
            this.safeNumber(item.progress, 0),
            Math.min(99, Math.round(30 + serverPercent * 0.7)),
        );
        item.stageLabel = progress.label || '서버 문서 분석 중';
        item.completedSteps = 2 + this.safeNumber(progress.completed_steps, 0);
        item.totalSteps = 11;
        item.stageDetail = progress.detail
            || `서버 분석 ${this.safeNumber(progress.completed_steps, 0)} / ${this.safeNumber(progress.total_steps, 9)}단계`;
        return true;
    }

    private startPipelineProgressPolling(progressId: string, onProgress: (progress: any) => void) {
        let active = true;
        const poll = async () => {
            while (active) {
                try {
                    const query = new URLSearchParams({ mode: 'progress', progress_id: progressId });
                    const response = await fetch(`/wiz/api/portal.post.detail/analyze?${query.toString()}`, {
                        method: 'POST', credentials: 'same-origin'
                    });
                    const payload = await response.json();
                    const progress = payload && payload.code === 200 && payload.data ? payload.data.progress : null;
                    if (active && progress) onProgress(progress);
                } catch (_) {
                    // The main request owns error reporting; a transient poll failure is retried.
                }
                if (!active) break;
                await new Promise((resolve) => setTimeout(resolve, 500));
            }
        };
        poll();
        return () => { active = false; };
    }

    private async recoverExistingAnalysis(
        progressId: string,
        resumeUnstarted: boolean = false,
        item: any = null,
    ) {
        const startedAt = Date.now();
        let progress: any = null;
        while (Date.now() - startedAt < this.recoveryTimeoutMs) {
            progress = await this.requestRegistrationRecoveryProgress(progressId);
            const status = `${progress.status || ''}`.toLowerCase();
            if (this.applyServerAnalysisProgress(item, progress)) {
                this.scheduleAnalysisProgressRender();
            }
            if (
                resumeUnstarted
                && ['queued', 'reserved'].includes(status)
                && !`${progress.updated || ''}`.trim()
            ) {
                return { resume_progress_id: progressId };
            }
            if (status === 'complete' && progress.analysis_id) {
                const response = await wiz.call('analyze', {
                    mode: 'registration_recovery',
                    analysis_ids: '[]',
                    progress_ids: JSON.stringify([progressId]),
                });
                const rows = response && response.code === 200 && response.data?.recovery
                    ? response.data.recovery.items || [] : [];
                const completed = rows.find((row: any) => row.analysis);
                return completed ? this.normaliseAnalysis(completed.analysis) : null;
            }
            if (!['running', 'processing', 'queued', 'reserved'].includes(status)) return null;
            await this.service.sleep(this.recoveryPollIntervalMs);
        }
        throw new Error(
            '기존 분석이 아직 처리 중입니다. 새 작업을 만들지 않고 기존 진행 상태를 계속 보존했습니다.'
        );
    }

    private registrationWorkspaceProgressRow(workspace: any, item: any) {
        const items = Array.isArray(workspace?.snapshot?.items)
            ? workspace.snapshot.items : [];
        const stagedSourceId = `${item?.stagedSourceId || ''}`;
        const sourceIndex = Number(item?.sourceIndex);
        return items.find((row: any) => {
            const rowSourceId = `${row?.source_id || row?.staged_source_id || ''}`;
            if (stagedSourceId) return rowSourceId === stagedSourceId;
            return Number.isInteger(sourceIndex)
                && sourceIndex >= 0
                && Number(row?.source_index) === sourceIndex;
        }) || null;
    }

    private async bindRegistrationWorkspaceProgress(item: any, progressId: string) {
        this.ensureRegistrationWorkspaceId();
        let lastError: any = null;
        for (let attempt = 0; attempt < 2; attempt += 1) {
            try {
                const result = await wiz.call('analyze', {
                    mode: 'registration_workspace_progress',
                    workspace_id: this.registrationWorkspaceId,
                    staged_source_id: `${item?.stagedSourceId || ''}`,
                    source_id: `${item?.stagedSourceId || ''}`,
                    progress_id: progressId,
                    source_index: Number(item?.sourceIndex ?? -1),
                    name: `${item?.name || ''}`,
                    source_url: `${item?.sourceUrl || ''}`,
                });
                if (
                    result
                    && result.code === 200
                    && result.data?.workspace
                    && `${result.data.workspace.workspace_id || ''}`
                        === this.registrationWorkspaceId
                    && /^[0-9a-f]{32}$/.test(`${result.data.progress_id || ''}`)
                ) {
                    this.applyRegistrationWorkspaceSummary(result.data.workspace);
                    return {
                        progressId: `${result.data.progress_id}`,
                        reused: result.data.reused === true,
                    };
                }
                lastError = result?.data || new Error(
                    '분석 진행 상태를 서버 작업공간에 연결하지 못했습니다.'
                );
            } catch (error) {
                lastError = error;
            }

            // A response can be lost after the durable bind. Reconcile only
            // this same workspace and source; never overwrite a newer snapshot.
            const latest = await this.latestRegistrationWorkspace();
            if (
                latest
                && `${latest.workspace_id || ''}` === this.registrationWorkspaceId
            ) {
                const persisted = this.registrationWorkspaceProgressRow(latest, item);
                const persistedProgressId = `${persisted?.progress_id || ''}`;
                if (/^[0-9a-f]{32}$/.test(persistedProgressId)) {
                    this.applyRegistrationWorkspaceSummary(latest);
                    return {
                        progressId: persistedProgressId,
                        reused: persistedProgressId !== progressId,
                    };
                }
            }
            if (attempt === 0) await this.service.sleep(150);
        }
        throw lastError || new Error(
            '분석 진행 상태를 서버 작업공간에 연결하지 못했습니다.'
        );
    }

    private async requestAnalysis(
        file: File | null,
        item: any,
        sourceUrl: string = '',
        resumeUnstarted: boolean = false,
    ) {
        const form = new FormData();
        const stagedSourceId = `${item?.stagedSourceId || ''}`;
        const uploadingFile = this.isNativeUploadFile(file) && !stagedSourceId;
        if (uploadingFile) form.append('file', file as File, (file as File).name);
        const existingProgressId = item.progressId || '';
        let resumeProgressId = '';
        if (existingProgressId) {
            const recovered = await this.recoverExistingAnalysis(
                existingProgressId,
                resumeUnstarted,
                item,
            );
            if (recovered && recovered.resume_progress_id) {
                resumeProgressId = existingProgressId;
            } else if (recovered) {
                return recovered;
            }
            // A terminal progress record can remain after its pending analysis
            // was registered and cleaned up. Reusing that ID preserves stale
            // analysis_id/request_hash fields and prevents a clean retry.
            if (!resumeProgressId) item.progressId = '';
        }
        const progressId = resumeProgressId || this.createProgressId();
        item.progressId = progressId;
        this.persistRegistrationRecovery();
        let progressBinding: any = null;
        try {
            progressBinding = await this.bindRegistrationWorkspaceProgress(
                item,
                progressId,
            );
        } catch (_) {
            item.progressId = '';
            this.persistRegistrationRecovery();
            throw new Error(
                '분석 진행 상태를 서버 작업공간에 저장하지 못해 분석을 시작하지 않았습니다.'
            );
        }
        const boundProgressId = `${progressBinding?.progressId || progressId}`;
        item.progressId = boundProgressId;
        this.persistRegistrationRecovery();
        if (boundProgressId !== progressId || progressBinding?.reused === true) {
            const recovered = await this.recoverExistingAnalysis(
                boundProgressId,
                true,
                item,
            );
            if (recovered && !recovered.resume_progress_id) return recovered;
        }
        if (this.analysisCancellationRequested) {
            item.progressId = '';
            this.persistRegistrationRecovery();
            await this.saveRegistrationWorkspace(true);
            throw new Error('사용자가 이 등록 작업을 취소했습니다.');
        }
        const query = new URLSearchParams({ source_type: this.uploadSourceType, progress_id: boundProgressId });
        if (this.registrationWorkspaceId) query.set('workspace_id', this.registrationWorkspaceId);
        if (stagedSourceId) {
            query.set('staged_source_id', stagedSourceId);
            query.set('source_id', stagedSourceId);
        }
        if (item.requestedProfile) query.set('document_profile', item.requestedProfile);
        if (this.uploadSourceType === 'url') query.set('url', sourceUrl);
        if (item.preflightHash) {
            query.set('original_hash', `${item.preflightHash || ''}`);
            query.set(
                'claim_token',
                `${item.preflightClaimToken || boundProgressId}`,
            );
        }
        if (`${item.duplicateOverrideReason || ''}`.trim()) {
            query.set(
                'override_reason',
                `${item.duplicateOverrideReason || ''}`.trim(),
            );
        }
        if (`${item.duplicateOverrideDocumentId || ''}`.trim()) {
            query.set(
                'override_document_id',
                `${item.duplicateOverrideDocumentId || ''}`.trim(),
            );
        }
        await this.reserveAnalysisSlot(item, boundProgressId);
        const stopPolling = this.startPipelineProgressPolling(boundProgressId, (progress: any) => {
            if (this.applyServerAnalysisProgress(item, progress)) {
                this.scheduleAnalysisProgressRender();
            }
        });
        let payload: any;
        try {
            payload = await this.requestJsonWithUploadProgress(
                `/wiz/api/portal.post.detail/analyze?${query.toString()}`,
                form,
                (ratio: number) => {
                    item.progress = Math.max(item.progress, Math.round(20 + ratio * 10));
                    item.stageLabel = ratio >= 1
                        ? '원문 전송 완료 · 서버 분석 시작 대기 중'
                        : '분석용 원문 전송 중';
                    item.stageDetail = uploadingFile
                        ? `${Math.round(ratio * 100)}% 바이트 전송 완료`
                        : stagedSourceId
                            ? '서버에 보존된 원본으로 분석을 시작합니다.'
                            : '원격 원문을 서버에서 내려받고 있습니다.';
                    this.scheduleAnalysisProgressRender();
                }
            );
        } finally {
            stopPolling();
        }
        if (!payload || payload.code !== 200) {
            const failure = payload && payload.data ? payload.data : null;
            const failureCode = `${
                failure?.error_code || failure?.errorCode || ''
            }`.toUpperCase();
            if (failureCode === 'OPERATION_IN_PROGRESS' && boundProgressId) {
                const recoveryProgressId = `${
                    failure?.existing_progress_id || ''
                }`.trim().toLowerCase();
                if (!/^[0-9a-f]{32}$/.test(recoveryProgressId)) {
                    // The rejected request id is not proof of the active
                    // operation. Clear it so recovery never polls or restarts
                    // the wrong pipeline while preserving the staged source.
                    item.progressId = '';
                    this.persistRegistrationRecovery();
                    await this.saveRegistrationWorkspace(true);
                    throw failure || new Error(
                        '기존 분석 작업 ID를 확인할 수 없어 안전하게 재연결하지 않았습니다.'
                    );
                }
                item.progressId = recoveryProgressId;
                this.persistRegistrationRecovery();
                const reconnectSaved = await this.saveRegistrationWorkspace(true);
                if (!reconnectSaved) {
                    throw new Error(
                        '기존 분석 작업 ID를 서버 작업공간에 저장하지 못해 재연결을 중단했습니다.'
                    );
                }
                try {
                    const recovered = await this.recoverExistingAnalysis(
                        recoveryProgressId,
                        false,
                        item,
                    );
                    if (recovered) return recovered;
                } catch (_) {
                    // Keep the server-owned progress id in the recovery snapshot.
                    // The row remains an analysis conflict, never a source loss.
                }
            }
            throw (payload && payload.data)
                || new Error('문서 처리에 실패했습니다.');
        }
        const analysis = payload.data && payload.data.analysis ? payload.data.analysis : null;
        if (!analysis || !analysis.id) throw new Error('문서 분석 결과를 확인할 수 없습니다.');
        return this.normaliseAnalysis(analysis);
    }

    private async requestSecurityScan(file: File | null, item: any, sourceUrl: string = '') {
        const progressId = this.createProgressId();
        item.securityProgressId = progressId;
        await this.reserveAnalysisSlot(item, progressId);
        const query = new URLSearchParams({ mode: 'security_scan', source_type: this.uploadSourceType, progress_id: progressId });
        const stagedSourceId = `${item?.stagedSourceId || ''}`;
        const uploadingFile = this.isNativeUploadFile(file) && !stagedSourceId;
        if (this.registrationWorkspaceId) query.set('workspace_id', this.registrationWorkspaceId);
        if (stagedSourceId) {
            query.set('staged_source_id', stagedSourceId);
            query.set('source_id', stagedSourceId);
        }
        if (this.uploadSourceType === 'url') query.set('url', sourceUrl);
        if (uploadingFile || stagedSourceId) {
            query.set('original_hash', `${item.preflightHash || ''}`);
            query.set('claim_token', `${item.preflightClaimToken || ''}`);
        }
        const form = new FormData();
        if (uploadingFile) form.append('file', file as File, (file as File).name);
        if (`${item.duplicateOverrideReason || ''}`.trim()) {
            query.set(
                'override_reason',
                `${item.duplicateOverrideReason || ''}`.trim(),
            );
        }
        if (`${item.duplicateOverrideDocumentId || ''}`.trim()) {
            query.set(
                'override_document_id',
                `${item.duplicateOverrideDocumentId || ''}`.trim(),
            );
        }
        const payload = await this.requestJsonWithUploadProgress(
            `/wiz/api/portal.post.detail/analyze?${query.toString()}`,
            form,
            (ratio: number) => {
                item.progress = Math.max(item.progress, Math.round(ratio * 10));
                item.stageLabel = ratio >= 1 ? '바이러스·악성코드 검사 중' : '보안 검사용 원문 전송 중';
                item.stageDetail = uploadingFile
                    ? `${Math.round(ratio * 100)}% 바이트 전송 완료`
                    : stagedSourceId
                        ? '서버에 보존된 원본을 검사하고 있습니다.'
                        : '원격 원문을 안전하게 내려받고 있습니다.';
                this.scheduleAnalysisProgressRender();
            }
        );
        if (!payload || payload.code !== 200) {
            throw (payload && payload.data)
                || new Error('바이러스·악성코드 검사에 실패했습니다.');
        }
        item.securityProgressId = '';
        const security = payload.data && payload.data.security ? payload.data.security : null;
        if (!security || !security.report || security.report.status !== 'clean') {
            throw new Error('파일 보안 검사 결과를 확인할 수 없습니다.');
        }
        const securityDuplicate = this.normaliseDuplicatePayload(
            security.duplicate,
        );
        const confirmedTarget = `${item?.duplicateOverrideDocumentId || ''}`;
        const overrideMatchesDuplicate = !!(
            securityDuplicate
            && this.aiSettingsAdmin
            && item?.duplicateOverrideSelected
            && item?.duplicateOverrideConfirmed
            && this.duplicateOverrideReasonValid(item)
            && confirmedTarget
            && (
                !securityDuplicate.post_id
                || confirmedTarget === `${securityDuplicate.post_id || ''}`
            )
        );
        if (securityDuplicate && !overrideMatchesDuplicate) {
            throw {
                stage: 'duplicate',
                field: uploadingFile || stagedSourceId ? 'file' : 'source_url',
                error_code: 'DUPLICATE_MATERIAL',
                message: '동일한 원문 자료가 이미 등록되어 있습니다.',
                user_action: this.aiSettingsAdmin
                    ? '기존 자료를 확인하거나 새 버전 등록 체크박스를 선택해주세요.'
                    : '기존 자료를 확인하고 이번 등록에서 제외해주세요.',
                retryable: false,
                duplicate: securityDuplicate,
            };
        }
        if (security.original_hash) {
            item.preflightHash = `${security.original_hash}`;
        }
        if (security.claim_token) {
            item.preflightClaimToken = `${security.claim_token}`;
        }
        item.progress = Math.max(item.progress, 20);
        item.completedSteps = 2;
        item.stageLabel = '보안 검사 통과';
        item.stageDetail = security.report.protection_level === 'full'
            ? 'ClamAV 및 기본 보안 검사를 통과했습니다.'
            : '기본 파일 구조 보안 검사를 통과했습니다.';
        return {
            ...security.report,
            original_hash: `${security.original_hash || ''}`,
            claim_token: `${security.claim_token || ''}`,
            duplicate: securityDuplicate,
        };
    }

    private normaliseAnalysis(value: any) {
        const analysis = value && typeof value === 'object' ? value : {};
        const source = analysis.source && typeof analysis.source === 'object' ? analysis.source : {};
        const ocr = analysis.ocr && typeof analysis.ocr === 'object' ? analysis.ocr : {};
        const rawStats = analysis.stats && typeof analysis.stats === 'object' ? analysis.stats : {};
        const rawMetadata = analysis.metadata && analysis.metadata.fields
            ? analysis.metadata.fields
            : (analysis.metadata && typeof analysis.metadata === 'object' ? analysis.metadata : {});
        const metadata: any = {};
        const metadataValue = (name: string, fallback: any) => {
            const value = rawMetadata[name];
            if (value && typeof value === 'object' && !Array.isArray(value) && typeof value.value !== 'undefined') {
                return value.value;
            }
            return typeof value === 'undefined' ? fallback : value;
        };
        const fieldDefaults: any = {
            title: metadataValue('title', analysis.title || ''),
            category: metadataValue('category', analysis.category || '기타'),
            authors: metadataValue('authors', Array.isArray(analysis.authors) ? analysis.authors : []),
            publisher: metadataValue('publisher', analysis.publisher || ''),
            date: metadataValue('date', analysis.date || ''),
            era: metadataValue('era', analysis.era || ''),
            keywords: metadataValue('keywords', Array.isArray(analysis.keywords) ? analysis.keywords : []),
            language: metadataValue('language', analysis.language || ''),
            summary: metadataValue('summary', analysis.summary || ''),
        };
        Object.keys(fieldDefaults).forEach((name: string) => {
            const field = rawMetadata[name] && typeof rawMetadata[name] === 'object' && !Array.isArray(rawMetadata[name])
                ? rawMetadata[name]
                : {};
            const confidence = field.confidence === null || typeof field.confidence === 'undefined'
                ? null
                : Number(field.confidence);
            metadata[name] = {
                ...field,
                value: typeof field.value === 'undefined' ? fieldDefaults[name] : field.value,
                confidence: confidence !== null && Number.isFinite(confidence) ? confidence : null,
            };
        });
        const documentText = analysis.document && typeof analysis.document.text === 'string'
            ? analysis.document.text
            : '';
        const text = [ocr.text, analysis.text, documentText, analysis.text_preview]
            .find((row: any) => typeof row === 'string' && row.trim()) || '';
        const reviewTasks = Array.isArray(analysis.review_tasks)
            ? analysis.review_tasks.map((task: any) => ({ ...task }))
            : [];
        const detectedForeignLanguages: string[] = [];
        if (/[\u3400-\u4dbf\u4e00-\u9fff\uf900-\ufaff]/.test(text)) {
            detectedForeignLanguages.push('hanja');
        }
        if (/[\u3040-\u30ff\u31f0-\u31ff]/.test(text)) {
            detectedForeignLanguages.push('japanese');
        }
        if (/\b[A-Za-z]{2,}\b/.test(text)) {
            detectedForeignLanguages.push('english');
        }
        if (detectedForeignLanguages.length) {
            const multilingualSource = analysis.multilingual && typeof analysis.multilingual === 'object'
                ? analysis.multilingual : {};
            const multilingualRows = [
                ...(Array.isArray(multilingualSource.segments) ? multilingualSource.segments : []),
                ...(Array.isArray(multilingualSource.pages) ? multilingualSource.pages : []),
            ];
            const fallbackStatus = multilingualRows.length ? 'review_required' : 'pending';
            const labels: any = { hanja: '한자', japanese: '일본어', english: '영어' };
            const reason = `${detectedForeignLanguages.map((key: string) => labels[key]).join('·')} 구간이 있어 한국어 번역 ${multilingualRows.length ? '결과를 확인해야 합니다.' : '처리가 필요합니다.'}`;
            const multilingualTaskIndex = reviewTasks.findIndex(
                (task: any) => `${task && task.key ? task.key : ''}` === 'multilingual_translation'
            );
            const existingTask = multilingualTaskIndex >= 0 ? reviewTasks[multilingualTaskIndex] : {};
            if (multilingualTaskIndex < 0 || `${existingTask.status || ''}` === 'not_applicable') {
                const repairedTask = {
                    ...existingTask,
                    key: 'multilingual_translation',
                    label: existingTask.label || '한자·일본어·영어 구간의 한국어 번역 검수',
                    description: existingTask.description || '외국어 구간과 한국어 번역 결과를 확인합니다.',
                    status: fallbackStatus,
                    status_label: fallbackStatus === 'pending' ? '대기' : '검토 필요',
                    applicable: true,
                    reason,
                    empty_reason: '',
                    review_keys: ['translated_text'],
                    evidence: {
                        ...(existingTask.evidence || {}),
                        detected: detectedForeignLanguages,
                    },
                };
                if (multilingualTaskIndex >= 0) reviewTasks[multilingualTaskIndex] = repairedTask;
                else reviewTasks.push(repairedTask);
            }
        }
        const chunks = Array.isArray(analysis.chunks) ? analysis.chunks : [];
        const firstEmbedding = chunks.length && Array.isArray(chunks[0].embedding) ? chunks[0].embedding : [];
        const models = analysis.models && typeof analysis.models === 'object' ? analysis.models : {};
        const rawLayout = analysis.layout && typeof analysis.layout === 'object' ? analysis.layout : {};
        const multilingual = this.normaliseMultilingual(analysis.multilingual);
        const layoutTextMarkers = Array.isArray(rawLayout.text_markers) ? rawLayout.text_markers : [];
        const markerOffsets: any = {};
        layoutTextMarkers.forEach((marker: any) => {
            if (marker && marker.region_id) markerOffsets[marker.region_id] = this.safeNumber(marker.char_offset, -1);
        });
        const layoutRegions = Array.isArray(rawLayout.regions) ? rawLayout.regions.map((region: any) => ({
            ...region,
            marker_offset: typeof region.marker_offset !== 'undefined'
                ? this.safeNumber(region.marker_offset, -1)
                : (typeof markerOffsets[region.id] !== 'undefined' ? markerOffsets[region.id] : -1),
            bbox: region && region.bbox && typeof region.bbox === 'object' ? region.bbox : {},
            normalized_bbox: region && region.normalized_bbox && typeof region.normalized_bbox === 'object'
                ? region.normalized_bbox
                : {},
        })) : [];
        const rawLayoutSummary = rawLayout.summary && typeof rawLayout.summary === 'object' ? rawLayout.summary : {};
        const format = this.inferSourceFormat(source);
        const duplicate = this.normaliseDuplicatePayload(analysis.duplicate) || {
            found: false,
        };
        return {
            ...analysis,
            title: metadata.title.value || '',
            category: metadata.category.value || '기타',
            summary: metadata.summary.value || '',
            authors: Array.isArray(metadata.authors.value) ? metadata.authors.value : [],
            publisher: metadata.publisher.value || '',
            date: metadata.date.value || '',
            era: this.normaliseEraValue(metadata.era.value || ''),
            keywords: Array.isArray(metadata.keywords.value) ? metadata.keywords.value : [],
            language: metadata.language.value || '',
            metadata_confidence_target: this.safeConfidence(
                analysis.metadata_confidence_target,
                this.aiSettings && typeof this.aiSettings.metadata_confidence_threshold !== 'undefined'
                    ? this.aiSettings.metadata_confidence_threshold
                    : 0.75
            ),
            source: {
                ...source,
                name: source.name || this.uploadFileName || '선택 자료',
                format,
                kind: source.kind || format,
            },
            duplicate,
            ocr: {
                ...ocr,
                text,
                words: Array.isArray(ocr.words) ? ocr.words : [],
                characters: Array.isArray(ocr.characters) ? ocr.characters : [],
            },
            metadata,
            xml_field_review: analysis.xml_field_review && typeof analysis.xml_field_review === 'object'
                ? JSON.parse(JSON.stringify(analysis.xml_field_review)) : {},
            document_profile: analysis.document_profile && typeof analysis.document_profile === 'object'
                ? analysis.document_profile : {},
            profile_fields: analysis.profile_fields && typeof analysis.profile_fields === 'object'
                ? JSON.parse(JSON.stringify(analysis.profile_fields)) : {},
            review_tasks: reviewTasks,
            multilingual,
            layout: {
                ...rawLayout,
                regions: layoutRegions,
                text_markers: layoutTextMarkers,
                warnings: Array.isArray(rawLayout.warnings) ? rawLayout.warnings : [],
                text_with_markers: typeof rawLayout.text_with_markers === 'string' ? rawLayout.text_with_markers : text,
                summary: {
                    ...rawLayoutSummary,
                    pages_total: this.safeNumber(rawLayoutSummary.pages_total, rawLayoutSummary.pages_analyzed || 0),
                    pages_analyzed: this.safeNumber(rawLayoutSummary.pages_analyzed, 0),
                    page_limit: this.safeNumber(rawLayoutSummary.page_limit, rawLayoutSummary.pages_analyzed || 0),
                    analysis_limited: !!rawLayoutSummary.analysis_limited,
                    region_count: this.safeNumber(rawLayoutSummary.region_count, layoutRegions.length),
                    coordinate_count: this.safeNumber(rawLayoutSummary.coordinate_count, layoutRegions.length),
                    table_count: this.safeNumber(
                        rawLayoutSummary.table_count,
                        layoutRegions.filter((row: any) => row.type === 'table').length
                    ),
                    figure_count: this.safeNumber(
                        rawLayoutSummary.figure_count,
                        layoutRegions.filter((row: any) => row.type === 'figure').length
                    ),
                    embedded_image_count: this.safeNumber(
                        rawLayoutSummary.embedded_image_count,
                        layoutRegions.filter((row: any) => row.detector === 'pdf-embedded-image').length
                    ),
                    rendered_figure_count: this.safeNumber(
                        rawLayoutSummary.rendered_figure_count,
                        layoutRegions.filter((row: any) => row.type === 'figure' && row.detector !== 'pdf-embedded-image').length
                    ),
                    image_pages_scanned: this.safeNumber(
                        rawLayoutSummary.image_pages_scanned,
                        rawLayoutSummary.pages_analyzed || 0
                    ),
                    direct_image_scan_complete: typeof rawLayoutSummary.embedded_image_count !== 'undefined',
                    annotation_count: this.safeNumber(
                        rawLayoutSummary.annotation_count,
                        layoutRegions.filter((row: any) => row.type === 'annotation').length
                    ),
                    extracted_image_count: this.safeNumber(
                        rawLayoutSummary.extracted_image_count,
                        layoutRegions.filter((row: any) => !!row.image).length
                    ),
                    structured_table_count: this.safeNumber(
                        rawLayoutSummary.structured_table_count,
                        layoutRegions.filter((row: any) => row.table && Array.isArray(row.table.rows) && row.table.rows.length > 0).length
                    ),
                    extracted_content_count: this.safeNumber(
                        rawLayoutSummary.extracted_content_count,
                        layoutRegions.filter((row: any) => !!row.image || !!row.text || !!row.caption).length
                    ),
                    marker_count: this.safeNumber(rawLayoutSummary.marker_count, layoutTextMarkers.length),
                },
            },
            stats: {
                ...rawStats,
                text_length: this.safeNumber(rawStats.text_length, text.length),
                chunk_count: this.safeNumber(rawStats.chunk_count, chunks.length),
                embedding_dimension: this.safeNumber(
                    rawStats.embedding_dimension,
                    this.safeNumber(models.embedding_dimension, firstEmbedding.length)
                ),
                embedding_model: rawStats.embedding_model || models.embedding || '',
            },
        };
    }

    private inferSourceFormat(source: any) {
        const probeFormat = `${source && source.probe ? source.probe.actual_format || '' : ''}`.trim().toLowerCase();
        if (probeFormat && !['do', 'action', 'jsp', 'php', 'aspx'].includes(probeFormat)) {
            return probeFormat;
        }
        const explicit = `${source && (source.format || source.kind) ? (source.format || source.kind) : ''}`.trim();
        if (explicit && !['do', 'action', 'jsp', 'php', 'aspx'].includes(explicit.toLowerCase())) {
            return explicit.toLowerCase();
        }
        const name = `${source && source.name ? source.name : this.uploadFileName || ''}`.split(/[?#]/)[0];
        const extensionMatch = name.match(/\.([a-z0-9]{1,8})$/i);
        if (extensionMatch && !['do', 'action', 'jsp', 'php', 'aspx'].includes(extensionMatch[1].toLowerCase())) {
            return extensionMatch[1].toLowerCase();
        }
        const mime = `${source && source.mime_type ? source.mime_type : ''}`.split(';')[0].trim().toLowerCase();
        const mimeMap: any = {
            'application/pdf': 'pdf',
            'application/xml': 'xml',
            'text/xml': 'xml',
            'text/html': 'html',
            'application/json': 'json',
        };
        if (mimeMap[mime]) return mimeMap[mime];
        return mime.includes('/') ? mime.split('/')[1].split('+')[0] : '';
    }

    private sourceScheme(value: string) {
        try {
            return value ? new URL(value).hostname : '';
        } catch (_error) {
            return '';
        }
    }

    public provenanceLabel(value?: string) {
        const key = value || (this.data && this.data.provenance_type) || (this.uploadSourceType === 'url' ? 'external_crawl' : 'direct_upload');
        const found = this.provenanceTypeOptions.find((row: any) => row.value === key);
        return found ? found.label : '기타';
    }

    private safeNumber(value: any, fallback: number = 0) {
        const parsed = Number(value);
        return Number.isFinite(parsed) && parsed >= 0 ? parsed : fallback;
    }

    private safeConfidence(value: any, fallback: number = 0.75) {
        const parsed = Number(value);
        if (!Number.isFinite(parsed)) return fallback;
        return Math.max(0, Math.min(1, parsed));
    }

    private normaliseDuplicatePayload(value: any, errorCode: string = '') {
        const source = value && typeof value === 'object' ? value : {};
        const existing = source.existing && typeof source.existing === 'object'
            ? source.existing : {};
        const status = `${source.status || ''}`.trim().toLowerCase();
        const postId = `${
            source.post_id
            || source.document_id
            || existing.document_id
            || ''
        }`.trim();
        const found = source.found === true
            || ['registered', 'deleted'].includes(status)
            || !!postId
            || `${errorCode || ''}`.trim().toUpperCase() === 'DUPLICATE_MATERIAL';
        if (!found) return null;
        const restricted = typeof source.restricted === 'boolean'
            ? source.restricted : !postId;
        return {
            ...source,
            found: true,
            post_id: postId,
            title: `${source.title || existing.title || ''}`.trim(),
            status: `${source.status || existing.status || (restricted ? 'restricted' : 'registered')}`,
            restricted,
            message: `${
                source.message || '동일한 원문 자료가 이미 등록되어 있습니다.'
            }`,
        };
    }

    private registrationErrorExplanation(errorCode: string, stage: string, raw: string) {
        const code = `${errorCode || ''}`.trim().toUpperCase();
        const lower = `${raw || ''}`.toLowerCase();
        if (/timeout|timed out|시간 초과/.test(lower)) {
            return {
                cause: '등록 서버가 제한 시간 안에 저장 완료 응답을 보내지 못했습니다.',
                prevention: '완료 기록을 확인한 뒤 아직 저장되지 않은 파일의 작은 초안 참조만 다시 전송합니다.',
            };
        }
        if (/network|failed to fetch|통신하지 못|connection|연결/.test(lower)) {
            return {
                cause: '브라우저와 등록 서버의 연결이 저장 완료 전에 끊겼습니다.',
                prevention: '동일 작업 키로 서버 완료 여부를 확인하고 실패한 파일의 저장 단계만 다시 연결합니다.',
            };
        }
        const known: any = {
            STORAGE_SAVE_FAILED: {
                cause: '기존 등록 방식이 대형 검수 데이터를 다시 전송하는 동안 첫 저장 완료 기록이 만들어지기 전에 요청이 중단됐습니다.',
                prevention: '신규 등록과 재시도에서 전체 검수 데이터를 다시 보내지 않고, 서버에 저장된 초안의 ID·revision·원본 체크섬만 전송합니다.',
            },
            MYSQL_UNAVAILABLE: {
                cause: '자료 메타데이터를 기록하는 데이터베이스 연결 또는 쓰기 확인이 완료되지 않았습니다.',
                prevention: '완료 기록과 동일 작업 키를 확인해 중복 생성을 막고 실패한 파일만 다시 저장합니다.',
            },
            REVISION_CONFLICT: {
                cause: '사전검증 뒤 검수 초안이 변경되어 확인한 버전과 저장할 버전이 달라졌습니다.',
                prevention: '정확히 검증한 초안 revision과 원본 체크섬이 모두 일치할 때만 저장합니다.',
            },
            REGISTRATION_DRAFT_REFERENCE_MISSING: {
                cause: '검수 초안의 서버 저장 ID·revision·원본 체크섬 중 하나가 준비되지 않았습니다.',
                prevention: '대용량 전체 데이터로 우회하지 않고 등록을 중단한 뒤 초안을 다시 저장·검증합니다.',
            },
            REGISTRATION_DRAFT_SAVE_FAILED: {
                cause: '최종 등록 전에 검수 초안을 서버에 저장하지 못해 검증할 정확한 버전이 없습니다.',
                prevention: '오래된 초안을 검증하거나 전체 데이터를 우회 전송하지 않고 등록 시작 전에 차단합니다.',
            },
        };
        if (known[code]) return known[code];
        return {
            cause: stage
                ? `${this.registrationErrorStageLabel(stage)} 단계가 완료되기 전에 요청이 중단되었습니다.`
                : '등록 서버가 원인 정보를 보내기 전에 요청이 중단되었습니다.',
            prevention: '입력값과 검수 결과를 보존하고, 성공한 파일은 건드리지 않은 채 실패한 파일만 다시 처리합니다.',
        };
    }

    private captureError(error: any, fallback: string) {
        console.error('[WIZ][portal.post.detail] 처리 오류', error, { fallback });
        const candidate = error && error.data && typeof error.data === 'object'
            ? error.data : (error && typeof error === 'object' ? error : {});
        const errorCode = `${candidate.error_code || candidate.errorCode || ''}`.trim();
        const requestId = `${candidate.request_id || candidate.requestId || ''}`.trim();
        const userAction = `${candidate.user_action || candidate.userAction || ''}`.trim();
        const suppliedCause = `${candidate.cause || ''}`.trim();
        const suppliedPrevention = `${candidate.prevention || ''}`.trim();
        const stage = `${candidate.stage || ''}`.trim();
        const field = `${candidate.field || ''}`.trim();
        const fileName = `${candidate.file_name || candidate.fileName || ''}`.trim();
        const rawExistingProgressId = `${
            candidate.existing_progress_id || candidate.existingProgressId || ''
        }`.trim().toLowerCase();
        const existingProgressId = /^[0-9a-f]{32}$/.test(rawExistingProgressId)
            ? rawExistingProgressId : '';
        const sourceProbe = candidate.source_probe && typeof candidate.source_probe === 'object'
            ? candidate.source_probe : {};
        const duplicate = this.normaliseDuplicatePayload(
            candidate.duplicate,
            errorCode,
        );
        let raw = '';
        if (candidate && typeof candidate.message === 'string') raw = candidate.message;
        else if (typeof error === 'string') raw = error;
        else if (error && typeof error.message === 'string') raw = error.message;
        raw = `${raw || ''}`.trim();
        const lower = raw.toLowerCase();
        let message = errorCode && raw ? raw : fallback;
        if (!errorCode) {
            if (/json_invalid|invalid json|eof while parsing|validation error|pydantic/.test(lower)) {
                message = 'AI 분석 응답이 완전하지 않습니다. 실패한 파일만 다시 처리해주세요.';
            } else if (/timeout|timed out|시간 초과/.test(lower)) {
                message = '처리 시간이 초과되었습니다. 잠시 후 실패한 항목만 다시 시도해주세요.';
            } else if (/network|failed to fetch|통신하지 못|connection/.test(lower)) {
                message = '서버 연결이 불안정합니다. 연결을 확인한 뒤 다시 시도해주세요.';
            } else if (/429|too many|처리 순서|slot/.test(lower)) {
                message = '현재 분석 요청이 많습니다. 잠시 후 실패한 항목만 다시 시도해주세요.';
            } else if (
                raw
                && raw.length <= 240
                && !/traceback|stack|authorization|bearer|api[_ -]?key|password|secret|token|file "\/.+line \d+|(?:\/[^\s]+){2,}/i.test(raw)
            ) {
                message = raw;
            }
        }
        const explanation = this.registrationErrorExplanation(errorCode, stage, raw);
        return {
            message,
            cause: suppliedCause || explanation.cause,
            prevention: suppliedPrevention || explanation.prevention,
            details: requestId ? `요청 ID: ${requestId}` : '',
            stage,
            fileName,
            field,
            errorCode,
            userAction,
            retryable: typeof candidate.retryable === 'boolean'
                ? candidate.retryable : true,
            requestId,
            existingProgressId,
            sourceProbe,
            duplicate,
        };
    }

    private async openRegistrationSaveError(
        captured: any,
        targetIndex: number = -1,
        failedCount: number = 1,
    ) {
        const item = targetIndex >= 0 ? this.batchItems[targetIndex] : null;
        const normalized = captured && typeof captured === 'object'
            ? captured : this.captureError(captured, '자료 저장에 실패했습니다.');
        this.registrationSaveError = {
            title: failedCount > 1
                ? `${failedCount}개 파일을 자료함에 저장하지 못했습니다`
                : '자료함 저장을 완료하지 못했습니다',
            message: normalized.message || '자료 저장에 실패했습니다.',
            cause: normalized.cause
                || '등록 저장 단계가 완료되기 전에 요청이 중단되었습니다.',
            prevention: normalized.prevention
                || '검수 내용을 보존하고 실패한 파일의 저장 단계만 다시 실행합니다.',
            errorCode: normalized.errorCode || '',
            stage: normalized.stage || 'storage',
            userAction: normalized.userAction
                || '검수 내용은 유지됩니다. 실패한 파일의 저장만 다시 시도해주세요.',
            fileName: normalized.fileName
                || item?.name || this.reviewFileName(item) || '',
            requestId: normalized.requestId || '',
            retryable: normalized.retryable !== false,
            targetIndex,
            failedCount: Math.max(1, failedCount),
        };
        this.registrationSaveErrorOpen = true;
        await this.service.render();
    }

    public async closeRegistrationSaveError() {
        if (this.registrationSaveRetrying) return;
        this.registrationSaveErrorOpen = false;
        await this.service.render();
    }

    public async retryRegistrationSaveFromDialog() {
        if (this.registrationSaveRetrying || !this.registrationSaveError?.retryable) return;
        const targetIndex = Number(this.registrationSaveError?.targetIndex);
        this.registrationSaveRetrying = true;
        this.registrationSaveErrorOpen = false;
        await this.service.render();
        try {
            await this.retryFailedItems(
                Number.isInteger(targetIndex) && targetIndex >= 0
                    ? targetIndex : undefined
            );
        } finally {
            this.registrationSaveRetrying = false;
            await this.service.render();
        }
    }

    private parseSavedReviewTimestamp(value: string) {
        const trimmed = `${value || ''}`.trim();
        const normalised = trimmed.includes('T')
            ? trimmed : trimmed.replace(' ', 'T');
        const zoned = /(?:Z|[+-]\d{2}:?\d{2})$/i.test(normalised)
            ? normalised : `${normalised}Z`;
        return new Date(zoned);
    }

    private formatAutoSaveTime(date: Date = new Date()) {
        if (Number.isNaN(date.getTime())) return '';
        return new Intl.DateTimeFormat('ko-KR', {
            timeZone: 'Asia/Seoul',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hourCycle: 'h23',
        }).format(date);
    }

    public autoSaveStatusLabel() {
        if (this.autoSaveState === 'saved' && this.autoSaveSavedAt) {
            return `${this.autoSaveMessage} · ${this.autoSaveSavedAt}`;
        }
        return this.autoSaveMessage;
    }

    public autoSaveStatusClass() {
        return 'is-' + this.autoSaveState;
    }

    public async toggleTechnicalErrorDetails() {
        this.technicalErrorOpen = !this.technicalErrorOpen;
        await this.service.render();
    }

    public async showBatchErrorDetails(index: number) {
        const item = this.batchItems[index];
        if (!item || item.status !== 'error') return;
        this.analysisError = item.error || '해당 파일 처리에 실패했습니다.';
        this.technicalErrorDetails = item.errorDetails || '';
        this.technicalErrorOpen = false;
        await this.service.render();
    }

    private commonMetadataDefinitions() {
        return [
            { id: 'title', label: '자료명', repeatable: false },
            { id: 'authors', label: '저자·편찬자', repeatable: true },
            { id: 'publisher', label: '발행처', repeatable: false },
            { id: 'created_dates', label: '작성연대', repeatable: true },
            { id: 'issued_dates', label: '발행연대', repeatable: true },
            { id: 'era', label: '시대', repeatable: false },
            { id: 'category', label: '자료 유형', repeatable: false },
            { id: 'keywords', label: '색인어·키워드', repeatable: true },
            { id: 'language', label: '언어', repeatable: false },
            { id: 'summary', label: '요약', repeatable: false },
        ];
    }

    private commonMetadataValue(analysis: any, fieldId: string) {
        const aliases: any = {
            title: analysis?.title,
            authors: analysis?.authors,
            publisher: analysis?.publisher,
            created_dates: analysis?.created_dates,
            issued_dates: analysis?.issued_dates,
            era: analysis?.era,
            category: analysis?.category,
            keywords: analysis?.keywords,
            language: analysis?.language || analysis?.document?.language,
            summary: analysis?.summary,
        };
        let value = fieldId === 'era'
            ? this.normaliseEraValue(aliases[fieldId])
            : aliases[fieldId];
        if (
            fieldId === 'issued_dates'
            && !this.normaliseDateValues(value).length
            && analysis?.date
        ) value = [analysis.date];
        const rows = Array.isArray(value) ? value : [value];
        return rows.map((row: any) => `${row || ''}`.trim()).filter(Boolean);
    }

    private normaliseDateValues(value: any) {
        const rows = Array.isArray(value) ? value : [value];
        return rows
            .map((row: any) => `${row || ''}`.trim())
            .filter((row: string, index: number, values: string[]) => (
                !!row && values.indexOf(row) === index
            ))
            .slice(0, 20);
    }

    public dateValuesText(value: any) {
        return this.normaliseDateValues(value).join(' · ') || '-';
    }

    public normaliseEraValue(value: any) {
        const raw = `${value || ''}`.trim();
        if (!raw || this.eraOptions.includes(raw)) return raw;
        const compact = raw.replace(/\s+/g, '');
        const aliases: any = {
            선사시대: '선사', 고대사: '고대', 고려시대: '고려',
            조선시대: '조선', 근대사: '근대', 현대사: '현대', 통사자료: '통사',
        };
        if (aliases[compact]) return aliases[compact];
        return this.eraOptions.slice(0, -1).find(
            (option: string) => compact.includes(option)
        ) || '기타';
    }

    public eraSelectionValue(field: any, value: any) {
        if (
            field && Object.prototype.hasOwnProperty.call(field, 'era_code')
        ) {
            const explicit = `${field.era_code || ''}`.trim();
            return this.eraOptions.includes(explicit) ? explicit : '';
        }
        return this.normaliseEraValue(value);
    }

    public eraOtherInputValue(field: any, value: any) {
        if (this.eraSelectionValue(field, value) !== '기타') return '';
        if (
            field
            && Object.prototype.hasOwnProperty.call(field, 'era_other_value')
        ) {
            return `${field.era_other_value || ''}`.slice(0, 100);
        }
        const raw = `${value || ''}`.trim();
        return raw && raw !== '기타' && !this.eraOptions.includes(raw)
            ? raw.slice(0, 100) : '';
    }

    public eraOtherSelected(field: any, value: any) {
        return this.eraSelectionValue(field, value) === '기타';
    }

    private metadataFieldAutoReviewable(field: any, requireEvidence: boolean = true) {
        if (!field || `${field.status || ''}` !== 'auto_match') return false;
        const hasValue = this.xmlReviewValues(field, 'extracted_value')
            .some((row: any) => `${row || ''}`.trim());
        const conflictState = `${field.conflict_state || 'none'}`;
        const hasEvidence = !requireEvidence
            || (Array.isArray(field.evidence) && field.evidence.length > 0);
        return hasValue
            && hasEvidence
            && conflictState === 'none'
            && !this.metadataReviewHierarchyNeedsDecision(field)
            && this.metadataReviewSameScopeConflictCount(field) === 0
            && !this.metadataReviewScopeTruncated(field)
            && !this.xmlReviewChanged(field);
    }

    private applyAutomaticMetadataReview(review: any, requireEvidence: boolean = true) {
        const fields = review && Array.isArray(review.fields) ? review.fields : [];
        fields.forEach((field: any) => {
            if (this.metadataFieldAutoReviewable(field, requireEvidence)) {
                field.reviewed = true;
            }
        });
    }

    private commonMetadataReviewFromAnalysis(analysis: any) {
        const metadataFields = analysis?.metadata?.fields || {};
        const fields = this.commonMetadataDefinitions().map((definition: any) => {
            const values = this.commonMetadataValue(analysis, definition.id);
            const metadataField = metadataFields[definition.id] || {};
            const evidenceRows = Array.isArray(metadataField.evidence)
                ? metadataField.evidence : [];
            const evidence = evidenceRows.map((row: any) => (
                typeof row === 'object'
                    ? { ...row }
                    : { value: `${row || ''}`, quote: `${row || ''}` }
            ));
            let status = 'auto_match';
            if (metadataField.error) status = 'extraction_error';
            else if (!values.length && evidence.length) status = 'extraction_failed';
            else if (!values.length) status = 'source_absent';
            else if (metadataField.requires_review) status = 'needs_review';
            return {
                id: definition.id,
                label: definition.label,
                repeatable: definition.repeatable,
                extracted_value: values,
                current_value: [...values],
                original_value: evidence.map((row: any) => row.value || row.quote).filter(Boolean),
                original_display_value: evidence.map((row: any) => row.value || row.quote).filter(Boolean),
                evidence,
                source_paths: evidence.map((row: any) => row.path).filter(Boolean),
                extraction_method: metadataField.provenance || analysis?.source?.format || '자동 추출',
                confidence: this.safeConfidence(
                    metadataField.confidence,
                    this.safeConfidence(analysis?.confidence?.[definition.id], values.length ? 0.8 : 0),
                ),
                conflict_state: evidence.length ? 'none' : 'no_evidence',
                status,
                reviewed: false,
                reason: '',
                standard_reference: { id: '', label: '' },
                history: [],
            };
        });
        return {
            schema_version: 'common-metadata-review-v1',
            source_excerpt: '',
            fields,
            summary: {
                total: fields.length,
                completed: 0,
                pending: fields.length,
                conflicts: fields.filter((row: any) => row.conflict_state === 'conflict').length,
                no_evidence: fields.filter((row: any) => row.conflict_state === 'no_evidence').length,
                complete: false,
            },
        };
    }

    private sourceVisibility(analysis: any) {
        const direct = analysis?.source_visibility;
        if (
            direct
            && typeof direct === 'object'
            && Object.keys(direct).length > 0
        ) return direct;
        const nested = analysis?.xml_field_review?.source_visibility;
        return nested && typeof nested === 'object' ? nested : {};
    }

    private sourceVisibilityStatus(analysis: any): 'draft' | 'published' | '' {
        const visibility = this.sourceVisibility(analysis);
        const status = `${visibility.status || ''}`;
        if (!visibility.explicit || !visibility.resolved) return '';
        return ['draft', 'published'].includes(status)
            ? status as 'draft' | 'published' : '';
    }

    private analysisForm(analysis: any) {
        const markedText = analysis && analysis.layout && typeof analysis.layout.text_with_markers === 'string'
            ? analysis.layout.text_with_markers
            : '';
        const xmlReview = analysis.xml_field_review
            ? JSON.parse(JSON.stringify(analysis.xml_field_review)) : {};
        const commonReview = this.commonMetadataReviewFromAnalysis(analysis);
        this.applyAutomaticMetadataReview(xmlReview, true);
        this.applyAutomaticMetadataReview(commonReview, false);
        const canonicalFields = Array.isArray(xmlReview.fields) && xmlReview.fields.length
            ? xmlReview.fields : commonReview.fields;
        const canonical = (fieldId: string, fallback: any) => {
            const field = canonicalFields.find((row: any) => row.id === fieldId);
            const values = field && Array.isArray(field.current_value)
                ? field.current_value.filter((row: any) => `${row || ''}`.trim()) : [];
            return values.length ? values : (Array.isArray(fallback) ? fallback : [fallback]);
        };
        const sourceVisibilityStatus = this.sourceVisibilityStatus(analysis);
        const createdDates = canonical(
            'created_dates', analysis.created_dates || []
        ).filter((row: any) => `${row || ''}`.trim());
        const issuedDates = canonical(
            'issued_dates', analysis.issued_dates || (
                analysis.date ? [analysis.date] : []
            )
        ).filter((row: any) => `${row || ''}`.trim());
        return {
            id: 'new',
            title: canonical('title', analysis.title || '')[0] || '',
            source_name: analysis && analysis.source ? analysis.source.name || '' : '',
            category: canonical('category', analysis.category || '기타')[0] || '기타',
            content: canonical('summary', analysis.summary || '')[0] || '',
            status: sourceVisibilityStatus || 'draft',
            provenance_type: analysis.source && analysis.source.type === 'url' ? 'external_crawl' : 'direct_upload',
            source_scheme: this.sourceScheme(analysis.source && analysis.source.url ? analysis.source.url : ''),
            source_category: '',
            authors: canonical('authors', analysis.authors || []).join(', '),
            publisher: canonical('publisher', analysis.publisher || '')[0] || '',
            created_dates: createdDates,
            issued_dates: issuedDates,
            document_date: issuedDates[0] || createdDates[0] || analysis.date || '',
            era: canonical('era', analysis.era || '')[0] || '',
            keywords: canonical('keywords', analysis.keywords || []).join(', '),
            language: canonical('language', analysis.language || analysis.document?.language || '')[0] || '',
            ocr_text: (analysis.ocr ? (analysis.ocr.text || '') : '') || markedText,
            ocr_page_corrections: [],
            entities: (analysis.entities || []).map(
                (row: any, index: number) => this.prepareEntityForReview(row, index)
            ),
            multilingual: this.normaliseMultilingual(analysis.multilingual),
            document_profile: analysis.document_profile?.key || '',
            profile_fields: analysis.profile_fields
                ? JSON.parse(JSON.stringify(analysis.profile_fields)) : {},
            duplicate_confirmed: !(analysis.duplicate && analysis.duplicate.found),
            duplicate_override_reason: '',
            security_acknowledged: !!(
                analysis.security_scan && analysis.security_scan.protection_level === 'full'
            ),
            common_metadata_review: commonReview,
            metadata_v2_1_review: this.metadataV21ReviewFromAnalysis(analysis),
            xml_field_review: xmlReview,
        };
    }

    private emptyMultilingual() {
        return {
            enabled: true,
            status: 'not_started',
            source_language: '',
            source_language_override: '',
            target_language: '한국어',
            segments: [],
            pages: [],
            page_count: 0,
            terms: [],
            source_truncated: false,
            translated: false,
            warning: '',
            model: '',
        };
    }

    private automaticForeignAnnotationPresent(value: string, source: string) {
        const escaped = `${source || ''}`.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        return !!escaped && new RegExp(`[\\(（]\\s*${escaped}\\s*[\\)）]`).test(`${value || ''}`);
    }

    private automaticCompactForeignLabels(value: string) {
        const foreign = /[\u3400-\u4dbf\u4e00-\u9fff\uf900-\ufaff\u3040-\u30ff\u31f0-\u31ff]/;
        const compact = /^[\u3400-\u4dbf\u4e00-\u9fff\uf900-\ufaff\u3040-\u30ff\u31f0-\u31ff・·\s]+$/;
        return Array.from(new Set(`${value || ''}`.split(/\r?\n/).map((line: string) => line.trim()).filter(
            (line: string) => (
                line.length >= 2
                && line.length <= 40
                && !['『', '「', '《', '〈'].includes(line.charAt(0))
                && compact.test(line)
                && foreign.test(line)
            )
        )));
    }

    private annotateAutomaticTranslationOriginals(
        source: string,
        target: string,
        termRows: any[] = [],
    ) {
        let result = `${target || ''}`;
        const wrappers = [
            { opener: '『', closer: '』', pattern: /『([^『』]*)』/g },
            { opener: '「', closer: '」', pattern: /「([^「」]*)」/g },
            { opener: '《', closer: '》', pattern: /《([^《》]*)》/g },
            { opener: '〈', closer: '〉', pattern: /〈([^〈〉]*)〉/g },
        ];
        const foreign = /[\u3400-\u4dbf\u4e00-\u9fff\uf900-\ufaff\u3040-\u30ff\u31f0-\u31ff]/;
        const hangul = /[\uac00-\ud7a3\u1100-\u11ff\u3130-\u318f]/;
        wrappers.forEach((wrapper: any) => {
            const sources: string[] = [];
            let sourceMatch: RegExpExecArray | null;
            wrapper.pattern.lastIndex = 0;
            while ((sourceMatch = wrapper.pattern.exec(`${source || ''}`)) !== null) {
                const original = `${sourceMatch[1] || ''}`.trim();
                if (original && foreign.test(original)) sources.push(original);
            }
            let sourceIndex = 0;
            wrapper.pattern.lastIndex = 0;
            result = result.replace(wrapper.pattern, (matched: string, translated: string) => {
                if (sourceIndex >= sources.length) return matched;
                const original = sources[sourceIndex++];
                const korean = `${translated || ''}`.trim();
                if (
                    !korean
                    || !hangul.test(korean)
                    || this.automaticForeignAnnotationPresent(korean, original)
                ) {
                    return matched;
                }
                return `${wrapper.opener}${korean}(${original})${wrapper.closer}`;
            });
        });

        (Array.isArray(termRows) ? termRows : []).forEach((row: any) => {
            const original = `${row && row.source ? row.source : ''}`.trim();
            const korean = `${
                row && (row.korean || row.normalized)
                    ? (row.korean || row.normalized) : ''
            }`.trim();
            if (
                !original
                || !source.includes(original)
                || !korean
                || korean === original
                || !hangul.test(korean)
                || !foreign.test(original)
                || this.automaticForeignAnnotationPresent(result, original)
            ) {
                return;
            }
            const position = result.indexOf(korean);
            if (position < 0) return;
            result = (
                result.slice(0, position)
                + `${korean}(${original})`
                + result.slice(position + korean.length)
            );
        });

        const sourceLines = `${source || ''}`.split(/\r?\n/);
        const resultLines = result.split(/\r?\n/);
        if (sourceLines.length === resultLines.length) {
            const compact = new Set(this.automaticCompactForeignLabels(source));
            sourceLines.forEach((line: string, index: number) => {
                const original = line.trim();
                const translated = `${resultLines[index] || ''}`.trim();
                if (
                    compact.has(original)
                    && translated
                    && hangul.test(translated)
                    && !this.automaticForeignAnnotationPresent(translated, original)
                ) {
                    resultLines[index] = `${translated}(${original})`;
                }
            });
            result = resultLines.join('\n');
        }
        return result;
    }

    private automaticTranslationHasLostWrapper(source: string, target: string) {
        const foreign = '[\\u3400-\\u4dbf\\u4e00-\\u9fff\\uf900-\\ufaff\\u3040-\\u30ff\\u31f0-\\u31ff]';
        const sourceHasForeignParenthetical = new RegExp(
            `(?:\\([^()]*${foreign}[^()]*\\)|（[^（）]*${foreign}[^（）]*）|\\[[^\\[\\]]*${foreign}[^\\[\\]]*\\])`
        ).test(source);
        if (
            sourceHasForeignParenthetical
            && /(?:\(\s*\)|（\s*）|\[\s*\])/.test(target)
        ) {
            return true;
        }
        const sourceTitles = source.match(
            /(?:『[^『』]*[\u3400-\u4dbf\u4e00-\u9fff\uf900-\ufaff\u3040-\u30ff\u31f0-\u31ff][^『』]*』|「[^「」]*[\u3400-\u4dbf\u4e00-\u9fff\uf900-\ufaff\u3040-\u30ff\u31f0-\u31ff][^「」]*」|《[^《》]*[\u3400-\u4dbf\u4e00-\u9fff\uf900-\ufaff\u3040-\u30ff\u31f0-\u31ff][^《》]*》|〈[^〈〉]*[\u3400-\u4dbf\u4e00-\u9fff\uf900-\ufaff\u3040-\u30ff\u31f0-\u31ff][^〈〉]*〉)/g
        ) || [];
        const targetTitles = target.match(
            /(?:『\s*[^『』\s][^『』]*』|「\s*[^「」\s][^「」]*」|《\s*[^《》\s][^《》]*》|〈\s*[^〈〉\s][^〈〉]*〉)/g
        ) || [];
        if (sourceTitles.length > targetTitles.length) return true;
        const requiredAnnotations = sourceTitles.map(
            (value: string) => value.slice(1, -1).trim()
        ).concat(this.automaticCompactForeignLabels(source));
        return requiredAnnotations.some(
            (value: string) => !this.automaticForeignAnnotationPresent(target, value)
        );
    }

    private automaticTranslationForeignRemainder(source: string, target: string) {
        const preserve = (
            match: string,
            prefix: string,
            value: string,
        ) => {
            const wrapped = `${value || ''}`.trim();
            const original = wrapped.length >= 2
                ? wrapped.slice(1, -1).trim() : wrapped;
            return source.includes(wrapped) || (!!original && source.includes(original))
                ? prefix : match;
        };
        return target
            .replace(
                /([\uac00-\ud7a3])(\s*\([^()\n]*[\u3400-\u4dbf\u4e00-\u9fff\uf900-\ufaff\u3040-\u30ff\u31f0-\u31ff][^()\n]*\))/g,
                preserve,
            )
            .replace(
                /([\uac00-\ud7a3])(\s*（[^（）\n]*[\u3400-\u4dbf\u4e00-\u9fff\uf900-\ufaff\u3040-\u30ff\u31f0-\u31ff][^（）\n]*）)/g,
                preserve,
            )
            .replace(
                /([\uac00-\ud7a3])(\s*\[[^\[\]\n]*[\u3400-\u4dbf\u4e00-\u9fff\uf900-\ufaff\u3040-\u30ff\u31f0-\u31ff][^\[\]\n]*\])/g,
                preserve,
            );
    }

    private validAutomaticKoreanTranslation(
        original: string,
        translation: string,
        translationRequired: boolean = true,
    ) {
        if (!translationRequired) return !!`${translation || ''}`.trim();
        const source = `${original || ''}`.trim();
        const target = `${translation || ''}`.trim();
        if (!source || !target) return false;
        if (source.replace(/\s+/g, '') === target.replace(/\s+/g, '')) return false;
        if (!/[\uac00-\ud7a3\u1100-\u11ff\u3130-\u318f]/.test(target)) return false;
        if (this.automaticTranslationHasLostWrapper(source, target)) return false;
        const sourceHasHanjaOrKana = /[\u3400-\u4dbf\u4e00-\u9fff\uf900-\ufaff\u3040-\u30ff\u31f0-\u31ff]/.test(source);
        const targetRemainder = this.automaticTranslationForeignRemainder(source, target);
        const targetHasHanjaOrKana = /[\u3400-\u4dbf\u4e00-\u9fff\uf900-\ufaff\u3040-\u30ff\u31f0-\u31ff]/.test(targetRemainder);
        return !(sourceHasHanjaOrKana && targetHasHanjaOrKana);
    }

    private normaliseMultilingual(value: any) {
        const source = value && typeof value === 'object' ? value : {};
        const annotationTerms = Array.isArray(source.terms) ? source.terms : [];
        const segments = Array.isArray(source.segments) ? source.segments.map((row: any, index: number) => {
            const original = `${row && row.original ? row.original : ''}`;
            const translationRequired = row && typeof row.translation_required === 'boolean'
                ? row.translation_required : true;
            const manuallyCorrected = !!(row && row.manually_corrected);
            const validationStatus = `${row && row.validation_status ? row.validation_status : ''}`;
            const serverValidated = ['validated', 'partial', 'failed', 'not_required'].includes(
                validationStatus
            );
            let translation = `${row && row.translation ? row.translation : ''}`;
            if (translationRequired && !manuallyCorrected) {
                translation = this.annotateAutomaticTranslationOriginals(
                    original, translation, annotationTerms
                );
            }
            if (
                translationRequired
                && !manuallyCorrected
                && !serverValidated
                && !this.validAutomaticKoreanTranslation(
                    original, translation, translationRequired
                )
            ) {
                translation = '';
            }
            const sourceStatus = `${row && row.status ? row.status : ''}`;
            const status = !translationRequired
                ? 'not_required'
                : (
                    translation.trim()
                    && (sourceStatus === 'complete' || !sourceStatus)
                    && validationStatus !== 'partial'
                        ? 'complete'
                        : 'review_required'
                );
            return {
                index: Number.isFinite(Number(row && row.index)) ? Number(row.index) : index,
                page: Number.isFinite(Number(row && row.page)) ? Number(row.page) : 0,
                part: Number.isFinite(Number(row && row.part)) ? Number(row.part) : 1,
                original,
                translation,
                source_language: `${row && row.source_language ? row.source_language : ''}`,
                translation_required: translationRequired,
                status,
                manually_corrected: manuallyCorrected,
                failure_reason: `${row && row.failure_reason ? row.failure_reason : ''}`,
                validation_status: validationStatus || (
                    status === 'complete' ? 'validated' : status
                ),
            };
        }).filter((row: any) => row.original || row.translation) : [];
        const pages = Array.isArray(source.pages) ? source.pages.map((row: any, index: number) => {
            const original = `${row && row.original ? row.original : ''}`;
            const translationRequired = row && typeof row.translation_required === 'boolean'
                ? row.translation_required : true;
            const manuallyCorrected = !!(row && row.manually_corrected);
            const validationStatus = `${row && row.validation_status ? row.validation_status : ''}`;
            const serverValidated = ['validated', 'partial', 'failed', 'not_required'].includes(
                validationStatus
            );
            let translation = `${row && row.translation ? row.translation : ''}`;
            if (translationRequired && !manuallyCorrected) {
                translation = this.annotateAutomaticTranslationOriginals(
                    original, translation, annotationTerms
                );
            }
            if (
                translationRequired
                && !manuallyCorrected
                && !serverValidated
                && !this.validAutomaticKoreanTranslation(
                    original, translation, translationRequired
                )
            ) {
                translation = '';
            }
            const sourceStatus = `${row && row.status ? row.status : ''}`;
            const status = !translationRequired
                ? 'not_required'
                : (
                    translation.trim()
                    && (sourceStatus === 'complete' || !sourceStatus)
                    && validationStatus !== 'partial'
                        ? 'complete'
                        : 'review_required'
                );
            return {
                page: Number.isFinite(Number(row && row.page)) ? Number(row.page) : index + 1,
                original,
                translation,
                segment_count: Number.isFinite(Number(row && row.segment_count)) ? Number(row.segment_count) : 1,
                translated: status === 'complete',
                translation_required: translationRequired,
                status,
                manually_corrected: manuallyCorrected,
                failure_reason: `${row && row.failure_reason ? row.failure_reason : ''}`,
                validation_status: validationStatus || (
                    status === 'complete' ? 'validated' : status
                ),
            };
        }).filter((row: any) => row.original || row.translation) : [];
        const terms = Array.isArray(source.terms) ? source.terms.map((row: any) => {
            const termSource = `${row && row.source ? row.source : ''}`;
            const category = `${row && row.category ? row.category : '역사 용어'}`;
            const originalScript = `${row && row.original_script ? row.original_script : ''}`
                || (/[㐀-䶿一-鿿豈-﫿]/.test(termSource) ? termSource : '');
            const personCategory = /person|personal\s*name|인명|인물|사람|성명|이름/i.test(category);
            const untrustedHanjaName = !!(
                originalScript
                && personCategory
                && !(row && row.dictionary_match)
                && !(row && row.auto_confirmed === true)
            );
            const proposedNormalized = `${row && row.normalized ? row.normalized : termSource}`;
            const proposedKorean = `${row && row.korean ? row.korean : ''}`;
            const rawCandidates = Array.isArray(row && row.reading_candidates)
                ? row.reading_candidates : [];
            const candidates: any[] = [];
            const candidateValues = new Set<string>();
            [...rawCandidates, ...(untrustedHanjaName ? [{
                value: proposedKorean || proposedNormalized,
                source: '기존 자동 추출값',
                confidence: row && row.confidence,
                auto_confirmable: false,
            }] : [])].forEach((candidate: any) => {
                const value = `${candidate && candidate.value ? candidate.value : ''}`.trim();
                if (!value || value === termSource || candidateValues.has(value)) return;
                candidateValues.add(value);
                candidates.push({
                    value,
                    source: `${candidate && candidate.source ? candidate.source : 'AI 용어 정규화'}`,
                    confidence: this.safeConfidence(candidate && candidate.confidence, 0),
                    auto_confirmable: !!(candidate && candidate.auto_confirmable),
                });
            });
            return {
                source: termSource,
                original_script: originalScript,
                normalized: untrustedHanjaName ? termSource : proposedNormalized,
                korean: untrustedHanjaName ? '' : proposedKorean,
                language: `${row && row.language ? row.language : 'other'}`,
                category,
                definition: `${row && row.definition ? row.definition : ''}`,
                confidence: this.safeConfidence(row && row.confidence, 0),
                dictionary_match: !!(row && row.dictionary_match),
                dictionary_source: `${row && row.dictionary_source ? row.dictionary_source : ''}`,
                hanja_to_hangul: !!(row && (row.hanja_to_hangul || candidates.length)),
                tag: untrustedHanjaName ? '한자 인명 후보' : `${row && row.tag ? row.tag : '용어 정규화'}`,
                reading_candidates: candidates,
                reading_status: untrustedHanjaName
                    ? 'review_required' : `${row && row.reading_status ? row.reading_status : 'confirmed'}`,
                auto_confirmed: untrustedHanjaName ? false : !!(row && row.auto_confirmed !== false),
                requires_review: untrustedHanjaName || !!(row && row.requires_review),
                review_reason: `${row && row.review_reason ? row.review_reason : ''}` || (
                    untrustedHanjaName ? '사전 근거가 없는 한자 인명 독음은 자동 확정하지 않습니다.' : ''
                ),
            };
        }).filter((row: any) => row.source) : [];
        let status = `${source.status || (source.translated ? 'complete' : 'not_started')}`;
        const translationScope = pages.length ? pages : segments;
        const hasRequiredTranslation = translationScope.some(
            (row: any) => row.translation_required !== false
        );
        const translated = !!translationScope.length
            && hasRequiredTranslation
            && translationScope.every((row: any) => (
                row.translation_required === false || row.status === 'complete'
            ));
        if (!['failed', 'disabled', 'processing', 'not_started'].includes(status)) {
            status = !hasRequiredTranslation && translationScope.length
                ? 'not_required'
                : (translated ? 'complete' : 'partial');
        }
        return {
            ...this.emptyMultilingual(),
            ...source,
            status,
            source_language: `${source.source_language || ''}`,
            source_language_override: `${source.source_language_override || ''}`,
            target_language: `${source.target_language || '한국어'}`,
            segments,
            pages,
            page_count: Number.isFinite(Number(source.page_count)) ? Number(source.page_count) : pages.length,
            terms,
            source_truncated: !!source.source_truncated,
            translated: ['failed', 'disabled', 'processing', 'not_started'].includes(status)
                ? false : translated,
            warning: `${source.warning || ''}`,
        };
    }

    private cloneForm(form: any) {
        const source = form && typeof form === 'object' ? form : {};
        return {
            ...source,
            entities: Array.isArray(source.entities) ? source.entities.map((row: any) => ({ ...row })) : [],
            ocr_page_corrections: Array.isArray(source.ocr_page_corrections)
                ? source.ocr_page_corrections.map((row: any) => ({ ...row })) : [],
            multilingual: this.normaliseMultilingual(source.multilingual),
            profile_fields: source.profile_fields
                ? JSON.parse(JSON.stringify(source.profile_fields)) : {},
            common_metadata_review: source.common_metadata_review
                ? JSON.parse(JSON.stringify(source.common_metadata_review))
                : { schema_version: 'common-metadata-review-v1', fields: [] },
            metadata_v2_1_review: source.metadata_v2_1_review
                ? JSON.parse(JSON.stringify(source.metadata_v2_1_review))
                : { review_status: 'NOT_APPLICABLE', fields: {} },
            xml_field_review: source.xml_field_review
                ? JSON.parse(JSON.stringify(source.xml_field_review)) : {},
        };
    }

    public documentProfile(analysis: any = null) {
        const source = analysis || this.analysisInfo || {};
        if (source.document_profile && typeof source.document_profile === 'object') {
            return source.document_profile;
        }
        const savedProfile = !analysis
            && this.data?.document_profile_detail
            && typeof this.data.document_profile_detail === 'object'
            ? this.data.document_profile_detail : null;
        return savedProfile || {
                key: this.data?.document_profile || '',
                label: '자료 유형 자동 판별',
                description: '',
                detected_key: '',
                auto_detected: true,
                selected_by_user: false,
                review_items: [],
                options: [],
            };
    }

    public documentProfileOptions() {
        const profile = this.documentProfile();
        return Array.isArray(profile.options) ? profile.options : [];
    }

    private materialMetadataReviewSource(analysis: any = null, form: any = null) {
        const formReview = form && form.xml_field_review
            && typeof form.xml_field_review === 'object'
            ? form.xml_field_review : {};
        if (formReview.metadata_strategy) return formReview;
        const analysisReview = analysis && analysis.xml_field_review
            && typeof analysis.xml_field_review === 'object'
            ? analysis.xml_field_review : {};
        return analysisReview;
    }

    public materialMetadataStrategy(analysis: any = null, form: any = null) {
        const sourceAnalysis = analysis || this.analysisInfo || {};
        const sourceForm = form || (!analysis ? this.data : null) || {};
        const review = this.materialMetadataReviewSource(sourceAnalysis, sourceForm);
        const strategy = review.metadata_strategy
            && typeof review.metadata_strategy === 'object'
            ? review.metadata_strategy : {};
        const classifiedStrategy = sourceAnalysis.nahf_item_classification
            && typeof sourceAnalysis.nahf_item_classification === 'object'
            ? sourceAnalysis.nahf_item_classification : {};
        const strategyId = `${strategy.id || classifiedStrategy.material_strategy_id || ''}`;
        const fallback = this.metadataStrategyFallbackOptions().find(
            (row: any) => `${row.id || ''}` === strategyId
        ) || {};
        return {
            ...fallback,
            ...strategy,
            id: strategyId || `${fallback.id || ''}`,
            label: strategy.label || fallback.label || '',
            description: strategy.description || fallback.description || '',
            content_review_keys: Array.isArray(strategy.content_review_keys)
                ? strategy.content_review_keys
                : (Array.isArray(fallback.content_review_keys)
                    ? fallback.content_review_keys : []),
        };
    }

    public activeMaterialMetadataStrategy() {
        const active = this.activeBatchItem();
        return this.materialMetadataStrategy(
            active && active.analysis ? active.analysis : this.analysisInfo,
            this.data || (active ? active.form : null),
        );
    }

    public activeMaterialTypeLabel() {
        return this.activeMaterialMetadataStrategy().label
            || this.documentProfile().label
            || '자료 유형 확인 필요';
    }

    public batchItemMaterialTypeLabel(item: any) {
        if (!item || !item.analysis || typeof item.analysis !== 'object') {
            return this.batchItemProfileLabel(item);
        }
        const strategy = this.materialMetadataStrategy(
            item.analysis,
            item && item.form ? item.form : null,
        );
        return strategy.label || this.batchItemProfileLabel(item);
    }

    public batchItemMaterialTypeReason(item: any) {
        if (!item || !item.analysis || typeof item.analysis !== 'object') {
            return this.batchItemProfileReason(item);
        }
        const strategy = this.materialMetadataStrategy(
            item.analysis,
            item && item.form ? item.form : null,
        );
        return strategy.description || this.batchItemProfileReason(item);
    }

    public documentProfileReviewItems(analysis: any = null, form: any = null) {
        const profile = this.documentProfile(analysis);
        const items = Array.isArray(profile.review_items) ? profile.review_items : [];
        const strategy = this.materialMetadataStrategy(analysis, form);
        const keys = Array.isArray(strategy.content_review_keys)
            ? strategy.content_review_keys.map((key: any) => `${key || ''}`)
            : [];
        if (!strategy.id || !keys.length) return items;
        const byKey = new Map<string, any>();
        items.forEach((item: any) => byKey.set(`${item && item.key || ''}`, item));
        const scopedItems = keys.map((key: string) => byKey.get(key)).filter(Boolean);
        const translationItem = byKey.get('translated_text');
        if (
            translationItem
            && !scopedItems.some((item: any) => `${item && item.key || ''}` === 'translated_text')
        ) {
            const originalIndex = scopedItems.findIndex(
                (item: any) => `${item && item.key || ''}` === 'original_text'
            );
            scopedItems.splice(originalIndex >= 0 ? originalIndex + 1 : 0, 0, translationItem);
        }
        return scopedItems.length ? scopedItems : items;
    }

    public documentProfileReviewItemRequired(item: any) {
        return !!item && (item.required === true || item.blocking === true);
    }

    public fileReviewTasks(analysis: any = null) {
        const source = analysis || this.analysisInfo || {};
        return Array.isArray(source.review_tasks) ? source.review_tasks : [];
    }

    public fileReviewTasksEmptyReason(analysis: any = null) {
        const source = analysis || this.analysisInfo || {};
        return `${source.review_tasks_empty_reason || (
            this.inferSourceFormat(source.source || {}) === 'xml'
                ? 'XML 검수 항목 데이터를 불러오지 못했습니다. 원문 분석을 다시 실행해주세요.'
                : '이 자료에 추가로 표시할 파일별 검수 항목이 없습니다.'
        )}`;
    }

    public fileReviewTaskStatus(task: any) {
        const status = `${task && task.status ? task.status : 'pending'}`;
        if (['not_applicable', 'failed', 'in_progress'].includes(status)) return status;
        const keys = Array.isArray(task && task.review_keys) ? task.review_keys : [];
        const active = this.activeBatchItem();
        if (!keys.length || !active) return status;
        const checks = this.normaliseReviewChecks(
            active.reviewChecks, null, this.reviewKeys(active)
        );
        return keys.every((key: string) => !!checks[key]) ? 'complete' : status;
    }

    public fileReviewTaskStatusLabel(task: any) {
        const labels: any = {
            not_applicable: '해당 없음',
            pending: '대기',
            in_progress: '진행 중',
            review_required: '검토 필요',
            complete: '완료',
            failed: '실패',
        };
        const status = this.fileReviewTaskStatus(task);
        return labels[status] || '검토 필요';
    }

    public fileReviewTaskEvidence(task: any) {
        return task && task.evidence && typeof task.evidence === 'object'
            ? task.evidence : {};
    }

    public fileReviewTaskPairs(task: any) {
        const evidence = this.fileReviewTaskEvidence(task);
        const pairs = Array.isArray(evidence.pairs)
            ? evidence.pairs : (Array.isArray(evidence.segments) ? evidence.segments : []);
        return pairs.filter((row: any) => row && (row.original || row.translation));
    }

    public fileReviewTaskLanguageLabels(task: any) {
        const evidence = this.fileReviewTaskEvidence(task);
        const detected = Array.isArray(evidence.detected) ? evidence.detected : [];
        const labels: any = {
            hanja: '한자',
            japanese: '일본어',
            english: '영어',
        };
        return detected.map((key: string) => labels[key] || key);
    }

    public fileReviewTaskHistory(task: any) {
        const evidence = this.fileReviewTaskEvidence(task);
        return Array.isArray(evidence.history) ? evidence.history : [];
    }

    public reviewTasksForArea(area: any) {
        const key = typeof area === 'string' ? area : `${area && area.key ? area.key : ''}`;
        return this.fileReviewTasks().filter((task: any) => {
            const reviewKeys = Array.isArray(task && task.review_keys) ? task.review_keys : [];
            return reviewKeys.includes(key) || `${task && task.key ? task.key : ''}` === `profile_${key}`;
        });
    }

    public reviewTaskForArea(area: any) {
        const priorities: any = {
            failed: 6,
            in_progress: 5,
            review_required: 4,
            pending: 3,
            complete: 2,
            not_applicable: 1,
        };
        return this.reviewTasksForArea(area).reduce((selected: any, task: any) => {
            if (!selected) return task;
            const selectedPriority = priorities[`${selected.status || ''}`] || 0;
            const taskPriority = priorities[`${task.status || ''}`] || 0;
            return taskPriority > selectedPriority ? task : selected;
        }, null);
    }

    public reviewAreaValue(area: any) {
        if (!area) return '';
        if (area.key === 'entities') return Array.isArray(this.data?.entities) ? this.data.entities : [];
        if (area.key === 'image_ocr' || area.key === 'pdf_pages') return this.data?.ocr_text || '';
        const direct = this.profileFieldValue(area.key);
        if (this.profileFieldHasValue(area.key)) return direct;
        const sourceKeys = Array.isArray(area.source_keys) ? area.source_keys : [];
        const values = sourceKeys
            .map((key: string) => this.profileFieldValue(key))
            .filter((value: any) => {
                if (Array.isArray(value)) return value.length > 0;
                if (value && typeof value === 'object') return Object.keys(value).length > 0;
                return !!`${value || ''}`.trim();
            });
        if (values.length === 1) return values[0];
        return values;
    }

    public reviewAreaHasValue(area: any) {
        const value = this.reviewAreaValue(area);
        if (Array.isArray(value)) return value.length > 0;
        if (value && typeof value === 'object') return Object.keys(value).length > 0;
        return !!`${value || ''}`.trim();
    }

    public reviewAreaStatus(area: any) {
        const item = this.activeBatchItem();
        const checks = this.normaliseReviewChecks(
            item && item.reviewChecks, null, this.reviewKeys(item)
        );
        if (area && checks[area.key]) return 'complete';
        const task = this.reviewTaskForArea(area);
        const status = this.fileReviewTaskStatus(task);
        if (status === 'failed') return 'error';
        if (status === 'in_progress') return 'processing';
        if (status === 'not_applicable') return 'not_applicable';
        if (status === 'pending') return 'review_required';
        if (!this.reviewAreaHasValue(area)) {
            if (area && area.blocking) return 'missing';
            return 'source_absent';
        }
        if (this.reviewAreaModified(area)) return 'modified';
        return 'review_required';
    }

    public reviewAreaStatusLabel(area: any) {
        const labels: any = {
            complete: '검수 완료',
            modified: '수정됨',
            review_required: '확인 필요',
            processing: '처리 중',
            error: '추출 오류',
            missing: '필수값 누락',
            source_absent: '원본에 없음',
            not_applicable: '적용 대상 아님',
        };
        return labels[this.reviewAreaStatus(area)] || '확인 필요';
    }

    public reviewAreaStatusDescription(area: any) {
        const task = this.reviewTaskForArea(area);
        const status = this.reviewAreaStatus(area);
        if (task && ['error', 'processing', 'not_applicable', 'review_required'].includes(status)) {
            return task.reason || task.empty_reason || '';
        }
        const descriptions: any = {
            complete: '현재 결과를 최종 등록값으로 확정했습니다.',
            modified: '자동 추출값을 수정했으며 다시 확인해야 합니다.',
            review_required: '추출 결과와 원본 근거를 확인해주세요.',
            missing: '완료를 막는 필수 원본 또는 추출 결과가 없습니다.',
            source_absent: '원본에 해당 요소가 없어 비어 있습니다.',
            not_applicable: '이 Profile에서는 완료를 막지 않는 항목입니다.',
        };
        return descriptions[status] || '';
    }

    public reviewAreaItemCount(area: any) {
        const value = this.reviewAreaValue(area);
        if (Array.isArray(value)) return value.length;
        if (value && typeof value === 'object') return Object.keys(value).length;
        const text = `${value || ''}`.trim();
        if (!text) return 0;
        if (area && ['original_text', 'translated_text', 'image_ocr', 'pdf_pages'].includes(area.key)) {
            return text.length;
        }
        return 1;
    }

    public reviewAreaCountUnit(area: any) {
        return area && ['original_text', 'translated_text', 'image_ocr', 'pdf_pages'].includes(area.key)
            ? '자' : '개';
    }

    public reviewRequiredAreaCount() {
        return this.reviewSections.filter((area: any) => (
            ['review_required', 'modified', 'missing'].includes(this.reviewAreaStatus(area))
        )).length;
    }

    public reviewErrorAreaCount() {
        return this.reviewSections.filter((area: any) => this.reviewAreaStatus(area) === 'error').length;
    }

    public reviewModifiedAreaCount() {
        return this.reviewSections.filter((area: any) => this.reviewAreaModified(area)).length;
    }

    public reviewBlockingAreaCount() {
        return this.reviewSections.filter((area: any) => (
            !!area.blocking && ['error', 'missing', 'processing'].includes(this.reviewAreaStatus(area))
        )).length;
    }

    public reviewAreaModified(area: any) {
        if (!area || !this.analysisInfo) return false;
        const current = this.reviewAreaValue(area);
        let original: any = this.analysisInfo.profile_fields
            && typeof this.analysisInfo.profile_fields === 'object'
            ? this.analysisInfo.profile_fields[area.key] : '';
        if (area.key === 'entities') {
            const comparable = (rows: any[]) => (Array.isArray(rows) ? rows : []).map((row: any) => ({
                text: `${row?.text || ''}`,
                hanja: `${row?.hanja || ''}`,
                normalized: `${row?.normalized || ''}`,
                type: `${row?.type || 'OTHER'}`,
                kg_id: `${row?.kg_id || ''}`,
            }));
            return JSON.stringify(comparable(current)) !== JSON.stringify(
                comparable(this.analysisInfo.entities || [])
            );
        }
        if (area.key === 'image_ocr' || area.key === 'pdf_pages') {
            original = this.analysisInfo.ocr?.text || this.analysisInfo.document?.text || '';
        }
        if (typeof original === 'undefined' && Array.isArray(area.source_keys)) {
            original = area.source_keys.map((key: string) => this.analysisInfo.profile_fields?.[key]);
        }
        return JSON.stringify(current || '') !== JSON.stringify(original || '');
    }

    private appendProfileReviewHistoryToForm(
        form: any, areaKey: string, action: string, reason: string = ''
    ) {
        if (!form) return;
        if (!form.profile_fields || typeof form.profile_fields !== 'object') {
            form.profile_fields = {};
        }
        const history = Array.isArray(form.profile_fields.__review_history)
            ? form.profile_fields.__review_history : [];
        history.push({
            area_key: areaKey,
            action,
            reason,
            user: '현재 사용자',
            changed_at: new Date().toISOString(),
        });
        form.profile_fields.__review_history = history.slice(-100);
    }

    private appendProfileReviewHistory(areaKey: string, action: string, reason: string = '') {
        this.appendProfileReviewHistoryToForm(this.data, areaKey, action, reason);
    }

    public reviewAreaHistory(area: any) {
        const local = Array.isArray(this.data?.profile_fields?.__review_history)
            ? this.data.profile_fields.__review_history.filter(
                (row: any) => row && row.area_key === area?.key
            ) : [];
        const server = this.fileReviewTaskHistory(this.reviewTaskForArea(area));
        return [...server, ...local].slice(-20).reverse();
    }

    public reviewTextValue() {
        const area = this.activeProfileReviewItem();
        return `${this.reviewAreaValue(area) || ''}`;
    }

    private reviewTextAllSegments() {
        const text = this.reviewTextValue();
        if (!text) return [];
        let rows = text.split(/\n\s*\n/).map((row: string) => row.trim()).filter(Boolean);
        if (rows.length <= 1 && text.length > 2400) {
            rows = [];
            for (let offset = 0; offset < text.length; offset += 2000) {
                rows.push(text.slice(offset, offset + 2000));
            }
        }
        return rows.map((textValue: string, index: number) => ({
            index,
            text: textValue,
            attention: textValue.length < 8
                || textValue.length > 4000
                || /�|\\u0000|<[^>]{1,80}>/.test(textValue),
        }));
    }

    public reviewTextSegments() {
        const query = this.reviewTextSearch.trim().toLocaleLowerCase();
        const rows = this.reviewTextAllSegments().filter((row: any) => (
            (!this.reviewTextAttentionOnly || row.attention)
            && (!query || row.text.toLocaleLowerCase().includes(query))
        ));
        const page = Math.min(this.reviewTextPage, Math.max(1, Math.ceil(rows.length / this.reviewTextPageSize)));
        const start = (page - 1) * this.reviewTextPageSize;
        return rows.slice(start, start + this.reviewTextPageSize);
    }

    public reviewTextMetrics() {
        const text = this.reviewTextValue();
        const segments = this.reviewTextAllSegments();
        const suspicious = segments.filter((row: any) => row.attention).length;
        return {
            characters: text.length,
            segments: segments.length,
            lineBreaks: (text.match(/\n/g) || []).length,
            suspicious,
            basis: `문자 ${text.length.toLocaleString()}자 · 공백줄 기준 ${segments.length.toLocaleString()}구간 · 8자 미만/4,000자 초과/깨진 문자·태그 잔여 ${suspicious.toLocaleString()}건`,
        };
    }

    public reviewTextFilteredCount() {
        const query = this.reviewTextSearch.trim().toLocaleLowerCase();
        return this.reviewTextAllSegments().filter((row: any) => (
            (!this.reviewTextAttentionOnly || row.attention)
            && (!query || row.text.toLocaleLowerCase().includes(query))
        )).length;
    }

    public reviewTextPageCount() {
        return Math.max(1, Math.ceil(this.reviewTextFilteredCount() / this.reviewTextPageSize));
    }

    public async setReviewTextPage(page: number) {
        this.reviewTextPage = Math.max(1, Math.min(page, this.reviewTextPageCount()));
        await this.renderPreservingViewport();
    }

    public async applyReviewTextFilter() {
        this.reviewTextPage = 1;
        await this.renderPreservingViewport();
    }

    public async toggleReviewTextAttentionOnly() {
        this.reviewTextAttentionOnly = !this.reviewTextAttentionOnly;
        this.reviewTextPage = 1;
        await this.renderPreservingViewport();
    }

    public reviewTranslationRows() {
        const multilingual = this.multilingualData();
        const status = `${multilingual.status || ''}`;
        const segmentRows = (Array.isArray(multilingual.segments) ? multilingual.segments : [])
            .map((row: any, sourcePosition: number) => ({
                original: row.original || '',
                translation: row.translation || '',
                status: row.status || (row.translation ? 'complete' : 'review_required'),
                index: row.index,
                source_position: sourcePosition,
                page: row.page,
                translation_required: row.translation_required,
                failure_reason: row.failure_reason || '',
                validation_status: row.validation_status || '',
            }))
            .filter((row: any) => row.translation_required !== false)
            .filter((row: any) => row.original || row.translation);
        const pageRows = this.multilingualPages().map((row: any) => ({
            original: row.original || '',
            translation: row.translation || '',
            status: row.status || (row.translation ? 'complete' : 'review_required'),
            page: row.page,
            failure_reason: row.failure_reason || '',
            validation_status: row.validation_status || '',
        }));
        if (status === 'partial' && segmentRows.length) {
            return segmentRows;
        }
        if (
            status === 'processing'
            && this.translationSourceIsXml()
            && segmentRows.length
        ) {
            return segmentRows;
        }
        if (pageRows.some((row: any) => `${row.translation || ''}`.trim())) {
            return pageRows;
        }
        const multilingualRows = this.fileReviewTaskPairs(
            this.fileReviewTasks().find((task: any) => task.key === 'multilingual_translation')
        );
        if (
            this.multilingualData().status === 'complete'
            && multilingualRows.some((row: any) => `${row.translation || ''}`.trim())
        ) {
            return multilingualRows;
        }
        if (status === 'complete' && segmentRows.length) {
            return segmentRows;
        }
        if (status !== 'complete') return [];
        const translatedText = `${this.profileFieldValue('translated_text') || ''}`.trim();
        if (!translatedText) return [];
        const originals = `${this.profileFieldValue('original_text') || ''}`.split(/\n\s*\n/);
        const translations = translatedText.split(/\n\s*\n/);
        return translations.map((translation: string, index: number) => ({
            original: originals[index] || '',
            translation,
            status: 'complete',
        })).filter((row: any) => row.original || row.translation);
    }

    private reviewTranslationLanguageKeys(value: string) {
        const text = `${value || ''}`;
        const keys: string[] = [];
        if (/[\u3400-\u4dbf\u4e00-\u9fff\uf900-\ufaff]/.test(text)) keys.push('hanja');
        if (/[\u3040-\u30ff\u31f0-\u31ff]/.test(text)) keys.push('japanese');
        if (/\b[A-Za-z]{2,}\b/.test(text)) keys.push('english');
        return keys;
    }

    private reviewTranslationTargetSnippets(value: string) {
        const text = `${value || ''}`;
        const labels: any = { hanja: '한자', japanese: '일본어', english: '영어' };
        const patterns: any[] = [
            {
                key: 'japanese',
                expression: /[\u3040-\u30ff\u31f0-\u31ff][\u3040-\u30ff\u31f0-\u31ff\u3400-\u4dbf\u4e00-\u9fff\uf900-\ufaff]{0,79}/g,
            },
            {
                key: 'hanja',
                expression: /[\u3400-\u4dbf\u4e00-\u9fff\uf900-\ufaff]{1,80}/g,
            },
            {
                key: 'english',
                expression: /\b[A-Za-z][A-Za-z0-9'’._-]*(?:\s+[A-Za-z][A-Za-z0-9'’._-]*){0,5}\b/g,
            },
        ];
        const targets: any[] = [];
        const seen = new Set<string>();
        patterns.forEach((pattern: any) => {
            const matches = text.match(pattern.expression) || [];
            matches.forEach((match: string) => {
                const snippet = `${match || ''}`.trim();
                const normalized = snippet.toLowerCase();
                if (!snippet || seen.has(normalized)) return;
                if (pattern.key === 'english' && snippet.replace(/[^A-Za-z]/g, '').length < 2) return;
                seen.add(normalized);
                targets.push({
                    language: pattern.key,
                    label: labels[pattern.key],
                    text: snippet,
                });
            });
        });
        return targets.slice(0, 8);
    }

    public reviewTranslationCandidateRows() {
        const pairRows = this.fileReviewTaskPairs(
            this.fileReviewTasks().find((task: any) => task.key === 'source_translation_compare')
        );
        let originals = pairRows
            .map((row: any) => `${row.original || ''}`.trim())
            .filter(Boolean);
        if (!originals.length) {
            const text = `${this.profileFieldValue('original_text') || ''}`.trim();
            originals = text.split(/\n\s*\n/).map((row: string) => row.trim()).filter(Boolean);
            if (originals.length <= 1 && text.length > 1600) {
                originals = [];
                for (let offset = 0; offset < text.length; offset += 1600) {
                    originals.push(text.slice(offset, offset + 1600).trim());
                }
            }
        }
        return originals.map((original: string, index: number) => {
            const languages = this.reviewTranslationLanguageKeys(original);
            const labels: any = { hanja: '한자', japanese: '일본어', english: '영어' };
            return {
                index,
                original,
                languages,
                language_label: languages.map((key: string) => labels[key]).join(' · '),
                targets: this.reviewTranslationTargetSnippets(original),
                status: 'pending',
            };
        }).filter((row: any) => row.languages.length > 0);
    }

    public reviewTranslationPageRows() {
        const rows = this.reviewTranslationRows();
        const start = (this.reviewTranslationPage - 1) * this.reviewTranslationPageSize;
        return rows.slice(start, start + this.reviewTranslationPageSize);
    }

    public reviewTranslationCandidatePageRows() {
        const rows = this.reviewTranslationCandidateRows();
        const start = (this.reviewTranslationPage - 1) * this.reviewTranslationPageSize;
        return rows.slice(start, start + this.reviewTranslationPageSize);
    }

    public translationReviewProcessing() {
        return this.multilingualProcessing || this.multilingualData().status === 'processing';
    }

    public reviewTranslationCandidateExpanded(index: number) {
        return this.reviewTranslationCandidateExpandedIndex === index;
    }

    public async toggleReviewTranslationCandidate(index: number) {
        this.reviewTranslationCandidateExpandedIndex = this.reviewTranslationCandidateExpanded(index)
            ? -1
            : index;
        await this.renderPreservingViewport();
    }

    public reviewTranslationActivePageCount() {
        const rows = this.reviewTranslationRows().length
            ? this.reviewTranslationRows()
            : this.reviewTranslationCandidateRows();
        return Math.max(1, Math.ceil(rows.length / this.reviewTranslationPageSize));
    }

    public reviewTranslationCompletedCount() {
        return this.reviewTranslationRows().filter(
            (row: any) => row.status === 'complete'
        ).length;
    }

    public reviewTranslationMissingCount() {
        return this.reviewTranslationRows().filter(
            (row: any) => row.status !== 'complete'
        ).length;
    }

    public reviewTranslationRowStatusLabel(row: any) {
        if (row?.status === 'complete') return '번역 완료';
        return `${row?.translation || ''}`.trim()
            ? '부분 번역 · 검수 필요'
            : '번역 누락';
    }

    public translationSegmentRetryIndex(row: any) {
        const hasDirectIndex = !!row
            && row.index !== undefined
            && row.index !== null
            && `${row.index}`.trim() !== '';
        const directIndex = hasDirectIndex ? Number(row.index) : Number.NaN;
        if (Number.isFinite(directIndex)) return directIndex;
        const sourceIndexes = Array.isArray(row && row.source_segment_indexes)
            ? row.source_segment_indexes : [];
        if (sourceIndexes.length !== 1) return -1;
        const sourceIndex = Number(sourceIndexes[0]);
        const segments = this.translationSegments();
        if (!Number.isFinite(sourceIndex) || !segments[sourceIndex]) return -1;
        const storedIndex = Number(segments[sourceIndex].index);
        return Number.isFinite(storedIndex) ? storedIndex : sourceIndex;
    }

    public translationSegmentRetrying(row: any) {
        const index = this.translationSegmentRetryIndex(row);
        return index >= 0 && this.multilingualSegmentProcessingIndex === index;
    }

    public trackByTranslationRow(index: number, row: any) {
        const original = `${row && row.original ? row.original : ''}`;
        return `${row && row.page ? row.page : 0}:${row && row.index !== undefined ? row.index : index}:${original.length}:${original.slice(0, 48)}`;
    }

    public reviewTranslationEmptyLabel() {
        const task = this.fileReviewTasks().find((row: any) => row.key === 'multilingual_translation')
            || this.reviewTaskForArea('translated_text');
        const status = this.fileReviewTaskStatus(task);
        if (status === 'failed') return '원본에는 번역 대상이 있지만 추출 또는 번역 처리에 실패했습니다.';
        if (status === 'not_applicable') return '원본 XML에 번역문 요소가 없거나 번역이 필요하지 않습니다.';
        if (status === 'in_progress') return '번역 결과를 생성하고 있습니다.';
        if (status === 'pending') return task?.reason || '원본에서 외국어 구간이 확인되어 번역 처리가 필요합니다.';
        return '번역문 요소는 확인되었지만 표시할 추출 결과가 없습니다.';
    }

    public reviewTranslationPendingTitle() {
        const status = `${this.multilingualData().status || ''}`;
        if (status === 'failed') return '한국어 번역 처리 실패';
        if (status === 'partial') return '한국어 번역 결과 확인 필요';
        if (status === 'ready') return '한국어 번역 필요';
        return '한국어 번역 처리 전';
    }

    public reviewTranslationActionLabel() {
        if (this.multilingualProcessing) return '한국어 번역 처리 중';
        const status = `${this.multilingualData().status || ''}`;
        return ['failed', 'partial'].includes(status)
            ? '한국어 번역 다시 시도'
            : '한국어 번역 시작';
    }

    public reviewParagraphs() {
        const value = this.profileFieldValue('paragraphs');
        return Array.isArray(value) ? value.map((row: any) => `${row || ''}`) : [];
    }

    public async selectReviewParagraph(index: number) {
        const rows = this.reviewParagraphs();
        this.reviewParagraphIndex = Math.max(0, Math.min(index, Math.max(0, rows.length - 1)));
        this.reviewParagraphDraft = rows[this.reviewParagraphIndex] || '';
        await this.renderPreservingViewport();
    }

    private async commitReviewParagraphs(rows: string[], action: string) {
        const area = this.reviewSections.find((row: any) => row.key === 'paragraphs');
        if (!area) return;
        if (!this.data.profile_fields || typeof this.data.profile_fields !== 'object') {
            this.data.profile_fields = {};
        }
        this.data.profile_fields.paragraphs = rows.map((row: string) => row.trim()).filter(Boolean);
        const active = this.activeBatchItem();
        if (active) {
            const checks = this.normaliseReviewChecks(active.reviewChecks, null, this.reviewKeys(active));
            checks.paragraphs = false;
            active.reviewChecks = checks;
        }
        this.appendProfileReviewHistory('paragraphs', action, `문단 ${rows.length}개`);
        this.reviewParagraphIndex = Math.min(this.reviewParagraphIndex, Math.max(0, rows.length - 1));
        this.reviewParagraphDraft = rows[this.reviewParagraphIndex] || '';
        this.syncActiveBatch();
        await this.renderPreservingViewport();
    }

    public async commitSelectedReviewParagraph() {
        const rows = this.reviewParagraphs();
        if (!rows.length) return;
        rows[this.reviewParagraphIndex] = this.reviewParagraphDraft.trim();
        await this.commitReviewParagraphs(rows.filter(Boolean), 'paragraph_updated');
    }

    public async mergeReviewParagraph(next: boolean = true) {
        const rows = this.reviewParagraphs();
        const target = next ? this.reviewParagraphIndex + 1 : this.reviewParagraphIndex - 1;
        if (!rows.length || target < 0 || target >= rows.length) return;
        const first = Math.min(this.reviewParagraphIndex, target);
        rows.splice(first, 2, `${rows[first]}\n${rows[first + 1]}`.trim());
        this.reviewParagraphIndex = first;
        await this.commitReviewParagraphs(rows, 'paragraph_merged');
    }

    public async splitReviewParagraph(cursorPosition: number | null) {
        const rows = this.reviewParagraphs();
        if (!rows.length) return;
        const draft = this.reviewParagraphDraft || rows[this.reviewParagraphIndex] || '';
        const separator = Math.max(
            0,
            Math.min(Number(cursorPosition), draft.length)
        );
        const first = draft.slice(0, separator).trim();
        const second = draft.slice(separator).trim();
        if (!first || !second) {
            await this.service.modal.error('문단 내용 사이에 커서를 놓은 뒤 다시 분리해주세요.');
            return;
        }
        rows.splice(this.reviewParagraphIndex, 1, first, second);
        await this.commitReviewParagraphs(rows, 'paragraph_split');
    }

    public async resetReviewParagraphs() {
        const original = this.analysisInfo?.profile_fields?.paragraphs;
        if (!Array.isArray(original)) return;
        this.reviewParagraphIndex = 0;
        await this.commitReviewParagraphs(original.map((row: any) => `${row || ''}`), 'paragraph_reset');
    }

    public reviewParagraphAnomalyCount() {
        const rows = this.reviewParagraphs();
        return rows.filter((row: string) => row.length < 8 || row.length > 4000).length;
    }

    public reviewStructuredRows(area: any) {
        const value = this.reviewAreaValue(area);
        if (Array.isArray(value)) return value.map((row: any, index: number) => ({
            index,
            label: row && typeof row === 'object'
                ? `${row.label || row.title || row.value || JSON.stringify(row)}`
                : `${row || ''}`,
            level: row && typeof row === 'object' ? row.level || row.depth || '' : '',
            linked: !(row && typeof row === 'object' && row.linked === false),
        }));
        if (value && typeof value === 'object') {
            return Object.keys(value).map((key: string, index: number) => ({
                index,
                label: `${key}: ${Array.isArray(value[key]) ? value[key].join(', ') : value[key]}`,
                level: '',
                linked: true,
            }));
        }
        return `${value || ''}`.split('\n').filter(Boolean).map((row: string, index: number) => ({
            index, label: row, level: '', linked: true,
        }));
    }

    public entityDecisionUnresolved(entity: any) {
        if (!entity) return false;
        const status = `${entity.link_status || ''}`.trim().toLowerCase();
        const selected = status === 'selected' && !!`${entity.kg_id || ''}`.trim();
        const explicitlyDeferred = ['deferred', 'excluded'].includes(status)
            && (
                !!entity.manually_corrected
                || !!`${entity.selection_reason || ''}`.trim()
            );
        return !selected && !explicitlyDeferred;
    }

    private reviewItemEntities(item: any = this.activeBatchItem()) {
        const form = item === this.activeBatchItem() && this.data
            ? this.data
            : item?.form;
        return Array.isArray(form?.entities) ? form.entities : [];
    }

    public unresolvedEntityDecisionRows(item: any = this.activeBatchItem()) {
        return this.reviewItemEntities(item)
            .map((entity: any, index: number) => ({ entity, index }))
            .filter((row: any) => this.entityDecisionUnresolved(row.entity));
    }

    public unresolvedEntityDecisionCount(item: any = this.activeBatchItem()) {
        return this.unresolvedEntityDecisionRows(item).length;
    }

    public reviewUnresolvedEntityDecisionCount() {
        return this.reviewNavigableFileItems()
            .map((row: any) => row.item)
            .reduce(
                (count: number, item: any) => count + this.unresolvedEntityDecisionCount(item),
                0,
            );
    }

    public registrationEntityRows() {
        const query = this.registrationEntitySearch.trim().toLocaleLowerCase();
        return (Array.isArray(this.data?.entities) ? this.data.entities : [])
            .map((entity: any, index: number) => ({ entity, index }))
            .filter((row: any) => {
                const status = (
                    this.entityDecisionUnresolved(row.entity)
                    || this.finalCorrectionEntityNeedsAttention(row.entity)
                ) ? 'attention'
                    : row.entity.link_status === 'selected' ? 'linked' : 'reviewed';
                const text = `${row.entity.text || ''} ${row.entity.normalized || ''} ${row.entity.hanja || ''}`.toLocaleLowerCase();
                return (this.registrationEntityStatus === 'all' || this.registrationEntityStatus === status)
                    && (!query || text.includes(query));
            });
    }

    public registrationEntityPageRows() {
        const rows = this.registrationEntityRows();
        const start = (this.registrationEntityPage - 1) * this.registrationEntityPageSize;
        return rows.slice(start, start + this.registrationEntityPageSize);
    }

    public registrationEntityPageCount() {
        return Math.max(1, Math.ceil(this.registrationEntityRows().length / this.registrationEntityPageSize));
    }

    public registrationEntityBulkEligibleCount() {
        return this.registrationEntityRows().filter((row: any) => (
            (
                this.entityDecisionUnresolved(row.entity)
                || this.finalCorrectionEntityNeedsAttention(row.entity)
            )
            && row.entity.link_status !== 'selected'
        )).length;
    }

    public async deferFilteredRegistrationEntities() {
        const rows = this.registrationEntityRows().filter((row: any) => (
            (
                this.entityDecisionUnresolved(row.entity)
                || this.finalCorrectionEntityNeedsAttention(row.entity)
            )
            && row.entity.link_status !== 'selected'
        ));
        if (!rows.length) {
            await this.entityActionError('현재 필터에는 일괄 보류할 미연결 확인 필요 개체가 없습니다.');
            return;
        }
        rows.forEach((row: any) => {
            row.entity.kg_id = '';
            row.entity.link_status = 'deferred';
            row.entity.selection_reason = '현재 필터의 미연결 확인 필요 개체를 일괄 보류';
            row.entity.manually_corrected = true;
        });
        this.appendProfileReviewHistory(
            'entities',
            'filtered_entities_deferred',
            `미연결 확인 필요 ${rows.length}개`,
        );
        this.syncEntityProfileField();
        await this.renderPreservingViewport();
    }

    public selectedRegistrationEntity() {
        return Array.isArray(this.data?.entities)
            ? this.data.entities[this.registrationEntityIndex] || null : null;
    }

    public async selectRegistrationEntity(index: number) {
        this.registrationEntityIndex = index;
        await this.renderPreservingViewport();
    }

    public async applyRegistrationEntityFilter() {
        this.registrationEntityPage = 1;
        const first = this.registrationEntityRows()[0];
        if (first) this.registrationEntityIndex = first.index;
        await this.renderPreservingViewport();
    }

    public async focusUnresolvedEntityDecisions() {
        const rows = this.unresolvedEntityDecisionRows();
        if (!rows.length) return;
        this.reviewSection = 'entities';
        this.registrationEntitySearch = '';
        this.registrationEntityStatus = 'attention';
        this.registrationEntityPage = 1;
        this.registrationEntityIndex = rows[0].index;
        await this.renderPreservingViewport();
    }

    private async focusFirstUnresolvedEntityDecision() {
        this.syncActiveBatch();
        const target = this.reviewNavigableFileItems()
            .map((row: any) => ({
                item: row.item,
                index: row.index,
                rows: this.unresolvedEntityDecisionRows(row.item),
            }))
            .find((row: any) => (
                this.reviewItemCanBeReviewed(row.item) && row.rows.length > 0
            ));
        if (!target) return;
        await this.selectBatchItem(target.index);
        this.reviewFileFilter = 'attention';
        this.reviewSection = 'entities';
        this.registrationEntitySearch = '';
        this.registrationEntityStatus = 'attention';
        this.registrationEntityPage = 1;
        this.registrationEntityIndex = target.rows[0].index;
        await this.renderPreservingViewport();
    }

    private async advanceToNextUnresolvedEntityDecision(previousIndex: number) {
        const rows = this.unresolvedEntityDecisionRows();
        if (!rows.length) {
            await this.service.render();
            return;
        }
        const target = rows.find((row: any) => row.index > previousIndex) || rows[0];
        this.registrationEntitySearch = '';
        this.registrationEntityStatus = 'attention';
        this.registrationEntityIndex = target.index;
        const visibleRows = this.registrationEntityRows();
        const visibleIndex = visibleRows.findIndex(
            (row: any) => row.index === target.index
        );
        this.registrationEntityPage = visibleIndex >= 0
            ? Math.floor(visibleIndex / this.registrationEntityPageSize) + 1
            : 1;
        await this.renderPreservingViewport();
    }

    public async goToNextRegistrationEntityIssue() {
        const rows = (Array.isArray(this.data?.entities) ? this.data.entities : [])
            .map((entity: any, index: number) => ({ entity, index }))
            .filter((row: any) => (
                this.entityDecisionUnresolved(row.entity)
                || this.finalCorrectionEntityNeedsAttention(row.entity)
            ));
        if (!rows.length) return;
        const current = rows.findIndex((row: any) => row.index === this.registrationEntityIndex);
        const target = rows[(current + 1 + rows.length) % rows.length];
        this.registrationEntityIndex = target.index;
        await this.renderPreservingViewport();
    }

    public reviewSourceSizeLabel() {
        const size = this.safeNumber(this.analysisInfo?.source?.size, 0);
        if (size >= 1024 * 1024) return `${(size / 1024 / 1024).toFixed(1)} MB`;
        if (size >= 1024) return `${Math.round(size / 1024).toLocaleString()} KB`;
        return `${size.toLocaleString()} B`;
    }

    public reviewSourceChecksum() {
        const checksum = `${this.analysisInfo?.source?.checksum_sha256 || ''}`;
        return checksum ? `${checksum.slice(0, 12)}…${checksum.slice(-8)}` : 'checksum 미확인';
    }

    public documentProfileExtractors() {
        const profile = this.documentProfile();
        return Array.isArray(profile.extractors) ? profile.extractors : [];
    }

    public documentProfileSelectionLabel() {
        const profile = this.documentProfile();
        if (!profile.key) return '자동 판별 대기';
        return profile.selected_by_user
            ? '사용자 선택'
            : `자동 판별 · ${profile.label || profile.key}`;
    }

    private syncReviewSections() {
        this.reviewSections = this.documentProfileReviewItems().map((item: any, index: number) => ({
            ...item,
            order: `${index + 1}`.padStart(2, '0'),
        }));
        if (!this.reviewSections.some((item: any) => item.key === this.reviewSection)) {
            this.reviewSection = this.reviewSections.length ? this.reviewSections[0].key : '';
        }
    }

    private reviewKeys(item: any = null) {
        const analysis = item && item.analysis ? item.analysis : this.analysisInfo;
        const form = item && item.form ? item.form : (!item ? this.data : null);
        return this.documentProfileReviewItems(analysis, form).map((row: any) => row.key);
    }

    public activeProfileReviewItem() {
        return this.reviewSections.find((item: any) => item.key === this.reviewSection)
            || this.reviewSections[0]
            || null;
    }

    public profileFieldValue(key: string, form: any = null) {
        const target = form || this.data || {};
        const fields = target.profile_fields && typeof target.profile_fields === 'object'
            ? target.profile_fields : {};
        return typeof fields[key] === 'undefined' ? '' : fields[key];
    }

    public profileFieldHasValue(key: string, form: any = null) {
        const value = this.profileFieldValue(key, form);
        if (Array.isArray(value)) return value.length > 0;
        if (value && typeof value === 'object') return Object.keys(value).length > 0;
        return !!`${value || ''}`.trim();
    }

    public profileFieldEditorValue(item: any) {
        if (!item) return '';
        const value = this.profileFieldValue(item.key);
        if (Array.isArray(value)) {
            if (item.input_type === 'entities') {
                return value.map((row: any) => (
                    row && typeof row === 'object'
                        ? `${row.text || row.normalized || ''}`
                        : `${row || ''}`
                )).filter(Boolean).join('\n');
            }
            return value.map((row: any) => (
                row && typeof row === 'object' ? JSON.stringify(row) : `${row || ''}`
            )).join('\n');
        }
        if (value && typeof value === 'object') {
            return Object.keys(value).map((key: string) => {
                const row = value[key];
                return `${key}: ${Array.isArray(row) ? row.join(', ') : row}`;
            }).join('\n');
        }
        return `${value || ''}`;
    }

    public profileFieldDisplayValue(item: any) {
        const value = this.profileFieldEditorValue(item);
        return value || '추출된 값이 없습니다.';
    }

    public profileFieldItemCount(item: any) {
        const value = item ? this.profileFieldValue(item.key) : null;
        if (Array.isArray(value)) return value.length;
        if (value && typeof value === 'object') return Object.keys(value).length;
        return `${value || ''}`.trim() ? 1 : 0;
    }

    public profileFieldReadonly(item: any) {
        return !!item && ['image', 'attachment'].includes(item.input_type);
    }

    public documentProfileSourceUrl() {
        if (!this.analysisId) return '';
        const query = new URLSearchParams({
            mode: 'source_file',
            analysis_id: this.analysisId,
        });
        return `/wiz/api/portal.post.detail/analyze?${query.toString()}`;
    }

    public pendingImageAssets() {
        const value = this.analysisInfo?.image_assets;
        return value && typeof value === 'object'
            ? value
            : { total: 0, ready: 0, missing: 0, failed: 0, page: 1, pages: 1, items: [] };
    }

    public pendingImageAssetRows() {
        return Array.isArray(this.pendingImageAssets()?.items)
            ? this.pendingImageAssets().items : [];
    }

    public pendingImageAssetUrl(asset: any, variant: 'preview' | 'original' = 'preview') {
        if (!this.analysisId || !asset?.id) return '';
        const query = new URLSearchParams({
            mode: 'image_asset',
            analysis_id: this.analysisId,
            asset_id: `${asset.id}`,
            variant,
            v: `${asset.checksum_sha256 || this.analysisInfo?.source?.checksum_sha256 || ''}`,
        });
        return `/wiz/api/portal.post.detail/analyze?${query.toString()}`;
    }

    private replacePendingImageAsset(updated: any) {
        const page = this.pendingImageAssets();
        const rows = this.pendingImageAssetRows();
        const index = rows.findIndex((row: any) => row?.id === updated?.id);
        if (index < 0) return;
        const previousStatus = `${rows[index]?.status || ''}`;
        const nextStatus = `${updated?.status || previousStatus}`;
        rows[index] = { ...rows[index], ...updated };
        if (previousStatus !== nextStatus) {
            for (const status of ['ready', 'missing', 'failed']) {
                const delta = (nextStatus === status ? 1 : 0)
                    - (previousStatus === status ? 1 : 0);
                page[status] = Math.max(0, this.safeNumber(page[status], 0) + delta);
            }
        }
    }

    public async materializePendingImageAsset(asset: any) {
        if (!this.analysisId || !asset?.id || this.pendingImageAssetMaterializing[asset.id]) return;
        this.pendingImageAssetMaterializing[asset.id] = true;
        this.pendingImageAssetsError = '';
        try {
            const result = await wiz.call('analyze', {
                mode: 'materialize_image_asset',
                analysis_id: this.analysisId,
                asset_id: asset.id,
            });
            this.replacePendingImageAsset(result?.data || {});
        } catch (error) {
            const captured = this.captureError(
                error, '이미지를 스토리지에 저장하지 못했습니다.'
            );
            this.pendingImageAssetsError = captured.message;
        } finally {
            delete this.pendingImageAssetMaterializing[asset.id];
            await this.service.render();
        }
    }

    public async loadPendingImageAssetPage(page: number) {
        if (!this.analysisId) return;
        this.pendingImageAssetsError = '';
        try {
            const result = await wiz.call('analyze', {
                mode: 'image_assets',
                analysis_id: this.analysisId,
                page: Math.max(1, page),
                page_size: 24,
            });
            this.analysisInfo.image_assets = result?.data || this.pendingImageAssets();
        } catch (error) {
            const captured = this.captureError(
                error, '이미지 목록을 불러오지 못했습니다.'
            );
            this.pendingImageAssetsError = captured.message;
        }
        await this.service.render();
    }

    public async movePendingImageAssetPage(offset: number) {
        const assets = this.pendingImageAssets();
        const next = Math.max(
            1,
            Math.min(
                this.safeNumber(assets.pages, 1),
                this.safeNumber(assets.page, 1) + offset,
            ),
        );
        if (next !== this.safeNumber(assets.page, 1)) {
            await this.loadPendingImageAssetPage(next);
        }
    }

    public async updateProfileField(item: any, rawValue: any) {
        if (!item || this.profileFieldReadonly(item) || !this.data) return;
        if (!this.data.profile_fields || typeof this.data.profile_fields !== 'object') {
            this.data.profile_fields = {};
        }
        let value: any = `${rawValue || ''}`;
        if (['string_list', 'entities'].includes(item.input_type)) {
            const rows = value.split('\n').map((row: string) => row.trim()).filter(Boolean);
            value = item.input_type === 'entities'
                ? rows.map((text: string) => ({ text, normalized: text, type: 'OTHER', confidence: 1 }))
                : rows;
        } else if (item.input_type === 'key_value') {
            const values: any = {};
            value.split('\n').forEach((row: string) => {
                const separator = row.indexOf(':');
                if (separator <= 0) return;
                const key = row.slice(0, separator).trim();
                const rowValue = row.slice(separator + 1).trim();
                if (key && rowValue) values[key] = rowValue;
            });
            value = values;
        }
        this.data.profile_fields[item.key] = value;
        if (item.key === 'original_text') this.data.ocr_text = `${rawValue || ''}`;
        if (item.key === 'description') this.data.content = `${rawValue || ''}`;
        if (item.key === 'title') this.data.title = `${rawValue || ''}`;
        if (item.key === 'authors') this.data.authors = Array.isArray(value) ? value.join(', ') : `${rawValue || ''}`;
        if (item.key === 'publisher') this.data.publisher = `${rawValue || ''}`;
        if (item.key === 'publication_date') {
            this.data.issued_dates = this.normaliseDateValues(rawValue);
            this.data.document_date = this.data.issued_dates[0]
                || this.normaliseDateValues(this.data.created_dates)[0] || '';
            this.onMetadataFieldChange('issued_dates', this.data.issued_dates);
        }
        if (item.key === 'entities') {
            this.data.entities = Array.isArray(value)
                ? value.map(
                    (row: any, index: number) => this.prepareEntityForReview(row, index)
                )
                : [];
            this.data.profile_fields[item.key] = this.data.entities.map(
                (row: any) => ({ ...row })
            );
        }
        const active = this.activeBatchItem();
        if (active) {
            const checks = this.normaliseReviewChecks(active.reviewChecks, null, this.reviewKeys(active));
            checks[item.key] = false;
            active.reviewChecks = checks;
        }
        if (!this.isNewPost() && this.savedReviewHydrated) {
            const contentKey = this.savedContentReviewKey(item.key);
            if (contentKey) this.savedContentReviewChecks[contentKey] = false;
            this.markSavedReviewDirty();
        }
        this.syncActiveBatch();
        await this.service.render();
    }

    public async changeDocumentProfile(profileKey: string) {
        const item = this.activeBatchItem();
        if (
            !item
            || !item.analysis
            || this.documentProfileChanging
            || profileKey === this.documentProfile().key
        ) return;
        const allowed = this.documentProfileOptions().some((row: any) => row.key === profileKey);
        if (!allowed) return;
        this.syncActiveBatch();
        this.documentProfileChanging = true;
        await this.service.render();
        try {
            const result = await wiz.call('analyze', {
                mode: 'document_profile',
                analysis_id: item.analysis.id,
                document_profile: profileKey,
            });
            if (!result || result.code !== 200 || !result.data?.analysis) {
                throw new Error(result?.data?.message || '자료 유형을 변경하지 못했습니다.');
            }
            const analysis = this.normaliseAnalysis(result.data.analysis);
            item.analysis = analysis;
            item.requestedProfile = profileKey;
            item.form.document_profile = profileKey;
            item.form.profile_fields = JSON.parse(JSON.stringify(analysis.profile_fields || {}));
            this.analysisInfo = analysis;
            this.analysisId = analysis.id;
            this.data.document_profile = profileKey;
            this.data.profile_fields = JSON.parse(JSON.stringify(analysis.profile_fields || {}));
            item.reviewChecks = this.normaliseReviewChecks(
                {},
                null,
                this.reviewKeys(item),
            );
            this.reviewSection = '';
            this.syncReviewSections();
            this.queueRegistrationRecoverySave();
        } catch (error) {
            const captured = this.captureError(error, '자료 유형을 변경하지 못했습니다.');
            await this.service.modal.error(captured.message);
        } finally {
            this.documentProfileChanging = false;
            await this.service.render();
        }
    }

    private syncActiveBatch() {
        if (this.activeBatchIndex < 0 || !this.batchItems[this.activeBatchIndex]) return;
        this.batchItems[this.activeBatchIndex].form = this.cloneForm(this.data);
        this.queueRegistrationRecoverySave();
    }

    public async selectBatchItem(index: number) {
        const item = this.batchItems[index];
        if (!item || !item.analysis || !item.form) return;
        const fileChanged = index !== this.activeBatchIndex;
        this.syncActiveBatch();
        this.activeBatchIndex = index;
        this.analysisInfo = item.analysis;
        this.analysisId = item.analysis.id;
        this.data = this.cloneForm(item.form);
        this.initialiseMetadataReviewFocus();
        this.metadataReviewScopeMode = 'representative';
        this.metadataHierarchySearch = '';
        this.metadataHierarchyActiveUnitIds = {};
        this.initialiseDtdReviewFocus();
        if (fileChanged) this.reviewSection = '';
        this.syncReviewSections();
        this.reviewTextPage = 1;
        this.reviewTranslationPage = 1;
        this.reviewTranslationCandidateExpandedIndex = -1;
        this.reviewParagraphIndex = 0;
        this.reviewParagraphDraft = this.reviewParagraphs()[0] || '';
        this.registrationEntityPage = 1;
        this.registrationEntityIndex = 0;
        this.resetLayoutInspector();
        this.multilingualViewerOpen = false;
        this.selectedTranslationPage = 0;
        this.translationPdfState = 'idle';
        this.translationPdfError = '';
        this.translationPdfPreview = '';
        this.translationPdfPageCache = {};
        this.translationPdfRequestId += 1;
        this.translationRailCollapsed = false;
        this.translationMobilePane = 'source';
        this.selectedOcrCandidate = null;
        this.ocrCorrectionValue = '';
        this.ocrModalOpen = false;
        this.ocrPageNumber = 1;
        this.ocrPageCache = {};
        this.ocrSavedPages = {};
        if (this.metadataSection === 'bibliography') {
            this.syncMetadataReviewFilePageToIndex(index);
        }
        await this.service.render();
    }

    public async setBatchVisibility(index: number, status: 'draft' | 'published', event?: Event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        const item = this.batchItems[index];
        if (!item || item.status !== 'complete' || !item.form) return;
        if (this.activeBatchIndex === index && this.data) this.syncActiveBatch();
        item.form.status = status;
        item.visibilityConfirmed = true;
        item.visibilityStatus = status;
        if (this.activeBatchIndex === index && this.data) this.data.status = status;
        this.queueRegistrationRecoverySave();
        await this.service.render();
    }

    private visibilitySelectionKey(item: any, index: number) {
        const analysisId = `${item?.analysis?.id || ''}`.trim();
        if (analysisId) return `analysis:${analysisId}`;
        const progressId = `${item?.progressId || ''}`.trim();
        if (progressId) return `progress:${progressId}`;
        const source = item?.analysis?.source || {};
        const checksum = `${source.checksum_sha256 || item?.preflightHash || ''}`.trim();
        if (checksum) return `checksum:${checksum}:${index}`;
        return `batch:${index}:${item?.sourceUrl || item?.name || ''}`;
    }

    private visibilityIdentifierValues(item: any) {
        const values: string[] = [];
        const add = (value: any) => {
            if (Array.isArray(value)) {
                value.forEach((row: any) => add(row));
                return;
            }
            const text = `${value || ''}`.trim();
            if (text && !values.includes(text)) values.push(text);
        };
        const analysis = item?.analysis || {};
        const classification = analysis.nahf_item_classification || {};
        const probe = this.sourceProbe(analysis);
        add(classification.item_code);
        add(classification.observed_identifiers);
        add(probe.nahf_item_code);
        add(analysis.id);
        add(analysis.source?.checksum_sha256);

        const sourceUrl = `${item?.sourceUrl || analysis.source?.url || ''}`.trim();
        if (sourceUrl) {
            try {
                const parsed = new URL(sourceUrl, window.location.origin);
                parsed.searchParams.forEach((value: string, key: string) => {
                    if (['itemid', 'levelid'].includes(key.toLowerCase())) add(value);
                });
            } catch (_) { }
        }
        return values;
    }

    public visibilityItemIdentifier(item: any) {
        const analysis = item?.analysis || {};
        const classification = analysis.nahf_item_classification || {};
        const observed = Array.isArray(classification.observed_identifiers)
            ? classification.observed_identifiers : [];
        return `${
            classification.item_code
            || observed[0]
            || this.sourceProbe(analysis).nahf_item_code
            || analysis.id
            || ''
        }`.trim();
    }

    private visibilitySearchText(item: any) {
        return [
            item?.form?.title,
            item?.name,
            item?.form?.source_name,
            ...this.visibilityIdentifierValues(item),
        ].map((value: any) => `${value || ''}`.trim()).filter(Boolean).join(' ').toLocaleLowerCase('ko-KR');
    }

    public async setVisibilitySearch(value: any) {
        this.visibilitySearch = `${value || ''}`;
        this.visibilityPage = 1;
        await this.service.render();
    }

    public async clearVisibilitySearch() {
        await this.setVisibilitySearch('');
    }

    public async setVisibilityStatusFilter(value: any) {
        const status = `${value || ''}`;
        this.visibilityStatusFilter = ['published', 'draft', 'unset'].includes(status)
            ? status as 'published' | 'draft' | 'unset'
            : 'all';
        this.visibilityPage = 1;
        await this.service.render();
    }

    public async resetVisibilityDiscovery() {
        this.visibilitySearch = '';
        this.visibilityStatusFilter = 'all';
        this.visibilityPage = 1;
        await this.service.render();
    }

    public visibilityFilterCount(status: 'all' | 'published' | 'draft' | 'unset') {
        if (status === 'all') return this.batchItems.length;
        if (status === 'unset') return this.visibilityUnsetCount();
        return this.visibilityStatusCount(status);
    }

    public visibilityEligibleCount() {
        return this.batchItems.filter((item: any) => (
            item?.status === 'complete' && !!item?.form
        )).length;
    }

    public visibilityUnavailableCount() {
        return Math.max(0, this.batchItems.length - this.visibilityEligibleCount());
    }

    public visibilityFilteredRows() {
        const query = `${this.visibilitySearch || ''}`.trim().toLocaleLowerCase('ko-KR');
        const filter = this.visibilityStatusFilter;
        return this.batchItems
            .map((item: any, index: number) => ({ item, index }))
            .filter((row: any) => {
                const item = row.item;
                if (query && !this.visibilitySearchText(item).includes(query)) return false;
                if (filter === 'all') return true;
                if (!item || item.status !== 'complete' || !item.form) return false;
                if (filter === 'unset') return !item.visibilityConfirmed;
                return !!item.visibilityConfirmed && item.form.status === filter;
            });
    }

    public visibilityPageCount() {
        return Math.max(1, Math.ceil(
            this.visibilityFilteredRows().length / this.visibilityPageSize
        ));
    }

    public visibilityPageRows() {
        const rows = this.visibilityFilteredRows();
        const page = Math.min(
            Math.max(1, this.visibilityPage),
            Math.max(1, Math.ceil(rows.length / this.visibilityPageSize))
        );
        const start = (page - 1) * this.visibilityPageSize;
        return rows.slice(start, start + this.visibilityPageSize);
    }

    public visibilityPageRangeLabel() {
        const count = this.visibilityFilteredRows().length;
        if (!count) return '표시할 자료 없음';
        const page = Math.min(Math.max(1, this.visibilityPage), this.visibilityPageCount());
        const start = (page - 1) * this.visibilityPageSize + 1;
        const end = Math.min(count, start + this.visibilityPageSize - 1);
        return `${start.toLocaleString('ko-KR')}–${end.toLocaleString('ko-KR')} / ${count.toLocaleString('ko-KR')}개`;
    }

    public async setVisibilityPage(page: number) {
        this.visibilityPage = Math.min(
            Math.max(1, Number(page) || 1),
            this.visibilityPageCount()
        );
        await this.service.render();
    }

    public resolvedVisibilityInspectorIndex() {
        const rows = this.visibilityPageRows();
        const selected = Number(this.selectedVisibilityInspectorIndex);
        if (
            this.selectedVisibilityInspectorIndex !== null
            && Number.isInteger(selected)
            && rows.some((row: any) => row.index === selected)
        ) {
            return selected;
        }
        if (rows.some((row: any) => row.index === this.activeBatchIndex)) {
            return this.activeBatchIndex;
        }
        return rows.length ? rows[0].index : -1;
    }

    public visibilityInspectorItem() {
        const index = this.resolvedVisibilityInspectorIndex();
        return index >= 0 ? this.batchItems[index] : null;
    }

    public async toggleVisibilityInspector() {
        this.visibilityInspectorOpen = !this.visibilityInspectorOpen;
        await this.service.render();
    }

    public async selectVisibilityInspector(index: number, event?: Event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        const item = this.batchItems[index];
        if (!item) return;
        this.selectedVisibilityInspectorIndex = index;
        this.visibilityInspectorOpen = true;
        if (item.analysis && item.form) {
            await this.selectBatchItem(index);
            return;
        }
        await this.service.render();
    }

    public visibilitySourceStateLabel(item: any) {
        if (!item || item.status !== 'complete' || !item.analysis) {
            return '분석 완료 후 확인';
        }
        const notice = this.sourceVisibilityNotice(item);
        if (!notice) return 'XML 공개정보 없음';
        const stateClass = this.sourceVisibilityNoticeClass(item);
        if (stateClass === 'is-warning') return 'XML 값 직접 확인 필요';
        if (stateClass === 'is-manual') return 'XML 값에서 직접 변경';
        return 'XML 공개정보 자동 반영';
    }

    public visibilitySourceStateClass(item: any) {
        if (!item || item.status !== 'complete' || !item.analysis) return 'is-disabled';
        const stateClass = this.sourceVisibilityNoticeClass(item);
        if (!this.sourceVisibilityNotice(item)) return 'is-neutral';
        if (stateClass === 'is-warning') return 'is-warning';
        if (stateClass === 'is-manual') return 'is-manual';
        return 'is-applied';
    }

    public visibilityFilteredSelectableRows() {
        return this.visibilityFilteredRows().filter((row: any) => (
            row.item?.status === 'complete' && !!row.item?.form
        ));
    }

    private visibilitySelectedKeySet() {
        if (this.selectedVisibilityKeySetSource !== this.selectedVisibilityKeys) {
            this.selectedVisibilityKeySetSource = this.selectedVisibilityKeys;
            this.selectedVisibilityKeySet = new Set(this.selectedVisibilityKeys);
        }
        return this.selectedVisibilityKeySet;
    }

    private setVisibilitySelectionKeys(keys: string[]) {
        this.selectedVisibilityKeys = Array.from(new Set(keys));
        this.selectedVisibilityKeySetSource = this.selectedVisibilityKeys;
        this.selectedVisibilityKeySet = new Set(this.selectedVisibilityKeys);
    }

    private applyVisibilitySelectionFeedback(
        checked: boolean,
        event?: Event,
        updateVisibleRows: boolean = false,
    ) {
        const target = event?.target as HTMLElement | null;
        const input = target && `${(target as HTMLInputElement).type || ''}` === 'checkbox'
            ? target as HTMLInputElement : null;
        if (input) {
            input.checked = checked;
            input.indeterminate = false;
        }
        if (!updateVisibleRows) {
            input?.closest('li')?.classList.toggle('is-bulk-selected', checked);
            return;
        }
        const root = target?.closest('.visibility-command-main');
        root?.querySelectorAll(
            '.visibility-command-row-select input[type="checkbox"]:not(:disabled)'
        ).forEach((rowInput: HTMLInputElement) => {
            rowInput.checked = checked;
            rowInput.closest('li')?.classList.toggle('is-bulk-selected', checked);
        });
    }

    private queueVisibilitySelectionRender() {
        if (this.visibilitySelectionRenderQueued) return;
        this.visibilitySelectionRenderQueued = true;
        const renderAfterPaint = () => {
            setTimeout(async () => {
                this.visibilitySelectionRenderQueued = false;
                await this.service.render();
            }, 0);
        };
        if (typeof window !== 'undefined' && typeof window.requestAnimationFrame === 'function') {
            window.requestAnimationFrame(renderAfterPaint);
            return;
        }
        renderAfterPaint();
    }

    public visibilityItemSelected(item: any, index: number) {
        return this.visibilitySelectedKeySet().has(
            this.visibilitySelectionKey(item, index)
        );
    }

    public toggleVisibilitySelection(index: number, checked: boolean, event?: Event) {
        if (event) {
            event.stopPropagation();
        }
        const item = this.batchItems[index];
        if (!item || item.status !== 'complete' || !item.form) return;
        const key = this.visibilitySelectionKey(item, index);
        const selected = new Set(this.visibilitySelectedKeySet());
        if (checked) selected.add(key);
        else selected.delete(key);
        this.setVisibilitySelectionKeys(Array.from(selected));
        this.applyVisibilitySelectionFeedback(checked, event);
        this.queueVisibilitySelectionRender();
    }

    public visibilitySelectedCount() {
        return this.batchItems.filter((item: any, index: number) => (
            item?.status === 'complete'
            && !!item?.form
            && this.visibilityItemSelected(item, index)
        )).length;
    }

    public visibilityFilteredSelectedCount() {
        return this.visibilityFilteredSelectableRows().filter((row: any) => (
            this.visibilityItemSelected(row.item, row.index)
        )).length;
    }

    public visibilityAllFilteredSelected() {
        const rows = this.visibilityFilteredSelectableRows();
        return rows.length > 0 && rows.every((row: any) => (
            this.visibilityItemSelected(row.item, row.index)
        ));
    }

    public visibilitySomeFilteredSelected() {
        const count = this.visibilityFilteredSelectedCount();
        return count > 0 && !this.visibilityAllFilteredSelected();
    }

    public toggleFilteredVisibilitySelection(checked: boolean, event?: Event) {
        const selected = new Set(this.visibilitySelectedKeySet());
        this.visibilityFilteredSelectableRows().forEach((row: any) => {
            const key = this.visibilitySelectionKey(row.item, row.index);
            if (checked) selected.add(key);
            else selected.delete(key);
        });
        this.setVisibilitySelectionKeys(Array.from(selected));
        this.applyVisibilitySelectionFeedback(checked, event, true);
        this.queueVisibilitySelectionRender();
    }

    public async clearVisibilitySelection() {
        this.selectedVisibilityKeys = [];
        await this.service.render();
    }

    public async setSelectedBatchVisibility(status: 'draft' | 'published') {
        this.syncActiveBatch();
        const selected = new Set(this.selectedVisibilityKeys);
        let activeUpdated = false;
        this.batchItems.forEach((item: any, index: number) => {
            if (
                !item
                || item.status !== 'complete'
                || !item.form
                || !selected.has(this.visibilitySelectionKey(item, index))
            ) return;
            item.form.status = status;
            item.visibilityConfirmed = true;
            item.visibilityStatus = status;
            this.captureRegistrationLocalDraft(item, item.form);
            if (this.activeBatchIndex === index) activeUpdated = true;
        });
        if (activeUpdated && this.data) this.data.status = status;
        this.queueRegistrationRecoverySave();
        await this.renderPreservingViewport();
    }

    public trackByVisibilityRow(_index: number, row: any) {
        const item = row && row.item ? row.item : {};
        const rowIndex = Number.isFinite(Number(row && row.index))
            ? Number(row.index) : _index;
        const analysisId = `${item?.analysis?.id || ''}`.trim();
        if (analysisId) return `analysis:${analysisId}`;
        const progressId = `${item?.progressId || ''}`.trim();
        if (progressId) return `progress:${progressId}`;
        const source = item?.analysis?.source || {};
        const checksum = `${source.checksum_sha256 || item?.preflightHash || ''}`.trim();
        if (checksum) return `checksum:${checksum}:${rowIndex}`;
        return `batch:${rowIndex}:${item?.sourceUrl || item?.name || ''}`;
    }

    public sourceVisibilityNotice(item: any) {
        const visibility = this.sourceVisibility(item?.analysis);
        if (!visibility.explicit) return '';
        if (!visibility.resolved) {
            return visibility.reason === 'conflicting_explicit_visibility_values'
                ? 'XML 공개 여부 값이 서로 달라 직접 선택이 필요합니다.'
                : 'XML 공개 여부 값을 해석할 수 없어 직접 선택이 필요합니다.';
        }
        const sourceStatus = this.sourceVisibilityStatus(item?.analysis);
        if (!sourceStatus) return '';
        const sourceLabel = sourceStatus === 'published' ? '공개' : '비공개';
        const currentStatus = `${item?.form?.status || ''}`;
        const rawValues = (Array.isArray(visibility.evidence) ? visibility.evidence : [])
            .filter((row: any) => !row?.scope || row.scope === 'document')
            .map((row: any) => `${row?.raw_value || ''}`.trim())
            .filter((value: string, index: number, rows: string[]) => (
                !!value && rows.indexOf(value) === index
            ))
            .slice(0, 2)
            .join(', ');
        if (currentStatus && currentStatus !== sourceStatus) {
            const currentLabel = currentStatus === 'published' ? '공개' : '비공개';
            return `XML 원문은 ${sourceLabel} · 현재 ${currentLabel}로 직접 설정했습니다.`;
        }
        return `XML 공개 여부 자동 반영 · ${sourceLabel}${rawValues ? ` (원문 ${rawValues})` : ''}`;
    }

    public sourceVisibilityNoticeClass(item: any) {
        const visibility = this.sourceVisibility(item?.analysis);
        if (!visibility.resolved) return 'is-warning';
        return `${item?.form?.status || ''}` === this.sourceVisibilityStatus(item?.analysis)
            ? 'is-applied' : 'is-manual';
    }

    public visibilityStatusCount(status: 'draft' | 'published') {
        return this.batchItems.filter((item: any) => (
            item.status === 'complete'
            && item.visibilityConfirmed
            && item.form?.status === status
        )).length;
    }

    public visibilityUnsetCount() {
        return this.batchItems.filter((item: any) => (
            item.status === 'complete' && !item.visibilityConfirmed
        )).length;
    }

    public allBatchVisibilityActive(status: 'draft' | 'published') {
        const targetCount = this.visibilityTargetCount();
        return targetCount > 0
            && this.visibilityUnsetCount() === 0
            && this.visibilityStatusCount(status) === targetCount;
    }

    public async setAllBatchVisibility(status: 'draft' | 'published') {
        this.syncActiveBatch();
        let activeUpdated = false;
        this.batchItems.forEach((item: any, index: number) => {
            if (!item || item.status !== 'complete' || !item.form) return;
            item.form.status = status;
            item.visibilityConfirmed = true;
            item.visibilityStatus = status;
            this.captureRegistrationLocalDraft(item, item.form);
            if (this.activeBatchIndex === index) activeUpdated = true;
        });
        if (activeUpdated && this.data) this.data.status = status;
        this.queueRegistrationRecoverySave();
        await this.renderPreservingViewport();
    }

    public metadataSectionIndex(key: MetadataSectionKey = this.metadataSection) {
        const visibleKey = !this.deferredRegistrationReviewStagesVisible && key === 'layout'
            ? 'bibliography' : key;
        return this.metadataSections.findIndex((section: any) => section.key === visibleKey);
    }

    public metadataSectionActive(key: MetadataSectionKey) {
        return this.metadataSectionIndex() === this.metadataSectionIndex(key);
    }

    public registrationStepActive(key: RegisterStepKey) {
        const activeKey = !this.deferredRegistrationReviewStagesVisible
            && this.registerStep === 'manual'
            ? 'complete' : this.registerStep;
        return activeKey === key;
    }

    public reviewSectionIndex(key: ReviewSectionKey = this.reviewSection) {
        return this.reviewSections.findIndex((section: any) => section.key === key);
    }

    private normaliseReviewChecks(value: any, fallback: any = null, keys: string[] = []) {
        const source = value && typeof value === 'object' ? value : {};
        const base = fallback && typeof fallback === 'object' ? fallback : {};
        const result: any = {};
        Array.from(new Set([
            ...Object.keys(base),
            ...Object.keys(source),
            ...keys,
        ])).forEach((key: string) => {
            result[key] = typeof source[key] === 'boolean'
                ? source[key]
                : !!base[key];
        });
        return result;
    }

    private defaultReviewChecks(analysis: any, form: any) {
        const keys = this.documentProfileReviewItems(analysis, form).map((row: any) => row.key);
        return keys.reduce((checks: any, key: string) => {
            checks[key] = false;
            return checks;
        }, {});
    }

    public activeBatchItem() {
        return this.activeBatchIndex >= 0 ? this.batchItems[this.activeBatchIndex] : null;
    }

    public reviewFileName(item: any) {
        const resolvedName = `${
            item?.analysis?.source?.name
            || item?.form?.source_name
            || ''
        }`.trim();
        return resolvedName || `${item?.name || ''}`.trim() || '현재 파일';
    }

    public reviewFileSelectLabel(item: any) {
        const fileName = this.reviewFileName(item);
        const sourceUrl = `${item?.sourceUrl || ''}`.trim();
        return sourceUrl && sourceUrl !== fileName
            ? `${fileName} · ${sourceUrl}`
            : fileName;
    }

    public reviewTargetCount() {
        return this.reviewNavigableFileCount();
    }

    public reviewItemCanBeReviewed(item: any) {
        return !!item?.analysis && !!item?.form;
    }

    public reviewNavigableFileItems() {
        return this.batchItems
            .map((item: any, index: number) => ({ item, index }))
            .filter((row: any) => (
                this.reviewItemCanBeReviewed(row.item)
                && this.metadataAdvanceItemIncluded(row.item, row.index)
            ));
    }

    public reviewNavigableFileCount() {
        return this.reviewNavigableFileItems().length;
    }

    public reviewActiveFilePosition() {
        const position = this.reviewNavigableFileItems()
            .findIndex((row: any) => row.index === this.activeBatchIndex);
        return position >= 0 ? position + 1 : 0;
    }

    public reviewCompletedFileCount() {
        return this.reviewNavigableFileItems().filter((row: any) => (
            this.reviewItemCanBeReviewed(row.item)
            && this.unresolvedEntityDecisionCount(row.item) === 0
            && this.reviewKeys(row.item).every((key: string) => (
                this.normaliseReviewChecks(
                    row.item.reviewChecks, null, this.reviewKeys(row.item)
                )[key]
            ))
        )).length;
    }

    public reviewCurrentSectionCompletedCount() {
        return this.reviewNavigableFileItems().filter((row: any) => (
            this.reviewItemCanBeReviewed(row.item)
            && this.reviewKeys(row.item).includes(this.reviewSection)
            && !!this.normaliseReviewChecks(
                row.item.reviewChecks, null, this.reviewKeys(row.item)
            )[this.reviewSection]
            && (
                this.reviewSection !== 'entities'
                || this.unresolvedEntityDecisionCount(row.item) === 0
            )
        )).length;
    }

    public reviewCurrentSectionTargetCount() {
        return this.reviewNavigableFileItems().filter((row: any) => (
            this.reviewItemCanBeReviewed(row.item)
            && this.reviewKeys(row.item).includes(this.reviewSection)
        )).length;
    }

    public reviewItemNeedsAttention(item: any, section: ReviewSectionKey = this.reviewSection) {
        if (!this.reviewItemCanBeReviewed(item)) return false;
        if (!this.reviewKeys(item).includes(section)) return false;
        if (section === 'entities' && this.unresolvedEntityDecisionCount(item) > 0) return true;
        return !this.normaliseReviewChecks(
            item.reviewChecks, null, this.reviewKeys(item)
        )[section];
    }

    public reviewFileItems() {
        const rows = this.reviewNavigableFileItems();
        if (this.reviewFileFilter === 'attention') {
            return rows.filter((row: any) => this.reviewItemNeedsAttention(row.item));
        }
        return rows;
    }

    public async goToAdjacentReviewFile(direction: number) {
        const rows = this.reviewNavigableFileItems();
        if (rows.length < 2) return;
        const current = rows.findIndex((row: any) => row.index === this.activeBatchIndex);
        const currentPosition = current >= 0 ? current : 0;
        const target = rows[(currentPosition + direction + rows.length) % rows.length];
        await this.selectBatchItem(target.index);
        await this.renderPreservingViewport();
    }

    public reviewAttentionCount() {
        return this.reviewNavigableFileItems().filter(
            (row: any) => this.reviewItemNeedsAttention(row.item)
        ).length;
    }

    public reviewAttentionItems() {
        const rows: any[] = [];
        this.reviewNavigableFileItems().forEach((fileRow: any) => {
            const item = fileRow.item;
            const batchIndex = fileRow.index;
            const sections = this.documentProfileReviewItems(item.analysis, item.form);
            const keys = sections.map((section: any) => section.key);
            const checks = this.normaliseReviewChecks(item.reviewChecks, null, keys);
            sections.forEach((section: any, sectionIndex: number) => {
                const unresolvedEntities = section.key === 'entities'
                    ? this.unresolvedEntityDecisionCount(item)
                    : 0;
                if (checks[section.key] && unresolvedEntities === 0) return;
                rows.push({
                    batchIndex,
                    sectionKey: section.key,
                    sectionOrder: `${sectionIndex + 1}`.padStart(2, '0'),
                    sectionLabel: section.label || section.key,
                    fileName: this.reviewFileName(item),
                    filePosition: batchIndex + 1,
                    unresolvedEntities,
                    statusLabel: unresolvedEntities > 0
                        ? `개체 ${unresolvedEntities.toLocaleString()}개 결정 필요`
                        : '검수 완료 필요',
                    isCurrent: batchIndex === this.activeBatchIndex
                        && section.key === this.reviewSection,
                });
            });
        });
        return rows;
    }

    public reviewBulkPendingFileCount() {
        return this.reviewNavigableFileItems().filter((row: any) => {
            const keys = this.reviewKeys(row.item);
            const checks = this.normaliseReviewChecks(
                row.item.reviewChecks, null, keys
            );
            return keys.some((key: string) => !checks[key])
                || this.unresolvedEntityDecisionCount(row.item) > 0;
        }).length;
    }

    public async toggleReviewAttentionMenu(event?: Event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (this.reviewAttentionItems().length === 0) {
            this.reviewAttentionMenuOpen = false;
            return;
        }
        this.reviewAttentionMenuOpen = !this.reviewAttentionMenuOpen;
        await this.service.render();
    }

    public async closeReviewAttentionMenu() {
        if (!this.reviewAttentionMenuOpen) return;
        this.reviewAttentionMenuOpen = false;
        await this.service.render();
    }

    public async openReviewAttentionItem(target: any) {
        if (!target || !Number.isInteger(target.batchIndex) || !target.sectionKey) return;
        this.reviewAttentionMenuOpen = false;
        this.reviewFileFilter = 'attention';
        await this.selectBatchItem(target.batchIndex);
        await this.selectReviewSection(target.sectionKey);
        setTimeout(() => {
            const detail = document.querySelector('.profile-review-detail');
            if (!detail) return;
            const reduceMotion = window.matchMedia
                && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            detail.scrollIntoView({
                behavior: reduceMotion ? 'auto' : 'smooth',
                block: 'start',
            });
        }, 0);
    }

    public currentReviewConfirmed() {
        const item = this.activeBatchItem();
        return !!(
            item
            && (
                this.reviewSection !== 'entities'
                || this.unresolvedEntityDecisionCount(item) === 0
            )
            && this.normaliseReviewChecks(
                item.reviewChecks, null, this.reviewKeys(item)
            )[this.reviewSection]
        );
    }

    public async toggleCurrentReviewConfirmed() {
        const item = this.activeBatchItem();
        if (!item || item.status !== 'complete') return;
        const unresolvedEntities = this.unresolvedEntityDecisionCount(item);
        if (
            this.reviewSection === 'entities'
            && !this.currentReviewConfirmed()
            && unresolvedEntities > 0
        ) {
            await this.service.modal.error(
                `개체명 ${unresolvedEntities}개가 아직 결정되지 않았습니다. 맞는 표준정보 후보를 선택하거나 후보가 없으면 보류해주세요.`
            );
            await this.focusUnresolvedEntityDecisions();
            return;
        }
        const area = this.activeProfileReviewItem();
        if (
            area
            && !this.currentReviewConfirmed()
            && ['error', 'missing', 'processing'].includes(this.reviewAreaStatus(area))
        ) {
            await this.service.modal.error(
                `${area.label}: 완료를 막는 원본·추출 오류를 먼저 해결해주세요.`
            );
            return;
        }
        this.syncActiveBatch();
        const checks = this.normaliseReviewChecks(
            item.reviewChecks, null, this.reviewKeys(item)
        );
        checks[this.reviewSection] = !checks[this.reviewSection];
        item.reviewChecks = checks;
        this.appendProfileReviewHistory(
            this.reviewSection,
            checks[this.reviewSection] ? 'area_completed' : 'area_reopened',
        );
        this.partialRegistrationConfirmed = false;
        this.queueRegistrationRecoverySave();
        if (checks[this.reviewSection]) {
            const currentIndex = this.reviewSectionIndex();
            const pendingAreas = [
                ...this.reviewSections.slice(currentIndex + 1),
                ...this.reviewSections.slice(0, Math.max(0, currentIndex)),
            ].filter((section: any) => !checks[section.key]);
            const nextArea = pendingAreas[0];
            if (nextArea) {
                await this.selectReviewSection(nextArea.key);
                return;
            }
        }
        await this.renderPreservingViewport();
    }

    public async deferCurrentReviewArea() {
        const area = this.activeProfileReviewItem();
        if (!area) return;
        const item = this.activeBatchItem();
        const checks = this.normaliseReviewChecks(item?.reviewChecks, null, this.reviewKeys(item));
        checks[area.key] = false;
        if (item) item.reviewChecks = checks;
        this.appendProfileReviewHistory(area.key, 'area_deferred', '추가 확인을 위해 보류');
        this.queueRegistrationRecoverySave();
        await this.goToNextReviewIssue();
    }

    public currentReviewFileComplete() {
        const item = this.activeBatchItem();
        const keys = this.reviewKeys(item);
        const checks = this.normaliseReviewChecks(item?.reviewChecks, null, keys);
        return keys.length > 0
            && this.unresolvedEntityDecisionCount(item) === 0
            && keys.every((key: string) => checks[key]);
    }

    public canCompleteCurrentReviewFile() {
        return this.reviewSections.length > 0
            && this.reviewBlockingAreaCount() === 0
            && this.unresolvedEntityDecisionCount() === 0;
    }

    public async completeCurrentReviewFile() {
        const item = this.activeBatchItem();
        const unresolvedEntities = this.unresolvedEntityDecisionCount(item);
        if (item && unresolvedEntities > 0) {
            await this.service.modal.error(
                `이 파일의 개체명 ${unresolvedEntities}개가 아직 결정되지 않았습니다. 후보를 선택하거나 보류한 뒤 파일 검수를 완료해주세요.`
            );
            await this.focusUnresolvedEntityDecisions();
            return;
        }
        if (!item || !this.canCompleteCurrentReviewFile()) {
            await this.service.modal.error(
                `필수 오류·누락 ${this.reviewBlockingAreaCount()}개를 먼저 해결해주세요.`
            );
            return;
        }
        const checks = this.normaliseReviewChecks(item.reviewChecks, null, this.reviewKeys(item));
        this.reviewSections.forEach((area: any) => {
            if (!['error', 'missing', 'processing'].includes(this.reviewAreaStatus(area))) {
                checks[area.key] = true;
            }
        });
        item.reviewChecks = checks;
        this.appendProfileReviewHistory('file', 'file_completed', 'Profile별 검수 완료');
        this.queueRegistrationRecoverySave();
        await this.renderPreservingViewport();
    }

    private reviewAreaValueForForm(area: any, form: any) {
        if (!area || !form) return '';
        if (area.key === 'entities') {
            return Array.isArray(form.entities) ? form.entities : [];
        }
        if (area.key === 'image_ocr' || area.key === 'pdf_pages') {
            return form.ocr_text || '';
        }
        const fields = form.profile_fields && typeof form.profile_fields === 'object'
            ? form.profile_fields : {};
        const hasValue = (value: any) => {
            if (Array.isArray(value)) return value.length > 0;
            if (value && typeof value === 'object') return Object.keys(value).length > 0;
            return !!`${value || ''}`.trim();
        };
        const direct = fields[area.key];
        if (hasValue(direct)) return direct;
        const values = (Array.isArray(area.source_keys) ? area.source_keys : [])
            .map((key: string) => fields[key])
            .filter((value: any) => hasValue(value));
        return values.length === 1 ? values[0] : values;
    }

    private reviewAreaBulkBlocked(item: any, area: any) {
        const tasks = this.fileReviewTasks(item?.analysis).filter((task: any) => {
            const keys = Array.isArray(task?.review_keys) ? task.review_keys : [];
            return keys.includes(area?.key)
                || `${task?.key || ''}` === `profile_${area?.key || ''}`;
        });
        if (tasks.some((task: any) => ['failed', 'in_progress'].includes(`${task?.status || ''}`))) {
            return true;
        }
        const value = this.reviewAreaValueForForm(area, item?.form);
        const hasValue = Array.isArray(value)
            ? value.length > 0
            : value && typeof value === 'object'
                ? Object.keys(value).length > 0
                : !!`${value || ''}`.trim();
        return !!area?.blocking && !hasValue;
    }

    private deferBulkUnresolvedEntities(form: any) {
        const entities = Array.isArray(form?.entities) ? form.entities : [];
        let deferred = 0;
        entities.forEach((entity: any) => {
            if (!this.entityDecisionUnresolved(entity)) return;
            entity.kg_id = '';
            entity.link_status = 'deferred';
            entity.selection_reason = '모든 파일 콘텐츠 검수 일괄 승인';
            entity.manually_corrected = true;
            deferred += 1;
        });
        if (deferred > 0) {
            if (!form.profile_fields || typeof form.profile_fields !== 'object') {
                form.profile_fields = {};
            }
            form.profile_fields.entities = entities.map((entity: any) => ({ ...entity }));
        }
        return deferred;
    }

    public async approveAllReviewFiles() {
        this.syncActiveBatch();
        const pendingAreas = this.reviewAttentionItems().length;
        const pendingFiles = this.reviewBulkPendingFileCount();
        if (!pendingAreas || !pendingFiles) return;
        const unresolvedEntities = this.reviewUnresolvedEntityDecisionCount();
        const entityNotice = unresolvedEntities > 0
            ? ` 미결정 개체 ${unresolvedEntities}개는 보류 처리됩니다.` : '';
        const accepted = typeof window === 'undefined' ? true : window.confirm(
            `전체 ${pendingFiles}개 파일의 미완료 검수 영역 ${pendingAreas}개를 일괄 승인합니다.${entityNotice}`
        );
        if (!accepted) return;

        let approvedAreas = 0;
        let deferredEntities = 0;
        const blockedFiles = new Set<number>();
        const rows = this.reviewNavigableFileItems();
        rows.forEach((row: any) => {
            const item = row.item;
            const form = item.form;
            if (!form) return;
            const areas = this.documentProfileReviewItems(item.analysis, form);
            const keys = areas.map((area: any) => area.key);
            const checks = this.normaliseReviewChecks(item.reviewChecks, null, keys);
            const hasPendingArea = keys.some((key: string) => !checks[key]);
            const hasUnresolvedEntity = (Array.isArray(form.entities) ? form.entities : [])
                .some((entity: any) => this.entityDecisionUnresolved(entity));
            if (!hasPendingArea && !hasUnresolvedEntity) return;
            let fileApprovedAreas = 0;
            deferredEntities += this.deferBulkUnresolvedEntities(form);
            areas.forEach((area: any) => {
                if (checks[area.key]) return;
                if (this.reviewAreaBulkBlocked(item, area)) {
                    blockedFiles.add(row.index);
                    return;
                }
                checks[area.key] = true;
                approvedAreas += 1;
                fileApprovedAreas += 1;
            });
            item.reviewChecks = checks;
            this.appendProfileReviewHistoryToForm(
                form,
                'file',
                'all_files_bulk_approved',
                `콘텐츠 검수 ${fileApprovedAreas}개 영역 일괄 승인`,
            );
            this.captureRegistrationLocalDraft(item, form);
        });

        const active = this.activeBatchItem();
        if (active?.form) this.data = this.cloneForm(active.form);
        this.partialRegistrationConfirmed = false;
        this.queueRegistrationRecoverySave();
        this.syncReviewSections();
        await this.renderPreservingViewport();

        const deferredLabel = deferredEntities > 0
            ? ` 미결정 개체 ${deferredEntities}개는 보류했습니다.` : '';
        if (blockedFiles.size > 0) {
            await this.service.modal.error(
                `${approvedAreas}개 영역을 승인했습니다.${deferredLabel} 오류·누락이 있는 ${blockedFiles.size}개 파일은 직접 확인해주세요.`
            );
            return;
        }
        await this.service.modal.success(
            `모든 파일의 콘텐츠 검수 ${approvedAreas}개 영역을 일괄 승인했습니다.${deferredLabel}`
        );
    }

    public async setReviewFileFilter(filter: 'all' | 'attention') {
        this.reviewFileFilter = filter;
        await this.service.render();
    }

    public async goToNextReviewIssue() {
        const candidates: any[] = [];
        this.reviewNavigableFileItems().forEach((row: any) => {
            const item = row.item;
            const index = row.index;
            const keys = this.reviewKeys(item);
            const checks = this.normaliseReviewChecks(item.reviewChecks, null, keys);
            keys.forEach((key: string) => {
                const unresolvedEntities = key === 'entities'
                    && this.unresolvedEntityDecisionCount(item) > 0;
                if (!checks[key] || unresolvedEntities) candidates.push({ item, index, key });
            });
        });
        if (candidates.length) {
            const current = candidates.findIndex((row: any) => (
                row.index === this.activeBatchIndex && row.key === this.reviewSection
            ));
            const target = candidates[(current + 1 + candidates.length) % candidates.length];
            this.reviewFileFilter = 'attention';
            await this.selectBatchItem(target.index);
            this.reviewSection = target.key;
            await this.renderPreservingViewport();
            return;
        }
        await this.service.modal.success('모든 파일의 검수 항목을 확인했습니다.');
    }

    public currentOperationScopeLabel() {
        if (this.registerStep === 'upload') {
            const overall = this.analysisOverallTotalCount();
            return overall > 1 ? `업로드 전체 ${overall}개 원문` : '선택한 원문';
        }
        if (this.registerStep === 'complete') {
            const count = this.finalRegistrableCount();
            return count > 1 ? `등록 대상 전체 ${count}개` : '현재 자료 1개';
        }
        const item = this.activeBatchItem();
        if (!item) return '현재 파일';
        return `현재 파일 ${this.activeBatchIndex + 1}/${Math.max(1, this.batchItems.length)} · ${item.name}`;
    }

    public isDirectTextExtraction(item: any = null) {
        const analysis = item && item.analysis ? item.analysis : this.analysisInfo;
        const source = analysis && analysis.source ? analysis.source : {};
        const ocr = analysis && analysis.ocr ? analysis.ocr : {};
        const format = this.inferSourceFormat(source);
        return ocr.processing_mode === 'embedded_text'
            || ['xml', 'html', 'txt', 'text', 'json', 'csv', 'md', 'markdown'].includes(format);
    }

    public batchOcrProcessingLabel(item: any = null) {
        const analysis = item && item.analysis ? item.analysis : this.analysisInfo;
        const ocr = analysis && analysis.ocr ? analysis.ocr : {};
        const nativePages = this.safeNumber(ocr.native_text_page_count, 0);
        const ocrPages = this.safeNumber(ocr.ocr_page_count, 0);
        if (this.isDirectTextExtraction(item)) return '텍스트 직접 추출 · OCR 생략';
        if (ocr.processing_mode === 'pdf_text_layer') {
            return '기존 OCR 텍스트 ' + nativePages.toLocaleString() + '쪽 재사용';
        }
        if (ocr.processing_mode === 'pdf_hybrid') {
            return '기존 텍스트 ' + nativePages.toLocaleString() + '쪽 · 보완 OCR '
                + ocrPages.toLocaleString() + '쪽';
        }
        if (ocr.processing_mode === 'ocr' && ocrPages > 0) {
            return '이미지 OCR ' + ocrPages.toLocaleString() + '쪽';
        }
        return '본문 처리 방식 자동 판별';
    }

    public ocrReviewHeading() {
        return this.isDirectTextExtraction()
            ? 'XML·문서 텍스트 직접 추출 결과 확인'
            : '원본 페이지와 OCR 결과 비교';
    }

    public ocrReviewDescription() {
        return this.isDirectTextExtraction()
            ? '구조화된 원문의 텍스트를 직접 읽었으며 이미지 OCR은 실행하지 않았습니다. 추출 본문만 확인·교정합니다.'
            : '긴 본문을 한꺼번에 펼치지 않고, 원본 페이지와 OCR 문장을 나란히 보며 교정합니다.';
    }

    public finalRegistrableItems() {
        return this.batchItems.filter((item: any, index: number) => (
            (item.status === 'complete' || item.status === 'saved')
            && this.metadataAdvanceItemIncluded(item, index)
        ));
    }

    public finalRegistrableCount() {
        return this.finalRegistrableItems().length;
    }

    public finalPendingRegistrationItems() {
        return this.finalRegistrableItems().filter(
            (item: any) => item.status === 'complete'
        );
    }

    public finalPendingRegistrationCount() {
        return this.finalPendingRegistrationItems().length;
    }

    public finalSavedRegistrationItems() {
        return this.finalRegistrableItems().filter(
            (item: any) => item.status === 'saved'
        );
    }

    public finalSavedRegistrationCount() {
        return this.finalSavedRegistrationItems().length;
    }

    public finalSavedCompletionReady() {
        const candidates = this.finalRegistrableItems();
        return candidates.length > 0 && candidates.every(
            (item: any) => item.status === 'saved'
        );
    }

    public finalPartialCompletionReady() {
        return this.finalSavedCompletionReady()
            && this.finalFailedCount() > 0
            && this.partialRegistrationConfirmed;
    }

    private creditSavedRegistrationItems() {
        const uncounted = this.finalSavedRegistrationItems().filter(
            (item: any) => item.registrationCounted !== true
        );
        uncounted.forEach((item: any) => {
            item.registrationCounted = true;
        });
        this.completedRegistrationCount += uncounted.length;
        return uncounted.length;
    }

    public finalRegistrationPageCount() {
        return Math.max(
            1,
            Math.ceil(this.batchItems.length / this.finalRegistrationPageSize),
        );
    }

    public finalRegistrationCurrentPage() {
        return Math.min(
            Math.max(1, this.finalRegistrationPage),
            this.finalRegistrationPageCount(),
        );
    }

    public finalRegistrationPageItems() {
        const page = this.finalRegistrationCurrentPage();
        const start = (page - 1) * this.finalRegistrationPageSize;
        return this.batchItems
            .map((item: any, index: number) => ({ item, index }))
            .slice(start, start + this.finalRegistrationPageSize);
    }

    public finalRegistrationPageNumbers() {
        return Array.from(
            { length: this.finalRegistrationPageCount() },
            (_value, index) => index + 1,
        );
    }

    public finalRegistrationPageRangeLabel() {
        if (!this.batchItems.length) return '0개';
        const page = this.finalRegistrationCurrentPage();
        const start = (page - 1) * this.finalRegistrationPageSize + 1;
        const end = Math.min(
            this.batchItems.length,
            start + this.finalRegistrationPageSize - 1,
        );
        return `${start}–${end} / ${this.batchItems.length}개`;
    }

    public async setFinalRegistrationPage(page: number) {
        const next = Math.min(
            Math.max(1, Number(page) || 1),
            this.finalRegistrationPageCount(),
        );
        if (next === this.finalRegistrationPage) return;
        this.finalRegistrationPage = next;
        await this.service.render();
        const list = document.getElementById('final-registration-data-list');
        if (list) list.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    public finalFailedCount() {
        return this.batchItems.filter((item: any) => item.status === 'error').length;
    }

    public finalCancelledCount() {
        return this.batchItems.filter((item: any) => item.status === 'cancelled').length;
    }

    public finalExcludedCount() {
        return this.finalFailedCount() + this.finalCancelledCount()
            + this.metadataAdvanceDeferredCount();
    }

    public finalNewCount() {
        return this.finalRegistrableItems().filter((item: any) => !this.duplicateReviewRequired(item)).length;
    }

    public finalUpdateCount() {
        return this.finalRegistrableItems().filter((item: any) => this.duplicateReviewRequired(item)).length;
    }

    public finalPublicCount() {
        return this.finalRegistrableItems().filter(
            (item: any) => item.form && item.form.status === 'published'
        ).length;
    }

    public finalPrivateCount() {
        return Math.max(0, this.finalRegistrableCount() - this.finalPublicCount());
    }

    public finalDirectTextCount() {
        return this.finalRegistrableItems().filter((item: any) => this.isDirectTextExtraction(item)).length;
    }

    public finalOcrCount() {
        return this.finalRegistrableItems().filter((item: any) => {
            const ocr = item && item.analysis && item.analysis.ocr ? item.analysis.ocr : {};
            return ['ocr', 'pdf_hybrid'].includes(`${ocr.processing_mode || ''}`)
                || this.safeNumber(ocr.ocr_page_count, 0) > 0;
        }).length;
    }

    public finalReusedTextCount() {
        return Math.max(
            0,
            this.finalRegistrableCount() - this.finalDirectTextCount() - this.finalOcrCount()
        );
    }

    public finalRegistrationActionLabel(item: any) {
        if (!item || item.status === 'error') return '등록 제외';
        if (item.status === 'cancelled') return '등록 취소';
        const index = this.batchItems.indexOf(item);
        if (!this.metadataAdvanceItemIncluded(item, index)) return '검수 보류 · 이번 등록 제외';
        if (item.status === 'saved') return '자료함 등록 완료';
        return this.duplicateReviewRequired(item) ? '기존 자료 새 버전' : '신규 추가';
    }

    public finalItemExcluded(item: any) {
        const index = this.batchItems.indexOf(item);
        return !item
            || ['error', 'cancelled'].includes(`${item.status || ''}`)
            || !this.metadataAdvanceItemIncluded(item, index);
    }

    public batchReviewStatusLabel(item: any) {
        if (!item || item.status === 'error') return '실패';
        const keys = this.reviewKeys(item);
        const checks = this.normaliseReviewChecks(item.reviewChecks, null, keys);
        const completed = keys.filter((key: string) => checks[key]).length;
        return `검수 ${completed}/${keys.length}`;
    }

    public finalGateReady() {
        const candidates = this.finalRegistrableItems();
        return candidates.length > 0 && candidates.every(
            (item: any) => item.status === 'saved' || this.registrationGateReady(item)
        );
    }

    public finalMetadataReady() {
        const candidates = this.finalRegistrableItems();
        return candidates.length > 0 && candidates.every((item: any) => (
            item.status === 'saved'
            || (
                item.form
                && `${item.form.title || ''}`.trim()
                && `${item.form.category || ''}`.trim()
                && this.metadataReviewSectionReady(item.form)
            )
        ));
    }

    public finalReviewReady() {
        const candidates = this.finalRegistrableItems();
        return candidates.length > 0 && candidates.every((item: any) => {
            if (item.status === 'saved') return true;
            const keys = this.reviewKeys(item);
            const checks = this.normaliseReviewChecks(item.reviewChecks, null, keys);
            return keys.every((key: string) => checks[key]);
        });
    }

    public finalPartialFailureReady() {
        return this.finalFailedCount() === 0 || this.partialRegistrationConfirmed;
    }

    public finalAutoSaveReady() {
        return this.finalSavedCompletionReady() || this.autoSaveState !== 'error';
    }

    public finalChecklistTotal() {
        return 5;
    }

    public finalChecklistCompletedCount() {
        const candidates = this.finalRegistrableItems();
        const checks = [
            candidates.length > 0,
            candidates.every((item: any) => this.registrationGateReady(item) || item.status === 'saved'),
            this.finalMetadataReady(),
            this.finalFailedCount() === 0 || this.partialRegistrationConfirmed,
            this.finalAutoSaveReady(),
        ];
        return checks.filter(Boolean).length;
    }

    public finalReadinessPercent() {
        return Math.round(this.finalChecklistCompletedCount() / this.finalChecklistTotal() * 100);
    }

    public finalPreflightIssues(severity: 'blocking' | 'warning' | '' = '') {
        const rows: any[] = [];
        this.batchItems.forEach((item: any, index: number) => {
            if (this.finalItemExcluded(item)) return;
            if (item.status === 'saved') return;
            const issues = Array.isArray(item?.registrationPreflight?.issues)
                ? item.registrationPreflight.issues : [];
            issues.forEach((issue: any) => {
                if (
                    this.finalPreflightIssueVisible(item, issue)
                    && (!severity || issue.severity === severity)
                ) {
                    rows.push({ ...issue, item, index });
                }
            });
        });
        return rows;
    }

    public finalPreflightIssueVisible(item: any, issue: any) {
        if (
            issue
            && `${issue.field || ''}` === 'layout'
            && ['DTD_UNSUPPORTED', 'LAYOUT_REVIEW_REQUIRED'].includes(`${issue.code || ''}`)
            && this.layoutWarnings(item?.analysis).length === 0
        ) {
            return false;
        }
        return true;
    }

    public finalWarningGroups() {
        return this.batchItems
            .map((item: any, index: number) => ({
                item,
                index,
                issues: (
                    Array.isArray(item?.registrationPreflight?.issues)
                        ? item.registrationPreflight.issues
                        : []
                ).filter((issue: any) => (
                    issue?.severity === 'warning'
                    && this.finalPreflightIssueVisible(item, issue)
                )),
            }))
            .filter((group: any) => (
                !this.finalItemExcluded(group.item)
                && group.item.status === 'complete'
                && group.issues.length > 0
            ));
    }

    public trackByWarningGroup(_index: number, group: any) {
        return group?.index;
    }

    public finalBlockingCount() {
        return this.finalPreflightIssues('blocking').length;
    }

    public finalWarningCount() {
        return this.finalPreflightIssues('warning').length;
    }

    public finalPreflightRetryRequired() {
        return this.finalPreflightIssues('blocking').some((issue: any) => (
            issue?.retryable !== false
            && ['PREFLIGHT_FAILED', 'PREFLIGHT_UNAVAILABLE'].includes(
                `${issue?.code || ''}`
            )
        ));
    }

    public finalAttentionFileCount() {
        return this.finalPendingRegistrationItems().filter((item: any) => (
            Array.isArray(item?.registrationPreflight?.issues)
            && item.registrationPreflight.issues.some((issue: any) => (
                issue?.severity === 'warning'
                && this.finalPreflightIssueVisible(item, issue)
            ))
            && !item.registrationPreflight.issues.some((issue: any) => issue?.severity === 'blocking')
        )).length;
    }

    public finalBlockedFileCount() {
        return this.finalPendingRegistrationItems().filter(
            (item: any) => item?.registrationPreflight?.ready === false
        ).length;
    }

    public finalOverallStatusKey() {
        if (this.saving || this.registrationSubmitting) return 'processing';
        if (this.registrationCompletionFinalized) return 'complete';
        if (this.registrationResults.length > 0) {
            const succeeded = this.registrationResults.filter((row: any) => row.status === 'saved').length;
            if (succeeded === this.registrationResults.length) return 'complete';
            if (succeeded > 0) return 'partial';
            return 'failed';
        }
        if (this.finalBlockingCount() > 0) return 'blocked';
        if (this.finalWarningCount() > 0 || this.finalFailedCount() > 0) return 'attention';
        if (this.finalServerPreflightReady()) return 'ready';
        return 'checking';
    }

    public finalOverallStatusLabel() {
        const labels: any = {
            checking: '사전검증 필요',
            ready: '등록 준비 완료',
            attention: '확인 필요',
            blocked: '등록 불가',
            processing: '등록 처리 중',
            partial: '일부 등록 완료',
            complete: '등록 완료',
            failed: '등록 실패',
        };
        return labels[this.finalOverallStatusKey()] || '확인 필요';
    }

    public finalServerPreflightReady() {
        const candidates = this.finalPendingRegistrationItems();
        return this.finalRegistrableCount() > 0 && candidates.every(
            (item: any) => item?.registrationPreflight?.ready === true
        );
    }

    private registrationPreflightCacheCurrent() {
        const candidates = this.finalPendingRegistrationItems();
        return this.finalRegistrableCount() > 0 && candidates.every(
            (item: any) => this.registrationPreflightReusable(item)
        );
    }

    public finalItemProfileLabel(item: any) {
        return `${item?.form?.document_profile || item?.analysis?.document_profile?.key || '미확정'}`;
    }

    public finalItemEntitySummary(item: any) {
        const entities = Array.isArray(item?.form?.entities) ? item.form.entities : [];
        const linked = entities.filter((row: any) => !!row.kg_id).length;
        const deferred = entities.filter((row: any) => row.link_status === 'deferred').length;
        const modified = entities.filter((row: any) => !!row.manually_corrected).length;
        return {
            total: entities.length,
            linked,
            unlinked: Math.max(0, entities.length - linked - deferred),
            deferred,
            modified,
        };
    }

    public finalEntityTypeRows(item: any) {
        const labels: any = {
            PERSON: '인물', PLACE: '지명', EVENT: '사건',
            ORGANIZATION: '단체·기관', WORK: '문헌', ARTIFACT: '유물·유적',
            SUBJECT: '주제어', OTHER: '기타',
        };
        const counts: any = {};
        (Array.isArray(item?.form?.entities) ? item.form.entities : []).forEach((row: any) => {
            const key = `${row?.type || 'OTHER'}`.toUpperCase();
            counts[key] = (counts[key] || 0) + 1;
        });
        return Object.keys(counts).map((key: string) => ({
            key,
            label: labels[key] || '기타',
            count: counts[key],
        }));
    }

    public finalItemDtdSummary(item: any) {
        const fields = Array.isArray(item?.form?.xml_field_review?.fields)
            ? item.form.xml_field_review.fields
            : Array.isArray(item?.analysis?.xml_field_review?.fields)
            ? item.analysis.xml_field_review.fields : [];
        const status = (name: string) => fields.filter(
            (row: any) => `${row?.status || ''}` === name
        ).length;
        return {
            total: fields.length,
            complete: fields.filter((row: any) => !!row.reviewed).length,
            attention: status('conflict') + status('pending') + status('unconfirmed'),
            errors: status('error') + status('missing'),
            unsupported: status('unsupported'),
        };
    }

    public finalItemModifiedCount(item: any) {
        const common = item?.form?.common_metadata_review || {};
        const commonHistory = Array.isArray(common.history) ? common.history : [];
        const profileHistory = Array.isArray(item?.form?.profile_fields?.__review_history)
            ? item.form.profile_fields.__review_history : [];
        return commonHistory.length + profileHistory.length
            + this.finalItemEntitySummary(item).modified;
    }

    public async goToFinalCorrection(
        index: number,
        target: string,
        field: string = '',
        returnAnchorId: string = '',
        issue: any = null,
    ) {
        this.finalRegistrationAgreement = false;
        const item = this.batchItems[index];
        const reviewWasComplete = !!(
            issue
            && issue?.severity === 'warning'
            && (
                `${issue?.stage || ''}` !== 'manual'
                || !!this.normaliseReviewChecks(
                    item?.reviewChecks,
                    null,
                    this.reviewKeys(item),
                )[field]
            )
        );
        this.finalReviewReturnState = {
            scrollY: window.scrollY,
            itemIndex: index,
            anchorId: returnAnchorId || (
                issue ? `final-warning-group-${index}` : ''
            ),
            mode: issue ? 'issue' : 'file',
            issue: issue ? { ...issue } : null,
            reviewWasComplete,
        };
        if (item?.analysis && item?.form) await this.selectBatchItem(index);
        if (target === 'upload') {
            this.registerStep = 'upload';
        } else if (target === 'visibility') {
            this.registerStep = 'metadata';
            this.metadataSection = 'visibility';
        } else if (target === 'metadata' || target === 'layout') {
            this.registerStep = 'metadata';
            this.metadataSection = 'bibliography';
            if (field) this.xmlReviewActiveFieldId = field;
        } else {
            this.registerStep = 'metadata';
            this.metadataSection = 'bibliography';
        }
        await this.service.render();
        this.scrollToCurrentStep();
    }

    public async editFinalRegistrationItem(index: number) {
        const item = this.batchItems[index];
        if (!item?.analysis || !item?.form || item.status === 'saved') return;
        await this.goToFinalCorrection(
            index,
            'metadata',
            '',
            `final-registration-data-item-${index}`,
        );
    }

    public finalCorrectionActive() {
        return !!this.finalReviewReturnState && this.registerStep !== 'complete';
    }

    public finalCorrectionFileName() {
        const index = Number(this.finalReviewReturnState?.itemIndex);
        return Number.isInteger(index) && this.batchItems[index]
            ? this.reviewFileName(this.batchItems[index])
            : this.reviewFileName(this.activeBatchItem());
    }

    public finalCorrectionIssueActive() {
        return this.finalCorrectionActive()
            && this.finalReviewReturnState?.mode === 'issue'
            && !!this.finalReviewReturnState?.issue;
    }

    public finalCorrectionIssue() {
        return this.finalCorrectionIssueActive()
            ? this.finalReviewReturnState.issue
            : null;
    }

    public finalCorrectionIssueField(field: string) {
        return `${this.finalCorrectionIssue()?.field || ''}` === field;
    }

    public finalCorrectionEntityNeedsAttention(entity: any) {
        if (!this.finalCorrectionIssueField('entities') || !entity) return false;
        return this.entityDecisionUnresolved(entity);
    }

    public finalCorrectionEntityTargetCount() {
        return (Array.isArray(this.data?.entities) ? this.data.entities : [])
            .filter((entity: any) => this.finalCorrectionEntityNeedsAttention(entity))
            .length;
    }

    public finalCorrectionLayoutTargetActive() {
        return this.finalCorrectionIssueField('layout')
            && this.layoutWarnings().length > 0;
    }

    public layoutWarningText(warning: any) {
        if (warning && typeof warning === 'object') {
            return `${warning.message || warning.reason || warning.label || JSON.stringify(warning)}`;
        }
        return `${warning || '상세 내용을 확인할 수 없는 추출 경고'}`;
    }

    public finalCorrectionStatusLabel() {
        const issue = this.finalCorrectionIssue();
        if (!issue) return '등록 정보 수정 중';
        const source = `${issue?.actual || issue?.message || ''}`;
        const count = source.match(/(\d[\d,]*)/);
        const quantity = count ? `${count[1]}건` : '1건';
        const status = this.finalReviewReturnState?.reviewWasComplete
            ? '검수 완료'
            : '확인 필요';
        const issueType = issue?.severity === 'blocking' ? '차단 오류' : '경고';
        return `${status} · ${issueType} ${quantity}`;
    }

    public finalCorrectionTitle() {
        return `${this.finalCorrectionFileName()} ${
            this.finalCorrectionIssueActive() ? '경고 확인 중' : '등록 정보 수정 중'
        }`;
    }

    public finalCorrectionDescription() {
        const issue = this.finalCorrectionIssue();
        if (!issue) {
            return '필요한 값을 수정한 뒤 완료하면 4단계의 해당 파일로 돌아갑니다.';
        }
        return `${issue.message} 필요한 항목만 확인하거나 수정한 뒤 완료하면 4단계의 같은 경고 위치로 돌아갑니다.`;
    }

    public finalCorrectionActionLabel() {
        return this.finalCorrectionIssueActive() ? '경고 확인 완료' : '수정 완료';
    }

    public async completeFinalCorrection() {
        if (!this.finalReviewReturnState) return;
        if (this.registerStep !== 'upload') this.syncActiveBatch();
        this.registerStep = 'complete';
        await this.service.render();
        await this.refreshRegistrationPreflight();
        this.restoreFinalReviewReturnPosition();
    }

    public async goToFinalIssue(issue: any) {
        const field = `${issue?.field || ''}`;
        const stage = `${issue?.stage || ''}`;
        let target = 'metadata';
        if (stage === 'source' || stage === 'file') target = 'upload';
        else if (stage === 'manual') target = 'manual';
        else if (field === 'layout') target = 'layout';
        else if (['status', 'duplicate', 'security_acknowledged'].includes(field)) target = 'visibility';
        const index = Number(issue?.index || 0);
        await this.goToFinalCorrection(
            index,
            target,
            field,
            issue?.severity === 'warning'
                ? `final-warning-group-${index}`
                : 'final-registration-issues',
            issue,
        );
    }

    public finalDateOriginal(item: any, fieldId: string) {
        const fields = Array.isArray(item?.form?.xml_field_review?.fields)
            ? item.form.xml_field_review.fields : [];
        const dateField = fields.find(
            (row: any) => `${row?.id || ''}` === fieldId
        );
        return this.xmlReviewValueText(
            dateField?.original_value || dateField?.current_value || []
        ).replace(/^값 없음$/, '');
    }

    public registrationResultStatusLabel(row: any) {
        const labels: any = {
            saved: '등록 완료',
            failed: '등록 실패',
            excluded: '등록 제외',
            existing: '이미 등록됨',
            processing: '후처리 중',
        };
        return labels[row?.status] || '결과 확인';
    }

    private registrationPreflightReusable(item: any) {
        const preflight = item?.registrationPreflight;
        if (!preflight || typeof preflight !== 'object') return false;
        if (item.localRecoveryDraft || item.localRecoveryDraftHash) return false;
        const draftRevision = `${item.draftRevision || ''}`;
        const preflightRevision = `${
            item.registrationPreflightDraftRevision
            || preflight.draft_revision
            || ''
        }`;
        if (!draftRevision || draftRevision !== preflightRevision) return false;
        const sourceChecksum = `${
            item.analysis?.source?.checksum_sha256 || ''
        }`.replace(/^sha256:/i, '').toLowerCase();
        const preflightChecksum = `${
            item.registrationPreflightSourceChecksum
            || preflight.source_checksum
            || preflight.source?.checksum
            || ''
        }`.replace(/^sha256:/i, '').toLowerCase();
        return !!sourceChecksum
            && !!preflightChecksum
            && sourceChecksum === preflightChecksum;
    }

    private async callRegistrationSave(params: any, maxAttempts: number = 3) {
        const host = window as any;
        const retryableCodes = [500, 502, 503, 504];
        let lastResult: any = null;
        let lastError: any = null;
        host.__wizInlineHttpErrorHandling = Number(
            host.__wizInlineHttpErrorHandling || 0
        ) + 1;
        try {
            for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
                try {
                    lastResult = await wiz.call('save', params);
                    const code = Number(lastResult?.code || 0);
                    if (!retryableCodes.includes(code)) return lastResult;
                    lastError = null;
                } catch (error) {
                    lastError = error;
                    lastResult = null;
                }
                if (attempt >= maxAttempts - 1) break;
                if (this.registrationProcessingVisible()) {
                    this.registrationProgress = {
                        ...this.registrationProgress,
                        status: 'processing',
                        label: `서버 연결 복구 중 (${attempt + 2}/${maxAttempts})`,
                    };
                    await this.service.render();
                }
                await this.service.sleep(400 * Math.pow(2, attempt));
            }
        } finally {
            host.__wizInlineHttpErrorHandling = Math.max(
                0,
                Number(host.__wizInlineHttpErrorHandling || 1) - 1,
            );
        }
        if (lastResult) return lastResult;
        throw lastError || new Error('등록 서버 연결에 실패했습니다.');
    }

    public async refreshRegistrationPreflight(force: boolean = false) {
        if (this.registrationPreflightLoading || this.saving) return false;
        this.syncActiveBatch();
        const candidates = this.batchItems
            .map((item: any, index: number) => ({ item, index }))
            .filter((row: any) => (
                row.item.status === 'complete'
                && this.metadataAdvanceItemIncluded(row.item, row.index)
            ));
        this.registrationPreflightDraftWorkTotal = 0;
        this.registrationPreflightCandidateWorkTotal = candidates.length;
        this.registrationPreflightLoading = true;
        this.registrationPreflightRequestId = '';
        this.registrationProgress = {
            status: 'processing',
            stage: 'draft',
            label: '검수 초안 저장 확인 중',
            completed: 0,
            total: 0,
            percent: 0,
        };
        await this.service.render();
        this.registrationDraftSyncError = null;
        const draftsSaved = await this.flushRegistrationRecoveryDraftsNow();
        const syncFailures = draftsSaved
            ? [] : this.registrationDraftSyncFailures.slice();
        const failedItems = new Map<any, any>();
        syncFailures.forEach((failure: any) => {
            if (failure?.item) failedItems.set(failure.item, failure.captured || null);
        });
        const draftSyncBlocked = draftsSaved ? [] : candidates.filter(
            (row: any) => !failedItems.size || failedItems.has(row.item)
        );
        draftSyncBlocked.forEach((row: any) => {
            const captured = failedItems.get(row.item) || this.captureError(
                '검수 초안을 서버에 저장하지 못했습니다.',
                '검수 초안을 서버에 저장하지 못했습니다.',
            );
            const errorCode = captured.errorCode || 'REGISTRATION_DRAFT_SAVE_FAILED';
            const cause = captured.errorCode
                ? captured.cause
                : '최종 등록 전에 검수 초안을 서버에 저장하지 못해 검증할 정확한 버전이 없습니다.';
            const prevention = captured.errorCode
                ? captured.prevention
                : '오래된 초안을 검증하거나 대용량 전체 데이터를 우회 전송하지 않고 등록 시작 전에 차단합니다.';
            row.item.registrationPreflight = {
                ready: false,
                status: 'blocked',
                issues: [{
                    severity: 'blocking',
                    code: errorCode,
                    message: captured.message || '검수 초안을 서버에 저장하지 못했습니다.',
                    cause,
                    prevention,
                    stage: captured.stage || 'draft',
                    field: captured.field || 'draft_revision',
                    user_action: captured.userAction
                        || '검수 초안을 다시 저장한 뒤 사전검증을 실행해주세요.',
                    retryable: captured.retryable !== false,
                    request_id: captured.requestId || '',
                }],
            };
        });
        if (draftSyncBlocked.length) {
            const first = draftSyncBlocked[0];
            const captured = failedItems.get(first.item) || {};
            const targetIndex = this.batchItems.indexOf(first.item);
            this.registrationDraftSyncError = {
                ...captured,
                message: captured.message || '검수 초안을 서버에 저장하지 못했습니다.',
                cause: captured.errorCode
                    ? captured.cause
                    : '최종 등록 전에 검수 초안을 서버에 저장하지 못해 검증할 정확한 버전이 없습니다.',
                prevention: captured.errorCode
                    ? captured.prevention
                    : '오래된 초안을 검증하거나 대용량 전체 데이터를 우회 전송하지 않고 등록 시작 전에 차단합니다.',
                errorCode: captured.errorCode || 'REGISTRATION_DRAFT_SAVE_FAILED',
                stage: captured.stage || 'draft',
                fileName: captured.fileName || this.reviewFileName(first.item),
                userAction: captured.userAction
                    || '검수 초안을 다시 저장한 뒤 사전검증을 실행해주세요.',
                retryable: captured.retryable !== false,
                targetIndex: draftSyncBlocked.length === 1 ? targetIndex : -1,
                failedCount: draftSyncBlocked.length,
            };
        }
        const availableCandidates = candidates.filter(
            (row: any) => !draftSyncBlocked.some((blocked: any) => blocked.item === row.item)
        );
        const reusable = force ? [] : availableCandidates.filter(
            (row: any) => this.registrationPreflightReusable(row.item)
        );
        const pending = force ? availableCandidates : availableCandidates.filter(
            (row: any) => !this.registrationPreflightReusable(row.item)
        );
        reusable.forEach((row: any) => {
            row.item.registrationPreflight = {
                ...row.item.registrationPreflight,
                cached: true,
            };
        });
        let completed = this.registrationPreflightDraftWorkTotal
            + reusable.length
            + draftSyncBlocked.length;
        this.setRegistrationPreflightProgress(
            'preflight',
            pending.length
                ? '변경된 파일 사전검증 중'
                : '저장된 사전검증 결과 확인 완료',
            completed,
        );
        await this.service.render();
        const host = window as any;
        host.__wizInlineHttpErrorHandling = Number(host.__wizInlineHttpErrorHandling || 0) + 1;
        try {
            await this.runBounded(
                pending,
                this.registrationPreflightConcurrency,
                async ({ item }: any) => {
                try {
                    const draftRevision = `${item.draftRevision || ''}`;
                    const sourceChecksum = `${
                        item.analysis?.source?.checksum_sha256 || ''
                    }`.replace(/^sha256:/i, '').toLowerCase();
                    if (!draftRevision || !sourceChecksum) {
                        throw this.registrationDraftReferenceError(item);
                    }
                    const result = await this.callRegistrationSave({
                        mode: 'registration_preflight',
                        analysis_id: item.analysis.id,
                        draft_revision: draftRevision,
                        source_checksum: sourceChecksum,
                        source_name: item.name || '',
                        force: force ? 'true' : 'false',
                    });
                    if (result.code === 200 && result.data?.preflight) {
                        item.registrationPreflight = result.data.preflight;
                        item.registrationPreflightDraftRevision = `${
                            result.data.preflight.draft_revision
                            || item.draftRevision
                            || ''
                        }`;
                        item.registrationPreflightSourceChecksum = `${
                            result.data.preflight.source?.checksum
                            || item.analysis?.source?.checksum_sha256
                            || ''
                        }`;
                        this.registrationPreflightRequestId = result.data.request_id
                            || this.registrationPreflightRequestId;
                    } else {
                        const captured = this.captureError(
                            result.data,
                            '등록 사전검증에 실패했습니다.',
                        );
                        item.registrationPreflight = {
                            ready: false,
                            issues: [{
                                severity: 'blocking',
                                code: captured.errorCode || 'PREFLIGHT_FAILED',
                                message: captured.message,
                                stage: captured.stage || 'save',
                                field: captured.field || '',
                                user_action: captured.userAction || '잠시 후 사전검증을 다시 실행해주세요.',
                                retryable: captured.retryable !== false,
                                request_id: captured.requestId || '',
                            }],
                        };
                    }
                } catch (error) {
                    const captured = this.captureError(error, '등록 사전검증에 실패했습니다.');
                    item.registrationPreflight = {
                        ready: false,
                        issues: [{
                            severity: 'blocking',
                            code: 'PREFLIGHT_UNAVAILABLE',
                            message: captured.message,
                            stage: 'save',
                            field: '',
                            user_action: '검수 내용은 임시 저장되어 있습니다. 잠시 후 다시 시도해주세요.',
                            retryable: true,
                            request_id: captured.requestId || '',
                        }],
                    };
                } finally {
                    completed += 1;
                    this.setRegistrationPreflightProgress(
                        'preflight',
                        '등록 사전검증 중',
                        completed,
                    );
                    await this.service.render();
                }
            });
        } finally {
            host.__wizInlineHttpErrorHandling = Math.max(
                0,
                Number(host.__wizInlineHttpErrorHandling || 1) - 1,
            );
        }
        this.registrationPreflightLoading = false;
        this.setRegistrationPreflightProgress(
            'preflight',
            '등록 사전검증 완료',
            this.registrationPreflightDraftWorkTotal + candidates.length,
            true,
        );
        this.persistRegistrationRecovery();
        if (!this.registrationSubmitting) {
            void this.saveRegistrationWorkspace();
        }
        await this.service.render();
        return draftSyncBlocked.length === 0;
    }

    public setFinalRegistrationAgreement(checked: boolean) {
        this.finalRegistrationAgreement = !!checked;
        void this.service.render();
    }

    private async confirmFinalRegistration(): Promise<boolean> {
        if (this.finalRegistrationConfirmResolver) return false;
        this.finalRegistrationConfirmOpen = true;
        const confirmation = new Promise<boolean>((resolve) => {
            this.finalRegistrationConfirmResolver = resolve;
        });
        await this.service.render();
        const confirmButton = document.querySelector(
            '.final-confirm-primary'
        ) as HTMLButtonElement | null;
        if (confirmButton) confirmButton.focus({ preventScroll: true });
        return await confirmation;
    }

    public async resolveFinalRegistrationConfirmation(confirmed: boolean) {
        const resolver = this.finalRegistrationConfirmResolver;
        this.finalRegistrationConfirmResolver = null;
        this.finalRegistrationConfirmOpen = false;
        await this.service.render();
        if (resolver) resolver(!!confirmed);
    }

    private async settleRegistrationWorkspaceWrites() {
        if (this.recoverySaveTimer) {
            clearTimeout(this.recoverySaveTimer);
            this.recoverySaveTimer = null;
        }
        await this.registrationWorkspaceSaveQueue;
    }

    private async resumeDeferredRegistrationReview(
        savedCount: number,
        alreadyStored: boolean = false,
    ) {
        const deferred = this.metadataAdvanceDeferredCount();
        if (deferred <= 0) return false;
        const failed = this.finalFailedCount();
        const deferredRows = this.metadataReviewTargetItems().filter(
            (row: any) => !this.metadataAdvanceItemSelected(row.item, row.index)
        );
        const hasIncompleteCommonMetadata = deferredRows.some(
            (row: any) => !this.metadataReviewFileComplete(row.item)
        );
        this.metadataAdvanceMode = 'all';
        this.metadataAdvanceSelectionKeys = [];
        this.batchItems.forEach((item: any) => {
            if (item.status === 'complete') {
                item.metadataReviewState = this.metadataReviewFileComplete(item)
                    ? 'ready' : 'draft';
            }
        });
        const nextIndex = deferredRows.length ? deferredRows[0].index : -1;
        this.registerStep = 'metadata';
        this.metadataSection = 'bibliography';
        this.metadataReviewFileFilter = hasIncompleteCommonMetadata
            ? 'incomplete' : 'all';
        if (nextIndex >= 0) await this.selectBatchItem(nextIndex);
        this.registrationCompletionFinalized = false;
        this.persistRegistrationRecovery();
        this.registrationProgress = {
            status: 'partial',
            stage: 'metadata_review_resume',
            label: '선택 자료 등록 완료 · 남은 검수 보존',
            completed: savedCount,
            total: savedCount + deferred,
            percent: Math.round(savedCount / Math.max(1, savedCount + deferred) * 100),
        };
        const workspaceSaved = await this.saveRegistrationWorkspace(true);
        this.registrationSubmitting = false;
        this.registrationProcessingOpen = false;
        this.recoveryNotice = alreadyStored
            ? `${savedCount}개 자료는 이미 등록되어 다시 업로드하지 않았습니다. 실패 ${failed}개는 제외하고 미완료 ${deferred}개는 임시저장 상태로 보존했습니다.`
            : `${savedCount}개 자료를 등록했습니다. 미완료 ${deferred}개는 임시저장 상태로 남겨 검수를 이어갈 수 있습니다.`;
        await this.service.render();
        if (workspaceSaved) {
            await this.service.modal.success(this.recoveryNotice);
        } else {
            await this.service.modal.error(
                `${this.recoveryNotice} 서버 작업공간 반영에는 실패했으므로 화면을 닫지 말고 다시 저장해주세요.`
            );
        }
        return true;
    }

    private async completeSavedRegistration() {
        if (!this.finalSavedCompletionReady()) return;
        const savedCount = this.finalSavedRegistrationCount();
        const excludedCount = this.finalExcludedCount();
        this.registrationSubmitting = true;
        this.registrationProcessingOpen = true;
        this.registrationProgress = {
            status: 'processing',
            stage: 'complete',
            label: '이미 저장된 자료 확인 및 작업 완료 처리',
            completed: savedCount,
            total: savedCount,
            percent: 100,
        };
        await this.settleRegistrationWorkspaceWrites();
        this.creditSavedRegistrationItems();
        this.persistRegistrationRecovery();
        await this.service.render();
        try {
            if (await this.resumeDeferredRegistrationReview(savedCount, true)) {
                return;
            }
            if (this.queuedRegistrationSourceCount() > this.batchItems.length) {
                const processedCount = this.batchItems.length;
                await this.prepareNextRegistrationBatch(processedCount, 0);
                this.registrationProgress = {
                    status: 'complete',
                    stage: 'chunk_complete',
                    label: '부분 등록 완료 · 다음 묶음 준비',
                    completed: this.completedRegistrationCount,
                    total: this.completedRegistrationCount
                        + this.queuedRegistrationSourceCount(),
                    percent: Math.round(
                        this.completedRegistrationCount
                        / Math.max(
                            1,
                            this.completedRegistrationCount
                                + this.queuedRegistrationSourceCount(),
                        ) * 100
                    ),
                };
                this.registrationSubmitting = false;
                this.registrationProcessingOpen = false;
                await this.service.render();
                await this.service.modal.success(
                    `${savedCount}개 자료는 이미 등록되어 다시 업로드하지 않았습니다. `
                    + `${excludedCount}개를 제외하고 다음 묶음으로 이동합니다.`
                );
                return;
            }
            const workspaceCompleted = await this.setRegistrationWorkspaceState('completed');
            this.registrationCompletionFinalized = workspaceCompleted;
            if (workspaceCompleted) {
                this.clearRegistrationRecovery();
            } else {
                this.persistRegistrationRecovery();
            }
            this.registrationProgress = {
                status: workspaceCompleted ? 'complete' : 'partial',
                stage: 'complete',
                label: workspaceCompleted
                    ? '부분 등록 완료'
                    : '등록 완료 상태 반영 재시도 필요',
                completed: this.completedRegistrationCount,
                total: this.completedRegistrationCount,
                percent: 100,
            };
            this.registrationSubmitting = false;
            this.registrationProcessingOpen = false;
            await this.service.render();
            const completionMessage = `${savedCount}개 자료는 이미 등록되어 다시 업로드하지 않았습니다. `
                + `${excludedCount}개를 제외하고 등록 작업을 완료했습니다.`;
            if (workspaceCompleted) {
                await this.service.modal.success(completionMessage);
            } else {
                const failureReason = this.registrationWorkspaceMessage
                    || '서버가 작업공간 완료 상태를 확인하지 못했습니다.';
                await this.service.modal.error(
                    `${completionMessage} 다만 작업공간의 완료 상태 반영에 실패했습니다. 원인: ${failureReason} 같은 버튼을 다시 누르면 저장된 자료를 재업로드하지 않고 완료 처리만 다시 시도합니다.`
                );
            }
        } finally {
            this.registrationSubmitting = false;
            this.registrationProcessingOpen = false;
            await this.service.render();
        }
    }

    public canSaveRegistration() {
        if (
            this.saving || this.registrationSubmitting || this.registrationPreflightLoading
            || this.metaRecognizing || this.registrationCompletionFinalized
            || this.finalRegistrableCount() === 0
        ) return false;
        if (this.finalFailedCount() > 0 && !this.partialRegistrationConfirmed) return false;
        return this.finalRegistrationAgreement
            && this.finalServerPreflightReady()
            && this.finalBlockingCount() === 0
            && this.finalChecklistCompletedCount() === this.finalChecklistTotal();
    }

    public finalSaveDisabledReason() {
        if (this.registrationCompletionFinalized) return '등록 작업이 완료되었습니다.';
        if (this.saving || this.registrationSubmitting) return '자료함 등록을 처리하고 있습니다.';
        if (this.registrationPreflightLoading) return '서버 사전검증을 진행하고 있습니다.';
        if (this.metaRecognizing) return '원본 분석이 끝날 때까지 기다려주세요.';
        if (this.finalRegistrableCount() === 0) return '등록할 수 있는 파일이 없습니다.';
        if (this.finalFailedCount() > 0 && !this.partialRegistrationConfirmed) {
            return '실패 파일을 제외하고 등록할지 먼저 확인해주세요.';
        }
        if (this.finalBlockingCount() > 0) return '차단 오류를 수정해야 등록할 수 있습니다.';
        if (!this.finalRegistrationAgreement) return '최종 등록 내용 확인에 동의해주세요.';
        if (!this.finalAutoSaveReady()) return '검수 초안 자동 저장 오류를 먼저 확인해주세요.';
        if (!this.finalServerPreflightReady()) return '저장하지 않은 파일의 사전검증을 다시 실행해주세요.';
        if (this.finalChecklistCompletedCount() !== this.finalChecklistTotal()) {
            return '완료되지 않은 필수 검수 항목을 확인해주세요.';
        }
        return '';
    }

    public finalRegistrationButtonLabel() {
        if (this.registrationCompletionFinalized) return '등록 완료';
        if (this.finalPartialCompletionReady()) {
            if (this.metadataAdvanceDeferredCount() > 0) {
                return `저장된 ${this.finalSavedRegistrationCount()}개 반영 후 검수 계속`;
            }
            return `저장된 ${this.finalSavedRegistrationCount()}개로 등록 마치기`;
        }
        if (this.finalSavedCompletionReady()) return '등록 작업 마치기';
        return this.finalRegistrableCount() > 1 ? '선택 자료 등록' : '자료함에 등록';
    }

    public finalRegistrationConfirmationTitle() {
        if (this.finalPartialCompletionReady()) {
            if (this.metadataAdvanceDeferredCount() > 0) {
                return `이미 저장된 ${this.finalSavedRegistrationCount()}개를 유지하고 검수를 계속할까요?`;
            }
            return `이미 저장된 ${this.finalSavedRegistrationCount()}개로 등록을 마칠까요?`;
        }
        if (this.finalSavedCompletionReady()) return '자료함 등록 작업을 마칠까요?';
        return `선택한 ${this.finalRegistrableCount()}개 자료를 등록할까요?`;
    }

    public finalRegistrationConfirmationDescription() {
        if (this.finalPartialCompletionReady()) {
            if (this.metadataAdvanceDeferredCount() > 0) {
                return `성공한 ${this.finalSavedRegistrationCount()}개는 다시 업로드하지 않고, 실패한 ${this.finalFailedCount()}개를 제외하며 미완료 ${this.metadataAdvanceDeferredCount()}개 초안은 보존합니다.`;
            }
            return `성공한 ${this.finalSavedRegistrationCount()}개는 다시 업로드하지 않고, 실패한 ${this.finalFailedCount()}개를 제외해 작업만 완료합니다.`;
        }
        if (this.finalSavedCompletionReady()) {
            return '모든 대상은 이미 자료함에 저장되어 다시 업로드하지 않고 작업 완료 상태만 반영합니다.';
        }
        return '최종 검수를 마친 자료와 공개 범위를 확인한 뒤 등록을 진행합니다.';
    }

    public registrationProcessingVisible() {
        return !this.finalRegistrationConfirmOpen && (
            this.registrationProcessingOpen || this.registrationSubmitting
        );
    }

    public async setPartialRegistrationConfirmed(checked: boolean) {
        this.partialRegistrationConfirmed = !!checked;
        this.queueRegistrationRecoverySave();
        await this.service.render();
    }

    public securityReviewRequired(item: any) {
        return !!(item && item.securityScan && item.securityScan.protection_level !== 'full');
    }

    public duplicateInfo(item: any) {
        const analysisDuplicate = this.normaliseDuplicatePayload(
            item?.analysis?.duplicate,
        );
        if (analysisDuplicate) return analysisDuplicate;
        return this.normaliseDuplicatePayload(
            item?.errorInfo?.duplicate,
            `${item?.errorInfo?.errorCode || ''}`,
        );
    }

    public duplicateReviewRequired(item: any) {
        return !!this.duplicateInfo(item);
    }

    public registrationGateReady(item: any) {
        if (!item || item.status !== 'complete' || !item.visibilityConfirmed) return false;
        if (this.securityReviewRequired(item) && !item.securityAcknowledged) return false;
        if (
            this.duplicateReviewRequired(item)
            && (
                !this.aiSettingsAdmin
                || !this.duplicateOverrideValid(item)
            )
        ) return false;
        return true;
    }

    public async setSecurityAcknowledged(index: number, checked: boolean) {
        const item = this.batchItems[index];
        if (!item || !this.securityReviewRequired(item)) return;
        item.securityAcknowledged = !!checked;
        if (item.form) item.form.security_acknowledged = !!checked;
        if (this.activeBatchIndex === index && this.data) this.data.security_acknowledged = !!checked;
        this.queueRegistrationRecoverySave();
        await this.service.render();
    }

    public async setDuplicateOverrideSelected(index: number, checked: boolean) {
        const item = this.batchItems[index];
        if (!item || !this.duplicateReviewRequired(item) || !this.aiSettingsAdmin) return;
        const duplicateDocumentId = `${this.duplicateInfo(item)?.post_id || ''}`;
        const selected = !!checked && !!duplicateDocumentId;
        const reason = selected ? this.duplicateVersionCheckboxReason : '';
        item.duplicateOverrideSelected = selected;
        item.duplicateOverrideConfirmed = selected;
        item.duplicateConfirmed = selected;
        item.duplicateOverrideReason = reason;
        item.duplicateOverrideDocumentId = selected ? duplicateDocumentId : '';
        if (item.form) {
            item.form.duplicate_override_reason = reason;
            item.form.duplicate_confirmed = selected;
        }
        if (this.activeBatchIndex === index && this.data) {
            this.data.duplicate_override_reason = reason;
            this.data.duplicate_confirmed = selected;
        }
        this.queueRegistrationRecoverySave();
        await this.service.render();
    }

    public duplicateOverrideReasonValid(item: any) {
        return !!(
            item
            && item.duplicateOverrideSelected
            && `${
                item.form?.duplicate_override_reason
                || item.duplicateOverrideReason
                || ''
            }`.trim().length >= 5
        );
    }

    public duplicateOverrideValid(item: any) {
        const currentTarget = `${this.duplicateInfo(item)?.post_id || ''}`;
        const confirmedTarget = `${item?.duplicateOverrideDocumentId || ''}`;
        return this.duplicateOverrideReasonValid(item)
            && !!item?.duplicateOverrideConfirmed
            && !!confirmedTarget
            && (!currentTarget || currentTarget === confirmedTarget);
    }

    public async cancelDuplicateRegistration(index: number, event?: Event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        const item = this.batchItems[index];
        if (!item || !this.duplicateReviewRequired(item)) return;
        const confirmed = await this.service.modal.show({
            title: '이 파일 등록을 취소할까요?',
            message: '기존 자료는 변경하지 않고 이 파일만 이번 등록 대상에서 제외합니다.',
            action: '등록 취소',
            cancel: '계속 검토',
            status: 'warning',
        });
        if (!confirmed) return;

        item.status = 'cancelled';
        item.stageLabel = '등록 취소';
        item.stageDetail = '기존 자료는 변경하지 않았습니다.';
        item.duplicateOverrideSelected = false;
        item.duplicateOverrideConfirmed = false;
        item.duplicateConfirmed = false;
        item.duplicateOverrideReason = '';
        item.duplicateOverrideDocumentId = '';
        if (item.form) {
            item.form.duplicate_override_reason = '';
            item.form.duplicate_confirmed = false;
        }

        const nextIndex = this.batchItems.findIndex(
            (candidate: any, candidateIndex: number) => (
                candidateIndex !== index && candidate.status === 'complete'
            )
        );
        if (nextIndex >= 0) {
            await this.selectBatchItem(nextIndex);
            this.queueRegistrationRecoverySave();
            await this.service.render();
            return;
        }

        this.clearRegistrationRecovery();
        this.navigationBypass = true;
        this.service.href(this.libraryPath);
    }

    public duplicatePostUrl(item: any) {
        const postId = `${this.duplicateInfo(item)?.post_id || ''}`;
        return postId ? '/posts/' + postId + '/view' : '';
    }

    private applyDuplicateConflict(item: any, duplicate: any) {
        duplicate = this.normaliseDuplicatePayload(
            duplicate,
            'DUPLICATE_MATERIAL',
        );
        if (!item || !duplicate) return;
        const previousTarget = `${
            item.duplicateOverrideDocumentId
            || item.analysis?.duplicate?.post_id
            || item.analysis?.duplicate_override?.document_id
            || ''
        }`;
        const currentTarget = `${duplicate.post_id || ''}`;
        const reason = `${item.duplicateOverrideReason || item.form?.duplicate_override_reason || ''}`.trim();
        const keepConfirmedOverride = !!(
            this.aiSettingsAdmin
            && item.duplicateOverrideSelected
            && item.duplicateOverrideConfirmed
            && item.duplicateConfirmed
            && reason.length >= 5
            && !!previousTarget
            && !!currentTarget
            && previousTarget === currentTarget
        );
        const canReconfirm = keepConfirmedOverride;
        if (item.analysis) item.analysis.duplicate = duplicate;
        item.duplicateOverrideSelected = canReconfirm;
        item.duplicateOverrideConfirmed = keepConfirmedOverride;
        item.duplicateConfirmed = keepConfirmedOverride;
        item.duplicateOverrideReason = canReconfirm ? reason : '';
        item.duplicateOverrideDocumentId = keepConfirmedOverride
            ? currentTarget : '';
        item.error = keepConfirmedOverride
            ? '새 버전 등록 선택을 유지했습니다. 저장을 다시 시도해주세요.'
            : canReconfirm
                ? '중복 대상이 변경되어 새 버전 등록을 다시 확인해야 합니다.'
                : '동일한 원문 자료가 새로 확인되었습니다. 기존 자료를 확인하고 새 버전 등록 체크박스를 선택해주세요.';
        if (item.form) {
            item.form.duplicate_override_reason = canReconfirm ? reason : '';
            item.form.duplicate_confirmed = keepConfirmedOverride;
        }
        if (this.batchItems[this.activeBatchIndex] === item) {
            this.analysisInfo = item.analysis;
            if (this.data) {
                this.data.duplicate_override_reason = canReconfirm ? reason : '';
                this.data.duplicate_confirmed = keepConfirmedOverride;
            }
        }
        if (item.analysis && item.form) {
            this.registerStep = 'metadata';
            this.metadataSection = 'visibility';
        }
        this.persistRegistrationRecovery();
    }

    public visibilityCompletedCount() {
        return this.batchItems.filter((item: any) => this.registrationGateReady(item)).length;
    }

    public visibilityTargetCount() {
        return this.batchItems.filter((item: any) => item.status === 'complete').length;
    }

    public internalSectionState(group: 'metadata' | 'review', key: string) {
        const current = group === 'metadata' ? this.metadataSectionIndex() : this.reviewSectionIndex();
        const index = group === 'metadata'
            ? this.metadataSections.findIndex((row: any) => row.key === key)
            : this.reviewSections.findIndex((row: any) => row.key === key);
        if (group === 'review') {
            const item = this.activeBatchItem();
            const checks: any = this.normaliseReviewChecks(
                item && item.reviewChecks,
                null,
                this.reviewKeys(item),
            );
            if (checks[key]) return '완료';
            return index === current ? '진행 중' : '확인 필요';
        }
        if (index === current) return '진행 중';
        return index < current ? '완료' : '대기';
    }

    public internalSectionClass(group: 'metadata' | 'review', key: string) {
        const state = this.internalSectionState(group, key);
        if (state === '완료') return 'is-complete';
        if (state === '진행 중') return key === (group === 'metadata' ? this.metadataSection : this.reviewSection)
            ? 'is-active'
            : 'is-processing';
        if (state === '실패') return 'is-failed';
        if (state === '확인 필요') return 'is-attention';
        return 'is-pending';
    }

    public async selectMetadataSection(key: MetadataSectionKey) {
        if (!this.deferredRegistrationReviewStagesVisible && key === 'layout') {
            key = 'bibliography';
        }
        this.syncActiveBatch();
        const target = this.metadataSectionIndex(key);
        if (target > 0 && this.visibilityCompletedCount() < this.visibilityTargetCount()) {
            await this.service.modal.error('먼저 모든 파일의 공개 범위·중복 여부·보안 검사 수준을 확인해주세요.');
            return;
        }
        if (target > 1) {
            if (!this.metadataReviewAdvanceReady()) {
                await this.service.modal.error(
                    `공통 메타데이터 검수 완료 ${this.metadataReviewCompletedFileCount()}개 중 다음 단계로 진행할 범위를 확인해주세요. 미완료 자료가 있으면 완료 자료를 직접 선택해 진행할 수 있습니다.`
                );
                return;
            }
            const blockingCount = this.metadataReviewBatchBlockingCount();
            if (blockingCount > 0) {
                await this.service.modal.error(
                    `필수값 누락 또는 원문 충돌 ${blockingCount}개를 먼저 확인해주세요.`
                );
                return;
            }
            if (this.autoSaveState === 'error') {
                await this.service.modal.error('자동 저장 오류를 해결한 뒤 다음 단계로 이동해주세요.');
                return;
            }
            this.markMetadataAdvanceScope();
            await this.ensureActiveReviewScopeItem();
        }
        if (key === 'bibliography') {
            this.initialiseMetadataReviewFocus();
            this.syncMetadataReviewFilePageToIndex(this.activeBatchIndex);
        }
        if (key === 'layout') {
            this.initialiseDtdReviewFocus();
        }
        this.metadataSection = key;
        await this.service.render();
        this.scrollToCurrentStep();
    }

    public async selectReviewSection(key: ReviewSectionKey) {
        this.syncActiveBatch();
        this.reviewSection = key;
        this.reviewTextPage = 1;
        this.reviewTranslationPage = 1;
        this.reviewTranslationCandidateExpandedIndex = -1;
        if (key === 'paragraphs') {
            this.reviewParagraphIndex = 0;
            this.reviewParagraphDraft = this.reviewParagraphs()[0] || '';
        }
        if (key === 'entities') {
            this.registrationEntityPage = 1;
            const first = this.registrationEntityRows()[0];
            if (first) this.registrationEntityIndex = first.index;
        }
        await this.renderPreservingViewport();
    }

    public async nextMetadataSection() {
        const index = this.metadataSectionIndex();
        if (index < this.metadataSections.length - 1) {
            await this.selectMetadataSection(this.metadataSections[index + 1].key);
        }
    }

    public async prevMetadataSection() {
        const index = this.metadataSectionIndex();
        if (index > 0) await this.selectMetadataSection(this.metadataSections[index - 1].key);
    }

    public async nextReviewSection() {
        const index = this.reviewSectionIndex();
        if (index < this.reviewSections.length - 1) await this.selectReviewSection(this.reviewSections[index + 1].key);
    }

    public async prevReviewSection() {
        const index = this.reviewSectionIndex();
        if (index > 0) await this.selectReviewSection(this.reviewSections[index - 1].key);
    }

    public async goRegisterStep(step: RegisterStepKey) {
        if (!this.deferredRegistrationReviewStagesVisible && step === 'manual') {
            step = 'complete';
        }
        if (this.uploadSourceType === 'incremental' && step !== 'upload') {
            await this.service.modal.error("증분 수집은 현재 단계에서 소스와 실행 이력을 관리합니다.");
            return;
        }
        if (this.registerStep === 'upload' && step !== 'upload') {
            await this.proceedToMetadataReview(false);
            return;
        }
        if (step !== 'upload' && !this.analysisId) {
            await this.service.modal.error("먼저 파일 또는 URL 원본을 분석해주세요.");
            return;
        }
        if (this.registerStep !== 'upload') this.syncActiveBatch();
        if (this.registerStep === 'metadata' && this.registerStepIndex(step) > this.registerStepIndex('metadata')) {
            if (this.visibilityCompletedCount() < this.visibilityTargetCount()) {
                await this.service.modal.error('먼저 모든 파일의 공개 범위·중복 여부·보안 검사 수준을 확인해주세요.');
                return;
            }
            if (!this.metadataReviewAdvanceReady()) {
                await this.service.modal.error(
                    '공통 메타데이터 검수를 완료한 자료만 선택해 다음 단계로 진행해주세요.'
                );
                return;
            }
            await this.ensureActiveReviewScopeItem();
            if (this.metadataV21PendingCount() > 0) {
                await this.service.modal.error(
                    `V2.1 후보 검토 ${this.metadataV21PendingCount()}개를 확정해주세요.`
                );
                return;
            }
            if (this.xmlReviewBatchPendingCount() > 0) {
                await this.service.modal.error(
                    `XML 원본 비교 검수 ${this.xmlReviewBatchPendingCount()}개 필드를 완료해주세요.`
                );
                return;
            }
            this.markMetadataAdvanceScope();
        }
        if (step === 'complete') {
            await this.ensureActiveReviewScopeItem();
        }
        if (this.registerStep !== 'upload') this.syncActiveBatch();
        this.registerStep = step;
        await this.service.render();
        this.scrollToCurrentStep();
        if (step === 'complete') {
            if (
                !this.finalServerPreflightReady()
                || !this.registrationPreflightCacheCurrent()
            ) {
                await this.refreshRegistrationPreflight();
            }
            this.restoreFinalReviewReturnPosition();
        }
    }

    private restoreFinalReviewReturnPosition() {
        if (!this.finalReviewReturnState) return;
        const state = this.finalReviewReturnState;
        this.finalReviewReturnState = null;
        setTimeout(() => {
            const target = state.anchorId
                ? document.getElementById(`${state.anchorId}`)
                : null;
            if (target) {
                target.scrollIntoView({ behavior: 'smooth', block: 'center' });
                if (typeof (target as any).focus === 'function') {
                    (target as any).focus({ preventScroll: true });
                }
                return;
            }
            window.scrollTo({ top: Number(state.scrollY || 0) });
        }, 0);
    }

    public async nextRegisterStep() {
        if (this.uploadSourceType === 'incremental') return;
        if (this.registerStep === 'upload') {
            if (!this.batchItems.length || this.batchItems.every((item: any) => item.status === 'queued')) {
                await this.runAutoMeta();
            } else {
                await this.proceedToMetadataReview(false);
            }
            return;
        }

        this.syncActiveBatch();

        if (
            this.registerStep === 'metadata'
            && this.metadataSectionIndex() < this.metadataSections.length - 1
        ) {
            await this.nextMetadataSection();
            return;
        }

        if (this.registerStep === 'metadata') {
            if (!this.metadataReviewAdvanceReady()) {
                await this.service.modal.error(
                    '공통 메타데이터 검수를 완료한 자료만 선택해 다음 단계로 진행해주세요.'
                );
                return;
            }
            await this.ensureActiveReviewScopeItem();
            if (this.xmlReviewBatchPendingCount() > 0) {
                await this.service.modal.error(
                    `XML 원본 비교 검수 ${this.xmlReviewBatchPendingCount()}개 필드를 완료해주세요.`
                );
                return;
            }
            this.markMetadataAdvanceScope();
        }

        const index = this.currentStepIndex();
        if (index < this.registerSteps.length - 1) {
            const nextStep = this.registerSteps[index + 1].key;
            if (nextStep === 'complete') {
                await this.ensureActiveReviewScopeItem();
            }
            if (this.registerStep !== 'upload') this.syncActiveBatch();
            this.registerStep = nextStep;
            await this.service.render();
            this.scrollToCurrentStep();
            if (this.registerStep === 'complete') {
                if (
                    !this.finalServerPreflightReady()
                    || !this.registrationPreflightCacheCurrent()
                ) {
                    await this.refreshRegistrationPreflight();
                }
            }
        }
    }

    public async prevRegisterStep() {
        if (this.registerStep === 'metadata' && this.metadataSection !== 'visibility') {
            await this.prevMetadataSection();
            return;
        }
        const index = this.currentStepIndex();
        if (index > 0) {
            if (this.registerStep !== 'upload') this.syncActiveBatch();
            if (this.registerStep === 'complete') this.metadataSection = 'bibliography';
            this.registerStep = this.registerSteps[index - 1].key;
            await this.service.render();
            this.scrollToCurrentStep();
        }
    }

    private scrollToCurrentStep() {
        setTimeout(() => {
            const workbench = document.getElementById('register-workbench');
            if (!workbench) return;
            const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            workbench.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        }, 0);
    }

    public currentStepIndex() {
        return this.registerSteps.findIndex((step) => this.registrationStepActive(step.key));
    }

    public currentRegisterStep() {
        const index = this.currentStepIndex();
        return this.registerSteps[index >= 0 ? index : 0];
    }

    public registerStepIndex(key: RegisterStepKey) {
        return this.registerSteps.findIndex((step) => step.key === key);
    }

    public registerProgressPercent() {
        const total = this.registerSteps.length;
        if (total <= 0) return 100;
        const index = Math.max(0, this.currentStepIndex());
        return Math.round(((index + 1) / total) * 100);
    }

    public nextStepButtonLabel() {
        if (this.uploadSourceType === 'incremental') return '증분 수집 설정';
        if (this.registerStep === 'upload') {
            return this.batchItems.length > 0
                ? '분석 완료 파일로 메타정보 검수 시작'
                : '원본 자동 분석 시작';
        }
        if (this.registerStep === 'metadata') {
            if (this.metadataSection === 'visibility') return '다음: 공통 메타데이터 검수';
            return '다음: 최종 확인 및 자료함 등록';
        }
        return '자료함에 등록';
    }

    public previousStepButtonLabel() {
        if (this.registerStep === 'metadata') {
            if (this.metadataSection === 'visibility') return '이전: 원본 분석';
            return '이전: 공개 및 운영 설정';
        }
        if (this.registerStep === 'complete') return '이전: 공통 메타데이터 검수';
        return '이전';
    }

    public currentStepGuidance() {
        if (this.uploadSourceType === 'incremental') return '일·주 단위 실행 주기와 URL을 저장하면 변경·삭제 이력을 자동 추적합니다.';
        if (this.registerStep === 'upload') return '실제 원본 응답과 형식·XML 구조·추천 자료 유형을 파일별로 확인합니다.';
        if (this.registerStep === 'metadata') {
            if (this.metadataSection === 'visibility') return '먼저 파일별 공개 여부를 선택합니다.';
            return '파일을 바꿔가며 10개 공통 메타데이터와 원본 근거를 검수합니다.';
        }
        return '입력 내용을 확인한 뒤 자료함에 최종 등록합니다.';
    }

    public canGoNext() {
        if (this.uploadSourceType === 'incremental') return false;
        if (this.metaRecognizing || this.saving) return false;
        if (this.registerStep === 'upload') {
            if (this.batchItems.length > 0) return this.currentAnalysisReadyCount() > 0;
            return this.uploadSourceType === 'file'
                ? this.filePreflightsReady()
                : !!this.uploadFileName;
        }
        if (this.registerStep === 'metadata' && this.metadataSection === 'visibility') {
            return this.visibilityTargetCount() > 0 && this.visibilityCompletedCount() === this.visibilityTargetCount();
        }
        if (this.registerStep === 'metadata' && this.metadataSection === 'bibliography') {
            return this.metadataReviewAdvanceReady()
                && this.metadataReviewBatchBlockingCount() === 0
                && this.autoSaveState !== 'error';
        }
        return true;
    }

    public selectedSourceSummary() {
        if (this.uploadSourceType === 'incremental') return this.syncSources.length ? `${this.syncSources.length}개 수집 소스 관리 중` : '증분 수집 소스를 등록해주세요.';
        if (this.uploadSourceType === 'url') {
            return this.xmlUrls.length > 0 ? `${this.xmlUrls.length}개 XML URL 연결 완료` : 'XML URL을 입력해주세요.';
        }
        if (this.uploadFiles.length > 1) return `${this.uploadFiles.length}개 파일 선택됨`;
        return this.uploadFileName || '원문 파일을 선택해주세요.';
    }

    public fileSizeLabel(file: File) {
        const bytes = Number(file && file.size ? file.size : 0);
        if (bytes >= 1024 * 1024) return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
        if (bytes >= 1024) return `${Math.round(bytes / 1024).toLocaleString()} KB`;
        return `${bytes.toLocaleString()} B`;
    }

    public analysisProgressSnapshot() {
        const total = this.batchItems.length;
        const terminalStatuses = ['complete', 'error', 'saved', 'cancelled'];
        let completed = 0;
        let active = 0;
        let progressTotal = 0;
        for (const item of this.batchItems) {
            const status = `${item?.status || ''}`;
            if (terminalStatuses.includes(status)) {
                completed += 1;
                progressTotal += 100;
                continue;
            }
            if (['scanning', 'running'].includes(status)) active += 1;
            progressTotal += Math.max(
                0,
                Math.min(99, this.safeNumber(item?.progress, 0)),
            );
        }
        const percent = total
            ? Math.min(100, Math.round(progressTotal / total))
            : 0;
        const activeLabel = active > 0 ? `, 현재 ${active}개 분석 중` : '';
        return {
            total,
            completed,
            active,
            percent,
            transform: `scaleX(${percent / 100})`,
            ariaText: `${total}개 중 ${completed}개 처리 종료, 전체 ${percent}%${activeLabel}`,
        };
    }

    public analysisOverallProgressSnapshot() {
        const total = this.analysisOverallTotalCount();
        const terminalStatuses = ['complete', 'error', 'saved', 'cancelled'];
        let currentCompleted = 0;
        let active = 0;
        let progressTotal = this.processedRegistrationSourceCount * 100;
        for (const item of this.batchItems) {
            const status = `${item?.status || ''}`;
            if (terminalStatuses.includes(status)) {
                currentCompleted += 1;
                progressTotal += 100;
                continue;
            }
            if (['scanning', 'running'].includes(status)) active += 1;
            progressTotal += Math.max(
                0,
                Math.min(99, this.safeNumber(item?.progress, 0)),
            );
        }
        const completed = Math.min(
            total,
            this.processedRegistrationSourceCount + currentCompleted,
        );
        const percent = total
            ? Math.min(100, Math.round(progressTotal / total))
            : 0;
        const actionRequired = this.analysisActionRequiredCount();
        const waiting = Math.max(0, total - completed - active - actionRequired);
        const activeLabel = active > 0 ? `, 현재 ${active}개 분석 중` : '';
        return {
            total,
            completed,
            active,
            actionRequired,
            waiting,
            percent,
            transform: `scaleX(${percent / 100})`,
            ariaText: `업로드 전체 ${total}개 중 ${completed}개 처리 종료, ${actionRequired}개 조치 필요, ${waiting}개 대기, 전체 ${percent}%${activeLabel}`,
        };
    }

    public analysisProgressPercent() {
        return this.analysisProgressSnapshot().percent;
    }

    public analysisCompletedCount() {
        return this.analysisProgressSnapshot().completed;
    }

    public analysisCurrentName() {
        const running = this.batchItems.filter(
            (item: any) => ['scanning', 'running'].includes(item.status)
        );
        if (running.length > 1) return `${running[0].name} 외 ${running.length - 1}개`;
        if (running.length === 1) return running[0].name;
        if (this.analysisCompletedCount() === this.batchItems.length && this.batchItems.length) {
            return this.analysisActionRequiredCount() > 0
                ? `분석 종료 · 성공 ${this.analysisReadyCount()} / 조치 필요 ${this.analysisActionRequiredCount()}`
                : '모든 파일 분석 완료';
        }
        return '처리 대기 중';
    }

    public analysisCurrentStage() {
        const running = this.batchItems.filter(
            (item: any) => ['scanning', 'running'].includes(item.status)
        );
        if (running.length > 1) return `${running.length}개 파일 동시 처리 중`;
        if (running.length === 1) return running[0].stageLabel || '실제 처리 단계 확인 중';
        if (this.analysisCompletedCount() === this.batchItems.length && this.batchItems.length) {
            return this.analysisActionRequiredCount() > 0
                ? `서버 원본 ${this.analysisPreservedCount()}개는 보존되어 있습니다.`
                : '모든 실제 처리 단계를 완료했습니다.';
        }
        return '파일별 처리 순서를 기다리고 있습니다.';
    }

    public analysisStageSummary() {
        const running = this.batchItems.filter(
            (item: any) => ['scanning', 'running'].includes(item.status)
        );
        if (running.length > 1) {
            return running.map((item: any) => (
                `${item.name}: ${item.stageLabel || '처리 중'}`
            )).join(' · ');
        }
        if (running.length === 1) {
            return running[0].stageDetail
                || `${running[0].completedSteps || 0} / ${running[0].totalSteps || 11}단계 완료`;
        }
        if (this.analysisCompletedCount() === this.batchItems.length && this.batchItems.length) {
            return `처리 종료 ${this.analysisCompletedCount()}개 · 분석 성공 ${this.analysisReadyCount()}개 · 조치 필요 ${this.analysisActionRequiredCount()}개`;
        }
        return `${this.analysisCompletedCount()} / ${this.batchItems.length}개 파일 처리 종료`;
    }

    private analysisDurationLabel(milliseconds: number) {
        const totalSeconds = Math.max(0, Math.round(milliseconds / 1000));
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;
        if (hours > 0) return `${hours}시간 ${minutes}분`;
        if (minutes > 0) return `${minutes}분 ${seconds}초`;
        return `${seconds}초`;
    }

    public analysisBatchTimingLabel() {
        if (!this.analysisBatchStartedAt || !this.batchItems.length) return '';
        const endpoint = this.analysisBatchFinishedAt || Date.now();
        const elapsed = Math.max(0, endpoint - this.analysisBatchStartedAt);
        if (!this.metaRecognizing) {
            return `실제 소요 ${this.analysisDurationLabel(elapsed)} · 동시 최대 ${this.analysisWorkerConcurrency}개`;
        }
        const samples = this.batchItems
            .filter((item: any) => (
                ['complete', 'saved'].includes(`${item.status || ''}`)
                && !!item.analysis
                && !item.error
            ))
            .map((item: any) => (
                item.processingStartedAt && item.processingCompletedAt
                    ? item.processingCompletedAt - item.processingStartedAt : 0
            ))
            .filter((value: number) => value > 0)
            .sort((left: number, right: number) => left - right);
        if (samples.length < 3) {
            return `경과 ${this.analysisDurationLabel(elapsed)} · 남은 시간 계산 중 · 동시 최대 ${this.analysisWorkerConcurrency}개`;
        }
        const midpoint = Math.floor(samples.length / 2);
        const median = samples.length % 2
            ? samples[midpoint]
            : (samples[midpoint - 1] + samples[midpoint]) / 2;
        const remaining = this.batchItems.filter(
            (item: any) => !['complete', 'error', 'saved', 'cancelled'].includes(item.status)
        ).length;
        const waves = Math.ceil(remaining / this.analysisWorkerConcurrency);
        return `경과 ${this.analysisDurationLabel(elapsed)} · 추정 남은 시간 ${this.analysisDurationLabel(waves * median)} · ${this.analysisCompletedCount()} / ${this.batchItems.length}개 완료`;
    }

    public batchItemStatusLabel(item: any) {
        if (!item) return '대기';
        if (item.status === 'queued') return '대기';
        if (item.status === 'scanning') return `${item.stageLabel || '악성코드 검사 중'} · ${this.safeNumber(item.progress, 0)}%`;
        if (item.status === 'running') return `${item.stageLabel || '문서 분석 중'} · ${this.safeNumber(item.progress, 0)}%`;
        if (item.status === 'complete') return item.securityScan ? '보안 검사 통과 · 메타정보 완료' : '메타정보 완료';
        if (item.status === 'saved') return '등록 완료';
        if (item.status === 'cancelled') return '등록 취소';
        if (item.status === 'error' && this.duplicateReviewRequired(item)) {
            return '동일 파일 등록됨 · 확인 필요';
        }
        if (item.status === 'error' && this.batchItemOperationInProgress(item)) {
            return this.batchItemOperationReconnectable(item)
                ? '서버 분석 상태 확인 필요'
                : '업로드 원본 분석 준비 필요';
        }
        if (item.status === 'error' && item.failureStage === 'save') return '저장 실패 · 재시도 가능';
        if (`${item.error || ''}`.includes('보안 검사')) return '위험 파일 차단';
        return '처리 실패 · 재시도 가능';
    }

    public analysisTotalCount() {
        return this.analysisOverallTotalCount();
    }

    public analysisBatchTotalCount() {
        return this.batchItems.length;
    }

    public analysisOverallTotalCount() {
        const inferredSelectionCount = Math.max(
            this.processedRegistrationSourceCount + this.queuedRegistrationSourceCount(),
            this.processedRegistrationSourceCount + this.batchItems.length,
        );
        if (this.selectedRegistrationSourceCount > 0) {
            return Math.max(
                this.selectedRegistrationSourceCount,
                inferredSelectionCount,
            );
        }
        return Math.max(inferredSelectionCount, this.registrationWorkspaceSourceCount, 0);
    }

    public analysisOverallCompletedCount() {
        const terminalStatuses = ['complete', 'error', 'saved', 'cancelled'];
        const currentCompleted = this.batchItems.filter((item: any) => (
            terminalStatuses.includes(`${item?.status || ''}`)
        )).length;
        return Math.min(
            this.analysisOverallTotalCount(),
            this.processedRegistrationSourceCount + currentCompleted,
        );
    }

    public analysisOverallReadyCount() {
        return Math.min(
            this.analysisOverallTotalCount(),
            this.completedRegistrationCount + this.analysisReadyCount(),
        );
    }

    public currentAnalysisReadyCount() {
        return this.batchItems.filter(
            (item: any) => this.batchItemCanProceed(item)
        ).length;
    }

    public analysisItemComplete(item: any) {
        return !!item && (
            ['saved', 'registration_complete'].includes(`${item.status || ''}`)
            || this.batchItemCanProceed(item)
        );
    }

    public analysisReadyCount() {
        return this.analysisQueueAllRows().filter(
            (row: any) => this.analysisItemComplete(row.item)
        ).length;
    }

    public analysisAttentionCount() {
        return this.analysisQueueAllRows().filter((row: any) => (
            row.item
            && row.item.status === 'complete'
            && !this.batchItemCanProceed(row.item)
        )).length;
    }

    public analysisInProgressCount() {
        return this.analysisQueueAllRows().filter((row: any) => (
            row.item && ['scanning', 'running'].includes(row.item.status)
        )).length;
    }

    public analysisWaitingCount() {
        return this.analysisQueueAllRows().filter(
            (row: any) => row.item && row.item.status === 'queued'
        ).length;
    }

    public batchItemSourceAcquired(item: any) {
        if (!item) return false;
        if (`${item.stagedSourceId || ''}`.trim()) return true;
        const readiness = item.analysis && item.analysis.analysis_readiness
            && typeof item.analysis.analysis_readiness === 'object'
            ? item.analysis.analysis_readiness : {};
        if (readiness.source_acquired === true) return true;
        const probe = this.batchSourceProbe(item);
        const classification = `${probe.classification || ''}`.trim().toLowerCase();
        if (['actual_xml', 'pdf', 'image'].includes(classification)) return true;
        const actualFormat = `${probe.actual_format || ''}`.trim().toLowerCase();
        return !!actualFormat && !['html', 'unknown'].includes(actualFormat);
    }

    public batchItemServerPreservationFailure(item: any) {
        if (!item) return false;
        const code = `${
            item.errorInfo?.errorCode || item.errorInfo?.error_code || ''
        }`.trim().toUpperCase();
        if (code === 'SOURCE_PRESERVATION_INVALID') return true;
        const message = `${
            item.error || item.errorInfo?.message || ''
        }`.trim().toLowerCase();
        if (
            message.includes('서버 보존 원본의 무결성')
            || /보존된 등록 원본.*(찾을 수 없|경로|sha-256|무결성)/i.test(message)
        ) return true;
        const stagedSourceId = `${item.stagedSourceId || ''}`.trim();
        const rawSourceIndex = item.sourceIndex;
        const sourceIndex = Number(rawSourceIndex);
        const hasSourceIndex = rawSourceIndex !== null
            && typeof rawSourceIndex !== 'undefined'
            && `${rawSourceIndex}`.trim() !== ''
            && Number.isInteger(sourceIndex)
            && sourceIndex >= 0;
        const preflight = this.filePreflights.find((row: any, index: number) => (
            !!row
            && (
                (!!stagedSourceId && `${row.stagedSourceId || ''}` === stagedSourceId)
                || (hasSourceIndex && Number(row.sourceIndex ?? index) === sourceIndex)
            )
        ));
        return !!(
            preflight
            && preflight.stageStatus === 'error'
            && /원본|보존|sha-256|무결성/i.test(`${preflight.stageError || ''}`)
        );
    }

    public batchItemServerPreserved(item: any) {
        if (!item || this.batchItemServerPreservationFailure(item)) return false;
        const stagedSourceId = `${item.stagedSourceId || ''}`.trim();
        const rawSourceIndex = item.sourceIndex;
        const sourceIndex = Number(rawSourceIndex);
        const hasSourceIndex = rawSourceIndex !== null
            && typeof rawSourceIndex !== 'undefined'
            && `${rawSourceIndex}`.trim() !== ''
            && Number.isInteger(sourceIndex)
            && sourceIndex >= 0;
        const preflight = this.filePreflights.find((row: any, index: number) => (
            !!row
            && (
                (!!stagedSourceId && `${row.stagedSourceId || ''}` === stagedSourceId)
                || (hasSourceIndex && Number(row.sourceIndex ?? index) === sourceIndex)
            )
        ));
        if (preflight) {
            return preflight.stageStatus !== 'error'
                && preflight.staged === true
                && !!`${preflight.stagedSourceId || ''}`.trim();
        }
        return !!stagedSourceId;
    }

    public batchItemSourceStatusComplete(item: any) {
        if (this.batchItemServerPreservationFailure(item)) return false;
        return this.batchItemServerPreserved(item)
            || this.batchItemSourceAcquired(item)
            || this.batchItemCanProceed(item);
    }

    private batchItemOperationInProgress(item: any) {
        const code = `${item?.errorInfo?.errorCode || item?.errorInfo?.error_code || ''}`.toUpperCase();
        const message = `${item?.error || item?.errorInfo?.message || ''}`.toUpperCase();
        return code === 'OPERATION_IN_PROGRESS' || message.includes('OPERATION_IN_PROGRESS');
    }

    private operationReconnectProgressId(item: any) {
        const candidates = [
            item?.progressId,
            item?.progress_id,
            item?.errorInfo?.existingProgressId,
            item?.errorInfo?.existing_progress_id,
        ];
        return candidates
            .map((value: any) => `${value || ''}`.trim().toLowerCase())
            .find((value: string) => /^[0-9a-f]{32}$/.test(value)) || '';
    }

    private batchItemOperationReconnectable(item: any) {
        return this.batchItemOperationInProgress(item)
            && !!this.operationReconnectProgressId(item);
    }

    private batchItemTrueSourceFailure(item: any) {
        if (!item || item.status !== 'error') return false;
        if (this.batchItemServerPreservationFailure(item)) return true;
        if (this.batchItemSourceAcquired(item)) return false;
        const stage = `${item.failureStage || item.errorInfo?.stage || ''}`.trim().toLowerCase();
        const field = `${item.errorInfo?.field || ''}`.trim().toLowerCase();
        return ['source', 'file', 'download', 'fetch', 'url'].includes(stage)
            || ['file', 'source_url'].includes(field);
    }

    public analysisItemNeedsAction(item: any) {
        if (!item) return false;
        if (item.status === 'error' || item.status === 'cancelled') return true;
        return item.status === 'complete' && !this.batchItemCanProceed(item);
    }

    public analysisActionRequiredCount() {
        return this.analysisQueueAllRows().filter(
            (row: any) => this.analysisItemNeedsAction(row.item)
        ).length;
    }

    public analysisActiveOrWaitingCount() {
        return this.analysisQueueAllRows().filter((row: any) => (
            row.item && ['queued', 'scanning', 'running'].includes(row.item.status)
        )).length;
    }

    public analysisPreservedCount() {
        return this.analysisQueueAllRows().filter(
            (row: any) => this.batchItemServerPreserved(row.item)
        ).length;
    }

    public analysisOverallPreservedCount() {
        if (this.uploadSourceType === 'file') {
            return Math.min(
                this.analysisOverallTotalCount(),
                Math.max(this.registrationWorkspaceSourceCount, this.analysisPreservedCount()),
            );
        }
        const acquired = this.batchItems.filter(
            (item: any) => this.batchItemSourceAcquired(item),
        ).length;
        return Math.min(
            this.analysisOverallTotalCount(),
            this.processedRegistrationSourceCount + acquired,
        );
    }

    public analysisPreservedPercent() {
        const total = this.analysisOverallTotalCount();
        if (!total) return 0;
        return Math.round((this.analysisOverallPreservedCount() / total) * 100);
    }

    public analysisOutcomeTitle() {
        if (!this.batchItems.length) return '분석할 파일이 없습니다.';
        const overallCompleted = this.analysisOverallCompletedCount();
        const overallTotal = this.analysisOverallTotalCount();
        if (this.metaRecognizing) {
            return `원본 분석 진행 중 · ${overallCompleted} / ${overallTotal}개 처리`;
        }
        const ready = this.analysisReadyCount();
        const attention = this.analysisActionRequiredCount();
        const resumableWaiting = this.resumableWaitingAnalysisCount();
        if (resumableWaiting > 0) {
            return `원본 분석 대기 · ${resumableWaiting}개 재개 가능 · 완료 ${ready}${
                attention > 0 ? ` / 조치 필요 ${attention}` : ''
            } · 전체 ${overallCompleted} / ${overallTotal}개 처리`;
        }
        if (attention > 0) {
            return `원본 분석 결과 · 전체 ${overallCompleted} / ${overallTotal}개 처리 · 분석 완료 ${ready} / 조치 필요 ${attention}`;
        }
        return `원본 분석 완료 · ${ready}개 다음 단계 준비 · 전체 ${overallCompleted} / ${overallTotal}개 처리`;
    }

    public analysisOutcomeDescription() {
        const preserved = this.analysisOverallPreservedCount();
        const total = this.analysisOverallTotalCount();
        if (this.metaRecognizing) {
            return `${this.analysisCurrentStage()} · 서버 보존 원본 ${preserved} / 업로드 ${total}개`;
        }
        const resumableWaiting = this.resumableWaitingAnalysisCount();
        if (resumableWaiting > 0) {
            return `서버에 보존된 분석 대기 ${resumableWaiting}개를 상단의 재개 버튼으로 바로 이어서 분석할 수 있습니다.`;
        }
        if (this.analysisActionRequiredCount() > 0) {
            return `업로드 원본 ${total}개 중 서버에서 확인된 ${preserved}개는 유지되어 있습니다. 조치가 필요한 항목만 다시 분석합니다.`;
        }
        return `선택 원본 ${total}개와 서버 보존 원본 ${preserved}개를 확인했습니다.`;
    }

    private analysisIssueCode(item: any) {
        if (!item) return '';
        if (this.batchItemOperationInProgress(item)) {
            return this.batchItemOperationReconnectable(item)
                ? 'OPERATION_RECONNECTABLE'
                : 'OPERATION_CLAIM_CONFLICT';
        }
        const code = `${item.errorInfo?.errorCode || item.errorInfo?.error_code || ''}`.trim().toUpperCase();
        if (code) return code;
        if (item.status === 'complete' && !this.batchItemCanProceed(item)) return 'REVIEW_REQUIRED';
        if (item.status === 'cancelled') return 'ANALYSIS_CANCELLED';
        return item.status === 'error' ? 'ANALYSIS_FAILED' : '';
    }

    public analysisPrimaryIssueCode() {
        const counts: any = {};
        this.analysisQueueAllRows().forEach((row: any) => {
            const item = row.item;
            if (!this.analysisItemNeedsAction(item)) return;
            const code = this.analysisIssueCode(item);
            if (code) counts[code] = (counts[code] || 0) + 1;
        });
        return Object.keys(counts).sort((left: string, right: string) => (
            counts[right] - counts[left] || left.localeCompare(right)
        ))[0] || '';
    }

    public analysisPrimaryIssueCount() {
        const code = this.analysisPrimaryIssueCode();
        if (!code) return 0;
        return this.analysisQueueAllRows().filter(
            (row: any) => this.analysisIssueCode(row.item) === code
        ).length;
    }

    public analysisPrimaryIssueTitle() {
        const code = this.analysisPrimaryIssueCode();
        if (code === 'OPERATION_RECONNECTABLE') return '서버에서 실행 중인 분석 상태를 확인합니다.';
        if (code === 'OPERATION_CLAIM_CONFLICT') return '업로드 원본의 분석 준비를 확인해야 합니다.';
        if (code === 'REVIEW_REQUIRED') return 'Profile 또는 추출 결과를 확인해주세요.';
        if (code === 'DUPLICATE_MATERIAL') return '이미 등록된 동일 원본이 있습니다.';
        if (code === 'ANALYSIS_CANCELLED') return '취소된 분석 항목이 있습니다.';
        return '같은 원인의 조치 필요 항목을 묶어 표시했습니다.';
    }

    public analysisPrimaryIssueDescription() {
        const code = this.analysisPrimaryIssueCode();
        if (code === 'OPERATION_RECONNECTABLE') {
            return '원본은 보존되어 있습니다. 새 분석을 시작하지 않고 서버의 기존 진행 ID를 조회해 완료 결과 또는 실제 진행 상태만 연결합니다.';
        }
        if (code === 'OPERATION_CLAIM_CONFLICT') {
            return '원본은 정상 보존되어 있고 실행 중인 서버 분석은 없습니다. 덮어쓰기 과정에서 분리된 처리 권한을 이번 작업에 다시 연결한 뒤, 새로 업로드한 원본으로 분석합니다.';
        }
        if (code === 'DUPLICATE_MATERIAL') {
            return '원본을 다시 올리지 말고 기존 자료 확인 또는 새 버전 등록 정책을 선택해주세요.';
        }
        return '오른쪽 상세 패널에서 대표 오류와 권장 조치를 확인할 수 있습니다.';
    }

    public analysisPrimaryIssueClass() {
        return ['OPERATION_RECONNECTABLE', 'OPERATION_CLAIM_CONFLICT'].includes(
            this.analysisPrimaryIssueCode()
        )
            ? 'is-blocked' : 'is-error';
    }

    public analysisPrimaryIssueBadgeLabel() {
        const labels: any = {
            OPERATION_RECONNECTABLE: '서버 분석 상태 확인',
            OPERATION_CLAIM_CONFLICT: '업로드 원본 분석 준비',
            REVIEW_REQUIRED: '검수 확인 필요',
            DUPLICATE_MATERIAL: '동일 원본 등록 확인',
            ANALYSIS_CANCELLED: '분석 취소',
        };
        const code = this.analysisPrimaryIssueCode();
        return labels[code] || '조치 필요';
    }

    private analysisQueuePendingItem(source: any) {
        const sourceIndex = this.registrationAnalysisSourceIndex(source);
        const stageFailed = `${source?.stageStatus || ''}` === 'error';
        const stageActive = ['pending', 'uploading'].includes(
            `${source?.stageStatus || ''}`
        );
        const stageError = `${source?.stageError || ''}`.trim();
        const preflight = this.uploadSourceType === 'file'
            ? this.filePreflights.find((row: any, index: number) => (
                Number(row?.sourceIndex ?? index) === sourceIndex
            )) || null
            : null;
        const preflightStatus = `${preflight?.status || ''}`;
        const preflightActive = ['checking', 'processing'].includes(preflightStatus);
        const preflightBlocked = !!(
            preflight
            && !stageFailed
            && !stageActive
            && !preflightActive
            && !this.filePreflightReady(preflight)
        );
        const duplicateBlocked = preflightBlocked && preflightStatus === 'registered';
        const needsAction = stageFailed || preflightBlocked;
        const actionMessage = preflightBlocked
            ? this.filePreflightBlockingMessage(preflight)
            : stageError || '서버 작업공간에 원본을 보존하지 못했습니다.';
        return {
            name: `${source?.name || `업로드 원본 ${sourceIndex + 1}`}`,
            status: needsAction ? 'error' : 'queued',
            progress: 0,
            stageLabel: duplicateBlocked
                ? '동일 원본 등록 확인'
                : stageFailed
                ? '서버 원본 보존 실패'
                : preflightBlocked ? '분석 전 확인 필요'
                : stageActive ? '서버 원본 보존 중' : '분석 대기',
            stageDetail: needsAction
                ? actionMessage
                : stageActive
                    ? '원본 파일을 서버 작업공간에 안전하게 보존하고 있습니다.'
                    : '업로드한 전체 목록에서 분석 순서를 기다리고 있습니다.',
            completedSteps: 0,
            totalSteps: 11,
            securityScan: null,
            analysis: null,
            error: needsAction ? actionMessage : '',
            form: null,
            visibilityConfirmed: false,
            visibilityStatus: '',
            securityAcknowledged: false,
            duplicateConfirmed: false,
            duplicateOverrideSelected: false,
            duplicateOverrideConfirmed: false,
            progressId: '',
            securityProgressId: '',
            sourceUrl: `${source?.sourceUrl || ''}`,
            sourceFile: source?.sourceFile || null,
            sourceIndex,
            stagedSourceId: `${source?.stagedSourceId || ''}`,
            preflightHash: `${source?.preflightHash || ''}`,
            failureStage: duplicateBlocked
                ? 'duplicate' : needsAction ? 'source' : '',
            errorDetails: '',
            errorInfo: needsAction ? {
                stage: duplicateBlocked
                    ? 'duplicate' : stageFailed ? 'source' : 'preflight',
                errorCode: duplicateBlocked
                    ? 'DUPLICATE_MATERIAL'
                    : stageFailed
                        ? 'SOURCE_PRESERVATION_INVALID' : 'FILE_PREFLIGHT_REQUIRED',
                message: actionMessage,
                userAction: duplicateBlocked
                    ? this.aiSettingsAdmin
                        ? '기존 자료를 확인하거나 새 버전 등록 체크박스를 선택해주세요.'
                        : '기존 자료를 확인하고 이번 등록에서 제외해주세요.'
                    : stageFailed
                        ? '원본 보존 상태를 확인한 뒤 업로드 단계에서 다시 시도해주세요.'
                        : '파일 선택 목록에서 중복 확인 상태를 확인해주세요.',
                retryable: !duplicateBlocked,
                requestId: '',
            } : null,
            requestedProfile: '',
            displayOnly: true,
        };
    }

    public analysisQueueAllRows() {
        const merged = new Map<string, any>();
        const activeBatchIndexes = new Map<string, number>();
        const append = (source: any, fallback: number, item: any = null) => {
            if (!source || typeof source !== 'object') return;
            const descriptor = this.registrationAnalysisSourceDescriptor(source, fallback);
            const existing = merged.get(descriptor.key) || {};
            const next: any = { ...existing };
            Object.entries(descriptor).forEach(([key, value]: [string, any]) => {
                if (key === 'item' && !value) return;
                if (value === '' || value === null || typeof value === 'undefined') return;
                next[key] = value;
            });
            if (source?.item) next.item = source.item;
            if (item) next.item = item;
            next.key = descriptor.key;
            next.staged = existing.staged === true || descriptor.staged === true;
            merged.set(descriptor.key, next);
        };

        this.registrationAnalysisSources.forEach((source: any, index: number) => {
            append(source, index, source?.item || null);
        });
        this.registrationQueuedSources().forEach((source: any, index: number) => {
            append(source, this.processedRegistrationSourceCount + index);
        });
        this.batchItems.forEach((item: any, batchIndex: number) => {
            const fallback = this.processedRegistrationSourceCount + batchIndex;
            const key = this.registrationAnalysisSourceKey(item, fallback);
            append(item, fallback, item);
            activeBatchIndexes.set(key, batchIndex);
        });

        return Array.from(merged.values())
            .sort((left: any, right: any) => {
                const leftIndex = Number(left?.sourceIndex);
                const rightIndex = Number(right?.sourceIndex);
                const safeLeft = Number.isInteger(leftIndex) && leftIndex >= 0
                    ? leftIndex : Number.MAX_SAFE_INTEGER;
                const safeRight = Number.isInteger(rightIndex) && rightIndex >= 0
                    ? rightIndex : Number.MAX_SAFE_INTEGER;
                return safeLeft - safeRight
                    || `${left?.name || ''}`.localeCompare(`${right?.name || ''}`);
            })
            .map((source: any, index: number) => ({
                item: source.item || this.analysisQueuePendingItem(source),
                index,
                batchIndex: activeBatchIndexes.has(`${source.key || ''}`)
                    ? activeBatchIndexes.get(`${source.key || ''}`) : -1,
                sourceIndex: this.registrationAnalysisSourceIndex(source, index),
                key: `${source.key || `analysis-row:${index}`}`,
            }));
    }

    public analysisQueueAllCount() {
        return this.analysisQueueAllRows().length;
    }

    private analysisQueueIndexForBatchIndex(batchIndex: number): number | null {
        const row = this.analysisQueueAllRows().find(
            (candidate: any) => candidate.batchIndex === batchIndex
        );
        return row ? row.index : null;
    }

    private analysisQueueFilterMatches(item: any) {
        if (this.analysisQueueFilter === 'attention') return this.analysisItemNeedsAction(item);
        if (this.analysisQueueFilter === 'active') {
            return !!item && ['queued', 'scanning', 'running'].includes(item.status);
        }
        if (this.analysisQueueFilter === 'ready') return this.analysisItemComplete(item);
        return true;
    }

    public analysisQueueFilteredRows() {
        const search = `${this.analysisQueueSearch || ''}`.trim().toLocaleLowerCase();
        return this.analysisQueueAllRows()
            .filter((row: any) => {
                if (!this.analysisQueueFilterMatches(row.item)) return false;
                if (!search) return true;
                const haystack = [
                    row.item?.name,
                    row.item?.error,
                    row.item?.errorInfo?.errorCode,
                    this.batchItemMaterialTypeLabel(row.item),
                    this.batchItemProfileLabel(row.item),
                    this.batchAnalysisStateLabel(row.item),
                ].map((value: any) => `${value || ''}`.toLocaleLowerCase()).join(' ');
                return haystack.includes(search);
            });
    }

    public analysisQueueFilteredCount() {
        return this.analysisQueueFilteredRows().length;
    }

    public setAnalysisQueueSearch(value: any) {
        this.analysisQueueSearch = `${value || ''}`.slice(0, 200);
        this.analysisQueuePage = 1;
        this.selectedAnalysisInspectorIndex = null;
    }

    public setAnalysisQueueFilter(filter: 'all' | 'attention' | 'active' | 'ready') {
        this.analysisQueueFilter = filter;
        this.analysisQueuePage = 1;
        this.selectedAnalysisInspectorIndex = null;
    }

    public resetAnalysisQueueFilter() {
        this.analysisQueueSearch = '';
        this.analysisQueueFilter = 'all';
        this.analysisQueuePage = 1;
        this.selectedAnalysisInspectorIndex = null;
    }

    public analysisQueuePageCount() {
        return Math.max(1, Math.ceil(this.analysisQueueFilteredCount() / this.analysisQueuePageSize));
    }

    private defaultAnalysisInspectorOpen() {
        return typeof window === 'undefined' || window.innerWidth > 1320;
    }

    public setAnalysisQueuePage(page: number) {
        this.analysisQueuePage = Math.max(1, Math.min(this.analysisQueuePageCount(), Number(page) || 1));
        this.selectedAnalysisInspectorIndex = null;
    }

    public analysisQueuePageRows() {
        const page = Math.max(1, Math.min(this.analysisQueuePage, this.analysisQueuePageCount()));
        const start = (page - 1) * this.analysisQueuePageSize;
        return this.analysisQueueFilteredRows().slice(start, start + this.analysisQueuePageSize);
    }

    public analysisQueuePageRangeLabel() {
        const count = this.analysisQueueFilteredCount();
        if (!count) return '0개';
        const page = Math.max(1, Math.min(this.analysisQueuePage, this.analysisQueuePageCount()));
        const start = (page - 1) * this.analysisQueuePageSize + 1;
        const end = Math.min(count, start + this.analysisQueuePageSize - 1);
        return `${start}–${end} / ${count}개`;
    }

    public analysisRowNumber(_item: any, fallbackIndex: number) {
        return Math.max(0, Number(fallbackIndex) || 0) + 1;
    }

    public resolvedAnalysisInspectorRow() {
        const pageRows = this.analysisQueuePageRows();
        if (!pageRows.length) return null;
        return pageRows.find(
            (row: any) => row.index === this.selectedAnalysisInspectorIndex
        ) || pageRows[0];
    }

    public resolvedAnalysisInspectorIndex() {
        const row = this.resolvedAnalysisInspectorRow();
        return row ? Number(row.index) : -1;
    }

    public resolvedAnalysisInspectorBatchIndex() {
        const row = this.resolvedAnalysisInspectorRow();
        return row ? Number(row.batchIndex) : -1;
    }

    public analysisInspectorItem() {
        return this.resolvedAnalysisInspectorRow()?.item || null;
    }

    public async selectAnalysisInspector(index: number, event?: Event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (!this.analysisQueueAllRows().some((row: any) => row.index === index)) return;
        this.selectedAnalysisInspectorIndex = index;
        this.analysisInspectorOpen = true;
        await this.service.render();
        const panel = document.querySelector(
            '.analysis-command-inspector'
        ) as HTMLElement | null;
        if (!panel) return;
        panel.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
        panel.focus({ preventScroll: true });
    }

    public async toggleAnalysisInspector() {
        this.analysisInspectorOpen = !this.analysisInspectorOpen;
        await this.service.render();
        if (this.analysisInspectorOpen) {
            const panel = document.querySelector(
                '.analysis-command-inspector'
            ) as HTMLElement | null;
            if (panel) panel.focus({ preventScroll: true });
        }
    }

    public async closeAnalysisInspector(event?: Event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (!this.analysisInspectorOpen) return;
        const selectedIndex = this.resolvedAnalysisInspectorIndex();
        this.analysisInspectorOpen = false;
        await this.service.render();
        const trigger = document.getElementById(
            `analysis-row-${selectedIndex}`
        ) as HTMLElement | null;
        if (trigger) trigger.focus({ preventScroll: true });
    }

    public analysisInspectorNeedsAction() {
        return this.analysisItemNeedsAction(this.analysisInspectorItem());
    }

    public analysisInspectorIssueMessage() {
        const item = this.analysisInspectorItem();
        if (!item) return '';
        if (this.batchItemOperationInProgress(item)) {
            return this.batchItemOperationReconnectable(item)
                ? '서버 원본은 보존되어 있고 실제 분석 진행 ID도 확인됐습니다. 새 요청 없이 해당 상태를 조회합니다.'
                : '서버 원본은 정상 보존되어 있지만 덮어쓰기 권한이 이 작업의 원본에 끝까지 연결되지 않았습니다. 실제 실행 중인 분석은 아닙니다.';
        }
        return `${item.error || ''}`.trim()
            || '추천 자료 유형 또는 추출 준비 상태를 확인해주세요.';
    }

    public analysisInspectorRetryable() {
        const index = this.resolvedAnalysisInspectorBatchIndex();
        return index >= 0 && this.failedItemCanRetry(this.batchItems[index], index);
    }

    public analysisInspectorRetryActionLabel() {
        const item = this.analysisInspectorItem();
        if (this.batchItemOperationReconnectable(item)) {
            return '서버 분석 상태 확인';
        }
        if (this.batchItemOperationInProgress(item)) {
            return '업로드된 원본으로 다시 분석';
        }
        return '이 파일만 다시 시도';
    }

    public batchItemCanProceed(item: any) {
        if (!item || item.status !== 'complete' || !item.analysis || !item.analysis.id) return false;
        const source = item.analysis.source && typeof item.analysis.source === 'object'
            ? item.analysis.source : {};
        const actualFormat = this.inferSourceFormat(source);
        const profile = item.analysis.document_profile && typeof item.analysis.document_profile === 'object'
            ? item.analysis.document_profile : {};
        const readiness = item.analysis.analysis_readiness
            && typeof item.analysis.analysis_readiness === 'object'
            ? item.analysis.analysis_readiness : {};
        if (!actualFormat || ['html', 'unknown', 'do'].includes(actualFormat)) return false;
        if (!profile.key) return false;
        if (readiness.can_proceed === false) return false;
        if (readiness.source_acquired === false || readiness.format_detected === false) return false;
        if (readiness.extraction_completed === false && readiness.extraction_runnable === false) return false;
        return true;
    }

    public batchItemInputTypeLabel(item: any) {
        return item && item.sourceUrl ? 'URL' : '파일';
    }

    public batchItemActualFormatLabel(item: any) {
        const source = item && item.analysis && item.analysis.source ? item.analysis.source : {};
        let format = this.inferSourceFormat(source);
        if (!format && item && item.errorInfo && item.errorInfo.sourceProbe) {
            const probe = item.errorInfo.sourceProbe;
            format = `${probe.actual_format || ''}`.trim().toLowerCase();
            if (!format) {
                const formats: any = {
                    actual_xml: 'xml',
                    html_viewer: 'html',
                    pdf: 'pdf',
                    image: 'image',
                    empty: '',
                    unknown: '',
                };
                format = formats[`${probe.classification || ''}`] || '';
            }
        }
        return format ? format.toUpperCase() : '판별 전';
    }

    public batchItemSourceStatusLabel(item: any) {
        if (this.batchItemServerPreservationFailure(item)) {
            return '서버 원본 무결성 확인 필요';
        }
        if (this.batchItemServerPreserved(item)) {
            return '서버 원본 보존 완료';
        }
        if (this.batchItemSourceAcquired(item) || this.batchItemCanProceed(item)) return '원본 확보 완료';
        if (this.batchItemTrueSourceFailure(item)) return '원본 확보 실패';
        const preflight = this.filePreflights.find((row: any, index: number) => (
            Number(row?.sourceIndex ?? index) === Number(item?.sourceIndex)
        ));
        if (preflight && ['pending', 'uploading'].includes(`${preflight.stageStatus || ''}`)) {
            return '서버 원본 보존 중';
        }
        if (item && ['scanning', 'running'].includes(item.status)) return '원본 확보 중';
        if (item && item.status === 'error') return '원본 상태 확인 필요';
        return '분석 대기';
    }

    public batchItemHttpStatusLabel(item: any) {
        const probe = this.batchSourceProbe(item);
        if (!item || !item.sourceUrl) return '해당 없음';
        return probe.status_code ? `HTTP ${probe.status_code}` : '응답 확인 중';
    }

    public batchSourceProbe(item: any) {
        return item && item.analysis
            ? this.sourceProbe(item.analysis)
            : (item && item.errorInfo ? item.errorInfo.sourceProbe || {} : {});
    }

    public batchItemNahfClassification(item: any) {
        const value = item && item.analysis
            ? item.analysis.nahf_item_classification : null;
        return value && typeof value === 'object' ? value : {};
    }

    public batchItemNahfClassificationLabel(item: any) {
        const value = this.batchItemNahfClassification(item);
        if (value.status === 'classified') {
            return `${value.item_code || '-'} · ${value.item_label || '-'} · ${value.category || '-'}`;
        }
        if (value.status === 'conflict') {
            const candidates = Array.isArray(value.candidates)
                ? value.candidates.join(', ') : '';
            return `XML 아이템 ID 충돌${candidates ? ` · ${candidates}` : ''}`;
        }
        if (value.status === 'unavailable') return 'XML 아이템 분류 확인 불가';
        if (value.status === 'unclassified') return '분류표와 일치하는 XML 아이템 ID 없음';
        return '해당 없음';
    }

    public viewerResolutionPathLabel(value: any) {
        const labels: any = {
            direct_response: '입력 URL의 직접 XML 응답',
            local_upload: '로컬 파일 업로드',
            download_link: '다운로드 링크',
            iframe: 'iframe',
            embed: 'embed',
            form_action: 'form action',
            form_action_query: 'form action 및 query parameter',
            script_xml_reference: 'script 내부 XML 참조',
            fetch_xhr: 'fetch/XHR 호출',
            script_url: 'script 내부 URL',
            html_reference: 'HTML 내부 원본 XML 참조',
            nahf_query_adapter: 'NAHF itemId·levelId adapter',
        };
        return labels[`${value || ''}`] || (value ? `${value}` : '해당 없음');
    }

    public batchItemProfile(item: any) {
        return item && item.analysis && item.analysis.document_profile
            && typeof item.analysis.document_profile === 'object'
            ? item.analysis.document_profile : {};
    }

    public batchItemProfileLabel(item: any) {
        const profile = this.batchItemProfile(item);
        return profile.label || (item && item.status === 'complete' ? 'Profile 확인 필요' : '판별 전');
    }

    public batchItemProfileReason(item: any) {
        const profile = this.batchItemProfile(item);
        if (profile.recommendation_reason) return profile.recommendation_reason;
        const format = this.batchItemActualFormatLabel(item);
        if (format === 'XML') return '실제 XML root와 추출 가능한 본문을 확인해 XML 원문 직접 추출 Profile로 판별했습니다.';
        if (format === 'PDF') return 'PDF magic bytes를 확인해 PDF·첨부자료로 추천했습니다.';
        if (format === 'IMAGE' || ['PNG', 'JPG', 'JPEG', 'GIF', 'WEBP', 'TIFF', 'BMP'].includes(format)) {
            return '이미지 signature와 MIME을 확인해 이미지 자료로 추천했습니다.';
        }
        return '실제 원본 형식과 추출 가능한 항목을 기준으로 판별합니다.';
    }

    public batchAnalysisPipelineLabel(item: any) {
        const performance = item?.analysis?.analysis_performance || {};
        if (performance.fast_path) {
            return 'NAHF DTD 직접 추출 · 메타 LLM/OCR/KG 연결 생략';
        }
        return performance.pipeline_mode === 'standard'
            ? '표준 문서 분석'
            : '분석 경로 확인 전';
    }

    public batchAnalysisDurationLabel(item: any) {
        const milliseconds = this.safeNumber(
            item?.analysis?.analysis_performance?.total_duration_ms,
            0,
        );
        return milliseconds > 0
            ? this.analysisDurationLabel(milliseconds)
            : '계측 정보 없음';
    }

    public batchItemExtractedCount(item: any) {
        const readiness = item && item.analysis && item.analysis.analysis_readiness
            ? item.analysis.analysis_readiness : {};
        if (Number.isFinite(Number(readiness.extracted_item_count))) {
            return Math.max(0, Number(readiness.extracted_item_count));
        }
        const fields = item && item.analysis && item.analysis.profile_fields
            && typeof item.analysis.profile_fields === 'object'
            ? item.analysis.profile_fields : {};
        return Object.values(fields).reduce((total: number, value: any) => {
            if (Array.isArray(value)) return total + value.length;
            if (value && typeof value === 'object') return total + Object.keys(value).length;
            return total + (`${value || ''}`.trim() ? 1 : 0);
        }, 0);
    }

    public batchAnalysisStateKey(item: any) {
        if (item && ['saved', 'registration_complete'].includes(`${item.status || ''}`)) {
            return 'registration_complete';
        }
        if (item && this.batchItemServerPreservationFailure(item)) {
            return 'source_integrity_failed';
        }
        if (!item || item.status === 'queued') return 'analysis_waiting';
        if (item.status === 'error') {
            const code = `${item.errorInfo?.errorCode || ''}`.toLowerCase();
            const message = `${item.error || ''}`.toLowerCase();
            const stage = `${item.failureStage || item.errorInfo?.stage || ''}`.toLowerCase();
            if (this.batchItemServerPreservationFailure(item)) return 'source_integrity_failed';
            if (this.batchItemOperationInProgress(item)) {
                return this.batchItemOperationReconnectable(item)
                    ? 'operation_reconnectable'
                    : 'operation_claim_conflict';
            }
            if (this.duplicateReviewRequired(item)) return 'duplicate_material';
            if (/malware|virus|security/.test(code + ' ' + message)) return 'security_blocked';
            if (/network|timeout|connection|dns|server/.test(code + ' ' + message)) return 'network_error';
            if (/unsupported|no_content_signature|format/.test(code + ' ' + message)) return 'unsupported_format';
            if (this.batchItemTrueSourceFailure(item)) return 'source_failed';
            if (this.batchItemSourceAcquired(item) || ['analysis', 'metadata', 'save'].includes(stage)) {
                return 'analysis_failed';
            }
            return 'source_failed';
        }
        const stage = `${item.stageLabel || ''}`.toLowerCase();
        if (/redirect/.test(stage)) return 'checking_redirect';
        if (/viewer|원본 xml 탐색/.test(stage)) return 'viewer_xml';
        if (/원본 확보 완료/.test(stage)) return 'source_acquired';
        if (/형식|페이지 구조 해석/.test(stage)) return 'detecting_format';
        if (item.status === 'scanning' || /원문|원본|내려받/.test(stage)) return 'acquiring_source';
        if (item.status === 'running') return 'analyzing';
        if (item.status === 'complete' && !this.batchItemProfile(item).key) return 'user_confirmation_required';
        if (this.batchItemCanProceed(item)) return 'profile_complete';
        return 'user_confirmation_required';
    }

    public batchAnalysisStateLabel(item: any) {
        const labels: any = {
            analysis_waiting: '분석 대기',
            acquiring_source: '원본 확보 중',
            checking_redirect: 'Redirect 확인 중',
            viewer_xml: 'XML Viewer에서 원본 XML 탐색 중',
            source_acquired: '원본 확보 완료',
            detecting_format: '형식 판별 중',
            analyzing: '분석 진행 중',
            format_detected: '형식 판별 완료',
            profile_complete: 'Profile 판별 완료',
            registration_complete: '자료 등록 완료',
            user_confirmation_required: '사용자 확인 필요',
            operation_reconnectable: '서버 분석 상태 확인 필요',
            operation_claim_conflict: '업로드 원본 분석 준비 필요',
            analysis_failed: '분석 처리 실패',
            source_integrity_failed: '서버 원본 무결성 확인 필요',
            source_failed: '원본 확보 실패',
            duplicate_material: '동일 파일 등록됨',
            security_blocked: '보안 검사 차단',
            unsupported_format: '지원하지 않는 형식',
            network_error: '서버 또는 네트워크 오류',
        };
        return labels[this.batchAnalysisStateKey(item)] || '분석 대기';
    }

    public batchAnalysisStateClass(item: any) {
        const key = this.batchAnalysisStateKey(item);
        if (['profile_complete', 'registration_complete'].includes(key)) return 'is-complete';
        if (['source_failed', 'source_integrity_failed', 'analysis_failed', 'duplicate_material', 'security_blocked', 'unsupported_format', 'network_error'].includes(key)) return 'is-error';
        if (['user_confirmation_required', 'operation_reconnectable', 'operation_claim_conflict'].includes(key)) return 'is-attention';
        if (['acquiring_source', 'checking_redirect', 'viewer_xml', 'source_acquired', 'detecting_format', 'analyzing', 'format_detected'].includes(key)) {
            return 'is-running';
        }
        return 'is-pending';
    }

    public batchAnalysisCurrentTask(item: any) {
        const readiness = item && item.analysis ? item.analysis.analysis_readiness || {} : {};
        return readiness.current_task || item?.stageLabel || this.batchAnalysisStateLabel(item);
    }

    public batchAnalysisUserAction(item: any) {
        if (item && item.status === 'error') {
            if (this.batchItemOperationInProgress(item)) {
                return this.batchItemOperationReconnectable(item)
                    ? '원본을 다시 올리지 말고 ‘서버 분석 상태 확인’을 눌러 완료 결과 또는 실제 진행 상태를 연결해주세요.'
                    : '원본을 다시 올릴 필요가 없습니다. ‘업로드된 원본으로 다시 분석’을 누르면 이번 작업에서 덮어쓴 원본의 권한을 확인한 뒤 이 파일만 다시 처리합니다.';
            }
            return item.errorInfo?.userAction || '입력 원본을 확인한 뒤 분석을 재시도해주세요.';
        }
        const readiness = item && item.analysis
            ? item.analysis.analysis_readiness || {} : {};
        if (this.batchAnalysisStateKey(item) === 'user_confirmation_required') {
            return `${readiness.user_action || ''}`.trim()
                || '추천 자료 유형 또는 처리 Profile을 확인하거나 원본을 다시 지정해주세요.';
        }
        if (this.batchItemCanProceed(item)) {
            return '추천 자료 유형을 확인하고 메타정보 검수를 시작할 수 있습니다.';
        }
        return '자동 분석이 끝날 때까지 기다려주세요.';
    }

    public batchAnalysisRetryable(item: any, index: number) {
        return this.failedItemCanRetry(item, index);
    }

    public toggleAnalysisDetail(index: number) {
        const shouldOpen = !this.analysisDetailOpen[index];
        this.analysisDetailOpen = {};
        if (shouldOpen) this.analysisDetailOpen[index] = true;
        this.service.render();
    }

    public collapseAnalysisDetails() {
        this.analysisDetailOpen = {};
        this.service.render();
    }

    public hasOpenAnalysisDetail() {
        return Object.values(this.analysisDetailOpen).some((value: boolean) => !!value);
    }

    public async changeBatchDocumentProfile(index: number, profileKey: string) {
        const item = this.batchItems[index];
        if (!item || item.status !== 'complete' || !item.analysis) return;
        await this.selectBatchItem(index);
        await this.changeDocumentProfile(profileKey);
    }

    public focusBatchProfile(index: number) {
        const target = document.getElementById(`source-profile-${index}`) as HTMLElement;
        if (!target) return;
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        if (typeof (target as any).focus === 'function') (target as any).focus();
    }

    public batchSourceReplacementBusy(index: number) {
        return !!this.batchSourceReplacementLocks[Number(index)];
    }

    private setBatchSourceReplacementLock(index: number, locked: boolean) {
        const key = Number(index);
        if (!Number.isInteger(key) || key < 0) return;
        const next = { ...this.batchSourceReplacementLocks };
        if (locked) next[key] = true;
        else delete next[key];
        this.batchSourceReplacementLocks = next;
        this.batchSourceReplacementRunning = Object.keys(next).length > 0;
    }

    private async cancelUploadClaimBestEffort(
        originalHash: string,
        claimToken: string,
    ) {
        const hash = `${originalHash || ''}`.trim().toLowerCase();
        const token = `${claimToken || ''}`.trim().toLowerCase();
        if (
            !/^sha256:[0-9a-f]{64}$/.test(hash)
            || !/^[0-9a-f]{32}$/.test(token)
        ) return false;
        try {
            const query = new URLSearchParams({
                mode: 'duplicate_cancel',
                original_hash: hash,
                claim_token: token,
            });
            const response = await fetch(
                `/wiz/api/portal.post.detail/analyze?${query.toString()}`,
                { method: 'POST', credentials: 'same-origin', keepalive: true },
            );
            const payload = await response.json();
            return !!(
                payload?.code === 200
                && payload?.data?.preflight?.status === 'cancelled'
            );
        } catch (_) {
            return false;
        }
    }

    private async restartSourceReplacementClaim(row: any, file: File) {
        if (
            !row
            || row.status !== 'processing'
            || row.ownedByMe !== true
            || row.canOverwrite !== true
            || !/^sha256:[0-9a-f]{64}$/i.test(`${row.originalHash || ''}`)
            || !/^[0-9a-f]{32}$/i.test(`${row.overwriteToken || ''}`)
        ) {
            throw new Error(this.filePreflightBlockingMessage(row));
        }
        const newClaimToken = this.createProgressId();
        const query = new URLSearchParams({
            mode: 'duplicate_overwrite',
            original_hash: `${row.originalHash}`,
            claim_token: newClaimToken,
            previous_claim_token: `${row.overwriteToken}`,
        });
        const response = await fetch(
            `/wiz/api/portal.post.detail/analyze?${query.toString()}`,
            { method: 'POST', credentials: 'same-origin' },
        );
        const payload = await response.json();
        const preflight = payload?.code === 200
            ? payload?.data?.preflight : null;
        if (!preflight || preflight.status !== 'new') {
            throw (payload && payload.data) || new Error(
                `${file.name || '교체 파일'}의 처리 권한을 갱신하지 못했습니다.`
            );
        }
        row.status = 'new';
        row.label = preflight.label || '신규 자료';
        row.message = '교체할 파일을 서버에 다시 보존할 준비가 완료됐습니다.';
        row.blocking = false;
        row.restricted = false;
        row.ownedByMe = true;
        row.canOverwrite = false;
        row.overwriteToken = '';
        row.claimToken = `${preflight.claim_token || newClaimToken}`;
        row.progress = 100;
    }

    private async stagedReplacementSourceVerified(
        stagedSourceId: string,
        originalHash: string,
    ) {
        const workspace = await this.latestRegistrationWorkspace();
        if (
            !workspace
            || `${workspace.workspace_id || ''}` !== `${this.registrationWorkspaceId || ''}`
        ) return false;
        const expectedChecksum = `${originalHash || ''}`
            .replace(/^sha256:/i, '').toLowerCase();
        const source = (workspace.sources || []).find((candidate: any) => (
            `${candidate?.source_id || candidate?.staged_source_id || ''}`
                === `${stagedSourceId || ''}`
        ));
        const actualChecksum = `${
            source?.checksum_sha256 || source?.original_hash || ''
        }`.replace(/^sha256:/i, '').toLowerCase();
        return !!(
            source
            && `${source.state || 'staged'}` === 'staged'
            && /^[0-9a-f]{64}$/.test(expectedChecksum)
            && actualChecksum === expectedChecksum
        );
    }

    public async reselectBatchSource(
        item: any,
        replacementInput?: HTMLInputElement,
    ) {
        const index = this.batchItems.indexOf(item);
        if (
            index < 0
            || !item
            || item.sourceUrl
            || this.metaRecognizing
            || this.saving
            || this.batchSourceReplacementRunning
            || this.batchSourceReplacementBusy(index)
        ) return;
        const target = replacementInput || document.querySelector(
            '.analysis-source-replacement-input'
        ) as HTMLInputElement | null;
        if (!target) {
            this.analysisError = '교체할 원본 선택 창을 준비하지 못했습니다. 페이지를 새로고침한 뒤 다시 시도해주세요.';
            await this.service.render();
            return;
        }
        this.batchSourceReplacementTargetIndex = index;
        target.value = '';
        this.setBatchSourceReplacementLock(index, true);
        try {
            const releaseCancelledSelection = () => {
                setTimeout(() => {
                    if (
                        this.batchSourceReplacementTargetIndex === index
                        && this.batchSourceReplacementBusy(index)
                        && !(target.files && target.files.length)
                    ) {
                        void this.cancelBatchSourceReplacementSelection({
                            target,
                        });
                    }
                }, 0);
            };
            window.addEventListener('focus', releaseCancelledSelection, {
                once: true,
            });
            target.click();
        } catch (error) {
            this.batchSourceReplacementTargetIndex = -1;
            this.setBatchSourceReplacementLock(index, false);
            const captured = this.captureError(
                error,
                '원본 선택 창을 열지 못했습니다.',
            );
            this.analysisError = captured.message;
            await this.service.render();
        }
    }

    public async cancelBatchSourceReplacementSelection(event?: any) {
        const input = event?.target as HTMLInputElement | null;
        const index = Number(this.batchSourceReplacementTargetIndex);
        if (input) input.value = '';
        this.batchSourceReplacementTargetIndex = -1;
        if (Number.isInteger(index) && index >= 0) {
            this.setBatchSourceReplacementLock(index, false);
        }
        await this.service.render();
    }

    public async replaceBatchSource(index: number, event: any) {
        const input = event?.target as HTMLInputElement | null;
        const file = input?.files && input.files.length
            ? input.files[0] : null;
        const capturedTargetIndex = Number(this.batchSourceReplacementTargetIndex);
        index = Number.isInteger(capturedTargetIndex) && capturedTargetIndex >= 0
            ? capturedTargetIndex : Number(index);
        if (
            !file
            || !Number.isInteger(index)
            || index < 0
            || !this.batchItems[index]
        ) {
            if (input) input.value = '';
            if (
                Number.isInteger(capturedTargetIndex)
                && capturedTargetIndex >= 0
            ) {
                this.batchSourceReplacementTargetIndex = -1;
                this.setBatchSourceReplacementLock(
                    capturedTargetIndex,
                    false,
                );
                await this.service.render();
            }
            return;
        }
        const ownsSelectionLock = !!(
            this.batchSourceReplacementBusy(index)
            && capturedTargetIndex === index
        );
        if (this.batchSourceReplacementRunning && !ownsSelectionLock) {
            input.value = '';
            return;
        }
        if (!ownsSelectionLock) this.setBatchSourceReplacementLock(index, true);
        try {
            if (file.size <= 0 || file.size > 100 * 1024 * 1024) {
                await this.service.modal.error(
                    file.size <= 0
                        ? '비어 있는 파일은 원본으로 지정할 수 없습니다.'
                        : `${file.name}: 원문 파일은 100MB 이하만 처리할 수 있습니다.`
                );
                return;
            }
            const extension = `${file.name || ''}`.toLowerCase()
                .match(/\.[a-z0-9]+$/)?.[0] || '';
            const supported = new Set([
                '.pdf', '.png', '.jpg', '.jpeg', '.webp', '.gif', '.bmp',
                '.tif', '.tiff', '.xml', '.txt', '.md', '.html', '.htm',
                '.json', '.csv', '.hwp', '.hwpx', '.doc', '.docx', '.ppt',
                '.pptx', '.xls', '.xlsx', '.odt', '.rtf', '.mp4', '.mov',
                '.avi', '.mkv', '.webm', '.m4v', '.mpeg', '.mpg',
            ]);
            if (!supported.has(extension)) {
                await this.service.modal.error(
                    `${file.name}: 지원하지 않는 원본 형식입니다.`
                );
                return;
            }

            const item = this.batchItems[index];
            const queueIndex = this.filePreflights.findIndex(
                (candidate: any) => (
                    Number(candidate?.sourceIndex) === Number(item.sourceIndex)
                    || (
                        !!`${item.stagedSourceId || ''}`
                        && `${candidate?.stagedSourceId || ''}`
                            === `${item.stagedSourceId || ''}`
                    )
                )
            );
            if (queueIndex < 0) {
                this.analysisError = '교체 대상의 서버 원본 정보를 찾지 못했습니다.';
                await this.service.render();
                return;
            }
            const confirmed = await this.service.modal.show({
                title: `${item.name || '선택 파일'} 원본을 교체할까요?`,
                message: '이 항목의 기존 분석 결과만 초기화하고, 선택한 파일을 같은 위치에 보존한 뒤 자동으로 다시 분석합니다. 다른 파일의 분석·검수 내용은 유지됩니다.',
                action: '원본 교체 후 분석',
                actionBtn: 'warning',
                cancel: '취소',
                status: 'warning',
            });
            if (!confirmed) return;

            const previousRow = this.filePreflights[queueIndex];
            const previousFile = this.uploadFiles[queueIndex];
            const previousHash = `${
                item.preflightHash || previousRow?.originalHash || ''
            }`.toLowerCase();
            const previousStagedSourceId = `${
                item.stagedSourceId || previousRow?.stagedSourceId || ''
            }`;
            const previousSourceLocallyVerified = !!(
                previousRow?.staged === true
                && previousRow?.stageStatus === 'staged'
                && previousStagedSourceId
                && !this.batchItemServerPreservationFailure(item)
            );
            const previousClaimTokens = [
                previousRow?.claimToken,
                item.preflightClaimToken,
                previousRow?.overwriteToken,
            ].map((value: any) => `${value || ''}`.trim().toLowerCase())
                .filter((value: string, tokenIndex: number, values: string[]) => (
                    /^[0-9a-f]{32}$/.test(value)
                    && values.indexOf(value) === tokenIndex
                ));
            const replacementRow: any = {
                name: file.name,
                status: 'checking',
                label: '중복 확인 중',
                message: '교체할 원본의 SHA-256을 계산하고 있습니다.',
                progress: 0,
                originalHash: '',
                claimToken: '',
                blocking: true,
                restricted: false,
                canOverride: false,
                ownedByMe: false,
                canOverwrite: false,
                overwriteToken: '',
                overwritePending: false,
                releasePending: false,
                overrideSelected: false,
                overrideConfirmed: false,
                overrideReason: '',
                existing: null,
                policy: '',
                sourceIndex: Number(previousRow?.sourceIndex ?? item.sourceIndex ?? queueIndex),
                stagedSourceId: previousStagedSourceId,
                staged: false,
                stageStatus: 'pending',
                stageError: '',
                stageProgress: 0,
                stagedAt: '',
                stagedBy: '',
                sourceGeneration: '',
                size: Number(file.size || 0),
                mimeType: `${file.type || 'application/octet-stream'}`,
                lastModified: Number(file.lastModified || 0),
                replaceExisting: true,
                expectedPreviousOriginalHash: previousHash,
            };
            let replacementReady = false;
            let durableReplacement = false;
            let taskStarted = false;
            this.uploadFiles[queueIndex] = file;
            this.filePreflights[queueIndex] = replacementRow;
            this.beginFilePreflightTask();
            taskStarted = true;
            try {
                await this.checkSelectedFile(
                    queueIndex,
                    file,
                    false,
                    false,
                    replacementRow,
                );
                const sameBytes = !!previousHash
                    && `${replacementRow.originalHash || ''}`.toLowerCase()
                        === previousHash;
                const reuseVerifiedSource = !!(
                    sameBytes
                    && previousSourceLocallyVerified
                    && await this.stagedReplacementSourceVerified(
                        previousStagedSourceId,
                        previousHash,
                    )
                );
                let reusedExistingSource = false;
                if (reuseVerifiedSource) {
                    replacementRow.staged = true;
                    replacementRow.stageStatus = 'staged';
                    replacementRow.stageProgress = 100;
                    replacementRow.stagedAt = `${previousRow?.stagedAt || ''}`;
                    replacementRow.stagedBy = `${previousRow?.stagedBy || ''}`;
                    replacementRow.sourceGeneration = `${previousRow?.sourceGeneration || ''}`;
                    replacementRow.replaceExisting = false;
                    try {
                        await this.reconcileUploadedSourceClaim(item, replacementRow);
                        if (!this.filePreflightReady(replacementRow)) {
                            throw new Error(this.filePreflightBlockingMessage(replacementRow));
                        }
                        reusedExistingSource = true;
                        durableReplacement = true;
                    } catch (_) {
                        // The public workspace summary can be stale when the
                        // underlying source bytes were removed or corrupted.
                        // Fall through to a real restage of the file the user
                        // just selected instead of leaving a no-op repair.
                        replacementRow.staged = false;
                        replacementRow.stageStatus = 'pending';
                        replacementRow.stageProgress = 0;
                        replacementRow.stagedAt = '';
                        replacementRow.stagedBy = '';
                        replacementRow.sourceGeneration = '';
                        replacementRow.replaceExisting = true;
                    }
                }
                if (!reusedExistingSource) {
                    if (
                        replacementRow.status === 'processing'
                        && replacementRow.ownedByMe === true
                        && replacementRow.canOverwrite === true
                    ) {
                        await this.restartSourceReplacementClaim(replacementRow, file);
                    }
                    if (!this.filePreflightClaimReady(replacementRow)) {
                        throw new Error(this.filePreflightBlockingMessage(replacementRow));
                    }
                    let staged = await this.stageRegistrationSource(
                        queueIndex,
                        file,
                        replacementRow,
                    );
                    if (!staged) {
                        // The response can be lost after a durable write.  A
                        // same-byte repair counts only when the server rotated
                        // the source generation or staging timestamp.
                        const latestWorkspace = await this.latestRegistrationWorkspace();
                        const expectedChecksum = `${replacementRow.originalHash || ''}`
                            .replace(/^sha256:/i, '').toLowerCase();
                        const persistedSource = (latestWorkspace?.sources || []).find(
                            (source: any) => (
                                `${source?.source_id || source?.staged_source_id || ''}`
                                    === `${replacementRow.stagedSourceId || ''}`
                                && `${source?.checksum_sha256 || ''}`.toLowerCase()
                                    === expectedChecksum
                            )
                        );
                        const sourceVersionChanged = !sameBytes || !!(
                            persistedSource
                            && (
                                `${persistedSource.source_generation || ''}`
                                    !== `${previousRow?.sourceGeneration || ''}`
                                || `${persistedSource.staged_at || ''}`
                                    !== `${previousRow?.stagedAt || ''}`
                            )
                        );
                        if (persistedSource && sourceVersionChanged) {
                            this.applyRegistrationWorkspaceSummary(latestWorkspace);
                            replacementRow.staged = true;
                            replacementRow.stageStatus = 'staged';
                            replacementRow.stageError = '';
                            replacementRow.stageProgress = 100;
                            replacementRow.stagedAt = `${persistedSource.staged_at || ''}`;
                            replacementRow.stagedBy = `${persistedSource.staged_by || ''}`;
                            replacementRow.sourceGeneration = `${persistedSource.source_generation || ''}`;
                            staged = true;
                        }
                        if (!staged) {
                            throw new Error(
                                replacementRow.stageError
                                || '선택한 원본을 서버에 보존하지 못했습니다.'
                            );
                        }
                    }
                    durableReplacement = true;
                }

                const replacementHash = `${replacementRow.originalHash || ''}`
                    .trim().toLowerCase();
                if (previousHash && replacementHash && previousHash !== replacementHash) {
                    for (const previousClaimToken of previousClaimTokens) {
                        if (await this.cancelUploadClaimBestEffort(
                            previousHash,
                            previousClaimToken,
                        )) break;
                    }
                }

                item.name = file.name;
                item.sourceFile = file;
                item.sourceIndex = replacementRow.sourceIndex;
                item.stagedSourceId = `${replacementRow.stagedSourceId || ''}`;
                item.preflightHash = `${replacementRow.originalHash || ''}`;
                item.preflightClaimToken = `${replacementRow.claimToken || item.preflightClaimToken || ''}`;
                item.sourceGeneration = `${replacementRow.sourceGeneration || ''}`;
                item.securityProgressId = '';
                item.progressId = '';
                item.securityScan = null;
                item.analysis = null;
                item.form = null;
                item.visibilityConfirmed = false;
                item.visibilityStatus = '';
                item.securityAcknowledged = false;
                item.duplicateConfirmed = false;
                item.failureStage = 'analysis';
                item.status = 'error';
                item.progress = 0;
                item.error = '새로 지정한 업로드 원본으로 분석을 시작합니다.';
                item.errorDetails = '';
                item.errorInfo = {
                    stage: 'source',
                    fileName: file.name,
                    field: 'file',
                    errorCode: 'SOURCE_REPLACED_READY',
                    message: item.error,
                    userAction: '업로드된 원본으로 다시 분석합니다.',
                    retryable: true,
                    requestId: '',
                };
                item.stageLabel = '업로드 원본 교체 완료';
                item.stageDetail = '다른 파일은 유지하고 이 파일만 다시 분석합니다.';
                this.resetRetryProgressState();
                this.persistRegistrationRecovery();
                if (!await this.saveRegistrationWorkspace(true)) {
                    throw new Error(
                        '교체한 업로드 원본은 서버에 보존했지만 작업 상태를 저장하지 '
                        + '못했습니다. 이 파일의 다시 분석 버튼을 눌러 저장부터 재확인해주세요.'
                    );
                }
                replacementReady = true;
            } catch (error) {
                const captured = this.captureError(
                    error,
                    '선택한 원본으로 교체하지 못했습니다.',
                );
                if (!durableReplacement) {
                    if (this.filePreflightClaimReady(replacementRow)) {
                        await this.cancelUploadClaimBestEffort(
                            `${replacementRow.originalHash || ''}`,
                            `${replacementRow.claimToken || ''}`,
                        );
                    }
                    this.uploadFiles[queueIndex] = previousFile;
                    this.filePreflights[queueIndex] = previousRow;
                } else {
                    item.status = 'error';
                    item.failureStage = 'analysis';
                    item.error = captured.message;
                    item.errorDetails = captured.details;
                    item.errorInfo = captured;
                    item.stageLabel = '업로드 원본 보존 완료 · 작업 저장 확인 필요';
                }
                this.analysisError = captured.message;
                item.stageDetail = captured.message;
            } finally {
                if (taskStarted) this.endFilePreflightTask();
                await this.service.render();
            }
            if (replacementReady) {
                await this.retryFailedItems(index);
            }
        } finally {
            if (input) input.value = '';
            this.batchSourceReplacementTargetIndex = -1;
            this.setBatchSourceReplacementLock(index, false);
            await this.service.render();
        }
    }

    public async fixFailedAnalysesBeforeProceed() {
        const index = this.batchItems.findIndex((item: any) => !this.batchItemCanProceed(item));
        if (index < 0) return;
        const item = this.batchItems[index];
        if (item.status === 'error') {
            await this.goToFailedField(index);
            return;
        }
        await this.reselectBatchSource(item);
    }

    public async proceedWithSuccessfulAnalyses() {
        await this.proceedToMetadataReview(true);
    }

    private async proceedToMetadataReview(allowPartial: boolean = false) {
        const readyRows = this.batchItems
            .map((item: any, index: number) => ({ item, index }))
            .filter((row: any) => this.batchItemCanProceed(row.item));
        if (!readyRows.length) {
            await this.service.modal.error(
                '메타정보 검수로 전달할 수 있는 정상 분석 파일이 없습니다. 원본을 수정한 뒤 다시 분석해주세요.'
            );
            return false;
        }
        const blockedCount = this.batchItems.length - readyRows.length;
        if (blockedCount > 0 && !allowPartial) {
            await this.service.modal.error(
                `확인 또는 수정이 필요한 ${blockedCount}개 항목이 있습니다. 모두 수정하거나 아래의 ‘정상 분석된 파일만 진행’을 선택해주세요.`
            );
            return false;
        }
        if (blockedCount > 0) {
            const confirmed = await this.service.modal.show({
                title: '정상 분석된 파일만 진행할까요?',
                message: `실패·확인 필요 ${blockedCount}개는 제외되고 정상 분석 ${readyRows.length}개만 2단계로 전달됩니다.`,
                action: '정상 파일만 진행',
                actionBtn: 'warning',
                cancel: '실패 항목 수정',
                status: 'warning',
            });
            if (!confirmed) return false;
            this.partialRegistrationConfirmed = true;
        } else {
            this.partialRegistrationConfirmed = false;
        }
        await this.selectBatchItem(readyRows[0].index);
        this.registerStep = 'metadata';
        this.metadataSection = 'visibility';
        await this.service.render();
        this.scrollToCurrentStep();
        return true;
    }

    public securityScanLabel(report: any) {
        if (!report || report.status !== 'clean') return '검사 대기';
        return report.protection_level === 'full' ? 'ClamAV 검사 통과' : '기본 보안 검사 통과';
    }

    public analysisSecurityLabel() {
        const report = this.analysisInfo && this.analysisInfo.security_scan
            ? this.analysisInfo.security_scan
            : null;
        return this.securityScanLabel(report);
    }

    public ocrProcessingLabel() {
        return this.batchOcrProcessingLabel();
    }

    public ocrLowQualityPageCount() {
        return this.safeNumber(
            this.analysisInfo && this.analysisInfo.ocr
                ? this.analysisInfo.ocr.low_quality_text_page_count
                : 0,
            0
        );
    }

    public batchVisibilityLabel(item: any) {
        if (item && !item.visibilityConfirmed) return '선택 필요';
        return item && item.form && item.form.status === 'published' ? '공개' : '비공개';
    }

    public analysisTextLength() {
        return this.safeNumber(this.analysisInfo && this.analysisInfo.stats && this.analysisInfo.stats.text_length, 0);
    }

    public analysisChunkCount() {
        return this.safeNumber(this.analysisInfo && this.analysisInfo.stats && this.analysisInfo.stats.chunk_count, 0);
    }

    public analysisDimensionLabel() {
        const dimension = this.safeNumber(this.analysisInfo && this.analysisInfo.stats && this.analysisInfo.stats.embedding_dimension, 0);
        return dimension > 0 ? `${dimension.toLocaleString()}차원` : '생성 정보 없음';
    }

    public analysisFormatLabel() {
        const source = this.analysisInfo && this.analysisInfo.source ? this.analysisInfo.source : {};
        const format = `${source.format || source.kind || ''}`.trim();
        return format ? format.toUpperCase() : '형식 확인 필요';
    }

    public sourceProbe(analysis: any = null) {
        const source = analysis || this.analysisInfo || {};
        const probe = source && source.source && source.source.probe
            ? source.source.probe
            : (source && source.probe ? source.probe : {});
        return probe && typeof probe === 'object' ? probe : {};
    }

    public sourceProbeClassificationLabel(probe: any = null) {
        const target = probe || this.sourceProbe();
        const labels: any = {
            actual_xml: '실제 XML 응답',
            html_viewer: 'HTML viewer',
            pdf: 'PDF 응답',
            image: '이미지 응답',
            empty: '빈 응답',
            unknown: '형식 확인 실패',
        };
        return labels[`${target.classification || ''}`] || '응답 확인 정보 없음';
    }

    public sourceProbeRootLabel(probe: any = null) {
        const target = probe || this.sourceProbe();
        if (!target.xml_root) return 'XML root 없음';
        return target.xml_doctype
            ? `root <${target.xml_root}> · DOCTYPE ${target.xml_doctype}`
            : `root <${target.xml_root}> · DOCTYPE 없음`;
    }

    public layoutSummary() {
        return this.analysisInfo && this.analysisInfo.layout && this.analysisInfo.layout.summary
            ? this.analysisInfo.layout.summary
            : {
                pages_total: 0, pages_analyzed: 0, page_limit: 0, analysis_limited: false,
                region_count: 0, coordinate_count: 0, table_count: 0, figure_count: 0,
                embedded_image_count: 0, rendered_figure_count: 0, image_pages_scanned: 0,
                direct_image_scan_complete: false,
                annotation_count: 0, extracted_image_count: 0, structured_table_count: 0,
                extracted_content_count: 0, marker_count: 0,
            };
    }

    public layoutRegions() {
        return this.analysisInfo && this.analysisInfo.layout && Array.isArray(this.analysisInfo.layout.regions)
            ? this.analysisInfo.layout.regions
            : [];
    }

    public layoutFilteredRegions() {
        if (this.layoutRegionFilter === 'all') return this.layoutRegions();
        return this.layoutRegions().filter((region: any) => region.type === this.layoutRegionFilter);
    }

    public layoutVisibleRegions() {
        const regions = this.layoutFilteredRegions();
        const page = Math.min(this.layoutRegionPage, this.layoutRegionTotalPages());
        const start = (page - 1) * this.layoutRegionsPerPage;
        return regions.slice(start, start + this.layoutRegionsPerPage);
    }

    public layoutRegionTotalPages() {
        return Math.max(1, Math.ceil(this.layoutFilteredRegions().length / this.layoutRegionsPerPage));
    }

    public layoutPageCoverageLabel() {
        const summary = this.layoutSummary();
        const analyzed = this.safeNumber(summary.pages_analyzed, 0);
        const total = this.safeNumber(summary.pages_total, analyzed);
        return total > analyzed ? `${analyzed} / ${total}쪽` : `${analyzed}쪽`;
    }

    public layoutCoordinateCount() {
        return this.safeNumber(this.layoutSummary().coordinate_count, this.layoutRegions().length);
    }

    public layoutMarkerCount() {
        const markers = this.analysisInfo && this.analysisInfo.layout && Array.isArray(this.analysisInfo.layout.text_markers)
            ? this.analysisInfo.layout.text_markers
            : [];
        return this.safeNumber(this.layoutSummary().marker_count, markers.length);
    }

    public layoutImageScanLabel() {
        const summary = this.layoutSummary();
        const scanned = this.safeNumber(summary.image_pages_scanned, summary.pages_analyzed || 0);
        const total = this.safeNumber(summary.pages_total, scanned);
        return total > scanned ? `${scanned} / ${total}쪽` : `${scanned}쪽`;
    }

    private shouldRefreshLayoutExtraction() {
        if (!this.analysisId || this.layoutRefreshing || this.layoutRefreshAttemptedId === this.analysisId) return false;
        const source = this.analysisInfo && this.analysisInfo.source ? this.analysisInfo.source : {};
        const format = `${source.format || source.kind || ''}`.toLowerCase();
        return format === 'pdf' && !this.layoutSummary().direct_image_scan_complete;
    }

    public async refreshLayoutExtraction(silent: boolean = false) {
        if (!this.analysisId || this.layoutRefreshing) return;
        this.layoutRefreshing = true;
        this.layoutRefreshAttemptedId = this.analysisId;
        this.layoutPreviewError = '';
        await this.service.render();
        try {
            const query = new URLSearchParams({
                mode: 'layout_refresh', analysis_id: this.analysisId
            });
            const response = await fetch(`/wiz/api/portal.post.detail/analyze?${query.toString()}`, {
                method: 'POST', credentials: 'same-origin'
            });
            const payload = await response.json();
            if (!payload || payload.code !== 200) {
                throw new Error((payload && payload.data && payload.data.message) || '이미지를 다시 추출하지 못했습니다.');
            }
            const analysis = payload.data && payload.data.analysis ? payload.data.analysis : null;
            if (!analysis || !analysis.id) throw new Error('갱신된 레이아웃 분석 결과가 비어 있습니다.');
            const refreshed = this.normaliseAnalysis(analysis);
            this.analysisInfo = refreshed;
            if (this.activeBatchIndex >= 0 && this.batchItems[this.activeBatchIndex]) {
                this.batchItems[this.activeBatchIndex].analysis = refreshed;
            }
            this.resetLayoutInspector();
            this.layoutDetailsOpen = true;
            this.layoutRegionFilter = 'figure';
            const first = this.layoutVisibleRegions()[0];
            this.selectedLayoutRegionId = first ? first.id : '';
            await this.ensureLayoutRegionPreview(first);
            if (!silent) {
                await this.service.modal.success(
                    `PDF 내장 이미지 ${this.formatCount(this.layoutSummary().embedded_image_count)}개를 포함해 추출 결과를 다시 만들었습니다.`
                );
            }
        } catch (error) {
            const captured = this.captureError(error, '이미지를 다시 추출하지 못했습니다.');
            this.layoutPreviewError = captured.message;
            if (captured.details) this.technicalErrorDetails = captured.details;
            if (!silent) await this.service.modal.error(captured.message);
        } finally {
            this.layoutRefreshing = false;
            await this.service.render();
        }
    }

    public async toggleLayoutDetails() {
        this.layoutDetailsOpen = !this.layoutDetailsOpen;
        if (this.layoutDetailsOpen && !this.selectedLayoutRegionId) {
            const first = this.layoutVisibleRegions()[0];
            this.selectedLayoutRegionId = first ? first.id : '';
        }
        if (this.layoutDetailsOpen) await this.ensureLayoutRegionPreview(this.selectedLayoutRegion());
        await this.service.render();
    }

    private async openLayoutExtractionResults() {
        this.layoutDetailsOpen = true;
        this.layoutRegionFilter = this.safeNumber(this.layoutSummary().figure_count, 0) > 0 ? 'figure' : 'all';
        this.layoutRegionPage = 1;
        const first = this.layoutVisibleRegions()[0];
        this.selectedLayoutRegionId = first ? first.id : '';
        await this.ensureLayoutRegionPreview(first);
        await this.service.render();
    }

    public async setLayoutRegionFilter(type: 'all' | 'table' | 'figure' | 'annotation') {
        this.layoutRegionFilter = type;
        this.layoutRegionPage = 1;
        const first = this.layoutVisibleRegions()[0];
        this.selectedLayoutRegionId = first ? first.id : '';
        await this.ensureLayoutRegionPreview(first);
        await this.service.render();
    }

    public async setLayoutRegionPage(page: number) {
        this.layoutRegionPage = Math.max(1, Math.min(this.layoutRegionTotalPages(), page));
        const first = this.layoutVisibleRegions()[0];
        this.selectedLayoutRegionId = first ? first.id : '';
        await this.ensureLayoutRegionPreview(first);
        await this.service.render();
    }

    public async selectLayoutRegion(region: any) {
        if (!region) return;
        this.selectedLayoutRegionId = region.id || '';
        await this.ensureLayoutRegionPreview(region);
        await this.service.render();
    }

    public selectedLayoutRegion() {
        const regions = this.layoutFilteredRegions();
        return regions.find((region: any) => region.id === this.selectedLayoutRegionId)
            || this.layoutVisibleRegions()[0]
            || null;
    }

    public layoutRegionLabel(region: any) {
        const labels: any = { table: '표', figure: '그림', annotation: '주석' };
        return (region && region.label) || labels[region && region.type] || '영역';
    }

    public layoutRegionClass(region: any) {
        const type = region && region.type ? region.type : 'unknown';
        return `is-${type}`;
    }

    public layoutRegionStyle(region: any) {
        const bbox = region && region.normalized_bbox ? region.normalized_bbox : {};
        const percent = (value: any, fallback: number) => {
            const number = Number(value);
            return `${Math.max(0, Math.min(1, Number.isFinite(number) ? number : fallback)) * 100}%`;
        };
        return {
            left: percent(bbox.x, 0.08),
            top: percent(bbox.y, 0.08),
            width: percent(bbox.width, 0.84),
            height: percent(bbox.height, 0.24),
        };
    }

    public layoutCoordinateLabel(region: any) {
        const bbox = region && region.bbox ? region.bbox : {};
        return `x ${this.safeNumber(bbox.x, 0)} · y ${this.safeNumber(bbox.y, 0)} · w ${this.safeNumber(bbox.width, 0)} · h ${this.safeNumber(bbox.height, 0)}`;
    }

    public layoutNormalizedCoordinateLabel(region: any) {
        const bbox = region && region.normalized_bbox ? region.normalized_bbox : {};
        const value = (key: string) => {
            const number = Number(bbox[key]);
            return Number.isFinite(number) ? number.toFixed(4) : '0.0000';
        };
        return `x ${value('x')} · y ${value('y')} · w ${value('width')} · h ${value('height')}`;
    }

    public layoutRegionStorageLabel(region: any) {
        const image = region && region.image && typeof region.image === 'object' ? region.image : {};
        if (image.stored_name) return image.stored_name;
        if (region && region.marker) return '본문 이미지 마커';
        return '좌표·유형 메타데이터';
    }

    public layoutExtractionMethodLabel(region: any) {
        const method = region && region.image ? `${region.image.extraction_method || ''}` : '';
        if (method === 'pdf-embedded-original') return 'PDF 내장 원본 직접 추출';
        if (method === 'rendered-page-crop') return '렌더링 페이지 좌표 crop';
        if (region && region.detector === 'pdf-embedded-image') return 'PDF 내장 원본 직접 추출';
        return region && region.image ? '영역 이미지 crop' : '이미지 없음';
    }

    public layoutSourceImageSizeLabel(region: any) {
        const image = region && region.image ? region.image : {};
        const width = this.safeNumber(image.source_width, 0);
        const height = this.safeNumber(image.source_height, 0);
        return width > 0 && height > 0 ? `${width.toLocaleString()} × ${height.toLocaleString()} px` : '';
    }

    public layoutRegionTitle(region: any) {
        if (!region) return '추출 영역';
        return region.display_title || region.caption || region.text || `${region.page || '-'}쪽 ${this.layoutRegionLabel(region)}`;
    }

    public layoutTableRows(region: any) {
        const rows = region && region.table && Array.isArray(region.table.rows) ? region.table.rows : [];
        return rows.slice(0, 12).map((row: any) => Array.isArray(row) ? row.slice(0, 12) : []);
    }

    public downloadLayoutTableCsv(region: any) {
        const rows = region && region.table && Array.isArray(region.table.rows) ? region.table.rows : [];
        if (!rows.length) return;
        const escape = (value: any) => `"${`${value || ''}`.replace(/"/g, '""')}"`;
        const csv = '\ufeff' + rows.map((row: any) => (Array.isArray(row) ? row : []).map(escape).join(',')).join('\r\n');
        const url = URL.createObjectURL(new Blob([csv], { type: 'text/csv;charset=utf-8' }));
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = `${region && region.id ? region.id : 'table'}.csv`;
        anchor.click();
        URL.revokeObjectURL(url);
    }

    public layoutRegionExtractedText(region: any) {
        if (!region) return '';
        if (region.type === 'figure') return region.figure?.description || region.caption || region.text || '';
        if (region.type === 'annotation') return region.annotation?.text || region.text || '';
        return region.text || '';
    }

    public layoutRegionContext(region: any) {
        if (!region) return '';
        return region.annotation?.context || region.caption || '';
    }

    public layoutRegionDownloadName(region: any) {
        return region && region.image && region.image.download_name
            ? region.image.download_name
            : `${region && region.id ? region.id : 'layout-region'}.png`;
    }

    private async ensureLayoutRegionPreview(region: any) {
        if (!region || !region.id || region.preview_data_url || this.layoutPreviewLoadingId === region.id) return;
        if (!this.analysisId) return;
        this.layoutPreviewLoadingId = region.id;
        this.layoutPreviewError = '';
        await this.service.render();
        try {
            const query = new URLSearchParams({
                mode: 'layout_asset', analysis_id: this.analysisId, region_id: region.id
            });
            const response = await fetch(`/wiz/api/portal.post.detail/analyze?${query.toString()}`, {
                method: 'POST', credentials: 'same-origin'
            });
            const payload = await response.json();
            if (!payload || payload.code !== 200) {
                throw new Error((payload && payload.data && payload.data.message) || '추출 이미지를 불러오지 못했습니다.');
            }
            const asset = payload.data && payload.data.asset ? payload.data.asset : null;
            if (!asset || !asset.data_url) throw new Error('추출 이미지 응답이 비어 있습니다.');
            region.preview_data_url = asset.data_url;
            region.image = { ...(region.image || {}), ...asset, data_url: undefined };
        } catch (error) {
            const captured = this.captureError(error, '추출 이미지를 불러오지 못했습니다.');
            this.layoutPreviewError = captured.message;
            if (captured.details) this.technicalErrorDetails = captured.details;
        } finally {
            this.layoutPreviewLoadingId = '';
            await this.service.render();
        }
    }

    public layoutMarkerOffsetLabel(region: any) {
        const offset = Number(region && region.marker_offset);
        return Number.isFinite(offset) && offset >= 0 ? `본문 ${offset.toLocaleString()}자 위치` : '이미지 마커 없음';
    }

    public layoutImageChecksumLabel(region: any) {
        const checksum = region && region.image ? `${region.image.checksum_sha256 || ''}` : '';
        return checksum ? `${checksum.slice(0, 16)}…` : '-';
    }

    private layoutWarningMessage(warning: any) {
        if (warning && typeof warning === 'object') {
            return `${warning.message || warning.reason || warning.label || ''}`;
        }
        return `${warning || ''}`;
    }

    public layoutAnalysisNotApplicable(analysis: any = null) {
        const target = analysis || this.analysisInfo || {};
        const source = target && target.source ? target.source : {};
        return ['xml', 'html', 'json', 'txt', 'text', 'csv', 'md', 'markdown'].includes(
            this.inferSourceFormat(source)
        );
    }

    public layoutWarnings(analysis: any = null) {
        const target = analysis || this.analysisInfo;
        const warnings = target && target.layout && Array.isArray(target.layout.warnings)
            ? target.layout.warnings
            : [];
        return warnings.filter((warning: any) => {
            const message = this.layoutWarningMessage(warning);
            return !(
                this.layoutAnalysisNotApplicable(target)
                && message.includes('페이지 이미지가 없어')
                && message.includes('영역 분리를 건너뛰었습니다')
            );
        });
    }

    public selectedUploadSize() {
        const bytes = this.uploadFiles.reduce((total: number, file: File) => total + Number(file.size || 0), 0);
        if (!bytes) return '';
        if (bytes >= 1024 * 1024) return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
        if (bytes >= 1024) return `${Math.round(bytes / 1024).toLocaleString()} KB`;
        return `${bytes.toLocaleString()} B`;
    }

    public reviewCompletedCount() {
        const values = [
            this.analysisId,
            this.data && this.data.title,
            this.data && this.data.category,
            this.data && this.data.status,
            this.data && this.data.content
        ];
        return values.filter((value: any) => `${value || ''}`.trim()).length;
    }

    public registerStepStateLabel(key: RegisterStepKey) {
        if (this.registrationStepActive(key)) return '진행 중';
        if (this.registerStepIndex(key) < this.currentStepIndex()) return '완료';
        return '대기';
    }

    public registerStepClass(key: RegisterStepKey) {
        if (this.registrationStepActive(key)) return 'is-active';
        if (this.registerStepIndex(key) < this.currentStepIndex()) return 'is-complete';
        return 'is-upcoming';
    }

    public registerStepNumberClass(key: RegisterStepKey) {
        return this.registerStepClass(key);
    }

    public async save() {
        if (this.registrationSubmitting || this.saving) return;
        if (this.registrationCompletionFinalized) return;
        if (this.isNewPost() && this.finalSavedCompletionReady()) {
            if (this.finalFailedCount() > 0 && !this.partialRegistrationConfirmed) {
                await this.service.modal.error(
                    '실패 파일을 제외한 부분 등록 여부를 최종 화면에서 확인해주세요.'
                );
                return;
            }
            if (!this.finalRegistrationAgreement) {
                await this.service.modal.error('최종 등록 내용과 경고 확인에 동의해주세요.');
                await this.service.render();
                return;
            }
            const confirmed = await this.confirmFinalRegistration();
            if (!confirmed) return;
            await this.completeSavedRegistration();
            return;
        }
        if (this.isNewPost() && !this.analysisId) {
            await this.service.modal.error("먼저 파일의 메타정보 등록을 완료해주세요.");
            return;
        }
        if (!this.data.title) {
            await this.service.modal.error("자료명을 입력해주세요.");
            return;
        }
        if (!`${this.data.category || ''}`.trim()) {
            await this.service.modal.error("자료 유형을 선택하거나 입력해주세요.");
            return;
        }
        if (
            this.isNewPost()
            && !this.xmlReviewComplete(this.data.xml_field_review)
        ) {
            await this.service.modal.error('XML 원본 비교 필드 검수를 모두 완료해주세요.');
            this.registerStep = 'metadata';
            this.metadataSection = 'bibliography';
            await this.service.render();
            return;
        }
        if (this.isNewPost() && this.finalFailedCount() > 0 && !this.partialRegistrationConfirmed) {
            await this.service.modal.error('실패 파일을 제외한 부분 등록 여부를 최종 화면에서 확인해주세요.');
            return;
        }

        if (this.isNewPost()) {
            if (!this.finalRegistrationAgreement) {
                await this.service.modal.error('최종 등록 내용과 경고 확인에 동의해주세요.');
                await this.service.render();
                return;
            }
            const confirmed = await this.confirmFinalRegistration();
            if (!confirmed) {
                this.registrationProgress.status = 'idle';
                await this.service.render();
                return;
            }
            this.registrationSubmitting = true;
            this.registrationProcessingOpen = true;
            this.registrationProgress = {
                status: 'processing',
                stage: 'preflight',
                label: '등록 준비 및 검수 결과 확인',
                completed: 0,
                total: this.finalRegistrableCount(),
                percent: 0,
            };
            await this.service.render();
            if (
                !this.finalServerPreflightReady()
                || !this.registrationPreflightCacheCurrent()
            ) {
                await this.refreshRegistrationPreflight();
            }
            if (
                !this.finalServerPreflightReady()
                || !this.registrationPreflightCacheCurrent()
                || this.finalBlockingCount() > 0
            ) {
                const draftSyncError = this.registrationDraftSyncError;
                this.registrationSubmitting = false;
                this.registrationProcessingOpen = false;
                this.registrationProgress = {
                    ...this.registrationProgress,
                    status: 'blocked',
                    label: '차단 오류를 확인해주세요.',
                    percent: 0,
                };
                await this.service.render();
                if (draftSyncError) {
                    await this.openRegistrationSaveError(
                        draftSyncError,
                        Number(draftSyncError.targetIndex ?? -1),
                        Number(draftSyncError.failedCount || 1),
                    );
                }
                setTimeout(() => {
                    const target = document.getElementById('final-registration-issues');
                    if (target) {
                        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
                        target.focus();
                    }
                }, 0);
                return;
            }
            this.registrationProgress = {
                status: 'processing',
                stage: 'commit',
                label: '원본·메타데이터·검수 스냅샷 저장',
                completed: 0,
                total: this.finalRegistrableCount(),
                percent: 30,
            };
            await this.service.render();
        }

        if (this.isNewPost() && this.batchItems.length > 1) {
            this.registrationCommitPreflightPrepared = true;
            try {
                await this.saveBatch();
            } finally {
                this.registrationCommitPreflightPrepared = false;
                this.registrationSubmitting = false;
                this.registrationProcessingOpen = false;
                await this.service.render();
            }
            return;
        }

        const activeItem = this.batchItems[this.activeBatchIndex];
        if (this.isNewPost() && activeItem && !this.registrationGateReady(activeItem)) {
            this.registerStep = 'metadata';
            this.metadataSection = 'visibility';
            this.registrationSubmitting = false;
            this.registrationProcessingOpen = false;
            await this.service.render();
            await this.service.modal.error('공개 범위·중복 여부·보안 검사 수준을 모두 확인해주세요.');
            await this.service.render();
            return;
        }

        this.saving = true;
        await this.service.render();

        try {
            const result = await this.callRegistrationSave(
                this.registrationCommitRequest(activeItem, this.data)
            );
            if (this.isNewPost()) {
                this.registrationProgress = {
                    status: 'processing',
                    stage: 'commit',
                    label: '자료함 등록 응답 확인 완료',
                    completed: 1,
                    total: 1,
                    percent: 100,
                };
                await this.service.render();
            }
            if (result.code === 200) {
                if (!this.isNewPost() && result.data) {
                    this.data.updated = result.data.updated || this.data.updated;
                    this.data.revision = result.data.revision
                        || result.data.updated || this.data.revision;
                }
                const warning = result.data && result.data.ingestion ? result.data.ingestion.warning : '';
                this.registrationProcessingOpen = false;
                await this.service.render();
                await this.service.modal.success(warning ? '저장되었습니다.\n' + warning : "저장되었습니다.");
                this.clearRegistrationRecovery();
                if (this.isNewPost() && result.data.id) {
                    this.navigationBypass = true;
                    this.id = result.data.id;
                    this.service.href(`${this.basePath}/${this.id}/view`);
                }
            } else if (result.code === 409 && result.data && result.data.duplicate) {
                this.applyDuplicateConflict(this.batchItems[this.activeBatchIndex], result.data.duplicate);
                this.registrationProcessingOpen = false;
                await this.service.render();
                await this.service.modal.error(
                    '저장 직전에 동일한 원문 자료가 확인되었습니다. 기존 자료를 확인하고 새 버전 등록 체크박스를 선택하거나 이 파일을 제외해주세요.'
                );
            } else if (result.code === 409 && result.data?.conflict === 'revision_conflict') {
                this.registrationProcessingOpen = false;
                await this.service.render();
                await this.service.modal.error(
                    '다른 사용자가 먼저 수정했습니다. 최신 내용을 다시 불러온 뒤 변경사항을 적용해주세요.'
                );
            } else {
                const captured = this.captureError(
                    result.data || '저장에 실패했습니다.',
                    '자료 저장에 실패했습니다.'
                );
                if (activeItem) {
                    activeItem.status = 'error';
                    activeItem.failureStage = 'save';
                    activeItem.error = captured.message;
                    activeItem.errorDetails = captured.details;
                    activeItem.errorInfo = captured;
                    activeItem.stageLabel = '저장 실패';
                    activeItem.stageDetail = captured.message;
                    this.persistRegistrationRecovery();
                }
                this.technicalErrorDetails = captured.details;
                this.technicalErrorOpen = false;
                this.registrationProcessingOpen = false;
                await this.service.render();
                await this.openRegistrationSaveError(
                    captured,
                    this.activeBatchIndex,
                    1,
                );
            }
        } catch (error) {
            const captured = this.captureError(error, '자료 저장 중 오류가 발생했습니다.');
            if (activeItem) {
                activeItem.status = 'error';
                activeItem.failureStage = 'save';
                activeItem.error = captured.message;
                activeItem.errorDetails = captured.details;
                activeItem.errorInfo = captured;
                activeItem.stageLabel = '저장 실패';
                activeItem.stageDetail = captured.message;
                this.persistRegistrationRecovery();
            }
            this.technicalErrorDetails = captured.details;
            this.technicalErrorOpen = false;
            this.registrationProcessingOpen = false;
            await this.service.render();
            await this.openRegistrationSaveError(
                captured,
                this.activeBatchIndex,
                1,
            );
        } finally {
            this.saving = false;
            this.registrationSubmitting = false;
            this.registrationProcessingOpen = false;
            await this.service.render();
        }
    }

    private savePayload(
        form: any,
        analysisId: string,
        item: any = null,
        purpose: 'draft' | 'preflight' | 'commit' = 'commit',
    ) {
        const sourceItem = item || this.activeBatchItem();
        const duplicateOverrideReasonCandidate = `${
            form.duplicate_override_reason
            || sourceItem?.duplicateOverrideReason
            || ''
        }`.trim();
        const duplicateOverrideReason = sourceItem?.duplicateOverrideSelected
            && duplicateOverrideReasonCandidate.length < 5
            ? this.duplicateVersionCheckboxReason
            : duplicateOverrideReasonCandidate;
        const reviewKeys = this.reviewKeys(sourceItem);
        const reviewChecks = this.normaliseReviewChecks(
            sourceItem?.reviewChecks, null, reviewKeys
        );
        const registrationSnapshot = {
            schema_version: '1.0',
            workflow_mode: 'simplified_registration_v1',
            deferred_review_stages: ['dtd_scope', 'file_content', 'item_relations'],
            analysis_id: analysisId || '',
            source_name: this.reviewFileName(sourceItem),
            document_profile: form.document_profile || '',
            status: form.status || 'draft',
            required_review_keys: reviewKeys,
            review_checks: reviewChecks,
            review_history: Array.isArray(form?.profile_fields?.__review_history)
                ? form.profile_fields.__review_history.slice(-100) : [],
            entity_review: this.finalItemEntitySummary(sourceItem),
            ...(purpose === 'commit' ? {
                warning_acknowledged: !!this.finalRegistrationAgreement,
                warning_count: Array.isArray(sourceItem?.registrationPreflight?.issues)
                    ? sourceItem.registrationPreflight.issues.filter(
                        (row: any) => row.severity === 'warning'
                    ).length : 0,
            } : {}),
            duplicate_override: {
                selected: !!sourceItem?.duplicateOverrideSelected,
                confirmed: !!sourceItem?.duplicateOverrideConfirmed,
                document_id: `${
                    sourceItem?.duplicateOverrideDocumentId
                    || sourceItem?.analysis?.duplicate?.post_id
                    || sourceItem?.analysis?.duplicate_override?.document_id
                    || ''
                }`,
                original_hash: `${sourceItem?.analysis?.source?.checksum_sha256 || ''}`,
            },
        };
        const duplicateOverride = {
            selected: !!sourceItem?.duplicateOverrideSelected,
            confirmed: !!sourceItem?.duplicateOverrideConfirmed,
            document_id: `${
                sourceItem?.duplicateOverrideDocumentId
                || sourceItem?.analysis?.duplicate?.post_id
                || sourceItem?.analysis?.duplicate_override?.document_id
                || ''
            }`,
            original_hash: `${sourceItem?.analysis?.source?.checksum_sha256 || ''}`,
            reason: duplicateOverrideReason,
        };
        return {
            id: form.id === 'new' ? '' : form.id,
            title: form.title || '',
            _registration_file_name: form.source_name || '',
            content: form.content || '',
            category: form.category || '',
            status: form.status || 'draft',
            expected_revision: form.revision || form.updated || '',
            analysis_id: analysisId || '',
            _idempotency_key: `registration:${analysisId || form.id || 'new'}`,
            _registration_snapshot: registrationSnapshot,
            ai_corrections: {
                title: form.title || '',
                category: form.category || '',
                summary: form.content || '',
                authors: this.splitValues(form.authors),
                publisher: form.publisher || '',
                created_dates: this.normaliseDateValues(form.created_dates),
                issued_dates: this.normaliseDateValues(form.issued_dates),
                date: this.normaliseDateValues(form.issued_dates)[0]
                    || this.normaliseDateValues(form.created_dates)[0]
                    || form.document_date || '',
                language: form.language || '',
                era: form.era || '',
                keywords: this.splitValues(form.keywords),
                ocr_text: form.ocr_text || '',
                ocr_pages: form.ocr_page_corrections || [],
                entities: form.entities || [],
                multilingual: this.normaliseMultilingual(form.multilingual),
                document_profile: form.document_profile || '',
                profile_fields: form.profile_fields || {},
                provenance_type: form.provenance_type || 'direct_upload',
                source_scheme: form.source_scheme || '',
                source_category: form.source_category || '',
                duplicate_confirmed: !!form.duplicate_confirmed,
                duplicate_override_reason: duplicateOverrideReason,
                duplicate_override: duplicateOverride,
                security_acknowledged: !!form.security_acknowledged,
                common_metadata_review: form.common_metadata_review || {},
                metadata_v2_1_review: form.metadata_v2_1_review || {},
                xml_field_review: form.xml_field_review || {},
                registration_snapshot: registrationSnapshot,
            },
        };
    }

    private registrationDraftReferenceError(item: any) {
        return {
            errorCode: 'REGISTRATION_DRAFT_REFERENCE_MISSING',
            stage: 'draft',
            field: 'draft_revision',
            message: '등록에 필요한 검수 초안 확인값을 준비하지 못했습니다.',
            cause: '검수 초안의 서버 저장 ID·revision·원본 체크섬 중 하나가 준비되지 않았습니다.',
            prevention: '대용량 전체 검수 데이터로 우회 전송하지 않고 등록을 중단했습니다. 초안을 다시 저장·검증한 뒤 작은 참조 요청만 전송합니다.',
            userAction: '검수 초안을 다시 저장하고 사전검증을 완료한 뒤 이 파일만 다시 시도해주세요.',
            retryable: true,
            fileName: this.reviewFileName(item),
        };
    }

    private registrationCommitRequest(item: any, form: any = null) {
        const sourceItem = item || this.activeBatchItem();
        const activeForm = form || sourceItem?.form || this.data;
        const analysisId = `${sourceItem?.analysis?.id || this.analysisId || ''}`;
        const draftRevision = `${sourceItem?.draftRevision || ''}`;
        const sourceChecksum = `${
            sourceItem?.analysis?.source?.checksum_sha256 || ''
        }`.replace(/^sha256:/i, '').toLowerCase();
        if (this.isNewPost()) {
            if (!analysisId || !draftRevision || !sourceChecksum) {
                throw this.registrationDraftReferenceError(sourceItem);
            }
            if (!this.finalRegistrationAgreement) {
                throw {
                    errorCode: 'FINAL_REGISTRATION_AGREEMENT_REQUIRED',
                    stage: 'input',
                    field: 'final_registration_agreement',
                    message: '최종 등록 내용과 경고 확인 동의가 필요합니다.',
                    cause: '현재 화면에서 최종 등록 동의가 확인되지 않았습니다.',
                    prevention: '사용자 동의 없이 자료함 저장이 시작되지 않도록 등록 요청 전에 차단합니다.',
                    userAction: '최종 확인 화면에서 동의한 뒤 이 파일만 다시 시도해주세요.',
                    retryable: false,
                    fileName: this.reviewFileName(sourceItem),
                };
            }
            const warningCount = Array.isArray(
                sourceItem?.registrationPreflight?.issues
            ) ? sourceItem.registrationPreflight.issues.filter(
                (row: any) => row?.severity === 'warning'
            ).length : 0;
            return {
                mode: 'registration_commit',
                analysis_id: analysisId,
                draft_revision: draftRevision,
                source_checksum: sourceChecksum,
                source_name: this.reviewFileName(sourceItem),
                warning_acknowledged: 'true',
                warning_count: `${warningCount}`,
                _idempotency_key: `registration:${analysisId}`,
            };
        }
        // Existing-post edits keep the legacy payload contract. New
        // registrations must never replay multi-megabyte review bodies.
        const fallbackPayload = item?.form && item?.analysis?.id
            ? this.savePayload(item.form, item.analysis.id, item)
            : this.savePayload(activeForm, analysisId, sourceItem);
        return {
            data: JSON.stringify(fallbackPayload),
        };
    }

    private splitValues(value: any) {
        if (Array.isArray(value)) return value.filter(Boolean);
        return `${value || ''}`.split(/[,;\n]/).map((row: string) => row.trim()).filter(Boolean);
    }

    private queuedRegistrationSourceCount() {
        return this.uploadSourceType === 'url'
            ? this.xmlUrls.length : this.uploadFiles.length;
    }

    private async prepareNextRegistrationBatch(processedCount: number, _savedCount: number) {
        this.creditSavedRegistrationItems();
        this.batchItems.forEach((item: any) => {
            if (item?.status === 'saved') item.status = 'registration_complete';
        });
        this.rememberRegistrationAnalysisItems(this.batchItems);
        const count = Math.max(0, Math.min(
            Number(processedCount) || 0,
            this.queuedRegistrationSourceCount(),
        ));
        this.processedRegistrationSourceCount += count;
        if (this.uploadSourceType === 'url') {
            this.xmlUrls = this.xmlUrls.slice(count);
            this.uploadFileName = this.xmlUrlSelectionLabel();
        } else {
            this.uploadFiles = this.uploadFiles.slice(count);
            this.filePreflights = this.filePreflights.slice(count);
            this.uploadFile = this.uploadFiles[0] || null;
            this.uploadFileName = this.uploadFiles.length === 1
                ? this.uploadFiles[0].name
                : (this.uploadFiles.length ? `${this.uploadFiles.length}개 파일 선택됨` : '');
        }
        this.sourceSelectionPage = 1;
        this.uploadQueueSearch = '';
        this.uploadQueueFilter = 'all';
        this.selectedUploadInspectorIndex = null;
        this.analysisQueueSearch = '';
        this.analysisQueueFilter = 'all';
        this.analysisQueuePage = 1;
        this.selectedAnalysisInspectorIndex = null;
        this.analysisInspectorOpen = this.defaultAnalysisInspectorOpen();
        this.registerStep = 'upload';
        this.metadataSection = 'visibility';
        this.visibilitySearch = '';
        this.visibilityStatusFilter = 'all';
        this.selectedVisibilityKeys = [];
        this.visibilityPage = 1;
        this.visibilityInspectorOpen = true;
        this.selectedVisibilityInspectorIndex = null;
        this.reviewSection = '';
        this.reviewSections = [];
        this.batchItems = [];
        this.analysisDetailOpen = {};
        this.activeBatchIndex = -1;
        this.partialRegistrationConfirmed = false;
        this.finalRegistrationAgreement = false;
        this.registrationCompletionFinalized = false;
        this.finalRegistrationPage = 1;
        this.registrationResults = [];
        this.autoSaveState = 'idle';
        this.autoSaveSavedAt = '';
        this.autoSaveMessage = '변경 내용은 자동 저장됩니다.';
        this.resetAnalysis();
        this.data = this.emptyRegistrationData();
        this.data.provenance_type = this.uploadSourceType === 'url'
            ? 'external_crawl' : 'direct_upload';
        const remaining = this.queuedRegistrationSourceCount();
        this.selectedRegistrationSourceCount = Math.max(
            this.selectedRegistrationSourceCount,
            this.processedRegistrationSourceCount + remaining,
        );
        this.uploadSelectionNotice = `${this.completedRegistrationCount.toLocaleString('ko-KR')}개 등록 완료 · 남은 ${remaining.toLocaleString('ko-KR')}개 중 다음 ${Math.min(remaining, this.maxActiveBatchFiles)}개를 처리할 수 있습니다.`;
        this.persistRegistrationRecovery();
        await this.saveRegistrationWorkspace(true);
    }

    public async saveBatch() {
        const preflightPrepared = this.registrationCommitPreflightPrepared;
        if (!preflightPrepared) this.syncActiveBatch();
        const scopedCompleteItems = this.finalRegistrableItems().filter(
            (item: any) => item.status === 'complete'
        );
        const metadataReviewInvalid = scopedCompleteItems.find((item: any) => (
            item.form
            && !this.metadataReviewSectionReady(this.metadataReviewFormForItem(item))
        ));
        if (metadataReviewInvalid) {
            this.registrationSubmitting = false;
            this.registrationProcessingOpen = false;
            await this.service.render();
            await this.service.modal.error(
                `${metadataReviewInvalid.name}: 필수 메타데이터와 원문 충돌 항목을 확인해주세요.`
            );
            return;
        }
        const gateInvalid = scopedCompleteItems.find(
            (item: any) => !this.registrationGateReady(item)
        );
        if (gateInvalid) {
            this.registrationSubmitting = false;
            this.registrationProcessingOpen = false;
            await this.service.render();
            await this.service.modal.error(
                gateInvalid.name + ': 공개 범위·중복 여부·보안 검사 수준을 모두 확인해주세요.'
            );
            return;
        }
        if (this.failedItemCount() > 0 && !this.partialRegistrationConfirmed) {
            this.registrationSubmitting = false;
            this.registrationProcessingOpen = false;
            await this.service.render();
            await this.service.modal.error(
                '실패 파일을 제외하고 저장하려면 최종 확인 화면에서 부분 등록 동의를 선택해주세요.'
            );
            return;
        }

        this.saving = true;
        this.registrationResults = [];
        if (!preflightPrepared) {
            await this.flushRegistrationRecoveryDraftsNow();
        }
        await this.service.render();
        let saved = 0;
        let processed = 0;
        let duplicateConflictIndex = -1;
        const targets = scopedCompleteItems;
        const targetResults: any[] = new Array(targets.length);
        const errors: string[] = [];
        const previouslyExcludedItems = this.batchItems.filter(
            (item: any) => item.status === 'error' || item.status === 'cancelled'
        );
        const previouslyExcludedItemSet = new Set(previouslyExcludedItems);
        const excludedResults = previouslyExcludedItems
            .map((item: any) => ({
                name: item.name,
                status: 'excluded',
                message: item.status === 'cancelled'
                    ? '사용자가 등록에서 제외했습니다.'
                    : '부분 등록 동의에 따라 실패 파일을 제외했습니다.',
                id: '',
            }));
        this.registrationResults = excludedResults.slice();

        try {
            await this.runBounded(
                targets,
                this.registrationSaveConcurrency,
                async (item: any, targetIndex: number) => {
                try {
                    const result = await this.callRegistrationSave(
                        this.registrationCommitRequest(item, item.form)
                    );
                    if (result.code === 200) {
                        saved += 1;
                        item.status = 'saved';
                        item.failureStage = '';
                        item.error = '';
                        item.errorDetails = '';
                        item.errorInfo = null;
                        item.savedId = result.data?.id || '';
                        item.registrationResult = {
                            name: item.name,
                            title: item.form?.title || item.name,
                            status: 'saved',
                            message: result.data?.ingestion?.warning || '자료함 등록 완료',
                            id: result.data?.id || '',
                            visibility: item.form?.status || 'draft',
                            updated: result.data?.updated || '',
                            postprocess: result.data?.ingestion?.status || 'complete',
                        };
                        targetResults[targetIndex] = item.registrationResult;
                        this.persistRegistrationRecovery();
                    } else if (result.code === 409 && result.data && result.data.duplicate) {
                        this.applyDuplicateConflict(item, result.data.duplicate);
                        item.status = 'complete';
                        const conflictIndex = this.batchItems.indexOf(item);
                        duplicateConflictIndex = duplicateConflictIndex < 0
                            ? conflictIndex
                            : Math.min(duplicateConflictIndex, conflictIndex);
                        errors.push(`${item.name}: 동일한 원문 자료 확인이 필요합니다.`);
                        targetResults[targetIndex] = {
                            name: item.name,
                            status: 'failed',
                            message: '동일한 원문 자료 확인이 필요합니다.',
                            id: '',
                        };
                    } else {
                        const captured = this.captureError(
                            result.data || '저장 실패',
                            '자료 저장에 실패했습니다.'
                        );
                        item.status = 'error';
                        item.failureStage = 'save';
                        item.error = captured.message;
                        item.errorDetails = captured.details;
                        item.errorInfo = captured;
                        errors.push(`${item.name}: ${captured.message}`);
                        targetResults[targetIndex] = {
                            name: item.name,
                            status: 'failed',
                            message: captured.message,
                            id: '',
                            requestId: captured.requestId || '',
                        };
                        if (captured.details) this.technicalErrorDetails = captured.details;
                    }
                } catch (error) {
                    const captured = this.captureError(error, '자료 저장 중 오류가 발생했습니다.');
                    item.status = 'error';
                    item.failureStage = 'save';
                    item.error = captured.message;
                    item.errorDetails = captured.details;
                    item.errorInfo = captured;
                    errors.push(`${item.name}: ${captured.message}`);
                    targetResults[targetIndex] = {
                        name: item.name,
                        status: 'failed',
                        message: captured.message,
                        id: '',
                        requestId: captured.requestId || '',
                    };
                    if (captured.details) this.technicalErrorDetails = captured.details;
                }
                processed += 1;
                this.registrationProgress = {
                    status: 'processing',
                    stage: 'commit',
                    label: `${item.name} 등록 결과 확인`,
                    completed: processed,
                    total: targets.length,
                    percent: Math.round(
                        30 + processed / Math.max(1, targets.length) * 70
                    ),
                };
                await this.service.render();
                },
            );
        } finally {
            this.saving = false;
            await this.service.render();
        }
        this.registrationResults = [
            ...excludedResults,
            ...targetResults.filter(Boolean),
        ];
        this.creditSavedRegistrationItems();
        this.persistRegistrationRecovery();
        this.registrationProcessingOpen = false;
        await this.service.render();

        if (duplicateConflictIndex >= 0) {
            await this.selectBatchItem(duplicateConflictIndex);
            this.registerStep = 'metadata';
            this.metadataSection = 'visibility';
        }
        if (errors.length > 0) {
            this.partialRegistrationConfirmed = false;
            this.persistRegistrationRecovery();
            this.analysisError = `${saved}개 저장, ${errors.length}개 실패했습니다. 실패 항목만 다시 시도할 수 있습니다.`;
            this.registrationProgress = {
                ...this.registrationProgress,
                status: saved > 0 ? 'partial' : 'failed',
                label: saved > 0 ? '일부 등록 완료' : '등록 실패',
                completed: saved,
                percent: saved > 0 ? Math.round(saved / Math.max(1, this.finalRegistrableCount()) * 100) : 0,
            };
            const saveFailures = this.batchItems
                .map((item: any, index: number) => ({ item, index }))
                .filter((row: any) => (
                    row.item.status === 'error' && row.item.failureStage === 'save'
                    && !previouslyExcludedItemSet.has(row.item)
                ));
            if (saveFailures.length > 0) {
                const first = saveFailures[0];
                await this.openRegistrationSaveError(
                    first.item.errorInfo || {
                        message: first.item.error,
                        fileName: first.item.name,
                        retryable: true,
                    },
                    saveFailures.length === 1 ? first.index : -1,
                    saveFailures.length,
                );
            } else {
                await this.service.modal.error(this.analysisError);
            }
        } else if (await this.resumeDeferredRegistrationReview(saved)) {
            // The shared branch keeps unselected drafts active instead of
            // terminally completing their registration workspace.
        } else if (this.queuedRegistrationSourceCount() > this.batchItems.length) {
            const processedCount = this.batchItems.length;
            await this.prepareNextRegistrationBatch(processedCount, saved);
            this.registrationProgress = {
                status: 'complete',
                stage: 'chunk_complete',
                label: '업로드 자료 등록 계속 진행',
                completed: this.completedRegistrationCount,
                total: this.completedRegistrationCount + this.queuedRegistrationSourceCount(),
                percent: Math.round(
                    this.completedRegistrationCount
                    / Math.max(
                        1,
                        this.completedRegistrationCount + this.queuedRegistrationSourceCount(),
                    ) * 100
                ),
            };
            await this.service.modal.success(
                `${saved}개 자료를 등록했습니다. 남은 ${this.queuedRegistrationSourceCount().toLocaleString('ko-KR')}개 분석 화면으로 계속 이어집니다.`
            );
        } else {
            await this.settleRegistrationWorkspaceWrites();
            const workspaceCompleted = await this.setRegistrationWorkspaceState('completed');
            this.registrationCompletionFinalized = workspaceCompleted;
            if (workspaceCompleted) {
                this.clearRegistrationRecovery();
            } else {
                this.persistRegistrationRecovery();
            }
            this.registrationProgress = {
                status: workspaceCompleted ? 'complete' : 'partial',
                stage: 'complete',
                label: workspaceCompleted
                    ? '자료함 등록 완료'
                    : '등록 완료 상태 반영 재시도 필요',
                completed: this.completedRegistrationCount,
                total: this.completedRegistrationCount,
                percent: 100,
            };
            const completionMessage = `${this.completedRegistrationCount.toLocaleString('ko-KR')}개 자료를 배치 등록했습니다.`;
            if (workspaceCompleted) {
                await this.service.modal.success(completionMessage);
            } else {
                const failureReason = this.registrationWorkspaceMessage
                    || '서버가 작업공간 완료 상태를 확인하지 못했습니다.';
                await this.service.modal.error(
                    `${completionMessage} 다만 작업공간의 완료 상태 반영에 실패했습니다. 원인: ${failureReason} 같은 버튼을 다시 누르면 저장된 자료를 재업로드하지 않고 완료 처리만 다시 시도합니다.`
                );
            }
        }
        await this.service.render();
    }

    private prepareEntityForReview(row: any, index: number = 0) {
        const entity = row && typeof row === 'object' ? { ...row } : {};
        const text = `${entity.text || ''}`;
        const type = `${entity.type || 'OTHER'}`.toUpperCase();
        const normalized = `${entity.normalized || text}`;
        return {
            ...entity,
            entity_id: entity.entity_id || '',
            text,
            type,
            normalized,
            kg_id: entity.kg_id || '',
            link_status: ['unlinked', 'selected', 'deferred'].includes(entity.link_status)
                ? entity.link_status
                : (entity.kg_id ? 'selected' : 'unlinked'),
            selection_reason: '',
            manually_corrected: !!entity.manually_corrected,
            history: Array.isArray(entity.history) ? entity.history : [],
            kg_candidates: Array.isArray(entity.kg_candidates) ? entity.kg_candidates : [],
            original_script: `${entity.original_script || (
                entity.hanja_verified ? entity.hanja || '' : ''
            )}`,
            name_candidates: Array.isArray(entity.name_candidates)
                ? entity.name_candidates : [],
            name_resolution_status: `${entity.name_resolution_status || 'confirmed'}`,
            name_auto_confirmed: entity.name_auto_confirmed !== false,
            name_resolution_reason: `${entity.name_resolution_reason || ''}`,
            evidence: entity.evidence && typeof entity.evidence === 'object'
                ? entity.evidence : {},
            draft_text: text,
            draft_type: type,
            draft_normalized: normalized,
            _editor_index: index,
        };
    }

    private syncEntityProfileField() {
        if (!this.data) return;
        if (!this.data.profile_fields || typeof this.data.profile_fields !== 'object') {
            this.data.profile_fields = {};
        }
        this.data.profile_fields.entities = Array.isArray(this.data.entities)
            ? this.data.entities.map((row: any) => ({ ...row }))
            : [];
        const item = this.activeBatchItem();
        if (item) {
            const checks = this.normaliseReviewChecks(item.reviewChecks);
            checks.entities = false;
            item.reviewChecks = checks;
        }
        this.syncActiveBatch();
        this.queueRegistrationRecoverySave();
    }

    private resetEntityDetailState() {
        this.entitySearch = '';
        this.entityTypeFilter = 'all';
        this.entityStatusFilter = 'all';
        this.entityLinkFilter = 'all';
        this.entityPage = 1;
        this.entityReviewEditing = false;
        this.rebuildEntityOccurrenceCounts();
        const rows = this.entityRows();
        this.selectedEntityRecord = rows.length ? rows[0] : null;
        this.resetEntityReviewDraft(this.selectedEntityRecord);
    }

    public entityRows() {
        return this.data && Array.isArray(this.data.entities)
            ? this.data.entities.filter((row: any) => row && typeof row === 'object')
            : [];
    }

    private entityRecordKey(entity: any, index: number = 0) {
        return `${entity?.entity_id || [
            entity?.type || 'OTHER',
            entity?.text || '',
            entity?.normalized || '',
            index,
        ].join(':')}`;
    }

    private literalOccurrenceCount(text: string, needle: string) {
        const source = `${text || ''}`.toLocaleLowerCase();
        const query = `${needle || ''}`.trim().toLocaleLowerCase();
        if (!query) return 0;
        let count = 0;
        let offset = 0;
        while (offset <= source.length - query.length) {
            const found = source.indexOf(query, offset);
            if (found < 0) break;
            count += 1;
            offset = found + Math.max(1, query.length);
        }
        return count;
    }

    private rebuildEntityOccurrenceCounts() {
        const text = `${this.data?.ocr_text || ''}`;
        const counts: any = {};
        this.entityRows().forEach((entity: any, index: number) => {
            const explicit = Number(entity?.occurrence_count);
            if (Number.isFinite(explicit) && explicit >= 0) {
                counts[this.entityRecordKey(entity, index)] = explicit;
                return;
            }
            const names = [entity?.text, entity?.normalized]
                .map((value: any) => `${value || ''}`.trim())
                .filter((value: string, nameIndex: number, values: string[]) =>
                    !!value && values.indexOf(value) === nameIndex
                );
            const found = names.reduce(
                (maximum: number, name: string) =>
                    Math.max(maximum, this.literalOccurrenceCount(text, name)),
                0,
            );
            counts[this.entityRecordKey(entity, index)] = text ? found : null;
        });
        this.entityOccurrenceCounts = counts;
    }

    public entityTypeOptions() {
        const preferred = [
            'PERSON', 'PLACE', 'ORGANIZATION', 'EVENT', 'WORK', 'DATE', 'OTHER',
        ];
        const available = new Set(
            this.entityRows().map((row: any) => `${row.type || 'OTHER'}`.toUpperCase())
        );
        return preferred.filter((type: string) => available.has(type));
    }

    public entityLinkedCount() {
        return this.entityRows().filter(
            (entity: any) =>
                entity.link_status === 'selected' && !!entity.kg_id
        ).length;
    }

    public entityReviewNeededCount() {
        return this.entityRows().filter(
            (entity: any) => !this.entityExcluded(entity)
                && this.entityReviewStatusKey(entity) === 'needs_review'
        ).length;
    }

    public entityExcluded(entity: any) {
        return `${entity?.entity_status || 'active'}` === 'excluded'
            || ['excluded', 'duplicate'].includes(
                `${entity?.review_disposition || ''}`
            );
    }

    public entityTotalOccurrenceCount() {
        return Object.values(this.entityOccurrenceCounts || {}).reduce(
            (total: number, value: any) => (
                value !== null && value !== undefined
                    && Number.isFinite(Number(value))
                    ? total + Number(value) : total
            ),
            0,
        );
    }

    public entityUnknownOccurrenceCount() {
        return this.entityRows().filter((entity: any, index: number) => {
            const value = this.entityOccurrenceCounts[
                this.entityRecordKey(entity, index)
            ];
            return value === null || value === undefined
                || !Number.isFinite(Number(value));
        }).length;
    }

    public entityOccurrenceSummaryLabel() {
        const unknown = this.entityUnknownOccurrenceCount();
        const total = this.entityTotalOccurrenceCount().toLocaleString();
        return unknown > 0
            ? `확인된 출현 ${total}회 · ${unknown.toLocaleString()}개 항목 미집계`
            : `원문 출현 합계 ${total}회`;
    }

    public savedEntityDeletionTargetCount() {
        return this.entityRows().filter(
            (entity: any) => this.entityReviewStatusKey(entity) === 'excluded'
        ).length;
    }

    public savedEntityDuplicateCount() {
        return this.entityRows().filter(
            (entity: any) => this.entityReviewStatusKey(entity) === 'duplicate'
        ).length;
    }

    public async toggleSavedEntityDeletionTarget(entity: any, event?: Event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (!entity || !this.canManageEntities()) return;
        const index = this.entityRows().indexOf(entity);
        const key = this.entityRecordKey(entity, Math.max(0, index));
        if (this.entityExcluded(entity)) {
            const snapshot = this.savedEntityDeletionSnapshots[key];
            entity.entity_status = 'active';
            entity.review_status = 'reviewed';
            entity.requires_review = false;
            entity.review_disposition = snapshot?.review_disposition || 'approved';
            entity.duplicate_of_entity_id = '';
            entity.kg_id = snapshot?.kg_id || '';
            entity.link_status = snapshot?.link_status || 'unlinked';
            if (typeof snapshot?.manually_corrected === 'boolean') {
                entity.manually_corrected = snapshot.manually_corrected;
            }
            delete this.savedEntityDeletionSnapshots[key];
        } else {
            this.savedEntityDeletionSnapshots[key] = {
                review_status: entity.review_status,
                requires_review: entity.requires_review,
                kg_id: entity.kg_id,
                link_status: entity.link_status,
                manually_corrected: entity.manually_corrected,
                review_disposition: entity.review_disposition,
                duplicate_of_entity_id: entity.duplicate_of_entity_id,
            };
            entity.entity_status = 'excluded';
            entity.review_status = 'reviewed';
            entity.requires_review = false;
            entity.review_disposition = 'excluded';
            entity.duplicate_of_entity_id = '';
            entity.kg_id = '';
            entity.link_status = 'unlinked';
        }
        entity.selection_reason = '';
        this.markSavedReviewDirty();
        await this.renderPreservingViewport();
    }

    public filteredEntityRows() {
        const query = `${this.entitySearch || ''}`.trim().toLocaleLowerCase();
        return this.entityRows().filter((entity: any) => {
            const type = `${entity.type || 'OTHER'}`.toUpperCase();
            if (this.entityTypeFilter !== 'all' && type !== this.entityTypeFilter) {
                return false;
            }
            const reviewStatus = this.entityReviewStatusKey(entity);
            if (
                this.entityStatusFilter !== 'all'
                && reviewStatus !== this.entityStatusFilter
            ) {
                return false;
            }
            const linked = entity.link_status === 'selected' && !!entity.kg_id;
            if (this.entityLinkFilter === 'linked' && !linked) return false;
            if (this.entityLinkFilter === 'unlinked' && linked) return false;
            if (!query) return true;
            const candidates = Array.isArray(entity.kg_candidates)
                ? entity.kg_candidates : [];
            const searchable = [
                entity.text,
                entity.normalized,
                entity.hanja,
                this.entityTypeLabel(type),
                entity.kg_id,
                ...candidates.reduce((values: any[], candidate: any) => [
                    ...values,
                    candidate?.id,
                    candidate?.label,
                    candidate?.hanja_name,
                ], []),
            ].map((value: any) => `${value || ''}`.toLocaleLowerCase()).join(' ');
            return searchable.includes(query);
        });
    }

    public entityPageCount() {
        return Math.max(
            1,
            Math.ceil(this.filteredEntityRows().length / this.entityPageSize),
        );
    }

    public pagedEntityRows() {
        const page = Math.min(Math.max(1, this.entityPage), this.entityPageCount());
        const start = (page - 1) * this.entityPageSize;
        return this.filteredEntityRows().slice(start, start + this.entityPageSize);
    }

    public entityPaginationPages() {
        const total = this.entityPageCount();
        let start = Math.max(1, this.entityPage - 3);
        let end = Math.min(total, start + 6);
        start = Math.max(1, end - 6);
        return Array.from({ length: end - start + 1 }, (_row, index) => start + index);
    }

    public entityPageRangeStart() {
        return this.filteredEntityRows().length
            ? (this.entityPage - 1) * this.entityPageSize + 1
            : 0;
    }

    public entityPageRangeEnd() {
        return Math.min(
            this.filteredEntityRows().length,
            this.entityPage * this.entityPageSize,
        );
    }

    public async setEntityFilter(filter: 'type' | 'status' | 'link', value: string) {
        if (filter === 'type') this.entityTypeFilter = value;
        if (filter === 'status') this.entityStatusFilter = value;
        if (filter === 'link') this.entityLinkFilter = value;
        this.entityPage = 1;
        await this.service.render();
    }

    public async onEntitySearchChange(value: string) {
        this.entitySearch = value;
        this.entityPage = 1;
        await this.service.render();
    }

    public async setEntityPage(page: number) {
        this.entityPage = Math.min(Math.max(1, page), this.entityPageCount());
        await this.service.render();
    }

    public async selectEntityRecord(entity: any) {
        this.selectedEntityRecord = entity;
        this.entityReviewEditing = false;
        this.resetEntityReviewDraft(entity);
        await this.service.render();
    }

    public entityRecordSelected(entity: any) {
        return !!entity && this.selectedEntityRecord === entity;
    }

    public entityOccurrenceLabel(entity: any) {
        const index = this.entityRows().indexOf(entity);
        const count = this.entityOccurrenceCounts[
            this.entityRecordKey(entity, Math.max(0, index))
        ];
        return count !== null && count !== undefined
            && Number.isFinite(Number(count))
            ? `${Number(count)}회` : '미확인';
    }

    public entityEvidencePage(entity: any) {
        const evidence = entity?.evidence || {};
        return evidence.verified && evidence.page ? `${evidence.page}쪽` : '페이지 미확인';
    }

    public entityEvidenceExcerpt(entity: any) {
        const quote = `${entity?.evidence?.quote || ''}`.trim();
        if (!quote) return '인용문 미확인';
        return quote.length > 42 ? `${quote.slice(0, 42)}…` : quote;
    }

    public entityReviewStatusKey(entity: any) {
        const explicit = `${entity?.review_disposition || ''}`;
        if ([
            'approved', 'corrected', 'excluded', 'duplicate', 'needs_review',
        ].includes(explicit)) return explicit;
        if (`${entity?.entity_status || 'active'}` === 'excluded') return 'excluded';
        if (entity?.review_status === 're_review') return 'corrected';
        if (entity?.review_status === 'reviewed' && !entity?.requires_review) {
            return 'approved';
        }
        return 'needs_review';
    }

    public entityReviewStatusLabel(entity: any) {
        const labels: any = {
            approved: '승인',
            corrected: '수정',
            excluded: '제외',
            duplicate: '중복',
            needs_review: '확인 필요',
        };
        return labels[this.entityReviewStatusKey(entity)] || '확인 필요';
    }

    public entityReviewStatusClass(entity: any) {
        return `is-${this.entityReviewStatusKey(entity).replace('_', '-')}`;
    }

    public entityLinkedGraphLabel(entity: any) {
        if (this.entityExcluded(entity)) return this.entityReviewStatusLabel(entity);
        const candidate = this.selectedEntityCandidate(entity);
        if (candidate) {
            return `${candidate.label || candidate.id || '연결됨'} · ${candidate.id || entity.kg_id}`;
        }
        if (entity?.link_status === 'deferred') return '판단 보류';
        return entity?.kg_id ? `${entity.kg_id}` : '연결 없음';
    }

    public savedEntityLinkStatusLabel(entity: any) {
        const status = `${entity?.link_status || ''}`.trim().toLowerCase();
        const labels: any = {
            selected: '지식그래프 연결',
            linked: '지식그래프 연결',
            deferred: '지식그래프 연결 보류',
            unlinked: '지식그래프 미연결',
        };
        return labels[status] || (
            entity?.kg_id ? '지식그래프 연결' : '지식그래프 미연결'
        );
    }

    public canManageEntities() {
        return !!(this.data && this.data.can_manage_entities);
    }

    private resetEntityReviewDraft(entity: any) {
        this.entityReviewDraft = {
            type: `${entity?.type || 'OTHER'}`.toUpperCase(),
            normalized: `${entity?.normalized || entity?.text || ''}`,
            kg_id: `${entity?.kg_id || ''}`,
            link_status: entity?.link_status || 'unlinked',
            entity_status: entity?.entity_status || 'active',
            review_disposition: this.entityReviewStatusKey(entity),
            duplicate_of_entity_id: `${entity?.duplicate_of_entity_id || ''}`,
            reason: '',
        };
    }

    public async beginEntityReview() {
        if (!this.selectedEntityRecord || !this.canManageEntities()) return;
        this.resetEntityReviewDraft(this.selectedEntityRecord);
        this.entityReviewEditing = true;
        await this.service.render();
    }

    public async cancelEntityReview() {
        this.entityReviewEditing = false;
        this.resetEntityReviewDraft(this.selectedEntityRecord);
        await this.service.render();
    }

    public async selectEntityReviewCandidate(candidate: any) {
        if (!candidate?.id) return;
        this.entityReviewDraft.kg_id = candidate.id;
        this.entityReviewDraft.link_status = 'selected';
        this.entityReviewDraft.entity_status = 'active';
        this.entityReviewDraft.review_disposition = 'corrected';
        await this.service.render();
    }

    public async setEntityReviewLinkStatus(status: 'unlinked' | 'deferred') {
        this.entityReviewDraft.kg_id = '';
        this.entityReviewDraft.link_status = status;
        this.entityReviewDraft.entity_status = 'active';
        this.entityReviewDraft.review_disposition = 'corrected';
        await this.service.render();
    }

    public async markEntityReviewCorrection() {
        this.entityReviewDraft.review_disposition = 'corrected';
        this.entityReviewDraft.entity_status = 'active';
        this.entityReviewDraft.duplicate_of_entity_id = '';
        await this.service.render();
    }

    public async setEntityReviewStatus(status: 'active' | 'excluded') {
        this.entityReviewDraft.entity_status = status;
        if (status === 'excluded') {
            this.entityReviewDraft.review_disposition = 'excluded';
            this.entityReviewDraft.duplicate_of_entity_id = '';
            this.entityReviewDraft.kg_id = '';
            this.entityReviewDraft.link_status = 'unlinked';
        } else if (['excluded', 'duplicate'].includes(
            this.entityReviewDraft.review_disposition
        )) {
            this.entityReviewDraft.review_disposition = 'approved';
            this.entityReviewDraft.duplicate_of_entity_id = '';
        }
        await this.service.render();
    }

    public async setEntityReviewDisposition(disposition: string) {
        if (![
            'approved', 'corrected', 'excluded', 'duplicate', 'needs_review',
        ].includes(disposition)) return;
        this.entityReviewDraft.review_disposition = disposition;
        const excluded = ['excluded', 'duplicate'].includes(disposition);
        this.entityReviewDraft.entity_status = excluded ? 'excluded' : 'active';
        if (disposition !== 'corrected' && this.selectedEntityRecord) {
            this.entityReviewDraft.type = `${
                this.selectedEntityRecord.type || 'OTHER'
            }`.toUpperCase();
            this.entityReviewDraft.normalized = `${
                this.selectedEntityRecord.normalized
                || this.selectedEntityRecord.text || ''
            }`;
            this.entityReviewDraft.kg_id = `${
                this.selectedEntityRecord.kg_id || ''
            }`;
            this.entityReviewDraft.link_status = (
                this.selectedEntityRecord.link_status || 'unlinked'
            );
        }
        if (excluded) {
            this.entityReviewDraft.kg_id = '';
            this.entityReviewDraft.link_status = 'unlinked';
        }
        if (disposition !== 'duplicate') {
            this.entityReviewDraft.duplicate_of_entity_id = '';
        }
        await this.service.render();
    }

    public entityDuplicateTargets(entity: any) {
        return this.entityRows().filter((row: any) => (
            row !== entity
            && !this.entityExcluded(row)
            && !!`${row?.entity_id || ''}`
        ));
    }

    public entityOriginalValues(entity: any) {
        const original = entity?.original_values;
        if (original && typeof original === 'object') return original;
        const first = this.entityHistory(entity).find(
            (event: any) => event?.changes && typeof event.changes === 'object'
        );
        const before = (key: string, fallback: any) => (
            first?.changes?.[key] && 'before' in first.changes[key]
                ? first.changes[key].before : fallback
        );
        return {
            text: before('text', entity?.text || ''),
            type: before('type', entity?.type || 'OTHER'),
            normalized: before('normalized', entity?.normalized || entity?.text || ''),
            kg_id: before('kg_id', entity?.kg_id || ''),
            link_status: before('link_status', entity?.link_status || 'unlinked'),
        };
    }

    public entityValueChanged(entity: any, key: string) {
        const original = this.entityOriginalValues(entity);
        return `${original?.[key] || ''}` !== `${entity?.[key] || ''}`;
    }

    public entityReviewDeletionStatusChanged() {
        const entity = this.selectedEntityRecord;
        if (!entity) return false;
        const previousStatus = this.entityExcluded(entity) ? 'excluded' : 'active';
        const nextStatus = this.entityReviewDraft.entity_status === 'excluded'
            ? 'excluded' : 'active';
        return previousStatus !== nextStatus;
    }

    public entityReviewStatusOnlyChange() {
        const entity = this.selectedEntityRecord;
        if (!entity) return false;
        if (!this.entityReviewDeletionStatusChanged()) return false;
        const nextStatus = this.entityReviewDraft.entity_status === 'excluded'
            ? 'excluded' : 'active';
        if (
            `${this.entityReviewDraft.normalized || ''}`.trim()
            !== `${entity.normalized || entity.text || ''}`.trim()
        ) return false;
        if (nextStatus === 'excluded') return true;
        return (
            `${this.entityReviewDraft.link_status || 'unlinked'}`
                === `${entity.link_status || 'unlinked'}`
            && `${this.entityReviewDraft.kg_id || ''}` === `${entity.kg_id || ''}`
        );
    }

    private async persistEntityReviewSubmission(
        entity: any,
        submission: any,
        successMessage: string,
    ) {
        this.entityReviewSaving = true;
        await this.service.render();
        try {
            const result = await wiz.call('save', {
                mode: 'entity_review',
                id: this.id,
                expected_revision: this.data.revision || this.data.updated || '',
                entity: JSON.stringify({
                    entity_id: entity.entity_id,
                    ...submission,
                }),
            });
            if (result.code === 200) {
                const response = result.data || {};
                const rows = Array.isArray(response.entities) ? response.entities : [];
                this.data.entities = rows;
                this.data.profile_fields = {
                    ...(this.data.profile_fields || {}),
                    entities: rows.map((row: any) => ({ ...row })),
                };
                this.data.ai_metadata = {
                    ...(this.data.ai_metadata || {}),
                    entities: rows,
                    profile_fields: this.data.profile_fields,
                };
                this.data.revision = response.revision || response.updated || this.data.revision;
                this.data.updated = response.updated || this.data.updated;
                this.rebuildEntityOccurrenceCounts();
                this.selectedEntityRecord = rows.find(
                    (row: any) => row.entity_id === entity.entity_id
                ) || rows[0] || null;
                this.entityReviewEditing = false;
                this.resetEntityReviewDraft(this.selectedEntityRecord);
                await this.service.modal.success(successMessage);
                return true;
            }
            if (
                result.code === 409
                && result.data?.conflict === 'revision_conflict'
            ) {
                await this.service.modal.error(
                    '다른 사용자가 먼저 수정했습니다. 최신 내용을 다시 불러온 뒤 다시 시도해주세요.'
                );
            } else {
                await this.service.modal.error(
                    result.data?.message || '개체명 검수 결과를 저장하지 못했습니다.'
                );
            }
        } catch (error) {
            const captured = this.captureError(
                error, '개체명 검수 결과 저장 중 오류가 발생했습니다.'
            );
            await this.service.modal.error(captured.message);
        } finally {
            this.entityReviewSaving = false;
            await this.service.render();
        }
        return false;
    }

    public async toggleEntityDeletionTarget(entity: any) {
        if (!entity || !this.canManageEntities() || this.entityReviewSaving) return;
        const excluding = !this.entityExcluded(entity);
        await this.persistEntityReviewSubmission(
            entity,
            {
                type: `${entity.type || 'OTHER'}`.toUpperCase(),
                normalized: `${entity.normalized || entity.text || ''}`.trim(),
                kg_id: excluding ? '' : `${entity.kg_id || ''}`,
                link_status: excluding ? 'unlinked' : (entity.link_status || 'unlinked'),
                entity_status: excluding ? 'excluded' : 'active',
                review_disposition: excluding ? 'excluded' : 'approved',
                duplicate_of_entity_id: '',
                deletion_action: excluding ? 'exclude' : 'restore',
                reason: '',
            },
            excluding
                ? '선택한 개체명을 제외로 분류했습니다.'
                : '제외 지정을 취소하고 승인 상태로 복구했습니다.',
        );
    }

    public async saveEntityReview() {
        const entity = this.selectedEntityRecord;
        if (!entity || !this.canManageEntities() || this.entityReviewSaving) return;
        const reason = `${this.entityReviewDraft.reason || ''}`.trim();
        const disposition = `${
            this.entityReviewDraft.review_disposition || 'needs_review'
        }`;
        const entityStatus = ['excluded', 'duplicate'].includes(disposition)
            ? 'excluded' : 'active';
        const entityType = `${this.entityReviewDraft.type || 'OTHER'}`.toUpperCase();
        const normalized = `${this.entityReviewDraft.normalized || ''}`.trim();
        const linkStatus = this.entityReviewDraft.link_status || 'unlinked';
        const kgId = `${this.entityReviewDraft.kg_id || ''}`;
        if (!normalized) {
            await this.entityActionError('표준명을 입력해주세요.');
            return;
        }
        if (
            disposition === 'duplicate'
            && !`${this.entityReviewDraft.duplicate_of_entity_id || ''}`
        ) {
            await this.entityActionError('중복 기준이 되는 다른 개체명을 선택해주세요.');
            return;
        }
        if (
            linkStatus === 'selected'
            && !kgId
        ) {
            await this.entityActionError('연결할 지식그래프 후보를 선택해주세요.');
            return;
        }

        await this.persistEntityReviewSubmission(
            entity,
            {
                type: entityType,
                normalized,
                kg_id: kgId,
                link_status: linkStatus,
                entity_status: entityStatus,
                review_disposition: disposition,
                duplicate_of_entity_id: `${
                    this.entityReviewDraft.duplicate_of_entity_id || ''
                }`,
                deletion_action: '',
                reason,
            },
            ({
                approved: '개체명을 승인했습니다.',
                corrected: '개체명 수정값을 저장하고 재검수 대상으로 분류했습니다.',
                excluded: '개체명을 제외로 분류했습니다.',
                duplicate: '개체명을 중복으로 분류했습니다.',
                needs_review: '개체명을 확인 필요로 분류했습니다.',
            } as any)[disposition] || '개체명 검수 결과를 저장했습니다.',
        );
    }

    public entityHistoryChangeSummary(event: any) {
        const labels: any = {
            text: '원문 표기',
            type: '유형',
            normalized: '표준명',
            kg_id: '연결 후보',
            link_status: '연결 상태',
            review_status: '검수 상태',
            entity_status: '개체 상태',
            review_disposition: '검수 구분',
            duplicate_of_entity_id: '중복 기준 개체',
        };
        const changes = event && event.changes && typeof event.changes === 'object'
            ? event.changes : {};
        return Object.keys(changes).map((key: string) => {
            const change = changes[key] || {};
            return `${labels[key] || key}: ${change.before || '없음'} → ${change.after || '없음'}`;
        }).join(' · ');
    }

    public async addEntity() {
        if (!Array.isArray(this.data.entities)) this.data.entities = [];
        this.data.entities.push(this.prepareEntityForReview({
            entity_id: `manual-${Date.now()}-${Math.random().toString(16).slice(2)}`,
            text: '',
            type: 'PERSON',
            normalized: '',
            confidence: 1,
            kg_id: '',
            link_status: 'unlinked',
            manually_corrected: true,
            kg_candidates: [],
            history: [],
            evidence: {},
        }, this.data.entities.length));
        this.syncEntityProfileField();
        await this.service.render();
    }

    public async removeEntity(index: number) {
        this.data.entities.splice(index, 1);
        this.syncEntityProfileField();
        await this.service.render();
    }

    public entityTypeLabel(type: string) {
        const labels: any = {
            PERSON: '인물', PLACE: '지명', ORGANIZATION: '기관', EVENT: '사건',
            WORK: '저작', DATE: '날짜', OTHER: '기타',
        };
        return labels[`${type || 'OTHER'}`.toUpperCase()] || '기타';
    }

    public entityTypeClass(type: string) {
        return `is-${`${type || 'OTHER'}`.toLowerCase()}`;
    }

    public entityDisplayName(entity: any) {
        const standard = `${entity?.normalized || entity?.text || '미확인'}`.trim();
        const hanja = entity && entity.hanja_verified ? `${entity.hanja || ''}`.trim() : '';
        return hanja && !standard.includes(hanja) ? `${standard}(${hanja})` : standard;
    }

    public entityEvidenceLabel(entity: any) {
        const evidence = entity && entity.evidence && typeof entity.evidence === 'object'
            ? entity.evidence : {};
        if (!evidence.verified) return '원문 page·quote·offset 미확인';
        const offset = evidence.offset && typeof evidence.offset === 'object'
            ? evidence.offset : {};
        return `${evidence.page || '?'}쪽 · offset ${offset.start ?? '?'}–${offset.end ?? '?'}`;
    }

    public entityEvidenceQuote(entity: any) {
        const evidence = entity && entity.evidence && typeof entity.evidence === 'object'
            ? entity.evidence : {};
        return evidence.verified && evidence.quote ? `“${evidence.quote}”` : '미확인';
    }

    public entityLinkStatusLabel(entity: any) {
        const labels: any = {
            selected: '후보 연결',
            unlinked: '연결 안 함',
            deferred: '판단 보류',
        };
        return labels[entity?.link_status || 'unlinked'] || '연결 안 함';
    }

    public entityReasonReady(entity: any) {
        return `${entity?.selection_reason || ''}`.trim().length > 0;
    }

    public entityHasCandidates(entity: any) {
        return Array.isArray(entity?.kg_candidates) && entity.kg_candidates.length > 0;
    }

    public entityNameCandidates(entity: any) {
        return Array.isArray(entity?.name_candidates)
            ? entity.name_candidates.filter((row: any) => !!`${row?.value || ''}`.trim())
            : [];
    }

    public entityNameResolutionNeedsReview(entity: any) {
        return entity?.name_resolution_status === 'review_required'
            || (!!entity?.original_script && entity?.name_auto_confirmed === false
                && !entity?.manually_corrected);
    }

    public useEntityNameCandidate(entity: any, candidate: any) {
        const value = `${candidate?.value || ''}`.trim();
        if (!entity || !value) return;
        entity.draft_normalized = value;
        if (!`${entity.selection_reason || ''}`.trim()) {
            entity.selection_reason = `한자 인명 국문 표기 후보 선택: ${value}`;
        }
    }

    public entityCanDefer(entity: any) {
        return !!entity && (
            !this.entityHasCandidates(entity)
            || this.entityReasonReady(entity)
        );
    }

    public entityDeferButtonLabel(entity: any) {
        return this.entityHasCandidates(entity) ? '보류' : '후보 없음으로 보류';
    }

    public entityCandidateSelectionReason(candidate: any) {
        return `지식그래프 후보 직접 선택: ${this.candidateDisplayName(candidate)} (${candidate?.id || 'ID 미확인'})`;
    }

    public selectedEntityCandidate(entity: any) {
        const rows = Array.isArray(entity?.kg_candidates) ? entity.kg_candidates : [];
        return rows.find((candidate: any) => candidate && candidate.id === entity.kg_id) || null;
    }

    public candidateDisplayName(candidate: any) {
        const label = `${candidate?.label || '미확인'}`.trim() || '미확인';
        const hanja = `${candidate?.hanja_name || ''}`.trim();
        return hanja && !label.includes(hanja) ? `${label}(${hanja})` : label;
    }

    public candidateText(candidate: any, key: string) {
        const value = candidate ? candidate[key] : null;
        if (Array.isArray(value)) {
            const labels = value.map((row: any) => {
                if (!row || typeof row !== 'object') return `${row || ''}`.trim();
                const label = `${row.label || row.value || row.id || ''}`.trim();
                return row.relation && label ? `${row.relation}: ${label}` : label;
            }).filter(Boolean);
            return labels.length ? labels.join(' · ') : '미확인';
        }
        return `${value || ''}`.trim() || '미확인';
    }

    public candidateLinks(candidate: any) {
        return Array.isArray(candidate?.service_links) ? candidate.service_links : [];
    }

    public candidateIdentifiers(candidate: any) {
        return Array.isArray(candidate?.external_identifiers)
            ? candidate.external_identifiers : [];
    }

    public candidateSelected(entity: any, candidate: any) {
        return !!entity && !!candidate && entity.link_status === 'selected'
            && entity.kg_id === candidate.id;
    }

    private async entityActionError(message: string) {
        await this.service.modal.error(message);
        await this.service.render();
    }

    public async applyEntityModification(entity: any) {
        if (!entity || !this.entityReasonReady(entity)) {
            await this.entityActionError('표준명·유형 수정 근거를 먼저 입력해주세요.');
            return;
        }
        const nextText = `${entity.draft_text || ''}`.trim();
        const nextNormalized = `${entity.draft_normalized || nextText}`.trim();
        if (!nextText || !nextNormalized) {
            await this.entityActionError('개체명과 한국어 표준명을 입력해주세요.');
            return;
        }
        if (!(entity.evidence && entity.evidence.verified)) entity.text = nextText;
        entity.type = `${entity.draft_type || 'OTHER'}`.toUpperCase();
        entity.normalized = nextNormalized;
        entity.manually_corrected = true;
        if (entity.original_script && nextNormalized !== entity.original_script) {
            entity.name_resolution_status = 'confirmed_by_reviewer';
            entity.name_auto_confirmed = false;
            entity.name_resolution_reason = '검수자가 국문 표기를 확정했습니다.';
        }
        this.syncEntityProfileField();
        await this.service.render();
    }

    public async selectEntityCandidate(entity: any, candidate: any) {
        if (!entity || !candidate || !candidate.id) return;
        const previousIndex = this.registrationEntityIndex;
        const currentReason = `${entity.selection_reason || ''}`.trim();
        if (!currentReason || currentReason.startsWith('지식그래프 후보 직접 선택:')) {
            entity.selection_reason = this.entityCandidateSelectionReason(candidate);
        }
        entity.kg_id = candidate.id;
        entity.link_status = 'selected';
        entity.manually_corrected = true;
        this.syncEntityProfileField();
        await this.advanceToNextUnresolvedEntityDecision(previousIndex);
    }

    public async unlinkEntity(entity: any) {
        if (!entity || !this.entityReasonReady(entity)) {
            await this.entityActionError('연결 해제 근거를 먼저 입력해주세요.');
            return;
        }
        entity.kg_id = '';
        entity.link_status = 'unlinked';
        entity.manually_corrected = true;
        this.syncEntityProfileField();
        await this.service.render();
    }

    public async deferEntity(entity: any) {
        if (!entity) return;
        const previousIndex = this.registrationEntityIndex;
        if (!this.entityReasonReady(entity) && this.entityHasCandidates(entity)) {
            await this.entityActionError('보류 근거를 먼저 입력해주세요.');
            return;
        }
        if (!this.entityReasonReady(entity)) {
            entity.selection_reason = '지식그래프 후보가 없어 사용자 보류';
        }
        entity.kg_id = '';
        entity.link_status = 'deferred';
        entity.manually_corrected = true;
        this.syncEntityProfileField();
        await this.advanceToNextUnresolvedEntityDecision(previousIndex);
    }

    public entityHistory(entity: any) {
        const rows = Array.isArray(entity?.history) ? entity.history : [];
        return [...rows].reverse();
    }

    public entityHistoryActionLabel(action: string) {
        const labels: any = {
            selected: '후보 선택',
            unlinked: '연결 해제',
            deferred: '보류',
            modified: '개체 수정',
            re_review: '재검수 전환',
            excluded: '검수 제외',
            restored: '검수 복구',
            approved: '승인',
            duplicate: '중복 분류',
            needs_review: '확인 필요 분류',
        };
        return labels[action] || '변경';
    }

    public confidencePercent(value: any) {
        if (value === null || typeof value === 'undefined' || !Number.isFinite(Number(value))) return '정보 없음';
        return `${Math.round(Number(value || 0) * 100)}%`;
    }

    private normaliseMetadataReviewWorkflowState(value: any): MetadataReviewWorkflowState {
        const state = `${
            value && typeof value === 'object'
                ? value.state || (value.advanced ? 'advanced' : '')
                : value || ''
        }`.trim().toLowerCase();
        return ['ready', 'advanced'].includes(state)
            ? state as MetadataReviewWorkflowState
            : 'draft';
    }

    private metadataReviewWorkflowState(item: any): MetadataReviewWorkflowState {
        if (!item || !item.form) return 'draft';
        const complete = this.metadataReviewFileComplete(item);
        if (complete && item.metadataReviewState === 'advanced') return 'advanced';
        return complete ? 'ready' : 'draft';
    }

    private registrationDraftWorkflowState(item: any) {
        const existing = item?.registrationWorkflowState
            && typeof item.registrationWorkflowState === 'object'
            ? item.registrationWorkflowState : {};
        const existingMetadataReview = existing.metadata_review
            && typeof existing.metadata_review === 'object'
            ? existing.metadata_review : {};
        const state = this.metadataReviewWorkflowState(item);
        return {
            ...existing,
            metadata_review: {
                ...existingMetadataReview,
                schema_version: existingMetadataReview.schema_version
                    || 'metadata-review-workflow-v1',
                state,
                advanced: state === 'advanced',
            },
        };
    }

    public metadataReviewWorkflowStateLabel(item: any) {
        if (item?.status === 'saved') return '자료함 등록 완료';
        if (item?.metadataReviewPaused) return '임시저장 · 나중에 계속';
        const labels: any = {
            draft: '검수 초안',
            ready: '검수 완료 · 다음 단계 준비',
            advanced: '이번 진행 대상',
        };
        return labels[this.metadataReviewWorkflowState(item)] || '검수 초안';
    }

    public metadataReviewItemKey(item: any, index: number = -1) {
        const analysisId = `${item?.analysis?.id || ''}`.trim();
        if (analysisId) return `analysis:${analysisId}`;
        const progressId = `${item?.progressId || ''}`.trim();
        if (progressId) return `progress:${progressId}`;
        const sourceUrl = `${item?.sourceUrl || ''}`.trim();
        if (sourceUrl) return `url:${sourceUrl}`;
        const resolvedIndex = index >= 0 ? index : this.batchItems.indexOf(item);
        return `file:${resolvedIndex}:${item?.name || ''}`;
    }

    private metadataReviewFormForItem(item: any) {
        return this.batchItems[this.activeBatchIndex] === item && this.data
            ? this.data : item?.form;
    }

    public metadataReviewTargetItems() {
        return this.batchItems
            .map((item: any, index: number) => ({ item, index }))
            .filter((row: any) => (
                row.item?.status === 'complete'
                && !!row.item.analysis
                && !!row.item.form
            ));
    }

    public metadataReviewFileItems() {
        let rows = this.batchItems.map((item: any, index: number) => ({ item, index }));
        if (this.metadataReviewFileFilter === 'complete') {
            rows = rows.filter((row: any) => this.metadataReviewFileComplete(row.item));
        }
        if (this.metadataReviewFileFilter === 'incomplete') {
            rows = rows.filter((row: any) => !this.metadataReviewFileComplete(row.item));
        }
        const search = `${this.metadataReviewQueueSearch || ''}`
            .trim().toLocaleLowerCase();
        if (!search) return rows;
        return rows.filter((row: any) => {
            const form = this.metadataReviewFormForItem(row.item);
            const review = form?.xml_field_review
                && typeof form.xml_field_review === 'object'
                ? form.xml_field_review
                : form?.common_metadata_review;
            const fields = Array.isArray(review?.fields) ? review.fields : [];
            const haystack = [
                this.reviewFileName(row.item),
                row.item?.name,
                this.metadataReviewWorkflowStateLabel(row.item),
                ...fields.flatMap((field: any) => [
                    field?.label,
                    field?.id,
                    this.xmlReviewValueText(field?.current_value),
                    this.xmlReviewValueText(field?.original_display_value || field?.original_value),
                ]),
            ].map((value: any) => `${value || ''}`.toLocaleLowerCase()).join(' ');
            return haystack.includes(search);
        });
    }

    public metadataReviewFilePageCount() {
        return Math.max(
            1,
            Math.ceil(
                this.metadataReviewFileItems().length
                / this.metadataReviewFilePageSize
            ),
        );
    }

    public metadataReviewFileCurrentPage() {
        return Math.min(
            Math.max(1, this.metadataReviewFilePage),
            this.metadataReviewFilePageCount(),
        );
    }

    public metadataReviewFilePageItems() {
        const start = (
            this.metadataReviewFileCurrentPage() - 1
        ) * this.metadataReviewFilePageSize;
        return this.metadataReviewFileItems().slice(
            start,
            start + this.metadataReviewFilePageSize,
        );
    }

    public metadataReviewFilePageRangeLabel() {
        const total = this.metadataReviewFileItems().length;
        if (!total) return '0개';
        const start = (
            this.metadataReviewFileCurrentPage() - 1
        ) * this.metadataReviewFilePageSize + 1;
        const end = Math.min(
            total,
            start + this.metadataReviewFilePageSize - 1,
        );
        return `${start.toLocaleString('ko-KR')}–${end.toLocaleString('ko-KR')} / ${total.toLocaleString('ko-KR')}개`;
    }

    private syncMetadataReviewFilePageToIndex(index: number) {
        const position = this.metadataReviewFileItems().findIndex(
            (row: any) => row.index === index
        );
        if (position < 0) return;
        this.metadataReviewFilePage = Math.floor(
            position / this.metadataReviewFilePageSize
        ) + 1;
    }

    public async setMetadataReviewFilePage(page: number) {
        this.metadataReviewFilePage = Math.min(
            Math.max(1, Number(page) || 1),
            this.metadataReviewFilePageCount(),
        );
        await this.service.render();
    }

    public async setMetadataReviewQueueSearch(value: any) {
        this.metadataReviewQueueSearch = `${value || ''}`.slice(0, 200);
        this.metadataReviewFilePage = 1;
        await this.service.render();
    }

    public metadataReviewIncompleteFileCount() {
        return this.metadataReviewTargetItems().filter(
            (row: any) => !this.metadataReviewFileComplete(row.item)
        ).length;
    }

    public async setMetadataReviewFileFilter(filter: MetadataReviewFileFilter) {
        this.metadataReviewFileFilter = filter;
        this.metadataReviewFilePage = 1;
        const visible = this.metadataReviewFileItems();
        if (
            visible.length
            && !visible.some((row: any) => row.index === this.activeBatchIndex)
        ) {
            const first = visible.find((row: any) => row.item?.analysis && row.item?.form);
            if (first) await this.selectBatchItem(first.index);
        }
        await this.service.render();
    }

    public metadataAdvanceItemSelected(item: any, index: number = -1) {
        if (!item) return false;
        const key = this.metadataReviewItemKey(item, index);
        return item.metadataReviewState === 'advanced'
            || this.metadataAdvanceSelectionKeys.includes(key);
    }

    public metadataAdvanceSelectedCount() {
        return this.metadataReviewTargetItems().filter(
            (row: any) => this.metadataAdvanceItemSelected(row.item, row.index)
        ).length;
    }

    public metadataAdvanceDeferredCount() {
        if (this.metadataAdvanceMode !== 'selected') return 0;
        return this.metadataReviewTargetItems().filter(
            (row: any) => !this.metadataAdvanceItemSelected(row.item, row.index)
        ).length;
    }

    public metadataAdvanceItemIncluded(item: any, index: number = -1) {
        return this.metadataAdvanceMode !== 'selected'
            || this.metadataAdvanceItemSelected(item, index);
    }

    public metadataAdvanceFileItems() {
        return this.metadataReviewTargetItems().filter(
            (row: any) => this.metadataAdvanceItemIncluded(row.item, row.index)
        );
    }

    private async ensureActiveReviewScopeItem() {
        const rows = this.reviewNavigableFileItems();
        if (!rows.length) return false;
        if (!rows.some((row: any) => row.index === this.activeBatchIndex)) {
            await this.selectBatchItem(rows[0].index);
        }
        return true;
    }

    private async initialiseManualReviewStart() {
        const rows = this.reviewNavigableFileItems();
        if (!rows.length) return false;
        await this.selectBatchItem(rows[0].index);
        this.reviewFileFilter = 'all';
        this.reviewAttentionMenuOpen = false;
        this.syncReviewSections();
        this.reviewSection = this.reviewSections.length
            ? this.reviewSections[0].key : '';
        this.reviewTextPage = 1;
        this.reviewTranslationPage = 1;
        this.reviewTranslationCandidateExpandedIndex = -1;
        this.reviewParagraphIndex = 0;
        this.reviewParagraphDraft = this.reviewParagraphs()[0] || '';
        this.registrationEntityPage = 1;
        this.registrationEntityIndex = 0;
        return true;
    }

    private metadataReviewAdvanceItems() {
        return this.metadataAdvanceFileItems().map((row: any) => row.item);
    }

    public metadataReviewAdvanceReady() {
        const rows = this.metadataAdvanceMode === 'selected'
            ? this.metadataAdvanceFileItems()
            : this.metadataReviewTargetItems();
        return rows.length > 0 && rows.every(
            (row: any) => this.metadataReviewFileComplete(row.item)
        );
    }

    public async selectAllCompletedMetadataFiles() {
        this.syncActiveBatch();
        this.metadataAdvanceSelectionKeys = this.metadataReviewTargetItems()
            .filter((row: any) => this.metadataReviewFileComplete(row.item))
            .map((row: any) => this.metadataReviewItemKey(row.item, row.index));
        this.persistRegistrationRecovery();
        await this.service.render();
    }

    public async clearMetadataAdvanceSelection() {
        this.metadataAdvanceSelectionKeys = [];
        this.batchItems.forEach((item: any) => {
            if (item.metadataReviewState === 'advanced') {
                item.metadataReviewState = this.metadataReviewFileComplete(item)
                    ? 'ready' : 'draft';
            }
        });
        if (this.metadataAdvanceMode === 'selected') this.metadataAdvanceMode = 'all';
        this.persistRegistrationRecovery();
        await this.service.render();
    }

    private markMetadataAdvanceScope() {
        const selectedMode = this.metadataAdvanceMode === 'selected';
        this.metadataReviewTargetItems().forEach((row: any) => {
            const included = !selectedMode
                || this.metadataAdvanceItemSelected(row.item, row.index);
            row.item.metadataReviewState = included
                && this.metadataReviewFileComplete(row.item)
                ? 'advanced'
                : this.metadataReviewFileComplete(row.item) ? 'ready' : 'draft';
            if (included) row.item.metadataReviewPaused = false;
            this.captureRegistrationLocalDraft(row.item, row.item.form);
        });
        this.persistRegistrationRecovery();
    }

    public async advanceSelectedMetadataFiles() {
        this.syncActiveBatch();
        const selectedRows = this.metadataReviewTargetItems().filter(
            (row: any) => this.metadataAdvanceSelectionKeys.includes(
                this.metadataReviewItemKey(row.item, row.index)
            )
        );
        if (!selectedRows.length) {
            await this.service.modal.error('다음 단계로 진행할 검수 완료 자료를 선택해주세요.');
            return;
        }
        const incomplete = selectedRows.filter(
            (row: any) => !this.metadataReviewFileComplete(row.item)
        );
        if (incomplete.length) {
            await this.service.modal.error(
                `선택한 자료 중 ${incomplete.length}개가 미완료입니다. 검수를 완료하거나 선택에서 제외해주세요.`
            );
            return;
        }
        const deferred = this.metadataReviewTargetItems().length - selectedRows.length;
        const accepted = typeof window === 'undefined' ? true : window.confirm(
            `검수 완료 자료 ${selectedRows.length}개만 다음 단계로 진행합니다. 미완료·미선택 자료 ${Math.max(0, deferred)}개는 임시저장 상태로 남고 이번 최종 등록 대상에서 제외됩니다.`
        );
        if (!accepted) return;
        this.metadataAdvanceMode = 'selected';
        selectedRows.forEach((row: any) => {
            row.item.metadataReviewState = 'advanced';
            row.item.metadataReviewPaused = false;
        });
        this.markMetadataAdvanceScope();
        const saved = await this.flushRegistrationRecoveryDraftsForExit();
        if (!saved) {
            this.metadataDraftNotice = '선택한 진행 범위를 서버에 저장하지 못했습니다. 다시 시도해주세요.';
            await this.service.render();
            return;
        }
        if (!selectedRows.some((row: any) => row.index === this.activeBatchIndex)) {
            await this.selectBatchItem(selectedRows[0].index);
        }
        await this.goRegisterStep('complete');
    }

    public async resumeMetadataReview(index: number) {
        const item = this.batchItems[index];
        if (!item || !item.analysis || !item.form || item.status !== 'complete') return;
        item.metadataReviewPaused = false;
        this.metadataDraftNotice = `${this.reviewFileName(item)} 검수를 이어서 진행합니다.`;
        await this.selectBatchItem(index);
        this.queueRegistrationRecoverySave();
        await this.service.render();
    }

    public xmlFieldReview() {
        const xmlReview = this.data && this.data.xml_field_review
            && typeof this.data.xml_field_review === 'object'
            ? this.data.xml_field_review : {};
        if (Array.isArray(xmlReview.fields) && xmlReview.fields.length) return xmlReview;
        return this.data && this.data.common_metadata_review
            && typeof this.data.common_metadata_review === 'object'
            ? this.data.common_metadata_review : {};
    }

    public metadataReviewUsesXml() {
        return !!(
            this.data
            && this.data.xml_field_review
            && Array.isArray(this.data.xml_field_review.fields)
            && this.data.xml_field_review.fields.length
        );
    }

    public xmlFieldReviewEnabled() {
        return Array.isArray(this.xmlFieldReview().fields)
            && this.xmlFieldReview().fields.length > 0;
    }

    public xmlReviewFields() {
        const review = this.xmlFieldReview();
        return Array.isArray(review.fields) ? review.fields : [];
    }

    public xmlMetadataStrategy() {
        const review = this.xmlFieldReview();
        return review.metadata_strategy && typeof review.metadata_strategy === 'object'
            ? review.metadata_strategy : {};
    }

    private metadataStrategyFallbackOptions() {
        return [
            {
                id: 'full_text',
                label: '원문 Full Text 및 국역문 Full Text 기반 사료',
                description: '원문·국역문과 서지정보를 중심으로 검수하고 장·절 계층값을 본문 단위 메타데이터로 보존합니다.',
                content_review_keys: [
                    'original_text', 'translated_text', 'paragraphs',
                    'annotations', 'table_of_contents', 'entities',
                ],
            },
            {
                id: 'record_hierarchy',
                label: '문서철 및 개별 문서가 계층적으로 구성된 기록자료',
                description: '대표 메타데이터와 ITEM·LEVEL별 문서 단위 메타데이터를 분리해 검수합니다.',
                content_review_keys: [
                    'original_text', 'paragraphs', 'annotations',
                    'table_of_contents', 'entities',
                ],
            },
            {
                id: 'image_artifact',
                label: '이미지 중심의 유물·유적 자료',
                description: '유물·유적 식별정보와 이미지 설명, 시대·주제 메타데이터를 우선 검수합니다.',
                content_review_keys: ['original_text', 'annotations', 'entities'],
            },
            {
                id: 'research_attachment',
                label: 'PDF 및 첨부파일과 목차·기본정보 중심의 연구자료',
                description: '논문·간행물 서지정보와 목차·첨부 연결에 필요한 메타데이터를 우선 검수합니다.',
                content_review_keys: ['original_text', 'table_of_contents', 'entities'],
            },
            {
                id: 'historical_issue',
                label: '역사이슈 콘텐츠',
                description: '주제·시대·핵심 설명과 콘텐츠 계층을 중심으로 검수합니다.',
                content_review_keys: [
                    'original_text', 'paragraphs', 'annotations', 'entities',
                ],
            },
            {
                id: 'history_education',
                label: '역사교육 콘텐츠',
                description: '교육자료의 제목·발행정보·주제·설명과 학습 단위 계층을 중심으로 검수합니다.',
                content_review_keys: [
                    'original_text', 'paragraphs', 'annotations',
                    'table_of_contents', 'entities',
                ],
            },
        ];
    }

    public metadataStrategyOptions() {
        const rows = Array.isArray(this.xmlMetadataStrategy().available_strategies)
            ? this.xmlMetadataStrategy().available_strategies : [];
        const allowed = new Set([
            'full_text', 'record_hierarchy', 'image_artifact',
            'research_attachment', 'historical_issue', 'history_education',
        ]);
        const safeRows = rows.filter(
            (row: any) => row && allowed.has(`${row.id || ''}`)
        );
        const fallbackRows = this.metadataStrategyFallbackOptions();
        return fallbackRows.map((fallback: any) => {
            const serverRow = safeRows.find(
                (row: any) => `${row.id || ''}` === fallback.id
            ) || {};
            return {
                ...fallback,
                ...serverRow,
                label: fallback.label,
                description: fallback.description,
            };
        });
    }

    public metadataStrategyAutoDetectedId() {
        const strategy = this.xmlMetadataStrategy();
        return `${strategy.auto_detected_strategy_id || strategy.id || ''}`;
    }

    public metadataStrategySelectedByUser() {
        return !!this.xmlMetadataStrategy().selected_by_user;
    }

    private updateLocalMetadataStrategy(strategyId: string, selectedByUser: boolean) {
        const review = this.xmlFieldReview();
        if (!review || typeof review !== 'object') return false;
        const current = this.xmlMetadataStrategy();
        const option = this.metadataStrategyOptions().find(
            (row: any) => `${row.id || ''}` === strategyId
        );
        if (!option) return false;
        const detectedId = `${current.auto_detected_strategy_id || current.id || ''}`;
        review.metadata_strategy = {
            ...current,
            ...option,
            id: strategyId,
            selection_reason: selectedByUser ? 'user_override' : current.selection_reason,
            auto_detected_strategy_id: detectedId,
            auto_detected_strategy_label: current.auto_detected_strategy_label || current.label || '',
            selected_by_user: selectedByUser,
            available_strategies: this.metadataStrategyOptions(),
            hierarchy_role_overrides: {},
            hierarchy_role_review: {
                ...(current.hierarchy_role_review || {}),
                applicable: this.metadataHierarchyApplicable(),
                mode: 'backend_automatic',
                required: false,
                confirmed: true,
                status: this.metadataHierarchyApplicable()
                    ? 'auto_applied' : 'not_applicable',
                auto_applied: this.metadataHierarchyApplicable(),
                confirmed_at: '',
                confirmed_by: this.metadataHierarchyApplicable() ? 'system' : '',
            },
            hierarchy_unit_review: {
                ...(current.hierarchy_unit_review || {}),
                mode: 'backend_automatic',
                review_required: false,
                reviewed_unit_ids: [],
                reviewed_count: this.metadataHierarchyUnitCount(),
                auto_applied_count: this.metadataHierarchyUnitCount(),
                pending_count: 0,
            },
            server_owned: true,
        };
        const contracts = Array.isArray(option.field_contracts)
            ? option.field_contracts : [];
        const contractMap = new Map<string, any>();
        contracts.forEach((row: any) => contractMap.set(`${row?.id || ''}`, row));
        this.xmlReviewFields().forEach((field: any) => {
            const contract = contractMap.get(`${field?.id || ''}`);
            if (!contract) return;
            const policy = contract.review_policy || {};
            field.review_policy = {
                ...(field.review_policy || {}),
                strategy_id: strategyId,
                contract_schema_version: option.contract_schema_version || '',
                server_owned: true,
                requirement: contract.requirement || 'optional',
                priority: contract.priority || 'supporting',
                automatic_mode: policy.mode || 'automatic_if_exact',
                missing_value_policy: policy.missing_value || 'manual_required',
                multiple_value_policy: policy.multiple_values || 'select_representative',
                exposure: { ...(contract.exposure || {}) },
                expected_source: { ...(contract.source || {}) },
            };
            if (field.scope_review && typeof field.scope_review === 'object') {
                field.scope_review.strategy_id = strategyId;
                field.scope_review.review_priority = contract.priority || 'supporting';
            }
        });
        return true;
    }

    private async persistMetadataStrategySelection(
        strategyId: string,
        selectedByUser: boolean,
    ) {
        if (this.metadataStrategyChanging) return;
        const current = this.xmlMetadataStrategy();
        if (
            `${current.id || ''}` === strategyId
            && !!current.selected_by_user === selectedByUser
        ) return;
        const option = this.metadataStrategyOptions().find(
            (row: any) => `${row.id || ''}` === strategyId
        );
        if (!option) {
            await this.service.modal.error('선택한 자료 유형을 적용할 수 없습니다.');
            return;
        }
        const accepted = typeof window === 'undefined' ? true : window.confirm(
            `자료 유형을 ‘${option.label}’(으)로 변경합니다. 입력한 값은 유지되고 필수·핵심 필드와 자료 단위 역할이 다시 적용됩니다.`
        );
        if (!accepted) {
            await this.service.render();
            return;
        }
        this.metadataStrategyChanging = true;
        this.metadataDraftNotice = '자료 유형 변경을 적용하고 있습니다.';
        this.updateLocalMetadataStrategy(strategyId, selectedByUser);
        this.syncReviewSections();
        this.syncActiveBatch();
        this.queueRegistrationRecoverySave();
        await this.service.render();
        const saved = await this.flushRegistrationRecoveryDraftsForExit();
        this.metadataStrategyChanging = false;
        this.metadataDraftNotice = saved
            ? `자료 유형을 ‘${option.label}’(으)로 변경하고 저장했습니다.`
            : '자료 유형 변경을 저장하지 못했습니다. 화면을 닫지 말고 다시 시도해주세요.';
        await this.service.render();
    }

    public async changeXmlMetadataStrategy(strategyId: string) {
        await this.persistMetadataStrategySelection(`${strategyId || ''}`, true);
    }

    public async resetXmlMetadataStrategy() {
        const automaticId = this.metadataStrategyAutoDetectedId();
        if (!automaticId) return;
        await this.persistMetadataStrategySelection(automaticId, false);
    }

    public xmlReviewHierarchy() {
        const review = this.xmlFieldReview();
        return review.hierarchy && typeof review.hierarchy === 'object'
            ? review.hierarchy : {};
    }

    public metadataStrategyPrimaryFieldIds() {
        const strategy = this.xmlMetadataStrategy();
        return Array.isArray(strategy.primary_field_ids)
            ? strategy.primary_field_ids.map((id: any) => `${id || ''}`)
            : [];
    }

    public metadataReviewFieldPrimary(field: any) {
        if (!field) return false;
        if (`${field?.review_policy?.priority || ''}` === 'primary') return true;
        return this.metadataStrategyPrimaryFieldIds().includes(`${field.id || ''}`);
    }

    public metadataReviewPrimaryCount() {
        return this.xmlReviewFields().filter(
            (field: any) => this.metadataReviewFieldPrimary(field)
        ).length;
    }

    public metadataHierarchyApplicable() {
        const hierarchy = this.xmlReviewHierarchy();
        return !!hierarchy.applicable && this.metadataHierarchyUnitCount() > 0;
    }

    public metadataHierarchyUnitCount() {
        const hierarchy = this.xmlReviewHierarchy();
        const units = Array.isArray(hierarchy.units) ? hierarchy.units : [];
        return this.safeNumber(hierarchy.unit_count, units.length);
    }

    public metadataHierarchyLevelSummary() {
        const hierarchy = this.xmlReviewHierarchy();
        const levels = Array.isArray(hierarchy.levels) ? hierarchy.levels : [];
        return levels.map((level: any) => (
            `${level.id || 'LEVEL'} ${this.safeNumber(level.count, 0)}`
        )).join(' · ') || '계층 단위 없음';
    }

    public metadataHierarchyRoleReview() {
        const strategy = this.xmlMetadataStrategy();
        return strategy.hierarchy_role_review
            && typeof strategy.hierarchy_role_review === 'object'
            ? strategy.hierarchy_role_review : {};
    }

    public metadataHierarchyRolesConfirmed() {
        const review = this.metadataHierarchyRoleReview();
        return !review.required || !!review.confirmed;
    }

    public metadataHierarchyRoleOptions() {
        const strategy = this.xmlMetadataStrategy();
        return Array.isArray(strategy.hierarchy_role_options)
            ? strategy.hierarchy_role_options.filter((row: any) => row && row.id)
            : [];
    }

    public metadataHierarchyLevelRoles() {
        const strategy = this.xmlMetadataStrategy();
        return Array.isArray(strategy.hierarchy_level_roles)
            ? strategy.hierarchy_level_roles : [];
    }

    public metadataHierarchyRoleSelectedId(level: any) {
        return `${level?.role_id || level?.unit_kind || ''}`;
    }

    public metadataHierarchyRoleReviewReason() {
        const review = this.metadataHierarchyRoleReview();
        const reasons = Array.isArray(review.reason_codes) ? review.reason_codes : [];
        if (reasons.includes('mixed_roles_in_same_level')) {
            return '같은 LEVEL에서 서로 다른 역할이 감지됐습니다. 실제 자료 단위를 확인해 역할을 확정해주세요.';
        }
        if (reasons.includes('structure_only_classification')) {
            return 'XML 구조만으로 판별된 역할입니다. 실제 자료 의미와 맞는지 확인해주세요.';
        }
        return 'ITEM과 각 LEVEL의 의미를 확인해야 최종 등록할 수 있습니다.';
    }

    private applyLocalMetadataHierarchyRoles(overrides: any) {
        const options = new Map<string, any>();
        this.metadataHierarchyRoleOptions().forEach(
            (row: any) => options.set(`${row.id || ''}`, row)
        );
        const roleByLevel = new Map<string, any>();
        this.metadataHierarchyLevelRoles().forEach((row: any) => {
            const selected = overrides && overrides[`${row.level || ''}`];
            const roleId = `${selected?.id || selected?.role_id || selected || row.role_id || ''}`;
            const role = options.get(roleId);
            if (role) roleByLevel.set(`${row.level || ''}`, role);
        });
        const applyRole = (row: any) => {
            if (!row || typeof row !== 'object') return;
            const role = roleByLevel.get(`${row.level || row.scope_level || ''}`);
            if (!role) return;
            row.role = role.role || '';
            row.unit_kind = role.unit_kind || role.id || '';
            row.service_unit = !!role.service_unit;
            row.management_unit = !!role.management_unit;
            if (row.scope_role !== undefined) row.scope_role = role.role || '';
            const breadcrumb = Array.isArray(row.breadcrumb) ? row.breadcrumb : [];
            breadcrumb.forEach((crumb: any) => {
                const crumbRole = roleByLevel.get(`${crumb?.level || ''}`);
                if (crumbRole) crumb.role = crumbRole.role || '';
            });
        };
        const hierarchy = this.xmlReviewHierarchy();
        (Array.isArray(hierarchy.units) ? hierarchy.units : []).forEach(applyRole);
        (Array.isArray(hierarchy.all_units) ? hierarchy.all_units : []).forEach(applyRole);
        this.xmlReviewFields().forEach((field: any) => {
            this.metadataHierarchyUnits(field).forEach((unit: any) => {
                applyRole(unit);
                (Array.isArray(unit.candidates) ? unit.candidates : []).forEach(applyRole);
            });
            (Array.isArray(field?.evidence) ? field.evidence : []).forEach((evidence: any) => {
                if (evidence?.scope) applyRole(evidence.scope);
            });
        });
        this.metadataHierarchyLevelRoles().forEach((row: any) => {
            const role = roleByLevel.get(`${row.level || ''}`);
            if (!role) return;
            row.role_id = role.id || role.unit_kind || '';
            row.role = role.role || '';
            row.unit_kind = role.unit_kind || role.id || '';
            row.service_unit = !!role.service_unit;
            row.management_unit = !!role.management_unit;
            row.source = overrides && overrides[`${row.level || ''}`] ? 'manual' : 'automatic';
            row.mixed = false;
        });
    }

    private async persistMetadataHierarchyReview(successMessage: string) {
        if (this.metadataHierarchyReviewChanging) return false;
        this.metadataHierarchyReviewChanging = true;
        this.syncActiveBatch();
        this.queueRegistrationRecoverySave();
        await this.service.render();
        const saved = await this.flushRegistrationRecoveryDraftsForExit();
        this.metadataHierarchyReviewChanging = false;
        this.metadataDraftNotice = saved
            ? successMessage
            : '계층 역할 변경을 저장하지 못했습니다. 화면을 닫지 말고 다시 시도해주세요.';
        await this.service.render();
        return saved;
    }

    public async changeMetadataHierarchyLevelRole(level: string, roleId: string) {
        if (this.metadataHierarchyReviewChanging) return;
        const strategy = this.xmlMetadataStrategy();
        const option = this.metadataHierarchyRoleOptions().find(
            (row: any) => `${row.id || ''}` === `${roleId || ''}`
        );
        if (!strategy || !option || !level) return;
        strategy.hierarchy_role_overrides = {
            ...(strategy.hierarchy_role_overrides || {}),
            [level]: { ...option },
        };
        strategy.hierarchy_role_review = {
            ...this.metadataHierarchyRoleReview(),
            required: true,
            confirmed: false,
            status: 'review_required',
            confirmed_at: '',
            confirmed_by: '',
        };
        strategy.hierarchy_unit_review = {
            ...(strategy.hierarchy_unit_review || {}),
            reviewed_unit_ids: [],
            reviewed_count: 0,
        };
        this.applyLocalMetadataHierarchyRoles(strategy.hierarchy_role_overrides);
        this.metadataDraftNotice = `${level} 역할을 ‘${option.role || option.label || roleId}’(으)로 변경했습니다. 역할 확인 후 등록할 수 있습니다.`;
        await this.service.render();
        await this.persistMetadataHierarchyReview(`${level} 역할을 변경하고 저장했습니다.`);
    }

    public async confirmMetadataHierarchyRoles() {
        if (!this.metadataHierarchyApplicable() || this.metadataHierarchyReviewChanging) return;
        const strategy = this.xmlMetadataStrategy();
        strategy.hierarchy_role_review = {
            ...this.metadataHierarchyRoleReview(),
            required: true,
            confirmed: true,
            status: 'confirmed',
        };
        this.metadataDraftNotice = '현재 파일의 ITEM·LEVEL 역할을 확인했습니다.';
        await this.service.render();
        await this.persistMetadataHierarchyReview('계층 역할 확인을 저장했습니다.');
    }

    public async resetMetadataHierarchyRoles() {
        if (this.metadataHierarchyReviewChanging) return;
        const strategy = this.xmlMetadataStrategy();
        strategy.hierarchy_role_overrides = {};
        strategy.hierarchy_role_review = {
            ...this.metadataHierarchyRoleReview(),
            required: true,
            confirmed: false,
            status: 'review_required',
            confirmed_at: '',
            confirmed_by: '',
        };
        await this.persistMetadataHierarchyReview('계층 역할을 자동 판별값으로 되돌렸습니다.');
    }

    public metadataHierarchyUnitReview() {
        const strategy = this.xmlMetadataStrategy();
        return strategy.hierarchy_unit_review
            && typeof strategy.hierarchy_unit_review === 'object'
            ? strategy.hierarchy_unit_review : {};
    }

    public metadataHierarchyUnitReviewed(unit: any) {
        const ids = Array.isArray(this.metadataHierarchyUnitReview().reviewed_unit_ids)
            ? this.metadataHierarchyUnitReview().reviewed_unit_ids : [];
        return ids.includes(`${unit?.id || ''}`);
    }

    public metadataHierarchyUnitOverviewRows() {
        const hierarchy = this.xmlReviewHierarchy();
        const units = Array.isArray(hierarchy.units) ? hierarchy.units : [];
        const fieldMaps = this.xmlReviewFields().map((field: any) => ({
            field,
            units: new Map<string, any>(this.metadataHierarchyUnits(field).map(
                (unit: any) => [`${unit?.id || ''}`, unit]
            )),
        }));
        const rows = units.map((unit: any) => {
            const fields: any[] = [];
            const persons: string[] = [];
            const places: string[] = [];
            let conflictCount = 0;
            fieldMaps.forEach((entry: any) => {
                const scoped = entry.units.get(`${unit?.id || ''}`);
                if (!scoped) return;
                const values = this.metadataHierarchyUnitValues(scoped);
                if (values.length) fields.push({
                    id: entry.field.id,
                    label: entry.field.label,
                    values,
                });
                if (`${scoped.conflict_state || ''}` === 'conflict') conflictCount += 1;
                (Array.isArray(scoped.candidates) ? scoped.candidates : []).forEach((candidate: any) => {
                    const value = this.metadataHierarchyCandidateValue(candidate);
                    if (candidate?.index_type === 'person' && value && !persons.includes(value)) persons.push(value);
                    if (candidate?.index_type === 'place' && value && !places.includes(value)) places.push(value);
                });
            });
            return {
                ...unit,
                common_fields: fields,
                persons,
                places,
                conflict_count: conflictCount,
            };
        });
        const query = `${this.metadataHierarchyOverviewSearch || ''}`.trim().toLowerCase();
        if (!query) return rows;
        return rows.filter((row: any) => [
            row.id, row.xml_id, row.level, row.role, row.label,
            this.metadataHierarchyUnitBreadcrumb(row),
            ...row.persons, ...row.places,
            ...row.common_fields.reduce((values: string[], field: any) => (
                values.concat([field.label, ...field.values])
            ), []),
        ].join(' ').toLowerCase().includes(query));
    }

    public metadataHierarchyUnitOverviewPageCount() {
        return Math.max(1, Math.ceil(
            this.metadataHierarchyUnitOverviewRows().length
            / this.metadataHierarchyOverviewPageSize
        ));
    }

    public metadataHierarchyUnitOverviewPageRows() {
        const rows = this.metadataHierarchyUnitOverviewRows();
        const page = Math.max(1, Math.min(
            this.metadataHierarchyOverviewPage,
            Math.max(1, Math.ceil(rows.length / this.metadataHierarchyOverviewPageSize)),
        ));
        const start = (page - 1) * this.metadataHierarchyOverviewPageSize;
        return rows.slice(start, start + this.metadataHierarchyOverviewPageSize);
    }

    public async setMetadataHierarchyOverviewPage(page: number) {
        this.metadataHierarchyOverviewPage = Math.max(1, Math.min(
            this.metadataHierarchyUnitOverviewPageCount(), this.safeNumber(page, 1)
        ));
        await this.service.render();
    }

    public async toggleMetadataHierarchyUnitReviewed(unit: any) {
        if (!unit?.id) return;
        const strategy = this.xmlMetadataStrategy();
        const review = this.metadataHierarchyUnitReview();
        const ids = new Set<string>(Array.isArray(review.reviewed_unit_ids)
            ? review.reviewed_unit_ids.map((id: any) => `${id || ''}`) : []);
        const id = `${unit.id}`;
        if (ids.has(id)) ids.delete(id); else ids.add(id);
        strategy.hierarchy_unit_review = {
            ...review,
            reviewed_unit_ids: Array.from(ids),
            reviewed_count: ids.size,
        };
        this.syncActiveBatch();
        this.queueRegistrationRecoverySave();
        await this.service.render();
    }

    public async reviewVisibleMetadataHierarchyUnits() {
        const strategy = this.xmlMetadataStrategy();
        const review = this.metadataHierarchyUnitReview();
        const ids = new Set<string>(Array.isArray(review.reviewed_unit_ids)
            ? review.reviewed_unit_ids.map((id: any) => `${id || ''}`) : []);
        this.metadataHierarchyUnitOverviewPageRows().forEach((unit: any) => {
            if (unit?.id && !unit.conflict_count) ids.add(`${unit.id}`);
        });
        strategy.hierarchy_unit_review = {
            ...review,
            reviewed_unit_ids: Array.from(ids),
            reviewed_count: ids.size,
        };
        this.syncActiveBatch();
        this.queueRegistrationRecoverySave();
        this.metadataDraftNotice = '현재 표시된 정상 자료 단위를 검수 완료로 표시했습니다.';
        await this.service.render();
    }

    public xmlReviewScope(field: any) {
        return field && field.scope_review && typeof field.scope_review === 'object'
            ? field.scope_review : {};
    }

    public xmlReviewScopeApplicable(field: any) {
        const scope = this.xmlReviewScope(field);
        return !!scope.applicable && this.metadataHierarchyUnits(field).length > 0;
    }

    public metadataReviewScopeCandidateCount(field: any) {
        const scope = this.xmlReviewScope(field);
        return this.safeNumber(
            scope.candidate_count,
            this.metadataHierarchyCandidates(field).length,
        );
    }

    public metadataReviewScopeReturnedCandidateCount(field: any) {
        const scope = this.xmlReviewScope(field);
        return this.safeNumber(
            scope.returned_candidate_count,
            this.metadataHierarchyCandidates(field).length,
        );
    }

    public metadataReviewScopeTruncated(field: any) {
        return !!this.xmlReviewScope(field).truncated;
    }

    public metadataReviewHierarchicalVariation(field: any) {
        return !!this.xmlReviewScope(field).hierarchical_variation;
    }

    public metadataReviewSameScopeConflictCount(field: any) {
        return this.safeNumber(
            this.xmlReviewScope(field).same_scope_conflict_count,
            this.metadataHierarchyUnits(field).filter(
                (unit: any) => `${unit?.conflict_state || ''}` === 'conflict'
            ).length,
        );
    }

    public metadataReviewScopeDistinctCount(field: any) {
        const scope = this.xmlReviewScope(field);
        const candidates = this.metadataHierarchyCandidates(field);
        const distinct = new Set(candidates.map((candidate: any) => (
            this.metadataHierarchyCandidateValue(candidate).trim().toLowerCase()
        )).filter(Boolean));
        return this.safeNumber(scope.distinct_value_count, distinct.size);
    }

    public metadataReviewRepresentativeCandidateIds(field: any) {
        const scope = this.xmlReviewScope(field);
        return Array.isArray(scope.representative_candidate_ids)
            ? scope.representative_candidate_ids.map((id: any) => `${id || ''}`).filter(Boolean)
            : [];
    }

    public metadataReviewHierarchyNeedsDecision(field: any) {
        if (!this.xmlReviewScopeApplicable(field)) return false;
        if ([
            'confirmed', 'modified', 'deferred', 'excluded', 'not_applicable',
        ].includes(`${field?.status || ''}`) && !!field?.reviewed) return false;
        const scope = this.xmlReviewScope(field);
        const selectionRequired = typeof scope.representative_selection_required === 'boolean'
            ? !!scope.representative_selection_required
            : !field?.repeatable && this.metadataReviewScopeDistinctCount(field) > 1;
        if (!selectionRequired) return false;
        if (this.metadataReviewRepresentativeCandidateIds(field).length > 0) return false;
        const source = `${scope.representative_source || ''}`;
        return ![
            'manual',
            'xml_candidate',
            'extracted_confirmed',
            'original_confirmed',
            'multiple_confirmed',
            'metadata_v2_1',
        ].includes(source);
    }

    public metadataReviewHierarchyResolved(field: any) {
        return !this.metadataReviewHierarchyNeedsDecision(field);
    }

    public metadataReviewScopeStatusLabel(field: any) {
        if (!this.xmlReviewScopeApplicable(field)) return '';
        const selected = this.metadataReviewRepresentativeCandidateIds(field).length;
        const source = `${this.xmlReviewScope(field).representative_source || ''}`;
        if (this.metadataReviewScopeTruncated(field) && !field?.reviewed) {
            return '원문 후보 일부 표시';
        }
        if (this.metadataReviewSameScopeConflictCount(field) > 0 && !field?.reviewed) {
            return `자료 단위 내부 충돌 ${this.metadataReviewSameScopeConflictCount(field)}건`;
        }
        if (this.metadataReviewHierarchyNeedsDecision(field)) return '대표값 선택 필요';
        if (selected) return `계층 후보 ${selected}개 선택`;
        if (source === 'multiple_confirmed') return '복수 값 선택';
        if (source === 'manual' || source === 'metadata_v2_1') return '직접 입력 대표값';
        return this.metadataReviewHierarchicalVariation(field)
            ? '계층별 값 차이 자동 보존' : '자료 단위값 자동 보존';
    }

    public metadataReviewScopeSummaryText(field: any) {
        if (!this.xmlReviewScopeApplicable(field)) return '';
        const scope = this.xmlReviewScope(field);
        const unitCount = this.safeNumber(
            scope.scope_count,
            this.metadataHierarchyUnits(field).length,
        );
        return `${unitCount}개 자료 단위 · ${this.metadataReviewScopeDistinctCount(field)}개 고유값`;
    }

    public metadataReviewHierarchyMode(field: any) {
        return this.metadataReviewScopeMode === 'hierarchy'
            && this.xmlReviewScopeApplicable(field);
    }

    public async setMetadataReviewScopeMode(
        field: any,
        mode: 'representative' | 'hierarchy'
    ) {
        if (mode === 'hierarchy' && !this.xmlReviewScopeApplicable(field)) return;
        this.metadataReviewScopeMode = mode;
        this.xmlReviewSourceOpen = false;
        if (mode === 'hierarchy' && field) {
            const active = this.metadataHierarchyActiveUnit(field);
            if (active) {
                this.metadataHierarchyActiveUnitIds[`${field.id || ''}`] = `${active.id || ''}`;
            }
        }
        await this.renderPreservingViewport(
            `#${this.metadataReviewModeDomId(field, mode)}`
        );
    }

    private metadataReviewStableDomId(prefix: string, ...parts: any[]) {
        const source = parts.map((part: any) => `${part || ''}`).join('|');
        const readable = source.toLowerCase()
            .replace(/[^a-z0-9_-]+/g, '-')
            .replace(/^-+|-+$/g, '')
            .slice(0, 48) || 'item';
        let hash = 0;
        for (let index = 0; index < source.length; index += 1) {
            hash = ((hash << 5) - hash + source.charCodeAt(index)) | 0;
        }
        return `${prefix}-${readable}-${Math.abs(hash).toString(36)}`;
    }

    public metadataReviewModeDomId(field: any, mode: string) {
        return this.metadataReviewStableDomId(
            'metadata-review-mode', field?.id, mode
        );
    }

    public metadataHierarchyUnitDomId(field: any, unit: any) {
        return this.metadataReviewStableDomId(
            'metadata-hierarchy-unit', field?.id, unit?.id || unit?.path
        );
    }

    public metadataHierarchyCandidateDomId(field: any, candidate: any) {
        return this.metadataReviewStableDomId(
            'metadata-hierarchy-candidate',
            field?.id,
            this.metadataHierarchyCandidateId(candidate),
        );
    }

    public metadataHierarchySearchDomId(field: any) {
        return this.metadataReviewStableDomId(
            'metadata-hierarchy-search', field?.id
        );
    }

    public metadataReviewInputDomId(field: any, index: number) {
        if (index === 0) return `registration-field-${field?.id || 'value'}`;
        return this.metadataReviewStableDomId(
            'registration-field', field?.id, index
        );
    }

    public trackMetadataHierarchyUnit(index: number, unit: any) {
        return `${unit?.id || unit?.path || index}`;
    }

    public trackMetadataHierarchyCandidate(index: number, candidate: any) {
        return `${candidate?.id || candidate?.candidate_id || index}`;
    }

    public metadataHierarchyUnits(field: any) {
        const scope = this.xmlReviewScope(field);
        return Array.isArray(scope.units) ? scope.units : [];
    }

    public metadataHierarchyCandidates(field: any) {
        const scope = this.xmlReviewScope(field);
        const direct = Array.isArray(scope.candidates) ? scope.candidates : [];
        const nested = this.metadataHierarchyUnits(field).reduce(
            (rows: any[], unit: any) => (
                rows.concat(Array.isArray(unit?.candidates) ? unit.candidates : [])
            ),
            [],
        );
        const candidates = direct.length ? direct : nested;
        const seen = new Set<string>();
        return candidates.filter((candidate: any) => {
            const id = this.metadataHierarchyCandidateId(candidate);
            if (!id || seen.has(id)) return false;
            seen.add(id);
            return true;
        });
    }

    public metadataHierarchyCandidatesForUnit(unit: any) {
        return Array.isArray(unit?.candidates) ? unit.candidates : [];
    }

    public metadataHierarchyCandidateId(candidate: any) {
        return `${candidate?.id || candidate?.candidate_id || ''}`;
    }

    public metadataHierarchyCandidateValue(candidate: any) {
        return `${
            candidate?.display_value
            || candidate?.raw_value
            || candidate?.value
            || ''
        }`;
    }

    public metadataHierarchyCandidatePath(candidate: any) {
        return `${candidate?.source_path || candidate?.path || '경로 정보 없음'}`;
    }

    public metadataHierarchyUnitDepth(unit: any) {
        return Math.max(0, Math.min(6, this.safeNumber(unit?.depth, 0)));
    }

    public metadataHierarchyUnitBreadcrumb(unit: any) {
        if (unit?.breadcrumb_label) return `${unit.breadcrumb_label}`;
        const breadcrumb = Array.isArray(unit?.breadcrumb) ? unit.breadcrumb : [];
        const label = breadcrumb.map((row: any) => (
            `${row?.level || ''} ${row?.label || ''}`.trim()
        )).filter(Boolean).join(' > ');
        return label || `${unit?.path || unit?.id || '자료 단위'}`;
    }

    public metadataHierarchyUnitValues(unit: any) {
        const display = Array.isArray(unit?.display_values) ? unit.display_values : [];
        const values = display.length
            ? display
            : Array.isArray(unit?.values) ? unit.values : [];
        if (values.length) return values;
        return (Array.isArray(unit?.candidates) ? unit.candidates : [])
            .map((candidate: any) => this.metadataHierarchyCandidateValue(candidate))
            .filter(Boolean);
    }

    public metadataHierarchyUnitValueText(unit: any) {
        return this.xmlReviewValueText(this.metadataHierarchyUnitValues(unit));
    }

    public metadataHierarchyUnitPreservationLabel(unit: any) {
        if (`${unit?.conflict_state || ''}` === 'conflict') return '단위 내부 충돌';
        const labels: any = {
            auto_preserved: '자동 보존',
            preserved: '보존',
            modified: '수정됨',
            excluded: '제외',
        };
        return labels[`${unit?.preservation_status || ''}`] || '자료 단위값 보존';
    }

    public metadataHierarchyUnitConflictRoleLabel(unit: any) {
        const roles = Array.isArray(unit?.value_roles) ? unit.value_roles : [];
        return roles.filter(
            (role: any) => `${role?.conflict_state || ''}` === 'conflict'
        ).map((role: any) => {
            const name = `${role?.element_name || 'element'}${
                role?.attribute_name ? `@${role.attribute_name}` : ''
            }`;
            return `${name} ${this.safeNumber(role?.distinct_value_count, 0)}개 값`;
        }).join(' · ') || '같은 XML 역할에 서로 다른 값이 있습니다.';
    }

    public metadataHierarchyVisibleUnits(field: any) {
        const query = `${this.metadataHierarchySearch || ''}`.trim().toLowerCase();
        if (!query) return this.metadataHierarchyUnits(field);
        return this.metadataHierarchyUnits(field).filter((unit: any) => {
            const candidateText = (Array.isArray(unit?.candidates) ? unit.candidates : [])
                .map((candidate: any) => (
                    `${this.metadataHierarchyCandidateValue(candidate)} ${this.metadataHierarchyCandidatePath(candidate)}`
                )).join(' ');
            return [
                unit?.id,
                unit?.path,
                unit?.level,
                unit?.role,
                unit?.label,
                unit?.xml_id,
                this.metadataHierarchyUnitBreadcrumb(unit),
                this.metadataHierarchyUnitValueText(unit),
                candidateText,
            ].join(' ').toLowerCase().includes(query);
        });
    }

    public metadataHierarchyActiveUnit(field: any) {
        const visible = this.metadataHierarchyVisibleUnits(field);
        const selectedId = `${this.metadataHierarchyActiveUnitIds[`${field?.id || ''}`] || ''}`;
        return visible.find((unit: any) => `${unit?.id || ''}` === selectedId)
            || visible[0]
            || null;
    }

    public metadataHierarchyUnitActive(field: any, unit: any) {
        const active = this.metadataHierarchyActiveUnit(field);
        return !!unit && !!active && `${unit.id || ''}` === `${active.id || ''}`;
    }

    public async selectMetadataHierarchyUnit(field: any, unit: any) {
        if (!field || !unit) return;
        this.metadataHierarchyActiveUnitIds[`${field.id || ''}`] = `${unit.id || ''}`;
        this.xmlReviewSourceOpen = false;
        await this.renderPreservingViewport(
            `#${this.metadataHierarchyUnitDomId(field, unit)}`
        );
    }

    public metadataHierarchyUnitEvidence(field: any, unit: any) {
        if (!field || !unit) return [];
        if (Array.isArray(unit.evidence)) return unit.evidence;
        const candidates = Array.isArray(unit.candidates) ? unit.candidates : [];
        const paths = new Set(candidates.map(
            (candidate: any) => this.metadataHierarchyCandidatePath(candidate)
        ));
        return this.xmlReviewEvidence(field).filter((evidence: any) => (
            paths.has(`${evidence?.path || ''}`)
        ));
    }

    public metadataHierarchyCandidateSelected(field: any, candidate: any) {
        const id = this.metadataHierarchyCandidateId(candidate);
        return !!id && this.metadataReviewRepresentativeCandidateIds(field).includes(id);
    }

    private clearMetadataRepresentativeCandidates(field: any, source: string) {
        const scope = this.xmlReviewScope(field);
        if (!scope || !Object.keys(scope).length) return;
        scope.representative_candidate_ids = [];
        scope.representative_source = source;
        const sourceMap: any = {
            extracted: 'extracted',
            extracted_confirmed: 'extracted',
            original: 'original',
            original_confirmed: 'original',
        };
        scope.representative_sources = sourceMap[source]
            ? [sourceMap[source]] : [];
    }

    public async selectMetadataRepresentativeCandidate(field: any, candidate: any) {
        if (!field || !candidate) return;
        const scope = this.xmlReviewScope(field);
        const candidateId = this.metadataHierarchyCandidateId(candidate);
        if (!candidateId || !Object.keys(scope).length) return;
        let selected = this.metadataReviewRepresentativeCandidateIds(field);
        if (field.repeatable) {
            selected = selected.includes(candidateId)
                ? selected.filter((id: string) => id !== candidateId)
                : [...selected, candidateId];
        } else {
            selected = [candidateId];
        }
        const selectedIds = new Set(selected);
        const values: string[] = [];
        this.metadataHierarchyCandidates(field).forEach((row: any) => {
            if (!selectedIds.has(this.metadataHierarchyCandidateId(row))) return;
            const value = this.metadataHierarchyCandidateValue(row).trim();
            if (value && !values.includes(value)) values.push(value);
        });
        scope.representative_candidate_ids = selected;
        scope.representative_source = 'xml_candidate';
        scope.representative_sources = [];
        field.current_value = field.repeatable ? values : values.slice(0, 1);
        if (!field.current_value.length) field.current_value = [''];
        field.status = this.xmlReviewChanged(field) ? 'modified' : 'unreviewed';
        field.reviewed = false;
        this.syncXmlReviewFieldToForm(field);
        await this.renderPreservingViewport(
            `#${this.metadataHierarchyCandidateDomId(field, candidate)}`
        );
    }

    public xmlMetadataProfile() {
        const review = this.xmlFieldReview();
        return review.profile && typeof review.profile === 'object'
            ? review.profile : {};
    }

    public xmlProfileRelevant() {
        const review = this.xmlFieldReview();
        const profile = this.xmlMetadataProfile();
        const format = `${this.analysisInfo?.source?.format || this.analysisInfo?.source?.kind || ''}`.toLowerCase();
        return !!(
            profile.material_type === 'XML'
            || review.notice
            || format === 'xml'
        );
    }

    public xmlProfileApplicable() {
        return !!this.xmlMetadataProfile().applicable;
    }

    public xmlProfileLabel() {
        const profile = this.xmlMetadataProfile();
        return `${profile.label || profile.id || 'XML 메타정보 Profile'}`;
    }

    public xmlProfileIdentityLabel() {
        const profile = this.xmlMetadataProfile();
        const values = [
            `${profile.id || ''}`.trim(),
            `${profile.version || ''}`.trim(),
        ].filter(Boolean);
        return values.length ? values.join(' · ') : 'Profile 미적용';
    }

    public xmlProfileDtdLabel() {
        const profile = this.xmlMetadataProfile();
        const dtd = profile.dtd && typeof profile.dtd === 'object'
            ? profile.dtd : {};
        return `${dtd.basename || dtd.system_id || dtd.name || 'DTD 정보 없음'}`;
    }

    public xmlProfileNamespaceLabel() {
        const profile = this.xmlMetadataProfile();
        const namespaces = Array.isArray(profile.namespace_uris)
            ? profile.namespace_uris : [];
        return namespaces.length
            ? `${namespaces.length}개 namespace`
            : 'namespace 없음';
    }

    public xmlProfileNotice() {
        const review = this.xmlFieldReview();
        const notice = review.notice && typeof review.notice === 'object'
            ? review.notice : {};
        return `${notice.message || '적용 가능한 Profile을 찾지 못했습니다.'}`;
    }

    public xmlProfileDiagnostics() {
        const review = this.xmlFieldReview();
        const diagnostics = review.diagnostics && typeof review.diagnostics === 'object'
            ? review.diagnostics : {};
        return {
            profileFieldCount: this.safeNumber(
                diagnostics.profile_defined_field_count,
                this.xmlMetadataProfile().field_count || 0,
            ),
            matchedFieldCount: this.safeNumber(
                diagnostics.xml_matched_field_count,
                this.xmlReviewFields().filter((field: any) => (
                    Array.isArray(field?.evidence) && field.evidence.length > 0
                )).length,
            ),
            apiFieldCount: this.safeNumber(
                diagnostics.api_returned_field_count,
                this.xmlReviewFields().length,
            ),
            uiFieldCount: this.xmlReviewFields().length,
            requestId: `${diagnostics.request_id || this.analysisInfo?.request_id || ''}`,
            zeroStage: `${diagnostics.zero_stage || ''}`,
        };
    }

    public xmlReviewValueLabel(field: any, key: string) {
        const value = field && typeof field === 'object' ? field[key] : '';
        if (Array.isArray(value)) return value.length ? value.join(' · ') : '-';
        if (value && typeof value === 'object') {
            try {
                return JSON.stringify(value, null, 2);
            } catch (_) {
                return '-';
            }
        }
        return `${value || '-'}`;
    }

    public xmlReviewSourcePathLabel(field: any) {
        const paths = field && Array.isArray(field.source_paths) ? field.source_paths : [];
        if (!paths.length) return '매칭 경로 없음';
        return paths.length === 1 ? paths[0] : `${paths[0]} 외 ${paths.length - 1}개`;
    }

    public xmlReviewRevision() {
        return `${this.xmlFieldReview().revision || ''}`;
    }

    public xmlReviewHistoryCount() {
        return this.xmlReviewFields().reduce(
            (total: number, field: any) => (
                total + (Array.isArray(field?.history) ? field.history.length : 0)
            ),
            0,
        );
    }

    public xmlReviewFieldActive(field: any) {
        return !!field && `${field.id || ''}` === this.xmlReviewActiveFieldId;
    }

    public xmlReviewActiveField() {
        return this.xmlReviewFields().find(
            (field: any) => `${field.id || ''}` === this.xmlReviewActiveFieldId
        ) || null;
    }

    private async renderPreservingViewport(focusSelector: string = '') {
        const scrollX = typeof window !== 'undefined' ? window.scrollX : 0;
        const scrollY = typeof window !== 'undefined' ? window.scrollY : 0;
        await this.service.render();
        setTimeout(() => {
            if (typeof window === 'undefined') return;
            window.scrollTo(scrollX, scrollY);
            if (!focusSelector) return;
            const target = document.querySelector(focusSelector) as HTMLElement;
            if (target && typeof target.focus === 'function') {
                try {
                    target.focus({ preventScroll: true });
                } catch (_) {
                    target.focus();
                    window.scrollTo(scrollX, scrollY);
                }
            }
        }, 0);
    }

    public async selectXmlReviewField(field: any) {
        if (!field) return;
        this.xmlReviewActiveFieldId = `${field.id || ''}`;
        if (this.metadataV21FieldNames().includes(this.xmlReviewActiveFieldId)) {
            this.metadataV21FieldName = this.xmlReviewActiveFieldId;
        }
        await this.renderPreservingViewport(
            `#metadata-review-field-${this.xmlReviewActiveFieldId}`
        );
    }

    public async revealXmlReviewEvidence() {
        this.xmlReviewSourceOpen = true;
        await this.renderPreservingViewport();
        const revealHighlight = (attempt: number = 0) => {
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    const preview = document.querySelector(
                        '.metadata-source-preview'
                    ) as HTMLElement;
                    const mark = preview?.querySelector('mark') as HTMLElement;
                    if (!preview || !mark) {
                        if (attempt < 5) {
                            setTimeout(() => revealHighlight(attempt + 1), 40);
                        }
                        return;
                    }
                    const previewRect = preview.getBoundingClientRect();
                    const markRect = mark.getBoundingClientRect();
                    const targetTop = (
                        preview.scrollTop
                        + markRect.top
                        - previewRect.top
                        - Math.max(0, (preview.clientHeight - markRect.height) / 2)
                    );
                    preview.scrollTo({
                        top: Math.max(0, targetTop),
                        behavior: 'auto',
                    });
                });
            });
        };
        revealHighlight();
    }

    public xmlReviewSourceSegments() {
        const source = `${this.xmlFieldReview().source_excerpt || ''}`;
        if (!source) return [];
        const selected = this.xmlReviewFields().find(
            (field: any) => `${field.id || ''}` === this.xmlReviewActiveFieldId
        );
        if (!selected) return [{ text: source, highlight: false }];
        const activeUnit = this.metadataReviewHierarchyMode(selected)
            ? this.metadataHierarchyActiveUnit(selected) : null;
        const selectedEvidence = activeUnit
            ? this.metadataHierarchyUnitEvidence(selected, activeUnit)
            : this.xmlReviewEvidence(selected);
        const ranges = selectedEvidence.map((evidence: any) => ({
            start: Number(evidence.source_start),
            end: Number(evidence.source_end),
        })).filter((range: any) => (
            Number.isFinite(range.start)
            && Number.isFinite(range.end)
            && range.start >= 0
            && range.end > range.start
            && range.start < source.length
        )).map((range: any) => ({
            start: Math.max(0, range.start),
            end: Math.min(source.length, range.end),
        })).sort((first: any, second: any) => first.start - second.start);
        if (!ranges.length) {
            const fallbackValues = selectedEvidence
                .map((row: any) => `${row.value || ''}`)
                .filter(Boolean);
            fallbackValues.forEach((value: string) => {
                let start = source.indexOf(value);
                while (start >= 0) {
                    ranges.push({ start, end: start + value.length });
                    start = source.indexOf(value, start + value.length);
                }
            });
            ranges.sort((first: any, second: any) => first.start - second.start);
        }
        if (!ranges.length) return [{ text: source, highlight: false }];
        const merged: any[] = [];
        ranges.forEach((range: any) => {
            const previous = merged[merged.length - 1];
            if (previous && range.start <= previous.end) {
                previous.end = Math.max(previous.end, range.end);
            } else {
                merged.push({ ...range });
            }
        });
        const segments: any[] = [];
        let cursor = 0;
        merged.forEach((range: any) => {
            if (range.start > cursor) {
                segments.push({
                    text: source.slice(cursor, range.start),
                    highlight: false,
                });
            }
            segments.push({
                text: source.slice(range.start, range.end),
                highlight: true,
            });
            cursor = range.end;
        });
        if (cursor < source.length) {
            segments.push({ text: source.slice(cursor), highlight: false });
        }
        return segments;
    }

    public xmlReviewHighlightedSource() {
        const escape = (value: any) => `${value || ''}`
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
        return this.xmlReviewSourceSegments().map((segment: any) => (
            segment.highlight
                ? `<mark>${escape(segment.text)}</mark>`
                : escape(segment.text)
        )).join('');
    }

    public xmlReviewWorkflow() {
        const review = this.xmlFieldReview();
        return Array.isArray(review.workflow) ? review.workflow : [];
    }

    public xmlReviewSummary() {
        const review = this.xmlFieldReview();
        return review.summary && typeof review.summary === 'object'
            ? review.summary : {
                total: this.xmlReviewFields().length,
                completed: 0,
                pending: this.xmlReviewFields().length,
                conflicts: 0,
                no_evidence: 0,
                complete: false,
            };
    }

    private xmlReviewComplete(review: any) {
        const fields = review && Array.isArray(review.fields) ? review.fields : [];
        return fields.length === 0 || fields.every(
            (field: any) => this.metadataReviewFieldComplete(field)
        );
    }

    public xmlReviewPendingCount() {
        return this.xmlReviewFields().filter(
            (field: any) => !this.metadataReviewFieldComplete(field)
        ).length;
    }

    public xmlReviewBatchPendingCount() {
        return this.metadataReviewAdvanceItems().reduce((total: number, item: any) => {
            if (!item || item.status !== 'complete' || !item.form) return total;
            const form = this.metadataReviewFormForItem(item);
            const review = form?.xml_field_review;
            const fields = review && Array.isArray(review.fields) ? review.fields : [];
            return total + fields.filter(
                (field: any) => !this.metadataReviewFieldComplete(field)
            ).length;
        }, 0);
    }

    public xmlReviewStatusLabel(field: any) {
        if (this.metadataReviewScopeTruncated(field) && !field?.reviewed) {
            return '원문 후보 일부 표시';
        }
        if (this.metadataReviewSameScopeConflictCount(field) > 0 && !field?.reviewed) {
            return '자료 단위 내부 충돌';
        }
        if (this.metadataReviewHierarchyNeedsDecision(field)) return '대표값 선택 필요';
        const labels: any = {
            unreviewed: '미검수',
            confirmed: '확인 완료',
            modified: '수정됨',
            conflict: '충돌',
            no_evidence: '원문에 없음',
            source_absent: '원문에 없음',
            extraction_failed: '추출 실패',
            extraction_error: '추출 오류',
            not_run: '미실행',
            auto_match: '자동 일치',
            needs_review: '확인 필요',
            deferred: '보류',
            excluded: '검수 제외',
            not_applicable: '미적용',
        };
        if (
            field && ['confirmed', 'modified'].includes(`${field.status || ''}`)
            && !field.reviewed
        ) {
            return field.status === 'modified' ? '수정 후 확인 필요' : '확인 필요';
        }
        return labels[`${field && field.status ? field.status : 'unreviewed'}`] || '미검수';
    }

    public xmlReviewStatusClass(field: any) {
        if (this.metadataReviewScopeTruncated(field) && !field?.reviewed) {
            return 'is-needs_review';
        }
        if (this.metadataReviewSameScopeConflictCount(field) > 0 && !field?.reviewed) {
            return 'is-conflict';
        }
        if (this.metadataReviewHierarchyNeedsDecision(field)) return 'is-conflict';
        if (
            field && ['confirmed', 'modified'].includes(`${field.status || ''}`)
            && !field.reviewed
        ) return 'is-unreviewed';
        return `is-${field && field.status ? field.status : 'unreviewed'}`;
    }

    public xmlReviewConflictLabel(field: any) {
        if (this.metadataReviewSameScopeConflictCount(field) > 0 && !field?.reviewed) {
            return '자료 단위 내부 충돌';
        }
        if (this.metadataReviewHierarchyNeedsDecision(field)) return '계층별 대표값 선택 필요';
        if (!field || field.conflict_state === 'none') return '충돌 없음';
        if (field.conflict_state === 'no_evidence') return 'XML 근거 없음';
        return '추출값·원문 충돌';
    }

    public xmlReviewValues(field: any, key: string = 'current_value') {
        const value = field && Array.isArray(field[key]) ? field[key] : [];
        return value.length ? value : [''];
    }

    public trackReviewValueIndex(index: number, _value: any) {
        return index;
    }

    public xmlReviewValueText(value: any) {
        const rows = Array.isArray(value) ? value : [value];
        return rows.map((row: any) => `${row || ''}`.trim()).filter(Boolean).join(' · ') || '값 없음';
    }

    public metadataReviewValueExpandable(value: any) {
        const text = this.xmlReviewValueText(value);
        return text !== '값 없음' && (
            text.length > 120
            || text.split(/\r?\n/).length > 3
        );
    }

    public async openMetadataValueModal(
        field: any,
        valueType: 'extracted' | 'original'
    ) {
        if (!field) return;
        const isOriginal = valueType === 'original';
        const value = isOriginal
            ? (field.original_display_value || field.original_value)
            : field.extracted_value;
        this.metadataValueModalFieldLabel = `${field.label || '메타데이터'}`;
        this.metadataValueModalValueLabel = isOriginal
            ? (this.metadataReviewUsesXml() ? 'XML 원문값' : '원본 근거값')
            : '자동 추출값';
        this.metadataValueModalValue = this.xmlReviewValueText(value);
        this.metadataValueModalContext = isOriginal
            ? this.xmlReviewSourcePathLabel(field)
            : `추출 방법 · ${field.extraction_method || '자동 추출'}`;
        this.metadataValueModalOpen = true;
        await this.service.render();
        setTimeout(() => {
            const closeButton = document.querySelector(
                '.metadata-value-modal-close'
            ) as HTMLElement;
            if (closeButton && typeof closeButton.focus === 'function') {
                closeButton.focus({ preventScroll: true });
            }
        }, 0);
    }

    public async closeMetadataValueModal() {
        this.metadataValueModalOpen = false;
        await this.service.render();
    }

    public xmlReviewEvidence(field: any) {
        return field && Array.isArray(field.evidence) ? field.evidence : [];
    }

    public xmlReviewHistory(field: any) {
        const rows = field && Array.isArray(field.history) ? field.history : [];
        return [...rows].reverse();
    }

    public metadataReviewHistoryActionLabel(action: any) {
        const labels: any = {
            value_changed: '대표값 변경',
            representative_scope_changed: '대표 자료 단위 변경',
            value_and_representative_scope_changed: '값·대표 자료 단위 변경',
            review_confirmed: '검수 완료',
            review_reopened: '검수 다시 열기',
            review_status_changed: '검수 상태 변경',
        };
        return labels[`${action || ''}`] || '검수 변경';
    }

    public metadataReviewHistoryScopeChanged(history: any) {
        return [
            'representative_scope_changed',
            'value_and_representative_scope_changed',
        ].includes(`${history?.action || ''}`);
    }

    public metadataReviewHistoryCandidateIdsText(value: any) {
        const ids = Array.isArray(value)
            ? value.map((id: any) => `${id || ''}`.trim()).filter(Boolean)
            : [];
        if (!ids.length) return '선택 없음';
        const shown = ids.slice(0, 5).join(', ');
        return ids.length > 5 ? `${shown} 외 ${ids.length - 5}개` : shown;
    }

    public xmlReviewChanged(field: any) {
        const current = this.xmlReviewValues(field).map((row: any) => `${row || ''}`.trim()).filter(Boolean);
        const extracted = this.xmlReviewValues(field, 'extracted_value')
            .map((row: any) => `${row || ''}`.trim()).filter(Boolean);
        return JSON.stringify(current) !== JSON.stringify(extracted);
    }

    public metadataReviewVisibleFields() {
        const fields = this.xmlReviewFields();
        if (this.metadataReviewFilter === 'all') return fields;
        if (this.metadataReviewFilter === 'primary') {
            return fields.filter(
                (field: any) => this.metadataReviewFieldPrimary(field)
            );
        }
        return fields.filter((field: any) => !this.metadataReviewFieldComplete(field));
    }

    private initialiseMetadataReviewFocus() {
        const fields = this.xmlReviewFields();
        const attention = fields.find(
            (field: any) => !this.metadataReviewFieldComplete(field)
        );
        this.metadataReviewFilter = attention ? 'attention' : 'all';
        this.xmlReviewActiveFieldId = `${attention?.id || fields[0]?.id || ''}`;
    }

    public metadataReviewFieldComplete(field: any) {
        if (!field || !field.reviewed || !this.metadataReviewHierarchyResolved(field)) {
            return false;
        }
        const status = `${field.status || ''}`;
        if (status === 'auto_match') {
            return `${field.conflict_state || 'none'}` === 'none'
                && this.metadataReviewSameScopeConflictCount(field) === 0
                && !this.metadataReviewScopeTruncated(field)
                && !this.xmlReviewChanged(field);
        }
        return ['confirmed', 'modified', 'deferred', 'excluded', 'not_applicable']
            .includes(status);
    }

    public metadataReviewCompletedCount() {
        return this.xmlReviewFields().filter(
            (field: any) => this.metadataReviewFieldComplete(field)
        ).length;
    }

    public metadataReviewProgressPercent() {
        const total = this.xmlReviewFields().length;
        if (!total) return 0;
        return Math.round((this.metadataReviewCompletedCount() / total) * 100);
    }

    public metadataReviewCompletedFileCount() {
        return this.batchItems.filter(
            (item: any) => this.metadataReviewFileComplete(item)
        ).length;
    }

    public metadataReviewFileProgressPercent() {
        if (!this.batchItems.length) return 0;
        return Math.round(
            (this.metadataReviewCompletedFileCount() / this.batchItems.length)
            * 100
        );
    }

    public metadataReviewValueSelected(
        field: any, source: 'extracted' | 'original'
    ) {
        if (!field) return false;
        const selectedSources = this.metadataReviewValueSources(field);
        if (selectedSources.length) return selectedSources.includes(source);
        const representativeSource = `${this.xmlReviewScope(field).representative_source || ''}`;
        const explicitSource: any = {
            extracted: 'extracted',
            extracted_confirmed: 'extracted',
            original: 'original',
            original_confirmed: 'original',
        };
        if (explicitSource[representativeSource]) {
            return explicitSource[representativeSource] === source;
        }
        if ([
            'manual', 'xml_candidate', 'metadata_v2_1',
        ].includes(representativeSource)) return false;
        const sourceKey = source === 'original'
            ? (
                Array.isArray(field.original_display_value)
                    ? 'original_display_value'
                    : 'original_value'
            )
            : 'extracted_value';
        const normalise = (values: any[]) => values
            .map((value: any) => `${value || ''}`.trim())
            .filter(Boolean);
        return JSON.stringify(normalise(this.xmlReviewValues(field)))
            === JSON.stringify(
                normalise(this.xmlReviewValues(field, sourceKey))
            );
    }

    public metadataReviewValueSources(field: any) {
        const scope = this.xmlReviewScope(field);
        const supported = ['extracted', 'original'];
        const explicitSource: any = {
            extracted_confirmed: 'extracted',
            original_confirmed: 'original',
        };
        const source = `${scope.representative_source || ''}`;
        if (explicitSource[source]) return [explicitSource[source]];
        const stored = Array.isArray(scope.representative_sources)
            ? scope.representative_sources.map(
                (source: any) => `${source || ''}`
            ).filter((source: string) => supported.includes(source))
            : [];
        if (stored.length) return Array.from(new Set(stored));
        const sourceMap: any = {
            extracted: 'extracted',
            extracted_confirmed: 'extracted',
            original: 'original',
            original_confirmed: 'original',
        };
        const legacy = sourceMap[source];
        return legacy ? [legacy] : [];
    }

    public metadataReviewValueSelectionLabel(
        field: any, source: 'extracted' | 'original'
    ) {
        const selected = this.metadataReviewValueSources(field);
        if (selected.includes(source)) {
            return selected.length > 1
                ? '선택됨 · 다시 누르면 제외' : '선택됨';
        }
        return selected.length ? '최종값에 추가' : '이 값을 최종값으로 선택';
    }

    public metadataReviewFileComplete(item: any) {
        if (!item || !['complete', 'saved'].includes(`${item.status || ''}`) || !item.form) return false;
        const form = this.batchItems[this.activeBatchIndex] === item && this.data
            ? this.data : item.form;
        const xmlReview = form && form.xml_field_review;
        const commonReview = form && form.common_metadata_review;
        const review = (
            xmlReview
            && Array.isArray(xmlReview.fields)
            && xmlReview.fields.length
        ) ? xmlReview : commonReview;
        const fields = review && Array.isArray(review.fields) ? review.fields : [];
        return fields.length > 0 && fields.every(
            (field: any) => this.metadataReviewFieldComplete(field)
        );
    }

    public metadataReviewAttentionCount() {
        return this.xmlReviewFields().filter(
            (field: any) => !this.metadataReviewFieldComplete(field)
        ).length;
    }

    public metadataReviewModifiedCount() {
        return this.xmlReviewFields().filter(
            (field: any) => field.status === 'modified'
        ).length;
    }

    public metadataReviewFieldRequired(field: any) {
        if (!field) return false;
        const requirement = `${field?.review_policy?.requirement || ''}`;
        if (requirement) return requirement === 'required';
        return ['title', 'category'].includes(`${field.id || ''}`);
    }

    private metadataReviewFieldRegistrationRequired(field: any) {
        return ['title', 'category'].includes(`${field?.id || ''}`);
    }

    public metadataReviewBlockingFields(form: any = this.data) {
        const review = form && form.xml_field_review
            && Array.isArray(form.xml_field_review.fields)
            && form.xml_field_review.fields.length
            ? form.xml_field_review : form?.common_metadata_review;
        const fields = review && Array.isArray(review.fields) ? review.fields : [];
        return fields.filter((field: any) => {
            const values = Array.isArray(field.current_value)
                ? field.current_value.map((row: any) => `${row || ''}`.trim()).filter(Boolean)
                : [];
            if (this.metadataReviewFieldRequired(field)) {
                return !this.metadataReviewFieldComplete(field)
                    || (
                        this.metadataReviewFieldRegistrationRequired(field)
                        && !values.length
                    );
            }
            return field.conflict_state === 'conflict'
                && !this.metadataReviewFieldComplete(field);
        });
    }

    public metadataReviewSectionReady(form: any = this.data) {
        return this.metadataReviewBlockingFields(form).length === 0;
    }

    public metadataReviewBatchBlockingCount() {
        return this.metadataReviewAdvanceItems().reduce((total: number, item: any) => (
            total + (
                item?.status === 'complete' && item.form ? (() => {
                    const form = this.metadataReviewFormForItem(item);
                    return this.metadataReviewBlockingFields(form).length;
                })() : 0
            )
        ), 0);
    }

    public async setMetadataReviewFilter(filter: 'all' | 'primary' | 'attention') {
        this.metadataReviewFilter = filter;
        const visible = this.metadataReviewVisibleFields();
        if (visible.length && !visible.some((row: any) => this.xmlReviewFieldActive(row))) {
            this.xmlReviewActiveFieldId = visible[0].id;
        }
        await this.renderPreservingViewport();
    }

    public currentMetadataBulkApprovalFields() {
        return this.xmlReviewFields().filter(
            (field: any) => !this.metadataReviewFieldComplete(field)
        );
    }

    public currentMetadataBulkApprovalCount() {
        return this.currentMetadataBulkApprovalFields().length;
    }

    public currentMetadataBulkApprovalFileName() {
        return this.reviewFileName(this.activeBatchItem()) || '현재 파일';
    }

    private nextMetadataReviewFileIndex(currentIndex: number = this.activeBatchIndex) {
        const rows = this.metadataReviewTargetItems();
        const position = rows.findIndex((row: any) => row.index === currentIndex);
        return position >= 0 && position + 1 < rows.length
            ? rows[position + 1].index : -1;
    }

    public async approveCurrentFileMetadataFields() {
        const pending = this.currentMetadataBulkApprovalFields();
        if (!pending.length) return;
        const nextFileIndex = this.nextMetadataReviewFileIndex();
        let approved = 0;
        let blocked = 0;
        let notApplicable = 0;
        pending.forEach((field: any) => {
            const hasValue = this.xmlReviewValues(field).some(
                (value: any) => `${value || ''}`.trim()
            );
            const hardRequired = this.metadataReviewFieldRegistrationRequired(field);
            if (hardRequired && !hasValue) {
                blocked += 1;
                return;
            }
            field.status = !hasValue
                ? 'not_applicable'
                : this.xmlReviewChanged(field) ? 'modified' : 'confirmed';
            field.reviewed = true;
            this.syncXmlReviewFieldToForm(field);
            if (!hasValue) notApplicable += 1;
            approved += 1;
        });
        const item = this.activeBatchItem();
        if (item) {
            item.metadataReviewPaused = false;
            item.metadataReviewState = this.metadataReviewFileComplete(item)
                ? 'ready' : 'draft';
        }
        this.metadataDraftNotice = blocked
            ? `${this.currentMetadataBulkApprovalFileName()} 공통 필드 ${approved}개를 승인했습니다. 값이 없는 필수 필드 ${blocked}개는 직접 입력해주세요.`
            : `${this.currentMetadataBulkApprovalFileName()} 공통 필드 ${approved}개를 일괄 승인했습니다.${
                notApplicable ? ` 원문에 값이 없는 ${notApplicable}개는 ‘해당 없음’으로 처리했습니다.` : ''
            }`;
        this.queueRegistrationRecoverySave();
        const next = this.xmlReviewFields().find(
            (field: any) => !this.metadataReviewFieldComplete(field)
        );
        if (next) this.xmlReviewActiveFieldId = next.id;
        if (
            item
            && this.metadataReviewFileComplete(item)
            && nextFileIndex >= 0
        ) {
            await this.selectBatchItem(nextFileIndex);
            return;
        }
        await this.renderPreservingViewport();
    }

    public async setMetadataReviewDecision(
        field: any, status: 'deferred' | 'excluded' | 'not_applicable'
    ) {
        if (!field) return;
        if (status !== 'not_applicable' && !`${field.reason || ''}`.trim()) {
            await this.service.modal.error(`${field.label || '필드'} 처리 사유를 입력해주세요.`);
            return;
        }
        field.status = status;
        field.reviewed = true;
        this.queueRegistrationRecoverySave();
        await this.renderPreservingViewport();
    }

    public metadataReviewStatusReason(field: any) {
        if (!field) return '';
        if (this.metadataReviewScopeTruncated(field) && !field.reviewed) {
            return `전체 ${this.metadataReviewScopeCandidateCount(field)}개 후보 중 ${this.metadataReviewScopeReturnedCandidateCount(field)}개만 표시되었습니다.`;
        }
        if (this.metadataReviewSameScopeConflictCount(field) > 0 && !field.reviewed) {
            return `같은 자료 단위와 같은 XML 역할에서 서로 다른 값이 ${this.metadataReviewSameScopeConflictCount(field)}건 발견되었습니다.`;
        }
        if (this.metadataReviewHierarchyNeedsDecision(field)) {
            return `${this.metadataReviewScopeSummaryText(field)} 중 대표 메타데이터로 사용할 값을 확인해주세요.`;
        }
        if (field.status === 'confirmed' && field.reviewed) return '현재 값을 최종 등록값으로 확정했습니다.';
        if (field.status === 'modified' && field.reviewed) return '수정한 값을 사유와 함께 확정했습니다.';
        if (field.status === 'deferred' && field.reviewed) return '추가 확인을 위해 보류했습니다.';
        if (field.status === 'excluded' && field.reviewed) return '사유를 기록하고 검수 대상에서 제외했습니다.';
        if (field.status === 'not_applicable' && field.reviewed) return '현재 Profile에 적용되지 않는 항목입니다.';
        if (field.status === 'not_run') return '분석이 실행되지 않았습니다.';
        if (field.status === 'source_absent' || field.status === 'no_evidence') return '원본에서 대응 근거를 찾지 못했습니다.';
        if (field.status === 'extraction_failed') return '근거는 있으나 값을 만들지 못했습니다.';
        if (field.status === 'extraction_error') return '추출 중 오류가 발생했습니다.';
        if (field.status === 'needs_review') return '신뢰도가 낮거나 규칙 검수가 필요합니다.';
        if (field.conflict_state === 'conflict') return '추출값과 원문값이 달라 선택이 필요합니다.';
        if (field.status === 'auto_match') return '추출값과 원문 근거가 자동으로 일치했습니다.';
        return field.reason || '사용자 확인을 기다리고 있습니다.';
    }

    public dtdCoverage() {
        const review = this.data?.xml_field_review || {};
        return review.dtd_coverage && typeof review.dtd_coverage === 'object'
            ? review.dtd_coverage : {};
    }

    public batchItemDtdCoverage(item: any) {
        const form = item === this.activeBatchItem() && this.data
            ? this.data : (item && item.form ? item.form : {});
        const formReview = form && form.xml_field_review
            && typeof form.xml_field_review === 'object'
            ? form.xml_field_review : {};
        const analysisReview = item && item.analysis
            && item.analysis.xml_field_review
            && typeof item.analysis.xml_field_review === 'object'
            ? item.analysis.xml_field_review : {};
        const coverage = formReview.dtd_coverage || analysisReview.dtd_coverage;
        return coverage && typeof coverage === 'object' ? coverage : {};
    }

    public batchItemDtdCoverageLabel(item: any) {
        const coverage = this.batchItemDtdCoverage(item);
        if (coverage.applicable === false) return 'DTD 적용 대상 아님';
        if (!Object.keys(coverage).length) return 'DTD 결과 확인 중';
        const issueCount = this.safeNumber(coverage.unmapped_element_count, 0)
            + this.safeNumber(coverage.unmapped_attribute_count, 0)
            + this.safeNumber(coverage.error_count, 0);
        if (issueCount > 0) return `확인 필요 ${issueCount}건`;
        return `${this.safeNumber(coverage.found_element_count, 0)}개 발견 · 정상`;
    }

    public dtdCoverageGroups() {
        const groups = this.dtdCoverage().groups;
        if (Array.isArray(groups) && groups.length) return groups;
        const grouped = new Map<string, any>();
        this.dtdReviewFields().forEach((field: any) => {
            const groupId = `${field?.group_id || ''}`;
            if (!groupId) return;
            if (!grouped.has(groupId)) {
                grouped.set(groupId, {
                    id: groupId,
                    label: field.group_label || groupId,
                    defined_element_count: 0,
                    defined_attribute_count: 0,
                    found_element_count: 0,
                    found_attribute_count: 0,
                    attention_count: 0,
                    error_count: 0,
                });
            }
            const group = grouped.get(groupId);
            const kind = `${field?.kind || ''}` === 'attribute'
                || `${field?.id || ''}`.startsWith('attribute:')
                ? 'attribute' : 'element';
            group[`defined_${kind}_count`] += 1;
            if (field?.found) group[`found_${kind}_count`] += 1;
            if (field?.error) group.error_count += 1;
            else if (this.dtdReviewFieldNeedsHumanReview(field)) {
                group.attention_count += 1;
            }
        });
        return Array.from(grouped.values());
    }

    public dtdCoverageCount(key: string) {
        return this.safeNumber(this.dtdCoverage()[key], 0);
    }

    public dtdCoverageDeclaredTotal() {
        return this.dtdCoverageCount('declared_element_count')
            + this.dtdCoverageCount('declared_attribute_count');
    }

    public dtdCoverageUnmappedCount() {
        return this.dtdCoverageCount('unmapped_element_count')
            + this.dtdCoverageCount('unmapped_attribute_count');
    }

    public dtdCoverageIssueCount() {
        return this.dtdCoverageUnmappedCount()
            + this.dtdCoverageCount('error_count');
    }

    public dtdCoverageGroupMetric(group: any, metric: 'defined' | 'found') {
        if (!group) return 0;
        return this.safeNumber(group[`${metric}_element_count`], 0)
            + this.safeNumber(group[`${metric}_attribute_count`], 0);
    }

    public dtdCoverageGroupState(group: any): 'normal' | 'attention' | 'error' {
        if (this.safeNumber(group?.error_count, 0) > 0) return 'error';
        if (
            this.safeNumber(group?.attention_count, 0) > 0
            || this.safeNumber(group?.unsupported_count, 0) > 0
        ) return 'attention';
        return 'normal';
    }

    public dtdCoverageGroupStatusLabel(group: any) {
        const state = this.dtdCoverageGroupState(group);
        if (state === 'error') {
            return `오류 ${this.safeNumber(group?.error_count, 0)}`;
        }
        if (state === 'attention') {
            return `확인 ${Math.max(
                this.safeNumber(group?.attention_count, 0),
                this.safeNumber(group?.unsupported_count, 0),
            )}`;
        }
        return '정상';
    }

    public dtdCoverageHealthyGroupCount() {
        return this.dtdCoverageGroups().filter(
            (group: any) => this.dtdCoverageGroupState(group) === 'normal'
        ).length;
    }

    public dtdCoverageSelectedGroup() {
        const groups = this.dtdCoverageGroups();
        return groups.find(
            (group: any) => `${group?.id || ''}` === this.dtdCoverageActiveGroup
        ) || groups[0] || null;
    }

    public dtdCoverageGroupActive(group: any) {
        const selected = this.dtdCoverageSelectedGroup();
        return !!group && !!selected
            && `${selected.id || ''}` === `${group.id || ''}`;
    }

    public async toggleDtdCoverageGroup(group: any) {
        if (!group) return;
        this.dtdCoverageActiveGroup = `${group.id || ''}`;
        const first = this.dtdReviewFieldsForGroup(group)[0] || null;
        if (first) this.dtdReviewActiveFieldId = `${first.id || ''}`;
        await this.renderPreservingViewport();
    }

    public dtdCoverageItemFound(item: any) {
        return this.safeNumber(item?.repeat_count, 0) > 0
            && `${item?.status || ''}` !== 'source_absent';
    }

    public dtdCoverageItemCount(item: any) {
        return this.safeNumber(item?.repeat_count, 0);
    }

    public dtdCoverageItemAttributeCount(item: any) {
        return Array.isArray(item?.attributes) ? item.attributes.length : 0;
    }

    public dtdCoverageItemStatusLabel(item: any) {
        if (!this.dtdCoverageItemFound(item)) return '원문에 없음';
        if (`${item?.status || ''}` === 'extracted') return '발견';
        return '보존';
    }

    public dtdReviewFields(form: any = this.data) {
        const review = form?.xml_field_review;
        return review && Array.isArray(review.dtd_fields)
            ? review.dtd_fields : [];
    }

    public dtdReviewFieldStructureOnly(field: any) {
        if (!field || !field.found) return false;
        const automatic = field.automatic_review || {};
        if (`${automatic.reason_code || ''}` === 'structure_only') return true;
        if (
            field.error
            || field.evidence_truncated
            || field.values_truncated
            || ['extraction_error', 'extraction_failed', 'not_run']
                .includes(`${field.status || ''}`)
        ) return false;
        const hasValue = (value: any) => (Array.isArray(value) ? value : [value])
            .some((row: any) => `${row || ''}`.trim());
        const evidenceHasValue = (Array.isArray(field.evidence) ? field.evidence : [])
            .some((row: any) => `${row?.value || row?.raw_value || ''}`.trim());
        return !hasValue(field.extracted_value)
            && !hasValue(field.original_value)
            && !evidenceHasValue;
    }

    public dtdReviewFieldNeedsHumanReview(field: any) {
        if (field?.human_review_required === false) return false;
        return !!field?.found
            && !this.dtdReviewFieldStructureOnly(field)
            && !this.dtdReviewFieldComplete(field);
    }

    public dtdReviewActionableFields(form: any = this.data) {
        return this.dtdReviewFields(form).filter(
            (field: any) => this.dtdReviewFieldNeedsHumanReview(field)
        );
    }

    public savedReviewDtdFields(form: any = this.data) {
        return this.dtdReviewFields(form).filter(
            (field: any) => !!field?.found && !this.dtdReviewFieldStructureOnly(field)
        );
    }

    public savedReviewDtdGroups() {
        const groups = this.dtdCoverageGroups();
        if (this.savedDtdShowAllGroups) return groups;
        return groups.filter(
            (group: any) => this.dtdCoverageGroupMetric(group, 'found') > 0
        );
    }

    public savedReviewDtdPendingCount(group: any = null) {
        const groupId = `${group?.id || ''}`;
        return this.savedReviewDtdFields().filter((field: any) => (
            (!groupId || `${field?.group_id || ''}` === groupId)
            && !this.dtdReviewFieldComplete(field)
        )).length;
    }

    public savedReviewDtdGroupStatusLabel(group: any) {
        const errors = this.safeNumber(group?.error_count, 0);
        if (errors > 0) return `오류 ${errors}`;
        const pending = this.savedReviewDtdPendingCount(group);
        if (pending > 0) return `확인 필요 ${pending}`;
        if (this.dtdCoverageGroupMetric(group, 'found') <= 0) return '원문에 없음';
        return '이상 없음';
    }

    public savedReviewDtdGroupStatusClass(group: any) {
        if (this.safeNumber(group?.error_count, 0) > 0) return 'is-error';
        if (this.savedReviewDtdPendingCount(group) > 0) return 'is-attention';
        if (this.dtdCoverageGroupMetric(group, 'found') <= 0) return 'is-empty';
        return 'is-complete';
    }

    public savedReviewDtdAllStatusLabel() {
        const pending = this.savedReviewDtdPendingCount();
        return pending > 0 ? `확인 필요 ${pending}` : '이상 없음';
    }

    public savedReviewDtdGroupFilterActive(groupId: string) {
        return `${this.savedDtdGroupFilter || 'all'}` === `${groupId || 'all'}`;
    }

    public savedReviewFilteredDtdFields() {
        const fields = this.savedReviewDtdFields();
        if (this.savedDtdGroupFilter === 'all') return fields;
        return fields.filter(
            (field: any) => `${field?.group_id || ''}` === this.savedDtdGroupFilter
        );
    }

    public async selectSavedDtdGroupFilter(groupId: string) {
        const target = `${groupId || 'all'}`;
        const known = target === 'all' || this.dtdCoverageGroups().some(
            (group: any) => `${group?.id || ''}` === target
        );
        if (!known) return;
        this.savedDtdGroupFilter = target;
        const first = this.savedReviewFilteredDtdFields()[0] || null;
        this.dtdReviewActiveFieldId = `${first?.id || ''}`;
        await this.renderPreservingViewport();
    }

    public async toggleSavedDtdGroupVisibility() {
        this.savedDtdShowAllGroups = !this.savedDtdShowAllGroups;
        if (
            !this.savedDtdShowAllGroups
            && this.savedDtdGroupFilter !== 'all'
            && !this.savedReviewDtdGroups().some(
                (group: any) => `${group?.id || ''}` === this.savedDtdGroupFilter
            )
        ) {
            this.savedDtdGroupFilter = 'all';
        }
        const first = this.savedReviewFilteredDtdFields()[0] || null;
        if (first) this.dtdReviewActiveFieldId = `${first.id || ''}`;
        await this.renderPreservingViewport();
    }

    public savedReviewDtdActiveField() {
        const fields = this.savedReviewFilteredDtdFields();
        return fields.find(
            (field: any) => `${field?.id || ''}` === this.dtdReviewActiveFieldId
        ) || fields[0] || null;
    }

    public dtdReviewSummary() {
        const review = this.data?.xml_field_review || {};
        const summary = review.dtd_summary;
        const fields = this.dtdReviewFields();
        if (!fields.length && summary && typeof summary === 'object') return summary;
        const found = fields.filter((field: any) => !!field.found);
        const completed = found.filter(
            (field: any) => this.dtdReviewFieldComplete(field)
        ).length;
        return {
            ...(summary && typeof summary === 'object' ? summary : {}),
            total: fields.length,
            found: found.length,
            found_completed: completed,
            found_pending: Math.max(0, found.length - completed),
            search_indexed: fields.filter(
                (field: any) => !!field?.search_index?.enabled
            ).length,
            complete: found.length === completed,
        };
    }

    public dtdReviewAutoConfirmableCount() {
        return this.dtdReviewAutoConfirmableFields().length;
    }

    public dtdReviewFieldAutoConfirmable(field: any) {
        if (!field || !field.found) return false;
        const automatic = field.automatic_review;
        if (!automatic || typeof automatic !== 'object') return false;
        if (automatic.server_owned !== true) return false;
        if (automatic.eligible !== true) return false;
        if (automatic.decision !== 'auto_match') return false;
        if (automatic.reason_code !== 'normalized_match') return false;
        if (field.evidence_truncated || field.values_truncated || field.error) return false;
        if ([
            'needs_review',
            'attention_required',
            'conflict',
            'extraction_error',
            'extraction_failed',
            'not_run',
        ].includes(`${field.status || ''}`)) return false;
        return !this.dtdReviewFieldComplete(field)
            && !this.dtdReviewChanged(field)
            && !this.dtdReviewSearchChanged(field);
    }

    private dtdReviewAutoConfirmableFields(form: any = this.data) {
        return this.dtdReviewFields(form).filter(
            (field: any) => this.dtdReviewFieldAutoConfirmable(field)
        );
    }

    public dtdReviewBatchAutoConfirmableCount() {
        return this.metadataReviewTargetItems().reduce(
            (total: number, row: any) => total + this.dtdReviewAutoConfirmableFields(
                this.metadataReviewFormForItem(row.item)
            ).length,
            0,
        );
    }

    public dtdReviewFieldComplete(field: any) {
        if (this.dtdReviewFieldStructureOnly(field)) return true;
        return !!field
            && ['auto_match', 'confirmed', 'modified', 'deferred', 'excluded', 'not_applicable']
                .includes(`${field.status || ''}`)
            && !!field.reviewed;
    }

    public dtdReviewPendingCount(form: any = this.data) {
        return this.dtdReviewActionableFields(form).length;
    }

    public dtdReviewBatchPendingCount() {
        return this.metadataReviewTargetItems().reduce((total: number, row: any) => {
            const form = this.metadataReviewFormForItem(row.item);
            return total + this.dtdReviewPendingCount(form);
        }, 0);
    }

    public currentDtdBulkApprovalFileName() {
        return this.reviewFileName(this.activeBatchItem()) || '현재 파일';
    }

    private approveDtdReviewExceptions(form: any, reason: string) {
        const fields = this.dtdReviewActionableFields(form);
        fields.forEach((field: any) => {
            if (
                (this.dtdReviewChanged(field) || this.dtdReviewSearchChanged(field))
                && !`${field.reason || ''}`.trim()
            ) {
                field.reason = reason;
            }
            field.status = this.dtdReviewChanged(field) ? 'modified' : 'confirmed';
            field.reviewed = true;
            field.human_review_required = false;
        });
        return fields.length;
    }

    public async approveCurrentFileDtdExceptions() {
        const pending = this.dtdReviewPendingCount();
        if (!pending) return;
        const fileName = this.currentDtdBulkApprovalFileName();
        const accepted = typeof window === 'undefined' ? true : window.confirm(
            `[${fileName}] DTD 예외 ${pending}개를 현재 등록값 기준으로 일괄 승인합니다.`
        );
        if (!accepted) return;
        const approved = this.approveDtdReviewExceptions(
            this.data,
            '현재 파일 DTD 예외 일괄 승인',
        );
        const item = this.activeBatchItem();
        if (item) {
            item.metadataReviewPaused = false;
            item.metadataReviewState = this.metadataReviewFileComplete(item)
                ? 'ready' : 'draft';
        }
        this.metadataDraftNotice = `${fileName} DTD 예외 ${approved}개 승인 내용을 서버에 저장 중입니다.`;
        this.queueRegistrationRecoverySave();
        this.initialiseDtdReviewFocus();
        await this.renderPreservingViewport();
        const saved = await this.flushRegistrationRecoveryDraftsNow();
        const remaining = this.dtdReviewPendingCount();
        if (!saved || remaining > 0) {
            await this.service.modal.error(
                saved
                    ? `${fileName} DTD 예외 ${remaining}개가 서버 확인 후 남았습니다. 다시 시도해주세요.`
                    : `${fileName} DTD 예외 승인 상태를 서버에 저장하지 못했습니다. 승인 내용은 현재 화면에 보존했습니다.`
            );
            return;
        }
        this.metadataDraftNotice = `${fileName} DTD 예외 ${approved}개를 승인하고 서버에 저장했습니다.`;
        await this.service.modal.success(this.metadataDraftNotice);
    }

    public async approveAllFilesDtdExceptions() {
        this.syncActiveBatch();
        const rows = this.metadataReviewTargetItems()
            .map((row: any) => ({
                ...row,
                form: this.metadataReviewFormForItem(row.item),
            }))
            .map((row: any) => ({
                ...row,
                pending: this.dtdReviewPendingCount(row.form),
            }))
            .filter((row: any) => row.pending > 0);
        const total = rows.reduce(
            (count: number, row: any) => count + row.pending,
            0,
        );
        if (!total) return;
        const accepted = typeof window === 'undefined' ? true : window.confirm(
            `모든 파일의 DTD 예외 ${total}개를 현재 등록값 기준으로 일괄 승인합니다.`
        );
        if (!accepted) return;
        rows.forEach((row: any) => {
            this.approveDtdReviewExceptions(
                row.form,
                '모든 파일 DTD 예외 일괄 승인',
            );
            row.item.metadataReviewPaused = false;
            row.item.metadataReviewState = this.metadataReviewFileComplete(row.item)
                ? 'ready' : 'draft';
            if (row.index === this.activeBatchIndex) {
                this.data = row.form;
                row.item.form = this.cloneForm(row.form);
            }
            this.captureRegistrationLocalDraft(row.item, row.item.form);
        });
        this.metadataDraftNotice = `모든 파일의 DTD 예외 ${total}개 승인 내용을 서버에 저장 중입니다.`;
        this.syncActiveBatch();
        this.queueRegistrationRecoverySave();
        this.initialiseDtdReviewFocus();
        await this.renderPreservingViewport();
        const saved = await this.flushRegistrationRecoveryDraftsNow();
        const remaining = this.dtdReviewBatchPendingCount();
        if (!saved || remaining > 0) {
            await this.service.modal.error(
                saved
                    ? `서버 확인 후 DTD 예외 ${remaining}개가 남았습니다. 남은 파일만 다시 승인해주세요.`
                    : '모든 파일 DTD 예외 승인 상태를 서버에 저장하지 못했습니다. 승인 내용은 현재 화면에 보존했습니다.'
            );
            return;
        }
        this.metadataDraftNotice = `모든 파일의 DTD 예외 ${total}개를 승인하고 서버에 저장했습니다.`;
        await this.service.modal.success(this.metadataDraftNotice);
    }

    public dtdReviewFieldsForGroup(group: any = this.dtdCoverageSelectedGroup()) {
        const groupId = `${group?.id || ''}`;
        const query = `${this.dtdReviewSearch || ''}`.trim().toLowerCase();
        return this.dtdReviewActionableFields().filter((field: any) => {
            if (`${field.group_id || ''}` !== groupId) return false;
            if (!query) return true;
            const target = [
                field.id,
                field.label,
                field.element,
                field.attribute,
                ...(Array.isArray(field.current_value) ? field.current_value : []),
                ...(Array.isArray(field.source_paths) ? field.source_paths : []),
            ].join(' ').toLowerCase();
            return target.includes(query);
        });
    }

    public dtdReviewActiveField() {
        const visibleFields = this.dtdReviewFieldsForGroup();
        return visibleFields.find(
            (field: any) => `${field.id || ''}` === this.dtdReviewActiveFieldId
        ) || visibleFields[0] || null;
    }

    private focusDtdReviewField(field: any) {
        if (!field) return;
        this.dtdCoverageActiveGroup = `${field.group_id || ''}`;
        this.dtdReviewActiveFieldId = `${field.id || ''}`;
    }

    private initialiseDtdReviewFocus() {
        this.dtdReviewSearch = '';
        const pending = this.dtdReviewActionableFields()[0] || null;
        this.dtdReviewFilter = 'attention';
        this.focusDtdReviewField(pending);
    }

    public dtdReviewFieldActive(field: any) {
        return !!field
            && `${field.id || ''}` === `${this.dtdReviewActiveField()?.id || ''}`;
    }

    public dtdReviewDomId(field: any) {
        return `dtd-review-field-${`${field?.id || ''}`.replace(/[^a-zA-Z0-9_-]/g, '-')}`;
    }

    public async selectDtdReviewField(field: any) {
        if (!field) return;
        this.dtdReviewActiveFieldId = `${field.id || ''}`;
        await this.renderPreservingViewport(
            `#${this.dtdReviewDomId(field)}`
        );
    }

    public async setDtdReviewFilter(filter: 'all' | 'attention') {
        this.dtdReviewFilter = filter;
        const first = this.dtdReviewFieldsForGroup()[0]
            || (filter === 'attention'
                ? this.dtdReviewActionableFields()[0]
                : null);
        if (first) this.focusDtdReviewField(first);
        await this.renderPreservingViewport();
    }

    public async goToNextPendingDtdReviewField() {
        if (!this.deferredRegistrationReviewStagesVisible) {
            this.metadataSection = 'bibliography';
            await this.service.render();
            return;
        }
        this.dtdReviewFilter = 'attention';
        this.metadataSection = 'layout';

        const indexes = this.metadataAdvanceFileItems().map(
            (row: any) => row.index
        );
        const currentIndex = this.activeBatchIndex;
        const orderedIndexes = indexes.includes(currentIndex)
            ? [currentIndex, ...indexes.filter((index: number) => index !== currentIndex)]
            : indexes;

        for (const index of orderedIndexes) {
            const item = this.batchItems[index];
            if (!item || item.status !== 'complete' || !item.form) continue;
            const form = index === this.activeBatchIndex && this.data
                ? this.data : item.form;
            const pending = this.dtdReviewActionableFields(form)[0];
            if (!pending) continue;
            if (index !== this.activeBatchIndex) await this.selectBatchItem(index);
            const activePending = this.dtdReviewActionableFields().find(
                (field: any) => `${field.id || ''}` === `${pending.id || ''}`
            ) || pending;
            this.focusDtdReviewField(activePending);
            await this.renderPreservingViewport(
                `#${this.dtdReviewDomId(activePending)}`
            );
            return;
        }

        await this.renderPreservingViewport();
    }

    public async updateDtdReviewSearch(value: any) {
        this.dtdReviewSearch = `${value || ''}`;
        const first = this.dtdReviewFieldsForGroup()[0] || null;
        if (first) this.dtdReviewActiveFieldId = `${first.id || ''}`;
        await this.renderPreservingViewport();
    }

    public dtdReviewChanged(field: any) {
        return this.xmlReviewChanged(field);
    }

    public dtdReviewSearchChanged(field: any) {
        const search = field?.search_index || {};
        return !!search.enabled !== !!search.default_enabled;
    }

    public async updateDtdReviewValue(field: any, index: number, value: any) {
        if (!field) return;
        const values = Array.isArray(field.current_value)
            ? [...field.current_value] : [];
        while (values.length <= index) values.push('');
        values[index] = `${value || ''}`;
        field.current_value = values;
        field.status = this.dtdReviewChanged(field) ? 'modified' : 'unreviewed';
        field.reviewed = false;
        if (!this.isRegistrationMode()) {
            this.markSavedReviewDirty();
            return;
        }
        if (!this.dtdReviewChanged(field) || `${field.reason || ''}`.trim()) {
            this.queueRegistrationRecoverySave();
        }
    }

    public async addDtdReviewValue(field: any) {
        if (!field) return;
        if (!Array.isArray(field.current_value)) field.current_value = [];
        field.current_value.push('');
        field.reviewed = false;
        this.queueRegistrationRecoverySave();
        await this.renderPreservingViewport();
    }

    public async removeDtdReviewValue(field: any, index: number) {
        if (!field || !Array.isArray(field.current_value)) return;
        field.current_value.splice(index, 1);
        field.status = this.dtdReviewChanged(field) ? 'modified' : 'unreviewed';
        field.reviewed = false;
        if (!this.isRegistrationMode()) {
            this.markSavedReviewDirty();
            await this.renderPreservingViewport();
            return;
        }
        if (!this.dtdReviewChanged(field) || `${field.reason || ''}`.trim()) {
            this.queueRegistrationRecoverySave();
        }
        await this.renderPreservingViewport();
    }

    public async updateDtdReviewMetadata(field: any) {
        if (!field) return;
        field.reviewed = false;
        if (!this.isRegistrationMode()) {
            this.markSavedReviewDirty();
            return;
        }
        if (
            (!this.dtdReviewChanged(field) && !this.dtdReviewSearchChanged(field))
            || `${field.reason || ''}`.trim()
        ) {
            this.queueRegistrationRecoverySave();
        }
    }

    public async toggleDtdSearchIndex(field: any, enabled: any) {
        if (!field) return;
        if (field.search_index?.eligible === false) return;
        if (!field.search_index || typeof field.search_index !== 'object') {
            field.search_index = {
                eligible: true,
                enabled: false,
                default_enabled: false,
                projection_key: field.id,
            };
        }
        field.search_index.enabled = !!enabled;
        field.reviewed = false;
        if (!this.dtdReviewSearchChanged(field) || `${field.reason || ''}`.trim()) {
            this.queueRegistrationRecoverySave();
        }
        await this.renderPreservingViewport();
    }

    public savedDtdActionRunning() {
        return this.savedDtdActionState === 'running';
    }

    public savedDtdActionPercent() {
        return this.savedDtdActionState === 'success' ? 100 : 0;
    }

    public savedDtdActionStatusLabel() {
        if (this.savedDtdActionState === 'running') return '저장 중';
        if (this.savedDtdActionState === 'success') return '저장 완료';
        if (this.savedDtdActionState === 'error') return '저장 실패';
        return '';
    }

    private startSavedDtdAction(label: string, total: number) {
        this.savedDtdActionState = 'running';
        this.savedDtdActionLabel = label;
        this.savedDtdActionMessage = '현재 검수 상태를 서버에 저장하고 있습니다.';
        this.savedDtdActionTotal = Math.max(1, total);
        this.savedDtdActionCompleted = 0;
    }

    private async persistSavedDtdAction(successMessage: string) {
        const saved = await this.persistSavedReview('save', true);
        this.savedDtdActionState = saved ? 'success' : 'error';
        this.savedDtdActionCompleted = saved ? this.savedDtdActionTotal : 0;
        this.savedDtdActionMessage = saved
            ? successMessage
            : (this.savedReviewNotice || '검수 상태를 저장하지 못했습니다. 다시 시도해주세요.');
        await this.service.render();
        return saved;
    }

    public async confirmDtdReviewField(field: any) {
        if (!field) return;
        const savedReviewMode = !this.isRegistrationMode();
        if (
            savedReviewMode
            && (
                !this.canManageSavedReview()
                || this.savedReviewSaving
                || this.savedDtdActionRunning()
            )
        ) return;
        if (
            (this.dtdReviewChanged(field) || this.dtdReviewSearchChanged(field))
            && !`${field.reason || ''}`.trim()
        ) {
            await this.service.modal.error(
                `${field.label || 'DTD 필드'} 수정·검색 색인 변경 사유를 입력해주세요.`
            );
            return;
        }
        const fieldLabel = `${field.label || field.id || 'DTD 필드'}`;
        if (savedReviewMode) {
            this.startSavedDtdAction(`${fieldLabel} 현재 값 확인`, 1);
            await this.service.render();
        }
        field.status = this.dtdReviewChanged(field) ? 'modified' : 'confirmed';
        field.reviewed = true;
        const next = this.dtdReviewFieldsForGroup()[0]
            || this.dtdReviewActionableFields()[0];
        if (next) this.focusDtdReviewField(next);
        if (savedReviewMode) {
            this.markSavedReviewDirty();
            await this.service.render();
            await this.persistSavedDtdAction(
                `${fieldLabel}의 현재 등록값을 확인 완료로 저장했습니다.`
            );
            return;
        }
        this.queueRegistrationRecoverySave();
        await this.renderPreservingViewport();
    }

    public async confirmAutoDtdFields() {
        const savedReviewMode = !this.isRegistrationMode();
        if (
            savedReviewMode
            && (
                !this.canManageSavedReview()
                || this.savedReviewSaving
                || this.savedDtdActionRunning()
            )
        ) return;
        const eligible = this.dtdReviewAutoConfirmableFields();
        if (!eligible.length) {
            await this.service.modal.error('서버가 안전한 원문 일치로 판정한 DTD 필드가 없습니다.');
            return;
        }
        const accepted = typeof window === 'undefined'
            ? true
            : window.confirm(
                `서버가 원문 일치로 판정한 안전한 DTD 필드 ${eligible.length}개만 확인 완료로 처리합니다.`
            );
        if (!accepted) return;
        if (savedReviewMode) {
            this.startSavedDtdAction(
                `원문 일치 안전 항목 ${eligible.length}개 일괄 완료`,
                eligible.length,
            );
            await this.service.render();
        }
        eligible.forEach((field: any) => {
            field.status = 'confirmed';
            field.reviewed = true;
        });
        const next = this.dtdReviewActionableFields()[0];
        if (next) this.focusDtdReviewField(next);
        if (savedReviewMode) {
            this.markSavedReviewDirty();
            await this.service.render();
            await this.persistSavedDtdAction(
                `원문 일치 안전 항목 ${eligible.length}개를 확인 완료로 저장했습니다.`
            );
            return;
        }
        this.queueRegistrationRecoverySave();
        await this.renderPreservingViewport();
    }

    public async confirmBatchAutoDtdFields() {
        this.syncActiveBatch();
        const eligibleRows = this.metadataReviewTargetItems()
            .map((row: any) => ({
                ...row,
                form: this.metadataReviewFormForItem(row.item),
            }))
            .map((row: any) => ({
                ...row,
                fields: this.dtdReviewAutoConfirmableFields(row.form),
            }))
            .filter((row: any) => row.fields.length > 0);
        const total = eligibleRows.reduce(
            (count: number, row: any) => count + row.fields.length,
            0,
        );
        if (!total) {
            await this.service.modal.error('전체 파일에서 안전하게 일괄 완료할 DTD 필드가 없습니다.');
            return;
        }
        const accepted = typeof window === 'undefined' ? true : window.confirm(
            `서버가 원문 일치로 판정한 전체 파일의 DTD 필드 ${total}개만 확인 완료로 처리합니다. 확인 필요·오류·근거 잘림 항목은 제외됩니다.`
        );
        if (!accepted) return;
        eligibleRows.forEach((row: any) => {
            row.fields.forEach((field: any) => {
                field.status = 'confirmed';
                field.reviewed = true;
            });
            if (row.index === this.activeBatchIndex) {
                row.item.form = this.cloneForm(this.data);
            }
            this.captureRegistrationLocalDraft(row.item, row.item.form);
        });
        this.syncActiveBatch();
        this.queueRegistrationRecoverySave();
        this.initialiseDtdReviewFocus();
        await this.renderPreservingViewport();
    }

    public dtdReviewSourceSegments(field: any = this.dtdReviewActiveField()) {
        const source = `${this.xmlFieldReview().source_excerpt || ''}`;
        if (!source) return [];
        const ranges = (Array.isArray(field?.evidence) ? field.evidence : [])
            .map((evidence: any) => ({
                start: Number(evidence.source_start),
                end: Number(evidence.source_end),
            }))
            .filter((range: any) => (
                Number.isFinite(range.start)
                && Number.isFinite(range.end)
                && range.start >= 0
                && range.end > range.start
                && range.start < source.length
            ))
            .map((range: any) => ({
                start: Math.max(0, range.start),
                end: Math.min(source.length, range.end),
            }))
            .sort((first: any, second: any) => first.start - second.start);
        if (!ranges.length) return [{ text: source, highlight: false }];
        const segments: any[] = [];
        let cursor = 0;
        ranges.forEach((range: any) => {
            if (range.start < cursor) return;
            if (range.start > cursor) {
                segments.push({
                    text: source.slice(cursor, range.start),
                    highlight: false,
                });
            }
            segments.push({
                text: source.slice(range.start, range.end),
                highlight: true,
            });
            cursor = range.end;
        });
        if (cursor < source.length) {
            segments.push({ text: source.slice(cursor), highlight: false });
        }
        return segments;
    }

    private syncXmlReviewFieldToForm(field: any) {
        if (!this.data || !field) return;
        const values = this.xmlReviewValues(field)
            .map((row: any) => `${row || ''}`.trim()).filter(Boolean);
        const scalar = values[0] || '';
        if (field.id === 'title') this.data.title = scalar;
        if (field.id === 'category') this.data.category = scalar;
        if (field.id === 'authors') this.data.authors = values.join(', ');
        if (field.id === 'publisher') this.data.publisher = scalar;
        if (field.id === 'created_dates') this.data.created_dates = values;
        if (field.id === 'issued_dates') this.data.issued_dates = values;
        if (['created_dates', 'issued_dates'].includes(field.id)) {
            this.data.document_date = this.normaliseDateValues(
                this.data.issued_dates
            )[0] || this.normaliseDateValues(this.data.created_dates)[0] || '';
        }
        if (field.id === 'language') this.data.language = scalar;
        if (field.id === 'era') this.data.era = scalar;
        if (field.id === 'keywords') this.data.keywords = values.join(', ');
        if (field.id === 'summary') this.data.content = scalar;
    }

    private applyXmlReviewValue(field: any, index: number, value: any) {
        if (!field) return;
        this.clearMetadataRepresentativeCandidates(field, 'manual');
        const values = Array.isArray(field.current_value)
            ? [...field.current_value] : [];
        while (values.length <= index) values.push('');
        values[index] = `${value || ''}`;
        field.current_value = field.repeatable ? values : values.slice(0, 1);
        field.status = this.xmlReviewChanged(field) ? 'modified' : (
            field.conflict_state === 'conflict' ? 'conflict'
                : field.conflict_state === 'no_evidence' ? 'no_evidence' : 'unreviewed'
        );
        field.reviewed = false;
        this.syncXmlReviewFieldToForm(field);
    }

    public async updateEraSelection(field: any, index: number, rawCode: any) {
        if (!field) return;
        const code = this.eraOptions.includes(`${rawCode || ''}`)
            ? `${rawCode || ''}` : '';
        const other = code === '기타'
            ? this.eraOtherInputValue(field, this.xmlReviewValues(field)[index])
            : '';
        field.era_code = code;
        field.era_other_value = other;
        this.applyXmlReviewValue(field, index, code === '기타' ? other : code);
        this.queueRegistrationRecoverySave();
    }

    public async updateEraOtherValue(field: any, index: number, rawValue: any) {
        if (!field) return;
        const other = `${rawValue || ''}`.slice(0, 100);
        field.era_code = '기타';
        field.era_other_value = other;
        this.applyXmlReviewValue(field, index, other);
        this.queueRegistrationRecoverySave();
    }

    public async updateXmlReviewValue(field: any, index: number, value: any) {
        if (field?.id === 'era') {
            await this.updateEraSelection(field, index, value);
            return;
        }
        this.applyXmlReviewValue(field, index, value);
        this.queueRegistrationRecoverySave();
    }

    public async chooseXmlReviewValue(
        field: any, source: 'extracted' | 'original'
    ) {
        if (!field) return;
        let selectedSources = this.metadataReviewValueSources(field);
        if (selectedSources.includes(source)) {
            if (selectedSources.length === 1) return;
            selectedSources = selectedSources.filter(
                (row: string) => row !== source
            );
        } else {
            selectedSources = [...selectedSources, source];
        }
        selectedSources = ['extracted', 'original'].filter(
            (row: string) => selectedSources.includes(row)
        );
        const values: string[] = [];
        selectedSources.forEach((selectedSource: string) => {
            const key = selectedSource === 'original'
                ? (Array.isArray(field.original_display_value) ? 'original_display_value' : 'original_value')
                : 'extracted_value';
            const sourceValues = this.xmlReviewValues(field, key)
                .map((value: any) => `${value || ''}`.trim())
                .filter(Boolean);
            const applicable = field.repeatable ? sourceValues : sourceValues.slice(0, 1);
            applicable.forEach((value: string) => {
                if (!values.includes(value)) values.push(value);
            });
        });
        const scope = this.xmlReviewScope(field);
        scope.representative_candidate_ids = [];
        scope.representative_sources = selectedSources;
        scope.representative_source = selectedSources.length > 1
            ? 'multiple_confirmed'
            : `${selectedSources[0] || 'extracted'}_confirmed`;
        field.current_value = field.repeatable
            ? [...values] : [values.join(' · ')];
        if (!field.current_value.length) field.current_value = [''];
        if (field.id === 'era') {
            const era = this.normaliseEraValue(field.current_value[0]);
            field.era_code = era;
            field.era_other_value = '';
            field.current_value = era ? [era] : [];
        }
        field.status = this.xmlReviewChanged(field) ? 'modified' : 'unreviewed';
        field.reviewed = false;
        this.syncXmlReviewFieldToForm(field);
        await this.selectXmlReviewField(field);
        this.queueRegistrationRecoverySave();
    }

    public async addXmlReviewValue(field: any) {
        if (!field || !field.repeatable) return;
        this.clearMetadataRepresentativeCandidates(field, 'manual');
        if (!Array.isArray(field.current_value)) field.current_value = [];
        field.current_value.push('');
        field.reviewed = false;
        this.queueRegistrationRecoverySave();
        await this.renderPreservingViewport();
    }

    public async removeXmlReviewValue(field: any, index: number) {
        if (!field || !field.repeatable || !Array.isArray(field.current_value)) return;
        this.clearMetadataRepresentativeCandidates(field, 'manual');
        field.current_value.splice(index, 1);
        field.status = this.xmlReviewChanged(field) ? 'modified' : 'unreviewed';
        field.reviewed = false;
        this.syncXmlReviewFieldToForm(field);
        this.queueRegistrationRecoverySave();
        await this.renderPreservingViewport();
    }

    public async updateXmlReviewMetadata(field: any) {
        if (!field) return;
        field.reviewed = false;
        this.queueRegistrationRecoverySave();
    }

    public async confirmXmlReviewField(field: any) {
        if (!field) return;
        if (this.metadataReviewHierarchyNeedsDecision(field)) {
            this.xmlReviewScope(field).representative_source = this.xmlReviewChanged(field)
                ? 'manual' : 'extracted_confirmed';
        }
        field.status = this.xmlReviewChanged(field) ? 'modified' : 'confirmed';
        field.reviewed = true;
        this.syncXmlReviewFieldToForm(field);
        this.queueRegistrationRecoverySave();
        const next = this.xmlReviewFields().find(
            (row: any) => !this.metadataReviewFieldComplete(row)
        );
        if (next) this.xmlReviewActiveFieldId = next.id;
        await this.renderPreservingViewport();
    }

    public async toggleXmlReviewSource() {
        if (!this.xmlReviewSourceOpen) {
            await this.revealXmlReviewEvidence();
            return;
        }
        this.xmlReviewSourceOpen = false;
        await this.renderPreservingViewport();
    }

    public onMetadataFieldChange(fieldId: string, value: any) {
        const field = this.xmlReviewFields().find((row: any) => row.id === fieldId);
        if (!field) {
            this.queueRegistrationRecoverySave();
            return;
        }
        this.clearMetadataRepresentativeCandidates(field, 'manual');
        const repeatable = !!field.repeatable;
        const values = repeatable ? this.splitValues(value) : [`${value || ''}`];
        field.current_value = values;
        field.status = this.xmlReviewChanged(field) ? 'modified' : 'unreviewed';
        field.reviewed = false;
        this.queueRegistrationRecoverySave();
    }

    private metadataV21ReviewFromAnalysis(analysis: any) {
        const block = analysis && analysis.metadata_v2_1
            && typeof analysis.metadata_v2_1 === 'object'
            ? analysis.metadata_v2_1 : null;
        if (!block || !block.fields) {
            return { review_status: 'NOT_APPLICABLE', fields: {} };
        }
        return {
            review_status: analysis.review_status || 'REVIEW_REQUIRED',
            fields: JSON.parse(JSON.stringify(block.fields)),
        };
    }

    public metadataV21Enabled() {
        return !!(
            this.analysisInfo
            && this.analysisInfo.review_status
            && this.analysisInfo.metadata_v2_1
        );
    }

    public metadataV21FieldNames() {
        return ['title', 'authors', 'date', 'keywords', 'entities'];
    }

    public metadataV21FieldLabel(fieldName: string) {
        const labels: any = {
            title: '자료명', authors: '저자·편찬자', date: '발행연대 보조 후보',
            keywords: '색인어·키워드', entities: '주요 개체명',
        };
        return labels[fieldName] || fieldName;
    }

    public async selectMetadataV21Field(fieldName: string) {
        if (!this.metadataV21FieldNames().includes(fieldName)) return;
        this.metadataV21FieldName = fieldName;
        await this.service.render();
    }

    private metadataV21CurrentValue(fieldName: string) {
        if (!this.data) return fieldName === 'title' || fieldName === 'date' ? '' : [];
        if (fieldName === 'title') return `${this.data.title || ''}`;
        if (fieldName === 'date') return this.normaliseDateValues(
            this.data.issued_dates
        )[0] || `${this.data.document_date || ''}`;
        if (fieldName === 'authors') return this.splitValues(this.data.authors);
        if (fieldName === 'keywords') return this.splitValues(this.data.keywords);
        if (fieldName === 'entities') {
            return (Array.isArray(this.data.entities) ? this.data.entities : [])
                .map((row: any) => `${row.normalized || row.text || ''}`.trim())
                .filter(Boolean);
        }
        return '';
    }

    private metadataV21Same(first: any, second: any) {
        return JSON.stringify(first) === JSON.stringify(second);
    }

    public metadataV21FieldReview(fieldName: string = this.metadataV21FieldName) {
        const review = this.data && this.data.metadata_v2_1_review
            ? this.data.metadata_v2_1_review : {};
        const fields = review.fields && typeof review.fields === 'object'
            ? review.fields : {};
        return fields[fieldName] || {};
    }

    public metadataV21FieldConfirmed(fieldName: string) {
        const field = this.metadataV21FieldReview(fieldName);
        return field.review_status === 'CONFIRMED'
            && this.metadataV21Same(
                field.reviewed_value,
                this.metadataV21CurrentValue(fieldName)
            );
    }

    public metadataV21PendingCount() {
        if (!this.metadataV21Enabled()) return 0;
        return this.metadataV21FieldNames().filter(
            (fieldName: string) => !this.metadataV21FieldConfirmed(fieldName)
        ).length;
    }

    public metadataV21Candidates(fieldName: string = this.metadataV21FieldName) {
        const rows = this.analysisInfo && Array.isArray(this.analysisInfo.candidates)
            ? this.analysisInfo.candidates : [];
        return rows.filter((row: any) => row.field === fieldName).slice(0, 30);
    }

    public metadataV21Evidence(candidate: any) {
        const rows = this.analysisInfo && this.analysisInfo.evidence
            ? this.analysisInfo.evidence : {};
        return candidate && rows[candidate.candidate_id]
            ? rows[candidate.candidate_id] : {};
    }

    public metadataV21SourceLabel(candidate: any) {
        if (candidate && candidate.origin === 'v1') return 'V1 fallback';
        const source = `${candidate && candidate.source_type ? candidate.source_type : ''}`;
        if (source === 'xml_primary' || source === 'pdf_metadata') return '구조정보';
        return 'V2.1';
    }

    public metadataV21ConflictLabel(fieldName: string = this.metadataV21FieldName) {
        const status = this.analysisInfo && this.analysisInfo.conflict
            ? `${this.analysisInfo.conflict[fieldName] || 'none'}` : 'none';
        if (status === 'unresolved') return '후보 충돌 미해결';
        if (status === 'resolved') return '후보 충돌 · 선택 필요';
        return '충돌 없음';
    }

    public metadataV21CandidateSelected(candidate: any) {
        const field = this.metadataV21FieldReview(candidate && candidate.field);
        return !!candidate && Array.isArray(field.selected_candidate_ids)
            && field.selected_candidate_ids.includes(candidate.candidate_id);
    }

    private applyMetadataV21Value(fieldName: string, value: any) {
        if (fieldName === 'title') this.data.title = `${value || ''}`;
        if (fieldName === 'date') {
            this.data.issued_dates = this.normaliseDateValues(value);
            this.data.document_date = this.data.issued_dates[0]
                || this.normaliseDateValues(this.data.created_dates)[0] || '';
        }
        if (fieldName === 'authors') this.data.authors = (value || []).join(', ');
        if (fieldName === 'keywords') this.data.keywords = (value || []).join(', ');
        if (fieldName === 'entities') {
            this.data.entities = (value || []).map((text: string) => ({
                text, normalized: text, type: 'OTHER', confidence: 1,
                kg_id: '', manually_corrected: true,
            }));
        }
        const xmlFieldId = fieldName === 'date' ? 'issued_dates' : fieldName;
        const xmlField = this.xmlReviewFields().find(
            (row: any) => row.id === xmlFieldId
        );
        if (xmlField) {
            this.clearMetadataRepresentativeCandidates(xmlField, 'metadata_v2_1');
            xmlField.current_value = xmlField.repeatable
                ? (Array.isArray(value) ? [...value] : this.splitValues(value))
                : [`${value || ''}`];
            xmlField.status = this.xmlReviewChanged(xmlField)
                ? 'modified' : 'unreviewed';
            xmlField.reviewed = false;
        }
    }

    public async chooseMetadataV21Candidate(candidate: any) {
        if (!candidate || !this.data) return;
        const fieldName = `${candidate.field || ''}`;
        const review = this.metadataV21FieldReview(fieldName);
        let selected = Array.isArray(review.selected_candidate_ids)
            ? [...review.selected_candidate_ids] : [];
        if (['authors', 'keywords', 'entities'].includes(fieldName)) {
            selected = selected.includes(candidate.candidate_id)
                ? selected.filter((id: string) => id !== candidate.candidate_id)
                : [...selected, candidate.candidate_id];
        } else {
            selected = [candidate.candidate_id];
        }
        const values = this.metadataV21Candidates(fieldName)
            .filter((row: any) => selected.includes(row.candidate_id))
            .map((row: any) => row.value);
        const nextValue = ['authors', 'keywords', 'entities'].includes(fieldName)
            ? values : (values[0] || '');
        review.selected_candidate_ids = selected;
        review.review_status = 'REVIEW_REQUIRED';
        review.manual_override = false;
        review.reviewed_value = nextValue;
        this.applyMetadataV21Value(fieldName, nextValue);
        this.queueRegistrationRecoverySave();
        await this.service.render();
    }

    public async confirmMetadataV21Field(fieldName: string = this.metadataV21FieldName) {
        const field = this.metadataV21FieldReview(fieldName);
        const current = this.metadataV21CurrentValue(fieldName);
        const selectedValues = this.metadataV21Candidates(fieldName)
            .filter((row: any) => (field.selected_candidate_ids || []).includes(row.candidate_id))
            .map((row: any) => row.value);
        const candidateValue = ['authors', 'keywords', 'entities'].includes(fieldName)
            ? selectedValues : (selectedValues[0] || '');
        field.reviewed_value = JSON.parse(JSON.stringify(current));
        field.manual_override = !this.metadataV21Same(current, candidateValue);
        field.review_status = 'CONFIRMED';
        const review = this.data.metadata_v2_1_review;
        review.review_status = this.metadataV21FieldNames().every(
            (name: string) => name === fieldName
                ? true : this.metadataV21FieldConfirmed(name)
        ) ? 'CONFIRMED' : 'REVIEW_REQUIRED';
        this.queueRegistrationRecoverySave();
        await this.service.render();
    }

    public confidenceLabel(fieldName: string) {
        const field = this.analysisInfo && this.analysisInfo.metadata
            ? this.analysisInfo.metadata[fieldName]
            : null;
        const hasValue = field
            ? (Array.isArray(field.value) ? field.value.length > 0 : !!`${field.value || ''}`.trim())
            : false;
        if (!field || field.confidence === null || typeof field.confidence === 'undefined') {
            return hasValue ? 'LLM 재분석 필요' : '정보 없음';
        }
        const confidence = Number(field.confidence);
        if (!Number.isFinite(confidence)) return hasValue ? 'LLM 재분석 필요' : '정보 없음';
        if (confidence <= 0) return hasValue ? '검토 필요' : '정보 없음';
        return `${Math.round(Math.max(0, Math.min(1, confidence)) * 100)}%`;
    }

    public metadataConfidenceTarget() {
        return this.safeConfidence(
            this.analysisInfo && this.analysisInfo.metadata_confidence_target,
            this.aiSettings && typeof this.aiSettings.metadata_confidence_threshold !== 'undefined'
                ? this.aiSettings.metadata_confidence_threshold
                : 0.75
        );
    }

    public metadataNeedsReview(fieldName: string) {
        const field = this.analysisInfo && this.analysisInfo.metadata
            ? this.analysisInfo.metadata[fieldName]
            : null;
        if (!field || field.confidence === null || typeof field.confidence === 'undefined') return false;
        const confidence = Number(field.confidence);
        if (!Number.isFinite(confidence)) return false;
        return typeof field.requires_review === 'boolean'
            ? field.requires_review
            : confidence < this.metadataConfidenceTarget();
    }

    public metadataRequiresReanalysis(fieldName: string) {
        const field = this.analysisInfo && this.analysisInfo.metadata
            ? this.analysisInfo.metadata[fieldName]
            : null;
        if (!field) return false;
        const hasValue = Array.isArray(field.value) ? field.value.length > 0 : !!`${field.value || ''}`.trim();
        return hasValue && (field.confidence === null || typeof field.confidence === 'undefined' || !Number.isFinite(Number(field.confidence)));
    }

    public metadataConfidenceClass(fieldName: string) {
        if (this.metadataRequiresReanalysis(fieldName)) return 'is-unscored';
        if (this.metadataNeedsReview(fieldName)) return 'is-low';
        const field = this.analysisInfo && this.analysisInfo.metadata
            ? this.analysisInfo.metadata[fieldName]
            : null;
        return field && field.confidence !== null && typeof field.confidence !== 'undefined' ? 'is-good' : 'is-empty';
    }

    public lowConfidenceMetadataCount() {
        return ['title', 'category', 'authors', 'date', 'era', 'keywords', 'summary']
            .filter((fieldName: string) => this.metadataNeedsReview(fieldName)).length;
    }

    public unscoredMetadataCount() {
        return ['title', 'category', 'authors', 'date', 'era', 'keywords', 'summary']
            .filter((fieldName: string) => this.metadataRequiresReanalysis(fieldName)).length;
    }

    public ocrReviewSummary() {
        const textLength = `${this.data && this.data.ocr_text ? this.data.ocr_text : ''}`.length;
        const ocr = this.analysisInfo && this.analysisInfo.ocr ? this.analysisInfo.ocr : {};
        const confidence = Number(ocr.confidence);
        if (ocr.confidence !== null && typeof ocr.confidence !== 'undefined' && Number.isFinite(confidence)) {
            return `본문 ${textLength.toLocaleString()}자 · 인식 신뢰도 ${this.confidencePercent(confidence)}`;
        }
        return textLength > 0 ? `본문 ${textLength.toLocaleString()}자 추출 완료` : '추출된 본문이 없습니다.';
    }

    public ocrOverallConfidenceLabel() {
        const ocr = this.analysisInfo && this.analysisInfo.ocr ? this.analysisInfo.ocr : {};
        if (ocr.confidence === null || typeof ocr.confidence === 'undefined' || !Number.isFinite(Number(ocr.confidence))) {
            return '산정 정보 없음';
        }
        return this.confidencePercent(Number(ocr.confidence));
    }

    public lowConfidenceWords() {
        const ocr = this.analysisInfo && this.analysisInfo.ocr ? this.analysisInfo.ocr : null;
        if (!ocr) return [];
        return (ocr.words || []).filter((word: any) => Number(word.confidence || 0) < Number(ocr.confidence_target || 0.9)).slice(0, 80);
    }

    public ocrWords() {
        const ocr = this.analysisInfo && this.analysisInfo.ocr ? this.analysisInfo.ocr : {};
        return Array.isArray(ocr.words) ? ocr.words : [];
    }

    public ocrCharacters() {
        const ocr = this.analysisInfo && this.analysisInfo.ocr ? this.analysisInfo.ocr : {};
        return Array.isArray(ocr.characters) ? ocr.characters : [];
    }

    public ocrLowWordCount() {
        const ocr = this.analysisInfo && this.analysisInfo.ocr ? this.analysisInfo.ocr : {};
        return this.safeNumber(
            ocr.low_confidence_word_count,
            this.ocrWords().filter((row: any) => Number(row.confidence || 0) < Number(ocr.confidence_target || 0.9)).length
        );
    }

    public ocrLowCharacterCount() {
        const ocr = this.analysisInfo && this.analysisInfo.ocr ? this.analysisInfo.ocr : {};
        return this.safeNumber(
            ocr.low_confidence_character_count,
            this.ocrCharacters().filter((row: any) => Number(row.confidence || 0) < Number(ocr.confidence_target || 0.9)).length
        );
    }

    public ocrUnitCount(unit: 'word' | 'character') {
        const ocr = this.analysisInfo && this.analysisInfo.ocr ? this.analysisInfo.ocr : {};
        return this.safeNumber(unit === 'word' ? ocr.word_count : ocr.character_count,
            unit === 'word' ? this.ocrWords().length : this.ocrCharacters().length);
    }

    public ocrConfidenceRows() {
        const ocr = this.analysisInfo && this.analysisInfo.ocr ? this.analysisInfo.ocr : {};
        const target = Number(ocr.confidence_target || 0.9);
        const rows = this.ocrReviewUnit === 'word'
            ? this.ocrWords().map((row: any, index: number) => ({ ...row, _source: row, _index: index, _value: `${row.text || ''}` }))
            : this.ocrCharacters().map((row: any, index: number) => ({ ...row, _source: row, _index: index, _value: `${row.character || ''}` }));
        return rows.filter((row: any) => this.ocrReviewFilter === 'all' || Number(row.confidence || 0) < target).slice(0, 240);
    }

    public async setOcrReviewUnit(unit: 'word' | 'character') {
        this.ocrReviewUnit = unit;
        this.selectedOcrCandidate = null;
        this.ocrCorrectionValue = '';
        await this.service.render();
    }

    public async setOcrReviewFilter(filter: 'low' | 'all') {
        this.ocrReviewFilter = filter;
        await this.service.render();
    }

    public async setOcrMobilePane(pane: 'source' | 'ocr') {
        this.ocrMobilePane = pane;
        await this.service.render();
    }

    public async selectOcrCandidate(row: any) {
        if (!row) return;
        this.selectedOcrCandidate = row;
        this.ocrCorrectionValue = `${row._value || ''}`;
        await this.service.render();
        this.focusOcrOccurrence(`${row._value || ''}`);
    }

    private focusOcrOccurrence(value: string) {
        const textarea = document.getElementById('ocr-correction-text') as HTMLTextAreaElement;
        if (!textarea || !value) return;
        const source = this.ocrModalOpen
            ? `${this.ocrPageDraftText || ''}`
            : `${this.data && this.data.ocr_text ? this.data.ocr_text : ''}`;
        const startAt = Math.max(0, Number(textarea.selectionEnd || 0));
        let index = source.indexOf(value, startAt);
        if (index < 0) index = source.indexOf(value);
        if (index < 0) return;
        textarea.focus();
        textarea.setSelectionRange(index, index + value.length);
        const line = source.slice(0, index).split('\n').length;
        textarea.scrollTop = Math.max(0, (line - 3) * 22);
    }

    public async applyOcrCorrection() {
        const candidate = this.selectedOcrCandidate;
        const original = `${candidate && candidate._value ? candidate._value : ''}`;
        const replacement = `${this.ocrCorrectionValue || ''}`;
        if (!candidate || !original || !replacement) return;
        const textarea = document.getElementById('ocr-correction-text') as HTMLTextAreaElement;
        const source = this.ocrModalOpen
            ? `${this.ocrPageDraftText || ''}`
            : `${this.data && this.data.ocr_text ? this.data.ocr_text : ''}`;
        let start = textarea ? Number(textarea.selectionStart || 0) : -1;
        let end = textarea ? Number(textarea.selectionEnd || 0) : -1;
        if (start < 0 || source.slice(start, end) !== original) {
            start = source.indexOf(original);
            end = start + original.length;
        }
        if (start < 0) {
            await this.service.modal.error('교정할 문자 또는 단어를 OCR 본문에서 찾을 수 없습니다.');
            return;
        }
        const correctedText = source.slice(0, start) + replacement + source.slice(end);
        if (this.ocrModalOpen) this.ocrPageDraftText = correctedText;
        else this.data.ocr_text = correctedText;
        candidate.corrected = true;
        candidate.replacement = replacement;
        candidate.confidence = 1;
        if (candidate._source) {
            candidate._source.corrected = true;
            candidate._source.replacement = replacement;
            candidate._source.confidence = 1;
        }
        await this.service.render();
        setTimeout(() => {
            const editor = document.getElementById('ocr-correction-text') as HTMLTextAreaElement;
            if (!editor) return;
            editor.focus();
            editor.setSelectionRange(start, start + replacement.length);
        }, 0);
    }

    public async openOcrCorrection() {
        this.syncActiveBatch();
        this.ocrModalOpen = true;
        this.ocrMobilePane = 'source';
        this.selectedOcrCandidate = null;
        this.ocrCorrectionValue = '';
        await this.loadOcrPage(this.ocrPageNumber || 1);
    }

    public ocrPageCount() {
        const ocr = this.analysisInfo && this.analysisInfo.ocr ? this.analysisInfo.ocr : {};
        return Math.max(1, this.safeNumber(ocr.page_count, this.layoutSummary().pages_total || 1));
    }

    public ocrPageConfidenceLabel() {
        return this.ocrPageConfidence === null || !Number.isFinite(Number(this.ocrPageConfidence))
            ? '점수 정보 없음'
            : this.confidencePercent(this.ocrPageConfidence);
    }

    public ocrPageConfidenceRows() {
        return this.ocrConfidenceRows().filter((row: any) => Number(row.page || 1) === this.ocrPageNumber);
    }

    public ocrPageHasChanges() {
        return `${this.ocrPageDraftText || ''}` !== `${this.ocrPageOriginalText || ''}`;
    }

    public async loadOcrPage(page: number) {
        if (!this.analysisId) return;
        page = Math.max(1, Math.min(this.ocrPageCount(), Number(page || 1)));
        if (this.ocrPageHasChanges()) await this.applyOcrPage(false);
        this.ocrPageNumber = page;
        this.ocrPageLoading = true;
        this.ocrPageError = '';
        this.selectedOcrCandidate = null;
        const key = `${this.analysisId}:${page}`;
        const cached = this.ocrPageCache[key];
        if (cached) {
            this.ocrPagePreview = cached.data_url;
            this.ocrPageOriginalText = cached.original_text;
            this.ocrPageDraftText = cached.draft_text;
            this.ocrPageConfidence = cached.confidence;
            this.ocrPageLoading = false;
            await this.service.render();
            return;
        }
        await this.service.render();
        try {
            const query = new URLSearchParams({
                mode: 'source_page', analysis_id: this.analysisId, page: `${page}`
            });
            const response = await fetch(`/wiz/api/portal.post.detail/analyze?${query.toString()}`, {
                method: 'POST', credentials: 'same-origin'
            });
            const payload = await response.json();
            if (!payload || payload.code !== 200) {
                throw new Error((payload && payload.data && payload.data.message) || '원본 페이지를 불러오지 못했습니다.');
            }
            const pageData = payload.data && payload.data.page ? payload.data.page : null;
            if (!pageData || !pageData.data_url) throw new Error('원본 페이지 응답이 비어 있습니다.');
            const correction = Array.isArray(this.data.ocr_page_corrections)
                ? this.data.ocr_page_corrections.find((row: any) => Number(row.page) === page)
                : null;
            this.ocrPagePreview = pageData.data_url;
            this.ocrPageOriginalText = `${pageData.ocr_text || ''}`;
            this.ocrPageDraftText = correction ? `${correction.text || ''}` : this.ocrPageOriginalText;
            this.ocrPageConfidence = pageData.ocr_confidence === null || typeof pageData.ocr_confidence === 'undefined'
                ? null : Number(pageData.ocr_confidence);
            this.ocrPageCache[key] = {
                data_url: this.ocrPagePreview,
                original_text: this.ocrPageOriginalText,
                draft_text: this.ocrPageDraftText,
                confidence: this.ocrPageConfidence,
            };
        } catch (error) {
            const captured = this.captureError(error, '원본 페이지를 불러오지 못했습니다.');
            this.ocrPageError = captured.message;
            if (captured.details) this.technicalErrorDetails = captured.details;
        } finally {
            this.ocrPageLoading = false;
            await this.service.render();
        }
    }

    public async applyOcrPage(showMessage: boolean = true) {
        if (!this.data) return;
        if (!Array.isArray(this.data.ocr_page_corrections)) this.data.ocr_page_corrections = [];
        const existing = this.data.ocr_page_corrections.find((row: any) => Number(row.page) === this.ocrPageNumber);
        if (existing) existing.text = this.ocrPageDraftText;
        else this.data.ocr_page_corrections.push({ page: this.ocrPageNumber, text: this.ocrPageDraftText });
        const fullText = `${this.data.ocr_text || ''}`;
        if (this.ocrPageOriginalText && fullText.includes(this.ocrPageOriginalText)) {
            this.data.ocr_text = fullText.replace(this.ocrPageOriginalText, this.ocrPageDraftText);
        }
        this.ocrPageOriginalText = this.ocrPageDraftText;
        this.ocrSavedPages[this.ocrPageNumber] = true;
        const key = `${this.analysisId}:${this.ocrPageNumber}`;
        if (this.ocrPageCache[key]) {
            this.ocrPageCache[key].original_text = this.ocrPageDraftText;
            this.ocrPageCache[key].draft_text = this.ocrPageDraftText;
        }
        if (this.metadataV21Enabled()) {
            await this.revalidateMetadataV21AfterOcr();
        }
        if (showMessage) await this.service.modal.success(`${this.ocrPageNumber}쪽 OCR 교정을 반영했습니다.`);
        await this.service.render();
    }

    private async revalidateMetadataV21AfterOcr() {
        const body = new URLSearchParams({
            ocr_pages: JSON.stringify(this.data.ocr_page_corrections || []),
        });
        const query = new URLSearchParams({
            mode: 'metadata_v2_1_revalidate',
            analysis_id: this.analysisId,
        });
        const response = await fetch(
            `/wiz/api/portal.post.detail/analyze?${query.toString()}`,
            {
                method: 'POST',
                credentials: 'same-origin',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: body.toString(),
            }
        );
        const payload = await response.json();
        if (!payload || payload.code !== 200 || !payload.data?.analysis) {
            throw new Error(
                (payload && payload.data && payload.data.message)
                || 'OCR 변경 후 V2.1 근거 재검증에 실패했습니다.'
            );
        }
        const analysis = this.normaliseAnalysis(payload.data.analysis);
        this.analysisInfo = analysis;
        this.data.metadata_v2_1_review = this.metadataV21ReviewFromAnalysis(analysis);
        const item = this.activeBatchItem();
        if (item) {
            item.analysis = analysis;
            item.form.metadata_v2_1_review = JSON.parse(
                JSON.stringify(this.data.metadata_v2_1_review)
            );
        }
        this.metadataV21FieldName = this.metadataV21FieldNames().find(
            (fieldName: string) => !this.metadataV21FieldConfirmed(fieldName)
        ) || 'title';
    }

    public async closeOcrCorrection() {
        if (this.ocrPageHasChanges()) await this.applyOcrPage(false);
        this.ocrModalOpen = false;
        await this.service.render();
    }

    public summaryRequiredEntities(form: any = this.data) {
        const priorities: any = { PERSON: 0, PLACE: 1, ORGANIZATION: 2, EVENT: 3 };
        const entities = form && Array.isArray(form.entities) ? form.entities : [];
        const seen: any = {};
        return entities.filter((row: any) => typeof priorities[row.type] !== 'undefined')
            .sort((first: any, second: any) => priorities[first.type] - priorities[second.type]
                || Number(second.confidence || 0) - Number(first.confidence || 0))
            .map((row: any) => `${row.normalized || row.text || ''}`.trim())
            .filter((name: string) => {
                const key = name.toLocaleLowerCase();
                if (!name || seen[key]) return false;
                seen[key] = true;
                return true;
            }).slice(0, 6);
    }

    public summaryMissingEntities(form: any = this.data) {
        const summary = `${form && form.content ? form.content : ''}`.toLocaleLowerCase();
        return this.summaryRequiredEntities(form).filter((name: string) => !summary.includes(name.toLocaleLowerCase()));
    }

    public summaryLineCount(form: any = this.data) {
        return `${form && form.content ? form.content : ''}`
            .split(/\n+/).map((row: string) => row.trim()).filter(Boolean).length;
    }

    public async addMissingEntitiesToSummary() {
        const missing = this.summaryMissingEntities();
        if (!missing.length) return;
        const line = `주요 개체: ${missing.join(', ')}.`;
        const rows = `${this.data.content || ''}`.split(/\n+/).map((row: string) => row.trim()).filter(Boolean);
        if (rows.length >= 5) rows[4] = `${rows[4].replace(/[.。\s]+$/, '')}. ${line}`;
        else rows.push(line);
        this.data.content = rows.join('\n');
        await this.service.render();
    }

    public multilingualData() {
        return this.data && this.data.multilingual
            ? this.data.multilingual
            : this.emptyMultilingual();
    }

    public translationSegments() {
        const multilingual = this.multilingualData();
        return Array.isArray(multilingual.segments) ? multilingual.segments : [];
    }

    public normalizedTerms() {
        const multilingual = this.multilingualData();
        return Array.isArray(multilingual.terms) ? multilingual.terms : [];
    }

    public hanjaTermCount() {
        return this.normalizedTerms().filter((term: any) => !!term.hanja_to_hangul).length;
    }

    public dictionaryTermCount() {
        return this.normalizedTerms().filter((term: any) => !!term.dictionary_match).length;
    }

    public translatedSegmentCount() {
        return this.translationSegments().filter((row: any) => `${row.translation || ''}`.trim()).length;
    }

    public translationCoverageLabel() {
        const rows = this.translationWorkspaceRows();
        if (rows.length) {
            const complete = rows.filter((row: any) => this.translationPageStatus(row) === 'complete').length;
            const notRequired = rows.filter((row: any) => this.translationPageStatus(row) === 'not_required').length;
            const parts: string[] = [];
            const suffix = this.translationSourceUnitSuffix();
            if (complete) parts.push(`${complete}${suffix} 번역 완료`);
            if (notRequired) parts.push(`${notRequired}${suffix} 번역 불필요`);
            const review = rows.length - complete - notRequired;
            if (review) parts.push(`${review}${suffix} 검토 필요`);
            return parts.join(' · ') || `${rows.length}${suffix}`;
        }
        const total = this.translationSegments().length;
        if (!total) return '병렬 번역 없음';
        return `${this.translatedSegmentCount()} / ${total}문단 번역`;
    }

    public multilingualPages() {
        const multilingual = this.multilingualData();
        if (Array.isArray(multilingual.pages) && multilingual.pages.length) return multilingual.pages;
        const segments = this.translationSegments();
        const grouped: any = {};
        let syntheticPage = segments.reduce((maximum: number, row: any) => (
            Number(row.page) > 0 ? Math.max(maximum, Number(row.page)) : maximum
        ), 0);
        segments.forEach((row: any, index: number) => {
            const page = Number(row.page) > 0 ? Number(row.page) : ++syntheticPage;
            if (!grouped[page]) grouped[page] = {
                page,
                original: [],
                translation: [],
                segment_count: 0,
                source_segment_indexes: [],
                translation_required: false,
                statuses: [],
            };
            grouped[page].original.push(row.original || '');
            grouped[page].translation.push(row.translation || '');
            grouped[page].segment_count += 1;
            grouped[page].source_segment_indexes.push(index);
            grouped[page].translation_required = grouped[page].translation_required
                || row.translation_required !== false;
            grouped[page].statuses.push(`${row.status || ''}`);
        });
        return Object.keys(grouped).map((key: string) => ({
            page: Number(key),
            original: grouped[key].original.filter(Boolean).join('\n\n'),
            translation: grouped[key].translation.filter(Boolean).join('\n\n'),
            segment_count: grouped[key].segment_count,
            translated: grouped[key].translation_required
                && grouped[key].translation.some((value: string) => !!`${value || ''}`.trim()),
            translation_required: grouped[key].translation_required,
            status: !grouped[key].translation_required
                ? 'not_required'
                : (
                    grouped[key].statuses.some((value: string) => value === 'review_required')
                        || !grouped[key].translation.some((value: string) => !!`${value || ''}`.trim())
                        ? 'review_required'
                        : 'complete'
                ),
            source_segment_indexes: grouped[key].source_segment_indexes,
        })).sort((first: any, second: any) => first.page - second.page);
    }

    private savedDetailSegmentPages() {
        const segments = this.translationSegments();
        if (!segments.length) return [];
        const grouped: any = {};
        let syntheticPage = segments.reduce((maximum: number, row: any) => (
            Number(row.page) > 0 ? Math.max(maximum, Number(row.page)) : maximum
        ), 0);
        segments.forEach((row: any, sourceIndex: number) => {
            const page = Number(row.page) > 0 ? Number(row.page) : ++syntheticPage;
            if (!grouped[page]) grouped[page] = {
                page,
                rows: [],
                source_segment_indexes: [],
            };
            grouped[page].rows.push(row);
            grouped[page].source_segment_indexes.push(sourceIndex);
        });
        return Object.keys(grouped).map((key: string) => {
            const rows = grouped[key].rows;
            const requiredRows = rows.filter((row: any) => row.translation_required !== false);
            const reviewRequired = requiredRows.some((row: any) => (
                !`${row.translation || ''}`.trim()
                || `${row.status || ''}` === 'review_required'
                || ['partial', 'failed'].includes(`${row.validation_status || ''}`)
            ));
            return {
                page: Number(key),
                original: rows.map((row: any) => `${row.original || ''}`.trim())
                    .filter(Boolean).join('\n\n'),
                translation: rows.map((row: any) => `${row.translation || ''}`.trim())
                    .filter(Boolean).join('\n\n'),
                segment_count: rows.length,
                translated: requiredRows.length > 0 && !reviewRequired,
                translation_required: requiredRows.length > 0,
                status: !requiredRows.length
                    ? 'not_required'
                    : (reviewRequired ? 'review_required' : 'complete'),
                source_segment_indexes: grouped[key].source_segment_indexes,
                saved_detail_source: 'segments',
            };
        }).filter((row: any) => row.original || row.translation)
            .sort((first: any, second: any) => first.page - second.page);
    }

    private savedDetailProfileTranslationRow(pageRows: any[], segmentRows: any[]) {
        const translation = `${this.profileFieldValue('translated_text') || ''}`.trim();
        if (!translation) return null;
        const profileOriginal = `${this.profileFieldValue('original_text') || ''}`.trim();
        const original = profileOriginal || pageRows
            .map((row: any) => `${row.original || ''}`.trim())
            .filter(Boolean).join('\n\n') || segmentRows
            .map((row: any) => `${row.original || ''}`.trim())
            .filter(Boolean).join('\n\n');
        const multilingualStatus = `${this.multilingualData().status || ''}`;
        const requiredSegments = this.translationSegments().filter(
            (row: any) => row.translation_required !== false
        );
        const segmentReviewRequired = requiredSegments.some((row: any) => (
            !`${row.translation || ''}`.trim()
            || `${row.status || ''}` === 'review_required'
            || ['partial', 'failed'].includes(`${row.validation_status || ''}`)
        ));
        const pageReviewRequired = pageRows.some((row: any) => (
            row.translation_required !== false && !`${row.translation || ''}`.trim()
        ));
        const reviewRequired = (
            ['partial', 'failed', 'ready'].includes(multilingualStatus)
            || segmentReviewRequired
            || pageReviewRequired
        );
        return {
            page: 1,
            original,
            translation,
            segment_count: requiredSegments.length || 1,
            translated: !reviewRequired,
            translation_required: true,
            status: reviewRequired ? 'review_required' : 'complete',
            saved_detail_source: 'profile_fields.translated_text',
        };
    }

    public savedDetailTranslationRows() {
        const multilingual = this.multilingualData();
        const pageRows = Array.isArray(multilingual.pages)
            ? multilingual.pages.filter((row: any) => row && (row.original || row.translation))
                .map((row: any, index: number) => ({
                    ...row,
                    page: Number(row.page) > 0 ? Number(row.page) : index + 1,
                }))
            : [];
        const segmentRows = this.savedDetailSegmentPages();
        const profileRow = this.savedDetailProfileTranslationRow(pageRows, segmentRows);
        const hasPageTranslation = pageRows.some(
            (row: any) => !!`${row.translation || ''}`.trim()
        );
        const hasSegmentTranslation = segmentRows.some(
            (row: any) => !!`${row.translation || ''}`.trim()
        );
        const segmentsComplete = (
            hasSegmentTranslation
            && segmentRows.every((row: any) => (
                row.translation_required === false || row.status === 'complete'
            ))
        );

        if (!pageRows.length) {
            if (segmentsComplete) return segmentRows;
            return profileRow ? [profileRow] : segmentRows;
        }
        if (!hasPageTranslation) {
            if (segmentsComplete) return segmentRows;
            if (profileRow) return [profileRow];
            if (hasSegmentTranslation) return segmentRows;
            return pageRows;
        }

        const segmentsByPage: any = {};
        segmentRows.forEach((row: any) => {
            segmentsByPage[Number(row.page)] = row;
        });
        const merged = pageRows.map((row: any, index: number) => {
            if (`${row.translation || ''}`.trim()) return row;
            const segment = segmentsByPage[Number(row.page)]
                || (segmentRows.length === pageRows.length ? segmentRows[index] : null)
                || (pageRows.length === 1 && segmentRows.length ? {
                    ...segmentRows[0],
                    original: segmentRows.map((item: any) => item.original)
                        .filter(Boolean).join('\n\n'),
                    translation: segmentRows.map((item: any) => item.translation)
                        .filter(Boolean).join('\n\n'),
                    status: segmentRows.every((item: any) => (
                        item.translation_required === false || item.status === 'complete'
                    )) ? 'complete' : 'review_required',
                } : null);
            if (!segment || !`${segment.translation || ''}`.trim()) return row;
            return {
                ...row,
                translation: segment.translation,
                translated: segment.status === 'complete',
                status: segment.status,
                saved_detail_source: 'segments',
            };
        });
        const missingRows = merged.filter((row: any) => (
            row.translation_required !== false && !`${row.translation || ''}`.trim()
        ));
        if (missingRows.length && profileRow) {
            const profileParts = `${profileRow.translation || ''}`.split(/\n\s*\n/)
                .map((value: string) => value.trim()).filter(Boolean);
            if (profileParts.length === merged.length) {
                return merged.map((row: any, index: number) => (
                    `${row.translation || ''}`.trim()
                        ? row
                        : {
                            ...row,
                            translation: profileParts[index],
                            translated: false,
                            status: 'review_required',
                            saved_detail_source: profileRow.saved_detail_source,
                        }
                ));
            }
            return [profileRow];
        }
        return merged;
    }

    public savedDetailTranslationReviewCount() {
        return this.savedDetailTranslationRows().filter(
            (row: any) => this.translationPageStatus(row) === 'review_required'
        ).length;
    }

    public savedDetailCanManageTranslation() {
        return !!(
            !this.isRegistrationMode()
            && this.data
            && (
                this.data.can_manage_translation
                || this.data.can_manage_entities
            )
        );
    }

    public savedDetailTranslationSourceAvailable() {
        const metadata = this.data && this.data.ai_metadata
            && typeof this.data.ai_metadata === 'object'
            ? this.data.ai_metadata : {};
        return !!(
            metadata.translation_source_available
            || `${this.savedReviewSourceText() || ''}`.trim()
            || `${this.data && this.data.ocr_text || ''}`.trim()
            || `${metadata.ocr_text || ''}`.trim()
            || `${this.profileFieldValue('original_text') || ''}`.trim()
        );
    }

    public savedDetailTranslationAvailable() {
        return this.savedDetailTranslationRows().length > 0 || (
            this.savedDetailCanManageTranslation()
            && this.savedDetailTranslationSourceAvailable()
        );
    }

    public savedDetailTranslationActionLabel() {
        if (this.multilingualProcessing) return '전체 번역 처리 중';
        const hasTranslation = this.savedDetailTranslationRows().some(
            (row: any) => !!`${row?.translation || ''}`.trim()
        );
        return hasTranslation ? '전체 번역 다시 하기' : '전체 번역';
    }

    public savedDetailTranslationProgressVisible() {
        return this.multilingualProcessing || [
            'queued', 'running', 'complete', 'failed',
        ].includes(`${this.multilingualProgress?.status || ''}`);
    }

    public async requestSavedDetailTranslation() {
        if (
            !this.savedDetailCanManageTranslation()
            || !this.savedDetailTranslationSourceAvailable()
            || this.multilingualProcessing
        ) return;
        const replacingExistingResults = this.savedDetailTranslationRows().some(
            (row: any) => !!`${row && row.translation || ''}`.trim()
        );
        const confirmed = await this.confirmMultilingualProcessing(
            replacingExistingResults
        );
        if (!confirmed) return;
        await this.runSavedDetailTranslation();
    }

    public async runSavedDetailTranslation() {
        if (
            !this.id
            || this.id === 'new'
            || !this.savedDetailCanManageTranslation()
            || this.multilingualProcessing
        ) return;
        const progressId = this.createProgressId();
        const sourceLanguageOverride = `${
            this.multilingualData().source_language_override || ''
        }`;
        this.multilingualProcessing = true;
        this.analysisError = '';
        this.multilingualProgress = {
            status: 'queued', stage: 'queued', label: '등록 원문 번역 요청 전송 중',
            detail: '자료함에 보존된 원문을 확인하면 실제 처리 단계를 표시합니다.',
            completed_steps: 0, total_steps: 6, percent: 0,
        };
        await this.service.render();
        const stopPolling = this.startPipelineProgressPolling(
            progressId,
            (progress: any) => {
                this.multilingualProgress = {
                    ...this.multilingualProgress,
                    ...progress,
                };
                this.service.render();
            },
        );
        try {
            const query = new URLSearchParams({
                mode: 'registered_multilingual',
                id: `${this.id}`,
                expected_revision: `${this.data && this.data.revision || ''}`,
                progress_id: progressId,
                source_language: sourceLanguageOverride,
            });
            const response = await fetch(
                `/wiz/api/portal.post.detail/analyze?${query.toString()}`,
                { method: 'POST', credentials: 'same-origin' },
            );
            const payload = await response.json();
            if (!payload || payload.code !== 200) {
                throw new Error(
                    (payload && payload.data && payload.data.message)
                    || '등록 원문 번역에 실패했습니다.'
                );
            }
            const rawAnalysis = payload.data && payload.data.analysis
                ? payload.data.analysis : null;
            if (!rawAnalysis) {
                throw new Error('저장된 번역 결과를 확인할 수 없습니다.');
            }
            const analysis = this.normaliseAnalysis(rawAnalysis);
            this.data.multilingual = this.normaliseMultilingual(
                analysis.multilingual
            );
            this.data.profile_fields = JSON.parse(JSON.stringify(
                analysis.profile_fields || {}
            ));
            this.data.ai_metadata = {
                ...(this.data.ai_metadata || {}),
                multilingual: this.data.multilingual,
                profile_fields: this.data.profile_fields,
                translation_source_available: true,
            };
            if (payload.data.revision) {
                this.data.revision = `${payload.data.revision}`;
            }
            this.savedDetailSection = 'translation';
            this.multilingualProgress = {
                ...this.multilingualProgress,
                status: 'complete', stage: 'complete', label: '등록 원문 번역 완료',
                detail: '저장된 원문과 한국어 번역을 비교할 수 있습니다.',
                completed_steps: 6, total_steps: 6, percent: 100,
            };
        } catch (error) {
            const captured = this.captureError(
                error, '등록 원문 번역에 실패했습니다.'
            );
            this.analysisError = captured.message;
            this.technicalErrorDetails = captured.details;
            this.multilingualProgress = {
                ...this.multilingualProgress,
                status: 'failed', stage: 'failed', label: '등록 원문 번역 실패',
                detail: captured.message,
            };
            await this.service.modal.error(captured.message);
        } finally {
            stopPolling();
            this.multilingualProcessing = false;
            await this.service.render();
        }
    }

    public savedEntityProgressPercent() {
        return Math.max(0, Math.min(100, Math.round(
            this.safeNumber(this.savedEntityProgress?.percent, 0)
        )));
    }

    public savedEntityProgressVisible() {
        return this.savedEntityExtracting || [
            'queued', 'running', 'complete', 'failed',
        ].includes(`${this.savedEntityProgress?.status || ''}`);
    }

    public async requestSavedEntityExtraction() {
        if (
            !this.canManageEntities()
            || this.savedEntityExtracting
            || !this.id
            || this.id === 'new'
        ) return;
        if (this.entityRows().length) {
            const confirmed = await this.service.modal.show({
                title: '개체명을 다시 추출할까요?',
                message: '새 자동 추출 결과를 반영하되 기존 수동 선택과 검수 이력은 유지합니다.',
                action: '다시 추출',
                actionBtn: 'success',
                cancel: '취소',
                status: 'warning',
            });
            if (!confirmed) return;
        }

        const progressId = this.createProgressId();
        this.savedEntityExtracting = true;
        this.savedEntityProgress = {
            status: 'queued', stage: 'queued', label: '개체명 추출 요청 전송 중',
            detail: '보존된 원문과 기존 검수 이력을 확인합니다.',
            completed_steps: 0, total_steps: 4, percent: 0,
        };
        await this.service.render();
        const stopPolling = this.startPipelineProgressPolling(
            progressId,
            (progress: any) => {
                this.savedEntityProgress = {
                    ...this.savedEntityProgress,
                    ...progress,
                };
                this.service.render();
            },
        );
        try {
            const query = new URLSearchParams({
                mode: 'registered_entities',
                id: `${this.id}`,
                expected_revision: `${this.data?.revision || ''}`,
                progress_id: progressId,
            });
            const response = await fetch(
                `/wiz/api/portal.post.detail/analyze?${query.toString()}`,
                { method: 'POST', credentials: 'same-origin' },
            );
            const payload = await response.json();
            if (!payload || payload.code !== 200) {
                throw new Error(
                    payload?.data?.message || '개체명 추출에 실패했습니다.'
                );
            }
            const result = payload.data || {};
            const rows = Array.isArray(result.entities) ? result.entities : [];
            this.data.entities = rows;
            this.data.profile_fields = {
                ...(this.data.profile_fields || {}),
                entities: rows.map((row: any) => ({ ...row })),
            };
            this.data.ai_metadata = {
                ...(this.data.ai_metadata || {}),
                entities: rows,
                profile_fields: this.data.profile_fields,
            };
            if (result.revision) this.data.revision = `${result.revision}`;
            if (result.updated) this.data.updated = result.updated;
            this.rebuildEntityOccurrenceCounts();
            this.selectedEntityRecord = rows[0] || null;
            this.resetEntityReviewDraft(this.selectedEntityRecord);
            this.savedContentReviewGroupKeys('entities').forEach(
                (key: string) => { this.savedContentReviewChecks[key] = false; }
            );
            this.markSavedReviewDirty();
            this.savedEntityProgress = {
                ...this.savedEntityProgress,
                status: 'complete', stage: 'complete', label: '개체명 추출 완료',
                detail: rows.length
                    ? `${rows.length.toLocaleString()}개 개체명을 확인했습니다.`
                    : '원문에서 추출할 개체명을 찾지 못했습니다.',
                completed_steps: 4, total_steps: 4, percent: 100,
            };
            await this.service.modal.success(
                rows.length
                    ? `개체명 ${rows.length.toLocaleString()}개를 추출했습니다.`
                    : '원문에서 추출할 개체명을 찾지 못했습니다.'
            );
        } catch (error) {
            const captured = this.captureError(
                error, '개체명 추출 중 오류가 발생했습니다.'
            );
            this.savedEntityProgress = {
                ...this.savedEntityProgress,
                status: 'failed', stage: 'failed', label: '개체명 추출 실패',
                detail: captured.message,
            };
            await this.service.modal.error(captured.message);
        } finally {
            stopPolling();
            this.savedEntityExtracting = false;
            await this.service.render();
        }
    }

    public translationWorkspaceRows() {
        if (this.translationSourceIsPdf()) return this.multilingualPages();
        const segments = this.translationSegments();
        if (!segments.length) return this.multilingualPages();
        return segments.map((row: any, sourceIndex: number) => ({
            page: sourceIndex + 1,
            original: `${row.original || ''}`,
            translation: `${row.translation || ''}`,
            segment_count: 1,
            translated: !!`${row.translation || ''}`.trim(),
            translation_required: row.translation_required !== false,
            status: row.translation_required === false
                ? 'not_required'
                : (`${row.translation || ''}`.trim() ? 'complete' : 'review_required'),
            manually_corrected: !!row.manually_corrected,
            source_segment_indexes: [sourceIndex],
            source_page: Number(row.page) || 0,
            source_part: Number(row.part) || 1,
        })).filter((row: any) => row.original || row.translation);
    }

    public translationPageStatus(page: any) {
        if (!page) return 'review_required';
        const status = `${page.status || ''}`;
        if (['complete', 'not_required', 'review_required'].includes(status)) return status;
        if (page.translation_required === false) return 'not_required';
        return `${page.translation || ''}`.trim() ? 'complete' : 'review_required';
    }

    public translationPageStatusLabel(page: any) {
        const labels: any = {
            complete: '번역 완료',
            not_required: '번역 불필요',
            review_required: '검토 필요',
        };
        return labels[this.translationPageStatus(page)] || '검토 필요';
    }

    public translationPageStatusClass(page: any) {
        return `is-${this.translationPageStatus(page).replace(/_/g, '-')}`;
    }

    public multilingualStatusLabel() {
        const status = `${this.multilingualData().status || 'not_started'}`;
        const labels: any = {
            not_started: '처리 전',
            processing: '처리 중',
            complete: '처리 완료',
            partial: '일부 번역 확인 필요',
            not_required: '번역 불필요',
            failed: '처리 실패',
            disabled: '관리자 설정에서 비활성',
            ready: '수동 검토 필요',
        };
        return labels[status] || '처리 전';
    }

    public multilingualProgressPercent() {
        return Math.max(0, Math.min(100, Math.round(this.safeNumber(this.multilingualProgress && this.multilingualProgress.percent, 0))));
    }

    public multilingualProgressSteps() {
        const completed = this.safeNumber(this.multilingualProgress && this.multilingualProgress.completed_steps, 0);
        const total = Math.max(1, this.safeNumber(this.multilingualProgress && this.multilingualProgress.total_steps, 1));
        return `${Math.min(completed, total)} / ${total}단계 완료`;
    }

    public multilingualPageCountLabel() {
        const processed = this.multilingualPages().length;
        const total = this.safeNumber(this.multilingualData().page_count, processed);
        if (processed && total > processed) return `${processed} / ${total}쪽`;
        return `${total || processed}쪽`;
    }

    public canOpenMultilingualViewer() {
        return this.translationWorkspaceRows().length > 0;
    }

    private async confirmMultilingualProcessing(replacingExistingResults: boolean = false) {
        const replacementNotice = replacingExistingResults
            ? '현재 번역 결과와 직접 수정한 내용이 새 번역 결과로 교체됩니다.\n\n'
            : '';
        return await this.service.modal.show({
            title: replacingExistingResults
                ? '전체 번역을 다시 진행할까요?'
                : '한국어 번역 처리 안내',
            message: `${replacementNotice}원문을 여러 구간으로 나누어 한국어로 번역한 뒤, 결과를 검증하고 누락된 구간은 자동으로 다시 처리합니다.\n\n자료 분량, 번역 대상 구간 수, 서버 상황에 따라 완료까지 시간이 오래 걸릴 수 있습니다. 처리 중에는 화면의 실제 서버 진행률에서 상태를 확인할 수 있습니다.`,
            action: replacingExistingResults ? '전체 번역 다시 하기' : '한국어 번역 시작',
            actionBtn: 'warning',
            cancel: '취소',
            status: 'warning',
        });
    }

    public async requestMultilingualProcessing() {
        if (
            !this.analysisId
            || this.multilingualProcessing
            || this.multilingualSegmentProcessingIndex !== null
        ) return;
        const replacingExistingResults = this.translationWorkspaceRows().some(
            (row: any) => !!`${row && row.translation ? row.translation : ''}`.trim()
        );
        const confirmed = await this.confirmMultilingualProcessing(replacingExistingResults);
        if (!confirmed) return;
        await this.runMultilingualProcessing();
    }

    public async rerunMultilingualProcessing() {
        if (
            !this.analysisId
            || this.multilingualProcessing
            || this.multilingualSegmentProcessingIndex !== null
        ) return;
        const confirmed = await this.confirmMultilingualProcessing(true);
        if (!confirmed) return;
        await this.runMultilingualProcessing();
    }

    public async runMultilingualProcessing() {
        if (!this.analysisId || this.multilingualProcessing) return;
        const targetAnalysisId = this.analysisId;
        const targetBatchIndex = this.activeBatchIndex;
        const sourceLanguageOverride = `${this.multilingualData().source_language_override || ''}`;
        const progressId = this.createProgressId();
        this.multilingualProcessing = true;
        this.reviewTranslationCandidateExpandedIndex = -1;
        this.analysisError = '';
        this.multilingualProgress = {
            status: 'queued', stage: 'queued', label: '다국어 처리 요청 전송 중',
            detail: '서버가 OCR 원문을 확인하면 실제 처리 단계를 표시합니다.',
            completed_steps: 0, total_steps: 6, percent: 0,
        };
        this.data.multilingual = this.normaliseMultilingual({
            ...this.multilingualData(), status: 'processing', warning: '',
        });
        if (targetBatchIndex >= 0 && this.batchItems[targetBatchIndex]) {
            this.batchItems[targetBatchIndex].form.multilingual = this.normaliseMultilingual(this.data.multilingual);
            const checks = this.normaliseReviewChecks(this.batchItems[targetBatchIndex].reviewChecks);
            checks.translated_text = false;
            this.batchItems[targetBatchIndex].reviewChecks = checks;
        }
        await this.service.render();
        const stopPolling = this.startPipelineProgressPolling(progressId, (progress: any) => {
            this.multilingualProgress = { ...this.multilingualProgress, ...progress };
            this.service.render();
        });
        try {
            const query = new URLSearchParams({
                mode: 'multilingual', analysis_id: targetAnalysisId, progress_id: progressId,
                source_language: sourceLanguageOverride,
            });
            const response = await fetch(`/wiz/api/portal.post.detail/analyze?${query.toString()}`, {
                method: 'POST', credentials: 'same-origin'
            });
            const payload = await response.json();
            if (!payload || payload.code !== 200) {
                throw new Error((payload && payload.data && payload.data.message) || '다국어 처리에 실패했습니다.');
            }
            const rawAnalysis = payload.data && payload.data.analysis ? payload.data.analysis : null;
            if (!rawAnalysis) throw new Error('다국어 처리 결과를 확인할 수 없습니다.');
            const analysis = this.normaliseAnalysis(rawAnalysis);
            const completedMultilingual = this.normaliseMultilingual(analysis.multilingual);
            if (targetBatchIndex >= 0 && this.batchItems[targetBatchIndex]) {
                this.batchItems[targetBatchIndex].analysis = analysis;
                this.batchItems[targetBatchIndex].form.multilingual = completedMultilingual;
                this.batchItems[targetBatchIndex].form.profile_fields = JSON.parse(
                    JSON.stringify(analysis.profile_fields || {})
                );
                const checks = this.normaliseReviewChecks(this.batchItems[targetBatchIndex].reviewChecks);
                checks.translated_text = false;
                this.batchItems[targetBatchIndex].reviewChecks = checks;
            }
            if (this.analysisId === targetAnalysisId) {
                this.analysisInfo = analysis;
                this.data.multilingual = completedMultilingual;
                this.data.profile_fields = JSON.parse(JSON.stringify(analysis.profile_fields || {}));
            }
            this.multilingualProgress = {
                ...this.multilingualProgress,
                status: 'complete', stage: 'complete', label: '다국어 처리 완료',
                detail: '페이지별 원문·번역 검수를 시작할 수 있습니다.',
                completed_steps: 6, total_steps: 6, percent: 100,
            };
            if (this.analysisId === targetAnalysisId && this.reviewSection === 'translated_text') {
                await this.openMultilingualViewer();
            }
        } catch (error) {
            const captured = this.captureError(error, '다국어 처리에 실패했습니다.');
            const message = captured.message;
            this.analysisError = message;
            this.technicalErrorDetails = captured.details;
            this.technicalErrorOpen = false;
            const failedMultilingual = this.normaliseMultilingual({
                ...(targetBatchIndex >= 0 && this.batchItems[targetBatchIndex]
                    ? this.batchItems[targetBatchIndex].form.multilingual
                    : this.multilingualData()),
                status: 'failed', warning: message,
            });
            if (targetBatchIndex >= 0 && this.batchItems[targetBatchIndex]) {
                this.batchItems[targetBatchIndex].form.multilingual = failedMultilingual;
            }
            if (this.analysisId === targetAnalysisId) this.data.multilingual = failedMultilingual;
            this.multilingualProgress = {
                ...this.multilingualProgress,
                status: 'failed', stage: 'failed', label: '다국어 처리 실패', detail: message,
            };
            await this.service.modal.error(message);
        } finally {
            stopPolling();
            this.multilingualProcessing = false;
            this.queueRegistrationRecoverySave();
            await this.service.render();
        }
    }

    public async retryMultilingualSegment(row: any) {
        const segmentIndex = this.translationSegmentRetryIndex(row);
        if (
            !this.analysisId
            || segmentIndex < 0
            || this.multilingualProcessing
            || this.multilingualSegmentProcessingIndex !== null
        ) return;
        const targetAnalysisId = this.analysisId;
        const targetBatchIndex = this.activeBatchIndex;
        const sourceLanguageOverride = `${this.multilingualData().source_language_override || ''}`;
        this.multilingualSegmentProcessingIndex = segmentIndex;
        this.analysisError = '';
        await this.renderPreservingViewport();
        try {
            const query = new URLSearchParams({
                mode: 'multilingual',
                translation_scope: 'segment',
                analysis_id: targetAnalysisId,
                segment_index: `${segmentIndex}`,
                segment_position: `${Number(row && row.source_position)}`,
                source_language: sourceLanguageOverride,
            });
            const response = await fetch(
                `/wiz/api/portal.post.detail/analyze?${query.toString()}`,
                { method: 'POST', credentials: 'same-origin' }
            );
            const payload = await response.json();
            if (!payload || payload.code !== 200) {
                throw new Error(
                    (payload && payload.data && payload.data.message)
                    || '해당 구간을 다시 번역하지 못했습니다.'
                );
            }
            const rawAnalysis = payload.data && payload.data.analysis
                ? payload.data.analysis : null;
            if (!rawAnalysis) {
                throw new Error('구간 번역 결과를 확인할 수 없습니다.');
            }
            const analysis = this.normaliseAnalysis(rawAnalysis);
            const completedMultilingual = this.normaliseMultilingual(
                analysis.multilingual
            );
            if (targetBatchIndex >= 0 && this.batchItems[targetBatchIndex]) {
                this.batchItems[targetBatchIndex].analysis = analysis;
                this.batchItems[targetBatchIndex].form.multilingual
                    = completedMultilingual;
                this.batchItems[targetBatchIndex].form.profile_fields
                    = JSON.parse(JSON.stringify(analysis.profile_fields || {}));
                const checks = this.normaliseReviewChecks(
                    this.batchItems[targetBatchIndex].reviewChecks
                );
                checks.translated_text = false;
                this.batchItems[targetBatchIndex].reviewChecks = checks;
            }
            if (this.analysisId === targetAnalysisId) {
                this.analysisInfo = analysis;
                this.data.multilingual = completedMultilingual;
                this.data.profile_fields = JSON.parse(
                    JSON.stringify(analysis.profile_fields || {})
                );
            }
        } catch (error) {
            const captured = this.captureError(
                error,
                '해당 구간을 다시 번역하지 못했습니다.'
            );
            this.analysisError = captured.message;
            this.technicalErrorDetails = captured.details;
            this.technicalErrorOpen = false;
            await this.service.modal.error(captured.message);
        } finally {
            this.multilingualSegmentProcessingIndex = null;
            this.queueRegistrationRecoverySave();
            await this.renderPreservingViewport();
        }
    }

    public async openMultilingualViewer() {
        const rows = this.translationWorkspaceRows();
        if (!rows.length) return;
        this.multilingualViewerOpen = true;
        this.selectedTranslationPage = rows[0].page;
        this.translationRailCollapsed = false;
        this.translationMobilePane = 'source';
        this.translationPdfState = 'idle';
        this.translationPdfError = '';
        this.translationPdfPreview = '';
        await this.service.render();
        if (this.translationSourceIsPdf()) {
            await this.loadTranslationPdf();
        }
    }

    public async closeMultilingualViewer() {
        this.multilingualViewerOpen = false;
        this.translationPdfPreview = '';
        this.translationPdfState = 'idle';
        this.translationPdfRequestId += 1;
        await this.service.render();
    }

    public selectedMultilingualPage() {
        const rows = this.translationWorkspaceRows();
        return rows.find((row: any) => row.page === this.selectedTranslationPage) || rows[0] || null;
    }

    public async selectTranslationPage(page: number) {
        this.selectedTranslationPage = page;
        if (this.translationSourceIsPdf()) {
            await this.loadTranslationPdfPage(page);
            return;
        }
        await this.service.render();
    }

    public async toggleTranslationRail() {
        this.translationRailCollapsed = !this.translationRailCollapsed;
        await this.service.render();
    }

    public async setTranslationMobilePane(pane: 'source' | 'translation') {
        this.translationMobilePane = pane;
        await this.service.render();
    }

    public translationSourceFormat() {
        const source = this.analysisInfo && this.analysisInfo.source
            ? this.analysisInfo.source : {};
        return this.inferSourceFormat(source);
    }

    public translationSourceIsPdf() {
        return this.translationSourceFormat() === 'pdf';
    }

    public translationSourceIsXml() {
        return this.translationSourceFormat() === 'xml';
    }

    public translationSourceLabel() {
        if (this.translationSourceIsPdf()) return '원본 PDF';
        if (this.translationSourceIsXml()) return 'XML 원문';
        return '추출 원문';
    }

    public translationSourceUnitLabel() {
        return this.translationSourceIsPdf() ? '페이지' : '구간';
    }

    public translationSourceUnitSuffix() {
        return this.translationSourceIsPdf() ? '쪽' : '구간';
    }

    public translationWorkspaceTitle() {
        return this.translationSourceIsPdf()
            ? '원본 PDF · 페이지별 번역 검수'
            : `${this.translationSourceLabel()} · 구간별 번역 검수`;
    }

    public translationWorkspaceDescription() {
        return this.translationSourceIsPdf()
            ? '확정된 OCR 읽기 순서의 번역 결과를 원본 PDF와 같은 페이지에서 비교합니다.'
            : '원문에서 추출한 구간과 한국어 번역을 같은 순서로 나란히 비교합니다.';
    }

    private translationPdfEndpoint() {
        const query = new URLSearchParams({
            mode: 'source_file',
            analysis_id: this.analysisId,
        });
        return `/wiz/api/portal.post.detail/analyze?${query.toString()}`;
    }

    private async probeTranslationPdfRange() {
        try {
            const response = await fetch(this.translationPdfEndpoint(), {
                method: 'GET',
                credentials: 'same-origin',
                headers: { Range: 'bytes=0-0' },
            });
            const contentType = `${response.headers.get('Content-Type') || ''}`.toLowerCase();
            try {
                if (response.body) await response.body.cancel();
            } catch (_) {}
            return response.ok && contentType.includes('application/pdf');
        } catch (_) {
            return false;
        }
    }

    private async loadTranslationPdfPage(page: number) {
        page = Math.max(1, Number(page || 1));
        const analysisId = this.analysisId;
        const requestId = ++this.translationPdfRequestId;
        const cacheKey = `${analysisId}:${page}`;
        const cached = this.translationPdfPageCache[cacheKey]
            || this.ocrPageCache[cacheKey];

        this.translationPdfState = 'loading';
        this.translationPdfError = '';
        this.translationPdfPreview = '';
        await this.service.render();

        if (cached && cached.data_url) {
            if (requestId !== this.translationPdfRequestId) return;
            this.translationPdfPreview = cached.data_url;
            this.translationPdfState = 'ready';
            await this.service.render();
            return;
        }

        try {
            const query = new URLSearchParams({
                mode: 'source_page',
                analysis_id: analysisId,
                page: `${page}`,
            });
            const response = await fetch(
                `/wiz/api/portal.post.detail/analyze?${query.toString()}`,
                { method: 'POST', credentials: 'same-origin' }
            );
            const payload = await response.json();
            if (!payload || payload.code !== 200) {
                throw new Error(
                    (payload && payload.data && payload.data.message)
                    || '원본 PDF 페이지를 불러오지 못했습니다.'
                );
            }
            const pageData = payload.data && payload.data.page
                ? payload.data.page : null;
            if (!pageData || !pageData.data_url) {
                throw new Error('원본 PDF 페이지 응답이 비어 있습니다.');
            }
            if (
                requestId !== this.translationPdfRequestId
                || analysisId !== this.analysisId
                || page !== this.selectedTranslationPage
            ) return;
            this.translationPdfPageCache[cacheKey] = pageData;
            this.translationPdfPreview = pageData.data_url;
            this.translationPdfState = 'ready';
        } catch (error) {
            if (requestId !== this.translationPdfRequestId) return;
            const captured = this.captureError(
                error, '원본 PDF 페이지를 불러오지 못했습니다.'
            );
            this.translationPdfState = 'error';
            this.translationPdfError = captured.message;
            this.translationPdfPreview = '';
            if (captured.details) this.technicalErrorDetails = captured.details;
        }
        await this.service.render();
    }

    public async loadTranslationPdf() {
        if (!this.analysisId) return;
        const source = this.analysisInfo && this.analysisInfo.source
            ? this.analysisInfo.source : {};
        const format = `${source.format || source.kind || ''}`.toLowerCase();
        const mimeType = `${source.mime_type || ''}`.toLowerCase();
        if (format !== 'pdf' && mimeType !== 'application/pdf') {
            this.translationPdfState = 'missing';
            this.translationPdfError = '이 원문에는 비교할 PDF가 없습니다.';
            this.translationPdfPreview = '';
            await this.service.render();
            return;
        }

        const rangeProbe = this.probeTranslationPdfRange();
        await this.loadTranslationPdfPage(this.selectedTranslationPage);
        await rangeProbe;
    }

    public multilingualSourceLanguageLabel() {
        const multilingual = this.multilingualData();
        return this.multilingualLanguageLabel(
            multilingual.source_language_override || multilingual.source_language
        );
    }

    public async onMultilingualSourceLanguageChange() {
        const multilingual = this.multilingualData();
        const allowed = ['', 'hanmun', 'zh', 'zh-hans', 'zh-hant', 'ja', 'en', 'mixed'];
        if (!allowed.includes(`${multilingual.source_language_override || ''}`)) {
            multilingual.source_language_override = '';
        }
        if (this.multilingualPages().length && multilingual.status !== 'processing') {
            multilingual.status = 'ready';
            multilingual.translated = false;
            multilingual.warning = '원문 언어 선택이 변경되었습니다. 새 선택으로 다시 처리해 주세요.';
        }
        const item = this.activeBatchItem();
        if (item) {
            const checks = this.normaliseReviewChecks(item.reviewChecks);
            checks.translated_text = false;
            item.reviewChecks = checks;
        }
        this.syncActiveBatch();
        await this.service.render();
    }

    public async updateTranslationPage(page: any) {
        if (!page) return;
        if (
            !this.translationSourceIsPdf()
            && Array.isArray(page.source_segment_indexes)
            && page.source_segment_indexes.length === 1
        ) {
            await this.updateTranslationSegment(page);
            return;
        }
        const multilingual = this.multilingualData();
        const pageNumber = Number(page.page) || 1;
        page.translation = `${page.translation || ''}`;
        page.translation_required = page.translation_required !== false;
        page.status = page.translation_required
            ? (page.translation.trim() ? 'complete' : 'review_required')
            : 'not_required';
        page.translated = page.status === 'complete';
        page.manually_corrected = true;

        const segments = Array.isArray(multilingual.segments) ? multilingual.segments : [];
        const pageRows = this.multilingualPages().map((row: any) => (
            Number(row.page) === pageNumber
                ? {
                    ...row,
                    translation: page.translation,
                    translated: page.translated,
                    translation_required: page.translation_required,
                    status: page.status,
                    manually_corrected: true,
                }
                : { ...row }
        ));
        const editedPage = pageRows.find((row: any) => Number(row.page) === pageNumber) || page;
        const sourceSegmentIndexes = Array.isArray(editedPage.source_segment_indexes)
            ? editedPage.source_segment_indexes.map((value: any) => Number(value))
            : [];
        const materializedPageBySegmentIndex: any = {};
        pageRows.forEach((row: any) => {
            if (!Array.isArray(row.source_segment_indexes)) return;
            row.source_segment_indexes.forEach((value: any) => {
                materializedPageBySegmentIndex[Number(value)] = Number(row.page);
            });
        });
        const syncedSegments: any[] = [];
        let pageInserted = false;
        segments.forEach((row: any, sourceIndex: number) => {
            const targetsEditedPage = sourceSegmentIndexes.length
                ? sourceSegmentIndexes.includes(sourceIndex)
                : Number(row.page) === pageNumber;
            if (!targetsEditedPage) {
                const materializedPage = materializedPageBySegmentIndex[sourceIndex];
                syncedSegments.push(materializedPage
                    ? { ...row, page: materializedPage, part: 1 }
                    : { ...row });
                return;
            }
            if (pageInserted) return;
            syncedSegments.push({
                ...row,
                page: pageNumber,
                part: 1,
                original: `${page.original || row.original || ''}`,
                translation: page.translation,
                source_language: row.source_language || '',
                translation_required: page.translation_required,
                status: page.status,
                manually_corrected: true,
            });
            pageInserted = true;
        });
        if (!pageInserted) {
            syncedSegments.push({
                index: syncedSegments.length,
                page: pageNumber,
                part: 1,
                original: `${page.original || ''}`,
                translation: page.translation,
                source_language: '',
                translation_required: page.translation_required,
                status: page.status,
                manually_corrected: true,
            });
        }
        multilingual.segments = syncedSegments.map((row: any, index: number) => ({
            ...row,
            index,
        }));
        multilingual.pages = pageRows.map((row: any) => {
            const stored = { ...row };
            delete stored.source_segment_indexes;
            return stored;
        });

        const pages = this.multilingualPages();
        const reviewRequired = pages.some((row: any) => this.translationPageStatus(row) === 'review_required');
        const allNotRequired = pages.length > 0 && pages.every(
            (row: any) => this.translationPageStatus(row) === 'not_required'
        );
        const complete = pages.length > 0 && !reviewRequired;
        multilingual.translated = complete && !allNotRequired;
        if (!['failed', 'disabled', 'processing', 'not_started'].includes(`${multilingual.status || ''}`)) {
            multilingual.status = allNotRequired
                ? 'not_required'
                : (complete ? 'complete' : 'partial');
        }
        const item = this.activeBatchItem();
        if (item) {
            const checks = this.normaliseReviewChecks(item.reviewChecks);
            checks.translated_text = false;
            item.reviewChecks = checks;
        }
        this.syncActiveBatch();
        await this.service.render();
    }

    private async updateTranslationSegment(page: any) {
        const multilingual = this.multilingualData();
        const sourceIndex = Number(page.source_segment_indexes[0]);
        const segments = Array.isArray(multilingual.segments)
            ? multilingual.segments.map((row: any) => ({ ...row }))
            : [];
        if (!Number.isFinite(sourceIndex) || !segments[sourceIndex]) return;
        const translation = `${page.translation || ''}`;
        const translationRequired = page.translation_required !== false;
        segments[sourceIndex] = {
            ...segments[sourceIndex],
            translation,
            translation_required: translationRequired,
            status: translationRequired
                ? (translation.trim() ? 'complete' : 'review_required')
                : 'not_required',
            manually_corrected: true,
        };
        multilingual.segments = segments;
        multilingual.pages = [];
        const required = segments.filter((row: any) => row.translation_required !== false);
        const missing = required.filter((row: any) => !`${row.translation || ''}`.trim());
        const allNotRequired = segments.length > 0 && required.length === 0;
        multilingual.translated = required.length > 0 && missing.length === 0;
        if (!['failed', 'disabled', 'processing', 'not_started'].includes(`${multilingual.status || ''}`)) {
            multilingual.status = allNotRequired
                ? 'not_required'
                : (missing.length ? 'partial' : 'complete');
        }
        const item = this.activeBatchItem();
        if (item) {
            const checks = this.normaliseReviewChecks(item.reviewChecks);
            checks.translated_text = false;
            item.reviewChecks = checks;
        }
        this.syncActiveBatch();
        await this.service.render();
    }

    public multilingualLanguageLabel(value: string) {
        const labels: any = {
            hanmun: '한문',
            hanja: '한문',
            'classical-chinese': '한문',
            zh: '중국어',
            zho: '중국어',
            'zh-hans': '중국어(간체)',
            'zh-cn': '중국어(간체)',
            'zh-hant': '중국어(번체)',
            'zh-tw': '중국어(번체)',
            ja: '일본어',
            en: '영어',
            ko: '한국어',
            mixed: '혼합 언어',
            unknown: '언어 확인 필요',
        };
        const key = `${value || ''}`.toLowerCase().replace(/_/g, '-');
        return labels[key] || value || '언어 확인 필요';
    }

    public normalizedTermLabel(term: any) {
        if (!term) return '';
        if (term.reading_status === 'review_required' || term.requires_review) {
            return term.original_script || term.source || '';
        }
        return term.korean || term.normalized || term.source || '';
    }

    public normalizedTermCandidateText(term: any) {
        const rows = Array.isArray(term?.reading_candidates)
            ? term.reading_candidates : [];
        return rows.map((row: any) => `${row?.value || ''}`.trim())
            .filter(Boolean).join(' · ');
    }

    public normalizedTermStatusLabel(term: any) {
        if (term?.reading_status === 'review_required' || term?.requires_review) {
            return '검수 필요 · 자동 확정 안 함';
        }
        return term?.dictionary_match ? '사전 일치' : '확정';
    }

    public normalizedTermClass(term: any) {
        if (term && term.hanja_to_hangul) return 'is-hanja';
        if (term && term.dictionary_match) return 'is-dictionary';
        return 'is-normalized';
    }

    private emptySyncForm() {
        return {
            id: '',
            url: '',
            schedule: 'daily',
            weekday: 0,
            hour: 2,
            target_status: 'published',
            deletion_policy: 'deactivate',
            enabled: true,
        };
    }

    private syncFormSnapshot(form: any) {
        const value = form || {};
        return JSON.stringify({
            id: value.id || '',
            url: value.url || '',
            schedule: value.schedule || 'daily',
            weekday: Number(value.weekday || 0),
            hour: Number(value.hour || 0),
            target_status: value.target_status || 'published',
            deletion_policy: value.deletion_policy || 'deactivate',
            enabled: value.enabled !== false,
        });
    }

    private restoreSyncFormBaseline() {
        if (!this.syncFormBaseline) {
            this.syncForm = this.emptySyncForm();
            this.syncFormBaseline = this.syncFormSnapshot(this.syncForm);
            return;
        }
        try {
            this.syncForm = JSON.parse(this.syncFormBaseline);
        } catch (_error) {
            this.syncForm = this.emptySyncForm();
            this.syncFormBaseline = this.syncFormSnapshot(this.syncForm);
        }
    }

    public async loadSyncDashboard(showLoading: boolean = true) {
        if (showLoading) {
            this.syncLoading = true;
            await this.service.render();
        }
        const { code, data } = await wiz.call("get", { mode: "sync_dashboard" });
        this.syncLoading = false;
        if (code === 200) {
            this.syncSources = Array.isArray(data.sources) ? data.sources : [];
            this.syncHistory = Array.isArray(data.history) ? data.history : [];
            this.deletionHistory = Array.isArray(data.deletions) ? data.deletions : [];
            this.syncSummary = data.summary || { total: 0, enabled: 0, attention: 0, last_run: '' };
            this.syncMethod = data.change_method || null;
        }
        await this.service.render();
    }

    public async newSyncSource() {
        if (this.syncFormSnapshot(this.syncForm) !== this.syncFormBaseline) {
            const reset = await this.confirmRegistrationReset(
                '새 증분 수집 설정을 작성할까요?',
                '현재 저장하지 않은 증분 수집 설정 변경 내용이 초기화됩니다.',
                '새 설정 작성'
            );
            if (!reset) return;
        }
        this.syncForm = this.emptySyncForm();
        this.syncFormBaseline = this.syncFormSnapshot(this.syncForm);
        await this.service.render();
    }

    public async editSyncSource(source: any) {
        if (!source) return;
        if (this.syncFormSnapshot(this.syncForm) !== this.syncFormBaseline) {
            const change = await this.confirmRegistrationReset(
                '다른 수집 설정을 열까요?',
                '현재 저장하지 않은 증분 수집 설정 변경 내용이 사라집니다.',
                '다른 설정 열기'
            );
            if (!change) return;
        }
        this.syncForm = {
            id: source.id || '',
            url: source.url || '',
            schedule: source.schedule || 'daily',
            weekday: Number(source.weekday || 0),
            hour: Number(source.hour || 0),
            target_status: source.target_status || 'published',
            deletion_policy: source.deletion_policy || 'deactivate',
            enabled: !!source.enabled,
        };
        this.syncFormBaseline = this.syncFormSnapshot(this.syncForm);
        await this.service.render();
    }

    public async saveSyncSource(runAfterSave: boolean = false) {
        const url = `${this.syncForm && this.syncForm.url ? this.syncForm.url : ''}`.trim();
        if (!/^https?:\/\//i.test(url)) {
            await this.service.modal.error("http 또는 https로 시작하는 수집 URL을 입력해주세요.");
            return;
        }
        this.syncSaving = true;
        await this.service.render();
        const { code, data } = await wiz.call("save", {
            mode: "sync_source",
            source: JSON.stringify({ ...this.syncForm, url }),
        });
        this.syncSaving = false;
        if (code !== 200) {
            await this.service.modal.error((data && data.message) || "증분 수집 설정 저장에 실패했습니다.");
            await this.service.render();
            return;
        }
        this.syncForm = { ...this.syncForm, ...(data.source || {}) };
        this.syncFormBaseline = this.syncFormSnapshot(this.syncForm);
        await this.loadSyncDashboard(false);
        if (runAfterSave && this.syncForm.id) {
            await this.runSyncSource(this.syncForm.id);
            return;
        }
        await this.service.modal.success("증분 수집 설정을 저장했습니다.");
        await this.service.render();
    }

    public async runSyncSource(sourceId: string) {
        if (!sourceId || this.syncRunningId) return;
        this.syncRunningId = sourceId;
        await this.service.render();
        const { code, data } = await wiz.call("run_sync", { source_id: sourceId });
        this.syncRunningId = '';
        await this.loadSyncDashboard(false);
        if (code === 200) {
            const result = data.result || {};
            await this.service.modal.success(`증분 수집 완료: ${this.syncChangeLabel(result.change_type)}`);
        } else {
            await this.service.modal.error((data && data.message) || "증분 수집 실행에 실패했습니다.");
        }
        await this.service.render();
    }

    public async toggleSyncSource(source: any) {
        if (!source || this.syncSaving) return;
        this.syncSaving = true;
        await this.service.render();
        const { code, data } = await wiz.call("save", {
            mode: "sync_toggle",
            source_id: source.id,
            enabled: !source.enabled,
        });
        this.syncSaving = false;
        if (code !== 200) {
            await this.service.modal.error((data && data.message) || "수집 상태 변경에 실패했습니다.");
        }
        await this.loadSyncDashboard(false);
    }

    public syncScheduleLabel(source: any) {
        if (!source) return '-';
        const hour = `${Number(source.hour || 0)}`.padStart(2, '0');
        if (source.schedule === 'weekly') {
            const day = this.weekdays.find((item: any) => Number(item.value) === Number(source.weekday));
            return `매주 ${day ? day.label : '월요일'} ${hour}:00`;
        }
        return `매일 ${hour}:00`;
    }

    public syncChangeLabel(changeType: string) {
        const labels: any = {
            pending: '실행 대기',
            new: '신규 등록',
            modified: '수정 반영',
            restored: '복구 반영',
            unchanged: '변경 없음',
            deleted: '삭제 감지',
            private: '비공개 감지',
            error: '처리 오류',
        };
        return labels[changeType] || changeType || '-';
    }

    public syncChangeClass(changeType: string) {
        if (['new', 'modified', 'restored'].includes(changeType)) return 'is-changed';
        if (['deleted', 'private', 'error'].includes(changeType)) return 'is-attention';
        if (changeType === 'unchanged') return 'is-stable';
        return 'is-pending';
    }

    public syncPolicyLabel(policy: string) {
        return policy === 'delete' ? '연관 데이터 삭제' : '연관 데이터 비활성화';
    }

    public formatCount(value: any) {
        const number = Number(value || 0);
        return Number.isFinite(number) ? number.toLocaleString('ko-KR') : '0';
    }

    public async loadAISettings() {
        const { code, data } = await wiz.call("get", { mode: "ai_settings" });
        if (code !== 200) return;
        this.aiSettings = data.settings || null;
        this.aiSettingsAdmin = !!data.is_admin;
        if (this.aiSettingsAdmin && this.aiSettings) {
            this.entityDictionaryText = (this.aiSettings.entity_dictionary || [])
                .map((row: any) => `${row.term}|${row.type}|${row.normalized || row.term}`)
                .join('\n');
            this.historicalTermDictionaryText = (this.aiSettings.historical_term_dictionary || [])
                .map((row: any) => `${row.source}|${row.normalized || row.korean || row.source}|${row.korean || row.normalized || row.source}|${row.language || 'other'}|${row.category || '역사 용어'}`)
                .join('\n');
        }
        await this.service.render();
    }

    public async loadClassificationOptions() {
        const { code, data } = await wiz.call("get", { mode: "classification_options" });
        if (code !== 200) return;
        if (Array.isArray(data.material_types) && data.material_types.length > 0) {
            this.materialTypeOptions = data.material_types.slice(0, 200);
        }
        if (Array.isArray(data.provenance_types) && data.provenance_types.length > 0) {
            this.provenanceTypeOptions = data.provenance_types;
        }
        await this.service.render();
    }

    public async saveAISettings() {
        if (!this.aiSettingsAdmin || !this.aiSettings) return;
        this.settingsSaving = true;
        await this.service.render();
        const settings = {
            ...this.aiSettings,
            entity_dictionary: this.entityDictionaryText.split('\n').map((line: string) => {
                const [term, type, normalized] = line.split('|').map((value: string) => value.trim());
                return { term, type: type || 'OTHER', normalized: normalized || term };
            }).filter((row: any) => row.term),
            historical_term_dictionary: this.historicalTermDictionaryText.split('\n').map((line: string) => {
                const [source, normalized, korean, language, category] = line.split('|').map((value: string) => value.trim());
                return {
                    source,
                    normalized: normalized || korean || source,
                    korean: korean || normalized || source,
                    language: language || 'other',
                    category: category || '역사 용어',
                };
            }).filter((row: any) => row.source),
        };
        const { code, data } = await wiz.call("save", { mode: "ai_settings", settings: JSON.stringify(settings) });
        this.settingsSaving = false;
        if (code === 200) {
            await this.loadAISettings();
            await this.service.modal.success("AI 파이프라인 설정을 저장했습니다. 새 기준을 적용하려면 메타정보를 다시 추출해주세요.");
        } else {
            await this.service.modal.error((data && data.message) || "설정 저장에 실패했습니다.");
        }
        await this.service.render();
    }

    public async remove() {
        let res = await this.service.modal.show({
            title: "자료 삭제",
            message: "정말 이 자료를 삭제하시겠습니까? 이 작업은 되돌릴 수 없습니다.",
            action: "삭제",
            actionBtn: "error",
            status: "error"
        });
        if (!res) return;

        const { code } = await wiz.call("delete", { id: this.id });
        if (code === 200) {
            this.service.href(this.libraryPath);
        }
    }

    public statusClass(status: string) {
        switch (status) {
            case 'published': return 'bg-green-50 text-green-700 border border-green-200';
            case 'draft': return 'bg-yellow-50 text-yellow-700 border border-yellow-200';
            case 'archived': return 'bg-gray-50 text-gray-600 border border-gray-200';
            default: return 'bg-gray-50 text-gray-600 border border-gray-200';
        }
    }

    public statusLabel(status: string) {
        switch (status) {
            case 'published': return '공개';
            case 'draft': return '비공개';
            case 'archived': return '보관';
            default: return status || '-';
        }
    }

    private resetAnalysis() {
        this.analysisId = '';
        this.analysisInfo = null;
        this.analysisError = '';
        this.resetRetryProgressState();
        this.layoutRefreshing = false;
        this.layoutRefreshAttemptedId = '';
        this.resetLayoutInspector();
        this.multilingualViewerOpen = false;
        this.multilingualProcessing = false;
        this.multilingualProgress = {
            status: 'idle', stage: '', label: '', detail: '',
            completed_steps: 0, total_steps: 1, percent: 0,
        };
        this.selectedTranslationPage = 0;
        this.translationPdfState = 'idle';
        this.translationPdfError = '';
        this.translationPdfPreview = '';
        this.translationPdfPageCache = {};
        this.translationPdfRequestId += 1;
        this.translationRailCollapsed = false;
        this.translationMobilePane = 'source';
        this.selectedOcrCandidate = null;
        this.ocrCorrectionValue = '';
    }

    private resetLayoutInspector() {
        this.layoutDetailsOpen = false;
        this.layoutRegionFilter = 'all';
        this.layoutRegionPage = 1;
        this.selectedLayoutRegionId = '';
        this.layoutPreviewLoadingId = '';
        this.layoutPreviewError = '';
    }

    private routeId() {
        return WizRoute.segment.id || 'new';
    }

    private normaliseRegistrationWorkspaceId(value: any) {
        const workspaceId = `${value || ''}`.trim().toLowerCase();
        return /^[0-9a-f]{32}$/.test(workspaceId) ? workspaceId : '';
    }

    private routeWorkspaceId() {
        return this.normaliseRegistrationWorkspaceId(
            this.routeWorkspaceIdRaw(),
        );
    }

    private routeWorkspaceIdRaw() {
        return `${WizRoute.segment.workspaceId || ''}`.trim();
    }

    private routeTab(id: string) {
        const requestedTab = `${WizRoute.segment.tab || ''}`;
        if (id !== 'new' && requestedTab === 'edit') return 'view';
        if (requestedTab) return requestedTab;
        return id === 'new' ? 'edit' : 'view';
    }

    private sourceTitle(source: string) {
        const clean = source.split(/[?#]/)[0];
        const name = clean.substring(clean.lastIndexOf('/') + 1);
        return (name || 'XML URL 자료').replace(/\.[^/.]+$/, '');
    }
}

export default PortalPostDetailComponent;